(function() {
  'use strict';
  angular.module('proyecto-az-suministro',
  ['ngAnimate',
  'ngCookies',
  'ngTouch',
  'ngSanitize',
  'ngMessages',
  'ngAria',
  'ngStorage',
  'ngResource',
  'ui.router',
  'ui.bootstrap',
  'toastr',
  'ngTable',
  'base64',
  'formly',
  'formlyBootstrap',
  'oitozero.ngSweetAlert',
  'ui.toggle',
  'dtrw.bcrypt',
  'ngImgCrop' //Para recortar imágenes
]);
})();


(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-reclamos', {
        url: 'lista-reclamos',
        templateUrl: 'app/app/main/movimientos/egreso/reclamos/lista/lista.html',
        controller: 'ListaReclamosCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Reclamos',
          subtitulo:'Listado de reclamos'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          egresos: function(Usuario, EgresoConReclamo, EgresoConReclamoDeposito, EgresoConReclamoDepositoEmpresa){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              var deposito = usuario.empleado.deposito;
              var empresa = usuario.empleado.empresa;
              if (deposito){
                if (empresa){
                  return EgresoConReclamoDepositoEmpresa.query({'idDeposito':deposito.id, 'idEmpresa':empresa.id}).$promise.then(function(data){
                    return data;
                  });
                } else {
                  return EgresoConReclamoDeposito.query({'idDeposito':deposito.id}).$promise.then(function(data){
                    return data;
                  });
                }
              } else {
                return EgresoConReclamo.query({}).$promise.then(function(data){
                  return data;
                });
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaReclamosCtrl', ListaReclamosCtrl);

  /** @ngInject */
  function ListaReclamosCtrl($rootScope, NgTableParams, rol, HeaderBarService, $filter, egresos , CantidadReclamosDeposito, CantidadReclamos, Usuario, $stateParams, orderByFilter, $state, ServicioModales, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.egresos = orderByFilter(egresos,'fechaConfirmacion',true);
    vm.visualizarEgreso = visualizarEgreso;
    vm.verReclamo = verReclamo;
    vm.verAtencionReclamo = verAtencionReclamo;
    vm.atenderReclamo = atenderReclamo;
    vm.rol = rol;

    if (rol.id!=1 && rol.id!=2 && rol.id!=3) $state.go("home.home");

    function atenderReclamo(egreso){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalAtencionReclamoEgreso({
        onResult: function(resultado) {
          actualizarAtencion(resultado.egreso);
          actualizarTabla(vm.egresos);
          actualizarCantidadReclamos();
        },
        objeto: egreso.id
      });
    }

    function actualizarCantidadReclamos(){
      Usuario.obtenerUsuario().$promise.then(function(usuario){
        var deposito = usuario.empleado.deposito;
        if (deposito){
          CantidadReclamosDeposito.get({'idDeposito':deposito.id}).$promise.then(function(data){
            $rootScope.$broadcast('cantidadReclamos', {
              cantidad : data.cantidad
            });
            ServicioDialogos.cerrarDialogoCargando();
          }, function(error){
            console.log(error);
          });
        } else {
          CantidadReclamos.get({}).$promise.then(function(data){
            $rootScope.$broadcast('cantidadReclamos', {
              cantidad : data.cantidad
            });
            ServicioDialogos.cerrarDialogoCargando();
          }, function(error){
            console.log(error);
            ServicioDialogos.cerrarDialogoCargando();
          });
        }
      }, function(error){
        console.log(error);
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function actualizarAtencion(egreso){
      var index = null;
      vm.egresos.forEach(function(item, i){
        if (item.id==egreso.id){
          index = i;
        }
      });
      vm.egresos.splice(index, 1);
      vm.egresos.push(egreso);
    }

    function verAtencionReclamo(egreso){
      ServicioDialogos.mostrarDialogoInformacion("Atención de reclamo", "Fecha: "+$filter('date')(egreso.fechaAtencionReclamo, "dd/MM/yyyy HH:mm")+"\nAtendió: "+egreso.usuarioAtencionReclamo.empleado.apellido+", "+egreso.usuarioAtencionReclamo.empleado.nombre+"\n\n"+egreso.atencionReclamo);
    }
    
    function verReclamo(egreso){
      ServicioDialogos.mostrarDialogoInformacion("Reclamo", "Fecha: "+$filter('date')(egreso.fechaConfirmacion, "dd/MM/yyyy HH:mm")+"\nReclamó: "+egreso.nombreConfirmacion+"\nMail: "+egreso.mailIngresadoConfirmacion+"\n\n"+egreso.descripcionReclamo);
    }

    function filtrarTabla($defer, params) {
      var filtros = params.filter();
      var filtrosNuevos = {};
      for (var key in filtros) {
        if (filtros.hasOwnProperty(key) && filtros[key]!=='') {
          switch(key) {
            case 'deposito.nombre':
              angular.extend(filtrosNuevos, {
                deposito: {
                nombre: filtros[key]
                }
              });
              break;
            case 'empresa.nombre':
              angular.extend(filtrosNuevos, {
                empresa: {
                nombre: filtros[key]
                }
              });
              break;
            case 'sucursal.nombre':
              angular.extend(filtrosNuevos, {
                sucursal: {
                nombre: filtros[key]
                }
                });
              break;
            case 'estadoMovimiento.nombre':
              angular.extend(filtrosNuevos, {
                estadoMovimiento: {
                nombre: filtros[key]
                }
              });
              break;
            default:
              filtrosNuevos[key] = filtros[key];
          }
        }
      }
      var filtrados = filtros ? $filter('filter')(vm.egresos, filtrosNuevos) : vm.egresos;
      filtrados = params.sorting() ? $filter('orderBy')(filtrados, params.orderBy()) : filtrados;
      if (filtrados && filtrados.length){
        params.total(filtrados.length);
        return $defer.resolve(filtrados.slice((params.page() - 1) * params.count(), params.page() * params.count()));
      } else {
        params.total(0);
        return $defer.resolve(null);
      }
    }

    function actualizarTabla(data){
      vm.egresos = orderByFilter(data,'fechaConfirmacion',true);
      vm.tableParams.settings({
        data: vm.egresos
      });
      vm.tableParams.reload();
    }

    function visualizarEgreso(egreso){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalVisualizarEgreso({
        onResult: function(resultado) {
          console.log(resultado);
        },
        egreso: egreso,
        deposito: egreso.deposito
      });
    }

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10,
    },{
      getData: function($defer,params){ return filtrarTabla($defer, params);}
    });
    vm.tableParams.reload();

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.visualizar-egreso-despachado-donacion-scrap', {
        url: 'visualizar-egreso-despachado-donacion-scrap/:objeto',
        templateUrl: 'app/app/main/movimientos/donacion-scrap/egreso/visualizar-egreso-despachado/visualizar-egreso-despachado.html',
        controller: 'VisualizarEgresoDespachadoDonacionScrapCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Egreso de suministros para donación o scrap-reparación',
          subtituloNuevo: 'Visualizar información del egreso despachado',
        },
        resolve: {
          egreso: function(Egreso, $stateParams){
            if ($stateParams.objeto){
              return Egreso.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return $stateParams.objeto;
            }
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('VisualizarEgresoDespachadoDonacionScrapCtrl', VisualizarEgresoDespachadoDonacionScrapCtrl);

  /** @ngInject */
  function VisualizarEgresoDespachadoDonacionScrapCtrl(NgTableParams, URL_SERVIDOR, $http, HeaderBarService, $window, ServicioModales, egreso, $stateParams, $filter, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);

    var vm = this;
    vm.egreso = egreso;
    vm.volver = volver;

    vm.detalles = vm.egreso.detalles;
    vm.visualizarEgreso = visualizarEgreso;

    vm.detallesInventariables = [];
    vm.detallesNoInventariables = [];

    vm.detallesNoInventariablesAgrupados = [];
    vm.detallesInventariablesAgrupados = [];

    vm.ubicacionCompleta = ubicacionCompleta;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;


    inicializar();

    vm.editarSuministro = editarSuministro;
    vm.editarProblemas = editarProblemas;
    vm.comprobarEstadoEgreso = comprobarEstadoEgreso;
    vm.imprimirInforme = imprimirInforme;

    function imprimirInforme(){
      ServicioDialogos.abrirDialogoCargando();
      $http.get(URL_SERVIDOR+"/movimiento/reporte/movimiento/"+vm.egreso.id, {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }


    function inicializar(){
      if (!vm.egreso.id) return;
      vm.fechaCreacion=$filter('date')(vm.egreso.fecha, 'dd/MM/yyyy HH:mm');
      vm.fechaDespacho=$filter('date')(vm.egreso.egreso.fecha, 'dd/MM/yyyy HH:mm');
      vm.montoTotal = montoTotal();
      armarPersona();
      crearTablas();
      actualizarTabla();
      vm.detallesNoInventariablesAgrupados = [];
      vm.detallesInventariablesAgrupados = [];
      cargarDetalles();
    }

    function visualizarEgreso(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalVisualizarDespacho({
        onResult: function(resultado) {
          vm.egreso.egreso.nroGuia = resultado.egreso.nroGuia;
        },
        egreso: vm.egreso.egreso,
      });
    }

    function armarPersona(){
      if (vm.egreso.egreso.personaEmpresaLogistica && vm.egreso.egreso.personaEmpresaLogistica.id){
        vm.persona=vm.egreso.egreso.personaEmpresaLogistica.apellido.toUpperCase()+" ,"+vm.egreso.egreso.personaEmpresaLogistica.nombre.toUpperCase();
      } else {
        vm.persona=null;
      }
    }


    function ubicacionCompleta(detalle){
      if (detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación",
        "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+detalle.suministro.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+detalle.suministro.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+detalle.suministro.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+detalle.suministro.ubicacion.numeroUbicacion+
        "\nN° de orden: "+detalle.suministro.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+detalle.suministro.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+detalle.suministro.ubicacion.categoriaPeso.nombre.toUpperCase());
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "No hay ubicación");
      }
    }

    function ubicacionNaveNumeroOrden(detalle){
      if (detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        return "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+detalle.suministro.ubicacion.numeroOrden;
      }
    }


    function cargarDetalles(){
      vm.detallesInventariables = [];
      vm.detallesNoInventariables = [];
      vm.detalles.forEach(function(detalle){
        if (detalle.suministro.tipoSuministro.inventariable){
          vm.detallesInventariables.push(detalle);
        } else {
          vm.detallesNoInventariables.push(detalle);
        }
      });
      if (vm.detallesNoInventariables.length>0){
        armarDetallesNoInventariables();
      } else {
        actualizarTablaNoInventariables();
      }
      if (vm.detallesInventariables.length>0){
        armarDetallesInventariables();
      } else {
        actualizarTablaInventariables();
      }
    }

    function obtenerTiposUtilizados(){
      var esta = false;
      vm.detallesNoInventariables.forEach(function(detalle){
        esta = false;
        vm.detallesNoInventariablesAgrupados.forEach(function(agrupado){
          if (detalle.suministro.tipoSuministro.id==agrupado.tipoSuministro.id){
            esta = true;
          }
        });
        if (!esta){
          vm.detallesNoInventariablesAgrupados.push({tipoSuministro:detalle.suministro.tipoSuministro, precioTotal:0.0, cantidad:0, detalles:[]});
        }
      });
    }

    function armarDetallesNoInventariablesAgrupados(){
      vm.detallesNoInventariablesAgrupados.forEach(function(agrupado){
        vm.detallesNoInventariables.forEach(function(detalle){
          if (agrupado.tipoSuministro.id===detalle.suministro.tipoSuministro.id){
            agrupado.detalles.push({suministro:detalle.suministro, cantidad:detalle.cantidad});
            agrupado.cantidad = agrupado.cantidad + detalle.cantidad;
            agrupado.precioTotal = agrupado.precioTotal + detalle.suministro.precioUnitario*detalle.cantidad;
          }
        });
      });
    }

    function armarDetallesNoInventariables(){
      obtenerTiposUtilizados();
      armarDetallesNoInventariablesAgrupados();
      actualizarTablaNoInventariables();
    }

    function obtenerTiposInventariablesUtilizados(){
      var esta = false;
      vm.detallesInventariables.forEach(function(detalle){
        esta = false;
        vm.detallesInventariablesAgrupados.forEach(function(agrupado){
          if (detalle.suministro.tipoSuministro.id==agrupado.tipoSuministro.id){
            esta = true;
          }
        });
        if (!esta){
          vm.detallesInventariablesAgrupados.push({tipoSuministro:detalle.suministro.tipoSuministro, precioTotal:0.0, cantidad:0, detalles:[]});
        }
      });
    }

    function armarDetallesInventariablesAgrupados(){
      vm.detallesInventariablesAgrupados.forEach(function(agrupado){
        vm.detallesInventariables.forEach(function(detalle){
          if (agrupado.tipoSuministro.id===detalle.suministro.tipoSuministro.id){
            agrupado.detalles.push({suministro:detalle.suministro, suministroInventariable:detalle.suministroInventariable, cantidad:detalle.cantidad});
            agrupado.cantidad = agrupado.cantidad + detalle.cantidad;
            agrupado.precioTotal = agrupado.precioTotal + detalle.suministro.precioUnitario;
          }
        });
      });
    }

    function armarDetallesInventariables(){
      obtenerTiposInventariablesUtilizados();
      armarDetallesInventariablesAgrupados();
      actualizarTablaInventariables();
    }

    function editarProblemas(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea agregar o quitar problemas en este egreso?', function(){
        $state.go('home.problemas-egreso',{objeto:vm.egreso.id});
      });
    }

    function editarSuministro(suministro){
      if (suministro.suministro && suministro.suministro.tipoSuministro && suministro.suministro.tipoSuministro.inventariable) {
        editarSuministroInventariable(suministro);
      } else {
        editarSuministroNoInventariable(suministro);
      }
    }

    function editarSuministroInventariable(suministro){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Está seguro que desea editar la información del suministro?", function(){
        ServicioDialogos.abrirDialogoCargando();
        ServicioModales.abrirModalEditarSuministro({
          onResult: function(resultado){
            $window.location.reload();
          },
          suministro:suministro.suministroInventariable,
          modo:'editar'
        });
      });
    }

    function editarSuministroNoInventariable(suministro){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Está seguro que desea editar la información del suministro?", function(){
        ServicioDialogos.abrirDialogoCargando();
        ServicioModales.abrirModalEditarSuministroNoInventariable({
          onResult: function(resultado){
            $window.location.reload();
          },
          suministro:suministro.suministro,
          modo:'editar'
        });
      });
    }

    function volver(){
      $state.go("home.lista-egreso-donacion-scrap");
    }

    function montoTotal(){
      var total = 0;
      for(var i = 0; i < vm.egreso.detalles.length; i++){
        total += vm.egreso.detalles[i].suministro.precioUnitario*vm.egreso.detalles[i].cantidad;
      }
      return total ? '$ '+total.toFixed(2) : "-";
    }

    function actualizarTablaNoInventariables(){
      vm.tableParamsNoInventariableAgrupado.settings({
        data: vm.detallesNoInventariablesAgrupados,
        noPager: true,
        counts: []
      });
      vm.tableParamsNoInventariableAgrupado.reload();
    }

    function actualizarTablaInventariables(){
      vm.tableParamsInventariableAgrupado.settings({
        data: vm.detallesInventariablesAgrupados,
        noPager: true,
        counts: []
      });
      vm.tableParamsInventariableAgrupado.reload();
    }

    function actualizarTabla(){
      vm.tableParams1.settings({
        data: orderByFilter(vm.egreso.problemas,'nombre', false),
        noPager: true,
        count: []
      });
      vm.tableParams1.reload();
    }

    function crearTablas(){
      vm.tableParamsInventariableAgrupado = new NgTableParams({
        page: 1,
        count: 10,
        group:{
          tipoSuministro: 'desc'
        }
      });
      vm.tableParamsNoInventariableAgrupado = new NgTableParams({
        page: 1,
        count: 10,
        group:{
          tipoSuministro: 'desc'
        }
      });
      vm.tableParams1 = new NgTableParams({
        page:1,
        count:20
      });
    }

    function comprobarEstadoEgreso(){
      return vm.egreso && vm.egreso.estadoMovimiento && (vm.egreso.estadoMovimiento.id==4 || vm.egreso.estadoMovimiento.id==20 || vm.egreso.estadoMovimiento.id==24);
    }
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.visualizar-egreso-donacion-scrap', {
        url: 'visualizar-egreso-donacion-scrap/:objeto/:estadoAnterior',
        templateUrl: 'app/app/main/movimientos/donacion-scrap/egreso/visualizar-egreso/visualizar-egreso.html',
        controller: 'VisualizarEgresoDonacionScrapCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Egreso de suministros para donación o scrap-reparación',
          subtituloNuevo: 'Visualizar información del egreso',
        },
        resolve: {
          egreso: function(Egreso, $stateParams){
            if ($stateParams.objeto){
              return Egreso.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return $stateParams.objeto;
            }
          },
          estadoAnterior: function($stateParams){
            return $stateParams.estadoAnterior? $stateParams.estadoAnterior : 1;
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('VisualizarEgresoDonacionScrapCtrl', VisualizarEgresoDonacionScrapCtrl);

  /** @ngInject */
  function VisualizarEgresoDonacionScrapCtrl(NgTableParams, URL_SERVIDOR, $http, HeaderBarService, $window, ServicioModales, estadoAnterior, egreso, $stateParams, $filter, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);

    var vm = this;
    vm.egreso = egreso;
    vm.volver = volver;
    vm.estadoAnterior = estadoAnterior;

    vm.detalles = vm.egreso.detalles;

    vm.detallesInventariables = [];
    vm.detallesNoInventariables = [];

    vm.detallesNoInventariablesAgrupados = [];
    vm.detallesInventariablesAgrupados = [];
    vm.detallesNoInventariablesAgrupadosCajas = [];


    vm.ubicacionCompleta = ubicacionCompleta;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.ubicacionCompletaCaja = ubicacionCompletaCaja;
    vm.ubicacionNaveNumeroOrdenCaja = ubicacionNaveNumeroOrdenCaja;
    vm.cajas = vm.egreso.caja? "SI" : "NO";


    inicializar();

    vm.editarSuministro = editarSuministro;
    vm.editarProblemas = editarProblemas;
    vm.comprobarEstadoEgreso = comprobarEstadoEgreso;
    vm.imprimirInforme = imprimirInforme;

    function imprimirInforme(){
      ServicioDialogos.abrirDialogoCargando();
      $http.get(URL_SERVIDOR+"/movimiento/reporte/movimiento/"+vm.egreso.id, {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }


    function inicializar(){
      if (!vm.egreso.id) return;
      vm.fecha=$filter('date')(vm.egreso.fecha, 'dd/MM/yyyy HH:mm');
      vm.solicitante = vm.egreso.solicita? vm.egreso.solicita.apellido&&vm.egreso.solicita.nombre? vm.egreso.solicita.apellido.toUpperCase()+", "+vm.egreso.solicita.nombre : "-":"-";
      vm.montoTotal = montoTotal();
      vm.cajasAsignadas = obtenerNumeroCajas();
      crearTablas();
      actualizarTabla();
      vm.detallesNoInventariablesAgrupados = [];
      vm.detallesInventariablesAgrupados = [];
      cargarDetalles();
    }

    function obtenerNumeroCajas(){
      var numeros = [];
      var hash = {};
      vm.egreso.detalles.forEach(function(item){
        numeros.push(item.numeroCaja);
      });
      numeros = numeros.filter(function(current) {
        var exists = !hash[current] || false;
        hash[current] = true;
        return exists;
      });
      return numeros;
    }


    function ubicacionCompleta(detalle){
      if (detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación",
        "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+detalle.suministro.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+detalle.suministro.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+detalle.suministro.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+detalle.suministro.ubicacion.numeroUbicacion+
        "\nN° de orden: "+detalle.suministro.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+detalle.suministro.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+detalle.suministro.ubicacion.categoriaPeso.nombre.toUpperCase());
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "No hay ubicación");
      }
    }

    function ubicacionNaveNumeroOrden(detalle){
      if (detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        return "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+detalle.suministro.ubicacion.numeroOrden;
      } else {
        return "El suministro no posee ubicación";
      }
    }

    function ubicacionCompletaCaja(detalle){
      if (detalle.ubicacion && detalle.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación",
        "Nave: "+detalle.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+detalle.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+detalle.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+detalle.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+detalle.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+detalle.ubicacion.numeroUbicacion+
        "\nN° de orden: "+detalle.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+detalle.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+detalle.ubicacion.categoriaPeso.nombre.toUpperCase());
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "No hay ubicación");
      }
    }

    function ubicacionNaveNumeroOrdenCaja(detalle){
      if (detalle.ubicacion && detalle.ubicacion.nivel) {
        return "Nave: "+detalle.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+detalle.ubicacion.numeroOrden;
      } else {
        return "La caja no posee ubicación";
      }
    }


    function cargarDetalles(){
      vm.detallesInventariables = [];
      vm.detallesNoInventariables = [];
      vm.detalles.forEach(function(detalle){
        if (detalle.suministro.tipoSuministro.inventariable){
          vm.detallesInventariables.push(detalle);
        } else {
          vm.detallesNoInventariables.push(detalle);
        }
      });
      if (vm.detallesNoInventariables.length>0){
        armarDetallesNoInventariables();
      } else {
        actualizarTablaNoInventariables();
      }
      if (vm.detallesInventariables.length>0){
        if (vm.egreso.caja){
          armarDetallesInventariablesCajas();
        } else {
          armarDetallesInventariables();
        }
      } else {
        actualizarTablaInventariables();
      }
    }

    function obtenerTiposUtilizados(){
      var esta = false;
      vm.detallesNoInventariables.forEach(function(detalle){
        esta = false;
        vm.detallesNoInventariablesAgrupados.forEach(function(agrupado){
          if (detalle.suministro.tipoSuministro.id==agrupado.tipoSuministro.id){
            esta = true;
          }
        });
        if (!esta){
          vm.detallesNoInventariablesAgrupados.push({tipoSuministro:detalle.suministro.tipoSuministro, precioTotal:0.0, cantidad:0, detalles:[]});
        }
      });
    }

    function armarDetallesNoInventariablesAgrupados(){
      vm.detallesNoInventariablesAgrupados.forEach(function(agrupado){
        vm.detallesNoInventariables.forEach(function(detalle){
          if (agrupado.tipoSuministro.id===detalle.suministro.tipoSuministro.id){
            agrupado.detalles.push({suministro:detalle.suministro, cantidad:detalle.cantidad});
            agrupado.cantidad = agrupado.cantidad + detalle.cantidad;
            agrupado.precioTotal = agrupado.precioTotal + detalle.suministro.precioUnitario*detalle.cantidad;
          }
        });
      });
    }

    function armarDetallesNoInventariables(){
      obtenerTiposUtilizados();
      armarDetallesNoInventariablesAgrupados();
      actualizarTablaNoInventariables();
    }

    function obtenerTiposInventariablesUtilizados(){
      var esta = false;
      vm.detallesInventariables.forEach(function(detalle){
        esta = false;
        vm.detallesInventariablesAgrupados.forEach(function(agrupado){
          if (detalle.suministro.tipoSuministro.id==agrupado.tipoSuministro.id){
            esta = true;
          }
        });
        if (!esta){
          vm.detallesInventariablesAgrupados.push({tipoSuministro:detalle.suministro.tipoSuministro, precioTotal:0.0, cantidad:0, detalles:[]});
        }
      });
    }

    function armarDetallesInventariablesAgrupados(){
      vm.detallesInventariablesAgrupados.forEach(function(agrupado){
        vm.detallesInventariables.forEach(function(detalle){
          if (agrupado.tipoSuministro.id===detalle.suministro.tipoSuministro.id){
            agrupado.detalles.push({suministro:detalle.suministro, suministroInventariable:detalle.suministroInventariable, cantidad:detalle.cantidad});
            agrupado.cantidad = agrupado.cantidad + detalle.cantidad;
            agrupado.precioTotal = agrupado.precioTotal + detalle.suministro.precioUnitario;
          }
        });
      });
    }

    function armarDetallesInventariables(){
      obtenerTiposInventariablesUtilizados();
      armarDetallesInventariablesAgrupados();
      actualizarTablaInventariables();
    }

    function armarDetallesCajaAgrupados(){
      vm.detallesInventariablesAgrupadosCajas = [];
      vm.cajasAsignadas.forEach(function(numeroCaja){
        vm.detallesInventariablesAgrupadosCajas.push({numeroCaja:numeroCaja, tipoSuministro:null, precioTotal:0.0, cantidad:0, detalles:[], ubicacion:null});
      });
    }

    function armarDetallesInventariablesAgrupadosCajas(){
      vm.detallesInventariablesAgrupadosCajas.forEach(function(agrupado){
        vm.detallesInventariables.forEach(function(detalle){
          if (agrupado.numeroCaja===detalle.numeroCaja){
            agrupado.detalles.push({suministro:detalle.suministro, suministroInventariable:detalle.suministroInventariable, cantidad:detalle.cantidad});
            agrupado.cantidad = agrupado.cantidad + detalle.cantidad;
            agrupado.precioTotal = agrupado.precioTotal + detalle.suministro.precioUnitario;
            agrupado.ubicacion = detalle.suministro.ubicacion;
            agrupado.tipoSuministro = detalle.suministro.tipoSuministro;
          }
        });
      });
    }

    function armarDetallesInventariablesCajas(){
      armarDetallesCajaAgrupados();
      armarDetallesInventariablesAgrupadosCajas();
      actualizarTablaInventariablesCajas();
    }

    function editarProblemas(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea agregar o quitar problemas en este egreso?', function(){
        $state.go('home.problemas-egreso',{objeto:vm.egreso.id});
      });
    }

    function editarSuministro(suministro){
      if (suministro.suministro && suministro.suministro.tipoSuministro && suministro.suministro.tipoSuministro.inventariable) {
        editarSuministroInventariable(suministro);
      } else {
        editarSuministroNoInventariable(suministro);
      }
    }

    function editarSuministroInventariable(suministro){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Está seguro que desea editar la información del suministro?", function(){
        ServicioDialogos.abrirDialogoCargando();
        ServicioModales.abrirModalEditarSuministro({
          onResult: function(resultado){
            $window.location.reload();
          },
          suministro:suministro.suministroInventariable,
          modo:'editar'
        });
      });
    }

    function editarSuministroNoInventariable(suministro){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Está seguro que desea editar la información del suministro?", function(){
        ServicioDialogos.abrirDialogoCargando();
        ServicioModales.abrirModalEditarSuministroNoInventariable({
          onResult: function(resultado){
            $window.location.reload();
          },
          suministro:suministro.suministro,
          modo:'editar'
        });
      });
    }

    function volver(){
      if (estadoAnterior==2){
        $window.history.back();
      } else {
        $state.go("home.lista-egreso-donacion-scrap");
      }
    }

    function montoTotal(){
      var total = 0;
      for(var i = 0; i < vm.egreso.detalles.length; i++){
        total += vm.egreso.detalles[i].suministro.precioUnitario*vm.egreso.detalles[i].cantidad;
      }
      return total ? '$ '+total.toFixed(2) : "-";
    }

    function actualizarTablaNoInventariables(){
      vm.tableParamsNoInventariableAgrupado.settings({
        data: vm.detallesNoInventariablesAgrupados,
        noPager: true,
        counts: []
      });
      vm.tableParamsNoInventariableAgrupado.reload();
    }

    function actualizarTablaInventariables(){
      vm.tableParamsInventariableAgrupado.settings({
        data: vm.detallesInventariablesAgrupados,
        noPager: true,
        counts: []
      });
      vm.tableParamsInventariableAgrupado.reload();
    }

    function actualizarTablaInventariablesCajas(){
      vm.tableParamsInventariableAgrupadoCajas.settings({
        data: vm.detallesInventariablesAgrupadosCajas,
        noPager: true,
        counts: []
      });
      vm.tableParamsInventariableAgrupadoCajas.reload();
    }

    function actualizarTabla(){
      vm.tableParams1.settings({
        data: orderByFilter(vm.egreso.problemas,'nombre', false),
        noPager: true,
        count: []
      });
      vm.tableParams1.reload();
    }

    function crearTablas(){
      vm.tableParamsInventariableAgrupado = new NgTableParams({
        page: 1,
        count: 10,
        group:{
          tipoSuministro: 'desc'
        }
      });
      vm.tableParamsNoInventariableAgrupado = new NgTableParams({
        page: 1,
        count: 10,
        group:{
          tipoSuministro: 'desc'
        }
      });
      vm.tableParams1 = new NgTableParams({
        page:1,
        count:20
      });
      vm.tableParamsInventariableAgrupadoCajas = new NgTableParams({
        page: 1,
        count: 10,
        group:{
          tipoSuministro: 'desc'
        }
      });
    }

    function comprobarEstadoEgreso(){
      return vm.egreso && vm.egreso.estadoMovimiento && (vm.egreso.estadoMovimiento.id<=24 && vm.egreso.estadoMovimiento.id>=17);
    }
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-preparados-donacion-scrap', {
        url: 'lista-preparados-donacion-scrap',
        templateUrl: 'app/app/main/movimientos/donacion-scrap/egreso/lista-preparados/lista-preparados.html',
        controller: 'ListaEgresoPreparadosDonacionScrapCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar egresos para donación o scrap-reparación',
          subtitulo:'Listado de egresos preparados'
        },
        resolve: {
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          deposito: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return usuario.empleado.deposito;
              } else {
                return ;
              }
            });
          },
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data){
              return data;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaEgresoPreparadosDonacionScrapCtrl', ListaEgresoPreparadosDonacionScrapCtrl);

  /** @ngInject */
  function ListaEgresoPreparadosDonacionScrapCtrl(NgTableParams, deposito, HeaderBarService, $filter, focus, empresas, depositos, EgresoPreparadpDonacionScrapDepositoEmpresaEstadoUltimosCien , $stateParams, $scope, orderByFilter, $state, ServicioModales, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.egresos = [];
    vm.depositos = orderByFilter(depositos,'nombre',false);
    vm.deposito = deposito;
    vm.empresas = orderByFilter(empresas, 'nombre', false);
    vm.visualizarEgreso = visualizarEgreso;
    vm.comprobarSeleccionado = comprobarSeleccionado;
    vm.despacharSeleccionados = despacharSeleccionados;
    vm.buscarPorEmpresaDeposito = buscarPorEmpresaDeposito;
    vm.cambiarFiltros = cambiarFiltros;
    vm.verNumeroCajasEgreso = verNumeroCajasEgreso;
    vm.bandera=false;


    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10,
    },{
      getData: function($defer,params){ return filtrarTabla($defer, params);}
    });
    vm.tableParams.reload();

    function verNumeroCajasEgreso(egreso){
      var numeros = [];
      var hash = {};
      egreso.detalles.forEach(function(item){
        numeros.push(item.numeroCaja);
      });
      numeros = numeros.filter(function(current) {
        var exists = !hash[current] || false;
        hash[current] = true;
        return exists;
      });
      ServicioDialogos.mostrarDialogoInformacion("N° de Cajas cerradas", "Este egreso tiene asignadas las cajas cerradas N°:\n"+numeros);
    }


    function filtrarTabla($defer, params) {
      var filtros = params.filter();
      var filtrosNuevos = {};

      for (var key in filtros) {
        if (filtros.hasOwnProperty(key) && filtros[key]!=='') {
          switch(key) {
            case 'tipoMovimiento.nombre':
              angular.extend(filtrosNuevos, {
                tipoMovimiento: {
                nombre: filtros[key]
                }
              });
              break;
            default:
              filtrosNuevos[key] = filtros[key];
          }
        }
      }
      var filtrados = filtros ? $filter('filter')(vm.egresos, filtrosNuevos) : vm.egresos;
      filtrados = params.sorting() ? $filter('orderBy')(filtrados, params.orderBy()) : filtrados;
      if (filtrados && filtrados.length){
        params.total(filtrados.length);
        return $defer.resolve(filtrados.slice((params.page() - 1) * params.count(), params.page() * params.count()));
      } else {
        params.total(0);
        return $defer.resolve(null);
      }
    }

    function despacharSeleccionados(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Está seguro que desea despachar los egresos seleccionados?\nRecuerde que debe seleccionar egresos preparados del mismo tipo de movimiento", function(){
        ServicioDialogos.abrirDialogoCargando();
        armarEgresosSeleccionados();
      });
    }

    function armarEgresosSeleccionados(){
      var egresosSeleccionados = [];
      vm.egresos.forEach(function(egreso){
        if (egreso.seleccionado){
          egresosSeleccionados.push(egreso);
        }
      });
      if (comprobarEgresos(egresosSeleccionados)){
        abrirModalCargaPesoCantidadPaqueteEgresos(egresosSeleccionados);
      } else {
        setTimeout(function() {
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError("Error", "Debe seleccionar egresos del mismo tipo de movimiento");
        }, 1000);
      }
    }

    function comprobarEgresos(egresos){
      var idTipo = egresos[0].tipoMovimiento.id;
      var ban = true;
      egresos.forEach(function(item){
        if (idTipo!=item.tipoMovimiento.id){
          ban = false;
        }
      });
      return ban;
    }

    function abrirModalCargaPesoCantidadPaqueteEgresos(data){
      ServicioModales.abrirModalCargaPesoCantidadPaqueteEgresos({
        onResult: function(resultado) {
          console.log(resultado);
        },
        egresos: data,
        deposito: vm.deposito,
        empresa: vm.empresa
      });
    }

    function comprobarSeleccionado(){
      var hay = false;
      vm.egresos.forEach(function(item){
        if (item.seleccionado){
          hay = true;
        }
      });
      return hay;
    }
    
    function actualizarTabla(data){
      vm.egresos = orderByFilter(data,'fecha',true);
      vm.tableParams.settings({
        data: vm.egresos
      });
      vm.tableParams.reload();
    }

    function visualizarEgreso(egreso){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalVisualizarEgreso({
        onResult: function(resultado) {
          console.log(resultado);
        },
        egreso: egreso,
        deposito: vm.deposito
      });
    }

    function cambiarFiltros(){
      vm.bandera=false;
    }

    function buscarPorEmpresaDeposito(){
      vm.bandera=true;
      ServicioDialogos.abrirDialogoCargando();
      EgresoPreparadpDonacionScrapDepositoEmpresaEstadoUltimosCien.query({'idDeposito':vm.deposito.id, 'idEmpresa':vm.empresa.id}, function(data){
        actualizarTabla(data);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });

    }

    $scope.$watch('vm.deposito.nombre', function(){
      if (!vm.deposito || !vm.deposito.nombre) return;
      focus('empresa');
    });

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-generados-donacion-scrap', {
        url: 'lista-generados-donacion-scrap',
        templateUrl: 'app/app/main/movimientos/donacion-scrap/egreso/lista-generados/lista-generados.html',
        controller: 'ListaEgresoGeneradosDonacionScrapCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar egresos para donación o scrap-reparación',
          subtitulo:'Listado de egresos generados'
        },
        resolve: {
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          deposito: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return usuario.empleado.deposito;
              } else {
                return ;
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaEgresoGeneradosDonacionScrapCtrl', ListaEgresoGeneradosDonacionScrapCtrl);

  /** @ngInject */
  function ListaEgresoGeneradosDonacionScrapCtrl(NgTableParams, deposito, HeaderBarService, $q, $filter, focus, depositos, IngresoEstadoModificar, EgresoModificarEstadoArray, EgresoCreadoDonacionScrapDepositoEstadoUltimosCien , $stateParams, $scope, orderByFilter, $state, ServicioModales, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.egresos = [];
    vm.depositos = orderByFilter(depositos,'nombre',false);
    vm.deposito = deposito;
    vm.visualizarEgreso = visualizarEgreso;
    vm.comprobarSeleccionado = comprobarSeleccionado;
    vm.ubicacionesPorSuministros = ubicacionesPorSuministros;
    vm.buscarPorDeposito = buscarPorDeposito;
    vm.cambiarFiltros = cambiarFiltros;
    vm.verNumeroCajasEgreso = verNumeroCajasEgreso;


    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10,
    },{
      getData: function($defer,params){ return filtrarTabla($defer, params);}
    });
    vm.tableParams.reload();

    inicializar();


    function inicializar(){
      if (deposito && deposito.id){
        vm.deposito=deposito;
        buscarPorDeposito();
      }
    }

    function verNumeroCajasEgreso(egreso){
      var numeros = [];
      var hash = {};
      egreso.detalles.forEach(function(item){
        numeros.push(item.numeroCaja);
      });
      numeros = numeros.filter(function(current) {
        var exists = !hash[current] || false;
        hash[current] = true;
        return exists;
      });
      ServicioDialogos.mostrarDialogoInformacion("N° de Cajas cerradas", "Este egreso tiene asignadas las cajas cerradas N°:\n"+numeros);
    }

    function filtrarTabla($defer, params) {
      var filtros = params.filter();
      var filtrosNuevos = {};

      for (var key in filtros) {
        if (filtros.hasOwnProperty(key) && filtros[key]!=='') {
          switch(key) {
            case 'empresa.nombre':
              angular.extend(filtrosNuevos, {
                empresa: {
                nombre: filtros[key]
                }
              });
              break;
            case 'sucursal.nombre':
              angular.extend(filtrosNuevos, {
                sucursal: {
                nombre: filtros[key]
                }
              });
              break;
            default:
              filtrosNuevos[key] = filtros[key];
          }
        }
      }
      var filtrados = filtros ? $filter('filter')(vm.egresos, filtrosNuevos) : vm.egresos;
      filtrados = params.sorting() ? $filter('orderBy')(filtrados, params.orderBy()) : filtrados;
      if (filtrados && filtrados.length){
        params.total(filtrados.length);
        return $defer.resolve(filtrados.slice((params.page() - 1) * params.count(), params.page() * params.count()));
      } else {
        params.total(0);
        return $defer.resolve(null);
      }
    }

    function ubicacionesPorSuministros(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Está seguro que desea generar un listado de ubicaciones por los suministros de los egresos seleccionados?", function(){
        armarEgresosSeleccionados();
      });
    }

    function armarEgresosSeleccionados(){
      var egresosSeleccionados = [];
      vm.egresos.forEach(function(egreso){
        if (egreso.seleccionado){
          egresosSeleccionados.push(egreso);
        }
      });
      abrirModalVisualizarInformeRecorrido(egresosSeleccionados);
    }

    function abrirModalVisualizarInformeRecorrido(data){
      ServicioModales.abrirModalVisualizarInformeRecorrido({
        onResult: function(resultado) {
          console.log(resultado);
          buscarPorDeposito();
        },
        egresos: data,
        deposito: vm.deposito
      });
    }

    function comprobarSeleccionado(){
      var hay = false;
      vm.egresos.forEach(function(item){
        if (item.seleccionado){
          hay = true;
        }
      });
      return hay;
    }
    
    function actualizarTabla(data){
      vm.egresos = orderByFilter(data,'fecha',true);
      vm.tableParams.settings({
        data: vm.egresos
      });
      vm.tableParams.reload();
    }

    function visualizarEgreso(egreso){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalVisualizarEgreso({
        onResult: function(resultado) {
          console.log(resultado);
        },
        egreso: egreso,
        deposito: vm.deposito
      });
    }


    function cambiarFiltros(){
      vm.bandera=false;
    }

    function buscarPorDeposito(){
      vm.bandera=true;
      ServicioDialogos.abrirDialogoCargando();
      EgresoCreadoDonacionScrapDepositoEstadoUltimosCien.query({'idDeposito':vm.deposito.id}, function(data){
        actualizarTabla(data);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });


    }

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-despachados-donacion-scrap', {
        url: 'lista-despachados-donacion-scrap',
        templateUrl: 'app/app/main/movimientos/donacion-scrap/egreso/lista-despachados/lista-despachados.html',
        controller: 'ListaEgresoDespachadosDonacionScrapCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar egresos para donación o scrap-reparación',
          subtitulo:'Listado de egresos - Despachos',
          deposito:null
        },
        resolve: {
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          deposito: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return usuario.empleado.deposito;
              } else {
                return ;
              }
            });
          }
        }
      });
  }
})();

'use strict';
angular.module('proyecto-az-suministro')
  .factory('EgresoDespachoPorDeposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/egreso?deposito.id=:idDeposito", {idDeposito:"@idDeposito"});
  })
  .factory('EgresoDespachoPorDeposito4Estados', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/egreso?deposito.id=:idDeposito&&idEstado1=:idEstado1&&idEstado2=:idEstado2&&idEstado3=:idEstado3&&idEstado4=:idEstado4", {idDeposito:"@idDeposito", idEstado1:"@idEstado1", idEstado2:"@idEstado2", idEstado3:"@idEstado3", idEstado4:"@idEstado4"});
  });

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaEgresoDespachadosDonacionScrapCtrl', ListaEgresoDespachadosDonacionScrapCtrl);

  /** @ngInject */
  function ListaEgresoDespachadosDonacionScrapCtrl(NgTableParams, HeaderBarService, deposito, $filter, focus, depositos, EgresoDespachoPorDeposito2Estados , $stateParams, $scope, orderByFilter, $state, ServicioModales, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.egresos = [];
    vm.depositos = orderByFilter(depositos,'nombre',false);
    vm.visualizarEgreso = visualizarEgreso;
    vm.buscarPorDeposito = buscarPorDeposito;
    vm.cambiarFiltros = cambiarFiltros;
    vm.bandera=false;

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10,
    },{
      getData: function($defer,params){ return filtrarTabla($defer, params);}
    });
    vm.tableParams.reload();

    inicializar();


    function inicializar(){
      if (deposito && deposito.id){
        vm.deposito=deposito;
        buscarPorDeposito();
      }
    }

    function filtrarTabla($defer, params) {
      var filtros = params.filter();
      var filtrosNuevos = {};

      for (var key in filtros) {
        if (filtros.hasOwnProperty(key) && filtros[key]!=='') {
          switch(key) {
            case 'empresa.nombre':
              angular.extend(filtrosNuevos, {
                empresa: {
                nombre: filtros[key]
                }
              });
              break;
            case 'empresaLogistica.nombre':
              angular.extend(filtrosNuevos, {
                empresaLogistica: {
                nombre: filtros[key]
                }
              });
              break;
            default:
              filtrosNuevos[key] = filtros[key];
          }
        }
      }
      var filtrados = filtros ? $filter('filter')(vm.egresos, filtrosNuevos) : vm.egresos;
      filtrados = params.sorting() ? $filter('orderBy')(filtrados, params.orderBy()) : filtrados;
      if (filtrados && filtrados.length){
        params.total(filtrados.length);
        return $defer.resolve(filtrados.slice((params.page() - 1) * params.count(), params.page() * params.count()));
      } else {
        params.total(0);
        return $defer.resolve(null);
      }
    }

/*    function armarEgresosSeleccionados(){
      var egresosSeleccionados = [];
      vm.egresos.forEach(function(egreso){
        if (egreso.seleccionado){
          egresosSeleccionados.push(egreso);
        }
      });
      abrirModalCargaPesoCantidadPaqueteEgresos(egresosSeleccionados);
    }*/

    function abrirModalCargaPesoCantidadPaqueteEgresos(data){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalCargaPesoCantidadPaqueteEgresos({
        onResult: function(resultado) {
          console.log(resultado);
        },
        egresos: data,
        deposito: vm.deposito,
        empresa: vm.empresa
      });
    }

    
    function actualizarTabla(data){
      vm.egresos = orderByFilter(data,'fecha',true);
      vm.tableParams.settings({
        data: vm.egresos
      });
      vm.tableParams.reload();
    }

    function actualizarEgresos(egreso){
      vm.egresos.forEach(function(item){
        if (item.id === egreso.id){
          item.nroGuia = egreso.nroGuia;
        }
      });
    }

    function visualizarEgreso(egreso){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalVisualizarDespacho({
        onResult: function(resultado) {
          actualizarEgresos(resultado.egreso);
          actualizarTabla(vm.egresos);
        },
        egreso: egreso,
      });
    }

    function cambiarFiltros(){
      vm.bandera=false;
    }

    function buscarPorDeposito(){
      vm.bandera=true;
      ServicioDialogos.abrirDialogoCargando();
      EgresoDespachoPorDeposito2Estados.query({'idDeposito':vm.deposito.id, 'idEstado1':3,'idEstado2':4}, function(data){
        actualizarTabla(data);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });

    }

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-egreso-donacion-scrap', {
        url: 'lista-egreso-donacion-scrap',
        templateUrl: 'app/app/main/movimientos/donacion-scrap/egreso/lista/lista-egreso.html',
        controller: 'ListaEgresoDonacionScrapCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar egresos para donación o scrap-reparación',
          subtitulo:'Lista de egresos'
        },
        resolve: {
          egresos: function(DonacionScrapEgresoUltimosCien, Usuario, DonacionScrapEgresoUltimosCienDeposito){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return DonacionScrapEgresoUltimosCienDeposito.query({'idDeposito':usuario.empleado.deposito.id}).$promise.then(function(data){
                  return data;
                });
              } else {
                return DonacionScrapEgresoUltimosCien.query({}).$promise.then(function(data){
                  return data;
                });
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaEgresoDonacionScrapCtrl', ListaEgresoDonacionScrapCtrl);

  /** @ngInject */
  function ListaEgresoDonacionScrapCtrl(NgTableParams, HeaderBarService, $filter, Usuario, focus, egresos, IngresoEstadoModificar, EgresoEstadoModificar, DonacionScrapEgresoUltimosCienDeposito, DonacionScrapEgresoUltimosCien, $stateParams, $scope, orderByFilter, $state, ServicioModales, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.egresos = orderByFilter(egresos,'fecha',true);
    vm.visualizarEgreso = visualizarEgreso;
    vm.crearNuevo = crearNuevo;
    vm.editar = editar;
    vm.eliminar = eliminar;
    vm.filtrar = filtrar;
    vm.bandera = false;
    vm.busqueda = busqueda;
    vm.abrirModalFiltros = abrirModalFiltros;
    vm.abrirModalFiltroCajas = abrirModalFiltroCajas;
    vm.abrirModalFiltroNumeroVale = abrirModalFiltroNumeroVale;
    vm.cambiarEstado = cambiarEstado;
    vm.verNumeroCajasEgreso = verNumeroCajasEgreso;

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10,
    },{
      getData: function($defer,params){ return filtrarTabla($defer, params);}
    });
    vm.tableParams.reload();

    function abrirModalFiltroCajas(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalFiltroBusquedaIngresoCajas({
        onResult: function(resultado){
          vm.bandera=true;
          vm.filtrosUsados = resultado.filtros;
          actualizarTabla(resultado.detalles);
        },
        tipo: 1
      });
    }

    function abrirModalFiltroNumeroVale(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalFiltroBusquedaIngresoCajas({
        onResult: function(resultado){
          vm.bandera=true;
          vm.filtrosUsados = resultado.filtros;
          actualizarTabla(resultado.detalles);
        },
        tipo: 1,
        numeroVale: true
      });
    }

    function verNumeroCajasEgreso(egreso){
      var numeros = [];
      var hash = {};
      egreso.detalles.forEach(function(item){
        numeros.push(item.numeroCaja);
      });
      numeros = numeros.filter(function(current) {
        var exists = !hash[current] || false;
        hash[current] = true;
        return exists;
      });
      ServicioDialogos.mostrarDialogoInformacion("N° de Cajas cerradas", "Este egreso tiene asignadas las cajas cerradas N°:\n"+numeros);
    }


    function filtrarTabla($defer, params) {
      var filtros = params.filter();
      var filtrosNuevos = {};

      for (var key in filtros) {
        if (filtros.hasOwnProperty(key) && filtros[key]!=='') {
          switch(key) {
            case 'deposito.nombre':
              angular.extend(filtrosNuevos, {
                deposito: {
                nombre: filtros[key]
                }
              });
              break;
            case 'empresa.nombre':
              angular.extend(filtrosNuevos, {
                empresa: {
                nombre: filtros[key]
                }
              });
              break;
            case 'tipoMovimiento.nombre':
              angular.extend(filtrosNuevos, {
                tipoMovimiento: {
                nombre: filtros[key]
                }
                });
              break;
            case 'estadoMovimiento.nombre':
              angular.extend(filtrosNuevos, {
                estadoMovimiento: {
                nombre: filtros[key]
                }
              });
              break;
            default:
              filtrosNuevos[key] = filtros[key];
          }
        }
      }
      var filtrados = filtros ? $filter('filter')(vm.egresos, filtrosNuevos) : vm.egresos;
      filtrados = params.sorting() ? $filter('orderBy')(filtrados, params.orderBy()) : filtrados;
      if (filtrados && filtrados.length){
        params.total(filtrados.length);
        return $defer.resolve(filtrados.slice((params.page() - 1) * params.count(), params.page() * params.count()));
      } else {
        params.total(0);
        return $defer.resolve(null);
      }
    }

    function abrirModalFiltros(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalFiltroBusquedaEgreso({
        onResult: function(resultado){
          vm.bandera=true;
          vm.filtrosUsados = resultado.filtros;
          actualizarTabla(resultado.detalles);
        }
      });
    }

    function busqueda(){
      vm.bandera=false;
      vm.filtrosUsados=null;
      if (vm.buscar) {
        vm.egresos=null;
        actualizarTabla(vm.egresos);
      } else {
        filtrar();
      }
    }
    
    function actualizarTabla(data){
      vm.egresos = orderByFilter(data,'fecha',true);
      vm.tableParams.settings({
        data: vm.egresos
      });
      vm.tableParams.reload();
    }

    function filtrar(){
      ServicioDialogos.abrirDialogoCargando();
      if (!vm.buscar){
        obtenerUltimos();
      } else {
        actualizarTabla(undefined);
      }

    }

    function obtenerEstadoEnPreparacion(egreso){
      if (egreso.estadoMovimiento.id==17){
        return 18;
      } else {
        return 22;
      }
    }

    function obtenerEstadoPreparado(egreso){
      if (egreso.estadoMovimiento.id==18){
        return 19;
      } else {
        return 23;
      }
    }

    function cambiarEstado(egreso){
      if (egreso.estadoMovimiento.id==17 || egreso.estadoMovimiento.id==21){
        ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Desea cambiar el estado del egreso a EN PREPARACIÓN?', function() {
          var estado = obtenerEstadoEnPreparacion(egreso);
          prepararEgreso(egreso, estado);
        },null, false);
      } else if (egreso.estadoMovimiento.id==18 ||  egreso.estadoMovimiento.id==22){
        ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Desea cambiar el estado del egreso a PREPARADO?', function() {
          var estado = obtenerEstadoPreparado(egreso);
          prepararEgreso(egreso, estado);
        },null, false);
      }
    }

    function prepararEgreso(egreso, estado){
      IngresoEstadoModificar.update({idMovimiento:egreso.id, idEstado:estado}, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, "Se ha actualizado el estado del egreso con éxito.", function(){
          obtenerUltimos();
        });
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar el ingreso");
      });
    }

    function visualizarEgreso(egreso){
      if (egreso.estadoMovimiento.id===24 || egreso.estadoMovimiento.id===20){
        $state.go('home.visualizar-egreso-despachado-donacion-scrap', {objeto:egreso.id});
      } else {
        $state.go('home.visualizar-egreso-donacion-scrap', {objeto:egreso.id});
      }
    }

    function editar(egreso) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el egreso?', function() {
        $state.go('home.editar-egreso-donacion-scrap', {objeto:egreso.id, modo:'editar'});
      });
    }

    function eliminar(egreso) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea eliminar el egreso?', function() {
        anularEgreso(egreso);
      });
    }

    function obtenerEstadoEliminado(idTipo){
      if (idTipo==7){
        return 25;
      } else if(idTipo==8){
        return 26;
      } else {
        return 8;
      }
    }

    function anularEgreso(egreso){
      ServicioDialogos.abrirDialogoCargando();
      EgresoEstadoModificar.update({idMovimiento:egreso.id, idEstado:obtenerEstadoEliminado(egreso.tipoMovimiento.id)}, function(data){
        obtenerUltimos();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar el egreso");
      });

    }

    function obtenerUltimos(){
      Usuario.obtenerUsuario().$promise.then(function(usuario){
        if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
          DonacionScrapEgresoUltimosCienDeposito.query({'idDeposito':usuario.empleado.deposito.id}).$promise.then(function(data){
            ServicioDialogos.cerrarDialogoCargando();
            actualizarTabla(data);
          }, function(err){
            console.error(err);
            ServicioDialogos.cerrarDialogoCargando();
          });
        } else {
          DonacionScrapEgresoUltimosCien.query({}).$promise.then(function(data){
            ServicioDialogos.cerrarDialogoCargando();
            actualizarTabla(data);
          }, function(err){
            console.error(err);
            ServicioDialogos.cerrarDialogoCargando();
          });
        }
      });
    }

    function crearNuevo() {
      $state.go('home.editar-egreso-donacion-scrap');
    }


  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-egreso-donacion-scrap', {
        url: 'editar-egreso-donacion-scrap',
        templateUrl: 'app/app/main/movimientos/donacion-scrap/egreso/editar/editar-egreso.html',
        controller: 'EditarEgresoDonacionScrapCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Egreso de suministros',
          subtituloEditar:'Editar egreso donación o scrap-reparación',
          subtituloNuevo: 'Nuevo egreso',
          egreso:null,
          editar:null
        },
        resolve: {
          //el deposito se traerá dependiendo del usuario registrado.
          //si es admin traigo todos sino el del usuario
          egreso: function($stateParams){
            return $stateParams.egreso? $stateParams.egreso : {};
          },
          usuario: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario;
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          deposito: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return usuario.empleado.deposito;
              } else {
                return ;
              }
            });
          },
          tipoDonacion: function(TipoMovimiento){
            return TipoMovimiento.get({id:7}).$promise.then(function(data) {
              return data;
            });
          },
          tipoScrap: function(TipoMovimiento){
            return TipoMovimiento.get({id:8}).$promise.then(function(data) {
              return data;
            });
          },
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data){
              return data;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarEgresoDonacionScrapCtrl', EditarEgresoDonacionScrapCtrl);

  /** @ngInject */
  function EditarEgresoDonacionScrapCtrl(NgTableParams, usuario, deposito, SolicitanteEmpresa, HeaderBarService, egreso, focus, SucursalEmpresa, EgresoNumeroValeEmpresa, depositos, tipoDonacion, tipoScrap, empresas, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    egreso.empresa? HeaderBarService.setSubTitulo($stateParams.subtituloEditar) : HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);

    var vm = this;
    vm.tipos = [];
    vm.tipos.push(tipoDonacion);
    vm.tipos.push(tipoScrap);
    vm.depositos = orderByFilter(depositos,'nombre',false);
    vm.empresas = orderByFilter(empresas,'nombre',false);
    vm.egreso = egreso;
    vm.egreso.usuario = usuario;
    vm.egreso.deposito = deposito;
    vm.siguiente = siguiente;
    vm.cancelar = cancelar;


    window.onbeforeunload = function(){
      return "seguro?";
    };


    function cancelar(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea cancelar el egreso?', function() {
        $state.go('home.lista-egreso-donacion-scrap');
      });
    }

    function siguiente(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, 'Verifique los datos. ¿Desea continuar con el agregado de suministros en el egreso?', function() {
        $state.go('home.agregar-suministros-egreso-donacion-scrap', {'objeto':vm.egreso});
      });

    }

    function esEditar(){
      return vm.modo == "editar";
    }

    $scope.$watch('vm.egreso.empresa.nombre', function(){
      if (!vm.form.$dirty) {
        vm.form.$setDirty();
        return;
      }
      if (vm.egreso.sucursal) vm.egreso.sucursal=null;
      if (vm.egreso.solicita) vm.egreso.solicita=null;
      if (!vm.egreso.empresa) return;
      ServicioDialogos.abrirDialogoCargando();
      SolicitanteEmpresa.query({id:vm.egreso.empresa.id}, function(datos){
        vm.solicitantes = orderByFilter(datos, ["apellido", "nombre"], false);
        focus('tipoMovimiento');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(e){
        console.log(e);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });


  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.agregar-suministros-egreso-donacion-scrap', {
        url: 'agregar-suministros-egreso-donacion-scrap/',
        templateUrl: 'app/app/main/movimientos/donacion-scrap/egreso/agregar-suministros-egreso/agregar-suministros-egreso.html',
        controller: 'AgregarSuministroEgresoDonacionScrapCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Egreso de suministros para donación o scrap-reparación',
          subtitulo: 'Agregar suministros',
          objeto:null
        },
        resolve: {
          estadoGenerado: function($stateParams, EstadoMovimiento){
            if ($stateParams.objeto && $stateParams.objeto.tipoMovimiento.id==7){
              return EstadoMovimiento.get({id:17}).$promise.then(function(data){
                return data;
              });
            } else {
              return EstadoMovimiento.get({id:21}).$promise.then(function(data){
                return data;
              });
            }
          },
          egreso: function(Egreso, $stateParams){
            return $stateParams.objeto? $stateParams.objeto : {};
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('AgregarSuministroEgresoDonacionScrapCtrl', AgregarSuministroEgresoDonacionScrapCtrl);

  /** @ngInject */
  function AgregarSuministroEgresoDonacionScrapCtrl(NgTableParams, $filter, UltimoMovimiento, egreso, ServicioModales, estadoGenerado, HeaderBarService, Egreso, $timeout, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.estadoGenerado = estadoGenerado;
    vm.egreso = egreso;
    vm.ocultar=true;
    inicializar();


    vm.volver = volver;

    vm.detalles = [];
    vm.detallesInventariables = [];
    vm.detallesNoInventariables = [];

    vm.detallesNoInventariablesAgrupados = [];
    vm.detallesInventariablesAgrupados = [];

    vm.mostrarInformacion = mostrarInformacion;
    vm.ubicacionCompleta = ubicacionCompleta;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.quitarTipo = quitarTipo;
    vm.modo = "nuevo";
    vm.abrirModal = abrirModal;
    vm.guardar = guardar;
    vm.montoTotal = montoTotal;
    vm.getIcono = getIcono;

    window.onbeforeunload = function(){
      return '';
    };


    function inicializar(){
      if (vm.egreso && vm.egreso.empresa && vm.egreso.empresa.id){
        vm.fecha = $filter('date')(new Date(), 'dd/MM/yyyy HH:mm');
        vm.solicitante = vm.egreso.solicita? vm.egreso.solicita.apellido&&vm.egreso.solicita.nombre? vm.egreso.solicita.apellido.toUpperCase()+", "+vm.egreso.solicita.nombre : "-":"-";
      } else {
        vm.ocultar=false;
      }
    }

    function getIcono(estaAbierto) {
      if (estaAbierto) {
        return 'glyphicon glyphicon-chevron-down';
      } else {
        return 'glyphicon glyphicon-chevron-right';
      }
    }

    function montoTotal(){
      var total = 0;
      for(var i = 0; i < vm.detalles.length; i++){
        total += vm.detalles[i].suministro.precioUnitario*vm.detalles[i].cantidad;
      }
      return total ? total.toFixed(2) : "-";
    }

    function guardar(){
      if (vm.detalles.length===0){
        ServicioDialogos.mostrarDialogoError(null, "No ha agregado ningún suministro");
      } else {
        ServicioDialogos.mostrarDialogoConfirmacionWarning(
          null,
          "¿Está seguro que desea guardar el egreso?",
          function(){
            guardarEgreso();
          },
          null,
          false
        );
      }
    }

    function ubicacionCompleta(detalle){
      if (detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación",
        "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+detalle.suministro.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+detalle.suministro.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+detalle.suministro.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+detalle.suministro.ubicacion.numeroUbicacion+
        "\nN° de orden: "+detalle.suministro.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+detalle.suministro.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+detalle.suministro.ubicacion.categoriaPeso.nombre.toUpperCase());
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "No hay ubicación");
      }
    }

    function ubicacionNaveNumeroOrden(detalle){
      if (detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        return "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+detalle.suministro.ubicacion.numeroOrden;
      }
    }

    function quitarTipo(agrupado){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(
        null,
        "¿Está seguro que desea eliminar el detalle?",
        function(){
          limpiarTipo(agrupado.tipoSuministro);
        }
      );
    }

    function limpiarTipo(tipo){
      for (var i = vm.detalles.length - 1; i >= 0; i--) {
        if (vm.detalles[i].suministro.tipoSuministro.id == tipo.id){
          vm.detalles.splice(i, 1);
        }
      }
      vm.detallesNoInventariablesAgrupados = [];
      vm.detallesInventariablesAgrupados = [];
      cargarDetalles();
    }

    function obtenerNumeroMovimiento(callback){
      UltimoMovimiento.get({}, function(data){
        if (data && !isNaN(data.id)){
          callback(data.id + 10001);
        } else {
          callback(10001);
        }
      }, function (err){
        console.log(err);
      });
    }

    function obtenerEgreso(callback){
      obtenerNumeroMovimiento(function(data){
        var movimiento = {
          tipoMovimiento: vm.egreso.tipoMovimiento,
          estadoMovimiento: estadoGenerado,
          deposito: vm.egreso.deposito,
          empresa: vm.egreso.empresa,
          observacion: vm.egreso.observacion,
          fecha: new Date(),
          detalles: vm.detalles,
          usuario: vm.egreso.usuario,
          solicita: vm.egreso.solicita,
          solicitante: vm.egreso.solicitante,
          numeroVale: vm.egreso.numeroVale,
          numeroMovimiento: data,
          numeroMail: vm.egreso.numeroMail
        };
        callback(movimiento);
      });
    }


    function guardarEgreso(){
      obtenerEgreso(function(movimiento){
        Egreso.save(movimiento, function(data){
          ServicioDialogos.mostrarDialogoGuardadoExito(
            null,
            "Se ha registrado con éxito el egreso",
            function(){
              $state.go('home.lista-egreso-donacion-scrap');
            });
        }, function(err){
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar el egreso");
        });
      });
    }

    function cargarDetalles(){
      vm.detallesInventariables = [];
      vm.detallesNoInventariables = [];
      vm.detalles.forEach(function(detalle){
        if (detalle.suministro.tipoSuministro.inventariable){
          vm.detallesInventariables.push(detalle);
        } else {
          vm.detallesNoInventariables.push(detalle);
        }
      });
      if (vm.detallesNoInventariables.length>0){
        armarDetallesNoInventariables();
      } else {
        actualizarTablaNoInventariables();
      }
      if (vm.detallesInventariables.length>0){
        armarDetallesInventariables();
      } else {
        actualizarTablaInventariables();
      }
    }

    function obtenerTiposUtilizados(){
      var esta = false;
      vm.detallesNoInventariables.forEach(function(detalle){
        esta = false;
        vm.detallesNoInventariablesAgrupados.forEach(function(agrupado){
          if (detalle.suministro.tipoSuministro.id==agrupado.tipoSuministro.id){
            esta = true;
          }
        });
        if (!esta){
          vm.detallesNoInventariablesAgrupados.push({tipoSuministro:detalle.suministro.tipoSuministro, precioTotal:0.0, cantidad:0, detalles:[]});
        }
      });
    }

    function armarDetallesNoInventariablesAgrupados(){
      vm.detallesNoInventariablesAgrupados.forEach(function(agrupado){
        vm.detallesNoInventariables.forEach(function(detalle){
          if (agrupado.tipoSuministro.id===detalle.suministro.tipoSuministro.id){
            agrupado.detalles.push({suministro:detalle.suministro, cantidad:detalle.cantidad});
            agrupado.cantidad = agrupado.cantidad + detalle.cantidad;
            agrupado.precioTotal = agrupado.precioTotal + detalle.suministro.precioUnitario;
          }
        });
      });
    }

    function armarDetallesNoInventariables(){
      obtenerTiposUtilizados();
      armarDetallesNoInventariablesAgrupados();
      actualizarTablaNoInventariables();
    }

    function obtenerTiposInventariablesUtilizados(){
      var esta = false;
      vm.detallesInventariables.forEach(function(detalle){
        esta = false;
        vm.detallesInventariablesAgrupados.forEach(function(agrupado){
          if (detalle.suministro.tipoSuministro.id==agrupado.tipoSuministro.id){
            esta = true;
          }
        });
        if (!esta){
          vm.detallesInventariablesAgrupados.push({tipoSuministro:detalle.suministro.tipoSuministro, precioTotal:0.0, cantidad:0, detalles:[]});
        }
      });
    }

    function armarDetallesInventariablesAgrupados(){
      vm.detallesInventariablesAgrupados.forEach(function(agrupado){
        vm.detallesInventariables.forEach(function(detalle){
          if (agrupado.tipoSuministro.id===detalle.suministro.tipoSuministro.id){
            agrupado.detalles.push({suministro:detalle.suministro, suministroInventariable:detalle.suministroInventariable, cantidad:detalle.cantidad});
            agrupado.cantidad = agrupado.cantidad + detalle.cantidad;
            agrupado.precioTotal = agrupado.precioTotal + detalle.suministro.precioUnitario;
          }
        });
      });
    }

    function armarDetallesInventariables(){
      obtenerTiposInventariablesUtilizados();
      armarDetallesInventariablesAgrupados();
      actualizarTablaInventariables();
    }

    function abrirModal(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalAgregarSuministroEgreso({
        onResult: function(resultado) {
          vm.detalles = resultado.detalles;
          vm.detallesNoInventariablesAgrupados = [];
          vm.detallesInventariablesAgrupados = [];
          cargarDetalles();
        },
        detalles: vm.detalles,
        empresa: vm.egreso.empresa,
        deposito: vm.egreso.deposito.id,
        tipoMovimiento: vm.egreso.tipoMovimiento
      });
    }

    function esEditar(){
      return vm.modo == "editar";
    }

    function volver(){
      if (vm.ocultar){
        ServicioDialogos.mostrarDialogoConfirmacionWarning(
          null,
          "Si vuelve a la pantalla de edición de egreso, perderá la información de todos los suministros que haya agregado. ¿Está seguro que desea volver?",
          function(){
            $state.go("home.editar-egreso-donacion-scrap", {egreso:egreso});
          }
        );
      } else {
        $state.go("home.editar-egreso-donacion-scrap", {});
      }
    }

    function mostrarInformacion(detalle){
      var marca = detalle.suministro.marca ? detalle.suministro.marca : "-";
      var fecha = detalle.suministro.fechaVencimiento ? detalle.suministro.fechaVencimiento : "-";
      ServicioDialogos.mostrarDialogoInformacion(
        null,
        "Tipo de suministro: "+detalle.suministro.tipoSuministro.nombre.toUpperCase()+
        "\nMarca: "+marca.toUpperCase()+
        "\nFecha vencimiento: "+$filter('date')(fecha, 'dd/MM/yyyy')+
        "\nFamilia de suministro: "+detalle.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase()+
        "\nGrupo de suministro: "+detalle.suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+
        "\nCantidad solicitada: "+detalle.cantidad
      );
    }

    function actualizarTablaNoInventariables(){
      vm.tableParamsNoInventariableAgrupado.settings({
        data: vm.detallesNoInventariablesAgrupados,
        noPager: true,
        counts: []
      });
      vm.tableParamsNoInventariableAgrupado.reload();
    }

    function actualizarTablaInventariables(){
      vm.tableParamsInventariableAgrupado.settings({
        data: vm.detallesInventariablesAgrupados,
        noPager: true,
        counts: []
      });
      vm.tableParamsInventariableAgrupado.reload();
    }

    function comprobarExistencia(){
      var ban = false;
      vm.detalles.forEach(function(detalle){
        if (detalle.suministro.id==vm.suministro.id){
          ban = true;
        }
      });
      return ban;
    }

    function limpiarForm(){
      vm.grupo = null;
      vm.cantidad=null;
      vm.form.cantidad.$dirty = false;
    }

    function agregarDetalle(){
      if (!comprobarExistencia()){
        var detalle = {
          suministro : vm.suministro,
          cantidad : vm.cantidad
        };
        vm.numero = vm.numero+1;
        vm.detalles.push(detalle);
        limpiarForm();
        actualizarTabla(vm.detalles);
      } else {
        ServicioDialogos.mostrarDialogoError(null, "Ya agregó este suministro al pedido");
      }
    }

    $scope.$watch('vm.grupo.nombre', function(){
      vm.familiaSuministro=null;
      if (!vm.grupo) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupo.id}, function(data){
        vm.familias = data;
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.familiaSuministro.nombre', function(){
      vm.suministro=null;
      if (!vm.familiaSuministro) return;
      ServicioDialogos.abrirDialogoCargando();
      TipoSuministroFamilia.query({id:vm.familiaSuministro.id}, function(data){
        vm.suministros = data;
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    vm.tableParamsInventariableAgrupado = new NgTableParams({
      page: 1,
      count: 10,
      group:{
        tipoSuministro: 'desc'
      }
    });
    vm.tableParamsNoInventariableAgrupado = new NgTableParams({
      page: 1,
      count: 10,
      group:{
        tipoSuministro: 'desc'
      }
    });
   
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.visualizar-donacion-scrap', {
        url: 'visualizar-donacion-scrap/:objeto/:estadoAnterior',
        templateUrl: 'app/app/main/movimientos/donacion-scrap/ingreso/visualizar/visualizar-donacion-scrap.html',
        controller: 'VisualizarIngresoDonacionScrapCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar ingresos para donación o scrap-reparación',
          subtituloNuevo: 'Visualizar información del ingreso'
        },
        resolve: {
          ingreso: function(Ingreso, $stateParams){
            if ($stateParams.objeto){
              return Ingreso.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return $stateParams.objeto;
            }
          },
          estadoAnterior: function($stateParams){
            return $stateParams.estadoAnterior? $stateParams.estadoAnterior : 1;
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('VisualizarIngresoDonacionScrapCtrl', VisualizarIngresoDonacionScrapCtrl);

  /** @ngInject */
  function VisualizarIngresoDonacionScrapCtrl(NgTableParams, HeaderBarService, URL_SERVIDOR, $http, $window, ServicioModales, estadoAnterior, ingreso, $stateParams, $filter, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);

    var vm = this;
    vm.ingreso = ingreso;
    vm.volver = volver;
    inicializar();
    vm.editarSuministro = editarSuministro;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.ubicacionCompleta = ubicacionCompleta;
    vm.editarProblemas = editarProblemas;
    vm.comprobarIngresoCerrado = comprobarIngresoCerrado;
    vm.comprobarFotoProblema = comprobarFotoProblema;
    vm.imprimirInforme = imprimirInforme;

    function imprimirInforme(){
      ServicioDialogos.abrirDialogoCargando();
      $http.get(URL_SERVIDOR+"/movimiento/reporte/movimiento/"+vm.ingreso.id, {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function comprobarFotoProblema(){
      var ban = false;
      vm.ingreso.problemas.forEach(function(item){
        if (item.encabezadoFoto){
          ban = true;
        }
      });
      return ban;
    }

    function editarProblemas(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea agregar o quitar problemas en este ingreso?', function(){
        $state.go('home.problemas-ingreso',{objeto:vm.ingreso.id});
      });
    }

    function inicializar(){
      vm.fecha=$filter('date')(vm.ingreso.fecha, 'dd/MM/yyyy HH:mm');
      vm.foto = vm.ingreso.encabezadoFoto + vm.ingreso.cuerpoFoto;
      vm.montoTotal = montoTotal();
      //armarProblemas();
      crearTablas();
      actualizarTabla();
      vm.personaProveedor = personaProveedor();
      vm.personaEmpresaLogistica = personaEmpresaLogistica();
    }

    function personaProveedor(){
      if (vm.ingreso.personaProveedor){
        return vm.ingreso.personaProveedor.apellido.toUpperCase()+", "+vm.ingreso.personaProveedor.nombre.toUpperCase();
      }
    }

    function personaEmpresaLogistica(){
      if (vm.ingreso.personaEmpresaLogistica){
        return vm.ingreso.personaEmpresaLogistica.apellido.toUpperCase()+", "+vm.ingreso.personaEmpresaLogistica.nombre.toUpperCase();
      }
    }

    function armarProblemas(){
      vm.problemas = [];
      vm.ingreso.problemas.forEach(function(problema, i){
        problema.foto = problema.encabezadoFoto+problema.cuerpoFoto;
        problema.ind = i;
        vm.problemas.push(problema);
      });
    }

    function editarSuministro(suministro){
      if (suministro.suministro && suministro.suministro.tipoSuministro && suministro.suministro.tipoSuministro.inventariable) {
        editarSuministroInventariable(suministro);
      } else {
        editarSuministroNoInventariable(suministro);
      }
    }

    function editarSuministroInventariable(suministro){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Está seguro que desea editar la información del suministro?", function(){
        ServicioDialogos.abrirDialogoCargando();
        ServicioModales.abrirModalEditarSuministro({
          onResult: function(resultado){
            $window.location.reload();
          },
          suministro:suministro.suministroInventariable,
          modo:'editar'
        });
      });
    }

    function editarSuministroNoInventariable(suministro){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Está seguro que desea editar la información del suministro?", function(){
        ServicioDialogos.abrirDialogoCargando();
        ServicioModales.abrirModalEditarSuministroNoInventariable({
          onResult: function(resultado){
            $window.location.reload();
          },
          suministro:suministro.suministro,
          modo:'editar'
        });
      });
    }

    function volver(){
      if (estadoAnterior==2){
        $window.history.back();
      } else {
        $state.go("home.lista-ingreso-donacion-scrap");
      }
    }

    function montoTotal(){
      var total = 0;
      for(var i = 0; i < vm.ingreso.detalles.length; i++){
        total += vm.ingreso.detalles[i].suministro.precioUnitario*vm.ingreso.detalles[i].cantidad;
      }
      return total ? '$ '+total.toFixed(2) : "-";
    }

    function buscarCantidadPallets(){
      var mayor = vm.detallesInventariables[0].numeroRow;
      vm.detallesInventariables.forEach(function(detalle){
        if (detalle.numeroRow>mayor){
          mayor = detalle.numeroRow;
        }
      });
      return mayor;
    }

    function actualizarTablaInventariables(){
      vm.tableParamsStock.settings({
        data: vm.palletsInventariables,
        noPager: true,
        counts: []
      });
      vm.tableParamsStock.reload();
    }

    function actualizarTabla(){
      vm.tableParams.settings({
        data: orderByFilter(vm.ingreso.detalles,'numeroCaja',false),
        noPager: true,
        counts: []
      });
      vm.tableParams.reload();
      vm.tableParams1.settings({
        data: orderByFilter(vm.ingreso.problemas,'nombre', false),
        noPager: true,
        count: []
      });
      vm.tableParams1.reload();
    }

    function ubicacionNaveNumeroOrden(detalle){
      if (detalle.suministro && detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        return "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+detalle.suministro.ubicacion.numeroOrden;
      } else {
        return "El bien no posee una ubicación actual";
      }
    }

    function ubicacionCompleta(detalle){
      if (detalle.suministro && detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación",
        "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+detalle.suministro.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+detalle.suministro.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+detalle.suministro.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+detalle.suministro.ubicacion.numeroUbicacion+
        "\nN° de orden: "+detalle.suministro.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+detalle.suministro.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+detalle.suministro.ubicacion.categoriaPeso.nombre.toUpperCase());
      }
    }


    function crearTablas(){
      vm.tableParams = new NgTableParams({
        page: 1,
        count: 500
      });
      vm.tableParams1 = new NgTableParams({
        page:1,
        count:20
      });
    }

    function comprobarIngresoCerrado(){
      return vm.ingreso.estadoMovimiento.id==14 || vm.ingreso.estadoMovimiento.id==16;
    }
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-ingreso-donacion-scrap', {
        url: 'lista-ingreso-donacion-scrap',
        templateUrl: 'app/app/main/movimientos/donacion-scrap/ingreso/lista/lista-donacion-scrap.html',
        controller: 'ListaIngresoDonacionScrapCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar ingresos para donación o scrap-reparación',
          subtitulo:'Lista de ingresos'
        },
        resolve: {
          ingresos: function(DonacionScrapUltimosCien, Usuario, DonacionScrapUltimosCienDeposito){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return DonacionScrapUltimosCienDeposito.query({'idDeposito':usuario.empleado.deposito.id}).$promise.then(function(data){
                  return data;
                });
              } else {
                return DonacionScrapUltimosCien.query({}).$promise.then(function(data){
                  return data;
                });
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaIngresoDonacionScrapCtrl', ListaIngresoDonacionScrapCtrl);

  /** @ngInject */
  function ListaIngresoDonacionScrapCtrl(NgTableParams, HeaderBarService, Usuario, $filter, focus, ingresos, IngresoEstadoModificar , ProveedorEmpresa, DonacionScrapUltimosCien, DonacionScrapUltimosCienDeposito, $stateParams, $scope, orderByFilter, $state, ServicioModales, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
/*    
    vm.depositos = orderByFilter(depositos,'nombre',false);
    vm.empresas = orderByFilter(empresas,'nombre',false);
*/
    vm.ingresos = orderByFilter(ingresos,'fecha',true);
    vm.irAsignarUbicaciones = irAsignarUbicaciones;
    vm.visualizarIngreso = visualizarIngreso;
    vm.crearNuevo = crearNuevo;
    vm.editar = editar;
    vm.eliminar = eliminar;
    vm.filtrar = filtrar;
    vm.bandera = false;
    vm.busqueda = busqueda;
    vm.abrirModalFiltros = abrirModalFiltros;

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10,
    },{
      getData: function($defer,params){ return filtrarTabla($defer, params);}
    });
    vm.tableParams.reload();


    function filtrarTabla($defer, params) {
      var filtros = params.filter();
      var filtrosNuevos = {};

      for (var key in filtros) {
        if (filtros.hasOwnProperty(key) && filtros[key]!=='') {
          switch(key) {
            case 'deposito.nombre':
              angular.extend(filtrosNuevos, {
                deposito: {
                nombre: filtros[key]
                }
              });
              break;
            case 'empresa.nombre':
              angular.extend(filtrosNuevos, {
                empresa: {
                nombre: filtros[key]
                }
              });
              break;
            case 'proveedor.nombre':
              angular.extend(filtrosNuevos, {
                proveedor: {
                nombre: filtros[key]
                }
                });
              break;
            case 'tipoMovimiento.nombre':
              angular.extend(filtrosNuevos, {
                tipoMovimiento: {
                nombre: filtros[key]
                }
                });
              break;
            case 'estadoMovimiento.nombre':
              angular.extend(filtrosNuevos, {
                estadoMovimiento: {
                nombre: filtros[key]
                }
              });
              break;
            default:
              filtrosNuevos[key] = filtros[key];
          }
        }
      }
      var filtrados = filtros ? $filter('filter')(vm.ingresos, filtrosNuevos) : vm.ingresos;
      filtrados = params.sorting() ? $filter('orderBy')(filtrados, params.orderBy()) : filtrados;
      if (filtrados && filtrados.length){
        params.total(filtrados.length);
        return $defer.resolve(filtrados.slice((params.page() - 1) * params.count(), params.page() * params.count()));
      } else {
        params.total(0);
        return $defer.resolve(null);
      }
    }

    function abrirModalFiltros(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalFiltroBusquedaIngreso({
        onResult: function(resultado){
          vm.bandera=true;
          vm.filtrosUsados = resultado.filtros;
          actualizarTabla(resultado.detalles);
        }
      });
    }

    function busqueda(){
      vm.bandera=false;
      vm.filtrosUsados=null;
      if (vm.buscar) {
        vm.ingresos=null;
        actualizarTabla(vm.ingresos);
      } else {
        filtrar();
      }
    }
    
    function actualizarTabla(data){
      vm.ingresos = orderByFilter(data,'fecha',true);
      vm.tableParams.settings({
        data: vm.ingresos
      });
      vm.tableParams.reload();
    }

    function filtrar(){
      ServicioDialogos.abrirDialogoCargando();
      if (!vm.buscar){
        obtenerUltimos();
      } else {
        actualizarTabla(undefined);
      }

    }

    function irAsignarUbicaciones(ingreso) {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Desea asignar ubicaciones a los suministros de este ingreso?', function() {
        $state.go('home.asignar-ubicaciones-donacion-scrap', {objeto:ingreso.id});
      });
    }

    function visualizarIngreso(ingreso){
        $state.go('home.visualizar-donacion-scrap', {objeto:ingreso.id});
    }

    function editar(ingreso) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el ingreso?', function() {
        $state.go('home.home.editar-donacion-scrap', {objeto:ingreso.id, modo:'editar'});
      });
    }

    function eliminar(ingreso) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea eliminar el ingreso?', function() {
        anularIngreso(ingreso);
      });
    }

    function obtenerEstadoEliminado(ingreso){
      if (ingreso.tipoMovimiento.id==3){
        return 27;
      } else {
        return 28;
      }
    }

    function anularIngreso(ingreso){
      var estado = obtenerEstadoEliminado(ingreso);
      ServicioDialogos.abrirDialogoCargando();
      IngresoEstadoModificar.update({idMovimiento:ingreso.id, idEstado:estado}, function(data){
        obtenerUltimos();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar el ingreso");
      });

    }

    function obtenerUltimos(){
      Usuario.obtenerUsuario().$promise.then(function(usuario){
        if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
          DonacionScrapUltimosCienDeposito.query({'idDeposito':usuario.empleado.deposito.id}).$promise.then(function(data){
            ServicioDialogos.cerrarDialogoCargando();
            actualizarTabla(data);
          }, function(err){
            console.error(err);
            ServicioDialogos.cerrarDialogoCargando();
          });
        } else {
          DonacionScrapUltimosCien.query({}).$promise.then(function(data){
            ServicioDialogos.cerrarDialogoCargando();
            actualizarTabla(data);
          }, function(err){
            console.error(err);
            ServicioDialogos.cerrarDialogoCargando();
          });
        }
      });
    }

    function crearNuevo() {
      $state.go('home.editar-donacion-scrap');
    }

    $scope.$watch('vm.empresaFiltro2.nombre', function(){
      if (vm.proveedor) vm.proveedor=null;
      if (!vm.empresaFiltro2 || !vm.empresaFiltro2.nombre) return;
      ServicioDialogos.abrirDialogoCargando();
      ProveedorEmpresa.query({empresa:vm.empresaFiltro2.id}, function(data){
        vm.proveedores = data;
        focus('proveedor');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.asignar-ubicaciones-donacion-scrap', {
        url: 'asignar-ubicaciones-donacion-scrap/:objeto',
        templateUrl: 'app/app/main/movimientos/donacion-scrap/ingreso/asignar-ubicaciones/asignar-ubicaciones.html',
        controller: 'AsignarUbicacionesDonacionScrapCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Ingreso de suministros para donación o scrap-reparación',
          subtitulo: 'Asignar ubicaciones a suministros',
          objeto:null
        },
        resolve: {
          ingreso: function(Ingreso, $stateParams){
            if ($stateParams.objeto){
              return Ingreso.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return $stateParams.objeto;
            }
          }
        }
      });
  }
})();
(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('AsignarUbicacionesDonacionScrapCtrl', AsignarUbicacionesDonacionScrapCtrl);

  /** @ngInject */
  function AsignarUbicacionesDonacionScrapCtrl(NgTableParams, $sce, $q, Suministro, EstadoMovimiento, IngresoEstadoModificar, SuministroUbicacion, HeaderBarService, Deposito, focus, $filter, $stateParams, ingreso, $scope, orderByFilter, $state, ServicioDialogos, ServicioModales) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;

    vm.ingreso = ingreso;
    vm.montoTotal = montoTotal;
    inicializar();
    vm.asignarAutomaticamente = asignarAutomaticamente;
    vm.asignarIndividual = asignarIndividual;
    vm.ubicacionCompleta = ubicacionCompleta;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.limpiarUbicaciones = limpiarUbicaciones;
    vm.removerIndividual = removerIndividual;
    vm.comprobarUbicaciones = comprobarUbicaciones;
    vm.comprobarIngresoCerrado = comprobarIngresoCerrado;
    vm.corroborarOcuparUbicacionRepetida = corroborarOcuparUbicacionRepetida;
    vm.volver = volver;

    function corroborarOcuparUbicacionRepetida(detalle){
      if (!detalle.ubicacion) return;
      if (vm.detallesNoInventariables && vm.detallesNoInventariables.length>0){
        vm.detallesNoInventariables.forEach(function(item){
          if (item.ubicacion && item.ubicacion.id==detalle.ubicacion.id){
            item.ocupar = detalle.ocupar;
          }
        });
      }
      if (vm.palletsInventariables && vm.palletsInventariables.length>0){
        vm.palletsInventariables.forEach(function(item){
          if (item.ubicacion && item.ubicacion.id==detalle.ubicacion.id){
            item.ocupar = detalle.ocupar;
          }
        });
      }
    }


    function comprobarIngresoCerrado(){
      return (vm.ingreso && (vm.ingreso.estadoMovimiento.id==15 || vm.ingreso.estadoMovimiento.id==13));
    }

    function obtenerEstadoIngreso(){
      if (ingreso.tipoMovimiento.id==3){
        EstadoMovimiento.get({id:14}).$promise.then(function(data){
          vm.estadoIngresoCerrado = data;
        });
      } else {
        return EstadoMovimiento.get({id:16}).$promise.then(function(data){
          vm.estadoIngresoCerrado = data;
        });
      }
    }

    function volver(){
        ServicioDialogos.mostrarDialogoConfirmacionWarning(
          null,
          "¿Está seguro que desea volver al listado de ingresos?",
          function(){
            $state.go("home.lista-ingreso-donacion-scrap");
          }
        );
    }

    function comprobarUbicaciones(){
      var cantidadInv = 0;
      if (vm.palletsInventariables && vm.palletsInventariables.length>0){
        cantidadInv = vm.palletsInventariables.length;
      }
      if (vm.asignadas.length === (vm.detallesNoInventariables.length+cantidadInv)){
        verificarDetallesUbicacion();
      } else {
        ServicioDialogos.mostrarDialogoError(null, "No ha asignado todas las ubicaciones");
      }
    }

    function verificarDetallesUbicacion(){
      var ban = false;
      vm.detallesNoInventariables.forEach(function(item){
        if (!item.ubicacion){
          ban = true;
        }
      });
      if (vm.palletsInventariables && vm.palletsInventariables.length>0){
        vm.palletsInventariables.forEach(function(item){
          if (!item.ubicacion){
            ban = true;
          }
        });
      }
      if (!ban){
        abrirDialogoConfirmacionGuardar();
      } else {
        ServicioDialogos.mostrarDialogoError(null, "No ha asignado todas las ubicaciones");
      }
    }


/*    function comprobarUbicaciones(){
      if ((vm.detallesNoInventariables && vm.asignadas)) {
        var ubicacionesDetalle = [];
        var asignadas = [];
        if (vm.palletsInventariables && vm.palletsInventariables.length>0){
          vm.palletsInventariables.forEach(function(det){
            if (det.ubicacion && det.ubicacion.id){
              ubicacionesDetalle.push(det.ubicacion.id);
            }
          });
        }
        vm.detallesNoInventariables.forEach(function(de){
          if (de.ubicacion && de.ubicacion.id){
            ubicacionesDetalle.push(de.ubicacion.id);
          }
        });
        vm.asignadas.forEach(function(asig){
          asignadas.push(asig.id);
        });
        if (vm.palletsInventariables && vm.palletsInventariables.length>0){
          if (asignadas.length === (vm.detallesNoInventariables.length+vm.palletsInventariables.length)){
            verificarUbicaciones(ubicacionesDetalle, asignadas);
          } else {
            ServicioDialogos.mostrarDialogoError(null, "No ha asignado todas las ubicaciones");
          }
        } else {
          if (asignadas.length === (vm.detallesNoInventariables.length)){
            verificarUbicaciones(ubicacionesDetalle, asignadas);
          } else {
            ServicioDialogos.mostrarDialogoError(null, "No ha asignado todas las ubicaciones");
          }
        }
      }
    }

    function verificarUbicaciones(ubicaciones, asignadas){
      ubicaciones = ubicaciones.sort();
      asignadas = asignadas.sort();
      if (asignadas.length==ubicaciones.length && asignadas.every(function(v,i) { return v === ubicaciones[i];})) {
        comprobarNoRepetidas(ubicaciones, asignadas);
      } else {
        ServicioDialogos.mostrarDialogoError(null, "No ha asignado todas las ubicaciones");
      }
    }

    function comprobarNoRepetidas(ubicaciones, asignadas){
      ubicaciones = ubicaciones.sort();
      asignadas = asignadas.sort();
      var ubicacionesRepetidas = angular.copy(ubicaciones.unique().sort());
      var asignadasRepetidas = angular.copy(asignadas.unique().sort());
      if ((asignadasRepetidas.every(function(v,i) { return v === asignadas[i];})) && (ubicacionesRepetidas.every(function(v,i) { return v === ubicaciones[i];}))) {
        abrirDialogoConfirmacionGuardar();
      } else {
        ServicioDialogos.mostrarDialogoError(null, "Se han asignado ubicaciones repetidas");
      }
    }*/

    function abrirDialogoConfirmacionGuardar(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Desea asignar las ubicaciones?", function(){
        guardarUbicaciones();
      }, null, false);
    }

    function guardarUbicaciones(){
      guardarUbicacionesInventariables()
      .then(function(){
        guardarUbicacionesNoInventariables()
        .then(function(){
          actualizarEstadoIngreso();
        }, function(err){
          console.log(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido asignar las ubicaciones");
        });
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido asignar las ubicaciones");
      });
    }

    function actualizarEstadoIngreso(){
      IngresoEstadoModificar.update({idMovimiento:vm.ingreso.id, idEstado:vm.estadoIngresoCerrado.id}, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, "Se han asignado las ubicaciones correctamente", function(){
          $state.go('home.lista-ingreso-donacion-scrap');
        });
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido asignar las ubicaciones");
      });
    }

    function guardarUbicacionesNoInventariables(){
      var defer = $q.defer();
      var promise = defer.promise;
      vm.detallesNoInventariables.forEach(function(detalle){
        var ubicacion = detalle.ubicacion.id;
        var suministro = detalle.suministro.id;
        var ocupar = detalle.ocupar;
        promise = promise.then(function(){
          return guardarUbicacionSuministro(suministro, ubicacion, ocupar).then(function(){
            defer.resolve(true);
          });
        });
      });
      defer.resolve(true);
      return promise;
    }

    function guardarUbicacionesInventariables(){
      var defer = $q.defer();
      var promise = defer.promise;
      if (vm.palletsInventariables && vm.palletsInventariables.length>0){
        vm.palletsInventariables.forEach(function(pallet){
          promise = promise.then(function(){
            return guardarDetallesInventariables(pallet).then(function(){
              defer.resolve(true);
            });
          });
        });
      }
      defer.resolve(true);
      return promise;
    }

    function guardarDetallesInventariables(pallet){
      var defer = $q.defer();
      var promise = defer.promise;
      var ubicacion = pallet.ubicacion.id;
      var ocupar = pallet.ocupar;
      pallet.detalles.forEach(function(detalle){
        promise = promise.then(function(){
          return guardarUbicacionSuministro(detalle.suministro.id, ubicacion, ocupar).then(function(){
            defer.resolve(true);
          });
        });
      });
      defer.resolve(true);
      return promise;
    }

    function guardarUbicacionSuministro(suministro, ubicacion, ocupar){
      return SuministroUbicacion.update({'idSuministro': suministro,'idUbicacion':ubicacion,'ocupar':ocupar}).$promise.then(function(data) {
        return data;
      });
    }

    function inicializar(){
      if (!vm.ingreso){
        return;
      }
      if (vm.ingreso && vm.ingreso.caja){
        $state.go('home.asignar-ubicaciones-cajas', {objeto: ingreso.id});
      }
      obtenerEstadoIngreso();
      vm.fecha=$filter('date')(vm.ingreso.fecha, 'dd/MM/yyyy HH:mm');
      vm.personaProveedor = personaProveedor();
      vm.personaEmpresaLogistica = personaEmpresaLogistica();
      vm.montoTotal = montoTotal();
      vm.asignadas = [];
      crearTablas();
      cargarDetalles();
      setearOcuparUbicaciones();
    }

    function personaProveedor(){
      if (vm.ingreso.personaProveedor){
        return vm.ingreso.personaProveedor.apellido.toUpperCase()+", "+vm.ingreso.personaProveedor.nombre.toUpperCase();
      }
    }

    function personaEmpresaLogistica(){
      if (vm.ingreso.personaEmpresaLogistica){
        return vm.ingreso.personaEmpresaLogistica.apellido.toUpperCase()+", "+vm.ingreso.personaEmpresaLogistica.nombre.toUpperCase();
      }
    }

    function setearOcuparUbicaciones(){
      if (vm.palletsInventariables && vm.palletsInventariables.length>0){
        vm.palletsInventariables.forEach(function(pallet){
          pallet.ocupar = true;
        });
      }
      vm.detallesNoInventariables.forEach(function(detalle){
        detalle.ocupar=true;
      });
    }

    function limpiarUbicaciones(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Desea limpiar todas las ubicaciones asignadas?', function(){
        if (vm.palletsInventariables && vm.palletsInventariables.length>0){
          vm.palletsInventariables.forEach(function(detalle){
            if (detalle.ubicacion) detalle.ubicacion=null;
          });
        }
        vm.detallesNoInventariables.forEach(function(detalle){
          if (detalle.ubicacion) detalle.ubicacion=null;
        });
        actualizarTabla();
        actualizarTablaInventariables();
        limpiarAsignados();
      });
    }

    function removerIndividual(detalle){
      if (!(detalle.ubicacion && detalle.ubicacion.id)) return;
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Desea limpiar la ubicación asignada?', function(){
        limpiarAsignadaIndividual(detalle);
        detalle.ubicacion = null;
        actualizarTablaInventariables();
        actualizarTabla();
      });
    }

    function limpiarAsignadaIndividual(detalle){
      var index = null;
      for (var i = vm.asignadas.length - 1; i >= 0; i--) {
        var id = vm.asignadas[i].id;
        if (id==detalle.ubicacion.id) {
          index=i;
        }
      }
      if (index!==null){
        vm.asignadas.splice(index,1);
      }
    }

    function limpiarAsignados(){
      vm.asignadas = [];
    }

    function ubicacionNaveNumeroOrden(detalle){
      if (detalle.ubicacion && detalle.ubicacion.nivel) {
        return "Nave: "+detalle.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+detalle.ubicacion.numeroOrden;
      }
    }

    function ubicacionCompleta(detalle){
      var mensaje = "";
      if (detalle.tipoSuministro && detalle.ubicacion && detalle.ubicacion.categoriaPeso && detalle.tipoSuministro.categoriaPeso.id!=detalle.ubicacion.categoriaPeso.id){
        mensaje = "La categoría de peso de la ubicación asignada, no coincide con la del suministro";
      }
      if (detalle.ubicacion && detalle.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación asignada",
        "Nave: "+detalle.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+detalle.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+detalle.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+detalle.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+detalle.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+detalle.ubicacion.numeroUbicacion+
        "\nN° de orden: "+detalle.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+detalle.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+detalle.ubicacion.categoriaPeso.nombre.toUpperCase()+
        "\n\n"+mensaje);
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "No ha asignado ninguna ubicación");
      }
    }

    function cargarDetalles(){
      vm.detallesInventariables = [];
      vm.detallesNoInventariables = [];
      vm.ingreso.detalles.forEach(function(detalle){
        if (detalle.suministro.tipoSuministro.inventariable){
          vm.detallesInventariables.push(detalle);
        } else {
          vm.detallesNoInventariables.push(detalle);
        }
      });
      if (vm.detallesInventariables.length>0) {
        armarPallets();
      }
      actualizarTabla();
    }

    function armarPallets(){
      crearPallets();
      vm.palletsInventariables.forEach(function(pallet){
        vm.detallesInventariables.forEach(function(detalle){
          if (pallet.numeroRow===detalle.numeroRow){
            pallet.detalles.push(detalle);
            pallet.tipoSuministro=detalle.suministro.tipoSuministro;
          }
        });
      });
      actualizarTablaInventariables();
    }

    function crearPallets(){
      var esta = false;
      vm.palletsInventariables = [];
      vm.detallesInventariables.forEach(function(detalle){
        esta = false;
        vm.palletsInventariables.forEach(function(usado){
          if (detalle.numeroRow==usado.numeroRow){
            esta = true;
          }
        });
        if (!esta){
          vm.palletsInventariables.push({numeroRow:detalle.numeroRow, detalles:[], tipoSuministro:null});
        }
      });
    }
    
    function montoTotal(){
      var total = 0;
      vm.ingreso.detalles.forEach(function(item){
        total += item.suministro.precioUnitario*item.cantidad;
      });
      return total ? '$ '+total.toFixed(2) : "-";
    }

    function actualizarTablaInventariables(){
      vm.tableParamsStock.settings({
        data: vm.palletsInventariables,
        noPager: true,
        counts: []
      });
      vm.tableParamsStock.reload();
    }

    function actualizarTabla(){
      vm.tableParams.settings({
        data: vm.detallesNoInventariables,
        noPager: true,
        counts: []
      });
      vm.tableParams.reload();
    }

    function crearTablas(){
      vm.tableParams = new NgTableParams({
        page: 1,
        count: 50
      });
      vm.tableParamsStock = new NgTableParams({
        group: "numeroRow",
        page: 1,
        count: 50
      });
    }

    function agregarAsignada(ubicacion){
      if (!(vm.asignadas)) {
        vm.asignadas = [];
      }
      vm.asignadas.push(ubicacion);

    }

    function actualizarAsignadas(asignadas){
      vm.asignadas = asignadas;
      if (vm.asignadas.length==0){
        ServicioDialogos.mostrarDialogoInformacion(
          null,
          "No se ha asignado ninguna ubicación."+
          "\nEsto es porque las ubicaciones libres, poseen una categoría de peso distinta a la de los suministros"
        );
      } else {
        mostrarMensajeAsignacion();  
      }
    }

    function mostrarMensajeAsignacion(){
      if ((vm.palletsInventariables && ((vm.palletsInventariables.length+vm.detallesNoInventariables.length)==vm.asignadas.length)) || (vm.detallesNoInventariables.length==vm.asignadas.length)){
        ServicioDialogos.mostrarDialogoInformacion(
          null,
          "Se han asignado todas las ubicaciones",
          null
        );
      } else {
        ServicioDialogos.mostrarDialogoInformacion(
          null,
          "Se asignó al menos una ubicación",
          null
        );
      }
    }

    function agregarSuministroUbicacionAsignada(detalle, asignada){
      if (asignada.suministros){
        asignada.suministros.push(detalle.suministro);
      } else {
        asignada.suministros = [];
        asignada.suministros.push(detalle.suministro);
      }
      return asignada;
    }

    function asignarAutomaticamente(){
      ServicioDialogos.abrirDialogoCargando();
      Deposito.get({id:vm.ingreso.deposito.id}, function(data){
        ServicioModales.abrirModalAsignarUbicaciones({
          onResult: function(resultado) {
            actualizarAsignadas(resultado.asignadas);
          },
          deposito: vm.ingreso.deposito,
          detallesInventariables: vm.palletsInventariables,
          detallesNoInventariables: vm.detallesNoInventariables,
          asignadas: vm.asignadas
        });
      });
    }

    function asignarIndividual(detalle){
      ServicioDialogos.abrirDialogoCargando();
      Deposito.get({id:vm.ingreso.deposito.id}, function(data){
        ServicioModales.abrirModalAsignarUbicacionIndividual({
          onResult: function(resultado){
            detalle.ubicacion = resultado.ubicacionAsignada;
            var asignada = agregarSuministroUbicacionAsignada(detalle, resultado.ubicacionAsignada);
            agregarAsignada(asignada);
            corroborarOcuparUbicacionRepetida(detalle);
          },
          deposito: vm.ingreso.deposito,
          'detalle': detalle,
          asignadas: vm.asignadas
        });
      });
    }

    Array.prototype.unique=function(a){
      return function(){return this.filter(a);};}(function(a,b,c){return c.indexOf(a,b+1)<0;
    });

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-donacion-scrap', {
        url: 'editar-donacion-scrap',
        templateUrl: 'app/app/main/movimientos/donacion-scrap/ingreso/editar/editar-donacion-scrap.html',
        controller: 'EditarIngresoDonacionScrapCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Ingreso de suministros para donación o scrap-reparación',
          subtituloEditar:'Editar nuevo ingreso',
          subtituloNuevo: 'Nuevo ingreso',
          ingreso:null,
          editar:null,
          caja:null
        },
        resolve: {
          //el deposito se traerá dependiendo del usuario registrado.
          //si es admin traigo todos sino el del usuario
          ingreso: function($stateParams){
            return $stateParams.ingreso? $stateParams.ingreso : {};
          },
          usuario: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario;
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          deposito: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return usuario.empleado.deposito;
              } else {
                return ;
              }
            });
          },
          tipoDonacion: function(TipoMovimiento){
            return TipoMovimiento.get({id:3}).$promise.then(function(data) {
              return data;
            });
          },
          tipoScrap: function(TipoMovimiento){
            return TipoMovimiento.get({id:4}).$promise.then(function(data) {
              return data;
            });
          },
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data){
              return data;
            });
          },
          proveedores: function(ProveedorEmpresa, $stateParams){
            if ($stateParams.ingreso){
              return ProveedorEmpresa.query({empresa:$stateParams.ingreso.empresa.id}).$promise.then(function(data){
                return data;
              });
            } else {
              return [];
            }
          },
          caja: function($stateParams){
            return $stateParams.caja;
          },
          personas: function(PersonaProveedorNombreProveedor, $stateParams){
            if ($stateParams.ingreso){
              return PersonaProveedorNombreProveedor.query({id:$stateParams.ingreso.proveedor.id}, function(data){
                return data;
              });
            } else {
              return [];
            }
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarIngresoDonacionScrapCtrl', EditarIngresoDonacionScrapCtrl);

  /** @ngInject */
  function EditarIngresoDonacionScrapCtrl(NgTableParams, deposito, usuario, SucursalEmpresa, EmpresaLogisticaEmpresa, PersonaEmpresaLogisticaEmpresa, HeaderBarService, ServicioModales, caja, ingreso, focus, proveedores, personas, PersonaProveedorNombreProveedor, ProveedorEmpresa, depositos, tipoScrap, tipoDonacion, empresas, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    ingreso.empresa? HeaderBarService.setSubTitulo($stateParams.subtituloEditar) : HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);

    var vm = this;
    vm.tipos = [];
    vm.tipos.push(tipoDonacion);
    vm.tipos.push(tipoScrap);
    vm.depositos = orderByFilter(depositos,'nombre',false);
    vm.empresas = orderByFilter(empresas,'nombre',false);
    vm.ingreso = ingreso;
    vm.ingreso.deposito = deposito;
    vm.ingreso.usuario = usuario;
    vm.siguiente = siguiente;
    vm.cancelar = cancelar;
    vm.proveedores = proveedores;
    vm.personas = personas;
    vm.ingreso.caja = caja===true? true : false;


    window.onbeforeunload = function(){
      return "seguro?";
    };

    function cancelar(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea cancelar el ingreso?', function() {
        $state.go('home.lista-ingreso-donacion-scrap');
      });
    }

    function siguiente(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, 'Verifique los datos. ¿Desea continuar con el agregado de suministros en el ingreso?', function() {
        $state.go('home.agregar-suministros-donacion-scrap', {'objeto':vm.ingreso});
      });
    }

    function esEditar(){
      return vm.modo == "editar";
    }


    $scope.$watch('vm.ingreso.empresa.nombre', function(){
      if (!vm.form.$dirty) {
        return;
      }
      if (vm.ingreso.proveedor) vm.ingreso.proveedor=null;
      if (vm.ingreso.empresaLogistica) vm.ingreso.empresaLogistica=null;
      if (!vm.ingreso.empresa || !vm.ingreso.empresa.nombre) return;
      ServicioDialogos.abrirDialogoCargando();
      buscarProveedoresYEmpresasLogistica();
    });

    function buscarProveedoresYEmpresasLogistica(){
      ProveedorEmpresa.query({empresa:vm.ingreso.empresa.id}, function(data){
        EmpresaLogisticaEmpresa.query({idEmpresa:vm.ingreso.empresa.id}, function(datos){
          SucursalEmpresa.query({id:vm.ingreso.empresa.id}, function(sucursales){
            vm.sucursales = orderByFilter(sucursales, "nombre", false);
            vm.proveedores = orderByFilter(data, "nombre", false);
            vm.empresasLogistica = orderByFilter(datos, "nombre", false);
            focus('solicitante');
            ServicioDialogos.cerrarDialogoCargando();
          }, function(e){
            console.log(e);
            ServicioDialogos.cerrarDialogoCargando();
            ServicioDialogos.mostrarDialogoError();
          });
        }, function(er){
          console.log(er);
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError();
        });
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    }


    $scope.$watch('vm.ingreso.proveedor.id', function(){
      if (!vm.form.$dirty) {
        vm.form.$setDirty();
        return;
      }
      if (vm.ingreso.personaProveedor) vm.ingreso.personaProveedor=null;
      if (!vm.ingreso.empresa || !vm.ingreso.empresa.nombre || !vm.ingreso.proveedor || !vm.ingreso.proveedor.id) return;
      ServicioDialogos.abrirDialogoCargando();
      PersonaProveedorNombreProveedor.query({id:vm.ingreso.proveedor.id}, function(data){
        vm.personas = data;
        if (vm.personas.length>0){
          focus('personaProveedor');
        } else {
          focus('empresaLogistica');
        }
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.ingreso.empresaLogistica.id', function(valorNuevo, valorAnterior){
      if (valorNuevo === valorAnterior) return;
      if (!vm.form.$dirty) {
        vm.form.$setDirty();
        return;
      }
      if (vm.ingreso.personaEmpresaLogistica) vm.ingreso.personaEmpresaLogistica=null;
      if (!vm.ingreso.empresa || !vm.ingreso.empresa.nombre || !vm.ingreso.empresaLogistica || !vm.ingreso.empresaLogistica.id) return;
      ServicioDialogos.abrirDialogoCargando();
      PersonaEmpresaLogisticaEmpresa.query({id:vm.ingreso.empresaLogistica.id}, function(data){
        vm.personasLogistica = data;
        if (vm.personasLogistica.length>0){
          focus('personaEmpresaLogistica');
        } else {
          focus('numeroRemito');
        }
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.agregar-suministros-donacion-scrap', {
        url: 'agregar-suministros-donacion-scrap',
        templateUrl: 'app/app/main/movimientos/donacion-scrap/ingreso/agregar-suministros/agregar-suministros-donacion-scrap.html',
        controller: 'AgregarSuministroIngresoDonacionScrapCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Ingreso de suministros para donación o scrap-reparación',
          subtitulo: 'Agregar suministros',
          objeto:null
        },
        resolve: {
          estadoGenerado: function($stateParams, EstadoMovimiento){
            if ($stateParams.objeto && $stateParams.objeto.tipoMovimiento.id==3){
              return EstadoMovimiento.get({id:13}).$promise.then(function(data){
                return data;
              });
            } else {
              return EstadoMovimiento.get({id:15}).$promise.then(function(data){
                return data;
              });
            }
          },
          estadoSuministro: function($stateParams, EstadoSuministro){
            if ($stateParams.objeto && $stateParams.objeto.tipoMovimiento.id==3){
              return EstadoSuministro.get({id:4}).$promise.then(function(data){
                return data;
              });
            } else {
              return EstadoSuministro.get({id:7}).$promise.then(function(data){
                return data;
              });
            }
          },
          ingreso: function(Ingreso, $stateParams){
            return $stateParams.objeto? $stateParams.objeto : {};
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('AgregarSuministroIngresoDonacionScrapCtrl', AgregarSuministroIngresoDonacionScrapCtrl);

  /** @ngInject */
  function AgregarSuministroIngresoDonacionScrapCtrl(NgTableParams, $filter, UltimoMovimiento, estadoSuministro, ingreso, ServicioModales, estadoGenerado, HeaderBarService, Ingreso, $timeout, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.estadoGenerado = estadoGenerado;
    vm.ingreso = ingreso;
    vm.ocultar=true;
    inicializar();

    vm.agregar = agregar;
    vm.volver = volver;

    vm.detalles = [];
    vm.numeroCajas=[];
    vm.detallesInventariables = [];
    vm.detallesNoInventariables = [];
    vm.numeroRow = 0;



    vm.mostrarInformacion = mostrarInformacion;
    vm.eliminar = eliminar;
    vm.modo = "nuevo";
    vm.abrirModal = abrirModal;
    vm.abrirModalAgregarSuministrosExcel = abrirModalAgregarSuministrosExcel;
    vm.guardar = guardar;
    vm.montoTotal = montoTotal;
    vm.getIcono = getIcono;

    window.onbeforeunload = function(){
      return '';
    };


    function inicializar(){
      if (vm.ingreso && vm.ingreso.empresa && vm.ingreso.empresa.id){
        vm.fecha = $filter('date')(new Date(), 'dd/MM/yyyy HH:mm');
        vm.personaProveedor = personaProveedor();
        vm.personaEmpresaLogistica = personaEmpresaLogistica();
        vm.cajaCerrada = vm.ingreso.caja? "SI" : "NO";
      } else {
        vm.ocultar=false;
      }
    }

    function getIcono(estaAbierto) {
      if (estaAbierto) {
        return 'glyphicon glyphicon-chevron-down';
      } else {
        return 'glyphicon glyphicon-chevron-right';
      }
    }

    function montoTotal(){
      var total = 0;
      for(var i = 0; i < vm.detalles.length; i++){
        total += vm.detalles[i].suministro.precioUnitario*vm.detalles[i].cantidad;
      }
      return total ? total.toFixed(2) : "-";
    }

    function personaProveedor(){
      if (vm.ingreso.personaProveedor){
        return vm.ingreso.personaProveedor.apellido.toUpperCase()+", "+vm.ingreso.personaProveedor.nombre.toUpperCase();
      }
    }

    function personaEmpresaLogistica(){
      if (vm.ingreso.personaEmpresaLogistica){
        return vm.ingreso.personaEmpresaLogistica.apellido.toUpperCase()+", "+vm.ingreso.personaEmpresaLogistica.nombre.toUpperCase();
      }
    }

    function guardar(){
      if (vm.detalles.length===0){
        ServicioDialogos.mostrarDialogoError(null, "No ha agregado ningún suministro");
      } else {
        ServicioDialogos.mostrarDialogoConfirmacionWarning(
          null,
          "¿Está seguro que desea guardar el ingreso?",
          function(){
            guardarIngreso();
          },
          null,
          false
        );
      }
    }

    function obtenerNumeroMovimiento(callback){
      UltimoMovimiento.get({}, function(data){
        if (data && !isNaN(data.id)){
          callback(data.id + 10001);
        } else {
          callback(10001);
        }
      }, function (err){
        console.log(err);
      });
    }

    function obtenerIngreso(callback){
      obtenerNumeroMovimiento(function(data){
        var movimiento = {
          tipoMovimiento: vm.ingreso.tipoMovimiento,
          estadoMovimiento: estadoGenerado,
          deposito: vm.ingreso.deposito,
          empresa: vm.ingreso.empresa,
          sucursal: vm.ingreso.sucursal,
          observacion: vm.ingreso.observacion,
          proveedor: vm.ingreso.proveedor,
          empresaLogistica: vm.ingreso.empresaLogistica,
          personaProveedor: vm.ingreso.personaProveedor,
          personaEmpresaLogistica: vm.ingreso.personaEmpresaLogistica,
          fecha: new Date(),
          solicitante: vm.ingreso.solicitante,
          usuario: vm.ingreso.usuario,
          detalles: vm.detalles,
          numeroMovimiento: data,
          numeroRemito: vm.ingreso.numeroRemito,
          numeroIngresoVale: vm.ingreso.numeroIngresoVale,
          numeroGuia: vm.ingreso.numeroGuia
        };
        callback(movimiento);
      });
    }

    function actualizarEstadoSuministro(detalles){
      detalles.forEach(function(item){
        item.suministro.estadoSuministro = estadoSuministro;
      });
      return detalles;
    }

    function guardarIngreso(){
      obtenerIngreso(function(movimiento){
        movimiento.detalles = actualizarEstadoSuministro(movimiento.detalles);
        Ingreso.save(movimiento, function(data){
          ServicioDialogos.mostrarDialogoGuardadoExito(
            null,
            "Se ha registrado con éxito el ingreso",
            function(){
              $state.go('home.asignar-ubicaciones-donacion-scrap',{objeto:data.id});
              //Acá se abrirá un PDF o una pantalla "resumen" del ingreso que se acaba de ingresar.. como un remito!
            });
        }, function(err){
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar el ingreso");
        });
      });
    }

    function cargarDetalles(){
      vm.detallesInventariables = [];
      vm.detallesNoInventariables = [];
      vm.detalles.forEach(function(detalle){
        if (detalle.suministro.tipoSuministro.inventariable){
          vm.detallesInventariables.push(detalle);
        } else {
          vm.detallesNoInventariables.push(detalle);
        }
      });
      actualizarTablaInventariables();
      actualizarTabla();
    }

    function abrirModal(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalAgregarSuministroIngreso({
        onResult: function(resultado) {

          vm.detalles = resultado.detalles;
          vm.numeroRow = resultado.numeroRow;
          vm.numeroCajas = resultado.numeroCajas;
          cargarDetalles();
        },
        detalles: vm.detalles,
        empresa: vm.ingreso.empresa,
        numeroRow : vm.numeroRow,
        caja: vm.ingreso.caja,
        numeroCajas: vm.numeroCajas
      });
    }

    function abrirModalAgregarSuministrosExcel(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalAgregarSuministroIngresoExcel({
        onResult: function(resultado) {
          vm.detalles = resultado.detalles;
          vm.numeroRow = resultado.numeroRow;
          vm.numeroCajas = resultado.numeroCajas;
          cargarDetalles();
        },
        detalles: vm.detalles,
        empresa: vm.ingreso.empresa,
        numeroRow : vm.numeroRow,
        caja: vm.ingreso.caja,
        numeroCajas: vm.numeroCajas
      });
    }

    function eliminar(objeto){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(
        null,
        "¿Está seguro que desea eliminar el detalle?",
        function(){
          quitarDetalle(objeto);
          cargarDetalles();
        }
      );
    }

    function quitarDetalle(objeto){
      var index = null;
      vm.detalles.forEach(function(detalle, i){
        if (detalle==objeto){
          index = i;
        }
      });
      if (index!=null){
        var eliminado = vm.detalles.splice(index, 1);
        if (eliminado[0].numeroCaja){
          comprobarNumeroCajas(eliminado[0].numeroCaja);
        }
      } else {
        ServicioDialogos.mostrarDialogoError(null, "No se puede quitar el detalle");
      }


/*      
      comprobarNumeroRow(eliminado[0].numeroRow);*/
    }

/*    function comprobarNumeroRow(numero){
      var ban = false;
      vm.detalles.forEach(function(item){
        if (item.numeroRow==numero){
          ban = true;
        }
      });
      if (!ban){
        quitarNumeroRow(numero);
      }
    }

    function quitarNumeroRow(numero){
      var index = null;
    }*/

    function comprobarNumeroCajas(numero){
      var ban = false;
      vm.detalles.forEach(function(item){
        if (item.numeroCaja==numero){
          ban = true;
        }
      });
      if (!ban){
        quitarNumeroCajas(numero);
      }
    }

    function quitarNumeroCajas(numero){
      var index = null;
      vm.numeroCajas.forEach(function(item, i){
        if (item===numero){
          index = i;
        }
      });
      if (index!==null) vm.numeroCajas.splice(index, 1);
    }

    function esEditar(){
      return vm.modo == "editar";
    }

    function volver(){
      if (vm.ocultar){
        ServicioDialogos.mostrarDialogoConfirmacionWarning(
          null,
          "Si vuelve a la pantalla de edición de ingreso, perderá la información de todos los suministros que haya agregado. ¿Está seguro que desea volver?",
          function(){
            $state.go("home.editar-donacion-scrap", {ingreso:ingreso});
          }
        );
      } else {
        $state.go("home.editar-donacion-scrap", {});
      }
    }


    function mostrarInformacion(detalle){
      var marca = detalle.suministro.marca ? detalle.suministro.marca : "-";
      var fecha = detalle.suministro.fechaVencimiento ? detalle.suministro.fechaVencimiento : "-";
      ServicioDialogos.mostrarDialogoInformacion(
        null,
        "Tipo de suministro: "+detalle.suministro.tipoSuministro.nombre.toUpperCase()+
        "\nMarca: "+marca.toUpperCase()+
        "\nFecha vencimiento: "+$filter('date')(fecha, 'dd/MM/yyyy')+
        "\nFamilia de suministro: "+detalle.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase()+
        "\nGrupo de suministro: "+detalle.suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+
        "\nCantidad solicitada: "+detalle.cantidad
      );
    }

    function actualizarTablaInventariables(){
      vm.tableParamsStock.settings({
        data: vm.detallesInventariables
      });
      vm.tableParamsStock.reload();
    }

    function actualizarTabla(){
      vm.tableParams.settings({
        data: vm.detallesNoInventariables
      });
      vm.tableParams.reload();
    }

    function comprobarExistencia(){
      var ban = false;
      vm.detalles.forEach(function(detalle){
        if (detalle.suministro.id==vm.suministro.id){
          ban = true;
        }
      });
      return ban;
    }

    function limpiarForm(){
      vm.grupo = null;
      vm.cantidad=null;
      vm.form.cantidad.$dirty = false;
    }

    function agregarDetalle(){
      if (!comprobarExistencia()){
        var detalle = {
          suministro : vm.suministro,
          cantidad : vm.cantidad
        };
        vm.numero = vm.numero+1;
        vm.detalles.push(detalle);
        limpiarForm();
        actualizarTabla(vm.detalles);
      } else {
        ServicioDialogos.mostrarDialogoError(null, "Ya agregó este suministro al pedido");
      }
    }

    function editarDetalle(){

    }


    function agregar(){
      if (esEditar()){
        editarDetalle();
      } else {
        agregarDetalle();
      }
    }

    $scope.$watch('vm.grupo.nombre', function(){
      vm.familiaSuministro=null;
      if (!vm.grupo) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupo.id}, function(data){
        vm.familias = data;
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.familiaSuministro.nombre', function(){
      vm.suministro=null;
      if (!vm.familiaSuministro) return;
      ServicioDialogos.abrirDialogoCargando();
      TipoSuministroFamilia.query({id:vm.familiaSuministro.id}, function(data){
        vm.suministros = data;
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });
    vm.tableParamsStock = new NgTableParams({
      page: 1,
      count: 10,
      group:{
        numeroRow: 'desc'
      }
    });
   
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-usuario-pedidos', {
        url: 'editar-usuario-pedidos/:objeto/:modo',
        templateUrl: 'app/app/main/usuarios/usuario/usuario-pedidos/usuario-pedidos.html',
        controller: 'EditarUsuarioPedidosCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar usuarios',
          subtituloEditar:'Editar usuario para pedidos',
          subtituloNuevo: 'Nuevo usuario para pedidos',
          modo:null,
          objeto:null
        },
        resolve:{
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          usuario: function(Usuarios, $stateParams){
            if ($stateParams.objeto){
              return Usuarios.get({id:$stateParams.objeto}).$promise.then(function(usuario) {
                return usuario;
              });
            } else {
              return {};
            }
          },
          roles: function(Roles, Usuario){
            var datos = [];
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return Roles.query().$promise.then(function(data){
                data.forEach(function(item){
                  if (usuario.rol && usuario.rol.id<=item.id){
                    datos.push(item);
                  }
                });
                return datos;
              });
            });
          },
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data){
              return data;
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            var depositos = [];
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito){
                depositos.push(usuario.empleado.deposito);
                return depositos;
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarUsuarioPedidosCtrl', EditarUsuarioPedidosCtrl);

  /** @ngInject */
  function EditarUsuarioPedidosCtrl(NgTableParams, Util, SolicitanteUsuario, focus, SolicitanteEmpresa, rol, empresas, HeaderBarService, ServicioModales, usuario, roles, depositos, UsuarioActual, UsuarioNombre, Usuarios, orderByFilter, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    vm.modo = $stateParams.modo;
    inicializar();
    vm.rol = rol;
    vm.cancelar = cancelar;
    vm.guardar = guardar;
    vm.roles = orderByFilter(roles,'nombre',false);
    vm.depositos = orderByFilter(depositos,'nombre',false);
    vm.empresas = orderByFilter(empresas, 'nombre', false);
    vm.alerta = alerta;
    vm.abrirModalCambioPassword = abrirModalCambioPassword;
    vm.validarPassword = validarPassword;

    function validarPassword(){
      if (vm.usuario && vm.usuario.password){
        return Util.validarPassword(vm.usuario.password, {});
      }
      return {validation:false, mensaje: "La contraseña debe cumplir los siguientes requisitos:\nLongitud mínima de 8 y máxima de 25 caracteres\nPoseer al menos una minúscula, una mayúscula, un número y un caracter especial\n"};
    }
    
    if (rol.id!=1 && rol.id!=2) $state.go("home.home");

    function abrirModalCambioPassword(){
      ServicioModales.abrirModalCambioPassword({
        onResult: function(usuario, saludo) {
          vm.usuario = usuario;
        },
        usuario : vm.usuario
      });
    }

    function inicializar(){
      setearTitulos();
      setearObjeto();
      obtenerSolicitantes();
    }

    function obtenerSolicitantes(){
      if (!vm.empresa) return;
      SolicitanteEmpresa.query({id:vm.empresa.id}, function(datos){
        vm.solicitantes = orderByFilter(datos, ["apellido", "nombre"], false);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(e){
        console.log(e);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });

    }

    function setearObjeto(){
      vm.rolPedido = {nombre: "PEDIDOS", id:30};
      if (esEditar()) {
        vm.idUsuario = usuario.id;
        vm.usuario = usuario;
        vm.deposito = vm.usuario.empleado.deposito;
        vm.empresa = vm.usuario.solicitante.empresa;
        vm.usuario.password = vm.usuario.repitePassword = null;
        vm.nombreUsuario = vm.usuario.nombreUsuario;
      }
    }

    function esEditar() {
      return vm.modo=='editar';
    }

    function alerta(){
      ServicioDialogos.abrirDialogoCargando();
      UsuarioActual.get({}, function(data){
        ServicioDialogos.cerrarDialogoCargando();
        if (vm.usuario.nombreUsuario == data.nombreUsuario && vm.usuario.activo==false){
          ServicioDialogos.mostrarDialogoAtencion(
            "¡Cuidado!",
            "Está por desactivar su propio usuario."+
            "\nSi guarda estos cambios, se cerrará sesión y no podrá ingresar mas al sistema con este usuario."
          );
        } else if (vm.usuario.nombreUsuario !== data.nombreUsuario && vm.usuario.activo==false) {
          ServicioDialogos.mostrarDialogoAtencion(
            null,
            "Si desactiva el usuario, le prohibe el ingreso al sistema."
          );
        }
      });
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      if (esEditar()) {
        HeaderBarService.setSubTitulo($stateParams.subtituloEditar);
      } else {
        HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);
      }
    }

    function cancelar() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        $state.go('home.lista-usuario');
      });
    }

    //hace una acción dependiendo del modo.
    function guardar() {
      ServicioDialogos.abrirDialogoCargando();
      SolicitanteUsuario.query({id:vm.usuario.solicitante.id}, function(data){
        ServicioDialogos.cerrarDialogoCargando();
        if (esEditar()) {
          if (data && data.length>0 && data[0].id!=vm.idUsuario){
            ServicioDialogos.mostrarDialogoError(null, "El solicitante seleccionado ya está asignado a un usuario de pedidos");
          } else {
            editarObjeto();
          }
        } else {
          if (data && data.length>0){
            ServicioDialogos.mostrarDialogoError(null, "El solicitante seleccionado ya está asignado a un usuario de pedidos");
          } else {
            nuevoObjeto();
          }
        }
      });
    }

    //al ser nuevo compruebo lo que sea necesario.
    function nuevoObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea registrar un nuevo Usuario?', function(){
        comprobarNombre();
      }, null, false);
    }

    //si los nombres son iguales, 
    function editarObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el Usuario?', function(){
        if (vm.nombreUsuario==vm.usuario.nombreUsuario){
          guardarOEditar();
        } else {
          comprobarNombre();
        }
      },null,false);
    }

    //como este método puede ser llmado por nuevo o por edición, se llama a GuardarOEditar..
    //comprueba el username..
    function comprobarNombre(){
      UsuarioNombre.query({nombreUsuario:vm.usuario.nombreUsuario},function(data){
        if (data.length>0){
          ServicioDialogos.mostrarDialogoError(null, 'El nombre de usuario ingresado ya existe');
        } else {
          guardarOEditar();
        }
      }, function(err){
        console.error(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar el Usuario");
      });
    }

    //según el modo, edito o guardo..
    function guardarOEditar(){
      if (esEditar()){
        editarUsuario();
      } else {
        guardarUsuario();
      }
    }

    function actualizarUsuarioEmpleado(id){
      vm.usuario.empleado = {
        nombre: vm.usuario.solicitante.nombre,
        apellido: vm.usuario.solicitante.apellido,
        deposito: vm.deposito,
        empresa: vm.empresa
      };
      if (id){
        vm.usuario.empleado.id = id;
      }
    }

    //una vez comprobado todo, edito..
    function editarUsuario(){
      actualizarUsuarioEmpleado(usuario.empleado.id);
      Usuarios.update(vm.usuario, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado el Usuario correctamente', function(){
          $state.go('home.lista-usuario');
        });
      }, function(err){
        console.error(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar el Usuario");
      });
    }

    //una vez comprobado todo, se guarda
    function guardarUsuario(){
      actualizarUsuarioEmpleado();
      vm.usuario.rol = vm.rolPedido;
      Usuarios.save(vm.usuario, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha registrado el Usuario correctamente', function(){
          $state.go('home.lista-usuario');
        });
      }, function(error){
        console.error(error);
        ServicioDialogos.mostrarDialogoError(null, 'No se ha podido registrar el Usuario');
      });
    }

    $scope.$watch('vm.empresa.nombre', function(anterior, actual){
      if (anterior == actual) return;
      if (vm.usuario && vm.usuario.solicitante) vm.usuario.solicitante=null;
      if (!vm.empresa) return;
      ServicioDialogos.abrirDialogoCargando();
      SolicitanteEmpresa.query({id:vm.empresa.id}, function(datos){
        vm.solicitantes = orderByFilter(datos, ["apellido", "nombre"], false);
        focus('solicitante');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(e){
        console.log(e);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

     
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-usuario', {
        url: 'lista-usuario',
        templateUrl: 'app/app/main/usuarios/usuario/lista/lista-usuario.html',
        controller: 'ListaUsuariosCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Usuarios',
          subtitulo:'Lista de Usuarios'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          usuarios: function(Usuarios, Usuario){
            var datos = [];
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return Usuarios.query().$promise.then(function(data) {
                data.forEach(function(item){
                  if (usuario.rol.id<=item.rol.id){
                    if (usuario.empleado && !usuario.empleado.deposito){
                      datos.push(item);
                    } else {
                      if (usuario.empleado && usuario.empleado.deposito && item.empleado && item.empleado.deposito && item.empleado.deposito.id==usuario.empleado.deposito.id){
                        datos.push(item);
                      }
                    }
                  }
                });
                return datos;
              });
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaUsuariosCtrl', ListaUsuariosCtrl);

  /** @ngInject */
  function ListaUsuariosCtrl(NgTableParams, rol, HeaderBarService, EmpresaLogistica, $timeout, $stateParams, $scope, orderByFilter, $state, usuarios, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.usuarios = orderByFilter(usuarios,'nombreUsuario',false);
    vm.mostrarInformacion = mostrarInformacion;
    vm.crearNuevo = crearNuevo;
    vm.editar = editar;
    vm.exportToExcel = exportToExcel;
    vm.eliminar = eliminar;
    vm.crearNuevoPedidos = crearNuevoPedidos;

    if (rol.id!=1 && rol.id!=2) $state.go("home.home");

    function mostrarInformacion(usuario){
      var activo = usuario.activo? "SI" : "NO";
      var deposito = usuario.empleado.deposito? '\n Depósito: '+usuario.empleado.deposito.nombre.toUpperCase():"";
      ServicioDialogos.mostrarDialogoInformacion(
        "Información",
        usuario.empleado.apellido.toUpperCase()+", "+usuario.empleado.nombre.toUpperCase()+
        "\n Usuario: " + usuario.nombreUsuario+
        '\n Rol: '+usuario.rol.nombre.toUpperCase()+
        deposito+
        '\n Activo: ' + activo
      );
    }

    function editar(usuario) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el usuario?', function() {
        if (usuario.rol.id==30){
          $state.go('home.editar-usuario-pedidos', {objeto:usuario.id, modo:'editar'});
        } else {
          $state.go('home.editar-usuario', {objeto:usuario.id, modo:'editar'});
        }
      });
    }

    function crearNuevo() {
      $state.go('home.editar-usuario');
    }

    function crearNuevoPedidos(){
      $state.go('home.editar-usuario-pedidos');
    }

    function eliminar(usuario){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Desea desactivar el usuario: \n"+usuario.nombreUsuario.toUpperCase()+"?",function(){
        EmpresaLogistica.remove({id:usuario.id}, function(data){
          ServicioDialogos.mostrarDialogoInformacion(null, "Se ha desactivado el usuario con éxito");
          EmpresaLogistica.query().$promise.then(function(usuarios){
            vm.usuarios = orderByFilter(usuarios,'nombreUsuario',false);
            vm.tableParams.settings({
              data: vm.usuarios
            });
            vm.tableParams.reload();
          }, function(err){
            console.log(err);
          });
        }, function(error){
          console.log(error);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido desactivar el usuario");
        });
      },null,false);
    }

    function exportToExcel(){ // ex: '#my-table'
      var array = [];
      var encargado;
      var empresa;
      var deposito;
      for (var i = vm.usuarios.length - 1; i >= 0; i--) {
        if (vm.usuarios[i].apellidoEncargado && vm.usuarios[i].nombreUsuarioEncargado){
          encargado = vm.usuarios[i].apellidoEncargado+', '+vm.usuarios[i].nombreUsuarioEncargado;
        } else {
          encargado = '-';
        }
        empresa = vm.usuarios[i].empleado.empresa? vm.usuarios[i].empleado.empresa.nombre.toUpperCase() : "-";
        deposito = vm.usuarios[i].empleado.deposito? vm.usuarios[i].empleado.deposito.nombre.toUpperCase() : "-";
        array.push({
          "Nombre" : vm.usuarios[i].empleado.nombre,
          "Apellido" : vm.usuarios[i].empleado.apellido,
          "Nombre de usuario": vm.usuarios[i].nombreUsuario,
          "Activo" : vm.usuarios[i].activo,
          "Rol" : vm.usuarios[i].rol.nombre,
          "Empresa" : empresa,
          "Depósito" : deposito
        });
      }
      alasql('SELECT * INTO XLSX("usuarios.xlsx",{headers:true}) FROM ?',[array]);
    }

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });
    vm.tableParams.settings({
      data: vm.usuarios
    });
    vm.tableParams.reload();
    
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-usuario', {
        url: 'editar-usuario/:objeto/:modo',
        templateUrl: 'app/app/main/usuarios/usuario/editar/editar-usuario.html',
        controller: 'EditarUsuariosCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Usuarios',
          subtituloEditar:'Editar Usuario',
          subtituloNuevo: 'Nuevo Usuario',
          modo:null,
          objeto:null
        },
        resolve:{
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          logueado: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario;
            });
          },
          usuario: function(Usuarios, $stateParams){
            if ($stateParams.objeto){
              return Usuarios.get({id:$stateParams.objeto}).$promise.then(function(usuario) {
                return usuario;
              });
            }
          },
          roles: function(Roles, Usuario){
            var datos = [];
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return Roles.query().$promise.then(function(data){
                data.forEach(function(item){
                  if (usuario.rol && usuario.rol.id<=item.id){
                    datos.push(item);
                  }
                });
                return datos;
              });
            });
          },
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data){
              return data;
            });
          },
          depositos: function(DepositoSoloNaves){
            return DepositoSoloNaves.query().$promise.then(function(data){
              return data;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarUsuariosCtrl', EditarUsuariosCtrl);

  /** @ngInject */
  function EditarUsuariosCtrl(NgTableParams, Util, rol, logueado, empresas, HeaderBarService, ServicioModales, usuario, roles, depositos, UsuarioActual, UsuarioNombre, Usuarios, orderByFilter, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    vm.modo = $stateParams.modo;
    inicializar();
    vm.rol = rol;
    vm.cancelar = cancelar;
    vm.guardar = guardar;
    vm.roles = orderByFilter(roles,'nombre',false);
    vm.depositos = orderByFilter(depositos,'nombre',false);
    vm.empresas = orderByFilter(empresas, 'nombre', false);
    vm.alerta = alerta;
    vm.abrirModalCambioPassword = abrirModalCambioPassword;
    vm.validarPassword = validarPassword;

    function validarPassword(){
      if (vm.usuario && vm.usuario.password){
        return Util.validarPassword(vm.usuario.password, {});
      }
      return {validation:false, mensaje: "La contraseña debe cumplir los siguientes requisitos:\nLongitud mínima de 8 y máxima de 25 caracteres\nPoseer al menos una minúscula, una mayúscula, un número y un caracter especial\n"};
    }

    if (rol.id!=1 && rol.id!=2) $state.go("home.home");

    function abrirModalCambioPassword(){
      ServicioModales.abrirModalCambioPassword({
        onResult: function(usuario, saludo) {
          vm.usuario = usuario;
        },
        usuario : vm.usuario
      });
    }

    function inicializar(){
      setearTitulos();
      setearObjeto();
    }

    function setearObjeto(){
      if (esEditar()) {
        vm.usuario = usuario;
        vm.usuario.password = vm.usuario.repitePassword = null;
        vm.rol=vm.usuario.rol.nombre;
        vm.nombreUsuario = vm.usuario.nombreUsuario;
      }
    }

    function esEditar() {
      return vm.modo=='editar';
    }

    function alerta(){
      ServicioDialogos.abrirDialogoCargando();
      UsuarioActual.get({}, function(data){
        ServicioDialogos.cerrarDialogoCargando();
        if (vm.usuario.nombreUsuario == data.nombreUsuario && vm.usuario.activo==false){
          ServicioDialogos.mostrarDialogoAtencion(
            "¡Cuidado!",
            "Está por desactivar su propio usuario."+
            "\nSi guarda estos cambios, se cerrará sesión y no podrá ingresar mas al sistema con este usuario."
          );
        } else if (vm.usuario.nombreUsuario !== data.nombreUsuario && vm.usuario.activo==false) {
          ServicioDialogos.mostrarDialogoAtencion(
            null,
            "Si desactiva el usuario prohibe su ingreso al sistema."
          );
        }
      });
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      if (esEditar()) {
        HeaderBarService.setSubTitulo($stateParams.subtituloEditar);
      } else {
        HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);
      }
    }

    function cancelar() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        $state.go('home.lista-usuario');
      });
    }

    //hace una acción dependiendo del modo.
    function guardar() {
      if (esEditar()) {
        editarObjeto();
      } else {
        nuevoObjeto();
      }
    }

    //al ser nuevo compruebo lo que sea necesario.
    function nuevoObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea registrar un nuevo Usuario?', function(){
        comprobarNombre();
      }, null, false);
    }

    //si los nombres son iguales, 
    function editarObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el Usuario?', function(){
        if (vm.nombreUsuario==vm.usuario.nombreUsuario){
          guardarOEditar();
        } else {
          comprobarNombre();
        }
      },null,false);
    }

    //como este método puede ser llmado por nuevo o por edición, se llama a GuardarOEditar..
    //comprueba el username..
    function comprobarNombre(){
      UsuarioNombre.get({nombreUsuario:vm.usuario.nombreUsuario},function(data){
        if (data.id){
          ServicioDialogos.mostrarDialogoError(null, 'El nombre de usuario ingresado ya existe');
        } else {
          guardarOEditar();
        }
      }, function(err){
        console.error(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar el Usuario");
      });
    }

    //según el modo, edito o guardo..
    function guardarOEditar(){
      if (esEditar()){
        editarUsuario();
      } else {
        guardarUsuario();
      }
    }

    //una vez comprobado todo, edito..
    function editarUsuario(){
      if (vm.usuario.rol.nombre === 'CONSULTA' && !vm.usuario.empleado.deposito && !vm.usuario.empleado.empresa){
        cargarEmpresas();
      }
      Usuarios.update(vm.usuario, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado el Usuario correctamente', function(){
          $state.go('home.lista-usuario');
        });
      }, function(err){
        console.error(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar el Usuario");
      });
    }

    function cargarEmpresas(){
      vm.usuario.empleado.empresas = [];
      empresas.forEach(function(item){
        if (!item.borrado && item.id!=6) {
          vm.usuario.empleado.empresas.push(item.id);
        }
      });
    }

    //una vez comprobado todo, se guarda
    function guardarUsuario(){
      if (vm.usuario.rol.nombre === 'CONSULTA' && !vm.usuario.empleado.deposito && !vm.usuario.empleado.empresa){
        cargarEmpresas();
      }
      Usuarios.save(vm.usuario, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha registrado el Usuario correctamente', function(){
          $state.go('home.lista-usuario');
        });
      }, function(error){
        console.error(error);
        ServicioDialogos.mostrarDialogoError(null, 'No se ha podido registrar el Usuario');
      });

    }
     
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.crear-nuevas-ubicaciones', {
        url: 'crear-nuevas-ubicaciones/:nivel',
        templateUrl: 'app/app/main/ubicaciones/ubicaciones/nueva-jerarquia/nueva-jerarquia.html',
        controller: 'VariasUbicacionesNuevasCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar ubicaciones',
          subtitulo:'Crear nuevas ubicaciones'
        },
        resolve: {
          nivel: function($stateParams, NivelId){
            return NivelId.get({ id : $stateParams.nivel }).$promise;
          },
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('VariasUbicacionesNuevasCtrl', VariasUbicacionesNuevasCtrl);

  /** @ngInject */
  function VariasUbicacionesNuevasCtrl(NgTableParams, nivel, $q, orderByFilter, Util, HeaderBarService, Ubicacion, $state, $stateParams, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.util = Util;
    vm.nivel = nivel;
    vm.crearJerarquia = crearJerarquia;
    vm.cancelar = cancelar;

    function cancelar(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(
        null,
        "¿Está seguro que desea cancelar?",
        function(){
          $state.go('home.lista-ubicaciones',{nivel:nivel.id});
        }
      );
    }

    function obtenerUltimo(array){
      if (array.length>0) {
        var ubicaciones = orderByFilter(array,'numeroUbicacion*1',true);
        return parseInt(ubicaciones[0].numeroUbicacion);
      } else {
        return 1;
      }

    }

    function crearUbicacion(numeroUbicacion){
      var categoriaPesoId = null;
      if (nivel && nivel.numeroNivel==1){
        categoriaPesoId = 1;
      } else {
        categoriaPesoId = 2;
      }
      var ubicacion = {
        numeroUbicacion:numeroUbicacion,
        borrado:false,
        nivel: nivel,
        estadoUbicacion:{
          id:1
        },
        categoriaPeso: {
          id:categoriaPesoId
        }
      };
      return ubicacion;
    }


    function actualizarCategoriasPeso(nivel){
      nivel.ubicaciones.forEach(function(ubicacion){
        if (nivel.numeroNivel>1){
          ubicacion.categoriaPeso = {id:2};
        } else {
          ubicacion.categoriaPeso = { id:1};
        }
      });
      return nivel;
    }

    function obtenerRepeticiones(){
      var repeticiones = [];
      for (var i = vm.cantidad.ubicaciones - 1; i >= 0; i--) {
        repeticiones.push({index:i});
      }
      return repeticiones;
    }

    function crear(){
      var numeroNuevaUbicacion = obtenerUltimo(nivel.ubicaciones);
      var defer = $q.defer();
      var promise = defer.promise;
      obtenerRepeticiones().forEach(function(item, index){
        promise = promise.then(function(){
          return Ubicacion.save(crearUbicacion(numeroNuevaUbicacion+index+1)).$promise.then(function(data){
            defer.resolve(true);
          });
        });
      });
      defer.resolve(true);
      return promise;
    }


    function actualizarNroOrden(){
      return vm.util.actualizarNroOrden(vm.nivel.estante.estructura.pasillo.nave)
      .then(function(res){
        mostrarMensajeExito();
      }, function(err){
        console.log(err);
      });
    }


    function mostrarMensajeExito(){
      ServicioDialogos.mostrarDialogoGuardadoExito(
        null,
        "Se han creado las ubicaciones con éxito",
        function(){
          $state.go('home.lista-ubicaciones', {nivel:nivel.id});
        }
      );

    }

    function crearJerarquia(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(
        null,
        "¿Está seguro que desea crear ubicaciones?",
        function(){
          crear().
            then(function(){
              actualizarNroOrden();
            });
        },
        null,
        false
      );
    }
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-ubicaciones', {
        url: 'lista-ubicaciones/:nivel',
        templateUrl: 'app/app/main/ubicaciones/ubicaciones/lista/lista-ubicaciones.html',
        controller: 'ListaUbicacionCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Ubicaciones',
          subtitulo:'Vista por Ubicaciones'
        },
        resolve: {
          nivel: function($stateParams, NivelId){
            return NivelId.get({ id : $stateParams.nivel }).$promise;
          },
          ubicaciones: function($stateParams, UbicacionNivel){
            return UbicacionNivel.query({id:$stateParams.nivel}).$promise.then(function(data) {
              return data;
            });

          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaUbicacionCtrl', ListaUbicacionCtrl);

  /** @ngInject */
  function ListaUbicacionCtrl(NgTableParams, HeaderBarService, ServicioModales, UbicacionNivel, Ubicacion, CambiarEstadoUbicacion, Util, nivel, $timeout, $stateParams, $scope, orderByFilter, $state, ubicaciones, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.util = Util;
    vm.ubicaciones = orderByFilter(ubicaciones,'numeroUbicacion',false);
    vm.nivel = nivel;
    vm.volver = volver;
    vm.editar = editar;
    vm.eliminar = eliminar;
    vm.irVistaNave = irVistaNave;
    vm.irVistaDeposito = irVistaDeposito;
    vm.irVistaPasillo = irVistaPasillo;
    vm.irVistaEstructura = irVistaEstructura;
    vm.irVistaEstanteria = irVistaEstanteria;
    vm.claseUbicaciones = claseUbicaciones;
    vm.cambiarEstado = cambiarEstado;
    vm.crearNuevo = crearNuevo;
    vm.mostrarInformacion = mostrarInformacion;
    vm.crearNuevas = crearNuevas;

    function crearNuevas(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(
        null,
        '¿Está seguro que desea crear mas de una ubicación en el estante?',
        function(){
          $state.go('home.crear-nuevas-ubicaciones', {nivel:nivel.id});
        }
      );
    }

    function cambiarEstado(ubicacion){
      if (ubicacion.suministros.length>0 && ubicacion.estadoUbicacion.id==2){
        cambiarEstadoOcupado(ubicacion.id);
      } else if (ubicacion.suministros.length>0 && ubicacion.estadoUbicacion.id==3){
        cambiarEstadoPoseeSuministro(ubicacion.id);
      }
    }

    function actualizarUbicacion(ubicacion){
      vm.ubicaciones.forEach(function(item){
        if (item.id==ubicacion.id){
          item.estadoUbicacion=ubicacion.estadoUbicacion;
        }
      });
    }

    function cambiarEstadoOcupado(idUbicacion){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cambiar el estado de la ubicación a\n POSEE SUMINISTRO?", function(){
        CambiarEstadoUbicacion.update({'idUbicacion':idUbicacion, 'idEstadoUbicacion':3}, function(data){
          actualizarUbicacion(data);
          ServicioDialogos.mostrarDialogoGuardadoExito(
            null,
            "Se ha actualizado el estado de la ubicación con éxito",
            function(){
              actualizarTabla();
            });
        });
      }, null, false);
    }

    function cambiarEstadoPoseeSuministro(idUbicacion){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cambiar el estado de la ubicación a\n OCUPADO?", function(){
        CambiarEstadoUbicacion.update({'idUbicacion':idUbicacion, 'idEstadoUbicacion':2}, function(data){
          actualizarUbicacion(data);
          ServicioDialogos.mostrarDialogoGuardadoExito(
            null,
            "Se ha actualizado el estado de la ubicación con éxito",
            function(){
              actualizarTabla();
            });
        });
      }, null, false);
    }

    function actualizarTabla(){
      vm.tableParams.settings({
        data: orderByFilter(vm.ubicaciones,'numeroUbicacion',false)
      });
      vm.tableParams.reload();
    }

    function crearNuevo() {
      $state.go('home.editar-ubicaciones',{nivel:vm.nivel.id});
    }

    function editar(ubicacion){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar la Ubicación?', function() {
        $state.go('home.editar-ubicaciones', {objeto:ubicacion.id, modo:'editar', nivel:ubicacion.nivel.id});
      });
    }

    function claseUbicaciones(){
      var cantidadUbicaciones = Util.contarNoBorrados(vm.nivel.ubicaciones);
        return {"width":parseInt(100/cantidadUbicaciones)+"%"};
    }

    function mostrarInformacion(ubicacion){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(
        "Ubicación N° "+ubicacion.numeroUbicacion+
        "\nNúmero de orden: "+ubicacion.numeroOrden,
        "\nDepósito: "+ubicacion.nivel.estante.estructura.pasillo.nave.deposito.nombre.toUpperCase()+
        "\nNave: "+ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo N° "+ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura N° "+ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería N° "+ubicacion.nivel.estante.numeroEstante+
        "\nEstante N° "+ubicacion.nivel.numeroNivel,
        function(){
          ServicioDialogos.abrirDialogoCargando();
          ServicioModales.abrirModalSuministroUbicaciones({"ubicacion": ubicacion});
        },
        null,
        true,
        "Mostrar suministros",
        "Cerrar"
      );
    }

    function volver(){
      $state.go('home.lista-nivel-ubicaciones', {estante:vm.nivel.estante.id});
    }

    function eliminarUbicacion(ubicacion){
      Ubicacion.remove({id:ubicacion.id}, function(data){
        ServicioDialogos.mostrarDialogoInformacion(null, "Se ha eliminado la Ubicación con éxito");
        UbicacionNivel.query({id:$stateParams.nivel}).$promise.then(function(data) {
          vm.ubicaciones = orderByFilter(data,'numeroUbicacion',false);
          actualizarTabla();
        }, function(err){
          console.log(err);
        });
      }, function(error){
        console.log(error);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar la Ubicación");
      });
    }

    function mostrarMsjError(){
      console.log("hola");
    }

    function eliminar(ubicacion){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Desea eliminar la Ubicación N° "+ubicacion.numeroUbicacion+"?",function(){
        Ubicacion.get({id:ubicacion.id}, function(data){
          if (data.estadoUbicacion.id==1){
            eliminarUbicacion(ubicacion);
          } else {
            ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar la Ubicación porque está siendo utilizada");
          }
        });
      },null,false);
    }

    function irVistaEstanteria(){
      $state.go('home.lista-nivel-ubicaciones', {estante:vm.nivel.estante.id});
    }

    function irVistaEstructura(){
      $state.go('home.lista-estante-ubicaciones', {estructura:vm.nivel.estante.estructura.id});
    }

    function irVistaPasillo(){
      $state.go('home.lista-estructura-ubicaciones', {pasillo:vm.nivel.estante.estructura.pasillo.id});
    }

    function irVistaNave(){
      $state.go('home.lista-pasillo-ubicaciones',{nave:vm.nivel.estante.estructura.pasillo.nave.id});
    }

    function irVistaDeposito(){
      $state.go('home.lista-nave-ubicaciones', {deposito:vm.nivel.estante.estructura.pasillo.nave.deposito.id});
    }

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });
    vm.tableParams.settings({
      data: vm.ubicaciones
    });
    vm.tableParams.reload();
    
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-ubicaciones', {
        url: 'editar-ubicaciones/:modo/:nivel/:objeto',
        templateUrl: 'app/app/main/ubicaciones/ubicaciones/editar/editar-ubicaciones.html',
        controller: 'EditarUbicacionesCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Ubicaciones',
          subtituloEditar:'Editar Ubicación',
          subtituloNuevo: 'Nueva Ubicación',
          modo:null,
          objeto:null,
          nivel:null
        },
        resolve: {
          nivel: function($stateParams, NivelId){
            return NivelId.get({ id : $stateParams.nivel }).$promise.then(function(data){
              return data;
            });
          },
          ubicacion: function($stateParams, Ubicacion){
            if ($stateParams.modo){
              return Ubicacion.get({id:$stateParams.objeto}).$promise.then(function(data){
                return data;
              });
            } else {
              return {};
            }
          },
          estadoNuevo: function(EstadoUbicacion){
            return EstadoUbicacion.get({ id : 1 }).$promise.then(function(data){
              return data;
            });
          },
          categoriaPesado: function(CategoriasPeso){
            return CategoriasPeso.get({id : 1}).$promise.then(function(data){
              return data;
            });
          },
          categoriaLiviano: function(CategoriasPeso){
            return CategoriasPeso.get({id : 3}).$promise.then(function(data){
              return data;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarUbicacionesCtrl', EditarUbicacionesCtrl);

  /** @ngInject */
  function EditarUbicacionesCtrl(NgTableParams, HeaderBarService, categoriaPesado, categoriaLiviano, ubicacion, Util, UbicacionNivelTodos, estadoNuevo, nivel, orderByFilter, Ubicacion, UbicacionNumeroNivel, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    vm.util = Util;
    vm.cancelar = cancelar;
    vm.guardar = guardar;
    vm.nivel = nivel;
    vm.categoriaPesado = categoriaPesado;
    vm.categoriaLiviano = categoriaLiviano;

    inicializar();
    vm.modo = $stateParams.modo;
    vm.estadoNuevo = estadoNuevo;


    function obtenerUltimoNumero(){
      UbicacionNivelTodos.query({id:vm.nivel.id}).$promise.then(function(data) {
        vm.ubicacion.numeroUbicacion = obtenerUltimo(data);
      }, function(error){
        console.log(error);
        ServicioDialogos.mostrarDialogoError(null, null);
      });
    }

    function obtenerUltimo(array){
      if (array.length>0) {
        var ubicaciones = orderByFilter(array,'numeroUbicacion*1',true);
        return parseInt(ubicaciones[0].numeroUbicacion)+1;
      } else {
        return 1;
      }
    }

    function inicializar(){
      setearTitulos();
      setearObjeto();
    }

    function setearObjeto(){
      vm.ubicacion = ubicacion;
      vm.categoria = obtenerCategoriaPeso();
      if (esEditar()) {
        vm.numeroUbicacion = vm.ubicacion.numeroUbicacion;
      } else {
        obtenerUltimoNumero();
      }
    }

    function esEditar() {
      return $stateParams.modo=='editar';
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      if (esEditar()) {
        HeaderBarService.setSubTitulo($stateParams.subtituloEditar);
      } else {
        HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);
      }
    }

    function cancelar() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        $state.go('home.lista-ubicaciones',{nivel:nivel.id});
      });
    }

    function guardar() {
      if (esEditar()) {
        editarObjeto();
      } else {
        nuevoObjeto();
      }
    }


    function nuevoObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea registrar un nueva Ubicación?', function(){
        comprobarNumero();
      }, null, false);
    }

    function editarObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el Depósito?', function(){
        if (vm.numeroUbicacion==vm.ubicacion.numeroUbicacion) {
          editarUbicacion();
        } else {
          comprobarNumero();
        }
      },null,false);
    }

    function comprobarNumero(){
      if (vm.numeroUbicacion==vm.ubicacion.numeroUbicacion) {
        guardarOEditar();
      } else {
        UbicacionNumeroNivel.query({'numeroUbicacion':vm.ubicacion.numeroUbicacion, id:vm.nivel.id}, function(data){
          if (data.length>0){
            ServicioDialogos.mostrarDialogoError(null, 'El número de ubicación ingresado ya existe para ese estante');
          } else {
            guardarOEditar();
          }
        }, function(err){
          console.log(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar la ubicación");
        });
      }
    }


    function guardarOEditar(){
      if (esEditar()){
        editarUbicacion();
      } else {
        guardarUbicacion();
      }
    }

    function editarUbicacion(){
      Ubicacion.update(vm.ubicacion, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado la Ubicación correctamente', function(){
          $state.go('home.lista-ubicaciones',{nivel:nivel.id});
        });
      }, function(err){
        console.error(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar la Ubicación");
      });
    }

    function actualizarNroOrden(){
      return vm.util.actualizarNroOrden(vm.nivel.estante.estructura.pasillo.nave)
      .then(function(res){
        ServicioDialogos.mostrarDialogoExito(
          null,
          'Se ha registrado la Ubicación correctamente'+
          '\nSe actualizaron los número de orden de cada ubicación de la nave',
          function(){
            $state.go('home.lista-ubicaciones',{nivel:nivel.id});
          }
        );
      }, function(err){
        console.log(err);
      });
    }

    function obtenerCategoriaPeso(){
      if (nivel.numeroNivel>1){
        return  {id:2, nombre:"LIVIANO"};
      } else {
        return { id:1, nombre:"PESADO"};
      }
    }

    function guardarUbicacion(){
      vm.ubicacion.estadoUbicacion = vm.estadoNuevo;
      vm.ubicacion.nivel=vm.nivel;
      vm.ubicacion.categoriaPeso = vm.categoria;
      Ubicacion.save(vm.ubicacion, function(data){
        actualizarNroOrden();
      }, function(error){
        console.error(error);
        ServicioDialogos.mostrarDialogoError(null, 'No se ha podido registrar la Ubicación');
      });
    }
     
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.nueva-jerarquia-pasillo-ubicaciones', {
        url: 'nueva-jerarquia-pasillo-ubicaciones/:nave',
        templateUrl: 'app/app/main/ubicaciones/pasillo/nueva-jerarquia/nueva-jerarquia.html',
        controller: 'NuevaJerarquiaPasilloUbicacionesCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar ubicaciones',
          subtitulo:'Crear nuevo pasillo con jerarquía completa'
        },
        resolve: {
          nave: function($stateParams, NaveSoloPasillos){
            return NaveSoloPasillos.get({ id : $stateParams.nave }).$promise;
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('NuevaJerarquiaPasilloUbicacionesCtrl', NuevaJerarquiaPasilloUbicacionesCtrl);

  /** @ngInject */
  function NuevaJerarquiaPasilloUbicacionesCtrl(NgTableParams, $q, nave, orderByFilter, Util, HeaderBarService, PasilloId, PasilloNaveTodosHastaEstructura, $state, $stateParams, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.util = Util;
    vm.nave = nave;
    vm.crearJerarquia = crearJerarquia;
    vm.cancelar = cancelar;
    vm.numeroNivel = 0;

    function cancelar(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(
        null,
        "¿Está seguro que desea cancelar?",
        function(){
          $state.go('home.lista-pasillo-ubicaciones', {nave:vm.nave.id});
        }
      );
    }

    function obtenerUltimo(array){
      if (array.length>0) {
        var pasillos = orderByFilter(array,'numeroPasillo*1',true);
        return parseInt(pasillos[0].numeroPasillo)+1;
      } else {
        return 1;
      }

    }

    function crearEstructuras(pasillo){
      var estructuras = [];
      for (var i = 1; i < vm.cantidad.estructuras+1; i++) {
        estructuras.push({
          identificadorEstructura:i,
          borrado:false
        });
      }
      pasillo.estructuras=estructuras;
      return pasillo;
    }

    function crearEstantes(pasillo){
      var estantes = [];
      for (var i = 1; i < vm.cantidad.estantes+1; i++) {
        estantes.push({
          numeroEstante:i,
          borrado:false
        });
      }
      pasillo.estructuras.forEach(function(estructura){
        estructura.estantes = estantes;
      });
      return pasillo;
    }

    function crearNiveles(pasillo){
      var niveles = [];
      for (var i = 1; i < vm.cantidad.niveles+1; i++) {
        niveles.push({
          numeroNivel:i,
          borrado:false
        });
      }
      pasillo.estructuras.forEach(function(estructura){
        estructura.estantes.forEach(function(estante){
          estante.niveles=niveles;
        });
      });
      return pasillo;
    }

    function crearUbicaciones(pasillo){
      var ubicaciones = [];
      for (var i = 1; i < vm.cantidad.ubicaciones+1; i++) {
        ubicaciones.push({
          numeroUbicacion:i,
          borrado:false,
          estadoUbicacion:{
            id:1
          }
        });
      }
      pasillo.estructuras.forEach(function(estructura){
        estructura.estantes.forEach(function(estante){
          estante.niveles.forEach(function(nivel){
            nivel.ubicaciones = angular.copy(ubicaciones);
          });
        });
      });
      return pasillo;
    }

    function actualizarCategoriasPeso(pasillo){
      pasillo.estructuras.forEach(function(estructura){
        estructura.estantes.forEach(function(estante){
          estante.niveles.forEach(function(nivel){
            nivel.ubicaciones.forEach(function(ubicacion){
              if (nivel.numeroNivel>1){
                ubicacion.categoriaPeso = {id:2};
              } else {
                ubicacion.categoriaPeso = { id:1};
              }
            });
          });
        });
      });
      return pasillo;
    }

    function actualizarNroOrden(){
      return vm.util.actualizarNroOrden(vm.nave)
      .then(function(res){
        console.log("OK");
        mostrarMensajeExito();
      }, function(err){
        console.log(err);
      });
    }

    function mostrarMensajeExito(){
      ServicioDialogos.mostrarDialogoGuardadoExito(
        null,
        "Se ha creado el pasillo con éxito",
        function(){
          $state.go('home.lista-pasillo-ubicaciones', {nave:vm.nave.id});
        }
      );
    }


    function editarNroOrden(ubi){
      var defered = $q.defer();
      var promesa = defered.promise;
      Ubicacion.get({id:ubi.id},function(ubicacion){
        vm.contadorOrden = vm.contadorOrden + 1;
        ubicacion.numeroOrden = vm.contadorOrden;
        Ubicacion.update(ubicacion, function(res){
          defered.resolve(true);
        }, function(err){
          console.log(err);
          return $q.reject();
        });
      }, function(err){
        console.log(err);
        return $q.reject();
      });
      return promesa;
    }

    function crear(){
      var numeroNuevoPasillo;
      var nuevoPasillo = {};
      PasilloNaveTodosHastaEstructura.query({id:vm.nave.id}).$promise.then(function(data) {
        numeroNuevoPasillo = obtenerUltimo(data);
        nuevoPasillo.nave = {
          id:vm.nave.id
        };
        nuevoPasillo.numeroPasillo=numeroNuevoPasillo;
        nuevoPasillo.borrado = false;
        nuevoPasillo = crearEstructuras(nuevoPasillo);
        nuevoPasillo = crearEstantes(nuevoPasillo);
        nuevoPasillo = crearNiveles(nuevoPasillo);
        nuevoPasillo = crearUbicaciones(nuevoPasillo);
        nuevoPasillo = actualizarCategoriasPeso(nuevoPasillo);
        PasilloId.save(nuevoPasillo, function(data){
          actualizarNroOrden();
        }, function(err){
          console.log(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido crear el pasillo");
        });
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido crear el pasillo");
      });
    }

    function crearJerarquia(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(
        null,
        "¿Está seguro que desea crear un pasillo con jerarquía completa?",
        function(){
          crear();
        },
        null,
        false
      );
    }

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-pasillo-ubicaciones', {
        url: 'lista-pasillo-ubicaciones/:nave',
        templateUrl: 'app/app/main/ubicaciones/pasillo/lista/lista-pasillo-ubicaciones.html',
        controller: 'UbicacionPasilloCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Ubicaciones',
          subtitulo:'Vista por Pasillos'
        },
        resolve: {
          nave: function($stateParams, NaveSoloPasillos){
            return NaveSoloPasillos.get({ id : $stateParams.nave }).$promise.then(function(data){
              return data;
            });
          },
          pasillos: function($stateParams, PasilloNaveHastaUbicacion){
            return PasilloNaveHastaUbicacion.query({id:$stateParams.nave}).$promise.then(function(data) {
              return data;
            });

          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('UbicacionPasilloCtrl', UbicacionPasilloCtrl);

  /** @ngInject */
  function UbicacionPasilloCtrl(NgTableParams, HeaderBarService, Util, nave, $timeout, PasilloId, PasilloHastaUbicacion, PasilloNaveHastaUbicacion, $stateParams, $scope, orderByFilter, $state, pasillos, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.util = Util;
    vm.pasillos = orderByFilter(pasillos,'numeroPasillo',false);
    vm.nave = nave;

    vm.volver = volver;
    vm.verPlanoEstructura = verPlanoEstructura;
    vm.verPlanoEstantes = verPlanoEstantes;
    vm.verPlanoNiveles = verPlanoNiveles;
    vm.irVistaDeposito = irVistaDeposito;

    vm.clasePasillos = clasePasillos;
    vm.claseEstante = claseEstante;
    
    vm.crearNuevo = crearNuevo;
    vm.mostrarInformacion = mostrarInformacion;
    vm.eliminar = eliminar;
    vm.editar = editar;
    vm.crearNuevoHijo = crearNuevoHijo;
    vm.crearNuevaJerarquia = crearNuevaJerarquia;

    function crearNuevoHijo(pasillo){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(
        null,
        '¿Está seguro que desea crear una nueva estructura para el pasillo N°'+pasillo.numeroPasillo+'?',
        function(){
          $state.go('home.editar-estructura-ubicaciones', {pasillo:pasillo.id});
        }
      );
    }

    function crearNuevaJerarquia(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(
        null,
        '¿Está seguro que desea crear un pasillo con jerarquía completa?',
        function(){
          $state.go('home.nueva-jerarquia-pasillo-ubicaciones', {nave:vm.nave.id});
        }
      );
    }

    function crearNuevo() {
      $state.go('home.editar-pasillo-ubicaciones', {nave:vm.nave.id});
    }

    function editar(pasillo){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el pasillo?', function() {
        $state.go('home.editar-pasillo-ubicaciones', {objeto:pasillo.id, modo:'editar', nave:pasillo.nave.id});
      });
    }


    function mostrarInformacion(pasillo){
      var cantidades = vm.util.ubicacionesCompletasPorPasillo(pasillo);
      var porcentaje = isNaN((cantidades.libres/cantidades.totales).toFixed(2)*100)? "-" : (cantidades.libres/cantidades.totales).toFixed(2)*100+"%";
      ServicioDialogos.mostrarDialogoInformacion(
        "Pasillo N° "+pasillo.numeroPasillo,
        "Depósito: "+pasillo.nave.deposito.nombre.toUpperCase()+" / Nave: "+pasillo.nave.nombre.toUpperCase()+
        "\nCantidad de ubicaciones que posee el pasillo: "+cantidades.totales+
        "\nLibres: "+cantidades.libres+
        "\nOcupadas: "+cantidades.ocupados+
        "\nSemi ocupadas: "+cantidades.semi+
        "\nPorcentaje libre: "+porcentaje);
    }

    function eliminarPasillo(pasillo){
      PasilloId.remove({id:pasillo.id}, function(data){
        ServicioDialogos.mostrarDialogoInformacion(null, "Se ha eliminado el pasillo con éxito");
        PasilloNaveHastaUbicacion.query({id:$stateParams.nave}).$promise.then(function(data) {
          vm.pasillos = orderByFilter(data,'numeroPasillo',false);
          vm.tableParams.settings({
            data: vm.pasillos
          });
          vm.tableParams.reload();
        }, function(err){
          console.log(err);
        });
      }, function(error){
        console.log(error);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar el pasillo");
      });
    }

    function eliminar(pasillo){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Desea eliminar el pasillo N° "+pasillo.numeroPasillo+"?",function(){
        PasilloHastaUbicacion.get({id:pasillo.id}, function(data){
          if (Util.contarNoBorrados(data.estructuras)==0){
            eliminarPasillo(pasillo);
          } else {
            ServicioDialogos.mostrarDialogoError(null, "No es posible eliminar el pasillo porque posee estructuras vigentes");
          }
        });
      },null,false);
    }


    function claseEstante(estructura){
      var cantEstantes = Util.contarNoBorrados(estructura.estantes);
      if (cantEstantes<=4){
        return {"height": parseInt(315/4)+"px"};
      } else {
        return {"height": parseInt(315/cantEstantes)+"px"};
      }
    }

    function clasePasillos() {
      var pasillosNoBorrados = Util.traerNoBorrados(vm.pasillos);
      var cantPasillos= 0;
      for (var i = pasillosNoBorrados.length - 1; i >= 0; i--) {
        if (pasillosNoBorrados[i].estructuras.length>0) {
          cantPasillos = cantPasillos + 1; 
        }
      };
      return {"width": parseInt(100/pasillosNoBorrados.length)+"%"};
    }

    function volver(){
      $state.go('home.lista-nave-ubicaciones', {deposito:vm.nave.deposito.id});
    }

    function verPlanoEstructura(pasillo) {
      $state.go('home.lista-estructura-ubicaciones', {pasillo:pasillo.id});
    }

    function verPlanoEstantes(estructura){
      $state.go('home.lista-estante-ubicaciones', {estructura:estructura.id});
    }

    function verPlanoNiveles(estante){
      $state.go('home.lista-nivel-ubicaciones', {estante:estante.id});
    }

    function irVistaDeposito(){
      $state.go('home.lista-nave-ubicaciones', {deposito:vm.nave.deposito.id});
    }

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });
    vm.tableParams.settings({
      data: vm.pasillos
    });
    vm.tableParams.reload();
    
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-pasillo-ubicaciones', {
        url: 'editar-pasillo-ubicaciones/:nave/:modo/:objeto',
        templateUrl: 'app/app/main/ubicaciones/pasillo/editar/editar-pasillo-ubicaciones.html',
        controller: 'EditarPasilloUbicacionesCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Pasillos',
          subtituloEditar:'Editar Pasillo',
          subtituloNuevo: 'Nuevo Pasillo',
          modo:null,
          objeto:null,
          nave:null
        },
        resolve: {
          nave: function($stateParams, NaveSoloPasillos){
            return NaveSoloPasillos.get({ id : $stateParams.nave }).$promise;
          },
          pasillo: function($stateParams, PasilloHastaUbicacion){
            if ($stateParams.modo){
              return PasilloHastaUbicacion.get({id:$stateParams.objeto}).$promise;
            } else {
              return {};
            }
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarPasilloUbicacionesCtrl', EditarPasilloUbicacionesCtrl);

  /** @ngInject */
  function EditarPasilloUbicacionesCtrl(NgTableParams, HeaderBarService, PasilloId, PasilloNaveTodosHastaEstructura, nave, pasillo, orderByFilter, PasilloNumeroNaveHastaEstructura, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    vm.cancelar = cancelar;
    vm.guardar = guardar;
    vm.nave = nave;
    inicializar();
    vm.modo = $stateParams.modo;

    function obtenerUltimoNumero(){
      var numeroNuevoNivel;
      PasilloNaveTodosHastaEstructura.query({id:vm.nave.id}).$promise.then(function(data) {
        vm.pasillo.numeroPasillo = obtenerUltimo(data);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(error){
        console.log(error);
        ServicioDialogos.mostrarDialogoError(null, null);
      });
    }

    function obtenerUltimo(array){
      if (array.length>0) {
        var pasillos = orderByFilter(array,'numeroPasillo*1',true);
        return parseInt(pasillos[0].numeroPasillo)+1;
      } else {
        return 1;
      }
    }

    function inicializar(){
      ServicioDialogos.abrirDialogoCargando();
      setearTitulos();
      setearObjeto();
    }

    function setearObjeto(){
      vm.pasillo = pasillo;
      if (esEditar()) {
        vm.numeroPasillo = vm.pasillo.numeroPasillo;
      } else {
        obtenerUltimoNumero();
      }
    }

    function esEditar() {
      return $stateParams.modo=='editar';
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      if (esEditar()) {
        HeaderBarService.setSubTitulo($stateParams.subtituloEditar);
      } else {
        HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);
      }
    }

    function cancelar() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        $state.go('home.lista-pasillo-ubicaciones',{nave:nave.id});
      });
    }

    function guardar() {
      if (esEditar()) {
        editarObjeto();
      } else {
        nuevoObjeto();
      }
    }


    function nuevoObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea registrar un nuevo pasillo?', function(){
        comprobarNumero();
      }, null, false);
    }

    function editarObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el pasillo?', function(){
        if (vm.numeroPasillo==vm.pasillo.numeroPasillo) {
          editarPasillo();
        } else {
          comprobarNumero();
        }
      },null,false);
    }

    function comprobarNumero(){
      if (vm.numeroPasillo==vm.pasillo.numeroPasillo) {
        guardarOEditar();
      } else {
        PasilloNumeroNaveHastaEstructura.query({'numeroPasillo':vm.pasillo.numeroPasillo, id:vm.nave.id}, function(data){
          if (data.length>0){
            ServicioDialogos.mostrarDialogoError(null, 'El número de pasillo ingresado ya existe para esta nave');
          } else {
            guardarOEditar();
          }
        }, function(err){
          console.log(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar el pasillo");
        });
      }
    }


    function guardarOEditar(){
      if (esEditar()){
        editarPasillo();
      } else {
        guardarPasillo();
      }
    }

    function editarPasillo(){
      PasilloId.update(vm.pasillo, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado el pasillo correctamente', function(){
        $state.go('home.lista-pasillo-ubicaciones',{nave:nave.id});
        });
      }, function(err){
        console.error(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar el pasillo");
      });
    }

    function guardarPasillo(){
      vm.pasillo.nave=vm.nave;
      PasilloId.save(vm.pasillo, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha registrado el pasillo correctamente', function(){
        $state.go('home.lista-pasillo-ubicaciones',{nave:nave.id});
        });
      }, function(error){
        console.error(error);
        ServicioDialogos.mostrarDialogoError(null, 'No se ha podido registrar el pasillo');
      });
    }
     
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.nueva-jerarquia-nivel-ubicaciones', {
        url: 'nueva-jerarquia-nivel-ubicaciones/:estante',
        templateUrl: 'app/app/main/ubicaciones/nivel/nueva-jerarquia/nueva-jerarquia.html',
        controller: 'NuevaJerarquiaNivelUbicacionesCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar ubicaciones',
          subtitulo:'Crear nuevo estante con jerarquía completa'
        },
        resolve: {
          estante: function($stateParams, EstanteHastaNivel){
            return EstanteHastaNivel.get({ id : $stateParams.estante }).$promise;
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('NuevaJerarquiaNivelUbicacionesCtrl', NuevaJerarquiaNivelUbicacionesCtrl);

  /** @ngInject */
  function NuevaJerarquiaNivelUbicacionesCtrl(NgTableParams, estante, orderByFilter, Util, HeaderBarService, NivelId, NivelEstanteTodos, $state, $stateParams, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.util = Util;
    vm.estante = estante;
    vm.crearJerarquia = crearJerarquia;
    vm.cancelar = cancelar;

    function cancelar(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(
        null,
        "¿Está seguro que desea cancelar?",
        function(){
          $state.go('home.lista-nivel-ubicaciones', {estante:vm.estante.id});
        }
      );
    }

    function obtenerUltimo(array){
      if (array.length>0) {
        var niveles = orderByFilter(array,'numeroNivel*1',true);
        return parseInt(niveles[0].numeroNivel)+1;
      } else {
        return 1;
      }

    }

    function crearUbicaciones(nivel){
      var ubicaciones = [];
      for (var i = 1; i < vm.cantidad.ubicaciones+1; i++) {
        ubicaciones.push({
          numeroUbicacion:i,
          borrado:false,
          estadoUbicacion:{
            id:1
          }
        });
      }
      nivel.ubicaciones = angular.copy(ubicaciones);
      return nivel;
    }


    function actualizarCategoriasPeso(nivel){
      nivel.ubicaciones.forEach(function(ubicacion){
        if (nivel.numeroNivel>1){
          ubicacion.categoriaPeso = {id:2};
        } else {
          ubicacion.categoriaPeso = { id:1};
        }
      });
      return nivel;
    }

    function crear(){
      var numeroNuevoNivel;
      var nuevoNivel = {};
      NivelEstanteTodos.query({id:vm.estante.id}).$promise.then(function(data) {
        numeroNuevoNivel = obtenerUltimo(data);
        nuevoNivel.estante = {
          id:vm.estante.id
        };
        nuevoNivel.numeroNivel=numeroNuevoNivel;
        nuevoNivel.borrado = false;
        nuevoNivel = crearUbicaciones(nuevoNivel);
        nuevoNivel = actualizarCategoriasPeso(nuevoNivel);
        NivelId.save(nuevoNivel, function(data){
          actualizarNroOrden();
        }, function(err){
          console.log(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido crear el estante");
        });
      }, function(error){
        console.log(error);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido crear el estante");
      });
    }


    function actualizarNroOrden(){
      return vm.util.actualizarNroOrden(vm.estante.estructura.pasillo.nave)
      .then(function(res){
        console.log("OK");
        mostrarMensajeExito();
      }, function(err){
        console.log(err);
      });
    }


    function mostrarMensajeExito(){
      ServicioDialogos.mostrarDialogoGuardadoExito(
        null,
        "Se ha creado el estante con éxito",
        function(){
          $state.go('home.lista-nivel-ubicaciones', {estante:vm.estante.id});
        }
      );

    }

    function crearJerarquia(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(
        null,
        "¿Está seguro que desea crear un nuevo estante con jerarquía completa?",
        function(){
          crear();
        },
        null,
        false
      );
    }
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-nivel-ubicaciones', {
        url: 'lista-nivel-ubicaciones/:estante',
        templateUrl: 'app/app/main/ubicaciones/nivel/lista/lista-nivel-ubicaciones.html',
        controller: 'UbicacionNivelCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Ubicaciones',
          subtitulo:'Vista por Estantes'
        },
        resolve: {
          estante: function($stateParams, EstanteHastaNivel){
            return EstanteHastaNivel.get({ id : $stateParams.estante }).$promise;
          },
          niveles: function($stateParams, NivelEstante){
            return NivelEstante.query({id:$stateParams.estante}).$promise.then(function(data) {
              return data;
            });

          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('UbicacionNivelCtrl', UbicacionNivelCtrl);

  /** @ngInject */
  function UbicacionNivelCtrl(NgTableParams, HeaderBarService, ServicioModales, Util, NivelEstanteHastaUbicacion, NivelId, estante, $timeout, $stateParams, $scope, orderByFilter, $state, niveles, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.util = Util;
    vm.niveles = orderByFilter(niveles,'numeroNivel',false);
    vm.verPlanoUbicaciones = verPlanoUbicaciones;
    vm.estante = estante;
    vm.volver = volver;
    vm.editar = editar;
    vm.eliminar = eliminar;
    vm.irVistaNave = irVistaNave;
    vm.irVistaDeposito = irVistaDeposito;
    vm.irVistaPasillo = irVistaPasillo;
    vm.irVistaEstructura = irVistaEstructura;
    vm.claseNivel = claseNivel;
    vm.claseUbicacion = claseUbicacion;
    vm.crearNuevo = crearNuevo;
    vm.mostrarInformacion = mostrarInformacion;
    vm.mostrarInfoUbicacion = mostrarInfoUbicacion;
    vm.crearNuevoHijo = crearNuevoHijo;
    vm.crearNuevaJerarquia = crearNuevaJerarquia;

    function crearNuevaJerarquia(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(
        null,
        '¿Está seguro que desea crear un estante con jerarquía completa?',
        function(){
          $state.go('home.nueva-jerarquia-nivel-ubicaciones', {estante:vm.estante.id});
        }
      );
    }

    function crearNuevoHijo(nivel){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(
        null,
        '¿Está seguro que desea crear un nueva ubicación para el estante N°'+nivel.numeroNivel+'?',
        function(){
          $state.go('home.editar-ubicaciones', {nivel:nivel.id});
        }
      );
    }

    function crearNuevo() {
      $state.go('home.editar-nivel-ubicaciones',{estante:vm.estante.id});
    }

    function claseNivel(estante){
      var cantEstantes = Util.contarNoBorrados(vm.estante.niveles);
      return {"width": parseInt(100/cantEstantes)+"%"};

    }

    function claseUbicacion(nivel){
      var cantidadUbicaciones = Util.contarNoBorrados(nivel.ubicaciones);
        return {"height":parseInt(355/cantidadUbicaciones)+"px"};
    }

    function mostrarInformacion(nivel){
      var cantidades = vm.util.ubicacionesCompletasPorNivel(nivel);
      var porcentaje = (cantidades.libres/cantidades.totales).toFixed(2)*100;
      ServicioDialogos.mostrarDialogoInformacion(
        "Estante N° "+nivel.numeroNivel,
        "Depósito: "+nivel.estante.estructura.pasillo.nave.deposito.nombre.toUpperCase()+
        " / Nave: "+nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        " / Pasillo N° "+nivel.estante.estructura.pasillo.numeroPasillo+
        " / Estructura N° "+nivel.estante.estructura.identificadorEstructura+
        " / Estantería N° "+nivel.estante.numeroEstante+
        "\nCantidad de ubicaciones que posee el estante: "+cantidades.totales+
        "\nLibres: "+cantidades.libres+
        "\nOcupadas: "+cantidades.ocupados+
        "\nSemi ocupadas: "+cantidades.semi+
        "\nPorcentaje libre: "+porcentaje+"%");
    }

    function mostrarInfoUbicacion(ubicacion, nivel){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(
        "Ubicación N° "+ubicacion.numeroUbicacion+
        "\nNúmero de orden: "+ubicacion.numeroOrden,
        "\nDepósito: "+nivel.estante.estructura.pasillo.nave.deposito.nombre.toUpperCase()+
        "\nNave: "+nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo N° "+nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura N° "+nivel.estante.estructura.identificadorEstructura+
        "\nEstantería N° "+nivel.estante.numeroEstante+
        "\nEstante N° "+nivel.numeroNivel,
        function(){
          ServicioDialogos.abrirDialogoCargando();
          ServicioModales.abrirModalSuministroUbicaciones({"ubicacion": ubicacion});
        },
        null,
        true,
        "Mostrar suministros",
        "Cerrar"
      );
    }

    function editar(nivel){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el estante?', function() {
        $state.go('home.editar-nivel-ubicaciones', {objeto:nivel.id, modo:'editar', estante:nivel.estante.id});
      });
    }

    function eliminarNivel(nivel){
      NivelId.remove({id:nivel.id}, function(data){
        ServicioDialogos.mostrarDialogoInformacion(null, "Se ha eliminado el estánte con éxito");
        NivelEstanteHastaUbicacion.query({id:$stateParams.estante}).$promise.then(function(data) {
          vm.niveles = orderByFilter(data,'numeroNivel',false);
          vm.tableParams.settings({
            data: vm.niveles
          });
          vm.tableParams.reload();
        }, function(err){
          console.log(err);
        });
      }, function(error){
        console.log(error);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar el estante");
      });
    }

    function eliminar(nivel){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Desea eliminar el estante N° "+nivel.numeroNivel+"?",function(){
        NivelId.get({id:nivel.id}, function(data){
          if (Util.contarNoBorrados(data.ubicaciones)==0){
            eliminarNivel(nivel);
          } else {
            ServicioDialogos.mostrarDialogoError(null, "No es posible eliminar el estante porque posee ubicaciones vigentes");
          }
        });
      },null,false);
    }

    function volver(){
      $state.go('home.lista-estante-ubicaciones', {estructura:vm.estante.estructura.id});
    }

    function verPlanoUbicaciones(nivel) {
      $state.go('home.lista-ubicaciones', {nivel:nivel.id});
    }

    function irVistaEstructura(){
      $state.go('home.lista-estante-ubicaciones', {estructura:vm.estante.estructura.id});
    }

    function irVistaPasillo(){
      $state.go('home.lista-estructura-ubicaciones', {pasillo:vm.estante.estructura.pasillo.id});
    }

    function irVistaNave(){
      $state.go('home.lista-pasillo-ubicaciones',{nave:vm.estante.estructura.pasillo.nave.id});
    }

    function irVistaDeposito(){
      $state.go('home.lista-nave-ubicaciones', {deposito:vm.estante.estructura.pasillo.nave.deposito.id});
    }


    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });
    vm.tableParams.settings({
      data: vm.niveles
    });
    vm.tableParams.reload();
    
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-nivel-ubicaciones', {
        url: 'editar-nivel-ubicaciones/:modo/:estante/:objeto',
        templateUrl: 'app/app/main/ubicaciones/nivel/editar/editar-nivel-ubicaciones.html',
        controller: 'EditarNivelUbicacionesCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Estantes',
          subtituloEditar:'Editar Estante',
          subtituloNuevo: 'Nuevo Estante',
          modo:null,
          objeto:null,
          estante:null
        },
        resolve: {
          estante: function($stateParams, EstanteHastaNivel){
            return EstanteHastaNivel.get({ id : $stateParams.estante }).$promise;
          },
          nivel: function($stateParams, NivelId){
            if ($stateParams.modo){
              return NivelId.get({id:$stateParams.objeto}).$promise;
            } else {
              return {};
            }
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarNivelUbicacionesCtrl', EditarNivelUbicacionesCtrl);

  /** @ngInject */
  function EditarNivelUbicacionesCtrl(NgTableParams, HeaderBarService, nivel, NivelId, NivelEstanteTodos, estante, orderByFilter, NivelNumeroEstante, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    vm.cancelar = cancelar;
    vm.guardar = guardar;
    vm.estante = estante;
    inicializar();
    vm.modo = $stateParams.modo;

    function obtenerUltimoNumero(){
      var numeroNuevoNivel;
      NivelEstanteTodos.query({id:vm.estante.id}).$promise.then(function(data) {
        vm.nivel.numeroNivel = obtenerUltimo(data);
      }, function(error){
        console.log(error);
        ServicioDialogos.mostrarDialogoError(null, null);
      });
    }

    function obtenerUltimo(array){
      if (array.length>0) {
        var niveles = orderByFilter(array,'numeroNivel*1',true);
        return parseInt(niveles[0].numeroNivel)+1;
      } else {
        return 1;
      }
    }


    function inicializar(){
      setearTitulos();
      setearObjeto();
    }

    function setearObjeto(){
      vm.nivel = nivel;
      if (esEditar()) {
        vm.numeroNivel = vm.nivel.numeroNivel;
      } else {
        obtenerUltimoNumero();
      }
    }

    function esEditar() {
      return $stateParams.modo=='editar';
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      if (esEditar()) {
        HeaderBarService.setSubTitulo($stateParams.subtituloEditar);
      } else {
        HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);
      }
    }

    function cancelar() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        $state.go('home.lista-nivel-ubicaciones',{estante:estante.id});
      });
    }

    function guardar() {
      if (esEditar()) {
        editarObjeto();
      } else {
        nuevoObjeto();
      }
    }


    function nuevoObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea registrar un nuevo estante?', function(){
        comprobarNumero();
      }, null, false);
    }

    function editarObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el estante?', function(){
        if (vm.numeroNivel==vm.nivel.numeroNivel) {
          editarNivel();
        } else {
          comprobarNumero();
        }
      },null,false);
    }

    function comprobarNumero(){
      if (vm.numeroNivel==vm.nivel.numeroNivel) {
        guardarOEditar();
      } else {
        NivelNumeroEstante.query({'numeroNivel':vm.nivel.numeroNivel, id:vm.estante.id}, function(data){
          if (data.length>0){
            ServicioDialogos.mostrarDialogoError(null, 'El número de estante ingresado ya existe para esta estantería');
          } else {
            guardarOEditar();
          }
        }, function(err){
          console.log(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar el estante");
        });
      }
    }


    function guardarOEditar(){
      if (esEditar()){
        editarNivel();
      } else {
        guardarNivel();
      }
    }

    function editarNivel(){
      NivelId.update(vm.nivel, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado el estante correctamente', function(){
        $state.go('home.lista-nivel-ubicaciones',{estante:estante.id});
        });
      }, function(err){
        console.error(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar el estante");
      });
    }

    function guardarNivel(){
      vm.nivel.estante=vm.estante;
      NivelId.save(vm.nivel, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha registrado el estante correctamente', function(){
        $state.go('home.lista-nivel-ubicaciones',{estante:estante.id});
        });
      }, function(error){
        console.error(error);
        ServicioDialogos.mostrarDialogoError(null, 'No se ha podido registrar el estante');
      });
    }
     
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-nave-ubicaciones', {
        url: 'lista-nave-ubicaciones/:deposito',
        templateUrl: 'app/app/main/ubicaciones/nave/lista/lista-nave-ubicaciones.html',
        controller: 'UbicacionesNaveCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Ubicaciones',
          subtitulo:'Lista de Naves del depósito'
        },
        resolve: {
          deposito: function($stateParams, DepositoSoloNaves){
            return DepositoSoloNaves.get({ id : $stateParams.deposito }).$promise;
          },
          naves: function($stateParams, NaveDepositoSoloPasillos){
            return NaveDepositoSoloPasillos.query({id:$stateParams.deposito}).$promise.then(function(data) {
              return data;
            });

          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('UbicacionesNaveCtrl', UbicacionesNaveCtrl);

  /** @ngInject */
  function UbicacionesNaveCtrl(NgTableParams, HeaderBarService, Util, deposito, $timeout, $stateParams, $scope, orderByFilter, $state, naves, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo+ ": "+deposito.nombre.toUpperCase());

    var vm = this;
    vm.util = Util;
    vm.naves = orderByFilter(naves,'nombre',false);
    vm.verPlano = verPlano;
    vm.deposito = deposito;
    vm.volver = volver;
    vm.crearNuevoHijo = crearNuevoHijo;

    function crearNuevoHijo(nave){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(
        null,
        '¿Está seguro que desea crear una nuevo pasillo para la nave '+nave.nombre.toUpperCase()+'?',
        function(){
          $state.go('home.editar-pasillo-ubicaciones', {nave:nave.id});
        }
      );
    }

    function volver(){
      $state.go('home.lista-deposito-ubicaciones');
    }

    function verPlano(nave) {
     $state.go('home.lista-pasillo-ubicaciones', {nave:nave.id});
    }

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });
    vm.tableParams.settings({
      data: vm.naves
    });
    vm.tableParams.reload();
    
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.nueva-jerarquia-estructura-ubicaciones', {
        url: 'nueva-jerarquia-estructura-ubicaciones/:pasillo',
        templateUrl: 'app/app/main/ubicaciones/estructura/nueva-jerarquia/nueva-jerarquia.html',
        controller: 'NuevaJerarquiaEstructuraUbicacionesCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar ubicaciones',
          subtitulo:'Crear nueva estructura con jerarquía completa'
        },
        resolve: {
          pasillo: function($stateParams, PasilloHastaEstructura){
            return PasilloHastaEstructura.get({ id : $stateParams.pasillo }).$promise;
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('NuevaJerarquiaEstructuraUbicacionesCtrl', NuevaJerarquiaEstructuraUbicacionesCtrl);

  /** @ngInject */
  function NuevaJerarquiaEstructuraUbicacionesCtrl(NgTableParams, pasillo, orderByFilter, Util, HeaderBarService, EstructuraId, EstructuraPasilloTodosHastaEstante, $state, $stateParams, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.util = Util;
    vm.pasillo = pasillo;
    vm.crearJerarquia = crearJerarquia;
    vm.cancelar = cancelar;

    function cancelar(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(
        null,
        "¿Está seguro que desea cancelar?",
        function(){
          $state.go('home.lista-estructura-ubicaciones', {pasillo:vm.pasillo.id});
        }
      );
    }

    function obtenerUltimo(array){
      if (array.length>0) {
        var estructuras = orderByFilter(array,'identificadorEstructura*1',true);
        return parseInt(estructuras[0].identificadorEstructura)+1;
      } else {
        return 1;
      }
    }

    function crearEstantes(estructura){
      var estantes = [];
      for (var i = 1; i < vm.cantidad.estantes+1; i++) {
        estantes.push({
          numeroEstante:i,
          borrado:false
        });
      }
      estructura.estantes=estantes;
      return estructura;
    }

    function crearNiveles(estructura){
      var niveles = [];
      for (var i = 1; i < vm.cantidad.niveles+1; i++) {
        niveles.push({
          numeroNivel:i,
          borrado:false
        });
      }
      estructura.estantes.forEach(function(estante){
        estante.niveles=niveles;
      });
      return estructura;
    }

    function crearUbicaciones(estructura){
      var ubicaciones = [];
      for (var i = 1; i < vm.cantidad.ubicaciones+1; i++) {
        ubicaciones.push({
          numeroUbicacion:i,
          borrado:false,
          estadoUbicacion:{
            id:1
          }
        });
      }
      estructura.estantes.forEach(function(estante){
        estante.niveles.forEach(function(nivel){
          nivel.ubicaciones = angular.copy(ubicaciones);
        });
      });
      return estructura;
    }

    function actualizarCategoriasPeso(estructura){
        estructura.estantes.forEach(function(estante){
          estante.niveles.forEach(function(nivel){
            nivel.ubicaciones.forEach(function(ubicacion){
              if (nivel.numeroNivel>1){
                ubicacion.categoriaPeso = {id:2};
              } else {
                ubicacion.categoriaPeso = { id:1};
              }
            });
          });
        });
      return estructura;
    }


    function actualizarNroOrden(){
      return vm.util.actualizarNroOrden(vm.pasillo.nave)
      .then(function(res){
        console.log("OK");
        mostrarMensajeExito();
      }, function(err){
        console.log(err);
      });
    }

    function crear(){
      var numeroNuevaEstructura;
      var nuevaEstructura = {};
      EstructuraPasilloTodosHastaEstante.query({id:vm.pasillo.id}).$promise.then(function(data) {
        numeroNuevaEstructura = obtenerUltimo(data);
        nuevaEstructura.pasillo = {
          id:vm.pasillo.id
        };
        nuevaEstructura.identificadorEstructura=numeroNuevaEstructura;
        nuevaEstructura.borrado = false;
        nuevaEstructura = crearEstantes(nuevaEstructura);
        nuevaEstructura = crearNiveles(nuevaEstructura);
        nuevaEstructura = crearUbicaciones(nuevaEstructura);
        nuevaEstructura = actualizarCategoriasPeso(nuevaEstructura);
        EstructuraId.save(nuevaEstructura, function(data){
          actualizarNroOrden();
        }, function(err){
          console.log(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido crear la estructura");
        });
      }, function(error){
        console.log(error);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido crear la estructura");
      });
    }

    function mostrarMensajeExito(){
      ServicioDialogos.mostrarDialogoGuardadoExito(
        null,
        "Se ha creado la estructura con éxito",
        function(){
          $state.go('home.lista-estructura-ubicaciones', {pasillo:vm.pasillo.id});
        }
      );

    }

    function crearJerarquia(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(
        null,
        "¿Está seguro que desea crear una nueva estructura con jerarquía completa?",
        function(){
          crear();
        },
        null,
        false
      );
    }
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-estructura-ubicaciones', {
        url: 'lista-estructura-ubicaciones/:pasillo',
        templateUrl: 'app/app/main/ubicaciones/estructura/lista/lista-estructura-ubicaciones.html',
        controller: 'UbicacionEstructuraCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Ubicaciones',
          subtitulo:'Vista por Estructuras'
        },
        resolve: {
          pasillo: function($stateParams, PasilloHastaEstructura){
            return PasilloHastaEstructura.get({ id : $stateParams.pasillo }).$promise;
          },
          estructuras: function($stateParams, EstructuraPasilloHastaUbicacion){
            return EstructuraPasilloHastaUbicacion.query({id:$stateParams.pasillo}).$promise.then(function(data) {
              return data;
            });

          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('UbicacionEstructuraCtrl', UbicacionEstructuraCtrl);

  /** @ngInject */
  function UbicacionEstructuraCtrl(NgTableParams, HeaderBarService, Util, pasillo, EstructuraHastaUbicacion, EstructuraPasilloHastaUbicacion, EstructuraId, $timeout, $stateParams, $scope, orderByFilter, $state, estructuras, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.util = Util;
    vm.estructuras = orderByFilter(estructuras,'identificadorEstructura',false);
    vm.verPlanoEstantes = verPlanoEstantes;
    vm.verPlanoNiveles = verPlanoNiveles;
    vm.pasillo = pasillo;
    vm.volver = volver;
    vm.irVistaNave = irVistaNave;
    vm.irVistaDeposito = irVistaDeposito;
    vm.claseEstante = claseEstante;
    vm.crearNuevo = crearNuevo;
    vm.mostrarInformacion = mostrarInformacion;
    vm.eliminar = eliminar;
    vm.editar = editar;
    vm.crearNuevoHijo = crearNuevoHijo;
    vm.crearNuevaJerarquia = crearNuevaJerarquia;

    function crearNuevaJerarquia(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(
        null,
        '¿Está seguro que desea crear una estructura con jerarquía completa?',
        function(){
          $state.go('home.nueva-jerarquia-estructura-ubicaciones', {pasillo:vm.pasillo.id});
        }
      );
    }

    function crearNuevoHijo(estructura){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(
        null,
        '¿Está seguro que desea crear una nueva estantería para la estructura N°'+estructura.identificadorEstructura+'?',
        function(){
          $state.go('home.editar-estante-ubicaciones', {estructura:estructura.id});
        }
      );
    }

    function crearNuevo() {
      $state.go('home.editar-estructura-ubicaciones', {pasillo:vm.pasillo.id});
    }

    function editar(estructura){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar la estructura?', function() {
        $state.go('home.editar-estructura-ubicaciones', {objeto:estructura.id, modo:'editar', pasillo:estructura.pasillo.id});
      });
    }



    function mostrarInformacion(estructura){
      var cantidades = vm.util.ubicacionesCompletasPorEstructura(estructura);
      var porcentaje = isNaN((cantidades.libres/cantidades.totales).toFixed(2)*100)? "-" : (cantidades.libres/cantidades.totales).toFixed(2)*100+"%";
      ServicioDialogos.mostrarDialogoInformacion(
        "Estructura N° "+estructura.identificadorEstructura,
        "Depósito: "+estructura.pasillo.nave.deposito.nombre.toUpperCase()+" / Nave: "+estructura.pasillo.nave.nombre.toUpperCase()+
        " / Pasillo N° "+estructura.pasillo.numeroPasillo+
        "\nCantidad de ubicaciones que posee la estructura: "+cantidades.totales+
        "\nLibres: "+cantidades.libres+
        "\nOcupadas: "+cantidades.ocupados+
        "\nSemi ocupadas: "+cantidades.semi+
        "\nPorcentaje libre: "+porcentaje);
    }

    function eliminarEstructura(estructura){
      EstructuraId.remove({id:estructura.id}, function(data){
        ServicioDialogos.mostrarDialogoInformacion(null, "Se ha eliminado la estructura con éxito");
        EstructuraPasilloHastaUbicacion.query({id:$stateParams.pasillo}).$promise.then(function(data) {
          vm.estructuras = orderByFilter(data,'numeroEstante',false);
          vm.tableParams.settings({
            data: vm.estructuras
          });
          vm.tableParams.reload();
        }, function(err){
          console.log(err);
        });
      }, function(error){
        console.log(error);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar la estructura");
      });
    }

    function eliminar(estructura){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Desea eliminar la estructura N° "+estructura.identificadorEstructura+"?",function(){
        EstructuraHastaUbicacion.get({id:estructura.id}, function(data){
          if (Util.contarNoBorrados(data.estantes)==0){
            eliminarEstructura(estructura);
          } else {
            ServicioDialogos.mostrarDialogoError(null, "No es posible eliminar la estructura porque posee estanterías vigentes");
          }
        });
      },null,false);
    }


    function claseEstante(estructura, estante){
      var cantEstantes = Util.contarNoBorrados(estructura.estantes);
      if (cantEstantes<=4){
        return {"height": parseInt(332/4)+"px"};
      } else {
        return {"height": parseInt(332/cantEstantes)+"px"};
      }
    }

    function volver(){
      $state.go('home.lista-pasillo-ubicaciones', {nave:vm.pasillo.nave.id});
    }

    function verPlanoEstantes(estructura){
      $state.go('home.lista-estante-ubicaciones', {estructura:estructura.id});
    }

    function verPlanoNiveles(estante){
      $state.go('home.lista-nivel-ubicaciones', {estante:estante.id});
    }


    function irVistaNave(){
      $state.go('home.lista-pasillo-ubicaciones',{nave:vm.pasillo.nave.id});
    }

    function irVistaDeposito(){
      $state.go('home.lista-nave-ubicaciones', {deposito:vm.pasillo.nave.deposito.id});
    }

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });
    vm.tableParams.settings({
      data: vm.estructuras
    });
    vm.tableParams.reload();
    
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-estructura-ubicaciones', {
        url: 'editar-estructura-ubicaciones/:modo/:pasillo/:objeto',
        templateUrl: 'app/app/main/ubicaciones/estructura/editar/editar-estructura-ubicaciones.html',
        controller: 'EditarEstructuraUbicacionesCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Estructuras',
          subtituloEditar:'Editar Estructura',
          subtituloNuevo: 'Nueva Estructura',
          modo:null,
          objeto:null,
          pasillo:null
        },
        resolve: {
          pasillo: function($stateParams, PasilloHastaEstructura){
            return PasilloHastaEstructura.get({ id : $stateParams.pasillo }).$promise;
          },
          estructura: function($stateParams, EstructuraHastaUbicacion){
            if ($stateParams.modo){
              return EstructuraHastaUbicacion.get({id:$stateParams.objeto}).$promise;
            } else {
              return {};
            }
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarEstructuraUbicacionesCtrl', EditarEstructuraUbicacionesCtrl);

  /** @ngInject */
  function EditarEstructuraUbicacionesCtrl(NgTableParams, HeaderBarService, estructura, EstructuraId, EstructuraPasilloTodosHastaEstante, pasillo, orderByFilter, EstructuraNumeroPasilloHastaEstante, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    vm.cancelar = cancelar;
    vm.guardar = guardar;
    vm.pasillo = pasillo;
    inicializar();
    vm.modo = $stateParams.modo;


    function obtenerUltimoNumero(){
      var numeroNuevoNivel;
      EstructuraPasilloTodosHastaEstante.query({id:vm.pasillo.id}).$promise.then(function(data) {
        ServicioDialogos.cerrarDialogoCargando();
        vm.estructura.identificadorEstructura = obtenerUltimo(data);
      }, function(error){
        console.log(error);
        ServicioDialogos.mostrarDialogoError(null, null);
      });
    }

    function obtenerUltimo(array){
      if (array.length>0) {
        var estructuras = orderByFilter(array,'identificadorEstructura*1',true);
        return parseInt(estructuras[0].identificadorEstructura)+1;
      } else {
        return 1;
      }
    }

    function inicializar(){
      ServicioDialogos.abrirDialogoCargando();
      setearTitulos();
      setearObjeto();
    }

    function setearObjeto(){
      vm.estructura = estructura;
      if (esEditar()) {
        vm.identificadorEstructura = vm.estructura.identificadorEstructura;
      } else {
        obtenerUltimoNumero();
      }
    }

    function esEditar() {
      return $stateParams.modo=='editar';
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      if (esEditar()) {
        HeaderBarService.setSubTitulo($stateParams.subtituloEditar);
      } else {
        HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);
      }
    }

    function cancelar() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        $state.go('home.lista-estructura-ubicaciones',{pasillo:pasillo.id});
      });
    }

    function guardar() {
      if (esEditar()) {
        editarObjeto();
      } else {
        nuevoObjeto();
      }
    }


    function nuevoObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea registrar una nueva estructura?', function(){
        comprobarNumero();
      }, null, false);
    }

    function editarObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar la estructura?', function(){
        if (vm.identificadorEstructura==vm.estructura.identificadorEstructura) {
          editarEstructura();
        } else {
          comprobarNumero();
        }
      },null,false);
    }

    function comprobarNumero(){
      if (vm.identificadorEstructura==vm.estructura.identificadorEstructura) {
        guardarOEditar();
      } else {
        EstructuraNumeroPasilloHastaEstante.query({'identificadorEstructura':vm.estructura.identificadorEstructura, id:vm.pasillo.id}, function(data){
          if (data.length>0){
            ServicioDialogos.mostrarDialogoError(null, 'El número de estructura ingresado ya existe para este pasillo');
          } else {
            guardarOEditar();
          }
        }, function(err){
          console.log(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar la estructura");
        });
      }
    }


    function guardarOEditar(){
      if (esEditar()){
        editarEstructura();
      } else {
        guardarEstructura();
      }
    }

    function editarEstructura(){
      EstructuraId.update(vm.estructura, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado la estructura correctamente', function(){
        $state.go('home.lista-estructura-ubicaciones',{pasillo:pasillo.id});
        });
      }, function(err){
        console.error(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar la estructura");
      });
    }

    function guardarEstructura(){
      vm.estructura.pasillo=vm.pasillo;
      EstructuraId.save(vm.estructura, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha registrado la estructura correctamente', function(){
        $state.go('home.lista-estructura-ubicaciones',{pasillo:pasillo.id});
        });
      }, function(error){
        console.error(error);
        ServicioDialogos.mostrarDialogoError(null, 'No se ha podido registrar la estructura');
      });
    }
     
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.nueva-jerarquia-estante-ubicaciones', {
        url: 'nueva-jerarquia-estante-ubicaciones/:estructura',
        templateUrl: 'app/app/main/ubicaciones/estante/nueva-jerarquia/nueva-jerarquia.html',
        controller: 'NuevaJerarquiaEstanteUbicacionesCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar ubicaciones',
          subtitulo:'Crear nueva estantería con jerarquía completa'
        },
        resolve: {
          estructura: function($stateParams, EstructuraHastaEstante){
            return EstructuraHastaEstante.get({ id : $stateParams.estructura }).$promise;
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('NuevaJerarquiaEstanteUbicacionesCtrl', NuevaJerarquiaEstanteUbicacionesCtrl);

  /** @ngInject */
  function NuevaJerarquiaEstanteUbicacionesCtrl(NgTableParams, estructura, orderByFilter, Util, HeaderBarService, EstanteId, EstanteEstructuraTodosHastaNivel, $state, $stateParams, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.util = Util;
    vm.estructura = estructura;
    vm.crearJerarquia = crearJerarquia;
    vm.cancelar = cancelar;

    function cancelar(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(
        null,
        "¿Está seguro que desea cancelar?",
        function(){
          $state.go('home.lista-estante-ubicaciones', {estructura:vm.estructura.id});
        }
      );
    }

    function obtenerUltimo(array){
      if (array.length>0) {
        var estantes = orderByFilter(array,'numeroEstante*1',true);
        return parseInt(estantes[0].numeroEstante)+1;
      } else {
        return 1;
      }

    }

    function crearNiveles(estante){
      var niveles = [];
      for (var i = 1; i < vm.cantidad.niveles+1; i++) {
        niveles.push({
          numeroNivel:i,
          borrado:false
        });
      }
      estante.niveles=niveles;
      return estante;
    }

    function crearUbicaciones(estante){
      var ubicaciones = [];
      for (var i = 1; i < vm.cantidad.ubicaciones+1; i++) {
        ubicaciones.push({
          numeroUbicacion:i,
          borrado:false,
          estadoUbicacion:{
            id:1
          }
        });
      }
      estante.niveles.forEach(function(nivel){
        nivel.ubicaciones = angular.copy(ubicaciones);
      });
      return estante;
    }


    function actualizarCategoriasPeso(estante){
      estante.niveles.forEach(function(nivel){
        nivel.ubicaciones.forEach(function(ubicacion){
          if (nivel.numeroNivel>1){
            ubicacion.categoriaPeso = {id:2};
          } else {
            ubicacion.categoriaPeso = { id:1};
          }
        });
      });
      return estante;
    }

    function actualizarNroOrden(){
      return vm.util.actualizarNroOrden(vm.estructura.pasillo.nave)
      .then(function(res){
        console.log("OK");
        mostrarMensajeExito();
      }, function(err){
        console.log(err);
      });
    }

    function crear(){
      var numeroNuevoEstante;
      var nuevoEstante = {};
      EstanteEstructuraTodosHastaNivel.query({id:vm.estructura.id}).$promise.then(function(data) {
        numeroNuevoEstante = obtenerUltimo(data);
        nuevoEstante.estructura = {
          id:vm.estructura.id
        };
        nuevoEstante.numeroEstante=numeroNuevoEstante;
        nuevoEstante.borrado = false;
        nuevoEstante = crearNiveles(nuevoEstante);
        nuevoEstante = crearUbicaciones(nuevoEstante);
        nuevoEstante = actualizarCategoriasPeso(nuevoEstante);
        EstanteId.save(nuevoEstante, function(data){
          actualizarNroOrden();
        }, function(err){
          console.log(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido crear la estantería");
        });
      }, function(error){
        console.log(error);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido crear la estantería");
      });
    }

    function mostrarMensajeExito(){
      ServicioDialogos.mostrarDialogoGuardadoExito(
        null,
        "Se ha creado el estante con éxito",
        function(){
          $state.go('home.lista-estante-ubicaciones', {estructura:vm.estructura.id});
        }
      );

    }

    function crearJerarquia(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(
        null,
        "¿Está seguro que desea crear una nueva estantería con jerarquía completa?",
        function(){
          crear();
        },
        null,
        false
      );
    }
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-estante-ubicaciones', {
        url: 'lista-estante-ubicaciones/:estructura',
        templateUrl: 'app/app/main/ubicaciones/estante/lista/lista-estante-ubicaciones.html',
        controller: 'UbicacionEstanteCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Ubicaciones',
          subtitulo:'Vista por Estanterías'
        },
        resolve: {
          estructura: function($stateParams, EstructuraHastaEstante){
            return EstructuraHastaEstante.get({ id : $stateParams.estructura }).$promise;
          },
          estantes: function($stateParams, EstanteEstructuraHastaUbicacion){
            return EstanteEstructuraHastaUbicacion.query({id:$stateParams.estructura}).$promise.then(function(data) {
              return data;
            });

          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('UbicacionEstanteCtrl', UbicacionEstanteCtrl);

  /** @ngInject */
  function UbicacionEstanteCtrl(NgTableParams, HeaderBarService, Util, estructura, EstanteId, EstanteHastaUbicacion, EstanteEstructuraHastaUbicacion, $timeout, $stateParams, $scope, orderByFilter, $state, estantes, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.util = Util;
    vm.estantes = orderByFilter(estantes,'numeroEstante',false);
    vm.verPlanoUbicaciones = verPlanoUbicaciones;
    vm.verPlanoNiveles = verPlanoNiveles;
    vm.estructura = estructura;
    vm.volver = volver;
    vm.irVistaNave = irVistaNave;
    vm.irVistaDeposito = irVistaDeposito;
    vm.irVistaPasillo = irVistaPasillo;
    vm.claseNivel = claseNivel;
    vm.claseEstante = claseEstante;
    vm.crearNuevo = crearNuevo;
    vm.mostrarInformacion = mostrarInformacion;
    vm.eliminar = eliminar;
    vm.editar = editar;
    vm.crearNuevoHijo = crearNuevoHijo;
    vm.crearNuevaJerarquia = crearNuevaJerarquia;

    function crearNuevaJerarquia(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(
        null,
        '¿Está seguro que desea crear una estantería con jerarquía completa?',
        function(){
          $state.go('home.nueva-jerarquia-estante-ubicaciones', {estructura:vm.estructura.id});
        }
      );
    }

    function crearNuevoHijo(estante){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(
        null,
        '¿Está seguro que desea crear un nuevo estante para la estantería N°'+estante.numeroEstante+'?',
        function(){
          $state.go('home.editar-nivel-ubicaciones', {estante:estante.id});
        }
      );
    }

    function crearNuevo() {
      $state.go('home.editar-estante-ubicaciones',{estructura:vm.estructura.id});
    }

    function editar(estante){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el estante?', function() {
        $state.go('home.editar-estante-ubicaciones', {objeto:estante.id, modo:'editar', estructura:estante.estructura.id});
      });    
    }


    function mostrarInformacion(estante){
      var cantidades = vm.util.ubicacionesCompletasPorEstante(estante);
      var porcentaje = (cantidades.libres/cantidades.totales).toFixed(2)*100;
      ServicioDialogos.mostrarDialogoInformacion(
        "Estantería N° "+estante.numeroEstante,
        "Depósito: "+estante.estructura.pasillo.nave.deposito.nombre.toUpperCase()+
        " / Nave: "+estante.estructura.pasillo.nave.nombre.toUpperCase()+
        " / Pasillo N° "+estante.estructura.pasillo.numeroPasillo+
        " / Estructura N° "+estante.estructura.identificadorEstructura+
        "\nCantidad de ubicaciones que posee la estantería: "+cantidades.totales+
        "\nLibres: "+cantidades.libres+
        "\nOcupadas: "+cantidades.ocupados+
        "\nSemi ocupadas: "+cantidades.semi+
        "\nPorcentaje libre: "+porcentaje+"%");
    }


    function eliminarEstante(estante){
      EstanteId.remove({id:estante.id}, function(data){
        ServicioDialogos.mostrarDialogoInformacion(null, "Se ha eliminado la estantería con éxito");
        EstanteEstructuraHastaUbicacion.query({id:$stateParams.estructura}).$promise.then(function(data) {
          vm.estantes = orderByFilter(data,'numeroEstante',false);
          vm.tableParams.settings({
            data: vm.estantes
          });
          vm.tableParams.reload();
        }, function(err){
          console.log(err);
        });
      }, function(error){
        console.log(error);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar la estantería");
      });
    }

    function eliminar(estante){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Desea eliminar la estantería N° "+estante.numeroEstante+"?",function(){
        EstanteHastaUbicacion.get({id:estante.id}, function(data){
          if (Util.contarNoBorrados(data.niveles)==0){
            eliminarEstante(estante);
          } else {
            ServicioDialogos.mostrarDialogoError(null, "No es posible eliminar la estantería porque posee estantes vigentes");
          }
        });
      },null,false);
    }


    function claseEstante(estante){
      var cantEstantes = Util.contarNoBorrados(vm.estructura.estantes);
      return {"width": parseInt(100/cantEstantes)+"%"};
    }

    function claseNivel(estante){
      var cantidadNiveles = Util.contarNoBorrados(estante.niveles);
      return {"height":355/cantidadNiveles+"px"};
    }

    function volver(){
      $state.go('home.lista-estructura-ubicaciones', {pasillo:vm.estructura.pasillo.id});
    }

    function verPlanoUbicaciones(nivel) {
      $state.go('home.lista-ubicaciones', {nivel:nivel.id});
    }

    function verPlanoNiveles(estante) {
      $state.go('home.lista-nivel-ubicaciones', {estante:estante.id});
    }

    function irVistaPasillo(){
      $state.go('home.lista-estructura-ubicaciones', {pasillo:vm.estructura.pasillo.id});
    }

    function irVistaNave(){
      $state.go('home.lista-pasillo-ubicaciones',{nave:vm.estructura.pasillo.nave.id});
    }

    function irVistaDeposito(){
      $state.go('home.lista-nave-ubicaciones', {deposito:vm.estructura.pasillo.nave.deposito.id});
    }


    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });
    vm.tableParams.settings({
      data: vm.estantes
    });
    vm.tableParams.reload();
    
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-estante-ubicaciones', {
        url: 'editar-estante-ubicaciones/:modo/:estructura/:objeto',
        templateUrl: 'app/app/main/ubicaciones/estante/editar/editar-estante-ubicaciones.html',
        controller: 'EditarEstanteUbicacionesCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Estanterías',
          subtituloEditar:'Editar Estantería',
          subtituloNuevo: 'Nueva Estantería',
          modo:null,
          objeto:null,
          estructura:null
        },
        resolve: {
          estructura: function($stateParams, EstructuraHastaEstante){
            return EstructuraHastaEstante.get({ id : $stateParams.estructura }).$promise;
          },
          estante: function($stateParams, EstanteHastaUbicacion){
            if ($stateParams.modo){
              return EstanteHastaUbicacion.get({id:$stateParams.objeto}).$promise;
            } else {
              return {};
            }
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarEstanteUbicacionesCtrl', EditarEstanteUbicacionesCtrl);

  /** @ngInject */
  function EditarEstanteUbicacionesCtrl(NgTableParams, HeaderBarService, estante, EstanteId, EstanteEstructuraTodosHastaNivel, estructura, orderByFilter, EstanteNumeroEstructuraHastaNivel, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    vm.cancelar = cancelar;
    vm.guardar = guardar;
    vm.estructura = estructura;
    inicializar();
    vm.modo = $stateParams.modo;

    function obtenerUltimoNumero(){
      var numeroNuevoNivel;
      EstanteEstructuraTodosHastaNivel.query({id:vm.estructura.id}).$promise.then(function(data) {
        vm.estante.numeroEstante = obtenerUltimo(data);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(error){
        console.log(error);
        ServicioDialogos.mostrarDialogoError(null, null);
      });
    }

    function obtenerUltimo(array){
      if (array.length>0) {
        var estantes = orderByFilter(array,'numeroEstante*1',true);
        return parseInt(estantes[0].numeroEstante)+1;
      } else {
        return 1;
      }

    }

    function inicializar(){
      setearTitulos();
      ServicioDialogos.abrirDialogoCargando();
      setearObjeto();
    }

    function setearObjeto(){
      vm.estante = estante;
      if (esEditar()) {
        vm.numeroEstante = vm.estante.numeroEstante;
      } else {
        obtenerUltimoNumero();
      }
    }

    function esEditar() {
      return $stateParams.modo=='editar';
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      if (esEditar()) {
        HeaderBarService.setSubTitulo($stateParams.subtituloEditar);
      } else {
        HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);
      }
    }

    function cancelar() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        $state.go('home.lista-estante-ubicaciones',{estructura:estructura.id});
      });
    }

    function guardar() {
      if (esEditar()) {
        editarObjeto();
      } else {
        nuevoObjeto();
      }
    }


    function nuevoObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea registrar una nueva estantería?', function(){
        comprobarNumero();
      }, null, false);
    }

    function editarObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar la estantería?', function(){
        if (vm.numeroEstante==vm.estante.numeroEstante) {
          editarNivel();
        } else {
          comprobarNumero();
        }
      },null,false);
    }

    function comprobarNumero(){
      if (vm.numeroEstante==vm.estante.numeroEstante) {
        guardarOEditar();
      } else {
        EstanteNumeroEstructuraHastaNivel.query({'numeroEstante':vm.estante.numeroEstante, id:vm.estructura.id}, function(data){
          if (data.length>0){
            ServicioDialogos.mostrarDialogoError(null, 'El número de estantería ingresado ya existe para esta estructura');
          } else {
            guardarOEditar();
          }
        }, function(err){
          console.log(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar la estantería");
        });
      }
    }


    function guardarOEditar(){
      if (esEditar()){
        editarNivel();
      } else {
        guardarNivel();
      }
    }

    function editarNivel(){
      EstanteId.update(vm.estante, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado la estantería correctamente', function(){
        $state.go('home.lista-estante-ubicaciones',{estructura:estructura.id});
        });
      }, function(err){
        console.error(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar la estantería");
      });
    }

    function guardarNivel(){
      vm.estante.estructura=vm.estructura;
      EstanteId.save(vm.estante, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha registrado la estantería correctamente', function(){
        $state.go('home.lista-estante-ubicaciones',{estructura:estructura.id});
        });
      }, function(error){
        console.error(error);
        ServicioDialogos.mostrarDialogoError(null, 'No se ha podido registrar la estantería');
      });
    }
     
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.cambiar-ubicacion-suministro', {
        url: 'cambiar-ubicacion-suministro/:suministro/:inventariable',
        templateUrl: 'app/app/main/ubicaciones/cambiar-ubicacion/cambiar-ubicacion-suministro/cambiar-ubicacion-suministro.html',
        controller: 'CambiarUbicacionSuministroCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar ubicaciones',
          subtitulo:'Cambiar ubicación a suministro'
        },
        resolve: {
          suministro: function($stateParams, Suministro, SuministroNoInventariable){
            if ($stateParams.inventariable=="true"){
              return Suministro.get({id:$stateParams.suministro}).$promise;
            } else {
              return SuministroNoInventariable.get({ id : $stateParams.suministro }).$promise;
            }
          },
          inventariable: function($stateParams){
            return $stateParams.inventariable=="true"? true : false;
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('CambiarUbicacionSuministroCtrl', CambiarUbicacionSuministroCtrl);

  /** @ngInject */
  function CambiarUbicacionSuministroCtrl(NgTableParams, HeaderBarService, $filter,  ServicioModales, $window, ReemplazarUbicacionSuministro, inventariable, suministro, $timeout, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.inventariable = inventariable;
    vm.suministro = suministro;
    vm.suministros = [];
    vm.volver = volver;
    vm.ubicacionCompleta = ubicacionCompleta;
    vm.comprobarSuministro = comprobarSuministro;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.mostrarInformacionSuministro = mostrarInformacionSuministro;
    vm.asignarIndividual = asignarIndividual;
    vm.actualizarUbicacion = actualizarUbicacion;
    vm.noUbicacion = false;
    vm.ocupar = false;

    inicializar();

    function inicializar(){
      inicializarTablas();
      vm.ubicacion = vm.inventariable? suministro.suministro.ubicacion : suministro.ubicacion;
      if (vm.ubicacion && vm.ubicacion.id){
        vm.deposito = vm.inventariable? suministro.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.deposito : suministro.ubicacion.nivel.estante.estructura.pasillo.nave.deposito;
      } else {
        vm.noUbicacion = true;
      }
    }

    function actualizarUbicacion(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(
        null,
        "¿Está seguro que desea guardar el ingreso?",
        function(){
          var sum = vm.inventariable? vm.suministro.suministro.id : vm.suministro.id;
          ReemplazarUbicacionSuministro.update({idSuministro: sum, idUbicacion: vm.nuevaUbicacion.id, ocupar: vm.ocupar}, function(data){
            ServicioDialogos.mostrarDialogoGuardadoExito(
              null,
              "Se ha actualizado la ubicación del suministro con éxito",
              function(){
                $window.location.reload();
              });
          }, function(err){
            console.log(err);
            ServicioDialogos.mostrarDialogoError();
          });
        },
        null,
        false
      );
    }

    function comprobarSuministro(){
      return (vm.suministro.id && ((inventariable && vm.suministro.suministro.ubicacion.id) || (!inventariable && vm.suministro.ubicacion)) && (vm.inventariable!==null || vm.inventariable!==undefined));
    }

    function ubicacionNaveNumeroOrden(ubicacion){
      if (ubicacion && ubicacion.nivel) {
        return "Nave: "+ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+ubicacion.numeroOrden;
      } else {
        return "El bien no posee una ubicación actual";
      }
    }

    function mostrarInformacionSuministro(){
      if (vm.inventariable){
        mostrarInformacionInventariable(vm.suministro);
      } else {
        mostrarInformacionNoInventariable(vm.suministro);
      }
    }

    function comprobarUbicacionElegida(ubicacion){
      if (ubicacion.id == vm.ubicacion.id){
        ServicioDialogos.mostrarDialogoError(null, "La ubicación elegida es la misma que la actual");
      } else {
        vm.nuevaUbicacion = ubicacion;
      }
    }

    function asignarIndividual(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalAsignarUbicacionIndividualCajas({
        onResult: function(resultado){
          comprobarUbicacionElegida(resultado.ubicacionAsignada);
        },
        deposito: vm.deposito,
        'detalle': vm.suministro
      });
    }

    function mostrarInformacionInventariable(bien){
      var marca = bien.suministro.marca? bien.suministro.marca.toUpperCase() : "-";
      var inventario = bien.inventario? bien.inventario : "-";
      var serie = bien.serie? bien.serie.toUpperCase() : "-";
      var nuevo = bien.nuevo? "SI" : "NO";
      var activo = bien.suministro.estadoSuministro.id == 2? "SI" : "NO";
      var precio = bien.suministro.precioUnitario ? bien.suministro.precioUnitario : "-";
      ServicioDialogos.mostrarDialogoInformacion(
        "Información del suministro",
        "Empresa: "+bien.suministro.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase()+
        "\nGrupo suministro: "+bien.suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+
        "\nFamilia de suministro: "+bien.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase()+
        "\nTipo de suministro: "+bien.suministro.tipoSuministro.nombre.toUpperCase()+
        "\nMarca: "+marca+
        "\nN° Inventario: "+inventario+
        "\nN° Serie: "+serie+
        "\nPrecio: $"+precio+
        "\n¿Nuevo?: "+nuevo
      );
    }

    function mostrarInformacionNoInventariable(bien){
      var marca = bien.marca? bien.marca.toUpperCase() : "-";
      var precio = bien.precioUnitario ? bien.precioUnitario : "-";
      var fecha = bien.fechaVencimiento? $filter('date')(bien.fechaVencimiento, "dd/MM/yyyy") : "-";
      ServicioDialogos.mostrarDialogoInformacion(
        "Información del suministro",
        "Empresa: "+bien.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase()+
        "\nGrupo suministro: "+bien.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+
        "\nFamilia de suministro: "+bien.tipoSuministro.familiaSuministro.nombre.toUpperCase()+
        "\nTipo de suministro: "+bien.tipoSuministro.nombre.toUpperCase()+
        "\nMarca: "+marca+
        "\nFecha vencimiento: "+fecha+
        "\nPrecio unitario: "+precio+
        "\nCantidad: "+bien.cantidad
      );
    }


    function ubicacionCompleta(ubicacion){
      ServicioDialogos.mostrarDialogoInformacion(
        "Ubicación N° "+ubicacion.numeroUbicacion+
        "\nNúmero de orden: "+ubicacion.numeroOrden,
        "\nDepósito: "+ubicacion.nivel.estante.estructura.pasillo.nave.deposito.nombre.toUpperCase()+
        "\nNave: "+ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo N° "+ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura N° "+ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería N° "+ubicacion.nivel.estante.numeroEstante+
        "\nEstante N° "+ubicacion.nivel.numeroNivel
      );
    }

    function volver(){
      return;
      //$state.go('home.lista-nivel-ubicaciones', {estante:vm.nivel.estante.id});
    }

    function inicializarTablas(){
      vm.suministros.push(vm.suministro);
      vm.tableParamsSuministro = new NgTableParams({
        page: 1,
        count: 10
      });
      vm.tableParamsSuministro.settings({
        data: vm.suministros,
        noPager: true,
        counts: []
      });
      vm.tableParamsSuministro.reload();
    }

    
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.cambiar-ubicacion-caja-cerrada', {
        url: 'cambiar-ubicacion-caja-cerrada',
        templateUrl: 'app/app/main/ubicaciones/cambiar-ubicacion/cambiar-ubicacion-caja-cerrada/cambiar-ubicacion-caja-cerrada.html',
        controller: 'CambiarUbicacionCajasCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar ubicaciones',
          subtitulo:'Reasignar ubicación a cajas cerradas'
        },
        resolve: {
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data){
              return data;
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          deposito: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return usuario.empleado.deposito;
              } else {
                return ;
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('CambiarUbicacionCajasCtrl', CambiarUbicacionCajasCtrl);

  /** @ngInject */
  function CambiarUbicacionCajasCtrl(NgTableParams, HeaderBarService, deposito, $q, focus, ReemplazarUbicacionSuministro, ServicioModales, SuministroInventariableTipoDeposito, SuministroTipoDeposito, SuministroEmpresaDepositoInventario, FamiliaSuministroGrupo, GrupoEmpresa, empresas, depositos, TipoSuministroFamilia, $stateParams, $window, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.depositos = orderByFilter(depositos,'nombre', false);
    vm.deposito=deposito;
    vm.empresas = orderByFilter(empresas,'nombre',false);
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.ubicacionCompleta = ubicacionCompleta;
    vm.abrirModalAgregarCajas = abrirModalAgregarCajas;
    vm.elegirOtraCaja = elegirOtraCaja;
    vm.asignarIndividual = asignarIndividual;
    vm.actualizarUbicacion = actualizarUbicacion;

    vm.detalles = [];
    vm.cajasAsignadas=[];
    vm.detallesInventariables = [];
    vm.ocupar = false;

    vm.detallesInventariablesAgrupados = [];

    function elegirOtraCaja(){
      vm.detalles = [];
      vm.cajasAsignadas = [];
      vm.detallesInventariablesAgrupados = [];
      cargarDetalles();
    }

    function comprobarUbicacionElegida(ubicacion){
      if (ubicacion.id == vm.ubicacion.id){
        ServicioDialogos.mostrarDialogoError(null, "La ubicación elegida es la misma que la actual");
      } else {
        vm.nuevaUbicacion = ubicacion;
      }
    }

    function asignarIndividual(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalAsignarUbicacionIndividualCajas({
        onResult: function(resultado){
          comprobarUbicacionElegida(resultado.ubicacionAsignada);
        },
        deposito: vm.deposito,
        'detalle': vm.detalles[0]
      });
    }

    function ubicacionCompleta(ubicacion){
      ServicioDialogos.mostrarDialogoInformacion(
        "Ubicación N° "+ubicacion.numeroUbicacion+
        "\nNúmero de orden: "+ubicacion.numeroOrden,
        "\nDepósito: "+ubicacion.nivel.estante.estructura.pasillo.nave.deposito.nombre.toUpperCase()+
        "\nNave: "+ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo N° "+ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura N° "+ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería N° "+ubicacion.nivel.estante.numeroEstante+
        "\nEstante N° "+ubicacion.nivel.numeroNivel
      );
    }

    function actualizarCajaCerrada(){
      var defer = $q.defer();
      var promise = defer.promise;
      vm.detalles.forEach(function(item){
        promise = promise.then(function(){
          return actualizarUbicacionSuministro(item.suministro.id).then(function(dat){
              defer.resolve(true);
            });
        });
      });
      defer.resolve(true);
      return promise;
    }

    function actualizarUbicacionSuministro(sum){
      var defer = $q.defer();
      var promise = defer.promise;
      ReemplazarUbicacionSuministro.update({idSuministro: sum, idUbicacion: vm.nuevaUbicacion.id, ocupar: vm.ocupar}, function(data){
        defer.resolve(data);
        return promise;
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        return $q.reject();
      });
      return promise;

    }

    function actualizarUbicacion(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(
        null,
        "¿Está seguro que desea actualizar la ubicación de la caja cerrada?",
        function(){
          actualizarCajaCerrada()
          .then(function(){
            ServicioDialogos.mostrarDialogoGuardadoExito(
              null,
              "Se ha actualizado la ubicación de la caja cerrada con éxito",
              function(){
                $window.location.reload();
              }
            );
          });
        },
        null,
        false
      );
    }

    function ubicacionNaveNumeroOrden(ubicacion){
      if (ubicacion && ubicacion.nivel) {
        return "Nave: "+ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+ubicacion.numeroOrden;
      } else {
        return "El bien no posee una ubicación actual";
      }
    }

    function cargarDetalles(){
      vm.detallesInventariables = [];
      vm.detalles.forEach(function(detalle){
        if (detalle.suministro.tipoSuministro.inventariable){
          vm.detallesInventariables.push(detalle);
        }
      });
      if (vm.detallesInventariables.length>0){
        armarDetallesInventariables();
      } else {
        actualizarTablaInventariables();
      }
    }

    function armarDetallesCajaAgrupados(){
      vm.detallesInventariablesAgrupados = [];
      vm.cajasAsignadas.forEach(function(numeroCaja){
        vm.detallesInventariablesAgrupados.push({numeroCaja:numeroCaja, tipoSuministro:null, precioTotal:0.0, cantidad:0, detalles:[], ubicacion:null});
      });
    }

    function armarDetallesInventariablesAgrupados(){
      vm.detallesInventariablesAgrupados.forEach(function(agrupado){
        vm.detallesInventariables.forEach(function(detalle){
          if (agrupado.numeroCaja===detalle.numeroCaja){
            agrupado.detalles.push({suministro:detalle.suministro, suministroInventariable:detalle.suministroInventariable, cantidad:detalle.cantidad});
            agrupado.cantidad = agrupado.cantidad + detalle.cantidad;
            agrupado.precioTotal = agrupado.precioTotal + detalle.suministro.precioUnitario;
            agrupado.ubicacion = detalle.suministro.ubicacion;
            agrupado.tipoSuministro = detalle.suministro.tipoSuministro;
          }
        });
      });
    }

    function armarDetallesInventariables(){
      armarDetallesCajaAgrupados();
      armarDetallesInventariablesAgrupados();
      actualizarTablaInventariables();
    }

    function agregarDetalles(detalles){
      detalles.forEach(function(det){
        vm.detalles.push(det);
      });
    }

    function abrirModalAgregarCajas(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalAgregarSuministroEgresoCajas({
        onResult: function(resultado) {
          agregarDetalles(resultado.detalles);
          vm.cajasAsignadas = resultado.cajasAsignadas;
          vm.ubicacion = resultado.detalles[0].suministro.ubicacion;
          cargarDetalles();
        },
        cajasAsignadas: [],
        empresa: vm.empresa,
        deposito: vm.deposito.id,
      });
    }


    function actualizarTablaInventariables(){
      vm.tableParamsInventariableAgrupado.settings({
        data: vm.detallesInventariablesAgrupados,
        noPager: true,
        counts: []
      });
      vm.tableParamsInventariableAgrupado.reload();
    }

    vm.tableParamsInventariableAgrupado = new NgTableParams({
      page: 1,
      count: 10,
      group:{
        tipoSuministro: 'desc'
      }
    });

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.buscar-suministro-cambiar-ubicacion', {
        url: 'buscar-suministro-cambiar-ubicacion',
        templateUrl: 'app/app/main/ubicaciones/cambiar-ubicacion/buscar-suministro-cambiar-ubicacion/buscar-suministro-cambiar-ubicacion.html',
        controller: 'ListaBuscarSuministroCambiarUbicacionCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar ubicaciones',
          subtitulo:'Búsqueda de suministros para cambiar ubicación'
        },
        resolve: {
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data){
              return data;
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          deposito: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return usuario.empleado.deposito;
              } else {
                return ;
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaBuscarSuministroCambiarUbicacionCtrl', ListaBuscarSuministroCambiarUbicacionCtrl);

  /** @ngInject */
  function ListaBuscarSuministroCambiarUbicacionCtrl(NgTableParams,deposito, HeaderBarService, focus, ServicioModales, SuministroInventariableTipoDeposito, SuministroTipoDeposito, SuministroEmpresaDepositoInventario, FamiliaSuministroGrupo, GrupoEmpresa, empresas, depositos, TipoSuministroFamilia, $stateParams, $window, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.depositos = orderByFilter(depositos,'nombre', false);
    vm.deposito = deposito;
    vm.empresas = orderByFilter(empresas,'nombre',false);
    vm.buscar = buscar;
    vm.cambioRadio = cambioRadio;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.ubicacionCompleta = ubicacionCompleta;
    vm.mostrarInformacion = mostrarInformacion;
    vm.verHistorial = verHistorial;
    vm.irACambiarUbicacionSuministro = irACambiarUbicacionSuministro;
    vm.radio = "etiqueta";
    vm.bandera=false;

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });

    function verHistorial(bien){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea ver el historial de este bien?', function(){
        $state.go('home.historico-suministro',{objeto:bien.id});
      });
    }


    function mostrarInformacion(bien){
      var marca = bien.suministro.marca? bien.suministro.marca.toUpperCase() : "-";
      var inventario = bien.inventario? bien.inventario : "-";
      var serie = bien.serie? bien.serie.toUpperCase() : "-";
      var nuevo = bien.nuevo? "SI" : "NO";
      var activo = bien.suministro.estadoSuministro.id == 2? "SI" : "NO";
      var precio = bien.suministro.precioUnitario ? bien.suministro.precioUnitario : "-";
      ServicioDialogos.mostrarDialogoInformacion(
        "Información del suministro",
        "Empresa: "+bien.suministro.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase()+
        "\nGrupo suministro: "+bien.suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+
        "\nFamilia de suministro: "+bien.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase()+
        "\nTipo de suministro: "+bien.suministro.tipoSuministro.nombre.toUpperCase()+
        "\nMarca: "+marca+
        "\nN° Inventario: "+inventario+
        "\nN° Serie: "+serie+
        "\nPrecio: "+precio+
        "\n¿Nuevo?: "+nuevo+
        "\n¿Activo?: "+activo
      );
    }
    function cambioRadio(){
      vm.bandera=false;
      if (vm.radio=="etiqueta"){
        if (vm.empresa1 && vm.empresa1.id) vm.empresa1=null;
      } else {
        if (vm.empresa && vm.empresa.id) vm.empresa=null;
        vm.etiqueta=null;
      }
    }
    

    function actualizarTabla(data){
      vm.bandera=true;
      vm.suministros = data;
      vm.tableParams.settings({
        data: vm.suministros
      });
      vm.tableParams.reload();
    }

    function buscar(){
      if (vm.radio=="etiqueta"){
        ServicioDialogos.abrirDialogoCargando();
        SuministroEmpresaDepositoInventario.query({idEmpresa:vm.empresa.id, inventario:vm.etiqueta,idDeposito:vm.deposito.id},function(data){
          vm.suministros = data;
          actualizarTabla(vm.suministros);
          ServicioDialogos.cerrarDialogoCargando();
        }, function(err){
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError(null, "No se puede buscar los suministros");
        });
      } else if (vm.radio=="tipo"){
        buscarPorTipo();
      } else {
        ServicioDialogos.mostrarDialogoError(null, "No se puede buscar");
      }
    }

    function ubicacionNaveNumeroOrden(detalle){
      if (detalle.suministro && detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        return "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+detalle.suministro.ubicacion.numeroOrden;
      } else {
        return "El bien no posee una ubicación actual";
      }
    }

    function ubicacionCompleta(detalle){
      if (detalle.suministro && detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación",
        "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+detalle.suministro.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+detalle.suministro.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+detalle.suministro.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+detalle.suministro.ubicacion.numeroUbicacion+
        "\nN° de orden: "+detalle.suministro.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+detalle.suministro.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+detalle.suministro.ubicacion.categoriaPeso.nombre.toUpperCase());
      }
    }


    function buscarTipoNoInventariable(){
      SuministroTipoDeposito.query({idTipo:vm.tipoSuministro.id, idDeposito:vm.deposito.id},function(data){
        vm.suministros = formatearSuministros(data);
        actualizarTabla(vm.suministros);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError(null, "No se puede buscar los suministros");
      });
    }

    function buscarTipoInventariable(){
      SuministroInventariableTipoDeposito.query({idTipo:vm.tipoSuministro.id, idDeposito:vm.deposito.id},function(data){
        vm.suministros = data;
        actualizarTabla(vm.suministros);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError(null, "No se puede buscar los suministros");
      });
    }

    function formatearSuministros(noInventariables){
      var suministros = [];
      noInventariables.forEach(function(noInv){
        var suministro = {};
        suministro.suministro = noInv;
        suministro.serie = "-";
        suministro.inventario = "-";
        suministro.nuevo = "-";
        suministros.push(suministro);
      });
      return suministros;
    }

    function abrirModal(sum, inv){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalCambiarUbicacionSuministro({
        onResult: function(resultado){
          $window.location.reload();
        },
        inventariable: inv,
        suministro: sum
      });
    }

    function irACambiarUbicacionSuministro(suministro){
      if (suministro.id){
        if (suministro.caja){
          ServicioDialogos.mostrarDialogoInformacion(null, "El suministro elegido, pertenece a una caja cerrada.\nPara mover una caja cerrada entera, vaya al módulo destinado a tal fin");
        } else {
          abrirModal(suministro.id, true);
          //$state.go("home.cambiar-ubicacion-suministro",{suministro:suministro.id, inventariable:true});
        }
      } else {
        abrirModal(suministro.suministro.id, false);
        //$state.go("home.cambiar-ubicacion-suministro", {suministro:suministro.suministro.id, inventariable:false});
      }
    }

    function buscarPorTipo(){
      ServicioDialogos.abrirDialogoCargando();
      if (vm.tipoSuministro.inventariable){
        buscarTipoInventariable();
      } else {
        buscarTipoNoInventariable();
      }
    }


    $scope.$watch('vm.empresa1.nombre', function(){
      if (vm.grupoSuministro && vm.grupoSuministro.id) vm.grupoSuministro=null;
      if (vm.familiaSuministro && vm.familiaSuministro.id) vm.familiaSuministro=null;
      if (vm.tipoSuministro && vm.tipoSuministro.id) vm.tipoSuministro=null;
      if (!vm.empresa1) return;
      ServicioDialogos.abrirDialogoCargando();
      GrupoEmpresa.query({id:vm.empresa1.id}, function(data) {
        vm.grupos = orderByFilter(data,'nombre',false);
        focus('grupoSuministro');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.grupoSuministro.nombre', function(){
      if (vm.familiaSuministro && vm.familiaSuministro.id) vm.familiaSuministro=null;
      if (vm.tipoSuministro &&vm.tipoSuministro.id) vm.tipoSuministro=null;
      if (!vm.grupoSuministro) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupoSuministro.id}, function(data){
        vm.familias = orderByFilter(data,'nombre',false);
        focus('familiaSuministro');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.familiaSuministro.nombre', function(){
      if (vm.tipoSuministro && vm.tipoSuministro.id) vm.tipoSuministro=null;
      if (!vm.familiaSuministro) return;
      ServicioDialogos.abrirDialogoCargando();
      TipoSuministroFamilia.query({id:vm.familiaSuministro.id}, function(data){
        vm.tipos = orderByFilter(data,'nombre',false);
        focus('tipoSuministro');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-tipo-suministro', {
        url: 'lista-tipo-suministro',
        templateUrl: 'app/app/main/suministro/tipo-suministro/lista/lista-tipo-suministro.html',
        controller: 'ListaTipoSuministroCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Tipo de suministro',
          subtitulo:'Lista de Tipo de suministro'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          grupos: function(GrupoSuministro){
            return GrupoSuministro.query().$promise.then(function(data) {
              return data;
            });
          },
          tipos: function(TipoSuministro){
            return TipoSuministro.query().$promise.then(function(data) {
              return data;
            });
          },
          categorias: function(CategoriasPeso){
            return CategoriasPeso.query().$promise.then(function(data){
              return data;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaTipoSuministroCtrl', ListaTipoSuministroCtrl);

  /** @ngInject */
  function ListaTipoSuministroCtrl(NgTableParams, URL_SERVIDOR, $filter, TipoSuministroPrecio, SuministroInventariableContarStockTipoEstado, SuministroContarStockTipoEstado, StockTipoSuministroDeposito, rol, $http, HeaderBarService, focus, FamiliaSuministroGrupo, TipoSuministro, categorias, tipos, grupos, TipoSuministroFamilia, $stateParams, $scope, $q, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.tipos = orderByFilter(tipos,'nombre',false);
    vm.mostrarInformacion = mostrarInformacion;
    vm.crearNuevo = crearNuevo;
    vm.editar = editar;
    vm.exportToExcel = exportToExcel;
    vm.eliminar = eliminar;
    vm.grupos = orderByFilter(grupos,'nombre',false);
    vm.categorias = orderByFilter(categorias,'nombre',false);
    vm.filtrar = filtrar;
    vm.busqueda = busqueda;
    vm.bandera = false;
    vm.reportePdf = reportePdf;
    vm.bloquearPorRol = bloquearPorRol;

    var arrayExcel = [];

    function bloquearPorRol(){
      return (rol.id!=1 && rol.id!=2);
    }
    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");


    function reportePdf(){
      var Url = URL_SERVIDOR+"/tiposuministro/reporte";
      ServicioDialogos.abrirDialogoCargando();
       
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });
    vm.tableParams.settings({
      data: orderByFilter(vm.tipos,['familiaSuministro.grupoSuministro.empresa.nombre','familiaSuministro.grupoSuministro.nombre','familiaSuministro.nombre','nombre'],false)
    });
    vm.tableParams.reload();

    $scope.$watch('vm.grupo.nombre', function(){
      if (!vm.grupo) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupo.id}, function(data){
        vm.familias = data;
        focus('familiaSuministro');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });
    
    function busqueda(){
      if (vm.familiaSuministro) vm.familiaSuministro=null;
      if (vm.grupo) vm.grupo=null;
      vm.bandera=false;

      if (vm.buscar) {
        vm.tipos=null;
        actualizarTabla(vm.tipos);
      } else {
        filtrar();
      }
    }

    function actualizarTabla(data){
      vm.tipos = orderByFilter(data,['familiaSuministro.grupoSuministro.empresa.nombre','familiaSuministro.grupoSuministro.nombre','familiaSuministro.nombre','nombre'],false);
      vm.tableParams.settings({
        data: vm.tipos
      });
      vm.tableParams.reload();
    }

    function filtrarPorFamilia(){
      TipoSuministroFamilia.query({id:vm.familiaSuministro.id},function(data){
        ServicioDialogos.cerrarDialogoCargando();
        if (data.length==0) {
          vm.bandera=true;
        }
        actualizarTabla(data);
      }, function(err){
        console.error(err);
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function filtrar(){
      vm.bandera=true;
      ServicioDialogos.abrirDialogoCargando();
      if (vm.familiaSuministro && typeof vm.familiaSuministro !== "string") {
        filtrarPorFamilia();
      } else {
        if (vm.familiaSuministro==undefined){
          TipoSuministro.query(function(data){
            ServicioDialogos.cerrarDialogoCargando();
            actualizarTabla(data);
          }, function(err){
            console.error(err);
            ServicioDialogos.cerrarDialogoCargando();
          });
        } else {
          actualizarTabla(undefined);
        }
      }
    }

    function obtenerCantidad(tipo){
      var defer = $q.defer();
      var promise = defer.promise;
      var respuesta = {};
      if (tipo.inventariable){
        SuministroInventariableContarStockTipoEstado.query({idTipo:tipo.id, idEstado:2}, function(datos){
          TipoSuministroPrecio.query({idTipo:tipo.id}, function(precio){
            respuesta.cantidad = datos[0];
            respuesta.precio = null;
            if (precio){
              respuesta.precio = precio[0];
            }
            defer.resolve(respuesta);
            return promise;
          });
          //vm.cantidadTotalStockTipo = datos[0];
        });

      } else {
        SuministroContarStockTipoEstado.query({idTipo:tipo.id, idEstado:2}, function(datos){
          TipoSuministroPrecio.query({idTipo:tipo.id}, function(precio){
            respuesta.cantidad = datos[0];
            respuesta.precio = null;
            if (precio){
              respuesta.precio = precio[0];
            }
            defer.resolve(respuesta);
            return promise;
          });
        });
      }
      return promise;
    }

    function mostrarInformacion(tipo) {
      ServicioDialogos.abrirDialogoCargando();
      obtenerCantidad(tipo)
      .then(function(respuesta){
        ServicioDialogos.cerrarDialogoCargando();
        vm.foto=tipo.encabezadoFoto+tipo.cuerpoFoto;
        var stock = tipo.stockMinimo? tipo.stockMinimo : '-';
        var volumen = tipo.volumenUnidad? tipo.volumenUnidad + ' m³' : '-';
        var periodo = tipo.tipoTope? tipo.tipoTope.periodo : "-";
        var inventariable = tipo.inventariable? "SI" : "NO";
        var solicitable = tipo.solicitable? "SI" : "NO";
        ServicioDialogos.mostrarDialogoInformacionConHtml(tipo.nombre.toUpperCase(),
            '<div class="marco-imagenes">'+
              '<img src="'+vm.foto+'" />'+
            '</div>'+
          '<div>'+
            '<b>'+tipo.nombre.toUpperCase()+'</b>'+
            '<br>Empresa: <b>' + tipo.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase() +'</b>'+
            '<br>Grupo de suministro: <b>' + tipo.familiaSuministro.grupoSuministro.nombre.toUpperCase() +'</b>'+
            '<br>Familia de suministro: <b>' + tipo.familiaSuministro.nombre.toUpperCase() +'</b>'+
            '<br>Inventariable: <b>' + inventariable +'</b>'+
            '<br>Solicitable: <b>' + solicitable +'</b>'+
            '<br>Categoría de peso: <b>' + tipo.categoriaPeso.nombre.toUpperCase() +'</b>'+
            '<br>Peso estimado unitario: <b>' + tipo.pesoEstimado + ' Kg.' +'</b>'+
            '<br>Código de Tipo suministro: <b>' + tipo.codigoProducto+'</b>'+
            '<br>Stock mínimo: <b>' +  stock +'</b>'+
            '<br>Periodicidad tope: <b>' +  periodo +'</b>'+
            '<br>Stock actual en todos los depósitos: <b>'+respuesta.cantidad+'</b>'+
          '</div>');
      });

    }

    function editar(tipo) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el suministro?', function() {
        $state.go('home.editar-tipo-suministro', {objeto:tipo.id, modo:'editar'});
      });
    }

    function crearNuevo() {
      $state.go('home.editar-tipo-suministro');
    }

    function eliminar(tipo){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Desea eliminar el suministro: \n"+tipo.nombre.toUpperCase()+"?",function(){
        TipoSuministro.remove({id:tipo.id}, function(data){
          ServicioDialogos.mostrarDialogoInformacion(null, "Se ha eliminado el suministro con éxito");
          TipoSuministro.query().$promise.then(function(data){
            actualizarTabla(data);
          }, function(err){
            console.log(err);
          });
        }, function(error){
          console.log(error);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar el suministro");
        });
      },null,false);
    }

    function exportToExcel(){
      arrayExcel = [];
      ServicioDialogos.abrirDialogoCargando();
      obtenerArrayExcel().then(function(data){
        arrayExcel = $filter('orderBy')(arrayExcel, [0,1,2,4], false);
        var nombreDocumento = vm.familiaSuministro ? "suministros-"+vm.familiaSuministro.nombre.toUpperCase() : "suministros";
        alasql('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true}) FROM ?',[arrayExcel]);
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function obtenerArrayExcel(){
      var promesas = [];
      vm.tipos.forEach(function(tipo){
        var defered = $q.defer();
        promesas.push(defered.promise);
        obtenerCantidad(tipo)
        .then(function(respuesta){
          arrayExcel = obtenerTipoArray(arrayExcel, tipo, respuesta);
          defered.resolve(true);
        }, function(err){
          return $q.reject();
        });
      });
      return $q.all(promesas);
    }

    function obtenerTipoArray(array, tipo, respuesta){
      var precio = respuesta.precio? respuesta.precio : tipo.precioActual;
      var stock = tipo.stockMinimo? tipo.stockMinimo : '-';
      var volumen = tipo.volumenUnidad? tipo.volumenUnidad + ' m³' : '-';
      array.push({
        "Empresa" : tipo.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase(),
        "Grupo de suministro" : tipo.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
        "Familia de suministro" : tipo.familiaSuministro.nombre.toUpperCase(),
        "Código de familia" : tipo.familiaSuministro.codigoFamiliaSuministro.toUpperCase(),
        "Tipo de suministro" : tipo.nombre.toUpperCase(),
        "Código de Tipo suministro" : tipo.codigoProducto.toUpperCase(),
        "Categoría de peso" : tipo.categoriaPeso.nombre.toUpperCase(),
        "Peso estimado" : tipo.pesoEstimado+' Kg.',
        "Volumen unitario" : volumen,
        "Stock mínimo" :  stock,
        "Precio actual" : "$"+precio,
        "Stock actual" : respuesta.cantidad,
      });
      return array;
    }

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-tipo-suministro', {
        url: 'editar-tipo-suministro/:objeto/:modo',
        templateUrl: 'app/app/main/suministro/tipo-suministro/editar/editar-tipo-suministro.html',
        controller: 'EditarTipoSuministroCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Tipo de suministro',
          subtituloEditar:'Editar Tipo de suministro',
          subtituloNuevo: 'Nuevo Tipo de suministro',
          modo:null,
          objeto:null
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          grupos: function(GrupoSuministro){
            return GrupoSuministro.query().$promise.then(function(data) {
              return data;
            });
          },
          categorias: function(CategoriasPeso){
            return CategoriasPeso.query().$promise.then(function(data){
              return data;
            });
          },
          tiposTope: function($timeout){
            return $timeout(function() {
              return [{id:1, borrado: false, periodo: 'ANUAL'},{id:2, borrado: false, periodo:'SEMESTRAL'},{id:3, borrado:false,periodo:'BIMESTRAL'}];
            }, 1000);
          },
          tipo: function(TipoSuministro, $stateParams){
            if ($stateParams.objeto){
              return TipoSuministro.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return {};
            }
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarTipoSuministroCtrl', EditarTipoSuministroCtrl);

  /** @ngInject */
  function EditarTipoSuministroCtrl(NgTableParams, rol, tiposTope, HeaderBarService, focus, ServicioModales, tipo, orderByFilter, categorias, grupos, FamiliaSuministroGrupo, TipoSuministroNombreFamilia, TipoSuministro, TipoSuministroCodigoFamilia, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    inicializar();
    vm.cancelar = cancelar;
    vm.guardar = guardar;
    vm.tiposTope = tiposTope;
    vm.grupos = orderByFilter(grupos,'nombre', false);
    vm.categorias = orderByFilter(categorias, 'nombre', false);
    vm.cambioGrupo = cambioGrupo;
    vm.abrirSeleccionFoto = abrirSeleccionFoto;
    vm.quitarFoto = quitarFoto;

    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");

    function quitarFoto(){
        vm.foto=null;
        vm.tipo.encabezadoFoto = null;
        vm.tipo.cuerpoFoto = null;
    }

    function cambioGrupo(){
      if (vm.tipo) {
        vm.tipo.familiaSuministro = null;
      }
    }

    function abrirSeleccionFoto(){
      ServicioModales.abrirModalSeleccionarFoto({
        onResult: function(res) {
          //console.log(res);
          vm.tipo.encabezadoFoto = res.encabezadoFoto;
          vm.tipo.cuerpoFoto = res.cuerpoFoto;
          vm.foto = vm.tipo.encabezadoFoto + vm.tipo.cuerpoFoto;
        },
      });
    }

    $scope.$watch('vm.grupo.nombre', function(){
      if (!vm.grupo) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupo.id}, function(data){
        vm.familias = data;
        focus('familiaSuministro');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    function inicializar(){
      setearTitulos();
      setearObjeto();
      vm.modo=$stateParams.modo;
    }

    function setearObjeto(){
      if (esEditar()) {
        vm.tipo = tipo;
        vm.nombre = vm.tipo.nombre;
        vm.familia = vm.tipo.familiaSuministro;
        vm.foto = vm.tipo.encabezadoFoto + vm.tipo.cuerpoFoto;
        //console.log(vm.tipo);
        vm.codigo = vm.tipo.codigoProducto;
        vm.grupo = vm.tipo.familiaSuministro.grupoSuministro;
      }
    }

    function esEditar() {
      return $stateParams.modo=='editar';
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      if (esEditar()) {
        HeaderBarService.setSubTitulo($stateParams.subtituloEditar);
      } else {
        HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);
      }
    }

    function cancelar() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        $state.go('home.lista-tipo-suministro');
      });
    }

    function guardar() {
      if (esEditar()) {
        editarObjeto();
      } else {
        nuevoObjeto();
      }
    }


    function nuevoObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea registrar un nuevo tipo de suministro?', function(){
        comprobarNombreTipoSuministro();
      }, null, false);
    }

    function editarObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el tipo de suministro?', function(){
        if (vm.nombre==vm.tipo.nombre && vm.familia.id==vm.tipo.familiaSuministro.id && vm.grupo.id == vm.tipo.familiaSuministro.grupoSuministro.id){
          if (vm.codigo==vm.tipo.codigoProducto) {
            editarTipoSuministro();
          } else {
            comprobarCodigoProducto();
          }
        } else {
          comprobarNombreTipoSuministro();
        }
      },null,false);
    }

    function comprobarCodigoProducto(){
      if (vm.codigo==vm.tipo.codigoProducto && vm.familia.id==vm.tipo.familiaSuministro.id) {
        guardarOEditar();
      } else {
        TipoSuministroCodigoFamilia.query({codigo:vm.tipo.codigoProducto, idFamilia:vm.tipo.familiaSuministro.id}, function(data){
          if (data.length>0){
            ServicioDialogos.mostrarDialogoError(null, 'El código de producto ingresado ya existe en la familia de suministro seleccionada');
          } else {
            guardarOEditar();
          }
        }, function(err){
          console.log(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar el tipo de suministro");
        });
      }
    }


    function comprobarNombreTipoSuministro(){
      TipoSuministroNombreFamilia.query({nombre:vm.tipo.nombre, id:vm.tipo.familiaSuministro.id},function(data){
        if (data.length>0){
          ServicioDialogos.mostrarDialogoError(null, 'El nombre ingresado ya existe en la familia de suministro seleccionada');
        } else {
          comprobarCodigoProducto();
        }
      }, function(err){
        console.error(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar el tipo de suministro");
      });
    }

    function guardarOEditar(){
      if (esEditar()){
        editarTipoSuministro();
      } else {
        guardarTipoSuministro();
      }
    }

    function editarTipoSuministro(){
      TipoSuministro.update(vm.tipo, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado el tipo de suministro correctamente', function(){
          $state.go('home.lista-tipo-suministro');
        });
      }, function(err){
        console.error(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar el tipo de suministro");
      });
    }

    function guardarTipoSuministro(){
      TipoSuministro.save(vm.tipo, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha registrado el tipo de suministro correctamente', function(){
          $state.go('home.lista-tipo-suministro');
        });
      }, function(error){
        console.error(error);
        ServicioDialogos.mostrarDialogoError(null, 'No se ha podido registrar el tipo de suministro');
      });
    }
     
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-suministro', {
        url: 'editar-suministro/:objeto/:modo/:familia',
        templateUrl: 'app/app/main/suministro/suministro/editar/editar-suministro.html',
        controller: 'EditarSuministroCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar suministros',
          subtituloEditar:'Editar suministro',
          subtituloNuevo: 'Nuevo suministro',
          modo:null,
          objeto:null,
          familia:null
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data) {
              return data;
            });
          },
          estadoSuministro: function(EstadoSuministro){
            return EstadoSuministro.get({id:1}).$promise.then(function(data) {
              return data;
            });
          },
          tipos: function(TipoSuministroFamiliaInventariable, $stateParams){
            if ($stateParams.objeto){
              var idFamilia = $stateParams.familia;
              return TipoSuministroFamiliaInventariable.query({idFamilia:idFamilia, inventariable:true}).$promise.then(function(data){
                return data;
              });
            } else {
              return null;
            }
          },
          suministro: function(Suministro, $stateParams){
            if ($stateParams.objeto){
              return Suministro.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return {suministro:{}};
            }
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarSuministroCtrl', EditarSuministroCtrl);

  /** @ngInject */
  function EditarSuministroCtrl(NgTableParams, rol, HeaderBarService, SucursalEmpresa, suministro, focus, tipos, estadoSuministro, orderByFilter, empresas, GrupoEmpresa, FamiliaSuministroGrupo, TipoSuministroFamiliaInventariable, Suministro, SuministroInventarioEmpresa, SuministroTipoSerie, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    vm.suministro = suministro;
    inicializar();
    vm.cancelar = cancelar;
    vm.guardar = guardar;
    vm.empresas = orderByFilter(empresas,'nombre', false);
    vm.modo = $stateParams.modo;

    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");


    function inicializar(){
      setearTitulos();
      setearObjeto();
    }

    function setearObjeto(){
      if (esEditar()){
        vm.tipos = tipos;
        vm.empresaMayus = vm.suministro.suministro.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase();
        vm.grupoMayus = vm.suministro.suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase();
        vm.familiaMayus = vm.suministro.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase();
        vm.serie = vm.suministro.serie;
        vm.inventario = vm.suministro.inventario;
        vm.tipoSuministro = vm.suministro.suministro.tipoSuministro;
      }
    }

    function esEditar() {
      return $stateParams.modo=='editar';
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      if (esEditar()) {
        HeaderBarService.setSubTitulo($stateParams.subtituloEditar);
      } else {
        HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);
      }
    }

     $scope.$watch('vm.empresa.nombre', function(){
      if (!vm.form.$dirty) {
        return;
      }
      if (vm.suministro && vm.suministro.sucursal && vm.suministro.sucursal.id) vm.suministro.sucursal = null;
      if (vm.grupoSuministro && vm.grupoSuministro.id) vm.grupoSuministro=null;
      if (vm.familiaSuministro && vm.familiaSuministro.id) vm.familiaSuministro=null;
      if (vm.suministro.suministro.tipoSuministro && vm.suministro.suministro.tipoSuministro.id) vm.suministro.suministro.tipoSuministro=null;
      if (!vm.empresa) return;
      ServicioDialogos.abrirDialogoCargando();
      GrupoEmpresa.query({id:vm.empresa.id}, function(data) {
        SucursalEmpresa.query({id:vm.empresa.id}, function(sucs){
          vm.sucursales = orderByFilter(sucs, "nombre", false);
          vm.grupos = orderByFilter(data, "nombre", false);
          focus('grupoSuministro');
          ServicioDialogos.cerrarDialogoCargando();
        }, function(err){
          console.log(err);
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError();
        });
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.grupoSuministro.nombre', function(){
      if (!vm.form.$dirty) {
        return;
      }
      if (vm.familiaSuministro && vm.familiaSuministro.id) vm.familiaSuministro=null;
      if (vm.suministro.suministro.tipoSuministro && vm.suministro.suministro.tipoSuministro.id) vm.suministro.suministro.tipoSuministro=null;
      if (!vm.grupoSuministro) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupoSuministro.id}, function(data){
        vm.familias = orderByFilter(data, "nombre", false);
        focus('familiaSuministro');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.familiaSuministro.nombre', function(){
      if (!vm.form.$dirty) {
        vm.form.$setDirty();
        vm.tipos = tipos;
        return;
      }
      if (vm.suministro.suministro.tipoSuministro && vm.suministro.suministro.tipoSuministro.id) vm.suministro.suministro.tipoSuministro=null;
      if (!vm.familiaSuministro) return;
      ServicioDialogos.abrirDialogoCargando();
      TipoSuministroFamiliaInventariable.query({idFamilia:vm.familiaSuministro.id, inventariable:true}, function(data){
        vm.tipos = orderByFilter(data, "nombre", false);
        focus('tipoSuministro');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });


    function cancelar() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        $state.go('home.lista-suministro');
      });
    }

    function guardar() {
      if (esEditar()) {
        editarObjeto();
      } else {
        nuevoObjeto();
      }
    }


    function nuevoObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea registrar un nuevo suministro?', function(){
        comprobarInventario();
      }, null, false);
    }

    function editarObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el suministro?', function(){
        if (vm.inventario==vm.suministro.inventario){
          if (vm.serie==vm.suministro.serie && vm.tipoSuministro.nombre==vm.suministro.suministro.tipoSuministro.nombre) {
            editarSuministro();
          } else {
            comprobarSerie();
          }
        } else {
          comprobarInventario();
        }
      },null,false);
    }

    function comprobarSerie(){
      if (vm.serie==vm.suministro.serie) {
        guardarOEditar();
      } else {
        SuministroTipoSerie.query({idTipo:vm.suministro.suministro.tipoSuministro.id, serie:vm.suministro.serie}, function(data){
          if (data.length>0){
            ServicioDialogos.mostrarDialogoConfirmacionWarning(null, 'El número de serie ingresado ya existe en el tipo de suministro seleccionado. ¿Está seguro que desea continuar de todos modos?', function(){
              guardarOEditar();
            }, null, false);
          } else {
            guardarOEditar();
          }
        }, function(err){
          console.log(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar el tipo de suministro");
        });
      }
    }


    function comprobarInventario(){
      SuministroInventarioEmpresa.query({inventario:vm.suministro.inventario, idEmpresa:vm.suministro.suministro.tipoSuministro.familiaSuministro.grupoSuministro.empresa.id},function(data){
        if (data.length>0){
          ServicioDialogos.mostrarDialogoError(null, 'El número de inventario ingresado ya existe en la empresa seleccionada');
        } else {
          comprobarSerie();
        }
      }, function(err){
        console.error(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar el suministro");
      });
    }

    function guardarOEditar(){
      if (esEditar()){
        editarSuministro();
      } else {
        guardarSuministro();
      }
    }

    function editarSuministro(){
      Suministro.update(vm.suministro, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado el suministro correctamente', function(){
          $state.go('home.lista-suministro');
        });
      }, function(err){
        console.error(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar el tipo de suministro");
      });
    }

    function guardarSuministro(){
      vm.suministro.suministro.estadoSuministro = estadoSuministro;
      vm.suministro.suministro.cantidad = 1;
      Suministro.save(vm.suministro, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha registrado el suministro correctamente', function(){
          $state.go('home.lista-suministro');
        });
      }, function(error){
        console.error(error);
        ServicioDialogos.mostrarDialogoError(null, 'No se ha podido registrar el suministro');
      });
    }
     
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-suministro', {
        url: 'lista-suministro',
        templateUrl: 'app/app/main/suministro/suministro/lista/lista-suministro.html',
        controller: 'ListaSuministroCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar suministros',
          subtitulo:'Búsqueda de suministros'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data){
              return data;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaSuministroCtrl', ListaSuministroCtrl);

  /** @ngInject */
  function ListaSuministroCtrl(NgTableParams, rol, HeaderBarService, focus, ServicioModales, SuministroTipoSerie, SuministroFamiliaSerie, SuministroEmpresaInventario, FamiliaSuministroGrupo, GrupoEmpresa, empresas, TipoSuministroFamiliaInventariable, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.crearNuevo = crearNuevo;
    vm.editar = editar;
    vm.empresas = orderByFilter(empresas,'nombre',false);
    vm.buscar = buscar;
    vm.cambioRadio = cambioRadio;
    vm.mostrarInformacion = mostrarInformacion;
    vm.verHistorial = verHistorial;
    vm.cargarDesdeExcel = cargarDesdeExcel;
    vm.radio = "etiqueta";
    vm.bandera=false;

    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");
    
    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });

    function cargarDesdeExcel(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalCargarInventariablesExcel({
        onResult: function(resultado) {
        }
      });

    }

    function verHistorial(bien){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea ver el historial de este bien?', function(){
        $state.go('home.historico-suministro',{objeto:bien.id});
      });
    }


    function mostrarInformacion(bien){
      var marca = bien.suministro.marca? bien.suministro.marca.toUpperCase() : "-";
      var inventario = bien.inventario? bien.inventario : "-";
      var serie = bien.serie? bien.serie.toUpperCase() : "-";
      var nuevo = bien.nuevo? "SI" : "NO";
      var activo = bien.suministro.estadoSuministro.id == 2? "SI" : "NO";
      var sucursal = bien.sucursal ? bien.sucursal.nombre.toUpperCase() : "-";
      var precio = bien.suministro.precioUnitario ? bien.suministro.precioUnitario : "-";
      var ubicacion = bien.suministro.ubicacion?
        "Depósito: "+bien.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.deposito.nombre.toUpperCase()+
        " - Nave: "+bien.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        " - Pasillo: "+bien.suministro.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        " - Estructura: "+bien.suministro.ubicacion.nivel.estante.estructura.identificadorEstructura+
        " - Estantería: "+bien.suministro.ubicacion.nivel.estante.numeroEstante+
        " - Estante: "+bien.suministro.ubicacion.nivel.numeroNivel+
        " - Ubicación: "+bien.suministro.ubicacion.numeroUbicacion: "-";
      ServicioDialogos.mostrarDialogoInformacion(
        "Información del suministro",
        "Empresa: "+bien.suministro.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase()+
        "\nGrupo suministro: "+bien.suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+
        "\nFamilia de suministro: "+bien.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase()+
        "\nTipo de suministro: "+bien.suministro.tipoSuministro.nombre.toUpperCase()+
        "\nMarca: "+marca+
        "\nN° Inventario: "+inventario+
        "\nN° Serie: "+serie+
        "\nSucursal anterior: "+sucursal+
        "\nPrecio: "+precio+
        "\n¿Nuevo?: "+nuevo+
        "\n¿Activo?: "+activo+
        "\n\nUbicación: "+ubicacion
      );
    }
    
    function cambioRadio(){
      vm.bandera=false;
      if (vm.radio=="etiqueta"){
        if (vm.empresa1 && vm.empresa1.id) vm.empresa1=null;
        if (vm.empresa2 && vm.empresa2.id) vm.empresa2=null;
        vm.serie=null;
        vm.serieParcial = null;
      } else if (vm.radio=="serie"){
        if (vm.empresa && vm.empresa.id) vm.empresa=null;
        if (vm.empresa2 && vm.empresa2.id) vm.empresa2=null;
        vm.etiqueta=null;
        vm.serieParcial = null;
      } else {
        if (vm.empresa1 && vm.empresa1.id) vm.empresa1=null;
        if (vm.empresa && vm.empresa.id) vm.empresa=null;
        vm.serie=null;
        vm.etiqueta=null;
      }
    }
    

    function actualizarTabla(data){
      vm.bandera=true;
      vm.suministros = orderByFilter(data,'inventario',false);
      vm.tableParams.settings({
        data: vm.suministros
      });
      vm.tableParams.reload();
    }

    function buscar(){
      if (vm.radio=="etiqueta"){
        ServicioDialogos.abrirDialogoCargando();
        SuministroEmpresaInventario.query({idEmpresa:vm.empresa.id, inventario:vm.etiqueta,inventariable:true},function(data){
          vm.suministros = data;
          actualizarTabla(vm.suministros);
          ServicioDialogos.cerrarDialogoCargando();
        }, function(err){
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError(null, "No se puede buscar los suministros");
        });
      } else if (vm.radio=="serie"){
        ServicioDialogos.abrirDialogoCargando();
        SuministroTipoSerie.query({idTipo:vm.tipoSuministro.id, serie:vm.serie},function(data){
          vm.suministros = data;
          actualizarTabla(vm.suministros);
          ServicioDialogos.cerrarDialogoCargando();
        }, function(err){
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError(null, "No se puede buscar los suministros");
        });
      } else if (vm.radio=="serieParcial"){
        ServicioDialogos.abrirDialogoCargando();
        SuministroFamiliaSerie.query({idFamilia:vm.familiaSuministroParcial.id, serie:vm.serieParcial},function(data){
          vm.suministros = data;
          actualizarTabla(vm.suministros);
          ServicioDialogos.cerrarDialogoCargando();
        }, function(err){
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError(null, "No se puede buscar los suministros");
        });
      } else {
        ServicioDialogos.mostrarDialogoError(null, "No se puede buscar");
      }
    }

    function editar(suministro) {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Está seguro que desea editar la información del suministro?", function(){
        ServicioDialogos.abrirDialogoCargando();
        ServicioModales.abrirModalEditarSuministro({
          onResult: function(resultado){
            //$window.location.reload();
          },
          suministro:suministro,
          modo:'editar'
        });
      });
    }

    function crearNuevo() {
      $state.go('home.editar-suministro');
    }

    $scope.$watch('vm.empresa1.nombre', function(){
      if (vm.grupoSuministro && vm.grupoSuministro.id) vm.grupoSuministro=null;
      if (vm.familiaSuministro && vm.familiaSuministro.id) vm.familiaSuministro=null;
      if (vm.tipoSuministro && vm.tipoSuministro.id) vm.tipoSuministro=null;
      if (!vm.empresa1) return;
      ServicioDialogos.abrirDialogoCargando();
      GrupoEmpresa.query({id:vm.empresa1.id}, function(data) {
        vm.grupos = data;
        focus('grupoSuministro');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.empresa2.nombre', function(){
      if (vm.grupoSuministroParcial && vm.grupoSuministroParcial.id) vm.grupoSuministroParcial=null;
      if (vm.familiaSuministroParcial && vm.familiaSuministroParcial.id) vm.familiaSuministroParcial=null;
      if (!vm.empresa2) return;
      ServicioDialogos.abrirDialogoCargando();
      GrupoEmpresa.query({id:vm.empresa2.id}, function(data) {
        vm.grupos = orderByFilter(data, "nombre", false);
        focus('grupoSuministroParcial');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.grupoSuministro.nombre', function(){
      if (vm.familiaSuministro && vm.familiaSuministro.id) vm.familiaSuministro=null;
      if (vm.tipoSuministro &&vm.tipoSuministro.id) vm.tipoSuministro=null;
      if (!vm.grupoSuministro) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupoSuministro.id}, function(data){
        vm.familias = orderByFilter(data, "nombre", false);
        focus('familiaSuministro');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.grupoSuministroParcial.nombre', function(){
      if (vm.familiaSuministroParcial && vm.familiaSuministroParcial.id) vm.familiaSuministroParcial=null;
      if (!vm.grupoSuministroParcial) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupoSuministroParcial.id}, function(data){
        vm.familias = orderByFilter(data, "nombre", false);
        focus('familiaSuministroParcial');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.tipoSuministro.nombre', function(){
      if (!vm.tipoSuministro) return;
      focus('serie');
    });

    $scope.$watch('vm.familiaSuministro.nombre', function(){
      if (vm.tipoSuministro && vm.tipoSuministro.id) vm.tipoSuministro=null;
      if (!vm.familiaSuministro) return;
      ServicioDialogos.abrirDialogoCargando();
      TipoSuministroFamiliaInventariable.query({idFamilia:vm.familiaSuministro.id, inventariable:true}, function(data){
        vm.tipos = orderByFilter(data, "nombre", false);
        focus('tipoSuministro');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.familiaSuministroParcial.nombre', function(){
      if (!vm.familiaSuministroParcial) return;
      ServicioDialogos.abrirDialogoCargando();
      TipoSuministroFamiliaInventariable.query({idFamilia:vm.familiaSuministroParcial.id, inventariable:true}, function(data){
        vm.tipos = orderByFilter(data, "nombre", false);
        focus('serieParcial');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.historico-suministro', {
        url: 'historico-suministro/:objeto',
        templateUrl: 'app/app/main/suministro/suministro/historico-suministro/historico-suministro.html',
        controller: 'HistoricoSuministroCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Histórico de suministro',
          subtitulo:'Lista de movimientos históricos de suministro',
          objeto:null
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          suministro: function(Suministro, $stateParams){
            return Suministro.get({id:$stateParams.objeto}).$promise.then(function(data) {
              return data;
            });
          },
          movimientos: function(MovimientosPorSuministroInventariable, $stateParams){
            return MovimientosPorSuministroInventariable.query({idSuministroInventariable:$stateParams.objeto}).$promise.then(function(data){
              return data;
            });
          },
          transferencias: function(TransferenciasPorSuministroInventariable, $stateParams){
            return TransferenciasPorSuministroInventariable.query({idSuministroInventariable:$stateParams.objeto}).$promise.then(function(data){
              return data;
            });
          },
          reparaciones: function(HistorialDetalleSuministroInventariable, $stateParams){
            return HistorialDetalleSuministroInventariable.query({id:$stateParams.objeto}).$promise.then(function(data){
              return data;
            });
          }
        }
      });
  }
})();


(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('HistoricoSuministroCtrl', HistoricoSuministroCtrl);

  /** @ngInject */
  function HistoricoSuministroCtrl(NgTableParams, reparaciones, transferencias, rol, HeaderBarService, suministro, movimientos, $stateParams, $filter, $scope, orderByFilter, $state, ServicioDialogos, ServicioModales) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.suministro = suministro;
    vm.movimientos = orderByFilter(movimientos, 'fecha', false);
    vm.suministros = [];

    inicializarTablas();
    vm.mostrarInformacion = mostrarInformacion;
    vm.volver = volver;
    vm.verFoto = verFoto;
    vm.esMovimientoCerrado = esMovimientoCerrado;

    vm.esInventariable = esInventariable;
    vm.exportToExcel = exportToExcel;

    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");

    function inicializarTablas(){
      vm.tableParams = new NgTableParams({
        page: 1,
        count: 50
      });
      vm.tableParams.settings({
        data: obtenerMovimientos()
      });
      vm.tableParams.reload();

      vm.suministros.push(vm.suministro);
      vm.tableParamsSuministro = new NgTableParams({
        page: 1,
        count: 10
      });
      vm.tableParamsSuministro.settings({
        data: vm.suministros,
        noPager: true,
        counts: []
      });
      vm.tableParamsSuministro.reload();
    }

    function obtenerMovimientos(){
      transferencias.forEach(function(item){
        vm.movimientos.push({
          fecha:item.fecha,
          numeroMovimiento:item.numeroTransferencia,
          tipoMovimiento:{
            nombre:"Transferencia de "+item.tipoDesde.nombre.toUpperCase()+" a "+item.tipoHasta.nombre.toUpperCase()
          },
          empresa:item.empresa,
          estadoMovimiento:{
            nombre:"CERRADO"
          },
          deposito:item.deposito,
          id:item.id
        });
      });
      reparaciones.forEach(function(item){
        vm.movimientos.push({
          fecha:item.fecha,
          numeroMovimiento:"-",
          tipoMovimiento:{
            nombre:"REPARACIÓN"
          },
          deposito:item.deposito,
          id:item.id
        });
      });
      return orderByFilter(vm.movimientos, "fecha", false);
    }

    function verFoto(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalMostrarFotoSuministro({
        onResult: function(resultado) {
          console.log(resultado);
        },
        tipoSuministro: vm.suministro.suministro.tipoSuministro
      });
    }

    function esMovimientoCerrado(movimiento){
      return movimiento.estadoMovimiento.id==5;
    }

    function volver(){
      $state.go('home.lista-suministro');
    }

    function esInventariable(){
      return (vm.suministro && vm.suministro.id!==undefined);
    }

    function actualizarTabla(data){
      vm.historiales = orderByFilter(data,'nombre',false);
      vm.tableParams.settings({
        data: vm.historiales
      });
      vm.tableParams.reload();
    }

    function filtrarPorTipo(){
      SuministroTipo.query({id:vm.tipoSuministro.id},function(data){
        ServicioDialogos.cerrarDialogoCargando();
        if (data.length==0) {
          vm.bandera=true;
        }
        actualizarTabla(data);
      }, function(err){
        console.error(err);
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function filtrar(){
      vm.bandera=true;
      ServicioDialogos.abrirDialogoCargando();
      if (vm.tipoSuministro && typeof vm.tipoSuministro !== "string") {
        filtrarPorTipo();
      } else {
        if (vm.tipoSuministro==undefined){
          Suministro.query(function(data){
            ServicioDialogos.cerrarDialogoCargando();
            actualizarTabla(data);
          }, function(err){
            console.error(err);
            ServicioDialogos.cerrarDialogoCargando();
          });
        } else {
          actualizarTabla(undefined);
        }
      }
    }

    function mostrarInformacion(movimiento) {
      if (movimiento.tipoMovimiento.id==2 || movimiento.tipoMovimiento.id==3 || movimiento.tipoMovimiento.id==4){
        visualizarIngresoModal(movimiento);
      } else if (movimiento.tipoMovimiento.id==1 || movimiento.tipoMovimiento.id==7 || movimiento.tipoMovimiento.id==8){
        visualizarEgresoModal(movimiento);
      } else {
        if (movimiento.empresa && movimiento.empresa.id){
          visualizarTransferencia(movimiento);
        } else {
          visualizarReparacion(movimiento);
        }
      }
    }

    function visualizarEgresoModal(movimiento){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalVisualizarEgreso({
        onResult: function(resultado) {
          console.log(resultado);
        },
        egreso: movimiento,
        deposito: movimiento.deposito
      });
    }

    function visualizarIngresoModal(movimiento){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalVisualizarIngreso({
        onResult: function(resultado) {
          console.log(resultado);
        },
        ingreso: movimiento,
        deposito: movimiento.deposito
      });
    }

    function visualizarReparacion(historial){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirVisualizarHistorialReparacion({
        onResult: function(resultado){
          //$state.go("home.editar-historial-suministro", {bien:resultado.bien.id, modo:"nuevo"});
        },
        historial: historial.id
      });
    }

    function visualizarTransferencia(transferencia){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalVisualizarTransferencia({
        onResult: function(resultado) {
          console.log(resultado);
        },
        transferencia: transferencia,
        deposito: transferencia.deposito
      });
    }


    function editar(suministro) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el suministro?', function() {
        $state.go('home.editar-suministro', {objeto:suministro.id, modo:'editar'});
      });
    }

    function crearNuevo() {
      $state.go('home.editar-suministro');
    }

    function eliminar(suministro){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Desea eliminar el suministro?",function(){
        Suministro.remove({id:suministro.id}, function(data){
          ServicioDialogos.mostrarDialogoInformacion(null, "Se ha eliminado el suministro con éxito");
          Suministro.query().$promise.then(function(data){
            actualizarTabla(data);
          }, function(err){
            console.log(err);
          });
        }, function(error){
          console.log(error);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar el suministro");
        });
      },null,false);
    }

    function armarBienExportar(){
      var array = [];
      array.push({
        "Empresa" : vm.suministro.suministro.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase(),
        "Grupo suministro" : vm.suministro.suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
        "Familia suministro" : vm.suministro.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase(),
        "Tipo suministro" : vm.suministro.suministro.tipoSuministro.nombre.toUpperCase(),
        "Marca" : vm.suministro.marca ? vm.suministro.marca.toUpperCase() : "-",
        "N° de serie" : vm.suministro.serie? vm.suministro.serie.toUpperCase():"-",
        "N° de inventario" : vm.suministro.inventario? vm.suministro.inventario:"-",
        "¿Activo?":vm.suministro.suministro.estadoSuministro==1? "SI" : "NO",
        "¿Nuevo?" : vm.suministro.nuevo? "SI":"NO"
      });
      return array;
    }

    function listadoHistorial(){
      var array = [];
      for (var i = vm.movimientos.length - 1; i >= 0; i--) {
        array.push({
          "Fecha" : $filter('date')(vm.movimientos[i].fecha, "dd/MM/yyyy HH:mm"),
          "N° Movimiento": vm.movimientos[i].numeroMovimiento,
          "Tipo Movimiento":vm.movimientos[i].tipoMovimiento.nombre.toUpperCase(),
          "Empresa" : vm.movimientos[i].empresa ? vm.movimientos[i].empresa.nombre.toUpperCase() : "-",
          "Sucursal":vm.movimientos[i].sucursal? vm.movimientos[i].sucursal.nombre.toUpperCase():"-",
          "Proveedor" : vm.movimientos[i].proveedor? vm.movimientos[i].proveedor.nombre.toUpperCase() : "-",
          "Empresa logística":vm.movimientos[i].empresaLogistica? vm.movimientos[i].empresaLogistica.nombre.toUpperCase() : "-",
          "Estado" : vm.movimientos[i].estadoMovimiento? vm.movimientos[i].estadoMovimiento.nombre.toUpperCase() : "-"
        });
      }
      return array;
    }

    function exportToExcel() {
      var pagina1 = armarBienExportar();
      var pagina2 = listadoHistorial();

      var opts = [
        {
          sheetid:'Suministro',
          header:true
        },{
          sheetid:'Histórico del suministro',
          header:true
        }
      ];

      alasql('SELECT INTO XLSX("histórico-suministro-'+$filter('date')(new Date(), "dd/MM/yyyy")+'.xlsx",?) FROM ?',[opts,[pagina1, pagina2]], function(){
        console.log("Exportado");
      });
    }

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-historial-suministro', {
        url: 'lista-historial-suministro',
        templateUrl: 'app/app/main/suministro/historial-suministro/lista/lista-historial-suministro.html',
        controller: 'ListaHistorialSuministroCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar historiales de reparación de suministros',
          subtitulo:'Lista de historiales de reparación de suministros'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          historiales: function(Usuario, Historial, HistorialesDeposito){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              var deposito = usuario.empleado.deposito;
              if (deposito){
                return HistorialesDeposito.query({'id':deposito.id}).$promise.then(function(data){
                  return data;
                });
              } else {
                return Historial.query().$promise.then(function(data) {
                  return data;
                });
              }
            });

          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaHistorialSuministroCtrl', ListaHistorialSuministroCtrl);

  /** @ngInject */
  function ListaHistorialSuministroCtrl(NgTableParams, rol, $filter, HeaderBarService, ServicioModales, HistorialSuministro, Historial, historiales, HistorialesDeposito, TipoSuministroFamilia, FamiliaSuministroGrupo, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.historiales = orderByFilter(historiales,'fecha',true);
    vm.mostrarInformacion = mostrarInformacion;
    vm.crearNuevo = crearNuevo;
    vm.editar = editar;
    vm.exportToExcel = exportToExcel;
    vm.eliminar = eliminar;
    vm.filtrar = filtrar;
    vm.abrirModalFiltros = abrirModalFiltros;
    vm.busqueda = busqueda;
    vm.bandera = false;
    vm.bloquearPorRol = bloquearPorRol;

    function bloquearPorRol(){
      return (rol.id!=1 && rol.id!=2);
    }

    if (rol.id!=1 && rol.id!=2) $state.go("home.home");

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });
    vm.tableParams.settings({
      getData: function($defer,params){ return filtrarTabla($defer, params);}
    });
    vm.tableParams.reload();

    function abrirModalFiltros(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalHistorialSuministro({
        onResult: function(resultado){
          vm.bandera=true;
          vm.filtrosUsados = resultado.filtros;
          ServicioDialogos.abrirDialogoCargando();
          HistorialSuministro.query({'id':resultado.bien.id}, function(data){
            actualizarTabla(data);
            ServicioDialogos.cerrarDialogoCargando();
          });
        },
        modo: "filtrar"
      });
    }



    function filtrarTabla($defer, params) {
      var filtros = params.filter();
      var filtrosNuevos = {};

      for (var key in filtros) {
        if (filtros.hasOwnProperty(key) && filtros[key]!=='') {
          switch(key) {
            case 'deposito.nombre':
              angular.extend(filtrosNuevos, {
                deposito: {
                nombre: filtros[key]
                }
              });
              break;
            default:
              filtrosNuevos[key] = filtros[key];
          }
        }
      }
      var filtrados = filtros ? $filter('filter')(vm.historiales, filtrosNuevos) : vm.historiales;
      filtrados = params.sorting() ? $filter('orderBy')(filtrados, params.orderBy()) : filtrados;
      if (filtrados && filtrados.length){
        params.total(filtrados.length);
        return $defer.resolve(filtrados.slice((params.page() - 1) * params.count(), params.page() * params.count()));
      } else {
        params.total(0);
        return $defer.resolve(null);
      }
    }
    
    function busqueda(){
      vm.bandera=false;
      vm.filtrosUsados=null;
      if (vm.buscar) {
        vm.ingresos=null;
        actualizarTabla(vm.ingresos);
      } else {
        filtrar();
      }
    }

    function actualizarTabla(data){
      vm.historiales = orderByFilter(data,'fecha',true);
      vm.tableParams.settings({
        data: vm.historiales
      });
      vm.tableParams.reload();
    }

    function filtrarPorDeposito(){
      HistorialesDeposito.query({id:vm.deposito.id},function(data){
        ServicioDialogos.cerrarDialogoCargando();
        if (data.length==0) {
          vm.bandera=true;
        }
        actualizarTabla(data);
      }, function(err){
        console.error(err);
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function filtrar(){
      vm.bandera=true;
      ServicioDialogos.abrirDialogoCargando();
      if (vm.deposito && typeof vm.deposito !== "string") {
        filtrarPorDeposito();
      } else {
        if (vm.deposito==undefined){
          Historial.query(function(data){
            ServicioDialogos.cerrarDialogoCargando();
            actualizarTabla(data);
          }, function(err){
            console.error(err);
            ServicioDialogos.cerrarDialogoCargando();
          });
        } else {
          actualizarTabla(undefined);
        }
      }
    }

    function mostrarInformacion(historial) {
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirVisualizarHistorialReparacion({
        onResult: function(resultado){
          //$state.go("home.editar-historial-suministro", {bien:resultado.bien.id, modo:"nuevo"});
        },
        historial: historial.id
      });
    }

    function editar(suministro) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el historial de reparación?', function() {
        $state.go('home.editar-suministro', {objeto:suministro.id, modo:'editar'});
      });
    }

    function crearNuevo() {
      $state.go("home.editar-historial-suministro");
    }

    function eliminar(historial){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Desea eliminar el historial de reparación?",function(){
        Historial.remove({id:historial.id}, function(data){
          ServicioDialogos.mostrarDialogoInformacion(null, "Se ha eliminado el historial de reparación con éxito");
          Historial.query().$promise.then(function(data){
            actualizarTabla(data);
          }, function(err){
            console.log(err);
          });
        }, function(error){
          console.log(error);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar el historial de reparación");
        });
      },null,false);
    }

    function exportToExcel(){
      var array = [];
      for (var i = vm.historiales.length - 1; i >= 0; i--) {
        array.push({
          "Empresa" : vm.historiales[i].tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase(),
          "Grupo de suministro" : vm.historiales[i].tipoSuministro.familiaSuministro.nombre.toUpperCase(),
          "Familia de suministro" : vm.historiales[i].tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
          "Código de Tipo suministro" : vm.historiales[i].tipoSuministro.codigoProducto,
          "Tipo de suministro" : vm.historiales[i].tipoSuministro.nombre.toUpperCase(),
          "Categoría de peso" : vm.historiales[i].tipoSuministro.categoriaPeso.nombre.toUpperCase(),
          "Peso estimado" : vm.historiales[i].tipoSuministro.pesoEstimado+' Kg.',
          "Precio actual" : "$"+vm.historiales[i].precioActual,
          "N° serie" : vm.historiales[i].serie.toUpperCase(),
          "N° inventario":vm.historiales[i].inventario
        });
      }
      var nombreDocumento = "historiales";
      alasql('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true}) FROM ?',[array]);
    }

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-historial-suministro', {
        url: 'editar-historial-suministro',
        templateUrl: 'app/app/main/suministro/historial-suministro/editar/editar-historial-suministro.html',
        controller: 'EditarHistorialSuministroCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar historiales de reparación de suministros',
          subtituloNuevo:'Nuevo historial de reparación de suministro',
          subtituloVisualizar: 'Historial de reparación de suministro',
          bien:null,
          modo:null,
          historial:null
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          deposito: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.empleado.deposito;
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          bien: function(Suministro, $stateParams){
            if ($stateParams.bien){
              return Suministro.get({id:$stateParams.bien}).$promise.then(function(data) {
                return data;
              });
            } else {
              return null;
            }
          },
          modo: function($stateParams){
            return $stateParams.modo;
          },
          historial: function(Historial, $stateParams){
            if ($stateParams.historial){
              return Historial.get({id:$stateParams.historial}).$promise.then(function(data){
                return data;
              });
            } else {
              return {};
            }
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarHistorialSuministroCtrl', EditarHistorialSuministroCtrl);

  /** @ngInject */
  function EditarHistorialSuministroCtrl(NgTableParams, orderByFilter, deposito, depositos, rol, ServicioModales, HeaderBarService, modo, Historial, historial, bien, $stateParams, $filter, $state, $timeout, $scope, ServicioDialogos) {
    var vm = this;
    vm.cancelar = cancelar;
    vm.guardar = guardar;
    vm.deposito = deposito;
    vm.depositos = orderByFilter(depositos, 'nombre', false);
    vm.historial = historial;
    vm.modo = modo;
    vm.volver = volver;
    vm.agregarDetalleHistorial = agregarDetalleHistorial;
    vm.cambiarDeposito = cambiarDeposito;
    vm.seleccionarDeposito = seleccionarDeposito;
    vm.mostrarFoto = mostrarFoto;
    vm.quitarDetalle = quitarDetalle;

    inicializar();


    if (rol.id!=1 && rol.id!=2) $state.go("home.home");

    function quitarDetalle(detalle){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea quitar el bien?', function(){
        var index = null;
        vm.detalles.forEach(function(item, i){
          if (detalle.suministroInventariable.id===item.suministroInventariable.id){
            index = i;
          }
        });
        if (index!==null) vm.detalles.splice(index, 1);
        actualizarTabla();
      });
    }

    function mostrarFoto(detalle){
      var foto=detalle.encabezadoFoto+detalle.cuerpoFoto;
      ServicioDialogos.mostrarDialogoInformacionConHtml(null,
        '<div class="marco-imagenes">'+
          '<img src="'+foto+'" />'+
        '</div>'
      );
    }

    function cambiarDeposito(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "Si continúa, perderá la información ingresada que no haya sido guardada. \n¿Está seguro que desea continuar?", function(){
        $timeout(function() {
          vm.bandera=false;
        }, 50);
      });
    }

    function seleccionarDeposito(){
      vm.bandera=true;
    }

    function agregarDetalleHistorial(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalAgregarDetalleReparacion({
        onResult: function(res){
          vm.detalles=res.detalles;
          actualizarTabla();
        },
        detalles: vm.detalles,
        deposito: vm.historial.deposito
      });
    }
    
    function volver(){
      $state.go("home.lista-historial-suministro");
    }


    function inicializar(){
      setearTitulos();
      armarObjetos();
      inicializarTabla();
    }

    function inicializarTabla(){
      vm.tableParams = new NgTableParams({
        page: 1,
        count: 10
      });
      vm.tableParams.settings({
        data: vm.detalles,
      });
      vm.tableParams.reload();
    }

    function actualizarTabla(){
      vm.tableParams.settings({
        data: vm.detalles,
      });
      vm.tableParams.reload();
    }

    function armarObjetos(){
      vm.detalles = [];
      vm.bandera=false;
      if (deposito) {
        vm.historial.deposito = deposito;
        vm.bandera=true;
      }
      vm.fecha = $filter('date')(new Date(), 'dd/MM/yyyy HH:mm');
    }

    function esVisualizar() {
      return vm.modo=='visualizar';
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      if (esVisualizar()) {
        HeaderBarService.setSubTitulo($stateParams.subtituloVisualizar);
      } else {
        HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);
      }
    }

    function cancelar() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        $state.go('home.lista-historial-suministro');
      });
    }

    function guardar() {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea registrar una nueva reparación?', function(){
        vm.historial.detalles = vm.detalles;
        vm.historial.fecha = new Date();
        Historial.save(vm.historial, function(data){
          ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha registrado la reparación correctamente', function(){
            $state.go('home.lista-historial-suministro');
          });
        },function(error){
          console.error(error);
          ServicioDialogos.mostrarDialogoError(null, 'No se ha podido registrar la reparación');
        });
      }, null, false);
    }
/*
    function editarObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar la reparación?', function(){
        Historial.update(vm.historial, function(data){
          ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado la reparación correctamente', function(){
            $state.go('home.lista-historial-suministro');
          });
        }, function(err){
          console.error(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar la reparación");
        });
      },null,false);
    }*/
     
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-grupo-suministro', {
        url: 'lista-grupo-suministro',
        templateUrl: 'app/app/main/suministro/grupo-suministro/lista/lista-grupo-suministro.html',
        controller: 'ListaGrupoSuministroCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Grupos de suministro',
          subtitulo:'Lista de Grupos de suministro'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          grupos: function(GrupoSuministro){
            return GrupoSuministro.query().$promise.then(function(data) {
              return data;
            });

          },
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data) {
              return data;
            });

          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaGrupoSuministroCtrl', ListaGrupoSuministroCtrl);

  /** @ngInject */
  function ListaGrupoSuministroCtrl(NgTableParams, URL_SERVIDOR, rol, FamiliaSuministroGrupo, $http, HeaderBarService, empresas, GrupoEmpresa, GrupoSuministro, $timeout, $stateParams, $scope, orderByFilter, $state, grupos, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.grupos = orderByFilter(grupos,'nombre',false);
    vm.mostrarInformacion = mostrarInformacion;
    vm.crearNuevo = crearNuevo;
    vm.editar = editar;
    vm.exportToExcel = exportToExcel;
    vm.eliminar = eliminar;
    vm.empresas = orderByFilter(empresas,'nombre',false);
    vm.filtrar = filtrar;
    vm.busqueda = busqueda;
    vm.bandera=false;
    vm.reportePdf = reportePdf;
    vm.bloquearPorRol = bloquearPorRol;

    function bloquearPorRol(){
      return (rol.id!=1 && rol.id!=2);
    }
    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");

    function reportePdf(){
      var Url = URL_SERVIDOR+"/gruposuministro/reporte";
      if (vm.empresa && vm.empresa.id){
        Url = URL_SERVIDOR+"/gruposuministro/reporte/"+vm.empresa.id;
      }
      ServicioDialogos.abrirDialogoCargando();
       
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }


    function busqueda(){
      if (vm.empresa && vm.empresa.id) vm.empresa = null;
      vm.bandera=false;

      if (vm.buscar) {
        vm.grupos=null;
        actualizarTabla(vm.grupos);
      } else {
        filtrar();
      }
    }

    function actualizarTabla(data){
      vm.grupos = orderByFilter(data,'nombre',false);
      vm.tableParams.settings({
        data: vm.grupos
      });
      vm.tableParams.reload();
    }

    function filtrarPorEmpresa(){
      GrupoEmpresa.query({id:vm.empresa.id},function(data){
        ServicioDialogos.cerrarDialogoCargando();
        if (data.length==0) {
          vm.bandera=true;
        }
        actualizarTabla(data);
      }, function(err){
        console.error(err);
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function filtrar(){
      vm.bandera=true;
      ServicioDialogos.abrirDialogoCargando();
      if (vm.empresa && typeof vm.empresa !== "string") {
        filtrarPorEmpresa();
      } else {
        if (vm.empresa==undefined){
          GrupoSuministro.query(function(data){
            ServicioDialogos.cerrarDialogoCargando();
            actualizarTabla(data);
          }, function(err){
            console.error(err);
            ServicioDialogos.cerrarDialogoCargando();
          });
        } else {
          actualizarTabla(undefined);
        }
      }
    }

    function mostrarInformacion(grupo) {
      ServicioDialogos.mostrarDialogoInformacion("Información", grupo.nombre.toUpperCase() + "\n Descripción: "+ grupo.descripcion);
    }

    function editar(grupo) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el Grupo de suministro?', function() {
        $state.go('home.editar-grupo-suministro', {objeto:grupo.id, modo:'editar'});
      });
    }

    function crearNuevo() {
      $state.go('home.editar-grupo-suministro');
    }

    function eliminarGrupo(grupo){
      GrupoSuministro.remove({id:grupo.id}, function(data){
        ServicioDialogos.mostrarDialogoInformacion(null, "Se ha eliminado el Grupo de suministro con éxito");
        GrupoSuministro.query().$promise.then(function(grupos){
          vm.grupos = orderByFilter(grupos,'nombre',false);
          vm.tableParams.settings({
            data: vm.grupos
          });
          vm.tableParams.reload();
        }, function(err){
          console.log(err);
        });
      }, function(error){
        console.log(error);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar el Grupo de suministro");
      });
    }

    function eliminar(grupo){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Desea eliminar el Grupo de suministro: \n"+grupo.nombre.toUpperCase()+"?",function(){
        FamiliaSuministroGrupo.query({id:grupo.id},function(data){
          if (data.length==0) {
            eliminarGrupo(grupo);
          } else {
            ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar el grupo de suministro");
          }
        }, function(err){
          console.error(err);
          ServicioDialogos.mostrarDialogoError();
        });
      },null,false);
    }

    function exportToExcel(){ // ex: '#my-table'
      var array = [];
      for (var i = vm.grupos.length - 1; i >= 0; i--) {
        array.push({
          "Empresa" : vm.grupos[i].empresa.nombre.toUpperCase(),
          "Grupo de suministro" : vm.grupos[i].nombre,
          "Descripción" : vm.grupos[i].descripcion
        });
      }
      var nombreDocumento = vm.empresa ? "grupos-suministro-de-"+vm.empresa.nombre.toUpperCase() : "grupos-suministro";
      alasql('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true}) FROM ?',[array]);
    }

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });
    vm.tableParams.settings({
      data: vm.grupos
    });
    vm.tableParams.reload();
    
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-grupo-suministro', {
        url: 'editar-grupo-suministro/:objeto/:modo',
        templateUrl: 'app/app/main/suministro/grupo-suministro/editar/editar-grupo-suministro.html',
        controller: 'EditarGrupoSuministroCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Grupos de suministros',
          subtituloEditar:'Editar Grupo de suministro',
          subtituloNuevo: 'Nuevo Grupo de suministro',
          modo:null,
          objeto:null
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data) {
              return data;
            });
          },
          grupo: function(GrupoSuministro, $stateParams){
            if ($stateParams.objeto){
              return GrupoSuministro.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return {};
            }
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarGrupoSuministroCtrl', EditarGrupoSuministroCtrl);

  /** @ngInject */
  function EditarGrupoSuministroCtrl(NgTableParams, rol, HeaderBarService, grupo, empresas, orderByFilter, GrupoSuministroNombreEmpresa, GrupoSuministro, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    inicializar();
    vm.cancelar = cancelar;
    vm.modo=$stateParams.modo;
    vm.guardar = guardar;
    vm.empresas = orderByFilter(empresas,'nombre',false);

    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");

    function inicializar(){
      setearTitulos();
      setearObjeto();
    }

    function setearObjeto(){
      if (esEditar()) {
        vm.grupo = grupo;
        vm.nombre = vm.grupo.nombre;
        vm.empresa = vm.grupo.empresa;

      }
    }

    function esEditar() {
      return $stateParams.modo=='editar';
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      if (esEditar()) {
        HeaderBarService.setSubTitulo($stateParams.subtituloEditar);
      } else {
        HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);
      }
    }

    function cancelar() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        $state.go('home.lista-grupo-suministro');
      });
    }

    function guardar() {
      if (esEditar()) {
        editarObjeto();
      } else {
        nuevoObjeto();
      }
    }

    function nuevoObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea registrar un nuevo Grupo de suministro?', function(){
        GrupoSuministroNombreEmpresa.query({nombre:vm.grupo.nombre, idEmpresa:vm.grupo.empresa.id},function(data){
          if (data.length>0) {
            ServicioDialogos.mostrarDialogoError(null, 'El nombre ingresado ya existe para la empresa seleccionada');
          } else {
            GrupoSuministro.save(vm.grupo, function(data){
              ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha registrado el Grupo de suministro correctamente', function(){
                $state.go('home.lista-grupo-suministro');
              });
            },function(error){
              console.error(error);
              ServicioDialogos.mostrarDialogoError(null, 'No se ha podido registrar el Grupo de suministro');
            });
          }
        }, function(err){
          console.error(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar el Grupo de suministro");
        });
      }, null, false);
    }

    function editarObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el Grupo de suministro?', function(){
        if (vm.nombre==vm.grupo.nombre && vm.empresa.id == vm.grupo.empresa.id) {
          GrupoSuministro.update(vm.grupo, function(data){
            ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado el Grupo de suministro correctamente', function(){
              $state.go('home.lista-grupo-suministro');
            });
          }, function(err){
            console.error(err);
            ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar el Grupo de suministro");
          });
        } else {
          GrupoSuministroNombreEmpresa.query({nombre:vm.grupo.nombre, idEmpresa:vm.grupo.empresa.id},function(data){
            if (data.length>0){
              ServicioDialogos.mostrarDialogoError(null, 'El nombre ingresado ya existe en la empresa seleccionada');
            } else {
              GrupoSuministro.update(vm.grupo, function(data){
                ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado el Grupo de suministro correctamente', function(){
                  $state.go('home.lista-grupo-suministro');
                });
              }, function(err){
                console.error(err);
                ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar el Grupo de suministro");
              });
            }
          }, function(err){
            console.error(err);
            ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar el Grupo de suministro");
          });
        }
      },null,false);
    }
     
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-familia-suministro', {
        url: 'lista-familia-suministro',
        templateUrl: 'app/app/main/suministro/familia-suministro/lista/lista-familia-suministro.html',
        controller: 'ListaFamiliaSuministroCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Familia de suministro',
          subtitulo:'Lista de Familia de suministro'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          grupos: function(GrupoSuministro){
            return GrupoSuministro.query().$promise.then(function(data) {
              return data;
            });
          },
          familias: function(FamiliaSuministro){
            return FamiliaSuministro.query().$promise.then(function(data){
              return data;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaFamiliaSuministroCtrl', ListaFamiliaSuministroCtrl);

  /** @ngInject */
  function ListaFamiliaSuministroCtrl(NgTableParams, URL_SERVIDOR, TipoSuministroFamilia, rol, $http, HeaderBarService, FamiliaSuministro, grupos, FamiliaSuministroNombreGrupo, FamiliaSuministroGrupo, $timeout, $stateParams, $scope, orderByFilter, $state, familias, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.familias = orderByFilter(familias,'nombre',false);
    vm.mostrarInformacion = mostrarInformacion;
    vm.crearNuevo = crearNuevo;
    vm.editar = editar;
    vm.exportToExcel = exportToExcel;
    vm.eliminar = eliminar;
    vm.grupos = orderByFilter(grupos,'nombre',false);
    vm.filtrar = filtrar;
    vm.busqueda = busqueda;
    vm.bandera=false;
    vm.reportePdf = reportePdf;
    vm.bloquearPorRol = bloquearPorRol;

    function bloquearPorRol(){
      return (rol.id!=1 && rol.id!=2);
    }

    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");

    function reportePdf(){
      var Url = URL_SERVIDOR+"/familiasuministro/reporte";
      if (vm.empresa && vm.empresa.id){
        Url = URL_SERVIDOR+"/familiasuministro/reporte/"+vm.grupoSuministro.empresa.id;
      }
      ServicioDialogos.abrirDialogoCargando();
       
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });
    vm.tableParams.settings({
      data: orderByFilter(vm.familias,['grupoSuministro.empresa.nombre', 'grupoSuministro.nombre','nombre'],false)
    });
    vm.tableParams.reload();
    
    function busqueda(){
      if (vm.grupoSuministro && vm.grupoSuministro.id) vm.grupoSuministro = null;
      vm.bandera=false;

      if (vm.buscar) {
        vm.familias=null;
        actualizarTabla(vm.familias);
      } else {
        filtrar();
      }
    }

    function actualizarTabla(data){
      vm.familias = orderByFilter(data,['grupoSuministro.empresa.nombre', 'grupoSuministro.nombre','nombre'],false);
      vm.tableParams.settings({
        data: vm.familias
      });
      vm.tableParams.reload();
    }

    function filtrarPorGrupo(){
      FamiliaSuministroGrupo.query({id:vm.grupoSuministro.id},function(data){
        ServicioDialogos.cerrarDialogoCargando();
        if (data.length==0) {
          vm.bandera=true;
        }
        actualizarTabla(data);
      }, function(err){
        console.error(err);
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function filtrar(){
      vm.bandera=true;
      ServicioDialogos.abrirDialogoCargando();
      if (vm.grupoSuministro && typeof vm.grupoSuministro !== "string") {
        filtrarPorGrupo();
      } else {
        if (vm.grupoSuministro==undefined){
          FamiliaSuministro.query(function(data){
            ServicioDialogos.cerrarDialogoCargando();
            actualizarTabla(data);
          }, function(err){
            console.error(err);
            ServicioDialogos.cerrarDialogoCargando();
          });
        } else {
          actualizarTabla(undefined);
        }
      }
    }

    function mostrarInformacion(familia) {
      var encargado = '';
      if (familia.apellidoEncargado && familia.nombreEncargado){
        var nombre = familia.nombreEncargado.toUpperCase();
        var apellido = familia.apellidoEncargado.toUpperCase();
        encargado = apellido+", "+nombre;
      } else {
        encargado='-';
      }
      var codigo = familia.codigoFamiliaSuministro ? familia.codigoFamiliaSuministro.toUpperCase() : "-";
      var mail = familia.mailEncargado? familia.mailEncargado : " - ";
      var mailAdicional = familia.mailAdicional? familia.mailAdicional : " - ";
      var telefono = familia.telefonoEncargado? familia.telefonoEncargado : " - ";
      ServicioDialogos.mostrarDialogoInformacion(
        "Información",
        familia.nombre.toUpperCase() +
        '\n Grupo de suministro: '+familia.grupoSuministro.nombre.toUpperCase()+
        '\n Código de familia de suministro: '+codigo+
        '\n Empresa: '+familia.grupoSuministro.empresa.nombre.toUpperCase()+
        '\n Encargado: '+encargado+
        '\n Teléfono: ' + telefono+
        '\n Mail: '+mail+
        '\n Mail adicional: '+mailAdicional);
    }

    function editar(familia) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar la Familia de suministro?', function() {
        $state.go('home.editar-familia-suministro', {objeto:familia.id, modo:'editar'});
      });
    }

    function crearNuevo() {
      $state.go('home.editar-familia-suministro');
    }

    function eliminarFamilia(familia){
      FamiliaSuministro.remove({id:familia.id}, function(data){
        ServicioDialogos.mostrarDialogoInformacion(null, "Se ha eliminado la Familia de suministro con éxito");
        FamiliaSuministro.query().$promise.then(function(data){
          actualizarTabla(data);
        }, function(err){
          console.log(err);
        });
      }, function(error){
        console.log(error);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar la Familia de suministro");
      });
    }

    function eliminar(familia){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Desea eliminar la Familia de suministro: \n"+familia.nombre.toUpperCase()+"?",function(){
        TipoSuministroFamilia.query({id:familia.id},function(data){
          if (data.length==0) {
            eliminarFamilia(familia);
          } else {
            ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar la familia de suministro");
          }
        }, function(err){
          console.error(err);
          ServicioDialogos.mostrarDialogoError();
        });

      },null,false);
    }

    function exportToExcel(){ // ex: '#my-table'
      var array = [];
      var encargado;
      for (var i = vm.familias.length - 1; i >= 0; i--) {
        if (vm.familias[i].apellidoEncargado && vm.familias[i].nombreEncargado){
          encargado = vm.familias[i].apellidoEncargado+', '+vm.familias[i].nombreEncargado;
        } else {
          encargado = '-';
        }
        array.push({
          "Grupo de suministro" : vm.familias[i].grupoSuministro.nombre,
          "Familia de suministro" : vm.familias[i].nombre,
          "Código familia de suministro": vm.familias[i].codigoFamiliaSuministro ? vm.familias[i].codigoFamiliaSuministro.toUpperCase() : "-",
          "Descripción" : vm.familias[i].descripcion ? vm.familias[i].descripcion : '-',
          "Encargado": encargado,
          "Teléfono encargado" : vm.familias[i].telefonoEncargado ? vm.familias[i].telefonoEncargado : '-',
          "Email encargado" : vm.familias[i].mailEncargado ? vm.familias[i].mailEncargado : '-'
        });
      }
      var nombreDocumento = vm.grupoSuministro ? "familias-"+vm.grupoSuministro.nombre.toUpperCase() : "familias";
      alasql('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true}) FROM ?',[array]);
    }

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-familia-suministro', {
        url: 'editar-familia-suministro/:objeto/:modo',
        templateUrl: 'app/app/main/suministro/familia-suministro/editar/editar-familia-suministro.html',
        controller: 'EditarFamiliaSuministroCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Familia de suministro',
          subtituloEditar:'Editar Familia de suministro',
          subtituloNuevo: 'Nueva Familia de suministro',
          modo:null,
          objeto:null
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          grupos: function(GrupoSuministro){
            return GrupoSuministro.query().$promise.then(function(data) {
              return data;
            });
          },
          familia: function(FamiliaSuministro, $stateParams){
            if ($stateParams.objeto){
              return FamiliaSuministro.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return {};
            }
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarFamiliaSuministroCtrl', EditarFamiliaSuministroCtrl);

  /** @ngInject */
  function EditarFamiliaSuministroCtrl(NgTableParams, rol, HeaderBarService, familia, orderByFilter, grupos, FamiliaSuministroNombreGrupo, FamiliaSuministro, FamiliaSuministroGrupo, FamiliaSuministroCodigoGrupo, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    inicializar();
    vm.cancelar = cancelar;
    vm.guardar = guardar;
    vm.grupos = orderByFilter(grupos,'nombre',false);
    vm.abrirMensaje = abrirMensaje;

    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");

    function inicializar(){
      setearTitulos();
      setearObjeto();
    }

    function setearObjeto(){
      if (esEditar()) {
        vm.familia = familia;
        vm.nombre = vm.familia.nombre;
        vm.codigo = vm.familia.codigoFamiliaSuministro;
        vm.grupo=vm.familia.grupoSuministro;
      }
    }

    function esEditar() {
      return $stateParams.modo=='editar';
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      if (esEditar()) {
        HeaderBarService.setSubTitulo($stateParams.subtituloEditar);
      } else {
        HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);
      }
    }

    function cancelar() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        $state.go('home.lista-familia-suministro');
      });
    }

    function guardar() {
      if (esEditar()) {
        editarObjeto();
      } else {
        nuevoObjeto();
      }
    }

    function abrirOtro(){
      ServicioDialogos.mostrarDialogoError(null, 'El nombre ingresado ya existe en el Grupo de suministro seleccionado',null,null,true);
    }

    function abrirMensaje() {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea registrar una nueva Familia de suministro?', function(){
        abrirOtro();
      }, null, false);

    }

    function guardarFamilia(){
      FamiliaSuministro.save(vm.familia, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha registrado la Familia de suministro correctamente', function(){
          $state.go('home.lista-familia-suministro');
        });
      }, function(error){
        console.error(error);
        ServicioDialogos.mostrarDialogoError(null, 'No se ha podido registrar la Familia de suministro');
      });
    }

    function nuevoObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea registrar una nueva Familia de suministro?', function(){
        comprobarNombreGrupo();
      }, null, false);
    }

    function guardarOEditar(){
      if (esEditar()){
        editarFamilia();
      } else {
        guardarFamilia();
      }
    }

    function comprobarCodigo(){
      if (vm.codigo==vm.familia.codigoFamiliaSuministro) {
        guardarOEditar();
      } else {
        FamiliaSuministroCodigoGrupo.query({codigo:vm.familia.codigoFamiliaSuministro, idGrupo:vm.familia.grupoSuministro.id}, function(data){
          if (data.length>0){
            ServicioDialogos.mostrarDialogoError(null, 'El código de familia de suministro ingresado ya existe en el grupo de suministro seleccionado');
          } else {
            guardarOEditar();
          }
        }, function(err){
          console.log(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar la familia de suministro");
        });
      }
    }

    function comprobarNombreGrupo(){
      FamiliaSuministroNombreGrupo.query({nombre:vm.familia.nombre, id:vm.familia.grupoSuministro.id},function(data){
        if (data.length>0){
          ServicioDialogos.mostrarDialogoError(null, 'El nombre ingresado ya existe en el grupo de suministro seleccionada');
        } else {
          comprobarCodigo();
        }
      }, function(err){
        console.error(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar la Familia de suministro");
      });
    }

    function editarFamilia(){
      FamiliaSuministro.update(vm.familia, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado la Familia de suministro correctamente', function(){
          $state.go('home.lista-familia-suministro');
        });
      }, function(err){
        console.error(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar la Familia de suministro");
      });
    }

    function editarObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar la Familia de suministro?', function(){
        if (vm.nombre==vm.familia.nombre && vm.grupo.id==vm.familia.grupoSuministro.id){
          if (vm.codigo==vm.familia.codigoFamiliaSuministro) {
            editarFamilia();
          } else {
            comprobarCodigo();
          }
        } else {
          comprobarNombreGrupo();
        }
      },null,false);
    }
     
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-categoria', {
        url: 'lista-categoria',
        templateUrl: 'app/app/main/suministro/categoria-peso/lista/lista-categoria.html',
        controller: 'ListaCategoriaCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Categorías de peso',
          subtitulo:'Lista de Categorías de peso'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          categorias: function(CategoriasPeso){
            return CategoriasPeso.query().$promise.then(function(data) {
              return data;
            });

          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaCategoriaCtrl', ListaCategoriaCtrl);

  /** @ngInject */
  function ListaCategoriaCtrl(NgTableParams, rol, HeaderBarService, CategoriasPeso, $timeout, $stateParams, $scope, orderByFilter, $state, categorias, ServicioDialogos) {
 HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.categorias = orderByFilter(categorias,'nombre',false);
    vm.mostrarInformacion = mostrarInformacion;
    vm.crearNuevo = crearNuevo;
    vm.editar = editar;
    vm.exportToExcel = exportToExcel;
    vm.eliminar = eliminar;
    vm.bloquearPorRol = bloquearPorRol;

    function bloquearPorRol(){
      return (rol.id!=1 && rol.id!=2);
    }

    if (rol.id!=1 && rol.id!=2) $state.go("home.home");

    function mostrarInformacion(categoria) {
      ServicioDialogos.mostrarDialogoInformacion(null, categoria.nombre.toUpperCase() + "\n Descripción: "+ categoria.descripcion);
    }

    function editar(categoria) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar la categoría de peso?', function() {
        $state.go('home.editar-categoria', {objeto:categoria.id, modo:'editar'});
      });
    }

    function crearNuevo() {
      $state.go('home.editar-categoria');
    }

    function eliminar(categoria){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Desea eliminar la Categoría de peso: \n"+categoria.nombre.toUpperCase()+"?",function(){
        CategoriasPeso.remove({id:categoria.id}, function(data){
          ServicioDialogos.mostrarDialogoInformacion(null, "Se ha eliminado la Categoría de peso con éxito");
          CategoriasPeso.query().$promise.then(function(categorias){
            vm.categorias = orderByFilter(categorias,'nombre',false);
            vm.tableParams.settings({
              data: vm.categorias
            });
            vm.tableParams.reload();
          }, function(err){
            console.log(err);
          });
        }, function(error){
          console.log(error);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar la Categoría de peso");
        });
      },null,false);
    }

    function exportToExcel(){ // ex: '#my-table'
      var array = [];
      for (var i = vm.categorias.length - 1; i >= 0; i--) {
        array.push({
          "Categoría peso" : vm.categorias[i].nombre,
          "Descripción": vm.categorias[i].descripcion
        });
      }
      alasql('SELECT * INTO XLSX("categorías-peso.xlsx",{headers:true}) FROM ?',[array]);
    }

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });
    vm.tableParams.settings({
      data: vm.categorias
    });
    vm.tableParams.reload();
    
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-categoria', {
        url: 'editar-categoria/:objeto/:modo',
        templateUrl: 'app/app/main/suministro/categoria-peso/editar/editar-categoria.html',
        controller: 'EditarCategoriaCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Categorías de peso',
          subtituloEditar:'Editar Categoría de peso',
          subtituloNuevo: 'Nueva Categoría de peso',
          modo:null,
          objeto:null
        },
        resolve:{
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          categoria: function(CategoriasPeso, $stateParams){
            if ($stateParams.objeto){
              return CategoriasPeso.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return {};
            }
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarCategoriaCtrl', EditarCategoriaCtrl);

  /** @ngInject */
  function EditarCategoriaCtrl(NgTableParams, rol, HeaderBarService, CategoriasPesoNombre, categoria, CategoriasPeso, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    inicializar();
    vm.cancelar = cancelar;
    vm.guardar = guardar;

    if (rol.id!=1 && rol.id!=2) $state.go("home.home");

    function inicializar(){
      setearTitulos();
      setearObjeto();
    }

    function setearObjeto(){
      if (esEditar()) {
        vm.categoria = categoria;
        vm.nombre = vm.categoria.nombre;

      }
    }

    function esEditar() {
      return $stateParams.modo=='editar';
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      if (esEditar()) {
        HeaderBarService.setSubTitulo($stateParams.subtituloEditar);
      } else {
        HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);
      }
    }

    function cancelar() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        $state.go('home.lista-categoria');
      });
    }

    function guardar() {
      if (esEditar()) {
        editarObjeto();
      } else {
        nuevoObjeto();
      }
    }

    function nuevoObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea registrar una nueva Categoría de peso?', function(){
        CategoriasPesoNombre.query({nombre:vm.categoria.nombre},function(data){
          if (data.length>0) {
            ServicioDialogos.mostrarDialogoError(null, 'El nombre ingresado ya existe');
          } else {
            CategoriasPeso.save(vm.categoria, function(data){
              ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha registrado la Categoría de peso correctamente', function(){
                $state.go('home.lista-categoria');
              });
            },function(error){
              console.error(error);
              ServicioDialogos.mostrarDialogoError(null, 'No se ha podido registrar la Categoría de peso');
            });
          }
        }, function(err){
          console.error(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar la Categoría de peso");
        });
      }, null, false);
    }

    function editarObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar la Categoría de peso?', function(){
        if (vm.nombre==vm.categoria.nombre) {
          CategoriasPeso.update(vm.categoria, function(data){
            ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado la Categoría de peso correctamente', function(){
              $state.go('home.lista-categoria');
            });
          }, function(err){
            console.error(err);
            ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar la Categoría de peso");
          });
        } else {
          CategoriasPesoNombre.query({nombre:vm.categoria.nombre},function(data){
            if (data.length>0){
              ServicioDialogos.mostrarDialogoError(null, 'El nombre ingresado ya existe');
            } else {
              CategoriasPeso.update(vm.categoria, function(data){
                ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado la Categoría de peso correctamente', function(){
                  $state.go('home.lista-categoria');
                });
              }, function(err){
                console.error(err);
                ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar la Categoría de peso");
              });
            }
          }, function(err){
            console.error(err);
            ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar la Categoría de peso");
          });
        }
      },null,false);
    }
     
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-transferencias-stock', {
        url: 'lista-transferencias-stock',
        templateUrl: 'app/app/main/movimientos/transferencias-stock/lista/lista.html',
        controller: 'ListaTransferenciasStockCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Transferencias de stock',
          subtitulo:'Lista de transferencias'
        },
        resolve: {
          transferencias: function(Transferencias, Usuario, TransferenciasDeposito, TransferenciasDepositoEmpresa){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              var deposito = usuario.empleado.deposito;
              var empresa = usuario.empleado.empresa;
              if (deposito){
                if (empresa){
                  return TransferenciasDepositoEmpresa.query({'idDeposito':deposito.id, 'idEmpresa':empresa.id}).$promise.then(function(data){
                    return data;
                  });
                } else {
                  return TransferenciasDeposito.query({'idDeposito':deposito.id}).$promise.then(function(data){
                    return data;
                  });
                }
              } else {
                return Transferencias.query({}).$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaTransferenciasStockCtrl', ListaTransferenciasStockCtrl);

  /** @ngInject */
  function ListaTransferenciasStockCtrl(NgTableParams, HeaderBarService, rol, $filter, focus, transferencias, Usuario, ProveedorEmpresa, TransferenciasDeposito, Transferencias, $stateParams, $scope, orderByFilter, $state, ServicioModales, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.rol = rol;
    vm.transferencias = orderByFilter(transferencias,'fecha',true);
    vm.visualizarTransferencia = visualizarTransferencia;
    vm.desdeHasta = desdeHasta;
    vm.crearNuevo = crearNuevo;
    vm.editar = editar;
    vm.eliminar = eliminar;
    vm.bandera = false;

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10,
    },{
      getData: function($defer,params){ return filtrarTabla($defer, params);}
    });
    vm.tableParams.reload();

    function desdeHasta(t){
      if (t.tipoDesde && t.tipoDesde.id ==2){
        if (t.tipoHasta && t.tipoHasta.id==3){
          return "De STOCK REGULAR a DONACIÓN";
        } else {
          return "De STOCK REGULAR a SCRAP-REPARACIÓN";
        }
      } else if (t.tipoDesde && t.tipoDesde.id == 3){
        if (t.tipoHasta && t.tipoHasta.id==2){
          return "De STOCK DONACIÓN a REGULAR";
        } else {
          return "De STOCK DONACIÓN a SCRAP-REPARACIÓN";
        }
      } else {
        if (t.tipoHasta && t.tipoHasta.id==2){
          return "De STOCK SCRAP-REPARACIÓN a REGULAR";
        } else {
          return "De STOCK SCRAP-REPARACIÓN a DONACIÓN";
        }
      }
    }

    function filtrarTabla($defer, params) {
      var filtros = params.filter();
      var filtrosNuevos = {};

      for (var key in filtros) {
        if (filtros.hasOwnProperty(key) && filtros[key]!=='') {
          switch(key) {
            case 'deposito.nombre':
              angular.extend(filtrosNuevos, {
                deposito: {
                nombre: filtros[key]
                }
              });
              break;
            case 'empresa.nombre':
              angular.extend(filtrosNuevos, {
                empresa: {
                nombre: filtros[key]
                }
              });
              break;
            default:
              filtrosNuevos[key] = filtros[key];
          }
        }
      }
      var filtrados = filtros ? $filter('filter')(vm.transferencias, filtrosNuevos) : vm.transferencias;
      filtrados = params.sorting() ? $filter('orderBy')(filtrados, params.orderBy()) : filtrados;
      if (filtrados && filtrados.length){
        params.total(filtrados.length);
        return $defer.resolve(filtrados.slice((params.page() - 1) * params.count(), params.page() * params.count()));
      } else {
        params.total(0);
        return $defer.resolve(null);
      }
    }
    
    function actualizarTabla(data){
      vm.transferencias = orderByFilter(data,'fecha',true);
      vm.tableParams.settings({
        data: vm.transferencias
      });
      vm.tableParams.reload();
    }

    function visualizarTransferencia(transferencia){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalVisualizarTransferencia({
        onResult: function(resultado) {
          console.log(resultado);
        },
        transferencia: transferencia,
        deposito: transferencia.deposito
      });
    }

    function editar(transferencia) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar la transferencia?', function() {
        $state.go('home.editar-transferencia', {objeto:transferencia.id, modo:'editar'});
      });
    }

    function eliminar(transferencia) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea eliminar la transferencia?', function() {
        anularIngreso(transferencia);
      });
    }

    function anularIngreso(transferencia){
      ServicioDialogos.abrirDialogoCargando();
      AnularTransferencia.update({idMovimiento:transferencia.id, idEstado:7}, function(data){
        obtenerUltimos();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar la transferencia");
      });

    }

    function obtenerUltimos(){
      Usuario.obtenerUsuario().$promise.then(function(usuario){
        if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
          TransferenciasDeposito.query({'idDeposito':usuario.empleado.deposito.id}).$promise.then(function(data){
            ServicioDialogos.cerrarDialogoCargando();
            actualizarTabla(data);
          }, function(err){
            console.error(err);
            ServicioDialogos.cerrarDialogoCargando();
          });
        } else {
          Transferencias.query({}).$promise.then(function(data){
            ServicioDialogos.cerrarDialogoCargando();
            actualizarTabla(data);
          }, function(err){
            console.error(err);
            ServicioDialogos.cerrarDialogoCargando();
          });
        }
      });
    }

    function crearNuevo() {
      $state.go('home.editar-transferencia');
    }
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-transferencia', {
        url: 'editar-transferencia',
        templateUrl: 'app/app/main/movimientos/transferencias-stock/editar/editar.html',
        controller: 'EditarTransferenciaCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar transferencia',
          subtituloNuevo:'Seleccionar suministros'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          usuario: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario;
            });
          },
          deposito: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.empleado.deposito;
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          tipos: function(){
            var tipos = [];
            tipos.push({nombre:"STOCK REGULAR", id:2});
            tipos.push({nombre:"DONACIÓN", id:3});
            tipos.push({nombre:"SCRAP-REPARACIÓN", id:4});
            return tipos;
          },
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data){
              return data;
            });
          }
        }
      });
  }
})();


(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarTransferenciaCtrl', EditarTransferenciaCtrl);

  /** @ngInject */
  function EditarTransferenciaCtrl(NgTableParams, usuario, orderByFilter, deposito, tipos, UltimaTransferencia, depositos, empresas, rol, ServicioModales, Transferencias, HeaderBarService, $stateParams, $filter, $state, $timeout, $scope, ServicioDialogos) {
    var vm = this;
    vm.cancelar = cancelar;
    vm.guardar = guardar;
    vm.deposito = deposito;
    vm.depositos = orderByFilter(depositos, 'nombre', false);
    vm.empresas = orderByFilter(empresas, 'nombre', false);
    vm.tipos = tipos;
    vm.volver = volver;
    vm.agregarDetalleTransferencia = agregarDetalleTransferencia;
    vm.cambiarSeleccion = cambiarSeleccion;
    vm.seleccionar = seleccionar;
    vm.quitarDetalle = quitarDetalle;

    inicializar();


    if (rol.id!=1 && rol.id!=2) $state.go("home.home");

    function quitarDetalle(detalle){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea quitar el detalle?', function(){
        var index = null;
        vm.detalles.forEach(function(item, i){
          if ((detalle.suministro && item.suministro && detalle.suministro.id==item.suministro.id) || (detalle.suministroInventariable && item.suministroInventariable && detalle.suministroInventariable.id===item.suministroInventariable.id)){
            index = i;
          }
        });
        if (index!==null) vm.detalles.splice(index, 1);
        actualizarTabla();
      });
    }

    function cambiarSeleccion(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "Si continúa, perderá la información ingresada que no haya sido guardada. \n¿Está seguro que desea continuar?", function(){
        $timeout(function() {
          vm.bandera=false;
          vm.detalles = [];
        }, 50);
      });
    }

    function seleccionar(){
      vm.bandera=true;
    }

    function agregarDetalleTransferencia(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalAgregarDetalleTransferencia({
        onResult: function(res){
          vm.detalles=res.detalles;
          actualizarTabla();
        },
        detalles: vm.detalles,
        empresa: vm.transferencia.empresa,
        deposito: vm.transferencia.deposito,
        tipoMovimiento: vm.transferencia.tipoDesde.id
      });
    }
    
    function volver(){
      $state.go("home.lista-transferencia-suministro");
    }


    function inicializar(){
      setearTitulos();
      armarObjetos();
      inicializarTabla();
    }

    function inicializarTabla(){
      vm.tableParams = new NgTableParams({
        page: 1,
        count: 10
      });
      vm.tableParams.settings({
        data: vm.detalles,
      });
      vm.tableParams.reload();
    }

    $scope.$watch('vm.transferencia.tipoDesde.id', function(){
      if (vm.transferencia.tipoHasta) vm.transferencia.tipoHasta=null;
      if (!vm.transferencia.tipoDesde) return;
      vm.tiposHasta = [];
      vm.tipos.forEach(function(item){
        if (item.id!=vm.transferencia.tipoDesde.id){
          vm.tiposHasta.push(item);
        }
      });
    });

    function actualizarTabla(){
      vm.tableParams.settings({
        data: vm.detalles,
      });
      vm.tableParams.reload();
    }

    function armarObjetos(){
      vm.transferencia = {};
      vm.detalles = [];
      vm.bandera=false;
      if (deposito) {
        vm.transferencia.deposito = deposito;
      }
      vm.fecha = $filter('date')(new Date(), 'dd/MM/yyyy HH:mm');
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);
    }

    function cancelar() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        $state.go('home.lista-transferencias-stock');
      });
    }


    function obtenerNumeroTransferencia(callback){
      UltimaTransferencia.get({}, function(data){
        if (data && !isNaN(data.id)){
          callback(data.id + 10001);
        } else {
          callback(10001);
        }
      }, function (err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
      });
    }

    function obtenerTransferencia(callback){
      obtenerNumeroTransferencia(function(data){
        var transferencia = {
          tipoDesde: {id:vm.transferencia.tipoDesde.id},
          tipoHasta: {id:vm.transferencia.tipoHasta.id},
          deposito: vm.transferencia.deposito,
          empresa: vm.transferencia.empresa,
          observacion: vm.transferencia.observacion,
          fecha: new Date(),
          detalles: vm.detalles,
          numeroTransferencia: data,
          usuario: usuario
        };
        callback(transferencia);
      });
    }


    function guardar() {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea transferir los bienes seleccionados de '+vm.transferencia.tipoDesde.nombre.toUpperCase()+' a '+vm.transferencia.tipoHasta.nombre.toUpperCase()+'?', function(){
        obtenerTransferencia(function(transferencia){
          Transferencias.save(transferencia, function(data){
            ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se han transferido los bienes correctamente', function(){
              $state.go('home.lista-transferencias-stock');
            });
          },function(error){
            console.error(error);
            ServicioDialogos.mostrarDialogoError(null, 'No se ha podido registrar la transferencia');
          });
        });
      }, null, false);
    }
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.visualizar-ingreso', {
        url: 'visualizar-ingreso/:objeto/:estadoAnterior',
        templateUrl: 'app/app/main/movimientos/ingreso/visualizar-ingreso/visualizar-ingreso.html',
        controller: 'VisualizarIngresoCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Ingreso de suministros',
          subtituloNuevo: 'Visualizar información del ingreso',
        },
        resolve: {
          ingreso: function(Ingreso, $stateParams){
            if ($stateParams.objeto){
              return Ingreso.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return $stateParams.objeto;
            }
          },
          estadoAnterior: function($stateParams){
            return $stateParams.estadoAnterior? $stateParams.estadoAnterior : 1;
          },
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('VisualizarIngresoCtrl', VisualizarIngresoCtrl);

  /** @ngInject */
  function VisualizarIngresoCtrl(NgTableParams, HeaderBarService, rol, URL_SERVIDOR, $http, $window, ServicioModales, estadoAnterior, ingreso, $stateParams, $filter, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);

    var vm = this;
    vm.ingreso = ingreso;
    vm.rol = rol;
    vm.volver = volver;
    inicializar();
    vm.editarSuministro = editarSuministro;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.ubicacionCompleta = ubicacionCompleta;
    vm.editarProblemas = editarProblemas;
    vm.comprobarIngresoCerrado = comprobarIngresoCerrado;
    vm.comprobarFotoProblema = comprobarFotoProblema;
    vm.imprimirInforme = imprimirInforme;
    vm.reporteNombre = reporteNombre;

    function reporteNombre(detalles){
      ServicioDialogos.abrirDialogoCargando();
      $http.get(URL_SERVIDOR+"/suministro/reporte/nombre/"+detalles.id, {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function imprimirInforme(){
      ServicioDialogos.abrirDialogoCargando();
      $http.get(URL_SERVIDOR+"/movimiento/reporte/movimiento/"+vm.ingreso.id, {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function comprobarFotoProblema(){
      var ban = false;
      vm.ingreso.problemas.forEach(function(item){
        if (item.encabezadoFoto){
          ban = true;
        }
      });
      return ban;
    }

    function editarProblemas(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea agregar o quitar problemas en este ingreso?', function(){
        $state.go('home.problemas-ingreso',{objeto:vm.ingreso.id});
      });
    }

    function inicializar(){
      vm.fecha=$filter('date')(vm.ingreso.fecha, 'dd/MM/yyyy HH:mm');
      vm.foto = vm.ingreso.encabezadoFoto + vm.ingreso.cuerpoFoto;
      vm.montoTotal = montoTotal();
      armarProblemas();
      crearTablas();
      actualizarTabla();
    }

    function armarProblemas(){
      vm.problemas = [];
      vm.ingreso.problemas.forEach(function(problema, i){
        problema.foto = problema.encabezadoFoto+problema.cuerpoFoto;
        problema.ind = i;
        vm.problemas.push(problema);
      });
    }

    function editarSuministro(suministro){
      if (suministro.suministro && suministro.suministro.tipoSuministro && suministro.suministro.tipoSuministro.inventariable) {
        editarSuministroInventariable(suministro);
      } else {
        editarSuministroNoInventariable(suministro);
      }
    }

    function editarSuministroInventariable(suministro){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Está seguro que desea editar la información del suministro?", function(){
        ServicioDialogos.abrirDialogoCargando();
        ServicioModales.abrirModalEditarSuministro({
          onResult: function(resultado){
            $window.location.reload();
          },
          suministro:suministro.suministroInventariable,
          modo:'editar'
        });
      });
    }

    function editarSuministroNoInventariable(suministro){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Está seguro que desea editar la información del suministro?", function(){
        ServicioDialogos.abrirDialogoCargando();
        ServicioModales.abrirModalEditarSuministroNoInventariable({
          onResult: function(resultado){
            $window.location.reload();
          },
          suministro:suministro.suministro,
          modo:'editar'
        });
      });
    }

    function volver(){
      if (estadoAnterior==2){
        $window.history.back();
      } else {
        if (vm.ingreso.caja){
          $state.go("home.lista-ingreso-cajas");
        } else {
          $state.go("home.lista-ingreso");
        }
      }
    }

    function montoTotal(){
      var total = 0;
      for(var i = 0; i < vm.ingreso.detalles.length; i++){
        total += vm.ingreso.detalles[i].suministro.precioUnitario*vm.ingreso.detalles[i].cantidad;
      }
      return total ? '$ '+total.toFixed(2) : "-";
    }

    function buscarCantidadPallets(){
      var mayor = vm.detallesInventariables[0].numeroRow;
      vm.detallesInventariables.forEach(function(detalle){
        if (detalle.numeroRow>mayor){
          mayor = detalle.numeroRow;
        }
      });
      return mayor;
    }

    function actualizarTablaInventariables(){
      vm.tableParamsStock.settings({
        data: vm.palletsInventariables,
        noPager: true,
        counts: []
      });
      vm.tableParamsStock.reload();
    }

    function actualizarTabla(){
      vm.tableParams.settings({
        data: orderByFilter(vm.ingreso.detalles,'numeroCaja',false),
        noPager: true,
        counts: []
      });
      vm.tableParams.reload();
      vm.tableParams1.settings({
        data: orderByFilter(vm.ingreso.problemas,'nombre', false),
        noPager: true,
        count: []
      });
      vm.tableParams1.reload();
    }

    function ubicacionNaveNumeroOrden(detalle){
      if (detalle.suministro && detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        return "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+detalle.suministro.ubicacion.numeroOrden;
      } else {
        return "El bien no posee una ubicación actual";
      }
    }

    function ubicacionCompleta(detalle){
      if (detalle.suministro && detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación",
        "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+detalle.suministro.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+detalle.suministro.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+detalle.suministro.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+detalle.suministro.ubicacion.numeroUbicacion+
        "\nN° de orden: "+detalle.suministro.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+detalle.suministro.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+detalle.suministro.ubicacion.categoriaPeso.nombre.toUpperCase());
      }
    }


    function crearTablas(){
      vm.tableParams = new NgTableParams({
        page: 1,
        count: 500
      });
      vm.tableParams1 = new NgTableParams({
        page:1,
        count:20
      });
    }

    function comprobarIngresoCerrado(){
      return vm.ingreso.estadoMovimiento.id==6;
    }
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.problemas-ingreso', {
        url: 'problemas-ingreso/:objeto',
        templateUrl: 'app/app/main/movimientos/ingreso/problemas/editar-problemas.html',
        controller: 'EditarProblemasCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Ingreso de suministros',
          subtituloNuevo: 'Agregar o quitar problemas en un ingreso de suministros',
        },
        resolve: {
          ingreso: function(Ingreso, $stateParams){
            if ($stateParams.objeto){
              return Ingreso.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return $stateParams.objeto;
            }
          },
          tiposProblema: function(TipoProblema){
            return TipoProblema.query().$promise.then(function(data){
              return data;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarProblemasCtrl', EditarProblemasCtrl);

  /** @ngInject */
  function EditarProblemasCtrl(NgTableParams, HeaderBarService, $window, ProblemaIngreso, ServicioModales, tiposProblema, ingreso, $stateParams, $filter, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);

    var vm = this;
    vm.ingreso = ingreso;
    vm.volver = volver;
    vm.tiposProblema = tiposProblema;
    vm.problemas = [];
    inicializar();
    vm.eliminarProblema = eliminarProblema;
    vm.editarProblemas = editarProblemas;
    vm.agregarProblema = agregarProblema;
    vm.verProblema = verProblema;
    vm.comprobarIngresoCerrado = comprobarIngresoCerrado;


    function inicializar(){
      vm.fecha=$filter('date')(vm.ingreso.fecha, 'dd/MM/yyyy HH:mm');
      vm.montoTotal = montoTotal();
      crearTablas();
      actualizarTabla();
      setearObservacion();
    }

    function setearObservacion(){
      if (!vm.ingreso.observacionProblema){
        vm.ingreso.observacionProblema='';
      }
    }

    function verProblema(problema){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalFotoProblema({
        onResult: function(res) {
          console.log(res);
        },
        problema: problema
      });
    }

    function estaProblema(){
      var esta = false;
      vm.ingreso.problemas.forEach(function(prob){
        if (vm.tipoProblema.id==prob.tipoProblema.id){
          esta = true;
        }
      });
      return esta;
    }

    function agregarProblema(){
      if (estaProblema()){
        ServicioDialogos.mostrarDialogoError(null, "El problema seleccionado, ya fue asignado al ingreso");
      } else {
        var problema = {
          tipoProblema: vm.tipoProblema
        };
        vm.ingreso.problemas.push(problema);
        actualizarTabla();
      }
    }

    function editarProblemas(problema){
      if (vm.ingreso.observacionProblema.length==0 && vm.ingreso.problemas.length>0){
        ServicioDialogos.mostrarDialogoError(null, "Si agrega un problema, debe ingresar una descripción");
      } else if (vm.ingreso.observacionProblema.length>0 && vm.ingreso.problemas.length==0) {
        ServicioDialogos.mostrarDialogoError(null, "Si agrega una descripción, debe agregar al menos un problema");
      } else {
        editarProblemaIngreso(problema);
      }
    }

    function editarProblemaIngreso(problema){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Está seguro que desea guardar la edición de los problemas en este ingreso?", function(){
        ProblemaIngreso.update(vm.ingreso, function(data){
          ServicioDialogos.mostrarDialogoGuardadoExito(null, "Se ha registrado correctamente la información de los problemas", function(){
            $state.go('home.visualizar-ingreso', {objeto:vm.ingreso.id});
          });
        }, function(err){
          console.log(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar la información de los problemas");
        });
      }, null, false);
    }

    function eliminarProblema(index){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "La eliminación de un problema, se verá reflejada en el ingreso, cuando presione el botón 'GUARDAR', una vez que termine la edición\n¿Está seguro que desea eliminar el problema en este ingreso?", function(){
        vm.ingreso.problemas.splice(index, 1);
        actualizarTabla();
      });
    }

    function volver(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "No se guardará ningún cambio. ¿Está seguro que desea cancelar", function(){
        $state.go('home.visualizar-ingreso', {objeto:vm.ingreso.id});
      });
    }

    function montoTotal(){
      var total = 0;
      for(var i = 0; i < vm.ingreso.detalles.length; i++){
        total += vm.ingreso.detalles[i].suministro.precioUnitario*vm.ingreso.detalles[i].cantidad;
      }
      return total ? '$ '+total.toFixed(2) : "-";
    }

    function actualizarTabla(){
      vm.tableParams.settings({
        data: orderByFilter(vm.ingreso.problemas,'tipoProblema.nombre',false),
        noPager: true,
        counts: []
      });
      vm.tableParams.reload();
    }

    function crearTablas(){
      vm.tableParams = new NgTableParams({
        page: 1,
        count: 500
      });
    }

    function comprobarIngresoCerrado(){
      return vm.ingreso.estadoMovimiento.id==6;
    }
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-ingreso-cajas', {
        url: 'lista-ingreso-cajas',
        templateUrl: 'app/app/main/movimientos/ingreso/lista-cajas/lista-ingreso-cajas.html',
        controller: 'ListaIngresoCajasCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar ingresos',
          subtitulo:'Lista de ingresos de cajas cerradas'
        },
        resolve: {
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data){
              return data;
            });
          },
          ingresos: function(IngresoUltimosCincuentaCajas, Usuario, IngresoDepositoEmpresa, IngresoUltimosCincuentaDepositoCajas){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              var deposito = usuario.empleado.deposito;
              var empresa = usuario.empleado.empresa;
              if (deposito){
                if (empresa){
                  return IngresoDepositoEmpresa.query({'idTipo':2,'idDeposito':deposito.id, 'idEmpresa':empresa.id,'cajas':true}).$promise.then(function(data){
                    return data;
                  });
                } else {
                  return IngresoUltimosCincuentaDepositoCajas.query({'idDeposito':deposito.id}).$promise.then(function(data){
                    return data;
                  });
                }
              } else {
                return IngresoUltimosCincuentaCajas.query().$promise.then(function(data){
                  if (usuario.empleado && usuario.rol && usuario.rol.nombre=='CONSULTA' && usuario.empleado.empresas && usuario.empleado.empresas.length>0) {
                    var movimientos = [];
                    data.forEach(function(movimiento){
                      if (usuario.empleado.empresas.includes(movimiento.empresa.id)){
                        movimientos.push(movimiento);
                      }
                    });
                    return movimientos;
                  }
                  return data;
                });
              }
            });
          },
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          }

        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaIngresoCajasCtrl', ListaIngresoCajasCtrl);

  /** @ngInject */
  function ListaIngresoCajasCtrl(NgTableParams, rol, HeaderBarService, $filter, focus, ingresos, empresas, Usuario, IngresoEstadoModificar , ProveedorEmpresa, IngresoUltimosCincuentaDepositoCajas, IngresoUltimosCincuentaCajas, $stateParams, $scope, orderByFilter, $state, ServicioModales, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.rol = rol;
    vm.empresas = orderByFilter(empresas,'nombre',false);
    vm.ingresos = orderByFilter(ingresos,'fecha',true);
    vm.irAsignarUbicaciones = irAsignarUbicaciones;
    vm.visualizarIngreso = visualizarIngreso;
    vm.crearNuevo = crearNuevo;
    vm.verNumeroCajasIngreso = verNumeroCajasIngreso;
    vm.editar = editar;
    vm.eliminar = eliminar;
    vm.filtrar = filtrar;
    vm.bandera = false;
    vm.busqueda = busqueda;
    vm.abrirModalFiltros = abrirModalFiltros;

    function verNumeroCajasIngreso(ingreso){
      var numeros = [];
      var hash = {};
      ingreso.detalles.forEach(function(item){
        numeros.push(item.numeroCaja);
      });
      numeros = numeros.filter(function(current) {
        var exists = !hash[current] || false;
        hash[current] = true;
        return exists;
      });
      ServicioDialogos.mostrarDialogoInformacion("N° de Cajas cerradas", "Este ingreso tiene asignadas las cajas cerradas N°:\n"+numeros);
    }

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10,
    },{
      getData: function($defer,params){ return filtrarTabla($defer, params);}
    });
    vm.tableParams.reload();


    function filtrarTabla($defer, params) {
      var filtros = params.filter();
      var filtrosNuevos = {};

      for (var key in filtros) {
        if (filtros.hasOwnProperty(key) && filtros[key]!=='') {
          switch(key) {
            case 'deposito.nombre':
              angular.extend(filtrosNuevos, {
                deposito: {
                nombre: filtros[key]
                }
              });
              break;
            case 'empresa.nombre':
              angular.extend(filtrosNuevos, {
                empresa: {
                nombre: filtros[key]
                }
              });
              break;
            case 'proveedor.nombre':
              angular.extend(filtrosNuevos, {
                proveedor: {
                nombre: filtros[key]
                }
                });
              break;
            case 'estadoMovimiento.nombre':
              angular.extend(filtrosNuevos, {
                estadoMovimiento: {
                nombre: filtros[key]
                }
              });
              break;
            default:
              filtrosNuevos[key] = filtros[key];
          }
        }
      }
      var filtrados = filtros ? $filter('filter')(vm.ingresos, filtrosNuevos) : vm.ingresos;
      filtrados = params.sorting() ? $filter('orderBy')(filtrados, params.orderBy()) : filtrados;
      if (filtrados && filtrados.length){
        params.total(filtrados.length);
        return $defer.resolve(filtrados.slice((params.page() - 1) * params.count(), params.page() * params.count()));
      } else {
        params.total(0);
        return $defer.resolve(null);
      }
    }

    function abrirModalFiltros(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalFiltroBusquedaIngresoCajas({
        onResult: function(resultado){
          vm.bandera=true;
          vm.filtrosUsados = resultado.filtros;
          actualizarTabla(resultado.detalles);
        },
        tipo: 2
      });
    }

    function busqueda(){
      vm.bandera=false;
      vm.filtrosUsados=null;
      if (vm.buscar) {
        vm.ingresos=null;
        actualizarTabla(vm.ingresos);
      } else {
        filtrar();
      }
    }
    
    function actualizarTabla(data){
      vm.ingresos = orderByFilter(data,'fecha',true);
      vm.tableParams.settings({
        data: vm.ingresos
      });
      vm.tableParams.reload();
    }

    function filtrar(){
      ServicioDialogos.abrirDialogoCargando();
      if (!vm.buscar){
        obtenerUltimos();
      } else {
        actualizarTabla(undefined);
      }

    }

    function irAsignarUbicaciones(ingreso) {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Desea asignar ubicaciones a los suministros de este ingreso de cajas cerradas ?', function() {
        $state.go('home.asignar-ubicaciones-cajas', {objeto:ingreso.id});
      });
    }

/*    function visualizarIngreso(ingreso){
        $state.go('home.visualizar-ingreso', {objeto:ingreso.id});
    }
*/
    function visualizarIngreso(ingreso){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalVisualizarIngreso({
        onResult: function(resultado) {
          console.log(resultado);
        },
        ingreso: ingreso,
        deposito: ingreso.deposito
      });
    }


    function editar(ingreso) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el ingreso de cajas cerradas?', function() {
        $state.go('home.editar-ingreso', {objeto:ingreso.id, modo:'editar'});
      });
    }

    function eliminar(ingreso) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea eliminar el ingreso de cajas cerradas?', function() {
        anularIngreso(ingreso);
      });
    }

    function anularIngreso(ingreso){
      ServicioDialogos.abrirDialogoCargando();
      IngresoEstadoModificar.update({idMovimiento:ingreso.id, idEstado:7}, function(data){
        obtenerUltimos();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar el ingreso");
      });

    }

    function obtenerUltimos(){
      Usuario.obtenerUsuario().$promise.then(function(usuario){
        if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
          IngresoUltimosCincuentaDepositoCajas.query({'idDeposito':usuario.empleado.deposito.id}).$promise.then(function(data){
            ServicioDialogos.cerrarDialogoCargando();
            actualizarTabla(data);
          }, function(err){
            console.error(err);
            ServicioDialogos.cerrarDialogoCargando();
          });
        } else {
          IngresoUltimosCincuentaCajas.query({}).$promise.then(function(data){
            ServicioDialogos.cerrarDialogoCargando();
            actualizarTabla(data);
          }, function(err){
            console.error(err);
            ServicioDialogos.cerrarDialogoCargando();
          });
        }
      });
    }

    function crearNuevo() {
      $state.go('home.editar-ingreso', {caja:true});
    }

    $scope.$watch('vm.empresaFiltro2.nombre', function(){
      if (vm.proveedor) vm.proveedor=null;
      if (!vm.empresaFiltro2 || !vm.empresaFiltro2.nombre) return;
      ServicioDialogos.abrirDialogoCargando();
      ProveedorEmpresa.query({empresa:vm.empresaFiltro2.id}, function(data){
        vm.proveedores = data;
        focus('proveedor');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-ingreso', {
        url: 'lista-ingreso',
        templateUrl: 'app/app/main/movimientos/ingreso/lista/lista-ingreso.html',
        controller: 'ListaIngresoCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar ingresos',
          subtitulo:'Lista de ingresos'
        },
        resolve: {
          ingresos: function(IngresoUltimosCincuenta, Usuario, IngresoUltimosCincuentaDeposito, IngresoUltimosCienDepositoEmpresa){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              var deposito = usuario.empleado.deposito;
              var empresa = usuario.empleado.empresa;
              if (deposito){
                if (empresa){
                  return IngresoUltimosCienDepositoEmpresa.query({'idDeposito':deposito.id, 'idEmpresa':empresa.id}).$promise.then(function(data){
                    return data;
                  });
                } else {
                  return IngresoUltimosCincuentaDeposito.query({'idDeposito':deposito.id}).$promise.then(function(data){
                    return data;
                  });
                }
              } else {
                return IngresoUltimosCincuenta.query({}).$promise.then(function(data){
                  if (usuario.empleado && usuario.rol && usuario.rol.nombre=='CONSULTA' && usuario.empleado.empresas && usuario.empleado.empresas.length>0) {
                    var movimientos = [];
                    data.forEach(function(movimiento){
                      if (usuario.empleado.empresas.includes(movimiento.empresa.id)){
                        movimientos.push(movimiento);
                      }
                    });
                    return movimientos;
                  }
                  return data;
                });
              }
            });
          },
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaIngresoCtrl', ListaIngresoCtrl);

  /** @ngInject */
  function ListaIngresoCtrl(NgTableParams, $timeout, HeaderBarService, rol, $filter, focus, ingresos, Usuario, IngresoEstadoModificar , ProveedorEmpresa, IngresoUltimosCincuentaDeposito, IngresoUltimosCincuenta, IngresoUltimosCienDepositoEmpresa, $stateParams, $scope, orderByFilter, $state, ServicioModales, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.rol = rol;
/*    vm.depositos = orderByFilter(depositos,'nombre',false);
    vm.empresas = orderByFilter(empresas,'nombre',false);
*/    vm.ingresos = orderByFilter(ingresos,'fecha',true);
    vm.irAsignarUbicaciones = irAsignarUbicaciones;
    vm.visualizarIngreso = visualizarIngreso;
    vm.crearNuevo = crearNuevo;
    vm.editar = editar;
    vm.eliminar = eliminar;
    vm.filtrar = filtrar;
    vm.bandera = false;
    vm.busqueda = busqueda;
    vm.abrirModalFiltros = abrirModalFiltros;
    vm.abrirModalFiltrosSuministro = abrirModalFiltrosSuministro;
    vm.abrirModalNumeroMovimiento = abrirModalNumeroMovimiento;
    vm.abrirModalNumeroRemito = abrirModalNumeroRemito;
    vm.abrirModalNumeroOrdenCompra = abrirModalNumeroOrdenCompra;
    vm.abrirModalFechaIngresoManual = abrirModalFechaIngresoManual;

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10,
    },{
      getData: function($defer,params){ return filtrarTabla($defer, params);}
    });
    vm.tableParams.reload();

    function abrirModalFechaIngresoManual(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalFechaIngresoManual({
        onResult: function(resultado){
          vm.bandera=true;
          vm.filtrosUsados = resultado.filtros;
          actualizarTabla(resultado.detalles);
        }
      });
    }

    function abrirModalNumeroOrdenCompra(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalFiltroIngresoOrdenCompra({
        onResult: function(resultado){
          vm.bandera=true;
          vm.filtrosUsados = resultado.filtros;
          actualizarTabla(resultado.detalles);
        }
      });
    }

    function abrirModalNumeroRemito(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalFiltroIngresoRemito({
        onResult: function(resultado){
          vm.bandera=true;
          vm.filtrosUsados = resultado.filtros;
          actualizarTabla(resultado.detalles);
        }
      });
    }

    function abrirModalNumeroMovimiento(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalFiltroIngresoNumeroMovimiento({
        onResult: function(resultado){
          vm.bandera=true;
          vm.filtrosUsados = resultado.filtros;
          actualizarTabla(resultado.detalles);
        },
        tipo: 2
      });
    }


    function abrirModalFiltrosSuministro(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalFiltroBusquedaIngresoSuministro({
        onResult: function(resultado){
          vm.bandera=true;
          vm.filtrosUsados = resultado.filtros;
          actualizarTabla(resultado.detalles);
        }
      });
    }


    function filtrarTabla($defer, params) {
      var filtros = params.filter();
      var filtrosNuevos = {};
      for (var key in filtros) {
        if (filtros.hasOwnProperty(key) && filtros[key]!=='') {
          switch(key) {
            case 'deposito.nombre':
              angular.extend(filtrosNuevos, {
                deposito: {
                nombre: filtros[key]
                }
              });
              break;
            case 'empresa.nombre':
              angular.extend(filtrosNuevos, {
                empresa: {
                nombre: filtros[key]
                }
              });
              break;
            case 'proveedor.nombre':
              angular.extend(filtrosNuevos, {
                proveedor: {
                nombre: filtros[key]
                }
                });
              break;
            case 'estadoMovimiento.nombre':
              angular.extend(filtrosNuevos, {
                estadoMovimiento: {
                nombre: filtros[key]
                }
              });
              break;
            default:
              filtrosNuevos[key] = filtros[key];
          }
        }
      }
      var filtrados = filtros ? $filter('filter')(vm.ingresos, filtrosNuevos) : vm.ingresos;
      filtrados = params.sorting() ? $filter('orderBy')(filtrados, params.orderBy()) : filtrados;
      if (filtrados && filtrados.length){
        params.total(filtrados.length);
        return $defer.resolve(filtrados.slice((params.page() - 1) * params.count(), params.page() * params.count()));
      } else {
        params.total(0);
        return $defer.resolve(null);
      }
    }

    function abrirModalFiltros(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalFiltroBusquedaIngreso({
        onResult: function(resultado){
          vm.bandera=true;
          vm.filtrosUsados = resultado.filtros;
          actualizarTabla(resultado.detalles);
        }
      });
    }

    function busqueda(){
      vm.bandera=false;
      vm.filtrosUsados=null;
      if (vm.buscar) {
        vm.ingresos=null;
        actualizarTabla(vm.ingresos);
      } else {
        filtrar();
      }
    }
    
    function actualizarTabla(data){
      vm.ingresos = orderByFilter(data,'fecha',true);
      vm.tableParams.settings({
        data: vm.ingresos
      });
      vm.tableParams.reload();
    }

    function filtrar(){
      ServicioDialogos.abrirDialogoCargando();
      if (!vm.buscar){
        obtenerUltimos();
      } else {
        actualizarTabla(undefined);
      }

    }

    function irAsignarUbicaciones(ingreso) {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Desea asignar ubicaciones a los suministros de este ingreso?', function() {
        $state.go('home.asignar-ubicaciones', {objeto:ingreso.id});
      });
    }

    function visualizarIngreso(ingreso){
      var fechaIngresoAnt = ingreso.fechaIngreso;
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalVisualizarIngreso({
        onResult: function(resultado) {
          if (resultado.fechaIngreso!=fechaIngresoAnt) {
            actualizarIngresosFechaIngreso(ingreso.id, resultado.fechaIngreso);
          }
        },
        ingreso: ingreso,
        deposito: ingreso.deposito
      });
    }

    function actualizarIngresosFechaIngreso(id, fechaIngreso){
      vm.ingresos.forEach(function(item){
        if (item.id===id){
          item.fechaIngreso = fechaIngreso;
        }
      });
      actualizarTabla(vm.ingresos);
    }

    function editar(ingreso) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el ingreso?', function() {
        $state.go('home.editar-ingreso', {objeto:ingreso.id, modo:'editar'});
      });
    }

    function eliminar(ingreso) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea eliminar el ingreso?', function() {
        anularIngreso(ingreso);
      });
    }

    function anularIngreso(ingreso){
      ServicioDialogos.abrirDialogoCargando();
      IngresoEstadoModificar.update({idMovimiento:ingreso.id, idEstado:7}, function(data){
        obtenerUltimos();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar el ingreso");
      });

    }

    function obtenerUltimos(){
      Usuario.obtenerUsuario().$promise.then(function(usuario){
        if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
          IngresoUltimosCincuentaDeposito.query({'idDeposito':usuario.empleado.deposito.id}).$promise.then(function(data){
            ServicioDialogos.cerrarDialogoCargando();
            actualizarTabla(data);
          }, function(err){
            console.error(err);
            ServicioDialogos.cerrarDialogoCargando();
          });
        } else {
          IngresoUltimosCincuenta.query({}).$promise.then(function(data){
            ServicioDialogos.cerrarDialogoCargando();
            actualizarTabla(data);
          }, function(err){
            console.error(err);
            ServicioDialogos.cerrarDialogoCargando();
          });
        }
      });
    }

    function crearNuevo() {
      $state.go('home.editar-ingreso');
    }

    $scope.$watch('vm.empresaFiltro2.nombre', function(){
      if (vm.proveedor) vm.proveedor=null;
      if (!vm.empresaFiltro2 || !vm.empresaFiltro2.nombre) return;
      ServicioDialogos.abrirDialogoCargando();
      ProveedorEmpresa.query({empresa:vm.empresaFiltro2.id}, function(data){
        vm.proveedores = data;
        focus('proveedor');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-ingreso', {
        url: 'editar-ingreso',
        templateUrl: 'app/app/main/movimientos/ingreso/editar/editar-ingreso.html',
        controller: 'EditarIngresoCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Ingreso de suministros',
          subtituloEditar:'Editar ingreso',
          subtituloNuevo: 'Nuevo ingreso',
          ingreso:null,
          editar:null,
          caja:null
        },
        resolve: {
          ingreso: function($stateParams){
            return $stateParams.ingreso? $stateParams.ingreso : {};
          },
          usuario: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario;
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          deposito: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return usuario.empleado.deposito;
              } else {
                return ;
              }
            });
          },
          tipoIngreso: function(TipoMovimiento){
            return TipoMovimiento.get({id:2}).$promise.then(function(data) {
              return data;
            });
          },
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data){
              return data;
            });
          },
          proveedores: function(ProveedorEmpresa, $stateParams){
            if ($stateParams.ingreso){
              return ProveedorEmpresa.query({empresa:$stateParams.ingreso.empresa.id}).$promise.then(function(data){
                return data;
              });
            } else {
              return [];
            }
          },
          caja: function($stateParams){
            return $stateParams.caja;
          },
          personas: function(PersonaProveedorNombreProveedor, $stateParams){
            if ($stateParams.ingreso){
              return PersonaProveedorNombreProveedor.query({id:$stateParams.ingreso.proveedor.id}).$promise.then(function(data){
                return data;
              });
            } else {
              return [];
            }
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarIngresoCtrl', EditarIngresoCtrl);

  /** @ngInject */
  function EditarIngresoCtrl(NgTableParams, deposito, usuario, SucursalEmpresa, PersonaEmpresaLogisticaEmpresa, HeaderBarService, ServicioModales, caja, ingreso, focus, proveedores, personas, EmpresaLogisticaEmpresa, PersonaProveedorNombreProveedor, ProveedorEmpresa, depositos, tipoIngreso, empresas, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    ingreso.empresa? HeaderBarService.setSubTitulo($stateParams.subtituloEditar) : HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);

    var vm = this;
    vm.tipoIngreso = tipoIngreso;
    vm.depositos = orderByFilter(depositos,'nombre',false);
    vm.empresas = orderByFilter(empresas,'nombre',false);
    vm.ingreso = ingreso;
    vm.ingreso.deposito=deposito;
    vm.ingreso.usuario = usuario;
    vm.siguiente = siguiente;
    vm.cancelar = cancelar;
    vm.proveedores = proveedores;
    vm.personas = personas;
    vm.ingreso.caja = caja===true? true : false;


    window.onbeforeunload = function(){
      return "seguro?";
    };

    function cancelar(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea cancelar el ingreso?', function() {
        $state.go('home.lista-ingreso');
      });
    }

    function siguiente(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, 'Verifique los datos. ¿Desea continuar con el agregado de suministros en el ingreso?', function() {
        $state.go('home.agregar-suministros-ingreso', {'objeto':vm.ingreso});
      });
    }

    function esEditar(){
      return vm.modo == "editar";
    }


    $scope.$watch('vm.ingreso.empresa.nombre', function(){
      if (!vm.form.$dirty) {
        return;
      }
      if (vm.ingreso.proveedor) vm.ingreso.proveedor=null;
      if (vm.ingreso.empresaLogistica) vm.ingreso.empresaLogistica=null;
      if (!vm.ingreso.empresa || !vm.ingreso.empresa.nombre) return;
      ServicioDialogos.abrirDialogoCargando();
      buscarProveedoresYEmpresasLogistica();
    });


    function buscarProveedoresYEmpresasLogistica(){
      ProveedorEmpresa.query({empresa:vm.ingreso.empresa.id}, function(data){
        EmpresaLogisticaEmpresa.query({idEmpresa:vm.ingreso.empresa.id}, function(datos){
          SucursalEmpresa.query({id:vm.ingreso.empresa.id}, function(sucursales){
            vm.sucursales = orderByFilter(sucursales, "nombre", false);
            vm.proveedores = orderByFilter(data, "nombre", false);
            vm.empresasLogistica = orderByFilter(datos, "nombre", false);
            focus('proveedor');
            ServicioDialogos.cerrarDialogoCargando();
          }, function(e){
            console.log(e);
            ServicioDialogos.cerrarDialogoCargando();
            ServicioDialogos.mostrarDialogoError();
          });
        }, function(er){
          console.log(er);
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError();
        });
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    }

    $scope.$watch('vm.ingreso.proveedor.id', function(){
      if (!vm.form.$dirty) {
        vm.form.$setDirty();
        return;
      }
      if (vm.ingreso.personaProveedor) vm.ingreso.personaProveedor=null;
      if (!vm.ingreso.empresa || !vm.ingreso.empresa.nombre || !vm.ingreso.proveedor || !vm.ingreso.proveedor.id) return;
      ServicioDialogos.abrirDialogoCargando();
      PersonaProveedorNombreProveedor.query({id:vm.ingreso.proveedor.id}, function(data){
        vm.personas = data;
        if (vm.personas.length>0){
          focus('personaProveedor');
        } else {
          focus('empresaLogistica');
        }
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.ingreso.empresaLogistica.id', function(valorNuevo, valorAnterior){
      if (valorNuevo === valorAnterior) return;
      if (!vm.form.$dirty) {
        vm.form.$setDirty();
        return;
      }
      if (vm.ingreso.personaEmpresaLogistica) vm.ingreso.personaEmpresaLogistica=null;
      if (!vm.ingreso.empresa || !vm.ingreso.empresa.nombre || !vm.ingreso.empresaLogistica || !vm.ingreso.empresaLogistica.id) return;
      ServicioDialogos.abrirDialogoCargando();
      PersonaEmpresaLogisticaEmpresa.query({id:vm.ingreso.empresaLogistica.id}, function(data){
        vm.personasLogistica = data;
        if (vm.personasLogistica.length>0){
          focus('personaEmpresaLogistica');
        } else {
          focus('solicitante');
        }
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });


  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.asignar-ubicaciones-cajas', {
        url: 'asignar-ubicaciones-cajas/:objeto',
        templateUrl: 'app/app/main/movimientos/ingreso/asignar-ubicaciones-cajas/asignar-ubicaciones-cajas.html',
        controller: 'AsignarUbicacionesCajasCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Ingreso de suministros',
          subtitulo: 'Asignar ubicaciones a cajas cerradas',
          objeto:null
        },
        resolve: {
          estadoIngresoCerrado: function(EstadoMovimiento){
            return EstadoMovimiento.get({id:6}).$promise.then(function(data) {
              return data;
            });
          },
          ingreso: function(Ingreso, $stateParams){
            if ($stateParams.objeto){
              return Ingreso.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return $stateParams.objeto;
            }
          }
        }
      });
  }
})();
(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('AsignarUbicacionesCajasCtrl', AsignarUbicacionesCajasCtrl);

  /** @ngInject */
  function AsignarUbicacionesCajasCtrl(NgTableParams, $sce, $q, Suministro, IngresoEstadoModificar, SuministroUbicacion, HeaderBarService, Deposito, focus, $filter, $stateParams, ingreso, estadoIngresoCerrado, $scope, orderByFilter, $state, ServicioDialogos, ServicioModales) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;

    vm.ingreso = ingreso;
    vm.estadoIngresoCerrado = estadoIngresoCerrado;
    vm.montoTotal = montoTotal;
    inicializar();
    vm.asignarAutomaticamente = asignarAutomaticamente;
    vm.asignarIndividual = asignarIndividual;
    vm.ubicacionCompleta = ubicacionCompleta;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.limpiarUbicaciones = limpiarUbicaciones;
    vm.removerIndividual = removerIndividual;
    vm.comprobarUbicaciones = comprobarUbicaciones;
    vm.comprobarIngresoCerrado = comprobarIngresoCerrado;
    vm.volver = volver;


    function comprobarIngresoCerrado(){
      return (vm.ingreso && vm.ingreso.estadoMovimiento.id==5);
    }

    function volver(){
        ServicioDialogos.mostrarDialogoConfirmacionWarning(
          null,
          "¿Está seguro que desea volver al listado de ingresos de cajas cerradas?",
          function(){
            $state.go("home.lista-ingreso-cajas");
          }
        );
    }

    function comprobarUbicaciones(){
      var contador = 0;
      vm.asignadas.forEach(function(ubicacion){
        contador = contador + ubicacion.cantidad;
      });
      if (contador==vm.palletsInventariables.length){
        abrirDialogoConfirmacionGuardar();
      } else {
        ServicioDialogos.mostrarDialogoError(null, "No ha asignado todas las ubicaciones");
      }
    }

    function abrirDialogoConfirmacionGuardar(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Desea asignar las ubicaciones?", function(){
        ServicioModales.abrirModalOcuparUbicacionesCajas({
          onResult: function(resultado) {
            console.log(resultado);
            vm.palletsInventariables=resultado.pallets;
            guardarUbicaciones();
          },
          palletsInventariables: vm.palletsInventariables,
          asignadas: vm.asignadas
        });
      });
    }

    function guardarUbicaciones(){
      guardarUbicacionesInventariables()
      .then(function(){
        actualizarEstadoIngreso();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido asignar las ubicaciones");
      });
    }

    function actualizarEstadoIngreso(){
      IngresoEstadoModificar.update({idMovimiento:vm.ingreso.id, idEstado:vm.estadoIngresoCerrado.id}, function(data){
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoGuardadoExito(null, "Se han asignado las ubicaciones correctamente", function(){
          $state.go('home.lista-ingreso-cajas');
        });
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido asignar las ubicaciones");
      });
    }

    function guardarUbicacionesNoInventariables(){
      var defer = $q.defer();
      var promise = defer.promise;
      vm.detallesNoInventariables.forEach(function(detalle){
        var ubicacion = detalle.ubicacion.id;
        var suministro = detalle.suministro.id;
        var ocupar = detalle.ocupar;
        promise = promise.then(function(){
          return guardarUbicacionSuministro(suministro, ubicacion, ocupar).then(function(){
            defer.resolve(true);
          });
        });
      });
      defer.resolve(true);
      return promise;
    }

    function guardarUbicacionesInventariables(){
      var defer = $q.defer();
      var promise = defer.promise;
      if (vm.palletsInventariables && vm.palletsInventariables.length>0){
        vm.palletsInventariables.forEach(function(pallet){
          promise = promise.then(function(){
            return guardarDetallesInventariables(pallet).then(function(){
              defer.resolve(true);
            });
          });
        });
      }
      defer.resolve(true);
      return promise;
    }

    function guardarDetallesInventariables(pallet){
      var defer = $q.defer();
      var promise = defer.promise;
      var ubicacion = pallet.ubicacion.id;
      var ocupar = pallet.ocupar;
      pallet.detalles.forEach(function(detalle){
        promise = promise.then(function(){
          return guardarUbicacionSuministro(detalle.suministro.id, ubicacion, ocupar).then(function(){
            defer.resolve(true);
          });
        });
      });
      defer.resolve(true);
      return promise;
    }

    function guardarUbicacionSuministro(suministro, ubicacion, ocupar){
      return SuministroUbicacion.update({'idSuministro': suministro,'idUbicacion':ubicacion,'ocupar':ocupar}).$promise.then(function(data) {
        return data;
      });
    }

    function inicializar(){
      if (!vm.ingreso){
        return;
      }
      if (vm.ingreso && !vm.ingreso.caja){
        $state.go('home.asignar-ubicaciones', {objeto: ingreso.id});
      }
      vm.fecha=$filter('date')(vm.ingreso.fecha, 'dd/MM/yyyy HH:mm');
      vm.personaProveedor = personaProveedor();
      vm.personaEmpresaLogistica = personaEmpresaLogistica();
      vm.montoTotal = montoTotal();
      vm.asignadas = [];
      crearTablas();
      cargarDetalles();
      setearOcuparUbicaciones();
    }

    function personaProveedor(){
      if (vm.ingreso.personaProveedor){
        return vm.ingreso.personaProveedor.apellido.toUpperCase()+", "+vm.ingreso.personaProveedor.nombre.toUpperCase();
      }
    }

    function personaEmpresaLogistica(){
      if (vm.ingreso.personaEmpresaLogistica){
        return vm.ingreso.personaEmpresaLogistica.apellido.toUpperCase()+", "+vm.ingreso.personaEmpresaLogistica.nombre.toUpperCase();
      }
    }


    function setearOcuparUbicaciones(){
      if (vm.palletsInventariables && vm.palletsInventariables.length>0){
        vm.palletsInventariables.forEach(function(pallet){
          pallet.ocupar = true;
        });
      }
      vm.detallesNoInventariables.forEach(function(detalle){
        detalle.ocupar=true;
      });
    }

    function limpiarUbicaciones(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Desea limpiar todas las ubicaciones asignadas?', function(){
        if (vm.palletsInventariables && vm.palletsInventariables.length>0){
          vm.palletsInventariables.forEach(function(detalle){
            if (detalle.ubicacion) detalle.ubicacion=null;
          });
        }
        vm.detallesNoInventariables.forEach(function(detalle){
          if (detalle.ubicacion) detalle.ubicacion=null;
        });
        actualizarTabla();
        actualizarTablaInventariables();
        limpiarAsignados();
      });
    }

    function removerIndividual(detalle){
      if (!(detalle.ubicacion && detalle.ubicacion.id)) return;
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Desea limpiar la ubicación asignada?', function(){
        limpiarAsignadaIndividual(detalle);
        detalle.ubicacion = null;
        actualizarTablaInventariables();
        actualizarTabla();
      });
    }

    function limpiarAsignadaIndividual(detalle){
      var index = null;
      var esta = false;
      vm.asignadas.forEach(function(asignada, i){
        if (asignada.ubicacion.id==detalle.ubicacion.id){
          esta = true;
          index = i;
        }
      });
      if (esta){
        if (vm.asignadas[index].cantidad==1){
          vm.asignadas.splice(index,1);
        } else {
          vm.asignadas[index].cantidad = vm.asignadas[index].cantidad-1;
        }
      }
    }

    function limpiarAsignados(){
      vm.asignadas = [];
    }

    function ubicacionNaveNumeroOrden(detalle){
      if (detalle.ubicacion && detalle.ubicacion.nivel) {
        return "Nave: "+detalle.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+detalle.ubicacion.numeroOrden;
      }
    }

    function ubicacionCompleta(detalle){
      var mensaje = "";
      if (detalle.tipoSuministro && detalle.ubicacion && detalle.ubicacion.categoriaPeso && detalle.tipoSuministro.categoriaPeso.id!=detalle.ubicacion.categoriaPeso.id){
        mensaje = "La categoría de peso de la ubicación asignada, no coincide con la del suministro";
      }
      if (detalle.ubicacion && detalle.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación asignada",
        "Nave: "+detalle.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+detalle.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+detalle.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+detalle.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+detalle.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+detalle.ubicacion.numeroUbicacion+
        "\nN° de orden: "+detalle.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+detalle.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+detalle.ubicacion.categoriaPeso.nombre.toUpperCase()+
        "\n\n"+mensaje);
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "No ha asignado ninguna ubicación");
      }
    }

    function cargarDetalles(){
      vm.detallesInventariables = [];
      vm.detallesNoInventariables = [];
      vm.ingreso.detalles.forEach(function(detalle){
        if (detalle.suministro.tipoSuministro.inventariable){
          vm.detallesInventariables.push(detalle);
        } else {
          vm.detallesNoInventariables.push(detalle);
        }
      });
      if (vm.detallesInventariables.length>0) {
        armarPallets();
      }
      actualizarTabla();

    }

    function armarPallets(){
      crearPallets();
      vm.palletsInventariables.forEach(function(pallet){
        vm.detallesInventariables.forEach(function(detalle){
          if (pallet.numeroRow===detalle.numeroRow){
            pallet.detalles.push(detalle);
            pallet.tipoSuministro=detalle.suministro.tipoSuministro;
            pallet.numeroCaja=detalle.numeroCaja;
          }
        });
      });
      actualizarTablaInventariables();
    }

    function crearPallets(){
      var esta = false;
      vm.palletsInventariables = [];
      vm.detallesInventariables.forEach(function(detalle){
        esta = false;
        vm.palletsInventariables.forEach(function(usado){
          if (detalle.numeroRow==usado.numeroRow){
            esta = true;
          }
        });
        if (!esta){
          vm.palletsInventariables.push({numeroRow:detalle.numeroRow, detalles:[], numeroCaja:null, tipoSuministro:null});
        }
      });
    }
    
    function montoTotal(){
      var total = 0;
      vm.ingreso.detalles.forEach(function(item){
        total += item.suministro.precioUnitario*item.cantidad;
      });
      return total ? '$ '+total.toFixed(2) : "-";
    }


    function actualizarTablaInventariables(){
      vm.tableParamsStock.settings({
        data: vm.palletsInventariables,
        noPager: true,
        counts: []
      });
      vm.tableParamsStock.reload();
    }

    function actualizarTabla(){
      vm.tableParams.settings({
        data: vm.detallesNoInventariables,
        noPager: true,
        counts: []
      });
      vm.tableParams.reload();
    }

    function crearTablas(){
      vm.tableParams = new NgTableParams({
        page: 1,
        count: 50
      });
      vm.tableParamsStock = new NgTableParams({
        group: "numeroCaja",
        page: 1,
        count: 50
      });
    }

    function contarAsignadas(){
      var cont = 0;
      vm.palletsInventariables.forEach(function(pallet){
        if (pallet.ubicacion && pallet.ubicacion.id){
          cont = cont +1;
        }
      });
      return cont;
    }

    function agregarAsignada(ubicacion, numero){
      var esta = false;
      var i = 0;
      vm.asignadas.forEach(function(asignada, indice){
        if (ubicacion.id==asignada.ubicacion.id){
          esta = true;
          i = indice;
        }
      });
      var suma = numero? numero : 1;
      if (!esta) {
        vm.asignadas.push({ubicacion:ubicacion, cantidad:suma});
      } else {
        vm.asignadas[i].cantidad = vm.asignadas[i].cantidad + suma;
      }
    }

    function asignarUbicaciones(ubicacion, numero){
      vm.palletsInventariables.forEach(function(pallet){
        if (!pallet.ubicacion){
          pallet.ubicacion = ubicacion;
        }
      });
      var asignadas = contarAsignadas();
      if (asignadas!=numero){
        var resta = asignadas-numero;
        agregarAsignada(ubicacion, resta);
      }
    }

    function asignarAutomaticamente(){
      var numero = contarAsignadas();
      ServicioDialogos.abrirDialogoCargando();
/*      Deposito.get({id:vm.ingreso.deposito.id}, function(data){
        console.log(data);
*/        ServicioModales.abrirModalAsignarUbicacionesCajas({
          onResult: function(resultado) {
            console.log(resultado);
            asignarUbicaciones(resultado.ubicacionAsignada, numero);
          },
          deposito: vm.ingreso.deposito
        });
/*      });
*/    }

    function asignarIndividual(detalle){
      var numero = contarAsignadas();
      ServicioDialogos.abrirDialogoCargando();
/*      Deposito.get({id:vm.ingreso.deposito.id}, function(data){
*/        ServicioModales.abrirModalAsignarUbicacionIndividualCajas({
          onResult: function(resultado){
            console.log(resultado);
            detalle.ubicacion = resultado.ubicacionAsignada;
            agregarAsignada(resultado.ubicacionAsignada);
          },
          deposito: vm.ingreso.deposito,
          'detalle': detalle
        });
/*      });
*/    }

    Array.prototype.unique=function(a){
      return function(){return this.filter(a);};}(function(a,b,c){return c.indexOf(a,b+1)<0;
    });

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.asignar-ubicaciones', {
        url: 'asignar-ubicaciones/:objeto',
        templateUrl: 'app/app/main/movimientos/ingreso/asignar-ubicaciones/asignar-ubicaciones.html',
        controller: 'AsignarUbicacionesCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Ingreso de suministros',
          subtitulo: 'Asignar ubicaciones a suministros',
          objeto:null
        },
        resolve: {
          estadoIngresoCerrado: function(EstadoMovimiento){
            return EstadoMovimiento.get({id:6}).$promise.then(function(data) {
              return data;
            });
          },
          ingreso: function(Ingreso, $stateParams){
            if ($stateParams.objeto){
              return Ingreso.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return $stateParams.objeto;
            }
          }
        }
      });
  }
})();
(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('AsignarUbicacionesCtrl', AsignarUbicacionesCtrl);

  /** @ngInject */
  function AsignarUbicacionesCtrl(NgTableParams, $sce, $q, Suministro, IngresoEstadoModificar, SuministroUbicacion, HeaderBarService, Deposito, focus, $filter, $stateParams, ingreso, estadoIngresoCerrado, $scope, orderByFilter, $state, ServicioDialogos, ServicioModales) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;

    vm.ingreso = ingreso;
    vm.estadoIngresoCerrado = estadoIngresoCerrado;
    vm.montoTotal = montoTotal;
    inicializar();
    vm.asignarAutomaticamente = asignarAutomaticamente;
    vm.asignarIndividual = asignarIndividual;
    vm.ubicacionCompleta = ubicacionCompleta;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.limpiarUbicaciones = limpiarUbicaciones;
    vm.removerIndividual = removerIndividual;
    vm.comprobarUbicaciones = comprobarUbicaciones;
    vm.comprobarIngresoCerrado = comprobarIngresoCerrado;
    vm.corroborarOcuparUbicacionRepetida = corroborarOcuparUbicacionRepetida;
    vm.volver = volver;

    function corroborarOcuparUbicacionRepetida(detalle){
      if (!detalle.ubicacion) return;
      if (vm.detallesNoInventariables && vm.detallesNoInventariables.length>0){
        vm.detallesNoInventariables.forEach(function(item){
          if (item.ubicacion && item.ubicacion.id==detalle.ubicacion.id){
            item.ocupar = detalle.ocupar;
          }
        });
      }
      if (vm.palletsInventariables && vm.palletsInventariables.length>0){
        vm.palletsInventariables.forEach(function(item){
          if (item.ubicacion && item.ubicacion.id==detalle.ubicacion.id){
            item.ocupar = detalle.ocupar;
          }
        });
      }
    }


    function comprobarIngresoCerrado(){
      return (vm.ingreso && vm.ingreso.estadoMovimiento.id==5);
    }

    function volver(){
        ServicioDialogos.mostrarDialogoConfirmacionWarning(
          null,
          "¿Está seguro que desea volver al listado de ingresos?",
          function(){
            $state.go("home.lista-ingreso");
          }
        );
    }

    function comprobarUbicaciones(){
      var cantidadInv = 0;
      if (vm.palletsInventariables && vm.palletsInventariables.length>0){
        cantidadInv = vm.palletsInventariables.length;
      }
      if (vm.asignadas.length === (vm.detallesNoInventariables.length+cantidadInv)){
        verificarDetallesUbicacion();
      } else {
        ServicioDialogos.mostrarDialogoError(null, "No ha asignado todas las ubicaciones");
      }
    }

    function verificarDetallesUbicacion(){
      var ban = false;
      vm.detallesNoInventariables.forEach(function(item){
        if (!item.ubicacion){
          ban = true;
        }
      });
      if (vm.palletsInventariables && vm.palletsInventariables.length>0){
        vm.palletsInventariables.forEach(function(item){
          if (!item.ubicacion){
            ban = true;
          }
        });
      }
      if (!ban){
        abrirDialogoConfirmacionGuardar();
      } else {
        ServicioDialogos.mostrarDialogoError(null, "No ha asignado todas las ubicaciones");
      }
    }
/*
    function comprobarUbicaciones2(){
      console.log(vm.asignadas);
      if ((vm.detallesNoInventariables && vm.asignadas)) {
        var ubicacionesDetalle = [];
        var asignadas = [];
        if (vm.palletsInventariables && vm.palletsInventariables.length>0){
          vm.palletsInventariables.forEach(function(det){
            if (det.ubicacion && det.ubicacion.id){
              ubicacionesDetalle.push(det.ubicacion.id);
            }
          });
        }
        vm.detallesNoInventariables.forEach(function(de){
          if (de.ubicacion && de.ubicacion.id){
            ubicacionesDetalle.push(de.ubicacion.id);
          }
        });
        vm.asignadas.forEach(function(asig){
          asignadas.push(asig.id);
        });
        if (vm.palletsInventariables && vm.palletsInventariables.length>0){
          if (asignadas.length === (vm.detallesNoInventariables.length+vm.palletsInventariables.length)){
            verificarUbicaciones(ubicacionesDetalle, asignadas);
          } else {
            ServicioDialogos.mostrarDialogoError(null, "No ha asignado todas las ubicaciones");
          }
        } else {
          if (asignadas.length === (vm.detallesNoInventariables.length)){
            verificarUbicaciones(ubicacionesDetalle, asignadas);
          } else {
            ServicioDialogos.mostrarDialogoError(null, "No ha asignado todas las ubicaciones");
          }
        }
      }
    }

    function verificarUbicaciones(ubicaciones, asignadas){
      ubicaciones = ubicaciones.sort();
      asignadas = asignadas.sort();
      if (asignadas.length==ubicaciones.length && asignadas.every(function(v,i) { return v === ubicaciones[i];})) {
        comprobarNoRepetidas(ubicaciones, asignadas);
      } else {
        ServicioDialogos.mostrarDialogoError(null, "No ha asignado todas las ubicaciones");
      }
    }

    function comprobarNoRepetidas(ubicaciones, asignadas){
      ubicaciones = ubicaciones.sort();
      asignadas = asignadas.sort();
      var ubicacionesRepetidas = angular.copy(ubicaciones.unique().sort());
      var asignadasRepetidas = angular.copy(asignadas.unique().sort());
      if ((asignadasRepetidas.every(function(v,i) { return v === asignadas[i];})) && (ubicacionesRepetidas.every(function(v,i) { return v === ubicaciones[i];}))) {
        abrirDialogoConfirmacionGuardar();
      } else {
        ServicioDialogos.mostrarDialogoError(null, "Se han asignado ubicaciones repetidas");
      }
    }*/

    function abrirDialogoConfirmacionGuardar(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Desea asignar las ubicaciones?", function(){
        guardarUbicaciones();
      }, null, false);
    }

    function guardarUbicaciones(){
      guardarUbicacionesInventariables()
      .then(function(){
        guardarUbicacionesNoInventariables()
        .then(function(){
          actualizarEstadoIngreso();
        }, function(err){
          console.log(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido asignar las ubicaciones");
        });
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido asignar las ubicaciones");
      });
    }

    function actualizarEstadoIngreso(){
      IngresoEstadoModificar.update({idMovimiento:vm.ingreso.id, idEstado:vm.estadoIngresoCerrado.id}, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, "Se han asignado las ubicaciones correctamente", function(){
          $state.go('home.lista-ingreso');
        });
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido asignar las ubicaciones");
      });
    }

    function guardarUbicacionesNoInventariables(){
      var defer = $q.defer();
      var promise = defer.promise;
      vm.detallesNoInventariables.forEach(function(detalle){
        var ubicacion = detalle.ubicacion.id;
        var suministro = detalle.suministro.id;
        var ocupar = detalle.ocupar;
        promise = promise.then(function(){
          return guardarUbicacionSuministro(suministro, ubicacion, ocupar).then(function(){
            defer.resolve(true);
          });
        });
      });
      defer.resolve(true);
      return promise;
    }

    function guardarUbicacionesInventariables(){
      var defer = $q.defer();
      var promise = defer.promise;
      if (vm.palletsInventariables && vm.palletsInventariables.length>0){
        vm.palletsInventariables.forEach(function(pallet){
          promise = promise.then(function(){
            return guardarDetallesInventariables(pallet).then(function(){
              defer.resolve(true);
            });
          });
        });
      }
      defer.resolve(true);
      return promise;
    }

    function guardarDetallesInventariables(pallet){
      var defer = $q.defer();
      var promise = defer.promise;
      var ubicacion = pallet.ubicacion.id;
      var ocupar = pallet.ocupar;
      pallet.detalles.forEach(function(detalle){
        promise = promise.then(function(){
          return guardarUbicacionSuministro(detalle.suministro.id, ubicacion, ocupar).then(function(){
            defer.resolve(true);
          });
        });
      });
      defer.resolve(true);
      return promise;
    }

    function guardarUbicacionSuministro(suministro, ubicacion, ocupar){
      return SuministroUbicacion.update({'idSuministro': suministro,'idUbicacion':ubicacion,'ocupar':ocupar}).$promise.then(function(data) {
        return data;
      });
    }

    function inicializar(){
      if (!vm.ingreso){
        return;
      }
      if (vm.ingreso && vm.ingreso.caja){
        $state.go('home.asignar-ubicaciones-cajas', {objeto: ingreso.id});
      }
      vm.fecha=$filter('date')(vm.ingreso.fecha, 'dd/MM/yyyy HH:mm');
      vm.personaProveedor = personaProveedor();
      vm.personaEmpresaLogistica = personaEmpresaLogistica();
      vm.montoTotal = montoTotal();
      vm.asignadas = [];
      crearTablas();
      cargarDetalles();
      setearOcuparUbicaciones();
    }

    function personaProveedor(){
      if (vm.ingreso.personaProveedor){
        return vm.ingreso.personaProveedor.apellido.toUpperCase()+", "+vm.ingreso.personaProveedor.nombre.toUpperCase();
      }
    }

    function personaEmpresaLogistica(){
      if (vm.ingreso.personaEmpresaLogistica){
        return vm.ingreso.personaEmpresaLogistica.apellido.toUpperCase()+", "+vm.ingreso.personaEmpresaLogistica.nombre.toUpperCase();
      }
    }

    function setearOcuparUbicaciones(){
      if (vm.palletsInventariables && vm.palletsInventariables.length>0){
        vm.palletsInventariables.forEach(function(pallet){
          pallet.ocupar = true;
        });
      }
      vm.detallesNoInventariables.forEach(function(detalle){
        detalle.ocupar=true;
      });
    }

    function limpiarUbicaciones(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Desea limpiar todas las ubicaciones asignadas?', function(){
        if (vm.palletsInventariables && vm.palletsInventariables.length>0){
          vm.palletsInventariables.forEach(function(detalle){
            if (detalle.ubicacion) detalle.ubicacion=null;
          });
        }
        vm.detallesNoInventariables.forEach(function(detalle){
          if (detalle.ubicacion) detalle.ubicacion=null;
        });
        actualizarTabla();
        actualizarTablaInventariables();
        limpiarAsignados();
      });
    }

    function removerIndividual(detalle){
      if (!(detalle.ubicacion && detalle.ubicacion.id)) return;
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Desea limpiar la ubicación asignada?', function(){
        limpiarAsignadaIndividual(detalle);
        detalle.ubicacion = null;
        actualizarTablaInventariables();
        actualizarTabla();
      });
    }

    function limpiarAsignadaIndividual(detalle){
      var index = null;
      for (var i = vm.asignadas.length - 1; i >= 0; i--) {
        var id = vm.asignadas[i].id;
        if (id==detalle.ubicacion.id) {
          index=i;
        }
      }
      if (index!==null){
        vm.asignadas.splice(index,1);
      }
    }

    function limpiarAsignados(){
      vm.asignadas = [];
    }

    function ubicacionNaveNumeroOrden(detalle){
      if (detalle.ubicacion && detalle.ubicacion.nivel) {
        return "Nave: "+detalle.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+detalle.ubicacion.numeroOrden;
      }
    }

    function ubicacionCompleta(detalle){
      var mensaje = "";
      if (detalle.tipoSuministro && detalle.ubicacion && detalle.ubicacion.categoriaPeso && detalle.tipoSuministro.categoriaPeso.id!=detalle.ubicacion.categoriaPeso.id){
        mensaje = "La categoría de peso de la ubicación asignada, no coincide con la del suministro";
      }
      if (detalle.ubicacion && detalle.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación asignada",
        "Nave: "+detalle.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+detalle.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+detalle.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+detalle.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+detalle.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+detalle.ubicacion.numeroUbicacion+
        "\nN° de orden: "+detalle.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+detalle.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+detalle.ubicacion.categoriaPeso.nombre.toUpperCase()+
        "\n\n"+mensaje);
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "No ha asignado ninguna ubicación");
      }
    }

    function cargarDetalles(){
      vm.detallesInventariables = [];
      vm.detallesNoInventariables = [];
      vm.ingreso.detalles.forEach(function(detalle){
        if (detalle.suministro.tipoSuministro.inventariable){
          vm.detallesInventariables.push(detalle);
        } else {
          vm.detallesNoInventariables.push(detalle);
        }
      });
      if (vm.detallesInventariables.length>0) {
        armarPallets();
      }
      actualizarTabla();
    }

    function armarPallets(){
      crearPallets();
      vm.palletsInventariables.forEach(function(pallet){
        vm.detallesInventariables.forEach(function(detalle){
          if (pallet.numeroRow===detalle.numeroRow){
            pallet.detalles.push(detalle);
            pallet.tipoSuministro=detalle.suministro.tipoSuministro;
          }
        });
      });
      actualizarTablaInventariables();
    }

    function crearPallets(){
      var esta = false;
      vm.palletsInventariables = [];
      vm.detallesInventariables.forEach(function(detalle){
        esta = false;
        vm.palletsInventariables.forEach(function(usado){
          if (detalle.numeroRow==usado.numeroRow){
            esta = true;
          }
        });
        if (!esta){
          vm.palletsInventariables.push({numeroRow:detalle.numeroRow, detalles:[], tipoSuministro:null});
        }
      });
    }
    
    function montoTotal(){
      var total = 0;
      vm.ingreso.detalles.forEach(function(item){
        total += item.suministro.precioUnitario*item.cantidad;
      });
      return total ? '$ '+total.toFixed(2) : "-";
    }

    function actualizarTablaInventariables(){
      vm.tableParamsStock.settings({
        data: vm.palletsInventariables,
        noPager: true,
        counts: []
      });
      vm.tableParamsStock.reload();
    }

    function actualizarTabla(){
      vm.tableParams.settings({
        data: vm.detallesNoInventariables,
        noPager: true,
        counts: []
      });
      vm.tableParams.reload();
    }

    function crearTablas(){
      vm.tableParams = new NgTableParams({
        page: 1,
        count: 50
      });
      vm.tableParamsStock = new NgTableParams({
        group: "numeroRow",
        page: 1,
        count: 50
      });
    }

    function agregarAsignada(ubicacion){
      if (!(vm.asignadas)) {
        vm.asignadas = [];
      }
      vm.asignadas.push(ubicacion);

    }

    function actualizarAsignadas(asignadas){
      vm.asignadas = asignadas;
      if (vm.asignadas.length==0){
        ServicioDialogos.mostrarDialogoInformacion(
          null,
          "No se ha asignado ninguna ubicación."+
          "\nEsto es porque las ubicaciones libres, poseen una categoría de peso distinta a la de los suministros"
        );
      } else {
        mostrarMensajeAsignacion();
      }
    }

    function mostrarMensajeAsignacion(){
      if ((vm.palletsInventariables && ((vm.palletsInventariables.length+vm.detallesNoInventariables.length)==vm.asignadas.length)) || (vm.detallesNoInventariables.length==vm.asignadas.length)){
        ServicioDialogos.mostrarDialogoInformacion(
          null,
          "Se han asignado todas las ubicaciones",
          null
        );
      } else {
        ServicioDialogos.mostrarDialogoInformacion(
          null,
          "Se asignó al menos una ubicación",
          null
        );
      }
    }

    function agregarSuministroUbicacionAsignada(detalle, asignada){
      if (asignada.suministros){
        asignada.suministros.push(detalle.suministro);
      } else {
        asignada.suministros = [];
        asignada.suministros.push(detalle.suministro);
      }
      return asignada;
    }

    function asignarAutomaticamente(){
      ServicioDialogos.abrirDialogoCargando();
      Deposito.get({id:vm.ingreso.deposito.id}, function(data){
        ServicioModales.abrirModalAsignarUbicaciones({
          onResult: function(resultado) {
            actualizarAsignadas(resultado.asignadas);
          },
          deposito: vm.ingreso.deposito,
          detallesInventariables: vm.palletsInventariables,
          detallesNoInventariables: vm.detallesNoInventariables,
          asignadas: vm.asignadas
        });
      });
    }

    function asignarIndividual(detalle){
      ServicioDialogos.abrirDialogoCargando();
      Deposito.get({id:vm.ingreso.deposito.id}, function(data){
        ServicioModales.abrirModalAsignarUbicacionIndividual({
          onResult: function(resultado){
            detalle.ubicacion = resultado.ubicacionAsignada;
            var asignada = agregarSuministroUbicacionAsignada(detalle, resultado.ubicacionAsignada);
            agregarAsignada(asignada);
            corroborarOcuparUbicacionRepetida(detalle);
          },
          deposito: vm.ingreso.deposito,
          'detalle': detalle,
          asignadas: vm.asignadas
        });
      });
    }

    Array.prototype.unique=function(a){
      return function(){return this.filter(a);};}(function(a,b,c){return c.indexOf(a,b+1)<0;
    });

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.agregar-suministros-ingreso', {
        url: 'agregar-suministros-ingreso',
        templateUrl: 'app/app/main/movimientos/ingreso/agregar-suministros/agregar-suministros-ingreso.html',
        controller: 'AgregarSuministroIngresoCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Ingreso de suministros',
          subtitulo: 'Agregar suministros',
          objeto:null
        },
        resolve: {
          tipoIngreso: function(TipoMovimiento){
            return TipoMovimiento.get({id:2}).$promise.then(function(data) {
              return data;
            });
          },
          estadoGenerado: function(EstadoMovimiento){
            return EstadoMovimiento.get({id:5}).$promise.then(function(data) {
              return data;
            });
          },
          ingreso: function(Ingreso, $stateParams){
            return $stateParams.objeto? $stateParams.objeto : {};
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('AgregarSuministroIngresoCtrl', AgregarSuministroIngresoCtrl);

  /** @ngInject */
  function AgregarSuministroIngresoCtrl(NgTableParams, $filter, UltimoMovimiento, ingreso, ServicioModales, tipoIngreso, estadoGenerado, HeaderBarService, Ingreso, $timeout, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.tipoIngreso = tipoIngreso;
    vm.estadoGenerado = estadoGenerado;
    vm.ingreso = ingreso;
    vm.ocultar=true;
    inicializar();

    vm.agregar = agregar;
    vm.volver = volver;

    vm.detalles = [];
    vm.numeroCajas=[];
    vm.detallesInventariables = [];
    vm.detallesNoInventariables = [];
    vm.numeroRow = 0;



    vm.mostrarInformacion = mostrarInformacion;
    vm.eliminar = eliminar;
    vm.modo = "nuevo";
    vm.abrirModal = abrirModal;
    vm.abrirModalAgregarSuministrosExcel = abrirModalAgregarSuministrosExcel;
    vm.guardar = guardar;
    vm.montoTotal = montoTotal;
    vm.getIcono = getIcono;

    window.onbeforeunload = function(){
      return '';
    };


    function inicializar(){
      if (vm.ingreso && vm.ingreso.empresa && vm.ingreso.empresa.id){
        vm.fecha = $filter('date')(new Date(), 'dd/MM/yyyy HH:mm');
        vm.personaProveedor = personaProveedor();
        vm.personaEmpresaLogistica = personaEmpresaLogistica();
        vm.cajaCerrada = vm.ingreso.caja? "SI" : "NO";
      } else {
        vm.ocultar=false;
      }
    }

    function getIcono(estaAbierto) {
      if (estaAbierto) {
        return 'glyphicon glyphicon-chevron-down';
      } else {
        return 'glyphicon glyphicon-chevron-right';
      }
    }

    function montoTotal(){
      var total = 0;
      for(var i = 0; i < vm.detalles.length; i++){
        total += vm.detalles[i].suministro.precioUnitario*vm.detalles[i].cantidad;
      }
      return total ? total.toFixed(2) : "-";
    }

    function personaProveedor(){
      if (vm.ingreso.personaProveedor){
        return vm.ingreso.personaProveedor.apellido.toUpperCase()+", "+vm.ingreso.personaProveedor.nombre.toUpperCase();
      }
    }

    function personaEmpresaLogistica(){
      if (vm.ingreso.personaEmpresaLogistica){
        return vm.ingreso.personaEmpresaLogistica.apellido.toUpperCase()+", "+vm.ingreso.personaEmpresaLogistica.nombre.toUpperCase();
      }
    }

    function guardar(){
      if (vm.detalles.length===0){
        ServicioDialogos.mostrarDialogoError(null, "No ha agregado ningún suministro");
      } else {
        ServicioDialogos.mostrarDialogoConfirmacionWarning(
          null,
          "¿Está seguro que desea guardar el ingreso?",
          function(){
            guardarIngreso();
          },
          null,
          false
        );
      }
    }

    function obtenerNumeroMovimiento(callback){
      UltimoMovimiento.get({}, function(data){
        if (data && !isNaN(data.id)){
          callback(data.id + 10001);
        } else {
          callback(10001);
        }
      }, function (err){
        console.log(err);
      });
    }

    function obtenerIngreso(callback){
      obtenerNumeroMovimiento(function(data){
        var movimiento = {
          tipoMovimiento: tipoIngreso,
          estadoMovimiento: estadoGenerado,
          deposito: vm.ingreso.deposito,
          empresa: vm.ingreso.empresa,
          sucursal: vm.ingreso.sucursal,
          observacion: vm.ingreso.observacion,
          proveedor: vm.ingreso.proveedor,
          empresaLogistica: vm.ingreso.empresaLogistica,
          personaProveedor: vm.ingreso.personaProveedor,
          personaEmpresaLogistica: vm.ingreso.personaEmpresaLogistica,
          numeroOrden: vm.ingreso.numeroOrden,
          numeroRemito: vm.ingreso.numeroRemito,
          solicitante: vm.ingreso.solicitante,
          fecha: new Date(),
          detalles: vm.detalles,
          numeroMovimiento: data,
          caja: vm.ingreso.caja,
          usuario: vm.ingreso.usuario,
          numeroIngresoVale: vm.ingreso.numeroIngresoVale,
          numeroGuia: vm.ingreso.numeroGuia
        };
        callback(movimiento);
      });
    }


    function guardarIngreso(){
      obtenerIngreso(function(movimiento){
        Ingreso.save(movimiento, function(data){
          ServicioDialogos.mostrarDialogoGuardadoExito(
            null,
            "Se ha registrado con éxito el ingreso",
            function(){
              if (vm.ingreso.caja){
                $state.go('home.asignar-ubicaciones-cajas',{objeto:data.id});
              } else {
                $state.go('home.asignar-ubicaciones',{objeto:data.id});
              }
              //Acá se abrirá un PDF o una pantalla "resumen" del ingreso que se acaba de ingresar.. como un remito!
            });
        }, function(err){
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar el ingreso");
        });
      });
    }

    function cargarDetalles(){
      vm.detallesInventariables = [];
      vm.detallesNoInventariables = [];
      vm.detalles.forEach(function(detalle){
        if (detalle.suministro.tipoSuministro.inventariable){
          vm.detallesInventariables.push(detalle);
        } else {
          vm.detallesNoInventariables.push(detalle);
        }
      });
      actualizarTablaInventariables();
      actualizarTabla();
    }

    function abrirModal(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalAgregarSuministroIngreso({
        onResult: function(resultado) {
          vm.detalles = resultado.detalles;
          vm.numeroRow = resultado.numeroRow;
          vm.numeroCajas = resultado.numeroCajas;
          cargarDetalles();
        },
        detalles: vm.detalles,
        empresa: vm.ingreso.empresa,
        numeroRow : vm.numeroRow,
        caja: vm.ingreso.caja,
        numeroCajas: vm.numeroCajas
      });
    }

    function abrirModalAgregarSuministrosExcel(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalAgregarSuministroIngresoExcel({
        onResult: function(resultado) {
          vm.detalles = resultado.detalles;
          vm.numeroRow = resultado.numeroRow;
          vm.numeroCajas = resultado.numeroCajas;
          cargarDetalles();
        },
        detalles: vm.detalles,
        empresa: vm.ingreso.empresa,
        numeroRow : vm.numeroRow,
        caja: vm.ingreso.caja,
        numeroCajas: vm.numeroCajas
      });
    }

    function eliminar(objeto){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(
        null,
        "¿Está seguro que desea eliminar el detalle?",
        function(){
          quitarDetalle(objeto);
          cargarDetalles();
        }
      );
    }

    function quitarDetalle(objeto){
      var index = null;
      vm.detalles.forEach(function(detalle, i){
        if (detalle==objeto){
          index = i;
        }
      });
      if (index!=null){
        var eliminado = vm.detalles.splice(index, 1);
        if (eliminado[0].numeroCaja){
          comprobarNumeroCajas(eliminado[0].numeroCaja);
        }
      } else {
        ServicioDialogos.mostrarDialogoError(null, "No se puede quitar el detalle");
      }


/*      
      comprobarNumeroRow(eliminado[0].numeroRow);*/
    }

/*    function comprobarNumeroRow(numero){
      var ban = false;
      vm.detalles.forEach(function(item){
        if (item.numeroRow==numero){
          ban = true;
        }
      });
      if (!ban){
        quitarNumeroRow(numero);
      }
    }

    function quitarNumeroRow(numero){
      var index = null;
    }*/

    function comprobarNumeroCajas(numero){
      var ban = false;
      vm.detalles.forEach(function(item){
        if (item.numeroCaja==numero){
          ban = true;
        }
      });
      if (!ban){
        quitarNumeroCajas(numero);
      }
    }

    function quitarNumeroCajas(numero){
      var index = null;
      vm.numeroCajas.forEach(function(item, i){
        if (item===numero){
          index = i;
        }
      });
      if (index!==null) vm.numeroCajas.splice(index, 1);
    }

    function esEditar(){
      return vm.modo == "editar";
    }

    function volver(){
      if (vm.ocultar){
        ServicioDialogos.mostrarDialogoConfirmacionWarning(
          null,
          "Si vuelve a la pantalla de edición de ingreso, perderá la información de todos los suministros que haya agregado. ¿Está seguro que desea volver?",
          function(){
            $state.go("home.editar-ingreso", {ingreso:ingreso});
          }
        );
      } else {
        $state.go("home.editar-ingreso", {});
      }
    }


    function mostrarInformacion(detalle){
      var marca = detalle.suministro.marca ? detalle.suministro.marca : "-";
      var fecha = detalle.suministro.fechaVencimiento ? detalle.suministro.fechaVencimiento : "-";
      ServicioDialogos.mostrarDialogoInformacion(
        null,
        "Tipo de suministro: "+detalle.suministro.tipoSuministro.nombre.toUpperCase()+
        "\nMarca: "+marca.toUpperCase()+
        "\nFecha vencimiento: "+$filter('date')(fecha, 'dd/MM/yyyy')+
        "\nFamilia de suministro: "+detalle.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase()+
        "\nGrupo de suministro: "+detalle.suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+
        "\nCantidad solicitada: "+detalle.cantidad
      );
    }

    function actualizarTablaInventariables(){
      vm.tableParamsStock.settings({
        data: vm.detallesInventariables
      });
      vm.tableParamsStock.reload();
    }

    function actualizarTabla(){
      vm.tableParams = new NgTableParams({
        page: 1,
        count: 10
      });
      vm.tableParams.settings({
        data: vm.detallesNoInventariables
      });
      vm.tableParams.reload();
    }

    function comprobarExistencia(){
      var ban = false;
      vm.detalles.forEach(function(detalle){
        if (detalle.suministro.id==vm.suministro.id){
          ban = true;
        }
      });
      return ban;
    }

    function limpiarForm(){
      vm.grupo = null;
      vm.cantidad=null;
      vm.form.cantidad.$dirty = false;
    }

    function agregarDetalle(){
      if (!comprobarExistencia()){
        var detalle = {
          suministro : vm.suministro,
          cantidad : vm.cantidad
        };
        vm.numero = vm.numero+1;
        vm.detalles.push(detalle);
        limpiarForm();
        actualizarTabla(vm.detalles);
      } else {
        ServicioDialogos.mostrarDialogoError(null, "Ya agregó este suministro al pedido");
      }
    }

    function editarDetalle(){

    }


    function agregar(){
      if (esEditar()){
        editarDetalle();
      } else {
        agregarDetalle();
      }
    }

    $scope.$watch('vm.grupo.nombre', function(){
      vm.familiaSuministro=null;
      if (!vm.grupo) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupo.id}, function(data){
        vm.familias = data;
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.familiaSuministro.nombre', function(){
      vm.suministro=null;
      if (!vm.familiaSuministro) return;
      ServicioDialogos.abrirDialogoCargando();
      TipoSuministroFamilia.query({id:vm.familiaSuministro.id}, function(data){
        vm.suministros = data;
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });
    vm.tableParamsStock = new NgTableParams({
      page: 1,
      count: 10,
      group:{
        numeroRow: 'desc'
      }
    });
   
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.visualizar-conciliacion', {
        url: 'visualizar-conciliacion/:objeto',
        templateUrl: 'app/app/main/movimientos/conciliaciones/visualizar-conciliacion/visualizar-conciliacion.html',
        controller: 'VisualizarConciliacionCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar conciliación',
          subtituloNuevo: 'Visualizar información de la conciliacion',
        },
        resolve: {
          conciliacion: function(Conciliacion, $stateParams){
            if ($stateParams.objeto){
              return Conciliacion.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return $stateParams.objeto;
            }
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('VisualizarConciliacionCtrl', VisualizarConciliacionCtrl);

  /** @ngInject */
  function VisualizarConciliacionCtrl(NgTableParams, HeaderBarService, URL_SERVIDOR, $http, $window, ServicioModales, conciliacion, $stateParams, $filter, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);

    var vm = this;
    vm.conciliacion = conciliacion;
    vm.volver = volver;

    vm.detalles = vm.conciliacion.detalles;

    vm.detallesNoInventariables = [];

    vm.detallesNoInventariablesAgrupados = [];
    vm.detallesNoInventariablesAgrupadosCajas = [];




    inicializar();

    vm.comprobarEstadoConciliacion = comprobarEstadoConciliacion;
    vm.imprimirInforme = imprimirInforme;

    function imprimirInforme(){
      ServicioDialogos.abrirDialogoCargando();
      $http.get(URL_SERVIDOR+"/movimiento/reporte/movimiento/"+vm.conciliacion.id, {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }


    function inicializar(){
      if (!vm.conciliacion.id) return;
      vm.fecha=$filter('date')(vm.conciliacion.fecha, 'dd/MM/yyyy HH:mm');
      crearTablas();
      vm.detallesNoInventariablesAgrupados = [];
      cargarDetalles();
    }

    function cargarDetalles(){
      vm.detallesNoInventariables = [];
      vm.detalles.forEach(function(detalle){
        if (detalle.suministro.tipoSuministro.inventariable){
          //vm.detallesInventariables.push(detalle);
        } else {
          vm.detallesNoInventariables.push(detalle);
        }
      });
      if (vm.detallesNoInventariables.length>0){
        armarDetallesNoInventariables();
      } else {
        actualizarTablaNoInventariables();
      }

    }

    function obtenerTiposUtilizados(){
      var esta = false;
      vm.detallesNoInventariables.forEach(function(detalle){
        esta = false;
        vm.detallesNoInventariablesAgrupados.forEach(function(agrupado){
          if (detalle.suministro.tipoSuministro.id==agrupado.tipoSuministro.id){
            esta = true;
          }
        });
        if (!esta){
          vm.detallesNoInventariablesAgrupados.push({tipoSuministro:detalle.suministro.tipoSuministro, precioTotal:0.0, cantidad:0, detalles:[]});
        }
      });
    }

    function armarDetallesNoInventariablesAgrupados(){
      vm.detallesNoInventariablesAgrupados.forEach(function(agrupado){
        vm.detallesNoInventariables.forEach(function(detalle){
          if (agrupado.tipoSuministro.id===detalle.suministro.tipoSuministro.id){
            agrupado.detalles.push({suministro:detalle.suministro, cantidad:detalle.cantidad});
            agrupado.cantidad = agrupado.cantidad + detalle.cantidad;
            agrupado.precioTotal = agrupado.precioTotal + detalle.suministro.precioUnitario*detalle.cantidad;
          }
        });
      });
    }

    function armarDetallesNoInventariables(){
      obtenerTiposUtilizados();
      armarDetallesNoInventariablesAgrupados();
      actualizarTablaNoInventariables();
    }


    function volver(){
      $state.go("home.lista-conciliaciones");
    }


    function actualizarTablaNoInventariables(){
      vm.tableParamsNoInventariableAgrupado.settings({
        data: vm.detallesNoInventariablesAgrupados,
        noPager: true,
        counts: []
      });
      vm.tableParamsNoInventariableAgrupado.reload();
    }

    function crearTablas(){
      vm.tableParamsNoInventariableAgrupado = new NgTableParams({
        page: 1,
        count: 10,
        group:{
          tipoSuministro: 'desc'
        }
      });
    }

    function comprobarEstadoConciliacion(){
      return vm.conciliacion && vm.conciliacion.estadoMovimiento;
    }
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-conciliaciones', {
        url: 'lista-conciliaciones',
        templateUrl: 'app/app/main/movimientos/conciliaciones/lista/lista-conciliaciones.html',
        controller: 'ListaConciliacionCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar conciliaciones',
          subtitulo:'Lista de conciliaciones'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          conciliaciones: function(ConciliacionUltimosCien, Usuario, ConciliacionUltimosCienDeposito){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return ConciliacionUltimosCienDeposito.query({'idDeposito':usuario.empleado.deposito.id}).$promise.then(function(data){
                  return data;
                });
              } else {
                return ConciliacionUltimosCien.query({}).$promise.then(function(data){
                  return data;
                });
              }
            });
          }

        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaConciliacionCtrl', ListaConciliacionCtrl);

  /** @ngInject */
  function ListaConciliacionCtrl(NgTableParams, rol, HeaderBarService, Usuario, $filter, focus, conciliaciones, ConciliacionUltimosCien, ConciliacionUltimosCienDeposito, $stateParams, $scope, orderByFilter, $state, ServicioModales, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.conciliaciones = orderByFilter(conciliaciones,'fecha',true);
    vm.visualizarConciliacion = visualizarConciliacion;
    vm.crearNuevo = crearNuevo;
    vm.eliminar = eliminar;
    vm.filtrar = filtrar;
    vm.bandera = false;
    vm.busqueda = busqueda;
    vm.abrirModalFiltros = abrirModalFiltros;

    if (rol.id!=1 && rol.id!=2) $state.go("home.home");


    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10,
    },{
      getData: function($defer,params){ return filtrarTabla($defer, params);}
    });
    vm.tableParams.reload();

    function filtrarTabla($defer, params) {
      var filtros = params.filter();
      var filtrosNuevos = {};

      for (var key in filtros) {
        if (filtros.hasOwnProperty(key) && filtros[key]!=='') {
          switch(key) {
            case 'deposito.nombre':
              angular.extend(filtrosNuevos, {
                deposito: {
                nombre: filtros[key]
                }
              });
              break;
            case 'empresa.nombre':
              angular.extend(filtrosNuevos, {
                empresa: {
                nombre: filtros[key]
                }
              });
              break;
            case 'tipoMovimiento.nombre':
              angular.extend(filtrosNuevos, {
                tipoMovimiento: {
                nombre: filtros[key]
                }
                });
              break;
            case 'estadoMovimiento.nombre':
              angular.extend(filtrosNuevos, {
                estadoMovimiento: {
                nombre: filtros[key]
                }
              });
              break;
            default:
              filtrosNuevos[key] = filtros[key];
          }
        }
      }
      var filtrados = filtros ? $filter('filter')(vm.conciliaciones, filtrosNuevos) : vm.conciliaciones;
      filtrados = params.sorting() ? $filter('orderBy')(filtrados, params.orderBy()) : filtrados;
      if (filtrados && filtrados.length){
        params.total(filtrados.length);
        return $defer.resolve(filtrados.slice((params.page() - 1) * params.count(), params.page() * params.count()));
      } else {
        params.total(0);
        return $defer.resolve(null);
      }
    }

    function abrirModalFiltros(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalFiltroBusquedaConciliacion({
        onResult: function(resultado){
          vm.bandera=true;
          vm.filtrosUsados = resultado.filtros;
          actualizarTabla(resultado.detalles);
        }
      });
    }

    function busqueda(){
      vm.bandera=false;
      vm.filtrosUsados=null;
      if (vm.buscar) {
        vm.conciliaciones=null;
        actualizarTabla(vm.conciliaciones);
      } else {
        filtrar();
      }
    }
    
    function actualizarTabla(data){
      vm.conciliaciones = orderByFilter(data,'fecha',true);
      vm.tableParams.settings({
        data: vm.conciliaciones
      });
      vm.tableParams.reload();
    }

    function filtrar(){
      ServicioDialogos.abrirDialogoCargando();
      if (!vm.buscar){
        obtenerUltimos();
      } else {
        actualizarTabla(undefined);
      }

    }

    function visualizarConciliacion(conciliacion){
      $state.go('home.visualizar-conciliacion', {objeto:conciliacion.id});
    }

    function eliminar(conciliacion) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea eliminar la conciliación?', function() {
        anularConciliacion(conciliacion);
      });
    }

    function anularConciliacion(conciliacion){
      console.log(conciliacion.id);
    }

    function obtenerUltimos(){
      Usuario.obtenerUsuario().$promise.then(function(usuario){
        if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
          ConciliacionUltimosCienDeposito.query({'idDeposito':usuario.empleado.deposito.id}).$promise.then(function(data){
            ServicioDialogos.cerrarDialogoCargando();
            actualizarTabla(data);
          }, function(err){
            console.error(err);
            ServicioDialogos.cerrarDialogoCargando();
          });
        } else {
          ConciliacionUltimosCien.query({}).$promise.then(function(data){
            ServicioDialogos.cerrarDialogoCargando();
            actualizarTabla(data);
          }, function(err){
            console.error(err);
            ServicioDialogos.cerrarDialogoCargando();
          });
        }
      });
    }

    function crearNuevo() {
      $state.go('home.editar-conciliacion');
    }


  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-conciliacion', {
        url: 'editar-conciliacion',
        templateUrl: 'app/app/main/movimientos/conciliaciones/editar/editar-conciliaciones.html',
        controller: 'EditarConciliacionCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar conciliaciones',
          subtituloEditar:'Editar conciliación',
          subtituloNuevo: 'Nueva conciliación',
          conciliacion:null,
          editar:null
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          usuario: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario;
            });
          },
          //el deposito se traerá dependiendo del usuario registrado.
          //si es admin traigo todos sino el del usuario
          conciliacion: function($stateParams){
            return $stateParams.conciliacion? $stateParams.conciliacion : {};
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          deposito: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return usuario.empleado.deposito;
              } else {
                return ;
              }
            });
          },
          tipoEgreso: function(TipoMovimiento){
            return TipoMovimiento.get({id:6}).$promise.then(function(data) {
              return data;
            });
          },
          tipoIngreso: function(TipoMovimiento){
            return TipoMovimiento.get({id:5}).$promise.then(function(data) {
              return data;
            });
          },
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data){
              return data;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarConciliacionCtrl', EditarConciliacionCtrl);

  /** @ngInject */
  function EditarConciliacionCtrl(NgTableParams, rol, deposito, usuario, HeaderBarService, conciliacion, focus, SucursalEmpresa, EgresoNumeroValeEmpresa, depositos, tipoIngreso, tipoEgreso, empresas, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    conciliacion.empresa? HeaderBarService.setSubTitulo($stateParams.subtituloEditar) : HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);

    var vm = this;
    vm.tipoEgreso = tipoEgreso;
    vm.tipoIngreso = tipoIngreso;
    vm.depositos = orderByFilter(depositos,'nombre',false);
    vm.empresas = orderByFilter(empresas,'nombre',false);
    vm.conciliacion = conciliacion;
    vm.conciliacion.deposito = deposito;
    vm.conciliacion.usuario = usuario;
    inicializar();
    vm.siguiente = siguiente;
    vm.cancelar = cancelar;

    if (rol.id!=1 && rol.id!=2) $state.go("home.home");



    window.onbeforeunload = function(){
      return "seguro?";
    };

    function inicializar(){
      vm.tipos = [];
      vm.tipos.push(vm.tipoEgreso);
      vm.tipos.push(vm.tipoIngreso);
    }


    function cancelar(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea cancelar la conciliación?', function() {
        $state.go('home.lista-conciliaciones');
      });
    }

    function siguiente(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, 'Verifique los datos. ¿Desea continuar con la selección de suministros en la conciliación?', function() {
        $state.go('home.agregar-suministros-conciliacion', {'objeto':vm.conciliacion});
      });

    }

    function esEditar(){
      return vm.modo == "editar";
    }

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.agregar-suministros-conciliacion', {
        url: 'agregar-suministros-conciliacion',
        templateUrl: 'app/app/main/movimientos/conciliaciones/agregar-suministros/agregar-suministros-conciliaciones.html',
        controller: 'AgregarSuministroConciliacionCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Conciliación de suministros',
          subtitulo: 'Selección de suministros',
          objeto:null
        },
        resolve: {
          estadoCreadaIngreso: function(EstadoMovimiento){
            return EstadoMovimiento.get({id:9}).$promise.then(function(data) {
              return data;
            });
          },
          estadoCreadaEgreso: function(EstadoMovimiento){
            return EstadoMovimiento.get({id:11}).$promise.then(function(data) {
              return data;
            });
          },
          conciliacion: function(Conciliacion, $stateParams){
            return $stateParams.objeto? $stateParams.objeto : {};
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('AgregarSuministroConciliacionCtrl', AgregarSuministroConciliacionCtrl);

  /** @ngInject */
  function AgregarSuministroConciliacionCtrl(NgTableParams, $filter, ActualizarEstadoUbicacion, UltimoMovimiento, conciliacion, ServicioModales, estadoCreadaEgreso, estadoCreadaIngreso, HeaderBarService, Conciliacion, $timeout, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.estadoCreadaEgreso = estadoCreadaEgreso;
    vm.estadoCreadaIngreso = estadoCreadaIngreso;
    vm.conciliacion = conciliacion;
    vm.ocultar=true;
    inicializar();


    vm.volver = volver;

    vm.detalles = [];
    vm.detallesNoInventariables = [];

    vm.detallesNoInventariablesAgrupados = [];

    vm.mostrarInformacion = mostrarInformacion;
    vm.ubicacionCompleta = ubicacionCompleta;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.quitarTipo = quitarTipo;
    vm.modo = "nuevo";
    vm.abrirModal = abrirModal;
    vm.guardar = guardar;
    vm.getIcono = getIcono;

    window.onbeforeunload = function(){
      return '';
    };


    function inicializar(){
      if (vm.conciliacion && vm.conciliacion.empresa && vm.conciliacion.empresa.id){
        vm.fecha = $filter('date')(new Date(), 'dd/MM/yyyy HH:mm');
      } else {
        vm.ocultar=false;
      }
    }

    function getIcono(estaAbierto) {
      if (estaAbierto) {
        return 'glyphicon glyphicon-chevron-down';
      } else {
        return 'glyphicon glyphicon-chevron-right';
      }
    }


    function guardar(){
      if (vm.detalles.length===0){
        ServicioDialogos.mostrarDialogoError(null, "No ha agregado ningún suministro");
      } else {
        ServicioDialogos.mostrarDialogoConfirmacionWarning(
          null,
          "¿Está seguro que desea guardar la conciliación?",
          function(){
            guardarConciliacion();
          },
          null,
          false
        );
      }
    }

    function ubicacionCompleta(detalle){
      if (detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación",
        "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+detalle.suministro.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+detalle.suministro.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+detalle.suministro.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+detalle.suministro.ubicacion.numeroUbicacion+
        "\nN° de orden: "+detalle.suministro.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+detalle.suministro.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+detalle.suministro.ubicacion.categoriaPeso.nombre.toUpperCase());
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "No hay ubicación");
      }
    }

    function ubicacionNaveNumeroOrden(detalle){
      if (detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        return "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+detalle.suministro.ubicacion.numeroOrden;
      }
    }

    function quitarTipo(agrupado){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(
        null,
        "¿Está seguro que desea eliminar el detalle?",
        function(){
          limpiarTipo(agrupado.tipoSuministro);
        }
      );
    }

    function limpiarTipo(tipo){
      for (var i = vm.detalles.length - 1; i >= 0; i--) {
        if (vm.detalles[i].suministro.tipoSuministro.id == tipo.id){
          vm.detalles.splice(i, 1);
        }
      }
      vm.detallesNoInventariablesAgrupados = [];
      cargarDetalles();
    }

    function obtenerNumeroMovimiento(callback){
      UltimoMovimiento.get({}, function(data){
        if (data && !isNaN(data.id)){
          callback(data.id + 10001);
        } else {
          callback(10001);
        }
      }, function (err){
        console.log(err);
      });
    }

    function obtenerEstado(){
      return vm.conciliacion.tipoMovimiento.id==5? estadoCreadaIngreso : estadoCreadaEgreso;
    }

    function obtenerConciliacion(callback){
      obtenerNumeroMovimiento(function(data){
        var movimiento = {
          tipoMovimiento: vm.conciliacion.tipoMovimiento,
          estadoMovimiento: obtenerEstado(),
          deposito: vm.conciliacion.deposito,
          empresa: vm.conciliacion.empresa,
          observacion: vm.conciliacion.observacion,
          fecha: new Date(),
          detalles: vm.detalles,
          usuario: vm.conciliacion.usuario,
          numeroMovimiento: data,
        };
        callback(movimiento);
      });
    }

    function mostrarMensajeExito(){
      ServicioDialogos.mostrarDialogoGuardadoExito(
        null,
        "Se ha registrado con éxito la conciliación",
        function(){
          $state.go('home.lista-conciliaciones');
        }
      );
    }

    function ocuparUbicacion(data){
      var ubicacion = vm.ubicacionAsignada.id;
      ActualizarEstadoUbicacion.update({"idUbicacion":ubicacion, "ocupar":vm.ocuparUbicacion}, function(){
        mostrarMensajeExito();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
      });
    }

    function guardarConciliacion(){
      obtenerConciliacion(function(movimiento){
        Conciliacion.save(movimiento, function(data){
          if (vm.conciliacion.tipoMovimiento.id==5){
            ocuparUbicacion(data);
          } else {
            mostrarMensajeExito();
          }
        }, function(err){
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar la conciliación");
        });
      });
    }

    function cargarDetalles(){
      vm.detallesNoInventariables = [];
      vm.detalles.forEach(function(detalle){
        if (detalle.suministro.tipoSuministro.inventariable){
          vm.detallesInventariables.push(detalle);
        } else {
          vm.detallesNoInventariables.push(detalle);
        }
      });
      if (vm.detallesNoInventariables.length>0){
        armarDetallesNoInventariables();
      } else {
        actualizarTablaNoInventariables();
      }
    }

    function obtenerTiposUtilizados(){
      var esta = false;
      vm.detallesNoInventariables.forEach(function(detalle){
        esta = false;
        vm.detallesNoInventariablesAgrupados.forEach(function(agrupado){
          if (detalle.suministro.tipoSuministro.id==agrupado.tipoSuministro.id){
            esta = true;
          }
        });
        if (!esta){
          vm.detallesNoInventariablesAgrupados.push({tipoSuministro:detalle.suministro.tipoSuministro, precioTotal:0.0, cantidad:0, detalles:[]});
        }
      });
    }

    function armarDetallesNoInventariablesAgrupados(){
      vm.detallesNoInventariablesAgrupados.forEach(function(agrupado){
        vm.detallesNoInventariables.forEach(function(detalle){
          if (agrupado.tipoSuministro.id===detalle.suministro.tipoSuministro.id){
            agrupado.detalles.push({suministro:detalle.suministro, cantidad:detalle.cantidad});
            agrupado.cantidad = agrupado.cantidad + detalle.cantidad;
            agrupado.precioTotal = agrupado.precioTotal + detalle.suministro.precioUnitario*detalle.cantidad;
          }
        });
      });
    }

    function armarDetallesNoInventariables(){
      obtenerTiposUtilizados();
      armarDetallesNoInventariablesAgrupados();
      actualizarTablaNoInventariables();
    }

    function abrirModalConciliacionEgreso(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalAgregarSuministroEgresoConciliacion({
        onResult: function(resultado) {
          vm.detalles = resultado.detalles;
          vm.detallesNoInventariablesAgrupados = [];
          cargarDetalles();
        },
        detalles: vm.detalles,
        empresa: vm.conciliacion.empresa,
        deposito: vm.conciliacion.deposito.id,
      });
    }

    function abrirModalConciliacionIngreso(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalAgregarSuministroIngresoConciliacion({
        onResult: function(resultado) {
          vm.detalles = resultado.detalles;
          vm.ubicacionAsignada = resultado.ubicacionAsignada;
          vm.ocuparUbicacion = resultado.ocuparUbicacion;
          vm.detallesNoInventariablesAgrupados = [];
          cargarDetalles();
        },
        detalles: vm.detalles,
        empresa: vm.conciliacion.empresa,
        deposito: vm.conciliacion.deposito,
      });
    }

    function abrirModal(){
      if (vm.conciliacion.tipoMovimiento.id==5){
        abrirModalConciliacionIngreso();
      } else {
        abrirModalConciliacionEgreso();
      }
    }

    function esEditar(){
      return vm.modo == "editar";
    }

    function volver(){
      if (vm.ocultar){
        ServicioDialogos.mostrarDialogoConfirmacionWarning(
          null,
          "Si vuelve a la pantalla de edición de conciliación, perderá la información de todos los suministros que haya agregado. ¿Está seguro que desea volver?",
          function(){
            $state.go("home.editar-conciliacion", {conciliacion:conciliacion});
          }
        );
      } else {
        $state.go("home.editar-conciliacion", {});
      }
    }

    function mostrarInformacion(detalle){
      var marca = detalle.suministro.marca ? detalle.suministro.marca : "-";
      var fecha = detalle.suministro.fechaVencimiento ? detalle.suministro.fechaVencimiento : "-";
      ServicioDialogos.mostrarDialogoInformacion(
        null,
        "Tipo de suministro: "+detalle.suministro.tipoSuministro.nombre.toUpperCase()+
        "\nMarca: "+marca.toUpperCase()+
        "\nFecha vencimiento: "+$filter('date')(fecha, 'dd/MM/yyyy')+
        "\nFamilia de suministro: "+detalle.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase()+
        "\nGrupo de suministro: "+detalle.suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+
        "\nCantidad solicitada: "+detalle.cantidad
      );
    }

    function actualizarTablaNoInventariables(){
      vm.tableParamsNoInventariableAgrupado.settings({
        data: vm.detallesNoInventariablesAgrupados,
        noPager: true,
        counts: []
      });
      vm.tableParamsNoInventariableAgrupado.reload();
    }

    function actualizarTablaInventariables(){
      vm.tableParamsInventariableAgrupado.settings({
        data: vm.detallesInventariablesAgrupados,
        noPager: true,
        counts: []
      });
      vm.tableParamsInventariableAgrupado.reload();
    }

    function comprobarExistencia(){
      var ban = false;
      vm.detalles.forEach(function(detalle){
        if (detalle.suministro.id==vm.suministro.id){
          ban = true;
        }
      });
      return ban;
    }

    function agregarDetalle(){
      if (!comprobarExistencia()){
        var detalle = {
          suministro : vm.suministro,
          cantidad : vm.cantidad
        };
        vm.numero = vm.numero+1;
        vm.detalles.push(detalle);
        actualizarTabla(vm.detalles);
      } else {
        ServicioDialogos.mostrarDialogoError(null, "Ya agregó este suministro al pedido");
      }
    }

    vm.tableParamsNoInventariableAgrupado = new NgTableParams({
      page: 1,
      count: 10,
      group:{
        tipoSuministro: 'desc'
      }
    });
   
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.visualizar-egreso-despachado', {
        url: 'visualizar-egreso-despachado/:objeto',
        templateUrl: 'app/app/main/movimientos/egreso/visualizar-egreso-despachado/visualizar-egreso-despachado.html',
        controller: 'VisualizarEgresoDespachadoCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Egreso de suministros',
          subtituloNuevo: 'Visualizar información del egreso despachado',
        },
        resolve: {
          egreso: function(Egreso, $stateParams){
            if ($stateParams.objeto){
              return Egreso.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return $stateParams.objeto;
            }
          },
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('VisualizarEgresoDespachadoCtrl', VisualizarEgresoDespachadoCtrl);

  /** @ngInject */
  function VisualizarEgresoDespachadoCtrl(NgTableParams, rol, HeaderBarService, URL_SERVIDOR, $http, $window, ServicioModales, egreso, $stateParams, $filter, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);

    var vm = this;
    vm.egreso = egreso;
    vm.volver = volver;
    vm.rol = rol;

    vm.detalles = vm.egreso.detalles;
    vm.visualizarEgreso = visualizarEgreso;

    vm.detallesInventariables = [];
    vm.detallesNoInventariables = [];

    vm.detallesNoInventariablesAgrupados = [];
    vm.detallesInventariablesAgrupados = [];

    vm.ubicacionCompleta = ubicacionCompleta;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;


    inicializar();

    vm.editarSuministro = editarSuministro;
    vm.editarProblemas = editarProblemas;
    vm.comprobarEstadoEgreso = comprobarEstadoEgreso;
    vm.imprimirInforme = imprimirInforme;

    function imprimirInforme(){
      ServicioDialogos.abrirDialogoCargando();
      $http.get(URL_SERVIDOR+"/movimiento/reporte/movimiento/"+vm.egreso.id, {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function inicializar(){
      if (!vm.egreso.id) return;
      vm.fechaCreacion=$filter('date')(vm.egreso.fecha, 'dd/MM/yyyy HH:mm');
      vm.fechaDespacho=$filter('date')(vm.egreso.egreso.fecha, 'dd/MM/yyyy HH:mm');
      vm.montoTotal = montoTotal();
      armarPersona();
      crearTablas();
      actualizarTabla();
      vm.detallesNoInventariablesAgrupados = [];
      vm.detallesInventariablesAgrupados = [];
      cargarDetalles();
    }

    function visualizarEgreso(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalVisualizarDespacho({
        onResult: function(resultado) {
          //console.log(resultado);
        },
        egreso: vm.egreso.egreso,
      });
    }

    function armarPersona(){
      if (vm.egreso.egreso.personaEmpresaLogistica && vm.egreso.egreso.personaEmpresaLogistica.id){
        vm.persona=vm.egreso.egreso.personaEmpresaLogistica.apellido.toUpperCase()+" ,"+vm.egreso.egreso.personaEmpresaLogistica.nombre.toUpperCase();
      } else {
        vm.persona=null;
      }
    }


    function ubicacionCompleta(detalle){
      if (detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación",
        "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+detalle.suministro.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+detalle.suministro.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+detalle.suministro.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+detalle.suministro.ubicacion.numeroUbicacion+
        "\nN° de orden: "+detalle.suministro.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+detalle.suministro.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+detalle.suministro.ubicacion.categoriaPeso.nombre.toUpperCase());
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "No hay ubicación");
      }
    }

    function ubicacionNaveNumeroOrden(detalle){
      //console.log(detalle);
      if (detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        return "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+detalle.suministro.ubicacion.numeroOrden;
      }
    }


    function cargarDetalles(){
      vm.detallesInventariables = [];
      vm.detallesNoInventariables = [];
      vm.detalles.forEach(function(detalle){
        if (detalle.suministro.tipoSuministro.inventariable){
          vm.detallesInventariables.push(detalle);
        } else {
          vm.detallesNoInventariables.push(detalle);
        }
      });
      if (vm.detallesNoInventariables.length>0){
        armarDetallesNoInventariables();
      } else {
        actualizarTablaNoInventariables();
      }
      if (vm.detallesInventariables.length>0){
        armarDetallesInventariables();
      } else {
        actualizarTablaInventariables();
      }
    }

    function obtenerTiposUtilizados(){
      var esta = false;
      vm.detallesNoInventariables.forEach(function(detalle){
        esta = false;
        vm.detallesNoInventariablesAgrupados.forEach(function(agrupado){
          if (detalle.suministro.tipoSuministro.id==agrupado.tipoSuministro.id){
            esta = true;
          }
        });
        if (!esta){
          vm.detallesNoInventariablesAgrupados.push({tipoSuministro:detalle.suministro.tipoSuministro, precioTotal:0.0, cantidad:0, detalles:[]});
        }
      });
    }

    function armarDetallesNoInventariablesAgrupados(){
      vm.detallesNoInventariablesAgrupados.forEach(function(agrupado){
        vm.detallesNoInventariables.forEach(function(detalle){
          if (agrupado.tipoSuministro.id===detalle.suministro.tipoSuministro.id){
            agrupado.detalles.push({suministro:detalle.suministro, cantidad:detalle.cantidad});
            agrupado.cantidad = agrupado.cantidad + detalle.cantidad;
            agrupado.precioTotal = agrupado.precioTotal + detalle.suministro.precioUnitario*detalle.cantidad;
          }
        });
      });
    }

    function armarDetallesNoInventariables(){
      obtenerTiposUtilizados();
      armarDetallesNoInventariablesAgrupados();
      actualizarTablaNoInventariables();
    }

    function obtenerTiposInventariablesUtilizados(){
      var esta = false;
      vm.detallesInventariables.forEach(function(detalle){
        esta = false;
        vm.detallesInventariablesAgrupados.forEach(function(agrupado){
          if (detalle.suministro.tipoSuministro.id==agrupado.tipoSuministro.id){
            esta = true;
          }
        });
        if (!esta){
          vm.detallesInventariablesAgrupados.push({tipoSuministro:detalle.suministro.tipoSuministro, precioTotal:0.0, cantidad:0, detalles:[]});
        }
      });
    }

    function armarDetallesInventariablesAgrupados(){
      vm.detallesInventariablesAgrupados.forEach(function(agrupado){
        vm.detallesInventariables.forEach(function(detalle){
          if (agrupado.tipoSuministro.id===detalle.suministro.tipoSuministro.id){
            agrupado.detalles.push({suministro:detalle.suministro, suministroInventariable:detalle.suministroInventariable, cantidad:detalle.cantidad});
            agrupado.cantidad = agrupado.cantidad + detalle.cantidad;
            agrupado.precioTotal = agrupado.precioTotal + detalle.suministro.precioUnitario;
          }
        });
      });
    }

    function armarDetallesInventariables(){
      obtenerTiposInventariablesUtilizados();
      armarDetallesInventariablesAgrupados();
      actualizarTablaInventariables();
    }

    function editarProblemas(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea agregar o quitar problemas en este egreso?', function(){
        $state.go('home.problemas-egreso',{objeto:vm.egreso.id});
      });
    }

    function editarSuministro(suministro){
      if (suministro.suministro && suministro.suministro.tipoSuministro && suministro.suministro.tipoSuministro.inventariable) {
        editarSuministroInventariable(suministro);
      } else {
        editarSuministroNoInventariable(suministro);
      }
    }

    function editarSuministroInventariable(suministro){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Está seguro que desea editar la información del suministro?", function(){
        ServicioDialogos.abrirDialogoCargando();
        ServicioModales.abrirModalEditarSuministro({
          onResult: function(resultado){
            $window.location.reload();
          },
          suministro:suministro.suministroInventariable,
          modo:'editar'
        });
      });
    }

    function editarSuministroNoInventariable(suministro){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Está seguro que desea editar la información del suministro?", function(){
        ServicioDialogos.abrirDialogoCargando();
        ServicioModales.abrirModalEditarSuministroNoInventariable({
          onResult: function(resultado){
            $window.location.reload();
          },
          suministro:suministro.suministro,
          modo:'editar'
        });
      });
    }

    function volver(){
      $state.go("home.lista-egreso");
    }

    function montoTotal(){
      var total = 0;
      for(var i = 0; i < vm.egreso.detalles.length; i++){
        total += vm.egreso.detalles[i].suministro.precioUnitario*vm.egreso.detalles[i].cantidad;
      }
      return total ? '$ '+total.toFixed(2) : "-";
    }

    function actualizarTablaNoInventariables(){
      vm.tableParamsNoInventariableAgrupado.settings({
        data: vm.detallesNoInventariablesAgrupados,
        noPager: true,
        counts: []
      });
      vm.tableParamsNoInventariableAgrupado.reload();
    }

    function actualizarTablaInventariables(){
      vm.tableParamsInventariableAgrupado.settings({
        data: vm.detallesInventariablesAgrupados,
        noPager: true,
        counts: []
      });
      vm.tableParamsInventariableAgrupado.reload();
    }

    function actualizarTabla(){
      vm.tableParams1.settings({
        data: orderByFilter(vm.egreso.problemas,'nombre', false),
        noPager: true,
        count: []
      });
      vm.tableParams1.reload();
    }

    function crearTablas(){
      vm.tableParamsInventariableAgrupado = new NgTableParams({
        page: 1,
        count: 10,
        group:{
          tipoSuministro: 'desc'
        }
      });
      vm.tableParamsNoInventariableAgrupado = new NgTableParams({
        page: 1,
        count: 10,
        group:{
          tipoSuministro: 'desc'
        }
      });
      vm.tableParams1 = new NgTableParams({
        page:1,
        count:20
      });
    }

    function comprobarEstadoEgreso(){
      return vm.egreso && vm.egreso.estadoMovimiento && vm.egreso.estadoMovimiento.id==4;
    }
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.visualizar-egreso', {
        url: 'visualizar-egreso/:objeto/:estadoAnterior',
        templateUrl: 'app/app/main/movimientos/egreso/visualizar-egreso/visualizar-egreso.html',
        controller: 'VisualizarEgresoCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Egreso de suministros',
          subtituloNuevo: 'Visualizar información del egreso',
        },
        resolve: {
          egreso: function(Egreso, $stateParams){
            if ($stateParams.objeto){
              return Egreso.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return $stateParams.objeto;
            }
          },
          estadoAnterior: function($stateParams){
            return $stateParams.estadoAnterior? $stateParams.estadoAnterior : 1;
          },
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('VisualizarEgresoCtrl', VisualizarEgresoCtrl);

  /** @ngInject */
  function VisualizarEgresoCtrl(NgTableParams, rol, HeaderBarService, URL_SERVIDOR, $window, $http, ServicioModales, estadoAnterior, egreso, $stateParams, $filter, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);

    var vm = this;
    vm.egreso = egreso;
    vm.volver = volver;
    vm.rol = rol;
    vm.estadoAnterior = estadoAnterior;

    vm.detalles = vm.egreso.detalles;

    vm.detallesInventariables = [];
    vm.detallesNoInventariables = [];

    vm.detallesNoInventariablesAgrupados = [];
    vm.detallesInventariablesAgrupados = [];
    vm.detallesNoInventariablesAgrupadosCajas = [];


    vm.ubicacionCompleta = ubicacionCompleta;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.ubicacionCompletaCaja = ubicacionCompletaCaja;
    vm.ubicacionNaveNumeroOrdenCaja = ubicacionNaveNumeroOrdenCaja;
    vm.cajas = vm.egreso.caja? "SI" : "NO";


    inicializar();

    vm.editarSuministro = editarSuministro;
    vm.editarProblemas = editarProblemas;
    vm.comprobarEstadoEgreso = comprobarEstadoEgreso;
    vm.imprimirInforme = imprimirInforme;

    function imprimirInforme(){
      ServicioDialogos.abrirDialogoCargando();
      $http.get(URL_SERVIDOR+"/movimiento/reporte/movimiento/"+vm.egreso.id, {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }


    function inicializar(){
      if (!vm.egreso.id) return;
      vm.fecha=$filter('date')(vm.egreso.fecha, 'dd/MM/yyyy HH:mm');
      vm.montoTotal = montoTotal();
      vm.cajasAsignadas = obtenerNumeroCajas();
      crearTablas();
      actualizarTabla();
      vm.detallesNoInventariablesAgrupados = [];
      vm.detallesInventariablesAgrupados = [];
      cargarDetalles();
    }

    function obtenerNumeroCajas(){
      var numeros = [];
      var hash = {};
      vm.egreso.detalles.forEach(function(item){
        numeros.push(item.numeroCaja);
      });
      numeros = numeros.filter(function(current) {
        var exists = !hash[current] || false;
        hash[current] = true;
        return exists;
      });
      return numeros;
    }


    function ubicacionCompleta(detalle){
      if (detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación",
        "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+detalle.suministro.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+detalle.suministro.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+detalle.suministro.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+detalle.suministro.ubicacion.numeroUbicacion+
        "\nN° de orden: "+detalle.suministro.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+detalle.suministro.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+detalle.suministro.ubicacion.categoriaPeso.nombre.toUpperCase());
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "No hay ubicación");
      }
    }

    function ubicacionNaveNumeroOrden(detalle){
      //console.log(detalle);
      if (detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        return "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+detalle.suministro.ubicacion.numeroOrden;
      } else {
        return "El suministro no posee ubicación";
      }
    }

    function ubicacionCompletaCaja(detalle){
      if (detalle.ubicacion && detalle.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación",
        "Nave: "+detalle.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+detalle.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+detalle.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+detalle.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+detalle.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+detalle.ubicacion.numeroUbicacion+
        "\nN° de orden: "+detalle.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+detalle.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+detalle.ubicacion.categoriaPeso.nombre.toUpperCase());
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "No hay ubicación");
      }
    }

    function ubicacionNaveNumeroOrdenCaja(detalle){
      //console.log(detalle);
      if (detalle.ubicacion && detalle.ubicacion.nivel) {
        return "Nave: "+detalle.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+detalle.ubicacion.numeroOrden;
      } else {
        return "La caja no posee ubicación";
      }
    }


    function cargarDetalles(){
      vm.detallesInventariables = [];
      vm.detallesNoInventariables = [];
      vm.detalles.forEach(function(detalle){
        if (detalle.suministro.tipoSuministro.inventariable){
          vm.detallesInventariables.push(detalle);
        } else {
          vm.detallesNoInventariables.push(detalle);
        }
      });
      if (vm.detallesNoInventariables.length>0){
        armarDetallesNoInventariables();
      } else {
        actualizarTablaNoInventariables();
      }
      if (vm.detallesInventariables.length>0){
        if (vm.egreso.caja){
          armarDetallesInventariablesCajas();
        } else {
          armarDetallesInventariables();
        }
      } else {
        actualizarTablaInventariables();
      }
    }

    function obtenerTiposUtilizados(){
      var esta = false;
      vm.detallesNoInventariables.forEach(function(detalle){
        esta = false;
        vm.detallesNoInventariablesAgrupados.forEach(function(agrupado){
          if (detalle.suministro.tipoSuministro.id==agrupado.tipoSuministro.id){
            esta = true;
          }
        });
        if (!esta){
          vm.detallesNoInventariablesAgrupados.push({tipoSuministro:detalle.suministro.tipoSuministro, precioTotal:0.0, cantidad:0, detalles:[]});
        }
      });
    }

    function armarDetallesNoInventariablesAgrupados(){
      vm.detallesNoInventariablesAgrupados.forEach(function(agrupado){
        vm.detallesNoInventariables.forEach(function(detalle){
          if (agrupado.tipoSuministro.id===detalle.suministro.tipoSuministro.id){
            agrupado.detalles.push({suministro:detalle.suministro, cantidad:detalle.cantidad});
            agrupado.cantidad = agrupado.cantidad + detalle.cantidad;
            agrupado.precioTotal = agrupado.precioTotal + detalle.suministro.precioUnitario*detalle.cantidad;
          }
        });
      });
    }

    function armarDetallesNoInventariables(){
      obtenerTiposUtilizados();
      armarDetallesNoInventariablesAgrupados();
      actualizarTablaNoInventariables();
    }

    function obtenerTiposInventariablesUtilizados(){
      var esta = false;
      vm.detallesInventariables.forEach(function(detalle){
        esta = false;
        vm.detallesInventariablesAgrupados.forEach(function(agrupado){
          if (detalle.suministro.tipoSuministro.id==agrupado.tipoSuministro.id){
            esta = true;
          }
        });
        if (!esta){
          vm.detallesInventariablesAgrupados.push({tipoSuministro:detalle.suministro.tipoSuministro, precioTotal:0.0, cantidad:0, detalles:[]});
        }
      });
    }

    function armarDetallesInventariablesAgrupados(){
      vm.detallesInventariablesAgrupados.forEach(function(agrupado){
        vm.detallesInventariables.forEach(function(detalle){
          if (agrupado.tipoSuministro.id===detalle.suministro.tipoSuministro.id){
            agrupado.detalles.push({suministro:detalle.suministro, suministroInventariable:detalle.suministroInventariable, cantidad:detalle.cantidad});
            agrupado.cantidad = agrupado.cantidad + detalle.cantidad;
            agrupado.precioTotal = agrupado.precioTotal + detalle.suministro.precioUnitario;
          }
        });
      });
    }

    function armarDetallesInventariables(){
      obtenerTiposInventariablesUtilizados();
      armarDetallesInventariablesAgrupados();
      actualizarTablaInventariables();
    }

    function armarDetallesCajaAgrupados(){
      vm.detallesInventariablesAgrupadosCajas = [];
      vm.cajasAsignadas.forEach(function(numeroCaja){
        vm.detallesInventariablesAgrupadosCajas.push({numeroCaja:numeroCaja, tipoSuministro:null, precioTotal:0.0, cantidad:0, detalles:[], ubicacion:null});
      });
    }

    function armarDetallesInventariablesAgrupadosCajas(){
      vm.detallesInventariablesAgrupadosCajas.forEach(function(agrupado){
        vm.detallesInventariables.forEach(function(detalle){
          if (agrupado.numeroCaja===detalle.numeroCaja){
            agrupado.detalles.push({suministro:detalle.suministro, suministroInventariable:detalle.suministroInventariable, cantidad:detalle.cantidad});
            agrupado.cantidad = agrupado.cantidad + detalle.cantidad;
            agrupado.precioTotal = agrupado.precioTotal + detalle.suministro.precioUnitario;
            agrupado.ubicacion = detalle.suministro.ubicacion;
            agrupado.tipoSuministro = detalle.suministro.tipoSuministro;
          }
        });
      });
    }

    function armarDetallesInventariablesCajas(){
      armarDetallesCajaAgrupados();
      armarDetallesInventariablesAgrupadosCajas();
      actualizarTablaInventariablesCajas();
    }

    function editarProblemas(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea agregar o quitar problemas en este egreso?', function(){
        $state.go('home.problemas-egreso',{objeto:vm.egreso.id});
      });
    }

    function editarSuministro(suministro){
      if (suministro.suministro && suministro.suministro.tipoSuministro && suministro.suministro.tipoSuministro.inventariable) {
        editarSuministroInventariable(suministro);
      } else {
        editarSuministroNoInventariable(suministro);
      }
    }

    function editarSuministroInventariable(suministro){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Está seguro que desea editar la información del suministro?", function(){
        ServicioDialogos.abrirDialogoCargando();
        ServicioModales.abrirModalEditarSuministro({
          onResult: function(resultado){
            $window.location.reload();
          },
          suministro:suministro.suministroInventariable,
          modo:'editar'
        });
      });
    }

    function editarSuministroNoInventariable(suministro){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Está seguro que desea editar la información del suministro?", function(){
        ServicioDialogos.abrirDialogoCargando();
        ServicioModales.abrirModalEditarSuministroNoInventariable({
          onResult: function(resultado){
            $window.location.reload();
          },
          suministro:suministro.suministro,
          modo:'editar'
        });
      });
    }

    function volver(){
      if (estadoAnterior==2){
        $window.history.back();
      } else {
        $state.go("home.lista-egreso");
      }
    }

    function montoTotal(){
      var total = 0;
      for(var i = 0; i < vm.egreso.detalles.length; i++){
        total += vm.egreso.detalles[i].suministro.precioUnitario*vm.egreso.detalles[i].cantidad;
      }
      return total ? '$ '+total.toFixed(2) : "-";
    }

    function actualizarTablaNoInventariables(){
      vm.tableParamsNoInventariableAgrupado.settings({
        data: vm.detallesNoInventariablesAgrupados,
        noPager: true,
        counts: []
      });
      vm.tableParamsNoInventariableAgrupado.reload();
    }

    function actualizarTablaInventariables(){
      vm.tableParamsInventariableAgrupado.settings({
        data: vm.detallesInventariablesAgrupados,
        noPager: true,
        counts: []
      });
      vm.tableParamsInventariableAgrupado.reload();
    }

    function actualizarTablaInventariablesCajas(){
      vm.tableParamsInventariableAgrupadoCajas.settings({
        data: vm.detallesInventariablesAgrupadosCajas,
        noPager: true,
        counts: []
      });
      vm.tableParamsInventariableAgrupadoCajas.reload();
    }

    function actualizarTabla(){
      vm.tableParams1.settings({
        data: orderByFilter(vm.egreso.problemas,'nombre', false),
        noPager: true,
        count: []
      });
      vm.tableParams1.reload();
    }

    function crearTablas(){
      vm.tableParamsInventariableAgrupado = new NgTableParams({
        page: 1,
        count: 10,
        group:{
          tipoSuministro: 'desc'
        }
      });
      vm.tableParamsNoInventariableAgrupado = new NgTableParams({
        page: 1,
        count: 10,
        group:{
          tipoSuministro: 'desc'
        }
      });
      vm.tableParams1 = new NgTableParams({
        page:1,
        count:20
      });
      vm.tableParamsInventariableAgrupadoCajas = new NgTableParams({
        page: 1,
        count: 10,
        group:{
          tipoSuministro: 'desc'
        }
      });
    }

    function comprobarEstadoEgreso(){
      return vm.egreso && vm.egreso.estadoMovimiento && (vm.egreso.estadoMovimiento.id==1 ||vm.egreso.estadoMovimiento.id==4 || vm.egreso.estadoMovimiento.id==2 || vm.egreso.estadoMovimiento.id==3);
    }
  }
})();

(function() {
'use strict';
angular.module('proyecto-az-suministro')
  .factory('CantidadReclamosDeposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/reclamos/cantidad/:idDeposito",{idDeposito:'@idDeposito'});
  })
  .factory('CantidadReclamos', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/reclamos/cantidad",{});
  })
  .factory('EgresoConReclamoDeposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/reclamos/:idDeposito",{deposito:"@deposito"});
  })
  .factory('EgresoConReclamoDepositoEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/reclamos/:idDeposito/:idEmpresa",{deposito:"@deposito", empresa:"@empresa"});
  })
  .factory('EgresoConReclamo', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/reclamos",{});
  });
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.problemas-egreso', {
        url: 'problemas-egreso/:objeto',
        templateUrl: 'app/app/main/movimientos/egreso/problemas/editar-problemas.html',
        controller: 'EditarProblemasEgresoCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Egreso de suministros',
          subtituloNuevo: 'Agregar o quitar problemas en un egreso de suministros',
        },
        resolve: {
          egreso: function(Egreso, $stateParams){
            if ($stateParams.objeto){
              return Egreso.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return $stateParams.objeto;
            }
          },
          problemas: function(Problema){
            return Problema.query().$promise.then(function(data){
              return data;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarProblemasEgresoCtrl', EditarProblemasEgresoCtrl);

  /** @ngInject */
  function EditarProblemasEgresoCtrl(NgTableParams, HeaderBarService, $window, ProblemaIngreso, ServicioModales, problemas, egreso, $stateParams, $filter, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);

    var vm = this;
    vm.egreso = egreso;
    vm.volver = volver;
    vm.problemas = problemas;
    inicializar();
    vm.eliminarProblema = eliminarProblema;
    vm.editarProblemas = editarProblemas;
    vm.agregarProblema = agregarProblema;
    vm.verProblema = verProblema;
    vm.comprobarEgresoCerrado = comprobarEgresoCerrado;

    function inicializar(){
      vm.fecha=$filter('date')(vm.egreso.fecha, 'dd/MM/yyyy HH:mm');
      vm.montoTotal = montoTotal();
      crearTablas();
      actualizarTabla();
      setearObservacion();
    }

    function setearObservacion(){
      if (!vm.egreso.observacionProblema){
        vm.egreso.observacionProblema='';
      }
    }

    function verProblema(problema){
      ServicioDialogos.mostrarDialogoInformacion(
        "Información",
        "Problema: "+problema.nombre.toUpperCase()+"\n"+problema.descripcion
      );
    }

    function estaProblema(){
      var esta = false;
      vm.egreso.problemas.forEach(function(prob){
        if (vm.problema.id==prob.id){
          esta = true;
        }
      });
      return esta;
    }

    function agregarProblema(){
      if (estaProblema()){
        ServicioDialogos.mostrarDialogoError(null, "El problema seleccionado, ya fue asignado al egreso");
      } else {
        vm.egreso.problemas.push(vm.problema);
        actualizarTabla();
      }
    }

    function editarProblemas(problema){
      if (vm.egreso.observacionProblema.length==0 && vm.egreso.problemas.length>0){
        ServicioDialogos.mostrarDialogoError(null, "Si agrega un problema, debe ingresar una descripción");
      } else if (vm.egreso.observacionProblema.length>0 && vm.egreso.problemas.length==0) {
        ServicioDialogos.mostrarDialogoError(null, "Si agrega una descripción, debe agregar al menos un problema");
      } else {
        editarProblemaEgreso(problema);
      }
    }

    function editarProblemaEgreso(problema){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Está seguro que desea guardar la edición de los problemas en este egreso?", function(){
        ProblemaIngreso.update(vm.egreso, function(data){
          ServicioDialogos.mostrarDialogoGuardadoExito(null, "Se ha registrado correctamente la información de los problemas", function(){
            $state.go('home.visualizar-egreso', {objeto:vm.egreso.id});
          });
        }, function(err){
          console.log(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar la información de los problemas");
        });
      }, null, false);
    }

    function eliminarProblema(index){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "La eliminación de un problema, se verá reflejada en el egreso, cuando presione el botón 'GUARDAR', una vez que termine la edición\n¿Está seguro que desea eliminar el problema en este egreso?", function(){
        vm.egreso.problemas.splice(index, 1);
        actualizarTabla();
      });
    }

    function volver(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "No se guardará ningún cambio. ¿Está seguro que desea cancelar", function(){
        $state.go('home.visualizar-egreso', {objeto:vm.egreso.id});
      });
    }

    function montoTotal(){
      var total = 0;
      for(var i = 0; i < vm.egreso.detalles.length; i++){
        total += vm.egreso.detalles[i].suministro.precioUnitario*vm.egreso.detalles[i].cantidad;
      }
      return total ? '$ '+total.toFixed(2) : "-";
    }

    function actualizarTabla(){
      vm.tableParams.settings({
        data: orderByFilter(vm.egreso.problemas,'nombre',false),
        noPager: true,
        counts: []
      });
      vm.tableParams.reload();
    }

    function crearTablas(){
      vm.tableParams = new NgTableParams({
        page: 1,
        count: 500
      });
    }

    function comprobarEgresoCerrado(){
      return vm.egreso.estadoMovimiento.id==1;
    }
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.egreso-multisucursal', {
        url: 'egreso-multisucursal',
        templateUrl: 'app/app/main/movimientos/egreso/nuevo-egreso-multisucursal/nuevo-egreso-multisucursal.html',
        controller: 'NuevoEgresoMultisucursalCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Egreso del mismo suministro a múltiples sucursales',
          subtituloNuevo: 'Nuevo egreso a múltiples sucursales',
          egreso:null,
          editar:null
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          deposito: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return usuario.empleado.deposito;
              } else {
                return ;
              }
            });
          },
          tipoEgreso: function(TipoMovimiento){
            return TipoMovimiento.get({id:1}).$promise.then(function(data) {
              return data;
            });
          },
          estadoGenerado: function(EstadoMovimiento){
            return EstadoMovimiento.get({id:1}).$promise.then(function(data) {
              return data;
            });
          },
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data){
              return data;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('NuevoEgresoMultisucursalCtrl', NuevoEgresoMultisucursalCtrl);

  /** @ngInject */
  function NuevoEgresoMultisucursalCtrl(NgTableParams, deposito, HeaderBarService, focus, Egreso, estadoGenerado, depositos, UltimoMovimiento, tipoEgreso, empresas, SucursalEmpresa, $stateParams, $scope, $q, $timeout, orderByFilter, $state, ServicioModales, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);

    var vm = this;
    vm.tipoEgreso = tipoEgreso;
    vm.estadoGenerado = estadoGenerado;
    vm.depositos = orderByFilter(depositos,'nombre',false);
    vm.deposito = deposito;
    vm.empresas = orderByFilter(empresas,'nombre',false);
    vm.guardar = guardar;
    vm.cancelar = cancelar;
    vm.faltanDatos = faltanDatos;

    vm.verTipoSuministro = verTipoSuministro;
    vm.abrirModalSeleccionTipoSuministro = abrirModalSeleccionTipoSuministro;
    vm.cambiarTipoSuministro = cambiarTipoSuministro;
    vm.comprobarSucursalSeleccionada = comprobarSucursalSeleccionada;
    vm.seleccionar = seleccionar;
    vm.cambiarSeleccion = cambiarSeleccion;

    vm.cantidadSeleccionableNoInventariable = cantidadSeleccionableNoInventariable;
    vm.cantidadSeleccionableInventariable = cantidadSeleccionableInventariable;

    vm.asignarSuministrosAutomaticamente = asignarSuministrosAutomaticamente;

    vm.calcularAsignadoSucursal = calcularAsignadoSucursal;

    vm.agregarSuministros = agregarSuministros;
    vm.eliminar = eliminar;
    vm.verAsignados = verAsignados;

    vm.sucursalesSeleccionadas = [];
    vm.cantidadAsignadaNoInventariable = 0;
    vm.cantidadAsignadaInventariable = 0;

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 20,
    });

    vm.bandera=false;

    function asignarSuministrosAutomaticamente(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalEgresoMultipleAutomatico({
        onResult: function(resultado) {
          vm.cantidadAsignadaNoInventariable += resultado.cantidad;
          agregarSucursalesAgregadasAutomaticamente(resultado.sucursales);

        },
        empresa: vm.empresa,
        deposito: vm.deposito,
        sucursalesSeleccionadas: vm.sucursalesSeleccionadas,
        tipoSuministro: vm.tipoSuministro,
        listaNoInventariables: vm.listaNoInventariables,
        cantidadDisponible: cantidadSeleccionableNoInventariable()
      });

    }

    function agregarSucursalesAgregadasAutomaticamente(sucursales){
      sucursales.forEach(function(sucursal){
        vm.sucursalesSeleccionadas.push(sucursal);
      });
      actualizarTabla();
      $timeout(function() {
        ServicioDialogos.cerrarDialogoCargando();
      }, 500);
    }

    function seleccionar(){
      vm.bandera=true;
    }

    function cambiarSeleccion(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "Si continúa, perderá la información ingresada. \n¿Está seguro que desea cambiar la selección?", function(){
        $timeout(function() {
          vm.bandera=false;
          vm.tipoSuministro=null;
          vm.listaNoInventariables = [];
          vm.listaInventariables = [];
          vm.sucursalesSeleccionadas = [];
          vm.sucursal = null;
        }, 50);
      });
    }

    function faltanDatos(){
      var ban = false;
      vm.sucursalesSeleccionadas.forEach(function(item){
        if (item.detalles.length===0){
          ban = true;
        }
      });
      return ban;
    }

    function esTipoInventariable(){
      return vm.tipoSuministro.inventariable;
    }

    function getListaSuministros(){
      return esTipoInventariable() ? vm.listaInventariables : vm.listaNoInventariables;
    }

    function limpiarDetalles(detalles){
      if (esTipoInventariable()){
        limpiarDetallesInventariables(detalles);
      } else {
        limpiarDetallesNoInventariables(detalles);
      }
    }

    function limpiarDetallesInventariables(detalles){
      detalles.forEach(function(item){
        vm.listaInventariables.push(item.suministroInventariable);
        vm.cantidadAsignadaInventariable-=1;
      });
    }

    function recuperarCantidadNoInventariable(item){
      vm.listaNoInventariables.forEach(function(sum){
        if (sum.id==item.suministro.id){
          sum.cantidad+=item.cantidad;
          vm.cantidadAsignadaNoInventariable-=item.cantidad;
        }
      });
    }

    function limpiarDetallesNoInventariables(detalles){
      detalles.forEach(function(item){
        recuperarCantidadNoInventariable(item);
      });

    }

    function quitarSucursal(sucursal){
      var i = null;
      vm.sucursalesSeleccionadas.forEach(function(item, index){
        if (item.sucursal.id==sucursal.id){
          i = index;
        }
      });
      if (i!==null){
        vm.sucursalesSeleccionadas.splice(i,1);
        actualizarTabla();
      }
    }

    function eliminar(item){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "Si elimina la sucursal de este listado, se perderán el progreso y los suministros que haya asignado se habilitarán nuevamente para ser elegidos.\n¿Desea eliminar la sucursal del listado?", function(){
        limpiarDetalles(item.detalles);
        quitarSucursal(item.sucursal);
      });
    }

    function verAsignados(item){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalVisualizarSuministroAsignado({
        onResult: function(resultado) {
          console.log(resultado);
        },
        sucursal: item.sucursal,
        detalles: item.detalles,
        tipoSuministro: esTipoInventariable(),
        tipo : vm.tipoSuministro,
      });
    }

    function abrirModalSeleccionTipoSuministro(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalSeleccionTipoSuministro({
        onResult: function(resultado) {
          vm.tipoSuministro = resultado.tipoSuministro;
          if (vm.tipoSuministro.inventariable){
            vm.listaInventariables = resultado.suministros;
          } else {
            vm.listaNoInventariables = resultado.suministros;
          }
        },
        empresa: vm.empresa,
        deposito: vm.deposito.id
      });
    }

    function agregarCantidadAsignada(detalles){
      if (esTipoInventariable()){
        agregarCantidadAsignadaInventariable(detalles);
      } else {
        agregarCantidadAsignadaNoInventariable(detalles);
      }
    }

    function agregarCantidadAsignadaInventariable(detalles){
      var cant = 0;
      detalles.forEach(function(item){
        cant += item.cantidad;
      });
      vm.cantidadAsignadaInventariable += cant;
    }

    function agregarCantidadAsignadaNoInventariable(detalles){
      var can = 0;
      detalles.forEach(function(item){
        can += item.cantidad;
      });
      vm.cantidadAsignadaNoInventariable += can;
    }

    function cambiarDisponibles(lista){
      if (esTipoInventariable()){
        cambiarDisponiblesInventariable(lista);
      } else {
        cambiarDisponiblesNoInventariable(lista);
      }
    }

    function cambiarDisponiblesInventariable(lista){
      vm.listaInventariables = lista;
    }

    function cambiarDisponiblesNoInventariable(lista){
      vm.listaNoInventariables = lista;
    }

    function agregarSuministros(item){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalAgregarQuitarSuministroEgresoSucursal({
        onResult: function(resultado){
          item.detalles = resultado.detalles;
          cambiarDisponibles(resultado.suministros);
          agregarCantidadAsignada(resultado.detalles);
        },
        inventariable: esTipoInventariable(),
        tipo: vm.tipoSuministro,
        sucursal: item.sucursal,
        detalles: item.detalles,
        suministros: getListaSuministros(),
        deposito: vm.deposito.nombre.toUpperCase()
      });
    }

    function calcularAsignadoSucursal(item){
      if (!esTipoInventariable()){
        var cant = null;
        item.detalles.forEach(function(det){
          cant += det.cantidad;
        });
        return cant;
      } else {
        return item.detalles.length;
      }

    }

    function comprobarSucursalSeleccionada(){
      var esta = false;
      vm.sucursalesSeleccionadas.forEach(function(item){
        if (item.sucursal.id==vm.sucursal.id){
          esta = true;
        }
      });
      if (!esta){
        vm.sucursalesSeleccionadas.push({sucursal:vm.sucursal, detalles:[]});
        actualizarTabla();
        focus('sucursal');
      } else {
        ServicioDialogos.mostrarDialogoError(null, "Sucursal ya agregada");
      }
    }

    function cantidadSeleccionableInventariable (){
      if (vm.listaInventariables && vm.listaInventariables.length==0) return;
      return vm.listaInventariables.length>0? vm.listaInventariables.length : "0";
    }

    function cantidadSeleccionableNoInventariable(){
      if (vm.listaNoInventariables && vm.listaNoInventariables.length==0) return;
      var cantidad = 0;
      vm.listaNoInventariables.forEach(function(item){
        cantidad += item.cantidad;
      });
      return cantidad ? cantidad : "0";
    }

    function actualizarTabla(){
      vm.tableParams.settings({
        data: vm.sucursalesSeleccionadas
      });
      vm.tableParams.reload();
    }

    window.onbeforeunload = function(){
      return "seguro?";
    };

    function verTipoSuministro(){
      return vm.tipoSuministro ? vm.tipoSuministro.nombre.toUpperCase()+" - "+vm.tipoSuministro.familiaSuministro.nombre.toUpperCase()+" - "+vm.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase() : "-";
    }

    function cambiarTipoSuministro(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, 'Si confirma, perderá todo lo que haya ingresado\n¿Está seguro que desea cambiar el tipo de suministro?', function(){
        $timeout(function(){
          vm.tipoSuministro=null;
          vm.listaNoInventariables = [];
          vm.listaInventariables = [];
          vm.sucursalesSeleccionadas = [];
          vm.sucursal = null;
        }, 100);
      });
    }


    function cancelar(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea cancelar el egreso a múltples sucursales?', function() {
        $state.go('home.lista-egreso');
      });
    }

    function guardar(){
      if (!(!vm.tipoSuministro.id || vm.sucursalesSeleccionadas.length>0 || vm.faltanDatos())) return;
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea guardar los egresos a múltiples sucursales?', function() {
        guardarEgresosMultiples();
      }, null, false);
    }

    function guardarEgresosMultiples(){
      armarEgresosMultiples()
      .then(function(){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, "Se ha registrado el egreso múltiple con éxito", function(){
          $state.go('home.lista-egreso');
        });
      });
    }

    function armarEgresosMultiples(){
      var defer = $q.defer();
      var promise = defer.promise;
      vm.sucursalesSeleccionadas.forEach(function(item){
        promise = promise.then(function(){
          return armarEgreso(item).then(function(movimiento){
            return guardarEgreso(movimiento).then(function(dat){
              defer.resolve(true);
            });
          });
        });
      });
      defer.resolve(true);
      return promise;
    }

    function guardarEgreso(movimiento){
      var defer = $q.defer();
      var promise = defer.promise;
      Egreso.save(movimiento, function(data){
        defer.resolve(data);
        return promise;
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar el egreso");
        return $q.reject();
      });
      return promise;

    }

    function obtenerNumeroMovimiento(callback){
      UltimoMovimiento.get({}, function(data){
        if (data && !isNaN(data.id)){
          callback(data.id + 10001);
        } else {
          callback(10001);
        }
      }, function (err){
        console.log(err);
      });
    }

    function armarEgreso(item, callback){
      var defer = $q.defer();
      var promise = defer.promise;
      obtenerNumeroMovimiento(function(data){
        var movimiento = {
          tipoMovimiento: vm.tipoEgreso,
          estadoMovimiento: vm.estadoGenerado,
          sector: item.sector,
          deposito: vm.deposito,
          empresa: vm.empresa,
          numeroMail: vm.numeroMail,
          solicitante: vm.autoriza,
          numeroVale: vm.numeroVale,
          sucursal: item.sucursal,
          observacion: "",
          fecha: new Date(),
          detalles: obtenerDetallesConFecha(item.detalles),
          numeroMovimiento: data,
        };
        defer.resolve(movimiento);
      });
      return promise;
    }

    function obtenerDetallesConFecha(detalles){
      var fecha = new Date();
      detalles.forEach(function(item){
        item.fecha=fecha;
      });
      return detalles;
    }

    $scope.$watch('vm.empresa.nombre', function(){
      if (!vm.empresa) return;
      ServicioDialogos.abrirDialogoCargando();
      SucursalEmpresa.query({id:vm.empresa.id}, function(data){
        vm.sucursales = orderByFilter(data, "nombre", false);
        focus('seleccionar');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-generados', {
        url: 'lista-generados',
        templateUrl: 'app/app/main/movimientos/egreso/lista-generados/lista-generados.html',
        controller: 'ListaEgresoGeneradosCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar egresos',
          subtitulo:'Listado de egresos generados'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          deposito: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return usuario.empleado.deposito;
              } else {
                return ;
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaEgresoGeneradosCtrl', ListaEgresoGeneradosCtrl);

  /** @ngInject */
  function ListaEgresoGeneradosCtrl(NgTableParams, rol, deposito, HeaderBarService, $q, $filter, focus, depositos, IngresoEstadoModificar, EgresoModificarEstadoArray, EgresoDepositoEstadoUltimosCien , $stateParams, $scope, orderByFilter, $state, ServicioModales, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.egresos = [];
    vm.depositos = orderByFilter(depositos,'nombre',false);
    vm.visualizarEgreso = visualizarEgreso;
    vm.comprobarSeleccionado = comprobarSeleccionado;
    vm.ubicacionesPorSuministros = ubicacionesPorSuministros;
    vm.buscarPorDeposito = buscarPorDeposito;
    vm.cambiarFiltros = cambiarFiltros;
    vm.verNumeroCajasEgreso = verNumeroCajasEgreso;
    vm.marcarTodo = marcarTodo;
    vm.reporteSeleccionados = reporteSeleccionados;

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10,
    },{
      getData: function($defer,params){ return filtrarTabla($defer, params);}
    });
    vm.tableParams.reload();

    inicializar();


    function inicializar(){
      if (deposito && deposito.id){
        vm.deposito=deposito;
        buscarPorDeposito();
      }
    }

    function reporteSeleccionados(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Está seguro que desea generar un listado de egresos seleccionados?", function(){
        armarEgresosSeleccionadosRemito();
      });
    }

    function armarEgresosSeleccionadosRemito(){
      var egresosSeleccionados = [];
      vm.egresos.forEach(function(egreso){
        if (egreso.seleccionado){
          egresosSeleccionados.push(egreso);
        }
      });
      abrirModalInformeEgresosEnPreparacion(egresosSeleccionados);
    }

    function abrirModalInformeEgresosEnPreparacion(data){
      ServicioModales.abrirModalInformeEgresosEnPreparacion({
        onResult: function(resultado) {
          buscarPorDeposito();
        },
        egresos: data,
        deposito: vm.deposito,
        bandera: true
      });
    }

    function marcarTodo(){
      vm.egresos.forEach(function(item){
        item.seleccionado=vm.check;
      });
    }

    function verNumeroCajasEgreso(egreso){
      var numeros = [];
      var hash = {};
      egreso.detalles.forEach(function(item){
        numeros.push(item.numeroCaja);
      });
      numeros = numeros.filter(function(current) {
        var exists = !hash[current] || false;
        hash[current] = true;
        return exists;
      });
      ServicioDialogos.mostrarDialogoInformacion("N° de Cajas cerradas", "Este egreso tiene asignadas las cajas cerradas N°:\n"+numeros);
    }

    function filtrarTabla($defer, params) {
      var filtros = params.filter();
      var filtrosNuevos = {};

      for (var key in filtros) {
        if (filtros.hasOwnProperty(key) && filtros[key]!=='') {
          switch(key) {
            case 'empresa.nombre':
              angular.extend(filtrosNuevos, {
                empresa: {
                nombre: filtros[key]
                }
              });
              break;
            case 'sucursal.nombre':
              angular.extend(filtrosNuevos, {
                sucursal: {
                nombre: filtros[key]
                }
              });
              break;
            default:
              filtrosNuevos[key] = filtros[key];
          }
        }
      }
      var filtrados = filtros ? $filter('filter')(vm.egresos, filtrosNuevos) : vm.egresos;
      filtrados = params.sorting() ? $filter('orderBy')(filtrados, params.orderBy()) : filtrados;
      if (filtrados && filtrados.length){
        params.total(filtrados.length);
        return $defer.resolve(filtrados.slice((params.page() - 1) * params.count(), params.page() * params.count()));
      } else {
        params.total(0);
        return $defer.resolve(null);
      }
    }

    function ubicacionesPorSuministros(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Está seguro que desea generar un listado de ubicaciones por los suministros de los egresos seleccionados?", function(){
        armarEgresosSeleccionados();
      });
    }

    function armarEgresosSeleccionados(){
      var egresosSeleccionados = [];
      vm.egresos.forEach(function(egreso){
        if (egreso.seleccionado){
          egresosSeleccionados.push(egreso);
        }
      });
      abrirModalVisualizarInformeRecorrido(egresosSeleccionados);
    }

    function abrirModalVisualizarInformeRecorrido(data){
      ServicioModales.abrirModalVisualizarInformeRecorrido({
        onResult: function(resultado) {
          buscarPorDeposito();
        },
        egresos: data,
        deposito: vm.deposito
      });
    }

    function comprobarSeleccionado(){
      var hay = false;
      vm.egresos.forEach(function(item){
        if (item.seleccionado){
          hay = true;
        }
      });
      return hay;
    }
    
    function actualizarTabla(data){
      vm.egresos = orderByFilter(data,'fecha',true);
      vm.tableParams.settings({
        data: vm.egresos
      });
      vm.tableParams.reload();
    }

    function visualizarEgreso(egreso){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalVisualizarEgreso({
        onResult: function(resultado) {
          console.log(resultado);
        },
        egreso: egreso,
        deposito: vm.deposito
      });
    }


    function cambiarFiltros(){
      vm.bandera=false;
    }

    function buscarPorDeposito(){
      vm.bandera=true;
      ServicioDialogos.abrirDialogoCargando();
      EgresoDepositoEstadoUltimosCien.query({'idTipo':1,'idDeposito':vm.deposito.id, 'idEstado':1}, function(data){
        actualizarTabla(data);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    }

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-en-preparacion', {
        url: 'lista-en-preparacion',
        templateUrl: 'app/app/main/movimientos/egreso/lista-en-preparacion/lista-en-preparacion.html',
        controller: 'ListaEgresoEnPreparacionCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar egresos',
          subtitulo:'Listado de egresos en preparación'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          deposito: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return usuario.empleado.deposito;
              } else {
                return ;
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaEgresoEnPreparacionCtrl', ListaEgresoEnPreparacionCtrl);

  /** @ngInject */
  function ListaEgresoEnPreparacionCtrl(NgTableParams, rol, deposito, HeaderBarService, $q, $filter, focus, depositos, IngresoEstadoModificar, EgresoModificarEstadoArray, EgresoDepositoEstadoUltimosCien , $stateParams, $scope, orderByFilter, $state, ServicioModales, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.egresos = [];
    vm.depositos = orderByFilter(depositos,'nombre',false);
    vm.visualizarEgreso = visualizarEgreso;
    vm.comprobarSeleccionado = comprobarSeleccionado;
    vm.reporteEgresosEnPreparacion = reporteEgresosEnPreparacion;
    vm.buscarPorDeposito = buscarPorDeposito;
    vm.cambiarFiltros = cambiarFiltros;
    vm.verNumeroCajasEgreso = verNumeroCajasEgreso;
    vm.marcarTodo = marcarTodo;
    vm.ubicacionesPorSuministros = ubicacionesPorSuministros;


    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10,
    },{
      getData: function($defer,params){ return filtrarTabla($defer, params);}
    });
    vm.tableParams.reload();

    inicializar();

    function marcarTodo(){
      vm.egresos.forEach(function(item){
        item.seleccionado=vm.check;
      });
    }

    function inicializar(){
      if (deposito && deposito.id){
        vm.deposito=deposito;
        buscarPorDeposito();
      }
    }


    function ubicacionesPorSuministros(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Está seguro que desea generar un listado de ubicaciones por los suministros de los egresos seleccionados?", function(){
        armarEgresosSeleccionadosUbicaciones();
      });
    }

    function armarEgresosSeleccionadosUbicaciones(){
      var egresosSeleccionados = [];
      vm.egresos.forEach(function(egreso){
        if (egreso.seleccionado){
          egresosSeleccionados.push(egreso);
        }
      });
      abrirModalVisualizarInformeRecorrido(egresosSeleccionados);
    }

    function abrirModalVisualizarInformeRecorrido(data){
      ServicioModales.abrirModalVisualizarInformeRecorrido({
        onResult: function(resultado) {
          buscarPorDeposito();
        },
        egresos: data,
        deposito: vm.deposito,
        noActualizar: true
      });
    }

    function verNumeroCajasEgreso(egreso){
      var numeros = [];
      var hash = {};
      egreso.detalles.forEach(function(item){
        numeros.push(item.numeroCaja);
      });
      numeros = numeros.filter(function(current) {
        var exists = !hash[current] || false;
        hash[current] = true;
        return exists;
      });
      ServicioDialogos.mostrarDialogoInformacion("N° de Cajas cerradas", "Este egreso tiene asignadas las cajas cerradas N°:\n"+numeros);
    }

    function filtrarTabla($defer, params) {
      var filtros = params.filter();
      var filtrosNuevos = {};

      for (var key in filtros) {
        if (filtros.hasOwnProperty(key) && filtros[key]!=='') {
          switch(key) {
            case 'empresa.nombre':
              angular.extend(filtrosNuevos, {
                empresa: {
                nombre: filtros[key]
                }
              });
              break;
            case 'sucursal.nombre':
              angular.extend(filtrosNuevos, {
                sucursal: {
                nombre: filtros[key]
                }
              });
              break;
            default:
              filtrosNuevos[key] = filtros[key];
          }
        }
      }
      var filtrados = filtros ? $filter('filter')(vm.egresos, filtrosNuevos) : vm.egresos;
      filtrados = params.sorting() ? $filter('orderBy')(filtrados, params.orderBy()) : filtrados;
      if (filtrados && filtrados.length){
        params.total(filtrados.length);
        return $defer.resolve(filtrados.slice((params.page() - 1) * params.count(), params.page() * params.count()));
      } else {
        params.total(0);
        return $defer.resolve(null);
      }
    }

    function reporteEgresosEnPreparacion(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Está seguro que desea generar un listado de egresos seleccionados?", function(){
        armarEgresosSeleccionados();
      });
    }

    function armarEgresosSeleccionados(){
      var egresosSeleccionados = [];
      vm.egresos.forEach(function(egreso){
        if (egreso.seleccionado){
          egresosSeleccionados.push(egreso);
        }
      });
      abrirModalInformeEgresosEnPreparacion(egresosSeleccionados);
    }

    function abrirModalInformeEgresosEnPreparacion(data){
      ServicioModales.abrirModalInformeEgresosEnPreparacion({
        onResult: function(resultado) {
          buscarPorDeposito();
        },
        egresos: data,
        deposito: vm.deposito
      });
    }

    function comprobarSeleccionado(){
      var hay = false;
      vm.egresos.forEach(function(item){
        if (item.seleccionado){
          hay = true;
        }
      });
      return hay;
    }
    
    function actualizarTabla(data){
      vm.egresos = orderByFilter(data,'fecha',true);
      vm.tableParams.settings({
        data: vm.egresos
      });
      vm.tableParams.reload();
    }

    function visualizarEgreso(egreso){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalVisualizarEgreso({
        onResult: function(resultado) {
          console.log(resultado);
        },
        egreso: egreso,
        deposito: vm.deposito
      });
    }


    function cambiarFiltros(){
      vm.bandera=false;
    }

    function buscarPorDeposito(){
      vm.bandera=true;
      ServicioDialogos.abrirDialogoCargando();
      EgresoDepositoEstadoUltimosCien.query({'idTipo':1,'idDeposito':vm.deposito.id, 'idEstado':3}, function(data){
        actualizarTabla(data);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    }

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-egreso', {
        url: 'lista-egreso',
        templateUrl: 'app/app/main/movimientos/egreso/lista/lista-egreso.html',
        controller: 'ListaEgresoCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar egresos',
          subtitulo:'Lista de egresos'
        },
        resolve: {
          egresos: function(EgresoUltimosCien, Usuario, EgresoUltimosCienDeposito, EgresoUltimosCienDepositoEmpresa){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              var deposito = usuario.empleado.deposito;
              var empresa = usuario.empleado.empresa;
              if (deposito){
                if (empresa){
                  return EgresoUltimosCienDepositoEmpresa.query({'idDeposito':deposito.id, 'idEmpresa':empresa.id}).$promise.then(function(data){
                    return data;
                  });
                } else {
                  return EgresoUltimosCienDeposito.query({'idDeposito':deposito.id}).$promise.then(function(data){
                    return data;
                  });
                }
              } else {
                return EgresoUltimosCien.query({}).$promise.then(function(data){
                  if (usuario.empleado && usuario.rol && usuario.rol.nombre=='CONSULTA' && usuario.empleado.empresas && usuario.empleado.empresas.length>0) {
                    var movimientos = [];
                    data.forEach(function(movimiento){
                      if (usuario.empleado.empresas.includes(movimiento.empresa.id)){
                        movimientos.push(movimiento);
                      }
                    });
                    return movimientos;
                  }
                  return data;
                });
              }
            });
          },
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          empresa: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.empleado.empresa;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaEgresoCtrl', ListaEgresoCtrl);

  /** @ngInject */
  function ListaEgresoCtrl(NgTableParams, rol, HeaderBarService, empresa, $filter, focus, egresos, Usuario, IngresoEstadoModificar, EgresoEstadoModificar , EgresoUltimosCienDeposito, EgresoUltimosCien, EgresoUltimosCienDepositoEmpresa, $stateParams, $scope, orderByFilter, $state, ServicioModales, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.egresos = orderByFilter(egresos,'fecha',true);
    vm.visualizarEgreso = visualizarEgreso;
    vm.crearNuevo = crearNuevo;
    vm.editar = editar;
    vm.eliminar = eliminar;
    vm.filtrar = filtrar;
    vm.bandera = false;
    vm.busqueda = busqueda;
    vm.abrirModalFiltros = abrirModalFiltros;
    vm.abrirModalFiltroCajas = abrirModalFiltroCajas;
    vm.abrirModalFiltroNumeroVale = abrirModalFiltroNumeroVale;
    vm.cambiarEstado = cambiarEstado;
    vm.verNumeroCajasEgreso = verNumeroCajasEgreso;
    vm.verConfirmacion = verConfirmacion;
    vm.abrirModalFiltrosSuministro = abrirModalFiltrosSuministro;
    vm.rol = rol;
    vm.abrirModalNumeroMovimiento = abrirModalNumeroMovimiento;

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10,
    },{
      getData: function($defer,params){ return filtrarTabla($defer, params);}
    });
    vm.tableParams.reload();

    function abrirModalNumeroMovimiento(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalFiltroIngresoNumeroMovimiento({
        onResult: function(resultado){
          vm.bandera=true;
          vm.filtrosUsados = resultado.filtros;
          actualizarTabla(resultado.detalles);
        },
        tipo: 1
      });
    }

    function abrirModalFiltrosSuministro(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalFiltroBusquedaEgresoSuministro({
        onResult: function(resultado){
          vm.bandera=true;
          vm.filtrosUsados = resultado.filtros;
          actualizarTabla(resultado.detalles);
        }
      });
    }

    function abrirModalFiltroCajas(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalFiltroBusquedaIngresoCajas({
        onResult: function(resultado){
          vm.bandera=true;
          vm.filtrosUsados = resultado.filtros;
          actualizarTabla(resultado.detalles);
        },
        tipo: 1
      });
    }

    function abrirModalFiltroNumeroVale(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalFiltroBusquedaIngresoCajas({
        onResult: function(resultado){
          vm.bandera=true;
          vm.filtrosUsados = resultado.filtros;
          actualizarTabla(resultado.detalles);
        },
        tipo: 1,
        numeroVale: true
      });
    }

    function verNumeroCajasEgreso(egreso){
      var numeros = [];
      var hash = {};
      egreso.detalles.forEach(function(item){
        numeros.push(item.numeroCaja);
      });
      numeros = numeros.filter(function(current) {
        var exists = !hash[current] || false;
        hash[current] = true;
        return exists;
      });
      ServicioDialogos.mostrarDialogoInformacion("N° de Cajas cerradas", "Este egreso tiene asignadas las cajas cerradas N°:\n"+numeros);
    }

    function verConfirmacion(egreso){
      ServicioDialogos.mostrarDialogoInformacion("Confirmación de recepción", "Fecha: "+$filter('date')(egreso.fechaConfirmacion, "dd/MM/yyyy HH:mm")+"\nPor: "+egreso.nombreConfirmacion+"\nMail: "+egreso.mailIngresadoConfirmacion);
    }


    function filtrarTabla($defer, params) {
      var filtros = params.filter();
      var filtrosNuevos = {};

      for (var key in filtros) {
        if (filtros.hasOwnProperty(key) && filtros[key]!=='') {
          switch(key) {
            case 'deposito.nombre':
              angular.extend(filtrosNuevos, {
                deposito: {
                nombre: filtros[key]
                }
              });
              break;
            case 'empresa.nombre':
              angular.extend(filtrosNuevos, {
                empresa: {
                nombre: filtros[key]
                }
              });
              break;
            case 'sucursal.nombre':
              angular.extend(filtrosNuevos, {
                sucursal: {
                nombre: filtros[key]
                }
                });
              break;
            case 'pedido.numeroPedido':
              angular.extend(filtrosNuevos, {
                pedido: {
                numeroPedido: filtros[key]
                }
                });
              break;
            case 'estadoMovimiento.nombre':
              angular.extend(filtrosNuevos, {
                estadoMovimiento: {
                nombre: filtros[key]
                }
              });
              break;
            default:
              filtrosNuevos[key] = filtros[key];
          }
        }
      }
      var filtrados = filtros ? $filter('filter')(vm.egresos, filtrosNuevos) : vm.egresos;
      filtrados = params.sorting() ? $filter('orderBy')(filtrados, params.orderBy()) : filtrados;
      if (filtrados && filtrados.length){
        params.total(filtrados.length);
        return $defer.resolve(filtrados.slice((params.page() - 1) * params.count(), params.page() * params.count()));
      } else {
        params.total(0);
        return $defer.resolve(null);
      }
    }

    function abrirModalFiltros(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalFiltroBusquedaEgreso({
        onResult: function(resultado){
          vm.bandera=true;
          vm.filtrosUsados = resultado.filtros;
          actualizarTabla(resultado.detalles);
        }
      });
    }

    function busqueda(){
      vm.bandera=false;
      vm.filtrosUsados=null;
      if (vm.buscar) {
        vm.egresos=null;
        actualizarTabla(vm.egresos);
      } else {
        filtrar();
      }
    }
    
    function actualizarTabla(data){
      vm.egresos = orderByFilter(data,'fecha',true);
      vm.tableParams.settings({
        data: vm.egresos
      });
      vm.tableParams.reload();
    }

    function filtrar(){
      ServicioDialogos.abrirDialogoCargando();
      if (!vm.buscar){
        obtenerUltimos();
      } else {
        actualizarTabla(undefined);
      }

    }

    function cambiarEstado(egreso){
      if (egreso.estadoMovimiento.id==1){
        ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Desea cambiar el estado del egreso a EN PREPARACIÓN?', function() {
          var estado = 3;
          prepararEgreso(egreso, estado);
        },null, false);
      } else if (egreso.estadoMovimiento.id==3){
        ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Desea cambiar el estado del egreso a PREPARADO?', function() {
          var estado = 2;
          prepararEgreso(egreso, estado);
        },null, false);
      }
    }

    function prepararEgreso(egreso, estado){
      IngresoEstadoModificar.update({idMovimiento:egreso.id, idEstado:estado}, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, "Se ha actualizado el estado del egreso con éxito.", function(){
          obtenerUltimos();
        });
      }, function(err){
        var mensaje = err.data.message;
        if (mensaje!=='El estado a actualizar no es válido') {
          mensaje = "No se ha podido actualizar el estado";
          console.log(err);
        }
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError(null, mensaje);
      });
    }
/*
    function visualizarEgreso(egreso){
      if (egreso.estadoMovimiento.id===4){
        $state.go('home.visualizar-egreso-despachado', {objeto:egreso.id});
      } else {
        $state.go('home.visualizar-egreso', {objeto:egreso.id});
      }
    }*/


    function visualizarEgreso(egreso){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalVisualizarEgreso({
        onResult: function(resultado) {
          console.log(resultado);
        },
        egreso: egreso,
        deposito: egreso.deposito
      });
    }

    function editar(egreso) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el egreso?', function() {
        $state.go('home.editar-egreso', {objeto:egreso.id, modo:'editar'});
      });
    }

    function eliminar(egreso) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea eliminar el egreso?', function() {
        anularEgreso(egreso);
      });
    }

    function anularEgreso(egreso){
      ServicioDialogos.abrirDialogoCargando();
      EgresoEstadoModificar.update({idMovimiento:egreso.id, idEstado:8}, function(data){
        obtenerUltimos();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar el egreso");
      });

    }

/*    function obtenerUltimos(){
      if (rol)
      EgresoUltimosCien.query(function(data){
        ServicioDialogos.cerrarDialogoCargando();
        actualizarTabla(data);
      }, function(err){
        console.error(err);
        ServicioDialogos.cerrarDialogoCargando();
      });
    }
*/
    function obtenerUltimos(){
      Usuario.obtenerUsuario().$promise.then(function(usuario){
        if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
          EgresoUltimosCienDeposito.query({'idDeposito':usuario.empleado.deposito.id}).$promise.then(function(data){
            ServicioDialogos.cerrarDialogoCargando();
            actualizarTabla(data);
          }, function(err){
            console.error(err);
            ServicioDialogos.cerrarDialogoCargando();
          });
        } else {
          EgresoUltimosCien.query({}).$promise.then(function(data){
            ServicioDialogos.cerrarDialogoCargando();
            actualizarTabla(data);
          }, function(err){
            console.error(err);
            ServicioDialogos.cerrarDialogoCargando();
          });
        }
      });
    }

    function crearNuevo() {
      $state.go('home.editar-egreso');
    }


  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.agregar-suministros-egreso-cajas', {
        url: 'agregar-suministros-egreso-cajas',
        templateUrl: 'app/app/main/movimientos/egreso/agregar-suministros-egreso-cajas/agregar-suministros-egreso-cajas.html',
        controller: 'AgregarSuministroEgresoCajasCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Egreso de suministros en cajas cerradas',
          subtitulo: 'Agregar suministros de cajas cerradas',
          objeto:null
        },
        resolve: {
          tipoEgreso: function(TipoMovimiento){
            return TipoMovimiento.get({id:1}).$promise.then(function(data) {
              return data;
            });
          },
          estadoGenerado: function(EstadoMovimiento){
            return EstadoMovimiento.get({id:1}).$promise.then(function(data) {
              return data;
            });
          },
          egreso: function(Egreso, $stateParams){
            return $stateParams.objeto? $stateParams.objeto : {};
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('AgregarSuministroEgresoCajasCtrl', AgregarSuministroEgresoCajasCtrl);

  /** @ngInject */
  function AgregarSuministroEgresoCajasCtrl(NgTableParams, $filter, UltimoMovimiento, egreso, ServicioModales, tipoEgreso, estadoGenerado, HeaderBarService, Egreso, $timeout, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.tipoEgreso = tipoEgreso;
    vm.estadoGenerado = estadoGenerado;
    vm.egreso = egreso;
    vm.ocultar=true;
    inicializar();


    vm.volver = volver;

    vm.detalles = [];
    vm.cajasAsignadas=[];
    vm.detallesInventariables = [];
    vm.detallesNoInventariables = [];

    vm.detallesNoInventariablesAgrupados = [];
    vm.detallesInventariablesAgrupados = [];

    vm.mostrarInformacion = mostrarInformacion;
    vm.ubicacionCompleta = ubicacionCompleta;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.quitarCaja = quitarCaja;
    vm.modo = "nuevo";
    vm.abrirModal = abrirModal;
    vm.guardar = guardar;
    vm.montoTotal = montoTotal;
    vm.getIcono = getIcono;

    window.onbeforeunload = function(){
      return '';
    };


    function inicializar(){
      if (vm.egreso && vm.egreso.empresa && vm.egreso.empresa.id){
        vm.fecha = $filter('date')(new Date(), 'dd/MM/yyyy HH:mm');
        vm.solicitante = vm.egreso.solicita? vm.egreso.solicita.apellido&&vm.egreso.solicita.nombre? vm.egreso.solicita.apellido.toUpperCase()+", "+vm.egreso.solicita.nombre : vm.egreso.solicitante : vm.egreso.solicitante;
        vm.cajaCerrada = vm.egreso.caja? "SI" : "NO";
      } else {
        vm.ocultar=false;
      }
    }

    function getIcono(estaAbierto) {
      if (estaAbierto) {
        return 'glyphicon glyphicon-chevron-down';
      } else {
        return 'glyphicon glyphicon-chevron-right';
      }
    }

    function montoTotal(){
      var total = 0;
      for(var i = 0; i < vm.detalles.length; i++){
        total += vm.detalles[i].suministro.precioUnitario*vm.detalles[i].cantidad;
      }
      return total ? total.toFixed(2) : "-";
    }

    function guardar(){
      if (vm.detalles.length===0){
        ServicioDialogos.mostrarDialogoError(null, "No ha agregado ningún suministro");
      } else {
        ServicioDialogos.mostrarDialogoConfirmacionWarning(
          null,
          "¿Está seguro que desea guardar el egreso?",
          function(){
            guardarEgreso();
          },
          null,
          false
        );
      }
    }

    function ubicacionCompleta(detalle){
      if (detalle.ubicacion && detalle.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación",
        "Nave: "+detalle.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+detalle.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+detalle.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+detalle.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+detalle.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+detalle.ubicacion.numeroUbicacion+
        "\nN° de orden: "+detalle.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+detalle.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+detalle.ubicacion.categoriaPeso.nombre.toUpperCase());
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "No hay ubicación");
      }
    }

    function ubicacionNaveNumeroOrden(detalle){
      //console.log(detalle);
      if (detalle.ubicacion && detalle.ubicacion.nivel) {
        return "Nave: "+detalle.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+detalle.ubicacion.numeroOrden;
      }
    }

    function quitarCaja(agrupado){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(
        null,
        "¿Está seguro que desea quitar la caja cerrada?",
        function(){
          limpiarCajaCerrada(agrupado.numeroCaja);
        }
      );
    }

    function limpiarCajaCerrada(caja){
      for (var i = vm.detalles.length - 1; i >= 0; i--) {
        if (vm.detalles[i].numeroCaja == caja){
          vm.detalles.splice(i, 1);
        }
      }
      var index = null;
      vm.cajasAsignadas.forEach(function(num, ind){
        if (num==caja){
          index = ind;
        }
      });
      vm.cajasAsignadas.splice(index, 1);
      vm.detallesInventariablesAgrupados = [];
      cargarDetalles();
    }

    function obtenerNumeroMovimiento(callback){
      UltimoMovimiento.get({}, function(data){
        if (data && !isNaN(data.id)){
          callback(data.id + 10001);
        } else {
          callback(10001);
        }
      }, function (err){
        console.log(err);
      });
    }

    function obtenerEgreso(callback){
      obtenerNumeroMovimiento(function(data){
        var movimiento = {
          tipoMovimiento: tipoEgreso,
          estadoMovimiento: estadoGenerado,
          deposito: vm.egreso.deposito,
          empresa: vm.egreso.empresa,
          sucursal: vm.egreso.sucursal,
          observacion: vm.egreso.observacion,
          fecha: new Date(),
          detalles: vm.detalles,
          numeroMovimiento: data,
          usuario: vm.egreso.usuario,
          sector: vm.egreso.sector,
          solicita: vm.egreso.solicita,
          solicitante: vm.egreso.solicitante,
          caja: vm.egreso.caja,
          numeroVale: vm.egreso.numeroVale,
          numeroMail: vm.egreso.numeroMail
        };
        callback(movimiento);
      });
    }


    function guardarEgreso(){
      obtenerEgreso(function(movimiento){
        Egreso.save(movimiento, function(data){
          ServicioDialogos.mostrarDialogoGuardadoExito(
            null,
            "Se ha registrado con éxito el egreso",
            function(){
              $state.go('home.lista-egreso');
            });
        }, function(err){
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar el egreso");
        });
      });
    }

    function cargarDetalles(){
      vm.detallesInventariables = [];
      vm.detalles.forEach(function(detalle){
        if (detalle.suministro.tipoSuministro.inventariable){
          vm.detallesInventariables.push(detalle);
        } else {
          vm.detallesNoInventariables.push(detalle);
        }
      });
      if (vm.detallesInventariables.length>0){
        armarDetallesInventariables();
      } else {
        actualizarTablaInventariables();
      }
    }

    function obtenerTiposUtilizados(){
      var esta = false;
      vm.detallesNoInventariables.forEach(function(detalle){
        esta = false;
        vm.detallesNoInventariablesAgrupados.forEach(function(agrupado){
          if (detalle.suministro.tipoSuministro.id==agrupado.tipoSuministro.id){
            esta = true;
          }
        });
        if (!esta){
          vm.detallesNoInventariablesAgrupados.push({tipoSuministro:detalle.suministro.tipoSuministro, precioTotal:0.0, cantidad:0, detalles:[]});
        }
      });
    }

    function armarDetallesNoInventariablesAgrupados(){
      vm.detallesNoInventariablesAgrupados.forEach(function(agrupado){
        vm.detallesNoInventariables.forEach(function(detalle){
          if (agrupado.tipoSuministro.id===detalle.suministro.tipoSuministro.id){
            agrupado.detalles.push({suministro:detalle.suministro, cantidad:detalle.cantidad});
            agrupado.cantidad = agrupado.cantidad + detalle.cantidad;
            agrupado.precioTotal = agrupado.precioTotal + detalle.suministro.precioUnitario;
          }
        });
      });
    }

    function armarDetallesNoInventariables(){
      obtenerTiposUtilizados();
      armarDetallesNoInventariablesAgrupados();
      actualizarTablaNoInventariables();
    }

    function armarDetallesCajaAgrupados(){
      vm.detallesInventariablesAgrupados = [];
      vm.cajasAsignadas.forEach(function(numeroCaja){
        vm.detallesInventariablesAgrupados.push({numeroCaja:numeroCaja, tipoSuministro:null, precioTotal:0.0, cantidad:0, detalles:[], ubicacion:null});
      });
    }

    function armarDetallesInventariablesAgrupados(){
      vm.detallesInventariablesAgrupados.forEach(function(agrupado){
        vm.detallesInventariables.forEach(function(detalle){
          if (agrupado.numeroCaja===detalle.numeroCaja){
            agrupado.detalles.push({suministro:detalle.suministro, suministroInventariable:detalle.suministroInventariable, cantidad:detalle.cantidad});
            agrupado.cantidad = agrupado.cantidad + detalle.cantidad;
            agrupado.precioTotal = agrupado.precioTotal + detalle.suministro.precioUnitario;
            agrupado.ubicacion = detalle.suministro.ubicacion;
            agrupado.tipoSuministro = detalle.suministro.tipoSuministro;
          }
        });
      });
    }

    function armarDetallesInventariables(){
      armarDetallesCajaAgrupados();
      armarDetallesInventariablesAgrupados();
      actualizarTablaInventariables();
    }

    function agregarDetalles(detalles){
      detalles.forEach(function(det){
        vm.detalles.push(det);
      });
    }

    function abrirModal(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalAgregarSuministroEgresoCajas({
        onResult: function(resultado) {
          agregarDetalles(resultado.detalles);
          vm.cajasAsignadas = resultado.cajasAsignadas;
          cargarDetalles();
        },
        cajasAsignadas: vm.cajasAsignadas,
        empresa: vm.egreso.empresa,
        deposito: vm.egreso.deposito.id,
      });
    }

    function esEditar(){
      return vm.modo == "editar";
    }

    function volver(){
      if (vm.ocultar){
        ServicioDialogos.mostrarDialogoConfirmacionWarning(
          null,
          "Si vuelve a la pantalla de edición de egreso, perderá la información de todos los suministros que haya agregado. ¿Está seguro que desea volver?",
          function(){
            $state.go("home.editar-egreso", {egreso:egreso});
          }
        );
      } else {
        $state.go("home.editar-egreso", {});
      }
    }

    function mostrarInformacion(detalle){
      var marca = detalle.suministro.marca ? detalle.suministro.marca : "-";
      var fecha = detalle.suministro.fechaVencimiento ? detalle.suministro.fechaVencimiento : "-";
      ServicioDialogos.mostrarDialogoInformacion(
        null,
        "Tipo de suministro: "+detalle.suministro.tipoSuministro.nombre.toUpperCase()+
        "\nMarca: "+marca.toUpperCase()+
        "\nFecha vencimiento: "+$filter('date')(fecha, 'dd/MM/yyyy')+
        "\nFamilia de suministro: "+detalle.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase()+
        "\nGrupo de suministro: "+detalle.suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+
        "\nCantidad solicitada: "+detalle.cantidad
      );
    }

    function actualizarTablaNoInventariables(){
      vm.tableParamsNoInventariableAgrupado.settings({
        data: vm.detallesNoInventariablesAgrupados,
        noPager: true,
        counts: []
      });
      vm.tableParamsNoInventariableAgrupado.reload();
    }

    function actualizarTablaInventariables(){
      vm.tableParamsInventariableAgrupado.settings({
        data: vm.detallesInventariablesAgrupados,
        noPager: true,
        counts: []
      });
      vm.tableParamsInventariableAgrupado.reload();
    }

    function comprobarExistencia(){
      var ban = false;
      vm.detalles.forEach(function(detalle){
        if (detalle.suministro.id==vm.suministro.id){
          ban = true;
        }
      });
      return ban;
    }

    function limpiarForm(){
      vm.grupo = null;
      vm.cantidad=null;
      vm.form.cantidad.$dirty = false;
    }
/*
    $scope.$watch('vm.grupo.nombre', function(){
      vm.familiaSuministro=null;
      if (!vm.grupo) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupo.id}, function(data){
        vm.familias = data;
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.familiaSuministro.nombre', function(){
      vm.suministro=null;
      if (!vm.familiaSuministro) return;
      ServicioDialogos.abrirDialogoCargando();
      TipoSuministroFamilia.query({id:vm.familiaSuministro.id}, function(data){
        vm.suministros = data;
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });*/

    vm.tableParamsInventariableAgrupado = new NgTableParams({
      page: 1,
      count: 10,
      group:{
        tipoSuministro: 'desc'
      }
    });
    vm.tableParamsNoInventariableAgrupado = new NgTableParams({
      page: 1,
      count: 10,
      group:{
        tipoSuministro: 'desc'
      }
    });
   
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-egreso', {
        url: 'editar-egreso',
        templateUrl: 'app/app/main/movimientos/egreso/editar/editar-egreso.html',
        controller: 'EditarEgresoCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Egreso de suministros',
          subtituloEditar:'Editar egreso',
          subtituloNuevo: 'Nuevo egreso',
          egreso:null,
          editar:null
        },
        resolve: {
          //el deposito se traerá dependiendo del usuario registrado.
          //si es admin traigo todos sino el del usuario
          egreso: function($stateParams){
            return $stateParams.egreso? $stateParams.egreso : {};
          },
          usuario: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario;
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          deposito: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return usuario.empleado.deposito;
              } else {
                return ;
              }
            });
          },
          tipoEgreso: function(TipoMovimiento){
            return TipoMovimiento.get({id:1}).$promise.then(function(data) {
              return data;
            });
          },
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data){
              return data;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarEgresoCtrl', EditarEgresoCtrl);

  /** @ngInject */
  function EditarEgresoCtrl(NgTableParams, deposito, usuario, HeaderBarService, SolicitanteEmpresa, ServicioModales, egreso, focus, SucursalEmpresa, EgresoNumeroValeEmpresa, depositos, tipoEgreso, empresas, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    egreso.empresa? HeaderBarService.setSubTitulo($stateParams.subtituloEditar) : HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);

    var vm = this;
    vm.tipoEgreso = tipoEgreso;
    vm.depositos = orderByFilter(depositos,'nombre',false);
    vm.empresas = orderByFilter(empresas,'nombre',false);
    vm.egreso = egreso;
    vm.egreso.usuario = usuario;
    vm.egreso.deposito = deposito;
    vm.siguiente = siguiente;
    vm.cancelar = cancelar;

    window.onbeforeunload = function(){
      return "seguro?";
    };


    function cancelar(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea cancelar el egreso?', function() {
        $state.go('home.lista-egreso');
      });
    }

    function siguiente(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, 'Verifique los datos. ¿Desea continuar con el agregado de suministros en el egreso?', function() {
        if (vm.egreso.caja){
          $state.go('home.agregar-suministros-egreso-cajas', {'objeto':vm.egreso});
        } else {
          $state.go('home.agregar-suministros-egreso', {'objeto':vm.egreso});
        }
      });
    }

    function esEditar(){
      return vm.modo == "editar";
    }

    $scope.$watch('vm.egreso.empresa.nombre', function(){
      if (!vm.form.$dirty) {
        vm.form.$setDirty();
        return;
      }
      if (vm.egreso.sucursal) vm.egreso.sucursal=null;
      if (vm.egreso.solicita) vm.egreso.solicita=null;
      if (!vm.egreso.empresa) return;
      ServicioDialogos.abrirDialogoCargando();
      SucursalEmpresa.query({id:vm.egreso.empresa.id}, function(data){
        SolicitanteEmpresa.query({id:vm.egreso.empresa.id}, function(datos){
          vm.sucursales = orderByFilter(data, "nombre", false);
          vm.solicitantes = orderByFilter(datos, ["apellido", "nombre"], false);
          focus('sucursal');
          ServicioDialogos.cerrarDialogoCargando();
        }, function(e){
          console.log(e);
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError();
        });
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.agregar-suministros-egreso', {
        url: 'agregar-suministros-egreso',
        templateUrl: 'app/app/main/movimientos/egreso/agregar-suministros-egreso/agregar-suministros-egreso.html',
        controller: 'AgregarSuministroEgresoCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Egreso de suministros',
          subtitulo: 'Agregar suministros',
          objeto:null
        },
        resolve: {
          tipoEgreso: function(TipoMovimiento){
            return TipoMovimiento.get({id:1}).$promise.then(function(data) {
              return data;
            });
          },
          estadoGenerado: function(EstadoMovimiento){
            return EstadoMovimiento.get({id:1}).$promise.then(function(data) {
              return data;
            });
          },
          egreso: function(Egreso, $stateParams){
            return $stateParams.objeto? $stateParams.objeto : {};
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('AgregarSuministroEgresoCtrl', AgregarSuministroEgresoCtrl);

  /** @ngInject */
  function AgregarSuministroEgresoCtrl(NgTableParams, $filter, UltimoMovimiento, egreso, ServicioModales, tipoEgreso, estadoGenerado, HeaderBarService, Egreso, $timeout, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.tipoEgreso = tipoEgreso;
    vm.estadoGenerado = estadoGenerado;
    vm.egreso = egreso;
    vm.ocultar=true;
    inicializar();


    vm.volver = volver;

    vm.detalles = [];
    vm.detallesInventariables = [];
    vm.detallesNoInventariables = [];

    vm.detallesNoInventariablesAgrupados = [];
    vm.detallesInventariablesAgrupados = [];

    vm.mostrarInformacion = mostrarInformacion;
    vm.ubicacionCompleta = ubicacionCompleta;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.quitarTipo = quitarTipo;
    vm.modo = "nuevo";
    vm.abrirModal = abrirModal;
    vm.guardar = guardar;
    vm.montoTotal = montoTotal;
    vm.getIcono = getIcono;
    vm.abrirModalAgregarSuministroEgresoKit = abrirModalAgregarSuministroEgresoKit;

    function abrirModalAgregarSuministroEgresoKit(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalAgregarSuministroEgresoKit({
        onResult: function(resultado) {
          vm.detalles = resultado.detalles;
          vm.detallesNoInventariablesAgrupados = [];
          vm.detallesInventariablesAgrupados = [];
          cargarDetalles();
        },
        sucursal: vm.egreso.sucursal,
        detalles: vm.detalles,
        deposito: vm.egreso.deposito
      });
    }

    window.onbeforeunload = function(){
      return '';
    };


    function inicializar(){
      if (vm.egreso && vm.egreso.empresa && vm.egreso.empresa.id){
        vm.fecha = $filter('date')(new Date(), 'dd/MM/yyyy HH:mm');
        vm.solicitante = vm.egreso.solicita? vm.egreso.solicita.apellido&&vm.egreso.solicita.nombre? vm.egreso.solicita.apellido.toUpperCase()+", "+vm.egreso.solicita.nombre : "-":"-";
        vm.cajaCerrada = vm.egreso.caja? "SI" : "NO";
      } else {
        vm.ocultar=false;
      }
    }

    function getIcono(estaAbierto) {
      if (estaAbierto) {
        return 'glyphicon glyphicon-chevron-down';
      } else {
        return 'glyphicon glyphicon-chevron-right';
      }
    }

    function montoTotal(){
      var total = 0;
      for(var i = 0; i < vm.detalles.length; i++){
        total += vm.detalles[i].suministro.precioUnitario*vm.detalles[i].cantidad;
      }
      return total ? total.toFixed(2) : "-";
    }

    function guardar(){
      if (vm.detalles.length===0){
        ServicioDialogos.mostrarDialogoError(null, "No ha agregado ningún suministro");
      } else {
        ServicioDialogos.mostrarDialogoConfirmacionWarning(
          null,
          "¿Está seguro que desea guardar el egreso?",
          function(){
            guardarEgreso();
          },
          null,
          false
        );
      }
    }

    function ubicacionCompleta(detalle){
      if (detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación",
        "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+detalle.suministro.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+detalle.suministro.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+detalle.suministro.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+detalle.suministro.ubicacion.numeroUbicacion+
        "\nN° de orden: "+detalle.suministro.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+detalle.suministro.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+detalle.suministro.ubicacion.categoriaPeso.nombre.toUpperCase());
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "No hay ubicación");
      }
    }

    function ubicacionNaveNumeroOrden(detalle){
      //console.log(detalle);
      if (detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        return "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+detalle.suministro.ubicacion.numeroOrden;
      }
    }

    function quitarTipo(agrupado){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(
        null,
        "¿Está seguro que desea eliminar el detalle?",
        function(){
          limpiarTipo(agrupado.tipoSuministro);
        }
      );
    }

    function limpiarTipo(tipo){
      for (var i = vm.detalles.length - 1; i >= 0; i--) {
        if (vm.detalles[i].suministro.tipoSuministro.id == tipo.id){
          vm.detalles.splice(i, 1);
        }
      }
      vm.detallesNoInventariablesAgrupados = [];
      vm.detallesInventariablesAgrupados = [];
      cargarDetalles();
    }

    function obtenerNumeroMovimiento(callback){
      UltimoMovimiento.get({}, function(data){
        if (data && !isNaN(data.id)){
          callback(data.id + 10001);
        } else {
          callback(10001);
        }
      }, function (err){
        console.log(err);
      });
    }

    function obtenerEgreso(callback){
      obtenerNumeroMovimiento(function(data){
        var movimiento = {
          tipoMovimiento: tipoEgreso,
          estadoMovimiento: estadoGenerado,
          deposito: vm.egreso.deposito,
          empresa: vm.egreso.empresa,
          sucursal: vm.egreso.sucursal,
          observacion: vm.egreso.observacion,
          fecha: new Date(),
          detalles: vm.detalles,
          numeroMovimiento: data,
          caja: vm.egreso.caja,
          usuario: vm.egreso.usuario,
          sector: vm.egreso.sector,
          solicita: vm.egreso.solicita,
          solicitante: vm.egreso.solicitante,
          numeroVale: vm.egreso.numeroVale,
          numeroMail: vm.egreso.numeroMail
        };
        callback(movimiento);
      });
    }


    function guardarEgreso(){
      obtenerEgreso(function(movimiento){
        Egreso.save(movimiento, function(data){
          ServicioDialogos.mostrarDialogoGuardadoExito(
            null,
            "Se ha registrado con éxito el egreso",
            function(){
              $state.go('home.lista-egreso');
            });
        }, function(err){
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar el egreso");
        });
      });
    }

    function cargarDetalles(){
      vm.detallesInventariables = [];
      vm.detallesNoInventariables = [];
      vm.detalles.forEach(function(detalle){
        if (detalle.suministro.tipoSuministro.inventariable){
          vm.detallesInventariables.push(detalle);
        } else {
          vm.detallesNoInventariables.push(detalle);
        }
      });
      if (vm.detallesNoInventariables.length>0){
        armarDetallesNoInventariables();
      } else {
        actualizarTablaNoInventariables();
      }
      if (vm.detallesInventariables.length>0){
        armarDetallesInventariables();
      } else {
        actualizarTablaInventariables();
      }
    }

    function obtenerTiposUtilizados(){
      var esta = false;
      vm.detallesNoInventariables.forEach(function(detalle){
        esta = false;
        vm.detallesNoInventariablesAgrupados.forEach(function(agrupado){
          if (detalle.suministro.tipoSuministro.id==agrupado.tipoSuministro.id){
            esta = true;
          }
        });
        if (!esta){
          vm.detallesNoInventariablesAgrupados.push({tipoSuministro:detalle.suministro.tipoSuministro, precioTotal:0.0, cantidad:0, detalles:[]});
        }
      });
    }

    function armarDetallesNoInventariablesAgrupados(){
      vm.detallesNoInventariablesAgrupados.forEach(function(agrupado){
        vm.detallesNoInventariables.forEach(function(detalle){
          if (agrupado.tipoSuministro.id===detalle.suministro.tipoSuministro.id){
            agrupado.detalles.push({suministro:detalle.suministro, cantidad:detalle.cantidad});
            agrupado.cantidad = agrupado.cantidad + detalle.cantidad;
            agrupado.precioTotal = agrupado.precioTotal + detalle.suministro.precioUnitario;
          }
        });
      });
    }

    function armarDetallesNoInventariables(){
      obtenerTiposUtilizados();
      armarDetallesNoInventariablesAgrupados();
      actualizarTablaNoInventariables();
    }

    function obtenerTiposInventariablesUtilizados(){
      var esta = false;
      vm.detallesInventariables.forEach(function(detalle){
        esta = false;
        vm.detallesInventariablesAgrupados.forEach(function(agrupado){
          if (detalle.suministro.tipoSuministro.id==agrupado.tipoSuministro.id){
            esta = true;
          }
        });
        if (!esta){
          vm.detallesInventariablesAgrupados.push({tipoSuministro:detalle.suministro.tipoSuministro, precioTotal:0.0, cantidad:0, detalles:[]});
        }
      });
    }

    function armarDetallesInventariablesAgrupados(){
      vm.detallesInventariablesAgrupados.forEach(function(agrupado){
        vm.detallesInventariables.forEach(function(detalle){
          if (agrupado.tipoSuministro.id===detalle.suministro.tipoSuministro.id){
            agrupado.detalles.push({suministro:detalle.suministro, suministroInventariable:detalle.suministroInventariable, cantidad:detalle.cantidad});
            agrupado.cantidad = agrupado.cantidad + detalle.cantidad;
            agrupado.precioTotal = agrupado.precioTotal + detalle.suministro.precioUnitario;
          }
        });
      });
    }

    function armarDetallesInventariables(){
      obtenerTiposInventariablesUtilizados();
      armarDetallesInventariablesAgrupados();
      actualizarTablaInventariables();
    }

    function abrirModal(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalAgregarSuministroEgreso({
        onResult: function(resultado) {
          vm.detalles = resultado.detalles;
          vm.detallesNoInventariablesAgrupados = [];
          vm.detallesInventariablesAgrupados = [];
          cargarDetalles();
        },
        detalles: angular.copy(vm.detalles),
        empresa: vm.egreso.empresa,
        deposito: vm.egreso.deposito.id,
        sucursal: vm.egreso.sucursal
      });
    }

    function esEditar(){
      return vm.modo == "editar";
    }

    function volver(){
      if (vm.ocultar){
        ServicioDialogos.mostrarDialogoConfirmacionWarning(
          null,
          "Si vuelve a la pantalla de edición de egreso, perderá la información de todos los suministros que haya agregado. ¿Está seguro que desea volver?",
          function(){
            $state.go("home.editar-egreso", {egreso:egreso});
          }
        );
      } else {
        $state.go("home.editar-egreso", {});
      }
    }

    function mostrarInformacion(detalle){
      var marca = detalle.suministro.marca ? detalle.suministro.marca : "-";
      var fecha = detalle.suministro.fechaVencimiento ? detalle.suministro.fechaVencimiento : "-";
      ServicioDialogos.mostrarDialogoInformacion(
        null,
        "Tipo de suministro: "+detalle.suministro.tipoSuministro.nombre.toUpperCase()+
        "\nMarca: "+marca.toUpperCase()+
        "\nFecha vencimiento: "+$filter('date')(fecha, 'dd/MM/yyyy')+
        "\nFamilia de suministro: "+detalle.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase()+
        "\nGrupo de suministro: "+detalle.suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+
        "\nCantidad solicitada: "+detalle.cantidad
      );
    }

    function actualizarTablaNoInventariables(){
      vm.tableParamsNoInventariableAgrupado.settings({
        data: vm.detallesNoInventariablesAgrupados,
        noPager: true,
        counts: []
      });
      vm.tableParamsNoInventariableAgrupado.reload();
    }

    function actualizarTablaInventariables(){
      vm.tableParamsInventariableAgrupado.settings({
        data: vm.detallesInventariablesAgrupados,
        noPager: true,
        counts: []
      });
      vm.tableParamsInventariableAgrupado.reload();
    }

    function comprobarExistencia(){
      var ban = false;
      vm.detalles.forEach(function(detalle){
        if (detalle.suministro.id==vm.suministro.id){
          ban = true;
        }
      });
      return ban;
    }

    vm.tableParamsInventariableAgrupado = new NgTableParams({
      page: 1,
      count: 10,
      group:{
        tipoSuministro: 'desc'
      }
    });
    vm.tableParamsNoInventariableAgrupado = new NgTableParams({
      page: 1,
      count: 10,
      group:{
        tipoSuministro: 'desc'
      }
    });
   
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-proveedor', {
        url: 'lista-proveedor',
        templateUrl: 'app/app/main/ingreso/proveedor/lista/lista-proveedor.html',
        controller: 'ListaProveedorCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Proveedores',
          subtitulo:'Lista de Proveedores'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          proveedores: function(Proveedor){
            return Proveedor.query().$promise.then(function(data) {
              return data;
            });

          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaProveedorCtrl', ListaProveedorCtrl);

  /** @ngInject */
  function ListaProveedorCtrl(NgTableParams, URL_SERVIDOR, rol, $http, HeaderBarService, Proveedor, $timeout, $stateParams, $scope, orderByFilter, $state, proveedores, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.proveedores = orderByFilter(proveedores,'nombre',false);
    vm.mostrarInformacion = mostrarInformacion;
    vm.crearNuevo = crearNuevo;
    vm.editar = editar;
    vm.exportToExcel = exportToExcel;
    vm.eliminar = eliminar;
    vm.reportePdf = reportePdf;
    vm.bloquearPorRol = bloquearPorRol;

    function bloquearPorRol(){
      return (rol.id!=1 && rol.id!=2);
    }

    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");


    function reportePdf(){
      var Url = URL_SERVIDOR+"/proveedor/reporte";
      ServicioDialogos.abrirDialogoCargando();
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }


    function mostrarInformacion(proveedor) {
      var encargado = '';
      if (proveedor.apellidoEncargado && proveedor.nombreEncargado){
        var nombre = proveedor.nombreEncargado.toUpperCase();
        var apellido = proveedor.apellidoEncargado.toUpperCase();
        encargado = apellido+", "+nombre;
      } else {
        encargado='-';
      }
      var mail = proveedor.mailEncargado? proveedor.mailEncargado : " - ";
      var telefono = proveedor.telefonoEncargado? proveedor.telefonoEncargado : " - ";
      var descripcion = proveedor.descripcion? proveedor.descripcion : '-';
      var cuit = proveedor.cuit? proveedor.cuit : '-';
      ServicioDialogos.mostrarDialogoInformacion(
        null,
        'El proveedor se llama ' + proveedor.nombre.toUpperCase()+
        '\n Descripción: '+descripcion+
        '\n CUIT: '+cuit+
        '\n Encargado: '+encargado+
        '\n Teléfono: ' + telefono+
        '\n Mail: '+mail
      );
    }

    function editar(proveedor) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el Proveedor?', function() {
        $state.go('home.editar-proveedor', {objeto:proveedor.id, modo:'editar'});
      });
    }

    function crearNuevo() {
      $state.go('home.editar-proveedor');
    }

    function eliminar(proveedor){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Desea eliminar el Proveedor: \n"+proveedor.nombre.toUpperCase()+"?",function(){
        Proveedor.remove({id:proveedor.id}, function(data){
          ServicioDialogos.mostrarDialogoInformacion(null, "Se ha eliminado el Proveedor con éxito");
          Proveedor.query().$promise.then(function(proveedores){
            vm.proveedores = orderByFilter(proveedores,'nombre',false);
            vm.tableParams.settings({
              data: vm.proveedores
            });
            vm.tableParams.reload();
          }, function(err){
            console.log(err);
          });
        }, function(error){
          console.log(error);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar el Proveedor");
        });
      },null,false);
    }

    function exportToExcel(){ // ex: '#my-table'
      var array = [];
      var descripcion;
      var cuit;
      var encargado;
      for (var i = vm.proveedores.length - 1; i >= 0; i--) {
        if (vm.proveedores[i].apellidoEncargado && vm.proveedores[i].nombreEncargado){
          encargado = vm.proveedores[i].apellidoEncargado+', '+vm.proveedores[i].nombreEncargado;
        } else {
          encargado = '-';
        }
        descripcion = vm.proveedores[i].descripcion? vm.proveedores[i].descripcion : '-';
        cuit = vm.proveedores[i].cuit? vm.proveedores[i].cuit : '-';
        array.push({
          "Proveedor" : vm.proveedores[i].nombre,
          "Descripción" : descripcion,
          "CUIT" : cuit,
          "Encargado": encargado,
          "Teléfono encargado" : vm.proveedores[i].telefonoEncargado ? vm.proveedores[i].telefonoEncargado : '-',
          "Email encargado" : vm.proveedores[i].mailEncargado ? vm.proveedores[i].mailEncargado : '-'
        });
      }
      alasql('SELECT * INTO XLSX("proveedores.xlsx",{headers:true}) FROM ?',[array]);
    }

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });
    vm.tableParams.settings({
      data: vm.proveedores
    });
    vm.tableParams.reload();
    
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-proveedor', {
        url: 'editar-proveedor/:objeto/:modo',
        templateUrl: 'app/app/main/ingreso/proveedor/editar/editar-proveedor.html',
        controller: 'EditarProveedorCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Proveedor',
          subtituloEditar:'Editar Proveedor',
          subtituloNuevo: 'Nuevo Proveedor',
          modo:null,
          objeto:null
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          proveedor: function(Proveedor, $stateParams){
            if ($stateParams.objeto){
              return Proveedor.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return {};
            }
          },
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data) {
              return data;
            });
          },
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarProveedorCtrl', EditarProveedorCtrl);

  /** @ngInject */
  function EditarProveedorCtrl(NgTableParams, rol, HeaderBarService, proveedor, empresas, ProveedorNombreEmpresa, Proveedor, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    inicializar();
    vm.cancelar = cancelar;
    vm.guardar = guardar;
    vm.empresas = empresas;

    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");

    function inicializar(){
      setearTitulos();
      setearObjeto();
    }

    function setearObjeto(){
      if (esEditar()) {
        vm.proveedor = proveedor;
        vm.nombre = vm.proveedor.nombre;
        vm.idEmpresa = vm.proveedor.empresa.id;
      }
    }

    function esEditar() {
      return $stateParams.modo=='editar';
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      if (esEditar()) {
        HeaderBarService.setSubTitulo($stateParams.subtituloEditar);
      } else {
        HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);
      }
    }

    function cancelar() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        $state.go('home.lista-proveedor');
      });
    }

    function guardar() {
      if (esEditar()) {
        editarObjeto();
      } else {
        nuevoObjeto();
      }
    }

    function nuevoObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea registrar un nuevo Proveedor?', function(){
          ProveedorNombreEmpresa.query({nombre:vm.proveedor.nombre, idEmpresa: vm.proveedor.empresa.id},function(data){
          if (data.length>0) {
            ServicioDialogos.mostrarDialogoError(null, 'El nombre ingresado ya existe en la empresa seleccionada');
          } else {
            Proveedor.save(vm.proveedor, function(data){
              ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha registrado el Proveedor correctamente', function(){
                $state.go('home.lista-proveedor');
              });
            },function(error){
              console.error(error);
              ServicioDialogos.mostrarDialogoError(null, 'No se ha podido registrar el Proveedor');
            });
          }
        }, function(err){
          console.error(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar el Proveedor");
        });
      }, null, false);
    }

    function editarObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el Proveedor?', function(){
        if (vm.nombre==vm.proveedor.nombre && vm.idEmpresa == vm.proveedor.empresa.id) {
          Proveedor.update(vm.proveedor, function(data){
            ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado el Proveedor correctamente', function(){
              $state.go('home.lista-proveedor');
            });
          }, function(err){
            console.error(err);
            ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar el Proveedor");
          });
        } else {
          ProveedorNombreEmpresa.query({nombre:vm.proveedor.nombre, idEmpresa: vm.proveedor.empresa.id},function(data){
            if (data.length>0){
              ServicioDialogos.mostrarDialogoError(null, 'El nombre ingresado ya existe en la empresa seleccionada');
            } else {
              Proveedor.update(vm.proveedor, function(data){
                ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado el Proveedor correctamente', function(){
                  $state.go('home.lista-proveedor');
                });
              }, function(err){
                console.error(err);
                ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar el Proveedor");
              });
            }
          }, function(err){
            console.error(err);
            ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar el Proveedor");
          });
        }
      },null,false);
    }
     
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-tipo-problema', {
        url: 'lista-tipo-problema',
        templateUrl: 'app/app/main/ingreso/tipo-problema/lista/lista-tipo-problema.html',
        controller: 'ListaTipoProblemaCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Tipos de Problemas',
          subtitulo:'Lista de Tipos de Problemas'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          tiposProblema: function(TipoProblema){
            return TipoProblema.query().$promise.then(function(data) {
              return data;
            });

          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaTipoProblemaCtrl', ListaTipoProblemaCtrl);

  /** @ngInject */
  function ListaTipoProblemaCtrl(NgTableParams, URL_SERVIDOR, rol, $http, HeaderBarService, TipoProblema, $timeout, $stateParams, $scope, orderByFilter, $state, tiposProblema, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.tiposProblema = orderByFilter(tiposProblema,'nombre',false);
    vm.mostrarInformacion = mostrarInformacion;
    vm.crearNuevo = crearNuevo;
    vm.editar = editar;
    vm.exportToExcel = exportToExcel;
    vm.eliminar = eliminar;
    vm.reportePdf = reportePdf;
    vm.bloquearPorRol = bloquearPorRol;

    function bloquearPorRol(){
      return (rol.id!=1 && rol.id!=2);
    }

    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");


    function reportePdf(){
      var Url = URL_SERVIDOR+"/tipoproblema/reporte";
      ServicioDialogos.abrirDialogoCargando();
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function mostrarInformacion(problema) {
      ServicioDialogos.mostrarDialogoInformacion("Información", problema.nombre.toUpperCase()+
        "\n"+problema.descripcion);
    }

    function editar(problema) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el Tipo de problema?', function() {
        $state.go('home.editar-tipo-problema', {objeto:problema.id, modo:'editar'});
      });
    }

    function crearNuevo() {
      $state.go('home.editar-tipo-problema');
    }

    function eliminar(problema){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Desea eliminar el Tipo de problema: \n"+problema.nombre.toUpperCase()+"?",function(){
        TipoProblema.remove({id:problema.id}, function(data){
          ServicioDialogos.mostrarDialogoInformacion(null, "Se ha eliminado el Tipo de Problema con éxito");
          TipoProblema.query().$promise.then(function(problemas){
            vm.tiposProblema = orderByFilter(problemas,'nombre',false);
            vm.tableParams.settings({
              data: vm.tiposProblema
            });
            vm.tableParams.reload();
          }, function(err){
            console.log(err);
          });
        }, function(error){
          console.log(error);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar el Tipo de problema");
        });
      },null,false);
    }

    function exportToExcel(){ // ex: '#my-table'
      var array = [];
      for (var i = vm.tiposProblema.length - 1; i >= 0; i--) {
        array.push({
          "Tipo de problema" : vm.tiposProblema[i].nombre,
          "Descripción" : vm.tiposProblema[i].descripcion
      });
      }
      alasql('SELECT * INTO XLSX("tipo-tipo-problemas.xlsx",{headers:true}) FROM ?',[array]);
    }

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });
    vm.tableParams.settings({
      data: vm.tiposProblema
    });
    vm.tableParams.reload();
    
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-tipo-problema', {
        url: 'editar-tipo-problema/:objeto/:modo',
        templateUrl: 'app/app/main/ingreso/tipo-problema/editar/editar-tipo-problema.html',
        controller: 'EditarTipoProblemaCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Tipos de problema',
          subtituloEditar:'Editar Tipo de problemas',
          subtituloNuevo: 'Nuevo Tipo de problema',
          modo:null,
          objeto:null
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          tipoProblema: function(TipoProblema, $timeout, $stateParams){
            if ($stateParams.objeto){
              return TipoProblema.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return $timeout(function() {
                return {};
              }, 1000);
            }
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarTipoProblemaCtrl', EditarTipoProblemaCtrl);

  /** @ngInject */
  function EditarTipoProblemaCtrl(NgTableParams, rol, HeaderBarService, tipoProblema,  TipoProblemaNombre, TipoProblema, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    inicializar();
    vm.cancelar = cancelar;
    vm.guardar = guardar;

    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");


    function inicializar(){
      setearTitulos();
      setearObjeto();
    }

    function setearObjeto(){
      if (esEditar()) {
        vm.tipoProblema = tipoProblema;
        vm.nombre = vm.tipoProblema.nombre;

      }
    }

    function esEditar() {
      return $stateParams.modo=='editar';
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      if (esEditar()) {
        HeaderBarService.setSubTitulo($stateParams.subtituloEditar);
      } else {
        HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);
      }
    }

    function cancelar() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        $state.go('home.lista-tipo-problema');
      });
    }

    function guardar() {
      if (esEditar()) {
        editarObjeto();
      } else {
        nuevoObjeto();
      }
    }

    function nuevoObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea registrar un nuevo Tipo de problema?', function(){
        TipoProblemaNombre.query({nombre:vm.tipoProblema.nombre},function(data){
          if (data.length>0) {
            ServicioDialogos.mostrarDialogoError(null, 'El nombre ingresado ya existe');
          } else {
            TipoProblema.save(vm.tipoProblema, function(data){
              ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha registrado el Tipo de problema correctamente', function(){
                $state.go('home.lista-tipo-problema');
              });
            },function(error){
              console.error(error);
              ServicioDialogos.mostrarDialogoError(null, 'No se ha podido registrar el Tipo de problema');
            });
          }
        }, function(err){
          console.error(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar el Tipo de problema");
        });
      }, null, false);
    }

    function editarObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el Tipo de problema?', function(){
        if (vm.nombre==vm.tipoProblema.nombre) {
          TipoProblema.update(vm.tipoProblema, function(data){
            ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado el Tipo de problema correctamente', function(){
              $state.go('home.lista-tipo-problema');
            });
          }, function(err){
            console.error(err);
            ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar el Tipo de problema");
          });
        } else {
          TipoProblemaNombre.query({nombre:vm.tipoProblema.nombre},function(data){
            if (data.length>0){
              ServicioDialogos.mostrarDialogoError(null, 'El nombre ingresado ya existe');
            } else {
              TipoProblema.update(vm.tipoProblema, function(data){
                ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado el Tipo de problema correctamente', function(){
                  $state.go('home.lista-tipo-problema');
                });
              }, function(err){
                console.error(err);
                ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar el Tipo de problema");
              });
            }
          }, function(err){
            console.error(err);
            ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar el Tipo de problema");
          });
        }
      },null,false);
    }
     
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-persona-proveedor', {
        url: 'lista-persona-proveedor',
        templateUrl: 'app/app/main/ingreso/persona-proveedor/lista/lista-persona-proveedor.html',
        controller: 'ListaPersonaProveedorCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Personas de Proveedores',
          subtitulo:'Lista de Personas de Proveedores'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          personas: function(PersonaProveedor){
            return PersonaProveedor.query().$promise.then(function(data) {
              return data;
            });
          },
          proveedores: function(Proveedor){
            return Proveedor.query().$promise.then(function(data) {
              return data;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaPersonaProveedorCtrl', ListaPersonaProveedorCtrl);

  /** @ngInject */
  function ListaPersonaProveedorCtrl(NgTableParams, rol, HeaderBarService, PersonaProveedor, proveedores, PersonaProveedorNombreProveedor, $timeout, $stateParams, $scope, orderByFilter, $state, personas, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.personas = orderByFilter(personas,'nombre',false);
    vm.mostrarInformacion = mostrarInformacion;
    vm.crearNuevo = crearNuevo;
    vm.editar = editar;
    vm.exportToExcel = exportToExcel;
    vm.eliminar = eliminar;
    vm.proveedores = orderByFilter(proveedores,'nombre',false);
    vm.filtrar = filtrar;
    vm.busqueda = busqueda;
    vm.bandera=false;
    vm.bloquearPorRol = bloquearPorRol;

    function bloquearPorRol(){
      return (rol.id!=1 && rol.id!=2);
    }

    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });
    vm.tableParams.settings({
      data: vm.personas
    });
    vm.tableParams.reload();
    
    function busqueda(){
      if (vm.proveedor && vm.proveedor.id) vm.proveedor = null;
      vm.bandera=false;

      if (vm.buscar) {
        vm.personas=null;
        actualizarTabla(vm.personas);
      } else {
        filtrar();
      }
    }

    function actualizarTabla(data){
      vm.personas = orderByFilter(data,'apellido',false);
      vm.tableParams.settings({
        data: vm.personas
      });
      vm.tableParams.reload();
    }

    function fitrarPorProveedor(){
      PersonaProveedorNombreProveedor.query({id:vm.proveedor.id},function(data){
        ServicioDialogos.cerrarDialogoCargando();
        if (data.length==0) {
          vm.bandera=true;
        }
        actualizarTabla(data);
      }, function(err){
        console.error(err);
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function filtrar(){
      vm.bandera=true;
      ServicioDialogos.abrirDialogoCargando();
      if (vm.proveedor && typeof vm.proveedor !== "string") {
        fitrarPorProveedor();
      } else {
        if (vm.proveedor==undefined){
          PersonaProveedor.query(function(data){
            ServicioDialogos.cerrarDialogoCargando();
            actualizarTabla(data);
          }, function(err){
            console.error(err);
            ServicioDialogos.cerrarDialogoCargando();
          });
        } else {
          actualizarTabla(undefined);
        }
      }
    }

    function mostrarInformacion(persona) {
      var nombreCompleto = persona.apellido.toUpperCase()+", "+persona.nombre.toUpperCase();
      var telefono = persona.telefono? persona.telefono : '-';
      var dni = persona.dni? persona.dni : " - ";
      ServicioDialogos.mostrarDialogoInformacion("Información",
        'Proveedor: '+persona.proveedor.nombre.toUpperCase() +
        "\n Persona: "+nombreCompleto+
        '\n Teléfono: ' + telefono+
        '\n N° DNI: '+ dni
      );
    }

    function editar(persona) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar la persona?', function() {
        $state.go('home.editar-persona-proveedor', {objeto:persona.id, modo:'editar'});
      });
    }

    function crearNuevo() {
      $state.go('home.editar-persona-proveedor');
    }

    function eliminar(persona){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Desea eliminar la persona?",function(){
        PersonaProveedor.remove({id:persona.id}, function(data){
          ServicioDialogos.mostrarDialogoInformacion(null, "Se ha eliminado la persona con éxito");
          PersonaProveedor.query().$promise.then(function(data){
            actualizarTabla(data);
          }, function(err){
            console.log(err);
          });
        }, function(error){
          console.log(error);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar la persona");
        });
      },null,false);
    }

    function exportToExcel(){
      var array = [];
      var telefono;
      var dni;
      var nombreCompleto;
      for (var i = vm.personas.length - 1; i >= 0; i--) {
      telefono = vm.personas[i].telefono? vm.personas[i].telefono : '-';
      dni = vm.personas[i].dni? vm.personas[i].dni : '-';
      nombreCompleto = vm.personas[i].apellido.toUpperCase()+", "+vm.personas[i].nombre.toUpperCase();
        array.push({
          "Proveedor" : vm.personas[i].proveedor.nombre.toUpperCase(),
          "Persona" : nombreCompleto,
          "Teléfono" : telefono,
          "N° DNI" : dni
        });
      }
      var nombreDocumento = vm.proveedor ? "personas-de-"+vm.proveedor.nombre.toUpperCase() : "personas-de-proveedores";
      alasql('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true}) FROM ?',[array]);
    }

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-persona-proveedor', {
        url: 'editar-persona-proveedor/:objeto/:modo',
        templateUrl: 'app/app/main/ingreso/persona-proveedor/editar/editar-persona-proveedor.html',
        controller: 'EditarPersonaProveedorCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Personas de Proveedor',
          subtituloEditar:'Editar Persona de Proveedor',
          subtituloNuevo: 'Nueva Persona de Proveedor',
          modo:null,
          objeto:null
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          persona: function(PersonaProveedor, $stateParams){
            if ($stateParams.objeto){
              return PersonaProveedor.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return {};
            }
          },
          proveedores: function(Proveedor){
            return Proveedor.query().$promise.then(function(data) {
              return data;
            });
          },
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarPersonaProveedorCtrl', EditarPersonaProveedorCtrl);

  /** @ngInject */
  function EditarPersonaProveedorCtrl(NgTableParams, rol, HeaderBarService, persona, proveedores, PersonaProveedor, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    inicializar();
    vm.cancelar = cancelar;
    vm.guardar = guardar;
    vm.proveedores = proveedores;

    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");

    function inicializar(){
      setearTitulos();
      setearObjeto();
    }

    function setearObjeto(){
      if (esEditar()) {
        vm.persona = persona;
        vm.nombre = vm.persona.nombre;

      }
    }

    function esEditar() {
      return $stateParams.modo=='editar';
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      if (esEditar()) {
        HeaderBarService.setSubTitulo($stateParams.subtituloEditar);
      } else {
        HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);
      }
    }

    function cancelar() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        $state.go('home.lista-persona-proveedor');
      });
    }

    function guardar() {
      if (esEditar()) {
        editarObjeto();
      } else {
        nuevoObjeto();
      }
    }

    function nuevoObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea registrar una nueva persona?', function(){
        PersonaProveedor.save(vm.persona, function(data){
          ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha registrado la persona correctamente', function(){
            $state.go('home.lista-persona-proveedor');
          });
        },function(error){
          console.error(error);
          ServicioDialogos.mostrarDialogoError(null, 'No se ha podido registrar la persona');
        });
      }, null, false);
    }

    function editarObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar la persona?', function(){
        PersonaProveedor.update(vm.persona, function(data){
          ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado la persona correctamente', function(){
            $state.go('home.lista-persona-proveedor');
          });
        }, function(err){
          console.error(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar la persona");
        });
      },null,false);
    }
     
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-tope-sucursal-tipo', {
        url: 'lista-tope-sucursal-tipo',
        templateUrl: 'app/app/main/empresa/tope-suministros/lista-sucursal-tipo/lista-sucursal-tipo.html',
        controller: 'ListaTopeSucursalTipoCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar topes de suministros en sucursales',
          subtitulo:'Lista de topes por sucursal y tipo de suministro'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          topes: function(Usuario, TopeProducto, TopeProductoEmpresa){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado.empresa){
                return TopeProductoEmpresa.query({idEmpresa:usuario.empleado.empresa.id}).$promise.then(function(data){
                  return data;
                });
              } else {
                return TopeProducto.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaTopeSucursalTipoCtrl', ListaTopeSucursalTipoCtrl);

  /** @ngInject */
  function ListaTopeSucursalTipoCtrl(NgTableParams, ServicioModales, rol, topes, HeaderBarService, $filter, focus, TopeProducto, SucursalEmpresa, TopeProductoSucursal, $timeout, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.topes = orderByFilter(topes,['sucursal.empresa.nombre', 'sucursal.nombre', 'tipoSuministro.familiaSuministro.nombre', 'tipoSuministro.tipoSuministro.nombre'], false);

    vm.editar = editar;
    vm.crearNuevo = crearNuevo;
    vm.eliminar = eliminar;
    vm.cargarExcel = cargarExcel;
    vm.exportToExcel = exportToExcel;

    vm.bloquearPorRol = bloquearPorRol;



    function bloquearPorRol(){
      return (rol.id!=1 && rol.id!=2);
    }

    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10,
    },{
      getData: function($defer,params){ return filtrarTabla($defer, params);}
    });
    vm.tableParams.reload();

    function cargarExcel(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalCargarTopesExcel({
        onResult: function(resultado) {
          ServicioDialogos.abrirDialogoCargando();
          TopeProducto.query().$promise.then(function(data){
            actualizarTabla(data);
            ServicioDialogos.cerrarDialogoCargando();
          }, function(err){
            console.log(err);
          });
        }
      });
    }

    function exportToExcel(){
      ServicioDialogos.abrirDialogoCargando();
      var lista = $filter('orderBy')(vm.topes, ['sucursal.empresa.nombre', 'sucursal.nombre', 'tipoSuministro.familiaSuministro.grupoSuministro.nombre','tipoSuministro.familiaSuministro.nombre', 'tipoSuministro.nombre'], true);
      var array = [];
      for (var i = lista.length - 1; i >= 0; i--) {
        array.push({
          "Empresa" : lista[i].sucursal.empresa.nombre,
          "Sucursal" : lista[i].sucursal.nombre,
          "Grupo suministro" : lista[i].tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
          "Familia suministro" : lista[i].tipoSuministro.familiaSuministro.nombre.toUpperCase(),
          "Código familia" : lista[i].tipoSuministro.familiaSuministro.codigoFamiliaSuministro.toUpperCase(),
          "Tipo suministro" : lista[i].tipoSuministro.nombre.toUpperCase(),
          "Código producto" : lista[i].tipoSuministro.codigoProducto.toUpperCase(),
          "Cantidad tope" : lista[i].cantidadTope
        });
      }
      var nombreDocumento = "topes";
      alasql.promise('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true,sheetid:"Topes"}) FROM ?',[array])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function filtrarTabla($defer, params) {
      var filtros = params.filter();
      var filtrosNuevos = {};

      for (var key in filtros) {
        if (filtros.hasOwnProperty(key) && filtros[key]!=='') {
          switch(key) {
            case 'tipoSuministro.nombre':
              angular.extend(filtrosNuevos, {
                tipoSuministro: {
                nombre: filtros[key]
                }
              });
              break;
            case 'sucursal.nombre':
              angular.extend(filtrosNuevos, {
                sucursal: {
                nombre: filtros[key]
                }
              });
              break;
            default:
              filtrosNuevos[key] = filtros[key];
          }
        }
      }
      var filtrados = filtros ? $filter('filter')(vm.topes, filtrosNuevos) : vm.topes;
      filtrados = params.sorting() ? $filter('orderBy')(filtrados, params.orderBy()) : filtrados;
      if (filtrados && filtrados.length){
        params.total(filtrados.length);
        return $defer.resolve(filtrados.slice((params.page() - 1) * params.count(), params.page() * params.count()));
      } else {
        params.total(0);
        return $defer.resolve(null);
      }
    }

    function actualizarTabla(data){
      vm.topes = orderByFilter(data,['sucursal.empresa.nombre', 'sucursal.nombre', 'tipoSuministro.familiaSuministro.nombre', 'tipoSuministro.tipoSuministro.nombre'],false);
      vm.tableParams.settings({
        data: vm.topes
      });
      vm.tableParams.reload();
    }

    function editar(tope) {
      $state.go("home.editar-tope-sucursal-tipo", {modo:"editar", objeto:tope.id});
    }

    function crearNuevo() {
      $state.go('home.editar-tope-sucursal-tipo');
    }

    function eliminar(tope){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Desea eliminar el tope al suministro: \n"+tope.tipoSuministro.nombre.toUpperCase()+" de la sucursal?",function(){
        TopeProducto.remove({id:tope.id}, function(data){
          ServicioDialogos.mostrarDialogoInformacion(null, "Se ha eliminado el tope con éxito");
          TopeProducto.query().$promise.then(function(data){
            actualizarTabla(data);
          }, function(err){
            console.log(err);
          });
        }, function(error){
          console.log(error);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar el tope");
        });
      },null,false);
    }

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-tope-suministros', {
        url: 'lista-tope-suministros/:objeto',
        templateUrl: 'app/app/main/empresa/tope-suministros/lista/lista.html',
        controller: 'ListaTopesCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar topes de suministros en sucursales',
          subtitulo:'Lista de topes'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          sucursal: function(Sucursal, $stateParams){
            if ($stateParams.objeto){
              return Sucursal.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return {};
            }
          },
          topes: function(TopeProductoSucursal, $stateParams){
            return TopeProductoSucursal.query({idSucursal:$stateParams.objeto}).$promise.then(function(data){
              return data;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaTopesCtrl', ListaTopesCtrl);

  /** @ngInject */
  function ListaTopesCtrl(NgTableParams, rol, topes, HeaderBarService, $filter, focus, TopeProducto, sucursal, SucursalEmpresa, TopeProductoSucursal, $timeout, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.sucursal = sucursal;
    vm.topes = orderByFilter(topes,'tipoSuministro.nombre',false);

    vm.editar = editar;
    vm.crearNuevo = crearNuevo;
    vm.eliminar = eliminar;
    vm.volver = volver;

    vm.bloquearPorRol = bloquearPorRol;

    function volver(){
      $state.go("home.lista-sucursal");
    }

    function bloquearPorRol(){
      return (rol.id!=1 && rol.id!=2);
    }

    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10,
    },{
      getData: function($defer,params){ return filtrarTabla($defer, params);}
    });
    vm.tableParams.reload();

    function filtrarTabla($defer, params) {
      var filtros = params.filter();
      var filtrosNuevos = {};

      for (var key in filtros) {
        if (filtros.hasOwnProperty(key) && filtros[key]!=='') {
          switch(key) {
            case 'tipoSuministro.nombre':
              angular.extend(filtrosNuevos, {
                tipoSuministro: {
                nombre: filtros[key]
                }
              });
              break;
            default:
              filtrosNuevos[key] = filtros[key];
          }
        }
      }
      var filtrados = filtros ? $filter('filter')(vm.topes, filtrosNuevos) : vm.topes;
      filtrados = params.sorting() ? $filter('orderBy')(filtrados, params.orderBy()) : filtrados;
      if (filtrados && filtrados.length){
        params.total(filtrados.length);
        return $defer.resolve(filtrados.slice((params.page() - 1) * params.count(), params.page() * params.count()));
      } else {
        params.total(0);
        return $defer.resolve(null);
      }
    }

    function actualizarTabla(data){
      vm.topes = orderByFilter(data,'nombre',false);
      vm.tableParams.settings({
        data: vm.topes
      });
      vm.tableParams.reload();
    }

    function editar(tope) {
      $state.go("home.editar-tope-suministros", {modo:"editar", objeto:tope.id, sucursal:vm.sucursal.id});
    }

    function crearNuevo() {
      $state.go('home.editar-tope-suministros',{sucursal:vm.sucursal.id});
    }

    function eliminar(tope){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Desea eliminar el tope al suministro: \n"+tope.tipoSuministro.nombre.toUpperCase()+" de la sucursal?",function(){
        TopeProducto.remove({id:tope.id}, function(data){
          ServicioDialogos.mostrarDialogoInformacion(null, "Se ha eliminado el tope con éxito");
          TopeProducto.query().$promise.then(function(data){
            actualizarTabla(data);
          }, function(err){
            console.log(err);
          });
        }, function(error){
          console.log(error);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar el tope");
        });
      },null,false);
    }

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-tope-sucursal-tipo', {
        url: 'editar-tope-sucursal-tipo/:modo/:objeto',
        templateUrl: 'app/app/main/empresa/tope-suministros/editar-sucursal-tipo/editar-sucursal-tipo.html',
        controller: 'EditarTopeSucursalTipoSuministroCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar topes de suministros en sucursales',
          subtituloEditar:'Editar tope de suministro',
          subtituloNuevo: 'Nuevo tope de suministro',
          modo:"nuevo",
          objeto:null
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          objeto: function(Usuario){
            var objeto = {};
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado.empresa){
                objeto.empresa = usuario.empleado.empresa;
              }
              return objeto;
            });
          },
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data){
              return data;
            });
          },
          tope: function(TopeProducto, $stateParams){
            if ($stateParams.objeto){
              return TopeProducto.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return {};
            }
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarTopeSucursalTipoSuministroCtrl', EditarTopeSucursalTipoSuministroCtrl);

  /** @ngInject */
  function EditarTopeSucursalTipoSuministroCtrl(NgTableParams, empresas, objeto, rol, HeaderBarService, TiposPorEmpresa, TipoSuministroFamilia, FamiliaSuministroGrupo, TopeProductoSucursalTipoSuministro, TopeProducto, ServicioModales, focus, orderByFilter, tope, SucursalEmpresa, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    vm.tope = tope;
    inicializar();
    vm.sucursal = tope.sucursal;
    vm.cancelar = cancelar;
    vm.guardar = guardar;
    vm.esEditar = esEditar;
    vm.abrirModalSeleccionTipoSuministro = abrirModalSeleccionTipoSuministro;

    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");


    function abrirModalSeleccionTipoSuministro(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalElegirTipoSuministro({
        onResult: function(resultado) {
          vm.tipoSuministro = angular.copy(resultado.tipoSuministro);
          vm.tipoFormateado = vm.tipoSuministro.nombre.toUpperCase()+" - "+vm.tipoSuministro.familiaSuministro.nombre.toUpperCase()+" - "+vm.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase();
        },
        empresa: vm.empresa
      });
    }

    function cancelar(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        $state.go("home.lista-tope-sucursal-tipo");
      });
    }

    function guardar(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea guardar el tope de suministro?", function(){
        comprobarTipoRepetido();
      }, null, false);
    }

    function comprobarTipoRepetido(){
      TopeProductoSucursalTipoSuministro.query({'idTipo':vm.tipoSuministro.id, 'idSucursal':vm.sucursal.id}, function(data){
        //console.log(data);
        if (data.length>0 && (!esEditar() || (esEditar() && vm.tope.id!=data[0].id))){
          ServicioDialogos.mostrarDialogoError(null, "Ya existe un tope para este tipo de suministro en la sucursal elegida");
        } else {
          if (esEditar()){
            editarTope();
          } else {
            guardarTope();
          }
        }
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError(null, "No se puede comprobar el tipo de suministro para el tope");
      });
    }

    function editarTope(){
      vm.tope.sucursal = vm.sucursal;
      TopeProducto.update(vm.tope, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, "Se ha editado el tope de suministro con éxito", function(){
          $state.go("home.lista-tope-sucursal-tipo");
        });
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
      });
    }

    function guardarTope(){
      TopeProducto.save(armarTope(), function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, "Se ha guardado el tope de suministro con éxito", function(){
          $state.go("home.lista-tope-sucursal-tipo");
        });
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
      });
    }

    function armarTope(){
      return {
        sucursal:vm.sucursal,
        tipoSuministro: vm.tipoSuministro,
        cantidadTope: vm.tope.cantidadTope
      };
    }

    function inicializar(){
      setearTitulos();
      if (objeto.empresa) {
        if (objeto.empresa.id!=vm.tope.sucursal.empresa.id) $state.go('home.home');
      }
      if (esEditar()){
        vm.sucursal = vm.tope.sucursal;
        vm.empresa = vm.tope.sucursal.empresa;
        obtenerSucursalesEmpresa();
        vm.tipoSuministro = angular.copy(vm.tope.tipoSuministro);
        vm.tipoFormateado = vm.tipoSuministro.nombre.toUpperCase()+" - "+vm.tipoSuministro.familiaSuministro.nombre.toUpperCase()+" - "+vm.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase();
      } else {
        vm.empresas = empresas;
        if (objeto.empresa && objeto.empresa.id){
          vm.tieneEmpresa = true;
          vm.empresa = objeto.empresa;
          obtenerSucursalesEmpresa();
        }
      }
    }

    function obtenerSucursalesEmpresa(){
      ServicioDialogos.abrirDialogoCargando();
      SucursalEmpresa.query({id:vm.empresa.id}, function(data){
        vm.sucursales = orderByFilter(data, "nombre", false);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(e){
        console.log(e);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    }


    function esEditar() {
      return $stateParams.modo=='editar';
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      if (esEditar()) {
        HeaderBarService.setSubTitulo($stateParams.subtituloEditar);
      } else {
        HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);
      }
    }

    $scope.$watch('vm.empresa.nombre', function(anterior, actual){
      if (anterior==actual) return;
      if (vm.sucursal) vm.sucursal=null;
      if (!vm.empresa) return;
      ServicioDialogos.abrirDialogoCargando();
      SucursalEmpresa.query({id:vm.empresa.id}, function(data){
        vm.sucursales = orderByFilter(data, "nombre", false);
        focus('sucursal');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(e){
        console.log(e);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });


  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-tope-suministros', {
        url: 'editar-tope-suministros/:sucursal/:modo/:objeto',
        templateUrl: 'app/app/main/empresa/tope-suministros/editar/editar.html',
        controller: 'EditarTopeSuministroCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar topes de suministros en sucursales',
          subtituloEditar:'Editar tope de suministro',
          subtituloNuevo: 'Nuevo tope de suministro',
          modo:"nuevo",
          sucursal:null,
          objeto:null
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          objeto: function(Sucursal, GrupoEmpresa, $stateParams){
            var objeto = {};
            if ($stateParams.sucursal){
              return Sucursal.get({id:$stateParams.sucursal}).$promise.then(function(data) {
                objeto.sucursal = data;
                return GrupoEmpresa.query({id:data.empresa.id}).$promise.then(function(data1) {
                  objeto.grupos = data1;
                  return objeto;
                });
              });
            } else {
              return {};
            }
          },
          tope: function(TopeProducto, $stateParams){
            if ($stateParams.objeto){
              return TopeProducto.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return {};
            }
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarTopeSuministroCtrl', EditarTopeSuministroCtrl);

  /** @ngInject */
  function EditarTopeSuministroCtrl(NgTableParams, objeto, rol, HeaderBarService, TiposPorEmpresa, TipoSuministroFamilia, FamiliaSuministroGrupo, TopeProductoSucursalTipoSuministro, TopeProducto, ServicioModales, focus, orderByFilter, tope, SucursalEmpresa, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    vm.tope = tope;
    inicializar();
    vm.sucursal = objeto.sucursal;
    vm.grupos = orderByFilter(objeto.grupos, "nombre", false);
    vm.cancelar = cancelar;
    vm.guardar = guardar;
    vm.abrirModalSeleccionTipoSuministro = abrirModalSeleccionTipoSuministro;

    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");


    function abrirModalSeleccionTipoSuministro(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalElegirTipoSuministro({
        onResult: function(resultado) {
          vm.tipoSuministro = angular.copy(resultado.tipoSuministro);
          vm.tipoFormateado = vm.tipoSuministro.nombre.toUpperCase()+" - "+vm.tipoSuministro.familiaSuministro.nombre.toUpperCase()+" - "+vm.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase();
        },
        empresa: vm.sucursal.empresa
      });
    }

    function cancelar(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        $state.go("home.lista-tope-suministros", {objeto:objeto.sucursal.id});
      });
    }

    function guardar(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea guardar el tope de suministro?", function(){
        comprobarTipoRepetido();
      }, null, false);
    }

    function comprobarTipoRepetido(){
      TopeProductoSucursalTipoSuministro.query({'idTipo':vm.tipoSuministro.id, 'idSucursal':vm.sucursal.id}, function(data){
        //console.log(data);
        if (data.length>0 && (!esEditar() || (esEditar() && vm.tope.id!=data[0].id))){
          ServicioDialogos.mostrarDialogoError(null, "Ya existe un tope para este tipo de suministro en la sucursal elegida");
        } else {
          if (esEditar()){
            editarTope();
          } else {
            guardarTope();
          }
        }
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError(null, "No se puede comprobar el tipo de suministro para el tope");
      });
    }

    function editarTope(){
      TopeProducto.update(vm.tope, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, "Se ha editado el tope de suministro con éxito", function(){
          $state.go("home.lista-tope-suministros", {objeto:objeto.sucursal.id});
        });
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
      });
    }

    function guardarTope(){
      TopeProducto.save(armarTope(), function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, "Se ha guardado el tope de suministro con éxito", function(){
          $state.go("home.lista-tope-suministros", {objeto:objeto.sucursal.id});
        });
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
      });
    }

    function armarTope(){
      return {
        sucursal:objeto.sucursal,
        tipoSuministro: vm.tipoSuministro,
        cantidadTope: vm.tope.cantidadTope
      };
    }

    function inicializar(){
      setearTitulos();
      if (esEditar()){
        vm.tipoSuministro = angular.copy(vm.tope.tipoSuministro);
        vm.tipoFormateado = vm.tipoSuministro.nombre.toUpperCase()+" - "+vm.tipoSuministro.familiaSuministro.nombre.toUpperCase()+" - "+vm.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase();
      }
    }


    function esEditar() {
      return $stateParams.modo=='editar';
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      if (esEditar()) {
        HeaderBarService.setSubTitulo($stateParams.subtituloEditar);
      } else {
        HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);
      }
    }

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-sucursal', {
        url: 'lista-sucursal',
        templateUrl: 'app/app/main/empresa/sucursal/lista/lista-sucursal.html',
        controller: 'ListaSucursalCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Sucursales',
          subtitulo:'Lista de Sucursales'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data) {
              return data;
            });
          },
          sucursales: function(Sucursal){
            return Sucursal.query().$promise.then(function(data){
              return data;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaSucursalCtrl', ListaSucursalCtrl);

  /** @ngInject */
  function ListaSucursalCtrl(NgTableParams, URL_SERVIDOR, rol, $http, HeaderBarService, Sucursal, empresas, SucursalEmpresa, SucursalNombreEmpresa, $timeout, $stateParams, $scope, orderByFilter, $state, sucursales, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.sucursales = orderByFilter(sucursales,'nombre',false);
    vm.mostrarInformacion = mostrarInformacion;
    vm.crearNuevo = crearNuevo;
    vm.editar = editar;
    vm.exportToExcel = exportToExcel;
    vm.eliminar = eliminar;
    vm.empresas = orderByFilter(empresas,'nombre',false);
    vm.filtrar = filtrar;
    vm.busqueda = busqueda;
    vm.reportePdf = reportePdf;
    vm.bandera=false;
    vm.bloquearPorRol = bloquearPorRol;
    vm.irATopeSuministro = irATopeSuministro;

    function irATopeSuministro(sucursal){
      $state.go("home.lista-tope-suministros", {objeto:sucursal.id});
    }

    function bloquearPorRol(){
      return (rol.id!=1 && rol.id!=2);
    }
    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });
    vm.tableParams.settings({
      data: vm.sucursales
    });
    vm.tableParams.reload();

    function reportePdf(){
      var Url = URL_SERVIDOR+"/sucursal/reporte";
      if (vm.empresa && vm.empresa.id){
        Url = URL_SERVIDOR+"/sucursal/reporte/"+vm.empresa.id;
      }
      ServicioDialogos.abrirDialogoCargando();
       
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    
    function busqueda(){
      if (vm.empresa && vm.empresa.id) vm.empresa = null;
      vm.bandera=false;

      if (vm.buscar) {
        vm.sucursales=null;
        actualizarTabla(vm.sucursales);
      } else {
        filtrar();
      }
    }

    function actualizarTabla(data){
      vm.sucursales = orderByFilter(data,'nombre',false);
      vm.tableParams.settings({
        data: vm.sucursales
      });
      vm.tableParams.reload();
    }

    function filtrarPorEmpresa(){
      SucursalEmpresa.query({id:vm.empresa.id},function(data){
        ServicioDialogos.cerrarDialogoCargando();
        if (data.length==0) {
          vm.bandera=true;
        }
        actualizarTabla(data);
      }, function(err){
        console.error(err);
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function filtrar(){
      vm.bandera=true;
      ServicioDialogos.abrirDialogoCargando();
      if (vm.empresa && typeof vm.empresa !== "string") {
        filtrarPorEmpresa();
      } else {
        if (vm.empresa==undefined){
          Sucursal.query(function(data){
            ServicioDialogos.cerrarDialogoCargando();
            actualizarTabla(data);
          }, function(err){
            console.error(err);
            ServicioDialogos.cerrarDialogoCargando();
          });
        } else {
          actualizarTabla(undefined);
        }
      }
    }

    function mostrarInformacion(sucursal) {
      var direccion = sucursal.direccion? sucursal.direccion : '-';
      var mail = sucursal.mail? sucursal.mail : '-';
      ServicioDialogos.mostrarDialogoInformacion("Información",
        sucursal.nombre.toUpperCase() +
        '\n Empresa: '+sucursal.empresa.nombre +
        '\n Código de sucursal: '+ sucursal.codigoSucursal+
        '\n Dirección: ' + direccion+
        '\n Email: '+mail
      );
    }

    function editar(sucursal) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar la Sucursal?', function() {
        $state.go('home.editar-sucursal', {objeto:sucursal.id, modo:'editar'});
      });
    }

    function crearNuevo() {
      $state.go('home.editar-sucursal');
    }

    function eliminar(sucursal){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Desea eliminar la Sucursal: \n"+sucursal.nombre.toUpperCase()+"?",function(){
        Sucursal.remove({id:sucursal.id}, function(data){
          ServicioDialogos.mostrarDialogoInformacion(null, "Se ha eliminado la Sucursal con éxito");
          Sucursal.query().$promise.then(function(data){
            actualizarTabla(data);
          }, function(err){
            console.log(err);
          });
        }, function(error){
          console.log(error);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar la Sucursal");
        });
      },null,false);
    }

    function exportToExcel(){
      var array = [];
      var direccion;
      var mail;
      for (var i = vm.sucursales.length - 1; i >= 0; i--) {
      direccion = vm.sucursales[i].direccion? vm.sucursales[i].direccion : '-';
      mail = vm.sucursales[i].mail? vm.sucursales[i].mail : '-';
        array.push({
          "Empresa" : vm.sucursales[i].empresa.nombre,
          "Sucursal" : vm.sucursales[i].nombre,
          "Código de sucursal" : vm.sucursales[i].codigoSucursal,
          "Dirección" : direccion,
          "Email" : mail
        });
      }
      var nombreDocumento = vm.empresa ? "sucursales-"+vm.empresa.nombre.toUpperCase() : "sucursales";
      alasql('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true}) FROM ?',[array]);
    }

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-sucursal', {
        url: 'editar-sucursal/:objeto/:modo',
        templateUrl: 'app/app/main/empresa/sucursal/editar/editar-sucursal.html',
        controller: 'EditarSucursalCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Sucursal',
          subtituloEditar:'Editar Sucursal',
          subtituloNuevo: 'Nueva Sucursal',
          modo:null,
          objeto:null
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data) {
              return data;
            });
          },
          sucursal: function(Sucursal, $stateParams){
            if ($stateParams.objeto){
              return Sucursal.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return {};
            }
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarSucursalCtrl', EditarSucursalCtrl);

  /** @ngInject */
  function EditarSucursalCtrl(NgTableParams, HeaderBarService,sucursal, rol, orderByFilter, empresas, SucursalNombreEmpresa, Sucursal, SucursalCodigo, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    inicializar();
    vm.cancelar = cancelar;
    vm.guardar = guardar;
    vm.empresas = orderByFilter(empresas,'nombre',false);

    function inicializar(){
      setearTitulos();
      setearObjeto();
    }

    function setearObjeto(){
      if (esEditar()) {
        vm.sucursal = sucursal;
        vm.nombre = vm.sucursal.nombre;
        vm.empresa=vm.sucursal.empresa;
        vm.codigo=vm.sucursal.codigoSucursal;
      }
    }
    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");


    function esEditar() {
      return $stateParams.modo=='editar';
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      if (esEditar()) {
        HeaderBarService.setSubTitulo($stateParams.subtituloEditar);
      } else {
        HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);
      }
    }

    function cancelar() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        $state.go('home.lista-sucursal');
      });
    }

    function guardar() {
      if (esEditar()) {
        editarObjeto();
      } else {
        nuevoObjeto();
      }
    }


    function nuevoObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea registrar una nueva Sucursal?', function(){
        comprobarNombreSucursal();
      }, null, false);
    }

    function editarObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar la Sucursal?', function(){
        if (vm.nombre==vm.sucursal.nombre && vm.empresa.nombre==vm.sucursal.empresa.nombre){
          if (vm.codigo==vm.sucursal.codigoSucursal) {
            editarSucursal();
          } else {
            comprobarCodigoSucursal();
          }
        } else {
          comprobarNombreSucursal();
        }
      },null,false);
    }

    function comprobarCodigoSucursal(){
      if (vm.codigo==vm.sucursal.codigoSucursal) {
        guardarOEditar();
      } else {
        SucursalCodigo.query({codigo:vm.sucursal.codigoSucursal}, function(data){
          if (data.length>0){
            ServicioDialogos.mostrarDialogoError(null, 'El código de sucursal ingresado ya existe');
          } else {
            guardarOEditar();
          }
        }, function(err){
          console.log(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar la Sucursal");
        });
      }
    }


    function comprobarNombreSucursal(){
      SucursalNombreEmpresa.query({nombre:vm.sucursal.nombre, id:vm.sucursal.empresa.id},function(data){
        if (data.length>0){
          ServicioDialogos.mostrarDialogoError(null, 'El nombre ingresado ya existe en la Empresa seleccionada');
        } else {
          comprobarCodigoSucursal();
        }
      }, function(err){
        console.error(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar la Sucursal");
      });
    }

    function guardarOEditar(){
      if (esEditar()){
        editarSucursal();
      } else {
        guardarSucursal();
      }
    }

    function editarSucursal(){
      Sucursal.update(vm.sucursal, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado la Sucursal correctamente', function(){
          $state.go('home.lista-sucursal');
        });
      }, function(err){
        console.error(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar la Sucursal");
      });
    }

    function guardarSucursal(){
      Sucursal.save(vm.sucursal, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha registrado la Sucursal correctamente', function(){
          $state.go('home.lista-sucursal');
        });
      }, function(error){
        console.error(error);
        ServicioDialogos.mostrarDialogoError(null, 'No se ha podido registrar la Sucursal');
      });
    }
     
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.visualizar-kit-prearmado', {
        url: 'visualizar-kit-prearmado/:objeto',
        templateUrl: 'app/app/main/empresa/kit-prearmados/visualizar/visualizar.html',
        controller: 'VisualizarKitPrearmadoCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar kits pre-armados',
          subtitulo: 'Visualizar kit',
          objeto:null
        },
        resolve: {
          kit: function($stateParams, Kit){
            return Kit.get({id:$stateParams.objeto}).$promise.then(function(data) {
              return data;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('VisualizarKitPrearmadoCtrl', VisualizarKitPrearmadoCtrl);

  /** @ngInject */
  function VisualizarKitPrearmadoCtrl(NgTableParams, kit, $filter, HeaderBarService, ServicioModales, focus, orderByFilter, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    vm.kit=kit;
    vm.volver = volver;

    inicializar();

    function volver(){
      $state.go("home.lista-kit-prearmado");
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      HeaderBarService.setSubTitulo($stateParams.subtitulo);
    }

    function inicializar(){
      setearTitulos();
      if (vm.kit){
        crearTabla();
        actualizarTabla();
      }
    }
     
    function crearTabla(){
      vm.tableParams = new NgTableParams({
        page: 1,
        count: 10
      });
    }

    function actualizarTabla(){
      vm.tableParams.settings({
        data: $filter('orderBy')(vm.kit.detalles, ["tipoSuministro.familiaSuministro.grupoSuministro.nombre","tipoSuministro.familiaSuministro.nombre","tipoSuministro.nombre"], false)
      });
      vm.tableParams.reload();
    }

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-kit-prearmado', {
        url: 'lista-kit-prearmado',
        templateUrl: 'app/app/main/empresa/kit-prearmados/lista/lista.html',
        controller: 'ListaKitPrearmadoCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar kits pre-armados de sucursales',
          subtitulo:'Lista de kits'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data) {
              return data;
            });
          },
          kits: function(Kit){
            return Kit.query().$promise.then(function(data){
              return data;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaKitPrearmadoCtrl', ListaKitPrearmadoCtrl);

  /** @ngInject */
  function ListaKitPrearmadoCtrl(NgTableParams, rol, HeaderBarService, focus, Kit, empresas, SucursalEmpresa, KitSucursal, $timeout, $stateParams, $scope, orderByFilter, $state, kits, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.empresas = orderByFilter(empresas,'nombre',false);
    vm.kits = orderByFilter(kits,'nombre',false);

    vm.mostrarInformacion = mostrarInformacion;
    vm.crearNuevo = crearNuevo;
    vm.eliminar = eliminar;
    vm.editar = editar;
    vm.filtrar = filtrar;
    vm.busqueda = busqueda;

    vm.bloquearPorRol = bloquearPorRol;

    function bloquearPorRol(){
      return (rol.id!=1 && rol.id!=2);
    }

    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");


    vm.bandera=false;

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });
    vm.tableParams.settings({
      data: orderByFilter(vm.kits,'sucursal.nombre',false)
    });
    vm.tableParams.reload();
    
    function busqueda(){
      if (vm.empresa && vm.empresa.id) vm.empresa = null;
      if (vm.sucursal && vm.sucursal.id) vm.sucursal = null;
      vm.bandera=false;
      if (vm.buscar) {
        vm.kits=null;
        actualizarTabla(vm.kits);
      } else {
        filtrar();
      }
    }

    function actualizarTabla(data){
      vm.kits = orderByFilter(data,'nombre',false);
      vm.tableParams.settings({
        data: vm.kits
      });
      vm.tableParams.reload();
    }

    function filtrarPorSucursal(){
      KitSucursal.query({idSucursal:vm.sucursal.id},function(data){
        if (data.length==0) {
          vm.bandera=true;
        }
        actualizarTabla(data);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.error(err);
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function filtrar(){
      vm.bandera=true;
      ServicioDialogos.abrirDialogoCargando();
      if (vm.sucursal && typeof vm.sucursal !== "string") {
        filtrarPorSucursal();
      } else {
        if (vm.sucursal==undefined){
          Kit.query(function(data){
            ServicioDialogos.cerrarDialogoCargando();
            actualizarTabla(data);
          }, function(err){
            console.error(err);
            ServicioDialogos.cerrarDialogoCargando();
          });
        } else {
          actualizarTabla(undefined);
        }
      }
    }

    function mostrarInformacion(kit) {
      $state.go("home.visualizar-kit-prearmado", {objeto:kit.id});
    }

    function editar(kit){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Desea editar el kit: \n"+kit.nombre.toUpperCase()+" de la sucursal "+kit.sucursal.nombre.toUpperCase()+"?",function(){
        $state.go("home.editar-kit-prearmado", {objeto:kit.id, modo:"editar"});
      });

    }


    function crearNuevo() {
      $state.go('home.editar-kit-prearmado');
    }

    function eliminar(kit){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Desea eliminar el kit: \n"+kit.nombre.toUpperCase()+" de la sucursal "+kit.sucursal.nombre.toUpperCase()+"?",function(){
        Kit.remove({id:kit.id}, function(data){
          ServicioDialogos.mostrarDialogoInformacion(null, "Se ha eliminado el kit con éxito");
          Kit.query().$promise.then(function(data){
            actualizarTabla(data);
          }, function(err){
            console.log(err);
          });
        }, function(error){
          console.log(error);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar el kit");
        });
      },null,false);
    }

    $scope.$watch('vm.empresa.nombre', function(){
      if (!vm.empresa) return;
      if (vm.sucursal) vm.sucursal=null;
      ServicioDialogos.abrirDialogoCargando();
      SucursalEmpresa.query({id:vm.empresa.id}, function(data){
        vm.sucursales = data;
        focus('sucursal');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-kit-prearmado', {
        url: 'editar-kit-prearmado/:modo/:objeto',
        templateUrl: 'app/app/main/empresa/kit-prearmados/editar/editar.html',
        controller: 'EditarKitPrearmadoCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar kits pre-armados',
          subtituloEditar:'Editar kit de sucursal',
          subtituloNuevo: 'Nuevo kit para sucursal',
          modo:"nuevo",
          objeto:null
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data) {
              return data;
            });
          },
          kit: function(Kit, $timeout, $stateParams){
            if ($stateParams.objeto){
              return Kit.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return $timeout(function() {
                return {};
              }, 500);
            }
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarKitPrearmadoCtrl', EditarKitPrearmadoCtrl);

  /** @ngInject */
  function EditarKitPrearmadoCtrl(NgTableParams, rol, kit, $filter, HeaderBarService, KitNombreSucursal, Kit, ServicioModales, focus, orderByFilter, empresas, SucursalEmpresa, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    //console.log(kit);
    inicializar();
    vm.empresas = orderByFilter(empresas,'nombre',false);
    vm.cambiarSucursal = cambiarSucursal;
    vm.eliminar = eliminar;
    vm.cancelar = cancelar;
    vm.guardar = guardar;
    vm.seleccionarSucursal = seleccionarSucursal;
    vm.editarDetalle = editarDetalle;
    vm.abrirModalSeleccionTipoSuministro = abrirModalSeleccionTipoSuministro;


    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");

    function actualizarDetalle(resultado){
      var i = null;
      vm.tipos.forEach(function(item, index){
        if (item.tipoSuministro.id==resultado.tipoSuministro.id){
          i = index;
        }
      });
      if (i!=null){
        vm.tipos[i].cantidad = resultado.cantidad;
      }
    }

    function editarDetalle(detalle){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalSeleccionTipoSuministroKit({
        onResult: function(resultado) {
          actualizarDetalle(resultado);
          actualizarTabla();
        },
        empresa: vm.empresa,
        tipos: vm.tipos,
        tipo: detalle,
        modo: "editar"
      });
    }

    function cancelar(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        $state.go("home.lista-kit-prearmado");
      });
    }

    function comprobarKitEditar(){
      if (vm.nombreUsado==vm.nombreKit && vm.sucursalUsada == vm.sucursal.id){
        editarKit();
      } else {
        comprobarNombre();
      }
    }

    function guardar(){
      var palabra = esEditar()? "editar" : "guardar";
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea "+palabra+" el kit pre-armado?", function(){
        if (esEditar()){
          comprobarKitEditar();
        } else {
          comprobarNombre();
        }
      }, null, false);
    }

    function comprobarNombre(){
      KitNombreSucursal.query({'nombre':vm.nombreKit, 'idSucursal':vm.sucursal.id}, function(data){
        if (data.length>0){
          ServicioDialogos.mostrarDialogoError(null, "El nombre ingresado ya fue utilizado");
        } else {
          if (esEditar()){
            editarKit();
          } else {
            guardarKit();
          }
        }
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError(null, "No se puede corroborar el nombre ingresado");
      });
    }

    function editarKit(){
      Kit.update(armarKitEditar(), function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, "Se ha editado el kit con éxito", function(){
          $state.go("home.lista-kit-prearmado");
        });
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
      });
    }

    function armarKitEditar(){
      return {
        sucursal:vm.sucursal,
        nombre:vm.nombreKit,
        detalles: vm.tipos,
        id: kit.id,
        borrado: false
      };
    }

    function guardarKit(){
      Kit.save(armarKit(), function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, "Se ha guardado el kit con éxito", function(){
          $state.go("home.lista-kit-prearmado");
        });
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
      });
    }

    function armarKit(){
      return {
        sucursal:vm.sucursal,
        nombre:vm.nombreKit,
        detalles: vm.tipos
      };
    }

    function eliminar(eliminado){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea quitar este item del kit pre-armado?", function(){
        var index = null;
        vm.tipos.forEach(function(item, i){
          if (item.tipoSuministro.id==eliminado.tipoSuministro.id){
            index = i;
          }
        });
        vm.tipos.splice(index, 1);
        actualizarTabla();
      });
    }

    function abrirModalSeleccionTipoSuministro(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalSeleccionTipoSuministroKit({
        onResult: function(resultado) {
          vm.tipos.push({'tipoSuministro':resultado.tipoSuministro, 'cantidad':resultado.cantidad});
          actualizarTabla();
        },
        empresa: vm.empresa,
        tipos: vm.tipos,
      });
    }

    function cambiarSucursal(){
      if (vm.tipos.length>0){
        ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "Si cambia de sucursal, perderá todos los tipos de suministro que haya agregado.\n¿Está seguro que desea continuar?", function(){
          vm.tipos = [];
          vm.bandera=false;
          actualizarTabla();
        });
      } else {
        vm.bandera=false;
      }
    }

    function seleccionarSucursal(){
      vm.bandera=true;
    }

    function inicializar(){
      setearTitulos();
      setearObjetos();
    }

    function setearObjetos(){
      vm.tipos = [];
      vm.bandera=false;
      if (esEditar()){
        vm.empresa = kit.sucursal.empresa;
        vm.sucursal = kit.sucursal;
        vm.nombreKit = kit.nombre;
        vm.tipos = kit.detalles;
        vm.bandera = true;
        vm.sucursalUsada = angular.copy(kit.sucursal.id);
        vm.nombreUsado = angular.copy(kit.nombre);
      }
    }


    function esEditar() {
      return $stateParams.modo=='editar';
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      if (esEditar()) {
        HeaderBarService.setSubTitulo($stateParams.subtituloEditar);
      } else {
        HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);
      }
    }

    $scope.$watch('vm.empresa.nombre', function(){
      if (!vm.form.$dirty) {
        vm.form.$setDirty();
        return;
      }
      if (vm.sucursal) vm.sucursal=null;
      if (!vm.empresa) return;
      ServicioDialogos.abrirDialogoCargando();
      SucursalEmpresa.query({id:vm.empresa.id}, function(data){
        vm.sucursales = data;
        focus('sucursal');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    function actualizarTabla(){
      vm.tableParams.settings({
        data: $filter('orderBy')(vm.tipos, ["tipoSuministro.familiaSuministro.grupoSuministro.nombre","tipoSuministro.familiaSuministro.nombre","tipoSuministro.nombre"], false)
      });
      vm.tableParams.reload();
    }
     
    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });
    vm.tableParams.settings({
      data: $filter('orderBy')(vm.tipos, ["tipoSuministro.familiaSuministro.grupoSuministro.nombre","tipoSuministro.familiaSuministro.nombre","tipoSuministro.nombre"], false)
    });
    vm.tableParams.reload();
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.tipos-no-solicitables', {
        url: 'seleccion-tipos/:objeto/:empresa',
        templateUrl: 'app/app/main/empresa/solicitantes/tipos-no-solicitables/tipos-no-solicitables.html',
        controller: 'TiposNoSolicitablesPorSolicitanteCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar tipos no solicitables',
          subtitulo:'Seleccionar tipos',
          objeto:null,
          empresa: null
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          solicitante: function(Solicitante, $stateParams){
			return Solicitante.get({id:$stateParams.objeto}).$promise.then(function(data) {
				return data;
			});
          },
          tipos: function(TipoSuministroEmpresaSolicitanteInventariable, $stateParams){
            return TipoSuministroEmpresaSolicitanteInventariable.query({id:$stateParams.empresa, inv:false}).$promise.then(function(data) {
              return data;
            });
          },
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('TiposNoSolicitablesPorSolicitanteCtrl', TiposNoSolicitablesPorSolicitanteCtrl);

  /** @ngInject */
  function TiposNoSolicitablesPorSolicitanteCtrl(NgTableParams, rol, focus, orderByFilter, HeaderBarService, solicitante, tipos, SolicitanteTiposNoSolicitables, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    inicializar();
    vm.cancelar = cancelar;
    vm.actualizar = actualizar;
    vm.tipos = tipos;
    vm.solicitante = solicitante;

    vm.expandirTodos = expandirTodos;
    vm.colapsarTodos = colapsarTodos;

    vm.seleccionarFamilia = seleccionarFamilia;
    vm.seleccionarGrupo = seleccionarGrupo;

    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");

    function inicializar(){
      setearTitulos();
      setearObjeto();
      obtenerAgrupados();
    }

    function seleccionarGrupo(grupo, valor){
      grupo.seleccionado = valor;
      grupo.familias.forEach(function(familia){
        familia.seleccionado = valor;
        familia.tipos.forEach(function(tipo){
          tipo.seleccionado = valor;
        });
      });
    }

    function seleccionarFamilia(familia, valor){
      familia.seleccionado = valor;
      familia.tipos.forEach(function(tipo){
        tipo.seleccionado = valor;
      });
    }

    function expandirTodos(){
      vm.grupos.forEach(function(grupo){
        grupo.familias.forEach(function(familia){
          familia.tipos.forEach(function(tipo){
            familia.$hideRows = false;
          });
          familia.$hideRows = false;
        });
        grupo.$hideRows = false;
      });
    }

    function colapsarTodos(){
      vm.grupos.forEach(function(grupo){
        grupo.familias.forEach(function(familia){
          familia.tipos.forEach(function(tipo){
            familia.$hideRows = true;
          });
          familia.$hideRows = true;
        });
        grupo.$hideRows = true;
      });
    }

    function setearObjeto(){
      vm.solicitanteString = solicitante.apellido.toUpperCase()+", "+solicitante.nombre.toUpperCase();
      vm.sucursalString = solicitante.sucursal ? solicitante.sucursal.nombre.toUpperCase() : "-";
      vm.tiposNoSolicitables = solicitante.tiposNoSolicitables;
      vm.tiposNoSolicitables.forEach(function(item){
        tipos.forEach(function(tipo){
          if (tipo.id==item.id) {
            tipo.seleccionado = true;
          }
        });
      });
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      HeaderBarService.setSubTitulo($stateParams.subtitulo);
    }

    function cancelar() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        $state.go('home.lista-solicitantes');
      });
    }

    function obtenerSeleccionados() {
      var seleccionados = [];
      vm.tipos.forEach(function(item){
        if (item.seleccionado) seleccionados.push(item);
      });
      return seleccionados;
    }

    function actualizar() {
      vm.solicitante.tiposNoSolicitables = obtenerSeleccionados();
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea actualizar los tipos no solicitables?', function(){
        SolicitanteTiposNoSolicitables.update(vm.solicitante, function(data){
          ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se han actualizado los tipos no solicitables correctamente', function(){
            $state.go('home.lista-solicitantes');
          });
        },function(error){
          console.error(error);
          ServicioDialogos.mostrarDialogoError(null, 'No se ha podido actualizar el solicitante');
        });
      }, null, false);
    }

    function obtenerAgrupados() {
      vm.familias = obtenerFamilias();
      seleccionarFamiliasCompletas();
      vm.grupos = obtenerGrupos();
      seleccionarGruposCompletos();
    }

    function seleccionarFamiliasCompletas() {
      var cont;
      vm.familias.forEach(function(familia){
        cont = 0;
        familia.tipos.forEach(function(tipo){
          if (tipo.seleccionado) cont++;
        });
        if (cont==familia.tipos.length) familia.seleccionado=true;
      });
    }

    function seleccionarGruposCompletos() {
      var cont;
      vm.grupos.forEach(function(grupo){
        cont = 0;
        grupo.familias.forEach(function(familia){
          if (familia.seleccionado) cont++;
        });
        if (cont==grupo.familias.length) grupo.seleccionado=true;
      });
    }

    function obtenerGrupos(){
      var grupos = [];
      var ban;
      vm.familias.forEach(function(familia){
        ban = false;
        grupos.forEach(function(grupo){
          if (grupo.grupo.id==familia.familia.grupoSuministro.id){
            grupo.familias.push(familia);
            ban = true;
          }
        });
        if (!ban) {
          var familias = [];
          familias.push(familia);
          grupos.push({grupo:familia.familia.grupoSuministro, familias:familias});
        }
      });
      return grupos;
    }

    function obtenerFamilias(){
      var familias = [];
      var ban;
      tipos.forEach(function(tipo){
        ban = false;
        familias.forEach(function(familia){
          if (familia.familia.id==tipo.familiaSuministro.id) {
            familia.tipos.push(tipo);
            ban = true;
          }
        });
        if (!ban) {
          var tipos = [];
          tipos.push(tipo);
          familias.push({familia:tipo.familiaSuministro, tipos:tipos});
        }
      });
      return familias;
    }

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-solicitantes', {
        url: 'lista-solicitantes',
        templateUrl: 'app/app/main/empresa/solicitantes/lista/lista.html',
        controller: 'ListaSolicitantesCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Solicitantes',
          subtitulo:'Lista de Solicitantes'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          solicitantes: function(Solicitante){
            return Solicitante.query().$promise.then(function(data) {
              return data;
            });

          },
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data) {
              return data;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaSolicitantesCtrl', ListaSolicitantesCtrl);

  /** @ngInject */
  function ListaSolicitantesCtrl(NgTableParams, rol, HeaderBarService, Solicitante, empresas, SolicitanteEmpresa, $timeout, $stateParams, $scope, orderByFilter, $state, solicitantes, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.solicitantes = orderByFilter(solicitantes,'nombre',false);
    vm.mostrarInformacion = mostrarInformacion;
    vm.crearNuevo = crearNuevo;
    vm.editar = editar;
    vm.exportToExcel = exportToExcel;
    vm.eliminar = eliminar;
    vm.empresas = orderByFilter(empresas,'nombre',false);
    vm.filtrar = filtrar;
    vm.busqueda = busqueda;
    vm.bandera=false;
    vm.bloquearPorRol = bloquearPorRol;
    vm.abrirSeleccionTipos = abrirSeleccionTipos;

    function abrirSeleccionTipos(solicitante){
      $state.go('home.tipos-no-solicitables', {objeto:solicitante.id, empresa:solicitante.empresa.id});
    }

    function bloquearPorRol(){
      return (rol.id!=1 && rol.id!=2);
    }

    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });
    vm.tableParams.settings({
      data: vm.solicitantes
    });
    vm.tableParams.reload();
    
    function busqueda(){
      if (vm.empresa && vm.empresa.id) vm.empresa = null;
      vm.bandera=false;

      if (vm.buscar) {
        vm.solicitantes=null;
        actualizarTabla(vm.solicitantes);
      } else {
        filtrar();
      }
    }

    function actualizarTabla(data){
      vm.solicitantes = orderByFilter(data,'apellido',false);
      vm.tableParams.settings({
        data: vm.solicitantes
      });
      vm.tableParams.reload();
    }

    function filtrarPorEmpresa(){
      SolicitanteEmpresa.query({id:vm.empresa.id},function(data){
        ServicioDialogos.cerrarDialogoCargando();
        if (data.length==0) {
          vm.bandera=true;
        }
        actualizarTabla(data);
      }, function(err){
        console.error(err);
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function filtrar(){
      vm.bandera=true;
      ServicioDialogos.abrirDialogoCargando();
      if (vm.empresa && typeof vm.empresa !== "string") {
        filtrarPorEmpresa();
      } else {
        if (vm.empresa==undefined){
          Solicitante.query(function(data){
            ServicioDialogos.cerrarDialogoCargando();
            actualizarTabla(data);
          }, function(err){
            console.error(err);
            ServicioDialogos.cerrarDialogoCargando();
          });
        } else {
          actualizarTabla(undefined);
        }
      }
    }

    function mostrarInformacion(solicitante) {
      var nombreCompleto = solicitante.apellido.toUpperCase()+", "+solicitante.nombre.toUpperCase();
      var telefono = solicitante.telefono? solicitante.telefono : '-';
      var dni = solicitante.dni? solicitante.dni : " - ";
      var mail = solicitante.mail? solicitante.mail : " - ";
      var sucursal = solicitante.sucursal? solicitante.sucursal.nombre.toUpperCase() : " - ";
      ServicioDialogos.mostrarDialogoInformacion("Información",
        'Empresa: '+solicitante.empresa.nombre.toUpperCase() +
        "\n Solicitante: "+nombreCompleto+
        '\n Teléfono: ' + telefono+
        '\n N° DNI: '+ dni +
        '\n Email: '+mail+
        '\n Sucursal: '+sucursal
      );
    }

    function editar(solicitante) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el solicitante?', function() {
        $state.go('home.editar-solicitante', {objeto:solicitante.id, modo:'editar'});
      });
    }

    function crearNuevo() {
      $state.go('home.editar-solicitante');
    }

    function eliminar(solicitante){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Desea eliminar el solicitante?",function(){
        Solicitante.remove({id:solicitante.id}, function(data){
          ServicioDialogos.mostrarDialogoInformacion(null, "Se ha eliminado el solicitante con éxito");
          Solicitante.query().$promise.then(function(data){
            actualizarTabla(data);
          }, function(err){
            console.log(err);
          });
        }, function(error){
          console.log(error);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar el solicitante");
        });
      },null,false);
    }

    function exportToExcel(){
      var array = [];
      var telefono;
      var dni;
      var nombreCompleto;
      for (var i = vm.solicitantes.length - 1; i >= 0; i--) {
      telefono = vm.solicitantes[i].telefono? vm.solicitantes[i].telefono : '-';
      dni = vm.solicitantes[i].dni? vm.solicitantes[i].dni : '-';
      nombreCompleto = vm.solicitantes[i].apellido.toUpperCase()+", "+vm.solicitantes[i].nombre.toUpperCase();
        array.push({
          "Empresa" : vm.solicitantes[i].empresa.nombre.toUpperCase(),
          "Solicitante" : nombreCompleto,
          "Teléfono" : telefono,
          "N° DNI" : dni
        });
      }
      var nombreDocumento = vm.empresa ? "solicitantes-de-"+vm.empresa.nombre.toUpperCase() : "solicitantes";
      alasql('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true}) FROM ?',[array]);
    }

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-solicitante', {
        url: 'editar-solicitante/:objeto/:modo',
        templateUrl: 'app/app/main/empresa/solicitantes/editar/editar.html',
        controller: 'EditarSolicitanteCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Solicitantes',
          subtituloEditar:'Editar solicitante',
          subtituloNuevo: 'Nuevo solicitante',
          modo:null,
          objeto:null
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          solicitante: function(Solicitante, $stateParams){
            if ($stateParams.objeto){
              return Solicitante.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return {};
            }
          },
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data) {
              return data;
            });
          },
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarSolicitanteCtrl', EditarSolicitanteCtrl);

  /** @ngInject */
  function EditarSolicitanteCtrl(NgTableParams, rol, focus, orderByFilter, SucursalEmpresa, HeaderBarService, solicitante, empresas, Solicitante, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    inicializar();
    vm.cancelar = cancelar;
    vm.guardar = guardar;
    vm.empresas = empresas;

    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");

    function inicializar(){
      setearTitulos();
      setearObjeto();
    }

    function setearObjeto(){
      if (esEditar()) {
        vm.solicitante = solicitante;
      }
    }

    function esEditar() {
      return $stateParams.modo=='editar';
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      if (esEditar()) {
        HeaderBarService.setSubTitulo($stateParams.subtituloEditar);
      } else {
        HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);
      }
    }

    function cancelar() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        $state.go('home.lista-solicitantes');
      });
    }

    function guardar() {
      if (esEditar()) {
        editarObjeto();
      } else {
        nuevoObjeto();
      }
    }

    function nuevoObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea registrar un nuevo solicitante?', function(){
        Solicitante.save(vm.solicitante, function(data){
          ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha registrado el solicitante correctamente', function(){
            $state.go('home.lista-solicitantes');
          });
        },function(error){
          console.error(error);
          ServicioDialogos.mostrarDialogoError(null, 'No se ha podido registrar el solicitante');
        });
      }, null, false);
    }

    function editarObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el solicitante?', function(){
        Solicitante.update(vm.solicitante, function(data){
          ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado el solicitante correctamente', function(){
            $state.go('home.lista-solicitantes');
          });
        }, function(err){
          console.error(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar el solicitante");
        });
      },null,false);
    }

    $scope.$watch('vm.solicitante.empresa.nombre', function(anterior, actual){
      if (anterior ==  actual) return;
      if (vm.solicitante && vm.solicitante.sucursal) vm.solicitante.sucursal=null;
      if (!vm.solicitante.empresa) return;
      ServicioDialogos.abrirDialogoCargando();
      SucursalEmpresa.query({id:vm.solicitante.empresa.id}, function(data){
        vm.sucursales = orderByFilter(data, "nombre", false);
        focus('sucursal');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-empresa', {
        url: 'lista-empresa',
        templateUrl: 'app/app/main/empresa/empresa/lista/lista-empresa.html',
        controller: 'ListaEmpresaCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Empresas',
          subtitulo:'Lista de Empresas'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data) {
              return data;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaEmpresaCtrl', ListaEmpresaCtrl);

  /** @ngInject */
  function ListaEmpresaCtrl(NgTableParams, rol, SucursalEmpresa, URL_SERVIDOR, $http, HeaderBarService, Empresa, $timeout, $stateParams, $scope, orderByFilter, $state, empresas, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.empresas = orderByFilter(empresas,'nombre',false);
    vm.mostrarInformacion = mostrarInformacion;
    vm.crearNuevo = crearNuevo;
    vm.editar = editar;
    vm.exportToExcel = exportToExcel;
    vm.eliminar = eliminar;
    vm.reportePdf = reportePdf;
    vm.bloquearPorRol = bloquearPorRol;

    function bloquearPorRol(){
      return (rol.id!=1 && rol.id!=2);
    }
    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");


    function reportePdf(){
      ServicioDialogos.abrirDialogoCargando();
      var Url = URL_SERVIDOR+"/empresa/reporte";
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function mostrarInformacion(empresa) {
      var mail1 = empresa.mailAdicional1? empresa.mailAdicional1 : "-";
      var mail2 = empresa.mailAdicional2? empresa.mailAdicional2 : "-";
      var mail3 = empresa.mailAdicional3? empresa.mailAdicional3 : "-";
      var mailStock1 = empresa.mailStock1? empresa.mailStock1 : "-";
      var mailStock2 = empresa.mailStock2? empresa.mailStock2 : "-";
      var mailStock3 = empresa.mailStock3? empresa.mailStock3 : "-";
      var mailIngreso1 = empresa.mailIngreso1? empresa.mailIngreso1 : "-";
      var mailIngreso2 = empresa.mailIngreso2? empresa.mailIngreso2 : "-";
      var mailIngreso3 = empresa.mailIngreso3? empresa.mailIngreso3 : "-";
      var periodoTope = empresa.tipoTope? empresa.tipoTope.periodo.toUpperCase() : "-";
      ServicioDialogos.mostrarDialogoInformacion(null,
        "La empresa se llama " + empresa.nombre.toUpperCase()+"\n"+
        "Periodicidad para topes de suministros: " +periodoTope+"\n\n"+
        "Mail adicional 1: "+mail1+
        "\nMail adicional 2: "+mail2+
        "\nMail adicional 3: "+mail3+
        "\n\nMail stock mínimo 1: "+mailStock1+
        "\nMail stock mínimo 2: "+mailStock2+
        "\nMail stock mínimo 3: "+mailStock3+
        "\n\nMail ingresos 1: "+mailIngreso1+
        "\nMail ingresos 2: "+mailIngreso2+
        "\nMail ingresos 3: "+mailIngreso3
      );
    }

    function editar(empresa) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar la Empresa?', function() {
        $state.go('home.editar-empresa', {objeto:empresa.id, modo:'editar'});
      });
    }

    function crearNuevo() {
      $state.go('home.editar-empresa');
    }

    function eliminarEmpresa(empresa){
      Empresa.remove({id:empresa.id}, function(data){
        ServicioDialogos.mostrarDialogoInformacion(null, "Se ha eliminado la Empresa con éxito");
        Empresa.query().$promise.then(function(empresas){
          vm.empresas = orderByFilter(empresas,'nombre',false);
          vm.tableParams.settings({
            data: vm.empresas
          });
          vm.tableParams.reload();
        }, function(err){
          console.log(err);
        });
      }, function(error){
        console.log(error);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar la Empresa");
      });
    }

    function eliminar(empresa){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Desea eliminar la Empresa: \n"+empresa.nombre.toUpperCase()+"?",function(){
        SucursalEmpresa.query({id:empresa.id},function(data){
          if (data.length==0) {
            eliminarEmpresa(empresa);
          } else {
            ServicioDialogos.mostrarDialogoError(null, "No se puede eliminar la empresa");
          }
        }, function(err){
          console.error(err);
          ServicioDialogos.mostrarDialogoError();
        });
      },null,false);
    }

    function exportToExcel(){ // ex: '#my-table'
      var array = [];
      for (var i = vm.empresas.length - 1; i >= 0; i--) {
        array.push({
          "Empresa" : vm.empresas[i].nombre,
          "Descripción" : vm.empresas[i].descripcion
      });
      }
      alasql('SELECT * INTO XLSX("empresas.xlsx",{headers:true}) FROM ?',[array]);
    }

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });
    vm.tableParams.settings({
      data: vm.empresas
    });
    vm.tableParams.reload();
    
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-empresa', {
        url: 'editar-empresa/:objeto/:modo',
        templateUrl: 'app/app/main/empresa/empresa/editar/editar-empresa.html',
        controller: 'EditarEmpresaCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Empresa',
          subtituloEditar:'Editar Empresa',
          subtituloNuevo: 'Nueva Empresa',
          modo:null,
          objeto:null
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          tiposTope: function($timeout){
            return $timeout(function() {
              return [{id:1, borrado: false, periodo: 'ANUAL'},{id:2, borrado: false, periodo:'SEMESTRAL'},{id:3, borrado:false,periodo:'BIMESTRAL'}];
            }, 1000);
          },
          empresa: function(Empresa, $timeout, $stateParams){
            if ($stateParams.objeto){
              return Empresa.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return $timeout(function() {
                return {};
              }, 1000);
            }
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarEmpresaCtrl', EditarEmpresaCtrl);

  /** @ngInject */
  function EditarEmpresaCtrl(NgTableParams, rol, tiposTope, HeaderBarService, empresa, EmpresaNombre, Empresa, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    inicializar();
    vm.cancelar = cancelar;
    vm.tiposTope = tiposTope;
    vm.guardar = guardar;
    vm.comprobarMails = comprobarMails;

    var emailsEmpresa = [];
    var emailsStock = [];
    var emailsIngresos = [];

    if (rol.id!=1 && rol.id!=2) $state.go("home.home");


    function inicializar(){
      setearTitulos();
      setearObjeto();
      setearMails();
    }

    function comprobarMails(){
      if (!vm.empresa) return;
      return (vm.empresa.mailAdicional1 && (vm.empresa.mailAdicional1===vm.empresa.mailAdicional2 ||
        vm.empresa.mailAdicional1===vm.empresa.mailAdicional3)) ||
        (vm.empresa.mailAdicional2 && (vm.empresa.mailAdicional2===vm.empresa.mailAdicional3));
    }

    function setearObjeto(){
      if (esEditar()) {
        vm.empresa = empresa;
        vm.nombre = vm.empresa.nombre;
      }
    }

    function setearMails(){
      vm.emailsEmpresa = [];
      vm.emailsStock = [];
      vm.emailsIngresos = [];
      if (esEditar()){
        if (vm.empresa.mailAdicional1) vm.emailsEmpresa.push(vm.empresa.mailAdicional1);
        if (vm.empresa.mailAdicional2) vm.emailsEmpresa.push(vm.empresa.mailAdicional2);
        if (vm.empresa.mailAdicional3) vm.emailsEmpresa.push(vm.empresa.mailAdicional3);
        if (vm.empresa.mailStock1) vm.emailsStock.push(vm.empresa.mailStock1);
        if (vm.empresa.mailStock2) vm.emailsStock.push(vm.empresa.mailStock2);
        if (vm.empresa.mailStock3) vm.emailsStock.push(vm.empresa.mailStock3);
        if (vm.empresa.mailIngreso1) vm.emailsIngresos.push(vm.empresa.mailIngreso1);
        if (vm.empresa.mailIngreso2) vm.emailsIngresos.push(vm.empresa.mailIngreso2);
        if (vm.empresa.mailIngreso3) vm.emailsIngresos.push(vm.empresa.mailIngreso3);

      }
    }

    function esEditar() {
      return $stateParams.modo=='editar';
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      if (esEditar()) {
        HeaderBarService.setSubTitulo($stateParams.subtituloEditar);
      } else {
        HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);
      }
    }

    function cancelar() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        $state.go('home.lista-empresa');
      });
    }

    function guardar() {
      obtenerMails();
      if (esEditar()) {
        editarObjeto();
      } else {
        nuevoObjeto();
      }
    }

    function obtenerMails(){
      vm.empresa.mailAdicional1 = vm.emailsEmpresa[0];
      vm.empresa.mailAdicional2 = vm.emailsEmpresa[1];
      vm.empresa.mailAdicional3 = vm.emailsEmpresa[2];
      vm.empresa.mailStock1 = vm.emailsStock[0];
      vm.empresa.mailStock2 = vm.emailsStock[1];
      vm.empresa.mailStock3 = vm.emailsStock[2];
      vm.empresa.mailIngreso1 = vm.emailsIngresos[0];
      vm.empresa.mailIngreso2 = vm.emailsIngresos[1];
      vm.empresa.mailIngreso3 = vm.emailsIngresos[2];
    }

    function nuevoObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea registrar una nueva Empresa?', function(){
        EmpresaNombre.query({nombre:vm.empresa.nombre},function(data){
          if (data.length>0) {
            ServicioDialogos.mostrarDialogoError(null, 'El nombre ingresado ya existe');
          } else {
            Empresa.save(vm.empresa, function(data){
              ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha registrado la Empresa correctamente', function(){
                $state.go('home.lista-empresa');
              });
            },function(error){
              console.error(error);
              ServicioDialogos.mostrarDialogoError(null, 'No se ha podido registrar la Empresa');
            });
          }
        }, function(err){
          console.error(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar la Empresa");
        });
      }, null, false);
    }

    function editarObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar la Empresa?', function(){
        if (vm.nombre==vm.empresa.nombre) {
          Empresa.update(vm.empresa, function(data){
            ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado la Empresa correctamente', function(){
              $state.go('home.lista-empresa');
            });
          }, function(err){
            console.error(err);
            ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar la Empresa");
          });
        } else {
          EmpresaNombre.query({nombre:vm.empresa.nombre},function(data){
            if (data.length>0){
              ServicioDialogos.mostrarDialogoError(null, 'El nombre ingresado ya existe');
            } else {
              Empresa.update(vm.empresa, function(data){
                ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado la Empresa correctamente', function(){
                  $state.go('home.lista-empresa');
                });
              }, function(err){
                console.error(err);
                ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar la Empresa");
              });
            }
          }, function(err){
            console.error(err);
            ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar la Empresa");
          });
        }
      },null,false);
    }
     
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-solicitud-suministros', {
        url: 'editar-solicitud-suministros',
        templateUrl: 'app/app/main/egreso/solicitud-suministros/editar/editar-solicitud-suministros.html',
        controller: 'EditarSolicitudSuministros',
        controllerAs: 'vm',
        params:{
          titulo:'Solicitudes de Suministros',
          subtitulo:'Nueva solicitud'
        },
        resolve: {
          productos: function(TipoSuministro){
            return TipoSuministro.query().$promise.then(function(data) {
              return data;
            });

          },
          grupos: function(GrupoSuministro){
            return GrupoSuministro.query().$promise.then(function(data) {
              return data;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarSolicitudSuministros', EditarSolicitudSuministros);

  /** @ngInject */
  function EditarSolicitudSuministros(NgTableParams, ServicioModales, HeaderBarService, TipoSuministroFamilia, FamiliaSuministroGrupo, TipoSuministro, grupos, productos, $timeout, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.productos = productos;
    vm.grupos = orderByFilter(grupos,'nombre',false);
    vm.agregar = agregar;
    vm.detalles = [];
    vm.mostrarInformacion = mostrarInformacion;
    vm.editar = editar;
    vm.eliminar = eliminar;
    vm.modo = "nuevo";
    vm.abrirModal = abrirModal;
    vm.guardar = guardar;

    function guardar(){
      var pedido = {

      };
    }

    function abrirModal(){
      ServicioModales.abrirModalAgregarPedido({
        onResult: function(detalles) {
          vm.detalles = detalles
          actualizarTabla(vm.detalles);
        },
        detalles: vm.detalles
      });
    }

    function eliminar(index){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(
        null,
        "¿Está seguro que desea eliminar el detalle?",
        function(){
          vm.detalles.splice(index, 1);
          actualizarTabla(vm.detalles);
        }
      );
    }

    $scope.$watch('vm.grupo.nombre', function(){
      vm.familiaSuministro=null;
      if (!vm.grupo) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupo.id}, function(data){
        vm.familias = data;
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.familiaSuministro.nombre', function(){
      vm.suministro=null;
      if (!vm.familiaSuministro) return;
      ServicioDialogos.abrirDialogoCargando();
      TipoSuministroFamilia.query({id:vm.familiaSuministro.id}, function(data){
        vm.suministros = data;
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    function esEditar(){
      return vm.modo == "editar";
    }

    function editar(detalle){
/*      vm.grupo = detalle.suministro.familiaSuministro.grupoSuministro;
      vm.familiaSuministro = detalle.suministro.familiaSuministro;
      vm.suministro = detalle.suministro;
      vm.cantidad = detalle.cantidad;
      vm.modo = "editar";*/
      ServicioModales.abrirModalAgregarPedido({
        onResult: function(detalles) {
          vm.detalles = detalles
          actualizarTabla(vm.detalles);
        },
        detalles: vm.detalles,
        modo : "editar",
        detalle : detalle
      });
    }

    function mostrarInformacion(detalle){
      ServicioDialogos.mostrarDialogoInformacion(
        null,
        "Suministro: "+detalle.suministro.nombre.toUpperCase()+
        "\nFamilia de suministro: "+detalle.suministro.familiaSuministro.nombre.toUpperCase()+
        "\nGrupo de suministro: "+detalle.suministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+
        "\nCantidad solicitada: "+detalle.cantidad
      );
    }

    function actualizarTabla(detalles){
      vm.tableParams.settings({
        data: detalles
      });
      vm.tableParams.reload();
    }

    function comprobarExistencia(){
      var ban = false;
      vm.detalles.forEach(function(detalle){
        if (detalle.suministro.id==vm.suministro.id){
          ban = true;
        }
      });
      return ban;
    }

    function limpiarForm(){
      vm.grupo = null;
      vm.cantidad=null;
      vm.form.cantidad.$dirty = false;
    }

    function agregarDetalle(){
      if (!comprobarExistencia()){
        var detalle = {
          suministro : vm.suministro,
          cantidad : vm.cantidad
        };
        vm.numero = vm.numero+1;
        vm.detalles.push(detalle);
        console.log(vm.detalles, vm.suministro, vm.cantidad);
        limpiarForm();
        actualizarTabla(vm.detalles);
      } else {
        ServicioDialogos.mostrarDialogoError(null, "Ya agregó este suministro al pedido");
      }
    }

    function editarDetalle(){

    }


    function agregar(){
      if (esEditar()){
        editarDetalle();
      } else {
        agregarDetalle();
      }
    }
    
    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });
   
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-empresa-logistica', {
        url: 'lista-empresa-logistica',
        templateUrl: 'app/app/main/egreso/empresa-logistica/lista/lista-empresa-logistica.html',
        controller: 'ListaEmpresaLogisticaCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Empresas de logística',
          subtitulo:'Lista de Empresas de logística'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          empresas: function(EmpresaLogistica){
            return EmpresaLogistica.query().$promise.then(function(data) {
              return data;
            });

          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaEmpresaLogisticaCtrl', ListaEmpresaLogisticaCtrl);

  /** @ngInject */
  function ListaEmpresaLogisticaCtrl(NgTableParams, rol, URL_SERVIDOR, $http, HeaderBarService, EmpresaLogistica, $timeout, $stateParams, $scope, orderByFilter, $state, empresas, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.empresas = orderByFilter(empresas,'nombre',false);
    vm.mostrarInformacion = mostrarInformacion;
    vm.crearNuevo = crearNuevo;
    vm.editar = editar;
    vm.exportToExcel = exportToExcel;
    vm.eliminar = eliminar;
    vm.reportePdf = reportePdf;
    vm.bloquearPorRol = bloquearPorRol;

    function bloquearPorRol(){
      return (rol.id!=1 && rol.id!=2);
    }

    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");


    function reportePdf(){
      var Url = URL_SERVIDOR+"/empresalogistica/reporte";
      ServicioDialogos.abrirDialogoCargando();
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }


    function mostrarInformacion(empresa) {
      var encargado = '';
      if (empresa.apellidoEncargado && empresa.nombreEncargado){
        var nombre = empresa.nombreEncargado.toUpperCase();
        var apellido = empresa.apellidoEncargado.toUpperCase();
        encargado = apellido+", "+nombre;
      } else {
        encargado='-';
      }
      var mail = empresa.mailEncargado? empresa.mailEncargado : " - ";
      var mailReclamo = empresa.mailReclamo? empresa.mailReclamo : " - ";
      var telefono = empresa.telefonoEncargado? empresa.telefonoEncargado : " - ";
      var descripcion = empresa.descripcion? empresa.descripcion : "-";
      ServicioDialogos.mostrarDialogoInformacion(null,
        "El empresa de logística se llama " + empresa.nombre.toUpperCase()+
        "\nDescripción: "+descripcion.toUpperCase()+
        '\n Mail reclamos: '+mailReclamo+
        '\n Encargado: '+encargado+
        '\n Teléfono: ' + telefono+
        '\n Mail: '+mail
      );
    }

    function editar(empresa) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar la Empresa de logística?', function() {
        $state.go('home.editar-empresa-logistica', {objeto:empresa.id, modo:'editar'});
      });
    }

    function crearNuevo() {
      $state.go('home.editar-empresa-logistica');
    }

    function eliminar(empresa){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Desea eliminar la Empresa de logística: \n"+empresa.nombre.toUpperCase()+"?",function(){
        EmpresaLogistica.remove({id:empresa.id}, function(data){
          ServicioDialogos.mostrarDialogoInformacion(null, "Se ha eliminado la Empresa de logística con éxito");
          EmpresaLogistica.query().$promise.then(function(empresas){
            vm.empresas = orderByFilter(empresas,'nombre',false);
            vm.tableParams.settings({
              data: vm.empresas
            });
            vm.tableParams.reload();
          }, function(err){
            console.log(err);
          });
        }, function(error){
          console.log(error);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar la Empresa de logística");
        });
      },null,false);
    }

    function exportToExcel(){ // ex: '#my-table'
      var array = [];
      var encargado;
      for (var i = vm.empresas.length - 1; i >= 0; i--) {
        if (vm.empresas[i].apellidoEncargado && vm.empresas[i].nombreEncargado){
          encargado = vm.empresas[i].apellidoEncargado+', '+vm.empresas[i].nombreEncargado;
        } else {
          encargado = '-';
        }
        array.push({
          "Nombre" : vm.empresas[i].nombre,
          "Descripción" : vm.empresas[i].descripcion ? vm.empresas[i].descripcion : '-',
          "Encargado": encargado,
          "Teléfono encargado" : vm.empresas[i].telefonoEncargado ? vm.empresas[i].telefonoEncargado : '-',
          "Email encargado" : vm.empresas[i].mailEncargado ? vm.empresas[i].mailEncargado : '-'
        });
      }
      alasql('SELECT * INTO XLSX("empresas-logistica.xlsx",{headers:true}) FROM ?',[array]);
    }

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });
    vm.tableParams.settings({
      data: vm.empresas
    });
    vm.tableParams.reload();
    
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-empresa-logistica', {
        url: 'editar-empresa-logistica/:objeto/:modo',
        templateUrl: 'app/app/main/egreso/empresa-logistica/editar/editar-empresa-logistica.html',
        controller: 'EditarEmpresaLogisticaCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Empresas de logística',
          subtituloEditar:'Editar Empresa de logística',
          subtituloNuevo: 'Nueva Empresa de logística',
          modo:null,
          objeto:null
        },
        resolve:{
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          empresa: function(EmpresaLogisticaId, $stateParams){
            if ($stateParams.objeto){
              return EmpresaLogisticaId.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return {};
            }
          },
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data){
              return data;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarEmpresaLogisticaCtrl', EditarEmpresaLogisticaCtrl);

  /** @ngInject */
  function EditarEmpresaLogisticaCtrl(NgTableParams, rol, HeaderBarService, empresas, empresa, EmpresaLogisticaNombreEmpresa, EmpresaLogistica, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    inicializar();
    vm.cancelar = cancelar;
    vm.guardar = guardar;
    vm.empresas = empresas;

    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");


    function inicializar(){
      setearTitulos();
      setearObjeto();
    }

    function setearObjeto(){
      if (esEditar()) {
        vm.empresa = empresa;
        vm.nombre = vm.empresa.nombre;
        vm.idEmpresa = vm.empresa.empresa.id;
      }
    }

    function esEditar() {
      return $stateParams.modo=='editar';
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      if (esEditar()) {
        HeaderBarService.setSubTitulo($stateParams.subtituloEditar);
      } else {
        HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);
      }
    }

    function cancelar() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        $state.go('home.lista-empresa-logistica');
      });
    }

    function guardar() {
      if (esEditar()) {
        editarObjeto();
      } else {
        nuevoObjeto();
      }
    }

    function nuevoObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea registrar una nueva Empresa de logística?', function(){
        EmpresaLogisticaNombreEmpresa.query({nombre:vm.empresa.nombre, idEmpresa:vm.empresa.empresa.id},function(data){
          if (data.length>0) {
            ServicioDialogos.mostrarDialogoError(null, 'El nombre ingresado ya existe en la empresa indicada');
          } else {
            EmpresaLogistica.save(vm.empresa, function(data){
              ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha registrado la Empresa de logística correctamente', function(){
                $state.go('home.lista-empresa-logistica');
              });
            },function(error){
              console.error(error);
              ServicioDialogos.mostrarDialogoError(null, 'No se ha podido registrar la Empresa de logística');
            });
          }
        }, function(err){
          console.error(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar la Empresa de logística");
        });
      }, null, false);
    }

    function editarObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar la Empresa de logística?', function(){
        if (vm.nombre==vm.empresa.nombre && vm.empresa.empresa.id==vm.idEmpresa) {
          EmpresaLogistica.update(vm.empresa, function(data){
            ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado la Empresa de logística correctamente', function(){
              $state.go('home.lista-empresa-logistica');
            });
          }, function(err){
            console.error(err);
            ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar la Empresa de logística");
          });
        } else {
          EmpresaLogisticaNombreEmpresa.query({nombre:vm.empresa.nombre, idEmpresa:vm.empresa.empresa.id},function(data){
            if (data.length>0){
              ServicioDialogos.mostrarDialogoError(null, 'El nombre ingresado ya existe en la empresa indicada');
            } else {
              EmpresaLogistica.update(vm.empresa, function(data){
                ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado la Empresa de logística correctamente', function(){
                  $state.go('home.lista-empresa-logistica');
                });
              }, function(err){
                console.error(err);
                ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar la Empresa de logística");
              });
            }
          }, function(err){
            console.error(err);
            ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar la Empresa de logística");
          });
        }
      },null,false);
    }
     
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-persona-empresa-logistica', {
        url: 'lista-persona-empresa-logistica',
        templateUrl: 'app/app/main/egreso/persona-empresa-logistica/lista/lista-persona-empresa-logistica.html',
        controller: 'ListaPersonaEmpresaLogisticaCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Personal de Empresas de logística',
          subtitulo:'Lista de Personal de Empresas de logística'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          personas: function(PersonaEmpresaLogistica){
            return PersonaEmpresaLogistica.query().$promise.then(function(data) {
              return data;
            });

          },
          empresas: function(EmpresaLogistica){
            return EmpresaLogistica.query().$promise.then(function(data) {
              return data;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaPersonaEmpresaLogisticaCtrl', ListaPersonaEmpresaLogisticaCtrl);

  /** @ngInject */
  function ListaPersonaEmpresaLogisticaCtrl(NgTableParams, rol, HeaderBarService, PersonaEmpresaLogistica, empresas, PersonaEmpresaLogisticaEmpresa, $timeout, $stateParams, $scope, orderByFilter, $state, personas, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.personas = orderByFilter(personas,'nombre',false);
    vm.mostrarInformacion = mostrarInformacion;
    vm.crearNuevo = crearNuevo;
    vm.editar = editar;
    vm.exportToExcel = exportToExcel;
    vm.eliminar = eliminar;
    vm.empresas = orderByFilter(empresas,'nombre',false);
    vm.filtrar = filtrar;
    vm.busqueda = busqueda;
    vm.bandera=false;
    vm.bloquearPorRol = bloquearPorRol;

    function bloquearPorRol(){
      return (rol.id!=1 && rol.id!=2);
    }

    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });
    vm.tableParams.settings({
      data: vm.personas
    });
    vm.tableParams.reload();
    
    function busqueda(){
      if (vm.empresa && vm.empresa.id) vm.empresa = null;
      vm.bandera=false;

      if (vm.buscar) {
        vm.personas=null;
        actualizarTabla(vm.personas);
      } else {
        filtrar();
      }
    }

    function actualizarTabla(data){
      vm.personas = orderByFilter(data,'apellido',false);
      vm.tableParams.settings({
        data: vm.personas
      });
      vm.tableParams.reload();
    }

    function fitrarPorProveedor(){
      PersonaEmpresaLogisticaEmpresa.query({id:vm.empresa.id},function(data){
        ServicioDialogos.cerrarDialogoCargando();
        if (data.length==0) {
          vm.bandera=true;
        }
        actualizarTabla(data);
      }, function(err){
        console.error(err);
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function filtrar(){
      vm.bandera=true;
      ServicioDialogos.abrirDialogoCargando();
      if (vm.empresa && typeof vm.empresa !== "string") {
        fitrarPorProveedor();
      } else {
        if (vm.empresa==undefined){
          PersonaEmpresaLogistica.query(function(data){
            ServicioDialogos.cerrarDialogoCargando();
            actualizarTabla(data);
          }, function(err){
            console.error(err);
            ServicioDialogos.cerrarDialogoCargando();
          });
        } else {
          actualizarTabla(undefined);
        }
      }
    }

    function mostrarInformacion(persona) {
      var nombreCompleto = persona.apellido.toUpperCase()+", "+persona.nombre.toUpperCase();
      var telefono = persona.telefono? persona.telefono : '-';
      var dni = persona.dni? persona.dni : " - ";
      ServicioDialogos.mostrarDialogoInformacion("Información",
        'Empresa Logística: '+persona.empresaLogistica.nombre.toUpperCase() +
        "\n Persona: "+nombreCompleto+
        '\n Teléfono: ' + telefono+
        '\n N° DNI: '+ dni
      );
    }

    function editar(persona) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar la persona?', function() {
        $state.go('home.editar-persona-empresa-logistica', {objeto:persona.id, modo:'editar'});
      });
    }

    function crearNuevo() {
      $state.go('home.editar-persona-empresa-logistica');
    }

    function eliminar(persona){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Desea eliminar la persona?",function(){
        PersonaEmpresaLogistica.remove({id:persona.id}, function(data){
          ServicioDialogos.mostrarDialogoInformacion(null, "Se ha eliminado la persona con éxito");
          PersonaEmpresaLogistica.query().$promise.then(function(data){
            actualizarTabla(data);
          }, function(err){
            console.log(err);
          });
        }, function(error){
          console.log(error);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar la persona");
        });
      },null,false);
    }

    function exportToExcel(){
      var array = [];
      var telefono;
      var dni;
      var nombreCompleto;
      for (var i = vm.personas.length - 1; i >= 0; i--) {
      telefono = vm.personas[i].telefono? vm.personas[i].telefono : '-';
      dni = vm.personas[i].dni? vm.personas[i].dni : '-';
      nombreCompleto = vm.personas[i].apellido.toUpperCase()+", "+vm.personas[i].nombre.toUpperCase();
        array.push({
          "Proveedor" : vm.personas[i].empresaLogistica.nombre.toUpperCase(),
          "Persona" : nombreCompleto,
          "Teléfono" : telefono,
          "N° DNI" : dni
        });
      }
      var nombreDocumento = vm.empresa ? "personas-de-"+vm.empresa.nombre.toUpperCase() : "personas-de-empresas-de-log";
      alasql('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true}) FROM ?',[array]);
    }

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-persona-empresa-logistica', {
        url: 'editar-persona-empresa-logistica/:objeto/:modo',
        templateUrl: 'app/app/main/egreso/persona-empresa-logistica/editar/editar-persona-empresa-logistica.html',
        controller: 'EditarPersonaEmpresaLogisticaCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Personas de Empresas de logística',
          subtituloEditar:'Editar Persona de Empresas de logística',
          subtituloNuevo: 'Nueva Persona de Empresas de logística',
          modo:null,
          objeto:null
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          persona: function(PersonaEmpresaLogistica, $stateParams){
            if ($stateParams.objeto){
              return PersonaEmpresaLogistica.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return {};
            }
          },
          empresas: function(EmpresaLogistica){
            return EmpresaLogistica.query().$promise.then(function(data) {
              return data;
            });
          },
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarPersonaEmpresaLogisticaCtrl', EditarPersonaEmpresaLogisticaCtrl);

  /** @ngInject */
  function EditarPersonaEmpresaLogisticaCtrl(NgTableParams, $filter, rol, HeaderBarService, persona, empresas, PersonaEmpresaLogistica, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    inicializar();
    vm.cancelar = cancelar;
    vm.guardar = guardar;
    vm.empresas = $filter('orderBy')(empresas, ['empresa.nombre', 'nombre'], false);

    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");

    function inicializar(){
      setearTitulos();
      setearObjeto();
    }

    function setearObjeto(){
      if (esEditar()) {
        vm.persona = persona;
      }
    }

    function esEditar() {
      return $stateParams.modo=='editar';
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      if (esEditar()) {
        HeaderBarService.setSubTitulo($stateParams.subtituloEditar);
      } else {
        HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);
      }
    }

    function cancelar() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        $state.go('home.lista-persona-empresa-logistica');
      });
    }

    function guardar() {
      if (esEditar()) {
        editarObjeto();
      } else {
        nuevoObjeto();
      }
    }

    function nuevoObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea registrar una nueva persona?', function(){
        PersonaEmpresaLogistica.save(vm.persona, function(data){
          ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha registrado la persona correctamente', function(){
            $state.go('home.lista-persona-empresa-logistica');
          });
        },function(error){
          console.error(error);
          ServicioDialogos.mostrarDialogoError(null, 'No se ha podido registrar la persona');
        });
      }, null, false);
    }

    function editarObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar la persona?', function(){
        PersonaEmpresaLogistica.update(vm.persona, function(data){
          ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado la persona correctamente', function(){
            $state.go('home.lista-persona-empresa-logistica');
          });
        }, function(err){
          console.error(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar la persona");
        });
      },null,false);
    }
     
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-preparados', {
        url: 'lista-preparados',
        templateUrl: 'app/app/main/egreso/egreso/lista-preparados/lista-preparados.html',
        controller: 'ListaEgresoPreparadosCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar egresos',
          subtitulo:'Listado de egresos preparados'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          deposito: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return usuario.empleado.deposito;
              } else {
                return ;
              }
            });
          },
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data){
              return data;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaEgresoPreparadosCtrl', ListaEgresoPreparadosCtrl);

  /** @ngInject */
  function ListaEgresoPreparadosCtrl(NgTableParams, rol, deposito, HeaderBarService, $filter, focus, empresas, depositos, EgresoDepositoEmpresaEstadoUltimosCien , $stateParams, $scope, orderByFilter, $state, ServicioModales, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.egresos = [];
    vm.depositos = orderByFilter(depositos,'nombre',false);
    vm.deposito = deposito;
    vm.empresas = orderByFilter(empresas, 'nombre', false);
    vm.visualizarEgreso = visualizarEgreso;
    vm.comprobarSeleccionado = comprobarSeleccionado;
    vm.despacharSeleccionados = despacharSeleccionados;
    vm.buscarPorEmpresaDeposito = buscarPorEmpresaDeposito;
    vm.cambiarFiltros = cambiarFiltros;
    vm.verNumeroCajasEgreso = verNumeroCajasEgreso;
    vm.bandera=false;
    vm.marcarTodo = marcarTodo;

    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");

    function marcarTodo(){
      vm.egresos.forEach(function(item){
        item.seleccionado=vm.check;
      });
    }

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10,
    },{
      getData: function($defer,params){ return filtrarTabla($defer, params);}
    });
    vm.tableParams.reload();

    function verNumeroCajasEgreso(egreso){
      var numeros = [];
      var hash = {};
      egreso.detalles.forEach(function(item){
        numeros.push(item.numeroCaja);
      });
      numeros = numeros.filter(function(current) {
        var exists = !hash[current] || false;
        hash[current] = true;
        return exists;
      });
      ServicioDialogos.mostrarDialogoInformacion("N° de Cajas cerradas", "Este egreso tiene asignadas las cajas cerradas N°:\n"+numeros);
    }


    function filtrarTabla($defer, params) {
      var filtros = params.filter();
      var filtrosNuevos = {};

      for (var key in filtros) {
        if (filtros.hasOwnProperty(key) && filtros[key]!=='') {
          switch(key) {
            case 'empresa.nombre':
              angular.extend(filtrosNuevos, {
                empresa: {
                nombre: filtros[key]
                }
              });
              break;
            case 'sucursal.nombre':
              angular.extend(filtrosNuevos, {
                sucursal: {
                nombre: filtros[key]
                }
              });
              break;
            default:
              filtrosNuevos[key] = filtros[key];
          }
        }
      }
      var filtrados = filtros ? $filter('filter')(vm.egresos, filtrosNuevos) : vm.egresos;
      filtrados = params.sorting() ? $filter('orderBy')(filtrados, params.orderBy()) : filtrados;
      if (filtrados && filtrados.length){
        params.total(filtrados.length);
        return $defer.resolve(filtrados.slice((params.page() - 1) * params.count(), params.page() * params.count()));
      } else {
        params.total(0);
        return $defer.resolve(null);
      }
    }

    function despacharSeleccionados(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Está seguro que desea despachar los egresos seleccionados?", function(){
        armarEgresosSeleccionados();
      });
    }

    function armarEgresosSeleccionados(){
      var egresosSeleccionados = [];
      vm.egresos.forEach(function(egreso){
        if (egreso.seleccionado){
          egresosSeleccionados.push(egreso);
        }
      });
      abrirModalCargaPesoCantidadPaqueteEgresos(egresosSeleccionados);
    }

    function abrirModalCargaPesoCantidadPaqueteEgresos(data){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalCargaPesoCantidadPaqueteEgresos({
        onResult: function(resultado) {
          console.log(resultado);
        },
        egresos: data,
        deposito: vm.deposito,
        empresa: vm.empresa
      });
    }

    function comprobarSeleccionado(){
      var hay = false;
      vm.egresos.forEach(function(item){
        if (item.seleccionado){
          hay = true;
        }
      });
      return hay;
    }
    
    function actualizarTabla(data){
      vm.egresos = orderByFilter(data,'fecha',true);
      vm.tableParams.settings({
        data: vm.egresos
      });
      vm.tableParams.reload();
    }

    function visualizarEgreso(egreso){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalVisualizarEgreso({
        onResult: function(resultado) {
          console.log(resultado);
        },
        egreso: egreso,
        deposito: vm.deposito
      });
    }

    function cambiarFiltros(){
      vm.bandera=false;
    }

    function buscarPorEmpresaDeposito(){
      vm.bandera=true;
      ServicioDialogos.abrirDialogoCargando();
      EgresoDepositoEmpresaEstadoUltimosCien.query({'idTipo':1,'idDeposito':vm.deposito.id, 'idEmpresa':vm.empresa.id,'idEstado':2}, function(data){
        actualizarTabla(data);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });

    }

    $scope.$watch('vm.deposito.nombre', function(){
      if (!vm.deposito || !vm.deposito.nombre) return;
      focus('empresa');
    });

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-despachados', {
        url: 'lista-despachados',
        templateUrl: 'app/app/main/egreso/egreso/lista-despachados/lista-despachados.html',
        controller: 'ListaEgresoDespachadosCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar egresos',
          subtitulo:'Listado de egresos - Despachos',
          deposito:null
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          deposito: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return usuario.empleado.deposito;
              } else {
                return ;
              }
            });
          }
        }
      });
  }
})();

'use strict';
angular.module('proyecto-az-suministro')
  .factory('EgresoDespachoPorDeposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/egreso?deposito.id=:idDeposito&&cajas=:cajas", {idDeposito:"@idDeposito", cajas:"@cajas"});
  })
  .factory('EgresoDespachoPorDeposito2Estados', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/egreso?deposito.id=:idDeposito&&idEstado1=:idEstado1&&idEstado2=:idEstado2", {idDeposito:"@idDeposito", idEstado1:"@idEstado1", idEstado2:"@idEstado2"});
  })
  .factory('EgresoDespachoNumeroEgreso', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/egreso?deposito.id=:idDeposito&&numeroEgreso=:numeroEgreso", {idDeposito:"@idDeposito", numeroEgreso:"@numeroEgreso"});
  })
  .factory('EgresoDespachoEntreFechas', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/egreso?deposito.id=:idDeposito&&idEstado1=:idEstado1&&idEstado2=:idEstado2&&fechaDesde=:fechaDesde&&fechaHasta=:fechaHasta", {idDeposito:"@idDeposito", idEstado1:"@idEstado1", idEstado2:"@idEstado2", fechaDesde:"@fechaDesde", fechaHasta:"@fechaHasta"});
  });

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaEgresoDespachadosCtrl', ListaEgresoDespachadosCtrl);

  /** @ngInject */
  function ListaEgresoDespachadosCtrl(NgTableParams, rol, HeaderBarService, deposito, $filter, focus, depositos, EgresoDespachoPorDeposito2Estados , $stateParams, $scope, orderByFilter, $state, ServicioModales, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.egresos = [];
    vm.depositos = orderByFilter(depositos,'nombre',false);
    vm.visualizarEgreso = visualizarEgreso;
    vm.buscarPorDeposito = buscarPorDeposito;
    vm.cambiarFiltros = cambiarFiltros;
    vm.busqueda = busqueda;
    vm.bandera=false;
    vm.ban = false;
    vm.rol = rol;

    vm.abrirModalFiltros = abrirModalFiltros;

    function abrirModalFiltros(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalFiltrosEgreso({
        onResult: function(resultado){
          vm.ban=true;
          vm.filtrosUsados = resultado.filtros;
          actualizarTabla(resultado.egresos);
        },
        deposito: vm.deposito
      });
    }

    if (rol.id!=1 && rol.id!=2 && rol.id>3) $state.go("home.home");

    function busqueda(){
      vm.ban=false;
      vm.filtrosUsados=null;
      if (vm.buscar) {
        vm.egresos=null;
        actualizarTabla(vm.egresos);
      } else {
        filtrar();
      }
    }


    function filtrar(){
      if (!vm.buscar){
        buscarPorDeposito();
      } else {
        actualizarTabla(undefined);
      }
    }

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10,
    },{
      getData: function($defer,params){ return filtrarTabla($defer, params);}
    });
    vm.tableParams.reload();

    inicializar();


    function inicializar(){
      if (deposito && deposito.id){
        vm.deposito=deposito;
        buscarPorDeposito();
      }
    }

    function filtrarTabla($defer, params) {
      var filtros = params.filter();
      var filtrosNuevos = {};

      for (var key in filtros) {
        if (filtros.hasOwnProperty(key) && filtros[key]!=='') {
          switch(key) {
            case 'empresa.nombre':
              angular.extend(filtrosNuevos, {
                empresa: {
                nombre: filtros[key]
                }
              });
              break;
            case 'empresaLogistica.nombre':
              angular.extend(filtrosNuevos, {
                empresaLogistica: {
                nombre: filtros[key]
                }
              });
              break;
            default:
              filtrosNuevos[key] = filtros[key];
          }
        }
      }
      var filtrados = filtros ? $filter('filter')(vm.egresos, filtrosNuevos) : vm.egresos;
      filtrados = params.sorting() ? $filter('orderBy')(filtrados, params.orderBy()) : filtrados;
      if (filtrados && filtrados.length){
        params.total(filtrados.length);
        return $defer.resolve(filtrados.slice((params.page() - 1) * params.count(), params.page() * params.count()));
      } else {
        params.total(0);
        return $defer.resolve(null);
      }
    }

    function armarEgresosSeleccionados(){
      var egresosSeleccionados = [];
      vm.egresos.forEach(function(egreso){
        if (egreso.seleccionado){
          egresosSeleccionados.push(egreso);
        }
      });
      abrirModalCargaPesoCantidadPaqueteEgresos(egresosSeleccionados);
    }

    function abrirModalCargaPesoCantidadPaqueteEgresos(data){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalCargaPesoCantidadPaqueteEgresos({
        onResult: function(resultado) {
          console.log(resultado);
        },
        egresos: data,
        deposito: vm.deposito,
        empresa: vm.empresa
      });
    }

    
    function actualizarTabla(data){
      vm.egresos = orderByFilter(data,'fecha',true);
      vm.tableParams.settings({
        data: vm.egresos
      });
      vm.tableParams.reload();
    }

    function actualizarEgresos(egreso){
      vm.egresos.forEach(function(item){
        if (item.id === egreso.id){
          item.nroGuia = egreso.nroGuia;
        }
      });
    }

    function visualizarEgreso(egreso){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalVisualizarDespacho({
        onResult: function(resultado) {
          actualizarEgresos(resultado.egreso);
          actualizarTabla(vm.egresos);
        },
        egreso: egreso,
      });
    }

    function cambiarFiltros(){
      vm.bandera=false;
      vm.buscar = false;
    }

    function buscarPorDeposito(){
      vm.bandera=true;
      ServicioDialogos.abrirDialogoCargando();
      EgresoDespachoPorDeposito2Estados.query({'idDeposito':vm.deposito.id, 'idEstado1':1, 'idEstado2':2}, function(data){
        actualizarTabla(data);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });

    }

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-deposito', {
        url: 'lista-deposito',
        templateUrl: 'app/app/main/deposito/deposito/lista/lista-deposito.html',
        controller: 'ListaDepositoCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Depósitos',
          subtitulo:'Lista de Depósitos'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          deposito: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return usuario.empleado.deposito;
              } else {
                return ;
              }
            });
          },
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaDepositoCtrl', ListaDepositoCtrl);

  /** @ngInject */
  function ListaDepositoCtrl(NgTableParams, deposito, rol, DepositoSoloNaves, HeaderBarService, Deposito, $timeout, $stateParams, $scope, orderByFilter, $state, depositos, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.depositos = orderByFilter(depositos,'nombre',false);
    vm.deposito = deposito;
    vm.mostrarInformacion = mostrarInformacion;
    vm.crearNuevo = crearNuevo;
    vm.editar = editar;
    vm.exportToExcel = exportToExcel;
    vm.eliminar = eliminar;
    vm.bloquearPorRol = bloquearPorRol;

    function bloquearPorRol(){
      return (rol.id!=1);
    }

    if (rol.id!=1 && rol.id!=2) $state.go("home.home");

    function mostrarInformacion(deposito) {
      var ubicacion = deposito.ubicacion? deposito.ubicacion : '-';
      var direccion = deposito.direccion? deposito.direccion : '-';
      ServicioDialogos.mostrarDialogoInformacion(null,
        "El depósito se llama " + deposito.nombre.toUpperCase()+
        '\n Número de depósito: '+deposito.numeroDeposito +
        '\n Ubicación: '+ ubicacion +
        '\n Dirección: '+ direccion
      );
    }

    function editar(deposito) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el Depósito?', function() {
        $state.go('home.editar-deposito', {objeto:deposito.id, modo:'editar'});
      });
    }

    function crearNuevo() {
      $state.go('home.editar-deposito');
    }

    function eliminarDeposito(deposito){
      Deposito.remove({id:deposito.id}, function(data){
        ServicioDialogos.mostrarDialogoInformacion(null, "Se ha eliminado el Depósito con éxito");
        DepositoSoloNaves.query().$promise.then(function(depositos){
          vm.depositos = orderByFilter(depositos,'nombre',false);
          vm.tableParams.settings({
            data: vm.depositos
          });
          vm.tableParams.reload();
        }, function(err){
          console.log(err);
        });
      }, function(error){
        console.log(error);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar el Depósito");
      });
    }

    function eliminar(deposito){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Desea eliminar el Depósito: \n"+deposito.nombre.toUpperCase()+"?",function(){
        DepositoSoloNaves.get({id:deposito.id}, function(data){
          if (data.naves.length==0){
            eliminarDeposito(deposito);
          } else {
            ServicioDialogos.mostrarDialogoError(null, "El depósito no puede ser eliminado");
          }
        });
      },null,false);
    }

    function exportToExcel(){ // ex: '#my-table'
      var array = [];
      var direccion;
      var ubicacion;
      for (var i = vm.depositos.length - 1; i >= 0; i--) {
        ubicacion = vm.depositos[i].ubicacion? vm.depositos[i].ubicacion : '-';
        direccion = vm.depositos[i].direccion? vm.depositos[i].direccion : '-';
        array.push({
          "Nombre" : vm.depositos[i].nombre,
          "Número de depósito" : vm.depositos[i].numeroDeposito,
          "Ubicación" : ubicacion,
          "Dirección" : direccion
        });
      }
      alasql('SELECT * INTO XLSX("depositos.xlsx",{headers:true}) FROM ?',[array]);
    }

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });
    vm.tableParams.settings({
      data: vm.depositos
    });
    vm.tableParams.reload();
    
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-deposito', {
        url: 'editar-deposito/:objeto/:modo',
        templateUrl: 'app/app/main/deposito/deposito/editar/editar-deposito.html',
        controller: 'EditarDepositoCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Depósitos',
          subtituloEditar:'Editar Depósito',
          subtituloNuevo: 'Nuevo Depósito',
          modo:null,
          objeto:null
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          deposito: function(DepositoSoloNaves, $timeout, $stateParams){
            if ($stateParams.objeto){
              return DepositoSoloNaves.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return $timeout(function() {
                return {};
              }, 1000);
            }
          },
          naves: function(NaveDepositoSoloPasillos, $stateParams){
            return NaveDepositoSoloPasillos.query({id:$stateParams.objeto}).$promise.then(function(data){
              return data;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarDepositoCtrl', EditarDepositoCtrl);

  /** @ngInject */
  function EditarDepositoCtrl(NgTableParams, rol, naves, HeaderBarService, orderByFilter, deposito, DepositoNombreSoloNaves, Deposito, DepositoNumeroSoloNaves, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    inicializar();
    vm.cancelar = cancelar;
    vm.guardar = guardar;
    vm.esEditar = esEditar;
    vm.naves = naves;

    if (rol.id!=1 && rol.id!=2 && rol.id>2) $state.go("home.home");


    function inicializar(){
      setearTitulos();
      setearObjeto();
    }

    function setearObjeto(){
      if (esEditar()) {
        vm.deposito = deposito;
        vm.nombre = vm.deposito.nombre;
        vm.numero=vm.deposito.numeroDeposito;
        buscarNave();
      }
    }

    function buscarNave(){
      if (naves.length>0){
        naves.forEach(function(item){
          if (item.id==deposito.idNaveBusqueda){
            vm.naveBusqueda = item;
          }
        });
      }
    }

    function esEditar() {
      return $stateParams.modo=='editar';
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      if (esEditar()) {
        HeaderBarService.setSubTitulo($stateParams.subtituloEditar);
      } else {
        HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);
      }
    }

    function cancelar() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        $state.go('home.lista-deposito');
      });
    }

    function guardar() {
      if (esEditar()) {
        editarObjeto();
      } else {
        nuevoObjeto();
      }
    }


    function nuevoObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea registrar un nuevo Depósito?', function(){
        comprobarNombre();
      }, null, false);
    }

    function editarObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el Depósito?', function(){
        if (vm.nombre==vm.deposito.nombre){
          if (vm.numero==vm.deposito.numeroDeposito) {
            editarDeposito();
          } else {
            comprobarNumeroDeposito();
          }
        } else {
          comprobarNombre();
        }
      },null,false);
    }

    function comprobarNumeroDeposito(){
      if (vm.numero==vm.deposito.numeroDeposito) {
        guardarOEditar();
      } else {
        DepositoNumeroSoloNaves.query({numeroDeposito:vm.deposito.numeroDeposito}, function(data){
          if (data.length>0){
            ServicioDialogos.mostrarDialogoError(null, 'El número de depósito ingresado ya existe');
          } else {
            guardarOEditar();
          }
        }, function(err){
          console.log(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar el Depósito");
        });
      }
    }


    function comprobarNombre(){
      DepositoNombreSoloNaves.query({nombre:vm.deposito.nombre},function(data){
        if (data.length>0){
          ServicioDialogos.mostrarDialogoError(null, 'El nombre ingresado ya existe');
        } else {
          comprobarNumeroDeposito();
        }
      }, function(err){
        console.error(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar el Depósito");
      });
    }

    function guardarOEditar(){
      if (esEditar()){
        editarDeposito();
      } else {
        guardarDeposito();
      }
    }

    function editarDeposito(){
      if (vm.naveBusqueda && vm.naveBusqueda.id){
        vm.deposito.idNaveBusqueda = vm.naveBusqueda.id;
        vm.deposito.nombreNaveBusqueda = vm.naveBusqueda.nombre+" ("+vm.naveBusqueda.numeroNave+")";
      } else {
        vm.deposito.idNaveBusqueda = null;
        vm.deposito.nombreNaveBusqueda = null;
      }
      Deposito.update(vm.deposito, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado el Depósito correctamente', function(){
          $state.go('home.lista-deposito');
        });
      }, function(err){
        console.error(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar el Depósito");
      });
    }

    function guardarDeposito(){
      Deposito.save(vm.deposito, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha registrado el Depósito correctamente', function(){
          $state.go('home.lista-deposito');
        });
      }, function(error){
        console.error(error);
        ServicioDialogos.mostrarDialogoError(null, 'No se ha podido registrar el Depósito');
      });
    }
     
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-nave', {
        url: 'lista-nave',
        templateUrl: 'app/app/main/deposito/nave/lista/lista-nave.html',
        controller: 'ListaNaveCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Naves',
          subtitulo:'Lista de Naves'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          naves: function(Usuario, NaveDepositoSoloPasillos, NaveSoloPasillos){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return NaveDepositoSoloPasillos.query({id:usuario.empleado.deposito.id}).$promise.then(function(data){
                  return data;
                });
              } else {
                return NaveSoloPasillos.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaNaveCtrl', ListaNaveCtrl);

  /** @ngInject */
  function ListaNaveCtrl(NgTableParams,rol, HeaderBarService, Usuario, Nave, depositos, NaveSoloPasillos, NaveDepositoSoloPasillos, NaveNombreDeposito, $timeout, $stateParams, $scope, orderByFilter, $state, naves, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.naves = orderByFilter(naves,'nombre',false);
    vm.mostrarInformacion = mostrarInformacion;
    vm.crearNuevo = crearNuevo;
    vm.editar = editar;
    vm.exportToExcel = exportToExcel;
    vm.eliminar = eliminar;
    vm.depositos = orderByFilter(depositos,'nombre',false);
    vm.filtrar = filtrar;
    vm.busqueda = busqueda;
    vm.bandera=false;

    if (rol.id!=1 && rol.id!=2 && rol.id>2) $state.go("home.home");

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });
    vm.tableParams.settings({
      data: vm.naves
    });
    vm.tableParams.reload();
    
    function busqueda(){
      if (vm.deposito && vm.deposito.id) vm.deposito = null;
      vm.bandera=false;
      if (vm.buscar) {
        vm.naves=null;
        actualizarTabla(vm.naves);
      } else {
        filtrar();
      }
    }

    function actualizarTabla(data){
      vm.naves = orderByFilter(data,'nombre',false);
      vm.tableParams.settings({
        data: vm.naves
      });
      vm.tableParams.reload();
    }

    function filtrarPorEmpresa(){
      NaveDepositoSoloPasillos.query({id:vm.deposito.id},function(data){
        ServicioDialogos.cerrarDialogoCargando();
        if (data.length==0) {
          vm.bandera=true;
        }
        actualizarTabla(data);
      }, function(err){
        console.error(err);
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function filtrar(){
      vm.bandera=true;
      ServicioDialogos.abrirDialogoCargando();
      if (vm.deposito && typeof vm.deposito !== "string") {
        filtrarPorEmpresa();
      } else {
        if (vm.deposito==undefined){
          obtenerNaves();
        } else {
          actualizarTabla(undefined);
        }
      }
    }

    function obtenerNaves(){
      Usuario.obtenerUsuario().$promise.then(function(usuario){
        if (usuario.empleado && usuario.empleado.deposito){
          NaveDepositoSoloPasillos.query({id:usuario.empleado.deposito.id}).$promise.then(function(data){
            ServicioDialogos.cerrarDialogoCargando();
            actualizarTabla(data);
          }, function(err){
            console.error(err);
            ServicioDialogos.cerrarDialogoCargando();
          });
        } else {
          NaveSoloPasillos.query().$promise.then(function(data){
            ServicioDialogos.cerrarDialogoCargando();
            actualizarTabla(data);
          }, function(err){
            console.error(err);
            ServicioDialogos.cerrarDialogoCargando();
          });
        }
      });
    }

    function mostrarInformacion(nave) {
      ServicioDialogos.mostrarDialogoInformacion("Información",
        nave.nombre.toUpperCase() +
        '\n Depósito: '+nave.deposito.nombre +
        '\n Código de nave: '+ nave.numeroNave);
    }

    function editar(nave) {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar la Nave?', function() {
        $state.go('home.editar-nave', {objeto:nave.id, modo:'editar'});
      });
    }

    function crearNuevo() {
      $state.go('home.editar-nave');
    }

    function eliminarNave(nave){
      Nave.remove({id:nave.id}, function(data){
        ServicioDialogos.mostrarDialogoInformacion(null, "Se ha eliminado la Nave con éxito");
        obtenerNaves();
      }, function(error){
        console.log(error);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido eliminar la nave");
      });
    }


    function eliminar(nave){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Desea eliminar: \n"+nave.nombre.toUpperCase()+"?",function(){
        NaveSoloPasillos.get({id:nave.id}, function(data){
          if (data.pasillos.length==0){
            eliminarNave(nave);
          } else {
            ServicioDialogos.mostrarDialogoError(null, "La nave no puede ser eliminada");
          }
        });
      },null,false);
    }

    function exportToExcel(){
      var array = [];
      for (var i = vm.naves.length - 1; i >= 0; i--) {
        array.push({
          "Depósito" : vm.naves[i].deposito.nombre,
          "Nave" : vm.naves[i].nombre,
          "Código de nave" : vm.naves[i].numeroNave
        });
      }
      var nombreDocumento = vm.deposito ? "naves-"+vm.deposito.nombre.toUpperCase() : "naves";
      alasql('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true}) FROM ?',[array]);
    }

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-nave', {
        url: 'editar-nave/:objeto/:modo',
        templateUrl: 'app/app/main/deposito/nave/editar/editar-nave.html',
        controller: 'EditarNaveCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Nave',
          subtituloEditar:'Editar Nave',
          subtituloNuevo: 'Nueva Nave',
          modo:null,
          objeto:null
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          nave: function(NaveSoloPasillos, $stateParams){
            if ($stateParams.objeto){
              return NaveSoloPasillos.get({id:$stateParams.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return {};
            }
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarNaveCtrl', EditarNaveCtrl);

  /** @ngInject */
  function EditarNaveCtrl(NgTableParams, rol, HeaderBarService, orderByFilter, nave, depositos, NaveNumeroDepositoSoloPasillos, NaveNombreDepositoSoloPasillos, Nave, NaveSoloPasillos, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    inicializar();
    vm.cancelar = cancelar;
    vm.guardar = guardar;
    vm.depositos = orderByFilter(depositos,'nombre',false);

    if (rol.id!=1 && rol.id!=2 && rol.id>2) $state.go("home.home");


    function inicializar(){
      setearTitulos();
      setearObjeto();
    }

    function setearObjeto(){
      if (esEditar()) {
        vm.nave = nave;
        vm.nombre = vm.nave.nombre;
        vm.deposito=vm.nave.deposito;
        vm.codigo=vm.nave.numeroNave;
      }
    }

    function esEditar() {
      return $stateParams.modo=='editar';
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      if (esEditar()) {
        HeaderBarService.setSubTitulo($stateParams.subtituloEditar);
      } else {
        HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);
      }
    }

    function cancelar() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        $state.go('home.lista-nave');
      });
    }

    function guardar() {
      if (esEditar()) {
        editarObjeto();
      } else {
        nuevoObjeto();
      }
    }


    function nuevoObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea registrar una nueva Nave?', function(){
        comprobarNombreNave();
      }, null, false);
    }

    function editarObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar la Nave?', function(){
        if (vm.nombre==vm.nave.nombre && vm.deposito.nombre==vm.nave.deposito.nombre){
          if (vm.codigo==vm.nave.numeroNave) {
            editarNave();
          } else {
            comprobarCodigoNave();
          }
        } else {
          comprobarNombreNave();
        }
      },null,false);
    }

    function comprobarCodigoNave(){
      if (vm.codigo==vm.nave.numeroNave) {
        guardarOEditar();
      } else {
        NaveNumeroDepositoSoloPasillos.query({numeroNave:vm.nave.numeroNave,id:vm.nave.deposito.id}, function(data){
          if (data.length>0){
            ServicioDialogos.mostrarDialogoError(null, 'El número de nave ya existe en el depósito indicado');
          } else {
            guardarOEditar();
          }
        }, function(err){
          console.log(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar la Nave");
        });
      }
    }


    function comprobarNombreNave(){
      NaveNombreDepositoSoloPasillos.query({nombre:vm.nave.nombre, id:vm.nave.deposito.id},function(data){
        if (data.length>0){
          ServicioDialogos.mostrarDialogoError(null, 'El nombre ingresado ya existe en el Depósito seleccionado');
        } else {
          comprobarCodigoNave();
        }
      }, function(err){
        console.error(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar la Nave");
      });
    }

    function guardarOEditar(){
      if (esEditar()){
        editarNave();
      } else {
        guardarNave();
      }
    }

    function editarNave(){
      NaveSoloPasillos.update(vm.nave, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado la Nave correctamente', function(){
          $state.go('home.lista-nave');
        });
      }, function(err){
        console.error(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar la Nave");
      });
    }

    function guardarNave(){
      Nave.save(vm.nave, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha registrado la Nave correctamente', function(){
          $state.go('home.lista-nave');
        });
      }, function(error){
        console.error(error);
        ServicioDialogos.mostrarDialogoError(null, 'No se ha podido registrar la Nave');
      });
    }
     
  }
})();

'use strict';
angular.module('proyecto-az-suministro')
  .factory('Usuarios', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/login/usuarios/:id",{id:'@id'});
  })  
  .factory('UsuarioActual', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/login/actual/:id", {id:"@id"});
  })
  .factory('UsuarioNombre', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/login/usuarios?nombreUsuario=:nombreUsuario", {nombreUsuario:"@nombreUsuario"});
  })
  .factory('Roles', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/rol/:id", {id:"@id"});
  })
  .factory('RenovarPassword', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/login/usuarios/password/:id", {id:"@id"});
  })
  .factory('RenovarPasswordUsuario', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/login/usuarios/renovar");
  })
  .factory('SolicitanteUsuario', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/login/usuarios/solicitante/:id", {id:"@id"});
  });

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.renovar-password', {
        url: 'renovar-password',
        templateUrl: 'app/app/main/usuarios/renovar-password/renovar-password.html',
        controller: 'RenovarPasswordCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Usuario',
          subtitulo:'Renovar Password'
        },
        resolve:{
          usuario: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario;
            });
          },
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('RenovarPasswordCtrl', RenovarPasswordCtrl);

  /** @ngInject */
  function RenovarPasswordCtrl(NgTableParams, HeaderBarService, Util, bcrypt, RenovarPassword, usuario, AlmacenUsuariosJWT, $stateParams, $state, $timeout, $scope, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.cancelar = cancelar;
    vm.guardar = guardar;
    vm.validarPassword = validarPassword;

    function validarPassword(){
      if (vm.renovar && vm.renovar.nuevaPassword){
        return Util.validarPassword(vm.renovar.nuevaPassword, {});
      }
      return {validation:false, mensaje: "La contraseña debe cumplir los siguientes requisitos:\nLongitud mínima de 8 y máxima de 25 caracteres\nPoseer al menos una minúscula, una mayúscula, un número y un caracter especial\n"};
    }

    function cancelar() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        $state.go('home.home');
      });
    }

    function guardar() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea renovar el password?", function(){
        renovarPass();
      },null,false);
    }

    function renovarPass(){
      bcrypt.genSalt(10, function(err, salt) {
        bcrypt.hash(vm.renovar.nuevaPassword, salt, function(err, hash) {
          var usuario = {
            nuevaPassword : hash,
            passwordActual:vm.renovar.passwordActual
          };
          RenovarPassword.update(usuario, function(data){
            if (data.codigo===1){
              ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha renovado el password correctamente!', function(){
                AlmacenUsuariosJWT.limpiar();
                $state.go('login');
              });
            } else {
              ServicioDialogos.mostrarDialogoError(null, 'El password actual ingresado es incorrecto');
            }
          }, function(error){
            console.error(error);
            ServicioDialogos.mostrarDialogoError(null, 'No se ha podido renovar el password');
          });
        });
      });
    }
     
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-deposito-ubicaciones', {
        url: 'lista-deposito-ubicaciones',
        templateUrl: 'app/app/main/ubicaciones/deposito/lista-deposito-ubicaciones.html',
        controller: 'UbicacionesDepositoCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar Ubicaciones',
          subtitulo:'Lista de Depósitos'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('UbicacionesDepositoCtrl', UbicacionesDepositoCtrl);

  /** @ngInject */
  function UbicacionesDepositoCtrl(NgTableParams, rol, HeaderBarService, Util, $timeout, $stateParams, $scope, orderByFilter, $state, depositos, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.util = Util;
    vm.depositos = orderByFilter(depositos,'nombre',false);
    vm.verNaves = verNaves;

    if (rol.id!=1 && rol.id!=2 && rol.id!=3) $state.go("home.home");


    function verNaves(deposito) {
      $state.go('home.lista-nave-ubicaciones', {deposito:deposito.id});
    }

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });
    vm.tableParams.settings({
      data: vm.depositos
    });
    vm.tableParams.reload();
    
  }
})();

'use strict';
angular.module('proyecto-az-suministro')
  .factory('TipoSuministro', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/tiposuministro/:id",{id:'@id'});
  })
  .factory('TipoSuministroEmpresaSolicitanteInventariable', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/tiposuministro?empresa.id=:id&&inventariable=:inv",{id:'@id', inv:'@inv'});
  })
  .factory('TipoSuministroNombreFamilia', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/tiposuministro?nombre=:nombre&&familia.id=:id", {nombre:"@nombre"});
  })
  .factory('TipoSuministroFamilia', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/tiposuministro?familia.id=:id", {id:"@id"});
  })
  .factory('TipoSuministroCodigo', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/tiposuministro?codigo=:codigo", {codigo:"@codigo"});
  })
  .factory('TipoSuministroCodigoFamilia', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/tiposuministro?codigo=:codigo&&familia.id=:idFamilia", {codigo:"@codigo", idFamilia:"@idFamilia"});
  })
  .factory('TipoSuministroPrecio', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministro/precio/:idTipo", {idTipo:"@idTipo"});
  });

'use strict';
angular.module('proyecto-az-suministro')
  .factory('Suministro', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministroinventariable/:id",{id:'@id'});
  })
  .factory('SuministroTipo', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministro?tipo.id=:id",{id:'@id'});
  })
  .factory('SuministroTipoDeposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministro?tipo.id=:idTipo&&deposito.id=:idDeposito",{idTipo:'@idTipo', idDeposito:'@idDeposito'});
  })
  .factory('SuministroInventarioEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministroinventariable?empresa.id=:idEmpresa&&inventario=:inventario",{idEmpresa:'@idEmpresa', inventario:'@inventario'});
  })
  .factory('SuministroUbicacion', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministro/ubicacion/:idSuministro/:idUbicacion/:ocupar",{idSuministro:"@idSuministro", idUbicacion:"@idUbicacion", ocupar:"@ocupar"});
  })
  .factory('TipoSuministroFamiliaInventariable', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/tiposuministro?familia.id=:idFamilia&&inventariable=:inventariable",{idFamilia:"@idFamilia", inventariable:"@inventariable"});
  })
  .factory('SuministroEmpresaInventario', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministroinventariable?empresa.id=:idEmpresa&&inventario=:inventario&&inventariable=:inventariable",{idEmpresa:"@idEmpresa", inventario:"@inventario", inventariable:"@inventariable"});
  })
  .factory('SuministroInventariableTipoDeposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministroinventariable?tipo.id=:idTipo&&deposito.id=:idDeposito",{idTipo:'@idTipo', idDeposito:'@idDeposito'});
  })
  .factory('SuministroEmpresaDepositoInventario', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministroinventariable?empresa.id=:idEmpresa&&deposito.id=:idDeposito&&inventario=:inventario",{idEmpresa:"@idEmpresa", idDeposito:'@idDeposito', inventario:"@inventario"});
  })
  .factory('SuministroTipoSerie', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministroinventariable?tipo.id=:idTipo&&serie=:serie",{idTipo:"@idTipo", serie:"@serie"});
  })
  .factory('SuministroFamiliaSerie', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministroinventariable?familia.id=:idFamilia&&serie=:serie",{idFamilia:"@idFamilia", serie:"@serie"});
  })
  .factory('SuministroNoInventariable', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministro/:id",{id:'@id'});
  })
  .factory('MovimientosPorSuministroInventariable', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/detallemovimiento?suministroinventariable.id=:idSuministroInventariable",{idSuministroInventariable:'@idSuministroInventariable'});
  })
  .factory('InventariableSuministroId', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministroinventariable?suministro.id=:idSuministro",{idSuministro:'@idSuministro'});
  })
  .factory('ReemplazarUbicacionSuministro', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministro/reemplazarUbicacion/:idSuministro/:idUbicacion/:ocupar",{idSuministro:'@idSuministro', idUbicacion:'@idUbicacion',ocupar:'@ocupar'});
  });
'use strict';
angular.module('proyecto-az-suministro')
  .factory('Historial', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/historial/:id",{id:'@id'});
  })
  .factory('HistorialSuministro', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/historial?suministroinventariable.id=:id",{id:'@id'});
  })
  .factory('HistorialDetalleSuministroInventariable', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/detallehistorial/detalles?suministroinventariable.id=:id",{id:'@id'});
  })
  .factory('HistorialSuministroSerie', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/historial?serie=:serie",{serie:'@serie'});
  })
  .factory('HistorialSuministroInventario', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/historial?inventario=:inventario",{inventario:'@inventario'});
  })
  .factory('HistorialesDeposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/historial?deposito.id=:id",{id:'@id'});
  });
'use strict';
angular.module('proyecto-az-suministro')
  .factory('GrupoSuministro', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/gruposuministro/:id",{id:'@id'});
  })
  .factory('GrupoSuministroNombreEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/gruposuministro?nombre=:nombre&&empresa.id=:idEmpresa", {nombre:"@nombre", idEmpresa:"@idEmpresa"});
  })
  .factory('GrupoEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/gruposuministro?empresa.id=:id", {id:"@id"});
  });

'use strict';
angular.module('proyecto-az-suministro')
  .factory('FamiliaSuministro', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/familiasuministro/:id",{id:'@id'});
  })
  .factory('FamiliaSuministroNombreGrupo', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/familiasuministro?nombre=:nombre&&grupo.id=:id", {nombre:"@nombre"});
  })
  .factory('FamiliaSuministroGrupo', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/familiasuministro?grupo.id=:id", {id:"@id"});
  })
  .factory('FamiliaSuministroCodigoGrupo', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/familiasuministro?codigo=:codigo&&grupo.id=:idGrupo", {codigo:"@codigo", idGrupo:"@idGrupo"});
  });

'use strict';
angular.module('proyecto-az-suministro')
  .factory('CategoriasPeso', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/categoriapeso/:id",{id:'@id'});
  })
  .factory('CategoriasPesoNombre', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/categoriapeso?nombre=:nombre", {nombre:"@nombre"});
  });

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.reporte-tope-sucursal', {
        url: 'reporte-tope-sucursal',
        templateUrl: 'app/app/main/reportes/reporte-tope-sucursal/reporte-tope-sucursal.html',
        controller: 'ReporteTopeSucursalCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Reportes',
          subtitulo:'Reporte de consumos y topes de una sucursal'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          empresas: function(Usuario, Empresa, $filter){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.empresa && usuario.empleado.empresa.id){
                var empresas = [];
                return Empresa.get({id:usuario.empleado.empresa.id}).$promise.then(function(empresa){
                  empresas.push(empresa);
                  return empresas;
                });
              } else {
                return Empresa.query().$promise.then(function(data) {
                  if (usuario.empleado && usuario.rol && usuario.rol.nombre=='CONSULTA' && usuario.empleado.empresas && usuario.empleado.empresas.length>0) {
                    var empresas = [];
                    data.forEach(function(empresa){
                      if (usuario.empleado.empresas.includes(empresa.id)){
                        empresas.push(empresa);
                      }
                    });
                    return $filter('orderBy')(empresas, 'nombre', false);
                  }
                  return data;
                });
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ReporteTopeSucursalCtrl', ReporteTopeSucursalCtrl);

  /** @ngInject */
  function ReporteTopeSucursalCtrl(NgTableParams, Util, $filter, focus, rol, TopesSucursalFamilia, TopesSucursalGrupo, HeaderBarService, URL_SERVIDOR, $http, empresas, $stateParams, SucursalEmpresa, $scope, orderByFilter, $state, GrupoEmpresa, TiposPorEmpresa, TipoSuministroFamilia, FamiliaSuministroGrupo, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.empresas = orderByFilter(empresas,'nombre',false);

    vm.mostrarReporte = mostrarReporte;
    vm.mostrarReporteExcel = mostrarReporteExcel;

    vm.validarFiltros = validarFiltros;
    vm.volver = volver;
    vm.radio = 'jerarquizada';

    if (rol.id!=1 && rol.id!=2 && rol.id!=3 && rol.id!=29) $state.go("home.home");

    function volver(){
      $state.go("home.lista-reportes");
    }

    function mostrarReporteExcel(){
      if (vm.familiaSuministro && vm.familiaSuministro.id){
        armarReporteTopesFamiliaExcel();
      } else {
        armarReporteTopesGrupoExcel();
      }
    }

    function armarReporteTopesGrupoExcel(){
      ServicioDialogos.abrirDialogoCargando();
      TopesSucursalGrupo.query({idSucursal:vm.sucursal.id, idGrupo: vm.grupo.id}, function(data) {
        armarExcelTopeGrupo(data);
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function armarReporteTopesFamiliaExcel(){
      ServicioDialogos.abrirDialogoCargando();
      TopesSucursalFamilia.query({idSucursal:vm.sucursal.id, idFamilia: vm.familiaSuministro.id}, function(data) {
        armarExcelTopeFamilia(data);
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function armarExcelTopeFamilia(data){
      data = $filter('orderBy')(data, ['tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre', 'tipoSuministro.familiaSuministro.grupoSuministro.nombre', 'tipoSuministro.familiaSuministro.nombre', 'tipoSuministro.nombre'], true);
      var array = [];
      var tope;
      var periodicidad;
      for (var j = data.length - 1; j >= 0; j--){
        tope = data[j].cantidadTope ? data[j].cantidadTope : "No definido";
        periodicidad = data[j].periodicidad ? data[j].periodicidad : "No definido";
        array.push({
          "Empresa" : data[j].tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase(),
          "Sucursal" : data[j].sucursal.nombre.toUpperCase(),
          "Código sucursal" : data[j].sucursal.codigoSucursal.toUpperCase(),
          "Grupo suministro" : data[j].tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
          "Familia suministro" : data[j].tipoSuministro.familiaSuministro.nombre.toUpperCase(),
          "Código familia" : data[j].tipoSuministro.familiaSuministro.codigoFamiliaSuministro.toUpperCase(),
          "Tipo suministro" : data[j].tipoSuministro.nombre.toUpperCase(),
          "Código producto" : data[j].tipoSuministro.codigoProducto.toUpperCase(),
          "Año vigente" : data[j].cantidadAnual,
          "Mes vigente" : data[j].cantidadMes,
          "Últimos 30 días" : data[j].cantidadUltimos30Dias,
          "Últimos 60 días" : data[j].cantidadUltimos60Dias,
          "Últimos 90 días" : data[j].cantidadUltimos90Dias,
          "Tope definido" : tope,
          "Periodicidad del tope" : periodicidad,
          "Consumo en el período del tope": data[j].consumoTope
        });
      }
      var nombreDocumento = vm.familiaSuministro ? "topes-"+Util.quitarCaracteresEspeciales(vm.sucursal.nombre.toUpperCase())+"-"+Util.quitarCaracteresEspeciales(vm.familiaSuministro.nombre.toUpperCase()) : "topes-"+Util.quitarCaracteresEspeciales(vm.sucursal.nombre.toUpperCase())+"-"+Util.quitarCaracteresEspeciales(vm.grupo.nombre.toUpperCase());
      alasql.promise('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true,sheetid:"Topes"}) FROM ?',[array])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function armarExcelTopeGrupo(data){
      data = $filter('orderBy')(data, ['tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre', 'tipoSuministro.familiaSuministro.grupoSuministro.nombre', 'tipoSuministro.familiaSuministro.nombre', 'tipoSuministro.nombre'], true);
      var array = [];
      var tope;
      var periodicidad;
      for (var j = data.length - 1; j >= 0; j--){
        tope = data[j].cantidadTope ? data[j].cantidadTope : "No definido";
        periodicidad = data[j].periodicidad ? data[j].periodicidad : "No definido";
        array.push({
          "Empresa" : data[j].tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase(),
          "Sucursal" : data[j].sucursal.nombre.toUpperCase(),
          "Código sucursal" : data[j].sucursal.codigoSucursal.toUpperCase(),
          "Grupo suministro" : data[j].tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
          "Familia suministro" : data[j].tipoSuministro.familiaSuministro.nombre.toUpperCase(),
          "Código familia" : data[j].tipoSuministro.familiaSuministro.codigoFamiliaSuministro.toUpperCase(),
          "Tipo suministro" : data[j].tipoSuministro.nombre.toUpperCase(),
          "Código producto" : data[j].tipoSuministro.codigoProducto.toUpperCase(),
          "Año vigente" : data[j].cantidadAnual,
          "Mes vigente" : data[j].cantidadMes,
          "Últimos 30 días" : data[j].cantidadUltimos30Dias,
          "Últimos 60 días" : data[j].cantidadUltimos60Dias,
          "Últimos 90 días" : data[j].cantidadUltimos90Dias,
          "Tope definido" : tope,
          "Periodicidad del tope" : periodicidad,
          "Consumo en el período del tope": data[j].consumoTope
        });
      }
      var nombreDocumento = vm.familiaSuministro ? "topes-"+Util.quitarCaracteresEspeciales(vm.sucursal.nombre.toUpperCase())+"-"+Util.quitarCaracteresEspeciales(vm.familiaSuministro.nombre.toUpperCase()) : "topes-"+Util.quitarCaracteresEspeciales(vm.sucursal.nombre.toUpperCase())+"-"+Util.quitarCaracteresEspeciales(vm.grupo.nombre.toUpperCase());
      alasql.promise('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true,sheetid:"Topes"}) FROM ?',[array])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function obtenerUrl(){
      if (vm.familiaSuministro && vm.familiaSuministro.id){
        return URL_SERVIDOR+"/reportes/topesSucursalFamilia/"+vm.sucursal.id+"/"+vm.familiaSuministro.id;
      } else {
        return URL_SERVIDOR+"/reportes/topesSucursalGrupo/"+vm.sucursal.id+"/"+vm.grupo.id;
      }
    }

    function mostrarReporte(){
      ServicioDialogos.abrirDialogoCargando();
      var Url = obtenerUrl();
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function validarFiltros(){
      return (vm.empresa && vm.empresa.id) && (vm.sucursal && vm.sucursal.id) && (vm.familiaSuministro && vm.familiaSuministro.id || vm.grupo && vm.grupo.id);
    }

    function cambioRadio(){
      if (vm.radio=='jerarquizada'){
        vm.tipoSuministroCompleto=null;
      } else {
        if (vm.tipoSuministro && vm.tipoSuministro.id) vm.tipoSuministro=null;
        if (vm.familiaSuministro && vm.familiaSuministro.id) vm.familiaSuministro=null;
        if (vm.grupo && vm.grupo.id) vm.grupo=null;
      }
    }

    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.dismiss();
    }

    $scope.$watch('vm.grupo.nombre', function(){
      if (vm.familiaSuministro) vm.familiaSuministro=null;
      if (!vm.grupo) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupo.id}, function(data){
        vm.familias = orderByFilter(data,'nombre',false);
        focus('familia');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.empresa.id', function(){
      if (vm.grupo) vm.grupo=null;
      if (vm.tipoSuministroCompleto) vm.tipoSuministroCompleto=null;
      if (!vm.empresa) return;
      ServicioDialogos.abrirDialogoCargando();
      GrupoEmpresa.query({id:vm.empresa.id}, function(data){
        SucursalEmpresa.query({id:vm.empresa.id}, function(sucs){
          vm.sucursales = orderByFilter(sucs, "nombre", false);
          vm.grupos = orderByFilter(data,'nombre',false);
          focus('sucursal');
          ServicioDialogos.cerrarDialogoCargando();
        }, function(err){
          console.log(err);
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError();
        });
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.tipoSuministroCompleto.nombre', function(){
      vm.tipoSuministro=vm.tipoSuministroCompleto;
      //if (!vm.tipoSuministroCompleto || vm.tipoSuministroCompleto.inventariable===false) return;
    });

    $scope.$watch('vm.familiaSuministro.nombre', function(){
      if (vm.tipoSuministro) vm.tipoSuministro=null;
      if (!vm.familiaSuministro) return;
      ServicioDialogos.abrirDialogoCargando();
      TipoSuministroFamilia.query({id:vm.familiaSuministro.id}, function(data){
        vm.tipos = orderByFilter(data,'nombre',false);
        focus('tipo');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.radio', function(){
      if (vm.radio=='directa') {
        ServicioDialogos.abrirDialogoCargando();
        TiposPorEmpresa.query({idEmpresa:vm.empresa.id}, function(data){
          vm.tiposCompletos = orderByFilter(data,'nombre',false);
          ServicioDialogos.cerrarDialogoCargando();
        }, function(err){
          console.log(err);
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError();
        });

      }
    });
    
    
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.reporte-tiempos-preparacion', {
        url: 'reporte-tiempos-preparacion',
        templateUrl: 'app/app/main/reportes/reporte-tiempos-preparacion/reporte-tiempos-preparacion.html',
        controller: 'ReporteTiempoPreparacionCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Reportes',
          subtitulo:'Reporte tiempos de preparaciones de salidas entre fechas'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          deposito: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return usuario.empleado.deposito;
              } else {
                return ;
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ReporteTiempoPreparacionCtrl', ReporteTiempoPreparacionCtrl);

  /** @ngInject */
  function ReporteTiempoPreparacionCtrl(NgTableParams, Util, $filter, ListaMovimientosEntreFechaEstadoPreparacion, focus, rol, HeaderBarService, URL_SERVIDOR, $http, depositos, deposito, $stateParams, StockTipoSuministroDeposito, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.depositos = orderByFilter(depositos, "nombre", false);
    vm.deposito = deposito;
    vm.fechaActual = new Date();

    vm.mostrarReporte = mostrarReporte;
    vm.mostrarReporteExcel = mostrarReporteExcel;
    vm.validarFiltros = validarFiltros;
    vm.volver = volver;
    vm.comprobarPeriodoFechas = comprobarPeriodoFechas;

    function comprobarPeriodoFechas(){
      return  (((vm.fechaHasta - vm.fechaDesde)/86400000)<=550);
    }

    if (rol.id!=1 && rol.id!=2 && rol.id!=3 && rol.id!=29) $state.go("home.home");

    function volver(){
      $state.go("home.lista-reportes");
    }

    function obtenerUrl(){
      return URL_SERVIDOR+"/reportes/tiempoPraparacion?idDeposito="+vm.deposito.id+"&&fechaDesde="+vm.fechaDesde+"&&fechaHasta="+vm.fechaHasta;
    }

    function mostrarReporteExcel(){
      ServicioDialogos.abrirDialogoCargando();
      ListaMovimientosEntreFechaEstadoPreparacion.query({idDeposito:vm.deposito.id, fechaDesde:vm.fechaDesde, fechaHasta:vm.fechaHasta}, function(data){
        armarReporteExcel(data);
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function obtenerTiempo(fecha1, fecha2){
		if (!fecha1 || !fecha2) return "-";
		var suma = fecha2-fecha1;
		var horas = (suma/(1000*3600));
		var minutos = (suma/(1000*60))%60;
		var segundos = (suma/(1000))%60;
		return Math.abs(Math.trunc(horas))+" h "+Math.abs(Math.trunc(minutos))+" m "+Math.abs(Math.trunc(segundos))+" s";
    }

    function obtenerTotalTiempo(suma, cont){
		if (!suma || !cont) return "-";
		var total = suma/cont;
		var horas = (total/(1000*3600));
		var minutos = (total/(1000*60))%60;
		var segundos = (total/(1000))%60;
		return Math.abs(Math.trunc(horas))+" h "+Math.abs(Math.trunc(minutos))+" m "+Math.abs(Math.trunc(segundos))+" s";
    }

    function obtenerPrimeroConTotal(totales, lista){
      var cont = 0;
      var sumaPreparado = 0;
      var sumaComienzoPreparacion = 0;
      var sumaPreparacion = 0;
      var horasComienzoPreparacion;
      var horasPreparacion;
      var horasPreparado;
      var fecha;
      var fechaEnPreparacion;
      var fechaPreparado;
      for (var i = lista.length - 1; i >= 0; i--) {
		if (lista[i].fechaEnPreparacion && lista[i].fechaPreparado) {
			cont ++;
			sumaPreparacion += lista[i].fechaPreparado-lista[i].fechaEnPreparacion;
			sumaPreparado += lista[i].fechaPreparado-lista[i].fecha;
			sumaComienzoPreparacion += lista[i].fechaEnPreparacion-lista[i].fecha;
		}
      }

      horasComienzoPreparacion = obtenerTotalTiempo(sumaComienzoPreparacion, cont);
      horasPreparacion = obtenerTotalTiempo(sumaPreparacion, cont);
      horasPreparado = obtenerTotalTiempo(sumaPreparado, cont);
      fecha = $filter('date')(lista[lista.length - 1].fecha, "dd-MM-yyyy HH:mm:ss");
      fechaEnPreparacion = $filter('date')(lista[lista.length - 1].fechaEnPreparacion, "dd-MM-yyyy HH:mm:ss");
      fechaPreparado = $filter('date')(lista[lista.length - 1].fechaPreparado, "dd-MM-yyyy HH:mm:ss");
      totales.push({
        "N° Movimiento":lista[lista.length - 1].numeroMovimiento,
        "Empresa" : lista[lista.length - 1].empresa.nombre.toUpperCase(),
        "Sucursal" : lista[lista.length - 1].sucursal.nombre.toUpperCase(),
        "Código sucursal" : lista[lista.length - 1].sucursal.codigoSucursal.toUpperCase(),
        "Fecha generado":fecha,
        "Fecha comienzo de preparación":fechaEnPreparacion ? fechaEnPreparacion : "-",
        "Fecha preparado":fechaPreparado ? fechaPreparado : "-",
        "Tiempo comienzo preparación" : obtenerTiempo(lista[lista.length - 1].fecha, lista[lista.length - 1].fechaEnPreparacion),
        "Tiempo en preparación" : obtenerTiempo(lista[lista.length - 1].fechaEnPreparacion, lista[lista.length - 1].fechaPreparado),
        "Tiempo preparado" : obtenerTiempo(lista[lista.length - 1].fecha, lista[lista.length - 1].fechaPreparado),
        "":"",
        "Tiempo promedio comienzo preparación":horasComienzoPreparacion,
        "Tiempo promedio preparación":horasPreparacion,
        "Tiempo promedio preparado":horasPreparado
      });
      return totales;
    }

  function armarReporteExcel(lista){
    if (lista && lista.length<=0) {
      ServicioDialogos.cerrarDialogoCargando();
      ServicioDialogos.mostrarDialogoError("Atención", "No hay registros para visualizar");
      return;
    }
		lista = $filter('orderBy')(lista, ['numeroMovimiento'], true);
		var totales = [];
		var fecha;
		var fechaEnPreparacion;
		var fechaPreparado;
		totales = obtenerPrimeroConTotal(totales, lista);
		for (var i = lista.length - 1; i >= 0; i--) {
			if (i==lista.length-1) continue;
			fecha = $filter('date')(lista[i].fecha, "dd-MM-yyyy HH:mm:ss");
			fechaEnPreparacion = $filter('date')(lista[i].fechaEnPreparacion, "dd-MM-yyyy HH:mm:ss");
			fechaPreparado = $filter('date')(lista[i].fechaPreparado, "dd-MM-yyyy HH:mm:ss");
			totales.push({
				"N° Movimiento":lista[i].numeroMovimiento,
				"Empresa" : lista[i].empresa.nombre.toUpperCase(),
				"Sucursal" : lista[i].sucursal.nombre.toUpperCase(),
				"Código sucursal" : lista[i].sucursal.codigoSucursal.toUpperCase(),
				"Fecha generado":fecha,
				"Fecha comienzo de preparación":fechaEnPreparacion ? fechaEnPreparacion : "-",
				"Fecha preparado":fechaPreparado ? fechaPreparado : "-",
				"Tiempo comienzo preparación" : obtenerTiempo(lista[i].fecha, lista[i].fechaEnPreparacion),
				"Tiempo en preparación" : obtenerTiempo(lista[i].fechaEnPreparacion, lista[i].fechaPreparado),
				"Tiempo preparado" : obtenerTiempo(lista[i].fecha, lista[i].fechaPreparado),
			});
		}
		var nombreDocumento = "tiempos-preparaciones-"+Util.quitarCaracteresEspeciales(vm.deposito.nombre.toUpperCase())+"-entre-"+$filter('date')(vm.fechaDesde, "dd-MM-yyyy")+"-y-"+$filter('date')(vm.fechaHasta, "dd-MM-yyyy");
		alasql.promise('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true,sheetid:"Tiempos preparaciones"}) FROM ?',[totales])
		.then(function(data){
			ServicioDialogos.cerrarDialogoCargando();
		}).catch(function(err){
			console.log(err);
			ServicioDialogos.mostrarDialogoError();
			ServicioDialogos.cerrarDialogoCargando();
		});
    }

    function mostrarReporte(){
      ServicioDialogos.abrirDialogoCargando();
      var Url = obtenerUrl();
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function validarFiltros(){
      return (vm.deposito && vm.deposito.id) && (vm.fechaDesde && vm.fechaHasta);
    }

    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.dismiss();
    }

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.reporte-tiempo-salidas', {
        url: 'reporte-tiempo-salidas',
        templateUrl: 'app/app/main/reportes/reporte-tiempo-salidas/reporte-tiempo-salidas.html',
        controller: 'ReporteTiempoSalidasCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Reportes',
          subtitulo:'Reporte duración de salidas entre fechas'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          deposito: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return usuario.empleado.deposito;
              } else {
                return ;
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ReporteTiempoSalidasCtrl', ReporteTiempoSalidasCtrl);

  /** @ngInject */
  function ReporteTiempoSalidasCtrl(NgTableParams, Util, $filter, ListaMovimientosEntreFechaEstado, focus, rol, HeaderBarService, URL_SERVIDOR, $http, depositos, deposito, $stateParams, StockTipoSuministroDeposito, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.depositos = orderByFilter(depositos, "nombre", false);
    vm.deposito = deposito;
    vm.fechaActual = new Date();

    vm.mostrarReporte = mostrarReporte;
    vm.mostrarReporteExcel = mostrarReporteExcel;
    vm.validarFiltros = validarFiltros;
    vm.volver = volver;
    vm.comprobarPeriodoFechas = comprobarPeriodoFechas;

    function comprobarPeriodoFechas(){
      return  (((vm.fechaHasta - vm.fechaDesde)/86400000)<=550);
    }

    if (rol.id!=1 && rol.id!=2 && rol.id!=3 && rol.id!=29) $state.go("home.home");

    function volver(){
      $state.go("home.lista-reportes");
    }

    function obtenerUrl(){
      return URL_SERVIDOR+"/reportes/tiempoSalidas?idDeposito="+vm.deposito.id+"&&fechaDesde="+vm.fechaDesde+"&&fechaHasta="+vm.fechaHasta;
    }

    function mostrarReporteExcel(){
      ServicioDialogos.abrirDialogoCargando();
      ListaMovimientosEntreFechaEstado.query({idDeposito:vm.deposito.id, fechaDesde:vm.fechaDesde, fechaHasta:vm.fechaHasta}, function(data){
        armarReporteExcel(data);
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function obtenerTiempo(mov){
      var suma = mov.egreso.fecha-mov.fecha;
      var horas = (suma/(1000*3600));
      var minutos = (suma/(1000*60))%60;
      var segundos = (suma/(1000))%60;
      return Math.abs(Math.trunc(horas))+" h "+Math.abs(Math.trunc(minutos))+" m "+Math.abs(Math.trunc(segundos))+" s";
    }

    function obtenerTotalTiempo(suma, cont){
      var total = suma/cont;
      var horas = (total/(1000*3600));
      var minutos = (total/(1000*60))%60;
      var segundos = (total/(1000))%60;
      return Math.abs(Math.trunc(horas))+" h "+Math.abs(Math.trunc(minutos))+" m "+Math.abs(Math.trunc(segundos))+" s";
    }

    function obtenerPrimeroConTotal(totales, lista){
      var cont = 0;
      var suma = 0;
      var horasTotal;
      var fecha;
      var fechaEgreso;
      for (var i = lista.length - 1; i >= 0; i--) {
        cont ++;
        suma += lista[i].egreso.fecha-lista[i].fecha;
      }
      horasTotal = obtenerTotalTiempo(suma, cont);
      fecha = $filter('date')(lista[lista.length - 1].fecha, "dd-MM-yyyy HH:mm:ss");
      fechaEgreso = $filter('date')(lista[lista.length - 1].egreso.fecha, "dd-MM-yyyy HH:mm:ss");
      totales.push({
        "N° Movimiento":lista[lista.length - 1].numeroMovimiento,
        "Empresa" : lista[lista.length - 1].empresa.nombre.toUpperCase(),
        "Sucursal" : lista[lista.length - 1].sucursal.nombre.toUpperCase(),
        "Código sucursal" : lista[lista.length - 1].sucursal.codigoSucursal.toUpperCase(),
        "Transporte" : lista[lista.length - 1].egreso.empresaLogistica.nombre.toUpperCase(),
        "Fecha generado":fecha,
        "Fecha despacho":fechaEgreso,
        "Tiempo" : obtenerTiempo(lista[lista.length - 1]),
        "":"",
        "Tiempo promedio":horasTotal
      });
      return totales;
    }

    function armarReporteExcel(lista){
      if (lista && lista.length<=0) {
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError("Atención", "No hay registros para visualizar");
        return;
      }
      lista = $filter('orderBy')(lista, ['numeroMovimiento'], true);
      var totales = [];
      var fecha;
      var fechaEgreso;
      totales = obtenerPrimeroConTotal(totales, lista);
      for (var i = lista.length - 1; i >= 0; i--) {
        if (i==lista.length-1) continue;
        fecha = $filter('date')(lista[i].fecha, "dd-MM-yyyy HH:mm:ss");
        fechaEgreso = $filter('date')(lista[i].egreso.fecha, "dd-MM-yyyy HH:mm:ss");
        totales.push({
          "N° Movimiento":lista[i].numeroMovimiento,
          "Empresa" : lista[i].empresa.nombre.toUpperCase(),
          "Sucursal" : lista[i].sucursal.nombre.toUpperCase(),
          "Código sucursal" : lista[i].sucursal.codigoSucursal.toUpperCase(),
          "Transporte" : lista[i].egreso.empresaLogistica.nombre.toUpperCase(),
          "Fecha generado":fecha,
          "Fecha despacho":fechaEgreso,
          "Tiempo" : obtenerTiempo(lista[i])
        });
      }
      var nombreDocumento = "tiempos-despachos-"+Util.quitarCaracteresEspeciales(vm.deposito.nombre.toUpperCase())+"-entre-"+$filter('date')(vm.fechaDesde, "dd-MM-yyyy")+"-y-"+$filter('date')(vm.fechaHasta, "dd-MM-yyyy");
      alasql.promise('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true,sheetid:"Tiempos despacho"}) FROM ?',[totales])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function mostrarReporte(){
      ServicioDialogos.abrirDialogoCargando();
      var Url = obtenerUrl();
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function validarFiltros(){
      return (vm.deposito && vm.deposito.id) && (vm.fechaDesde && vm.fechaHasta);
    }

    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.dismiss();
    }

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.reporte-suministro-deposito', {
        url: 'reporte-suministro-deposito',
        templateUrl: 'app/app/main/reportes/reporte-suministro-deposito/reporte-suministro-deposito.html',
        controller: 'ReporteSuministroDepositoCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Reportes',
          subtitulo:'Reporte de existencias de un tipo de suministro en depósito'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          empresas: function(Usuario, Empresa, $filter){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.empresa && usuario.empleado.empresa.id){
                var empresas = [];
                return Empresa.get({id:usuario.empleado.empresa.id}).$promise.then(function(empresa){
                  empresas.push(empresa);
                  return empresas;
                });
              } else {
                return Empresa.query().$promise.then(function(data) {
                  if (usuario.empleado && usuario.rol && usuario.rol.nombre=='CONSULTA' && usuario.empleado.empresas && usuario.empleado.empresas.length>0) {
                    var empresas = [];
                    data.forEach(function(empresa){
                      if (usuario.empleado.empresas.includes(empresa.id)){
                        empresas.push(empresa);
                      }
                    });
                    return $filter('orderBy')(empresas, 'nombre', false);
                  }
                  return data;
                });
              }
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          deposito: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return usuario.empleado.deposito;
              } else {
                return ;
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ReporteSuministroDepositoCtrl', ReporteSuministroDepositoCtrl);

  /** @ngInject */
  function ReporteSuministroDepositoCtrl(NgTableParams, Util, $filter, depositos, focus, deposito, rol, HeaderBarService, URL_SERVIDOR, $http, empresas, $stateParams, SuministroInventariableTipoDeposito, SuministroDepositoFamilia, StockTipoSuministroDeposito, $scope, orderByFilter, $state, GrupoEmpresa, TiposPorEmpresa, TipoSuministroFamilia, FamiliaSuministroGrupo, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.util = Util;
    vm.empresas = orderByFilter(empresas,'nombre',false);
    vm.depositos = orderByFilter(depositos,'nombre',false);

    vm.mostrarReporte = mostrarReporte;
    vm.validarFiltros = validarFiltros;
    vm.mostrarReporteSinDetalle = mostrarReporteSinDetalle;
    vm.mostrarReporteSinDetalleExcel = mostrarReporteSinDetalleExcel;
    vm.mostrarReporteExcel = mostrarReporteExcel;
    vm.volver = volver;
    vm.radio = 'jerarquizada';

    if (rol.id!=1 && rol.id!=2 && rol.id!=3 && rol.id!=29) $state.go("home.home");

    function volver(){
      $state.go("home.lista-reportes");
    }

    function mostrarReporteSinDetalle(){
      mostrarReporte(false);
    }

    function mostrarReporteExcel(){
      if (vm.tipoSuministro && vm.tipoSuministro.inventariable){
        armarExcelDetalladoInventariable();
      } else {
        armarExcelDetallado();
      }
    }

    function armarExcelDetalladoInventariable(){
      ServicioDialogos.abrirDialogoCargando();
      SuministroInventariableTipoDeposito.query({idDeposito:vm.deposito.id, idTipo: vm.tipoSuministro.id}, function(data) {
        armarExcelDetalladoTipoInventariable(data);
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });

    }

    function armarExcelDetalladoTipoInventariable(data){
      var array = [];
      var ubicacion;
      for (var i = data.length - 1; i >= 0; i--) {
        ubicacion = "Depósito: "+data[i].suministro.ubicacion.nivel.estante.estructura.pasillo.nave.deposito.nombre.toUpperCase()+
          " - Nave: "+data[i].suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
          " - Pasillo: "+data[i].suministro.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
          " - Estructura: "+data[i].suministro.ubicacion.nivel.estante.estructura.identificadorEstructura+
          " - Estantería: "+data[i].suministro.ubicacion.nivel.estante.numeroEstante+
          " - Estante: "+data[i].suministro.ubicacion.nivel.numeroNivel+
          " - Ubicación: "+data[i].suministro.ubicacion.numeroUbicacion;
        array.push({
          "Empresa" : data[i].suministro.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase(),
          "Grupo suministro" : data[i].suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
          "Familia suministro" : data[i].suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase(),
          "Código familia" : data[i].suministro.tipoSuministro.familiaSuministro.codigoFamiliaSuministro.toUpperCase(),
          "Tipo suministro" : data[i].suministro.tipoSuministro.nombre.toUpperCase(),
          "Código producto" : data[i].suministro.tipoSuministro.codigoProducto.toUpperCase(),
          "Ubicación" : ubicacion,
          "Inventario" : data[i].inventario,
          "Serie" : data[i].serie
        });
      }
      var nombreDocumento = vm.tipoSuministro ? "existencias-detalle-"+vm.util.quitarCaracteresEspeciales(vm.tipoSuministro.nombre.toUpperCase()) : "existencias-detalle";
      alasql.promise('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true,sheetid:"Existencias detalle'+vm.util.quitarCaracteresEspeciales(vm.tipoSuministro.nombre.toUpperCase())+'"}) FROM ?',[array])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });

    }

    function armarExcelDetallado(){
      ServicioDialogos.abrirDialogoCargando();
      StockTipoSuministroDeposito.query({idDeposito:vm.deposito.id, idTipo: vm.tipoSuministro.id}, function(data) {
        armarExcelDetalladoTipo(data);
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    }

    function armarExcelDetalladoTipo(data){
      var array = [];
      var ubicacion;
      for (var i = data.length - 1; i >= 0; i--) {
        ubicacion = "Depósito: "+data[i].ubicacion.nivel.estante.estructura.pasillo.nave.deposito.nombre.toUpperCase()+
          " - Nave: "+data[i].ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
          " - Pasillo: "+data[i].ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
          " - Estructura: "+data[i].ubicacion.nivel.estante.estructura.identificadorEstructura+
          " - Estantería: "+data[i].ubicacion.nivel.estante.numeroEstante+
          " - Estante: "+data[i].ubicacion.nivel.numeroNivel+
          " - Ubicación: "+data[i].ubicacion.numeroUbicacion;
        array.push({
          "Empresa" : data[i].tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase(),
          "Grupo suministro" : data[i].tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
          "Familia suministro" : data[i].tipoSuministro.familiaSuministro.nombre.toUpperCase(),
          "Código familia" : data[i].tipoSuministro.familiaSuministro.codigoFamiliaSuministro.toUpperCase(),
          "Tipo suministro" : data[i].tipoSuministro.nombre.toUpperCase(),
          "Código producto" : data[i].tipoSuministro.codigoProducto.toUpperCase(),
          "Ubicación" : ubicacion,
          "Cantidad" : data[i].cantidad
        });
      }
      var nombreDocumento = vm.tipoSuministro ? "existencias-detalle-"+vm.util.quitarCaracteresEspeciales(vm.tipoSuministro.nombre.toUpperCase()) : "existencias";
      alasql.promise('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true,sheetid:"Existencias detalle'+vm.util.quitarCaracteresEspeciales(vm.tipoSuministro.nombre.toUpperCase())+'"}) FROM ?',[array])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function mostrarReporteSinDetalleExcel(){
      if (vm.tipoSuministro && vm.tipoSuministro.id){
        obtenerReporteExcelTotalesTipos();
      } else {
        obtenerReporteExcelTotalesFamilia();
      }
    }

    function obtenerReporteExcelTotalesFamilia(){
      ServicioDialogos.abrirDialogoCargando();
      SuministroDepositoFamilia.query({idDeposito:vm.deposito.id, idFamilia: vm.familiaSuministro.id}, function(data) {
        armarExcelTotalesFamilia(data);
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    }

    function armarExcelTotalesFamilia(data){
      var lista = $filter('orderBy')(obtenerTotalesLista(data), ['tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre', 'tipoSuministro.familiaSuministro.grupoSuministro.nombre', 'tipoSuministro.familiaSuministro.nombre', 'tipoSuministro.nombre'], true);
      var array = [];
      for (var i = lista.length - 1; i >= 0; i--) {
        array.push({
          "Empresa" : lista[i].tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase(),
          "Grupo suministro" : lista[i].tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
          "Familia suministro" : lista[i].tipoSuministro.familiaSuministro.nombre.toUpperCase(),
          "Código familia" : lista[i].tipoSuministro.familiaSuministro.codigoFamiliaSuministro.toUpperCase(),
          "Tipo suministro" : lista[i].tipoSuministro.nombre.toUpperCase(),
          "Código producto" : lista[i].tipoSuministro.codigoProducto.toUpperCase(),
          "Cantidad total" : lista[i].cantidad,
          "Cant. regular": lista[i].cantidadRegular,
          "Cant. donación": lista[i].cantidadDonacion,
          "Cant. scrap-reparación": lista[i].cantidadScrap
        });
      }
      var nombreDocumento = vm.familiaSuministro ? "existencias-"+vm.util.quitarCaracteresEspeciales(vm.familiaSuministro.nombre.toUpperCase()) : "existencias";
      alasql.promise('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true,sheetid:"Existencias '+vm.util.quitarCaracteresEspeciales(vm.familiaSuministro.nombre.toUpperCase())+'"}) FROM ?',[array])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function obtenerReporteExcelTotalesTipos(){
      ServicioDialogos.abrirDialogoCargando();
      StockTipoSuministroDeposito.query({idDeposito:vm.deposito.id, idTipo: vm.tipoSuministro.id}, function(data) {
        armarExcelTotalesTipo(data);
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    }

    function obtenerTotalesLista(data){
      var lista = [];
      var ban = false;
      data.forEach(function(suministro){
        lista.forEach(function(item){
          if (item.tipoSuministro.id==suministro.tipoSuministro.id){
            ban = true;
            item.cantidad += suministro.cantidad;
            if (suministro.estadoSuministro && (suministro.estadoSuministro.id==2 || suministro.estadoSuministro.id==3)) item.cantidadRegular += suministro.cantidad;
            if (suministro.estadoSuministro && (suministro.estadoSuministro.id==4 || suministro.estadoSuministro.id==6)) item.cantidadDonacion += suministro.cantidad;
            if (suministro.estadoSuministro && (suministro.estadoSuministro.id==7 || suministro.estadoSuministro.id==9)) item.cantidadScrap += suministro.cantidad;
          }
        });
        if (!ban){
          lista.push({tipoSuministro:suministro.tipoSuministro, cantidad:suministro.cantidad, cantidadRegular: suministro.estadoSuministro.id==2 || suministro.estadoSuministro.id==3?suministro.cantidad:0, cantidadDonacion:suministro.estadoSuministro.id==4 || suministro.estadoSuministro.id==6?suministro.cantidad:0, cantidadScrap:suministro.estadoSuministro.id==7 || suministro.estadoSuministro.id==9?suministro.cantidad:0});
        }
        ban = false;
      });
      return lista;
    }

    function armarExcelTotalesTipo(data){
      var lista = $filter('orderBy')(obtenerTotalesLista(data), ['tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre', 'tipoSuministro.familiaSuministro.grupoSuministro.nombre', 'tipoSuministro.familiaSuministro.nombre', 'tipoSuministro.nombre'], true);
      var array = [];
      for (var i = lista.length - 1; i >= 0; i--) {
        array.push({
          "Empresa" : lista[i].tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase(),
          "Grupo suministro" : lista[i].tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
          "Familia suministro" : lista[i].tipoSuministro.familiaSuministro.nombre.toUpperCase(),
          "Código familia" : lista[i].tipoSuministro.familiaSuministro.codigoFamiliaSuministro.toUpperCase(),
          "Tipo suministro" : lista[i].tipoSuministro.nombre.toUpperCase(),
          "Código producto" : lista[i].tipoSuministro.codigoProducto.toUpperCase(),
          "Cantidad total" : lista[i].cantidad,
          "Cant. regular": lista[i].cantidadRegular,
          "Cant. donación": lista[i].cantidadDonacion,
          "Cant. scrap-reparación": lista[i].cantidadScrap
        });
      }
      var nombreDocumento = vm.tipoSuministro ? "existencias-"+vm.util.quitarCaracteresEspeciales(vm.tipoSuministro.nombre.toUpperCase()) : "existencias";
      alasql.promise('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true,sheetid:"Existencias '+vm.util.quitarCaracteresEspeciales(vm.tipoSuministro.nombre.toUpperCase())+'"}) FROM ?',[array])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function obtenerUrl(detalle){
      if (vm.tipoSuministro && vm.tipoSuministro.id){
        return URL_SERVIDOR+"/suministro/reporte/existencia/"+vm.deposito.id+"/"+vm.tipoSuministro.id+"/"+detalle;
      } else {
        return URL_SERVIDOR+"/suministro/reporte/existenciafamilia/"+vm.deposito.id+"/"+vm.familiaSuministro.id+"/"+detalle;
      }
    }

    function mostrarReporte(detalle){
      ServicioDialogos.abrirDialogoCargando();
      var Url = obtenerUrl(detalle);
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function validarFiltros(){
      return (vm.empresa && vm.empresa.id) && (vm.deposito && vm.deposito.id) && (vm.tipoSuministro && vm.tipoSuministro.id || vm.familiaSuministro && vm.familiaSuministro.id);
    }

    function cambioRadio(){
      if (vm.radio=='jerarquizada'){
        vm.tipoSuministroCompleto=null;
      } else {
        if (vm.tipoSuministro && vm.tipoSuministro.id) vm.tipoSuministro=null;
        if (vm.familiaSuministro && vm.familiaSuministro.id) vm.familiaSuministro=null;
        if (vm.grupo && vm.grupo.id) vm.grupo=null;
      }
    }

    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.dismiss();
    }

    $scope.$watch('vm.grupo.nombre', function(){
      if (vm.familiaSuministro) vm.familiaSuministro=null;
      if (!vm.grupo) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupo.id}, function(data){
        vm.familias = orderByFilter(data,'nombre',false);
        focus('familia');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.empresa.id', function(){
      if (vm.grupo) vm.grupo=null;
      if (vm.tipoSuministroCompleto) vm.tipoSuministroCompleto=null;
      if (!vm.empresa) return;
      ServicioDialogos.abrirDialogoCargando();
      GrupoEmpresa.query({id:vm.empresa.id}, function(data){
        vm.grupos = orderByFilter(data,'nombre',false);
        focus('grupo');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.tipoSuministroCompleto.nombre', function(){
      vm.tipoSuministro=vm.tipoSuministroCompleto;
    });

    $scope.$watch('vm.familiaSuministro.nombre', function(){
      if (vm.tipoSuministro) vm.tipoSuministro=null;
      if (!vm.familiaSuministro) return;
      ServicioDialogos.abrirDialogoCargando();
      TipoSuministroFamilia.query({id:vm.familiaSuministro.id}, function(data){
        vm.tipos = orderByFilter(data,'nombre',false);
        focus('tipo');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.radio', function(){
      if (vm.radio=='directa') {
        ServicioDialogos.abrirDialogoCargando();
        TiposPorEmpresa.query({idEmpresa:vm.empresa.id}, function(data){
          vm.tiposCompletos = orderByFilter(data,'nombre',false);
          ServicioDialogos.cerrarDialogoCargando();
        }, function(err){
          console.log(err);
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError();
        });

      }
    });
    
    
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.reporte-stock', {
        url: 'reporte-stock',
        templateUrl: 'app/app/main/reportes/reporte-stock/reporte-stock.html',
        controller: 'ReporteStockCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Reportes',
          subtitulo:'Reporte de stock de suministros de una empresa'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          empresas: function(Usuario, Empresa, $filter){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.empresa && usuario.empleado.empresa.id){
                var empresas = [];
                return Empresa.get({id:usuario.empleado.empresa.id}).$promise.then(function(empresa){
                  empresas.push(empresa);
                  return empresas;
                });
              } else {
                return Empresa.query().$promise.then(function(data) {
                  if (usuario.empleado && usuario.rol && usuario.rol.nombre=='CONSULTA' && usuario.empleado.empresas && usuario.empleado.empresas.length>0) {
                    var empresas = [];
                    data.forEach(function(empresa){
                      if (usuario.empleado.empresas.includes(empresa.id)){
                        empresas.push(empresa);
                      }
                    });
                    return $filter('orderBy')(empresas, 'nombre', false);
                  }
                  return data;
                });
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ReporteStockCtrl', ReporteStockCtrl);

  /** @ngInject */
  function ReporteStockCtrl(NgTableParams, Util, rol, HeaderBarService, URL_SERVIDOR, $filter, $http, empresas, $stateParams, $scope, orderByFilter, $state, SuministroStockEmpresa, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.empresas = orderByFilter(empresas, "nombre", false);

    vm.mostrarReporteCompleto = mostrarReporteCompleto;
    vm.mostrarReporteStock = mostrarReporteStock;
    vm.mostrarReporteCompletoExcel = mostrarReporteCompletoExcel;
    vm.mostrarReporteStockExcel = mostrarReporteStockExcel;
    vm.volver = volver;

    if (rol.id!=1 && rol.id!=2 && rol.id!=3 && rol.id!=29) $state.go("home.home");

    function volver(){
      $state.go("home.lista-reportes");
    }

    function mostrarReporteStockExcel(){
      ServicioDialogos.abrirDialogoCargando();
      SuministroStockEmpresa.query({idEmpresa: vm.empresa.id}, function(data) {
        armarExcelStockMinimo(data);
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function armarExcelStockMinimo(data){
      var lista = $filter('orderBy')(obtenerTotales(data), ['tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre', 'tipoSuministro.familiaSuministro.grupoSuministro.nombre', 'tipoSuministro.familiaSuministro.nombre', 'tipoSuministro.nombre'], true);
      var array = [];
      var stockMinimo;
      for (var i = lista.length - 1; i >= 0; i--) {
        if (lista[i].tipoSuministro.stockMinimo>lista[i].cantidad){
          array.push({
            "Empresa" : lista[i].tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase(),
            "Grupo suministro" : lista[i].tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
            "Familia suministro" : lista[i].tipoSuministro.familiaSuministro.nombre.toUpperCase(),
            "Código familia" : lista[i].tipoSuministro.familiaSuministro.codigoFamiliaSuministro.toUpperCase(),
            "Tipo suministro" : lista[i].tipoSuministro.nombre.toUpperCase(),
            "Código producto" : lista[i].tipoSuministro.codigoProducto.toUpperCase(),
            "Stock mínimo" : lista[i].tipoSuministro.stockMinimo,
            "Stock actual" : lista[i].cantidad
          });
        }
      }
      var nombreDocumento = vm.empresa ? "stock-mínimo-"+Util.quitarCaracteresEspeciales(vm.empresa.nombre.toUpperCase()) : "stock-mínimo";
      alasql.promise('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true,sheetid:"Stock mínimo"}) FROM ?',[array])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });

    }

    function mostrarReporteStock(){
      ServicioDialogos.abrirDialogoCargando();
      var Url = URL_SERVIDOR+"/reportes/stock-minimo/"+vm.empresa.id;
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function mostrarReporteCompletoExcel(){
      ServicioDialogos.abrirDialogoCargando();
      SuministroStockEmpresa.query({idEmpresa: vm.empresa.id}, function(data) {
        armarExcelStockCompleto(data);
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function armarExcelStockCompleto(data){
      var lista = $filter('orderBy')(obtenerTotales(data), ['tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre', 'tipoSuministro.familiaSuministro.grupoSuministro.nombre', 'tipoSuministro.familiaSuministro.nombre', 'tipoSuministro.nombre'], true);
      var array = [];
      var stockMinimo;
      for (var i = lista.length - 1; i >= 0; i--) {
        stockMinimo = lista[i].tipoSuministro.stockMinimo>lista[i].cantidad? "Si":"No";
        array.push({
          "Empresa" : lista[i].tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase(),
          "Grupo suministro" : lista[i].tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
          "Familia suministro" : lista[i].tipoSuministro.familiaSuministro.nombre.toUpperCase(),
          "Código familia" : lista[i].tipoSuministro.familiaSuministro.codigoFamiliaSuministro.toUpperCase(),
          "Tipo suministro" : lista[i].tipoSuministro.nombre.toUpperCase(),
          "Código producto" : lista[i].tipoSuministro.codigoProducto.toUpperCase(),
          "Stock mínimo" : lista[i].tipoSuministro.stockMinimo,
          "Stock actual" : lista[i].cantidad,
          "¿Mínimo superado?": stockMinimo
        });
      }
      var nombreDocumento = vm.empresa ? "stock-"+Util.quitarCaracteresEspeciales(vm.empresa.nombre.toUpperCase()) : "stock";
      alasql.promise('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true,sheetid:"Stock"}) FROM ?',[array])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function obtenerTotales(data){
      var lista = [];
      var ban = false;
      data.forEach(function(suministro){
        lista.forEach(function(item){
          if (item.tipoSuministro.id==suministro.tipoSuministro.id){
            ban = true;
            item.cantidad += suministro.cantidad;
          }
        });
        if (!ban){
          lista.push({tipoSuministro:suministro.tipoSuministro, cantidad:suministro.cantidad});
        }
        ban = false;
      });
      return lista;
    }

    function mostrarReporteCompleto(){
      ServicioDialogos.abrirDialogoCargando();
      var Url = URL_SERVIDOR+"/reportes/stock/"+vm.empresa.id;
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }
    
    
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.reporte-ocupacion-ubicaciones', {
        url: 'reporte-ocupacion-ubicaciones',
        templateUrl: 'app/app/main/reportes/reporte-ocupacion-ubicaciones/reporte-ocupacion-ubicaciones.html',
        controller: 'ReporteOcupacionUbicacionesCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Reportes',
          subtitulo:'Reporte de ocupación de ubicaciones de un depósito y para una empresa'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          empresas: function(Usuario, Empresa, $filter){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.empresa && usuario.empleado.empresa.id){
                var empresas = [];
                return Empresa.get({id:usuario.empleado.empresa.id}).$promise.then(function(empresa){
                  empresas.push(empresa);
                  return empresas;
                });
              } else {
                return Empresa.query().$promise.then(function(data) {
                  if (usuario.empleado && usuario.rol && usuario.rol.nombre=='CONSULTA' && usuario.empleado.empresas && usuario.empleado.empresas.length>0) {
                    var empresas = [];
                    data.forEach(function(empresa){
                      if (usuario.empleado.empresas.includes(empresa.id)){
                        empresas.push(empresa);
                      }
                    });
                    return $filter('orderBy')(empresas, 'nombre', false);
                  }
                  return data;
                });
              }
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          deposito: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return usuario.empleado.deposito;
              } else {
                return ;
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ReporteOcupacionUbicacionesCtrl', ReporteOcupacionUbicacionesCtrl);

  /** @ngInject */
  function ReporteOcupacionUbicacionesCtrl(NgTableParams, Util, $filter, deposito, rol, Deposito, HeaderBarService, URL_SERVIDOR, $http, empresas, depositos, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.depositos = orderByFilter(depositos, "nombre", false);
    vm.deposito = deposito;
    vm.empresas = orderByFilter(empresas, "nombre", false);

    var familias = [];
    var grupos = [];

    vm.armarReporte = armarReporte;
    vm.armarReporteExcel = armarReporteExcel;
    vm.volver = volver;
    
    if (rol.id!=1 && rol.id!=2 && rol.id!=3 && rol.id!=29) $state.go("home.home");

    function volver(){
      $state.go("home.lista-reportes");
    }

    function armarReporte(){
      vm.modo = true;
      ServicioDialogos.abrirDialogoCargando();
      familias = [];
      grupos = [];
      Deposito.get({id:vm.deposito.id}, function(depo){
        calcularOcupacion(depo);
      });
    }

    function armarReporteExcel(){
      vm.modo = false;
      ServicioDialogos.abrirDialogoCargando();
      familias = [];
      grupos = [];
      Deposito.get({id:vm.deposito.id}, function(depo){
        calcularOcupacion(depo);
      });
    }

    function armarArraysFamiliaYGrupo(ubicacion){
      var familiasUsadas = [];
      var gruposUsados = [];
      ubicacion.suministros.forEach(function(suministro){
        if (suministro.tipoSuministro.familiaSuministro.grupoSuministro.empresa.id!=vm.empresa.id){
          return;
        }
        familiasUsadas = setearArray(familiasUsadas, suministro.tipoSuministro.familiaSuministro);
        gruposUsados = setearArray(gruposUsados, suministro.tipoSuministro.familiaSuministro.grupoSuministro);
      });
      return {familias: familiasUsadas, grupos: gruposUsados};
    }

    function setearArray(array, objeto){
      var esta = false;
      array.forEach(function(item){
        if (item.id==objeto.id){
          esta = true;
        }
      });
      if (!esta){
        array.push(angular.copy(objeto));
      }
      return array;
    }

    function obtenerTotales(principal, carga){
      var esta = false;
      carga.forEach(function(item){
        esta = false;
        principal.forEach(function(objeto){
          if (item.id==objeto.objeto.id){
            esta = true;
            objeto.cantidad += 1;
          }
        });
        if (!esta){
          principal.push({"objeto":item, "cantidad":1});
        }
      });
      return principal;
    }

    function obtenerUbicacionesUnicas(ubicacion, array, modo){
      var cont = 0;
      var cantSum = 0;
      array.forEach(function(item){
        if (!item.cantidadUnicas) item.cantidadUnicas = 0;
        ubicacion.suministros.forEach(function(suministro){
          if (suministro.tipoSuministro.familiaSuministro.grupoSuministro.empresa.id!=vm.empresa.id){
            return;
          }
          cantSum += 1;
          if (modo=='familia' && item.objeto.id==suministro.tipoSuministro.familiaSuministro.id){
            cont += 1;
          } else if (modo=='grupo' && item.objeto.id==suministro.tipoSuministro.familiaSuministro.grupoSuministro.id){
            cont += 1;
          }
        });
        if (cantSum == cont && cantSum>0){
          item.cantidadUnicas += 1;
        }
        cantSum = 0;
        cont = 0;
      });
      return array;
    }

    function ubicacionOcupadaEmpresa(ubicacion){
      return (ubicacion.suministros.length>0 && comprobarEmpresaUbicacion(ubicacion));
    }

    function comprobarEmpresaUbicacion(ubicacion){
      var ban = false;
      ubicacion.suministros.forEach(function(item){
        if (item.tipoSuministro.familiaSuministro.grupoSuministro.empresa.id==vm.empresa.id){
          ban = true;
        }
      });
      return ban;
    }

    function obtenerCantidadesFamiliasYGrupos(deposito){
      var cantidadUbicaciones = 0;
      var cant = 0;
      var objeto = {};
      deposito.naves.forEach(function(nave){
        nave.pasillos.forEach(function(pasillo){
          pasillo.estructuras.forEach(function(estructura){
            estructura.estantes.forEach(function(estante){
              estante.niveles.forEach(function(nivel){
                nivel.ubicaciones.forEach(function(ubicacion){
                  objeto = armarArraysFamiliaYGrupo(ubicacion);
                  familias = obtenerTotales(familias, objeto.familias);
                  grupos = obtenerTotales(grupos, objeto.grupos);
                  familias = obtenerUbicacionesUnicas(ubicacion, familias, "familia");
                  grupos = obtenerUbicacionesUnicas(ubicacion, grupos, "grupo");
                  if (ubicacionOcupadaEmpresa(ubicacion)){
                    cantidadUbicaciones += 1;
                  }
                  cant = cant + 1;
                });
              });
            });
          });
        });
      });
      grupos = calcularPorcentaje(grupos);
      familias = calcularPorcentaje(familias);
      familias = calcularPorcentajeEnGrupos(familias, grupos);
      insertarGruposEnFamilia(familias, grupos);
      armarObjetoReporte(grupos, familias, cantidadUbicaciones, cant);
    }

    function obtenerGruposYFamiliasUtilizados(deposito){
      var familiasUsadas = [];
      var gruposUsados = [];
      var estaGrupo = false;
      var estaFamilia = false;
      deposito.naves.forEach(function(nave){
        nave.pasillos.forEach(function(pasillo){
          pasillo.estructuras.forEach(function(estructura){
            estructura.estantes.forEach(function(estante){
              estante.niveles.forEach(function(nivel){
                nivel.ubicaciones.forEach(function(ubicacion){
                  ubicacion.suministros.forEach(function(suministro){
                    if (suministro.tipoSuministro.familiaSuministro.grupoSuministro.empresa.id!=vm.empresa.id){
                      return;
                    }
                    estaFamilia = false;
                    estaGrupo = false;
                    familiasUsadas.forEach(function(familia){
                      if (familia.objeto.id==suministro.tipoSuministro.familiaSuministro.id){
                        estaFamilia = true;
                      }
                    });
                    gruposUsados.forEach(function(grupo){
                      if (grupo.objeto.id==suministro.tipoSuministro.familiaSuministro.grupoSuministro.id){
                        estaGrupo = true;
                      }
                    });
                    if (!estaFamilia){
                      familiasUsadas.push({grupo: null, objeto:suministro.tipoSuministro.familiaSuministro, cantidad:0, cantidadUnicas:0, porcentaje:0.0, porcentajeEnGrupo:0.0});
                    }
                    if (!estaGrupo){
                      gruposUsados.push({objeto: suministro.tipoSuministro.familiaSuministro.grupoSuministro, cantidad:0, cantidadUnicas:0, porcentaje:0.0});
                    }
                  });
                });
              });
            });
          });
        });
      });
      familias = familiasUsadas;
      grupos = gruposUsados;
    }

    function armarObjetoReporte(grupos, familias, cantidadUbicaciones, cantidadTotal){
      var reporte = {};
      reporte.grupos = grupos;
      reporte.familias = familias;
      reporte.cantidadOcupadas = cantidadUbicaciones;
      reporte.cantidadTotal = cantidadTotal;
      reporte.empresa = vm.empresa;
      reporte.deposito = vm.deposito;
      if (vm.modo){
        mostrarReporteOcupacionDepositoEmpresa(reporte);
      } else {
        mostrarReporteExcel(reporte);
      }
    }

    function mostrarReporteExcel(reporte){
      var pagina1 = obtenerTotalesGrupo(reporte);
      var pagina2 = obtenerDetalleGrupo(reporte);
      var opts = [{sheetid:'Resumen por Grupo',header:true}, {sheetid:'Detalle por grupo',header:true}];
      var nombreDocumento = vm.empresa ? "ocupación-depósito-"+Util.quitarCaracteresEspeciales(vm.empresa.nombre.toUpperCase()) : "ocupación-depósito";
      alasql.promise('SELECT INTO XLSX("'+nombreDocumento+'.xlsx",?) FROM ?',[opts,[pagina1, pagina2]])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function obtenerDetalleGrupo(reporte){
      var lista = $filter('orderBy')(reporte.familias, ['objeto.grupoSuministro.empresa.nombre', 'objeto.grupoSuministro.nombre', 'objeto.nombre'], true);
      var totales = [];
      var diferencia;
      for (var i = lista.length - 1; i >= 0; i--) {
        diferencia = lista[i].cantidad - lista[i].cantidadUnicas;
        totales.push({
          "Empresa" : lista[i].objeto.grupoSuministro.empresa.nombre.toUpperCase(),
          "Grupo suministro" : lista[i].objeto.grupoSuministro.nombre.toUpperCase(),
          "Familia suministro" : lista[i].objeto.nombre.toUpperCase(),
          "Código familia" : lista[i].objeto.codigoFamiliaSuministro.toUpperCase(),
          "Cantidad ubicaciones" : lista[i].cantidad,
          "Únicas" : lista[i].cantidadUnicas,
          "Compartidas" : diferencia,
          "Porcentaje ocupación": lista[i].porcentaje,
          "Porcentaje en el grupo": lista[i].porcentajeEnGrupo
        });
      }
      return totales;
    }

    function obtenerPrimeroConTotal(totales, primero, reporte){
      var diferencia = primero.cantidad - primero.cantidadUnicas;
      totales.push({
        "Empresa" : primero.objeto.empresa.nombre.toUpperCase(),
        "Grupo suministro" : primero.objeto.nombre.toUpperCase(),
        "Cantidad ubicaciones" : primero.cantidad,
        "Únicas" : primero.cantidadUnicas,
        "Compartidas" : diferencia,
        "Porcentaje ocupación":primero.porcentaje,
        "":"",
        "Ubicaciones totales en depósito":reporte.cantidadTotal,
        "Ubicaciones ocupadas por empresa":reporte.cantidadOcupadas
      });
      return totales;
    }

    function obtenerTotalesGrupo(reporte){
      var lista = $filter('orderBy')(reporte.grupos, ['objeto.empresa.nombre', 'objeto.nombre'], true);
      var totales = [];
      var diferencia;
      totales = obtenerPrimeroConTotal(totales, lista[lista.length-1], reporte);
      for (var i = lista.length - 1; i >= 0; i--) {
        if (i==lista.length-1) continue;
        diferencia = lista[i].cantidad - lista[i].cantidadUnicas;
        totales.push({
          "Empresa" : lista[i].objeto.empresa.nombre.toUpperCase(),
          "Grupo suministro" : lista[i].objeto.nombre.toUpperCase(),
          "Cantidad ubicaciones" : lista[i].cantidad,
          "Únicas" : lista[i].cantidadUnicas,
          "Compartidas" : diferencia,
          "Porcentaje ocupación": lista[i].porcentaje
        });
      }
      return totales;
    }

    function mostrarReporteOcupacionDepositoEmpresa(reporte){
      var Url = URL_SERVIDOR+"/reportes/ocupacionDepositoEmpresa";
      $http.post(Url, reporte,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function insertarGruposEnFamilia(familias, grupos){
      grupos.forEach(function(grupo){
        familias.forEach(function(familia){
          if (familia.objeto.grupoSuministro.id==grupo.objeto.id){
            familia.grupo = grupo;
          }
        });
      });
    }

    function calcularPorcentajeEnGrupos(familias){
      var por = 0;
      familias.forEach(function(item){
        por =0;
        familias.forEach(function(familia){
          if (item.objeto.grupoSuministro.id==familia.objeto.grupoSuministro.id){
            por += familia.cantidad;
          }
        });
        item.porcentajeEnGrupo = parseFloat((item.cantidad/por*100).toFixed(2));
      });
      return familias;

    }

    function calcularPorcentaje(array){
      var acu = 0;
      array.forEach(function(item){
        array.forEach(function(item2){
          acu += item2.cantidad;
        });
        item.porcentaje = parseFloat((item.cantidad/acu*100).toFixed(2));
        acu = 0;
      });
      return array;
    }

    function contarTotalesOcupados(array){
      var cant = 0;
      array.forEach(function(item){
        cant += item.cantidad;
      });
      return cant;
    }

    function calcularOcupacion(deposito){
      obtenerGruposYFamiliasUtilizados(deposito);
      obtenerCantidadesFamiliasYGrupos(deposito);
    }
  
    
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.reporte-problemas-ingresos', {
        url: 'reporte-problemas-ingresos',
        templateUrl: 'app/app/main/reportes/reporte-problemas-ingresos/reporte.html',
        controller: 'ReporteProblemasIngresosCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Reportes',
          subtitulo:'Reporte problemas en ingresos por proveedor'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          anos: function(Util){
            return Util.obtenerAnos();
          },
          empresas: function(Usuario, Empresa, $filter){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.empresa && usuario.empleado.empresa.id){
                var empresas = [];
                return Empresa.get({id:usuario.empleado.empresa.id}).$promise.then(function(empresa){
                  empresas.push(empresa);
                  return empresas;
                });
              } else {
                return Empresa.query().$promise.then(function(data) {
                  if (usuario.empleado && usuario.rol && usuario.rol.nombre=='CONSULTA' && usuario.empleado.empresas && usuario.empleado.empresas.length>0) {
                    var empresas = [];
                    data.forEach(function(empresa){
                      if (usuario.empleado.empresas.includes(empresa.id)){
                        empresas.push(empresa);
                      }
                    });
                    return $filter('orderBy')(empresas, 'nombre', false);
                  }
                  return data;
                });
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ReporteProblemasIngresosCtrl', ReporteProblemasIngresosCtrl);

  /** @ngInject */
  function ReporteProblemasIngresosCtrl(NgTableParams, Util, $filter, ReporteProblemasIngresos, rol, anos, HeaderBarService, URL_SERVIDOR, $http, empresas, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.empresas = orderByFilter(empresas, "nombre", false);
    vm.anos = anos;

    var familias = [];
    var grupos = [];

    vm.armarReporte = armarReporte;
    vm.armarReporteExcel = armarReporteExcel;
    vm.volver = volver;
    
    if (rol.id!=1 && rol.id!=2 && rol.id!=3 && rol.id!=29) $state.go("home.home");

    function volver(){
      $state.go("home.lista-reportes");
    }

    function armarReporte(){
      ServicioDialogos.abrirDialogoCargando();
      mostrarReporte();
    }

    function armarReporteExcel(){
      ServicioDialogos.abrirDialogoCargando();
      ReporteProblemasIngresos.get({idEmpresa:vm.empresa.id, ano:vm.ano}, function(data){
        armarExcel(data);
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function armarExcel(data){
      var pagina1 = obtenerTotales(data);
      var pagina2 = obtenerDetalles(data);
      var pagina3 = obtenerTipoProblemaDetalles(data);
      var pagina4 = obtenerResumen(data);
//      console.log(pagina1, pagina2, pagina3, pagina4)
      var opts = [{sheetid:'Totales empresa',header:true}, {sheetid:'Totales por proveedor',header:true},{sheetid:'Detalle por proveedor',header:true},{sheetid:'Totales por problema',header:true}];
      var nombreDocumento = "problemas-ingresos-"+Util.quitarCaracteresEspeciales(vm.empresa.nombre.toUpperCase()+"-"+vm.ano);
      alasql.promise('SELECT INTO XLSX("'+nombreDocumento+'.xlsx",?) FROM ?',[opts,[pagina1, pagina2, pagina3, pagina4]])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function obtenerTotales(data){
      var totales = [];
      totales.push({
        "Empresa":data.empresa.nombre.toUpperCase(),
        "Año":data.ano,
        "Cantidad ingresos" : data.ingresosTotales,
        "Cantidad problemas" : data.problemas,
        "Porcentaje problemas": data.porcentajeProblemas
      });
      return totales.length>0 ? totales : [{"No hay datos":""}];
    }

    function obtenerResumen(data){
      var lista = $filter('orderBy')(data.resumenes, ['tipoProblema.nombre'], true);
      var totales = [];
      if (!lista) return totales;
      for (var i = lista.length - 1; i >= 0; i--) {
        totales.push({
          "Empresa":data.empresa.nombre.toUpperCase(),
          "Problema" : lista[i].tipoProblema.nombre.toUpperCase(),
          "Cantidad" : lista[i].cantidad
        });
      }
      return totales.length>0 ? totales : [{"No hay datos":""}];
    }

    function obtenerDetalles(data){
      var lista = $filter('orderBy')(data.detalles, ['proveedor.nombre'], true);
      var totales = [];
      for (var i = lista.length - 1; i >= 0; i--) {
        totales.push({
          "Empresa":data.empresa.nombre.toUpperCase(),
          "Proveedor":lista[i].proveedor.nombre.toUpperCase(),
          "Cantidad ingresos" : lista[i].cantidadIngresos,
          "Cantidad problemas" : lista[i].problemas,
          "Porcentaje problemas" : lista[i].porcentajeProblemas
        });
      }
      return totales.length>0 ? totales : [{"No hay datos":""}];
    }

    function obtenerTipoProblemaDetalles(data){
      var lista = $filter('orderBy')(data.detalles, ['sucursal.nombre'], true);
      var totales = [];
      var tipos = [];
      for (var i = lista.length - 1; i >= 0; i--) {
        tipos = $filter('orderBy')(lista[i].tipos, ['tipoProblema.nombre'], true);
        if (!tipos) continue;
        for (var j = tipos.length - 1; j >= 0; j--) {
          totales.push({
            "Empresa":data.empresa.nombre.toUpperCase(),
            "Proveedor":lista[i].proveedor.nombre.toUpperCase(),
            "Problema" : tipos[j].tipoProblema.nombre.toUpperCase(),
            "Cantidad" : tipos[j].cantidad
          });
        }
      }
      return totales.length>0 ? totales : [{"No hay datos":""}];
    }

    function mostrarReporte(lista){
      var Url = URL_SERVIDOR+"/reportes/problemas-ingresos/"+vm.empresa.id+"/"+vm.ano;
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.reporte-ingresos-salidas', {
        url: 'reporte-ingresos-salidas',
        templateUrl: 'app/app/main/reportes/reporte-ingresos-salidas/reporte-ingresos-salidas.html',
        controller: 'ReporteIngresosSalidasEntreFechasCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Reportes',
          subtitulo:'Reporte de ingresos y egresos entre fechas por tipo de suministro'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          empresas: function(Usuario, Empresa, $filter){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.empresa && usuario.empleado.empresa.id){
                var empresas = [];
                return Empresa.get({id:usuario.empleado.empresa.id}).$promise.then(function(empresa){
                  empresas.push(empresa);
                  return empresas;
                });
              } else {
                return Empresa.query().$promise.then(function(data) {
                  if (usuario.empleado && usuario.rol && usuario.rol.nombre=='CONSULTA' && usuario.empleado.empresas && usuario.empleado.empresas.length>0) {
                    var empresas = [];
                    data.forEach(function(empresa){
                      if (usuario.empleado.empresas.includes(empresa.id)){
                        empresas.push(empresa);
                      }
                    });
                    return $filter('orderBy')(empresas, 'nombre', false);
                  }
                  return data;
                });
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ReporteIngresosSalidasEntreFechasCtrl', ReporteIngresosSalidasEntreFechasCtrl);

  /** @ngInject */
  function ReporteIngresosSalidasEntreFechasCtrl(NgTableParams, Util, $filter, DetallesPorTipoSuministroEntreFechas, DetalleMovimientoGrupoFechas, focus, rol, HeaderBarService, URL_SERVIDOR, $http, empresas, $stateParams, StockTipoSuministroDeposito, $scope, orderByFilter, $state, GrupoEmpresa, TiposPorEmpresa, TipoSuministroFamilia, FamiliaSuministroGrupo, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.empresas = orderByFilter(empresas,'nombre',false);
    vm.fechaActual = new Date();

    vm.mostrarReporte = mostrarReporte;
    vm.validarFiltros = validarFiltros;
    vm.comprobarPeriodoFechas = comprobarPeriodoFechas;

    vm.mostrarReporteExcel = mostrarReporteExcel;
    vm.volver = volver;

    if (rol.id!=1 && rol.id!=2 && rol.id!=3 && rol.id!=29) $state.go("home.home");

    function mostrarReporteExcel(){
      ServicioDialogos.abrirDialogoCargando();
      DetallesPorTipoSuministroEntreFechas.query({idTipo:vm.tipoSuministro.id, fechaDesde:vm.fechaDesde, fechaHasta:vm.fechaHasta}, function(data){
        armarReporteExcel(data);
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function armarReporteExcel(data){
      var lista = $filter('orderBy')(obtenerDetalle(data), ['tipoSuministro.nombre', 'fecha', 'numeroMovimiento'], true);
      var totales = [];
      for (var i = lista.length - 1; i >= 0; i--) {
        totales.push({
          "Empresa" : lista[i].empresa.nombre.toUpperCase(),
          "Fecha" : $filter('date')(lista[i].fecha, "dd/MM/yyyy"),
          "Tipo movimiento": lista[i].movimiento,
          "Grupo suministro" : lista[i].tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
          "Familia suministro" : lista[i].tipoSuministro.familiaSuministro.nombre.toUpperCase(),
          "Código familia" : lista[i].tipoSuministro.familiaSuministro.codigoFamiliaSuministro.toUpperCase(),
          "Tipo suministro" : lista[i].tipoSuministro.nombre.toUpperCase(),
          "Código producto" : lista[i].tipoSuministro.codigoProducto.toUpperCase(),
          "Sucursal" : lista[i].sucursal,
          "Código sucursal" : lista[i].codigoSucursal,
          "Proveedor":lista[i].proveedor,
          "Cantidad" : lista[i].cantidad,
          /*"Precio total" : lista[i].precioTotal,*/
          "N° Movimiento": lista[i].numeroMovimiento,
          "Solicitante":lista[i].solicita,
          "Autorizó":lista[i].solicitante
        });
      }
      var nombreDocumento = "movimientos-"+Util.quitarCaracteresEspeciales(vm.tipoSuministro.nombre.toUpperCase())+"-"+$filter('date')(vm.fechaDesde, "dd-MM-yyyy")+"--"+$filter('date')(vm.fechaHasta, "dd-MM-yyyy");
      alasql.promise('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true,sheetid:"Ingresos"}) FROM ?',[totales])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function obtenerDetalle(data){
      var lista = [];
      var ban = false;
      var solicita;
      var solicitante;
      var proveedor;
      var codigoSucursal;
      var sucursal;
      var cantidad;
      var movimiento;
      data.forEach(function(detalle){
        lista.forEach(function(item){
          if (item.tipoSuministro.id==detalle.suministro.tipoSuministro.id && detalle.movimiento.numeroMovimiento==item.numeroMovimiento){
            ban = true;
            item.cantidad += detalle.cantidad;
            item.precioTotal += detalle.suministro.precioUnitario*detalle.cantidad;
          }
        });
        movimiento = detalle.movimiento.tipoMovimiento.id==1?"EGRESO":"INGRESO";
        solicitante = detalle.movimiento.solicitante? detalle.movimiento.solicitante.toUpperCase():"-";
        proveedor = detalle.movimiento.proveedor? detalle.movimiento.proveedor.nombre.toUpperCase():"-";
        sucursal = detalle.movimiento.sucursal? detalle.movimiento.sucursal.nombre.toUpperCase():"-";
        codigoSucursal = detalle.movimiento.sucursal? detalle.movimiento.sucursal.codigoSucursal.toUpperCase():"-";
        solicita = detalle.movimiento.solicita?detalle.movimiento.solicita.apellido.toUpperCase()+", "+detalle.movimiento.solicita.nombre.toUpperCase():"-";
        if (!ban){
          lista.push({movimiento:movimiento, solicitante: solicitante, empresa:detalle.movimiento.empresa, tipoSuministro:detalle.suministro.tipoSuministro, cantidad:detalle.cantidad, proveedor:proveedor, sucursal: sucursal, codigoSucursal:codigoSucursal, solicita:solicita, precioTotal:detalle.suministro.precioUnitario*detalle.cantidad, numeroMovimiento:detalle.movimiento.numeroMovimiento, fecha:detalle.movimiento.fecha});
        }
        ban = false;
      });
      return lista;
    }

    function comprobarPeriodoFechas(){
      return  (((vm.fechaHasta - vm.fechaDesde)/86400000)<=550);
    }

    function volver(){
      $state.go("home.lista-reportes");
    }

    function obtenerUrl(){
      return URL_SERVIDOR+"/reportes/ingresosSalidas?idTipo="+vm.tipoSuministro.id+"&&fechaDesde="+vm.fechaDesde+"&&fechaHasta="+vm.fechaHasta;
    }

    function mostrarReporte(){
      ServicioDialogos.abrirDialogoCargando();
      var Url = obtenerUrl();
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function validarFiltros(){
      return (vm.empresa && vm.empresa.id) && (vm.fechaDesde && vm.fechaHasta);
    }

    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.dismiss();
    }

    $scope.$watch('vm.grupo.nombre', function(){
      if (vm.familiaSuministro) vm.familiaSuministro=null;
      if (!vm.grupo) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupo.id}, function(data){
        vm.familias = orderByFilter(data,'nombre',false);
        focus('familia');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.familiaSuministro.nombre', function(){
      if (vm.tipoSuministro) vm.tipoSuministro=null;
      if (!vm.familiaSuministro) return;
      ServicioDialogos.abrirDialogoCargando();
      TipoSuministroFamilia.query({id:vm.familiaSuministro.id}, function(data){
        vm.tipos = orderByFilter(data,'nombre',false);
        focus('tipo');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.empresa.id', function(){
      if (vm.grupo) vm.grupo=null;
      if (vm.tipoSuministroCompleto) vm.tipoSuministroCompleto=null;
      if (!vm.empresa) return;
      ServicioDialogos.abrirDialogoCargando();
      GrupoEmpresa.query({id:vm.empresa.id}, function(data){
        vm.grupos = orderByFilter(data,'nombre',false);
        focus('fechaDesde');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.reporte-ingresos-remito-orden', {
        url: 'reporte-ingresos-remito-orden',
        templateUrl: 'app/app/main/reportes/reporte-ingresos-remito-orden/reporte-ingresos-remito-orden.html',
        controller: 'ReporteIngresosRemitoOrdenCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Reportes',
          subtitulo:'Reporte de ingresos por número de remito u orden de compra'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          empresas: function(Usuario, Empresa, $filter){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.empresa && usuario.empleado.empresa.id){
                var empresas = [];
                return Empresa.get({id:usuario.empleado.empresa.id}).$promise.then(function(empresa){
                  empresas.push(empresa);
                  return empresas;
                });
              } else {
                return Empresa.query().$promise.then(function(data) {
                  if (usuario.empleado && usuario.rol && usuario.rol.nombre=='CONSULTA' && usuario.empleado.empresas && usuario.empleado.empresas.length>0) {
                    var empresas = [];
                    data.forEach(function(empresa){
                      if (usuario.empleado.empresas.includes(empresa.id)){
                        empresas.push(empresa);
                      }
                    });
                    return $filter('orderBy')(empresas, 'nombre', false);
                  }
                  return data;
                });
              }
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          deposito: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return usuario.empleado.deposito;
              } else {
                return ;
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ReporteIngresosRemitoOrdenCtrl', ReporteIngresosRemitoOrdenCtrl);

  /** @ngInject */
  function ReporteIngresosRemitoOrdenCtrl(NgTableParams, depositos, focus, deposito, rol, ProveedorEmpresa, MovimientosEmpresaDepositoProveedorTipoNumeroOrdenCompra, MovimientosEmpresaDepositoTipoNumeroRemito, HeaderBarService, $http, empresas, $stateParams, $scope, orderByFilter, $state, ServicioModales, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.empresas = orderByFilter(empresas,'nombre',false);
    vm.depositos = orderByFilter(depositos,'nombre',false);

    vm.validarFiltros = validarFiltros;
    vm.buscarIngresos = buscarIngresos;
    vm.volver = volver;
    vm.cambioRadio = cambioRadio;

    vm.radio = 'numeroOrden';

    if (rol.id!=1 && rol.id!=2 && rol.id!=3 && rol.id!=29) $state.go("home.home");

    function volver(){
      $state.go("home.lista-reportes");
    }

    function buscarIngresosPorNumeroOrden(){
      ServicioDialogos.abrirDialogoCargando();
      MovimientosEmpresaDepositoProveedorTipoNumeroOrdenCompra.query({numeroOrden:vm.numeroOrden,idDeposito:vm.deposito.id, idProveedor:vm.proveedor.id, idEmpresa:vm.empresa.id, idTipo:2}, function(data){
        ServicioDialogos.cerrarDialogoCargando();
        mostrarIngresos(data);
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
      });
    }

    function buscarIngresosPorNumeroRemito(){
      ServicioDialogos.abrirDialogoCargando();
      MovimientosEmpresaDepositoTipoNumeroRemito.query({numeroRemito:vm.numeroRemito,idDeposito:vm.deposito.id, idEmpresa:vm.empresa.id, idTipo:2}, function(data){
        ServicioDialogos.cerrarDialogoCargando();
        mostrarIngresos(data);
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
      });
    }

    function mostrarIngresos(data){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalIngresosRemitoOrden({
        onResult: function(res){
        },
        ingresos: data,
        empresa: vm.empresa,
        deposito: vm.deposito
      });
    }

    function buscarIngresos(){
      if (vm.radio=='numeroOrden'){
        buscarIngresosPorNumeroOrden();
      } else {
        buscarIngresosPorNumeroRemito();
      }
    }

    function validarFiltros(){
      return (vm.empresa && vm.empresa.id) && (vm.deposito && vm.deposito.id) && (((vm.numeroOrden!=null || vm.numeroOrden!=undefined) && (vm.proveedor && vm.proveedor.id)) || (vm.numeroRemito!=null || vm.numeroRemito!=undefined));
    }

    function cambioRadio(){
      if (vm.radio=='numeroOrden'){
        vm.numeroRemito=null;
        focus('proveedor');
      } else {
        vm.numeroOrden = null;
        vm.proveedor=null;
        focus('numeroRemito');
      }
    }

    $scope.$watch('vm.empresa.nombre', function(){
      if (!vm.empresa) return;
      if (vm.proveedor) vm.proveedor=null;
      ServicioDialogos.abrirDialogoCargando();
      ProveedorEmpresa.query({'empresa':vm.empresa.id}, function(data){
        vm.proveedores = data;
        focus('proveedor');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.reporte-ingresos-entre-fechas', {
        url: 'reporte-ingresos-entre-fechas',
        templateUrl: 'app/app/main/reportes/reporte-ingresos-entre-fechas/reporte-ingresos-entre-fechas.html',
        controller: 'ReporteIngresosEntreFechasCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Reportes',
          subtitulo:'Reporte de ingresos de suministros entre fechas'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          empresas: function(Usuario, Empresa, $filter){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.empresa && usuario.empleado.empresa.id){
                var empresas = [];
                return Empresa.get({id:usuario.empleado.empresa.id}).$promise.then(function(empresa){
                  empresas.push(empresa);
                  return empresas;
                });
              } else {
                return Empresa.query().$promise.then(function(data) {
                  if (usuario.empleado && usuario.rol && usuario.rol.nombre=='CONSULTA' && usuario.empleado.empresas && usuario.empleado.empresas.length>0) {
                    var empresas = [];
                    data.forEach(function(empresa){
                      if (usuario.empleado.empresas.includes(empresa.id)){
                        empresas.push(empresa);
                      }
                    });
                    return $filter('orderBy')(empresas, 'nombre', false);
                  }
                  return data;
                });
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ReporteIngresosEntreFechasCtrl', ReporteIngresosEntreFechasCtrl);

  /** @ngInject */
  function ReporteIngresosEntreFechasCtrl(NgTableParams, Util, $filter, DetalleMovimientoFamiliaFechas, focus, rol, HeaderBarService, URL_SERVIDOR, $http, empresas, $stateParams, StockTipoSuministroDeposito, $scope, orderByFilter, $state, GrupoEmpresa, TiposPorEmpresa, TipoSuministroFamilia, FamiliaSuministroGrupo, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.empresas = orderByFilter(empresas,'nombre',false);
    vm.fechaActual = new Date();

    vm.mostrarReporte = mostrarReporte;
    vm.mostrarReporteExcel = mostrarReporteExcel;
    vm.validarFiltros = validarFiltros;
    vm.comprobarPeriodoFechas = comprobarPeriodoFechas;
    vm.volver = volver;

    if (rol.id!=1 && rol.id!=2 && rol.id!=3 && rol.id!=29) $state.go("home.home");

    function mostrarReporteExcel(){
      ServicioDialogos.abrirDialogoCargando();
      DetalleMovimientoFamiliaFechas.query({idEmpresa:vm.empresa.id, fechaDesde:vm.fechaDesde, fechaHasta:vm.fechaHasta, idTipoMovimiento: 2, idFamilia:vm.familiaSuministro.id}, function(data){
        armarReporteGrupoDetalleExcel(data);
        //console.log(data);
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function armarReporteGrupoDetalleExcel(data){
      var lista = $filter('orderBy')(obtenerDetalle(data), ['tipoSuministro.nombre', 'numeroMovimiento'], true);
      var totales = [];
      for (var i = lista.length - 1; i >= 0; i--) {
        totales.push({
          "Empresa" : lista[i].empresa.nombre.toUpperCase(),
          "Fecha" : $filter('date')(lista[i].fecha, "dd/MM/yyyy"),
          "Grupo suministro" : lista[i].tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
          "Familia suministro" : lista[i].tipoSuministro.familiaSuministro.nombre.toUpperCase(),
          "Código familia" : lista[i].tipoSuministro.familiaSuministro.codigoFamiliaSuministro.toUpperCase(),
          "Tipo suministro" : lista[i].tipoSuministro.nombre.toUpperCase(),
          "Código producto" : lista[i].tipoSuministro.codigoProducto.toUpperCase(),
          "Cantidad" : lista[i].cantidad,
          "Precio total" : lista[i].precioTotal,
          "N° Movimiento": lista[i].numeroMovimiento,
          "Proveedor":lista[i].proveedor,
          "Autorizó":lista[i].solicita
        });
      }
      var nombreDocumento = "ingresos-"+Util.quitarCaracteresEspeciales(vm.familiaSuministro.nombre.toUpperCase())+"-"+$filter('date')(vm.fechaDesde, "dd-MM-yyyy")+"--"+$filter('date')(vm.fechaHasta, "dd-MM-yyyy");
      alasql.promise('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true,sheetid:"Ingresos"}) FROM ?',[totales])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function obtenerDetalle(data){
      var lista = [];
      var ban = false;
      var solicita;
      data.forEach(function(detalle){
        lista.forEach(function(item){
          if (item.tipoSuministro.id==detalle.suministro.tipoSuministro.id && detalle.movimiento.numeroMovimiento==item.numeroMovimiento){
            ban = true;
            item.cantidad += detalle.cantidad;
            item.precioTotal += detalle.suministro.precioUnitario*detalle.cantidad;
          }
        });
        solicita = detalle.movimiento.solicita?detalle.movimiento.solicita.apellido.toUpperCase()+", "+detalle.movimiento.solicita.nombre.toUpperCase():detalle.movimiento.solicitante?detalle.movimiento.solicitante.toUpperCase():"-";
        if (!ban){
          lista.push({empresa:detalle.movimiento.empresa, tipoSuministro:detalle.suministro.tipoSuministro, cantidad:detalle.cantidad, proveedor:detalle.movimiento.proveedor.nombre.toUpperCase(), solicita:solicita, precioTotal:detalle.suministro.precioUnitario*detalle.cantidad, numeroMovimiento:detalle.movimiento.numeroMovimiento, fecha:detalle.movimiento.fecha});
        }
        ban = false;
      });
      return lista;
    }


    function comprobarPeriodoFechas(){
      return  (((vm.fechaHasta - vm.fechaDesde)/86400000)<=550);
    }

    function volver(){
      $state.go("home.lista-reportes");
    }

    function obtenerUrl(){
        return URL_SERVIDOR+"/reportes/movimientosEntreFechas?idEmpresa="+vm.empresa.id+"&&fechaDesde="+vm.fechaDesde+"&&fechaHasta="+vm.fechaHasta+"&&idFamilia="+vm.familiaSuministro.id+"&&tipo="+false;
    }

    function mostrarReporte(){
      ServicioDialogos.abrirDialogoCargando();
      var Url = obtenerUrl();
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function validarFiltros(){
      return (vm.empresa && vm.empresa.id) && (vm.fechaDesde && vm.fechaHasta);
    }

    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.dismiss();
    }

    $scope.$watch('vm.grupo.nombre', function(){
      if (vm.familiaSuministro) vm.familiaSuministro=null;
      if (!vm.grupo) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupo.id}, function(data){
        vm.familias = orderByFilter(data,'nombre',false);
        focus('familia');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.empresa.id', function(){
      if (vm.grupo) vm.grupo=null;
      if (vm.tipoSuministroCompleto) vm.tipoSuministroCompleto=null;
      if (!vm.empresa) return;
      ServicioDialogos.abrirDialogoCargando();
      GrupoEmpresa.query({id:vm.empresa.id}, function(data){
        vm.grupos = orderByFilter(data,'nombre',false);
        focus('fechaDesde');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.reporte-existencias', {
        url: 'reporte-existencias',
        templateUrl: 'app/app/main/reportes/reporte-existencias/reporte-existencias.html',
        controller: 'ReporteExistenciasCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Reportes',
          subtitulo:'Reporte de existencias de un depósito y para una empresa'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          empresas: function(Usuario, Empresa, $filter){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.empresa && usuario.empleado.empresa.id){
                var empresas = [];
                return Empresa.get({id:usuario.empleado.empresa.id}).$promise.then(function(empresa){
                  empresas.push(empresa);
                  return empresas;
                });
              } else {
                return Empresa.query().$promise.then(function(data) {
                  if (usuario.empleado && usuario.rol && usuario.rol.nombre=='CONSULTA' && usuario.empleado.empresas && usuario.empleado.empresas.length>0) {
                    var empresas = [];
                    data.forEach(function(empresa){
                      if (usuario.empleado.empresas.includes(empresa.id)){
                        empresas.push(empresa);
                      }
                    });
                    return $filter('orderBy')(empresas, 'nombre', false);
                  }
                  return data;
                });
              }
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          deposito: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return usuario.empleado.deposito;
              } else {
                return ;
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ReporteExistenciasCtrl', ReporteExistenciasCtrl);

  /** @ngInject */
  function ReporteExistenciasCtrl(NgTableParams, deposito, Util, rol, $filter, SuministroDepositoEmpresaInventariables, SuministroDepositoEmpresaExistencias, HeaderBarService, URL_SERVIDOR, $http, empresas, depositos, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.util = Util;
    vm.depositos = orderByFilter(depositos, "nombre", false);
    vm.deposito = deposito;
    vm.empresas = orderByFilter(empresas, "nombre", false);

    vm.mostrarReporte = mostrarReporte;
    vm.mostrarReporteInventariables = mostrarReporteInventariables;
    vm.mostrarReporteInventariablesExcel = mostrarReporteInventariablesExcel;
    vm.mostrarReporteExcel = mostrarReporteExcel;
    vm.volver = volver;
    
    if (rol.id!=1 && rol.id!=2 && rol.id!=3 && rol.id!=29) $state.go("home.home");

    function volver(){
      $state.go("home.lista-reportes");
    }

    function mostrarReporteExcel(){
      ServicioDialogos.abrirDialogoCargando();
      SuministroDepositoEmpresaExistencias.query({idDeposito:vm.deposito.id, idEmpresa: vm.empresa.id}, function(data) {
        armarExcelExistencias(data);
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function mostrarReporteInventariablesExcel(){
      ServicioDialogos.abrirDialogoCargando();
      SuministroDepositoEmpresaInventariables.query({idDeposito:vm.deposito.id, idEmpresa: vm.empresa.id}, function(data) {
        armarExcelExistenciasInventariables(data);
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function obtenerInventariablesDetallado(data){
      data = $filter('orderBy')(data, ['suministro.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre', 'suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre', 'suministro.tipoSuministro.familiaSuministro.nombre', 'suministro.tipoSuministro.nombre'], true);
      var detallados = [];
      var nuevo;
      var marca;
      for (var j = data.length - 1; j >= 0; j--){
        nuevo = data[j].nuevo? "SI" : "NO";
        marca = data[j].suministro.marca? data[j].suministro.marca.toUpperCase() : "-";
        detallados.push({
          "Empresa" : data[j].suministro.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase(),
          "Grupo suministro" : data[j].suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
          "Familia suministro" : data[j].suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase(),
          "Código familia suministro" : data[j].suministro.tipoSuministro.familiaSuministro.codigoFamiliaSuministro.toUpperCase(),
          "Tipo suministro" : data[j].suministro.tipoSuministro.nombre.toUpperCase(),
          "Código tipo suministro" : data[j].suministro.tipoSuministro.codigoProducto.toUpperCase(),
          "Inventario" : data[j].inventario,
          "Serie" : data[j].serie,
          "Marca" : marca,
          "Nuevo" : nuevo
        });
      }
      return detallados.length>0 ? detallados : [{"No hay datos":""}];
    }

    function obtenerInventariablesTotales(data){
      var lista = $filter('orderBy')(obtenerInventariables(data), ['tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre', 'tipoSuministro.familiaSuministro.grupoSuministro.nombre', 'tipoSuministro.familiaSuministro.nombre', 'tipoSuministro.nombre'], true);
      var totales = [];
      for (var i = lista.length - 1; i >= 0; i--) {
        totales.push({
          "Empresa" : lista[i].tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase(),
          "Grupo suministro" : lista[i].tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
          "Familia suministro" : lista[i].tipoSuministro.familiaSuministro.nombre.toUpperCase(),
          "Código familia suministro" : lista[i].tipoSuministro.familiaSuministro.codigoFamiliaSuministro.toUpperCase(),
          "Tipo suministro" : lista[i].tipoSuministro.nombre.toUpperCase(),
          "Código tipo suministro" : lista[i].tipoSuministro.codigoProducto.toUpperCase(),
          "Cantidad total" : lista[i].cantidad,
          "Cant. regular": lista[i].cantidadRegular,
          "Cant. donación": lista[i].cantidadDonacion,
          "Cant. scrap-reparación": lista[i].cantidadScrap
        });
      }
      return totales.length>0 ? totales : [{"No hay datos":""}];
    }

    function armarExcelExistenciasInventariables(data){
      var pagina1 = obtenerInventariablesTotales(data);
      var pagina2 = obtenerInventariablesDetallado(data);
      var opts = [{sheetid:'Totales',header:true}, {sheetid:'Detallado',header:true}];
      var nombreDocumento = vm.empresa ? "existencias-inventariables-"+vm.util.quitarCaracteresEspeciales(vm.empresa.nombre.toUpperCase()) : "existencias-inventariables";
      alasql.promise('SELECT INTO XLSX("'+nombreDocumento+'.xlsx",?) FROM ?',[opts,[pagina1, pagina2]])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function obtenerInventariables(data){
      var lista = [];
      var ban = false;
      data.forEach(function(inventariable){
        lista.forEach(function(item){
          if (item.tipoSuministro.id==inventariable.suministro.tipoSuministro.id){
            ban = true;
            item.cantidad += inventariable.suministro.cantidad;
            if (inventariable.suministro.estadoSuministro && (inventariable.suministro.estadoSuministro.id==2 || inventariable.suministro.estadoSuministro.id==3)) item.cantidadRegular += inventariable.suministro.cantidad;
            if (inventariable.suministro.estadoSuministro && (inventariable.suministro.estadoSuministro.id==4 || inventariable.suministro.estadoSuministro.id==6)) item.cantidadDonacion += inventariable.suministro.cantidad;
            if (inventariable.suministro.estadoSuministro && (inventariable.suministro.estadoSuministro.id==7 || inventariable.suministro.estadoSuministro.id==9)) item.cantidadScrap += inventariable.suministro.cantidad;
          }
        });
        if (!ban){
          lista.push({tipoSuministro:inventariable.suministro.tipoSuministro, cantidad:inventariable.suministro.cantidad, cantidadRegular: inventariable.suministro.estadoSuministro.id==2 || inventariable.suministro.estadoSuministro.id==3?inventariable.suministro.cantidad:0, cantidadDonacion:inventariable.suministro.estadoSuministro.id==4 || inventariable.suministro.estadoSuministro.id==6?inventariable.suministro.cantidad:0, cantidadScrap:inventariable.suministro.estadoSuministro.id==7 || inventariable.suministro.estadoSuministro.id==9?inventariable.suministro.cantidad:0});
        }
        ban = false;
      });
      return lista;
    }

    function obtenerTotales(data){
      var lista = [];
      var ban = false;
      data.forEach(function(suministro){
        lista.forEach(function(item){
          if (item.tipoSuministro.id==suministro.tipoSuministro.id){
            ban = true;
            item.cantidad += suministro.cantidad;
            if (suministro.estadoSuministro && (suministro.estadoSuministro.id==2 || suministro.estadoSuministro.id==3)) item.cantidadRegular += suministro.cantidad;
            if (suministro.estadoSuministro && (suministro.estadoSuministro.id==4 || suministro.estadoSuministro.id==6)) item.cantidadDonacion += suministro.cantidad;
            if (suministro.estadoSuministro && (suministro.estadoSuministro.id==7 || suministro.estadoSuministro.id==9)) item.cantidadScrap += suministro.cantidad;
          }
        });
        if (!ban){
          lista.push({tipoSuministro:suministro.tipoSuministro, cantidad:suministro.cantidad, cantidadRegular: suministro.estadoSuministro.id==2 || suministro.estadoSuministro.id==3?suministro.cantidad:0, cantidadDonacion:suministro.estadoSuministro.id==4 || suministro.estadoSuministro.id==6?suministro.cantidad:0, cantidadScrap:suministro.estadoSuministro.id==7 || suministro.estadoSuministro.id==9?suministro.cantidad:0});
        }
        ban = false;
      });
      return lista;
    }

    function armarExcelExistencias(data){
      var lista = $filter('orderBy')(obtenerTotales(data), ['tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre', 'tipoSuministro.familiaSuministro.grupoSuministro.nombre', 'tipoSuministro.familiaSuministro.nombre', 'tipoSuministro.nombre'], true);
      var array = [];
      for (var i = lista.length - 1; i >= 0; i--) {
        array.push({
          "Empresa" : lista[i].tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase(),
          "Grupo suministro" : lista[i].tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
          "Familia suministro" : lista[i].tipoSuministro.familiaSuministro.nombre.toUpperCase(),
          "Código familia suministro" : lista[i].tipoSuministro.familiaSuministro.codigoFamiliaSuministro.toUpperCase(),
          "Tipo suministro" : lista[i].tipoSuministro.nombre.toUpperCase(),
          "Código tipo suministro" : lista[i].tipoSuministro.codigoProducto.toUpperCase(),
          "Cantidad total" : lista[i].cantidad,
          "Cant. regular": lista[i].cantidadRegular,
          "Cant. donación": lista[i].cantidadDonacion,
          "Cant. scrap-reparación": lista[i].cantidadScrap
        });
      }
      if (array.length<=0) array.push({"No hay datos":""});
      var nombreDocumento = vm.empresa ? "existencias-"+vm.util.quitarCaracteresEspeciales(vm.empresa.nombre.toUpperCase()) : "existencias";
      alasql.promise('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true,sheetid:"Existencias"}) FROM ?',[array])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function mostrarReporteInventariables(){
      ServicioDialogos.abrirDialogoCargando();
      var Url = URL_SERVIDOR+"/reportes/existencias-inventariables/"+vm.deposito.id+"/"+vm.empresa.id;
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function mostrarReporte(){
      ServicioDialogos.abrirDialogoCargando();
      var Url = URL_SERVIDOR+"/reportes/suministros/"+vm.deposito.id+"/"+vm.empresa.id;
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }
    
    
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.reporte-existencias-donacion-scrap', {
        url: 'reporte-existencias-donacion-scrap',
        templateUrl: 'app/app/main/reportes/reporte-existencias-donacion-scrap/reporte-existencias-donacion-scrap.html',
        controller: 'ReporteExistenciasDonacionScrapCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Reportes',
          subtitulo:'Reporte de existencias de un depósito y para una empresa de suministros para donación o scrap-reparación'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          empresas: function(Usuario, Empresa, $filter){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.empresa && usuario.empleado.empresa.id){
                var empresas = [];
                return Empresa.get({id:usuario.empleado.empresa.id}).$promise.then(function(empresa){
                  empresas.push(empresa);
                  return empresas;
                });
              } else {
                return Empresa.query().$promise.then(function(data) {
                  if (usuario.empleado && usuario.rol && usuario.rol.nombre=='CONSULTA' && usuario.empleado.empresas && usuario.empleado.empresas.length>0) {
                    var empresas = [];
                    data.forEach(function(empresa){
                      if (usuario.empleado.empresas.includes(empresa.id)){
                        empresas.push(empresa);
                      }
                    });
                    return $filter('orderBy')(empresas, 'nombre', false);
                  }
                  return data;
                });
              }
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          deposito: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return usuario.empleado.deposito;
              } else {
                return ;
              }
            });
          },
          tipos: function(){
            var tipos = [];
            tipos.push({nombre:"DONACIÓN", id:3});
            tipos.push({nombre:"SCRAP-REPARACIÓN", id:4});
            return tipos;
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ReporteExistenciasDonacionScrapCtrl', ReporteExistenciasDonacionScrapCtrl);

  /** @ngInject */
  function ReporteExistenciasDonacionScrapCtrl(NgTableParams, Util, $filter, ListaExistenciasDonacionScrap, ListaInventariablesDonacionScrap, deposito, rol, HeaderBarService, tipos, URL_SERVIDOR, $http, empresas, depositos, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.depositos = orderByFilter(depositos, "nombre", false);
    vm.deposito = deposito;
    vm.tipos = tipos;
    vm.empresas = orderByFilter(empresas, "nombre", false);

    vm.mostrarReporteTotales = mostrarReporteTotales;
    vm.mostrarReporteTotalesExcel = mostrarReporteTotalesExcel;

    vm.mostrarReporteDetalladoInventariables = mostrarReporteDetalladoInventariables;
    vm.mostrarReporteDetalladoInventariablesExcel = mostrarReporteDetalladoInventariablesExcel;
    vm.volver = volver;
    
    if (rol.id!=1 && rol.id!=2 && rol.id!=3 && rol.id!=29) $state.go("home.home");

    function volver(){
      $state.go("home.lista-reportes");
    }

    function mostrarReporteDetalladoInventariablesExcel(){
      ServicioDialogos.abrirDialogoCargando();
      ListaInventariablesDonacionScrap.query({idDeposito:vm.deposito.id, idEmpresa:vm.empresa.id, idTipoStock:vm.tipoStock.id}, function(data){
        armarExcelExistenciasInventariables(data);
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function obtenerInventariablesDetallado(data){
      data = $filter('orderBy')(data, ['suministro.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre', 'suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre', 'suministro.tipoSuministro.familiaSuministro.nombre', 'suministro.tipoSuministro.nombre'], true);
      var detallados = [];
      var nuevo;
      var marca;
      for (var j = data.length - 1; j >= 0; j--){
        marca = data[j].suministro.marca? data[j].suministro.marca.toUpperCase() : "-";
        detallados.push({
          "Empresa" : data[j].suministro.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase(),
          "Grupo suministro" : data[j].suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
          "Familia suministro" : data[j].suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase(),
          "Código familia" : data[j].suministro.tipoSuministro.familiaSuministro.codigoFamiliaSuministro.toUpperCase(),
          "Tipo suministro" : data[j].suministro.tipoSuministro.nombre.toUpperCase(),
          "Código producto" : data[j].suministro.tipoSuministro.codigoProducto.toUpperCase(),
          "Inventario" : data[j].inventario,
          "Serie" : data[j].serie,
          "Marca" : marca
        });
      }
      return detallados;
    }

    function obtenerInventariablesTotales(data){
      var lista = $filter('orderBy')(obtenerInventariables(data), ['tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre', 'tipoSuministro.familiaSuministro.grupoSuministro.nombre', 'tipoSuministro.familiaSuministro.nombre', 'tipoSuministro.nombre'], true);
      var totales = [];
      for (var i = lista.length - 1; i >= 0; i--) {
        totales.push({
          "Empresa" : lista[i].tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase(),
          "Grupo suministro" : lista[i].tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
          "Familia suministro" : lista[i].tipoSuministro.familiaSuministro.nombre.toUpperCase(),
          "Código familia" : lista[i].tipoSuministro.familiaSuministro.codigoFamiliaSuministro.toUpperCase(),
          "Tipo suministro" : lista[i].tipoSuministro.nombre.toUpperCase(),
          "Código producto" : lista[i].tipoSuministro.codigoProducto.toUpperCase(),
          "Cantidad" : lista[i].cantidad
        });
      }
      return totales;
    }

    function armarExcelExistenciasInventariables(data){
      var pagina1 = obtenerInventariablesTotales(data);
      var pagina2 = obtenerInventariablesDetallado(data);
      var opts = [{sheetid:'Totales '+vm.tipoStock.nombre.toUpperCase(),header:true}, {sheetid:'Detallado '+vm.tipoStock.nombre.toUpperCase(),header:true}];
      var nombreDocumento = "existencias-inventariables-"+Util.quitarCaracteresEspeciales(vm.tipoStock.nombre.toUpperCase()+"-"+vm.empresa.nombre.toUpperCase());
      alasql.promise('SELECT INTO XLSX("'+nombreDocumento+'.xlsx",?) FROM ?',[opts,[pagina1, pagina2]])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function obtenerInventariables(data){
      var lista = [];
      var ban = false;
      data.forEach(function(inventariable){
        lista.forEach(function(item){
          if (item.tipoSuministro.id==inventariable.suministro.tipoSuministro.id){
            ban = true;
            item.cantidad += inventariable.suministro.cantidad;
          }
        });
        if (!ban){
          lista.push({tipoSuministro:inventariable.suministro.tipoSuministro, cantidad:inventariable.suministro.cantidad});
        }
        ban = false;
      });
      return lista;
    }

    function mostrarReporteTotalesExcel(){
      ServicioDialogos.abrirDialogoCargando();
      ListaExistenciasDonacionScrap.query({idDeposito:vm.deposito.id, idEmpresa:vm.empresa.id, idTipoStock:vm.tipoStock.id}, function(data){
        armarExcelTotales(data);
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function obtenerTotales(data){
      var lista = [];
      var ban = false;
      data.forEach(function(suministro){
        lista.forEach(function(item){
          if (item.tipoSuministro.id==suministro.tipoSuministro.id){
            ban = true;
            item.cantidad += suministro.cantidad;
          }
        });
        if (!ban){
          lista.push({tipoSuministro:suministro.tipoSuministro, cantidad:suministro.cantidad});
        }
        ban = false;
      });
      return lista;
    }

    function armarExcelTotales(data){
      var lista = $filter('orderBy')(obtenerTotales(data), ['tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre', 'tipoSuministro.familiaSuministro.grupoSuministro.nombre', 'tipoSuministro.familiaSuministro.nombre', 'tipoSuministro.nombre'], true);
      var array = [];
      for (var i = lista.length - 1; i >= 0; i--) {
        array.push({
          "Empresa" : lista[i].tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase(),
          "Grupo suministro" : lista[i].tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
          "Familia suministro" : lista[i].tipoSuministro.familiaSuministro.nombre.toUpperCase(),
          "Código familia" : lista[i].tipoSuministro.familiaSuministro.codigoFamiliaSuministro.toUpperCase(),
          "Tipo suministro" : lista[i].tipoSuministro.nombre.toUpperCase(),
          "Código producto" : lista[i].tipoSuministro.codigoProducto.toUpperCase(),
          "Cantidad" : lista[i].cantidad
        });
      }
      var nombreDocumento = "existencias-"+Util.quitarCaracteresEspeciales(vm.tipoStock.nombre.toUpperCase()+"-"+vm.empresa.nombre.toUpperCase());
      alasql.promise('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true,sheetid:"Existencias '+vm.tipoStock.nombre.toUpperCase()+'"}) FROM ?',[array])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }


    function mostrarReporteDetalladoInventariables(){
      ServicioDialogos.abrirDialogoCargando();
      var Url = URL_SERVIDOR+"/reportes/inventariables-donacion-scrap/"+vm.deposito.id+"/"+vm.empresa.id+"/"+vm.tipoStock.id;
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function mostrarReporteTotales(){
      ServicioDialogos.abrirDialogoCargando();
      var Url = URL_SERVIDOR+"/reportes/existencias-donacion-scrap/"+vm.deposito.id+"/"+vm.empresa.id+"/"+vm.tipoStock.id;
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }
    
    
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.reporte-entregas-entre-fechas', {
        url: 'reporte-entregas-entre-fechas',
        templateUrl: 'app/app/main/reportes/reporte-entregas-entre-fechas/reporte-entregas-entre-fechas.html',
        controller: 'ReporteEntregasEntreFechasCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Reportes',
          subtitulo:'Reporte de entregas de suministros entre fechas'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          empresas: function(Usuario, Empresa, $filter){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.empresa && usuario.empleado.empresa.id){
                var empresas = [];
                return Empresa.get({id:usuario.empleado.empresa.id}).$promise.then(function(empresa){
                  empresas.push(empresa);
                  return empresas;
                });
              } else {
                return Empresa.query().$promise.then(function(data) {
                  if (usuario.empleado && usuario.rol && usuario.rol.nombre=='CONSULTA' && usuario.empleado.empresas && usuario.empleado.empresas.length>0) {
                    var empresas = [];
                    data.forEach(function(empresa){
                      if (usuario.empleado.empresas.includes(empresa.id)){
                        empresas.push(empresa);
                      }
                    });
                    return $filter('orderBy')(empresas, 'nombre', false);
                  }
                  return data;
                });
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ReporteEntregasEntreFechasCtrl', ReporteEntregasEntreFechasCtrl);

  /** @ngInject */
  function ReporteEntregasEntreFechasCtrl(NgTableParams, Util, $filter, DetalleMovimientoFamiliaFechas, DetalleMovimientoGrupoFechas, focus, rol, HeaderBarService, URL_SERVIDOR, $http, empresas, $stateParams, StockTipoSuministroDeposito, $scope, orderByFilter, $state, GrupoEmpresa, TiposPorEmpresa, TipoSuministroFamilia, FamiliaSuministroGrupo, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.empresas = orderByFilter(empresas,'nombre',false);
    vm.fechaActual = new Date();

    vm.mostrarReporte = mostrarReporte;
    vm.validarFiltros = validarFiltros;
    vm.mostrarReporteGrupoDetalle = mostrarReporteGrupoDetalle;
    vm.mostrarReporteTotales = mostrarReporteTotales;
    vm.comprobarPeriodoFechas = comprobarPeriodoFechas;

    vm.mostrarReporteGrupoDetalleExcel = mostrarReporteGrupoDetalleExcel;
    vm.mostrarReporteTotalesExcel = mostrarReporteTotalesExcel;
    vm.mostrarReporteExcel = mostrarReporteExcel;
    vm.volver = volver;

    if (rol.id!=1 && rol.id!=2 && rol.id!=3 && rol.id!=29) $state.go("home.home");

    function mostrarReporteExcel(){
      ServicioDialogos.abrirDialogoCargando();
      DetalleMovimientoFamiliaFechas.query({idEmpresa:vm.empresa.id, fechaDesde:vm.fechaDesde, fechaHasta:vm.fechaHasta, idTipoMovimiento: 1, idFamilia:vm.familiaSuministro.id}, function(data){
        armarReporteGrupoDetalleExcel(data);
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function mostrarReporteGrupoDetalleExcel(){
      ServicioDialogos.abrirDialogoCargando();
      DetalleMovimientoGrupoFechas.query({idGrupo:vm.grupo.id, fechaDesde:vm.fechaDesde, fechaHasta:vm.fechaHasta, idTipoMovimiento: 1}, function(data){
        armarReporteGrupoDetalleExcel(data, "grupo");
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function armarReporteGrupoDetalleExcel(data, det){
      var lista = $filter('orderBy')(obtenerTotalesGrupo(data), ['sucursal.nombre', 'numeroMovimiento', 'tipoSuministro.nombre'], true);
      var totales = [];
      for (var i = lista.length - 1; i >= 0; i--) {
        totales.push({
          "Empresa" : lista[i].sucursal.empresa.nombre.toUpperCase(),
          "Sucursal" : lista[i].sucursal.nombre.toUpperCase(),
          "Código sucursal" : lista[i].sucursal.codigoSucursal.toUpperCase(),
          "Fecha" : $filter('date')(lista[i].fecha, "dd/MM/yyyy"),
          "Grupo suministro" : lista[i].tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
          "Familia suministro" : lista[i].tipoSuministro.familiaSuministro.nombre.toUpperCase(),
          "Código familia" : lista[i].tipoSuministro.familiaSuministro.codigoFamiliaSuministro.toUpperCase(),
          "Tipo suministro" : lista[i].tipoSuministro.nombre.toUpperCase(),
          "Código producto" : lista[i].tipoSuministro.codigoProducto.toUpperCase(),
          "Cantidad" : lista[i].cantidad,
          "Precio total" : lista[i].precioTotal,
          "N° Movimiento": lista[i].numeroMovimiento,
          "Solicitó":lista[i].solicita,
          "Entregó":lista[i].entrego
        });
      }
      var tit = det? vm.grupo.nombre.toUpperCase(): vm.familiaSuministro.nombre.toUpperCase();
      var nombreDocumento = "entregas-"+Util.quitarCaracteresEspeciales(tit)+"-"+$filter('date')(vm.fechaDesde, "dd-MM-yyyy")+"-y-"+$filter('date')(vm.fechaHasta, "dd-MM-yyyy");
      alasql.promise('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true,sheetid:"Entregas"}) FROM ?',[totales])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function obtenerTotalesGrupo(data){
      var lista = [];
      var ban = false;
      var solicita;
      var entrego;
      data.forEach(function(detalle){
        lista.forEach(function(item){
          if (item.tipoSuministro.id==detalle.suministro.tipoSuministro.id && item.sucursal.id == detalle.movimiento.sucursal.id && detalle.movimiento.numeroMovimiento==item.numeroMovimiento){
            ban = true;
            item.cantidad += detalle.cantidad;
            item.precioTotal += detalle.suministro.precioUnitario*detalle.cantidad;
          }
        });
        solicita = detalle.movimiento.solicita?detalle.movimiento.solicita.apellido.toUpperCase()+", "+detalle.movimiento.solicita.nombre.toUpperCase():detalle.movimiento.solicitante?detalle.movimiento.solicitante.toUpperCase():"-";
        entrego = detalle.movimiento.egreso?detalle.movimiento.egreso.empresaLogistica.nombre.toUpperCase():"-";
        if (!ban){
          lista.push({tipoSuministro:detalle.suministro.tipoSuministro, cantidad:detalle.cantidad, entrego:entrego, solicita:solicita, precioTotal:detalle.suministro.precioUnitario*detalle.cantidad, numeroMovimiento:detalle.movimiento.numeroMovimiento, sucursal:detalle.movimiento.sucursal, fecha:detalle.movimiento.fecha});
        }
        ban = false;
      });
      return lista;
    }

    function obtenerTotalesFamilia(data){
      var lista = [];
      var ban = false;
      var solicita;
      data.forEach(function(detalle){
        lista.forEach(function(item){
          if (item.tipoSuministro.id==detalle.suministro.tipoSuministro.id && item.sucursal.id == detalle.movimiento.sucursal.id){
            ban = true;
            item.cantidad += detalle.cantidad;
            item.precioTotal += detalle.suministro.precioUnitario*detalle.cantidad;
          }
        });
        if (!ban){
          lista.push({tipoSuministro:detalle.suministro.tipoSuministro, cantidad:detalle.cantidad, precioTotal:detalle.suministro.precioUnitario*detalle.cantidad, sucursal:detalle.movimiento.sucursal});
        }
        ban = false;
      });
      return lista;
    }

    function armarReporteFamiliaTotalesExcel(data){
      var lista = $filter('orderBy')(obtenerTotalesFamilia(data), ['sucursal.nombre', 'numeroMovimiento', 'tipoSuministro.nombre'], true);
      var totales = [];
      for (var i = lista.length - 1; i >= 0; i--) {
        totales.push({
          "Empresa" : lista[i].sucursal.empresa.nombre.toUpperCase(),
          "Sucursal" : lista[i].sucursal.nombre.toUpperCase(),
          "Código sucursal" : lista[i].sucursal.codigoSucursal.toUpperCase(),
          "Grupo suministro" : lista[i].tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
          "Familia suministro" : lista[i].tipoSuministro.familiaSuministro.nombre.toUpperCase(),
          "Código familia" : lista[i].tipoSuministro.familiaSuministro.codigoFamiliaSuministro.toUpperCase(),
          "Tipo suministro" : lista[i].tipoSuministro.nombre.toUpperCase(),
          "Código producto" : lista[i].tipoSuministro.codigoProducto.toUpperCase(),
          "Cantidad" : lista[i].cantidad,
          "Precio total" : lista[i].precioTotal
        });
      }
      var nombreDocumento = "entregas-totales-"+Util.quitarCaracteresEspeciales(vm.familiaSuministro.nombre.toUpperCase())+"-"+$filter('date')(vm.fechaDesde, "dd-MM-yyyy")+"--"+$filter('date')(vm.fechaHasta, "dd-MM-yyyy");
      alasql.promise('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true,sheetid:"Entregas total"}) FROM ?',[totales])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function mostrarReporteTotalesExcel(){
      ServicioDialogos.abrirDialogoCargando();
      DetalleMovimientoFamiliaFechas.query({idEmpresa:vm.empresa.id, fechaDesde:vm.fechaDesde, fechaHasta:vm.fechaHasta, idTipoMovimiento: 1, idFamilia:vm.familiaSuministro.id}, function(data){
        armarReporteFamiliaTotalesExcel(data);
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function comprobarPeriodoFechas(){
      return  (((vm.fechaHasta - vm.fechaDesde)/86400000)<=550);
    }

    function volver(){
      $state.go("home.lista-reportes");
    }

    function mostrarReporteGrupoDetalle(){
      mostrarReporte(false);
    }

    function mostrarReporteTotales(){
      ServicioDialogos.abrirDialogoCargando();
      var Url = URL_SERVIDOR+"/reportes/entregasTotalesEntreFechas?idEmpresa="+vm.empresa.id+"&&fechaDesde="+vm.fechaDesde+"&&fechaHasta="+vm.fechaHasta+"&&idFamilia="+vm.familiaSuministro.id;
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function obtenerUrl(detalle){
      if (detalle){
        return URL_SERVIDOR+"/reportes/movimientosEntreFechas?idEmpresa="+vm.empresa.id+"&&fechaDesde="+vm.fechaDesde+"&&fechaHasta="+vm.fechaHasta+"&&idFamilia="+vm.familiaSuministro.id+"&&tipo="+detalle;
      } else {
        return URL_SERVIDOR+"/reportes/entregasEntreFechas?idGrupo="+vm.grupo.id+"&&fechaDesde="+vm.fechaDesde+"&&fechaHasta="+vm.fechaHasta;
      }
    }

    function mostrarReporte(detalle){
      ServicioDialogos.abrirDialogoCargando();
      var Url = obtenerUrl(detalle);
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function validarFiltros(){
      return (vm.empresa && vm.empresa.id) && (vm.fechaDesde && vm.fechaHasta);
    }

    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.dismiss();
    }

    $scope.$watch('vm.grupo.nombre', function(){
      if (vm.familiaSuministro) vm.familiaSuministro=null;
      if (!vm.grupo) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupo.id}, function(data){
        vm.familias = orderByFilter(data,'nombre',false);
        focus('familia');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.empresa.id', function(){
      if (vm.grupo) vm.grupo=null;
      if (vm.tipoSuministroCompleto) vm.tipoSuministroCompleto=null;
      if (!vm.empresa) return;
      ServicioDialogos.abrirDialogoCargando();
      GrupoEmpresa.query({id:vm.empresa.id}, function(data){
        vm.grupos = orderByFilter(data,'nombre',false);
        focus('fechaDesde');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.reporte-empresa-activos', {
        url: 'reporte-empresa-activos',
        templateUrl: 'app/app/main/reportes/reporte-empresa-activos/reporte-empresa-activos.html',
        controller: 'ReporteEmpresaActivosCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Reportes',
          subtitulo:'Reporte de activos de una empresa'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          empresas: function(Usuario, Empresa, $filter){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.empresa && usuario.empleado.empresa.id){
                var empresas = [];
                return Empresa.get({id:usuario.empleado.empresa.id}).$promise.then(function(empresa){
                  empresas.push(empresa);
                  return empresas;
                });
              } else {
                return Empresa.query().$promise.then(function(data) {
                  if (usuario.empleado && usuario.rol && usuario.rol.nombre=='CONSULTA' && usuario.empleado.empresas && usuario.empleado.empresas.length>0) {
                    var empresas = [];
                    data.forEach(function(empresa){
                      if (usuario.empleado.empresas.includes(empresa.id)){
                        empresas.push(empresa);
                      }
                    });
                    return $filter('orderBy')(empresas, 'nombre', false);
                  }
                  return data;
                });
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ReporteEmpresaActivosCtrl', ReporteEmpresaActivosCtrl);

  /** @ngInject */
  function ReporteEmpresaActivosCtrl(NgTableParams, Util, $filter, rol, SuministroEmpresaActivos, HeaderBarService, URL_SERVIDOR, $http, empresas, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.empresas = orderByFilter(empresas, "nombre", false);

    var familias = [];
    var grupos = [];

    vm.armarReporte = armarReporte;
    vm.volver = volver;
    
    if (rol.id!=1 && rol.id!=2 && rol.id!=3 && rol.id!=29) $state.go("home.home");

    function volver(){
      $state.go("home.lista-reportes");
    }

    function armarReporte(tipo){
      ServicioDialogos.abrirDialogoCargando();
      familias = [];
      grupos = [];
      SuministroEmpresaActivos.query({idEmpresa:vm.empresa.id}, function(data){
        var lista = obtenerCantidadesYPorcentajes(data);
        if (tipo){
          mostrarReporte(lista);
        } else {
          mostrarReporteExcel(lista);
        }
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function mostrarReporteExcel(lista){
      var pagina1 = obtenerTotalesTipoStock(lista);
      var pagina2 = obtenerDetalleGrupo(lista);
      var pagina3 = obtenerDetalleFamilia(lista);
      var opts = [{sheetid:'Total tipo stock',header:true}, {sheetid:'Detalle por grupo',header:true},{sheetid:'Detalle por familia',header:true}];
      var nombreDocumento = vm.empresa ? "activos-"+Util.quitarCaracteresEspeciales(vm.empresa.nombre.toUpperCase()) : "activos";
      alasql.promise('SELECT INTO XLSX("'+nombreDocumento+'.xlsx",?) FROM ?',[opts,[pagina1, pagina2, pagina3]])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function obtenerDetalleFamilia(lista){
      lista = $filter('orderBy')(lista, ['nombre'], true);
      var totales = [];
      var listaGrupos;
      var listaFamilias;
      for (var i = lista.length - 1; i >= 0; i--) {
        listaGrupos = $filter('orderBy')(lista[i].grupos, ['grupoSuministro.nombre'], false);
        for (var j = 0; j < listaGrupos.length; j++) {
          listaFamilias = $filter('orderBy')(listaGrupos[j].familias, ['familiaSuministro.nombre'], false);
          for (var k = 0; k < listaFamilias.length; k++) {
            totales.push({
              "Tipo stock" : lista[i].nombre.toUpperCase(),
              "Grupo suministro" : listaGrupos[j].grupoSuministro.nombre.toUpperCase(),
              "Familia suministro" : listaFamilias[k].familiaSuministro.nombre.toUpperCase(),
              "Código familia" : listaFamilias[k].familiaSuministro.codigoFamiliaSuministro.toUpperCase(),
              "Cantidad" : listaFamilias[k].cantidad,
              "Porcentaje en grupo" : listaFamilias[k].porcentaje,
              "Precio total" : listaFamilias[k].precioTotal
            });
          }
        }
      }
      return totales;
    }

    function obtenerDetalleGrupo(lista){
      lista = $filter('orderBy')(lista, ['nombre'], true);
      var totales = [];
      var listaGrupos;
      for (var i = lista.length - 1; i >= 0; i--) {
        listaGrupos = $filter('orderBy')(lista[i].grupos, ['grupoSuministro.nombre'], false);
        for (var j = 0; j < listaGrupos.length; j++) {
          totales.push({
            "Tipo stock" : lista[i].nombre.toUpperCase(),
            "Grupo suministro" : listaGrupos[j].grupoSuministro.nombre.toUpperCase(),
            "Cantidad" : listaGrupos[j].cantidad,
            "Porcentaje en tipo stock" : listaGrupos[j].porcentaje,
            "Precio total" : listaGrupos[j].precioTotal
          });
        }
      }
      return totales;
    }

    function obtenerTotalesTipoStock(lista){
      lista = $filter('orderBy')(lista, ['nombre'], true);
      var totales = [];
      for (var i = lista.length - 1; i >= 0; i--) {
        totales.push({
          "Tipo stock" : lista[i].nombre.toUpperCase(),
          "Cantidad" : lista[i].cantidad,
          "Precio total" : lista[i].precioTotal
        });
      }
      return totales;
    }

    function obtenerReporte(lista){
      var reporte = {};
      reporte.empresa = vm.empresa;
      reporte.tipos = lista;
      return reporte;
    }

    function mostrarReporte(lista){
      var Url = URL_SERVIDOR+"/reportes/activosEmpresa";
      $http.post(Url, obtenerReporte(lista),
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function obtenerTipos(suministros){
      var tipos = [];
      var esta = false;
      suministros.forEach(function(item){
        esta = false;
        tipos.forEach(function(agrupado){
          if (obtenerTipoMovimiento(item)==agrupado.nombre){
            esta = true;
          }
        });
        if (!esta){
          tipos.push({tipoMovimiento:item.estadoSuministro.tipoMovimiento, nombre:obtenerTipoMovimiento(item), precioTotal:0.0, cantidad:0, grupos:[]});
        }
      });
      return tipos;
    }

    function obtenerTipoMovimiento(item){
      switch (true){
        case (item.estadoSuministro.id==2 || item.estadoSuministro.id==3):
          return "Stock regular";
        case (item.estadoSuministro.id==4 || item.estadoSuministro.id==6):
          return "Donación";
        case (item.estadoSuministro.id==7 || item.estadoSuministro.id==9):
          return "Scrap-rep.";
        default:
          return "Stock regular";
      }
    }

    function obtenerGruposUtilizados(suministros, tipos){
      var esta = false;
      tipos.forEach(function(tipo){
        suministros.forEach(function(item){
          esta = false;
          if (item.estadoSuministro.tipoMovimiento.id==tipo.tipoMovimiento.id) {
            tipo.grupos.forEach(function(grupo){
              if (item.tipoSuministro.familiaSuministro.grupoSuministro.id==grupo.grupoSuministro.id){
                esta = true;
              }
            });
            if (!esta){
              tipo.grupos.push({grupoSuministro:item.tipoSuministro.familiaSuministro.grupoSuministro, cantidad:0, precioTotal:0.0, familias:[]});
            }
          }
        });
      });
      return tipos;
    }

    function obtenerFamilasUtilizadas(suministros, tiposPorGrupos){
      var esta = false;
      tiposPorGrupos.forEach(function(tipo){
        tipo.grupos.forEach(function(grupo){
          suministros.forEach(function(item){
            esta = false;
            if (item.estadoSuministro.tipoMovimiento.id==tipo.tipoMovimiento.id && grupo.grupoSuministro.id==item.tipoSuministro.familiaSuministro.grupoSuministro.id) {
              grupo.familias.forEach(function(familia){
                if (item.tipoSuministro.familiaSuministro.id==familia.familiaSuministro.id){
                  esta = true;
                }
              });
              if (!esta){
                grupo.familias.push({familiaSuministro:item.tipoSuministro.familiaSuministro, cantidad:0, precioTotal:0.0});
              }
            }
          });
        });
      });
      return tiposPorGrupos;
    }

    function obtenerCantidades(suministros, tiposCompletos){
      tiposCompletos.forEach(function(tipo){
        tipo.grupos.forEach(function(grupo){
          grupo.familias.forEach(function(familia){
            suministros.forEach(function(item){
              if (item.estadoSuministro.tipoMovimiento.id==tipo.tipoMovimiento.id && grupo.grupoSuministro.id==item.tipoSuministro.familiaSuministro.grupoSuministro.id && familia.familiaSuministro.id==item.tipoSuministro.familiaSuministro.id) {
                tipo.cantidad += item.cantidad;
                tipo.precioTotal += item.precioUnitario * item.cantidad;
                grupo.cantidad += item.cantidad;
                grupo.precioTotal += item.precioUnitario * item.cantidad;
                familia.cantidad += item.cantidad;
                familia.precioTotal += item.precioUnitario * item.cantidad;
              }
            });
          });
        });
      });
      return tiposCompletos;
    }

    function calcularPorcentaje(array){
      var acu = 0;
      array.forEach(function(item){
        array.forEach(function(item2){
          acu += item2.cantidad;
        });
        item.porcentaje = (item.cantidad/acu*100)<1? (item.cantidad/acu*100).toFixed(4) : (item.cantidad/acu*100).toFixed(1);
        acu = 0;
      });
    }

    function calcularPorcentajeGruposYFamilias(tiposPorGruposYFamilias){
      tiposPorGruposYFamilias.forEach(function(tipo){
        calcularPorcentaje(tipo.grupos);
        tipo.cantidad = tipo.cantidad.toFixed(0);
        tipo.precioTotal = tipo.precioTotal.toFixed(2);
        tipo.grupos.forEach(function(grupo){
          grupo.cantidad = grupo.cantidad.toFixed(0);
          grupo.precioTotal = grupo.precioTotal.toFixed(2);
          calcularPorcentaje(grupo.familias);
        });
      });
      return tiposPorGruposYFamilias;
    }

    function obtenerCantidadesYPorcentajes(suministros){
      var tipos = obtenerTipos(suministros);
      var tiposPorGrupos = obtenerGruposUtilizados(suministros, tipos);
      var tiposPorGruposYFamilias = obtenerFamilasUtilizadas(suministros, tiposPorGrupos);
      tiposPorGruposYFamilias = obtenerCantidades(suministros, tiposPorGruposYFamilias);
      tiposPorGruposYFamilias = calcularPorcentajeGruposYFamilias(tiposPorGruposYFamilias);
      return tiposPorGruposYFamilias;

    }
  
    
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.reporte-consumos-totales', {
        url: 'reporte-consumos-totales',
        templateUrl: 'app/app/main/reportes/reporte-consumos-totales/reporte-consumos-totales.html',
        controller: 'ReporteConsumosTotalesCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Reportes',
          subtitulo:'Reporte de consumos totales por sucursales'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          empresas: function(Usuario, Empresa, $filter){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.empresa && usuario.empleado.empresa.id){
                var empresas = [];
                return Empresa.get({id:usuario.empleado.empresa.id}).$promise.then(function(empresa){
                  empresas.push(empresa);
                  return empresas;
                });
              } else {
                return Empresa.query().$promise.then(function(data) {
                  if (usuario.empleado && usuario.rol && usuario.rol.nombre=='CONSULTA' && usuario.empleado.empresas && usuario.empleado.empresas.length>0) {
                    var empresas = [];
                    data.forEach(function(empresa){
                      if (usuario.empleado.empresas.includes(empresa.id)){
                        empresas.push(empresa);
                      }
                    });
                    return $filter('orderBy')(empresas, 'nombre', false);
                  }
                  return data;
                });
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ReporteConsumosTotalesCtrl', ReporteConsumosTotalesCtrl);

  /** @ngInject */
  function ReporteConsumosTotalesCtrl(NgTableParams, ListaReporteConsumosTotales, Util, $filter, ListaReporteConsumo, focus, rol, HeaderBarService, URL_SERVIDOR, $http, empresas, $stateParams, StockTipoSuministroDeposito, $scope, orderByFilter, $state, GrupoEmpresa, TiposPorEmpresa, TipoSuministroFamilia, FamiliaSuministroGrupo, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.empresas = orderByFilter(empresas,'nombre',false);
    vm.fechaActual = new Date();

    vm.mostrarReporte = mostrarReporte;
    vm.mostrarReporteExcel = mostrarReporteExcel;
    vm.validarFiltros = validarFiltros;
    vm.comprobarPeriodoFechas = comprobarPeriodoFechas;
    vm.volver = volver;

    if (rol.id!=1 && rol.id!=2 && rol.id!=3 && rol.id!=29) $state.go("home.home");

    function comprobarPeriodoFechas(){
      return  (((vm.fechaHasta - vm.fechaDesde)/86400000)<=550);
    }

    function volver(){
      $state.go("home.lista-reportes");
    }

    function obtenerNombreArchivo(){
      return vm.familiaSuministro? vm.familiaSuministro.nombre.toUpperCase() : vm.grupo? vm.grupo.nombre.toUpperCase() : (vm.empresa.nombre.toUpperCase());
    }

    function armarExcel(data){
      var pagina1 = obtenerTotales(data);
      var opts = [{sheetid:'Consumos Totales por sucursal entre '+$filter('date')(vm.fechaDesde, "dd-MM-yyyy")+" - "+$filter('date')(vm.fechaHasta, "dd-MM-yyyy"),header:true}];
      var nombreDocumento = "consumo-totales-"+Util.quitarCaracteresEspeciales(obtenerNombreArchivo())+"-"+$filter('date')(vm.fechaDesde, "dd-MM-yyyy")+"-y-"+$filter('date')(vm.fechaHasta, "dd-MM-yyyy");
      alasql.promise('SELECT INTO XLSX("'+nombreDocumento+'.xlsx",?) FROM ?',[opts,[pagina1]])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function obtenerTotales(lista){
      lista = $filter('orderBy')(lista, ['sucursal.nombre'], true);
      var totales = [];
      var tipos = [];
      for (var i = lista.length - 1; i >= 0; i--) {
        tipos = $filter('orderBy')(lista[i].tipos, ['tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre','tipoSuministro.familiaSuministro.grupoSuministro.nombre','tipoSuministro.familiaSuministro.nombre','tipoSuministro.nombre'], false);
        for (var j = 0; j < tipos.length; j++) {
          totales.push({
            "Empresa" : tipos[j].tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase(),
            "Sucursal" : lista[i].sucursal.nombre.toUpperCase(),
            "Código sucursal" : lista[i].sucursal.codigoSucursal.toUpperCase(),
            "Grupo suministro" : tipos[j].tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
            "Familia suministro" : tipos[j].tipoSuministro.familiaSuministro.nombre.toUpperCase(),
            "Código familia" : tipos[j].tipoSuministro.familiaSuministro.codigoFamiliaSuministro.toUpperCase(),
            "Tipo suministro" : tipos[j].tipoSuministro.nombre.toUpperCase(),
            "Código producto" : tipos[j].tipoSuministro.codigoProducto.toUpperCase(),
            "Cantidad": tipos[j].cantidad
          });
        }
      }
      return totales.length>0 ? totales : [{"No hay datos":""}];
    }

    function mostrarReporteExcel(){
      ServicioDialogos.abrirDialogoCargando();
      ListaReporteConsumosTotales.query({idFamilia:vm.familiaSuministro?vm.familiaSuministro.id:null, idGrupo:vm.grupo? vm.grupo.id:null, idEmpresa:vm.empresa.id, fechaDesde:vm.fechaDesde, fechaHasta:vm.fechaHasta}, function(data){
        armarExcel(data);
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function obtenerUrl(){
      if (vm.familiaSuministro && vm.familiaSuministro.id){
        return URL_SERVIDOR+"/reportes/consumos-totales-familia?idFamilia="+vm.familiaSuministro.id+"&&fechaDesde="+vm.fechaDesde+"&&fechaHasta="+vm.fechaHasta;
      } else if (vm.grupo && vm.grupo.id && !vm.familiaSuministro){
        return URL_SERVIDOR+"/reportes/consumos-totales-grupo?idGrupo="+vm.grupo.id+"&&fechaDesde="+vm.fechaDesde+"&&fechaHasta="+vm.fechaHasta;
      } else {
        return URL_SERVIDOR+"/reportes/consumos-totales-empresa?idEmpresa="+vm.empresa.id+"&&fechaDesde="+vm.fechaDesde+"&&fechaHasta="+vm.fechaHasta;
      }
    }

    function mostrarReporte(){
      ServicioDialogos.abrirDialogoCargando();
      var Url = obtenerUrl();
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function validarFiltros(){
      return (vm.empresa && vm.empresa.id) && (vm.fechaDesde && vm.fechaHasta);
    }

    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.dismiss();
    }

    $scope.$watch('vm.grupo.nombre', function(){
      if (vm.familiaSuministro) vm.familiaSuministro=null;
      if (!vm.grupo) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupo.id}, function(data){
        vm.familias = orderByFilter(data,'nombre',false);
        focus('familia');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.empresa.id', function(){
      if (vm.grupo) vm.grupo=null;
      if (vm.tipoSuministroCompleto) vm.tipoSuministroCompleto=null;
      if (!vm.empresa) return;
      ServicioDialogos.abrirDialogoCargando();
      GrupoEmpresa.query({id:vm.empresa.id}, function(data){
        vm.grupos = orderByFilter(data,'nombre',false);
        focus('fechaDesde');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.reporte-confirmacion-sucursales', {
        url: 'reporte-confirmacion-sucursales',
        templateUrl: 'app/app/main/reportes/reporte-confirmacion-sucursales/reporte.html',
        controller: 'ReporteConfirmacionSucursalesCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Reportes',
          subtitulo:'Reporte confirmación de recepciones de entregas por sucursal y año'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          anos: function(Util){
            return Util.obtenerAnos();
          },
          empresas: function(Usuario, Empresa, $filter){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.empresa && usuario.empleado.empresa.id){
                var empresas = [];
                return Empresa.get({id:usuario.empleado.empresa.id}).$promise.then(function(empresa){
                  empresas.push(empresa);
                  return empresas;
                });
              } else {
                return Empresa.query().$promise.then(function(data) {
                  if (usuario.empleado && usuario.rol && usuario.rol.nombre=='CONSULTA' && usuario.empleado.empresas && usuario.empleado.empresas.length>0) {
                    var empresas = [];
                    data.forEach(function(empresa){
                      if (usuario.empleado.empresas.includes(empresa.id)){
                        empresas.push(empresa);
                      }
                    });
                    return $filter('orderBy')(empresas, 'nombre', false);
                  }
                  return data;
                });
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ReporteConfirmacionSucursalesCtrl', ReporteConfirmacionSucursalesCtrl);

  /** @ngInject */
  function ReporteConfirmacionSucursalesCtrl(NgTableParams, Util, $filter, ReporteConfirmacionRecepcion, rol, anos, HeaderBarService, URL_SERVIDOR, $http, empresas, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.empresas = orderByFilter(empresas, "nombre", false);
    vm.anos = anos;

    var familias = [];
    var grupos = [];

    vm.armarReporte = armarReporte;
    vm.armarReporteExcel = armarReporteExcel;
    vm.volver = volver;
    
    if (rol.id!=1 && rol.id!=2 && rol.id!=3 && rol.id!=29) $state.go("home.home");

    function volver(){
      $state.go("home.lista-reportes");
    }

    function armarReporteExcel(){
      ServicioDialogos.abrirDialogoCargando();
      ReporteConfirmacionRecepcion.get({idEmpresa:vm.empresa.id, ano:vm.ano}, function(data){
        console.log(data);
        armarExcel(data);
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function armarExcel(data){
      var pagina1 = obtenerTotales(data);
      var pagina2 = obtenerTotalSucursales(data);
      var opts = [{sheetid:'Totales empresa',header:true}, {sheetid:'Detalle por sucursal',header:true}];
      var nombreDocumento = "confirmaciones-de-sucursales-"+Util.quitarCaracteresEspeciales(vm.empresa.nombre.toUpperCase()+"-"+vm.ano);
      alasql.promise('SELECT INTO XLSX("'+nombreDocumento+'.xlsx",?) FROM ?',[opts,[pagina1, pagina2]])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function obtenerTotalSucursales(data){
      var lista = $filter('orderBy')(data.detalles, ['sucursal.nombre'], true);
      var totales = [];
      for (var i = lista.length - 1; i >= 0; i--) {
        totales.push({
          "Empresa":vm.empresa.nombre.toUpperCase(),
          "Sucursal":lista[i].sucursal.nombre.toUpperCase(),
          "Código sucursal" : lista[i].sucursal.codigoSucursal.toUpperCase(),
          "Año":vm.ano,
          "Cantidad entregas" : lista[i].cantidadDespachos,
          "Cantidad confirmadas" : lista[i].cantidadConfirmado,
          "Cantidad no confirmadas" : lista[i].cantidadNoConfirmado,
          "Cantidad reclamos" : lista[i].cantidadReclamo,
          "Porcentaje confirmado":lista[i].porcentajeConfirmado+" %",
          "Porcentaje no confirmado":lista[i].porcentajeNoConfirmado+" %",
          "Porcentaje reclamos":lista[i].porcentajeReclamo+" %"
        });
      }
      return totales.length>0 ? totales : [{"No hay datos":""}];
    }

    function obtenerTotales(data){
      var totales = [];
      totales.push({
          "Empresa":vm.empresa.nombre.toUpperCase(),
          "Año":vm.ano,
          "Cantidad entregas" : data.cantidadDespachos,
          "Cantidad confirmadas" : data.cantidadConfirmado,
          "Cantidad no confirmadas" : data.cantidadNoConfirmado,
          "Cantidad reclamos" : data.cantidadReclamo,
          "Porcentaje confirmado":data.porcentajeConfirmado+" %",
          "Porcentaje no confirmado":data.porcentajeNoConfirmado+" %",
          "Porcentaje reclamos":data.porcentajeReclamo+" %"
      });
      return totales.length>0 ? totales : [{"No hay datos":""}];
    }


    function armarReporte(){
      ServicioDialogos.abrirDialogoCargando();
      mostrarReporte();
    }

    function mostrarReporte(lista){
      var Url = URL_SERVIDOR+"/reportes/confirmacionRecepciones/"+vm.empresa.id+"/"+vm.ano;
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.reporte-consumo', {
        url: 'reporte-consumo',
        templateUrl: 'app/app/main/reportes/reporte-consumo/reporte-consumo.html',
        controller: 'ReporteConsumoCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Reportes',
          subtitulo:'Reporte de consumos e ingresos por familia de suministro'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          empresas: function(Usuario, Empresa, $filter){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.empresa && usuario.empleado.empresa.id){
                var empresas = [];
                return Empresa.get({id:usuario.empleado.empresa.id}).$promise.then(function(empresa){
                  empresas.push(empresa);
                  return empresas;
                });
              } else {
                return Empresa.query().$promise.then(function(data) {
                  if (usuario.empleado && usuario.rol && usuario.rol.nombre=='CONSULTA' && usuario.empleado.empresas && usuario.empleado.empresas.length>0) {
                    var empresas = [];
                    data.forEach(function(empresa){
                      if (usuario.empleado.empresas.includes(empresa.id)){
                        empresas.push(empresa);
                      }
                    });
                    return $filter('orderBy')(empresas, 'nombre', false);
                  }
                  return data;
                });
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ReporteConsumoCtrl', ReporteConsumoCtrl);

  /** @ngInject */
  function ReporteConsumoCtrl(NgTableParams, Util, $filter, ListaReporteConsumo, focus, rol, HeaderBarService, URL_SERVIDOR, $http, empresas, $stateParams, StockTipoSuministroDeposito, $scope, orderByFilter, $state, GrupoEmpresa, TiposPorEmpresa, TipoSuministroFamilia, FamiliaSuministroGrupo, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.empresas = orderByFilter(empresas,'nombre',false);
    vm.fechaActual = new Date();

    vm.mostrarReporte = mostrarReporte;
    vm.mostrarReporteExcel = mostrarReporteExcel;
    vm.validarFiltros = validarFiltros;
    vm.comprobarPeriodoFechas = comprobarPeriodoFechas;
    vm.volver = volver;

    if (rol.id!=1 && rol.id!=2 && rol.id!=3 && rol.id!=29) $state.go("home.home");

    function comprobarPeriodoFechas(){
      return  (((vm.fechaHasta - vm.fechaDesde)/86400000)<=550);
    }

    function volver(){
      $state.go("home.lista-reportes");
    }

    function armarExcel(data){
      var pagina1 = obtenerTotales(data);
      var pagina2 = obtenerDetalles(data);
      var opts = [{sheetid:'Totales '+$filter('date')(vm.fechaDesde, "dd-MM-yyyy")+" - "+$filter('date')(vm.fechaHasta, "dd-MM-yyyy"),header:true}, {sheetid:'Detallado '+$filter('date')(vm.fechaDesde, "dd-MM-yyyy")+" - "+$filter('date')(vm.fechaHasta, "dd-MM-yyyy"),header:true}];
      var nombreDocumento = "consumo-ingresos-"+Util.quitarCaracteresEspeciales(vm.familiaSuministro.nombre.toUpperCase())+"-"+$filter('date')(vm.fechaDesde, "dd-MM-yyyy")+"-y-"+$filter('date')(vm.fechaHasta, "dd-MM-yyyy");
      alasql.promise('SELECT INTO XLSX("'+nombreDocumento+'.xlsx",?) FROM ?',[opts,[pagina1, pagina2]])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function obtenerTotales(lista){
      lista = $filter('orderBy')(lista, ['tipoSuministro.nombre'], true);
      var totales = [];
      var fechaIngreso;
      var fechaEgreso;
      for (var i = lista.length - 1; i >= 0; i--) {
        fechaIngreso = lista[i].ultimoIngreso? $filter('date')(lista[i].ultimoIngreso, "dd/MM/yyyy") : "-";
        fechaEgreso = lista[i].ultimoEgreso? $filter('date')(lista[i].ultimoEgreso, "dd/MM/yyyy") : "-";
        totales.push({
          "Empresa" : lista[i].tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase(),
          "Grupo suministro" : lista[i].tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
          "Familia suministro" : lista[i].tipoSuministro.familiaSuministro.nombre.toUpperCase(),
          "Código familia" : lista[i].tipoSuministro.familiaSuministro.codigoFamiliaSuministro.toUpperCase(),
          "Tipo suministro" : lista[i].tipoSuministro.nombre.toUpperCase(),
          "Código producto" : lista[i].tipoSuministro.codigoProducto.toUpperCase(),
          "Último ingreso": fechaIngreso,
          "Último egreso": fechaEgreso,
          "Saldo actual":lista[i].saldoActual,
          "Ingresado en el período":lista[i].totalIngresado,
          "Promedio ingreso mensual":lista[i].promedioIngreso,
          "Consumido en el período":lista[i].consumoTotal,
          "Promedio consumo mensual":lista[i].promedioMensual
        });
      }
      return totales.length>0 ? totales : [{"No hay datos":""}];
    }

    function obtenerDetalles(lista){
      lista = $filter('orderBy')(lista, ['tipoSuministro.nombre'], true);
      var totales = [];
      var mensuales = [];
      for (var i = lista.length - 1; i >= 0; i--) {
        if ((lista[i].consumoTotal+lista[i].totalIngresado)<=0) continue;
        mensuales = lista[i].mensuales;
        for (var j = 0; j < mensuales.length; j++) {
          totales.push({
            "Empresa" : lista[i].tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase(),
            "Grupo suministro" : lista[i].tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
            "Familia suministro" : lista[i].tipoSuministro.familiaSuministro.nombre.toUpperCase(),
            "Código familia" : lista[i].tipoSuministro.familiaSuministro.codigoFamiliaSuministro.toUpperCase(),
            "Tipo suministro" : lista[i].tipoSuministro.nombre.toUpperCase(),
            "Código producto" : lista[i].tipoSuministro.codigoProducto.toUpperCase(),
            "Mes": mensuales[j].fecha,
            "Ingreso":mensuales[j].cantidadIngreso,
            "Consumo":mensuales[j].cantidadEgreso
          });
        }
      }
      return totales.length>0 ? totales : [{"No hay datos":""}];

    }

    function mostrarReporteExcel(){
      //console.log("ASD");
      ServicioDialogos.abrirDialogoCargando();
      ListaReporteConsumo.query({idFamilia:vm.familiaSuministro.id, fechaDesde:vm.fechaDesde, fechaHasta:vm.fechaHasta}, function(data){
        armarExcel(data);
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function mostrarReporte(){
      ServicioDialogos.abrirDialogoCargando();
      var Url = URL_SERVIDOR+"/reportes/consumo?idFamilia="+vm.familiaSuministro.id+"&&fechaDesde="+vm.fechaDesde+"&&fechaHasta="+vm.fechaHasta;
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function validarFiltros(){
      return (vm.empresa && vm.empresa.id) && (vm.fechaDesde && vm.fechaHasta);
    }

    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.dismiss();
    }

    $scope.$watch('vm.grupo.nombre', function(){
      if (vm.familiaSuministro) vm.familiaSuministro=null;
      if (!vm.grupo) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupo.id}, function(data){
        vm.familias = orderByFilter(data,'nombre',false);
        focus('familia');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.empresa.id', function(){
      if (vm.grupo) vm.grupo=null;
      if (vm.tipoSuministroCompleto) vm.tipoSuministroCompleto=null;
      if (!vm.empresa) return;
      ServicioDialogos.abrirDialogoCargando();
      GrupoEmpresa.query({id:vm.empresa.id}, function(data){
        vm.grupos = orderByFilter(data,'nombre',false);
        focus('fechaDesde');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.reporte-bultos-peso-empresa', {
        url: 'reporte-bultos-peso-empresa',
        templateUrl: 'app/app/main/reportes/reporte-bultos-peso-empresa/reporte.html',
        controller: 'ReporteBultosPesoEmpresaCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Reportes',
          subtitulo:'Reporte cantidad de bultos y peso por sucursales de una empresa'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          anos: function(Util){
            return Util.obtenerAnos();
          },
          empresas: function(Usuario, Empresa, $filter){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.empresa && usuario.empleado.empresa.id){
                var empresas = [];
                return Empresa.get({id:usuario.empleado.empresa.id}).$promise.then(function(empresa){
                  empresas.push(empresa);
                  return empresas;
                });
              } else {
                return Empresa.query().$promise.then(function(data) {
                  if (usuario.empleado && usuario.rol && usuario.rol.nombre=='CONSULTA' && usuario.empleado.empresas && usuario.empleado.empresas.length>0) {
                    var empresas = [];
                    data.forEach(function(empresa){
                      if (usuario.empleado.empresas.includes(empresa.id)){
                        empresas.push(empresa);
                      }
                    });
                    return $filter('orderBy')(empresas, 'nombre', false);
                  }
                  return data;
                });
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ReporteBultosPesoEmpresaCtrl', ReporteBultosPesoEmpresaCtrl);

  /** @ngInject */
  function ReporteBultosPesoEmpresaCtrl(NgTableParams, Util, $filter, rol, anos, ReportePesoBultos, HeaderBarService, URL_SERVIDOR, $http, empresas, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.empresas = orderByFilter(empresas, "nombre", false);
    vm.anos = anos;

    var familias = [];
    var grupos = [];

    vm.armarReporte = armarReporte;
    vm.armarReporteExcel = armarReporteExcel;
    vm.volver = volver;
    
    if (rol.id!=1 && rol.id!=2 && rol.id!=3 && rol.id!=29) $state.go("home.home");

    function volver(){
      $state.go("home.lista-reportes");
    }

    function armarReporteExcel(){
      ServicioDialogos.abrirDialogoCargando();
      ReportePesoBultos.get({idEmpresa:vm.empresa.id, ano:vm.ano}, function(data){
        armarExcel(data);
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function armarExcel(data){
      var pagina1 = obtenerTotales(data);
      var pagina2 = obtenerTotalesResumenes(data);
      var pagina3 = obtenerDetalleResumenes(data);
      var pagina4 = obtenerTotalesDetalles(data);
      var pagina5 = obtenerDetalleSucursalTransporte(data);
      var pagina6 = obtenerDetalleSucursalTransporteMensual(data);
      var opts = [{sheetid:'Totales empresa',header:true}, {sheetid:'Totales por transporte',header:true},{sheetid:'Detalle por transporte',header:true},{sheetid:'Totales por sucursal',header:true},{sheetid:'Detalle por sucursal y transporte',header:true},{sheetid:'Mensual por sucursal y transporte',header:true}];
      var nombreDocumento = "peso-bultos-"+Util.quitarCaracteresEspeciales(vm.empresa.nombre.toUpperCase()+"-"+vm.ano);
      alasql.promise('SELECT INTO XLSX("'+nombreDocumento+'.xlsx",?) FROM ?',[opts,[pagina1, pagina2, pagina3, pagina4, pagina5, pagina6]])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function obtenerDetalleSucursalTransporteMensual(data){
      var lista = $filter('orderBy')(data.detalles, ['sucursal.nombre'], true);
      var totales = [];
      var detalles = [];
      for (var i = lista.length - 1; i >= 0; i--) {
        detalles = $filter('orderBy')(lista[i].detalles, ['empresaLogistica.nombre'], true);
        for (var j = detalles.length - 1; j >= 0; j--) {
          totales.push(obtenerDetalleEnero(detalles[j], lista[i].sucursal));
          totales.push(obtenerDetalleFebrero(detalles[j], lista[i].sucursal));
          totales.push(obtenerDetalleMarzo(detalles[j], lista[i].sucursal));
          totales.push(obtenerDetalleAbril(detalles[j], lista[i].sucursal));
          totales.push(obtenerDetalleMayo(detalles[j], lista[i].sucursal));
          totales.push(obtenerDetalleJunio(detalles[j], lista[i].sucursal));
          totales.push(obtenerDetalleJulio(detalles[j], lista[i].sucursal));
          totales.push(obtenerDetalleAgosto(detalles[j], lista[i].sucursal));
          totales.push(obtenerDetalleSeptiembre(detalles[j], lista[i].sucursal));
          totales.push(obtenerDetalleOctubre(detalles[j], lista[i].sucursal));
          totales.push(obtenerDetalleNoviembre(detalles[j], lista[i].sucursal));
          totales.push(obtenerDetalleDiciembre(detalles[j], lista[i].sucursal));
        }
      }
      return totales.length>0 ? totales : [{"No hay datos":""}];
    }

    function obtenerDetalleEnero(item, sucursal){
      return {
        "Empresa":vm.empresa.nombre.toUpperCase(),
        "Sucursal":sucursal.nombre.toUpperCase(),
        "Código sucursal":sucursal.codigoSucursal.toUpperCase(),
        "Transporte":item.empresaLogistica.nombre.toUpperCase(),
        "Mes":"Enero",
        "Peso total" : item.pesoEnero,
        "Bultos totales":item.bultoEnero
      };
    }

    function obtenerDetalleFebrero(item, sucursal){
      return {
        "Empresa":vm.empresa.nombre.toUpperCase(),
        "Sucursal":sucursal.nombre.toUpperCase(),
        "Código sucursal":sucursal.codigoSucursal.toUpperCase(),
        "Transporte":item.empresaLogistica.nombre.toUpperCase(),
        "Mes":"Febrero",
        "Peso total" : item.pesoFebrero,
        "Bultos totales":item.bultoFebrero
      };
    }

    function obtenerDetalleMarzo(item, sucursal){
      return {
        "Empresa":vm.empresa.nombre.toUpperCase(),
        "Sucursal":sucursal.nombre.toUpperCase(),
        "Código sucursal":sucursal.codigoSucursal.toUpperCase(),
        "Transporte":item.empresaLogistica.nombre.toUpperCase(),
        "Mes":"Marzo",
        "Peso total" : item.pesoMarzo,
        "Bultos totales":item.bultoMarzo
      };
    }

    function obtenerDetalleAbril(item, sucursal){
      return {
        "Empresa":vm.empresa.nombre.toUpperCase(),
        "Sucursal":sucursal.nombre.toUpperCase(),
        "Código sucursal":sucursal.codigoSucursal.toUpperCase(),
        "Transporte":item.empresaLogistica.nombre.toUpperCase(),
        "Mes":"Abril",
        "Peso total" : item.pesoAbril,
        "Bultos totales":item.bultoAbril
      };
    }

    function obtenerDetalleMayo(item, sucursal){
      return {
        "Empresa":vm.empresa.nombre.toUpperCase(),
        "Sucursal":sucursal.nombre.toUpperCase(),
        "Código sucursal":sucursal.codigoSucursal.toUpperCase(),
        "Transporte":item.empresaLogistica.nombre.toUpperCase(),
        "Mes":"Mayo",
        "Peso total" : item.pesoMayo,
        "Bultos totales":item.bultoMayo
      };
    }

    function obtenerDetalleJunio(item, sucursal){
      return {
        "Empresa":vm.empresa.nombre.toUpperCase(),
        "Sucursal":sucursal.nombre.toUpperCase(),
        "Código sucursal":sucursal.codigoSucursal.toUpperCase(),
        "Transporte":item.empresaLogistica.nombre.toUpperCase(),
        "Mes":"Junio",
        "Peso total" : item.pesoJunio,
        "Bultos totales":item.bultoJunio
      };
    }

    function obtenerDetalleJulio(item, sucursal){
      return {
        "Empresa":vm.empresa.nombre.toUpperCase(),
        "Sucursal":sucursal.nombre.toUpperCase(),
        "Código sucursal":sucursal.codigoSucursal.toUpperCase(),
        "Transporte":item.empresaLogistica.nombre.toUpperCase(),
        "Mes":"Julio",
        "Peso total" : item.pesoJulio,
        "Bultos totales":item.bultoJulio
      };
    }

    function obtenerDetalleAgosto(item, sucursal){
      return {
        "Empresa":vm.empresa.nombre.toUpperCase(),
        "Sucursal":sucursal.nombre.toUpperCase(),
        "Código sucursal":sucursal.codigoSucursal.toUpperCase(),
        "Transporte":item.empresaLogistica.nombre.toUpperCase(),
        "Mes":"Agosto",
        "Peso total" : item.pesoAgosto,
        "Bultos totales":item.bultoAgosto
      };
    }

    function obtenerDetalleSeptiembre(item, sucursal){
      return {
        "Empresa":vm.empresa.nombre.toUpperCase(),
        "Sucursal":sucursal.nombre.toUpperCase(),
        "Código sucursal":sucursal.codigoSucursal.toUpperCase(),
        "Transporte":item.empresaLogistica.nombre.toUpperCase(),
        "Mes":"Septiembre",
        "Peso total" : item.pesoSeptiembre,
        "Bultos totales":item.bultoSeptiembre
      };
    }

    function obtenerDetalleOctubre(item, sucursal){
      return {
        "Empresa":vm.empresa.nombre.toUpperCase(),
        "Sucursal":sucursal.nombre.toUpperCase(),
        "Código sucursal":sucursal.codigoSucursal.toUpperCase(),
        "Transporte":item.empresaLogistica.nombre.toUpperCase(),
        "Mes":"Octubre",
        "Peso total" : item.pesoOctubre,
        "Bultos totales":item.bultoOctubre
      };
    }

    function obtenerDetalleNoviembre(item, sucursal){
      return {
        "Empresa":vm.empresa.nombre.toUpperCase(),
        "Sucursal":sucursal.nombre.toUpperCase(),
        "Código sucursal":sucursal.codigoSucursal.toUpperCase(),
        "Transporte":item.empresaLogistica.nombre.toUpperCase(),
        "Mes":"Noviembre",
        "Peso total" : item.pesoNoviembre,
        "Bultos totales":item.bultoNoviembre
      };
    }

    function obtenerDetalleDiciembre(item, sucursal){
      return {
        "Empresa":vm.empresa.nombre.toUpperCase(),
        "Sucursal":sucursal.nombre.toUpperCase(),
        "Código sucursal":sucursal.codigoSucursal.toUpperCase(),
        "Transporte":item.empresaLogistica.nombre.toUpperCase(),
        "Mes":"Diciembre",
        "Peso total" : item.pesoDiciembre,
        "Bultos totales":item.bultoDiciembre
      };
    }

    function obtenerDetalleSucursalTransporte(data){
      var lista = $filter('orderBy')(data.detalles, ['sucursal.nombre'], true);
      var totales = [];
      var detalles = [];
      for (var i = lista.length - 1; i >= 0; i--) {
        detalles = $filter('orderBy')(lista[i].detalles, ['empresaLogistica.nombre'], true);
        for (var j = detalles.length - 1; j >= 0; j--) {
          totales.push({
            "Empresa":vm.empresa.nombre.toUpperCase(),
            "Sucursal":lista[i].sucursal.nombre.toUpperCase(),
            "Código sucursal" : lista[i].sucursal.codigoSucursal.toUpperCase(),
            "Transporte":detalles[j].empresaLogistica.nombre.toUpperCase(),
            "Cantidad despachos" : detalles[j].cantidadDespachos,
            "Peso total" : detalles[j].pesoTotal,
            "Bultos totales":detalles[j].bultoTotal
          });
        }
      }
      return totales.length>0 ? totales : [{"No hay datos":""}];
    }

    function obtenerTotalesDetalles(data){
      var lista = $filter('orderBy')(data.detalles, ['sucursal.nombre'], true);
      var totales = [];
      for (var i = lista.length - 1; i >= 0; i--) {
        totales.push({
          "Empresa":vm.empresa.nombre.toUpperCase(),
          "Sucursal":lista[i].sucursal.nombre.toUpperCase(),
          "Código sucursal" : lista[i].sucursal.codigoSucursal.toUpperCase(),
          "Cantidad movimientos" : lista[i].cantidadMovimientos,
          "Peso total" : lista[i].pesoTotal,
          "Bultos totales":lista[i].bultosTotales,
          "Promedio peso por movimiento":lista[i].promedioPesoPorMovimiento,
          "Promedio bultos por movimiento":lista[i].promedioBultosPorMovimiento
        });
      }
      return totales.length>0 ? totales : [{"No hay datos":""}];
    }

    function obtenerDetalleResumenes(data){
      var lista = $filter('orderBy')(data.resumenes, ['empresaLogistica.nombre'], true);
      var totales = [];
      for (var i = lista.length - 1; i >= 0; i--) {
        totales.push(obtenerEnero(lista[i]));
        totales.push(obtenerFebrero(lista[i]));
        totales.push(obtenerMarzo(lista[i]));
        totales.push(obtenerAbril(lista[i]));
        totales.push(obtenerMayo(lista[i]));
        totales.push(obtenerJunio(lista[i]));
        totales.push(obtenerJulio(lista[i]));
        totales.push(obtenerAgosto(lista[i]));
        totales.push(obtenerSeptiembre(lista[i]));
        totales.push(obtenerOctubre(lista[i]));
        totales.push(obtenerNoviembre(lista[i]));
        totales.push(obtenerDiciembre(lista[i]));
      }
      return totales.length>0 ? totales : [{"No hay datos":""}];
    }

    function obtenerEnero(item){
      return {
        "Empresa":vm.empresa.nombre.toUpperCase(),
        "Transporte":item.empresaLogistica.nombre.toUpperCase(),
        "Mes":"Enero",
        "Cantidad movimientos" : item.eneroMovimientos,
        "Cantidad egresos" : item.eneroDespachos,
        "Peso total" : item.eneroPeso,
        "Bultos totales":item.eneroPaquetes
      };
    }

    function obtenerFebrero(item){
      return {
        "Empresa":vm.empresa.nombre.toUpperCase(),
        "Transporte":item.empresaLogistica.nombre.toUpperCase(),
        "Mes":"Febrero",
        "Cantidad movimientos" : item.febreroMovimientos,
        "Cantidad egresos" : item.febreroDespachos,
        "Peso total" : item.febreroPeso,
        "Bultos totales":item.febreroPaquetes
      };
    }

    function obtenerMarzo(item){
      return {
        "Empresa":vm.empresa.nombre.toUpperCase(),
        "Transporte":item.empresaLogistica.nombre.toUpperCase(),
        "Mes":"Marzo",
        "Cantidad movimientos" : item.marzoMovimientos,
        "Cantidad egresos" : item.marzoDespachos,
        "Peso total" : item.marzoPeso,
        "Bultos totales":item.marzoPaquetes
      };
    }

    function obtenerAbril(item){
      return {
        "Empresa":vm.empresa.nombre.toUpperCase(),
        "Transporte":item.empresaLogistica.nombre.toUpperCase(),
        "Mes":"Abril",
        "Cantidad movimientos" : item.abrilMovimientos,
        "Cantidad egresos" : item.abrilDespachos,
        "Peso total" : item.abrilPeso,
        "Bultos totales":item.abrilPaquetes
      };
    }

    function obtenerMayo(item){
      return {
        "Empresa":vm.empresa.nombre.toUpperCase(),
        "Transporte":item.empresaLogistica.nombre.toUpperCase(),
        "Mes":"Mayo",
        "Cantidad movimientos" : item.mayoMovimientos,
        "Cantidad egresos" : item.mayoDespachos,
        "Peso total" : item.mayoPeso,
        "Bultos totales":item.mayoPaquetes
      };
    }

    function obtenerJunio(item){
      return {
        "Empresa":vm.empresa.nombre.toUpperCase(),
        "Transporte":item.empresaLogistica.nombre.toUpperCase(),
        "Mes":"Junio",
        "Cantidad movimientos" : item.junioMovimientos,
        "Cantidad egresos" : item.junioDespachos,
        "Peso total" : item.junioPeso,
        "Bultos totales":item.junioPaquetes
      };
    }

    function obtenerJulio(item){
      return {
        "Empresa":vm.empresa.nombre.toUpperCase(),
        "Transporte":item.empresaLogistica.nombre.toUpperCase(),
        "Mes":"Julio",
        "Cantidad movimientos" : item.julioMovimientos,
        "Cantidad egresos" : item.julioDespachos,
        "Peso total" : item.julioPeso,
        "Bultos totales":item.julioPaquetes
      };
    }

    function obtenerAgosto(item){
      return {
        "Empresa":vm.empresa.nombre.toUpperCase(),
        "Transporte":item.empresaLogistica.nombre.toUpperCase(),
        "Mes":"Agosto",
        "Cantidad movimientos" : item.agostoMovimientos,
        "Cantidad egresos" : item.agostoDespachos,
        "Peso total" : item.agostoPeso,
        "Bultos totales":item.agostoPaquetes
      };
    }

    function obtenerSeptiembre(item){
      return {
        "Empresa":vm.empresa.nombre.toUpperCase(),
        "Transporte":item.empresaLogistica.nombre.toUpperCase(),
        "Mes":"Septiembre",
        "Cantidad movimientos" : item.septiembreMovimientos,
        "Cantidad egresos" : item.septiembreDespachos,
        "Peso total" : item.septiembrePeso,
        "Bultos totales":item.septiembrePaquetes
      };
    }

    function obtenerOctubre(item){
      return {
        "Empresa":vm.empresa.nombre.toUpperCase(),
        "Transporte":item.empresaLogistica.nombre.toUpperCase(),
        "Mes":"Octubre",
        "Cantidad movimientos" : item.octubreMovimientos,
        "Cantidad egresos" : item.octubreDespachos,
        "Peso total" : item.octubrePeso,
        "Bultos totales":item.octubrePaquetes
      };
    }

    function obtenerNoviembre(item){
      return {
        "Empresa":vm.empresa.nombre.toUpperCase(),
        "Transporte":item.empresaLogistica.nombre.toUpperCase(),
        "Mes":"Noviembre",
        "Cantidad movimientos" : item.noviembreMovimientos,
        "Cantidad egresos" : item.noviembreDespachos,
        "Peso total" : item.noviembrePeso,
        "Bultos totales":item.noviembrePaquetes
      };
    }

    function obtenerDiciembre(item){
      return {
        "Empresa":vm.empresa.nombre.toUpperCase(),
        "Transporte":item.empresaLogistica.nombre.toUpperCase(),
        "Mes":"Diciembre",
        "Cantidad movimientos" : item.diciembreMovimientos,
        "Cantidad egresos" : item.diciembreDespachos,
        "Peso total" : item.diciembrePeso,
        "Bultos totales":item.diciembrePaquetes
      };
    }

    function obtenerTotalesResumenes(data){
      var lista = $filter('orderBy')(data.resumenes, ['empresaLogistica.nombre'], true);
      var totales = [];
      for (var i = lista.length - 1; i >= 0; i--) {
        totales.push({
          "Empresa":vm.empresa.nombre.toUpperCase(),
          "Transporte":lista[i].empresaLogistica.nombre.toUpperCase(),
          "Cantidad movimientos" : lista[i].cantidadDespachos,
          "Cantidad egresos" : lista[i].cantidadEgresos,
          "Peso total" : lista[i].pesoTotal,
          "Bultos totales":lista[i].bultoTotal,
          "Promedio peso por despacho":lista[i].promedioPesoDespacho,
          "Promedio bultos por despacho":lista[i].promedioBultoDespacho,
          "Promedio peso mensual":lista[i].promedioPesoMensual,
          "Promedio bultos mensual":lista[i].promedioBultoMensual,
          "Promedio peso diario":lista[i].promedioPesoDiario,
          "Promedio bultos diario":lista[i].promedioBultosDiario
        });
      }
      return totales.length>0 ? totales : [{"No hay datos":""}];
    }

    function obtenerTotales(data){
      var totales = [];
      totales.push({
        "Empresa":vm.empresa.nombre.toUpperCase(),
        "Cantidad movimientos" : data.cantidadDespachos,
        "Cantidad egresos" : data.cantidadEgresos,
        "Promedio bultos por despacho": data.bultoPromedioDespachos,
        "Promedio peso por despacho": data.pesoPromedioDespachos,
        "Cantidad bultos totales":data.bultoTotal,
        "Peso total": data.pesoTotal,
        "Promedio bultos por sucursal":data.bultoPromedioSucursal,
        "Promedio peso por sucursal":data.pesoPromedioSucursal
      });
      return totales.length>0 ? totales : [{"No hay datos":""}];
    }

    function armarReporte(){
      ServicioDialogos.abrirDialogoCargando();
      mostrarReporte();
    }

    function mostrarReporte(lista){
      var Url = URL_SERVIDOR+"/reportes/bultosPesoEmpresa/"+vm.empresa.id+"/"+vm.ano;
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.reporte-bienes-sucursal', {
        url: 'reporte-bienes-sucursal',
        templateUrl: 'app/app/main/reportes/reporte-bienes-sucursal/reporte-bienes-sucursal.html',
        controller: 'ReporteBienesSucursalCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Reportes',
          subtitulo:'Reporte de bienes por sucursal'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          empresas: function(Usuario, Empresa, $filter){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.empresa && usuario.empleado.empresa.id){
                var empresas = [];
                return Empresa.get({id:usuario.empleado.empresa.id}).$promise.then(function(empresa){
                  empresas.push(empresa);
                  return empresas;
                });
              } else {
                return Empresa.query().$promise.then(function(data) {
                  if (usuario.empleado && usuario.rol && usuario.rol.nombre=='CONSULTA' && usuario.empleado.empresas && usuario.empleado.empresas.length>0) {
                    var empresas = [];
                    data.forEach(function(empresa){
                      if (usuario.empleado.empresas.includes(empresa.id)){
                        empresas.push(empresa);
                      }
                    });
                    return $filter('orderBy')(empresas, 'nombre', false);
                  }
                  return data;
                });
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ReporteBienesSucursalCtrl', ReporteBienesSucursalCtrl);

  /** @ngInject */
  function ReporteBienesSucursalCtrl(NgTableParams, Util, rol, HeaderBarService, URL_SERVIDOR, $filter, $http, empresas, $stateParams, $scope, orderByFilter, $state, BienesPorSucursal, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.empresas = orderByFilter(empresas, "nombre", false);

    vm.mostrarReporteCompleto = mostrarReporteCompleto;
    vm.mostrarReporteCompletoExcel = mostrarReporteCompletoExcel;
    vm.volver = volver;

    if (rol.id!=1 && rol.id!=2 && rol.id!=3 && rol.id!=29) $state.go("home.home");

    function volver(){
      $state.go("home.lista-reportes");
    }

    function mostrarReporteCompletoExcel(){
      ServicioDialogos.abrirDialogoCargando();
      BienesPorSucursal.query({idEmpresa: vm.empresa.id}, function(data) {
        armarExcelStockCompleto(data);
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function armarExcelStockCompleto(data){
      data = $filter('orderBy')(data, ['suministro.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre', 'suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre', 'suministro.tipoSuministro.familiaSuministro.nombre', 'suministro.tipoSuministro.nombre'], true);
      var detallados = [];
      var nuevo;
      var marca;
      for (var j = data.length - 1; j >= 0; j--){
        nuevo = data[j].nuevo? "SI" : "NO";
        marca = data[j].suministro.marca? data[j].suministro.marca.toUpperCase() : "-";
        detallados.push({
          "Empresa" : data[j].sucursal.empresa.nombre.toUpperCase(),
          "Sucursal" : data[j].sucursal.nombre.toUpperCase(),
          "Código sucursal" : data[j].sucursal.codigoSucursal.toUpperCase(),
          "Grupo suministro" : data[j].suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
          "Familia suministro" : data[j].suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase(),
          "Código familia suministro" : data[j].suministro.tipoSuministro.familiaSuministro.codigoFamiliaSuministro.toUpperCase(),
          "Tipo suministro" : data[j].suministro.tipoSuministro.nombre.toUpperCase(),
          "Código tipo suministro" : data[j].suministro.tipoSuministro.codigoProducto.toUpperCase(),
          "Inventario" : data[j].inventario,
          "Serie" : data[j].serie,
          "Marca" : marca,
          "Nuevo" : nuevo
        });
      }
      if (detallados.length<=0) detallados.push({"No hay datos":""});
      var nombreDocumento = vm.empresa ? "bienes-"+Util.quitarCaracteresEspeciales(vm.empresa.nombre.toUpperCase()) : "bienes";
      alasql.promise('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true,sheetid:"Bienes por sucursal"}) FROM ?',[detallados])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function obtenerTotales(data){
      var lista = [];
      var ban = false;
      data.forEach(function(suministro){
        lista.forEach(function(item){
          if (item.tipoSuministro.id==suministro.tipoSuministro.id){
            ban = true;
            item.cantidad += suministro.cantidad;
          }
        });
        if (!ban){
          lista.push({tipoSuministro:suministro.tipoSuministro, cantidad:suministro.cantidad});
        }
        ban = false;
      });
      return lista;
    }

    function mostrarReporteCompleto(){
      ServicioDialogos.abrirDialogoCargando();
      var Url = URL_SERVIDOR+"/reportes/inventariables-sucursales/"+vm.empresa.id;
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }
    
    
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.reporte-agotamiento', {
        url: 'reporte-agotamiento',
        templateUrl: 'app/app/main/reportes/reporte-agotamiento/reporte-agotamiento.html',
        controller: 'ReporteAgotamientoCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Reportes',
          subtitulo:'Reporte de agotamiento de suministros por familia de suministros'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          empresas: function(Usuario, Empresa, $filter){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.empresa && usuario.empleado.empresa.id){
                var empresas = [];
                return Empresa.get({id:usuario.empleado.empresa.id}).$promise.then(function(empresa){
                  empresas.push(empresa);
                  return empresas;
                });
              } else {
                return Empresa.query().$promise.then(function(data) {
                  if (usuario.empleado && usuario.rol && usuario.rol.nombre=='CONSULTA' && usuario.empleado.empresas && usuario.empleado.empresas.length>0) {
                    var empresas = [];
                    data.forEach(function(empresa){
                      if (usuario.empleado.empresas.includes(empresa.id)){
                        empresas.push(empresa);
                      }
                    });
                    return $filter('orderBy')(empresas, 'nombre', false);
                  }
                  return data;
                });
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ReporteAgotamientoCtrl', ReporteAgotamientoCtrl);

  /** @ngInject */
  function ReporteAgotamientoCtrl(NgTableParams, Util, $filter, ReporteAgotamiento, rol, focus, HeaderBarService, URL_SERVIDOR, $http, empresas, FamiliaSuministroGrupo, GrupoEmpresa, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.empresas = orderByFilter(empresas, "nombre", false);

    vm.mostrarReporte = mostrarReporte;
    vm.mostrarReporteExcel = mostrarReporteExcel;
    vm.volver = volver;

    if (rol.id!=1 && rol.id!=2 && rol.id!=3 && rol.id!=29) $state.go("home.home");

    function volver(){
      $state.go("home.lista-reportes");
    }

    function mostrarReporteExcel(){
      ServicioDialogos.abrirDialogoCargando();
      ReporteAgotamiento.query({idFamilia:vm.familiaSuministro.id}, function(data){
        armarExcel(data);
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function armarExcel(data){
      var lista = $filter('orderBy')(data, ['tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre', 'tipoSuministro.familiaSuministro.grupoSuministro.nombre', 'tipoSuministro.familiaSuministro.nombre', 'tipoSuministro.nombre'], true);
      var array = [];
      var cubre60;
      var cubre90;
      var cubre180;
      for (var i = lista.length - 1; i >= 0; i--) {
        cubre60 = lista[i].agotamiento60Dias? "SI":"NO";
        cubre90 = lista[i].agotamiento90Dias? "SI":"NO";
        cubre180 = lista[i].agotamiento180Dias? "SI":"NO";
        array.push({
          "Empresa" : lista[i].tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase(),
          "Grupo suministro" : lista[i].tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
          "Familia suministro" : lista[i].tipoSuministro.familiaSuministro.nombre.toUpperCase(),
          "Código familia" : lista[i].tipoSuministro.familiaSuministro.codigoFamiliaSuministro.toUpperCase(),
          "Tipo suministro" : lista[i].tipoSuministro.nombre.toUpperCase(),
          "Código producto" : lista[i].tipoSuministro.codigoProducto.toUpperCase(),
          "Consumo 180 días" : lista[i].egreso180Dias,
          "Consumo 90 días" : lista[i].egreso90Dias,
          "Consumo 60 días" : lista[i].egreso60Dias,
          "Stock actual" : lista[i].stockActual,
          "Cubre 60 días" : cubre60,
          "Cubre 90 días" : cubre90,
          "Cubre 180 días" : cubre180
        });
      }
      var nombreDocumento = "agotamiento-"+Util.quitarCaracteresEspeciales(vm.familiaSuministro.nombre.toUpperCase());
      alasql.promise('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true,sheetid:"Agotamiento"}) FROM ?',[array])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function mostrarReporte(){
      ServicioDialogos.abrirDialogoCargando();
      var Url = URL_SERVIDOR+"/reportes/agotamiento/"+vm.familiaSuministro.id;
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }
    
   $scope.$watch('vm.grupo.nombre', function(){
      if (vm.familiaSuministro) vm.familiaSuministro=null;
      if (!vm.grupo) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupo.id}, function(data){
        vm.familias = orderByFilter(data,'nombre',false);
        focus('familia');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.empresa.id', function(){
      if (vm.grupo) vm.grupo=null;
      if (!vm.empresa) return;
      ServicioDialogos.abrirDialogoCargando();
      GrupoEmpresa.query({id:vm.empresa.id}, function(data){
        vm.grupos = orderByFilter(data,'nombre',false);
        focus('grupo');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });
    
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.reporte-anual-semestral-familia', {
        url: 'reporte-anual-semestral-familia',
        templateUrl: 'app/app/main/reportes/reporte-anual/reporte-anual.html',
        controller: 'ReporteAnualSemestralFamiliaCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Reportes',
          subtitulo:'Reporte anual o semestral de familia de suministro'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          empresas: function(Usuario, Empresa, $filter){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.empresa && usuario.empleado.empresa.id){
                var empresas = [];
                return Empresa.get({id:usuario.empleado.empresa.id}).$promise.then(function(empresa){
                  empresas.push(empresa);
                  return empresas;
                });
              } else {
                return Empresa.query().$promise.then(function(data) {
                  if (usuario.empleado && usuario.rol && usuario.rol.nombre=='CONSULTA' && usuario.empleado.empresas && usuario.empleado.empresas.length>0) {
                    var empresas = [];
                    data.forEach(function(empresa){
                      if (usuario.empleado.empresas.includes(empresa.id)){
                        empresas.push(empresa);
                      }
                    });
                    return $filter('orderBy')(empresas, 'nombre', false);
                  }
                  return data;
                });
              }
            });
          }

        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ReporteAnualSemestralFamiliaCtrl', ReporteAnualSemestralFamiliaCtrl);

  /** @ngInject */
  function ReporteAnualSemestralFamiliaCtrl(NgTableParams, Util, $filter, ReporteAnualSemestral, rol, focus, HeaderBarService, URL_SERVIDOR, $http, empresas, FamiliaSuministroGrupo, GrupoEmpresa, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.empresas = orderByFilter(empresas, "nombre", false);

    vm.mostrarReporte6Meses = mostrarReporte6Meses;
    vm.mostrarReporte6MesesExcel = mostrarReporte6MesesExcel;
    vm.mostrarReporte12Meses = mostrarReporte12Meses;
    vm.mostrarReporte12MesesExcel = mostrarReporte12MesesExcel;
    vm.volver = volver;

    if (rol.id!=1 && rol.id!=2 && rol.id!=3 && rol.id!=29) $state.go("home.home");

    function volver(){
      $state.go("home.lista-reportes");
    }

    function mostrarReporte12MesesExcel(){
      ServicioDialogos.abrirDialogoCargando();
      ReporteAnualSemestral.get({idFamilia:vm.familiaSuministro.id, semestral:false}, function(data){
        armarExcelReporte12Meses(data);
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function mostrarReporte6MesesExcel(){
      ServicioDialogos.abrirDialogoCargando();
      ReporteAnualSemestral.get({idFamilia:vm.familiaSuministro.id, semestral:true}, function(data){
        armarExcelReporte6Meses(data);
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function armarExcelReporte6Meses(data){
      var pagina1 = obtenerTotales(data);
      var pagina2 = obtenerDetalles(data, true);
      var opts = [{sheetid:'Totales 6 meses',header:true}, {sheetid:'Detalles 6 meses',header:true}];
      var nombreDocumento = "reporte-semestral-"+Util.quitarCaracteresEspeciales(vm.familiaSuministro.nombre.toUpperCase());
      alasql.promise('SELECT INTO XLSX("'+nombreDocumento+'.xlsx",?) FROM ?',[opts,[pagina1, pagina2]])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function armarExcelReporte12Meses(data){
      var pagina1 = obtenerTotales(data);
      var pagina2 = obtenerDetalles(data, false);
      var opts = [{sheetid:'Totales 12 meses',header:true}, {sheetid:'Detalles 12 meses',header:true}];
      var nombreDocumento = "reporte-anual-"+Util.quitarCaracteresEspeciales(vm.familiaSuministro.nombre.toUpperCase());
      alasql.promise('SELECT INTO XLSX("'+nombreDocumento+'.xlsx",?) FROM ?',[opts,[pagina1, pagina2]])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function obtenerDetalles(data, semestral){
      var lista = $filter('orderBy')(data.tipos, ['tipoSuministro.nombre'], true);
      var totales = [];
      var objeto = {};
      var fechaIngreso = null;
      var fechaEgreso = null;
      for (var i = lista.length - 1; i >= 0; i--) {
        fechaIngreso = lista[i].ultimoIngreso? $filter('date')(lista[i].ultimoIngreso, "dd/MM/yyyy") : "-";
        fechaEgreso = lista[i].ultimoEgreso? $filter('date')(lista[i].ultimoEgreso, "dd/MM/yyyy") : "-";
        objeto = {
          "Empresa":vm.empresa.nombre.toUpperCase(),
          "Grupo suministro":lista[i].tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
          "Familia suministro":lista[i].tipoSuministro.familiaSuministro.nombre.toUpperCase(),
          "Código familia":lista[i].tipoSuministro.familiaSuministro.codigoFamiliaSuministro.toUpperCase(),
          "Tipo suministro":lista[i].tipoSuministro.nombre.toUpperCase(),
          "Código producto":lista[i].tipoSuministro.codigoProducto.toUpperCase(),
          "Último ingreso" : fechaIngreso,
          "Último egreso" : fechaEgreso,
          "Total ingresado" : lista[i].totalIngresado,
          "Saldo actual" : lista[i].saldoActual,
          "Consumo total":lista[i].consumoTotal,
          "Promedio mensual":lista[i].promedioMensual
        };
        objeto[lista[i].mes1.fecha]=lista[i].mes1.cantidad;
        objeto[lista[i].mes2.fecha]=lista[i].mes2.cantidad;
        objeto[lista[i].mes3.fecha]=lista[i].mes3.cantidad;
        objeto[lista[i].mes4.fecha]=lista[i].mes4.cantidad;
        objeto[lista[i].mes5.fecha]=lista[i].mes5.cantidad;
        objeto[lista[i].mes6.fecha]=lista[i].mes6.cantidad;
        if (!semestral){
          objeto[lista[i].mes7.fecha]=lista[i].mes7.cantidad;
          objeto[lista[i].mes8.fecha]=lista[i].mes8.cantidad;
          objeto[lista[i].mes9.fecha]=lista[i].mes9.cantidad;
          objeto[lista[i].mes10.fecha]=lista[i].mes10.cantidad;
          objeto[lista[i].mes11.fecha]=lista[i].mes11.cantidad;
          objeto[lista[i].mes12.fecha]=lista[i].mes12.cantidad;
        }
        totales.push(objeto);
      }
      return totales;
    }

    function obtenerTotales(data){
      var totales = [];
      totales.push({
        "Empresa":vm.empresa.nombre.toUpperCase(),
        "Grupo suministro" : data.familia.grupoSuministro.nombre.toUpperCase(),
        "Familia suministro" : data.familia.nombre.toUpperCase(),
        "Código familia" : data.familia.codigoFamiliaSuministro.toUpperCase(),
        "Cantidad egresos total" : data.cantidadEgresoTotal,
        "Promedio mensual": data.promedioTotal
      });
      return totales;
    }

    function mostrarReporte12Meses(){
      ServicioDialogos.abrirDialogoCargando();
      var Url = URL_SERVIDOR+"/reportes/anualSemestral/"+vm.familiaSuministro.id+"/"+false;
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function mostrarReporte6Meses(){
      ServicioDialogos.abrirDialogoCargando();
      var Url = URL_SERVIDOR+"/reportes/anualSemestral/"+vm.familiaSuministro.id+"/"+true;
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }
    
   $scope.$watch('vm.grupo.nombre', function(){
      if (vm.familiaSuministro) vm.familiaSuministro=null;
      if (!vm.grupo) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupo.id}, function(data){
        vm.familias = orderByFilter(data,'nombre',false);
        focus('familia');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.empresa.id', function(){
      if (vm.grupo) vm.grupo=null;
      if (!vm.empresa) return;
      ServicioDialogos.abrirDialogoCargando();
      GrupoEmpresa.query({id:vm.empresa.id}, function(data){
        vm.grupos = orderByFilter(data,'nombre',false);
        focus('grupo');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });
    
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-reportes', {
        url: 'lista-reportes',
        templateUrl: 'app/app/main/reportes/lista/lista.html',
        controller: 'ListaReportesCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Reportes',
          subtitulo:'Seleccione el reporte que desea visualizar'
        },
        resolve: {
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data) {
              return data;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaReportesCtrl', ListaReportesCtrl);

  /** @ngInject */
  function ListaReportesCtrl(NgTableParams, rol, HeaderBarService, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.rol = rol;
    vm.irAReporteExistencias = irAReporteExistencias;
    vm.irAReporteStockMinimo = irAReporteStockMinimo;
    vm.irAReporteOcupacionUbicaciones = irAReporteOcupacionUbicaciones;
    vm.irAReporteSuministroDeposito = irAReporteSuministroDeposito;
    vm.irAReporteTopeSucursal = irAReporteTopeSucursal;
    vm.irAReporteIngresosOrdenRemito = irAReporteIngresosOrdenRemito;
    vm.irAReporteEmpresaActivos = irAReporteEmpresaActivos;
    vm.irAReportePesoYBultos = irAReportePesoYBultos;
    vm.irAReporteAnualSemestral = irAReporteAnualSemestral;
    vm.irAReporteIngresosEntreFechas = irAReporteIngresosEntreFechas;
    vm.irAReporteEntregasEntreFechas = irAReporteEntregasEntreFechas;
    vm.irAReporteAgotamiento = irAReporteAgotamiento;
    vm.irAReporteProblemasIngresos = irAReporteProblemasIngresos;
    vm.irAReporteTiemposDeSalidas = irAReporteTiemposDeSalidas;
    vm.irAReporteExistenciasDonacionScrap = irAReporteExistenciasDonacionScrap;
    vm.irAReporteConfirmacionSucursales = irAReporteConfirmacionSucursales;
    vm.irAReporteConsumo = irAReporteConsumo;
    vm.irAReporteConsumoTotales = irAReporteConsumoTotales;
    vm.irAReporteBienesPorSucursal = irAReporteBienesPorSucursal;
    vm.irAReporteIngresosYSalidasEntreFechas = irAReporteIngresosYSalidasEntreFechas;
    vm.irAReporteTiemposPreparacion = irAReporteTiemposPreparacion;

    if (rol.id!=1 && rol.id!=2 && rol.id!=3 && rol.id!=29) $state.go("home.home");

    function irAReporteTiemposPreparacion() {
      $state.go("home.reporte-tiempos-preparacion");
    }


    function irAReporteIngresosYSalidasEntreFechas(){
      $state.go("home.reporte-ingresos-salidas");
    }

    function irAReporteBienesPorSucursal(){
      $state.go("home.reporte-bienes-sucursal");
    }

    function irAReporteConsumoTotales(){
      $state.go("home.reporte-consumos-totales");
    }

    function irAReporteConsumo(){
      $state.go("home.reporte-consumo");
    }

    function irAReporteConfirmacionSucursales(){
      $state.go("home.reporte-confirmacion-sucursales");
    }

    function irAReporteExistenciasDonacionScrap(){
      $state.go("home.reporte-existencias-donacion-scrap");
    }

    function irAReporteTiemposDeSalidas(){
      $state.go("home.reporte-tiempo-salidas");
    }

    function irAReporteProblemasIngresos(){
      $state.go("home.reporte-problemas-ingresos");
    }

    function irAReporteAgotamiento(){
      $state.go("home.reporte-agotamiento");
    }

    function irAReporteEntregasEntreFechas(){
      $state.go("home.reporte-entregas-entre-fechas");
    }

    function irAReporteIngresosEntreFechas(){
      $state.go("home.reporte-ingresos-entre-fechas");
    }

    function irAReporteAnualSemestral(){
      $state.go("home.reporte-anual-semestral-familia");
    }

    function irAReportePesoYBultos(){
      $state.go("home.reporte-bultos-peso-empresa");
    }

    function irAReporteEmpresaActivos(){
      $state.go("home.reporte-empresa-activos");
    }

    function irAReporteIngresosOrdenRemito(){
      $state.go("home.reporte-ingresos-remito-orden");
    }

    function irAReporteSuministroDeposito(){
      $state.go("home.reporte-suministro-deposito");
    }

    function irAReporteTopeSucursal(){
      $state.go("home.reporte-tope-sucursal");
    }

    function irAReporteStockMinimo(){
      $state.go("home.reporte-stock");
    }

    function irAReporteOcupacionUbicaciones(){
      $state.go("home.reporte-ocupacion-ubicaciones");
    }

    function irAReporteExistencias(){
      $state.go("home.reporte-existencias");
    }
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.editar-pedido', {
        url: 'editar-pedidos',
        templateUrl: 'app/app/main/pedidos/editar/editar.html',
        controller: 'EditarPedidoCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar pedidos',
          subtitulo:'Nuevo pedido'
        },
        resolve: {
          usuario: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario;
            });
          },
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          deposito: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return usuario.empleado.deposito;
              } else {
                return ;
              }
            });
          },
          empresa: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.empresa && usuario.empleado.empresa.id){
                return usuario.empleado.empresa;
              } else {
                return ;
              }
            });
          },
          sucursales: function(Usuario, SucursalEmpresa){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.empresa && usuario.empleado.empresa.id){
                return SucursalEmpresa.query({id:usuario.empleado.empresa.id}).$promise.then(function(data){
                  return data;
                });
              } else {
                return ;
              }
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarPedidoCtrl', EditarPedidoCtrl);

  /** @ngInject */
  function EditarPedidoCtrl(NgTableParams, $timeout, deposito, PedidoSucursalComprobar, ProductosTopesSucursalSolicitante, sucursales, rol, usuario, HeaderBarService, ServicioModales, empresa, focus, $stateParams, $scope, $filter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    if (rol.id!=30) $state.go('home.home');
    vm.pedido = {};
    vm.pedido.usuario = usuario;
    vm.pedido.deposito = deposito;
    vm.pedido.empresa = empresa;
    vm.sucursales = $filter('orderBy')(sucursales, 'nombre', false);
    vm.cancelar = cancelar;
    vm.seleccionar = seleccionar;
    vm.cambiarSeleccion = cambiarSeleccion;
    vm.habilitarBoton = habilitarBoton;
    vm.visualizarPedido = visualizarPedido;
    vm.guardar = guardar;
    vm.visualizarSeleccionados = visualizarSeleccionados;
    vm.verPedidosAnteriores = verPedidosAnteriores;


    inicializar();

    window.onbeforeunload = function(){
      return "seguro?";
    };

    function verPedidosAnteriores(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalPedidosAnteriores({
        onResult: function(resultado) {
          $timeout(function() {
            cargarSeleccionadosPorPedidoAnterior(resultado.detalles);
          }, 500);
        },
        seleccionados: obtenerSeleccionados()
      });
    }

    function cargarSeleccionadosPorPedidoAnterior(detalles){
      if (detalles.length===0) {
        ServicioDialogos.mostrarDialogoError(null, "Los detalles del pedido anterior seleccionado, ya fueron asignados");
        return;
      }
      var cant = 0;
      detalles.forEach(function(detalle){
        vm.productos.forEach(function(item){
          if (item.tipoSuministro.id === detalle.tipoSuministro.id){
            cant += asignarCantidad(detalle, item);
          }
        });
      });
      if (cant === detalles.length){
        ServicioDialogos.mostrarDialogoExito(null, "Se asignaron todos los detalles seleccionables del pedido anterior, y sus respectivas cantidades");
      } else if (cant > 0 && cant != detalles.length) {
        ServicioDialogos.mostrarDialogoInformacion(null, "Se asignaron algunos detalles seleccionables del pedido anterior con sus respectivas cantidades. No fue posible asignar todos por falta de stock y/o el hecho de superar el tope de consumo establecido por producto y/o que ya fueron asignados anteriormente");
      } else {
        ServicioDialogos.mostrarDialogoError(null, "No se pudo asignar ningún detalle del pedido anterior. Esto se debe a la falta de stock y/o el hecho de superar el tope de consumo definido en los productos y/o que ya fueron asignados anteriormente");
      }
    }

    function asignarCantidad(detalle, producto){
      var cant = 0;
      if (producto.stockActual>0){
        if (producto.cantidadTope===null || (producto.cantidadTope!==null && producto.consumido+detalle.cantidad <= producto.cantidadTope))
        producto.seleccionado = true;
        producto.cantidadSolicitada = detalle.cantidad;
        cant = 1;
      }
      return cant;
    }

    function obtenerSeleccionados(){
      var detalles = [];
      vm.productos.forEach(function(item){
        if (item.seleccionado){
          detalles.push({
            'tipoSuministro': item.tipoSuministro,
            'cantidad': item.cantidadSolicitada
          });
        }
      });
      return detalles;
    }

    function visualizarSeleccionados(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalSeleccionadosPedido({
        onResult: function(resultado) {
          console.log(resultado);
        },
        seleccionados: obtenerSeleccionados()
      });
    }

    function guardar(){
      var detalles = [];
      vm.productos.forEach(function(item){
        if (item.seleccionado){
          detalles.push({
            'tipoSuministro': item.tipoSuministro,
            'cantidad': item.cantidadSolicitada
          });
        }
      });
      vm.pedido.detalles = detalles;
      visualizarPedido();
    }

    function habilitarBoton(){
      if (vm.productos && vm.productos.length>0){
        var cant = 0;
        var cantOk = 0;
        var cantMal = 0;
        vm.productos.forEach(function(item){
          if (item.seleccionado){
            cant+=1;
            if (item.cantidadSolicitada && (item.cantidadTope && item.cantidadSolicitada>(item.cantidadTope-item.consumido))){
              cantMal+=1;
            }
            if (item.cantidadSolicitada && item.cantidadSolicitada>0) {
              cantOk+=1;
            }
          }
        });
        return cant > 0 && cantOk==cant && cantMal === 0;
      }
      return false;
    }

    function visualizarPedido(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalVisualizarResumenPedido({
        onResult: function(resultado) {
          console.log(resultado);
        },
        pedido: vm.pedido,
        deposito: vm.pedido.deposito
      });
    }

    function inicializar(){
      inicializarTabla();
      vm.fecha=$filter('date')(new Date(), 'dd/MM/yyyy HH:mm');
      vm.solicitante = vm.pedido.usuario.solicitante.apellido.toUpperCase()+", "+vm.pedido.usuario.solicitante.nombre.toUpperCase();
      vm.tieneSucursal = false;
      if (usuario && usuario.solicitante && usuario.solicitante.sucursal){
        vm.pedido.sucursal = usuario.solicitante.sucursal;
        vm.tieneSucursal = true;
        vm.bandera=true;
        seleccionar();
      }
    }

    function cancelar(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea cancelar el pedido?', function() {
        $state.go('home.lista-pedidos');
      });
    }

    function cambiarSeleccion(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "Si continúa, perderá la información ingresada. \n¿Está seguro que desea continuar?", function(){
        $timeout(function() {
          vm.bandera=false;
          vm.productos = [];
        }, 50);
      });
    }

    function formatearData(data){
      var suministros = [];
      data.forEach(function(item){
        if (item.tipoSuministro.solicitable){
          item.codigoProducto = item.tipoSuministro.codigoProducto;
          suministros.push(item);
        }
      });
      return suministros;
    }


    function seleccionar(){
      ServicioDialogos.abrirDialogoCargando();
      PedidoSucursalComprobar.get({idSucursal: vm.pedido.sucursal.id}).$promise.then(function(data){
        if (!data.comprobar){
          ServicioDialogos.mostrarDialogoError(null, "Existen pedidos pendientes para la sucursal seleccionada");
          ServicioDialogos.cerrarDialogoCargando();
          return;
        }
        vm.bandera=true;
        ProductosTopesSucursalSolicitante.query({idSucursal: vm.pedido.sucursal.id, idDeposito: vm.pedido.deposito.id, idSolicitante: vm.pedido.usuario.solicitante.id}, function(data){
          vm.productos = formatearData(data);
          actualizarTabla();
          ServicioDialogos.cerrarDialogoCargando();
        }, function(err){
          console.log(err);
          ServicioDialogos.cerrarDialogoCargando();
        });
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function actualizarTabla(){
      vm.tableParams.settings({
        data: $filter('orderBy')(vm.productos, ['stockActual>0', 'nombre'], false)
      });
      vm.tableParams.reload();
    }

    function filtrarTabla($defer, params) {
      var filtros = params.filter();
      var filtrosNuevos = {};
      for (var key in filtros) {
        if (filtros.hasOwnProperty(key) && filtros[key]!=='') {
          switch(key) {
            case 'tipoSuministro.nombre':
              angular.extend(filtrosNuevos, {
                tipoSuministro: {
                nombre: filtros[key]
                }
              });
              break;
            default:
              filtrosNuevos[key] = filtros[key];
          }
        }
      }
      var filtrados = filtros ? $filter('filter')(vm.productos, filtrosNuevos) : vm.productos;
      filtrados = params.sorting() ? $filter('orderBy')(filtrados, params.orderBy()) : filtrados;
      if (filtrados && filtrados.length){
        params.total(filtrados.length);
        return $defer.resolve(filtrados.slice((params.page() - 1) * params.count(), params.page() * params.count()));
      } else {
        params.total(0);
        return $defer.resolve(null);
      }
    }

    function inicializarTabla(){
      vm.tableParams = new NgTableParams({
        page: 1,
        count: 100,
      },{
        getData: function($defer,params){ return filtrarTabla($defer, params);}
      });
      vm.tableParams.reload();
    }

    $scope.$watch('vm.pedido.sucursal.id', function(before, after){
      if (before === after) return;
      if (!vm.pedido.sucursal) return;
    });

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.lista-pedidos', {
        url: 'lista-pedidos',
        templateUrl: 'app/app/main/pedidos/lista/lista.html',
        controller: 'ListaPedidosCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Administrar pedidos',
          subtitulo:'Lista de pedidos'
        },
        resolve: {
          pedidos: function(Usuario, PedidosUsuario, PedidosUltimosDepositoEmpresa, PedidosUltimosDeposito, PedidosUltimos){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.rol.id===30){
                return PedidosUsuario.query({'idUsuario':usuario.id}).$promise.then(function(data){
                  return data;
                });
              } else {
                var deposito = usuario.empleado.deposito;
                var empresa = usuario.empleado.empresa;
                if (deposito){
                  if (empresa){
                    return PedidosUltimosDepositoEmpresa.query({'idDeposito':deposito.id, 'idEmpresa':empresa.id}).$promise.then(function(data){
                      return data;
                    });
                  } else {
                    return PedidosUltimosDeposito.query({'idDeposito':deposito.id}).$promise.then(function(data){
                      return data;
                    });
                  }
                } else {
                  return PedidosUltimos.query({}).$promise.then(function(data){
                    return data;
                  });
                }
              }
            });
          },
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          },
          usuario: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario;
            });
          },
          pedidosSinConfirmar: function(Usuario, PedidoSucursalComprobar){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario && usuario.solicitante && usuario.solicitante.sucursal){
                return PedidoSucursalComprobar.get({idSucursal: usuario.solicitante.sucursal.id}).$promise.then(function(data){
                  return data;
                });
              } else {
                return null;
              }
            });
          },

        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaPedidosCtrl', ListaPedidosCtrl);

  /** @ngInject */
  function ListaPedidosCtrl(NgTableParams, pedidosSinConfirmar, PedidoSucursalComprobar , ComprobarMovimientoPedido, PedidosUltimosDeposito, PedidosUltimos, PedidosUltimosDepositoEmpresa, PedidosUsuario, usuario, AnularPedido, HeaderBarService, rol, $filter, focus, pedidos, Usuario, IngresoEstadoModificar , ProveedorEmpresa, IngresoUltimosCincuentaDeposito, IngresoUltimosCincuenta, IngresoUltimosCienDepositoEmpresa, $stateParams, $scope, orderByFilter, $state, ServicioModales, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.rol = rol;
    vm.pedidosSinConfirmar = pedidosSinConfirmar;
    vm.pedidos = orderByFilter(pedidos,'fecha',true);
    vm.visualizarPedido = visualizarPedido;
    vm.crearNuevo = crearNuevo;
    vm.rechazar = rechazar;
    vm.confirmarReclamar = confirmarReclamar;
    vm.anular = anular;
    vm.atenderPedido = atenderPedido;

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10,
    },{
      getData: function($defer,params){ return filtrarTabla($defer, params);}
    });
    vm.tableParams.reload();

    function filtrarTabla($defer, params) {
      var filtros = params.filter();
      var filtrosNuevos = {};

      for (var key in filtros) {
        if (filtros.hasOwnProperty(key) && filtros[key]!=='') {
          switch(key) {
            case 'deposito.nombre':
              angular.extend(filtrosNuevos, {
                deposito: {
                nombre: filtros[key]
                }
              });
              break;
            case 'empresa.nombre':
              angular.extend(filtrosNuevos, {
                empresa: {
                  nombre: filtros[key]
                }
              });
              break;
            case 'sucursal.nombre':
              angular.extend(filtrosNuevos, {
                sucursal: {
                nombre: filtros[key]
                }
                });
              break;
            case 'estado.nombre':
              angular.extend(filtrosNuevos, {
                estado: {
                nombre: filtros[key]
                }
              });
              break;
            default:
              filtrosNuevos[key] = filtros[key];
          }
        }
      }
      var filtrados = filtros ? $filter('filter')(vm.pedidos, filtrosNuevos) : vm.pedidos;
      filtrados = params.sorting() ? $filter('orderBy')(filtrados, params.orderBy()) : filtrados;
      if (filtrados && filtrados.length){
        params.total(filtrados.length);
        return $defer.resolve(filtrados.slice((params.page() - 1) * params.count(), params.page() * params.count()));
      } else {
        params.total(0);
        return $defer.resolve(null);
      }
    }

    function atenderPedido(pedido){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea atender el pedido N° "+pedido.numeroPedido+"?", function(){
        $state.go('home.atender-pedido', {pedido:pedido.id});
      });
    }

    function confirmarReclamar(pedido){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalConfirmarReclamarPedido({
        onResult: function(resultado) {
          actualizarTablaRechazado();
          comprobarPedidosSinConfirmar();
        },
        pedido: pedido
      });
    }

    function comprobarPedidosSinConfirmar(){
      if (usuario && usuario.solicitante && usuario.solicitante.sucursal){
        PedidoSucursalComprobar.get({idSucursal: usuario.solicitante.sucursal.id}).$promise.then(function(data){
          vm.pedidosSinConfirmar = data;
        });
      }
    }

    function anular(pedido){
      if (pedido.usuario.id == usuario.id){
        ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea anular el pedido N° "+pedido.numeroPedido+"?", function(){
          anularPedido(pedido);
        }, null, false);
      } else {
        ServicioDialogos.mostrarDialogoError(null, "No puede anular un pedido que no haya generado");
      }
    }

    function anularPedido(pedido){
      ComprobarMovimientoPedido.get({idPedido:pedido.id}).$promise.then(function(p){
        if (p && p.id){
          ServicioDialogos.mostrarDialogoError(null, "No se puede anular el pedido porque ya fue atendido");
        } else {
          AnularPedido.update({id: pedido.id}).$promise.then(function(data){
            comprobarPedidosSinConfirmar();
            actualizarPedidos(data);
          }, function(err) {
            console.log(err);
            ServicioDialogos.mostrarDialogoError();
          });
        }
      }, function(err) {
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
      });
    }

    function actualizarPedidos(){
      if (usuario.rol.id===30){
        PedidosUsuario.query({'idUsuario':usuario.id}).$promise.then(function(data){
          actualizarTabla(data);
          ServicioDialogos.mostrarDialogoExito(null, "Se ha anulado el pedido con éxito");
        });
      } else {
        var deposito = usuario.empleado.deposito;
        var empresa = usuario.empleado.empresa;
        if (deposito){
          if (empresa){
            PedidosUltimosDepositoEmpresa.query({'idDeposito':deposito.id, 'idEmpresa':empresa.id}).$promise.then(function(data){
              actualizarTabla(data);
              ServicioDialogos.mostrarDialogoExito(null, "Se ha anulado el pedido con éxito");
            });
          } else {
            PedidosUltimosDeposito.query({'idDeposito':deposito.id}).$promise.then(function(data){
              actualizarTabla(data);
              ServicioDialogos.mostrarDialogoExito(null, "Se ha anulado el pedido con éxito");
            });
          }
        } else {
          PedidosUltimos.query({}).$promise.then(function(data){
            actualizarTabla(data);
            ServicioDialogos.mostrarDialogoExito(null, "Se ha anulado el pedido con éxito");
          });
        }
      }
    }
        
    function actualizarTabla(data){
      vm.pedidos = orderByFilter(data,'fecha',true);
      vm.tableParams.settings({
        data: vm.pedidos
      });
      vm.tableParams.reload();
    }

    function actualizarTablaRechazado(){
      ServicioDialogos.abrirDialogoCargando();
      if (usuario.rol.id===30){
        PedidosUsuario.query({'idUsuario':usuario.id}).$promise.then(function(data){
          actualizarTabla(data);
          ServicioDialogos.cerrarDialogoCargando();
        });
      } else {
        var deposito = usuario.empleado.deposito;
        var empresa = usuario.empleado.empresa;
        if (deposito){
          if (empresa){
            PedidosUltimosDepositoEmpresa.query({'idDeposito':deposito.id, 'idEmpresa':empresa.id}).$promise.then(function(data){
              actualizarTabla(data);
              ServicioDialogos.cerrarDialogoCargando();
            });
          } else {
            PedidosUltimosDeposito.query({'idDeposito':deposito.id}).$promise.then(function(data){
              actualizarTabla(data);
              ServicioDialogos.cerrarDialogoCargando();
            });
          }
        } else {
          PedidosUltimos.query({}).$promise.then(function(data){
            actualizarTabla(data);
            ServicioDialogos.cerrarDialogoCargando();
          });
        }
      }
    }

    function visualizarPedido(pedido){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalPedido({
        onResult: function(resultado) {
          console.log(resultado);
        },
        pedido: pedido,
      });
    }

    function rechazar(pedido) {
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalRechazarPedido({
        onResult: function(resultado) {
          actualizarTablaRechazado();
        },
        pedido: pedido
      });
    }

    function crearNuevo() {
      $state.go('home.editar-pedido');
    }

  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.atender-pedido', {
        url: 'atender-pedido/:pedido',
        templateUrl: 'app/app/main/pedidos/atender-pedido/atender-pedido.html',
        controller: 'AtenderPedidoCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Egreso de suministros por pedido',
          subtitulo: 'Agregar suministro a pedido',
          objeto:null,
          pedido:null
        },
        resolve: {
          tipoEgreso: function(TipoMovimiento){
            return TipoMovimiento.get({id:1}).$promise.then(function(data) {
              return data;
            });
          },
          estadoGenerado: function(EstadoMovimiento){
            return EstadoMovimiento.get({id:1}).$promise.then(function(data) {
              return data;
            });
          },
          pedido: function(Pedido, $stateParams){
            return Pedido.get({id:$stateParams.pedido}).$promise.then(function(data){
              return data;
            });
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('AtenderPedidoCtrl', AtenderPedidoCtrl);

  /** @ngInject */
  function AtenderPedidoCtrl(NgTableParams, $filter, Pedido, AsignarEgresoPedido, UltimoMovimiento, pedido, ServicioModales, tipoEgreso, estadoGenerado, HeaderBarService, Egreso, $timeout, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.tipoEgreso = tipoEgreso;
    vm.estadoGenerado = estadoGenerado;
    inicializar();


    vm.volver = volver;

    vm.detalles = [];
    vm.detallesInventariables = [];
    vm.detallesNoInventariables = [];

    vm.detallesNoInventariablesAgrupados = [];
    vm.detallesInventariablesAgrupados = [];

    vm.mostrarInformacion = mostrarInformacion;
    vm.ubicacionCompleta = ubicacionCompleta;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.quitarTipo = quitarTipo;
    vm.modo = "nuevo";
    vm.abrirModal = abrirModal;
    vm.guardar = guardar;
    vm.montoTotal = montoTotal;
    vm.getIcono = getIcono;
    vm.abrirModalAgregarSuministroPedido = abrirModalAgregarSuministroPedido;
    vm.visualizarPedido = visualizarPedido;

    function visualizarPedido(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalPedido({
        onResult: function(resultado) {
          console.log(resultado);
        },
        pedido: pedido,
        deposito: pedido.deposito
      });
    }

    function abrirModalAgregarSuministroPedido(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalAgregarSuministroPedido({
        onResult: function(resultado) {
          vm.detalles = resultado.detalles;
          vm.detallesNoInventariablesAgrupados = [];
          vm.detallesInventariablesAgrupados = [];
          cargarDetalles();
        },
        sucursal: vm.egreso.sucursal,
        detalles: vm.detalles,
        deposito: vm.egreso.deposito,
        pedido: pedido
      });
    }

    window.onbeforeunload = function(){
      return '';
    };


    function inicializar(){
      armarEgreso();
      vm.numeroPedido = pedido.numeroPedido;
      vm.fecha = $filter('date')(new Date(), 'dd/MM/yyyy HH:mm');
      vm.solicitante = vm.egreso.solicita? vm.egreso.solicita.apellido&&vm.egreso.solicita.nombre? vm.egreso.solicita.apellido.toUpperCase()+", "+vm.egreso.solicita.nombre : "-":"-";

    }

    function armarEgreso(){
      vm.egreso = {
        empresa: pedido.empresa,
        sucursal: pedido.sucursal,
        deposito: pedido.deposito,
        solicita: pedido.usuario.solicitante,
        sector: pedido.sector,
        solicitante: pedido.autoriza,
        observacion: pedido.observacion
      };
    }

    function getIcono(estaAbierto) {
      if (estaAbierto) {
        return 'glyphicon glyphicon-chevron-down';
      } else {
        return 'glyphicon glyphicon-chevron-right';
      }
    }

    function montoTotal(){
      var total = 0;
      for(var i = 0; i < vm.detalles.length; i++){
        total += vm.detalles[i].suministro.precioUnitario*vm.detalles[i].cantidad;
      }
      return total ? total.toFixed(2) : "-";
    }

    function guardar(){
      if (vm.detalles.length===0){
        ServicioDialogos.mostrarDialogoError(null, "No ha agregado ningún suministro");
      } else {
        ServicioDialogos.mostrarDialogoConfirmacionWarning(
          null,
          "¿Está seguro que desea guardar el egreso?",
          function(){
            guardarEgreso();
          },
          null,
          false
        );
      }
    }

    function ubicacionCompleta(detalle){
      if (detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación",
        "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+detalle.suministro.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+detalle.suministro.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+detalle.suministro.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+detalle.suministro.ubicacion.numeroUbicacion+
        "\nN° de orden: "+detalle.suministro.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+detalle.suministro.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+detalle.suministro.ubicacion.categoriaPeso.nombre.toUpperCase());
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "No hay ubicación");
      }
    }

    function ubicacionNaveNumeroOrden(detalle){
      //console.log(detalle);
      if (detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        return "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+detalle.suministro.ubicacion.numeroOrden;
      }
    }

    function quitarTipo(agrupado){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(
        null,
        "¿Está seguro que desea eliminar el detalle?",
        function(){
          limpiarTipo(agrupado.tipoSuministro);
        }
      );
    }

    function limpiarTipo(tipo){
      for (var i = vm.detalles.length - 1; i >= 0; i--) {
        if (vm.detalles[i].suministro.tipoSuministro.id == tipo.id){
          vm.detalles.splice(i, 1);
        }
      }
      vm.detallesNoInventariablesAgrupados = [];
      vm.detallesInventariablesAgrupados = [];
      cargarDetalles();
    }

    function obtenerNumeroMovimiento(callback){
      UltimoMovimiento.get({}, function(data){
        if (data && !isNaN(data.id)){
          callback(data.id + 10001);
        } else {
          callback(10001);
        }
      }, function (err){
        console.log(err);
      });
    }

    function obtenerEgreso(callback){
      obtenerNumeroMovimiento(function(data){
        var movimiento = {
          tipoMovimiento: tipoEgreso,
          estadoMovimiento: estadoGenerado,
          sector: pedido.sector,
          deposito: vm.egreso.deposito,
          empresa: vm.egreso.empresa,
          sucursal: vm.egreso.sucursal,
          observacion: vm.egreso.observacion,
          fecha: new Date(),
          detalles: vm.detalles,
          numeroMovimiento: data,
          caja: vm.egreso.caja,
          usuario: vm.egreso.usuario,
          solicita: vm.egreso.solicita,
          solicitante: vm.egreso.solicitante,
          numeroVale: vm.egreso.numeroVale,
          numeroMail: vm.egreso.numeroMail
        };
        callback(movimiento);
      });
    }


    function guardarEgreso(){
      Pedido.get({id:pedido.id}, function(p){
        if (p.estado.id==1){
          obtenerEgreso(function(movimiento){
            Egreso.save(movimiento, function(data){
              AsignarEgresoPedido.update({idMovimiento: data.id, idPedido:pedido.id}, function(datos){
                ServicioDialogos.mostrarDialogoGuardadoExito(
                  null,
                  "Se ha registrado con éxito el egreso",
                  function(){
                    $state.go('home.lista-egreso');
                  });
              }, function(err){
                ServicioDialogos.mostrarDialogoError(null, "Se guardó el egreso pero no se pudo vincular con el pedido en cuestión");
              })
            }, function(err){
              ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar el egreso");
            });
          });
        } else {
          ServicioDialogos.mostrarDialogoError(null, "El pedido no puede ser atendido. Ha cambiado de estado mientras de generaba el egreso.");
        }
      });
    }

    function cargarDetalles(){
      vm.detallesInventariables = [];
      vm.detallesNoInventariables = [];
      vm.detalles.forEach(function(detalle){
        if (detalle.suministro.tipoSuministro.inventariable){
          vm.detallesInventariables.push(detalle);
        } else {
          vm.detallesNoInventariables.push(detalle);
        }
      });
      if (vm.detallesNoInventariables.length>0){
        armarDetallesNoInventariables();
      } else {
        actualizarTablaNoInventariables();
      }
      if (vm.detallesInventariables.length>0){
        armarDetallesInventariables();
      } else {
        actualizarTablaInventariables();
      }
    }

    function obtenerTiposUtilizados(){
      var esta = false;
      vm.detallesNoInventariables.forEach(function(detalle){
        esta = false;
        vm.detallesNoInventariablesAgrupados.forEach(function(agrupado){
          if (detalle.suministro.tipoSuministro.id==agrupado.tipoSuministro.id){
            esta = true;
          }
        });
        if (!esta){
          vm.detallesNoInventariablesAgrupados.push({tipoSuministro:detalle.suministro.tipoSuministro, precioTotal:0.0, cantidad:0, detalles:[]});
        }
      });
    }

    function armarDetallesNoInventariablesAgrupados(){
      vm.detallesNoInventariablesAgrupados.forEach(function(agrupado){
        vm.detallesNoInventariables.forEach(function(detalle){
          if (agrupado.tipoSuministro.id===detalle.suministro.tipoSuministro.id){
            agrupado.detalles.push({suministro:detalle.suministro, cantidad:detalle.cantidad});
            agrupado.cantidad = agrupado.cantidad + detalle.cantidad;
            agrupado.precioTotal = agrupado.precioTotal + detalle.suministro.precioUnitario;
          }
        });
      });
    }

    function armarDetallesNoInventariables(){
      obtenerTiposUtilizados();
      armarDetallesNoInventariablesAgrupados();
      actualizarTablaNoInventariables();
    }

    function obtenerTiposInventariablesUtilizados(){
      var esta = false;
      vm.detallesInventariables.forEach(function(detalle){
        esta = false;
        vm.detallesInventariablesAgrupados.forEach(function(agrupado){
          if (detalle.suministro.tipoSuministro.id==agrupado.tipoSuministro.id){
            esta = true;
          }
        });
        if (!esta){
          vm.detallesInventariablesAgrupados.push({tipoSuministro:detalle.suministro.tipoSuministro, precioTotal:0.0, cantidad:0, detalles:[]});
        }
      });
    }

    function armarDetallesInventariablesAgrupados(){
      vm.detallesInventariablesAgrupados.forEach(function(agrupado){
        vm.detallesInventariables.forEach(function(detalle){
          if (agrupado.tipoSuministro.id===detalle.suministro.tipoSuministro.id){
            agrupado.detalles.push({suministro:detalle.suministro, suministroInventariable:detalle.suministroInventariable, cantidad:detalle.cantidad});
            agrupado.cantidad = agrupado.cantidad + detalle.cantidad;
            agrupado.precioTotal = agrupado.precioTotal + detalle.suministro.precioUnitario;
          }
        });
      });
    }

    function armarDetallesInventariables(){
      obtenerTiposInventariablesUtilizados();
      armarDetallesInventariablesAgrupados();
      actualizarTablaInventariables();
    }

    function abrirModal(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalAgregarSuministroEgreso({
        onResult: function(resultado) {
          vm.detalles = resultado.detalles;
          vm.detallesNoInventariablesAgrupados = [];
          vm.detallesInventariablesAgrupados = [];
          cargarDetalles();
        },
        detalles: angular.copy(vm.detalles),
        empresa: vm.egreso.empresa,
        deposito: vm.egreso.deposito.id,
        sucursal: vm.egreso.sucursal
      });
    }

    function esEditar(){
      return vm.modo == "editar";
    }

    function volver(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(
        null,
        "Si vuelve perderá la información ingresada. ¿Está seguro que desea volver?",
        function(){
          $state.go("home.lista-pedidos");
        }
      );
    }

    function mostrarInformacion(detalle){
      var marca = detalle.suministro.marca ? detalle.suministro.marca : "-";
      var fecha = detalle.suministro.fechaVencimiento ? detalle.suministro.fechaVencimiento : "-";
      ServicioDialogos.mostrarDialogoInformacion(
        null,
        "Tipo de suministro: "+detalle.suministro.tipoSuministro.nombre.toUpperCase()+
        "\nMarca: "+marca.toUpperCase()+
        "\nFecha vencimiento: "+$filter('date')(fecha, 'dd/MM/yyyy')+
        "\nFamilia de suministro: "+detalle.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase()+
        "\nGrupo de suministro: "+detalle.suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+
        "\nCantidad solicitada: "+detalle.cantidad
      );
    }

    function actualizarTablaNoInventariables(){
      vm.tableParamsNoInventariableAgrupado.settings({
        data: vm.detallesNoInventariablesAgrupados,
        noPager: true,
        counts: []
      });
      vm.tableParamsNoInventariableAgrupado.reload();
    }

    function actualizarTablaInventariables(){
      vm.tableParamsInventariableAgrupado.settings({
        data: vm.detallesInventariablesAgrupados,
        noPager: true,
        counts: []
      });
      vm.tableParamsInventariableAgrupado.reload();
    }

    function comprobarExistencia(){
      var ban = false;
      vm.detalles.forEach(function(detalle){
        if (detalle.suministro.id==vm.suministro.id){
          ban = true;
        }
      });
      return ban;
    }

    vm.tableParamsInventariableAgrupado = new NgTableParams({
      page: 1,
      count: 10,
      group:{
        tipoSuministro: 'desc'
      }
    });
    vm.tableParamsNoInventariableAgrupado = new NgTableParams({
      page: 1,
      count: 10,
      group:{
        tipoSuministro: 'desc'
      }
    });
   
  }
})();

'use strict';
angular.module('proyecto-az-suministro')
  .factory('Transferencias', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/transferencia/:id",{id:'@id'});
  })
  .factory('UltimaTransferencia', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/transferencia/ultimo",{id:'@id'});
  })
  .factory('TransferenciasDeposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/transferencia?deposito.id=:idDeposito",{idDeposito:'@idDeposito'});
  })
  .factory('TransferenciasDepositoEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/transferencia?deposito.id=:idDeposito&&empresa.id=:idEmpresa",{idEmpresa:'@idEmpresa', idDeposito:'@idDeposito'});
  })
  .factory('TransferenciasPorSuministroInventariable', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/detalletransferencia?suministroinventariable.id=:idSuministroInventariable",{idSuministroInventariable:'@idSuministroInventariable'});
  });
  
'use strict';
angular.module('proyecto-az-suministro')
  .factory('TipoMovimiento', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/tipomovimiento/:id",{id:'@id'});
  })
  .factory('EstadoMovimiento', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/estadomovimiento/:id",{id:'@id'});
  })
  .factory('IngresoDepositoEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?deposito.id=:deposito&&empresa.id=:empresa",{deposito:"@deposito", empresa:"@empresa"});
  })
  .factory('IngresoUltimosCienDepositoEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/2/:idDeposito/:idEmpresa",{idDeposito:"@idDeposito", idEmpresa:"@idEmpresa"});
  })
  .factory('Ingreso', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/:id",{id:"@id"});
  })
  .factory('IngresoEstadoModificar', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/estado/:idMovimiento/:idEstado",{idMovimiento:"@idMovimiento", idEstado:"@idEstado"});
  })
  .factory('ProblemaIngreso', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/problemas/:id",{id:"@id"});
  })
  .factory('IngresoUltimosCincuenta', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/ultimos/2/false");
  })
  .factory('IngresoUltimosCincuentaCajas', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/ultimos/2/true");
  })
  .factory('IngresoUltimosCincuentaDeposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/ultimos/2/:idDeposito/false",{idDeposito:"@idDeposito"});
  })
  .factory('IngresoUltimosCincuentaDepositoCajas', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/ultimos/2/:idDeposito/true",{idDeposito:"@idDeposito"});
  })
  .factory('UltimoMovimiento', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/ultimo",{id:"@id"});
  })
  .factory('EstadoMovimientoTipoMovimiento', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/estadomovimiento?tipo.id=:id",{id:"@id"});
  })
  .factory('IngresoEntreFechas', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:id&&inicio=:inicio&&fin=:fin&&cajas=:cajas",{id:"@id",inicio:"@inicio",fin:"@fin",cajas:"@cajas"});
  })
  .factory('IngresoDeposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&deposito.id=:idDeposito&&cajas=:cajas",{idTipo:"@idTipo",idDeposito:"@idDeposito",cajas:"@cajas"});
  })
  .factory('IngresoEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&estado.id=:idEstado&&cajas=:cajas",{idTipo:"@idTipo",idEstado:"@idEstado",cajas:"@cajas"});
  })
  .factory('IngresoEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&empresa.id=:idEmpresa&&cajas=:cajas",{idTipo:"@idTipo",idEmpresa:"@idEmpresa",cajas:"@cajas"});
  })
  .factory('IngresoProveedor', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&proveedor.id=:idProveedor&&cajas=:cajas",{idTipo:"@idTipo",idProveedor:"@idProveedor",cajas:"@cajas"});
  })
  .factory('IngresoEntreFechasDeposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&inicio=:inicio&&fin=:fin&&deposito.id=:idDeposito&&cajas=:cajas",{idTipo:"@idTipo",inicio:"@inicio",fin:"@fin", idDeposito:"@idDeposito",cajas:"@cajas"});
  })
  .factory('IngresoEntreFechasEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&inicio=:inicio&&fin=:fin&&estado.id=:idEstado&&cajas=:cajas",{idTipo:"@idTipo",inicio:"@inicio",fin:"@fin", idEstado:"@idEstado",cajas:"@cajas"});
  })
  .factory('IngresoEntreFechasProveedor', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&inicio=:inicio&&fin=:fin&&proveedor.id=:idProveedor&&cajas=:cajas",{idTipo:"@idTipo",inicio:"@inicio",fin:"@fin", idProveedor:"@idProveedor",cajas:"@cajas"});
  })
  .factory('IngresoEntreFechasEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&inicio=:inicio&&fin=:fin&&empresa.id=:idEmpresa&&cajas=:cajas",{idTipo:"@idTipo",inicio:"@inicio",fin:"@fin", idEmpresa:"@idEmpresa",cajas:"@cajas"});
  })
  .factory('IngresoDepositoEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&deposito.id=:idDeposito&&empresa.id=:idEmpresa&&cajas=:cajas",{idTipo:"@idTipo",idDeposito:"@idDeposito", idEmpresa:"@idEmpresa",cajas:"@cajas"});
  })
  .factory('IngresoDepositoProveedor', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&deposito.id=:idDeposito&&proveedor.id=:idProveedor&&cajas=:cajas",{idTipo:"@idTipo",idDeposito:"@idDeposito", idProveedor:"@idProveedor",cajas:"@cajas"});
  })
  .factory('IngresoDepositoEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&deposito.id=:idDeposito&&estado.id=:idEstado&&cajas=:cajas",{idTipo:"@idTipo",idDeposito:"@idDeposito", idEstado:"@idEstado",cajas:"@cajas"});
  })
  .factory('IngresoProveedorEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&proveedor.id=:idProveedor&&estado.id=:idEstado&&cajas=:cajas",{idTipo:"@idTipo",idProveedor:"@idProveedor", idEstado:"@idEstado",cajas:"@cajas"});
  })
  .factory('IngresoEmpresaEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&empresa.id=:idEmpresa&&estado.id=:idEstado&&cajas=:cajas",{idTipo:"@idTipo",idEmpresa:"@idEmpresa", idEstado:"@idEstado",cajas:"@cajas"});
  })
  .factory('IngresoFechaEmpresaEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&inicio=:inicio&&fin=:fin&&empresa.id=:idEmpresa&&estado.id=:idEstado&&cajas=:cajas",{idTipo:"@idTipo",inicio:"@inicio",fin:"@fin",idEmpresa:"@idEmpresa", idEstado:"@idEstado",cajas:"@cajas"});
  })
  .factory('IngresoFechaProveedorEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&inicio=:inicio&&fin=:fin&&proveedor.id=:idProveedor&&estado.id=:idEstado&&cajas=:cajas",{idTipo:"@idTipo",inicio:"@inicio",fin:"@fin",idProveedor:"@idProveedor", idEstado:"@idEstado",cajas:"@cajas"});
  })
  .factory('IngresoFechaDepositoEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&inicio=:inicio&&fin=:fin&&empresa.id=:idEmpresa&&deposito.id=:idDeposito&&cajas=:cajas",{idTipo:"@idTipo",inicio:"@inicio",fin:"@fin",idEmpresa:"@idEmpresa", idDeposito:"@idDeposito",cajas:"@cajas"});
  })
  .factory('IngresoFechaDepositoProveedor', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&inicio=:inicio&&fin=:fin&&proveedor.id=:idProveedor&&deposito.id=:idDeposito&&cajas=:cajas",{idTipo:"@idTipo",inicio:"@inicio",fin:"@fin",idProveedor:"@idProveedor", idDeposito:"@idDeposito",cajas:"@cajas"});
  })
  .factory('IngresoFechaDepositoEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&inicio=:inicio&&fin=:fin&&estado.id=:idEstado&&deposito.id=:idDeposito&&cajas=:cajas",{idTipo:"@idTipo",inicio:"@inicio",fin:"@fin",idEstado:"@idEstado", idDeposito:"@idDeposito",cajas:"@cajas"});
  })
  .factory('IngresoEmpresaDepositoEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&empresa.id=:idEmpresa&&estado.id=:idEstado&&deposito.id=:idDeposito&&cajas=:cajas",{idTipo:"@idTipo",idEmpresa:"@idEmpresa",idEstado:"@idEstado", idDeposito:"@idDeposito",cajas:"@cajas"});
  })
  .factory('IngresoProveedorDepositoEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&proveedor.id=:idProveedor&&estado.id=:idEstado&&deposito.id=:idDeposito&&cajas=:cajas",{idTipo:"@idTipo",idProveedor:"@idProveedor",idEstado:"@idEstado", idDeposito:"@idDeposito",cajas:"@cajas"});
  })
  .factory('IngresoFechaDepositoEmpresaEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&inicio=:inicio&&fin=:fin&&empresa.id=:idEmpresa&&estado.id=:idEstado&&deposito.id=:idDeposito&&cajas=:cajas",{idTipo:"@idTipo",inicio:"@inicio",fin:"@fin",idEmpresa:"@idEmpresa",idEstado:"@idEstado", idDeposito:"@idDeposito",cajas:"@cajas"});
  })
  .factory('IngresoFechaDepositoProveedorEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&inicio=:inicio&&fin=:fin&&proveedor.id=:idProveedor&&estado.id=:idEstado&&deposito.id=:idDeposito&&cajas=:cajas",{idTipo:"@idTipo",inicio:"@inicio",fin:"@fin",idProveedor:"@idProveedor",idEstado:"@idEstado", idDeposito:"@idDeposito",cajas:"@cajas"});
  })
  .factory('IngresoEntreFechasIngresoManual', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/fechas-manual?tipo.id=:idTipo&&inicio=:inicio&&fin=:fin&&empresa.id=:idEmpresa&&deposito.id=:idDeposito&&cajas=:cajas",{idTipo:"@idTipo",idEmpresa:"@idEmpresa",inicio:"@inicio",fin:"@fin", idDeposito:"@idDeposito",cajas:"@cajas"});
  });

'use strict';
angular.module('proyecto-az-suministro')
  .factory('Conciliacion', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/:id",{id:"@id"});
  })
  .factory('ConciliacionUltimosCienDeposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/ultimosCienTipos/5/6/:idDeposito");
  })
  .factory('ConciliacionUltimosCienDepositoEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/5/6/:idDeposito/:idEmpresa",{idDeposito:"@idDeposito", idEmpresa:"@idEmpresa"});
  })
  .factory('ConciliacionUltimosCien', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/primeros/5/6");
  })
  .factory('ActualizarEstadoUbicacion', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/ubicacion/estadoOcupar/:idUbicacion/:ocupar", {idUbicacion:"@idUbicacion", ocupar:"@ocupar"});
  });

'use strict';
angular.module('proyecto-az-suministro')
  .factory('TipoMovimiento', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/tipomovimiento/:id",{id:'@id'});
  })
  .factory('AsignarEgresoPedido', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/pedido/:idMovimiento/:idPedido",{idMovimiento:'@idMovimiento', idPedido:'@idPedido'});
  })
  .factory('EgresoModificarEstadoArray', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/estado/array/:idEstado",{idEstado:'@idEstado'});
  })
  .factory('EstadoMovimiento', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/estadomovimiento/:id",{id:'@id'});
  })
  .factory('EgresoDepositoEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?deposito.id=:deposito&&empresa.id=:empresa",{deposito:"@deposito", empresa:"@empresa"});
  })
  .factory('EgresoNumeroVale', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?numeroVale=:numeroVale",{numeroVale:"@numeroVale"});
  })
  .factory('EgresoNumeroValeEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?empresa.id=:idEmpresa&&numeroVale=:numeroVale",{idEmpresa:"@idEmpresa", numeroVale:"@numeroVale"});
  })
  .factory('EgresoUltimosCienDepositoEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/1/:idDeposito/:idEmpresa",{idDeposito:"@idDeposito", idEmpresa:"@idEmpresa"});
  })
  .factory('Egreso', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/:id",{id:"@id"});
  })
  .factory('EgresoEstadoModificar', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/estado/:idMovimiento/:idEstado",{idMovimiento:"@idMovimiento", idEstado:"@idEstado"});
  })
  .factory('ProblemaEgreso', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/problemas/:id",{id:"@id"});
  })
  .factory('EgresoUltimosCincuenta', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/ultimos/1/false");
  })
  //LISTA GENERADOS!!!
  .factory('EgresoDepositoEstadoUltimosCien', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/ultimosCien/:idTipo/:idDeposito/:idEstado",{idTipo:"@idTipo",idDeposito:"@idDeposito", idEstado:"@idEstado"});
  })
  //LISTA EMBALADOS!!!
  .factory('EgresoDepositoEmpresaEstadoUltimosCien', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/ultimosCien/:idTipo/:idDeposito/:idEmpresa/:idEstado",{idTipo:"@idTipo",idDeposito:"@idDeposito", idEmpresa:"@idEmpresa", idEstado:"@idEstado"});
  })
  //SIN FILTRAR POR CAJAS!!
  .factory('EgresoUltimosCien', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/ultimos/1");
  })
  .factory('EgresoUltimosCienDeposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/ultimosCien/1/:idDeposito");
  })
  
  .factory('EgresoUltimosCincuentaCajas', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/ultimos/1/true");
  })
  .factory('EgresoUltimosCincuentaDeposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/ultimos/1/:idDeposito/false",{idDeposito:"@idDeposito"});
  })
  .factory('EgresoUltimosCincuentaDepositoCajas', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/ultimos/1/:idDeposito/true",{idDeposito:"@idDeposito"});
  })
  .factory('UltimoMovimiento', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/ultimo",{id:"@id"});
  })
  .factory('EstadoMovimientoTipoMovimiento', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/estadomovimiento?tipo.id=:id",{id:"@id"});
  })
  .factory('EgresoEntreFechas', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:id&&inicio=:inicio&&fin=:fin",{id:"@id",inicio:"@inicio",fin:"@fin"});
  })
  .factory('EgresoDeposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&deposito.id=:idDeposito",{idTipo:"@idTipo",idDeposito:"@idDeposito"});
  })
  .factory('EgresoEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&estado.id=:idEstado",{idTipo:"@idTipo",idEstado:"@idEstado"});
  })
  .factory('EgresoEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&empresa.id=:idEmpresa",{idTipo:"@idTipo",idEmpresa:"@idEmpresa"});
  })
  .factory('EgresoSucursal', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&sucursal.id=:idSucursal",{idTipo:"@idTipo",idSucursal:"@idSucursal"});
  })
  .factory('EgresoEntreFechasDeposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&inicio=:inicio&&fin=:fin&&deposito.id=:idDeposito",{idTipo:"@idTipo",inicio:"@inicio",fin:"@fin", idDeposito:"@idDeposito"});
  })
  .factory('EgresoEntreFechasEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&inicio=:inicio&&fin=:fin&&estado.id=:idEstado",{idTipo:"@idTipo",inicio:"@inicio",fin:"@fin", idEstado:"@idEstado"});
  })
  .factory('EgresoEntreFechasSucursal', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&inicio=:inicio&&fin=:fin&&sucursal.id=:idSucursal",{idTipo:"@idTipo",inicio:"@inicio",fin:"@fin", idSucursal:"@idSucursal"});
  })
  .factory('EgresoEntreFechasEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&inicio=:inicio&&fin=:fin&&empresa.id=:idEmpresa",{idTipo:"@idTipo",inicio:"@inicio",fin:"@fin", idEmpresa:"@idEmpresa"});
  })
  .factory('EgresoDepositoEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&deposito.id=:idDeposito&&empresa.id=:idEmpresa",{idTipo:"@idTipo",idDeposito:"@idDeposito", idEmpresa:"@idEmpresa"});
  })
  .factory('EgresoDepositoSucursal', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&deposito.id=:idDeposito&&sucursal.id=:idSucursal",{idTipo:"@idTipo",idDeposito:"@idDeposito", idSucursal:"@idSucursal"});
  })
  .factory('EgresoDepositoEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&deposito.id=:idDeposito&&estado.id=:idEstado",{idTipo:"@idTipo",idDeposito:"@idDeposito", idEstado:"@idEstado"});
  })


  .factory('EgresoSucursalEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&sucursal.id=:idSucursal&&estado.id=:idEstado",{idTipo:"@idTipo",idSucursal:"@idSucursal", idEstado:"@idEstado"});
  })
  .factory('EgresoEmpresaEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&empresa.id=:idEmpresa&&estado.id=:idEstado",{idTipo:"@idTipo",idEmpresa:"@idEmpresa", idEstado:"@idEstado"});
  })
  .factory('EgresoFechaEmpresaEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&inicio=:inicio&&fin=:fin&&empresa.id=:idEmpresa&&estado.id=:idEstado",{idTipo:"@idTipo",inicio:"@inicio",fin:"@fin",idEmpresa:"@idEmpresa", idEstado:"@idEstado"});
  })
  .factory('EgresoFechaSucursalEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&inicio=:inicio&&fin=:fin&&sucursal.id=:idSucursal&&estado.id=:idEstado",{idTipo:"@idTipo",inicio:"@inicio",fin:"@fin",idSucursal:"@idSucursal", idEstado:"@idEstado"});
  })
  .factory('EgresoFechaDepositoEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&inicio=:inicio&&fin=:fin&&empresa.id=:idEmpresa&&deposito.id=:idDeposito",{idTipo:"@idTipo",inicio:"@inicio",fin:"@fin",idEmpresa:"@idEmpresa", idDeposito:"@idDeposito"});
  })
  .factory('EgresoFechaDepositoSucursal', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&inicio=:inicio&&fin=:fin&&sucursal.id=:idSucursal&&deposito.id=:idDeposito",{idTipo:"@idTipo",inicio:"@inicio",fin:"@fin",idSucursal:"@idSucursal", idDeposito:"@idDeposito"});
  })
  .factory('EgresoFechaDepositoEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&inicio=:inicio&&fin=:fin&&estado.id=:idEstado&&deposito.id=:idDeposito",{idTipo:"@idTipo",inicio:"@inicio",fin:"@fin",idEstado:"@idEstado", idDeposito:"@idDeposito"});
  })
  .factory('EgresoEmpresaDepositoEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&empresa.id=:idEmpresa&&estado.id=:idEstado&&deposito.id=:idDeposito",{idTipo:"@idTipo",idEmpresa:"@idEmpresa",idEstado:"@idEstado", idDeposito:"@idDeposito"});
  })
  .factory('EgresoSucursalDepositoEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&sucursal.id=:idSucursal&&estado.id=:idEstado&&deposito.id=:idDeposito",{idTipo:"@idTipo",idSucursal:"@idSucursal",idEstado:"@idEstado", idDeposito:"@idDeposito"});
  })
  .factory('EgresoFechaDepositoEmpresaEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&inicio=:inicio&&fin=:fin&&empresa.id=:idEmpresa&&estado.id=:idEstado&&deposito.id=:idDeposito",{idTipo:"@idTipo",inicio:"@inicio",fin:"@fin",idEmpresa:"@idEmpresa",idEstado:"@idEstado", idDeposito:"@idDeposito"});
  })
  .factory('EgresoFechaDepositoSucursalEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?tipo.id=:idTipo&&inicio=:inicio&&fin=:fin&&sucursal.id=:idSucursal&&estado.id=:idEstado&&deposito.id=:idDeposito",{idTipo:"@idTipo",inicio:"@inicio",fin:"@fin",idSucursal:"@idSucursal",idEstado:"@idEstado", idDeposito:"@idDeposito"});
  });

'use strict';
angular.module('proyecto-az-suministro')
  .factory('DonacionScrapUltimosCienDeposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/ultimosCienTipos/3/4/:idDeposito");
  })
  .factory('DonacionScrapUltimosCienDepositoEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/3/4/:idDeposito/:idEmpresa",{idDeposito:"@idDeposito", idEmpresa:"@idEmpresa"});
  })
  .factory('DonacionScrapUltimosCien', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/primerosBorrado/3/4");
  })
  .factory('DonacionScrapEgresoUltimosCienDeposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/ultimosCienTipos/7/8/:idDeposito");
  })
  .factory('DonacionScrapEgresoUltimosCienDepositoEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/7/8/:idDeposito/:idEmpresa",{idDeposito:"@idDeposito", idEmpresa:"@idEmpresa"});
  })
  .factory('DonacionScrapEgresoUltimosCien', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/primerosBorrado/7/8");
  })
  .factory('EgresoCreadoDonacionScrapDepositoEstadoUltimosCien', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/primerosBorrado/7/8/:idDeposito/17/21");
  })
  .factory('EgresoPreparadpDonacionScrapDepositoEmpresaEstadoUltimosCien', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/primerosBorrado/7/8/:idDeposito/:idEmpresa/19/23");
  });

  

'use strict';
angular.module('proyecto-az-suministro')
  .factory('Proveedor', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/proveedor/:id",{id:'@id'});
  })
  .factory('ProveedorNombre', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/proveedor?nombre=:nombre", {nombre:"@nombre"});
  })
  .factory('ProveedorEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/proveedor?empresa.id=:empresa", {empresa:"@empresa"});
  })
  .factory('ProveedorNombreEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/proveedor?nombre=:nombre&&empresa.id=:idEmpresa", {nombre:"@nombre", idEmpresa:"@idEmpresa"});
  });

'use strict';
angular.module('proyecto-az-suministro')
  .factory('TipoProblema', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/tipoproblema/:id",{id:'@id'});
  })
  .factory('TipoProblemaNombre', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/tipoproblema?nombre=:nombre", {nombre:"@nombre"});
  });

'use strict';
angular.module('proyecto-az-suministro')
  .factory('PersonaProveedor', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/personaproveedor/:id",{id:'@id'});
  })
  .factory('PersonaProveedorDni', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/personaproveedor?dni=:dni", {dni:"@dni"});
  })
  .factory('PersonaProveedorNombreProveedor', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/personaproveedor?proveedor.id=:id", {id:"@id"});
  });

'use strict';
angular.module('proyecto-az-suministro')
  .factory('TopeProducto', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/topeProducto/:id", {id:"@id"});
  })
  .factory('TopeProductoSucursal', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/topeProducto?sucursal.id=:idSucursal", {idSucursal:"@idSucursal"});
  })
  .factory('TopeProductoEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/topeProducto?empresa.id=:idEmpresa", {idEmpresa:"@idEmpresa"});
  })
  .factory('TopeProductoSucursalTipoSuministro', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/topeProducto?sucursal.id=:idSucursal&&tiposuministro.id=:idTipo", {idSucursal:"@idSucursal", idTipo:"@idTipo"});
  })
  .factory('GuardarActualizarTope', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/topeProducto?empresa.id=:idEmpresa&&codigoSucursal=:codigoSucursal&&codigoProducto=:codigoProducto&&cantidad=:cantidad", {idEmpresa: '@idEmpresa', codigoSucursal:"@codigoSucursal", codigoProducto:"@codigoProducto", cantidad:"@cantidad"});
  });

'use strict';
angular.module('proyecto-az-suministro')
  .factory('Sucursal', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/sucursal/:id",{id:'@id'});
  })
  .factory('SucursalNombreEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/sucursal?nombre=:nombre&&empresa.id=:id", {nombre:"@nombre"});
  })
  .factory('SucursalEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/sucursal?empresa.id=:id", {id:"@id"});
  })
  .factory('SucursalCodigo', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/sucursal?codigo=:codigo", {codigo:"@codigo"});
  });

'use strict';
angular.module('proyecto-az-suministro')
  .factory('Kit', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/kit/:id", {id:"@id"});
  })
  .factory('KitNombreSucursal', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/kit?nombre=:nombre&&sucursal.id=:idSucursal", {nombre:"@nombre", idSucursal:"@idSucursal"});
  })
  .factory('KitSucursal', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/kit?sucursal.id=:idSucursal", {idSucursal:"@idSucursal"});
  });

'use strict';
angular.module('proyecto-az-suministro')
  .factory('Solicitante', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/solicitante/:id",{id:'@id'});
  })
  .factory('SolicitanteDni', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/solicitante?dni=:dni", {dni:"@dni"});
  })
  .factory('SolicitanteTiposNoSolicitables', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/solicitante/tipos/:id", {id:'@id'});
  })
  .factory('SolicitanteEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/solicitante?empresa.id=:id", {id:"@id"});
  });


'use strict';
angular.module('proyecto-az-suministro')
  .factory('Empresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/empresa/:id",{id:'@id'});
  })
  .factory('EmpresaNombre', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/empresa?nombre=:nombre", {nombre:"@nombre"});
  });

'use strict';
angular.module('proyecto-az-suministro')
  .factory('Solicitud', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/empresalogistica/:id",{id:'@id'});
  });

'use strict';
angular.module('proyecto-az-suministro')
  .factory('EmpresaLogistica', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/empresalogistica/:id",{id:'@id'});
  })
  .factory('EmpresaLogisticaId', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/empresalogistica/:id",{id:'@id'});
  })
  .factory('EmpresaLogisticaNombre', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/empresalogistica?nombre=:nombre", {nombre:"@nombre"});
  })
  .factory('EmpresaLogisticaEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/empresalogistica?empresa.id=:idEmpresa", {idEmpresa:"@idEmpresa"});
  })
  .factory('EmpresaLogisticaNombreEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/empresalogistica?nombre=:nombre&&empresa.id=:idEmpresa", {nombre:"@nombre", idEmpresa:"@idEmpresa"});
  });

'use strict';
angular.module('proyecto-az-suministro')
  .factory('PersonaEmpresaLogistica', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/personaempresalogistica/:id",{id:'@id'});
  })
  .factory('PersonaEmpresaLogisticaDni', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/personaempresalogistica?dni=:dni", {dni:"@dni"});
  })
  .factory('PersonaEmpresaLogisticaEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/personaempresalogistica?empresa.id=:id", {id:"@id"});
  });


'use strict';
angular.module('proyecto-az-suministro')
  .factory('Deposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/deposito/:id",{id:'@id'});
  })
  .factory('DepositoSoloNaves', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/deposito/soloNaves/:id",{id:'@id'});
  })
  .factory('DepositoHastaUbicacion', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/deposito/hastaUbicacion/:id",{id:'@id'});
  })
  .factory('DepositoNombre', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/deposito?nombre=:nombre", {nombre:"@nombre"});
  })
  .factory('DepositoNumero', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/deposito?numeroDeposito=:numeroDeposito", {numeroDeposito:"@numeroDeposito"});
  })
  .factory('DepositoNombreSoloNaves', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/deposito/soloNaves?nombre=:nombre", {nombre:"@nombre"});
  })
  .factory('DepositoNumeroSoloNaves', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/deposito/soloNaves?numeroDeposito=:numeroDeposito", {numeroDeposito:"@numeroDeposito"});
  });

'use strict';
angular.module('proyecto-az-suministro')
  .factory('NaveSoloPasillos', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/nave/soloPasillos/:id",{id:'@id'});
  })
  .factory('NaveHastaUbicacion', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/nave/hastaUbicacion/:id",{id:'@id'});
  })
  .factory('Nave', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/nave/:id",{id:'@id'});
  })
  .factory('NaveNombreDeposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/nave?nombre=:nombre&&deposito.id=:id", {nombre:"@nombre"});
  })
  .factory('NaveNombreDepositoSoloPasillos', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/nave/soloPasillos?nombre=:nombre&&deposito.id=:id", {nombre:"@nombre"});
  })
  .factory('NaveNumeroDeposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/nave?numeroNave=:numeroNave&&deposito.id=:id", {numeroNave:"@numeroNave"});
  })
  .factory('NaveNumeroDepositoSoloPasillos', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/nave/soloPasillos?numeroNave=:numeroNave&&deposito.id=:id", {numeroNave:"@numeroNave"});
  })
  .factory('NaveDeposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/nave?deposito.id=:id", {id:"@id"});
  })
  .factory('NaveDepositoSoloPasillos', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/nave/soloPasillos?deposito.id=:id", {id:"@id"});
  })
  .factory('NaveNumero', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/nave?numeroNave=:numeroNave", {numeroNave:"@numeroNave"});
  });

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.clientes', {
        url: 'clientes',
        templateUrl: 'app/app/main/cliente/lista/lista.html',
        controller: 'ListaClienteCtrl',
        controllerAs: 'vm',
        params:{
          titulo:'Clientes',
          subtitulo:'Lista Clientes',
          estadoNuevoObjeto:'home.cliente',
        },
        resolve:{
          listaObjetos:function(Cliente) {
            return Cliente.query().$promise;
          },
          resource:function (Cliente) {
            return Cliente;
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaClienteCtrl', ListaClienteCtrl);

  /** @ngInject */
  function ListaClienteCtrl(NgTableParams, $stateParams, HeaderBarService, listaObjetos, resource, ServicioDialogos, $state) {
    var vm = this;
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);
    vm.confirmarEliminacion = confirmarEliminacion;
    vm.editarObjeto = editarObjeto;
    vm.nuevoObjeto = nuevoObjeto;
    vm.lista = listaObjetos;
    var recurso = resource;

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10,
      sorting: {
        nombre: "asc"
      }
    }, {
      data: vm.lista
    });

    function confirmarEliminacion(objeto) {
      var parametrosFuncionSi = [];
      parametrosFuncionSi.push(objeto);
      //Setear el msj al dialogo
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea eliminar el cliente ' + objeto.nombre + ' ' + objeto.apellido+ '?', eliminar, null, parametrosFuncionSi);
    }

    function eliminar(parametros) {
      var objeto = parametros[0];
      recurso.delete({id: objeto.id},
        function(res) {
          vm.lista = recurso.query(function(res) {
            setTimeout(function() {
              //Setear msj al dialogo
              ServicioDialogos.mostrarDialogoAtencion('Aviso', 'Cliente ' + objeto.nombre +' '+ objeto.apellido+ ' eliminado con éxito');
            }, 100);
            vm.tableParams.settings({
              data: res
            });
            vm.tableParams.reload();
          });
        },
        function() {
          ServicioDialogos.mostrarDialogoError();
        }
      );
    }

    function nuevoObjeto() {
      $state.go($stateParams.estadoNuevoObjeto);
    }

    function editarObjeto(objeto) {
        $state.go($stateParams.estadoNuevoObjeto, {objeto:objeto, modo:'editar'});
    }
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.cliente', {
        url: 'cliente',
        templateUrl: 'app/app/main/cliente/editar/editar.html',
        controller: 'EditarClienteCtrl',
        controllerAs: 'vm',
        params: {
          titulo: 'Clientes',
          subtituloNuevo: 'Nuevo Cliente',
          subtituloEditar: 'Editar Cliente',
          modo: null,
          objeto: null,
          estadoLista : 'home.clientes'
        },
        resolve:{
          resource: function(Cliente) {
            return Cliente;
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('EditarClienteCtrl', EditarClienteCtrl);

  /** @ngInject */
  function EditarClienteCtrl(HeaderBarService, resource, $stateParams, $http, ServicioDialogos, $state, $window) {
    var vm = this;
    var recurso = resource;
    var modo = $stateParams.modo;
    inicializar();
    vm.guardar = guardar;
    vm.cancelar = cancelar;

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      if (modo === 'nuevo') {
        HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);
      }
      if(modo === 'editar'){
        HeaderBarService.setSubTitulo($stateParams.subtituloEditar);
      }
    }

    function setearObjeto() {
      if (modo==='nuevo') {
        vm.objeto = vm.modelo;
      }
      if (modo==='editar') {
        vm.objeto = $stateParams.objeto;
        //Setear fecha
        vm.objeto.fechaNacimiento = new Date(vm.objeto.fechaNacimiento);
      }
      if (!modo) {
        modo='nuevo';
      }
    }

    function setCampos() {
      $http.get('app/app/main/cliente/editar/campos.json').then(function (data) {
        vm.campos = data.data;
        //setear los options de los campos utiliando los resolves
        vm.campos[5].templateOptions.options = [{nombre:'Bell Ville'}];
      });
    }

    function getCampos() {
      $http.get('app/app/main/cliente/editar/modelo.json').then(function (data) {
        vm.modelo = data.data[0];
      });
    }

    function inicializar() {
      setearObjeto();
      setearTitulos();
      setCampos();
      getCampos();
    }

    function guardar() {
      ServicioDialogos.cerrarDialogoCargando();
    }

    function crearObjeto() {
      recurso.save(vm.objeto, function(res){
        //Setear msj
        ServicioDialogos.mostrarDialogoExito(null,'Se registró el cliente '+res.nombre+' correctamente');
        limpiarObjeto();
        $state.go($stateParams.estadoLista);
      },
      function(){
        ServicioDialogos.mostrarDialogoError();
      });
    }

    function actualizarObjeto() {
      recurso.update(vm.objeto, function(res){
        //Setear msj
        ServicioDialogos.mostrarDialogoExito(null,'Se modificó el cliente '+res.nombre+' correctamente');
        limpiarObjeto();
        $state.go($stateParams.estadoLista);
      },
      function(){
        ServicioDialogos.mostrarDialogoError();
      });
    }

    function limpiarObjeto() {
      vm.objeto = vm.modelo;
    }

    function cancelar() {
      ServicioDialogos.abrirDialogoCargando();
      // limpiarObjeto();
      // $window.history.back();
    }

  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoVisualizarTransferencia',DialogoVisualizarTransferencia);

  function DialogoVisualizarTransferencia($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/visualizar-transferencia/modal.html',
        controller: 'ModalVisualizarTransferenciaCtrl as vm',
        resolve: {
          transferencia: function(Transferencias){
            return Transferencias.get({id:config.transferencia.id}).$promise.then(function(data){
              return data;
            });
          },
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalVisualizarTransferenciaCtrl', ModalVisualizarTransferenciaCtrl);

  /** @ngInject */
  function ModalVisualizarTransferenciaCtrl(NgTableParams, rol, $http, URL_SERVIDOR, $uibModalInstance, HeaderBarService,  ServicioModales, transferencia, $stateParams, $filter, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.transferencia = transferencia;
    vm.rol = rol;
    vm.editarSuministro = editarSuministro;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.ubicacionCompleta = ubicacionCompleta;
    vm.comprobarIngresoCerrado = comprobarIngresoCerrado;
    vm.cerrar = cerrar;
    vm.obtenerPrecioTotal = obtenerPrecioTotal;

    inicializar();
    ServicioDialogos.cerrarDialogoCargando();

    function obtenerPrecioTotal(suministro){
//      console.log(suministro);
      return (suministro.precioUnitario*suministro.cantidad).toFixed(2);
    }


    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
    }

    function obtenerTipoTransferencia(){
      if (transferencia.tipoDesde && transferencia.tipoDesde.id ==2){
        if (transferencia.tipoHasta && transferencia.tipoHasta.id==3){
          vm.tipoTransferencia = "De STOCK REGULAR a DONACIÓN";
        } else {
          vm.tipoTransferencia = "De STOCK REGULAR a SCRAP-REPARACIÓN";
        }
      } else if (transferencia.tipoDesde && transferencia.tipoDesde.id == 3){
        if (transferencia.tipoHasta && transferencia.tipoHasta.id==2){
          vm.tipoTransferencia = "De STOCK DONACIÓN a REGULAR";
        } else {
          vm.tipoTransferencia = "De STOCK DONACIÓN a SCRAP-REPARACIÓN";
        }
      } else {
        if (transferencia.tipoHasta && transferencia.tipoHasta.id==2){
          vm.tipoTransferencia = "De STOCK SCRAP-REPARACIÓN a REGULAR";
        } else {
          vm.tipoTransferencia = "De STOCK SCRAP-REPARACIÓN a DONACIÓN";
        }
      }
    }

    function inicializar(){
      vm.fecha=$filter('date')(vm.transferencia.fecha, 'dd/MM/yyyy HH:mm');
      obtenerTipoTransferencia();
      crearTablas();
      actualizarTablaInventariables();
    }

    function editarSuministro(detalle){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Está seguro que desea editar la información del suministro?", function(){
        ServicioDialogos.abrirDialogoCargando();
        ServicioModales.abrirModalEditarSuministro({
          onResult: function(resultado){
            actualizarSuministroInventariable(resultado.suministroEditado);
          },
          suministro:detalle.suministroInventariable,
          modo:'editar'
        });
      });
    }

    function actualizarSuministroInventariable(suministro){
      vm.transferencia.detalles.forEach(function(item){
        if (item.suministroInventariable.suministro.id==suministro.suministro.id){
          item.suministroInventariable.suministro = suministro.suministro;
        }
        if (item.suministroInventariable.id==suministro.id){
          item.suministroInventariable = suministro;
        }
      });
      actualizarTablaInventariables();
    }

    function buscarCantidadPallets(){
      var mayor = vm.detallesInventariables[0].numeroRow;
      vm.detallesInventariables.forEach(function(detalle){
        if (detalle.numeroRow>mayor){
          mayor = detalle.numeroRow;
        }
      });
      return mayor;
    }

    function actualizarTablaInventariables(){
      vm.tableParamsStock.settings({
        data: vm.transferencia.detalles,
        noPager: true,
        counts: []
      });
      vm.tableParamsStock.reload();
    }

    function ubicacionNaveNumeroOrden(detalle){
      var suministro;
      if (detalle.suministro){
        suministro = detalle.suministro;
      } else {
        suministro = detalle.suministroInventariable.suministro;
      }
      if (suministro && suministro.ubicacion && suministro.ubicacion.nivel) {
        return "Nave: "+suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+suministro.ubicacion.numeroOrden;
      } else {
        return "El bien no posee una ubicación actual";
      }
    }

    function ubicacionCompleta(detalle){
      var suministro;
      if (detalle.suministro){
        suministro = detalle.suministro;
      } else {
        suministro = detalle.suministroInventariable.suministro;
      }
      if (suministro && suministro.ubicacion && suministro.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación",
        "Nave: "+suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+suministro.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+suministro.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+suministro.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+suministro.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+suministro.ubicacion.numeroUbicacion+
        "\nN° de orden: "+suministro.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+suministro.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+suministro.ubicacion.categoriaPeso.nombre.toUpperCase());
      }
    }


    function crearTablas(){
      vm.tableParamsStock = new NgTableParams({
        page: 1,
        count: 500
      });
    }

    function comprobarIngresoCerrado(){
      return true;
    }


  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoVisualizarSuministrosAsignados',DialogoVisualizarSuministrosAsignados);

  function DialogoVisualizarSuministrosAsignados($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/visualizar-suministros-asignados/visualizar-suministros-asignados.html',
        controller: 'ModalVisualizarSuministrosAsignadosCtrl as vm',
        resolve: {
          sucursal: function(){
            return config.sucursal;
          },
          detalles: function(){
            return config.detalles;
          },
          tipoSuministro: function(){
            return config.tipoSuministro;
          },
          tipo: function(){
            return config.tipo;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalVisualizarSuministrosAsignadosCtrl', ModalVisualizarSuministrosAsignadosCtrl);

  /** @ngInject */
  function ModalVisualizarSuministrosAsignadosCtrl(NgTableParams, $uibModalInstance, tipo, HeaderBarService,  ServicioModales, detalles, sucursal, tipoSuministro, $stateParams, $filter, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.detalles = detalles;
    vm.tipoSuministro = tipoSuministro;
    vm.tipoCompleto = tipo.nombre.toUpperCase()+" - "+tipo.familiaSuministro.nombre.toUpperCase()+" - "+tipo.familiaSuministro.grupoSuministro.nombre.toUpperCase();
    vm.cerrar = cerrar;
    vm.sucursal = sucursal;

    vm.ubicacionCompleta = ubicacionCompleta;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;


    inicializar();
    ServicioDialogos.cerrarDialogoCargando();


    function inicializar(){
      crearTablas();
      vm.detallesNoInventariables = [];
      vm.detallesInventariables = [];
      cargarDetalles();
      if (!vm.tipoSuministro){
        var cant = 0;
        vm.detallesNoInventariables.forEach(function(item){
          cant += item.cantidad;
        });
        vm.cantidadNoInventariable = cant>0? cant:"0";
      }
    }


    function ubicacionCompleta(detalle){
      if (detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación",
        "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+detalle.suministro.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+detalle.suministro.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+detalle.suministro.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+detalle.suministro.ubicacion.numeroUbicacion+
        "\nN° de orden: "+detalle.suministro.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+detalle.suministro.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+detalle.suministro.ubicacion.categoriaPeso.nombre.toUpperCase());
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "No hay ubicación");
      }
    }

    function ubicacionNaveNumeroOrden(detalle){
      if (detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        return "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+detalle.suministro.ubicacion.numeroOrden;
      }
    }

    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
    }

    function cargarDetalles(){
      if (vm.tipoSuministro){
        vm.detallesInventariables = vm.detalles;
        actualizarTablaInventariables();
      } else {
        vm.detallesNoInventariables = vm.detalles;
        actualizarTablaNoInventariables();
      }
    }

    function actualizarTablaNoInventariables(){
      vm.tableParamsNoInventariable.settings({
        data: vm.detallesNoInventariables,
        noPager: true,
        counts: []
      });
      vm.tableParamsNoInventariable.reload();
    }

    function actualizarTablaInventariables(){
      vm.tableParamsInventariable.settings({
        data: vm.detallesInventariables,
        noPager: true,
        counts: []
      });
      vm.tableParamsInventariable.reload();
    }


    function crearTablas(){
      vm.tableParamsInventariable = new NgTableParams({
        page: 1,
        count: 10,
      });
      vm.tableParamsNoInventariable = new NgTableParams({
        page: 1,
        count: 10,
      });
    }

  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoVisualizarSeleccionadosPedido',DialogoVisualizarSeleccionadosPedido);

  function DialogoVisualizarSeleccionadosPedido($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/visualizar-seleccionados-pedido/visualizar-seleccionados-pedido.html',
        controller: 'ModalVisualizarSeleccionadosPedidoCtrl as vm',
        resolve: {
          seleccionados: function(){
            return config.seleccionados;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalVisualizarSeleccionadosPedidoCtrl', ModalVisualizarSeleccionadosPedidoCtrl);

  /** @ngInject */
  function ModalVisualizarSeleccionadosPedidoCtrl(NgTableParams, $uibModalInstance, seleccionados, orderByFilter, ServicioDialogos) {

    var vm = this;
    vm.seleccionados = seleccionados;
    vm.cerrar = cerrar;

    inicializar();
    ServicioDialogos.cerrarDialogoCargando();


    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
    }

    function inicializar(){
      crearTablas();
      actualizarTabla();
    }

    function actualizarTabla(){
      vm.tableParams.settings({
        data: orderByFilter(vm.seleccionados,['tipoSuministro.nombre'],false),
        noPager: true,
        counts: []
      });
      vm.tableParams.reload();
    }

    function crearTablas(){
      vm.tableParams = new NgTableParams({
        page: 1,
        count: 500
      });
    }

  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoVisualizarResumenPedido',DialogoVisualizarResumenPedido);

  function DialogoVisualizarResumenPedido($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/visualizar-resumen-pedido/visualizar-resumen-pedido.html',
        controller: 'ModalVisualizarResumenPedidoCtrl as vm',
        resolve: {
          pedido: function(){
            return config.pedido;
          },
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalVisualizarResumenPedidoCtrl', ModalVisualizarResumenPedidoCtrl);

  /** @ngInject */
  function ModalVisualizarResumenPedidoCtrl(NgTableParams, Pedido, rol, UltimoPedido, $http, URL_SERVIDOR, $uibModalInstance, HeaderBarService,  ServicioModales, pedido, $stateParams, $filter, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.pedido = pedido;
    vm.rol = rol;
    vm.cerrar = cerrar;
    vm.guardar = guardar;

    inicializar();
    ServicioDialogos.cerrarDialogoCargando();


    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
    }

    function guardar(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(
        null,
        "¿Está seguro que desea registrar el pedido?",
        function(){
          guardarPedido();
        },
        null,
        false
      );
    }

    function guardarPedido(){
      obtenerNumeroPedido(function(numero){
        vm.pedido.numeroPedido = numero;
        vm.pedido.fecha = new Date();
        Pedido.save(vm.pedido, function(data){
          ServicioDialogos.mostrarDialogoGuardadoExito(
            null,
            "Se ha registrado con éxito el pedido",
            function(){
              if ($('.modal.in').length<=1){
                $('.modal-backdrop').remove();
              }
              $uibModalInstance.dismiss();
              $state.go('home.lista-pedidos',{});
            });
        }, function(err){
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar el pedido");
        });
      });
    }

    function obtenerNumeroPedido(callback){
      UltimoPedido.get({}, function(data){
        if (data && !isNaN(data.id)){
          callback(data.id + 10001);
        } else {
          callback(10001);
        }
      }, function (err){
        console.log(err);
      });
    }

    function inicializar(){
      vm.fecha=$filter('date')(new Date(), 'dd/MM/yyyy HH:mm');
      vm.solicitante = vm.pedido.usuario.solicitante.apellido.toUpperCase()+", "+vm.pedido.usuario.solicitante.nombre.toUpperCase();
      crearTablas();
      actualizarTabla();
    }

    function actualizarTabla(){
      vm.tableParams.settings({
        data: orderByFilter(vm.pedido.detalles,['tipoSuministro.nombre'],false),
        noPager: true,
        counts: []
      });
      vm.tableParams.reload();
    }

    function crearTablas(){
      vm.tableParams = new NgTableParams({
        page: 1,
        count: 500
      });
    }

  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoPedidosAnteriores',DialogoPedidosAnteriores);

  function DialogoPedidosAnteriores($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
		var respuesta = $uibModal.open({
			backdrop : 'static',
			keyboard: false,
			size: 'lg',
			windowClass : 'modal-cargando',
			templateUrl: 'app/components/modales/visualizar-pedidos-anteriores/visualizar-pedidos-anteriores.html',
			controller: 'ModalPedidosAnterioresCtrl as vm',
			resolve: {
				seleccionados: function(){
					return config.seleccionados;
				},
				pedidos: function(Usuario, PedidosUsuarioUltimos10){
					return Usuario.obtenerUsuario().$promise.then(function(usuario){
						return PedidosUsuarioUltimos10.query({'idUsuario':usuario.id}).$promise.then(function(data){
							return data;
						});
					});
				}
			}
		});
		respuesta.result.then(config.onResult);
		return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalPedidosAnterioresCtrl', ModalPedidosAnterioresCtrl);

  /** @ngInject */
  function ModalPedidosAnterioresCtrl(NgTableParams, pedidos, seleccionados, $uibModalInstance, ServicioModales, $filter, $scope, ServicioDialogos) {

    var vm = this;
    vm.pedidos = pedidos;
    vm.cerrar = cerrar;
    vm.seleccionar = seleccionar;

    vm.visualizarPedido = visualizarPedido;

    inicializar();
    ServicioDialogos.cerrarDialogoCargando();

    function seleccionar(pedido){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Está seguro de asignar los detalles seleccionables de este pedido?", function(){
        if ($('.modal.in').length<=1){
          $('.modal-backdrop').remove();
        }
        $uibModalInstance.close({
          detalles: obtenerNoSeleccionados(pedido.detalles)
        });
      }, null, false);
    }

    function obtenerNoSeleccionados(detalles){
      var det = [];
      var ban;
      detalles.forEach(function(detalle){
        ban = true;
        seleccionados.forEach(function(seleccionado){
          if (seleccionado.tipoSuministro.id === detalle.tipoSuministro.id) ban = false;
        });
        if (ban){
          det.push(detalle);
        }
      });
      return det;
    }

    function visualizarPedido(pedido){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalPedido({
        onResult: function(resultado) {
          console.log(resultado);
        },
        pedido: pedido
      });
    }

    function inicializar(){
      crearTablas();
      actualizarTabla();
    }

    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
    }

    function actualizarTabla(){
      vm.tableParams.settings({
        data: $filter('orderBy')(vm.pedidos,'fecha', false),
        noPager: true,
        count: []
      });
      vm.tableParams.reload();
    }

    function crearTablas(){
      vm.tableParams = new NgTableParams({
        page: 1,
        count: 10,
      },{
        getData: function($defer,params){ return filtrarTabla($defer, params);}
      });
      vm.tableParams.reload();
    }

    function filtrarTabla($defer, params) {
      var filtros = params.filter();
      var filtrosNuevos = {};

      for (var key in filtros) {
        if (filtros.hasOwnProperty(key) && filtros[key]!=='') {
          switch(key) {
            case 'deposito.nombre':
              angular.extend(filtrosNuevos, {
                deposito: {
                nombre: filtros[key]
                }
              });
              break;
            case 'empresa.nombre':
              angular.extend(filtrosNuevos, {
                empresa: {
                  nombre: filtros[key]
                }
              });
              break;
            case 'sucursal.nombre':
              angular.extend(filtrosNuevos, {
                sucursal: {
                nombre: filtros[key]
                }
                });
              break;
            case 'estado.nombre':
              angular.extend(filtrosNuevos, {
                estado: {
                nombre: filtros[key]
                }
              });
              break;
            default:
              filtrosNuevos[key] = filtros[key];
          }
        }
      }
      var filtrados = filtros ? $filter('filter')(vm.pedidos, filtrosNuevos) : vm.pedidos;
      filtrados = params.sorting() ? $filter('orderBy')(filtrados, params.orderBy()) : filtrados;
      if (filtrados && filtrados.length){
        params.total(filtrados.length);
        return $defer.resolve(filtrados.slice((params.page() - 1) * params.count(), params.page() * params.count()));
      } else {
        params.total(0);
        return $defer.resolve(null);
      }
    }


  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoVisualizarPedido',DialogoVisualizarPedido);

  function DialogoVisualizarPedido($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/visualizar-pedido/visualizar-pedido.html',
        controller: 'ModalVisualizarPedidoCtrl as vm',
        resolve: {
          pedido: function(Pedido){
            return Pedido.get({id:config.pedido.id}).$promise.then(function(data){
              return data;
            });
          },
          movimiento: function(ComprobarMovimientoPedido){
            return ComprobarMovimientoPedido.get({idPedido:config.pedido.id}).$promise.then(function(data){
              return data;
            });
          },
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalVisualizarPedidoCtrl', ModalVisualizarPedidoCtrl);

  /** @ngInject */
  function ModalVisualizarPedidoCtrl(NgTableParams, rol, $http, movimiento, URL_SERVIDOR, $uibModalInstance, HeaderBarService,  ServicioModales, pedido, $stateParams, $filter, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.pedido = pedido;
    vm.movimiento = movimiento;
    vm.rol = rol;
    vm.cerrar = cerrar;

    vm.visualizarMovimiento = visualizarMovimiento;


    inicializar();
    ServicioDialogos.cerrarDialogoCargando();


    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
    }

    function visualizarMovimiento(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirVisualizarEgresoPedido({
        onResult: function(resultado) {
          console.log(resultado);
        },
        egreso: movimiento,
      });
    }

    function inicializar(){
      if (vm.movimiento) inicializarMovimiento();
      vm.fecha=$filter('date')(vm.pedido.fecha, 'dd/MM/yyyy HH:mm');
      vm.fechaRechazo =$filter('date')(vm.pedido.fechaRechazo, 'dd/MM/yyyy HH:mm');
      vm.usuarioRechazo = vm.pedido.motivoRechazoAnulacion ? vm.pedido.usuarioRechazo.empleado.apellido.toUpperCase()+", "+vm.pedido.usuarioRechazo.empleado.nombre.toUpperCase() : "-";
      vm.solicitante = vm.pedido.usuario.solicitante.apellido.toUpperCase()+", "+vm.pedido.usuario.solicitante.nombre.toUpperCase();
      vm.estado = vm.pedido.estadoMovimiento? vm.pedido.estado.nombre +" - "+vm.pedido.estadoMovimiento : vm.pedido.estado.nombre;
      crearTablas();
      actualizarTabla();
    }

    function inicializarMovimiento(){
      vm.fechaConfirmacion = movimiento.fechaConfirmacion? $filter('date')(movimiento.fechaConfirmacion, 'dd/MM/yyyy HH:mm') : "-";
      vm.usuarioAtencionReclamo = movimiento.usuarioAtencionReclamo? movimiento.usuarioAtencionReclamo.empleado.apellido.toUpperCase()+", "+movimiento.usuarioAtencionReclamo.empleado.nombre.toUpperCase() : "-";
    }

    function actualizarTabla(){
      vm.tableParams.settings({
        data: orderByFilter(vm.pedido.detalles,['tipoSuministro.nombre'],false),
        noPager: true,
        counts: []
      });
      vm.tableParams.reload();
    }

    function crearTablas(){
      vm.tableParams = new NgTableParams({
        page: 1,
        count: 500
      });
    }

  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoVisualizarKitPrearmado',DialogoVisualizarKitPrearmado);

  function DialogoVisualizarKitPrearmado($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/visualizar-kit-prearmado/visualizar-kit-prearmado.html',
        controller: 'ModalVisualizarKitPrearmadoCtrl as vm',
        resolve: {
          kit: function(){
            return config.kit;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalVisualizarKitPrearmadoCtrl', ModalVisualizarKitPrearmadoCtrl);

  /** @ngInject */
  function ModalVisualizarKitPrearmadoCtrl(NgTableParams, kit,  $uibModalInstance, HeaderBarService, ServicioModales, focus, orderByFilter, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    vm.kit=kit;
    vm.volver = volver;

    inicializar();
    ServicioDialogos.cerrarDialogoCargando();

    function volver(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      HeaderBarService.setSubTitulo($stateParams.subtitulo);
    }

    function inicializar(){
      setearTitulos();
      if (vm.kit){
        crearTabla();
        actualizarTabla();
      }
    }
     
    function crearTabla(){
      vm.tableParams = new NgTableParams({
        page: 1,
        count: 10
      });
    }

    function actualizarTabla(){
      vm.tableParams.settings({
        data: vm.kit.detalles
      });
      vm.tableParams.reload();
    }


  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoIngresosRemitoOrden',DialogoIngresosRemitoOrden);

  function DialogoIngresosRemitoOrden($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/visualizar-ingresos-orden-remito/visualizar-ingresos-orden-remito.html',
        controller: 'ModalVisualizarIngresosRemitoOrdenCtrl as vm',
        resolve: {
          ingresos: function(){
            return config.ingresos;
          },
          empresa: function(){
            return config.empresa;
          },
          deposito: function(){
            return config.deposito;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalVisualizarIngresosRemitoOrdenCtrl', ModalVisualizarIngresosRemitoOrdenCtrl);

  /** @ngInject */
  function ModalVisualizarIngresosRemitoOrdenCtrl(NgTableParams, Util, empresa, deposito, ingresos, $http, URL_SERVIDOR, $uibModalInstance, HeaderBarService,  ServicioModales, $stateParams, $filter, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.ingresos = orderByFilter(ingresos, "fecha", false);
    vm.cerrar = cerrar;

    vm.detalles = [];

    vm.detallesAgrupados = [];
    vm.visualizarIngreso = visualizarIngreso;
    vm.mostrarReporte = mostrarReporte;
    vm.mostrarReporteExcel = mostrarReporteExcel;
    
    inicializar();

    function mostrarReporteExcel(){
      ServicioDialogos.abrirDialogoCargando();
      var lista = $filter('orderBy')(vm.detallesAgrupados, ['movimiento.fecha','tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre', 'tipoSuministro.familiaSuministro.grupoSuministro.nombre', 'tipoSuministro.familiaSuministro.nombre', 'tipoSuministro.nombre'], true);
      var array = [];
      for (var i = lista.length - 1; i >= 0; i--) {
        array.push({
          "Empresa" : lista[i].tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase(),
          "Fecha": $filter('date')(lista[i].movimiento.fecha, "dd/MM/yyyy"),
          "N° Movimiento": lista[i].movimiento.numeroMovimiento,
          "Proveedor": lista[i].movimiento.proveedor.nombre.toUpperCase(),
          "N° Remito":lista[i].movimiento.numeroRemito,
          "N° Orden de compra":lista[i].movimiento.numeroOrden,
          "Grupo suministro" : lista[i].tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
          "Familia suministro" : lista[i].tipoSuministro.familiaSuministro.nombre.toUpperCase(),
          "Código familia" : lista[i].tipoSuministro.familiaSuministro.codigoFamiliaSuministro.toUpperCase(),
          "Tipo suministro" : lista[i].tipoSuministro.nombre.toUpperCase(),
          "Código producto" : lista[i].tipoSuministro.codigoProducto.toUpperCase(),
          "Cantidad" : lista[i].cantidad,
          "Precio":lista[i].precio
        });
      }
      var nombreDocumento = vm.empresa ? "ingresos-orden-remito-"+Util.quitarCaracteresEspeciales(vm.empresa.nombre.toUpperCase()) : "ingresos-orden-remito";
      alasql.promise('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true,sheetid:"Ingresos"}) FROM ?',[array])
      .then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
      }).catch(function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function armarDetalles(){
      vm.detalles = [];
      var detalles = [];
      ingresos.forEach(function(ingreso){
        if (!ingreso.borrado){
          ingreso.detalles.forEach(function(item){
            detalles.push(item);
          });
          vm.detallesAgrupados.push.apply(vm.detallesAgrupados, armarDetallesIngresosAgrupados(angular.copy(detalles), ingreso));
          detalles = [];
        }
      });
      vm.detallesAgrupados = orderByFilter(vm.detallesAgrupados, "movimiento.fecha", false);
    }

    function mostrarReporte(){
      ServicioDialogos.abrirDialogoCargando();
      var Url = URL_SERVIDOR+"/reportes/ingresosAgrupados";
      $http.post(Url, vm.detallesAgrupados,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }


    function inicializar(){
      crearTablas();
      vm.cantidadIngresos = ingresos.length;
      vm.empresa = empresa;
      vm.deposito = deposito;
      vm.detallesAgrupados = [];
      armarDetalles();
      vm.montoTotal = montoTotal();

      actualizarTablaAgrupados();

      ServicioDialogos.cerrarDialogoCargando();
    }

    function visualizarIngreso(ingreso){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalVisualizarIngreso({
        onResult: function(resultado) {
          console.log(resultado);
        },
        ingreso: ingreso,
        deposito: ingreso.deposito
      });
    }

    function armarDetallesIngresosAgrupados(detalles, ingreso){
      var esta = false;
      var detallesAgrupados = [];
      detalles.forEach(function(detalle){
        esta = false;
        detallesAgrupados.forEach(function(agrupado){
          if (detalle.suministro.tipoSuministro.id==agrupado.tipoSuministro.id){
            esta = true;
            agrupado.cantidad += detalle.cantidad;
            agrupado.precio += detalle.suministro.precioUnitario*detalle.cantidad;
          }
        });
        if (!esta){
          detallesAgrupados.push({tipoSuministro:detalle.suministro.tipoSuministro, precio: detalle.suministro.precioUnitario*detalle.cantidad, cantidad: detalle.cantidad, movimiento:ingreso});
        }
      });
      return detallesAgrupados;
    }

    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
    }

    function montoTotal(){
      var total = 0;
      for(var i = 0; i < vm.detallesAgrupados.length; i++){
        total += vm.detallesAgrupados[i].precio;
      }
      return total ? '$ '+total.toFixed(2) : "-";
    }

    function actualizarTablaAgrupados(){
      vm.tableParamsAgrupado.settings({
        noPager: true,
        counts: []
      });
      vm.tableParamsAgrupado.reload();
    }

    function crearTablas(){
      vm.tableParamsIngresos = new NgTableParams({
        page: 1,
        count: 10
      });
      vm.tableParamsIngresos.reload();

      vm.tableParamsAgrupado = new NgTableParams({
        page: 1,
        count: 10,
        group:{
          tipoSuministro: 'desc'
        }
      });
    }


  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoVisualizarIngreso',DialogoVisualizarIngreso);

  function DialogoVisualizarIngreso($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/visualizar-ingreso-modal/visualizar-ingreso-modal.html',
        controller: 'ModalVisualizarIngresoCtrl as vm',
        resolve: {
          ingreso: function(Ingreso){
/*            if (!config.ingreso.detalles || config.ingreso.detalles.length<=0){

            } else {
              return config.ingreso;
            }*/
            return Ingreso.get({id:config.ingreso.id}).$promise.then(function(data){
              return data;
            });
          },
          rol: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario.rol;
            });
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalVisualizarIngresoCtrl', ModalVisualizarIngresoCtrl);

  /** @ngInject */
  function ModalVisualizarIngresoCtrl(NgTableParams, rol, $http, URL_SERVIDOR, $uibModalInstance, HeaderBarService,  ServicioModales, ingreso, $stateParams, $filter, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.ingreso = ingreso;
    vm.rol = rol;
    vm.editarSuministro = editarSuministro;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.ubicacionCompleta = ubicacionCompleta;
    vm.editarProblemas = editarProblemas;
    vm.comprobarIngresoCerrado = comprobarIngresoCerrado;
    vm.comprobarFotoProblema = comprobarFotoProblema;
    vm.obtenerInforme = obtenerInforme;
    vm.reporteNombre = reporteNombre;
    vm.cerrar = cerrar;
    vm.abrirModalEditarMovimiento = abrirModalEditarMovimiento;
    vm.rotulosA4 = rotulosA4;
    vm.rotulosChicos = rotulosChicos;

    inicializar();
    ServicioDialogos.cerrarDialogoCargando();

    function rotulosA4(){
      ServicioDialogos.abrirDialogoCargando();
      $http.get(URL_SERVIDOR+"/reportes/rotulosA4/movimiento/"+vm.ingreso.id, {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function rotulosChicos(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalGenerarRotulosChicos({
        onResult: function(res){
          
        },
        id: vm.ingreso.id
      });
    }

    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.close({
        fechaIngreso: vm.ingreso.fechaIngreso
      });
    }


    function abrirModalEditarMovimiento(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalEditarMovimiento({
        onResult: function(res){
          vm.ingreso = res.movimientoEditado;
        },
        objeto: vm.ingreso.id
      });
    }

    function reporteNombre(detalles){
      ServicioDialogos.abrirDialogoCargando();
      $http.get(URL_SERVIDOR+"/suministro/reporte/nombre/"+detalles.id, {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function obtenerInforme(){
      ServicioDialogos.abrirDialogoCargando();
      $http.get(URL_SERVIDOR+"/movimiento/reporte/movimiento/"+vm.ingreso.id, {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function comprobarFotoProblema(){
      var ban = false;
      vm.ingreso.problemas.forEach(function(item){
        if (item.encabezadoFoto){
          ban = true;
        }
      });
      return ban;
    }

    function editarProblemas(){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea agregar o quitar problemas en este ingreso?', function(){
        ServicioDialogos.abrirDialogoCargando();
        ServicioModales.abrirModalEditarProblemasIngreso({
          onResult: function(resultado){
            vm.ingreso.problemas = resultado.problemas;
            armarProblemas();
            actualizarTabla();
          },
          ingreso:vm.ingreso,
          modo:'editar'
        });
      });
    }

    function inicializar(){
      vm.fecha=$filter('date')(vm.ingreso.fecha, 'dd/MM/yyyy HH:mm');
      vm.fechaIngreso = $filter('date')(vm.ingreso.fechaIngreso, 'dd/MM/yyyy');
      vm.montoTotal = montoTotal();
      vm.personaProveedor = personaProveedor();
      vm.personaEmpresaLogistica = personaEmpresaLogistica();
      armarProblemas();
      crearTablas();
      actualizarTabla();
    }

    function personaProveedor(){
      if (vm.ingreso.personaProveedor){
        return vm.ingreso.personaProveedor.apellido.toUpperCase()+", "+vm.ingreso.personaProveedor.nombre.toUpperCase();
      }
    }

    function personaEmpresaLogistica(){
      if (vm.ingreso.personaEmpresaLogistica){
        return vm.ingreso.personaEmpresaLogistica.apellido.toUpperCase()+", "+vm.ingreso.personaEmpresaLogistica.nombre.toUpperCase();
      }
    }


    function armarProblemas(){
      vm.problemas = [];
      vm.ingreso.problemas.forEach(function(problema, i){
        problema.foto = problema.encabezadoFoto+problema.cuerpoFoto;
        problema.ind = i;
        vm.problemas.push(problema);
      });
    }

    function editarSuministro(suministro){
      if (suministro.suministro && suministro.suministro.tipoSuministro && suministro.suministro.tipoSuministro.inventariable) {
        editarSuministroInventariable(suministro);
      } else {
        editarSuministroNoInventariable(suministro);
      }
    }

    function actualizarSuministroNoInventariables(suministro){
      vm.ingreso.detalles.forEach(function(item){
        if (suministro.id==item.suministro.id){
          item.suministro = suministro;
        }
      });
      actualizarTabla();
    }

    function actualizarSuministroInventariable(suministro){
      vm.ingreso.detalles.forEach(function(item){
        if (item.suministro.id==suministro.suministro.id){
          item.suministro = suministro.suministro;
        }
        if (item.suministroInventariable.id==suministro.id){
          item.suministroInventariable = suministro;
        }
      });
      actualizarTabla();
    }

    function editarSuministroInventariable(suministro){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Está seguro que desea editar la información del suministro?", function(){
        ServicioDialogos.abrirDialogoCargando();
        ServicioModales.abrirModalEditarSuministro({
          onResult: function(resultado){
            actualizarSuministroInventariable(resultado.suministroEditado);
          },
          suministro:suministro.suministroInventariable,
          modo:'editar'
        });
      });
    }

    function editarSuministroNoInventariable(suministro){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Está seguro que desea editar la información del suministro?", function(){
        ServicioDialogos.abrirDialogoCargando();
        ServicioModales.abrirModalEditarSuministroNoInventariable({
          onResult: function(resultado){
            actualizarSuministroNoInventariables(resultado.suministroEditado);
          },
          suministro:suministro.suministro,
          modo:'editar'
        });
      });
    }

    function montoTotal(){
      var total = 0;
      for(var i = 0; i < vm.ingreso.detalles.length; i++){
        total += vm.ingreso.detalles[i].suministro.precioUnitario*vm.ingreso.detalles[i].cantidad;
      }
      return total ? '$ '+total.toFixed(2) : "-";
    }

    function buscarCantidadPallets(){
      var mayor = vm.detallesInventariables[0].numeroRow;
      vm.detallesInventariables.forEach(function(detalle){
        if (detalle.numeroRow>mayor){
          mayor = detalle.numeroRow;
        }
      });
      return mayor;
    }

    function actualizarTablaInventariables(){
      vm.tableParamsStock.settings({
        data: vm.palletsInventariables,
        noPager: true,
        counts: []
      });
      vm.tableParamsStock.reload();
    }

    function actualizarTabla(){
      vm.tableParams.settings({
        data: orderByFilter(vm.ingreso.detalles,['suministro.tipoSuministro.nombre','numeroCaja'],false),
        noPager: true,
        counts: []
      });
      vm.tableParams.reload();
      vm.tableParams1.settings({
        data: orderByFilter(vm.ingreso.problemas,'nombre', false),
        noPager: true,
        count: []
      });
      vm.tableParams1.reload();
    }

    function ubicacionNaveNumeroOrden(detalle){
      if (detalle.suministro && detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        return "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+detalle.suministro.ubicacion.numeroOrden;
      } else {
        return "El bien no posee una ubicación actual";
      }
    }

    function ubicacionCompleta(detalle){
      if (detalle.suministro && detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación",
        "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+detalle.suministro.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+detalle.suministro.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+detalle.suministro.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+detalle.suministro.ubicacion.numeroUbicacion+
        "\nN° de orden: "+detalle.suministro.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+detalle.suministro.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+detalle.suministro.ubicacion.categoriaPeso.nombre.toUpperCase());
      }
    }


    function crearTablas(){
      vm.tableParams = new NgTableParams({
        page: 1,
        count: 500
      });
      vm.tableParams1 = new NgTableParams({
        page:1,
        count:20
      });
    }

    function comprobarIngresoCerrado(){
      return vm.ingreso.estadoMovimiento.id==6;
    }


  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoVisualizarInformeRecorrido',DialogoVisualizarInformeRecorrido);

  function DialogoVisualizarInformeRecorrido($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/visualizar-informe-recorrido/visualizar-informe-recorrido.html',
        controller: 'ModalVisualizarInformeRecorridoCtrl as vm',
        resolve: {
          egresos: function(){
            return config.egresos;
          },
          deposito: function(){
            return config.deposito;
          },
          noActualizar: function() {
            return config.noActualizar;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

'use strict';
angular.module('proyecto-az-suministro')
  .factory('ReporteRecorrido', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/reportes/recorrido/");
  });
(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalVisualizarInformeRecorridoCtrl', ModalVisualizarInformeRecorridoCtrl);

  /** @ngInject */
  function ModalVisualizarInformeRecorridoCtrl(NgTableParams, noActualizar, URL_SERVIDOR, ReporteRecorrido, $http, $uibModalInstance, $q, HeaderBarService, IngresoEstadoModificar, ServicioModales, deposito, egresos, $stateParams, $filter, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.egresos = egresos;
    vm.deposito = deposito;
    vm.cerrar = cerrar;

    vm.visualizarEgreso = visualizarEgreso;

    vm.detalles = [];
    vm.detallesAgrupados = [];


    vm.ubicacionCompleta = ubicacionCompleta;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.obtenerInforme = obtenerInforme;



    inicializar();
    ServicioDialogos.cerrarDialogoCargando();

    function obtenerLista(){
      var lista = [];
      var detalles = $filter('orderBy')(vm.detallesAgrupados, ['ubicacion.nivel.estructura.pasillo.nave.nombre', 'ubicacion.numeroOrden']);
      detalles.forEach(function(item){
        var ubicacion = item.ubicacion;
        item.detalles.forEach(function(detalle){
          lista.push({
            ubicacion: ubicacion,
            suministro: detalle.suministro,
            suministroInventariable: detalle.suministroInventariable,
            cantidad: detalle.cantidad,
            numeroLote: detalle.numeroLote
          });
        });
      });
      return lista;
    }

    function obtenerReporte(lista){
      var reporte = {
        detallesReporte : lista,
        idDeposito: vm.deposito.id
      };
      return reporte;
    }

    function mostrarReporte(reporte){
      ServicioDialogos.abrirDialogoCargando();
      var Url = URL_SERVIDOR+"/reportes/recorrido";
      $http.post(Url, reporte,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function obtenerInforme(){
      var lista = obtenerLista();
      var reporte = obtenerReporte(lista);
      mostrarReporte(reporte);
    }

    function visualizarEgreso(egreso){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalVisualizarEgreso({
        onResult: function(resultado) {
          console.log(resultado);
        },
        egreso: egreso
      });
    }

    function inicializar(){
      crearTablas();
      armarDetalles();
      actualizarTabla();
    }

    function armarDetalles(){
      crearDetalles();
      obtenerUbicacionesUtilizadas();
      armarDetallesAgrupados();
      actualizarTablaAgrupados();
    }

    function armarDetallesAgrupados(){
      vm.detallesAgrupados.forEach(function(agrupado){
        vm.detalles.forEach(function(detalle){
          if (agrupado.ubicacion.id===detalle.suministro.ubicacion.id){
            agregarDetalle(agrupado, detalle);
          }
        });
      });
    }

    function agregarDetalle(agrupado, detalle){
      var esta = false;
      agrupado.detalles.forEach(function(item){
        if (item.suministro.id == detalle.suministro.id){
          esta = true;
          item.cantidad +=detalle.cantidad;
        }
      });
      if (!esta){
        agrupado.detalles.push({numeroLote: detalle.numeroLote, suministro:detalle.suministro, suministroInventariable:detalle.suministroInventariable?detalle.suministroInventariable:null,cantidad:detalle.cantidad, numeroCaja:detalle.numeroCaja});
      }
    }

    function crearDetalles(){
      vm.egresos.forEach(function(item){
        item.detalles.forEach(function(detalle){
          detalle.numeroLote = item.numeroMovimiento;
          vm.detalles.push(detalle);
        });
      });
    }

    function obtenerUbicacionesUtilizadas(){
      var esta = false;
      vm.detalles.forEach(function(detalle){
        esta = false;
        vm.detallesAgrupados.forEach(function(agrupado){
          if (detalle.suministro.ubicacion.id==agrupado.ubicacion.id){
            esta = true;
          }
        });
        if (!esta){
          vm.detallesAgrupados.push({ubicacion:detalle.suministro.ubicacion, detalles:[]});
        }
      });
    }


    function ubicacionCompleta(agrupado){
      if (agrupado.ubicacion && agrupado.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación",
        "Nave: "+agrupado.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+agrupado.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+agrupado.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+agrupado.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+agrupado.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+agrupado.ubicacion.numeroUbicacion+
        "\nN° de orden: "+agrupado.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+agrupado.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+agrupado.ubicacion.categoriaPeso.nombre.toUpperCase());
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "No hay ubicación");
      }
    }

    function ubicacionNaveNumeroOrden(agrupado){
      if (agrupado.ubicacion && agrupado.ubicacion.nivel) {
        return "Nave: "+agrupado.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+agrupado.ubicacion.numeroOrden;
      }
    }

    function cerrar(){
      if (noActualizar){
        $('.modal-backdrop').remove();
        $uibModalInstance.dismiss();
      } else {
        ServicioDialogos.mostrarDialogoConfirmacionInfo(
          "Cambio de estado",
          "¿Desea cambiar el estado de los egresos a EN PREPARACIÓN?",
          function(){
            ServicioDialogos.abrirDialogoCargando();
            cambiarEstadosYCerrar(vm.egresos);
          },
          function(){
            $('.modal-backdrop').remove();
            $uibModalInstance.dismiss();
          },
          true,
          "Si, cambiar los estados",
          "No, no cambiar"
        );
      }
    }

    function cambiarEstadosYCerrar(egresosSeleccionados){
      cambiarEstadoEgresos(egresosSeleccionados).then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
        $('.modal-backdrop').remove();
        $uibModalInstance.close();
      }, function(err){
        ServicioDialogos.mostrarDialogoError();
      });
    }

    function obtenerEstadoMovimiento(egreso){
      if (egreso.tipoMovimiento.id==7){
        return 18;
      } else if (egreso.tipoMovimiento.id==8){
        return 22;
      } else {
        return 3;
      }
    }

    function cambiarEstadoEgresos(egresosSeleccionados){
      var promesas = [];
      var info = [];
      egresosSeleccionados.forEach(function(egreso) {
        var defer = $q.defer();
        promesas.push(defer.promise);
        IngresoEstadoModificar.update({idMovimiento:egreso.id, idEstado:obtenerEstadoMovimiento(egreso)}, function(data){
          info.push(data.id);
          defer.resolve(true);
        },
        function(error){
            console.log(err);
            ServicioDialogos.cerrarDialogoCargando();
            ServicioDialogos.mostrarDialogoError();
            return $q.reject();
        });
      });
      return $q.all(promesas, info);
    }

    function actualizarTablaAgrupados(){
      vm.tableParamsAgrupado.settings({
        data: $filter('orderBy')(vm.detallesAgrupados, ['ubicacion.nivel.estructura.pasillo.nave.nombre', 'ubicacion.numeroOrden']),
        noPager: true,
        counts: []
      });
      vm.tableParamsAgrupado.reload();
    }

    function actualizarTabla(){
      vm.tableParamsEgresos.settings({
        data: orderByFilter(vm.egresos,'fecha', false),
        noPager: true,
        count: []
      });
      vm.tableParamsEgresos.reload();
    }

    function crearTablas(){
      vm.tableParamsAgrupado = new NgTableParams({
        page: 1,
        count: 10,
        group:{
          tipoSuministro: 'desc'
        }
      });
      vm.tableParamsEgresos = new NgTableParams({
        page:1,
        count:20
      });
    }

  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoVisualizarHistorialReparacion',DialogoVisualizarHistorialReparacion);

  function DialogoVisualizarHistorialReparacion($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/visualizar-historial-reparacion/modal.html',
        controller: 'ModalVisualizarHistorialReparacionCtrl as vm',
        resolve: {
          historial: function(Historial){
            return Historial.get({id:config.historial}).$promise.then(function(data){
              return data;
            });
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalVisualizarHistorialReparacionCtrl', ModalVisualizarHistorialReparacionCtrl);

  /** @ngInject */
  function ModalVisualizarHistorialReparacionCtrl(NgTableParams, historial, $filter, $uibModalInstance, HeaderBarService, ServicioModales, focus, orderByFilter, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    vm.historial=historial;
    vm.volver = volver;
    vm.mostrarFoto = mostrarFoto;

//    console.log(historial);

    inicializar();
    ServicioDialogos.cerrarDialogoCargando();

    function volver(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      HeaderBarService.setSubTitulo($stateParams.subtitulo);
    }

    function mostrarFoto(detalle){
      var foto=detalle.encabezadoFoto+detalle.cuerpoFoto;
      ServicioDialogos.mostrarDialogoInformacionConHtml(null,
        '<div class="marco-imagenes">'+
          '<img src="'+foto+'" />'+
        '</div>'
      );
    }

    function setearObjetos(){
      vm.fecha = $filter('date')(vm.historial.fecha, 'dd/MM/yyyy hh:mm');
      if (historial.detalles.length==0){
        vm.detalles = [];
        vm.detalles.push({descripcion:historial.descripcion, suministroInventariable:historial.suministroInventariable, encabezadoFoto:historial.encabezadoFoto, cuerpoFoto:historial.cuerpoFoto});
      } else {
        vm.detalles = angular.copy(vm.historial.detalles);
      }
    }

    function inicializar(){
      setearTitulos();
      setearObjetos();
      if (vm.historial){
        crearTabla();
        actualizarTabla();
      }
    }
     
    function crearTabla(){
      vm.tableParams = new NgTableParams({
        page: 1,
        count: 10
      });
    }

    function actualizarTabla(){
      vm.tableParams.settings({
        data: vm.detalles
      });
      vm.tableParams.reload();
    }


  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoInformeEgresosEnPreparacion',DialogoInformeEgresosEnPreparacion);

  function DialogoInformeEgresosEnPreparacion($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
		var respuesta = $uibModal.open({
			backdrop : 'static',
			keyboard: false,
			size: 'lg',
			windowClass : 'modal-cargando',
			templateUrl: 'app/components/modales/visualizar-egresos-en-preparacion/visualizar-egresos-en-preparacion.html',
			controller: 'ModalInformeEgresosEnPreparacionCtrl as vm',
			resolve: {
				egresos: function(){
					return config.egresos;
				},
				deposito: function(){
					return config.deposito;
				},
				bandera: function(){
					return config.bandera;
				}
			}
		});
		respuesta.result.then(config.onResult);
		return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalInformeEgresosEnPreparacionCtrl', ModalInformeEgresosEnPreparacionCtrl);

  /** @ngInject */
  function ModalInformeEgresosEnPreparacionCtrl(NgTableParams, bandera, URL_SERVIDOR, ReporteRecorrido, $http, $uibModalInstance, $q, HeaderBarService, IngresoEstadoModificar, ServicioModales, deposito, egresos, $stateParams, $filter, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.egresos = egresos;
    vm.deposito = deposito;
    vm.cerrar = cerrar;
    vm.bandera = bandera;

    vm.visualizarEgreso = visualizarEgreso;

    vm.detalles = [];
    vm.detallesAgrupados = [];


    vm.ubicacionCompleta = ubicacionCompleta;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.obtenerInforme = obtenerInforme;


    inicializar();
    ServicioDialogos.cerrarDialogoCargando();

    function obtenerInforme(){
      ServicioDialogos.abrirDialogoCargando();
      var Url = URL_SERVIDOR+"/reportes/egresos-multiples";
      $http.post(Url, egresos,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function visualizarEgreso(egreso){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalVisualizarEgreso({
        onResult: function(resultado) {
          console.log(resultado);
        },
        egreso: egreso
      });
    }

    function inicializar(){
      crearTablas();
      actualizarTabla();
    }

    function ubicacionCompleta(agrupado){
      if (agrupado.ubicacion && agrupado.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación",
        "Nave: "+agrupado.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+agrupado.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+agrupado.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+agrupado.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+agrupado.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+agrupado.ubicacion.numeroUbicacion+
        "\nN° de orden: "+agrupado.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+agrupado.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+agrupado.ubicacion.categoriaPeso.nombre.toUpperCase());
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "No hay ubicación");
      }
    }

    function ubicacionNaveNumeroOrden(agrupado){
      if (agrupado.ubicacion && agrupado.ubicacion.nivel) {
        return "Nave: "+agrupado.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+agrupado.ubicacion.numeroOrden;
      }
    }


    function cerrar(){
      if (bandera){
        $('.modal-backdrop').remove();
        $uibModalInstance.dismiss();
      } else {
        ServicioDialogos.mostrarDialogoConfirmacionInfo(
          "Cambio de estado",
          "¿Desea cambiar el estado de los egresos a PREPARADOS?",
          function(){
            ServicioDialogos.abrirDialogoCargando();
            cambiarEstadosYCerrar(vm.egresos);
          },
          function(){
            $('.modal-backdrop').remove();
            $uibModalInstance.dismiss();
          },
          true,
          "Si, cambiar los estados",
          "No, no cambiar"
        );
      }
    }

    function cambiarEstadosYCerrar(egresosSeleccionados){
      cambiarEstadoEgresos(egresosSeleccionados).then(function(data){
        ServicioDialogos.cerrarDialogoCargando();
        $('.modal-backdrop').remove();
        $uibModalInstance.close();
      }, function(err){
        ServicioDialogos.mostrarDialogoError();
      });
    }

    function obtenerEstadoMovimiento(egreso){
      if (egreso.tipoMovimiento.id==7){
        return 19;
      } else if (egreso.tipoMovimiento.id==8){
        return 23;
      } else {
        return 2;
      }
    }

    function cambiarEstadoEgresos(egresosSeleccionados){
      var promesas = [];
      var info = [];
      egresosSeleccionados.forEach(function(egreso) {
        var defer = $q.defer();
        promesas.push(defer.promise);
        IngresoEstadoModificar.update({idMovimiento:egreso.id, idEstado:obtenerEstadoMovimiento(egreso)}, function(data){
          info.push(data.id);
          defer.resolve(true);
        },
        function(error){
            console.log(err);
            ServicioDialogos.cerrarDialogoCargando();
            ServicioDialogos.mostrarDialogoError();
            return $q.reject();
        });
      });
      return $q.all(promesas, info);
    }

    function actualizarTabla(){
      vm.tableParamsEgresos.settings({
        data: orderByFilter(vm.egresos,'fecha', false),
        noPager: true,
        count: []
      });
      vm.tableParamsEgresos.reload();
    }

    function crearTablas(){
      vm.tableParamsEgresos = new NgTableParams({
        page:1,
        count:20
      });
    }

  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoVisualizarEgresoPedido',DialogoVisualizarEgresoPedido);

  function DialogoVisualizarEgresoPedido($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/visualizar-egreso-pedido/visualizar-egreso-pedido.html',
        controller: 'ModalVisualizarEgresoPedidoCtrl as vm',
        resolve: {
          egreso: function(Egreso){
            return Egreso.get({id:config.egreso.id}).$promise.then(function(data){
              return data;
            });
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalVisualizarEgresoPedidoCtrl', ModalVisualizarEgresoPedidoCtrl);

  /** @ngInject */
  function ModalVisualizarEgresoPedidoCtrl(NgTableParams, $http, URL_SERVIDOR, $uibModalInstance, HeaderBarService,  ServicioModales, egreso, $stateParams, $filter, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.egreso = egreso;
    vm.cerrar = cerrar;
    vm.detalles = vm.egreso.detalles;
    vm.caja = vm.egreso.caja? "SI": "NO";

    vm.detallesInventariables = [];
    vm.detallesNoInventariables = [];

    vm.detallesNoInventariablesAgrupados = [];
    vm.detallesInventariablesAgrupados = [];
    vm.detallesNoInventariablesAgrupadosCajas = [];


    vm.ubicacionCompleta = ubicacionCompleta;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.ubicacionCompletaCaja = ubicacionCompletaCaja;
    vm.ubicacionNaveNumeroOrdenCaja = ubicacionNaveNumeroOrdenCaja;
    vm.abrirModalEditarMovimiento = abrirModalEditarMovimiento;

    vm.exportarCantidadesEgreso = exportarCantidadesEgreso;


    inicializar();
    ServicioDialogos.cerrarDialogoCargando();
    vm.comprobarEgresoGenerado = comprobarEgresoGenerado;
    vm.obtenerInforme = obtenerInforme;
    vm.visualizarPedido = visualizarPedido;

    function abrirModalEditarMovimiento(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalEditarMovimiento({
        onResult: function(res){
          vm.egreso = res.movimientoEditado;
        },
        objeto: vm.egreso.id
      });
    }

    function visualizarPedido(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalPedido({
        onResult: function(resultado) {
          console.log(resultado);
        },
        pedido: vm.egreso.pedido,
        deposito: vm.egreso.deposito
      });
    }

    function obtenerInforme(){
      ServicioDialogos.abrirDialogoCargando();
      $http.get(URL_SERVIDOR+"/movimiento/reporte/movimiento/"+vm.egreso.id, {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function inicializar(){
      vm.fecha=$filter('date')(vm.egreso.fecha, 'dd/MM/yyyy HH:mm');
      vm.solicitante = vm.egreso.solicita? vm.egreso.solicita.apellido&&vm.egreso.solicita.nombre? vm.egreso.solicita.apellido.toUpperCase()+", "+vm.egreso.solicita.nombre : "-":"-";
      vm.fechaDespacho=$filter('date')(vm.egreso.egreso? vm.egreso.egreso.fecha:"-", 'dd/MM/yyyy HH:mm');
      vm.montoTotal = montoTotal();
      vm.cajasAsignadas = obtenerNumeroCajas();
      crearTablas();
      actualizarTabla();

      vm.detallesNoInventariablesAgrupados = [];
      vm.detallesInventariablesAgrupados = [];
      cargarDetalles();
    }

    function obtenerNumeroCajas(){
      var numeros = [];
      var hash = {};
      vm.egreso.detalles.forEach(function(item){
        numeros.push(item.numeroCaja);
      });
      numeros = numeros.filter(function(current) {
        var exists = !hash[current] || false;
        hash[current] = true;
        return exists;
      });
      return numeros;
    }

    function ubicacionCompletaCaja(detalle){
      if (detalle.ubicacion && detalle.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación",
        "Nave: "+detalle.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+detalle.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+detalle.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+detalle.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+detalle.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+detalle.ubicacion.numeroUbicacion+
        "\nN° de orden: "+detalle.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+detalle.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+detalle.ubicacion.categoriaPeso.nombre.toUpperCase());
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "No hay ubicación");
      }
    }

    function ubicacionNaveNumeroOrdenCaja(detalle){
      //console.log(detalle);
      if (detalle.ubicacion && detalle.ubicacion.nivel) {
        return "Nave: "+detalle.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+detalle.ubicacion.numeroOrden;
      } else {
        return "La caja no posee ubicación";
      }
    }


    function ubicacionCompleta(detalle){
      if (detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación",
        "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+detalle.suministro.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+detalle.suministro.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+detalle.suministro.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+detalle.suministro.ubicacion.numeroUbicacion+
        "\nN° de orden: "+detalle.suministro.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+detalle.suministro.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+detalle.suministro.ubicacion.categoriaPeso.nombre.toUpperCase());
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "No hay ubicación");
      }
    }

    function ubicacionNaveNumeroOrden(detalle){
      //console.log(detalle);
      if (detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        return "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+detalle.suministro.ubicacion.numeroOrden;
      }
    }


    function cargarDetalles(){
      vm.detallesInventariables = [];
      vm.detallesNoInventariables = [];
      vm.detalles.forEach(function(detalle){
        if (detalle.suministro.tipoSuministro.inventariable){
          vm.detallesInventariables.push(detalle);
        } else {
          vm.detallesNoInventariables.push(detalle);
        }
      });
      if (vm.detallesNoInventariables.length>0){
        armarDetallesNoInventariables();
      } else {
        actualizarTablaNoInventariables();
      }
      if (vm.detallesInventariables.length>0){
        if (vm.egreso.caja){
          armarDetallesInventariablesCajas();
        } else {
          armarDetallesInventariables();
        }
      } else {
        actualizarTablaInventariables();
      }
    }

    function armarDetallesCajaAgrupados(){
      vm.detallesInventariablesAgrupadosCajas = [];
      vm.cajasAsignadas.forEach(function(numeroCaja){
        vm.detallesInventariablesAgrupadosCajas.push({numeroCaja:numeroCaja, tipoSuministro:null, precioTotal:0.0, cantidad:0, detalles:[], ubicacion:null});
      });
    }

    function armarDetallesInventariablesAgrupadosCajas(){
      vm.detallesInventariablesAgrupadosCajas.forEach(function(agrupado){
        vm.detallesInventariables.forEach(function(detalle){
          if (agrupado.numeroCaja===detalle.numeroCaja){
            agrupado.detalles.push({suministro:detalle.suministro, suministroInventariable:detalle.suministroInventariable, cantidad:detalle.cantidad});
            agrupado.cantidad = agrupado.cantidad + detalle.cantidad;
            agrupado.precioTotal = agrupado.precioTotal + detalle.suministro.precioUnitario;
            agrupado.ubicacion = detalle.suministro.ubicacion;
            agrupado.tipoSuministro = detalle.suministro.tipoSuministro;
          }
        });
      });
    }

    function armarDetallesInventariablesCajas(){
      armarDetallesCajaAgrupados();
      armarDetallesInventariablesAgrupadosCajas();
      actualizarTablaInventariablesCajas();
    }

    function obtenerTiposUtilizados(){
      var esta = false;
      vm.detallesNoInventariables.forEach(function(detalle){
        esta = false;
        vm.detallesNoInventariablesAgrupados.forEach(function(agrupado){
          if (detalle.suministro.tipoSuministro.id==agrupado.tipoSuministro.id){
            esta = true;
          }
        });
        if (!esta){
          vm.detallesNoInventariablesAgrupados.push({tipoSuministro:detalle.suministro.tipoSuministro, precioTotal:0.0, cantidad:0, detalles:[]});
        }
      });
    }

    function armarDetallesNoInventariablesAgrupados(){
      vm.detallesNoInventariablesAgrupados.forEach(function(agrupado){
        vm.detallesNoInventariables.forEach(function(detalle){
          if (agrupado.tipoSuministro.id===detalle.suministro.tipoSuministro.id){
            agrupado.detalles.push({suministro:detalle.suministro, cantidad:detalle.cantidad});
            agrupado.cantidad = agrupado.cantidad + detalle.cantidad;
            agrupado.precioTotal = agrupado.precioTotal + detalle.suministro.precioUnitario*detalle.cantidad;
          }
        });
      });
    }

    function armarDetallesNoInventariables(){
      obtenerTiposUtilizados();
      armarDetallesNoInventariablesAgrupados();
      actualizarTablaNoInventariables();
    }

    function obtenerTiposInventariablesUtilizados(){
      var esta = false;
      vm.detallesInventariables.forEach(function(detalle){
        esta = false;
        vm.detallesInventariablesAgrupados.forEach(function(agrupado){
          if (detalle.suministro.tipoSuministro.id==agrupado.tipoSuministro.id){
            esta = true;
          }
        });
        if (!esta){
          vm.detallesInventariablesAgrupados.push({tipoSuministro:detalle.suministro.tipoSuministro, precioTotal:0.0, cantidad:0, detalles:[]});
        }
      });
    }

    function armarDetallesInventariablesAgrupados(){
      vm.detallesInventariablesAgrupados.forEach(function(agrupado){
        vm.detallesInventariables.forEach(function(detalle){
          if (agrupado.tipoSuministro.id===detalle.suministro.tipoSuministro.id){
            agrupado.detalles.push({suministro:detalle.suministro, suministroInventariable:detalle.suministroInventariable, cantidad:detalle.cantidad});
            agrupado.cantidad = agrupado.cantidad + detalle.cantidad;
            agrupado.precioTotal = agrupado.precioTotal + detalle.suministro.precioUnitario;
          }
        });
      });
    }

    function armarDetallesInventariables(){
      obtenerTiposInventariablesUtilizados();
      armarDetallesInventariablesAgrupados();
      actualizarTablaInventariables();
    }

    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
    }

    function montoTotal(){
      var total = 0;
      for(var i = 0; i < vm.egreso.detalles.length; i++){
        total += vm.egreso.detalles[i].suministro.precioUnitario*vm.egreso.detalles[i].cantidad;
      }
      return total ? '$ '+total.toFixed(2) : "-";
    }

    function actualizarTablaNoInventariables(){
      vm.tableParamsNoInventariableAgrupado.settings({
        data: vm.detallesNoInventariablesAgrupados,
        noPager: true,
        counts: []
      });
      vm.tableParamsNoInventariableAgrupado.reload();
    }

    function actualizarTablaInventariables(){
      vm.tableParamsInventariableAgrupado.settings({
        data: vm.detallesInventariablesAgrupados,
        noPager: true,
        counts: []
      });
      vm.tableParamsInventariableAgrupado.reload();
    }

    function actualizarTabla(){
      vm.tableParams1.settings({
        data: orderByFilter(vm.egreso.problemas,'nombre', false),
        noPager: true,
        count: []
      });
      vm.tableParams1.reload();
    }

    function actualizarTablaInventariablesCajas(){
      vm.tableParamsInventariableAgrupadoCajas.settings({
        data: vm.detallesInventariablesAgrupadosCajas,
        noPager: true,
        counts: []
      });
      vm.tableParamsInventariableAgrupadoCajas.reload();
    }

    function crearTablas(){
      vm.tableParamsInventariableAgrupado = new NgTableParams({
        page: 1,
        count: 10,
        group:{
          tipoSuministro: 'desc'
        }
      });
      vm.tableParamsNoInventariableAgrupado = new NgTableParams({
        page: 1,
        count: 10,
        group:{
          tipoSuministro: 'desc'
        }
      });
      vm.tableParams1 = new NgTableParams({
        page:1,
        count:20
      });
      vm.tableParamsInventariableAgrupadoCajas = new NgTableParams({
        page: 1,
        count: 10,
        group:{
          tipoSuministro: 'desc'
        }
      });
    }

    function comprobarEgresoGenerado(){
      return vm.egreso && vm.egreso.estadoMovimiento && (vm.egreso.estadoMovimiento.id>=1 || vm.egreso.estadoMovimiento.id<=3) || (vm.egreso.estadoMovimiento.id>=17 || vm.egreso.estadoMovimiento.id<=24);
    }

    function exportarCantidadesEgreso(){
      var array = [];
      for (var i = vm.egreso.detalles.length - 1; i >= 0; i--) {
        array.push({
          "a":"",
          "grupo_nombre" : vm.egreso.detalles[i].suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
          "familia_cod":vm.egreso.detalles[i].suministro.tipoSuministro.familiaSuministro.codigoFamiliaSuministro,
          "familia_nombre":vm.egreso.detalles[i].suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase(),
          "tipo_cod":vm.egreso.detalles[i].suministro.tipoSuministro.codigoProducto,
          "f":vm.egreso.detalles[i].suministro.tipoSuministro.nombre.toUpperCase(),
          "g":"A",
          "h":"Primario",
          "i":"GRA21",
          "j":"Grabado 21%",
          "cantidad" : vm.egreso.detalles[i].cantidad
        });
      }
      var nombreDocumento = "cantidades-egreso-"+vm.egreso.numeroMovimiento;
      alasql('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true}) FROM ?',[array]);
    }


  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoVisualizarEgreso',DialogoVisualizarEgreso);

  function DialogoVisualizarEgreso($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/visualizar-egreso-modal/visualizar-egreso-modal.html',
        controller: 'ModalVisualizarEgresoCtrl as vm',
        resolve: {
          egreso: function(Egreso){
            return Egreso.get({id:config.egreso.id}).$promise.then(function(data){
              return data;
            });
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalVisualizarEgresoCtrl', ModalVisualizarEgresoCtrl);

  /** @ngInject */
  function ModalVisualizarEgresoCtrl(NgTableParams, $timeout, $http, URL_SERVIDOR, $uibModalInstance, HeaderBarService,  ServicioModales, egreso, $stateParams, $filter, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.egreso = egreso;
    vm.cerrar = cerrar;
    vm.detalles = vm.egreso.detalles;
    vm.caja = vm.egreso.caja? "SI": "NO";

    vm.detallesInventariables = [];
    vm.detallesNoInventariables = [];

    vm.detallesNoInventariablesAgrupados = [];
    vm.detallesInventariablesAgrupados = [];
    vm.detallesNoInventariablesAgrupadosCajas = [];


    vm.ubicacionCompleta = ubicacionCompleta;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.ubicacionCompletaCaja = ubicacionCompletaCaja;
    vm.ubicacionNaveNumeroOrdenCaja = ubicacionNaveNumeroOrdenCaja;
    vm.abrirModalEditarMovimiento = abrirModalEditarMovimiento;

    vm.exportarCantidadesEgreso = exportarCantidadesEgreso;
    vm.copiarDatosSalida = copiarDatosSalida;



    inicializar();
    ServicioDialogos.cerrarDialogoCargando();
    vm.comprobarEgresoGenerado = comprobarEgresoGenerado;
    vm.obtenerInforme = obtenerInforme;
    vm.visualizarPedido = visualizarPedido;

    function abrirModalEditarMovimiento(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalEditarMovimiento({
        onResult: function(res){
          vm.egreso = res.movimientoEditado;
        },
        objeto: vm.egreso.id
      });
    }

    function visualizarPedido(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalPedido({
        onResult: function(resultado) {
          console.log(resultado);
        },
        pedido: vm.egreso.pedido,
        deposito: vm.egreso.deposito
      });
    }

    function obtenerInforme(){
      ServicioDialogos.abrirDialogoCargando();
      $http.get(URL_SERVIDOR+"/movimiento/reporte/movimiento/"+vm.egreso.id, {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function inicializar(){
      vm.fecha=$filter('date')(vm.egreso.fecha, 'dd/MM/yyyy HH:mm');
      vm.solicitante = vm.egreso.solicita? vm.egreso.solicita.apellido&&vm.egreso.solicita.nombre? vm.egreso.solicita.apellido.toUpperCase()+", "+vm.egreso.solicita.nombre : "-":"-";
      vm.fechaDespacho=$filter('date')(vm.egreso.egreso? vm.egreso.egreso.fecha:"-", 'dd/MM/yyyy HH:mm');
      vm.montoTotal = montoTotal();
      vm.cajasAsignadas = obtenerNumeroCajas();
      crearTablas();
      actualizarTabla();

      vm.detallesNoInventariablesAgrupados = [];
      vm.detallesInventariablesAgrupados = [];
      cargarDetalles();
    }

    function obtenerNumeroCajas(){
      var numeros = [];
      var hash = {};
      vm.egreso.detalles.forEach(function(item){
        numeros.push(item.numeroCaja);
      });
      numeros = numeros.filter(function(current) {
        var exists = !hash[current] || false;
        hash[current] = true;
        return exists;
      });
      return numeros;
    }

    function ubicacionCompletaCaja(detalle){
      if (detalle.ubicacion && detalle.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación",
        "Nave: "+detalle.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+detalle.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+detalle.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+detalle.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+detalle.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+detalle.ubicacion.numeroUbicacion+
        "\nN° de orden: "+detalle.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+detalle.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+detalle.ubicacion.categoriaPeso.nombre.toUpperCase());
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "No hay ubicación");
      }
    }

    function ubicacionNaveNumeroOrdenCaja(detalle){
      //console.log(detalle);
      if (detalle.ubicacion && detalle.ubicacion.nivel) {
        return "Nave: "+detalle.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+detalle.ubicacion.numeroOrden;
      } else {
        return "La caja no posee ubicación";
      }
    }


    function ubicacionCompleta(detalle){
      if (detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación",
        "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+detalle.suministro.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+detalle.suministro.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+detalle.suministro.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+detalle.suministro.ubicacion.numeroUbicacion+
        "\nN° de orden: "+detalle.suministro.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+detalle.suministro.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+detalle.suministro.ubicacion.categoriaPeso.nombre.toUpperCase());
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "No hay ubicación");
      }
    }

    function ubicacionNaveNumeroOrden(detalle){
      //console.log(detalle);
      if (detalle.suministro.ubicacion && detalle.suministro.ubicacion.nivel) {
        return "Nave: "+detalle.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+detalle.suministro.ubicacion.numeroOrden;
      }
    }


    function cargarDetalles(){
      vm.detallesInventariables = [];
      vm.detallesNoInventariables = [];
      vm.detalles.forEach(function(detalle){
        if (detalle.suministro.tipoSuministro.inventariable){
          vm.detallesInventariables.push(detalle);
        } else {
          vm.detallesNoInventariables.push(detalle);
        }
      });
      if (vm.detallesNoInventariables.length>0){
        armarDetallesNoInventariables();
      } else {
        actualizarTablaNoInventariables();
      }
      if (vm.detallesInventariables.length>0){
        if (vm.egreso.caja){
          armarDetallesInventariablesCajas();
        } else {
          armarDetallesInventariables();
        }
      } else {
        actualizarTablaInventariables();
      }
    }

    function armarDetallesCajaAgrupados(){
      vm.detallesInventariablesAgrupadosCajas = [];
      vm.cajasAsignadas.forEach(function(numeroCaja){
        vm.detallesInventariablesAgrupadosCajas.push({numeroCaja:numeroCaja, tipoSuministro:null, precioTotal:0.0, cantidad:0, detalles:[], ubicacion:null});
      });
    }

    function armarDetallesInventariablesAgrupadosCajas(){
      vm.detallesInventariablesAgrupadosCajas.forEach(function(agrupado){
        vm.detallesInventariables.forEach(function(detalle){
          if (agrupado.numeroCaja===detalle.numeroCaja){
            agrupado.detalles.push({suministro:detalle.suministro, suministroInventariable:detalle.suministroInventariable, cantidad:detalle.cantidad});
            agrupado.cantidad = agrupado.cantidad + detalle.cantidad;
            agrupado.precioTotal = agrupado.precioTotal + detalle.suministro.precioUnitario;
            agrupado.ubicacion = detalle.suministro.ubicacion;
            agrupado.tipoSuministro = detalle.suministro.tipoSuministro;
          }
        });
      });
    }

    function armarDetallesInventariablesCajas(){
      armarDetallesCajaAgrupados();
      armarDetallesInventariablesAgrupadosCajas();
      actualizarTablaInventariablesCajas();
    }

    function obtenerTiposUtilizados(){
      var esta = false;
      vm.detallesNoInventariables.forEach(function(detalle){
        esta = false;
        vm.detallesNoInventariablesAgrupados.forEach(function(agrupado){
          if (detalle.suministro.tipoSuministro.id==agrupado.tipoSuministro.id){
            esta = true;
          }
        });
        if (!esta){
          vm.detallesNoInventariablesAgrupados.push({tipoSuministro:detalle.suministro.tipoSuministro, precioTotal:0.0, cantidad:0, detalles:[]});
        }
      });
    }

    function armarDetallesNoInventariablesAgrupados(){
      vm.detallesNoInventariablesAgrupados.forEach(function(agrupado){
        vm.detallesNoInventariables.forEach(function(detalle){
          if (agrupado.tipoSuministro.id===detalle.suministro.tipoSuministro.id){
            agrupado.detalles.push({suministro:detalle.suministro, cantidad:detalle.cantidad});
            agrupado.cantidad = agrupado.cantidad + detalle.cantidad;
            agrupado.precioTotal = agrupado.precioTotal + detalle.suministro.precioUnitario*detalle.cantidad;
          }
        });
      });
    }

    function armarDetallesNoInventariables(){
      obtenerTiposUtilizados();
      armarDetallesNoInventariablesAgrupados();
      actualizarTablaNoInventariables();
    }

    function obtenerTiposInventariablesUtilizados(){
      var esta = false;
      vm.detallesInventariables.forEach(function(detalle){
        esta = false;
        vm.detallesInventariablesAgrupados.forEach(function(agrupado){
          if (detalle.suministro.tipoSuministro.id==agrupado.tipoSuministro.id){
            esta = true;
          }
        });
        if (!esta){
          vm.detallesInventariablesAgrupados.push({tipoSuministro:detalle.suministro.tipoSuministro, precioTotal:0.0, cantidad:0, detalles:[]});
        }
      });
    }

    function armarDetallesInventariablesAgrupados(){
      vm.detallesInventariablesAgrupados.forEach(function(agrupado){
        vm.detallesInventariables.forEach(function(detalle){
          if (agrupado.tipoSuministro.id===detalle.suministro.tipoSuministro.id){
            agrupado.detalles.push({suministro:detalle.suministro, suministroInventariable:detalle.suministroInventariable, cantidad:detalle.cantidad});
            agrupado.cantidad = agrupado.cantidad + detalle.cantidad;
            agrupado.precioTotal = agrupado.precioTotal + detalle.suministro.precioUnitario;
          }
        });
      });
    }

    function armarDetallesInventariables(){
      obtenerTiposInventariablesUtilizados();
      armarDetallesInventariablesAgrupados();
      actualizarTablaInventariables();
    }

    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
    }

    function montoTotal(){
      var total = 0;
      for(var i = 0; i < vm.egreso.detalles.length; i++){
        total += vm.egreso.detalles[i].suministro.precioUnitario*vm.egreso.detalles[i].cantidad;
      }
      return total ? '$ '+total.toFixed(2) : "-";
    }

    function actualizarTablaNoInventariables(){
      vm.tableParamsNoInventariableAgrupado.settings({
        data: vm.detallesNoInventariablesAgrupados,
        noPager: true,
        counts: []
      });
      vm.tableParamsNoInventariableAgrupado.reload();
    }

    function actualizarTablaInventariables(){
      vm.tableParamsInventariableAgrupado.settings({
        data: vm.detallesInventariablesAgrupados,
        noPager: true,
        counts: []
      });
      vm.tableParamsInventariableAgrupado.reload();
    }

    function actualizarTabla(){
      vm.tableParams1.settings({
        data: orderByFilter(vm.egreso.problemas,'nombre', false),
        noPager: true,
        count: []
      });
      vm.tableParams1.reload();
    }

    function actualizarTablaInventariablesCajas(){
      vm.tableParamsInventariableAgrupadoCajas.settings({
        data: vm.detallesInventariablesAgrupadosCajas,
        noPager: true,
        counts: []
      });
      vm.tableParamsInventariableAgrupadoCajas.reload();
    }

    function crearTablas(){
      vm.tableParamsInventariableAgrupado = new NgTableParams({
        page: 1,
        count: 10,
        group:{
          tipoSuministro: 'desc'
        }
      });
      vm.tableParamsNoInventariableAgrupado = new NgTableParams({
        page: 1,
        count: 10,
        group:{
          tipoSuministro: 'desc'
        }
      });
      vm.tableParams1 = new NgTableParams({
        page:1,
        count:20
      });
      vm.tableParamsInventariableAgrupadoCajas = new NgTableParams({
        page: 1,
        count: 10,
        group:{
          tipoSuministro: 'desc'
        }
      });
    }

    function comprobarEgresoGenerado(){
      return vm.egreso && vm.egreso.estadoMovimiento && (vm.egreso.estadoMovimiento.id>=1 || vm.egreso.estadoMovimiento.id<=3) || (vm.egreso.estadoMovimiento.id>=17 || vm.egreso.estadoMovimiento.id<=24);
    }

    function copiarDatosSalida(){
      var tempInput = document.createElement('INPUT');
      var body = document.getElementsByTagName('body')[0];
      body.appendChild(tempInput);
      var guia = vm.egreso.egreso.nroGuia?vm.egreso.egreso.nroGuia:'No especificado';
      var bultos = vm.egreso.cantidadPaquetes?vm.egreso.cantidadPaquetes:'No especificado';
      var kg = vm.egreso.pesoPaquetes?vm.egreso.pesoPaquetes:'No especificado';
      var texto ="REMITO: \n"+vm.egreso.numeroMovimiento+
      " - FECHA: \n"+$filter('date')(vm.egreso.egreso.fecha, "dd/MM/yyyy HH:mm")+
      " - GUÍA: \n"+guia+
      " - SUCURSAL\n: "+vm.egreso.sucursal.codigoSucursal.toUpperCase()+" - "+vm.egreso.sucursal.nombre.toUpperCase()+
      " - BULTOS: \n"+bultos+
      " - KG: \n"+kg;
      tempInput.setAttribute('value', texto);
      tempInput.select();
      document.execCommand('copy');
      body.removeChild(tempInput);
      vm.copiado = "¡Copiado!";
      $timeout(function(){
          vm.copiado = null;
      }, 2000);
    }

    function exportarCantidadesEgreso(){
      var array = [];
      for (var i = vm.egreso.detalles.length - 1; i >= 0; i--) {
        array.push({
          "a":"",
          "grupo_nombre" : vm.egreso.detalles[i].suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(),
          "familia_cod":vm.egreso.detalles[i].suministro.tipoSuministro.familiaSuministro.codigoFamiliaSuministro,
          "familia_nombre":vm.egreso.detalles[i].suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase(),
          "tipo_cod":vm.egreso.detalles[i].suministro.tipoSuministro.codigoProducto,
          "f":vm.egreso.detalles[i].suministro.tipoSuministro.nombre.toUpperCase(),
          "g":"A",
          "h":"Primario",
          "i":"GRA21",
          "j":"Grabado 21%",
          "cantidad" : vm.egreso.detalles[i].cantidad
        });
      }
      var nombreDocumento = "cantidades-egreso-"+vm.egreso.numeroMovimiento;
      alasql('SELECT * INTO XLSX("'+nombreDocumento+'.xlsx",{headers:true}) FROM ?',[array]);
    }


  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoVisualizarDespacho',DialogoVisualizarDespacho);

  function DialogoVisualizarDespacho($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
		var respuesta = $uibModal.open({
			backdrop : 'static',
			keyboard: false,
			size: 'lg',
			windowClass : 'modal-cargando',
			templateUrl: 'app/components/modales/visualizar-despacho/visualizar-despacho.html',
			controller: 'ModalVisualizarDespachoCtrl as vm',
			resolve: {
				egreso: function(){
					return config.egreso;
				}
			}
		});
		respuesta.result.then(config.onResult);
		return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalVisualizarDespachoCtrl', ModalVisualizarDespachoCtrl);

  /** @ngInject */
  function ModalVisualizarDespachoCtrl(NgTableParams, URL_SERVIDOR, $http, HeaderBarService, focus, EgresoGuardar, egreso, $uibModalInstance, $stateParams, $filter, $scope, orderByFilter, $state, ServicioDialogos, ServicioModales) {

    var vm = this;
    vm.egreso = egreso;
    vm.cerrar = cerrar;

    vm.visualizarEgreso = visualizarEgreso;

    inicializar();
    ServicioDialogos.cerrarDialogoCargando();

    vm.reporteEtiquetas = reporteEtiquetas;
    vm.reporteEgreso = reporteEgreso;
    vm.reporteEtiquetasA4 = reporteEtiquetasA4;
    vm.reporteEgresoMultiples = reporteEgresoMultiples;
    vm.editarEgreso = editarEgreso;

    function editarEgreso(){
      ServicioModales.abrirModalEditarEgreso({
        onResult: function(data){
          vm.egreso = data.egresoEditado;
        },
        egreso: vm.egreso
      });
    }

    function mostrarReporte(lista){
      ServicioDialogos.abrirDialogoCargando();
      var Url = URL_SERVIDOR+"/reportes/egresos-multiples";
      $http.post(Url, lista,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function reporteEgresoMultiples(){
      var lista = orderByFilter(vm.egreso.movimientos,'numeroMovimiento', false);
      mostrarReporte(lista);
    }

    function reporteEtiquetasA4(){
      var lista = [];
      var solicitante;
      vm.egreso.movimientos.forEach(function(movimiento){
        solicitante = movimiento.solicita? "Solicitó: "+movimiento.solicita.apellido.toUpperCase()+", "+movimiento.solicita.nombre.toUpperCase():"";
        for (var i = 0; i < movimiento.cantidadPaquetes; i++) {
          lista.push({
            numeroMovimiento: movimiento.numeroMovimiento,
            bulto: "Bulto "+(i+1)+"/"+movimiento.cantidadPaquetes,
            sucursal: movimiento.sucursal,
            solicitante: solicitante,
            sector: movimiento.sector
          });
        }
      });
      if (lista.length>0){
        lista = orderByFilter(lista, 'sucursal.nombre', false);
        armarReporteEtiquetasA4(lista);
      } else {
        ServicioDialogos.mostrarDialogoError(null, "No hay cantidad de paquetes ingresados");
      }
    }

    function armarReporteEtiquetasA4(lista){
      var reporte = {
        detallesReporte: lista,
        deposito: vm.egreso.deposito.nombre.toUpperCase(),
        numeroEgreso: vm.egreso.numeroEgreso,
        empresaLogistica: vm.egreso.empresaLogistica.nombre.toUpperCase(),
        fecha: $filter('date')(vm.egreso.fecha, "dd/MM/yyyy HH:mm")
      };
      mostrarReporteEtiquetasA4(reporte);
    }

    function mostrarReporteEtiquetasA4(reporte){
      ServicioDialogos.abrirDialogoCargando();
      var Url = URL_SERVIDOR+"/reportes/paquetesA4";
      $http.post(Url, reporte,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function reporteEgreso(){
      ServicioDialogos.abrirDialogoCargando();
      var Url = URL_SERVIDOR+"/egreso/reporte/egreso/"+vm.egreso.id;
      $http.get(Url,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function reporteEtiquetas(){
      var lista = [];
      var solicitante;
      vm.egreso.movimientos.forEach(function(movimiento){
        solicitante = movimiento.solicita? "Solicitó: "+movimiento.solicita.apellido.toUpperCase()+", "+movimiento.solicita.nombre.toUpperCase():"";
        for (var i = 0; i < movimiento.cantidadPaquetes; i++) {
          lista.push({
            solicitante: solicitante,
            numeroMovimiento: movimiento.numeroMovimiento,
            bulto: "Bulto "+(i+1)+"/"+movimiento.cantidadPaquetes,
            sucursal: movimiento.sucursal
          });
        }
      });
      if (lista.length>0){
        armarReporteEtiquetas(lista);
      } else {
        ServicioDialogos.mostrarDialogoError(null, "No hay cantidad de paquetes ingresados");
      }
    }

    function armarReporteEtiquetas(lista){
      var reporte = {
        detallesReporte: lista,
        deposito: vm.egreso.deposito.nombre.toUpperCase(),
        numeroEgreso: vm.egreso.numeroEgreso,
        empresaLogistica: vm.egreso.empresaLogistica.nombre.toUpperCase(),
        fecha: $filter('date')(vm.egreso.fecha, "dd/MM/yyyy HH:mm")
      };
      mostrarReporteEtiquetas(reporte);
    }

    function mostrarReporteEtiquetas(reporte){
      ServicioDialogos.abrirDialogoCargando();
      var Url = URL_SERVIDOR+"/reportes/paquetes";
      $http.post(Url, reporte,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }



    function visualizarEgreso(egreso){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalVisualizarEgreso({
        onResult: function(resultado) {
          console.log(resultado);
        },
        egreso: egreso
      });
    }

    function inicializar(){
      vm.fecha=$filter('date')(vm.egreso.fecha, 'dd/MM/yyyy HH:mm');
      armarPersona();
      crearTablas();
      actualizarTabla();
    }

    function armarPersona(){
      if (vm.egreso.personaEmpresaLogistica && vm.egreso.personaEmpresaLogistica.id){
        vm.persona=vm.egreso.personaEmpresaLogistica.apellido.toUpperCase()+" ,"+vm.egreso.personaEmpresaLogistica.nombre.toUpperCase();
      } else {
        vm.persona=null;
      }
    }

    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.close({
        egreso: vm.egreso
      });
    }

    function actualizarTabla(){
      vm.tableParamsEgresos.settings({
        data: orderByFilter(vm.egreso.movimientos,'fecha', false),
        noPager: true,
        count: []
      });
      vm.tableParamsEgresos.reload();
    }

    function crearTablas(){
      vm.tableParamsEgresos = new NgTableParams({
        page:1,
        count:20
      });
    }

  }
})();
(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoSeleccionarTipoSuministroKit',DialogoSeleccionarTipoSuministroKit);

  function DialogoSeleccionarTipoSuministroKit($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/seleccionar-tipo-suministro-kit/modal-seleccionar-tipo-suministro.html',
        controller: 'ModalSeleccionarTipoSuministroKitCtrl as vm',
        resolve: {
          grupos: function(GrupoEmpresa){
            return GrupoEmpresa.query({id:config.empresa.id}).$promise.then(function(data) {
              return data;
            });
          },
          tipos: function(){
            return config.tipos;
          },
          empresa: function(){
            return config.empresa.id;
          },
          tipo: function(){
            return config.tipo;
          },
          modo: function(){
            return config.modo;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();


(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalSeleccionarTipoSuministroKitCtrl', ModalSeleccionarTipoSuministroKitCtrl);

  /** @ngInject */
  function ModalSeleccionarTipoSuministroKitCtrl(NgTableParams, modo, tipo, focus, empresa, tipos, TiposPorEmpresa, ServicioModales, $uibModalInstance, HeaderBarService, TipoSuministroFamilia, FamiliaSuministroGrupo, grupos, $timeout, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.grupos = orderByFilter(grupos,'nombre',false);
    vm.modo = modo;
    vm.empresaId = empresa;

    vm.agregar = agregar;
    vm.cerrar = cerrar;
    vm.cambioRadio = cambioRadio;
    inicializar();


    vm.radio = 'jerarquizada';

    ServicioDialogos.cerrarDialogoCargando();


    function inicializar(){
      if (modo=='editar'){
        vm.tipoSuministroCompleto = tipo.tipoSuministro;
//        console.log(vm.tipoSuministro);
        vm.cantidad = tipo.cantidad;
  //      console.log(vm.cantidad);
        vm.tipoEditar = "("+tipo.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+" - "+tipo.tipoSuministro.familiaSuministro.nombre.toUpperCase()+") "+tipo.tipoSuministro.nombre.toUpperCase();
      }
    }


    function comprobarTipoSeleccionado(){
      var ban = true;
      tipos.forEach(function(item){
        if (item.tipoSuministro.id==vm.tipoSuministro.id){
          ban=false;
        }
      });
      return ban;
    }

    function agregar(){
      if (modo=='editar' || comprobarTipoSeleccionado()){
        $uibModalInstance.close({tipoSuministro:vm.tipoSuministro, cantidad:vm.cantidad});
      } else {
        ServicioDialogos.mostrarDialogoError(null, "El tipo de suministro seleccionado, ya fue utilizado");
      }
    }

    function cambioRadio(){
      if (vm.radio=='jerarquizada'){
        vm.tipoSuministroCompleto=null;
      } else {
        if (vm.tipoSuministro && vm.tipoSuministro.id) vm.tipoSuministro=null;
        if (vm.familiaSuministro && vm.familiaSuministro.id) vm.familiaSuministro=null;
        if (vm.grupo && vm.grupo.id) vm.grupo=null;
      }
    }

    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.dismiss();
    }

    $scope.$watch('vm.grupo.nombre', function(){
      if (vm.familiaSuministro) vm.familiaSuministro=null;
      if (!vm.grupo) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupo.id}, function(data){
        vm.familias = orderByFilter(data,'nombre',false);
        focus('familia');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.familiaSuministro.nombre', function(){
      if (vm.tipoSuministro) vm.tipoSuministro=null;
      if (!vm.familiaSuministro) return;
      ServicioDialogos.abrirDialogoCargando();
      TipoSuministroFamilia.query({id:vm.familiaSuministro.id}, function(data){
        vm.tipos = orderByFilter(data,'nombre',false);
        focus('tipo');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.tipoSuministroCompleto.nombre', function(){
      vm.tipoSuministro=vm.tipoSuministroCompleto;
      //if (!vm.tipoSuministroCompleto || vm.tipoSuministroCompleto.inventariable===false) return;
    });

    $scope.$watch('vm.radio', function(){
      if (vm.radio=='directa') {
        ServicioDialogos.abrirDialogoCargando();
        TiposPorEmpresa.query({idEmpresa:vm.empresaId}, function(data){
          vm.tiposCompletos = orderByFilter(data,'nombre',false);
          ServicioDialogos.cerrarDialogoCargando();
        }, function(err){
          console.log(err);
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError();
        });

      }
    });
   
  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoSeleccionarTipoSuministro',DialogoSeleccionarTipoSuministro);

  function DialogoSeleccionarTipoSuministro($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/seleccionar-tipo-suministro/modal-seleccionar-tipo-suministro.html',
        controller: 'ModalSeleccionarTipoSuministroCtrl as vm',
        resolve: {
          grupos: function(GrupoEmpresa){
            return GrupoEmpresa.query({id:config.empresa.id}).$promise.then(function(data) {
              return data;
            });
          },
          deposito: function(){
            return config.deposito;
          },
          empresa: function(){
            return config.empresa.id;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();


(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalSeleccionarTipoSuministroCtrl', ModalSeleccionarTipoSuministroCtrl);

  /** @ngInject */
  function ModalSeleccionarTipoSuministroCtrl(NgTableParams, focus, empresa, deposito, TiposPorEmpresa, SuministroPor2TipoMovimientoEstadoSuministroTipoSuministroDepositoPorDetalle, SuministroInventariableTipoEstadoDepositoCaja, SuministroInventariableContarStockTipoEstado, SuministroTipoEstadoDeposito, SuministroContarStockTipoEstado, SuministroTipoEstadoDepositoPorDetalle, ServicioModales, $uibModalInstance, HeaderBarService, TipoSuministroFamilia, FamiliaSuministroGrupo, grupos, $timeout, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.grupos = orderByFilter(grupos,'nombre',false);
    vm.empresaId = empresa;
    vm.idDeposito = deposito;

    vm.agregar = agregar;
    vm.cerrar = cerrar;
    vm.cambioRadio = cambioRadio;
    vm.cantidadStockTipo = cantidadStockTipo;
    vm.cantidadStockBienes = cantidadStockBienes;


    vm.radio = 'jerarquizada';

    ServicioDialogos.cerrarDialogoCargando();

    function cambioRadio(){
      if (vm.radio=='jerarquizada'){
        vm.tipoSuministroCompleto=null;
      } else {
        if (vm.tipoSuministro && vm.tipoSuministro.id) vm.tipoSuministro=null;
        if (vm.familiaSuministro && vm.familiaSuministro.id) vm.familiaSuministro=null;
        if (vm.grupo && vm.grupo.id) vm.grupo=null;
      }
    }

    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.dismiss();
    }

    function cantidadStockTipo(){
      var cantidad = 0;
      if (vm.listaNoInventariables && vm.listaNoInventariables.length>0){
        vm.listaNoInventariables.forEach(function(suministro){
          cantidad += suministro.cantidad;
        });
      }
      return cantidad? cantidad : "0";
    }

    function cantidadStockBienes(){
      var cantidad = 0;
      if (vm.bienes && vm.bienes.length>0){
        vm.bienes.forEach(function(bien){
          cantidad += bien.suministro.cantidad;
        });
      }
      return cantidad? cantidad : "0";
    }

    function armarListaNoInventariable(data){
      var lista = [];
      data.forEach(function(item){
        item.suministro.fecha = item.fecha;
        item.suministro.cantidadOriginal = item.cantidad;
        lista.push(item.suministro);
      });
      vm.listaNoInventariables = lista;
    }

    $scope.$watch('vm.grupo.nombre', function(){
      if (vm.familiaSuministro) vm.familiaSuministro=null;
      if (!vm.grupo) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupo.id}, function(data){
        vm.familias = orderByFilter(data, "nombre", false);
        focus('familia');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.familiaSuministro.nombre', function(){
      if (vm.tipoSuministro) vm.tipoSuministro=null;
      if (!vm.familiaSuministro) return;
      ServicioDialogos.abrirDialogoCargando();
      TipoSuministroFamilia.query({id:vm.familiaSuministro.id}, function(data){
        vm.tipos = orderByFilter(data, "nombre", false);
        focus('tipo');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.tipoSuministro.nombre', function(){
      if (!vm.tipoSuministro) return;
      if (vm.tipoSuministro.inventariable===false) {
        buscarNoInventariables();
      } else {
        buscarInventariables();
      }
    });

    $scope.$watch('vm.tipoSuministroCompleto.nombre', function(){
      vm.tipoSuministro=vm.tipoSuministroCompleto;
      //if (!vm.tipoSuministroCompleto || vm.tipoSuministroCompleto.inventariable===false) return;
    });

    $scope.$watch('vm.radio', function(){
      if (vm.radio=='directa') {
        ServicioDialogos.abrirDialogoCargando();
        TiposPorEmpresa.query({idEmpresa:vm.empresaId}, function(data){
          vm.tiposCompletos = orderByFilter(data,'nombre',false);
          ServicioDialogos.cerrarDialogoCargando();
        }, function(err){
          console.log(err);
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError();
        });

      }
    });

    function buscarInventariables(){
      ServicioDialogos.abrirDialogoCargando();
      SuministroInventariableTipoEstadoDepositoCaja.query({idTipo:vm.tipoSuministro.id, idEstado:2, idDeposito:vm.idDeposito, caja:false}, function(data){
        SuministroInventariableContarStockTipoEstado.query({idTipo:vm.tipoSuministro.id, idEstado:2}, function(datos){
          vm.cantidadTotalStockTipo = datos[0];
          vm.bienes = orderByFilter(data, 'inventario', false);
          focus('bien');
          ServicioDialogos.cerrarDialogoCargando();
        }, function(err){
          console.log(err);
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError();
        });
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    }


    function buscarNoInventariables(){
      ServicioDialogos.abrirDialogoCargando();
      SuministroPor2TipoMovimientoEstadoSuministroTipoSuministroDepositoPorDetalle.query({idTipoMovimiento1:2, idTipoMovimiento2:5, idTipoSuministro:vm.tipoSuministro.id, idEstadoSuministro:2, idDeposito:vm.idDeposito}).$promise.then(function(data){

      //SuministroTipoEstadoDepositoPorDetalle.query({idTipoMovimiento:2, idTipo:vm.tipoSuministro.id, idEstado:2, idDeposito:vm.idDeposito}, function(data){
        SuministroContarStockTipoEstado.query({idTipo:vm.tipoSuministro.id, idEstado:2}, function(datos){
          armarListaNoInventariable(data);
          vm.cantidadTotalStockTipo = datos[0];
          ServicioDialogos.cerrarDialogoCargando();
        }, function(err){
          console.log(err);
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError();
        });
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    }

    function agregar(){
      var lista = [];
      if (vm.tipoSuministro && !vm.tipoSuministro.inventariable){
        lista = vm.listaNoInventariables;
      } else {
        lista = vm.bienes;
      }
      $uibModalInstance.close({tipoSuministro:vm.tipoSuministro, suministros:lista});
    }

   
  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoAgregarSuministroEgresoKit',DialogoAgregarSuministroEgresoKit);

  function DialogoAgregarSuministroEgresoKit($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/seleccionar-suministro-egreso-kit/seleccionar-suministro-egreso-kit.html',
        controller: 'ModalAgregarSuministroEgresoKitCtrl as vm',
        resolve: {
          sucursal: function(){
            return config.sucursal;
          },
          kits: function(KitSucursal){
            return KitSucursal.query({idSucursal:config.sucursal.id}).$promise.then(function(data){
              return data;
            });
          },
          detalles: function(){
            return config.detalles;
          },
          deposito: function(){
            return config.deposito;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalAgregarSuministroEgresoKitCtrl', ModalAgregarSuministroEgresoKitCtrl);

  /** @ngInject */
  function ModalAgregarSuministroEgresoKitCtrl(NgTableParams, $q, $filter, deposito, sucursal, kits, detalles, SuministroPor2TipoMovimientoEstadoSuministroTipoSuministroDepositoPorDetalle , $uibModalInstance, HeaderBarService, ServicioModales, focus, orderByFilter, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    vm.kits = kits;
    vm.sucursal = sucursal;
    vm.detalles = detalles;
    vm.deposito = deposito;

    vm.cerrar = cerrar;

    vm.cambiarKit = cambiarKit;
    vm.seleccionarKit = seleccionarKit;
    vm.visualizarKit = visualizarKit;
    vm.mostrarSuministrosAsignados = mostrarSuministrosAsignados;
    vm.asignarSuministros = asignarSuministros;
    vm.comprobarAgregar = comprobarAgregar;
    vm.asignarSuministrosAutomaticamente = asignarSuministrosAutomaticamente;
    vm.bandera=false;
    vm.detallesKit=[];

    inicializar();

    ServicioDialogos.cerrarDialogoCargando();

    function contarAsignados(){
      var cont = 0;
      vm.detallesKit.forEach(function(item){
        if (item.suministrosAsignados && item.suministrosAsignados.length>0){
          cont += 1;
        }
      });
      return cont;
    }

    function comprobarAsignados(libresAntes){
      var asignados = contarAsignados();
      var libresAhora = vm.detallesKit.length-asignados;
      if (libresAhora==0){
        ServicioDialogos.mostrarDialogoInformacion(null, "Se asignaron todos los suministros");
      } else if (libresAhora>0 && libresAhora!=libresAntes){
        ServicioDialogos.mostrarDialogoAtencion(null, "Se asignó al menos un suministro");
      } else if (libresAhora>0 && libresAhora==libresAntes){
        ServicioDialogos.mostrarDialogoAtencion(null, "No se asignó ningún suministro");
      }

    }

    function asignarSuministrosAutomaticamente(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea asignar los suministros automáticamente?", function(){
        var asignadosAntes = contarAsignados();
        var libres = vm.detallesKit.length-asignadosAntes;
        asignarAutomaticamente()
          .then(function(){
            actualizarTabla();
            comprobarAsignados(libres);
          });
      }, null, false);
    }

    function asignarAutomaticamente(){
      var defer = $q.defer();
      var promise = defer.promise;
      vm.detallesKit.forEach(function(det) {
        if (det.cantidad!=0 && det.cantidadSolicitada==0){
          promise = promise.then(function(){
            return buscarSuministrosTipo(det.tipoSuministro).then(function(detalle){
              asignarCantidades(det, detalle);
              defer.resolve(true);
            });
          });
        }
      });
      defer.resolve(true);
      return promise;
    }

    function comprobarSuministros(cantidad, detalles){
      if (detalles.length==0) return false;
      var cant = 0;
      detalles.forEach(function(sum){
        cant += sum.suministro.cantidad;
      });
      return cant>=cantidad;
    }

    function asignarCantidades(detalle, detalles){
      if (comprobarSuministros(detalle.cantidad, detalles)){
        var fecha = new Date();
        var suministrosAsignados = [];
        var cantidadNecesaria = detalle.cantidad;
        var cantidadUsada = 0;
        detalles.forEach(function(det){
          if (det.suministro.cantidad==0) return;
          if (cantidadNecesaria!=cantidadUsada){
            if (cantidadNecesaria-cantidadUsada-det.suministro.cantidad>0){
              suministrosAsignados.push({
                suministro: det.suministro,
                cantidad: det.suministro.cantidad,
                fecha: fecha
              });
              cantidadUsada += det.suministro.cantidad;
            } else if (cantidadNecesaria-cantidadUsada-det.suministro.cantidad<=0){
              suministrosAsignados.push({
                suministro: det.suministro,
                cantidad: cantidadNecesaria-cantidadUsada,
                fecha: fecha
              });
              cantidadUsada += cantidadNecesaria-cantidadUsada;
            }
          }
        });
        asignarSuministroTipo(detalle, suministrosAsignados);
      }
    }

    function buscarSuministrosTipo(tipo){
      return SuministroPor2TipoMovimientoEstadoSuministroTipoSuministroDepositoPorDetalle.query({idTipoMovimiento1:2, idTipoMovimiento2:5, idTipoSuministro:tipo.id, idEstadoSuministro:2, idDeposito:deposito.id}).$promise.then(function(data){
        data = $filter('orderBy')(data, [ordenarPorYaEmpezado, ordenarPorNavePorDefecto,"suministro.fechaVencimiento", "fecha","suministro.ubicacion.nivel.numeroNivel", "suministro.cantidad"], false);
        return data;
      });
    }

    function ordenarPorYaEmpezado(d){
      if (d.cantidad){
        return d.cantidad==d.suministro.cantidad? 1 : 0;
      }
    }

    function ordenarPorNavePorDefecto(a){
      if (deposito.idNaveBusqueda){
        return a.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.id==deposito.idNaveBusqueda? 0 : 1;
      }
    }

    function asignarSuministros(tipo){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalAgregarQuitarSuministroKit({
        onResult: function(resultado) {
          asignarSuministroTipo(tipo, resultado.suministrosAsignados);
        },
        deposito:vm.deposito,
        sucursal:vm.sucursal,
        tipo: tipo.tipoSuministro,
        suministrosAsignados: tipo.suministrosAsignados? tipo.suministrosAsignados : [],
        cantidadKit: tipo.cantidad
      });
    }

    function asignarSuministroTipo(tipo, suministros){
      var sum = 0;
      suministros.forEach(function(item){
        sum += item.cantidad;
      });
      tipo.cantidadSolicitada=sum;
      tipo.suministrosAsignados=suministros;
    }

    function mostrarSuministrosAsignados(tipo){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalVisualizarSuministroAsignado({
        onResult: function(resultado) {
          console.log(resultado);
        },
        sucursal: vm.sucursal,
        detalles: tipo.suministrosAsignados,
        tipoSuministro: false,
        tipo : tipo.tipoSuministro,
      });
    }

    function visualizarKit(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalVisualizarKitPrearmado({
        onResult: function(resultado) {
          console.log(resultado);
        },
        kit: vm.kit
      });
    }

    function cambiarKit(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "Si cambia de kit, perderá todo lo que haya agregado.\n¿Está seguro que desea cambiar la selección?", function(){
        vm.kit = null;
        vm.detallesKit = [];
        vm.bandera=false;
        actualizarTabla();
        focus('kit');
      });
    }

    function seleccionarKit(){
      vm.bandera=true;
      vm.detallesKit = angular.copy($filter('orderBy')(vm.kit.detalles, ["tipoSuministro.familiaSuministro.grupoSuministro.nombre","tipoSuministro.familiaSuministro.nombre","tipoSuministro.nombre"], false));
      recorrerTipos();
      actualizarTabla();
    }
    function recorrerTipos(){
      var ban = false;
      var cantidadSolicitada = 0;
      vm.detallesKit.forEach(function(item){
        ban = false;
        cantidadSolicitada= 0;
        vm.detalles.forEach(function(detalle){
          if (detalle.suministro.tipoSuministro.id==item.tipoSuministro.id){
            ban = true;
            cantidadSolicitada += detalle.cantidad;
          }
        });
        item.ocupado = ban;
        item.cantidadSolicitada = cantidadSolicitada;
      });
    }

    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      HeaderBarService.setSubTitulo($stateParams.subtitulo);
    }

    function comprobarAgregar(){
      var sum = 0;
      vm.detallesKit.forEach(function(item){
        if (item.cantidadSolicitada){
          sum += item.cantidadSolicitada;
        }
      });
      if (sum>0){
        armarDetalles();
      } else {
        ServicioDialogos.mostrarDialogoError(null, "No ha asignado suministros nuevos");
      }
    }

    function armarDetalles(){
      vm.detallesKit.forEach(function(item){
        if (item.suministrosAsignados && item.suministrosAsignados.length>0){
          item.suministrosAsignados.forEach(function(detalle){
            vm.detalles.push(detalle);
          });
        }
      });
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.close({
        detalles: vm.detalles,
      });

    }

    function inicializar(){
      setearTitulos();
      crearTabla();
    }
     
    function crearTabla(){
      vm.tableParams = new NgTableParams({
        page: 1,
        count: 10
      });
    }

    function actualizarTabla(){
      vm.tableParams.settings({
        data: $filter('orderBy')(vm.detallesKit, ["tipoSuministro.familiaSuministro.grupoSuministro.nombre","tipoSuministro.familiaSuministro.nombre","tipoSuministro.nombre"], false) 
      });
      vm.tableParams.reload();
    }


  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro')
  .service('DialogoSeleccionarFoto',DialogoSeleccionarFoto);

  function DialogoSeleccionarFoto($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        templateUrl: 'app/components/modales/seleccion-foto/seleccion-foto.html',
        controller: 'ModalSeleccionarFotoCtrl as vm',
        size: 'lg',
        resolve: {
          tipoSuministro: function() {
            return config.tipoSuministro;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }

  }

})();

(function() {
'use strict';
angular.module('proyecto-az-suministro')
  .factory('ImagenTipoSuministro', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/tiposuministro/:id/foto",{id:'@id'});
  });
})();
(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalSeleccionarFotoCtrl', ModalSeleccionarFotoCtrl);

 /** @ngInject */
  function ModalSeleccionarFotoCtrl($scope, $uibModalInstance, ServicioDialogos, ImagenTipoSuministro) {

  var vm = this;

  vm.si = si;
  vm.no = no;
  vm.verImagenRecortada = verImagenRecortada;

  function verImagenRecortada(){
    //console.log(vm.imagenRecortada);
  }

  function si() {
    var encabezado = vm.imagenRecortada.slice(0,vm.imagenRecortada.search(",")+1);
    var cuerpo = vm.imagenRecortada.slice(vm.imagenRecortada.search(",")+1);
    ServicioDialogos.mostrarDialogoConfirmacionInfo("Atención", "Hasta que no oprima el botón GUARDAR, la fotografía no se guardará ni actualizará", function(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }      $uibModalInstance.close({'encabezadoFoto':encabezado, 'cuerpoFoto':cuerpo});
    }, null, true, "Entendido", "Cancelar");
  }

  function no() {
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
  }

vm.imagenRecortada='';
vm.imagenCargada='';

  $scope.cargarFoto = function(file) {
    if (file && file.size>1038954 ) {
      document.getElementById('fileInput').value=null;
      ServicioDialogos.mostrarDialogoError(null, "La imagen no puede superar 1 MB de tamaño");
      file = null;
      return;
    } else {
      var formato = file.type.slice(0,file.type.search("/"));
      if (formato=='image') {
        vm.bandera = true;
        // ng-img-crop
        var imageReader = new FileReader();
        imageReader.onload = function(image) {
            $scope.$apply(function() {
                vm.imagenCargada = image.target.result;
            });
        };
        imageReader.readAsDataURL(file);
      } else {
        ServicioDialogos.mostrarDialogoError(null, "Debe subir una imagen JPEG o PNG");
        file=null;
        document.getElementById('fileInput').value=null;
      }
    }
  };

  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoGenerarRotulosChicos',DialogoGenerarRotulosChicos);

  function DialogoGenerarRotulosChicos($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/reporte-rotulos-chicos/reporte-rotulos-chicos.html',
        controller: 'ModalGenerarRotulosChicosCtrl as vm',
        resolve: {
          movimiento: function(Ingreso){
            if (config.id){
              return Ingreso.get({id:config.id}).$promise.then(function(data) {
                return data;
              });
            } else {
              return {};
            }
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalGenerarRotulosChicosCtrl', ModalGenerarRotulosChicosCtrl);

  /** @ngInject */
  function ModalGenerarRotulosChicosCtrl(NgTableParams, $filter, $http, URL_SERVIDOR, movimiento, $uibModalInstance, ServicioDialogos) {

    var vm = this;
    vm.cerrar = cerrar;
    vm.movimiento = movimiento;
    vm.generarRotulos = generarRotulos;
    vm.habilitarBoton = habilitarBoton;

    inicializar();

    function inicializar(){
      crearTablas();
      generarDetalles();
      ServicioDialogos.cerrarDialogoCargando();
    }

    function generarDetalles(){
      vm.detalles = [];
      var ban;
      vm.movimiento.detalles.forEach(function(item){
        ban = false;
        vm.detalles.forEach(function(detalle){
          if (item.suministro.tipoSuministro.id==detalle.suministro.tipoSuministro.id && detalle.suministro.marca==item.suministro.marca){
            ban = true;
          }
        });
        if (!ban) {
          vm.detalles.push(item);
        }
      });
      actualizarTabla();
    }

    function habilitarBoton(){
      var cant = 0;
      var cantOk = 0;
      if (vm.detalles && vm.detalles.length>0){
        vm.detalles.forEach(function(item){
          if (item.seleccionado){
            cant+=1;
            if ((!item.suministro.tipoSuministro.inventariable && item.cantidadRotulos && item.cantidadRotulos>0) || item.suministro.tipoSuministro.inventariable) {
              cantOk+=1;
            }
          }
        });
        return cant > 0 && cantOk==cant;
      }
      return false;
    }

    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
    }

    function obtenerDetallesDTO(){
      var detalles = [];
      var serie;
      var inventario;
      vm.detalles.forEach(function(item){
        if (item.seleccionado){
          if (item.suministro.tipoSuministro.inventariable) item.cantidadRotulos = 1;
          for (var i = item.cantidadRotulos - 1; i >= 0; i--) {
            serie = item.suministro.tipoSuministro.inventariable? item.suministroInventariable.serie:null;
            inventario = item.suministro.tipoSuministro.inventariable? item.suministroInventariable.inventario:null;
            detalles.push({
              'marca': item.suministro.marca,
              'tipo': item.suministro.tipoSuministro,
              'empresa': vm.movimiento.empresa,
              'numeroMovimiento': vm.movimiento.numeroMovimiento,
              'serie': serie,
              'inventario': inventario
            });
          }
        }
      });
      return detalles;
    }

    function generarRotulos() {
      ServicioDialogos.abrirDialogoCargando();
      $http.post(URL_SERVIDOR+"/reportes/rotulosChicos", obtenerDetallesDTO(), {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function actualizarTabla(){
      vm.tableParams.settings({
        data: $filter('orderBy')(vm.detalles,['suministro.tipoSuministro.inventariable','suministro.tipoSuministro.nombre'],false),
        noPager: true,
        counts: []
      });
      vm.tableParams.reload();
    }

    function crearTablas(){
      vm.tableParams = new NgTableParams({
        page: 1,
        count: 500
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
  .service('DialogoRechazarPedido',DialogoRechazarPedido);

  function DialogoRechazarPedido($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/rechazar-pedido/rechazar-pedido.html',
        controller: 'ModalRechazarPedidoCtrl as vm',
        resolve: {
          pedido: function(Pedido){
            return Pedido.get({id:config.pedido.id}).$promise.then(function(data){
              return data;
            });
          },
          usuario: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario;
            });
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalRechazarPedidoCtrl', ModalRechazarPedidoCtrl);

  /** @ngInject */
  function ModalRechazarPedidoCtrl(NgTableParams, Pedido, RechazarPedido, usuario, pedido, $filter, orderByFilter, ServicioModales, ServicioDialogos, $uibModalInstance, $stateParams, $scope) {

    var vm = this;
    vm.pedido = pedido;
    vm.cerrar = cerrar;
    vm.rechazar = rechazar;


    inicializar();
    ServicioDialogos.cerrarDialogoCargando();

    function rechazar(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea rechazar el pedido?', function() {
        rechazarPedido();
      }, null, false);
    }

    function rechazarPedido(){
      Pedido.get({id:pedido.id}, function(p){
        if (p.estado.id==1){
          pedido.motivoRechazoAnulacion = vm.motivo;
          pedido.usuarioRechazo = usuario;
          pedido.fechaRechazo = new Date();
          RechazarPedido.update(pedido).$promise.then(function(data){
            ServicioDialogos.mostrarDialogoGuardadoExito(
              null,
              "Se ha rechazado con éxito el pedido",
              function(){
                if ($('.modal.in').length<=1){
                  $('.modal-backdrop').remove();
                }
                $uibModalInstance.close({
                  pedido: data
                });
              });
          }, function(err){
            console.log(err);
            ServicioDialogos.mostrarDialogoError(null, "No fue posible rechazar el pedido");
          });
        } else {
          ServicioDialogos.mostrarDialogoError(null, "El pedido no puede ser rechazado ya que ha sido anulado.");
        }
      });
    }


    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
    }

    function inicializar(){
      vm.fecha=$filter('date')(vm.pedido.fecha, 'dd/MM/yyyy HH:mm');
      vm.solicitante = vm.pedido.usuario.solicitante.apellido.toUpperCase()+", "+vm.pedido.usuario.solicitante.nombre.toUpperCase();
      vm.estado = vm.pedido.estadoMovimiento? vm.pedido.estado.nombre +" - "+vm.pedido.estadoMovimiento : vm.pedido.estado.nombre;
      crearTablas();
      actualizarTabla();
    }

    function actualizarTabla(){
      vm.tableParams.settings({
        data: orderByFilter(vm.pedido.detalles,['tipoSuministro.nombre'],false),
        noPager: true,
        counts: []
      });
      vm.tableParams.reload();
    }

    function crearTablas(){
      vm.tableParams = new NgTableParams({
        page: 1,
        count: 500
      });
    }
  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoOcuparUbicacionesCajas',DialogoOcuparUbicacionesCajas);

  function DialogoOcuparUbicacionesCajas($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/ocupar-ubicaciones-cajas/ocupar-ubicaciones-cajas.html',
        controller: 'ModalOcuparUbicacionesCajasCtrl as vm',
        resolve: {
          asignadas: function(){
            return config.asignadas;
          },
          palletsInventariables: function(){
            return config.palletsInventariables;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalOcuparUbicacionesCajasCtrl', ModalOcuparUbicacionesCajasCtrl);

  /** @ngInject */
  function ModalOcuparUbicacionesCajasCtrl(NgTableParams, asignadas, palletsInventariables, $uibModalInstance, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.asignadas = asignadas;
    vm.palletsInventariables = palletsInventariables;
    vm.guardar = guardar;
    vm.cerrar = cerrar;
    inicializar();

    function inicializar(){
      vm.ubicaciones = [];
      vm.asignadas.forEach(function(asignada){
        asignada.ubicacion.ocupar=false;
        vm.ubicaciones.push(asignada.ubicacion);
      });
    }

    function guardar(){
      vm.ubicaciones.forEach(function(ubicacion){
        vm.palletsInventariables.forEach(function(detalle){
          if (detalle.ubicacion.id==ubicacion.id){
            detalle.ocupar=ubicacion.ocupar;
          }
        });
      });
      ServicioDialogos.abrirDialogoCargando();
      $('.modal-backdrop').remove();
      $uibModalInstance.close({pallets:vm.palletsInventariables});
    }

    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.dismiss();
    }

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 50

    });
    vm.tableParams.settings({
      data: vm.ubicaciones,
      noPager: true,
      counts: []
    });
    vm.tableParams.reload();


  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoMostrarSuministroUbicaciones',DialogoMostrarSuministroUbicaciones);

  function DialogoMostrarSuministroUbicaciones($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/mostrar-suministro-ubicaciones/modal-mostrar-suministro-ubicaciones.html',
        controller: 'ModalMostrarSuministrosUbicaciones as vm',
        resolve: {
          ubicacion: function(){
            return config.ubicacion;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalMostrarSuministrosUbicaciones', ModalMostrarSuministrosUbicaciones);

  /** @ngInject */
  function ModalMostrarSuministrosUbicaciones(NgTableParams, ubicacion, $filter, $q, $uibModalInstance,InventariableSuministroId, $stateParams, $window, $scope, orderByFilter, $state, ServicioModales, ServicioDialogos) {

    var vm = this;
    ServicioDialogos.cerrarDialogoCargando();
    vm.ubicacion = ubicacion;
    vm.cerrar = cerrar;
    vm.irACambiarUbicacionSuministro = irACambiarUbicacionSuministro;
    vm.reasignarUbicacionVarios = reasignarUbicacionVarios;
    vm.editarSuministro = editarSuministro;
    vm.mostrarInformacion = mostrarInformacion;
    inicializar();

    function inicializar(){
      ServicioDialogos.abrirDialogoCargando();
      buscarSuministros().then(function(){
        cargarTabla();
        setTimeout(function() {
          ServicioDialogos.cerrarDialogoCargando();
        }, 1000);
      });
    }

    function cargarTabla(){
      vm.tableParams.settings({
        data: orderByFilter(vm.suministros, 'tipoSuministro.nombre', false),
        noPager: true,
        counts: []
      });
      vm.tableParams.reload();
    }

    function formatearInventariable(inv){
      var suministro = inv.suministro;
      suministro.serie = inv.serie;
      suministro.inventario = inv.inventario;
      suministro.nuevo = inv.nuevo;
      suministro.caja = inv.caja;
      suministro.inventariable = true;
      suministro.idInventariable = inv.id;
      return suministro;
    }

    function buscarSuministros(){
      vm.suministros = [];
      var defer = $q.defer();
      var promise = defer.promise;
      vm.ubicacion.suministros.forEach(function(suministro){
        if (suministro.tipoSuministro.inventariable){
          promise = promise.then(function(){
            return InventariableSuministroId.query({idSuministro:suministro.id}).$promise.then(function(data) {
              vm.suministros.push(formatearInventariable(data[0]));
              defer.resolve(true);
            });
          });
        } else {
          vm.suministros.push(suministro);
          defer.resolve(true);
        }
      });
      defer.resolve(true);
      return promise;
    }


    function abrirModal(sum, inv){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalCambiarUbicacionSuministro({
        onResult: function(resultado){
          $window.location.reload();
        },
        inventariable: inv,
        suministro: sum
      });
    }

    function reasignarUbicacionVarios(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalCambiarUbicacionVariosSuministros({
        onResult: function(resultado){
          $window.location.reload();
        },
        suministros: vm.suministros,
        ubicacion: ubicacion
      });
    }

    function irACambiarUbicacionSuministro(suministro){
      if (suministro.idInventariable){
        if (suministro.caja){
          ServicioDialogos.mostrarDialogoInformacion(null, "El suministro elegido, pertenece a una caja cerrada.\nPara mover una caja cerrada entera, vaya al módulo destinado a tal fin");
        } else {
          abrirModal(suministro.idInventariable, true);
          //$state.go("home.cambiar-ubicacion-suministro",{suministro:suministro.id, inventariable:true});
        }
      } else {
        abrirModal(suministro.id, false);
        //$state.go("home.cambiar-ubicacion-suministro", {suministro:suministro.suministro.id, inventariable:false});
      }
    }

    function actualizarInventariableEditado(inv){
      vm.suministros.forEach(function(suministro){
        if (inv.suministro.id==suministro.id){
          suministro.serie = inv.serie;
          suministro.inventario = inv.inventario;
          suministro.nuevo = inv.nuevo;
          suministro.caja = inv.caja;
          suministro.inventariable = true;
          suministro.marca = inv.suministro.marca;
          suministro.tipoSuministro = inv.suministro.tipoSuministro;
        }
      });
      cargarTabla();
    }

    function actualizarNoInventariableEditado(sum){
      vm.suministros.forEach(function(suministro){
        if (suministro.id==sum.id){
          suministro.marca = sum.marca;
          suministro.tipoSuministro = sum.tipoSuministro;
        }
      });
      cargarTabla();
    }

    function mostrarInformacionInventariable(bien){
      var marca = bien.marca? bien.marca.toUpperCase() : "-";
      var inventario = bien.inventario? bien.inventario : "-";
      var serie = bien.serie? bien.serie.toUpperCase() : "-";
      var nuevo = bien.nuevo? "SI" : "NO";
      var activo = bien.estadoSuministro.id == 2? "SI" : "NO";
      var precio = bien.precioUnitario ? bien.precioUnitario : "-";
      ServicioDialogos.mostrarDialogoInformacion(
        "Información del suministro",
        "Empresa: "+bien.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase()+
        "\nGrupo suministro: "+bien.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+
        "\nFamilia de suministro: "+bien.tipoSuministro.familiaSuministro.nombre.toUpperCase()+
        "\nTipo de suministro: "+bien.tipoSuministro.nombre.toUpperCase()+
        "\nMarca: "+marca+
        "\nN° Inventario: "+inventario+
        "\nN° Serie: "+serie+
        "\nPrecio: $"+precio+
        "\n¿Nuevo?: "+nuevo
      );
    }

    function mostrarInformacionNoInventariable(bien){
      var marca = bien.marca? bien.marca.toUpperCase() : "-";
      var precio = bien.precioUnitario ? bien.precioUnitario : "-";
      var fecha = bien.fechaVencimiento? $filter('date')(bien.fechaVencimiento, "dd/MM/yyyy") : "-";
      ServicioDialogos.mostrarDialogoInformacion(
        "Información del suministro",
        "Empresa: "+bien.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase()+
        "\nGrupo suministro: "+bien.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+
        "\nFamilia de suministro: "+bien.tipoSuministro.familiaSuministro.nombre.toUpperCase()+
        "\nTipo de suministro: "+bien.tipoSuministro.nombre.toUpperCase()+
        "\nMarca: "+marca+
        "\nFecha vencimiento: "+fecha+
        "\nPrecio unitario: $"+precio+
        "\nCantidad: "+bien.cantidad

      );
    }

    function mostrarInformacion(bien){
      if (bien.inventariable){
        mostrarInformacionInventariable(bien);
      } else {
        mostrarInformacionNoInventariable(bien);
      }

    }

    function abrirEditarSuministroInventariable(suministro){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Está seguro que desea editar la información del suministro?", function(){
        InventariableSuministroId.query({idSuministro:suministro.id}, function(data){
          ServicioDialogos.abrirDialogoCargando();
          ServicioModales.abrirModalEditarSuministro({
            onResult: function(resultado){
              actualizarInventariableEditado(resultado.suministroEditado);
            },
            suministro:data[0],
            modo:'editar'
          });
        }, function(err){
          console.log(err);
          ServicioDialogos.mostrarDialogoError();
        });
      });
    }

    function abrirEditarSuministroNoInventariable(suministro){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Está seguro que desea editar la información del suministro?", function(){
        ServicioDialogos.abrirDialogoCargando();
        ServicioModales.abrirModalEditarSuministroNoInventariable({
          onResult: function(resultado){
            actualizarNoInventariableEditado(resultado.suministroEditado);
          },
          suministro:suministro,
          modo:'editar'
        });
      });
    }

    function editarSuministro(suministro){
      if (suministro.inventariable){
        abrirEditarSuministroInventariable(suministro);
      } else {
        abrirEditarSuministroNoInventariable(suministro);
      }
    }


    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.dismiss();
    }

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 20

    });



  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoRespuestaTopesExcel',DialogoRespuestaTopesExcel);

  function DialogoRespuestaTopesExcel($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/mostrar-respuesta-topes-excel/mostrar-respuesta-topes-excel.html',
        controller: 'ModalRespuestaTopesExcelCtrl as vm',
        resolve: {
          existentes: function(){
            return config.existentes;
          },
          nuevos: function(){
            return config.nuevos;
          },
          correctos: function(){
            return config.correctos;
          },
          erroneos: function(){
            return config.erroneos;
          },
          incompletos: function(){
            return config.incompletos;
          },
          nombreDocumento: function(){
            return config.nombreDocumento;
          },
          formatoIncorrecto: function(){
            return config.formatoIncorrecto;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalRespuestaTopesExcelCtrl', ModalRespuestaTopesExcelCtrl);

  /** @ngInject */
  function ModalRespuestaTopesExcelCtrl(NgTableParams, formatoIncorrecto, nombreDocumento, incompletos, erroneos, nuevos, correctos, existentes, $uibModalInstance, $stateParams, $scope, orderByFilter, $state, ServicioDialogos, ServicioModales) {

    var vm = this;
    vm.cerrar = cerrar;
    vm.incompletos = incompletos;
    vm.correctos = correctos;
    vm.erroneos = erroneos;
    vm.existentes = existentes;
    vm.nuevos = nuevos;
    vm.nombreDocumento = nombreDocumento;
    vm.formatoIncorrecto = formatoIncorrecto;

    inicializar();
    ServicioDialogos.cerrarDialogoCargando();

    function inicializar(){
      if (!vm.formatoIncorrecto){
        crearTablas();
        actualizarTablas();
      }
    }

    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.close({});
    }

    function crearTablas(){
      vm.tableParamsNuevos = new NgTableParams({
        page: 1,
        count: 10
      });
      vm.tableParamsExistentes = new NgTableParams({
        page: 1,
        count: 10
      });
      vm.tableParamsIncompletos = new NgTableParams({
        page: 1,
        count: 10
      });
      vm.tableParamsErroneos = new NgTableParams({
        page: 1,
        noPager: true,
        count: 10
      });
    }

    function actualizarTablas(){
      vm.tableParamsNuevos.settings({
        data: vm.nuevos,
        noPager: true,
        count: []
      });
      vm.tableParamsNuevos.reload();
      vm.tableParamsExistentes.settings({
        data: vm.existentes,
        noPager: true,
        count: []
      });
      vm.tableParamsExistentes.reload();
      vm.tableParamsErroneos.settings({
        data: vm.erroneos,
        noPager: true,
        count: []
      });
      vm.tableParamsErroneos.reload();
      vm.tableParamsIncompletos.settings({
        data: vm.incompletos,
        noPager: true,
        count: []
      });
      vm.tableParamsIncompletos.reload();
    }

  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoMostrarRespuestaInventariablesExcel',DialogoMostrarRespuestaInventariablesExcel);

  function DialogoMostrarRespuestaInventariablesExcel($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/mostrar-respuesta-inventariable-excel/mostrar-respuesta-inventariable-excel.html',
        controller: 'ModalRespuestaInventariablesExcel as vm',
        resolve: {
          existentes: function(){
            return config.existentes;
          },
          nuevos: function(){
            return config.nuevos;
          },
          correctos: function(){
            return config.correctos;
          },
          erroneos: function(){
            return config.erroneos;
          },
          incompletos: function(){
            return config.incompletos;
          },
          nombreDocumento: function(){
            return config.nombreDocumento;
          },
          formatoIncorrecto: function(){
            return config.formatoIncorrecto;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalRespuestaInventariablesExcel', ModalRespuestaInventariablesExcel);

  /** @ngInject */
  function ModalRespuestaInventariablesExcel(NgTableParams, formatoIncorrecto, nombreDocumento, incompletos, erroneos, nuevos, correctos, existentes, $uibModalInstance, $stateParams, $scope, orderByFilter, $state, ServicioDialogos, ServicioModales) {

    var vm = this;
    vm.cerrar = cerrar;
    vm.incompletos = incompletos;
    vm.correctos = correctos;
    vm.erroneos = erroneos;
    vm.existentes = existentes;
    vm.nuevos = nuevos;
    vm.nombreDocumento = nombreDocumento;
    vm.formatoIncorrecto = formatoIncorrecto;

    vm.validarInventarioExcel = validarInventarioExcel;
    vm.validarPrecioExcel = validarPrecioExcel;

    vm.util = Number;

    inicializar();
    ServicioDialogos.cerrarDialogoCargando();

    function inicializar(){
      if (!vm.formatoIncorrecto){
        crearTablas();
        actualizarTablas();
      }
    }

    function validarInventarioExcel(inventario){
      return Number.isInteger(inventario);
    }

    function validarPrecioExcel(precio){
      return isNaN(precio) || (precio===null) || (typeof(precio)== "boolean");
    }


    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.close({});
    }

    function crearTablas(){
      vm.tableParamsNuevos = new NgTableParams({
        page: 1,
        count: 10
      });
      vm.tableParamsExistentes = new NgTableParams({
        page: 1,
        count: 10
      });
      vm.tableParamsIncompletos = new NgTableParams({
        page: 1,
        count: 10
      });
      vm.tableParamsErroneos = new NgTableParams({
        page: 1,
        count: 10
      });
    }

    function actualizarTablas(){
      vm.tableParamsNuevos.settings({
        data: vm.nuevos,
        noPager: true
      });
      vm.tableParamsNuevos.reload();
      vm.tableParamsExistentes.settings({
        data: vm.existentes,
        noPager: true,
      });
      vm.tableParamsExistentes.reload();
      vm.tableParamsErroneos.settings({
        data: vm.erroneos,
        noPager: true,
      });
      vm.tableParamsErroneos.reload();
      vm.tableParamsIncompletos.settings({
        data: vm.incompletos,
        noPager: true,
      });
      vm.tableParamsIncompletos.reload();
    }

  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoMostrarRespuestaSuministroIngresoExcel',DialogoMostrarRespuestaSuministroIngresoExcel);

  function DialogoMostrarRespuestaSuministroIngresoExcel($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/mostrar-respuesta-ingreso-suministro-excel/mostrar-respuesta-ingreso-suministro-excel.html',
        controller: 'ModalMostrarRespuestaSuministroIngresoExcel as vm',
        resolve: {
          correctos: function(){
            return config.correctos;
          },
          erroneos: function(){
            return config.erroneos;
          },
          incompletos: function(){
            return config.incompletos;
          },
          completos: function(){
            return config.completos;
          },
          repetidos: function(){
            return config.repetidos;
          },
          tipoSuministro: function(){
            return config.tipoSuministro;
          },
          nombreDocumento: function(){
            return config.nombreDocumento;
          },
          formatoIncorrecto: function(){
            return config.formatoIncorrecto;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalMostrarRespuestaSuministroIngresoExcel', ModalMostrarRespuestaSuministroIngresoExcel);

  /** @ngInject */
  function ModalMostrarRespuestaSuministroIngresoExcel(NgTableParams, formatoIncorrecto, nombreDocumento, incompletos, completos, erroneos, correctos, repetidos, tipoSuministro, $uibModalInstance, $stateParams, $scope, orderByFilter, $state, ServicioDialogos, ServicioModales) {

    var vm = this;
    vm.cerrar = cerrar;
    vm.incompletos = incompletos;
    vm.correctos = correctos;
    vm.erroneos = erroneos;
    vm.repetidos = repetidos;
    vm.nombreDocumento = nombreDocumento;
    vm.formatoIncorrecto = formatoIncorrecto;
    vm.tipoSuministro = tipoSuministro;

    vm.validarInventarioExcel = validarInventarioExcel;
    vm.validarPrecioExcel = validarPrecioExcel;

    vm.util = Number;

    inicializar();
    ServicioDialogos.cerrarDialogoCargando();

    function inicializar(){
      if (!vm.formatoIncorrecto){
        crearTablas();
        actualizarTablas();
      }
    }

    function validarInventarioExcel(inventario){
      return Number.isInteger(inventario);
    }

    function validarPrecioExcel(precio){
      return isNaN(precio) || (precio===null) || (typeof(precio)== "boolean");
    }


    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.close({});
    }

    function crearTablas(){
      vm.tableParamsCorrectos = new NgTableParams({
        page: 1,
        count: 10
      });
      vm.tableParamsRepetidos = new NgTableParams({
        page: 1,
        count: 10
      });
      vm.tableParamsIncompletos = new NgTableParams({
        page: 1,
        count: 10
      });
      vm.tableParamsErroneos = new NgTableParams({
        page: 1,
        count: 10
      });
    }

    function actualizarTablas(){
      vm.tableParamsCorrectos.settings({
        data: vm.correctos,
        noPager: true,
      });
      vm.tableParamsCorrectos.reload();
      vm.tableParamsRepetidos.settings({
        data: vm.repetidos,
        noPager: true,
      });
      vm.tableParamsRepetidos.reload();
      vm.tableParamsErroneos.settings({
        data: vm.erroneos,
        noPager: true,
      });
      vm.tableParamsErroneos.reload();
      vm.tableParamsIncompletos.settings({
        data: vm.incompletos,
        noPager: true,
      });
      vm.tableParamsIncompletos.reload();
    }

  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoMostrarRespuestaEgresoGuardado',DialogoMostrarRespuestaEgresoGuardado);

  function DialogoMostrarRespuestaEgresoGuardado($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/mostrar-respuesta-egreso/mostrar-respuesta-egreso.html',
        controller: 'ModalMostrarRespuestaEgresoGuardadoCtrl as vm',
        resolve: {
          respuesta: function(){
            return config.respuesta;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalMostrarRespuestaEgresoGuardadoCtrl', ModalMostrarRespuestaEgresoGuardadoCtrl);

  /** @ngInject */
  function ModalMostrarRespuestaEgresoGuardadoCtrl(NgTableParams, $filter, URL_SERVIDOR, $http, respuesta, $q, $uibModalInstance, $stateParams, $scope, orderByFilter, $state, ServicioDialogos, ServicioModales) {

    var vm = this;
    vm.respuesta = respuesta;
    vm.cerrar = cerrar;
    vm.visualizarEgreso = visualizarEgreso;
    vm.egreso = vm.respuesta.egreso;
    vm.egresos = [];
    vm.ubicacionesModificadas = vm.respuesta.ubicacionesModificadas;
    vm.reporteEtiquetas = reporteEtiquetas;

    inicializar();
    ServicioDialogos.cerrarDialogoCargando();


    function inicializar(){
      vm.egresos.push(vm.egreso);
      crearTablas();
      actualizarTablas();
    }

    function visualizarEgreso(egreso){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalVisualizarDespacho({
        onResult: function(resultado) {
          egreso.nroGuia = resultado.egreso.nroGuia;
        },
        egreso: egreso,
      });
    }



    function reporteEtiquetas(){
      var lista = [];
      vm.egreso.movimientos.forEach(function(movimiento){
        for (var i = 0; i < movimiento.cantidadPaquetes; i++) {
          lista.push({
            bulto: "Bulto "+(i+1)+"/"+movimiento.cantidadPaquetes,
            sucursal: movimiento.sucursal,
            numeroMovimiento: movimiento.numeroMovimiento
          });
        }
      });
      if (lista.length>0){
        armarReporteEtiquetas(lista);
      } else {
        ServicioDialogos.mostrarDialogoError(null, "No hay cantidad de paquetes ingresados");
      }
    }

    function armarReporteEtiquetas(lista){
      var reporte = {
        detallesReporte: lista,
        deposito: vm.egreso.deposito.nombre.toUpperCase(),
        numeroEgreso: vm.egreso.numeroEgreso,
        empresaLogistica: vm.egreso.empresaLogistica.nombre.toUpperCase(),
        fecha: $filter('date')(vm.egreso.fecha, "dd/MM/yyyy HH:mm")
      };
      mostrarReporteEtiquetas(reporte);
    }

    function mostrarReporteEtiquetas(reporte){
      ServicioDialogos.abrirDialogoCargando();
      var Url = URL_SERVIDOR+"/reportes/paquetesA4";
      $http.post(Url, reporte,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.close({});
      if (vm.egreso.estadoEgreso.id==1){
        $state.go('home.lista-despachados', {deposito: vm.egreso.deposito.id});
      } else {
        $state.go('home.lista-despachados-donacion-scrap', {deposito: vm.egreso.deposito.id});
      }
    }

    function crearTablas(){
      vm.tableParamsUbicaciones = new NgTableParams({
        page: 1,
        count: 10
      });
      vm.tableParamsEgreso = new NgTableParams({
        page: 1,
        count: 20
      });
    }

    function actualizarTablas(){
      vm.tableParamsUbicaciones.settings({
        data: vm.ubicacionesModificadas,
        noPager: true,
        counts: []
      });
      vm.tableParamsUbicaciones.reload();

      vm.tableParamsEgreso.settings({
        data: vm.egresos,
        noPager: true,
        counts: []
      });
      vm.tableParamsEgreso.reload();
    }

  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoMostrarFotoSuministro',DialogoMostrarFotoSuministro);

  function DialogoMostrarFotoSuministro($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'md',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/mostrar-foto-suministro/mostrar-foto-suministro.html',
        controller: 'ModalMostrarFotoSuministro as vm',
        resolve: {
          tipoSuministro: function(TipoSuministro){
            return TipoSuministro.get({id:config.tipoSuministro.id}).$promise.then(function(data) {
              return data;
            });
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalMostrarFotoSuministro', ModalMostrarFotoSuministro);

  /** @ngInject */
  function ModalMostrarFotoSuministro(NgTableParams, tipoSuministro, ServicioDialogos, $uibModalInstance, $stateParams, $scope) {

    var vm = this;
    vm.tipoSuministro = tipoSuministro;
    vm.cerrar = cerrar;
    vm.foto = vm.tipoSuministro.encabezadoFoto+vm.tipoSuministro.cuerpoFoto;

    ServicioDialogos.cerrarDialogoCargando();

    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
    }
  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoFiltroNumeroMovimiento',DialogoFiltroNumeroMovimiento);

  function DialogoFiltroNumeroMovimiento($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'md',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/filtros-numero-movimiento/filtros-numero-movimiento.html',
        controller: 'ModalFiltroNumeroMovimientoCtrl as vm',
        resolve: {
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data) {
              return data;
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          tipo: function(){
            return config.tipo;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

'use strict';
angular.module('proyecto-az-suministro')
  .factory('MovimientosEmpresaDepositoTipoNumeroMovimiento', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?numeroMovimiento=:numeroMovimiento&&empresa.id=:idEmpresa&&deposito.id=:idDeposito&&tipo.id=:idTipo" ,{numeroMovimiento:'@numeroMovimiento', idEmpresa:'@idEmpresa',idDeposito:'@idDeposito', idTipo:'@idTipo'});
  });
(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalFiltroNumeroMovimientoCtrl', ModalFiltroNumeroMovimientoCtrl);

  /** @ngInject */
  function ModalFiltroNumeroMovimientoCtrl(NgTableParams, empresas, tipo, depositos, MovimientosEmpresaDepositoTipoNumeroMovimiento, focus, $uibModalInstance, $stateParams, $scope, $filter, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.empresas = orderByFilter(empresas, 'nombre', false);
    vm.depositos = orderByFilter(depositos, 'nombre', false);
    vm.filtrar = filtrar;
    vm.cerrar = cerrar;

    ServicioDialogos.cerrarDialogoCargando();

	function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
	}

    function filtrar(){
		ServicioDialogos.abrirDialogoCargando();
		MovimientosEmpresaDepositoTipoNumeroMovimiento.query({numeroMovimiento:vm.numeroMovimiento,idDeposito:vm.deposito.id, idEmpresa:vm.empresa.id, idTipo:tipo}, function(data){
			ServicioDialogos.cerrarDialogoCargando();
			if ($('.modal.in').length<=1){
				$('.modal-backdrop').remove();
			}
			$uibModalInstance.close({detalles:data, filtros:["Número movimiento: "+vm.numeroMovimiento, "Depósito: "+vm.deposito.nombre.toUpperCase(), "Empresa: "+vm.empresa.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
    }

  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoFiltroIngresoOrdenCompra',DialogoFiltroIngresoOrdenCompra);

  function DialogoFiltroIngresoOrdenCompra($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'md',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/filtros-ingreso-orden-compra/filtros-ingreso-orden-compra.html',
        controller: 'ModalFiltroIngresoOrdenCompraCtrl as vm',
        resolve: {
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data) {
              return data;
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

'use strict';
angular.module('proyecto-az-suministro')
  .factory('MovimientosEmpresaDepositoProveedorTipoNumeroOrdenCompra', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?numeroOrden=:numeroOrden&&empresa.id=:idEmpresa&&deposito.id=:idDeposito&&proveedor.id=:idProveedor&&tipo.id=:idTipo" ,{numeroOrden:'@numeroOrden', idEmpresa:'@idEmpresa',idDeposito:'@idDeposito',idProveedor:'@idProveedor', idTipo:'@idTipo'});
  });
(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalFiltroIngresoOrdenCompraCtrl', ModalFiltroIngresoOrdenCompraCtrl);

  /** @ngInject */
  function ModalFiltroIngresoOrdenCompraCtrl(NgTableParams, empresas, depositos, ProveedorEmpresa, MovimientosEmpresaDepositoProveedorTipoNumeroOrdenCompra , focus, $uibModalInstance, $stateParams, $scope, $filter, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.empresas = orderByFilter(empresas, 'nombre', false);
    vm.depositos = orderByFilter(depositos, 'nombre', false);
    vm.filtrar = filtrar;
    vm.cerrar = cerrar;

    ServicioDialogos.cerrarDialogoCargando();

	function cerrar(){
    if ($('.modal.in').length<=1){
      $('.modal-backdrop').remove();
    }
    $uibModalInstance.dismiss();
	}

  function filtrar(){
		ServicioDialogos.abrirDialogoCargando();
		MovimientosEmpresaDepositoProveedorTipoNumeroOrdenCompra.query({numeroOrden:vm.numeroOrdenCompra,idDeposito:vm.deposito.id, idProveedor:vm.proveedor.id, idEmpresa:vm.empresa.id, idTipo:2}, function(data){
			ServicioDialogos.cerrarDialogoCargando();
			if ($('.modal.in').length<=1){
				$('.modal-backdrop').remove();
			}
			$uibModalInstance.close({detalles:data, filtros:["Número orden de compra: "+vm.numeroOrdenCompra, "Proveedor: "+vm.proveedor.nombre.toUpperCase(),"Depósito: "+vm.deposito.nombre.toUpperCase(), "Empresa: "+vm.empresa.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
  }

    $scope.$watch('vm.empresa.nombre', function(){
      if (vm.proveedor) vm.proveedor=null;
      if (!vm.empresa || !vm.empresa.id) return;
      ServicioDialogos.abrirDialogoCargando();
      ProveedorEmpresa.query({empresa:vm.empresa.id}, function(data){
        vm.proveedores = data;
        focus('proveedor');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoFiltroIngresoRemito',DialogoFiltroIngresoRemito);

  function DialogoFiltroIngresoRemito($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'md',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/filtros-ingreso-numero-remito/filtros-ingreso-numero-remito.html',
        controller: 'ModalFiltroIngresoNumeroRemitoCtrl as vm',
        resolve: {
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data) {
              return data;
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

'use strict';
angular.module('proyecto-az-suministro')
  .factory('MovimientosEmpresaDepositoTipoNumeroRemito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?numeroRemito=:numeroRemito&&empresa.id=:idEmpresa&&deposito.id=:idDeposito&&tipo.id=:idTipo" ,{numeroRemito:'@numeroRemito', idEmpresa:'@idEmpresa',idDeposito:'@idDeposito', idTipo:'@idTipo'});
  });
(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalFiltroIngresoNumeroRemitoCtrl', ModalFiltroIngresoNumeroRemitoCtrl);

  /** @ngInject */
  function ModalFiltroIngresoNumeroRemitoCtrl(NgTableParams, empresas, depositos, MovimientosEmpresaDepositoTipoNumeroRemito, focus, $uibModalInstance, $stateParams, $scope, $filter, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.empresas = orderByFilter(empresas, 'nombre', false);
    vm.depositos = orderByFilter(depositos, 'nombre', false);
    vm.filtrar = filtrar;
    vm.cerrar = cerrar;

    ServicioDialogos.cerrarDialogoCargando();

	function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
	}

    function filtrar(){
		ServicioDialogos.abrirDialogoCargando();
		MovimientosEmpresaDepositoTipoNumeroRemito.query({numeroRemito:vm.numeroRemito,idDeposito:vm.deposito.id, idEmpresa:vm.empresa.id, idTipo:2}, function(data){
			ServicioDialogos.cerrarDialogoCargando();
			if ($('.modal.in').length<=1){
				$('.modal-backdrop').remove();
			}
			$uibModalInstance.close({detalles:data, filtros:["Número remito: "+vm.numeroRemito, "Depósito: "+vm.deposito.nombre.toUpperCase(), "Empresa: "+vm.empresa.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
    }

  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoFiltroIngresoFechaManual',DialogoFiltroIngresoFechaManual);

  function DialogoFiltroIngresoFechaManual($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/filtros-ingreso-fecha-manual/filtros-ingreso-fecha-manual.html',
        controller: 'ModalFiltroIngresoFechaManualCtrl as vm',
        resolve: {
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data) {
              return data;
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          deposito: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return usuario.empleado.deposito;
              } else {
                return ;
              }
            });
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalFiltroIngresoFechaManualCtrl', ModalFiltroIngresoFechaManualCtrl);

  /** @ngInject */
  function ModalFiltroIngresoFechaManualCtrl(NgTableParams, empresas, deposito, depositos, focus, IngresoEntreFechasIngresoManual, $uibModalInstance ,$stateParams, $scope, $filter, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.empresas = empresas;
    vm.depositos = depositos;
    vm.fechaActual = new Date();

    vm.validarFiltros = validarFiltros;

    vm.filtrar = filtrar;
    vm.cerrar = cerrar;
    vm.comprobarPeriodoFechas = comprobarPeriodoFechas;

    function comprobarPeriodoFechas(){
		return  (((vm.fechaHasta - vm.fechaDesde)/86400000)<=550);
    }

    inicializar();

    ServicioDialogos.cerrarDialogoCargando();

    function inicializar(){
		vm.depositoUsuario = deposito;
		if (deposito){
			vm.buscarDeposito = true;
			vm.deposito = deposito;
		}
    }

	function cerrar(){
		$('.modal-backdrop').remove();
		$uibModalInstance.dismiss();
	}

	function filtrar(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		IngresoEntreFechasIngresoManual.query({'idTipo':2,'idEmpresa':vm.empresa.id, 'idDeposito':vm.deposito.id, 'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada,'cajas':false}, function(data){
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Fecha ingreso manual entre: "+fechaDesde+" - "+fechaHasta, "Depósito: "+vm.deposito.nombre.toUpperCase(), "Empresa: "+vm.empresa.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	
	function validarFiltros(){
		return !(validarFechas() && validarDeposito() && validarEmpresa());
	}

	function validarFechas(){
		return (vm.fechaDesde && vm.fechaHasta && (vm.fechaDesde<=vm.fechaHasta)  && (vm.fechaHasta<=vm.fechaActual));
	}

	function validarEmpresa(){
		return (vm.empresa && vm.empresa.id);
	}

	function validarDeposito(){
		return (!vm.buscarDeposito || (vm.deposito && vm.deposito.id));
	}
  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoFiltroHistorialSuministro',DialogoFiltroHistorialSuministro);

  function DialogoFiltroHistorialSuministro($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/filtros-historial-suministro/filtros-historial-suministro.html',
        controller: 'ModalFiltroHistorialSuministroCtrl as vm',
        resolve: {
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data) {
              return data;
            });
          },
          modo: function(){
            return config.modo;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalFiltroHistorialSuministroCtrl', ModalFiltroHistorialSuministroCtrl);

  /** @ngInject */
  function ModalFiltroHistorialSuministroCtrl(NgTableParams, $uibModalInstance, modo, empresas, SuministroTipoSerie, SuministroEmpresaInventario, TipoSuministroFamiliaInventariable, FamiliaSuministroGrupo, GrupoEmpresa, focus, $stateParams, $scope, $filter, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.empresas = empresas;
    vm.fechaActual = new Date();
    vm.radio = "etiqueta";
    vm.bandera = false;
    vm.filtrarNuevo = filtrarNuevo;
    vm.buscar = buscar;
    vm.cerrar = cerrar;
    vm.modo = modo;
    vm.cambioRadio = cambioRadio;
    vm.nuevaReparacion = nuevaReparacion;
    vm.corroborarEstadoSuministro = corroborarEstadoSuministro;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.ubicacionCompleta = ubicacionCompleta;

    inicializar();
    ServicioDialogos.cerrarDialogoCargando();


    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });


    function ubicacionNaveNumeroOrden(suministro){
      if (suministro.ubicacion && suministro.ubicacion.nivel) {
        return "Nave: "+suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+suministro.ubicacion.numeroOrden;
      } else {
        return "El suministro no posee una ubicación actual";
      }
    }

    function ubicacionCompleta(suministro){
      if (suministro.ubicacion && suministro.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación completa",
        "Nave: "+suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+suministro.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+suministro.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+suministro.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+suministro.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+suministro.ubicacion.numeroUbicacion+
        "\nN° de orden: "+suministro.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+suministro.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+suministro.ubicacion.categoriaPeso.nombre.toUpperCase());
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "El suministro no posee ubicación asignada");
      }
    }

    function corroborarEstadoSuministro(bien){
      return bien.suministro.estadoSuministro.id!=2;
    }

    function inicializar(){
		if (vm.modo=='filtrar'){
			vm.titulo = "Filtrar por suministro";
		} else {
			vm.titulo = "Nueva reparación - Buscar suministro";
		}
    }

    function cambioRadio(){
      vm.bandera=false;
      if (vm.radio=="etiqueta"){
        if (vm.empresa1 && vm.empresa1.id) vm.empresa1=null;
        vm.serie=null;
      } else {
        if (vm.empresa && vm.empresa.id) vm.empresa=null;
        vm.etiqueta=null;
      }
    }
    

    function actualizarTabla(data){
      vm.bandera=true;
      vm.suministros = orderByFilter(data,'nombre',false);
      vm.tableParams.settings({
        data: vm.suministros,
        noPager: true,
        counts: []
      });
      vm.tableParams.reload();
    }

    function buscarPorInventario(){
      ServicioDialogos.abrirDialogoCargando();
      SuministroEmpresaInventario.query({idEmpresa:vm.empresa.id, inventario:vm.etiqueta,inventariable:true},function(data){
        vm.suministros = data;
        actualizarTabla(vm.suministros);
        ServicioDialogos.cerrarDialogoCargando();
      },
      function(err){
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError(null, "No se puede buscar los suministros");
      });
    }

    function buscarPorSerie(){
      ServicioDialogos.abrirDialogoCargando();
      SuministroTipoSerie.query({idTipo:vm.tipoSuministro.id, serie:vm.serie},function(data){
        vm.suministros = data;
        actualizarTabla(vm.suministros);
        ServicioDialogos.cerrarDialogoCargando();
      },
      function(err){
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError(null, "No se puede buscar los suministros");
      });
    }

    function buscar(){
      if (vm.radio=="etiqueta"){
        buscarPorInventario();
      } else if (vm.radio=="serie"){
        buscarPorSerie();
      } else {
        ServicioDialogos.mostrarDialogoError(null, "No se puede buscar");
      }
    }


	function cerrar(){
    if ($('.modal.in').length<=1){
      $('.modal-backdrop').remove();
    }
		$uibModalInstance.dismiss();
	}


	function filtrarNuevo(bien){
    if ($('.modal.in').length<=1){
      $('.modal-backdrop').remove();
    }
		$uibModalInstance.close({bien:bien, filtros:["Suministro filtrado: "+bien.suministro.tipoSuministro.nombre.toUpperCase()+". Serie: "+bien.serie+". Inventario: "+bien.inventario]});
	}

	function nuevaReparacion(bien){
    $('.modal-backdrop').remove();
		$uibModalInstance.close({bien:bien});
	}

    $scope.$watch('vm.empresa1.nombre', function(){
      if (vm.grupoSuministro && vm.grupoSuministro.id) vm.grupoSuministro=null;
      if (vm.familiaSuministro && vm.familiaSuministro.id) vm.familiaSuministro=null;
      if (vm.tipoSuministro && vm.tipoSuministro.id) vm.tipoSuministro=null;
      if (!vm.empresa1) return;
      ServicioDialogos.abrirDialogoCargando();
      GrupoEmpresa.query({id:vm.empresa1.id}, function(data) {
        vm.grupos = data;
        focus('grupoSuministro');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.grupoSuministro.nombre', function(){
      if (vm.familiaSuministro && vm.familiaSuministro.id) vm.familiaSuministro=null;
      if (vm.tipoSuministro &&vm.tipoSuministro.id) vm.tipoSuministro=null;
      if (!vm.grupoSuministro) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupoSuministro.id}, function(data){
        vm.familias = data;
        focus('familiaSuministro');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.tipoSuministro.nombre', function(){
      if (!vm.tipoSuministro) return;
      focus('serie');
    });

    $scope.$watch('vm.familiaSuministro.nombre', function(){
      if (vm.tipoSuministro && vm.tipoSuministro.id) vm.tipoSuministro=null;
      if (!vm.familiaSuministro) return;
      ServicioDialogos.abrirDialogoCargando();
      TipoSuministroFamiliaInventariable.query({idFamilia:vm.familiaSuministro.id, inventariable:true}, function(data){
        vm.tipos = data;
        focus('tipoSuministro');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });



  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoFiltroBusquedaIngresoSuministro',DialogoFiltroBusquedaIngresoSuministro);

  function DialogoFiltroBusquedaIngresoSuministro($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/filtros-busqueda-ingreso-suministro/filtros-busqueda-ingreso-suministro.html',
        controller: 'ModalFiltroBusquedaIngresoSuministroCtrl as vm',
        resolve: {
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data) {
              return data;
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

'use strict';
angular.module('proyecto-az-suministro')
  .factory('MovimientoTipoDepositoFechaDesdeHasta', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/detallemovimiento?tipoMovimiento.id=:idTipoMovimiento&&tipoSuministro.id=:idTipoSuministro&&deposito.id=:idDeposito&&fechaDesde=:fechaDesde&&fechaHasta=:fechaHasta" ,{idTipoMovimiento:'@idTipoMovimiento', idTipoSuministro:'@idTipoSuministro', idDeposito:'@idDeposito',fechaDesde:'@fechaDesde', fechaHasta:'@fechaHasta'});
  });
(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalFiltroBusquedaIngresoSuministroCtrl', ModalFiltroBusquedaIngresoSuministroCtrl);

  /** @ngInject */
  function ModalFiltroBusquedaIngresoSuministroCtrl(NgTableParams, empresas, depositos, focus, MovimientoTipoDepositoFechaDesdeHasta, GrupoEmpresa, TiposPorEmpresa, TipoSuministroFamilia, FamiliaSuministroGrupo, $uibModalInstance, $scope, $filter, orderByFilter, ServicioDialogos) {

    var vm = this;
    vm.empresas = orderByFilter(empresas,'nombre',false);
    vm.depositos = orderByFilter(depositos,'nombre',false);

    vm.agregar = agregar;
    vm.cerrar = cerrar;
    vm.cambioRadio = cambioRadio;
    vm.validarFiltros = validarFiltros;
    vm.filtrar = filtrar;


    vm.radio = 'jerarquizada';

    vm.comprobarPeriodoFechas = comprobarPeriodoFechas;

    function comprobarPeriodoFechas(){
      return  (((vm.fechaHasta - vm.fechaDesde)/86400000)<=550);
    }

    ServicioDialogos.cerrarDialogoCargando();

    function filtrar(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		MovimientoTipoDepositoFechaDesdeHasta.query({'idTipoMovimiento':2,'idTipoSuministro':vm.tipoSuministro.id,'idDeposito':vm.deposito.id, 'fechaDesde':vm.fechaDesde, 'fechaHasta':fechaHastaFormateada}, function(data){
//			console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Tipo de suministro: "+vm.tipoSuministro.nombre.toUpperCase()+" - Familia: "+vm.tipoSuministro.familiaSuministro.nombre.toUpperCase()+" - Grupo: "+vm.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(), "Empresa: "+vm.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase(), "Entre: "+fechaDesde+" - "+fechaHasta, "Depósito: "+vm.deposito.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
    }

    function validarFiltros(){
		return (vm.empresa && vm.empresa.id) && (vm.deposito && vm.deposito.id) && (vm.tipoSuministro && vm.tipoSuministro.id) && vm.fechaDesde && vm.fechaHasta;
    }

    function cambioRadio(){
      if (vm.radio=='jerarquizada'){
        vm.tipoSuministroCompleto=null;
      } else {
        if (vm.tipoSuministro && vm.tipoSuministro.id) vm.tipoSuministro=null;
        if (vm.familiaSuministro && vm.familiaSuministro.id) vm.familiaSuministro=null;
        if (vm.grupo && vm.grupo.id) vm.grupo=null;
      }
    }

    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.dismiss();
    }

    $scope.$watch('vm.grupo.nombre', function(){
      if (vm.familiaSuministro) vm.familiaSuministro=null;
      if (!vm.grupo) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupo.id}, function(data){
        vm.familias = orderByFilter(data,'nombre',false);
        focus('familia');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.empresa.id', function(){
      if (vm.grupo) vm.grupo=null;
      if (vm.tipoSuministroCompleto) vm.tipoSuministroCompleto=null;
      if (!vm.empresa) return;
      ServicioDialogos.abrirDialogoCargando();
      GrupoEmpresa.query({id:vm.empresa.id}, function(data){
        vm.grupos = orderByFilter(data,'nombre',false);
        focus('grupo');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.tipoSuministroCompleto.nombre', function(){
      vm.tipoSuministro=vm.tipoSuministroCompleto;
      //if (!vm.tipoSuministroCompleto || vm.tipoSuministroCompleto.inventariable===false) return;
    });

    $scope.$watch('vm.familiaSuministro.nombre', function(){
      if (vm.tipoSuministro) vm.tipoSuministro=null;
      if (!vm.familiaSuministro) return;
      ServicioDialogos.abrirDialogoCargando();
      TipoSuministroFamilia.query({id:vm.familiaSuministro.id}, function(data){
        vm.tipos = orderByFilter(data,'nombre',false);
        focus('tipo');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.radio', function(){
      if (vm.radio=='directa') {
        ServicioDialogos.abrirDialogoCargando();
        TiposPorEmpresa.query({idEmpresa:vm.empresa.id}, function(data){
          vm.tiposCompletos = orderByFilter(data,'nombre',false);
          ServicioDialogos.cerrarDialogoCargando();
        }, function(err){
          console.log(err);
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError();
        });

      }
    });

    function agregar(){
      var lista = [];
      if (vm.tipoSuministro && !vm.tipoSuministro.inventariable){
        lista = vm.listaNoInventariables;
      } else {
        lista = vm.bienes;
      }
      $uibModalInstance.close({tipoSuministro:vm.tipoSuministro, suministros:lista});
    }

  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoFiltroEgresos',DialogoFiltroEgresos);

  function DialogoFiltroEgresos($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/filtros-egresos/filtros-egresos.html',
        controller: 'ModalFiltroEgresosCtrl as vm',
        resolve: {
          deposito: function(){
            return config.deposito;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalFiltroEgresosCtrl', ModalFiltroEgresosCtrl);

  /** @ngInject */
  function ModalFiltroEgresosCtrl(NgTableParams, deposito, focus, EgresoDespachoEntreFechas, EgresoDespachoNumeroEgreso, $uibModalInstance, $stateParams, $scope, $filter, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.fechaActual = new Date();

    vm.cambioFiltro = cambioFiltro;

    vm.validarFiltrosFechas = validarFiltrosFechas;
    vm.validadFiltrosNumero = validadFiltrosNumero;

    vm.filtrar = filtrar;
    vm.cerrar = cerrar;
    vm.comprobarPeriodoFechas = comprobarPeriodoFechas;

    function comprobarPeriodoFechas(){
      return  (((vm.fechaHasta - vm.fechaDesde)/86400000)<=550);
    }

    inicializar();

    ServicioDialogos.cerrarDialogoCargando();

    function filtrar(){
		if (vm.radio=='numero'){
			buscarPorNumero();
		} else {
			buscarEntreFechas();
		}
    }

    function buscarEntreFechas(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		EgresoDespachoEntreFechas.query({idDeposito: deposito.id, 'idEstado1':1, 'idEstado2':2, fechaDesde:vm.fechaDesde, fechaHasta:fechaHastaFormateada}, function(data){
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({
				egresos: data,
				filtros:["Entre: "+fechaDesde+" - "+fechaHasta]
			});
		}, function(error){
			ServicioDialogos.cerrarDialogoCargando();
			console.log(error);
		});
    }

    function buscarPorNumero(){
		ServicioDialogos.abrirDialogoCargando();
		EgresoDespachoNumeroEgreso.query({idDeposito: deposito.id, numeroEgreso:vm.numeroEgreso}, function(data){
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({
				egresos: data,
				filtros:["Número egreso: "+vm.numeroEgreso]
			});
		}, function(error){
			ServicioDialogos.cerrarDialogoCargando();
			console.log(error);
		});
	}

	function inicializar(){
		vm.depositoUsuario=deposito;
		vm.radio='fechas';
		if (deposito){
			vm.deposito = deposito;
		}
    }

	function cerrar(){
		$('.modal-backdrop').remove();
		$uibModalInstance.dismiss();
	}

	function cambioFiltro(){
		if (vm.radio=='numero'){
			vm.fechaDesde = null;
			vm.fechaHasta = null;
			vm.form.fechaDesde.$setPristine();
			vm.form.fechaHasta.$setPristine();
		} else {
			vm.numeroEgreso = null;
		}
	}

	function validarFiltrosFechas(){
		return validarFechas() && comprobarPeriodoFechas();
	}

	function validadFiltrosNumero(){
		return vm.numeroEgreso;
	}

	function validarFechas(){
		return (vm.fechaDesde && vm.fechaHasta && (vm.fechaDesde<=vm.fechaHasta)  && (vm.fechaHasta<=vm.fechaActual));
	}
  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoFiltroBusquedaIngresoCajas',DialogoFiltroBusquedaIngresoCajas);

  function DialogoFiltroBusquedaIngresoCajas($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'md',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/filtros-busqueda-ingreso-cajas/filtros-busqueda-ingreso-cajas.html',
        controller: 'ModalFiltroBusquedaIngresoCajasCtrl as vm',
        resolve: {
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data) {
              return data;
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          estados: function(EstadoMovimientoTipoMovimiento){
            return EstadoMovimientoTipoMovimiento.query({'id':2}).$promise.then(function(data) {
              return data;
            });
          },
          tipo: function(){
            return config.tipo;
          },
          numeroVale: function(){
            return config.numeroVale;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

'use strict';
angular.module('proyecto-az-suministro')
  .factory('MovimientosNumeroCaja', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/detallemovimiento?numeroCaja=:numeroCaja&&empresa.id=:idEmpresa&&deposito.id=:idDeposito&&tipo.id=:idTipo" ,{numeroCaja:'@numeroCaja', idEmpresa:'@idEmpresa',idDeposito:'@idDeposito', idTipo:'@idTipo'});
  })
  .factory('MovimientosNumeroVale', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento?numeroVale=:numeroVale&&empresa.id=:idEmpresa&&deposito.id=:idDeposito&&tipo.id=:idTipo" ,{numeroVale:'@numeroVale', idEmpresa:'@idEmpresa',idDeposito:'@idDeposito', idTipo:'@idTipo'});
  });
(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalFiltroBusquedaIngresoCajasCtrl', ModalFiltroBusquedaIngresoCajasCtrl);

  /** @ngInject */
  function ModalFiltroBusquedaIngresoCajasCtrl(NgTableParams, estados, empresas, numeroVale, tipo, MovimientosNumeroCaja, MovimientosNumeroVale, depositos, focus, IngresoFechaDepositoEmpresaEstado, IngresoFechaDepositoProveedorEstado, IngresoEmpresaDepositoEstado, IngresoProveedorDepositoEstado, IngresoFechaDepositoEstado, IngresoFechaDepositoProveedor, IngresoFechaDepositoEmpresa, IngresoFechaEmpresaEstado, IngresoFechaProveedorEstado, IngresoEmpresaEstado, IngresoProveedorEstado, IngresoDepositoEstado, IngresoDepositoProveedor, IngresoDepositoEmpresa, IngresoEntreFechasEmpresa, IngresoEntreFechasProveedor, IngresoEntreFechasEstado, IngresoEntreFechasDeposito, IngresoProveedor, IngresoEmpresa, IngresoEstado, IngresoDeposito, IngresoEntreFechas, $uibModalInstance, ProveedorEmpresa, $stateParams, $scope, $filter, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.empresas = orderByFilter(empresas, 'nombre', false);
    vm.depositos = orderByFilter(depositos, 'nombre', false);
    vm.estados = orderByFilter(estados, 'nombre', false);
    vm.numeroVale = numeroVale;
    vm.fechaActual = new Date();

    vm.busquedaFecha = busquedaFecha;
    vm.busquedaProveedor = busquedaProveedor;
    vm.busquedaDeposito = busquedaDeposito;
    vm.busquedaEstado= busquedaEstado;

    vm.validarFiltros = validarFiltros;

    vm.filtrar = filtrar;
    vm.filtrarNuevo = filtrarNuevo;
    vm.cerrar = cerrar;

    ServicioDialogos.cerrarDialogoCargando();

	function cerrar(){
		$('.modal-backdrop').remove();
		$uibModalInstance.dismiss();
	}


	function filtrarNuevo(){
		ServicioDialogos.abrirDialogoCargando();
		if (vm.numeroVale==true){
			MovimientosNumeroVale.query({numeroVale:vm.vale, idDeposito:vm.deposito.id, idEmpresa:vm.empresa.id, idTipo:tipo}, function(data){
				ServicioDialogos.cerrarDialogoCargando();
				$('.modal-backdrop').remove();
				$uibModalInstance.close({detalles:data, filtros:["Número Vale: "+vm.vale, "Depósito: "+vm.deposito.nombre.toUpperCase(), "Empresa: "+vm.empresa.nombre.toUpperCase()]});
			}, function(err){
				console.log(err);
				ServicioDialogos.cerrarDialogoCargando();
				ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
			});
		} else {
			MovimientosNumeroCaja.query({numeroCaja:vm.numeroCaja, idDeposito:vm.deposito.id, idEmpresa:vm.empresa.id, idTipo:tipo}, function(data){
				ServicioDialogos.cerrarDialogoCargando();
				$('.modal-backdrop').remove();
				$uibModalInstance.close({detalles:data, filtros:["Número Caja: "+vm.numeroCaja, "Depósito: "+vm.deposito.nombre.toUpperCase(), "Empresa: "+vm.empresa.nombre.toUpperCase()]});
			}, function(err){
				console.log(err);
				ServicioDialogos.cerrarDialogoCargando();
				ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
			});
		}
	}

	function filtrar(){
		if (vm.buscarFecha && !vm.buscarDeposito && !vm.buscarProveedor && !vm.buscarEstado) filtrarPorFechas();
		else if (!vm.buscarFecha && vm.buscarDeposito && !vm.buscarProveedor && !vm.buscarEstado) filtrarPorDeposito();
		else if (!vm.buscarFecha && !vm.buscarDeposito && vm.buscarProveedor && !vm.buscarEstado) filtrarPorProveedorEmpresa();
		else if (!vm.buscarFecha && !vm.buscarDeposito && !vm.buscarProveedor && vm.buscarEstado) filtrarPorEstado();

		else if (vm.buscarFecha && vm.buscarDeposito && !vm.buscarProveedor && !vm.buscarEstado) filtrarPorFechaDeposito();
		else if (vm.buscarFecha && !vm.buscarDeposito && vm.buscarProveedor && !vm.buscarEstado) filtrarPorFechaEmpresaProveedor();
		else if (vm.buscarFecha && !vm.buscarDeposito && !vm.buscarProveedor && vm.buscarEstado) filtrarPorFechaEstado();
		else if (!vm.buscarFecha && vm.buscarDeposito && vm.buscarProveedor && !vm.buscarEstado) filtrarPorDepositoEmpresaProveedor();
		else if (!vm.buscarFecha && vm.buscarDeposito && !vm.buscarProveedor && vm.buscarEstado) filtrarPorDepositoEstado();
		else if (!vm.buscarFecha && !vm.buscarDeposito && vm.buscarProveedor && vm.buscarEstado) filtrarPorProveedorEmpresaEstado();


		else if (vm.buscarFecha && !vm.buscarDeposito && vm.buscarProveedor && vm.buscarEstado) filtrarPorFechaProveedorEmpresaEstado();
		else if (vm.buscarFecha && vm.buscarDeposito && vm.buscarProveedor && !vm.buscarEstado) filtrarPorFechaDepositoProveedorEmpresa();
		else if (vm.buscarFecha && vm.buscarDeposito && !vm.buscarProveedor && vm.buscarEstado) filtrarPorFechaDepositoEstado();
		else if (!vm.buscarFecha && vm.buscarDeposito && vm.buscarProveedor && vm.buscarEstado) filtrarPorDepositoProveedorEmpresaEstado();
			
		else if (vm.buscarFecha && vm.buscarDeposito && vm.buscarProveedor && vm.buscarEstado) filtrarPorTodoEmpresaProveedor();

		else {
			ServicioDialogos.mostrarDialogoInformacion(null, "No se puede filtrar");
		}
	}

	function filtrarPorFechas(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR SOLO POR FECHAS");
		IngresoEntreFechas.query({'id':2,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada,'cajas':true}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorDeposito(){
		ServicioDialogos.abrirDialogoCargando();
		//console.log("FILTRAR SOLO POR DEPOSITO");
		IngresoDeposito.query({'idTipo':2,'idDeposito':vm.deposito.id,'cajas':true}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Deposito: "+vm.deposito.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorProveedorEmpresa(){
		console.log(vm.empresa, vm.proveedor)
		if (vm.empresa && vm.empresa.id && vm.proveedor && vm.proveedor.id){
			filtrarPorProveedor();
		} else if (vm.empresa && vm.empresa.id && !vm.proveedor){
			filtrarPorEmpresa();
		}
	}

	function filtrarPorEmpresa(){
		ServicioDialogos.abrirDialogoCargando();
		//console.log("FILTRAR SOLO POR EMPRESA");
		IngresoEmpresa.query({'idTipo':2,'idEmpresa':vm.empresa.id,'cajas':true}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Empresa: "+vm.empresa.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorProveedor(){
		ServicioDialogos.abrirDialogoCargando();
		//console.log("FILTRAR SOLO POR PROVEEDOR");
		IngresoProveedor.query({'idTipo':2,'idProveedor':vm.proveedor.id,'cajas':true}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Proveedor: "+vm.proveedor.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorEstado(){
		ServicioDialogos.abrirDialogoCargando();
		//console.log("FILTRAR SOLO POR Empresa");
		IngresoEstado.query({'idTipo':2,'idEstado':vm.estado.id,'cajas':true}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Estado: "+vm.estado.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorFechaDeposito(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR FECHA Y DEPOSITO");
		IngresoEntreFechasDeposito.query({'idTipo':2,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada, 'idDeposito':vm.deposito.id,'cajas':true}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta, "Depósito: "+vm.deposito.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}
	function filtrarPorFechaEmpresaProveedor(){
		//console.log("FILTRAR SOLO POR FECHA Y PROVEEDOR");
		if (vm.empresa && vm.empresa.id && vm.proveedor && vm.proveedor.id){
			filtrarPorFechaProveedor();
		} else if (vm.empresa && vm.empresa.id && !vm.proveedor){
			filtrarPorFechaEmpresa();
		}
	}

	function filtrarPorFechaEmpresa(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR FECHA Y EMPRESA");
		IngresoEntreFechasEmpresa.query({'idTipo':2,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada, 'idEmpresa':vm.empresa.id,'cajas':true}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta, "Empresa: "+vm.empresa.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorFechaProveedor(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR FECHA Y Proveedor");
		IngresoEntreFechasProveedor.query({'idTipo':2,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada, 'idProveedor':vm.proveedor.id,'cajas':true}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta, "Proveedor: "+vm.proveedor.nombre.toUpperCase()+" ("+vm.proveedor.empresa.nombre.toUpperCase()+")"]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorFechaEstado(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR FECHA Y ESTADO");
		IngresoEntreFechasEstado.query({'idTipo':2,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada, 'idEstado':vm.estado.id,'cajas':true}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta, "Estado: "+vm.estado.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorDepositoEmpresaProveedor(){
		//console.log("FILTRAR SOLO POR Deposito Y PROVEEDOR");
		if (vm.empresa && vm.empresa.id && vm.proveedor && vm.proveedor.id){
			filtrarPorDepositoProveedor();
		} else if (vm.empresa && vm.empresa.id && !vm.proveedor){
			filtrarPorDepositoEmpresa();
		}
	}

	function filtrarPorDepositoEmpresa(){
		ServicioDialogos.abrirDialogoCargando();
		//console.log("FILTRAR POR DEPOSITO Y EMPRESA");
		IngresoDepositoEmpresa.query({'idTipo':2,'idDeposito':vm.deposito.id, 'idEmpresa':vm.empresa.id,'cajas':true}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Depósito: "+vm.deposito.nombre.toUpperCase(), "Empresa: "+vm.empresa.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorDepositoProveedor(){
		ServicioDialogos.abrirDialogoCargando();
		//console.log("FILTRAR POR DEPOSITO Y PROVEEDOR");
		IngresoDepositoProveedor.query({'idTipo':2,'idDeposito':vm.deposito.id, 'idProveedor':vm.proveedor.id,'cajas':true}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Depósito: "+vm.deposito.nombre.toUpperCase(), "Proveedor: "+vm.proveedor.nombre.toUpperCase()+" ("+vm.proveedor.empresa.nombre.toUpperCase()+")"]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorDepositoEstado(){
		ServicioDialogos.abrirDialogoCargando();
		//console.log("FILTRAR POR DEPOSITO Y ESTADO");
		IngresoDepositoEstado.query({'idTipo':2,'idDeposito':vm.deposito.id, 'idEstado':vm.estado.id,'cajas':true}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Depósito: "+vm.deposito.nombre.toUpperCase(), "Estado: "+vm.estado.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}
	function filtrarPorProveedorEmpresaEstado(){
		//console.log("FILTRAR SOLO POR PROVEEDOR/EMPRESA Y ESTADO");
		if (vm.empresa && vm.empresa.id && vm.proveedor && vm.proveedor.id){
			filtrarPorProveedorEstado();
		} else if (vm.empresa && vm.empresa.id && !vm.proveedor){
			filtrarPorEmpresaEstado();
		}
	}

	function filtrarPorProveedorEstado(){
		ServicioDialogos.abrirDialogoCargando();
		//console.log("FILTRAR POR ESTADO Y PROVEEDOR");
		IngresoProveedorEstado.query({'idTipo':2,'idProveedor':vm.proveedor.id, 'idEstado':vm.estado.id,'cajas':true}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Estado: "+vm.estado.nombre.toUpperCase(), "Proveedor: "+vm.proveedor.nombre.toUpperCase()+" ("+vm.proveedor.empresa.nombre.toUpperCase()+")"]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorEmpresaEstado(){
		ServicioDialogos.abrirDialogoCargando();
		//console.log("FILTRAR POR EMPRESA Y ESTADO");
		IngresoEmpresaEstado.query({'idTipo':2,'idEmpresa':vm.empresa.id, 'idEstado':vm.estado.id,'cajas':true}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Estado: "+vm.estado.nombre.toUpperCase(), "Empresa: "+vm.empresa.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorFechaProveedorEmpresaEstado(){
		if (vm.empresa && vm.empresa.id && vm.proveedor && vm.proveedor.id){
			filtrarPorFechaProveedorEstado();
		} else if (vm.empresa && vm.empresa.id && !vm.proveedor){
			filtrarPorFechaEmpresaEstado();
		}
	}

	function filtrarPorFechaProveedorEstado(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR Fecha Proveedor Y ESTADO");
		IngresoFechaProveedorEstado.query({'idTipo':2,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada,'idProveedor':vm.proveedor.id, 'idEstado':vm.estado.id,'cajas':true}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta,"Estado: "+vm.estado.nombre.toUpperCase(), "Proveedor: "+vm.proveedor.nombre.toUpperCase()+" ("+vm.proveedor.empresa.nombre.toUpperCase()+")"]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorFechaEmpresaEstado(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR FECHA EMPRESA Y ESTADO");
		IngresoFechaEmpresaEstado.query({'idTipo':2,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada,'idEmpresa':vm.empresa.id, 'idEstado':vm.estado.id,'cajas':true}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta,"Estado: "+vm.estado.nombre.toUpperCase(), "Empresa: "+vm.empresa.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorFechaDepositoProveedorEmpresa(){
		//console.log("FILTRAR POR TODO MENOS ESTADO",vm.proveedor, vm.empresa);
		if (vm.empresa && vm.empresa.id && vm.proveedor && vm.proveedor.id){
			filtrarPorFechaDepositoProveedor();
		} else if (vm.empresa && vm.empresa.id && !vm.proveedor){
			filtrarPorFechaDepositoEmpresa();
		}
	}

	function filtrarPorFechaDepositoProveedor(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR Fecha Proveedor Y DEPOSITO");
		IngresoFechaDepositoProveedor.query({'idTipo':2,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada,'idDeposito':vm.deposito.id, 'idProveedor':vm.proveedor.id,'cajas':true}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta,"Depósito: "+vm.deposito.nombre.toUpperCase(), "Proveedor: "+vm.proveedor.nombre.toUpperCase()+" ("+vm.proveedor.empresa.nombre.toUpperCase()+")"]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorFechaDepositoEmpresa(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR FECHA EMPRESA Y DEPOSITO");
		IngresoFechaDepositoEmpresa.query({'idTipo':2,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada, 'idDeposito':vm.deposito.id, 'idEmpresa':vm.empresa.id,'cajas':true}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta,"Depósito: "+vm.deposito.nombre.toUpperCase(), "Empresa: "+vm.empresa.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorFechaDepositoEstado(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR FECHA ESTADO Y DEPOSITO");
		IngresoFechaDepositoEstado.query({'idTipo':2,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada, 'idDeposito':vm.deposito.id, 'idEstado':vm.estado.id,'cajas':true}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta,"Depósito: "+vm.deposito.nombre.toUpperCase(), "Estado: "+vm.estado.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}
	function filtrarPorDepositoProveedorEmpresaEstado(){
		//console.log("FILTRAR POR TODO MENOS FECHA",vm.proveedor, vm.empresa);
		if (vm.empresa && vm.empresa.id && vm.proveedor && vm.proveedor.id){
			filtrarPorDepositoProveedorEstado();
		} else if (vm.empresa && vm.empresa.id && !vm.proveedor){
			filtrarPorDepositoEmpresaEstado();
		}
	}

	function filtrarPorDepositoProveedorEstado(){
	ServicioDialogos.abrirDialogoCargando();
		//console.log("FILTRAR POR PROVEEDOOR DEPOSITO Y ESTADO");
		IngresoProveedorDepositoEstado.query({'idTipo':2,'idProveedor':vm.proveedor.id,'idDeposito':vm.deposito.id, 'idEstado':vm.estado.id,'cajas':true}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Estado: "+vm.estado.nombre.toUpperCase(), "Depósito: "+vm.deposito.nombre.toUpperCase(),"Proveedor: "+vm.proveedor.nombre.toUpperCase()+" ("+vm.proveedor.empresa.nombre.toUpperCase()+")"]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorDepositoEmpresaEstado(){
		ServicioDialogos.abrirDialogoCargando();
		//console.log("FILTRAR POR EMPRESA DEPOSITO Y ESTADO");
		IngresoEmpresaDepositoEstado.query({'idTipo':2,'idEmpresa':vm.empresa.id,'idDeposito':vm.deposito.id, 'idEstado':vm.estado.id,'cajas':true}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Estado: "+vm.estado.nombre.toUpperCase(), "Depósito: "+vm.deposito.nombre.toUpperCase(), "Empresa: "+vm.empresa.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorTodoEmpresaProveedor(){
		//console.log("FILTRAR POR TODO!!!!!");
		if (vm.empresa && vm.empresa.id && vm.proveedor && vm.proveedor.id){
			filtrarPorTodoProveedor();
		} else if (vm.empresa && vm.empresa.id && !vm.proveedor){
			filtrarPorTodoEmpresa();
		}
	}

	function filtrarPorTodoProveedor(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR FECHA ESTADO PROVEDDOR Y DEPOSITO");
		IngresoFechaDepositoProveedorEstado.query({'idTipo':2,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada, 'idDeposito':vm.deposito.id,'idProveedor':vm.proveedor.id, 'idEstado':vm.estado.id,'cajas':true}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta,"Depósito: "+vm.deposito.nombre.toUpperCase(), "Proveedor: "+vm.proveedor.nombre.toUpperCase()+" ("+vm.proveedor.empresa.nombre.toUpperCase()+")","Estado: "+vm.estado.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorTodoEmpresa(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR FECHA ESTADO Empresa Y DEPOSITO");
		IngresoFechaDepositoEmpresaEstado.query({'idTipo':2,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada, 'idDeposito':vm.deposito.id,'idEmpresa':vm.empresa.id, 'idEstado':vm.estado.id,'cajas':true}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta,"Depósito: "+vm.deposito.nombre.toUpperCase(), "Empresa: "+vm.empresa.nombre.toUpperCase(),"Estado: "+vm.estado.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function busquedaFecha(){
		if (!vm.buscarFecha){
			vm.fechaDesde = null;
			vm.fechaHasta = null;
			vm.form.fechaDesde.$setPristine();
			vm.form.fechaHasta.$setPristine();
		}
	}

	function busquedaEstado(){
		if (!vm.buscarEstado){
			vm.estado = null;
		}
	}


	function busquedaDeposito(){
		if (!vm.buscarDeposito){
			vm.deposito = null;
		}
	}

	function busquedaProveedor(){
		if (!vm.buscarProveedor){
			if (vm.empresa) vm.empresa = null;
			if (vm.proveedor) vm.proveedor = null;
		}
	}

	function validarFiltros(){
		return !((validarFechas() && validarProveedor() && validarEstado() && validarDeposito()) && (vm.buscarFecha || vm.buscarProveedor || vm.buscarEstado || vm.buscarDeposito));
	}

	function validarFechas(){
		return (!vm.buscarFecha || (vm.buscarFecha && vm.fechaDesde && vm.fechaHasta && (vm.fechaDesde<=vm.fechaHasta)  && (vm.fechaHasta<=vm.fechaActual)));
	}

	function validarProveedor(){
		return (!vm.buscarProveedor || (vm.proveedor && vm.proveedor.id) || (vm.empresa && vm.empresa.id));
	}

	function validarEstado(){
		return (!vm.buscarEstado || (vm.estado && vm.estado.id));
	}

	function validarDeposito(){
		return (!vm.buscarDeposito || (vm.deposito && vm.deposito.id));
	}

    /*$scope.$watch('vm.empresa.nombre', function(){
		if (!vm.empresa) return;
		if (vm.proveedor) vm.proveedor=null;
		ServicioDialogos.abrirDialogoCargando();
		ProveedorEmpresa.query({'empresa':vm.empresa.id}, function(data){
			vm.proveedores = data;
			focus('proveedor');
			ServicioDialogos.cerrarDialogoCargando();
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError();
		});
    });*/

  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoFiltroBusquedaIngreso',DialogoFiltroBusquedaIngreso);

  function DialogoFiltroBusquedaIngreso($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/filtros-busqueda-ingreso/filtros-busqueda-ingreso.html',
        controller: 'ModalFiltroBusquedaIngresoCtrl as vm',
        resolve: {
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data) {
              return data;
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          deposito: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return usuario.empleado.deposito;
              } else {
                return ;
              }
            });
          },
          estados: function(EstadoMovimientoTipoMovimiento){
            return EstadoMovimientoTipoMovimiento.query({'id':2}).$promise.then(function(data) {
              return data;
            });
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalFiltroBusquedaIngresoCtrl', ModalFiltroBusquedaIngresoCtrl);

  /** @ngInject */
  function ModalFiltroBusquedaIngresoCtrl(NgTableParams, estados, empresas, deposito, depositos, focus, IngresoFechaDepositoEmpresaEstado, IngresoFechaDepositoProveedorEstado, IngresoEmpresaDepositoEstado, IngresoProveedorDepositoEstado, IngresoFechaDepositoEstado, IngresoFechaDepositoProveedor, IngresoFechaDepositoEmpresa, IngresoFechaEmpresaEstado, IngresoFechaProveedorEstado, IngresoEmpresaEstado, IngresoProveedorEstado, IngresoDepositoEstado, IngresoDepositoProveedor, IngresoDepositoEmpresa, IngresoEntreFechasEmpresa, IngresoEntreFechasProveedor, IngresoEntreFechasEstado, IngresoEntreFechasDeposito, IngresoProveedor, IngresoEmpresa, IngresoEstado, IngresoDeposito, IngresoEntreFechas, $uibModalInstance, ProveedorEmpresa, $stateParams, $scope, $filter, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.empresas = empresas;
    vm.depositos = depositos;
    vm.estados = estados;
    vm.fechaActual = new Date();

    vm.busquedaFecha = busquedaFecha;
    vm.busquedaProveedor = busquedaProveedor;
    vm.busquedaDeposito = busquedaDeposito;
    vm.busquedaEstado= busquedaEstado;

    vm.validarFiltros = validarFiltros;

    vm.filtrar = filtrar;
    vm.cerrar = cerrar;
    vm.comprobarPeriodoFechas = comprobarPeriodoFechas;

    function comprobarPeriodoFechas(){
		return  (((vm.fechaHasta - vm.fechaDesde)/86400000)<=550);
    }

    inicializar();

    ServicioDialogos.cerrarDialogoCargando();

    function inicializar(){
		vm.depositoUsuario = deposito;
		if (deposito){
			vm.buscarDeposito = true;
			vm.deposito = deposito;
		}
		editarEstados();
    }

    function editarEstados(){
		var i = null;
		vm.estados.forEach(function(estado, index){
			if (estado.id===7){
				i = index;
			}
		});
		vm.estados.splice(i,1);
    }

	function cerrar(){
		$('.modal-backdrop').remove();
		$uibModalInstance.dismiss();
	}

	function filtrar(){
		if (vm.buscarFecha && !vm.buscarDeposito && !vm.buscarProveedor && !vm.buscarEstado) filtrarPorFechas();
		else if (!vm.buscarFecha && vm.buscarDeposito && !vm.buscarProveedor && !vm.buscarEstado) filtrarPorDeposito();
		else if (!vm.buscarFecha && !vm.buscarDeposito && vm.buscarProveedor && !vm.buscarEstado) filtrarPorProveedorEmpresa();
		else if (!vm.buscarFecha && !vm.buscarDeposito && !vm.buscarProveedor && vm.buscarEstado) filtrarPorEstado();

		else if (vm.buscarFecha && vm.buscarDeposito && !vm.buscarProveedor && !vm.buscarEstado) filtrarPorFechaDeposito();
		else if (vm.buscarFecha && !vm.buscarDeposito && vm.buscarProveedor && !vm.buscarEstado) filtrarPorFechaEmpresaProveedor();
		else if (vm.buscarFecha && !vm.buscarDeposito && !vm.buscarProveedor && vm.buscarEstado) filtrarPorFechaEstado();
		else if (!vm.buscarFecha && vm.buscarDeposito && vm.buscarProveedor && !vm.buscarEstado) filtrarPorDepositoEmpresaProveedor();
		else if (!vm.buscarFecha && vm.buscarDeposito && !vm.buscarProveedor && vm.buscarEstado) filtrarPorDepositoEstado();
		else if (!vm.buscarFecha && !vm.buscarDeposito && vm.buscarProveedor && vm.buscarEstado) filtrarPorProveedorEmpresaEstado();


		else if (vm.buscarFecha && !vm.buscarDeposito && vm.buscarProveedor && vm.buscarEstado) filtrarPorFechaProveedorEmpresaEstado();
		else if (vm.buscarFecha && vm.buscarDeposito && vm.buscarProveedor && !vm.buscarEstado) filtrarPorFechaDepositoProveedorEmpresa();
		else if (vm.buscarFecha && vm.buscarDeposito && !vm.buscarProveedor && vm.buscarEstado) filtrarPorFechaDepositoEstado();
		else if (!vm.buscarFecha && vm.buscarDeposito && vm.buscarProveedor && vm.buscarEstado) filtrarPorDepositoProveedorEmpresaEstado();
			
		else if (vm.buscarFecha && vm.buscarDeposito && vm.buscarProveedor && vm.buscarEstado) filtrarPorTodoEmpresaProveedor();

		else {
			ServicioDialogos.mostrarDialogoInformacion(null, "No se puede filtrar");
		}
	}

	function filtrarPorFechas(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR SOLO POR FECHAS");
		IngresoEntreFechas.query({'id':2,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada,'cajas':false}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorDeposito(){
		ServicioDialogos.abrirDialogoCargando();
		//console.log("FILTRAR SOLO POR DEPOSITO");
		IngresoDeposito.query({'idTipo':2,'idDeposito':vm.deposito.id,'cajas':false}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Deposito: "+vm.deposito.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorProveedorEmpresa(){
		console.log(vm.empresa, vm.proveedor)
		if (vm.empresa && vm.empresa.id && vm.proveedor && vm.proveedor.id){
			filtrarPorProveedor();
		} else if (vm.empresa && vm.empresa.id && !vm.proveedor){
			filtrarPorEmpresa();
		}
	}

	function filtrarPorEmpresa(){
		ServicioDialogos.abrirDialogoCargando();
		//console.log("FILTRAR SOLO POR EMPRESA");
		IngresoEmpresa.query({'idTipo':2,'idEmpresa':vm.empresa.id,'cajas':false}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Empresa: "+vm.empresa.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorProveedor(){
		ServicioDialogos.abrirDialogoCargando();
		//console.log("FILTRAR SOLO POR PROVEEDOR");
		IngresoProveedor.query({'idTipo':2,'idProveedor':vm.proveedor.id,'cajas':false}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Proveedor: "+vm.proveedor.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorEstado(){
		ServicioDialogos.abrirDialogoCargando();
		//console.log("FILTRAR SOLO POR Empresa");
		IngresoEstado.query({'idTipo':2,'idEstado':vm.estado.id,'cajas':false}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Estado: "+vm.estado.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorFechaDeposito(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR FECHA Y DEPOSITO");
		IngresoEntreFechasDeposito.query({'idTipo':2,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada, 'idDeposito':vm.deposito.id,'cajas':false}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta, "Depósito: "+vm.deposito.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}
	function filtrarPorFechaEmpresaProveedor(){
		//console.log("FILTRAR SOLO POR FECHA Y PROVEEDOR");
		if (vm.empresa && vm.empresa.id && vm.proveedor && vm.proveedor.id){
			filtrarPorFechaProveedor();
		} else if (vm.empresa && vm.empresa.id && !vm.proveedor){
			filtrarPorFechaEmpresa();
		}
	}

	function filtrarPorFechaEmpresa(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR FECHA Y EMPRESA");
		IngresoEntreFechasEmpresa.query({'idTipo':2,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada, 'idEmpresa':vm.empresa.id,'cajas':false}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta, "Empresa: "+vm.empresa.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorFechaProveedor(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR FECHA Y Proveedor");
		IngresoEntreFechasProveedor.query({'idTipo':2,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada, 'idProveedor':vm.proveedor.id,'cajas':false}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta, "Proveedor: "+vm.proveedor.nombre.toUpperCase()+" ("+vm.proveedor.empresa.nombre.toUpperCase()+")"]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorFechaEstado(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR FECHA Y ESTADO");
		IngresoEntreFechasEstado.query({'idTipo':2,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada, 'idEstado':vm.estado.id,'cajas':false}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta, "Estado: "+vm.estado.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorDepositoEmpresaProveedor(){
		//console.log("FILTRAR SOLO POR Deposito Y PROVEEDOR");
		if (vm.empresa && vm.empresa.id && vm.proveedor && vm.proveedor.id){
			filtrarPorDepositoProveedor();
		} else if (vm.empresa && vm.empresa.id && !vm.proveedor){
			filtrarPorDepositoEmpresa();
		}
	}

	function filtrarPorDepositoEmpresa(){
		ServicioDialogos.abrirDialogoCargando();
		//console.log("FILTRAR POR DEPOSITO Y EMPRESA");
		IngresoDepositoEmpresa.query({'idTipo':2,'idDeposito':vm.deposito.id, 'idEmpresa':vm.empresa.id,'cajas':false}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Depósito: "+vm.deposito.nombre.toUpperCase(), "Empresa: "+vm.empresa.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorDepositoProveedor(){
		ServicioDialogos.abrirDialogoCargando();
		//console.log("FILTRAR POR DEPOSITO Y PROVEEDOR");
		IngresoDepositoProveedor.query({'idTipo':2,'idDeposito':vm.deposito.id, 'idProveedor':vm.proveedor.id,'cajas':false}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Depósito: "+vm.deposito.nombre.toUpperCase(), "Proveedor: "+vm.proveedor.nombre.toUpperCase()+" ("+vm.proveedor.empresa.nombre.toUpperCase()+")"]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorDepositoEstado(){
		ServicioDialogos.abrirDialogoCargando();
		//console.log("FILTRAR POR DEPOSITO Y ESTADO");
		IngresoDepositoEstado.query({'idTipo':2,'idDeposito':vm.deposito.id, 'idEstado':vm.estado.id,'cajas':false}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Depósito: "+vm.deposito.nombre.toUpperCase(), "Estado: "+vm.estado.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}
	function filtrarPorProveedorEmpresaEstado(){
		//console.log("FILTRAR SOLO POR PROVEEDOR/EMPRESA Y ESTADO");
		if (vm.empresa && vm.empresa.id && vm.proveedor && vm.proveedor.id){
			filtrarPorProveedorEstado();
		} else if (vm.empresa && vm.empresa.id && !vm.proveedor){
			filtrarPorEmpresaEstado();
		}
	}

	function filtrarPorProveedorEstado(){
		ServicioDialogos.abrirDialogoCargando();
		//console.log("FILTRAR POR ESTADO Y PROVEEDOR");
		IngresoProveedorEstado.query({'idTipo':2,'idProveedor':vm.proveedor.id, 'idEstado':vm.estado.id,'cajas':false}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Estado: "+vm.estado.nombre.toUpperCase(), "Proveedor: "+vm.proveedor.nombre.toUpperCase()+" ("+vm.proveedor.empresa.nombre.toUpperCase()+")"]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorEmpresaEstado(){
		ServicioDialogos.abrirDialogoCargando();
		//console.log("FILTRAR POR EMPRESA Y ESTADO");
		IngresoEmpresaEstado.query({'idTipo':2,'idEmpresa':vm.empresa.id, 'idEstado':vm.estado.id,'cajas':false}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Estado: "+vm.estado.nombre.toUpperCase(), "Empresa: "+vm.empresa.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorFechaProveedorEmpresaEstado(){
		if (vm.empresa && vm.empresa.id && vm.proveedor && vm.proveedor.id){
			filtrarPorFechaProveedorEstado();
		} else if (vm.empresa && vm.empresa.id && !vm.proveedor){
			filtrarPorFechaEmpresaEstado();
		}
	}

	function filtrarPorFechaProveedorEstado(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR Fecha Proveedor Y ESTADO");
		IngresoFechaProveedorEstado.query({'idTipo':2,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada,'idProveedor':vm.proveedor.id, 'idEstado':vm.estado.id,'cajas':false}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta,"Estado: "+vm.estado.nombre.toUpperCase(), "Proveedor: "+vm.proveedor.nombre.toUpperCase()+" ("+vm.proveedor.empresa.nombre.toUpperCase()+")"]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorFechaEmpresaEstado(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR FECHA EMPRESA Y ESTADO");
		IngresoFechaEmpresaEstado.query({'idTipo':2,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada,'idEmpresa':vm.empresa.id, 'idEstado':vm.estado.id,'cajas':false}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta,"Estado: "+vm.estado.nombre.toUpperCase(), "Empresa: "+vm.empresa.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorFechaDepositoProveedorEmpresa(){
		//console.log("FILTRAR POR TODO MENOS ESTADO",vm.proveedor, vm.empresa);
		if (vm.empresa && vm.empresa.id && vm.proveedor && vm.proveedor.id){
			filtrarPorFechaDepositoProveedor();
		} else if (vm.empresa && vm.empresa.id && !vm.proveedor){
			filtrarPorFechaDepositoEmpresa();
		}
	}

	function filtrarPorFechaDepositoProveedor(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR Fecha Proveedor Y DEPOSITO");
		IngresoFechaDepositoProveedor.query({'idTipo':2,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada,'idDeposito':vm.deposito.id, 'idProveedor':vm.proveedor.id,'cajas':false}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta,"Depósito: "+vm.deposito.nombre.toUpperCase(), "Proveedor: "+vm.proveedor.nombre.toUpperCase()+" ("+vm.proveedor.empresa.nombre.toUpperCase()+")"]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorFechaDepositoEmpresa(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR FECHA EMPRESA Y DEPOSITO");
		IngresoFechaDepositoEmpresa.query({'idTipo':2,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada, 'idDeposito':vm.deposito.id, 'idEmpresa':vm.empresa.id,'cajas':false}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta,"Depósito: "+vm.deposito.nombre.toUpperCase(), "Empresa: "+vm.empresa.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorFechaDepositoEstado(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR FECHA ESTADO Y DEPOSITO");
		IngresoFechaDepositoEstado.query({'idTipo':2,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada, 'idDeposito':vm.deposito.id, 'idEstado':vm.estado.id,'cajas':false}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta,"Depósito: "+vm.deposito.nombre.toUpperCase(), "Estado: "+vm.estado.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}
	function filtrarPorDepositoProveedorEmpresaEstado(){
		//console.log("FILTRAR POR TODO MENOS FECHA",vm.proveedor, vm.empresa);
		if (vm.empresa && vm.empresa.id && vm.proveedor && vm.proveedor.id){
			filtrarPorDepositoProveedorEstado();
		} else if (vm.empresa && vm.empresa.id && !vm.proveedor){
			filtrarPorDepositoEmpresaEstado();
		}
	}

	function filtrarPorDepositoProveedorEstado(){
	ServicioDialogos.abrirDialogoCargando();
		//console.log("FILTRAR POR PROVEEDOOR DEPOSITO Y ESTADO");
		IngresoProveedorDepositoEstado.query({'idTipo':2,'idProveedor':vm.proveedor.id,'idDeposito':vm.deposito.id, 'idEstado':vm.estado.id,'cajas':false}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Estado: "+vm.estado.nombre.toUpperCase(), "Depósito: "+vm.deposito.nombre.toUpperCase(),"Proveedor: "+vm.proveedor.nombre.toUpperCase()+" ("+vm.proveedor.empresa.nombre.toUpperCase()+")"]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorDepositoEmpresaEstado(){
		ServicioDialogos.abrirDialogoCargando();
		//console.log("FILTRAR POR EMPRESA DEPOSITO Y ESTADO");
		IngresoEmpresaDepositoEstado.query({'idTipo':2,'idEmpresa':vm.empresa.id,'idDeposito':vm.deposito.id, 'idEstado':vm.estado.id,'cajas':false}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Estado: "+vm.estado.nombre.toUpperCase(), "Depósito: "+vm.deposito.nombre.toUpperCase(), "Empresa: "+vm.empresa.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorTodoEmpresaProveedor(){
		//console.log("FILTRAR POR TODO!!!!!");
		if (vm.empresa && vm.empresa.id && vm.proveedor && vm.proveedor.id){
			filtrarPorTodoProveedor();
		} else if (vm.empresa && vm.empresa.id && !vm.proveedor){
			filtrarPorTodoEmpresa();
		}
	}

	function filtrarPorTodoProveedor(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR FECHA ESTADO PROVEDDOR Y DEPOSITO");
		IngresoFechaDepositoProveedorEstado.query({'idTipo':2,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada, 'idDeposito':vm.deposito.id,'idProveedor':vm.proveedor.id, 'idEstado':vm.estado.id,'cajas':false}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta,"Depósito: "+vm.deposito.nombre.toUpperCase(), "Proveedor: "+vm.proveedor.nombre.toUpperCase()+" ("+vm.proveedor.empresa.nombre.toUpperCase()+")","Estado: "+vm.estado.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorTodoEmpresa(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR FECHA ESTADO Empresa Y DEPOSITO");
		IngresoFechaDepositoEmpresaEstado.query({'idTipo':2,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada, 'idDeposito':vm.deposito.id,'idEmpresa':vm.empresa.id, 'idEstado':vm.estado.id,'cajas':false}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta,"Depósito: "+vm.deposito.nombre.toUpperCase(), "Empresa: "+vm.empresa.nombre.toUpperCase(),"Estado: "+vm.estado.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function busquedaFecha(){
		if (!vm.buscarFecha){
			vm.fechaDesde = null;
			vm.fechaHasta = null;
			vm.form.fechaDesde.$setPristine();
			vm.form.fechaHasta.$setPristine();
		}
	}

	function busquedaEstado(){
		if (!vm.buscarEstado){
			vm.estado = null;
		}
	}

	function busquedaDeposito(){
		if (!vm.buscarDeposito){
			vm.deposito = null;
		}
	}

	function busquedaProveedor(){
		if (!vm.buscarProveedor){
			if (vm.empresa) vm.empresa = null;
			if (vm.proveedor) vm.proveedor = null;
		}
	}

	function validarFiltros(){
		return !((validarFechas() && validarProveedor() && validarEstado() && validarDeposito()) && (vm.buscarFecha || vm.buscarProveedor || vm.buscarEstado || vm.buscarDeposito));
	}

	function validarFechas(){
		return (!vm.buscarFecha || (vm.buscarFecha && vm.fechaDesde && vm.fechaHasta && (vm.fechaDesde<=vm.fechaHasta)  && (vm.fechaHasta<=vm.fechaActual)));
	}

	function validarProveedor(){
		return (!vm.buscarProveedor || (vm.proveedor && vm.proveedor.id) || (vm.empresa && vm.empresa.id));
	}

	function validarEstado(){
		return (!vm.buscarEstado || (vm.estado && vm.estado.id));
	}

	function validarDeposito(){
		return (!vm.buscarDeposito || (vm.deposito && vm.deposito.id));
	}

    $scope.$watch('vm.empresa.nombre', function(){
		if (!vm.empresa) return;
		if (vm.proveedor) vm.proveedor=null;
		ServicioDialogos.abrirDialogoCargando();
		ProveedorEmpresa.query({'empresa':vm.empresa.id}, function(data){
			vm.proveedores = data;
			focus('proveedor');
			ServicioDialogos.cerrarDialogoCargando();
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError();
		});
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoFiltroBusquedaEgreso',DialogoFiltroBusquedaEgreso);

  function DialogoFiltroBusquedaEgreso($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/filtros-busqueda-egreso/filtros-busqueda-egreso.html',
        controller: 'ModalFiltroBusquedaEgresoCtrl as vm',
        resolve: {
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data) {
              return data;
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          },
          deposito: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                return usuario.empleado.deposito;
              } else {
                return ;
              }
            });
          },
          estados: function(EstadoMovimientoTipoMovimiento){
            return EstadoMovimientoTipoMovimiento.query({'id':1}).$promise.then(function(data) {
              return data;
            });
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalFiltroBusquedaEgresoCtrl', ModalFiltroBusquedaEgresoCtrl);

  /** @ngInject */
  function ModalFiltroBusquedaEgresoCtrl(NgTableParams, estados, deposito, empresas, depositos, focus, EgresoFechaDepositoEmpresaEstado, EgresoFechaDepositoSucursalEstado, EgresoEmpresaDepositoEstado, EgresoSucursalDepositoEstado, EgresoFechaDepositoEstado, EgresoFechaDepositoSucursal, EgresoFechaDepositoEmpresa, EgresoFechaEmpresaEstado, EgresoFechaSucursalEstado, EgresoEmpresaEstado, EgresoSucursalEstado, EgresoDepositoEstado, EgresoDepositoSucursal, EgresoDepositoEmpresa, EgresoEntreFechasEmpresa, EgresoEntreFechasSucursal, EgresoEntreFechasEstado, EgresoEntreFechasDeposito, EgresoSucursal, EgresoEmpresa, EgresoEstado, EgresoDeposito, EgresoEntreFechas, $uibModalInstance, SucursalEmpresa, $stateParams, $scope, $filter, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.depositos = orderByFilter(depositos,'nombre',false);
    vm.empresas = orderByFilter(empresas,'nombre',false);
    vm.estados = orderByFilter(estados,'nombre',false);
    vm.fechaActual = new Date();

    vm.busquedaFecha = busquedaFecha;
    vm.busquedaSucursal = busquedaSucursal;
    vm.busquedaDeposito = busquedaDeposito;
    vm.busquedaEstado= busquedaEstado;

    vm.validarFiltros = validarFiltros;

    vm.filtrar = filtrar;
    vm.cerrar = cerrar;
    vm.comprobarPeriodoFechas = comprobarPeriodoFechas;

    function comprobarPeriodoFechas(){
      return  (((vm.fechaHasta - vm.fechaDesde)/86400000)<=550);
    }

    inicializar();

    ServicioDialogos.cerrarDialogoCargando();

    function inicializar(){
		vm.depositoUsuario=deposito;
		if (deposito){
			vm.deposito = deposito;
			vm.buscarDeposito = true;
		}
		editarEstados();
    }

    function editarEstados(){
		var i = null;
		vm.estados.forEach(function(estado, index){
			if (estado.id===8){
				i = index;
			}
		});
		vm.estados.splice(i,1);
    }

	function cerrar(){
		$('.modal-backdrop').remove();
		$uibModalInstance.dismiss();
	}

	function filtrar(){
		if (vm.buscarFecha && !vm.buscarDeposito && !vm.buscarSucursal && !vm.buscarEstado) filtrarPorFechas();
		else if (!vm.buscarFecha && vm.buscarDeposito && !vm.buscarSucursal && !vm.buscarEstado) filtrarPorDeposito();
		else if (!vm.buscarFecha && !vm.buscarDeposito && vm.buscarSucursal && !vm.buscarEstado) filtrarPorSucursalEmpresa();
		else if (!vm.buscarFecha && !vm.buscarDeposito && !vm.buscarSucursal && vm.buscarEstado) filtrarPorEstado();

		else if (vm.buscarFecha && vm.buscarDeposito && !vm.buscarSucursal && !vm.buscarEstado) filtrarPorFechaDeposito();
		else if (vm.buscarFecha && !vm.buscarDeposito && vm.buscarSucursal && !vm.buscarEstado) filtrarPorFechaEmpresaSucursal();
		else if (vm.buscarFecha && !vm.buscarDeposito && !vm.buscarSucursal && vm.buscarEstado) filtrarPorFechaEstado();
		else if (!vm.buscarFecha && vm.buscarDeposito && vm.buscarSucursal && !vm.buscarEstado) filtrarPorDepositoEmpresaSucursal();
		else if (!vm.buscarFecha && vm.buscarDeposito && !vm.buscarSucursal && vm.buscarEstado) filtrarPorDepositoEstado();
		else if (!vm.buscarFecha && !vm.buscarDeposito && vm.buscarSucursal && vm.buscarEstado) filtrarPorSucursalEmpresaEstado();


		else if (vm.buscarFecha && !vm.buscarDeposito && vm.buscarSucursal && vm.buscarEstado) filtrarPorFechaSucursalEmpresaEstado();
		else if (vm.buscarFecha && vm.buscarDeposito && vm.buscarSucursal && !vm.buscarEstado) filtrarPorFechaDepositoSucursalEmpresa();
		else if (vm.buscarFecha && vm.buscarDeposito && !vm.buscarSucursal && vm.buscarEstado) filtrarPorFechaDepositoEstado();
		else if (!vm.buscarFecha && vm.buscarDeposito && vm.buscarSucursal && vm.buscarEstado) filtrarPorDepositoSucursalEmpresaEstado();
			
		else if (vm.buscarFecha && vm.buscarDeposito && vm.buscarSucursal && vm.buscarEstado) filtrarPorTodoEmpresaSucursal();

		else {
			ServicioDialogos.mostrarDialogoInformacion(null, "No se puede filtrar");
		}
	}

	function filtrarPorFechas(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		EgresoEntreFechas.query({'id':1,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada}, function(data){
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorDeposito(){
		ServicioDialogos.abrirDialogoCargando();
		EgresoDeposito.query({'idTipo':1,'idDeposito':vm.deposito.id}, function(data){
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Deposito: "+vm.deposito.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorSucursalEmpresa(){
		if (vm.empresa && vm.empresa.id && vm.sucursal && vm.sucursal.id){
			filtrarPorSucursal();
		} else if (vm.empresa && vm.empresa.id && !vm.sucursal){
			filtrarPorEmpresa();
		}
	}

	function filtrarPorEmpresa(){
		ServicioDialogos.abrirDialogoCargando();
		EgresoEmpresa.query({'idTipo':1,'idEmpresa':vm.empresa.id}, function(data){
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Empresa: "+vm.empresa.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorSucursal(){
		ServicioDialogos.abrirDialogoCargando();
		EgresoSucursal.query({'idTipo':1,'idSucursal':vm.sucursal.id}, function(data){
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Sucursal: "+vm.sucursal.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorEstado(){
		ServicioDialogos.abrirDialogoCargando();
		EgresoEstado.query({'idTipo':1,'idEstado':vm.estado.id}, function(data){
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Estado: "+vm.estado.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorFechaDeposito(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		EgresoEntreFechasDeposito.query({'idTipo':1,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada, 'idDeposito':vm.deposito.id}, function(data){
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta, "Depósito: "+vm.deposito.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}
	function filtrarPorFechaEmpresaSucursal(){
		if (vm.empresa && vm.empresa.id && vm.sucursal && vm.sucursal.id){
			filtrarPorFechaSucursal();
		} else if (vm.empresa && vm.empresa.id && !vm.sucursal){
			filtrarPorFechaEmpresa();
		}
	}

	function filtrarPorFechaEmpresa(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR FECHA Y EMPRESA");
		EgresoEntreFechasEmpresa.query({'idTipo':1,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada, 'idEmpresa':vm.empresa.id}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta, "Empresa: "+vm.empresa.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorFechaSucursal(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR FECHA Y Sucursal");
		EgresoEntreFechasSucursal.query({'idTipo':1,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada, 'idSucursal':vm.sucursal.id}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta, "Sucursal: "+vm.sucursal.nombre.toUpperCase()+" ("+vm.sucursal.empresa.nombre.toUpperCase()+")"]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorFechaEstado(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR FECHA Y ESTADO");
		EgresoEntreFechasEstado.query({'idTipo':1,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada, 'idEstado':vm.estado.id}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta, "Estado: "+vm.estado.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorDepositoEmpresaSucursal(){
		//console.log("FILTRAR SOLO POR Deposito Y PROVEEDOR");
		if (vm.empresa && vm.empresa.id && vm.sucursal && vm.sucursal.id){
			filtrarPorDepositoSucursal();
		} else if (vm.empresa && vm.empresa.id && !vm.sucursal){
			filtrarPorDepositoEmpresa();
		}
	}

	function filtrarPorDepositoEmpresa(){
		ServicioDialogos.abrirDialogoCargando();
		//console.log("FILTRAR POR DEPOSITO Y EMPRESA");
		EgresoDepositoEmpresa.query({'idTipo':1,'idDeposito':vm.deposito.id, 'idEmpresa':vm.empresa.id}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Depósito: "+vm.deposito.nombre.toUpperCase(), "Empresa: "+vm.empresa.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorDepositoSucursal(){
		ServicioDialogos.abrirDialogoCargando();
		//console.log("FILTRAR POR DEPOSITO Y PROVEEDOR");
		EgresoDepositoSucursal.query({'idTipo':1,'idDeposito':vm.deposito.id, 'idSucursal':vm.sucursal.id}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Depósito: "+vm.deposito.nombre.toUpperCase(), "Sucursal: "+vm.sucursal.nombre.toUpperCase()+" ("+vm.sucursal.empresa.nombre.toUpperCase()+")"]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorDepositoEstado(){
		ServicioDialogos.abrirDialogoCargando();
		//console.log("FILTRAR POR DEPOSITO Y ESTADO");
		EgresoDepositoEstado.query({'idTipo':1,'idDeposito':vm.deposito.id, 'idEstado':vm.estado.id}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Depósito: "+vm.deposito.nombre.toUpperCase(), "Estado: "+vm.estado.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}
	function filtrarPorSucursalEmpresaEstado(){
		//console.log("FILTRAR SOLO POR PROVEEDOR/EMPRESA Y ESTADO");
		if (vm.empresa && vm.empresa.id && vm.sucursal && vm.sucursal.id){
			filtrarPorSucursalEstado();
		} else if (vm.empresa && vm.empresa.id && !vm.sucursal){
			filtrarPorEmpresaEstado();
		}
	}

	function filtrarPorSucursalEstado(){
		ServicioDialogos.abrirDialogoCargando();
		//console.log("FILTRAR POR ESTADO Y PROVEEDOR");
		EgresoSucursalEstado.query({'idTipo':1,'idSucursal':vm.sucursal.id, 'idEstado':vm.estado.id}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Estado: "+vm.estado.nombre.toUpperCase(), "Sucursal: "+vm.sucursal.nombre.toUpperCase()+" ("+vm.sucursal.empresa.nombre.toUpperCase()+")"]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorEmpresaEstado(){
		ServicioDialogos.abrirDialogoCargando();
		//console.log("FILTRAR POR EMPRESA Y ESTADO");
		EgresoEmpresaEstado.query({'idTipo':1,'idEmpresa':vm.empresa.id, 'idEstado':vm.estado.id}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Estado: "+vm.estado.nombre.toUpperCase(), "Empresa: "+vm.empresa.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorFechaSucursalEmpresaEstado(){
		if (vm.empresa && vm.empresa.id && vm.sucursal && vm.sucursal.id){
			filtrarPorFechaSucursalEstado();
		} else if (vm.empresa && vm.empresa.id && !vm.sucursal){
			filtrarPorFechaEmpresaEstado();
		}
	}

	function filtrarPorFechaSucursalEstado(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR Fecha Sucursal Y ESTADO");
		EgresoFechaSucursalEstado.query({'idTipo':1,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada,'idSucursal':vm.sucursal.id, 'idEstado':vm.estado.id}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta,"Estado: "+vm.estado.nombre.toUpperCase(), "Sucursal: "+vm.sucursal.nombre.toUpperCase()+" ("+vm.sucursal.empresa.nombre.toUpperCase()+")"]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorFechaEmpresaEstado(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR FECHA EMPRESA Y ESTADO");
		EgresoFechaEmpresaEstado.query({'idTipo':1,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada,'idEmpresa':vm.empresa.id, 'idEstado':vm.estado.id}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta,"Estado: "+vm.estado.nombre.toUpperCase(), "Empresa: "+vm.empresa.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorFechaDepositoSucursalEmpresa(){
		//console.log("FILTRAR POR TODO MENOS ESTADO",vm.sucursal, vm.empresa);
		if (vm.empresa && vm.empresa.id && vm.sucursal && vm.sucursal.id){
			filtrarPorFechaDepositoSucursal();
		} else if (vm.empresa && vm.empresa.id && !vm.sucursal){
			filtrarPorFechaDepositoEmpresa();
		}
	}

	function filtrarPorFechaDepositoSucursal(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR Fecha Sucursal Y DEPOSITO");
		EgresoFechaDepositoSucursal.query({'idTipo':1,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada,'idDeposito':vm.deposito.id, 'idSucursal':vm.sucursal.id}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta,"Depósito: "+vm.deposito.nombre.toUpperCase(), "Sucursal: "+vm.sucursal.nombre.toUpperCase()+" ("+vm.sucursal.empresa.nombre.toUpperCase()+")"]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorFechaDepositoEmpresa(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR FECHA EMPRESA Y DEPOSITO");
		EgresoFechaDepositoEmpresa.query({'idTipo':1,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada, 'idDeposito':vm.deposito.id, 'idEmpresa':vm.empresa.id}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta,"Depósito: "+vm.deposito.nombre.toUpperCase(), "Empresa: "+vm.empresa.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorFechaDepositoEstado(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR FECHA ESTADO Y DEPOSITO");
		EgresoFechaDepositoEstado.query({'idTipo':1,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada, 'idDeposito':vm.deposito.id, 'idEstado':vm.estado.id}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta,"Depósito: "+vm.deposito.nombre.toUpperCase(), "Estado: "+vm.estado.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}
	function filtrarPorDepositoSucursalEmpresaEstado(){
		//console.log("FILTRAR POR TODO MENOS FECHA",vm.sucursal, vm.empresa);
		if (vm.empresa && vm.empresa.id && vm.sucursal && vm.sucursal.id){
			filtrarPorDepositoSucursalEstado();
		} else if (vm.empresa && vm.empresa.id && !vm.sucursal){
			filtrarPorDepositoEmpresaEstado();
		}
	}

	function filtrarPorDepositoSucursalEstado(){
	ServicioDialogos.abrirDialogoCargando();
		//console.log("FILTRAR POR SUCURSAL DEPOSITO Y ESTADO");
		EgresoSucursalDepositoEstado.query({'idTipo':1,'idSucursal':vm.sucursal.id,'idDeposito':vm.deposito.id, 'idEstado':vm.estado.id}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Estado: "+vm.estado.nombre.toUpperCase(), "Depósito: "+vm.deposito.nombre.toUpperCase(),"Sucursal: "+vm.sucursal.nombre.toUpperCase()+" ("+vm.sucursal.empresa.nombre.toUpperCase()+")"]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorDepositoEmpresaEstado(){
		ServicioDialogos.abrirDialogoCargando();
		//console.log("FILTRAR POR EMPRESA DEPOSITO Y ESTADO");
		EgresoEmpresaDepositoEstado.query({'idTipo':1,'idEmpresa':vm.empresa.id,'idDeposito':vm.deposito.id, 'idEstado':vm.estado.id}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Estado: "+vm.estado.nombre.toUpperCase(), "Depósito: "+vm.deposito.nombre.toUpperCase(), "Empresa: "+vm.empresa.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorTodoEmpresaSucursal(){
		//console.log("FILTRAR POR TODO!!!!!");
		if (vm.empresa && vm.empresa.id && vm.sucursal && vm.sucursal.id){
			filtrarPorTodoSucursal();
		} else if (vm.empresa && vm.empresa.id && !vm.sucursal){
			filtrarPorTodoEmpresa();
		}
	}

	function filtrarPorTodoSucursal(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR FECHA ESTADO SUCURSAL Y DEPOSITO");
		EgresoFechaDepositoSucursalEstado.query({'idTipo':1,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada, 'idDeposito':vm.deposito.id,'idSucursal':vm.sucursal.id, 'idEstado':vm.estado.id}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta,"Depósito: "+vm.deposito.nombre.toUpperCase(), "Sucursal: "+vm.sucursal.nombre.toUpperCase()+" ("+vm.sucursal.empresa.nombre.toUpperCase()+")","Estado: "+vm.estado.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function filtrarPorTodoEmpresa(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		//console.log("FILTRAR POR FECHA ESTADO Empresa Y DEPOSITO");
		EgresoFechaDepositoEmpresaEstado.query({'idTipo':1,'inicio':vm.fechaDesde, 'fin':fechaHastaFormateada, 'idDeposito':vm.deposito.id,'idEmpresa':vm.empresa.id, 'idEstado':vm.estado.id}, function(data){
			//console.log(data);
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Entre: "+fechaDesde+" - "+fechaHasta,"Depósito: "+vm.deposito.nombre.toUpperCase(), "Empresa: "+vm.empresa.nombre.toUpperCase(),"Estado: "+vm.estado.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
	}

	function busquedaFecha(){
		if (!vm.buscarFecha){
			vm.fechaDesde = null;
			vm.fechaHasta = null;
			vm.form.fechaDesde.$setPristine();
			vm.form.fechaHasta.$setPristine();
		}
	}

	function busquedaEstado(){
		if (!vm.buscarEstado){
			vm.estado = null;
		}
	}

	function busquedaDeposito(){
		if (!vm.buscarDeposito){
			vm.deposito = null;
		}
	}

	function busquedaSucursal(){
		if (!vm.buscarSucursal){
			if (vm.empresa) vm.empresa = null;
			if (vm.sucursal) vm.sucursal = null;
		}
	}

	function validarFiltros(){
		return !((validarFechas() && validarSucursal() && validarEstado() && validarDeposito()) && (vm.buscarFecha || vm.buscarSucursal || vm.buscarEstado || vm.buscarDeposito));
	}

	function validarFechas(){
		return (!vm.buscarFecha || (vm.buscarFecha && vm.fechaDesde && vm.fechaHasta && (vm.fechaDesde<=vm.fechaHasta)  && (vm.fechaHasta<=vm.fechaActual)));
	}

	function validarSucursal(){
		return (!vm.buscarSucursal || (vm.sucursal && vm.sucursal.id) || (vm.empresa && vm.empresa.id));
	}

	function validarEstado(){
		return (!vm.buscarEstado || (vm.estado && vm.estado.id));
	}

	function validarDeposito(){
		return (!vm.buscarDeposito || (vm.deposito && vm.deposito.id));
	}

    $scope.$watch('vm.empresa.nombre', function(){
		if (!vm.empresa) return;
		if (vm.sucursal) vm.sucursal=null;
		ServicioDialogos.abrirDialogoCargando();
		SucursalEmpresa.query({'id':vm.empresa.id}, function(data){
			vm.sucursales = data;
			focus('sucursal');
			ServicioDialogos.cerrarDialogoCargando();
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError();
		});
    });

  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoFiltroBusquedaEgresoSuministro',DialogoFiltroBusquedaEgresoSuministro);

  function DialogoFiltroBusquedaEgresoSuministro($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/filtros-busqueda-egreso-suministro/filtros-busqueda-egreso-suministro.html',
        controller: 'ModalFiltroBusquedaEgresoSuministroCtrl as vm',
        resolve: {
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data) {
              return data;
            });
          },
          depositos: function(DepositoSoloNaves, Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              if (usuario.empleado && usuario.empleado.deposito && usuario.empleado.deposito.id){
                var depos = [];
                return DepositoSoloNaves.get({id:usuario.empleado.deposito.id}).$promise.then(function(depo){
                  depos.push(depo);
                  return depos;
                });
              } else {
                return DepositoSoloNaves.query().$promise.then(function(data){
                  return data;
                });
              }
            });
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

/*'use strict';
angular.module('proyecto-az-suministro')
  .factory('IngresoTipoDepositoFechaDesdeHasta', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/detallemovimiento?tipoMovimiento.id=:idTipoMovimiento&&tipoSuministro.id=:idTipoSuministro&&deposito.id=:idDeposito&&fechaDesde=:fechaDesde&&fechaHasta=:fechaHasta" ,{idTipoMovimiento:'@idTipoMovimiento', idTipoSuministro:'@idTipoSuministro', idDeposito:'@idDeposito',fechaDesde:'@fechaDesde', fechaHasta:'@fechaHasta'});
  });*/
(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalFiltroBusquedaEgresoSuministroCtrl', ModalFiltroBusquedaEgresoSuministroCtrl);

  /** @ngInject */
  function ModalFiltroBusquedaEgresoSuministroCtrl(NgTableParams, empresas, depositos, focus, MovimientoTipoDepositoFechaDesdeHasta, GrupoEmpresa, TiposPorEmpresa, TipoSuministroFamilia, FamiliaSuministroGrupo, $uibModalInstance, $scope, $filter, orderByFilter, ServicioDialogos) {

    var vm = this;
    vm.empresas = orderByFilter(empresas,'nombre',false);
    vm.depositos = orderByFilter(depositos,'nombre',false);

    vm.agregar = agregar;
    vm.cerrar = cerrar;
    vm.cambioRadio = cambioRadio;
    vm.validarFiltros = validarFiltros;
    vm.filtrar = filtrar;
    vm.fechaActual = new Date();

    vm.comprobarPeriodoFechas = comprobarPeriodoFechas;

    function comprobarPeriodoFechas(){
      return  (((vm.fechaHasta - vm.fechaDesde)/86400000)<=550);
    }

    vm.radio = 'jerarquizada';

    ServicioDialogos.cerrarDialogoCargando();

    function filtrar(){
		ServicioDialogos.abrirDialogoCargando();
		var fechaDesde = $filter('date')(vm.fechaDesde, "dd/MM/yyyy");
		var fechaHasta = $filter('date')(vm.fechaHasta, "dd/MM/yyyy");
		var fechaHastaFormateada = angular.copy(vm.fechaHasta);
		fechaHastaFormateada.setHours(23);
		fechaHastaFormateada.setMinutes(59);
		fechaHastaFormateada.setSeconds(59);
		MovimientoTipoDepositoFechaDesdeHasta.query({'idTipoMovimiento':1,'idTipoSuministro':vm.tipoSuministro.id,'idDeposito':vm.deposito.id, 'fechaDesde':vm.fechaDesde, 'fechaHasta':fechaHastaFormateada}, function(data){
			ServicioDialogos.cerrarDialogoCargando();
			$('.modal-backdrop').remove();
			$uibModalInstance.close({detalles:data, filtros:["Tipo de suministro: "+vm.tipoSuministro.nombre.toUpperCase()+" - Familia: "+vm.tipoSuministro.familiaSuministro.nombre.toUpperCase()+" - Grupo: "+vm.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase(), "Empresa: "+vm.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase(), "Entre: "+fechaDesde+" - "+fechaHasta, "Depósito: "+vm.deposito.nombre.toUpperCase()]});
		}, function(err){
			console.log(err);
			ServicioDialogos.cerrarDialogoCargando();
			ServicioDialogos.mostrarDialogoError(null, "No se pudo filtrar");
		});
    }

    function validarFiltros(){
		return (vm.empresa && vm.empresa.id) && (vm.deposito && vm.deposito.id) && (vm.tipoSuministro && vm.tipoSuministro.id) && vm.fechaDesde && vm.fechaHasta;
    }

    function cambioRadio(){
      if (vm.radio=='jerarquizada'){
        vm.tipoSuministroCompleto=null;
      } else {
        if (vm.tipoSuministro && vm.tipoSuministro.id) vm.tipoSuministro=null;
        if (vm.familiaSuministro && vm.familiaSuministro.id) vm.familiaSuministro=null;
        if (vm.grupo && vm.grupo.id) vm.grupo=null;
      }
    }

    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.dismiss();
    }

    $scope.$watch('vm.grupo.nombre', function(){
      if (vm.familiaSuministro) vm.familiaSuministro=null;
      if (!vm.grupo) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupo.id}, function(data){
        vm.familias = orderByFilter(data,'nombre',false);
        focus('familia');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.empresa.id', function(){
      if (vm.grupo) vm.grupo=null;
      if (vm.tipoSuministroCompleto) vm.tipoSuministroCompleto=null;
      if (!vm.empresa) return;
      ServicioDialogos.abrirDialogoCargando();
      GrupoEmpresa.query({id:vm.empresa.id}, function(data){
        vm.grupos = orderByFilter(data,'nombre',false);
        focus('grupo');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.tipoSuministroCompleto.nombre', function(){
      vm.tipoSuministro=vm.tipoSuministroCompleto;
      //if (!vm.tipoSuministroCompleto || vm.tipoSuministroCompleto.inventariable===false) return;
    });

    $scope.$watch('vm.familiaSuministro.nombre', function(){
      if (vm.tipoSuministro) vm.tipoSuministro=null;
      if (!vm.familiaSuministro) return;
      ServicioDialogos.abrirDialogoCargando();
      TipoSuministroFamilia.query({id:vm.familiaSuministro.id}, function(data){
        vm.tipos = orderByFilter(data,'nombre',false);
        focus('tipo');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.radio', function(){
      if (vm.radio=='directa') {
        ServicioDialogos.abrirDialogoCargando();
        TiposPorEmpresa.query({idEmpresa:vm.empresa.id}, function(data){
          vm.tiposCompletos = orderByFilter(data,'nombre',false);
          ServicioDialogos.cerrarDialogoCargando();
        }, function(err){
          console.log(err);
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError();
        });

      }
    });

    function agregar(){
      var lista = [];
      if (vm.tipoSuministro && !vm.tipoSuministro.inventariable){
        lista = vm.listaNoInventariables;
      } else {
        lista = vm.bienes;
      }
      $uibModalInstance.close({tipoSuministro:vm.tipoSuministro, suministros:lista});
    }

  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoElegirTipoSuministro',DialogoElegirTipoSuministro);

  function DialogoElegirTipoSuministro($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/elegir-tipo-suministro/modal-elegir-tipo-suministro.html',
        controller: 'ModalElegirTipoSuministroCtrl as vm',
        resolve: {
          grupos: function(GrupoEmpresa){
            return GrupoEmpresa.query({id:config.empresa.id}).$promise.then(function(data) {
              return data;
            });
          },
          empresa: function(){
            return config.empresa.id;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalElegirTipoSuministroCtrl', ModalElegirTipoSuministroCtrl);

  /** @ngInject */
  function ModalElegirTipoSuministroCtrl(NgTableParams, focus, empresa, TiposPorEmpresa, ServicioModales, $uibModalInstance, HeaderBarService, TipoSuministroFamilia, FamiliaSuministroGrupo, grupos, $timeout, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.grupos = orderByFilter(grupos,'nombre',false);
    vm.empresaId = empresa;

    vm.agregar = agregar;
    vm.cerrar = cerrar;
    vm.cambioRadio = cambioRadio;


    vm.radio = 'jerarquizada';

    ServicioDialogos.cerrarDialogoCargando();


    function agregar(){
      $uibModalInstance.close({tipoSuministro:vm.tipoSuministro});
    }

    function cambioRadio(){
      if (vm.radio=='jerarquizada'){
        vm.tipoSuministroCompleto=null;
      } else {
        if (vm.tipoSuministro && vm.tipoSuministro.id) vm.tipoSuministro=null;
        if (vm.familiaSuministro && vm.familiaSuministro.id) vm.familiaSuministro=null;
        if (vm.grupo && vm.grupo.id) vm.grupo=null;
      }
    }

    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.dismiss();
    }

    $scope.$watch('vm.grupo.nombre', function(){
      if (vm.familiaSuministro) vm.familiaSuministro=null;
      if (!vm.grupo) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupo.id}, function(data){
        vm.familias = orderByFilter(data,'nombre',false);
        focus('familia');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.familiaSuministro.nombre', function(){
      if (vm.tipoSuministro) vm.tipoSuministro=null;
      if (!vm.familiaSuministro) return;
      ServicioDialogos.abrirDialogoCargando();
      TipoSuministroFamilia.query({id:vm.familiaSuministro.id}, function(data){
        vm.tipos = orderByFilter(data,'nombre',false);
        focus('tipo');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.tipoSuministroCompleto.nombre', function(){
      vm.tipoSuministro=vm.tipoSuministroCompleto;
      //if (!vm.tipoSuministroCompleto || vm.tipoSuministroCompleto.inventariable===false) return;
    });

    $scope.$watch('vm.radio', function(){
      if (vm.radio=='directa') {
        ServicioDialogos.abrirDialogoCargando();
        TiposPorEmpresa.query({idEmpresa:vm.empresaId}, function(data){
          vm.tiposCompletos = orderByFilter(data,'nombre',false);
          ServicioDialogos.cerrarDialogoCargando();
        }, function(err){
          console.log(err);
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError();
        });

      }
    });
   
  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoCargarSucursalesEgresoMultipleExcel', DialogoCargarSucursalesEgresoMultipleExcel);

  function DialogoCargarSucursalesEgresoMultipleExcel($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/egreso-multiple-excel/egreso-multiple-excel.html',
        controller: 'ModalCargarSucursalesEgresoMultipleExcelCtrl as vm',
        resolve: {
          sucursalesConsumoTope: function(){
            return angular.copy(config.sucursalesConsumoTope);
          },
          tipoSuministro: function(){
            return config.tipoSuministro;
          },
          cantidadDisponible: function(){
            return config.cantidadDisponible;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalCargarSucursalesEgresoMultipleExcelCtrl', ModalCargarSucursalesEgresoMultipleExcelCtrl);

  /** @ngInject */
  function ModalCargarSucursalesEgresoMultipleExcelCtrl(NgTableParams, $timeout, tipoSuministro, sucursalesConsumoTope, cantidadDisponible, $uibModalInstance, ServicioDialogos, $scope) {

    var vm = this;
    vm.cerrar = cerrar;
    vm.buscarExcel = buscarExcel;
    vm.tipoSuministroSeleccionado = tipoSuministro.nombre.toUpperCase()+" ("+tipoSuministro.familiaSuministro.nombre.toUpperCase()+") - ("+tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+")";

    vm.repetidos = [];
    vm.correctos = [];
    vm.erroneos = [];
    vm.unicos = [];
    vm.incompletos = [];
    vm.seleccionados = [];

    vm.cantidadTotal = 0;
    var cantidadRegistros = 0;

    crearTablas();
    ServicioDialogos.cerrarDialogoCargando();

    function buscarExcel(){
      if (vm.file===undefined || vm.file===null) {
        ServicioDialogos.mostrarDialogoError(null, "No ha elegido un archivo .xlsx");
        return;
      } else {
        var reader = new FileReader();
        ServicioDialogos.abrirDialogoCargando();
        reader.onload = function (e) {
          var bstr = e.target.result;
          var workbook = XLSX.read(bstr, {type:'binary'});
          var first_sheet_name = workbook.SheetNames[0];
          var worksheet = workbook.Sheets[first_sheet_name];
          var sucursales = XLSX.utils.sheet_to_json(worksheet);
          cantidadRegistros = sucursales.length;
          comprobarElementos(sucursales);
        };
        reader.readAsBinaryString(vm.file);
      }
    }

    function crearTablas(){
      vm.tableParamsCorrectos = new NgTableParams({
        page: 1,
        count: 10
      });
      vm.tableParamsIncompletos = new NgTableParams({
        page: 1,
        count: 10
      });
      vm.tableParamsErroneos = new NgTableParams({
        page: 1,
        noPager: true,
        count: 10
      });
    }

    function actualizarTablas(){
      vm.tableParamsCorrectos.settings({
        data: vm.correctos,
        noPager: true,
        count: []
      });
      vm.tableParamsCorrectos.reload();
      vm.tableParamsErroneos.settings({
        data: vm.erroneos,
        noPager: true,
        count: []
      });
      vm.tableParamsErroneos.reload();
      vm.tableParamsIncompletos.settings({
        data: vm.incompletos,
        noPager: true,
        count: []
      });
      vm.tableParamsIncompletos.reload();
    }

    function quitarIncompletos(sucursales){
      var sucs = [];
      sucursales.forEach(function(sucursal){
        if (!estaCompleto(sucursal)){
          vm.incompletos.push(sucursal);
        } else {
          sucs.push(sucursal);
        }
      });
      return sucs;
    }


    function comprobarElementos(sucursales){
      comprobarRepetidos(sucursales);
      vm.unicos.forEach(function(sucursal){
        comprobar(sucursal);
      });
      $timeout(function() {
        ServicioDialogos.cerrarDialogoCargando();
        if (vm.seleccionados.length>0){
          mostrarResultados();
        } else {
          vm.formatoIncorrecto = true;
          if (vm.correctos.length>0) vm.formatoIncorrecto = false; actualizarTablas();
          ServicioDialogos.mostrarDialogoError(null, "No fue posible asignar sucursales ni cantidades.");
          vm.resultado = true;
        }
      }, 500);
    }

    function mostrarResultados(){
      if (vm.seleccionados.length===cantidadRegistros){
        ServicioDialogos.mostrarDialogoExito('Éxito', 'Se han asignado todas las sucursales del archivo');
        mostrarTablas();
      } else {
        ServicioDialogos.mostrarDialogoInformacion('Éxito', 'Se ha procesado correctamente el archivo');
        mostrarTablas();
      }
    }

    function mostrarTablas(){
      vm.resultado = true;
      vm.formatoIncorrecto = false;
      actualizarTablas();
    }

    function validarCantidad(cantidad){
      return Number.isInteger(+cantidad) && cantidad>=0;
    }

    function comprobar(sucursal){
      if (validarCantidad(sucursal.cantidad)){
        validarSucursal(sucursal);
      } else {
        sucursal.estado = 'Cantidad ingresada es incorrecta';
        vm.erroneos.push(sucursal);
      }
    }

    function validarSucursal(sucursal){
      sucursal.cantidad = parseInt(sucursal.cantidad);
      var ban = false;
      sucursalesConsumoTope.forEach(function(item){
        if (sucursal.codigoSucursal == item.sucursal.codigoSucursal){
          if (!item.asignado && !item.seleccionado) {
            ban = true;
            if (sucursal.cantidad+vm.cantidadTotal<=cantidadDisponible){
              item.cantidadExcel = sucursal.cantidad;
              vm.cantidadTotal += sucursal.cantidad;
              vm.seleccionados.push(item);
              sucursal.estado = "Asignado";
              sucursal.sucursal = item.sucursal;
              vm.correctos.push(sucursal);
            } else {
              sucursal.sucursal = item.sucursal;
              sucursal.estado = 'No hay suficiente stock';
              vm.correctos.push(sucursal);
            }
          } else {
            ban = true;
            sucursal.sucursal = item.sucursal;
            sucursal.estado = 'El suministro ya fue asignado';
            vm.correctos.push(sucursal);
          }
        }
      });
      if (!ban){
        sucursal.estado = 'Código de sucursal incorrecto';
        vm.erroneos.push(sucursal);
      }

    }

    function estaCompleto(sucursal){
      return (sucursal.codigoSucursal!==null && sucursal.codigoSucursal!==undefined) && (sucursal.cantidad!==null && sucursal.cantidad!==undefined);
    }

    function validarCantidadTopeExcel(cantidad){
      return Number.isInteger(+cantidad) && cantidad>=0;
    }

    function comprobarRepetidos(sucursales){
      sucursales = quitarIncompletos(sucursales);
      var ban = false;
      sucursales.forEach(function(suc){
        if (suc.codigoSucursal) {
          ban = false;
          vm.unicos.forEach(function(item){
            if (suc.codigoSucursal===item.codigoSucursal) {
              ban = true;
            }
          });
          if (!ban) {
            vm.unicos.push(suc);
          } else {
            vm.repetidos.push(suc);
          }
        }
      });
    }

    $scope.cargarArchivo = function(file){
      vm.file = file;
    };

    function cerrar(){
      if (vm.resultado){
        if ($('.modal.in').length<=1){
          $('.modal-backdrop').remove();
        }
        $uibModalInstance.close({
          sucursales: vm.seleccionados
        });
      } else {
        if ($('.modal.in').length<=1){
          $('.modal-backdrop').remove();
        }
        $uibModalInstance.dismiss();
      }
    }
  
  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoEditarSuministroNoInventariable',DialogoEditarSuministroNoInventariable);

  function DialogoEditarSuministroNoInventariable($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/editar-suministro-no-inventariable/editar-suministro-no-inventariable.html',
        controller: 'ModalEditarSuministroNoInventariableCtrl as vm',
        resolve: {
          suministro: function(SuministroNoInventariable){
            if (config.suministro){
              return SuministroNoInventariable.get({id:config.suministro.id}).$promise.then(function(data) {
                return data;
              });
            } else {
              return {};
            }
          },
          modo: function(){
            return config.modo;
          },
          tipos: function(TipoSuministroFamiliaInventariable, $stateParams){
            if (config.suministro){
              var idFamilia = config.suministro.tipoSuministro.familiaSuministro.id;
              return TipoSuministroFamiliaInventariable.query({idFamilia:idFamilia, inventariable:false}).$promise.then(function(data){
                return data;
              });
            } else {
              return null;
            }
          },
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalEditarSuministroNoInventariableCtrl', ModalEditarSuministroNoInventariableCtrl);

  /** @ngInject */
  function ModalEditarSuministroNoInventariableCtrl(NgTableParams, $filter, suministro, $uibModalInstance, SuministroNoInventariable, SuministroInventarioEmpresa, SuministroTipoSerie, tipos, modo, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.cerrar = cerrar;
    vm.suministro = suministro;
    inicializar();
    vm.editarObjeto = editarObjeto;
    vm.modo = modo;

    ServicioDialogos.cerrarDialogoCargando();


    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
    }

    function inicializar(){
      setearObjeto();
      vm.suministro.fechaVencimiento = new Date(vm.suministro.fechaVencimiento);
    }


    function setearObjeto(){
        vm.tipos = tipos;
        vm.empresaMayus = vm.suministro.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase();
        vm.grupoMayus = vm.suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase();
        vm.familiaMayus = vm.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase();
        vm.tipoSuministro = vm.suministro.tipoSuministro;
    }

    function esEditar() {
      return vm.modo=='editar';
    }

    function editarObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el suministro?', function(){
        editarSuministro();
      },null,false);
    }


    function guardarOEditar(){
      if (esEditar()){
        editarSuministro();
      }
    }

    function editarSuministro(){
      SuministroNoInventariable.update(vm.suministro, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado el suministro correctamente', function(){
          if ($('.modal.in').length<=1){
            $('.modal-backdrop').remove();
          }
          $uibModalInstance.close({
            suministroEditado : data
          });
        });
      }, function(err){
        console.error(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar el tipo de suministro");
      });
    }




  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoEgresoMultipleAutomatico',DialogoEgresoMultipleAutomatico);

  function DialogoEgresoMultipleAutomatico($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/egreso-multiple-automatico/egreso-multiple-automatico.html',
        controller: 'ModalEgresoMultipleAutomaticoCtrl as vm',
        resolve: {
          sucursalesConsumoTope: function(SucursalesTopesProducto){
            return SucursalesTopesProducto.query({idTipo:config.tipoSuministro.id, idDeposito: config.deposito.id}).$promise.then(function(data){
              return data;
            });
          },
          deposito: function(SucursalesTopesProducto){
            return config.deposito;
          },
          tipoSuministro: function(){
            return config.tipoSuministro;
          },
          sucursalesSeleccionadas: function(){
            return config.sucursalesSeleccionadas;
          },
          listaNoInventariables: function(){
            return config.listaNoInventariables;
          },
          cantidadDisponible: function(){
            return config.cantidadDisponible;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalEgresoMultipleAutomaticoCtrl', ModalEgresoMultipleAutomaticoCtrl);

  /** @ngInject */
  function ModalEgresoMultipleAutomaticoCtrl(NgTableParams, $timeout, cantidadDisponible, deposito, listaNoInventariables, sucursalesConsumoTope, tipoSuministro, $uibModalInstance, ServicioModales, sucursalesSeleccionadas, $stateParams, $filter, $scope, ServicioDialogos) {

    var vm = this;
    vm.sucursalesConsumoTope = sucursalesConsumoTope;
    vm.cerrar = cerrar;

    vm.habilitarBoton = habilitarBoton;
    vm.armarDetalles = armarDetalles;
    vm.cantidadSeleccionada = cantidadSeleccionada;
    vm.tildar = tildar;
    vm.asignarSucursalesExcel = asignarSucursalesExcel;

    inicializar();
    ServicioDialogos.cerrarDialogoCargando();

    function inicializar(){
      deshabilitarAsignadas();
      vm.cantidadTotal = cantidadDisponible;
      vm.tipoSuministroSeleccionado = tipoSuministro.nombre.toUpperCase()+" ("+tipoSuministro.familiaSuministro.nombre.toUpperCase()+") - ("+tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+")";
      crearTablas();
      actualizarTabla();
    }

    function asignarSucursalesExcel(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalCargarSucursalesEgresoMultipleExcel({
        onResult: function(resultado) {
          asignarViaExcel(resultado.sucursales);
        },
        sucursalesConsumoTope: vm.sucursalesConsumoTope,
        cantidadDisponible: vm.cantidadTotal-vm.cantidadSeleccionada(),
        tipoSuministro: tipoSuministro
      });
    }

    function asignarViaExcel(sucursales){
      sucursales.forEach(function(suc){
        vm.sucursalesConsumoTope.forEach(function(item){
          if (suc.sucursal.id===item.sucursal.id){
            item.seleccionado = true;
            item.cantidadSolicitada = suc.cantidadExcel;
          }
        });
      });
    }

    function tildar(detalle){
      if (!detalle.seleccionado) detalle.cantidadSolicitada = null;
    }

    function armarDetalles(){
      ServicioDialogos.abrirDialogoCargando();
      var sucursalesAsignadas = [];
      vm.sucursalesConsumoTope.forEach(function(sucursal){
        if (sucursal.seleccionado){
          asignarCantidades(sucursal);
          sucursalesAsignadas.push(sucursal);
        }
      });
      $timeout(function() {
        ServicioDialogos.cerrarDialogoCargando();
        mostrarResultado(sucursalesAsignadas);
      }, 100);
    }

    function mostrarResultado(sucursales){
      var cant = 0;
      var cantidad = 0;
      sucursales.forEach(function(suc){
        if (suc.suministrosAsignados) {
          cant +=1;
          suc.suministrosAsignados.forEach(function(item){
            cantidad += item.cantidad;
          });
        }
      });
      if (cant===sucursales.length){
        ServicioDialogos.mostrarDialogoGuardadoExito('Éxito', 'Se han asignados todos los suministros', function(){
          cerrarDialogo(sucursales, cantidad);
        });
      } else if (cant>0){
        ServicioDialogos.mostrarDialogoInformacionConFuncion('Éxito', 'Se asignó al menos un suministro', function(){
          cerrarDialogo(sucursales, cantidad);
        });
      } else {
        ServicioDialogos.mostrarDialogoError('Atención', 'No se pudo asignar ningún suministro');
        cerrarDialogo(sucursales, cantidad);
      }
    }

    function cerrarDialogo(sucursales, cantidad){
      ServicioDialogos.abrirDialogoCargando();
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.close({
        sucursales: agregarDetalles(sucursales),
        cantidad: cantidad
      });
      limpiarTodo();
    }

    function agregarDetalles(seleccionadas){
      var sucursales = [];
      var detalles = [];
      seleccionadas.forEach(function(item){
        detalles = item.suministrosAsignados? item.suministrosAsignados : [];
        sucursales.push({
          sucursal: item.sucursal,
          detalles: detalles
        });
      });
      return sucursales;
    }

    function comprobarSuministros(cantidad, suministros){
      if (suministros.length==0) return false;
      var cant = 0;
      suministros.forEach(function(sum){
        cant += sum.cantidad;
      });
      return cant>=cantidad;
    }

    function obtenerListaSuministros(){
      listaNoInventariables = $filter('orderBy')(listaNoInventariables, [ordenarPorYaEmpezado, ordenarPorNavePorDefecto,"suministro.fechaVencimiento", "fecha","suministro.ubicacion.nivel.numeroNivel", "suministro.cantidad"], false);
      return listaNoInventariables;
    }

    function ordenarPorNavePorDefecto(s){
      if (deposito.idNaveBusqueda){
        return s.ubicacion.nivel.estante.estructura.pasillo.nave.id==deposito.idNaveBusqueda? 0 : 1;
      }
    }

    function ordenarPorYaEmpezado(s){
      if (s.cantidadOriginal){
        return s.cantidadOriginal==s.cantidad? 1 : 0;
      }
    }

    function asignarCantidades(sucursal){
      if (comprobarSuministros(sucursal.cantidadSolicitada, listaNoInventariables)){
        var fecha = new Date();
        var suministrosAsignados = [];
        var cantidadNecesaria = sucursal.cantidadSolicitada;
        var cantidadUsada = 0;
        obtenerListaSuministros().forEach(function(sum){
          if (sum.cantidad==0) return;
          if (cantidadNecesaria!=cantidadUsada){
            if (cantidadNecesaria-cantidadUsada-sum.cantidad>0){
              suministrosAsignados.push({
                suministro: sum,
                cantidad: sum.cantidad,
                fecha: fecha
              });
              cantidadUsada += sum.cantidad;
              sum.cantidad = 0;
            } else if (cantidadNecesaria-cantidadUsada-sum.cantidad<=0){
              suministrosAsignados.push({
                suministro: sum,
                cantidad: cantidadNecesaria-cantidadUsada,
                fecha: fecha
              });
              sum.cantidad = sum.cantidad-(cantidadNecesaria-cantidadUsada);
              cantidadUsada += cantidadNecesaria-cantidadUsada;
            }
          }
        });
        asignarSuministrosSucursal(sucursal, suministrosAsignados);
      }
    }

    function asignarSuministrosSucursal(sucursal, suministros){
      var sum = 0;
      suministros.forEach(function(item){
        sum += item.cantidad;
      });
      sucursal.cantidadAsignada=sum;
      sucursal.suministrosAsignados=suministros;
    }

    function habilitarBoton(){
      if (vm.sucursalesConsumoTope && vm.sucursalesConsumoTope.length>0){
        var cant = 0;
        var cantOk = 0;
        var cantMal = 0;
        vm.sucursalesConsumoTope.forEach(function(item){
          if (item.seleccionado){
            cant+=1;
            if (item.cantidadSolicitada && item.cantidadSolicitada>0) {
              cantOk+=1;
            }
          }
        });
        return cant > 0 && cantOk==cant && vm.cantidadTotal>=vm.cantidadSeleccionada();
      }
      return false;
    }

    function limpiarTodo(){
      sucursalesConsumoTope.forEach(function(sucursal){
        sucursal.cantidadSolicitada = null;
        sucursal.seleccionado = null;
      });
    }

    function cerrar(){
      limpiarTodo();
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
    }


    function cantidadSeleccionada(){
      var cant = 0;
      for(var i = 0; i < vm.sucursalesConsumoTope.length; i++){
        if (!vm.sucursalesConsumoTope[i].cantidadSolicitada) continue;
        cant += vm.sucursalesConsumoTope[i].cantidadSolicitada;
      }
      return cant? cant : 0;
    }

    function deshabilitarAsignadas(){
      sucursalesSeleccionadas.forEach(function(item){
        vm.sucursalesConsumoTope.forEach(function(detalle){
          if (detalle.sucursal.id===item.sucursal.id) detalle.asignado = true;
        });
      });
    }

    function actualizarTabla(){
      vm.tableParams.settings({
        data: $filter('orderBy')(vm.sucursalesConsumoTope, 'sucursal.nombre', false),
        noPager: true,
        counts: []
      });
      vm.tableParams.reload();
    }

    function crearTablas(){
      vm.tableParams = new NgTableParams({
        page: 1,
        count: 500
      },{
        getData: function($defer,params){ return filtrarTabla($defer, params);}
      });
    }

    function filtrarTabla($defer, params) {
      var filtros = params.filter();
      var filtrosNuevos = {};

      for (var key in filtros) {
        if (filtros.hasOwnProperty(key) && filtros[key]!=='') {
          switch(key) {
            case 'sucursal.codigoSucursal':
              angular.extend(filtrosNuevos, {
                sucursal: {
                codigoSucursal: filtros[key]
                }
              });
              break;
            case 'sucursal.nombre':
              angular.extend(filtrosNuevos, {
                sucursal: {
                nombre: filtros[key]
                }
                });
              break;
            default:
              filtrosNuevos[key] = filtros[key];
          }
        }
      }
      var filtrados = filtros ? $filter('filter')($filter('orderBy')(vm.sucursalesConsumoTope, 'sucursal.nombre', false), filtrosNuevos) : vm.egresos;
      filtrados = params.sorting() ? $filter('orderBy')(filtrados, params.orderBy()) : filtrados;
      if (filtrados && filtrados.length){
        params.total(filtrados.length);
        return $defer.resolve(filtrados.slice((params.page() - 1) * params.count(), params.page() * params.count()));
      } else {
        params.total(0);
        return $defer.resolve(null);
      }
    }

  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoEditarSuministros',DialogoEditarSuministros);

  function DialogoEditarSuministros($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/editar-suministro/editar-suministro.html',
        controller: 'ModalEditarSuministroCtrl as vm',
        resolve: {
          suministro: function(Suministro){
            if (config.suministro){
              return Suministro.get({id:config.suministro.id}).$promise.then(function(data) {
                return data;
              });
            } else {
              return {suministro:{}};
            }
          },
          modo: function(){
            return config.modo;
          },
          tipos: function(TipoSuministroFamiliaInventariable, $stateParams){
            if (config.suministro){
              var idFamilia = config.suministro.suministro.tipoSuministro.familiaSuministro.id;
              return TipoSuministroFamiliaInventariable.query({idFamilia:idFamilia, inventariable:true}).$promise.then(function(data){
                return data;
              });
            } else {
              return null;
            }
          },
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalEditarSuministroCtrl', ModalEditarSuministroCtrl);

  /** @ngInject */
  function ModalEditarSuministroCtrl(NgTableParams, suministro, $uibModalInstance, Suministro, SuministroInventarioEmpresa, SuministroTipoSerie, tipos, modo, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.cerrar = cerrar;
    vm.suministro = suministro;
    inicializar();
    vm.editarObjeto = editarObjeto;
    vm.modo = modo;

    ServicioDialogos.cerrarDialogoCargando();


    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
    }

    function inicializar(){
      setearObjeto();
    }


    function setearObjeto(){
        vm.tipos = tipos;
        vm.empresaMayus = vm.suministro.suministro.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase();
        vm.grupoMayus = vm.suministro.suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase();
        vm.familiaMayus = vm.suministro.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase();
        vm.serie = vm.suministro.serie;
        vm.inventario = vm.suministro.inventario;
        vm.tipoSuministro = vm.suministro.suministro.tipoSuministro;
    }

    function esEditar() {
      return vm.modo=='editar';
    }

    function editarObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el suministro?', function(){
        if (vm.inventario==vm.suministro.inventario){
          if (vm.serie==vm.suministro.serie && vm.tipoSuministro.nombre==vm.suministro.suministro.tipoSuministro.nombre) {
            editarSuministro();
          } else {
            comprobarSerie();
          }
        } else {
          comprobarInventario();
        }
      },null,false);
    }

    function comprobarSerie(){
      if (vm.serie==vm.suministro.serie) {
        guardarOEditar();
      } else {
        SuministroTipoSerie.query({idTipo:vm.suministro.suministro.tipoSuministro.id, serie:vm.suministro.serie}, function(data){
          if (data.length>0){
            ServicioDialogos.mostrarDialogoConfirmacionWarning(null, 'El número de serie ingresado ya existe. ¿Está seguro que desea continuar de todos modos?', function(){
              guardarOEditar();
            }, null, false);
          } else {
            guardarOEditar();
          }
        }, function(err){
          console.log(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar el tipo de suministro");
        });
      }
    }


    function comprobarInventario(){
      SuministroInventarioEmpresa.query({inventario:vm.suministro.inventario, idEmpresa:vm.suministro.suministro.tipoSuministro.familiaSuministro.grupoSuministro.empresa.id},function(data){
        if (data.length>0){
          ServicioDialogos.mostrarDialogoError(null, 'El número de inventario ya existe');
        } else {
          comprobarSerie();
        }
      }, function(err){
        console.error(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar el suministro");
      });
    }

    function guardarOEditar(){
      if (esEditar()){
        editarSuministro();
      } else {
        guardarSuministro();
      }
    }

    function editarSuministro(){
      Suministro.update(vm.suministro, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado el suministro correctamente', function(){
          if ($('.modal.in').length<=1){
            $('.modal-backdrop').remove();
          }
          $uibModalInstance.close({
            suministroEditado : data
          });
        });
      }, function(err){
        console.error(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar el suministro");
      });
    }




  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoEditarProblemasIngreso',DialogoEditarProblemasIngreso);

  function DialogoEditarProblemasIngreso($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/editar-problemas-ingreso/editar-problemas-ingreso.html',
        controller: 'ModalEditarProblemasIngresoCtrl as vm',
        resolve: {
          ingreso: function(){
            return config.ingreso;
          },
          tiposProblema: function(TipoProblema){
            return TipoProblema.query().$promise.then(function(data){
              return data;
            });
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();


(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalEditarProblemasIngresoCtrl', ModalEditarProblemasIngresoCtrl);

  /** @ngInject */
  function ModalEditarProblemasIngresoCtrl(NgTableParams, $uibModalInstance, HeaderBarService, $window, ProblemaIngreso, ServicioModales, tiposProblema, ingreso, $stateParams, $filter, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtituloNuevo);

    var vm = this;
//    console.log(ingreso);
    vm.ingreso = ingreso;
    vm.cerrar = cerrar;
    vm.tiposProblema = tiposProblema;
    vm.problemas = [];
    inicializar();
    ServicioDialogos.cerrarDialogoCargando();
    vm.eliminarProblema = eliminarProblema;
    vm.editarProblemas = editarProblemas;
    vm.agregarProblema = agregarProblema;
    vm.verProblema = verProblema;
    vm.comprobarIngresoCerrado = comprobarIngresoCerrado;


    function inicializar(){
      vm.fecha=$filter('date')(vm.ingreso.fecha, 'dd/MM/yyyy HH:mm');
      vm.montoTotal = montoTotal();
      crearTablas();
      actualizarTabla();
      setearObservacion();
    }

    function setearObservacion(){
      if (!vm.ingreso.observacionProblema){
        vm.ingreso.observacionProblema='';
      }
    }

    function verProblema(problema){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalFotoProblema({
        onResult: function(res) {
          console.log(res);
        },
        problema: problema
      });
    }

    function estaProblema(){
      var esta = false;
      vm.ingreso.problemas.forEach(function(prob){
        if (vm.tipoProblema.id==prob.tipoProblema.id){
          esta = true;
        }
      });
      return esta;
    }

    function agregarProblema(){
      if (estaProblema()){
        ServicioDialogos.mostrarDialogoError(null, "El problema seleccionado, ya fue asignado al ingreso");
      } else {
        var problema = {
          tipoProblema: vm.tipoProblema
        };
        vm.ingreso.problemas.push(problema);
        actualizarTabla();
      }
    }

    function editarProblemas(problema){
      if (vm.ingreso.observacionProblema.length==0 && vm.ingreso.problemas.length>0){
        ServicioDialogos.mostrarDialogoError(null, "Si agrega un problema, debe ingresar una descripción");
      } else if (vm.ingreso.observacionProblema.length>0 && vm.ingreso.problemas.length==0) {
        ServicioDialogos.mostrarDialogoError(null, "Si agrega una descripción, debe agregar al menos un problema");
      } else {
        editarProblemaIngreso(problema);
      }
    }

    function editarProblemaIngreso(problema){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "¿Está seguro que desea guardar la edición de los problemas en este ingreso?", function(){
        ProblemaIngreso.update(vm.ingreso, function(data){
          ServicioDialogos.mostrarDialogoGuardadoExito(null, "Se ha registrado correctamente la información de los problemas", function(){
			if ($('.modal.in').length<=1){
				$('.modal-backdrop').remove();
			}
			$uibModalInstance.close({
				problemas : data.problemas
			});
          });
        }, function(err){
          console.log(err);
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar la información de los problemas");
        });
      }, null, false);
    }

    function eliminarProblema(index){
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, "La eliminación de un problema, se verá reflejada en el ingreso, cuando presione el botón 'GUARDAR', una vez que termine la edición\n¿Está seguro que desea eliminar el problema en este ingreso?", function(){
        vm.ingreso.problemas.splice(index, 1);
        actualizarTabla();
      });
    }

    function cerrar(){
		ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "No se guardará ningún cambio. ¿Está seguro que desea cancelar", function(){
			if ($('.modal.in').length<=1){
				$('.modal-backdrop').remove();
			}
			$uibModalInstance.dismiss();
		});
    }

    function montoTotal(){
      var total = 0;
      for(var i = 0; i < vm.ingreso.detalles.length; i++){
        total += vm.ingreso.detalles[i].suministro.precioUnitario*vm.ingreso.detalles[i].cantidad;
      }
      return total ? '$ '+total.toFixed(2) : "-";
    }

    function actualizarTabla(){
      vm.tableParams.settings({
        data: orderByFilter(vm.ingreso.problemas,'tipoProblema.nombre',false),
        noPager: true,
        counts: []
      });
      vm.tableParams.reload();
    }

    function crearTablas(){
      vm.tableParams = new NgTableParams({
        page: 1,
        count: 500
      });
    }

    function comprobarIngresoCerrado(){
      return vm.ingreso.estadoMovimiento.id==6;
    }
  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoEditarEgreso',DialogoEditarEgreso);

  function DialogoEditarEgreso($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/editar-egreso/editar-egreso.html',
        controller: 'ModalEditarEgresoCtrl as vm',
        resolve: {
          egreso: function(){
            return angular.copy(config.egreso);
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

'use strict';
angular.module('proyecto-az-suministro')
  .factory('EditarEgreso', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/egreso/editar/:id",{id:"@id"});
  });
(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalEditarEgresoCtrl', ModalEditarEgresoCtrl);

  /** @ngInject */
  function ModalEditarEgresoCtrl(NgTableParams, EditarEgreso, egreso, $filter, $uibModalInstance, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.cerrar = cerrar;
    vm.egreso = egreso;
    vm.editarObjeto = editarObjeto;

    ServicioDialogos.cerrarDialogoCargando();


    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
    }

    function editarObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el egreso N°'+vm.egreso.numeroEgreso+'?', function(){
       editar();
      },null,false);
    }

    function editar(){
      EditarEgreso.update(vm.egreso, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado el egreso correctamente', function(){
          if ($('.modal.in').length<=1){
            $('.modal-backdrop').remove();
          }
          $uibModalInstance.close({
            egresoEditado : data
          });
        });
      }, function(err){
        console.error(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar el egreso");
      });
    }




  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoEditarMovimiento',DialogoEditarMovimiento);

  function DialogoEditarMovimiento($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/editar-movimiento/editar-movimiento.html',
        controller: 'ModalEditarMovimientoCtrl as vm',
        resolve: {
          movimiento: function(Ingreso){
            if (config.objeto){
              return Ingreso.get({id:config.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return {};
            }
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

'use strict';
angular.module('proyecto-az-suministro')
  .factory('EditarMovimiento', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/editar/:id",{id:"@id"});
  });
(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalEditarMovimientoCtrl', ModalEditarMovimientoCtrl);

  /** @ngInject */
  function ModalEditarMovimientoCtrl(NgTableParams, EditarMovimiento, movimiento, $filter, $uibModalInstance, Ingreso, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.cerrar = cerrar;
    vm.movimiento = movimiento;
    vm.fechaIngreso = vm.movimiento.fechaIngreso? new Date(vm.movimiento.fechaIngreso) : null;
    inicializar();
    vm.editarObjeto = editarObjeto;
    vm.fechaActual = new Date();

    ServicioDialogos.cerrarDialogoCargando();


    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
    }

    function inicializar(){

    }

    function editarObjeto() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea editar el '+vm.movimiento.tipoMovimiento.nombre+'?', function(){
       editar();
      },null,false);
    }

    function editar(){
      vm.movimiento.fechaIngreso = vm.fechaIngreso;
      EditarMovimiento.update(vm.movimiento, function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha editado el '+vm.movimiento.tipoMovimiento.nombre+' correctamente', function(){
          if ($('.modal.in').length<=1){
            $('.modal-backdrop').remove();
          }
          $uibModalInstance.close({
            movimientoEditado : data
          });
        });
      }, function(err){
        console.error(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido editar el "+vm.movimiento.tipoMovimiento.nombre);
      });
    }




  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoConfirmarReclamarPedido',DialogoConfirmarReclamarPedido);

  function DialogoConfirmarReclamarPedido($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/confirmar-reclamar-pedido/confirmar-reclamar-pedido.html',
        controller: 'ModalConfirmarReclamarPedidoCtrl as vm',
        resolve: {
          pedido: function(Pedido){
            return Pedido.get({id:config.pedido.id}).$promise.then(function(data){
              return data;
            });
          },
          movimiento: function(ComprobarMovimientoPedido){
            return ComprobarMovimientoPedido.get({idPedido:config.pedido.id}).$promise.then(function(data){
              return data;
            });
          },
          usuario: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario;
            });
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalConfirmarReclamarPedidoCtrl', ModalConfirmarReclamarPedidoCtrl);

  /** @ngInject */
  function ModalConfirmarReclamarPedidoCtrl(NgTableParams, movimiento, usuario, ReclamoEgreso, ConfirmarRecepcionEgreso, $http, URL_SERVIDOR, $uibModalInstance, HeaderBarService,  ServicioModales, pedido, $stateParams, $filter, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.pedido = pedido;
    vm.movimiento = movimiento;
    vm.cerrar = cerrar;
    vm.visualizarPedido = visualizarPedido;
    vm.visualizarMovimiento = visualizarMovimiento;

    vm.confirmar = confirmar;
    vm.reclamar = reclamar;


    inicializar();
    ServicioDialogos.cerrarDialogoCargando();

    function obtenerMovimiento(){
      var movimiento = {
        id : vm.movimiento.id,
        mailDestinatarioConfirmacion : pedido.usuario.solicitante.mail,
        mailIngresadoConfirmacion : pedido.usuario.solicitante.mail,
        fechaConfirmacion : new Date(),
        nombreConfirmacion : vm.nombreConfirmacion
      };
      return movimiento;
    }

    function obtenerMovimientoReclamo(){
      var movimiento = obtenerMovimiento();
      movimiento.descripcionReclamo = vm.descripcionReclamo;
      return movimiento;
    }

    function cerrarDialogo(data){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.close({
        pedido: pedido
      });
    }

    function reclamar(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea registrar el reclamo?", function(){
        ReclamoEgreso.update(obtenerMovimientoReclamo(), function(data){
          ServicioDialogos.mostrarDialogoGuardadoExito(
            null,
            "Se ha registrado el reclamo con éxito",
            function(){
              cerrarDialogo();
            });
        }, function(err){
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar la confirmación de recepción");
        });
      }, null, false);
    }

    function confirmar(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea confirmar la recepción?", function(){
        ConfirmarRecepcionEgreso.update(obtenerMovimiento(), function(data){
          ServicioDialogos.mostrarDialogoGuardadoExito(
            null,
            "Se ha confirmado la recepción con éxito",
            function(){
              cerrarDialogo();
            });
        }, function(err){
          ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar la confirmación de recepción");
        });
      }, null, false);
    }

    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
    }

    function visualizarPedido(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalPedido({
        onResult: function(resultado) {
          console.log(resultado);
        },
        pedido: pedido,
      });
    }

    function visualizarMovimiento(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirVisualizarEgresoPedido({
        onResult: function(resultado) {
          console.log(resultado);
        },
        egreso: movimiento,
      });
    }

    function inicializar(){
      vm.fecha=$filter('date')(new Date(), 'dd/MM/yyyy HH:mm');
      vm.numeroPedido = vm.pedido.numeroPedido;
      vm.numeroMovimiento = vm.movimiento.numeroMovimiento;
      vm.nombreConfirmacion = usuario.solicitante.apellido.toUpperCase()+", "+usuario.solicitante.nombre.toUpperCase();
    }
  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoCargarTopesExcel', DialogoCargarTopesExcel);

  function DialogoCargarTopesExcel($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/cargar-topes-excel/cargar-topes-excel.html',
        controller: 'ModalCargarTopesExcelCtrl as vm',
        resolve: {
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data) {
              return data;
            });
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalCargarTopesExcelCtrl', ModalCargarTopesExcelCtrl);

  /** @ngInject */
  function ModalCargarTopesExcelCtrl(GuardarActualizarTope, empresas, $uibModalInstance, $q, ServicioDialogos, ServicioModales, $scope) {

    var vm = this;
    vm.empresas = empresas;
    vm.cerrar = cerrar;
    vm.buscarExcel = buscarExcel;

    ServicioDialogos.cerrarDialogoCargando();

    function buscarExcel(){
      if (vm.file===undefined || vm.file===null) {
        ServicioDialogos.mostrarDialogoError(null, "No ha elegido un archivo .xlsx");
        return;
      } else {
        var reader = new FileReader();
        ServicioDialogos.abrirDialogoCargando();
        reader.onload = function (e) {
          var bstr = e.target.result;
          var workbook = XLSX.read(bstr, {type:'binary'});
          var first_sheet_name = workbook.SheetNames[0];
          var worksheet = workbook.Sheets[first_sheet_name];
          var topes = XLSX.utils.sheet_to_json(worksheet);
          comprobarElementos(topes);
        };
        reader.readAsBinaryString(vm.file);
      }
    }

    function comprobarElementos(topes){
      vm.nuevos = [];
      vm.existentes = [];
      vm.incompletos = [];
      vm.erroneos = [];
      vm.correctos = [];
//      console.log(topes);
      topes.forEach(function(item){
        validarTope(item);
      });
      if (vm.correctos.length>0){
        validarCorrectos();
      } else {
        mostrarErroneos();
      }
    }

    function mostrarErroneos(){
      ServicioModales.abrirModalRespuestaTopesExcel({
        onResult: function(resultado) {
          console.log(resultado);
        },
        formatoIncorrecto: true,
        nombreDocumento: vm.file.name,
        tipoSuministro: vm.tipoSuministro
      });
    }

    function validarCorrectos(){
      validarTopesCorrectos()
      .then(function(){
        mostrarInformacionValidacion();
      });
    }

    function mostrarInformacionValidacion(){
      ServicioModales.abrirModalRespuestaTopesExcel({
        onResult: function(resultado) {
          console.log(resultado);
        },
        formatoIncorrecto: false,
        existentes: vm.existentes,
        erroneos: vm.erroneos,
        incompletos: vm.incompletos,
        nuevos: vm.nuevos,
        correctos: vm.correctos,
        tipoSuministro: vm.tipoSuministro,
        nombreDocumento: vm.file.name,
      });
    }

    function validarTopesCorrectos(){
      var defer = $q.defer();
      var promise = defer.promise;
      vm.correctos.forEach(function(item){
        promise = promise.then(function(){
          return guardarActualizarTope(item).then(function(data){
            if (data && data.tope && data.tope.id){
              if (data.existente == "SI"){
                vm.existentes.push(data);
              } else {
                vm.nuevos.push(data);
              }
            } else {
              item.causa = data.causa;
              vm.erroneos.push(item);
            }
          });
        });
      });
      defer.resolve(true);
      return promise;
    }

    function guardarActualizarTope(tope){
      var defer = $q.defer();
      var promise = defer.promise;
      GuardarActualizarTope.get({idEmpresa: vm.empresa.id, codigoProducto: tope.codigoProducto, codigoSucursal:tope.codigoSucursal, cantidad: tope.cantidad}, function(data){
        defer.resolve(data);
        return promise;
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        return $q.reject();
      });
      return promise;
    }

    function estaCompleto(tope){
//      console.log(tope.codigoSucursal, tope.codigoProducto, tope.cantidad);
      return (tope.codigoSucursal!==null && tope.codigoSucursal!==undefined) && (tope.codigoProducto!==null && tope.codigoProducto!==undefined) && (tope.cantidad!==null && tope.cantidad!==undefined);
    }

    function yaExiste(tope){
      var ban = false;
      vm.correctos.forEach(function(item){
        if (item.codigoSucursal == tope.codigoSucursal && item.codigoProducto == tope.codigoProducto){
          ban = true;
        }
      });
      return ban;
    }

    function validarTope(tope){
      if (estaCompleto(tope)){
        if (!validarCantidadTope(tope.cantidad)){ //si es numérico
          if (validarCantidadTopeExcel(tope.cantidad)){
            if (!yaExiste(tope)){
              var objeto = {
                codigoSucursal : tope.codigoSucursal,
                codigoProducto: tope.codigoProducto,
                cantidad : tope.cantidad
              };
              vm.correctos.push(objeto);
            } else {
              tope.causa = "Ya se procesó un registro correcto con el mismo código de sucursal y producto";
              vm.erroneos.push(tope);

            }
          } else {
            tope.causa = "La cantidad no es un entero mayor o igual a 0";
            vm.erroneos.push(tope);
          }
        } else {
          tope.causa = "La cantidad no es numérica";
          vm.erroneos.push(tope);
        }
      } else {
        tope.causa = "Faltan datos";
        vm.incompletos.push(tope);
      }
    }

    function validarCantidadTopeExcel(cantidad){
      return Number.isInteger(+cantidad) && cantidad>=0;
    }

    function validarCantidadTope(cantidad){
      return isNaN(cantidad) || (cantidad===null) || (typeof(cantidad)== "boolean");
    }

    $scope.cargarArchivo = function(file){
      vm.file = file;
    };

    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.close({});
    }
  
  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoCambioPassword',DialogoCambioPassword);

  function DialogoCambioPassword($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/cambio-password/modal-cambio-password.html',
        controller: 'ModalCambioPasswordCtrl as vm',
        resolve: {
          usuario: function(){
           return config.usuario;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalCambioPasswordCtrl', ModalCambioPasswordCtrl);

  /** @ngInject */
  function ModalCambioPasswordCtrl(NgTableParams, Util, bcrypt, $window, RenovarPasswordUsuario, ServicioModales, usuario, $uibModalInstance, HeaderBarService, $stateParams, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.cerrar = cerrar;
    vm.cancelar = cancelar;
    vm.guardar = guardar;
    vm.usuario = usuario;

    vm.validarPassword = validarPassword;

    function validarPassword(){
      if (vm.renovar && vm.renovar.nuevaPassword){
        return Util.validarPassword(vm.renovar.nuevaPassword, {});
      }
      return {validation:false, mensaje: "La contraseña debe cumplir los siguientes requisitos:\nLongitud mínima de 8 y máxima de 25 caracteres\nPoseer al menos una minúscula, una mayúscula, un número y un caracter especial\n"};
    }

    function cancelar() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea cancelar?", function(){
        cerrar();
      });
    }


    function guardar() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea renovar el password?", function(){
        renovarPass();
      },null,false);
    }

    function renovarPass(){
      bcrypt.genSalt(10, function(err, salt) {
        bcrypt.hash(vm.renovar.nuevaPassword, salt, function(err, hash) {
          var renovar = {
            password : hash,
            id : vm.usuario.id
          };
          RenovarPasswordUsuario.update(renovar, function(data){
            ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha renovado el password correctamente!', function(){
              $window.location.reload();
            });
          }, function(error){
            console.error(error);
            ServicioDialogos.mostrarDialogoError(null, 'No se ha podido renovar el password');
          });
        });
      });
    }

    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.dismiss();
    }


    function cambiar(){
      var suministro = {
        tipoSuministro: vm.tipoSuministro,
        marca : vm.marca,
        fechaVencimiento : vm.fechaVencimiento
      };
      var detalles = [];
      for (var i = 0; i < vm.campos.length; i++) {
        vm.detalles.push({
          suministro : suministro,
          cantidad: vm.campos[i].cantidad
        });
      }
      $('.modal-backdrop').remove();
      $uibModalInstance.close(vm.detalles, "HOLA");
    }
  
  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoCargarInventariablesExcel', DialogoCargarInventariablesExcel);

  function DialogoCargarInventariablesExcel($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/cargar-inventariables-excel/cargar-inventariables-excel.html',
        controller: 'ModalCargarInventariablesExcelCtrl as vm',
        resolve: {
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data) {
              return data;
            });
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

'use strict';
angular.module('proyecto-az-suministro')
  .factory('GuardarActualizarInventariable', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministroinventariable?empresa.id=:idEmpresa&&codigoProducto=:codigoProducto&&precio=:precio&&nuevo=:nuevo&&codigoSucursal=:codigoSucursal&&serie=:serie&&inventario=:inventario&&marca=:marca",{idEmpresa: '@idEmpresa', marca: '@marca', inventario: '@inventario', serie: '@serie', codigoSucursal: '@codigoSucursal', nuevo: '@nuevo', precio: '@precio', codigoProducto:'@codigoProducto'});
  });
(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalCargarInventariablesExcelCtrl', ModalCargarInventariablesExcelCtrl);

  /** @ngInject */
  function ModalCargarInventariablesExcelCtrl(GuardarActualizarInventariable, empresas, $uibModalInstance, $q, ServicioDialogos, ServicioModales, $scope) {

    var vm = this;
    vm.empresas = empresas;
    vm.cerrar = cerrar;
    vm.buscarExcel = buscarExcel;

    ServicioDialogos.cerrarDialogoCargando();

    function buscarExcel(){
      if (vm.file===undefined || vm.file===null) {
        ServicioDialogos.mostrarDialogoError(null, "No ha elegido un archivo .xlsx");
        return;
      } else {
        var reader = new FileReader();
        ServicioDialogos.abrirDialogoCargando();
        reader.onload = function (e) {
          var bstr = e.target.result;
          var workbook = XLSX.read(bstr, {type:'binary'});
          var first_sheet_name = workbook.SheetNames[0];
          var worksheet = workbook.Sheets[first_sheet_name];
          var suministros = XLSX.utils.sheet_to_json(worksheet);
          comprobarElementos(suministros);
        };
        reader.readAsBinaryString(vm.file);
      }
    }

    function comprobarElementos(suministros){
      vm.completos = [];
      vm.existentes = [];
      vm.incompletos = [];
      vm.nuevos = [];
      vm.erroneos = [];
      vm.correctos = [];
      suministros.forEach(function(item){
        validarSuministro(item);
      });
      if (vm.completos.length>0){
        validarCompletos();
      } else {
        //console.log(vm.erroneos, vm.incompletos);
        mostrarIncompletos();
      }
    }

    function mostrarIncompletos(){
      ServicioModales.abrirModalRespuestaInventariablesExcel({
        onResult: function(resultado) {
          console.log(resultado);
        },
        formatoIncorrecto: true,
        nombreDocumento: vm.file.name,
        tipoSuministro: vm.tipoSuministro
      });
    }

    function validarCompletos(){
      validarSuministrosCompletos()
      .then(function(){
        mostrarInformacionValidacion();
      });
    }

    function mostrarInformacionValidacion(){
      ServicioModales.abrirModalRespuestaInventariablesExcel({
        onResult: function(resultado) {
          console.log(resultado);
        },
        formatoIncorrecto: false,
        existentes: vm.existentes,
        erroneos: vm.erroneos,
        incompletos: vm.incompletos,
        nuevos: vm.nuevos,
        correctos: vm.correctos,
        tipoSuministro: vm.tipoSuministro,
        nombreDocumento: vm.file.name,
      });

    }

    function validarSuministrosCompletos(){
      var defer = $q.defer();
      var promise = defer.promise;
      vm.completos.forEach(function(item){
        promise = promise.then(function(){
          return guardarActualizarInventariable(item).then(function(data){
            if (data && data.inventariable && data.inventariable.id){
              if (data.existente == "SI"){
                vm.existentes.push(data.inventariable);
              } else {
                vm.nuevos.push(data.inventariable);
              }
            } else {
              item.precio = item.precioUnitario;
              item.codigoProducto = data.codigoProducto;
              item.codigoSucursal = data.codigoSucursal;
              item.causa = data.causa;
              vm.erroneos.push(item);
            }
          });
        });
      });
      defer.resolve(true);
      return promise;
    }

    function guardarActualizarInventariable(suministro){
      var defer = $q.defer();
      var promise = defer.promise;
      GuardarActualizarInventariable.get({idEmpresa: vm.empresa.id, codigoProducto: suministro.tipoSuministro, precio: suministro.precioUnitario, nuevo: suministro.nuevo, codigoSucursal:suministro.sucursal, serie: suministro.serie, inventario: suministro.inventario, marca: suministro.marca, }, function(data){
        defer.resolve(data);
        return promise;
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        return $q.reject();
      });
      return promise;
    }

    function estaCompleto(suministro){
      return (suministro.codigoSucursal!==null && suministro.codigoSucursal!==undefined) && (suministro.codigoProducto!==null && suministro.codigoProducto!==undefined) && (suministro.serie!==null && suministro.serie!==undefined) && (suministro.precio!==null && suministro.precio!==undefined) && (suministro.inventario!==null && suministro.inventario!==undefined);
    }

    function yaExiste(suministro){
      var ban = false;
      vm.completos.forEach(function(item){
        if (item.inventario == suministro.inventario){
          ban = true;
        }
      });
      return ban;
    }

    function validarSuministro(suministro){
      if (estaCompleto(suministro)){
        if (!validarPrecioExcel(suministro.precio)){
          if (validarInventarioExcel(suministro.inventario)){
            if (!yaExiste(suministro)){
              var bien = {
                inventario : suministro.inventario,
                serie: suministro.serie,
                sucursal: suministro.codigoSucursal,
                marca: suministro.marca,
                precioUnitario: suministro.precio,
                tipoSuministro: suministro.codigoProducto,
                nuevo : suministro.nuevo==1? true:false
              };
              vm.completos.push(bien);
            } else {
              suministro.causa = "Ya se procesó un registro con el mismo número de inventario";
              vm.erroneos.push(suministro);
            }
          } else {
            suministro.causa = "El número de inventario debe ser un entero";
            vm.erroneos.push(suministro);
          }
        } else {
          suministro.causa = "El campo 'precio' no es numérico o es un número inválido";
          vm.erroneos.push(suministro);
        }
      } else {
        suministro.causa = "Faltan datos";
        vm.incompletos.push(suministro);
      }
    }

    function validarInventarioExcel(inventario){
      return Number.isInteger(+inventario) && inventario>=0;
    }

    function validarPrecioExcel(precio){
      return isNaN(precio) || (Number.isInteger(precio) && precio<=0) || (precio===null) || (typeof(precio)== "boolean");
    }

    $scope.cargarArchivo = function(file){
      vm.file = file;
    };
    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.close({});
    }
  
  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoCambiarUbicacionVariosSuministros',DialogoCambiarUbicacionVariosSuministros);

  function DialogoCambiarUbicacionVariosSuministros($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/cambiar-ubicacion-varios-suministros/cambiar-ubicacion-varios-suministros.html',
        controller: 'ModalCambioUbicacionVariosSuministros as vm',
        resolve: {
          suministros: function(){
            return config.suministros;
          },
          ubicacion: function(Ubicacion){
            return Ubicacion.get({id:config.ubicacion.id}).$promise.then(function(data){
              return data;
            });
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalCambioUbicacionVariosSuministros', ModalCambioUbicacionVariosSuministros);

  /** @ngInject */
  function ModalCambioUbicacionVariosSuministros(NgTableParams, $q, ubicacion, suministros, HeaderBarService, $filter, $uibModalInstance, ServicioModales, $window, ReemplazarUbicacionSuministro, $timeout, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.suministros = suministros;
    vm.ubicacion = ubicacion;
    vm.cerrar = cerrar;
    vm.ubicacionCompleta = ubicacionCompleta;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.mostrarInformacionSuministro = mostrarInformacionSuministro;
    vm.asignarIndividual = asignarIndividual;
    vm.actualizarUbicacion = actualizarUbicacion;
    vm.cantidadSeleccionada = cantidadSeleccionada;
    vm.comprobarCantidadSeleccionada = comprobarCantidadSeleccionada;
    vm.marcarTodo = marcarTodo;
    vm.noUbicacion = false;
    vm.ocupar = false;

    inicializar();
    ServicioDialogos.cerrarDialogoCargando();

    function inicializar(){
      inicializarTabla();
    }

    function cantidadSeleccionada(){
      var total = 0;
      for(var i = 0; i < vm.suministros.length; i++){
        if (vm.suministros[i].seleccionado){
          total += 1;
        }
      }
      return total;
    }

    function comprobarCantidadSeleccionada(suministro){
      if (cantidadSeleccionada()==0){
        ServicioDialogos.mostrarDialogoInformacion(
          null,
          "Se ha anulado la selección de la nueva ubicación.\nDebe seleccionar al menos un suministro.",
          function(){
//            console.log("1");
            vm.nuevaUbicacion=null;
          }
        );
      }
    }

    function actualizarUbicacion(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(
        null,
        "¿Está seguro que desea cambiar la ubicación de los suministros seleccionados?",
        function(){
          actualizarUbicaciones();
        },
        null,
        false
      );
    }

    function marcarTodo(){
      vm.suministros.forEach(function(item){
        item.seleccionado=vm.check;
      });
    }

    function actualizarUbicaciones(){
      cambiarUbicaciones()
      .then(function(){
        ServicioDialogos.mostrarDialogoGuardadoExito(
          null,
          "Se ha actualizado la ubicación con éxito",
          function(){
            cerrarModal();
          });
      });

    }

    function obtenerSeleccionados(){
      var seleccionados = [];
      vm.suministros.forEach(function(item){
        if (item.seleccionado){
          seleccionados.push(item);
        }
      });
      return seleccionados;
    }

    function cambiarUbicaciones(){
      var seleccionados = obtenerSeleccionados();
      var defer = $q.defer();
      var promise = defer.promise;
      seleccionados.forEach(function(suministro, index){
        promise = promise.then(function(){
          return actualizarUbicacionIndividual(suministro.id).then(function(){
            defer.resolve(true);
          });

        });
      });
      defer.resolve(true);
      return promise;
    }

    function actualizarUbicacionIndividual(id){
      var defered = $q.defer();
      var promesa = defered.promise;
      ReemplazarUbicacionSuministro.update({idSuministro: id, idUbicacion: vm.nuevaUbicacion.id, ocupar: vm.ocupar}, function(data){
        defered.resolve(true);
      }, function(err){
        console.log(err);
        return $q.reject();
      });
      return promesa;
    }

    function traerUbicaciones(){
      var defer = $q.defer();
      var promise = defer.promise;
      vm.detalles.forEach(function(det) {
        if (det.ubicacion){
          promise = promise.then(function(){
            return traerUbicacionIndividual(det.ubicacion.id).then(function(){
              defer.resolve(true);
            });
          });
        }
      });
      defer.resolve(true);
      return promise;
    }

    function cerrarModal(data){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.close({
        
      });
    }

    function ubicacionNaveNumeroOrden(ubicacion){
      if (ubicacion && ubicacion.nivel) {
        return "Nave: "+ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+ubicacion.numeroOrden;
      } else {
        return "El bien no posee una ubicación actual";
      }
    }

    function mostrarInformacionSuministro(suministro){
      if (suministro.tipoSuministro){
        mostrarInformacionNoInventariable(suministro);
      } else {
        mostrarInformacionInventariable(suministro);
      }
    }

    function comprobarUbicacionElegida(ubicacion){
      if (ubicacion.id == vm.ubicacion.id){
        ServicioDialogos.mostrarDialogoError(null, "La ubicación elegida es la misma que la actual");
      } else {
        vm.nuevaUbicacion = ubicacion;
      }
    }

    function asignarIndividual(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalAsignarUbicacionIndividualCajas({
        onResult: function(resultado){
          comprobarUbicacionElegida(resultado.ubicacionAsignada);
        },
        deposito: vm.ubicacion.nivel.estante.estructura.pasillo.nave.deposito,
        'detalle': {tipoSuministro: {categoriaPeso: {id:4}}}
      });
    }

    function mostrarInformacionInventariable(bien){
      var marca = bien.suministro.marca? bien.suministro.marca.toUpperCase() : "-";
      var inventario = bien.inventario? bien.inventario : "-";
      var serie = bien.serie? bien.serie.toUpperCase() : "-";
      var nuevo = bien.nuevo? "SI" : "NO";
      var activo = bien.suministro.estadoSuministro.id == 2? "SI" : "NO";
      var precio = bien.suministro.precioUnitario ? bien.suministro.precioUnitario : "-";
      ServicioDialogos.mostrarDialogoInformacion(
        "Información del suministro",
        "Empresa: "+bien.suministro.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase()+
        "\nGrupo suministro: "+bien.suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+
        "\nFamilia de suministro: "+bien.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase()+
        "\nTipo de suministro: "+bien.suministro.tipoSuministro.nombre.toUpperCase()+
        "\nMarca: "+marca+
        "\nN° Inventario: "+inventario+
        "\nN° Serie: "+serie+
        "\nPrecio: $"+precio+
        "\n¿Nuevo?: "+nuevo
      );
    }

    function mostrarInformacionNoInventariable(bien){
      var marca = bien.marca? bien.marca.toUpperCase() : "-";
      var precio = bien.precioUnitario ? bien.precioUnitario : "-";
      var fecha = bien.fechaVencimiento? $filter('date')(bien.fechaVencimiento, "dd/MM/yyyy") : "-";
      ServicioDialogos.mostrarDialogoInformacion(
        "Información del suministro",
        "Empresa: "+bien.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase()+
        "\nGrupo suministro: "+bien.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+
        "\nFamilia de suministro: "+bien.tipoSuministro.familiaSuministro.nombre.toUpperCase()+
        "\nTipo de suministro: "+bien.tipoSuministro.nombre.toUpperCase()+
        "\nMarca: "+marca+
        "\nFecha vencimiento: "+fecha+
        "\nPrecio unitario: "+precio+
        "\nCantidad: "+bien.cantidad
      );
    }


    function ubicacionCompleta(ubicacion){
      ServicioDialogos.mostrarDialogoInformacion(
        "Ubicación N° "+ubicacion.numeroUbicacion+
        "\nNúmero de orden: "+ubicacion.numeroOrden,
        "\nDepósito: "+ubicacion.nivel.estante.estructura.pasillo.nave.deposito.nombre.toUpperCase()+
        "\nNave: "+ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo N° "+ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura N° "+ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería N° "+ubicacion.nivel.estante.numeroEstante+
        "\nEstante N° "+ubicacion.nivel.numeroNivel
      );
    }

    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
    }

    function inicializarTabla(){
      vm.tableParams = new NgTableParams({
        page: 1,
        count: 10
      });
      vm.tableParams.settings({
        data: orderByFilter(vm.suministros, 'tipoSuministro.nombre', false)
      });
      vm.tableParams.reload();
    }

    
  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoCambiarUbicacionSuministro',DialogoCambiarUbicacionSuministro);

  function DialogoCambiarUbicacionSuministro($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/cambiar-ubicacion-suministro/cambiar-ubicacion-suministro.html',
        controller: 'ModalCambioUbicacionSuministro as vm',
        resolve: {
          suministro: function(Suministro, SuministroNoInventariable){
            if (config.inventariable){
              return Suministro.get({id:config.suministro}).$promise;
            } else {
              return SuministroNoInventariable.get({ id : config.suministro }).$promise;
            }
          },
          inventariable: function(){
            return config.inventariable;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalCambioUbicacionSuministro', ModalCambioUbicacionSuministro);

  /** @ngInject */
  function ModalCambioUbicacionSuministro(NgTableParams, HeaderBarService, $filter, $uibModalInstance, ServicioModales, $window, ReemplazarUbicacionSuministro, inventariable, suministro, $timeout, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var vm = this;
    vm.inventariable = inventariable;
    vm.suministro = suministro;
    vm.suministros = [];
    vm.cerrar = cerrar;
    vm.ubicacionCompleta = ubicacionCompleta;
    vm.comprobarSuministro = comprobarSuministro;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.mostrarInformacionSuministro = mostrarInformacionSuministro;
    vm.asignarIndividual = asignarIndividual;
    vm.actualizarUbicacion = actualizarUbicacion;
    vm.noUbicacion = false;
    vm.ocupar = false;



    inicializar();
    ServicioDialogos.cerrarDialogoCargando();

    function inicializar(){
      inicializarTablas();
      vm.ubicacion = vm.inventariable? suministro.suministro.ubicacion : suministro.ubicacion;
      if (vm.ubicacion && vm.ubicacion.id){
        vm.deposito = vm.inventariable? suministro.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.deposito : suministro.ubicacion.nivel.estante.estructura.pasillo.nave.deposito;
      } else {
        vm.noUbicacion = true;
      }
    }

    function actualizarUbicacion(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(
        null,
        "¿Está seguro que desea actualizar la ubicación?",
        function(){
          var sum = vm.inventariable? vm.suministro.suministro.id : vm.suministro.id;
          ReemplazarUbicacionSuministro.update({idSuministro: sum, idUbicacion: vm.nuevaUbicacion.id, ocupar: vm.ocupar}, function(data){
            ServicioDialogos.mostrarDialogoGuardadoExito(
              null,
              "Se ha actualizado la ubicación del suministro con éxito",
              function(){
                cerrarModal(data);
              });
          }, function(err){
            console.log(err);
            ServicioDialogos.mostrarDialogoError();
          });
        },
        null,
        false
      );

    }

    function cerrarModal(data){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.close({
        suministro : data
      });
    }

    function comprobarSuministro(){
      return (vm.suministro.id && ((inventariable && vm.suministro.suministro.ubicacion.id) || (!inventariable && vm.suministro.ubicacion)) && (vm.inventariable!==null || vm.inventariable!==undefined));
    }

    function ubicacionNaveNumeroOrden(ubicacion){
      if (ubicacion && ubicacion.nivel) {
        return "Nave: "+ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+ubicacion.numeroOrden;
      } else {
        return "El bien no posee una ubicación actual";
      }
    }

    function mostrarInformacionSuministro(){
      if (vm.inventariable){
        mostrarInformacionInventariable(vm.suministro);
      } else {
        mostrarInformacionNoInventariable(vm.suministro);
      }
    }

    function comprobarUbicacionElegida(ubicacion){
      if (ubicacion.id == vm.ubicacion.id){
        ServicioDialogos.mostrarDialogoError(null, "La ubicación elegida es la misma que la actual");
      } else {
        vm.nuevaUbicacion = ubicacion;
      }
    }

    function asignarIndividual(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalAsignarUbicacionIndividualCajas({
        onResult: function(resultado){
          comprobarUbicacionElegida(resultado.ubicacionAsignada);
        },
        deposito: vm.deposito,
        'detalle': vm.suministro
      });
    }

    function mostrarInformacionInventariable(bien){
      var marca = bien.suministro.marca? bien.suministro.marca.toUpperCase() : "-";
      var inventario = bien.inventario? bien.inventario : "-";
      var serie = bien.serie? bien.serie.toUpperCase() : "-";
      var nuevo = bien.nuevo? "SI" : "NO";
      var activo = bien.suministro.estadoSuministro.id == 2? "SI" : "NO";
      var precio = bien.suministro.precioUnitario ? bien.suministro.precioUnitario : "-";
      ServicioDialogos.mostrarDialogoInformacion(
        "Información del suministro",
        "Empresa: "+bien.suministro.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase()+
        "\nGrupo suministro: "+bien.suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+
        "\nFamilia de suministro: "+bien.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase()+
        "\nTipo de suministro: "+bien.suministro.tipoSuministro.nombre.toUpperCase()+
        "\nMarca: "+marca+
        "\nN° Inventario: "+inventario+
        "\nN° Serie: "+serie+
        "\nPrecio: $"+precio+
        "\n¿Nuevo?: "+nuevo
      );
    }

    function mostrarInformacionNoInventariable(bien){
      var marca = bien.marca? bien.marca.toUpperCase() : "-";
      var precio = bien.precioUnitario ? bien.precioUnitario : "-";
      var fecha = bien.fechaVencimiento? $filter('date')(bien.fechaVencimiento, "dd/MM/yyyy") : "-";
      ServicioDialogos.mostrarDialogoInformacion(
        "Información del suministro",
        "Empresa: "+bien.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase()+
        "\nGrupo suministro: "+bien.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+
        "\nFamilia de suministro: "+bien.tipoSuministro.familiaSuministro.nombre.toUpperCase()+
        "\nTipo de suministro: "+bien.tipoSuministro.nombre.toUpperCase()+
        "\nMarca: "+marca+
        "\nFecha vencimiento: "+fecha+
        "\nPrecio unitario: "+precio+
        "\nCantidad: "+bien.cantidad
      );
    }


    function ubicacionCompleta(ubicacion){
      ServicioDialogos.mostrarDialogoInformacion(
        "Ubicación N° "+ubicacion.numeroUbicacion+
        "\nNúmero de orden: "+ubicacion.numeroOrden,
        "\nDepósito: "+ubicacion.nivel.estante.estructura.pasillo.nave.deposito.nombre.toUpperCase()+
        "\nNave: "+ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo N° "+ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura N° "+ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería N° "+ubicacion.nivel.estante.numeroEstante+
        "\nEstante N° "+ubicacion.nivel.numeroNivel
      );
    }

    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
    }

    function inicializarTablas(){
      vm.suministros.push(vm.suministro);
      vm.tableParamsSuministro = new NgTableParams({
        page: 1,
        count: 10
      });
      vm.tableParamsSuministro.settings({
        data: vm.suministros,
        noPager: true,
        counts: []
      });
      vm.tableParamsSuministro.reload();
    }

    
  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoAsignarUbicacionesCajas',DialogoAsignarUbicacionesCajas);

  function DialogoAsignarUbicacionesCajas($uibModal, ServicioDialogos) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/asignar-ubicaciones-cajas/modal-asignar-ubicaciones-cajas.html',
        controller: 'ModalAsignarUbicacionesCajas as vm',
        resolve: {
          deposito: function(DepositoHastaUbicacion){
            return DepositoHastaUbicacion.get({id:config.deposito.id}).$promise.then(function(data){
              return data;
            });
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalAsignarUbicacionesCajas', ModalAsignarUbicacionesCajas);

  /** @ngInject */
  function ModalAsignarUbicacionesCajas(NgTableParams, Util, $filter, focus, $q, Ubicacion, ServicioModales, deposito, $timeout, $uibModalInstance, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.util = Util;
    vm.naves = orderByFilter(deposito.naves,'nombre',false);
    vm.deposito = deposito;

    vm.corroborarExistenciaUbicacionesNave = corroborarExistenciaUbicacionesNave;
    vm.corroborarExistenciaUbicacionesPasillo = corroborarExistenciaUbicacionesPasillo;
    vm.corroborarExistenciaUbicacionesPasilloMapa = corroborarExistenciaUbicacionesPasilloMapa;
    vm.corroborarExistenciaUbicacionesEstructura = corroborarExistenciaUbicacionesEstructura;
    vm.corroborarExistenciaUbicacionesEstructuraMapa = corroborarExistenciaUbicacionesEstructuraMapa;
    vm.corroborarExistenciaUbicacionesEstante = corroborarExistenciaUbicacionesEstante;
    vm.corroborarExistenciaUbicacionesEstanteMapa = corroborarExistenciaUbicacionesEstanteMapa;
    vm.corroborarExistenciaUbicacionesNivel = corroborarExistenciaUbicacionesNivel;
    vm.corroborarExistenciaUbicacionesNivelMapa = corroborarExistenciaUbicacionesNivelMapa;

    vm.atras = atras;

    vm.clasePasillos = clasePasillos;
    vm.claseEstante = claseEstante;
    vm.claseNivel = claseNivel;
    vm.claseUbicaciones = claseUbicaciones;

    vm.elegirPasillo = elegirPasillo;
    vm.elegirEstructura = elegirEstructura;
    vm.elegirEstante = elegirEstante;
    vm.elegirNivel = elegirNivel;
    vm.elegirUbicacion = elegirUbicacion;

    vm.deshabilitarUbicacion = deshabilitarUbicacion;

    ServicioDialogos.cerrarDialogoCargando();

    vm.asignar = asignar;
    vm.cerrar = cerrar;


    function asignar(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(
        null,
        "La ubicación seleccionada, será asignada a todas las cajas que todavía no posean una ubicación asignada.\n"+
        "Es probable que la categoría de peso de la misma, no coincida con todos los suministros de las cajas cerradas.\n"+
        "¿Está seguro que desea continuar?",
        function(){
          asignarUbicacion();
        }
      );
    }

    function asignarUbicacion(){
      ServicioDialogos.abrirDialogoCargando();
      Ubicacion.get({id:vm.ubicacion.id}, function(data){
        ServicioDialogos.cerrarDialogoCargando();
        $('.modal-backdrop').remove();
        $uibModalInstance.close({
          ubicacionAsignada : data
        });
      }, function(err){
        console.log(err);
      });
    }

    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.dismiss();
    }

    function atras(){
      if (vm.pasillo && vm.estructura && vm.estante && vm.nivel && vm.ubicacion) {vm.ubicacion = null;}
      else if (vm.pasillo && vm.estructura && vm.estante && vm.nivel && !vm.ubicacion) {vm.nivel = null;}
      else if (vm.pasillo && vm.estructura && vm.estante && !vm.nivel && !vm.ubicacion) {vm.estante = null;}
      else if (vm.pasillo && vm.estructura && !vm.estante && !vm.nivel && !vm.ubicacion) {vm.estructura = null;}
      else if (vm.pasillo && !vm.estructura && !vm.estante && !vm.nivel && !vm.ubicacion) {vm.pasillo = null;}
    }

    function deshabilitarUbicacion(ubicacion){
      return ubicacion.estadoUbicacion.id==2;
    }

    function clasePasillos() {
      var pasillosNoBorrados = Util.traerNoBorrados(vm.pasillos);
      var cantPasillos= 0;
      for (var i = pasillosNoBorrados.length - 1; i >= 0; i--) {
        if (pasillosNoBorrados[i].estructuras.length>0) {
          cantPasillos = cantPasillos + 1;
        }
      }
      return {"width": parseInt(100/pasillosNoBorrados.length)+"%"};
    }


    function claseUbicaciones(){
      var cantidadUbicaciones = Util.contarNoBorrados(vm.nivel.ubicaciones);
        return {"width":parseInt(100/cantidadUbicaciones)+"%"};
    }

    function claseEstante(estante){
      var cantEstantes = Util.contarNoBorrados(vm.estructura.estantes);
      return {"width": parseInt(100/cantEstantes)+"%"};
    }

    function claseNivel(estante){
      var cantEstantes = Util.contarNoBorrados(vm.estante.niveles);
      return {"width": parseInt(100/cantEstantes)+"%"};
    }

    function elegirPasillo(pasillo){
      vm.pasillo = pasillo;
    }

    function elegirUbicacion(ubicacion){
      if (ubicacion.estadoUbicacion.id!==2){
        vm.ubicacion = ubicacion;
      }
    }

    function elegirEstructura(estructura){
      vm.estructura = estructura;
    }

    function elegirEstante(estante){
      vm.estante = estante;
    }

    function elegirNivel(nivel){
      vm.nivel = nivel;
    }

    function obtenerUbicacionesDisponibles(){
      return orderByFilter(vm.nivel.ubicaciones,'numeroUbicacion', false);
    }

    function corroborarExistenciaUbicacionesNave(){
      var ubicaciones = {};
      if (vm.nave && vm.nave.id){
        ubicaciones = vm.util.ubicacionesCompletasPorNave(angular.copy(vm.nave));
        return (ubicaciones.totales-ubicaciones.ocupados)>0;
      } else {
        return false;
      }
    }

    function corroborarExistenciaUbicacionesPasillo(){
      var ubicaciones = {};
      if (vm.pasillo && vm.pasillo.id){
        ubicaciones = vm.util.ubicacionesCompletasPorPasillo(angular.copy(vm.pasillo));
        return (ubicaciones.totales-ubicaciones.ocupados)>0;
      } else {
        return false;
      }
    }

    function corroborarExistenciaUbicacionesPasilloMapa(pasillo){
      var ubicaciones = {};
      if (pasillo && pasillo.id){
        ubicaciones = vm.util.ubicacionesCompletasPorPasillo(angular.copy(pasillo));
        return (ubicaciones.totales-ubicaciones.ocupados)>0;
      } else {
        return false;
      }
    }

    function corroborarExistenciaUbicacionesEstructura(){
      var ubicaciones = {};
      if (vm.estructura && vm.estructura.id){
        ubicaciones = vm.util.ubicacionesCompletasPorEstructura(angular.copy(vm.estructura));
        return (ubicaciones.totales-ubicaciones.ocupados)>0;
      } else {
        return false;
      }
    }

    function corroborarExistenciaUbicacionesEstructuraMapa(estructura){
      var ubicaciones = {};
      if (estructura && estructura.id){
        ubicaciones = vm.util.ubicacionesCompletasPorEstructura(angular.copy(estructura));
        return (ubicaciones.totales-ubicaciones.ocupados)>0;
      } else {
        return false;
      }
    }

    function corroborarExistenciaUbicacionesEstante(){
      var ubicaciones = {};
      if (vm.estante && vm.estante.id){
        ubicaciones = vm.util.ubicacionesCompletasPorEstante(angular.copy(vm.estante));
        return (ubicaciones.totales-ubicaciones.ocupados)>0;
      } else {
        return false;
      }
    }

      function corroborarExistenciaUbicacionesEstanteMapa(estante){
      var ubicaciones = {};
      if (estante && estante.id){
        ubicaciones = vm.util.ubicacionesCompletasPorEstante(angular.copy(estante));
        return (ubicaciones.totales-ubicaciones.ocupados)>0;
      } else {
        return false;
      }
    }

    function corroborarExistenciaUbicacionesNivel(){
      var ubicaciones = {};
      if (vm.nivel && vm.nivel.id){
        ubicaciones = vm.util.ubicacionesCompletasPorNivel(angular.copy(vm.nivel));
        return (ubicaciones.totales-ubicaciones.ocupados)>0;
      } else {
        return false;
      }
    }

    function corroborarExistenciaUbicacionesNivelMapa(nivel){
      var ubicaciones = {};
      if (nivel && nivel.id){
        ubicaciones = vm.util.ubicacionesCompletasPorNivel(angular.copy(nivel));
        return (ubicaciones.totales-ubicaciones.ocupados)>0;
      } else {
        return false;
      }
    }

    $scope.$watch('vm.nivel.numeroNivel', function(){
      if (vm.nivel && vm.nivel.numeroNivel) vm.ubicaciones = obtenerUbicacionesDisponibles();
      if (vm.ubicacion && vm.ubicacion.numeroUbicacion) vm.ubicacion=null;
    });

    $scope.$watch('vm.estante.numeroEstante', function(){
      if (vm.estante && vm.estante.numeroEstante) vm.niveles = $filter('filtroNoBorrados')(orderByFilter(vm.estante.niveles,'numeroPasillo',false));
      if (vm.ubicacion && vm.ubicacion.numeroUbicacion) vm.ubicacion=null;
      if (vm.nivel && vm.nivel.numeroNivel) vm.nivel=null;
      
    });

    $scope.$watch('vm.estructura.identificadorEstructura', function(){
      if (vm.estructura && vm.estructura.identificadorEstructura) vm.estantes = $filter('filtroNoBorrados')(orderByFilter(vm.estructura.estantes,'numeroPasillo',false));
      if (vm.ubicacion && vm.ubicacion.numeroUbicacion) vm.ubicacion=null;
      if (vm.nivel && vm.nivel.numeroNivel) vm.nivel=null;
      if (vm.estante && vm.estante.numeroEstante) vm.estante=null;
    });

    $scope.$watch('vm.pasillo.numeroPasillo', function(){
      if (vm.pasillo && vm.pasillo.numeroPasillo) vm.estructuras = $filter('filtroNoBorrados')(orderByFilter(vm.pasillo.estructuras,'numeroPasillo',false));
      if (vm.ubicacion && vm.ubicacion.numeroUbicacion) vm.ubicacion=null;
      if (vm.nivel && vm.nivel.numeroNivel) vm.nivel=null;
      if (vm.estante && vm.estante.numeroEstante) vm.estante=null;
      if (vm.estructura && vm.estructura.identificadorEstructura) vm.estructura=null;
    });

    $scope.$watch('vm.nave.nombre', function(){
      if (vm.nave && vm.nave.nombre) vm.pasillos = $filter('filtroNoBorrados')(orderByFilter(vm.nave.pasillos,'numeroPasillo',false));
      if (vm.ubicacion && vm.ubicacion.numeroUbicacion) vm.ubicacion=null;
      if (vm.nivel && vm.nivel.numeroNivel) vm.nivel=null;
      if (vm.estante && vm.estante.numeroEstante) vm.estante=null;
      if (vm.estructura && vm.estructura.identificadorEstructura) vm.estructura=null;
      if (vm.pasillo && vm.pasillo.numeroPasillo) vm.pasillo=null;
    });


  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoAtencionReclamo',DialogoAtencionReclamo);

  function DialogoAtencionReclamo($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/atencion-reclamo/modal.html',
        controller: 'ModalAtencionReclamoCtrl as vm',
        resolve: {
          egreso: function(Ingreso){
            if (config.objeto){
              return Ingreso.get({id:config.objeto}).$promise.then(function(data) {
                return data;
              });
            } else {
              return {};
            }
          },
          usuario: function(Usuario){
            return Usuario.obtenerUsuario().$promise.then(function(usuario){
              return usuario;
            });
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

'use strict';
angular.module('proyecto-az-suministro')
  .factory('AtencionReclamo', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/notificar/atencion-reclamo/:id", {id:"@id"});
  });
(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalAtencionReclamoCtrl', ModalAtencionReclamoCtrl);

  /** @ngInject */
  function ModalAtencionReclamoCtrl(NgTableParams, usuario, AtencionReclamo, egreso, $filter, $uibModalInstance, Ingreso, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.cerrar = cerrar;
    vm.egreso = egreso;
    vm.actualizarReclamo = actualizarReclamo;

    ServicioDialogos.cerrarDialogoCargando();


    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
    }

    function actualizarReclamo() {
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, '¿Está seguro que desea actualizar el reclamo?', function(){
       editar();
      },null,false);
    }

    function obtenerEgreso(){
      vm.egreso.usuarioAtencionReclamo = usuario;
      vm.egreso.fechaAtencionReclamo = new Date();
      return vm.egreso;
    }

    function editar(){
      AtencionReclamo.update(obtenerEgreso(), function(data){
        ServicioDialogos.mostrarDialogoGuardadoExito(null, 'Se ha actualizado el reclamo correctamente', function(){
          ServicioDialogos.abrirDialogoCargando();
          if ($('.modal.in').length<=1){
            $('.modal-backdrop').remove();
          }
          $uibModalInstance.close({
            egreso : data
          });
        });
      }, function(err){
        console.error(err);
        ServicioDialogos.mostrarDialogoError(null, "No se ha podido actualizar el reclamo");
      });
    }
  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoAsignarUbicaciones',DialogoAsignarUbicaciones);

  function DialogoAsignarUbicaciones($uibModal, ServicioDialogos) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/asignar-ubicaciones/modal-asignar-ubicaciones.html',
        controller: 'ModalAsignarUbicaciones as vm',
        resolve: {
          deposito: function(Deposito){
            return Deposito.get({id:config.deposito.id}).$promise.then(function(data){
              return data;
            });
          },
          detallesNoInventariables: function(){
           return config.detallesNoInventariables;
          },
          detallesInventariables: function(){
           return config.detallesInventariables;
          },
          asignadas: function(){
            return config.asignadas;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalAsignarUbicaciones', ModalAsignarUbicaciones);

  /** @ngInject */
  function ModalAsignarUbicaciones(NgTableParams, Util, focus, $q, Ubicacion, asignadas, ServicioModales, detallesInventariables, detallesNoInventariables, deposito, $timeout, $uibModalInstance, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.util = Util;
    vm.naves = orderByFilter(deposito.naves,'nombre',false);
    vm.deposito = deposito;
    vm.detallesInventariables = detallesInventariables;
    vm.detallesNoInventariables = detallesNoInventariables;
    vm.ubicacionesAsignadas = asignadas ? asignadas : [];
    vm.corroborarExistenciaUbicaciones = corroborarExistenciaUbicaciones;

    ServicioDialogos.cerrarDialogoCargando();


    vm.asignar = asignar;
    vm.cerrar = cerrar;



    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.dismiss();
    }

    function asignar(){
      ServicioDialogos.abrirDialogoCargando();
      $timeout(function(){
        recorrerUbicaciones();
        armarUbicaciones();
      }, 100);

    }

    function corroborarExistenciaUbicaciones(){
      var ubicaciones = {};
      if (vm.nave && vm.nave.id){
        ubicaciones = vm.util.ubicacionesCompletasPorNave(angular.copy(vm.nave));
        return (ubicaciones.totales-(ubicaciones.ocupados+ubicaciones.semi))>0;
      } else {
        return false;
      }
    }

    function setearUbicacionesCompletas(){
      vm.ubicacionesAsignadas.forEach(function(ubi){
        vm.detalles.forEach(function(det){
          if (det.ubicacion && det.ubicacion.id==ubi.id){
            det.ubicacion = angular.copy(ubi);
          }
        });
      });
    }

    function armarUbicaciones(){
      traerUbicaciones()
      .then(function(){
        setearUbicacionesCompletas();
        ServicioDialogos.cerrarDialogoCargando();
        $('.modal-backdrop').remove();
        $uibModalInstance.close({detalles:vm.detalles, asignadas:vm.ubicacionesAsignadas});
      }, function(err){
        console.log(err);
      });
    }

    function traerUbicaciones(){
      var defer = $q.defer();
      var promise = defer.promise;
      vm.detalles.forEach(function(det) {
        if (det.ubicacion){
          promise = promise.then(function(){
            return traerUbicacionIndividual(det.ubicacion.id).then(function(){
              defer.resolve(true);
            });
          });
        }
      });
      defer.resolve(true);
      return promise;
    }

    function traerUbicacionIndividual(ubi){
      var defered = $q.defer();
      var promesa = defered.promise;
      Ubicacion.get({id:ubi},function(ubicacion){
        if (noEstaAsignada(ubicacion)){
          vm.ubicacionesAsignadas.push(ubicacion);
        }
        defered.resolve(true);
      }, function(err){
        console.log(err);
        return $q.reject();
      });
      return promesa;
    }

    function noEstaAsignada(ubicacion){
      var noEsta = true;
      vm.ubicacionesAsignadas.forEach(function(ub){
        if (ub.id==ubicacion.id){
          noEsta = false;
        }
      });
      return noEsta;
    }

    function obtenerAsignadaCompleta(ubicacion){
      var ubi = {};
      vm.ubicacionesAsignadas.forEach(function(ub){
        if (ub.id==ubicacion.id){
          ubi = ub;
        }
      });
      return ubi;
    }

    function recorrerUbicaciones(){
      vm.ubicacionesLibres = [];
      vm.ubicacionesOcupadas = [];
      vm.nave.pasillos.forEach(function(pasillo){
        pasillo.estructuras.forEach(function(estructura){
          estructura.estantes.forEach(function(estante){
            estante.niveles.forEach(function(nivel){
              nivel.ubicaciones.forEach(function(ubicacion){
                if (ubicacion.estadoUbicacion.id==1 && noEstaAsignada(ubicacion) && !ubicacion.borrado){
                  vm.ubicacionesLibres.push(ubicacion);
                }
                if ((ubicacion.estadoUbicacion.id==2 || ubicacion.estadoUbicacion.id==3) && !ubicacion.borrado) {
                  vm.ubicacionesOcupadas.push(ubicacion);
                }
                if (!noEstaAsignada(ubicacion)){
                  var ub = obtenerAsignadaCompleta(ubicacion);
                  vm.ubicacionesOcupadas.push(ub);
                }
              });
            });
          });
        });
      });
      armarDetalles();
    }

    function armarDetalles(){
      vm.detalles = [];
      if (vm.detallesInventariables && vm.detallesInventariables.length>0){
        vm.detallesInventariables.forEach(function(inv){
          vm.detalles.push(inv);
        });
      }
      vm.detallesNoInventariables.forEach(function(noInv){
        var tipo = angular.copy(noInv.suministro.tipoSuministro);
        noInv.tipoSuministro = tipo;
        vm.detalles.push(noInv);
      });
      asignarUbicaciones();
    }

    function asignarUbicaciones(){
      vm.detalles.forEach(function(detalle){
        if (!(detalle.ubicacion && detalle.ubicacion.id)){
          buscarLugaresCategoria(detalle);
        }
      });
    }

    function buscarLugaresCategoria(detalle){
      var ubicacionesCategoria = [];
      vm.ubicacionesLibres.forEach(function(ubi){
        if (ubi.categoriaPeso.id==detalle.tipoSuministro.categoriaPeso.id){
          ubicacionesCategoria.push(ubi);
        }
      });
      if (ubicacionesCategoria.length>0){
        buscarTiposOcupados(ubicacionesCategoria, detalle);
      }
    }

    function buscarTiposOcupados(ubicacionesCategoria, detalle){
      var lugaresOcupados = [];
      vm.ubicacionesOcupadas.forEach(function(ubicacion){
        if (coincideTipo(ubicacion, detalle)){
          lugaresOcupados.push(ubicacion);
        }
      });

      if (lugaresOcupados.length>0){
        asignarLugarCercano(lugaresOcupados, ubicacionesCategoria, detalle);
      } else {
        asignarUbicacion(detalle, ubicacionesCategoria[0]);
      }
    }

    function coincideTipo(ubicacion, detalle){
      var ban = false;
      ubicacion.suministros.forEach(function(ubi){
        if (ubi && detalle.tipoSuministro.id==ubi.tipoSuministro.id){
          ban=true;
        }
      });
      return ban;
    }

    function asignarLugarCercano(lugaresOcupados, lugaresLibres, detalle){

      var distancia = Math.abs(lugaresLibres[0].numeroOrden - lugaresOcupados[0].numeroOrden);
      var mejor = lugaresLibres[0];
      var intermedia = null;
      lugaresOcupados.forEach(function(ocupado){
        lugaresLibres.forEach(function(libre){
          intermedia = Math.abs(ocupado.numeroOrden-libre.numeroOrden);
          if (intermedia<distancia){
            mejor = libre;
            distancia = intermedia;
          }
        });
      });
      asignarUbicacion(detalle, mejor);
    }

    function asignarUbicacion(detalle, ubicacion){
      var asignada = angular.copy(ubicacion);
      detalle.ubicacion = asignada;
      ocuparUbicacion(ubicacion, detalle);
    }

    function ocuparUbicacion(ubicacion, detalle){
      var index = null;
      for (var i = vm.ubicacionesLibres.length - 1; i >= 0; i--) {
        if (vm.ubicacionesLibres[i].id == ubicacion.id){
          index = i;
        }
      }
      var ocupada = vm.ubicacionesLibres.splice(index,1);
      ocuparSuministrosUbicacion(ocupada[0], detalle);
    }

    function ocuparSuministrosUbicacion(ocupada, detalle){
      if (detalle.suministro){
        ocuparSuministrosUbicacionNoInventariables(ocupada, detalle);
      } else {
        ocuparSuministrosUbicacionInventariables(ocupada, detalle);
      }
    }

    function ocuparSuministrosUbicacionNoInventariables(ocupada, detalle){
      if (ocupada.suministros){
        ocupada.suministros.push(detalle.suministro);
      } else {
        ocupada.suministros = [];
        ocupada.suministros.push(detalle.suministro);
      }
      vm.ubicacionesOcupadas.push(ocupada);
    }

    function ocuparSuministrosUbicacionInventariables(ocupada, detalle){
      if (!ocupada.suministros){
        ocupada.suministros = [];
      }
      detalle.detalles.forEach(function(det){
        ocupada.suministros.push(det.suministro);
      });
      vm.ubicacionesOcupadas.push(ocupada);
    }






  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoAsignarUbicacionIndividualCajas', DialogoAsignarUbicacionIndividualCajas);

  function DialogoAsignarUbicacionIndividualCajas($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/asignar-ubicacion-individual-cajas/modal-asignar-ubicacion-individual-cajas.html',
        controller: 'ModalAsignarUbicacionIndividualCajas as vm',
        resolve: {
          deposito: function(DepositoHastaUbicacion){
            return DepositoHastaUbicacion.get({id:config.deposito.id}).$promise.then(function(data){
              return data;
            });
          },
          detalle: function(){
            return config.detalle;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalAsignarUbicacionIndividualCajas', ModalAsignarUbicacionIndividualCajas);

  /** @ngInject */
  function ModalAsignarUbicacionIndividualCajas(NgTableParams, Util, $filter, focus, $q, Ubicacion, detalle, ServicioModales, deposito, $timeout, $uibModalInstance, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.util = Util;
    vm.naves = orderByFilter(deposito.naves,'nombre',false);
    vm.deposito = deposito;
    vm.detalle = detalle;

    vm.corroborarExistenciaUbicacionesNave = corroborarExistenciaUbicacionesNave;
    vm.corroborarExistenciaUbicacionesPasillo = corroborarExistenciaUbicacionesPasillo;
    vm.corroborarExistenciaUbicacionesPasilloMapa = corroborarExistenciaUbicacionesPasilloMapa;
    vm.corroborarExistenciaUbicacionesEstructura = corroborarExistenciaUbicacionesEstructura;
    vm.corroborarExistenciaUbicacionesEstructuraMapa = corroborarExistenciaUbicacionesEstructuraMapa;
    vm.corroborarExistenciaUbicacionesEstante = corroborarExistenciaUbicacionesEstante;
    vm.corroborarExistenciaUbicacionesEstanteMapa = corroborarExistenciaUbicacionesEstanteMapa;
    vm.corroborarExistenciaUbicacionesNivel = corroborarExistenciaUbicacionesNivel;
    vm.corroborarExistenciaUbicacionesNivelMapa = corroborarExistenciaUbicacionesNivelMapa;

    vm.atras = atras;

    vm.clasePasillos = clasePasillos;
    vm.claseEstante = claseEstante;
    vm.claseNivel = claseNivel;
    vm.claseUbicaciones = claseUbicaciones;

    vm.elegirPasillo = elegirPasillo;
    vm.elegirEstructura = elegirEstructura;
    vm.elegirEstante = elegirEstante;
    vm.elegirNivel = elegirNivel;
    vm.elegirUbicacion = elegirUbicacion;

    vm.deshabilitarUbicacion = deshabilitarUbicacion;

    ServicioDialogos.cerrarDialogoCargando();

    vm.asignar = asignar;
    vm.cerrar = cerrar;

    function obtenerCategoriaDetalle(){
      if (vm.detalle.tipoSuministro){
        return vm.detalle.tipoSuministro.categoriaPeso.id;
      } else {
        return vm.detalle.suministro.tipoSuministro.categoriaPeso.id;
      }
    }

    function asignar(){
      var categoria = obtenerCategoriaDetalle();
      if (categoria==vm.ubicacion.categoriaPeso.id){
        asignarUbicacion();
      } else {
        informarCategoriaDistinta();
      }
    }

    function informarCategoriaDistinta(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(
        null,
        "La categoría de peso de la ubicación, no es igual a la del suministro que intenta asignar.\n¿Está seguro que desea continuar?",
        function(){
          asignarUbicacion();
        }
      );
    }

    function asignarUbicacion(){
      ServicioDialogos.abrirDialogoCargando();
      Ubicacion.get({id:vm.ubicacion.id}, function(data){
        ServicioDialogos.cerrarDialogoCargando();
        if ($('.modal.in').length<=1){
          $('.modal-backdrop').remove();
        }
        $uibModalInstance.close({
          ubicacionAsignada : data
        });
      }, function(err){
        console.log(err);
      });
    }

    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
    }

    function atras(){
      if (vm.pasillo && vm.estructura && vm.estante && vm.nivel && vm.ubicacion) {vm.ubicacion = null;}
      else if (vm.pasillo && vm.estructura && vm.estante && vm.nivel && !vm.ubicacion) {vm.nivel = null;}
      else if (vm.pasillo && vm.estructura && vm.estante && !vm.nivel && !vm.ubicacion) {vm.estante = null;}
      else if (vm.pasillo && vm.estructura && !vm.estante && !vm.nivel && !vm.ubicacion) {vm.estructura = null;}
      else if (vm.pasillo && !vm.estructura && !vm.estante && !vm.nivel && !vm.ubicacion) {vm.pasillo = null;}
    }

    function deshabilitarUbicacion(ubicacion){
      return ubicacion.estadoUbicacion.id==2;
    }

    function clasePasillos() {
      var pasillosNoBorrados = Util.traerNoBorrados(vm.pasillos);
      var cantPasillos= 0;
      for (var i = pasillosNoBorrados.length - 1; i >= 0; i--) {
        if (pasillosNoBorrados[i].estructuras.length>0) {
          cantPasillos = cantPasillos + 1;
        }
      }
      return {"width": parseInt(100/pasillosNoBorrados.length)+"%"};
    }


    function claseUbicaciones(){
      var cantidadUbicaciones = Util.contarNoBorrados(vm.nivel.ubicaciones);
        return {"width":parseInt(100/cantidadUbicaciones)+"%"};
    }

    function claseEstante(estante){
      var cantEstantes = Util.contarNoBorrados(vm.estructura.estantes);
      return {"width": parseInt(100/cantEstantes)+"%"};
    }

    function claseNivel(estante){
      var cantEstantes = Util.contarNoBorrados(vm.estante.niveles);
      return {"width": parseInt(100/cantEstantes)+"%"};
    }

    function elegirPasillo(pasillo){
      vm.pasillo = pasillo;
    }

    function elegirUbicacion(ubicacion){
      if (ubicacion.estadoUbicacion.id!==2){
        vm.ubicacion = ubicacion;
      }
    }

    function elegirEstructura(estructura){
      vm.estructura = estructura;
    }

    function elegirEstante(estante){
      vm.estante = estante;
    }

    function elegirNivel(nivel){
      vm.nivel = nivel;
    }

    function obtenerUbicacionesDisponibles(){
      return orderByFilter(vm.nivel.ubicaciones,'numeroUbicacion', false);
    }

    function corroborarExistenciaUbicacionesNave(){
      var ubicaciones = {};
      if (vm.nave && vm.nave.id){
        ubicaciones = vm.util.ubicacionesCompletasPorNave(angular.copy(vm.nave));
        return (ubicaciones.totales-ubicaciones.ocupados)>0;
      } else {
        return false;
      }
    }

    function corroborarExistenciaUbicacionesPasillo(){
      var ubicaciones = {};
      if (vm.pasillo && vm.pasillo.id){
        ubicaciones = vm.util.ubicacionesCompletasPorPasillo(angular.copy(vm.pasillo));
        return (ubicaciones.totales-ubicaciones.ocupados)>0;
      } else {
        return false;
      }
    }

    function corroborarExistenciaUbicacionesPasilloMapa(pasillo){
      var ubicaciones = {};
      if (pasillo && pasillo.id){
        ubicaciones = vm.util.ubicacionesCompletasPorPasillo(angular.copy(pasillo));
        return (ubicaciones.totales-ubicaciones.ocupados)>0;
      } else {
        return false;
      }
    }

    function corroborarExistenciaUbicacionesEstructura(){
      var ubicaciones = {};
      if (vm.estructura && vm.estructura.id){
        ubicaciones = vm.util.ubicacionesCompletasPorEstructura(angular.copy(vm.estructura));
        return (ubicaciones.totales-ubicaciones.ocupados)>0;
      } else {
        return false;
      }
    }

    function corroborarExistenciaUbicacionesEstructuraMapa(estructura){
      var ubicaciones = {};
      if (estructura && estructura.id){
        ubicaciones = vm.util.ubicacionesCompletasPorEstructura(angular.copy(estructura));
        return (ubicaciones.totales-ubicaciones.ocupados)>0;
      } else {
        return false;
      }
    }

    function corroborarExistenciaUbicacionesEstante(){
      var ubicaciones = {};
      if (vm.estante && vm.estante.id){
        ubicaciones = vm.util.ubicacionesCompletasPorEstante(angular.copy(vm.estante));
        return (ubicaciones.totales-ubicaciones.ocupados)>0;
      } else {
        return false;
      }
    }

      function corroborarExistenciaUbicacionesEstanteMapa(estante){
      var ubicaciones = {};
      if (estante && estante.id){
        ubicaciones = vm.util.ubicacionesCompletasPorEstante(angular.copy(estante));
        return (ubicaciones.totales-ubicaciones.ocupados)>0;
      } else {
        return false;
      }
    }

    function corroborarExistenciaUbicacionesNivel(){
      var ubicaciones = {};
      if (vm.nivel && vm.nivel.id){
        ubicaciones = vm.util.ubicacionesCompletasPorNivel(angular.copy(vm.nivel));
        return (ubicaciones.totales-ubicaciones.ocupados)>0;
      } else {
        return false;
      }
    }

    function corroborarExistenciaUbicacionesNivelMapa(nivel){
      var ubicaciones = {};
      if (nivel && nivel.id){
        ubicaciones = vm.util.ubicacionesCompletasPorNivel(angular.copy(nivel));
        return (ubicaciones.totales-ubicaciones.ocupados)>0;
      } else {
        return false;
      }
    }

    $scope.$watch('vm.nivel.numeroNivel', function(){
      if (vm.nivel && vm.nivel.numeroNivel) vm.ubicaciones = obtenerUbicacionesDisponibles();
      if (vm.ubicacion && vm.ubicacion.numeroUbicacion) vm.ubicacion=null;
    });

    $scope.$watch('vm.estante.numeroEstante', function(){
      if (vm.estante && vm.estante.numeroEstante) vm.niveles = $filter('filtroNoBorrados')(orderByFilter(vm.estante.niveles,'numeroPasillo',false));
      if (vm.ubicacion && vm.ubicacion.numeroUbicacion) vm.ubicacion=null;
      if (vm.nivel && vm.nivel.numeroNivel) vm.nivel=null;
      
    });

    $scope.$watch('vm.estructura.identificadorEstructura', function(){
      if (vm.estructura && vm.estructura.identificadorEstructura) vm.estantes = $filter('filtroNoBorrados')(orderByFilter(vm.estructura.estantes,'numeroPasillo',false));
      if (vm.ubicacion && vm.ubicacion.numeroUbicacion) vm.ubicacion=null;
      if (vm.nivel && vm.nivel.numeroNivel) vm.nivel=null;
      if (vm.estante && vm.estante.numeroEstante) vm.estante=null;
    });

    $scope.$watch('vm.pasillo.numeroPasillo', function(){
      if (vm.pasillo && vm.pasillo.numeroPasillo) vm.estructuras = $filter('filtroNoBorrados')(orderByFilter(vm.pasillo.estructuras,'numeroPasillo',false));
      if (vm.ubicacion && vm.ubicacion.numeroUbicacion) vm.ubicacion=null;
      if (vm.nivel && vm.nivel.numeroNivel) vm.nivel=null;
      if (vm.estante && vm.estante.numeroEstante) vm.estante=null;
      if (vm.estructura && vm.estructura.identificadorEstructura) vm.estructura=null;
    });

    $scope.$watch('vm.nave.nombre', function(){
      if (vm.nave && vm.nave.nombre) vm.pasillos = $filter('filtroNoBorrados')(orderByFilter(vm.nave.pasillos,'numeroPasillo',false));
      if (vm.ubicacion && vm.ubicacion.numeroUbicacion) vm.ubicacion=null;
      if (vm.nivel && vm.nivel.numeroNivel) vm.nivel=null;
      if (vm.estante && vm.estante.numeroEstante) vm.estante=null;
      if (vm.estructura && vm.estructura.identificadorEstructura) vm.estructura=null;
      if (vm.pasillo && vm.pasillo.numeroPasillo) vm.pasillo=null;
    });


  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoAgregarFotoProblema',DialogoAgregarFotoProblema);

  function DialogoAgregarFotoProblema($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'md',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/asignar-foto-problema/asignar-foto-problema.html',
        controller: 'ModalAgregarFotoProblema as vm',
        resolve: {
          problema: function(){
            return config.problema;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalAgregarFotoProblema', ModalAgregarFotoProblema);

  /** @ngInject */
  function ModalAgregarFotoProblema(NgTableParams, problema, ServicioModales, ServicioDialogos, $uibModalInstance, $stateParams, $scope) {

    var vm = this;
    vm.problema = problema;
    vm.cerrar = cerrar;
    vm.foto = vm.problema.encabezadoFoto+vm.problema.cuerpoFoto;
    vm.abrirSeleccionFoto = abrirSeleccionFoto;
    vm.quitarFoto = quitarFoto;


    function quitarFoto(){
        vm.foto=null;
        vm.problema.encabezadoFoto = null;
        vm.problema.cuerpoFoto = null;
    }

    function abrirSeleccionFoto(){
      ServicioModales.abrirModalSeleccionarFoto({
        onResult: function(res) {
          vm.problema.encabezadoFoto = res.encabezadoFoto;
          vm.problema.cuerpoFoto = res.cuerpoFoto;
          vm.foto = vm.problema.encabezadoFoto+vm.problema.cuerpoFoto;
        },
      });
    }

    ServicioDialogos.cerrarDialogoCargando();

    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.dismiss();
    }
  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoAsignarUbicacionIndividual', DialogoAsignarUbicacionIndividual);

  function DialogoAsignarUbicacionIndividual($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/asignar-ubicacion-individual/modal-asignar-ubicacion-individual.html',
        controller: 'ModalAsignarUbicacionIndividual as vm',
        resolve: {
          deposito: function(DepositoHastaUbicacion){
            return DepositoHastaUbicacion.get({id:config.deposito.id}).$promise.then(function(data){
              return data;
            });
          },

          detalle: function(){
            return config.detalle;
          },
          ubicacionesAsignadas: function(){
            return config.asignadas;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();


(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalAsignarUbicacionIndividual', ModalAsignarUbicacionIndividual);

  /** @ngInject */
  function ModalAsignarUbicacionIndividual(NgTableParams, Util, $filter, focus, $q, Ubicacion, detalle, ubicacionesAsignadas, ServicioModales, deposito, $timeout, $uibModalInstance, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.util = Util;
    vm.naves = orderByFilter(deposito.naves,'nombre',false);
    vm.deposito = deposito;
    vm.detalle = detalle;
    vm.ubicacionesAsignadas = ubicacionesAsignadas;

    vm.corroborarExistenciaUbicacionesNave = corroborarExistenciaUbicacionesNave;
    vm.corroborarExistenciaUbicacionesPasillo = corroborarExistenciaUbicacionesPasillo;
    vm.corroborarExistenciaUbicacionesPasilloMapa = corroborarExistenciaUbicacionesPasilloMapa;
    vm.corroborarExistenciaUbicacionesEstructura = corroborarExistenciaUbicacionesEstructura;
    vm.corroborarExistenciaUbicacionesEstructuraMapa = corroborarExistenciaUbicacionesEstructuraMapa;
    vm.corroborarExistenciaUbicacionesEstante = corroborarExistenciaUbicacionesEstante;
    vm.corroborarExistenciaUbicacionesEstanteMapa = corroborarExistenciaUbicacionesEstanteMapa;
    vm.corroborarExistenciaUbicacionesNivel = corroborarExistenciaUbicacionesNivel;
    vm.corroborarExistenciaUbicacionesNivelMapa = corroborarExistenciaUbicacionesNivelMapa;

    vm.atras = atras;

    vm.clasePasillos = clasePasillos;
    vm.claseEstante = claseEstante;
    vm.claseNivel = claseNivel;
    vm.claseUbicaciones = claseUbicaciones;

    vm.elegirPasillo = elegirPasillo;
    vm.elegirEstructura = elegirEstructura;
    vm.elegirEstante = elegirEstante;
    vm.elegirNivel = elegirNivel;
    vm.elegirUbicacion = elegirUbicacion;

    vm.desabilitarUbicacion = desabilitarUbicacion;

    ServicioDialogos.cerrarDialogoCargando();

    vm.asignar = asignar;
    vm.cerrar = cerrar;

    function obtenerCategoriaDetalle(){
      if (vm.detalle.tipoSuministro){
        return vm.detalle.tipoSuministro.categoriaPeso.id;
      } else {
        return vm.detalle.suministro.tipoSuministro.categoriaPeso.id;
      }
    }

    function asignar(){
      var categoria = obtenerCategoriaDetalle();
      if (categoria==vm.ubicacion.categoriaPeso.id){
        asignarUbicacion();
      } else {
        informarCategoriaDistinta();
      }
    }

    function informarCategoriaDistinta(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(
        null,
        "La categoría de peso de la ubicación, no es igual a la del suministro que intenta asignar.\n¿Está seguro que desea continuar?",
        function(){
          asignarUbicacion();
        }
      );
    }

    function asignarUbicacion(){
      ServicioDialogos.abrirDialogoCargando();
      controlarUbicacionYaAsignada();
      Ubicacion.get({id:vm.ubicacion.id}, function(data){
        ServicioDialogos.cerrarDialogoCargando();
        $('.modal-backdrop').remove();
        $uibModalInstance.close({
          ubicacionAsignada : data
        });
      }, function(err){
        console.log(err);
      });
    }

    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.dismiss();
    }

    function atras(){
      if (vm.pasillo && vm.estructura && vm.estante && vm.nivel && vm.ubicacion) {vm.ubicacion = null;}
      else if (vm.pasillo && vm.estructura && vm.estante && vm.nivel && !vm.ubicacion) {vm.nivel = null;}
      else if (vm.pasillo && vm.estructura && vm.estante && !vm.nivel && !vm.ubicacion) {vm.estante = null;}
      else if (vm.pasillo && vm.estructura && !vm.estante && !vm.nivel && !vm.ubicacion) {vm.estructura = null;}
      else if (vm.pasillo && !vm.estructura && !vm.estante && !vm.nivel && !vm.ubicacion) {vm.pasillo = null;}
    }

    function desabilitarUbicacion(ubicacion){
      return ubicacion.estadoUbicacion.id==2;
    }

    function clasePasillos() {
      var pasillosNoBorrados = Util.traerNoBorrados(vm.pasillos);
      var cantPasillos= 0;
      for (var i = pasillosNoBorrados.length - 1; i >= 0; i--) {
        if (pasillosNoBorrados[i].estructuras.length>0) {
          cantPasillos = cantPasillos + 1;
        }
      }
      return {"width": parseInt(100/pasillosNoBorrados.length)+"%"};
    }


    function claseUbicaciones(){
      var cantidadUbicaciones = Util.contarNoBorrados(vm.nivel.ubicaciones);
        return {"width":parseInt(100/cantidadUbicaciones)+"%"};
    }

    function claseEstante(estante){
      var cantEstantes = Util.contarNoBorrados(vm.estructura.estantes);
      return {"width": parseInt(100/cantEstantes)+"%"};
    }

    function claseNivel(estante){
      var cantEstantes = Util.contarNoBorrados(vm.estante.niveles);
      return {"width": parseInt(100/cantEstantes)+"%"};
    }

    function elegirPasillo(pasillo){
      vm.pasillo = pasillo;
    }

    function elegirUbicacion(ubicacion){
      if (ubicacion.estadoUbicacion.id!==2){
        vm.ubicacion = ubicacion;
      }
    }

    function elegirEstructura(estructura){
      vm.estructura = estructura;
    }

    function elegirEstante(estante){
      vm.estante = estante;
    }

    function elegirNivel(nivel){
      vm.nivel = nivel;
    }

    function controlarUbicacionYaAsignada(){
      if (vm.detalle.ubicacion){
        liberarUbicacion(vm.detalle.ubicacion);
      }
    }

    function liberarUbicacion(ubicacion){
      var index = null;
      for (var i = vm.ubicacionesAsignadas.length - 1; i >= 0; i--) {
        if (vm.ubicacionesAsignadas[i].id == ubicacion.id){
          index = i;
        }
      }
      if (index!==null) vm.ubicacionesAsignadas.splice(index,1);
    }

    function obtenerUbicacionesDisponibles(){
      return orderByFilter(vm.nivel.ubicaciones,'numeroUbicacion', false);
      //PRUEBA repetir ubicaciones
      if (vm.nivel && vm.nivel.ubicaciones && vm.ubicacionesAsignadas) {
        var ubicaciones = [];
        vm.nivel.ubicaciones.forEach(function(ub){
          var ban = false;
          vm.ubicacionesAsignadas.forEach(function(asignada){
            if (ub.id==asignada.id){
              ban = true;
            }
          });
          if (!ban && !ub.borrado) {
            ubicaciones.push(ub);
          }
        });
        return orderByFilter(ubicaciones,'numeroUbicacion', false);
      } else if (vm.nivel && vm.nivel.ubicaciones) {
        return orderByFilter(vm.nivel.ubicaciones,'numeroUbicacion', false);
      }
    }

    function corroborarExistenciaUbicacionesNave(){
      var ubicaciones = {};
      if (vm.nave && vm.nave.id){
        ubicaciones = vm.util.ubicacionesCompletasPorNave(angular.copy(vm.nave));
        return (ubicaciones.totales-ubicaciones.ocupados)>0;
      } else {
        return false;
      }
    }

    function corroborarExistenciaUbicacionesPasillo(){
      var ubicaciones = {};
      if (vm.pasillo && vm.pasillo.id){
        ubicaciones = vm.util.ubicacionesCompletasPorPasillo(angular.copy(vm.pasillo));
        return (ubicaciones.totales-ubicaciones.ocupados)>0;
      } else {
        return false;
      }
    }

    function corroborarExistenciaUbicacionesPasilloMapa(pasillo){
      var ubicaciones = {};
      if (pasillo && pasillo.id){
        ubicaciones = vm.util.ubicacionesCompletasPorPasillo(angular.copy(pasillo));
        return (ubicaciones.totales-ubicaciones.ocupados)>0;
      } else {
        return false;
      }
    }

    function corroborarExistenciaUbicacionesEstructura(){
      var ubicaciones = {};
      if (vm.estructura && vm.estructura.id){
        ubicaciones = vm.util.ubicacionesCompletasPorEstructura(angular.copy(vm.estructura));
        return (ubicaciones.totales-ubicaciones.ocupados)>0;
      } else {
        return false;
      }
    }

    function corroborarExistenciaUbicacionesEstructuraMapa(estructura){
      var ubicaciones = {};
      if (estructura && estructura.id){
        ubicaciones = vm.util.ubicacionesCompletasPorEstructura(angular.copy(estructura));
        return (ubicaciones.totales-ubicaciones.ocupados)>0;
      } else {
        return false;
      }
    }

    function corroborarExistenciaUbicacionesEstante(){
      var ubicaciones = {};
      if (vm.estante && vm.estante.id){
        ubicaciones = vm.util.ubicacionesCompletasPorEstante(angular.copy(vm.estante));
        return (ubicaciones.totales-ubicaciones.ocupados)>0;
      } else {
        return false;
      }
    }

      function corroborarExistenciaUbicacionesEstanteMapa(estante){
      var ubicaciones = {};
      if (estante && estante.id){
        ubicaciones = vm.util.ubicacionesCompletasPorEstante(angular.copy(estante));
        return (ubicaciones.totales-ubicaciones.ocupados)>0;
      } else {
        return false;
      }
    }

    function corroborarExistenciaUbicacionesNivel(){
      var ubicaciones = {};
      if (vm.nivel && vm.nivel.id){
        ubicaciones = vm.util.ubicacionesCompletasPorNivel(angular.copy(vm.nivel));
        return (ubicaciones.totales-ubicaciones.ocupados)>0;
      } else {
        return false;
      }
    }

    function corroborarExistenciaUbicacionesNivelMapa(nivel){
      var ubicaciones = {};
      if (nivel && nivel.id){
        ubicaciones = vm.util.ubicacionesCompletasPorNivel(angular.copy(nivel));
        return (ubicaciones.totales-ubicaciones.ocupados)>0;
      } else {
        return false;
      }
    }

    $scope.$watch('vm.nivel.numeroNivel', function(){
      if (vm.nivel && vm.nivel.numeroNivel) vm.ubicaciones = obtenerUbicacionesDisponibles();
      if (vm.ubicacion && vm.ubicacion.numeroUbicacion) vm.ubicacion=null;
    });

    $scope.$watch('vm.estante.numeroEstante', function(){
      if (vm.estante && vm.estante.numeroEstante) vm.niveles = $filter('filtroNoBorrados')(orderByFilter(vm.estante.niveles,'numeroPasillo',false));
      if (vm.ubicacion && vm.ubicacion.numeroUbicacion) vm.ubicacion=null;
      if (vm.nivel && vm.nivel.numeroNivel) vm.nivel=null;
      
    });

    $scope.$watch('vm.estructura.identificadorEstructura', function(){
      if (vm.estructura && vm.estructura.identificadorEstructura) vm.estantes = $filter('filtroNoBorrados')(orderByFilter(vm.estructura.estantes,'numeroPasillo',false));
      if (vm.ubicacion && vm.ubicacion.numeroUbicacion) vm.ubicacion=null;
      if (vm.nivel && vm.nivel.numeroNivel) vm.nivel=null;
      if (vm.estante && vm.estante.numeroEstante) vm.estante=null;
    });

    $scope.$watch('vm.pasillo.numeroPasillo', function(){
      if (vm.pasillo && vm.pasillo.numeroPasillo) vm.estructuras = $filter('filtroNoBorrados')(orderByFilter(vm.pasillo.estructuras,'numeroPasillo',false));
      if (vm.ubicacion && vm.ubicacion.numeroUbicacion) vm.ubicacion=null;
      if (vm.nivel && vm.nivel.numeroNivel) vm.nivel=null;
      if (vm.estante && vm.estante.numeroEstante) vm.estante=null;
      if (vm.estructura && vm.estructura.identificadorEstructura) vm.estructura=null;
    });

    $scope.$watch('vm.nave.nombre', function(){
      if (vm.nave && vm.nave.nombre) vm.pasillos = $filter('filtroNoBorrados')(orderByFilter(vm.nave.pasillos,'numeroPasillo',false));
      if (vm.ubicacion && vm.ubicacion.numeroUbicacion) vm.ubicacion=null;
      if (vm.nivel && vm.nivel.numeroNivel) vm.nivel=null;
      if (vm.estante && vm.estante.numeroEstante) vm.estante=null;
      if (vm.estructura && vm.estructura.identificadorEstructura) vm.estructura=null;
      if (vm.pasillo && vm.pasillo.numeroPasillo) vm.pasillo=null;
    });


  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoAgregarSuministroIngresoExcel',DialogoAgregarSuministroIngresoExcel);

  function DialogoAgregarSuministroIngresoExcel($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/agregar-suministros-excel/modal-agregar-suministro-excel.html',
        controller: 'ModalAgregarSuministroIngresoExcelCtrl as vm',
        resolve: {
          grupos: function(GrupoEmpresa){
            return GrupoEmpresa.query({id:config.empresa.id}).$promise.then(function(data) {
              return data;
            });
          },
          estadoSuministro: function(EstadoSuministro){
            return EstadoSuministro.get({id:2}).$promise.then(function(data) {
              return data;
            });
          },
          numeroRow: function(){
            return config.numeroRow;
          },
          caja: function(){
            return config.caja;
          },
          detalles: function(){
           return config.detalles;
          },
          numeroCajas: function(){
            return config.numeroCajas;
          },
          empresa: function(){
            return config.empresa.id;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

'use strict';
angular.module('proyecto-az-suministro')
  .factory('asdasdasd', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministroinventariable?tipo.id=:id",{id:'@id'});
  });
(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalAgregarSuministroIngresoExcelCtrl', ModalAgregarSuministroIngresoExcelCtrl);

  /** @ngInject */
  function ModalAgregarSuministroIngresoExcelCtrl(NgTableParams, focus, $q, caja, empresa, numeroCajas, NumeroCajaCerradaUtilizado, TiposPorEmpresa, SuministroPorInventarioEmpresa, SuministroPorTipoInventario, SuministroPorTipo, SuministroPorTipoEstado, numeroRow, estadoSuministro, ServicioModales, detalles, $uibModalInstance, HeaderBarService, TipoSuministroFamilia, FamiliaSuministroGrupo, TipoSuministro, grupos, $timeout, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.empresaId = empresa;
    vm.grupos = orderByFilter(grupos,'nombre',false);
    vm.detalles = detalles;
    vm.caja = caja;
    vm.numeroCajas = numeroCajas;
    vm.estadoSuministro = estadoSuministro;
    vm.numeroRow = numeroRow;
    vm.filtrarBienes = filtrarBienes;
    vm.cambioRadio = cambioRadio;

    vm.agregar = agregar;
    vm.comprobarNumeroCaja = comprobarNumeroCaja;
    vm.cerrar = cerrar;
    vm.campos = [];
    vm.cantidadPorPallets = cantidadPorPallets;
    vm.totalSuministros = totalSuministros;
    vm.comprobarCantidadPorPallets = comprobarCantidadPorPallets;
    vm.comprobarTotalSuministro = vm.comprobarTotalSuministro;
    vm.agregarBienFiltrado = agregarBienFiltrado;
    vm.agregarNuevoBien = agregarNuevoBien;
    vm.listaInventariables = [];
    vm.completos = [];
    vm.incompletos = [];
    vm.limpiar = limpiar;
    vm.eliminar = eliminar;
    vm.buscar = {
      valor : 'inventario'
    };
    vm.radio = 'jerarquizada';
    vm.numeroComprobado = null;
    vm.bandera = false;
    vm.cambiarNumero = cambiarNumero;
    vm.buscarExcel = buscarExcel;

    ServicioDialogos.cerrarDialogoCargando();

    vm.verFoto = verFoto;

    function verFoto(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalMostrarFotoSuministro({
        onResult: function(resultado) {
          console.log(resultado);
        },
        tipoSuministro: vm.tipoSuministro
      });
    }


    function buscarExcel(){
      if (vm.file===undefined || vm.file===null) {
        ServicioDialogos.mostrarDialogoError(null, "No ha elegido un archivo .xlsx");
        return;
      } else {
        var reader = new FileReader();
        ServicioDialogos.abrirDialogoCargando();
        reader.onload = function (e) {
          var bstr = e.target.result;
          var workbook = XLSX.read(bstr, {type:'binary'});
          var first_sheet_name = workbook.SheetNames[0];
          var worksheet = workbook.Sheets[first_sheet_name];
          var suministros = XLSX.utils.sheet_to_json(worksheet);
          comprobarElementos(suministros);
        };
        reader.readAsBinaryString(vm.file);
      }
    }

    function comprobarElementos(suministros){
      vm.completos = [];
      vm.incompletos = [];
      vm.repetidos = [];
      vm.erroneos = [];
      vm.correctos = [];
      suministros.forEach(function(item){
        validarSuministro(item);
      });
      if (vm.completos.length>0){
        validarCompletos();
      } else {
        mostrarIncompletos();
      }
    }

    function mostrarIncompletos(){
      ServicioModales.abrirModalMostrarSuministrosIngresoExcel({
        onResult: function(resultado) {
          console.log(resultado);
        },
        formatoIncorrecto: true,
        nombreDocumento: vm.file.name,
        tipoSuministro: vm.tipoSuministro
      });
    }



    function validarCompletos(){
      validarSuministrosCompletos()
      .then(function(){
        mostrarInformacionValidacion();
      });
    }

    function mostrarInformacionValidacion(){
      ServicioModales.abrirModalMostrarSuministrosIngresoExcel({
        onResult: function(resultado) {
          console.log(resultado);
        },
        formatoIncorrecto: false,
        repetidos: vm.repetidos,
        erroneos: vm.erroneos,
        incompletos: vm.incompletos,
        completos: vm.completos,
        correctos: vm.correctos,
        tipoSuministro: vm.tipoSuministro,
        nombreDocumento: vm.file.name,
      });

    }

    function validarSuministrosCompletos(){
      var defer = $q.defer();
      var promise = defer.promise;
      vm.completos.forEach(function(item){
        promise = promise.then(function(){
          return comprobarRepetido(item).then(function(data){
            if (data.length>0){
              item.causa = "Ya existe este número de inventario";
              vm.repetidos.push(item);
            } else {
              if (!controlarBienInventariable(item)){
                vm.listaInventariables.push(item);
                vm.correctos.push(item);
              } else {
                vm.repetidos.push(item);
              }
            }
          });
        });
      });
      defer.resolve(true);
      return promise;
    }

    function comprobarRepetido(suministro){
      var defer = $q.defer();
      var promise = defer.promise;
      SuministroPorInventarioEmpresa.query({inventario: suministro.inventario, idEmpresa:vm.tipoSuministro.familiaSuministro.grupoSuministro.empresa.id}, function(data){
        defer.resolve(data);
        return promise;
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        return $q.reject();
      });
      return promise;

    }

    function estaCompleto(suministro){
      return (suministro.serie!==null && suministro.serie!==undefined) && (suministro.precio!==null && suministro.precio!==undefined) && (suministro.marca!==null && suministro.marca!==undefined) && (suministro.inventario!==null && suministro.inventario!==undefined);
    }

    function validarSuministro(suministro){
      if (estaCompleto(suministro)){
        if (!validarPrecioExcel(suministro.precio)){
          if (validarInventarioExcel(suministro.inventario)){
            var bien = {
              inventario : suministro.inventario,
              serie: suministro.serie,
              suministro:{
                marca: suministro.marca,
                precioUnitario: suministro.precio,
              },
              nuevo : suministro.nuevo==1? true:false
            };
            vm.completos.push(bien);
          } else {
            suministro.errorInv = true;
            vm.erroneos.push(suministro);
          }
        } else {
          if (!validarInventarioExcel(suministro.inventario)){
            suministro.errorInv = true;
          }
          suministro.errorPrecio = true;
          vm.erroneos.push(suministro);
        }
      } else {
        suministro.causa = "Faltan datos";
        vm.incompletos.push(suministro);
      }
    }

    function validarInventarioExcel(inventario){
      return Number.isInteger(+inventario) && inventario>=0;
    }

    function validarPrecioExcel(precio){
      return isNaN(precio) || (Number.isInteger(precio) && precio<=0) || (precio===null) || (typeof(precio)== "boolean");
    }

    $scope.cargarArchivo = function(file){
      vm.file = file;
    };


    function obtenerInformacion(data){
      console.log(data);
    }


    function cambiarNumero(){
      vm.bandera=false;
      vm.numeroComprobado=false;
    }

    function cambioRadio(){
      if (vm.radio=='jerarquizada'){
        vm.tipoSuministroCompleto=null;
      } else {
        if (vm.tipoSuministro && vm.tipoSuministro.id) vm.tipoSuministro=null;
        if (vm.familiaSuministro && vm.familiaSuministro.id) vm.familiaSuministro=null;
        if (vm.grupo && vm.grupo.id) vm.grupo=null;
      }
    }

    function comprobarNumeroCaja(){
      if (!estaNumeroCajas()){
        NumeroCajaCerradaUtilizado.query({'numero':vm.numeroCaja, 'idEmpresa':vm.empresaId}, function(data){
          if (data.length===0){
            vm.numeroComprobado = true;
            vm.bandera=true;
          } else {
            if (data[0].disponible && !estaNumeroCajas()){
              vm.numeroComprobado = true;
              vm.bandera=true;
            } else {
              vm.numeroComprobado = false;
              ServicioDialogos.mostrarDialogoError(null, "El número de cajas ingresado ya fue utilizado");
            }
          }
        });
      } else {
        ServicioDialogos.mostrarDialogoError(null, "El número de cajas ingresado ya fue utilizado");
      }
    }

    function filtrarBienes(valor) {
      if (!valor) return;
      var bienesFiltrados = [];
      for (var i=0; i< vm.bienes.length; i++) {
        if (vm.bienes[i].serie.toLowerCase().indexOf(valor.toLowerCase()) != -1 || vm.bienes[i].inventario.toString().toLowerCase().indexOf(valor.toLowerCase()) != -1 ) {
          bienesFiltrados.push(vm.bienes[i]);
        }
      }
      return bienesFiltrados;
    }

    function eliminar(index){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(
        null,
        "¿Está seguro que desea eliminar el bien de la lista?",
        function(){
          vm.listaInventariables.splice(index, 1);
          actualizarTabla(vm.listaInventariables);
        }
      );
    }

    function actualizarTabla(detalles){
      vm.tableParams.settings({
        data: detalles
      });
      vm.tableParams.reload();
    }

    function limpiar(){
      //vm.form.$setPristine();
      switch (vm.buscar.valor){
        case 'nuevo':
          vm.file = null;
          document.getElementById('fileInput').value=null;
          break;
        case 'inventario':
          vm.nuevoBien = null;
          break;
      }
    }

    function agregarBienFiltrado(){
      if (!controlarBienInventariable(vm.bien)){
        vm.bien.nuevo=vm.nuevo;
        vm.listaInventariables.push(vm.bien);
        vm.form.$setPristine();
      } else {
        ServicioDialogos.mostrarDialogoError(null,"El bien ya fue ingresado");
      }
    }

    function agregarNuevoBien(){
      var bien = angular.copy(vm.nuevoBien);
      if (controlarBienInventariable(bien)==false){
        insertarBienNuevo(bien);
      } else {
        ServicioDialogos.mostrarDialogoError(null,"El número de inventario ya fue ingresado");
      }
    }

    function insertarBienNuevo(bien){
      SuministroPorInventarioEmpresa.query({inventario: bien.inventario, idEmpresa:vm.tipoSuministro.familiaSuministro.grupoSuministro.empresa.id}, function(data){
        if (data.length>0) {
          ServicioDialogos.mostrarDialogoError(null,"El número de inventario ya existe");
        } else {
          var bienInventariable = {
            serie: bien.serie,
            inventario: bien.inventario,
            nuevo: bien.nuevo? true:false,
            suministro:{
              marca: bien.marca,
              precioUnitario: bien.precio
            }
          };
          vm.listaInventariables.push(bienInventariable);
          vm.nuevoBien=null;
          vm.form.$setPristine();
          focus('marca');
        }
      }, function(err){
        console.log(err);
      })
    }

    function controlarBienInventariable(bienNuevo){
      var ban = false;
      vm.listaInventariables.forEach(function(bien){
        if (bien.inventario==bienNuevo.inventario){
          ban = true;
        }
      });
      for (var i = 0; i < vm.detalles.length; i++) {
        if (vm.detalles[i].suministroInventariable){
          if (vm.detalles[i].suministroInventariable.inventario == bienNuevo.inventario){
            ban = true;
          }
        }
      }
      return ban;
    }

    function busquedaPorTipo(){
      ServicioDialogos.abrirDialogoCargando();
      SuministroPorTipoEstado.query({idTipo:vm.tipoSuministro.id, idEstado:1}, function(data){
        vm.bienes = orderByFilter(data, 'inventario', false);
        focus('bien');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    }

    function comprobarTotalSuministro(){
      return vm.totalSuministros()>=vm.cantidad;
    }

    function comprobarCantidadPorPallets(){
      var bandera = true;
      for (var i = 0; i < vm.campos.length; i++) {
        if (vm.campos[i].cantidad==null || vm.campos[i].cantidad<1){
          bandera = false;
        }
      }
      return bandera;
    }

    function totalSuministros(){
      var total = 0;
      for(var i = 0; i < vm.campos.length; i++){
        total += vm.campos[i].cantidad;
      }
      return total ? total : "-";
    }

    function cantidadPorPallets(){
      if (vm.tipoSuministro.inventariable){

      } else {
        crearCamposNoInventariable();
      }
    }

    function crearCamposNoInventariable(){
      var campos = [];
      for (var i = 0; i < vm.cantidadPallets; i++) {
        campos.push({
          cantidad:null,
          observacion:null
        });
      }
      vm.campos = campos;
    }

    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.dismiss();
    }

    function limpiarCamposNoInventariables(){
      vm.marca=null;
      vm.fechaVencimiento=null;
      vm.precioUnitario=null;
      vm.cantidadPallets=null;
    }

    function limpiarCamposInventariables(){
      vm.nuevoBien={};
      vm.listaInventariables = [];
      vm.nuevo = false;
    }


    $scope.$watch('vm.grupo.nombre', function(){
       if (vm.familiaSuministro) vm.familiaSuministro=null;
      if (!vm.grupo) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupo.id}, function(data){
        vm.familias = data;
        focus('familia');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.tipoSuministro.nombre', function(){
      vm.campos = [];
      limpiarCamposNoInventariables();
      limpiarCamposInventariables();
      if (!vm.tipoSuministro || vm.tipoSuministro.inventariable===false) return;
      busquedaPorTipo();
    });

    $scope.$watch('vm.tipoSuministroCompleto.nombre', function(){
      vm.tipoSuministro=vm.tipoSuministroCompleto;
      //if (!vm.tipoSuministroCompleto || vm.tipoSuministroCompleto.inventariable===false) return;
    });

    $scope.$watch('vm.radio', function(){
      if (vm.radio=='directa') {
        ServicioDialogos.abrirDialogoCargando();
        TiposPorEmpresa.query({idEmpresa:vm.empresaId}, function(data){
          vm.tiposCompletos = orderByFilter(data,'nombre',false);
          ServicioDialogos.cerrarDialogoCargando();
        }, function(err){
          console.log(err);
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError();
        });

      }
    });

    $scope.$watch('vm.familiaSuministro.nombre', function(){
      if (vm.tipoSuministro) vm.tipoSuministro=null;
      if (!vm.familiaSuministro) return;
      ServicioDialogos.abrirDialogoCargando();
      TipoSuministroFamilia.query({id:vm.familiaSuministro.id}, function(data){
        vm.tipos = data;
        focus('tipo');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    function comprobarExistencia(){
      var ban = false;
      vm.detalles.forEach(function(detalle){
        if (detalle.tipoSuministro.id==vm.tipoSuministro.id){
          ban = true;
        }
      });
//      console.log(ban);
      return ban;
    }

    function agregarNoInventariable(){
      var detalles = [];
      for (var i = 0; i < vm.campos.length; i++) {
        var suministro1 = {
          tipoSuministro: vm.tipoSuministro,
          marca : vm.marca,
          fechaVencimiento : vm.fechaVencimiento,
          precioUnitario: vm.precioUnitario,
          cantidad: vm.campos[i].cantidad,
          estadoSuministro: vm.estadoSuministro
        };
        vm.detalles.push({
          suministro : suministro1,
          cantidad: vm.campos[i].cantidad,
          fecha: new Date()
        });
      }
      $('.modal-backdrop').remove();
      $uibModalInstance.close({detalles:vm.detalles, numeroRow:vm.numeroRow});
    }

    function crearSuministroCompleto(inventariable){
      var suministro1 = {
        tipoSuministro: vm.tipoSuministro,
        marca : inventariable.suministro.marca,
        precioUnitario: inventariable.suministro.precioUnitario,
        cantidad: 1,
        estadoSuministro: vm.estadoSuministro
      };
      var suministroInventariable = {
        nuevo: inventariable.nuevo,
        serie: inventariable.serie,
        inventario: inventariable.inventario,
        suministro: suministro1
      };
      return suministroInventariable;
    }

    function agregarInventariable(){
      if (vm.caja){
        controlarNumeroCajas();
      } else {
        agregarInventariableControlado();
      }
    }

    function agregarInventariableControlado(){
      vm.numeroRow = vm.numeroRow + 1;
      var inventariable = {};
      var suministroInventariable = {};
      for (var i = 0; i < vm.listaInventariables.length; i++) {
        inventariable = vm.listaInventariables[i];
        if (!inventariable.id){
          suministroInventariable = crearSuministroCompleto(inventariable);
        } else {
          suministroInventariable = inventariable;
        }
        vm.detalles.push({
          numeroRow: vm.numeroRow,
          numeroCaja: vm.numeroCaja,
          suministro: suministroInventariable.suministro,
          suministroInventariable: suministroInventariable,
          cantidad: 1,
          fecha: new Date()
        });
      }
      $('.modal-backdrop').remove();
      $uibModalInstance.close({detalles:vm.detalles, numeroRow:vm.numeroRow, numeroCajas: vm.numeroCajas});
    }

    function controlarNumeroCajas(){
      if (estaNumeroCajas()){
        ServicioDialogos.mostrarDialogoError(null, "El número de cajas ingresado ya fue utilizado");
      } else {
        vm.numeroCajas.push(vm.numeroCaja);
        agregarInventariableControlado();
      }
    }

    function estaNumeroCajas(){
      var esta = false;
      vm.numeroCajas.forEach(function(numero){
        if (vm.numeroCaja==numero) {
          esta = true;
        }
      });
      return esta;
    }

    function agregar(){
      if (!vm.tipoSuministro.inventariable) {
        agregarNoInventariable();
      } else {
        agregarInventariable();
      }
    }
    
    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10,
      noPager: true
    });
   
  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoAgregarSuministroEgresoPedido',DialogoAgregarSuministroEgresoPedido);

  function DialogoAgregarSuministroEgresoPedido($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/agregar-suministros-egreso-pedido/agregar-suministros-egreso-pedido.html',
        controller: 'ModalAgregarSuministroEgresoPedidoCtrl as vm',
        resolve: {
          sucursal: function(){
            return config.sucursal;
          },
          pedido: function(){
            return config.pedido;
          },
          detalles: function(){
            return config.detalles;
          },
          deposito: function(){
            return config.deposito;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalAgregarSuministroEgresoPedidoCtrl', ModalAgregarSuministroEgresoPedidoCtrl);

  /** @ngInject */
  function ModalAgregarSuministroEgresoPedidoCtrl(NgTableParams, $q, $filter, pedido, deposito, sucursal, detalles, SuministroPor2TipoMovimientoEstadoSuministroTipoSuministroDepositoPorDetalle , $uibModalInstance, HeaderBarService, ServicioModales, focus, orderByFilter, $stateParams, $state, $timeout, $scope, ServicioDialogos) {

    var vm = this;
    vm.sucursal = sucursal;
    vm.detalles = detalles;
    vm.deposito = deposito;
    vm.pedido = pedido;

    vm.cerrar = cerrar;

    vm.visualizarPedido = visualizarPedido;
    vm.mostrarSuministrosAsignados = mostrarSuministrosAsignados;
    vm.asignarSuministros = asignarSuministros;
    vm.comprobarAgregar = comprobarAgregar;
    vm.asignarSuministrosAutomaticamente = asignarSuministrosAutomaticamente;
    vm.bandera=false;
    vm.detallesPedido=[];

    inicializar();

    ServicioDialogos.cerrarDialogoCargando();

    function contarAsignados(){
      var cont = 0;
      vm.detallesPedido.forEach(function(item){
        if (item.suministrosAsignados && item.suministrosAsignados.length>0){
          cont += 1;
        }
      });
      return cont;
    }

    function comprobarAsignados(libresAntes){
      var asignados = contarAsignados();
      var libresAhora = vm.detallesPedido.length-asignados;
      if (libresAhora==0){
        ServicioDialogos.mostrarDialogoInformacion(null, "Se asignaron todos los suministros");
      } else if (libresAhora>0 && libresAhora!=libresAntes){
        ServicioDialogos.mostrarDialogoAtencion(null, "Se asignó al menos un suministro");
      } else if (libresAhora>0 && libresAhora==libresAntes){
        ServicioDialogos.mostrarDialogoAtencion(null, "No se asignó ningún suministro");
      }

    }

    function asignarSuministrosAutomaticamente(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea asignar los suministros automáticamente?", function(){
        var asignadosAntes = contarAsignados();
        var libres = vm.detallesPedido.length-asignadosAntes;
        asignarAutomaticamente()
          .then(function(){
            actualizarTabla();
            comprobarAsignados(libres);
          });
      }, null, false);
    }

    function asignarAutomaticamente(){
      var defer = $q.defer();
      var promise = defer.promise;
      vm.detallesPedido.forEach(function(det) {
        if (det.cantidad!=0 && det.cantidadSolicitada==0){
          promise = promise.then(function(){
            return buscarSuministrosTipo(det.tipoSuministro).then(function(detalle){
              asignarCantidades(det, detalle);
              defer.resolve(true);
            });
          });
        }
      });
      defer.resolve(true);
      return promise;
    }

    function comprobarSuministros(cantidad, detalles){
      if (detalles.length==0) return false;
      var cant = 0;
      detalles.forEach(function(sum){
        cant += sum.suministro.cantidad;
      });
      return cant>=cantidad;
    }

    function asignarCantidades(detalle, detalles){
      if (comprobarSuministros(detalle.cantidad, detalles)){
        var fecha = new Date();
        var suministrosAsignados = [];
        var cantidadNecesaria = detalle.cantidad;
        var cantidadUsada = 0;
        detalles.forEach(function(det){
          if (det.suministro.cantidad==0) return;
          if (cantidadNecesaria!=cantidadUsada){
            if (cantidadNecesaria-cantidadUsada-det.suministro.cantidad>0){
              suministrosAsignados.push({
                suministro: det.suministro,
                cantidad: det.suministro.cantidad,
                fecha: fecha
              });
              cantidadUsada += det.suministro.cantidad;
            } else if (cantidadNecesaria-cantidadUsada-det.suministro.cantidad<=0){
              suministrosAsignados.push({
                suministro: det.suministro,
                cantidad: cantidadNecesaria-cantidadUsada,
                fecha: fecha
              });
              cantidadUsada += cantidadNecesaria-cantidadUsada;
            }
          }
        });
        asignarSuministroTipo(detalle, suministrosAsignados);
      }
    }

    function buscarSuministrosTipo(tipo){
      return SuministroPor2TipoMovimientoEstadoSuministroTipoSuministroDepositoPorDetalle.query({idTipoMovimiento1:2, idTipoMovimiento2:5, idTipoSuministro:tipo.id, idEstadoSuministro:2, idDeposito:deposito.id}).$promise.then(function(data){
        data = $filter('orderBy')(data, [ordenarPorYaEmpezado, ordenarPorNavePorDefecto,"suministro.fechaVencimiento", "fecha","suministro.ubicacion.nivel.numeroNivel", "suministro.cantidad"], false);
        return data;
      });
    }

    function ordenarPorYaEmpezado(d){
      if (d.cantidad){
        return d.cantidad==d.suministro.cantidad? 1 : 0;
      }
    }

    function ordenarPorNavePorDefecto(a){
      if (deposito.idNaveBusqueda){
        return a.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.id==deposito.idNaveBusqueda? 0 : 1;
      }
    }

    function asignarSuministros(tipo){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalAgregarQuitarSuministroPedido({
        onResult: function(resultado) {
          asignarSuministroTipo(tipo, resultado.suministrosAsignados);
        },
        deposito:vm.deposito,
        sucursal:vm.sucursal,
        tipo: tipo.tipoSuministro,
        suministrosAsignados: tipo.suministrosAsignados? tipo.suministrosAsignados : [],
        cantidadPedido: tipo.cantidad
      });
    }

    function asignarSuministroTipo(tipo, suministros){
      var sum = 0;
      suministros.forEach(function(item){
        sum += item.cantidad;
      });
      tipo.cantidadSolicitada=sum;
      tipo.suministrosAsignados=suministros;
    }

    function mostrarSuministrosAsignados(tipo){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalVisualizarSuministroAsignado({
        onResult: function(resultado) {
          console.log(resultado);
        },
        sucursal: vm.sucursal,
        detalles: tipo.suministrosAsignados,
        tipoSuministro: false,
        tipo : tipo.tipoSuministro,
      });
    }

    function visualizarPedido(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalPedido({
        onResult: function(resultado) {
          console.log(resultado);
        },
        pedido: pedido,
        deposito: pedido.deposito
      });
    }

    function recorrerTipos(){
      var ban = false;
      var cantidadSolicitada = 0;
      vm.detallesPedido.forEach(function(item){
        ban = false;
        cantidadSolicitada= 0;
        vm.detalles.forEach(function(detalle){
          if (detalle.suministro.tipoSuministro.id==item.tipoSuministro.id){
            ban = true;
            cantidadSolicitada += detalle.cantidad;
          }
        });
        item.ocupado = ban;
        item.cantidadSolicitada = cantidadSolicitada;
      });
    }

    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
    }

    function setearTitulos() {
      HeaderBarService.setTitulo($stateParams.titulo);
      HeaderBarService.setSubTitulo($stateParams.subtitulo);
    }

    function comprobarAgregar(){
      var sum = 0;
      vm.detallesPedido.forEach(function(item){
        if (item.cantidadSolicitada){
          sum += item.cantidadSolicitada;
        }
      });
      if (sum>0){
        armarDetalles();
      } else {
        ServicioDialogos.mostrarDialogoError(null, "No ha asignado suministros nuevos");
      }
    }

    function armarDetalles(){
      vm.detallesPedido.forEach(function(item){
        if (item.suministrosAsignados && item.suministrosAsignados.length>0){
          item.suministrosAsignados.forEach(function(detalle){
            vm.detalles.push(detalle);
          });
        }
      });
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.close({
        detalles: vm.detalles,
      });

    }

    function inicializar(){
      setearTitulos();
      crearTabla();
      vm.detallesPedido = angular.copy($filter('orderBy')(vm.pedido.detalles, ["tipoSuministro.familiaSuministro.grupoSuministro.nombre","tipoSuministro.familiaSuministro.nombre","tipoSuministro.nombre"], false));
      recorrerTipos();
      actualizarTabla();
    }
     
    function crearTabla(){
      vm.tableParams = new NgTableParams({
        page: 1,
        count: 10
      });
    }

    function actualizarTabla(){
      vm.tableParams.settings({
        data: $filter('orderBy')(vm.detallesPedido, ["tipoSuministro.familiaSuministro.grupoSuministro.nombre","tipoSuministro.familiaSuministro.nombre","tipoSuministro.nombre"], false) 
      });
      vm.tableParams.reload();
    }


  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoAgregarSuministroIngresoConciliacion',DialogoAgregarSuministroIngresoConciliacion);

  function DialogoAgregarSuministroIngresoConciliacion($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/agregar-suministro-ingreso-conciliacion/modal-agregar-suministro-ingreso-conciliacion.html',
        controller: 'ModalAgregarSuministroIngresoConciliacionCtrl as vm',
        resolve: {
          grupos: function(GrupoEmpresa){
            return GrupoEmpresa.query({id:config.empresa.id}).$promise.then(function(data) {
              return data;
            });
          },
          estadoSuministro: function(EstadoSuministro){
            return EstadoSuministro.get({id:2}).$promise.then(function(data) {
              return data;
            });
          },
          detalles: function(){
            return config.detalles;
          },
          deposito: function(){
            return config.deposito;
          },
          empresa: function(){
            return config.empresa.id;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalAgregarSuministroIngresoConciliacionCtrl', ModalAgregarSuministroIngresoConciliacionCtrl);

  /** @ngInject */
  function ModalAgregarSuministroIngresoConciliacionCtrl(NgTableParams, estadoSuministro, focus, empresa, detalles, deposito, TiposPorEmpresa, SuministroInventariableTipoEstadoDepositoCaja, SuministroInventariableContarStockTipoEstado, SuministroTipoEstadoDeposito, SuministroContarStockTipoEstado, SuministroPorInventarioEmpresa, SuministroPorTipoInventario, SuministroTipoEstadoDepositoPorDetalle, SuministroPorTipo, SuministroPorTipoEstado, ServicioModales, $uibModalInstance, HeaderBarService, TipoSuministroFamilia, FamiliaSuministroGrupo, TipoSuministro, grupos, $timeout, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.grupos = orderByFilter(grupos,'nombre',false);
    vm.empresaId = empresa;
    vm.detalles = detalles;
    vm.deposito = deposito;

    vm.agregar = agregar;
    vm.cerrar = cerrar;
    vm.cambioRadio = cambioRadio;
    vm.asignarIndividual = asignarIndividual;
    vm.ubicacionCompleta = ubicacionCompleta;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;

    vm.ocuparUbicacion = false;

    vm.verFoto = verFoto;

    vm.radio = 'jerarquizada';

    ServicioDialogos.cerrarDialogoCargando();

    function verFoto(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalMostrarFotoSuministro({
        onResult: function(resultado) {
          console.log(resultado);
        },
        tipoSuministro: vm.tipoSuministro
      });
    }


    function ubicacionNaveNumeroOrden(){
      if (vm.suministro.ubicacion && vm.suministro.ubicacion.nivel) {
        return "Nave: "+vm.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+vm.suministro.ubicacion.numeroOrden;
      } else {
        return "Aún no ha asignado una ubicación";
      }
    }

    function ubicacionCompleta(){
      if (vm.suministro.ubicacion && vm.suministro.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación completa",
        "Nave: "+vm.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+vm.suministro.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+vm.suministro.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+vm.suministro.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+vm.suministro.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+vm.suministro.ubicacion.numeroUbicacion+
        "\nN° de orden: "+vm.suministro.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+vm.suministro.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+vm.suministro.ubicacion.categoriaPeso.nombre.toUpperCase());
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "El suministro no posee ubicación asignada");
      }
    }

    function asignarIndividual(){
      vm.suministro.tipoSuministro = vm.tipoSuministro;
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalAsignarUbicacionIndividualCajas({
        onResult: function(resultado){
          vm.suministro.ubicacion = resultado.ubicacionAsignada;
        },
        deposito: vm.deposito,
        'detalle': {suministro:vm.suministro}
      });
    }

    function cambioRadio(){
      if (vm.radio=='jerarquizada'){
        vm.tipoSuministroCompleto=null;
      } else {
        if (vm.tipoSuministro && vm.tipoSuministro.id) vm.tipoSuministro=null;
        if (vm.familiaSuministro && vm.familiaSuministro.id) vm.familiaSuministro=null;
        if (vm.grupo && vm.grupo.id) vm.grupo=null;
      }
    }


    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.dismiss();
    }

    $scope.$watch('vm.grupo.nombre', function(){
      if (vm.familiaSuministro) vm.familiaSuministro=null;
      if (!vm.grupo) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupo.id}, function(data){
        vm.familias = data;
        focus('familia');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });


    $scope.$watch('vm.tipoSuministroCompleto.nombre', function(){
      vm.tipoSuministro=vm.tipoSuministroCompleto;
      //if (!vm.tipoSuministroCompleto || vm.tipoSuministroCompleto.inventariable===false) return;
    });

    $scope.$watch('vm.radio', function(){
      if (vm.radio=='directa') {
        ServicioDialogos.abrirDialogoCargando();
        TiposPorEmpresa.query({idEmpresa:vm.empresaId}, function(data){
          vm.tiposCompletos = orderByFilter(data,'nombre',false);
          ServicioDialogos.cerrarDialogoCargando();
        }, function(err){
          console.log(err);
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError();
        });

      }
    });

    $scope.$watch('vm.familiaSuministro.nombre', function(){

      if (vm.tipoSuministro) vm.tipoSuministro=null;
      if (!vm.familiaSuministro) return;
      ServicioDialogos.abrirDialogoCargando();
      TipoSuministroFamilia.query({id:vm.familiaSuministro.id}, function(data){
        vm.tipos = data;
        focus('tipo');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });


    function agregar(){
      vm.suministro.estadoSuministro=estadoSuministro;
      vm.suministro.cantidad=vm.cantidadSolicitada;
      vm.detalles.push({
        suministro : vm.suministro,
        cantidad: vm.cantidadSolicitada,
        fecha: new Date()
      });
      $('.modal-backdrop').remove();
      $uibModalInstance.close({detalles:vm.detalles, ocuparUbicacion: vm.ocuparUbicacion, ubicacionAsignada:vm.suministro.ubicacion});
    }
       
  }
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
  .service('DialogoAgregarSuministro',DialogoAgregarSuministro);

  function DialogoAgregarSuministro($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/agregar-suministros/modal-agregar-suministro.html',
        controller: 'ModalAgregarSuministroCtrl as mod',
        resolve: {
          grupos: function(GrupoSuministro){
            return GrupoSuministro.query().$promise.then(function(data) {
              return data;
            });
          },
          detalles: function(){
           return config.detalles;
          },
          detalle: function(){
            return config.detalle? config.detalle : null;
          },
          modo: function(){
            return config.modo? config.modo : null;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalAgregarSuministroCtrl', ModalAgregarSuministroCtrl);

  /** @ngInject */
  function ModalAgregarSuministroCtrl(NgTableParams, ServicioModales, detalles, modo, detalle, $uibModalInstance, HeaderBarService, TipoSuministroFamilia, FamiliaSuministroGrupo, TipoSuministro, grupos, $timeout, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var mod = this;
    mod.grupos = orderByFilter(grupos,'nombre',false);
    mod.detalles = detalles;
    mod.agregar = agregar;
    mod.editar = editar;
    mod.detalle = detalle;
    mod.modo = modo;
    mod.cerrar = cerrar;
    inicializar();
    mod.ban2 = true;
    mod.ban = true;


    function inicializar(){
      if (esEditar()){
        mod.grupo = mod.detalle.suministro.familiaSuministro.grupoSuministro;
        mod.familiaSuministro = mod.detalle.suministro.familiaSuministro;
        mod.suministro = mod.detalle.suministro;
        mod.cantidad = mod.detalle.cantidad;
      }
    }

    function cerrar(){
      $uibModalInstance.dismiss();
    }

    $scope.$watch('mod.grupo.nombre', function(){
      if (esEditar() && mod.ban){
        mod.ban=false;
        return;
      } else {
        mod.familiaSuministro=null;
      }
      if (!mod.grupo) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:mod.grupo.id}, function(data){
        mod.familias = data;
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('mod.familiaSuministro.nombre', function(){
      if (esEditar() && mod.ban2){
        mod.ban2=false;
        return;
      } else {
        mod.suministro=null;
      }
      if (!mod.familiaSuministro) return;
      ServicioDialogos.abrirDialogoCargando();
      TipoSuministroFamilia.query({id:mod.familiaSuministro.id}, function(data){
        mod.suministros = data;
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    function esEditar(){
      return mod.modo == "editar";
    }

    function editar(detalle){
      mod.grupo = detalle.suministro.familiaSuministro.grupoSuministro;
      mod.familiaSuministro = detalle.suministro.familiaSuministro;
      mod.suministro = detalle.suministro;
      mod.cantidad = detalle.cantidad;
      mod.modo = "editar";
    }

    function comprobarExistencia(){
      var ban = false;
      mod.detalles.forEach(function(detalle){
        if (detalle.suministro.id==mod.suministro.id){
          ban = true;
        }
      });
      return ban;
    }

    function agregarDetalle(){
      if (!comprobarExistencia()){
        var detalle = {
          suministro : mod.suministro,
          cantidad : mod.cantidad
        };
        mod.detalles.push(detalle);
        $uibModalInstance.close(mod.detalles, "HOLA");
      } else {
        ServicioDialogos.mostrarDialogoError(null, "Ya agregó este suministro al pedido");
      }    
    }

    function editarDetalle(){

    }


    function agregar(){
      if (esEditar()){
        editarDetalle();
      } else {
        agregarDetalle();    
      }
    }
    
    mod.tableParams = new NgTableParams({
      page: 1,
      count: 10
    });
   
  }
})();

'use strict';
angular.module('proyecto-az-suministro')
  .factory('SuministroPorTipo', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministroinventariable?tipo.id=:id",{id:'@id'});
  })
  .factory('SuministroPorTipoEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministroinventariable?tipo.id=:idTipo&&estado.id=:idEstado",{id:'@id'});
  })
  .factory('SuministroPorTipoInventario', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministroinventariable?tipo.id=:idTipo&&inventario=:inventario",{id:'@id'});
  })
  .factory('SuministroPorInventarioEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministroinventariable?inventario=:inventario&&empresa.id=:idEmpresa",{id:'@id'});
  })
  .factory('TiposPorEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/tiposuministro?empresa.id=:idEmpresa",{idEmpresa:'@idEmpresa'});
  })
  .factory('EstadoSuministro', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/estadosuministro/:id",{id:'@id'});
  })
  .factory('NumeroCajaCerradaUtilizado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/numerocajacerradautilizado?empresa.id=:idEmpresa&&numero=:numero",{idEmpresa:'@idEmpresa', numero:'@numero'});
  })
  .factory('UltimoPrecioSuministro', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/detallemovimiento/ultimo/:id",{id:'@id'});
  });
(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoAgregarSuministroIngreso',DialogoAgregarSuministroIngreso);

  function DialogoAgregarSuministroIngreso($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/agregar-suministro-ingreso/modal-agregar-suministro-ingreso.html',
        controller: 'ModalAgregarSuministroIngresoCtrl as vm',
        resolve: {
          grupos: function(GrupoEmpresa){
            return GrupoEmpresa.query({id:config.empresa.id}).$promise.then(function(data) {
              return data;
            });
          },
          estadoSuministro: function(EstadoSuministro){
            return EstadoSuministro.get({id:2}).$promise.then(function(data) {
              return data;
            });
          },
          numeroRow: function(){
            return config.numeroRow;
          },
          caja: function(){
            return config.caja;
          },
          detalles: function(){
           return config.detalles;
          },
          numeroCajas: function(){
            return config.numeroCajas;
          },
          empresa: function(){
            return config.empresa.id;
          },
          sucursales: function(SucursalEmpresa){
            return SucursalEmpresa.query({id:config.empresa.id}).$promise.then(function(data){
              return data;
            });
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalAgregarSuministroIngresoCtrl', ModalAgregarSuministroIngresoCtrl);

  /** @ngInject */
  function ModalAgregarSuministroIngresoCtrl(NgTableParams, focus, caja, sucursales, empresa, numeroCajas, UltimoPrecioSuministro, NumeroCajaCerradaUtilizado, TiposPorEmpresa, SuministroPorInventarioEmpresa, SuministroPorTipoInventario, SuministroPorTipo, SuministroPorTipoEstado, numeroRow, estadoSuministro, ServicioModales, detalles, $uibModalInstance, HeaderBarService, TipoSuministroFamilia, FamiliaSuministroGrupo, TipoSuministro, grupos, $timeout, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.empresaId = empresa;
    vm.grupos = orderByFilter(grupos,'nombre',false);
    vm.sucursales = orderByFilter(sucursales, "nombre", false);
    vm.detalles = detalles;
    vm.caja = caja;
    vm.numeroCajas = numeroCajas;
    vm.estadoSuministro = estadoSuministro;
    vm.numeroRow = numeroRow;
    vm.filtrarBienes = filtrarBienes;
    vm.cambioRadio = cambioRadio;

    vm.agregar = agregar;
    vm.comprobarNumeroCaja = comprobarNumeroCaja;
    vm.cerrar = cerrar;
    vm.campos = [];
    vm.cantidadPorPallets = cantidadPorPallets;
    vm.totalSuministros = totalSuministros;
    vm.comprobarCantidadPorPallets = comprobarCantidadPorPallets;
    vm.comprobarTotalSuministro = vm.comprobarTotalSuministro;
    vm.agregarBienFiltrado = agregarBienFiltrado;
    vm.agregarNuevoBien = agregarNuevoBien;
    vm.listaInventariables = [];
    vm.limpiar = limpiar;
    vm.eliminar = eliminar;
    vm.buscar = {
      valor : 'inventario'
    };
    vm.radio = 'jerarquizada';
    vm.numeroComprobado = null;
    vm.bandera = false;
    vm.cambiarNumero = cambiarNumero;
    vm.obtenerUltimoPrecio = obtenerUltimoPrecio;

    vm.verFoto = verFoto;

    ServicioDialogos.cerrarDialogoCargando();

    function cambiarNumero(){
      vm.bandera=false;
      vm.numeroComprobado=false;
    }

    function verFoto(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalMostrarFotoSuministro({
        onResult: function(resultado) {
          console.log(resultado);
        },
        tipoSuministro: vm.tipoSuministro
      });
    }

    function cambioRadio(){
      if (vm.radio=='jerarquizada'){
        vm.tipoSuministroCompleto=null;
      } else {
        if (vm.tipoSuministro && vm.tipoSuministro.id) vm.tipoSuministro=null;
        if (vm.familiaSuministro && vm.familiaSuministro.id) vm.familiaSuministro=null;
        if (vm.grupo && vm.grupo.id) vm.grupo=null;
      }
    }

    function comprobarNumeroCaja(){
      if (!estaNumeroCajas()){
        ServicioDialogos.abrirDialogoCargando();
        NumeroCajaCerradaUtilizado.query({'numero':vm.numeroCaja, 'idEmpresa':vm.empresaId}, function(data){
          if (data.length===0){
            vm.numeroComprobado = true;
            vm.bandera=true;
          } else {
            if (data[0].disponible && !estaNumeroCajas()){
              vm.numeroComprobado = true;
              vm.bandera=true;
            } else {
              vm.numeroComprobado = false;
              ServicioDialogos.mostrarDialogoError(null, "El número de cajas ingresado ya fue utilizado");
            }
          }
          ServicioDialogos.cerrarDialogoCargando();
        }, function(err){
          console.log(err);
          ServicioDialogos.mostrarDialogoError();
          ServicioDialogos.cerrarDialogoCargando();
        });
      } else {
        ServicioDialogos.mostrarDialogoError(null, "El número de cajas ingresado ya fue utilizado");
      }
    }

    function filtrarBienes(valor) {
      if (!valor) return;
      var bienesFiltrados = [];
      for (var i=0; i< vm.bienes.length; i++) {
        if (vm.bienes[i].serie.toLowerCase().indexOf(valor.toLowerCase()) != -1 || vm.bienes[i].inventario.toString().toLowerCase().indexOf(valor.toLowerCase()) != -1 ) {
          bienesFiltrados.push(vm.bienes[i]);
        }
      }
      return bienesFiltrados;
    }

    function eliminar(index){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(
        null,
        "¿Está seguro que desea eliminar el bien de la lista?",
        function(){
          vm.listaInventariables.splice(index, 1);
          actualizarTabla(vm.listaInventariables);
        }
      );
    }

    function actualizarTabla(detalles){
      vm.tableParams.settings({
        data: detalles
      });
      vm.tableParams.reload();
    }

    function limpiar(){
      //vm.form.$setPristine();
      switch (vm.buscar.valor){
        case 'nuevo':
          vm.bien = null;
          break;
        case 'inventario':
          vm.nuevoBien = null;

          break;
      }
    }

    function agregarBienFiltrado(){
      if (!controlarBienInventariable(vm.bien)){
        vm.bien.nuevo=vm.nuevo;
        vm.bien.sucursal = vm.sucursalBien;
        vm.listaInventariables.push(angular.copy(vm.bien));
        vm.bien = null;
        vm.sucursalBien = null;
        focus("bien");
        vm.form.$setPristine();
      } else {
        ServicioDialogos.mostrarDialogoError(null,"El bien ya fue ingresado");
      }
    }

    function agregarNuevoBien(){
      var bien = angular.copy(vm.nuevoBien);
      if (controlarBienInventariable(bien)==false){
        insertarBienNuevo(bien);
      } else {
        ServicioDialogos.mostrarDialogoError(null,"El número de inventario ya fue ingresado");
      }
    }

    function insertarBienNuevo(bien){
      SuministroPorInventarioEmpresa.query({inventario: bien.inventario, idEmpresa:vm.tipoSuministro.familiaSuministro.grupoSuministro.empresa.id}, function(data){
        if (data.length>0) {
          ServicioDialogos.mostrarDialogoError(null,"El número de inventario ya existe");
        } else {
          var bienInventariable = {
            serie: bien.serie,
            inventario: bien.inventario,
            nuevo: bien.nuevo? true:false,
            sucursal: vm.sucursalNuevo,
            suministro:{
              marca: bien.marca,
              precioUnitario: bien.precio
            }
          };
          vm.listaInventariables.push(bienInventariable);
          vm.nuevoBien=null;
          vm.sucursalNuevo = null;
          vm.form.$setPristine();
          focus('marca');
        }
      }, function(err){
        console.log(err);
      });
    }

    function controlarBienInventariable(bienNuevo){
      var ban = false;
      vm.listaInventariables.forEach(function(bien){
        if (bien.inventario==bienNuevo.inventario){
          ban = true;
        }
      });
      for (var i = 0; i < vm.detalles.length; i++) {
        if (vm.detalles[i].suministroInventariable){
          if (vm.detalles[i].suministroInventariable.inventario == bienNuevo.inventario){
            ban = true;
          }
        }
      }
      return ban;
    }

    function busquedaPorTipo(){
      ServicioDialogos.abrirDialogoCargando();
      SuministroPorTipoEstado.query({idTipo:vm.tipoSuministro.id, idEstado:1}, function(data){
        vm.bienes = orderByFilter(data, 'inventario', false);
        focus('bien');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    }

    function comprobarTotalSuministro(){
      return vm.totalSuministros()>=vm.cantidad;
    }

    function comprobarCantidadPorPallets(){
      var bandera = true;
      for (var i = 0; i < vm.campos.length; i++) {
        if (vm.campos[i].cantidad==null || vm.campos[i].cantidad<1){
          bandera = false;
        }
      }
      return bandera;
    }

    function totalSuministros(){
      var total = 0;
      for(var i = 0; i < vm.campos.length; i++){
        total += vm.campos[i].cantidad;
      }
      return total ? total : "-";
    }

    function cantidadPorPallets(){
      if (vm.tipoSuministro.inventariable){

      } else {
        crearCamposNoInventariable();
      }
    }

    function crearCamposNoInventariable(){
      var campos = [];
      for (var i = 0; i < vm.cantidadPallets; i++) {
        campos.push({
          cantidad:null,
          observacion:null
        });
      }
      vm.campos = campos;
    }

    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.dismiss();
    }

    function obtenerUltimoPrecio(){
      if (!vm.tipoSuministro) return;
      ServicioDialogos.abrirDialogoCargando();
      UltimoPrecioSuministro.get({id:vm.tipoSuministro.id}).$promise.then(function(data){
        if (data && data.suministro && data.suministro.precioUnitario){
          if (vm.tipoSuministro.inventariable){
            vm.nuevoBien.precio=data.suministro.precioUnitario;
          } else {
            vm.precioUnitario = data.suministro.precioUnitario;
          }
        }
        ServicioDialogos.cerrarDialogoCargando();
      }, function(error){
        console.log(error);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError(null, "No se pudo obtener el último precio registrado para este tipo de suministro");
      });

    }

    function limpiarCamposNoInventariables(){
      vm.marca=null;
      vm.fechaVencimiento=null;
      vm.precioUnitario=null;
      vm.cantidadPallets=null;
    }

    function limpiarCamposInventariables(){
      vm.nuevoBien={};
      vm.listaInventariables = [];
      vm.nuevo = false;
    }

    $scope.$watch('vm.bien', function(){
      if (!vm.bien) {
        vm.sucursalBien = null;
        return;
      }
      if (vm.bien.sucursal) vm.sucursalBien = vm.bien.sucursal;
    });

    $scope.$watch('vm.grupo.nombre', function(){
       if (vm.familiaSuministro) vm.familiaSuministro=null;
      if (!vm.grupo) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupo.id}, function(data){
        vm.familias = data;
        focus('familia');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.tipoSuministro.nombre', function(){
        vm.campos = [];
        limpiarCamposNoInventariables();
        limpiarCamposInventariables();
        if (!vm.tipoSuministro || vm.tipoSuministro.inventariable===false) return;
        busquedaPorTipo();
    });

    $scope.$watch('vm.tipoSuministroCompleto.nombre', function(){
      vm.tipoSuministro=vm.tipoSuministroCompleto;
      //if (!vm.tipoSuministroCompleto || vm.tipoSuministroCompleto.inventariable===false) return;
    });

    $scope.$watch('vm.radio', function(){
      if (vm.radio=='directa') {
        ServicioDialogos.abrirDialogoCargando();
        TiposPorEmpresa.query({idEmpresa:vm.empresaId}, function(data){
          vm.tiposCompletos = orderByFilter(data,'nombre',false);
          ServicioDialogos.cerrarDialogoCargando();
        }, function(err){
          console.log(err);
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError();
        });

      }
    });

    $scope.$watch('vm.familiaSuministro.nombre', function(){
      if (vm.tipoSuministro) vm.tipoSuministro=null;
      if (!vm.familiaSuministro) return;
      ServicioDialogos.abrirDialogoCargando();
      TipoSuministroFamilia.query({id:vm.familiaSuministro.id}, function(data){
        vm.tipos = data;
        focus('tipo');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    function comprobarExistencia(){
      var ban = false;
      vm.detalles.forEach(function(detalle){
        if (detalle.tipoSuministro.id==vm.tipoSuministro.id){
          ban = true;
        }
      });
//      console.log(ban);
      return ban;
    }

    function agregarNoInventariable(){
      var detalles = [];
      for (var i = 0; i < vm.campos.length; i++) {
        var suministro1 = {
          tipoSuministro: vm.tipoSuministro,
          marca : vm.marca,
          fechaVencimiento : vm.fechaVencimiento,
          precioUnitario: vm.precioUnitario,
          cantidad: vm.campos[i].cantidad,
          estadoSuministro: vm.estadoSuministro
        };
        vm.detalles.push({
          suministro : suministro1,
          cantidad: vm.campos[i].cantidad,
          fecha: new Date()
        });
      }
      $('.modal-backdrop').remove();
      $uibModalInstance.close({detalles:vm.detalles, numeroRow:vm.numeroRow});
    }

    function crearSuministroCompleto(inventariable){
      var suministro1 = {
        tipoSuministro: vm.tipoSuministro,
        marca : inventariable.suministro.marca,
        precioUnitario: inventariable.suministro.precioUnitario,
        cantidad: 1,
        estadoSuministro: vm.estadoSuministro
      };
      var suministroInventariable = {
        nuevo: inventariable.nuevo,
        serie: inventariable.serie,
        inventario: inventariable.inventario,
        sucursal: inventariable.sucursal,
        suministro: suministro1
      };
      return suministroInventariable;
    }

    function agregarInventariable(){
      if (vm.caja){
        controlarNumeroCajas();
      } else {
        agregarInventariableControlado();
      }
    }

    function agregarInventariableControlado(){
      vm.numeroRow = vm.numeroRow + 1;
      var inventariable = {};
      var suministroInventariable = {};
      for (var i = 0; i < vm.listaInventariables.length; i++) {
        inventariable = vm.listaInventariables[i];
        if (!inventariable.id){
          suministroInventariable = crearSuministroCompleto(inventariable);
        } else {
          suministroInventariable = inventariable;
        }
        vm.detalles.push({
          numeroRow: vm.numeroRow,
          numeroCaja: vm.numeroCaja,
          suministro: suministroInventariable.suministro,
          suministroInventariable: suministroInventariable,
          cantidad: 1,
          fecha: new Date()
        });
      }
      $('.modal-backdrop').remove();
      $uibModalInstance.close({detalles:vm.detalles, numeroRow:vm.numeroRow, numeroCajas: vm.numeroCajas});
    }

    function controlarNumeroCajas(){
      if (estaNumeroCajas()){
        ServicioDialogos.mostrarDialogoError(null, "El número de cajas ingresado ya fue utilizado");
      } else {
        vm.numeroCajas.push(vm.numeroCaja);
        agregarInventariableControlado();
      }
    }

    function estaNumeroCajas(){
      var esta = false;
      vm.numeroCajas.forEach(function(numero){
        if (vm.numeroCaja==numero) {
          esta = true;
        }
      });
      return esta;
    }

    function agregar(){
      if (!vm.tipoSuministro.inventariable) {
        agregarNoInventariable();
      } else {
        agregarInventariable();
      }
    }
    
    vm.tableParams = new NgTableParams({
      page: 1,
      count: 10,
      noPager: true
    });
   
  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoAgregarSuministroEgresoConciliacion',DialogoAgregarSuministroEgresoConciliacion);

  function DialogoAgregarSuministroEgresoConciliacion($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/agregar-suministro-egreso-conciliacion/modal-agregar-suministro-egreso-conciliacion.html',
        controller: 'ModalAgregarSuministroEgresoConciliacionCtrl as vm',
        resolve: {
          grupos: function(GrupoEmpresa){
            return GrupoEmpresa.query({id:config.empresa.id}).$promise.then(function(data) {
              return data;
            });
          },
          detalles: function(){
            return config.detalles;
          },
          deposito: function(){
            return config.deposito;
          },
          empresa: function(){
            return config.empresa.id;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

'use strict';
angular.module('proyecto-az-suministro')
  .factory('SuministroPorTipo', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministroinventariable?tipo.id=:id",{id:'@id'});
  })
  .factory('SuministroTipoEstadoDeposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministro?tipo.id=:idTipo&&estado.id=:idEstado&&deposito.id=:idDeposito",{idTipo:'@idTipo', idEstado:'@idEstado',idDeposito:'@idDeposito'});
  })
  .factory('SuministroTipoEstadoDepositoPorDetalle', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/detallemovimiento?tipoMovimiento.id=:idTipoMovimiento&&tipoSuministro.id=:idTipo&&estadoSuministro.id=:idEstado&&deposito.id=:idDeposito",{idTipoMovimiento:'@idTipoMovimiento', idTipoSuministro:'@idTipoSuministro', idEstado:'@idEstado',idDeposito:'@idDeposito'});
  })
  .factory('SuministroContarStockTipoEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministro?tipo.id=:idTipo&&estado.id=:idEstado&&contar=false",{idTipo:'@idTipo', idEstado:'@idEstado'});
  })
  .factory('SuministroInventariableTipoEstadoDepositoCaja', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministroinventariable?tipo.id=:idTipo&&estado.id=:idEstado&&deposito.id=:idDeposito&&caja:=caja",{idTipo:'@idTipo', idEstado:'@idEstado',idDeposito:'@idDeposito', caja:'@caja'});
  })
  .factory('SuministroInventariableContarStockTipoEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministroinventariable?tipo.id=:idTipo&&estado.id=:idEstado&&contar=false",{idTipo:'@idTipo', idEstado:'@idEstado'});
  });
(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalAgregarSuministroEgresoConciliacionCtrl', ModalAgregarSuministroEgresoConciliacionCtrl);

  /** @ngInject */
  function ModalAgregarSuministroEgresoConciliacionCtrl(NgTableParams, focus, empresa, detalles, deposito, SuministroPor2TipoMovimientoEstadoSuministroTipoSuministroDepositoPorDetalle, TiposPorEmpresa, SuministroInventariableTipoEstadoDepositoCaja, SuministroInventariableContarStockTipoEstado, SuministroTipoEstadoDeposito, SuministroContarStockTipoEstado, SuministroPorInventarioEmpresa, SuministroPorTipoInventario, SuministroTipoEstadoDepositoPorDetalle, SuministroPorTipo, SuministroPorTipoEstado, ServicioModales, $uibModalInstance, HeaderBarService, TipoSuministroFamilia, FamiliaSuministroGrupo, TipoSuministro, grupos, $timeout, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.grupos = orderByFilter(grupos,'nombre',false);
    vm.empresaId = empresa;
    vm.filtrarBienes = filtrarBienes;
    vm.detalles = detalles;
    vm.idDeposito = deposito;

    vm.cantidadStockTipo = cantidadStockTipo;
    vm.cantidadStockBienes = cantidadStockBienes;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.ubicacionCompleta = ubicacionCompleta;
    vm.agregar = agregar;
    vm.cerrar = cerrar;
    vm.totalSuministros = totalSuministros;
    vm.comprobarCantidadSolicitada = comprobarCantidadSolicitada;
    vm.comprobarTotalSuministro = vm.comprobarTotalSuministro;
    vm.cambioRadio = cambioRadio;

    vm.agregarBienFiltrado = agregarBienFiltrado;
    vm.listaInventariables = [];

    vm.eliminar = eliminar;
    vm.radio = 'jerarquizada';

    vm.verFoto = verFoto;

    function verFoto(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalMostrarFotoSuministro({
        onResult: function(resultado) {
          console.log(resultado);
        },
        tipoSuministro: vm.tipoSuministro
      });
    }


    function cambioRadio(){
      if (vm.radio=='jerarquizada'){
        vm.tipoSuministroCompleto=null;
      } else {
        if (vm.tipoSuministro && vm.tipoSuministro.id) vm.tipoSuministro=null;
        if (vm.familiaSuministro && vm.familiaSuministro.id) vm.familiaSuministro=null;
        if (vm.grupo && vm.grupo.id) vm.grupo=null;
      }
    }

    ServicioDialogos.cerrarDialogoCargando();

    function ubicacionNaveNumeroOrden(suministro){
      if (suministro.ubicacion && suministro.ubicacion.nivel) {
        return "Nave: "+suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+suministro.ubicacion.numeroOrden;
      } else {
        return "El suministro no posee una ubicación actual";
      }
    }

    function ubicacionCompleta(suministro){
      if (suministro.ubicacion && suministro.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación completa",
        "Nave: "+suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+suministro.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+suministro.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+suministro.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+suministro.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+suministro.ubicacion.numeroUbicacion+
        "\nN° de orden: "+suministro.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+suministro.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+suministro.ubicacion.categoriaPeso.nombre.toUpperCase());
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "El suministro no posee ubicación asignada");
      }
    }

    function filtrarBienes(valor) {
      if (!valor) return;
      var bienesFiltrados = [];
      for (var i=0; i< vm.bienes.length; i++) {
        if (vm.bienes[i].serie.toLowerCase().indexOf(valor.toLowerCase()) != -1 || vm.bienes[i].inventario.toString().toLowerCase().indexOf(valor.toLowerCase()) != -1 ) {
          bienesFiltrados.push(vm.bienes[i]);
        }
      }
      return bienesFiltrados;
    }

    function eliminar(index){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(
        null,
        "¿Está seguro que desea eliminar el bien de la lista?",
        function(){
          vm.listaInventariables.splice(index, 1);
          actualizarTablaInventariables(vm.listaInventariables);
        }
      );
    }

    function actualizarTablaInventariables(detalles){
      vm.tableParamsInventariable.settings({
        data: detalles
      });
      vm.tableParamsInventariable.reload();
    }

    function actualizarTabla(detalles){
      vm.tableParams.settings({
        data: detalles
      });
      vm.tableParams.reload();
    }

    function agregarBienFiltrado(){
      if (!controlarBienInventariable(vm.bien)){
        vm.listaInventariables.push(angular.copy(vm.bien));
        vm.bien=null;
        focus('bien');
        vm.form.$setPristine();
      } else {
        ServicioDialogos.mostrarDialogoError(null,"El bien ya fue ingresado");
      }
    }

    function controlarBienInventariable(bienNuevo){
      var ban = false;
      vm.listaInventariables.forEach(function(bien){
        if (bien.inventario==bienNuevo.inventario){
          ban = true;
        }
      });
      for (var i = 0; i < vm.detalles.length; i++) {
        if (vm.detalles[i].suministroInventariable){
          if (vm.detalles[i].suministroInventariable.inventario == bienNuevo.inventario){
            ban = true;
          }
        }
      }
      return ban;
    }

    function comprobarTotalSuministro(){
      //console.log(vm.totalSuministros());
      return vm.totalSuministros()>=vm.cantidad;
    }

    function comprobarCantidadSolicitada(){
      if (!vm.listaNoInventariables) return;
      var cantidades = 0;
      var bandera = true;
      vm.listaNoInventariables.forEach(function(sum){
        if (sum.cantidadSolicitada>sum.cantidad) bandera=false;
        var cant = sum.cantidadSolicitada? sum.cantidadSolicitada : 0;
        cantidades = cantidades + cant;
      });
      return cantidades>0 && bandera;
    }

    function totalSuministros(){
      if (!vm.listaNoInventariables) return;
      var cantidades = 0;
      vm.listaNoInventariables.forEach(function(sum){
        var cant = sum.cantidadSolicitada? sum.cantidadSolicitada : 0;
        cantidades = cantidades + cant;
      });
      return cantidades? cantidades : "-";
    }

    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.dismiss();
    }

    $scope.$watch('vm.grupo.nombre', function(){
      if (vm.familiaSuministro) vm.familiaSuministro=null;
      if (!vm.grupo) return;
      vm.tipoRepetido=false;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupo.id}, function(data){
        vm.familias = orderByFilter(data,'nombre',false);
        focus('familia');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    function controlarSuministroIngresado(){
      var bandera = true;
      vm.detalles.forEach(function(det){
        if (det.suministro && det.suministro.tipoSuministro && det.suministro.tipoSuministro.id==vm.tipoSuministro.id){
          bandera = false;
        }
      });
      return bandera;
    }

    function limpiarCamposInventariables(){
      vm.listaInventariables = [];
    }


    $scope.$watch('vm.tipoSuministroCompleto.nombre', function(){
      vm.tipoSuministro=vm.tipoSuministroCompleto;
      //if (!vm.tipoSuministroCompleto || vm.tipoSuministroCompleto.inventariable===false) return;
    });

    $scope.$watch('vm.tipoSuministro.nombre', function(){
      limpiarCamposInventariables();
      if (!vm.tipoSuministro) return;
      vm.tipoRepetido=false;
      if (controlarSuministroIngresado()){
        if (vm.tipoSuministro.inventariable===false) {
          buscarNoInventariables();
        } else {
          //buscarInventariables();
        }
      } else {
        vm.tipoRepetido=true;
      }

    });

    $scope.$watch('vm.radio', function(){
      if (vm.radio=='directa') {
        ServicioDialogos.abrirDialogoCargando();
        TiposPorEmpresa.query({idEmpresa:vm.empresaId}, function(data){
          vm.tiposCompletos = orderByFilter(data,'nombre',false);
          ServicioDialogos.cerrarDialogoCargando();
        }, function(err){
          console.log(err);
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError();
        });

      }
    });

    $scope.$watch('vm.familiaSuministro.nombre', function(){

      if (vm.tipoSuministro) vm.tipoSuministro=null;
      if (!vm.familiaSuministro) return;
      vm.tipoRepetido=false;
      ServicioDialogos.abrirDialogoCargando();
      TipoSuministroFamilia.query({id:vm.familiaSuministro.id}, function(data){
        vm.tipos = orderByFilter(data,'nombre',false);
        focus('tipo');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    function buscarInventariables(){
      ServicioDialogos.abrirDialogoCargando();
      SuministroInventariableTipoEstadoDepositoCaja.query({idTipo:vm.tipoSuministro.id, idEstado:2, idDeposito:vm.idDeposito, caja:false}, function(data){
        SuministroInventariableContarStockTipoEstado.query({idTipo:vm.tipoSuministro.id, idEstado:2}, function(datos){
          vm.cantidadTotalStockTipo = datos[0];
          vm.bienes = orderByFilter(data, 'inventario', false);
          focus('bien');
          ServicioDialogos.cerrarDialogoCargando();
        }, function(err){
          console.log(err);
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError();
        });
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    }

    function ordenarPorCercania(data){
      var cercania = null;
      var distancia = null;
      cercania = Math.abs(data[0].ubicacion.numeroOrden - vm.detalles[0].suministro.ubicacion.numeroOrden);
      data.forEach(function(item){
        vm.detalles.forEach(function(detalle){
          distancia = Math.abs(item.ubicacion.numeroOrden-detalle.suministro.ubicacion.numeroOrden);
          cercania = Math.abs(item.ubicacion.numeroOrden-detalle.suministro.ubicacion.numeroOrden);
          if (cercania>distancia){
            cercania = distancia;
          }
        });
        item.cercania=cercania;
      });
      vm.listaNoInventariables = orderByFilter(data, 'cercania',false);
      actualizarTabla(vm.listaNoInventariables);
    }

    function ordenarListaNoInventariables(data){
      if (vm.detalles.length===0){
        vm.listaNoInventariables = orderByFilter(data, 'fechaVencimiento', false);
        actualizarTabla(vm.listaNoInventariables);
      } else {
        if (data.length>0){
          ordenarPorCercania(data);
        } else {
          vm.listaNoInventariables = [];
        }
      }
    }

    function armarListaNoInventariable(data){
      var lista = [];
      data.forEach(function(item){
        item.suministro.fecha = item.fecha;
        item.suministro.cantidadOriginal = item.cantidad;
        lista.push(item.suministro);
      });
      ordenarListaNoInventariables(lista);
    }

    function buscarNoInventariables(){
      ServicioDialogos.abrirDialogoCargando();
      SuministroPor2TipoMovimientoEstadoSuministroTipoSuministroDepositoPorDetalle.query({idTipoMovimiento1:2, idTipoMovimiento2:5, idTipoSuministro:vm.tipoSuministro.id, idEstadoSuministro:2, idDeposito:vm.idDeposito}).$promise.then(function(data){
     // SuministroTipoEstadoDepositoPorDetalle.query({idTipoMovimiento:2, idTipo:vm.tipoSuministro.id, idEstado:2, idDeposito:vm.idDeposito}, function(data){
        SuministroContarStockTipoEstado.query({idTipo:vm.tipoSuministro.id, idEstado:2}, function(datos){
          vm.cantidadTotalStockTipo = datos[0];
          armarListaNoInventariable(data);
          ServicioDialogos.cerrarDialogoCargando();
        }, function(err){
          console.log(err);
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError();
        });
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    }

    function cantidadStockTipo(){
      var cantidad = 0;
      if (vm.listaNoInventariables && vm.listaNoInventariables.length>0){
        vm.listaNoInventariables.forEach(function(suministro){
          cantidad = cantidad + suministro.cantidad;
        });
      }
      return cantidad? cantidad : "0";
    }

    function cantidadStockBienes(){
      var cantidad = 0;
      if (vm.bienes && vm.bienes.length>0){
        vm.bienes.forEach(function(bien){
          cantidad = cantidad + bien.suministro.cantidad;
        });
      }
      return cantidad? cantidad : "0";
    }

    function comprobarExistencia(){
      var ban = false;
      vm.detalles.forEach(function(detalle){
        if (detalle.tipoSuministro.id==vm.tipoSuministro.id){
          ban = true;
        }
      });
      return ban;
    }

    function buscarSuministrosSolicitados(){
      var detalles = [];
      vm.listaNoInventariables.forEach(function(sum){
        if (sum.cantidadSolicitada && sum.cantidadSolicitada>0 && sum.cantidadSolicitada<=sum.cantidad){
          detalles.push(sum);
        }
      });
      return detalles;
    }

    function agregarNoInventariable(){
      var suministros = buscarSuministrosSolicitados();
      suministros.forEach(function(sum){
        vm.detalles.push({
          suministro : sum,
          cantidad: sum.cantidadSolicitada,
          fecha: new Date()
        });
      });
      $('.modal-backdrop').remove();
      $uibModalInstance.close({detalles:vm.detalles});
    }

    function agregarInventariable(){
      vm.listaInventariables.forEach(function(inventariable){
        vm.detalles.push({
          suministro: inventariable.suministro,
          suministroInventariable: inventariable,
          cantidad: 1,
          fecha: new Date()
        });
      });
      $('.modal-backdrop').remove();
      $uibModalInstance.close({detalles:vm.detalles});
    }

    function agregar(){
      if (!vm.tipoSuministro.inventariable) {
        agregarNoInventariable();
      } else {
        agregarInventariable();
      }
    }
    
    vm.tableParams = new NgTableParams({
      page: 1,
      count: 1000,
      noPager: true
    });

    vm.tableParamsInventariable = new NgTableParams({
      page: 1,
      count: 1000,
      noPager: true
    });
   
  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoAgregarSuministroEgreso',DialogoAgregarSuministroEgreso);

  function DialogoAgregarSuministroEgreso($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/agregar-suministro-egreso/modal-agregar-suministro-egreso.html',
        controller: 'ModalAgregarSuministroEgresoCtrl as vm',
        resolve: {
          grupos: function(GrupoEmpresa){
            return GrupoEmpresa.query({id:config.empresa.id}).$promise.then(function(data) {
              return data;
            });
          },
          detalles: function(){
            return config.detalles;
          },
          deposito: function(){
            return config.deposito;
          },
          empresa: function(){
            return config.empresa.id;
          },
          sucursal: function(){
            return config.sucursal;
          },
          tipoMovimientoIngreso: function(){
            if (config.tipoMovimiento && config.tipoMovimiento.id==7) {
              return 3;
            } else if (config.tipoMovimiento && config.tipoMovimiento.id==8){
              return 4;
            } else {
              return 2;
            }
          },
          estadoSuministro: function(){
            if (config.tipoMovimiento && config.tipoMovimiento.id==7){
              return 4;
            } else if (config.tipoMovimiento && config.tipoMovimiento.id==8){
              return 7;
            } else {
              return 2;
            }
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

'use strict';
angular.module('proyecto-az-suministro')
  .factory('SuministroPorTipo', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministroinventariable?tipo.id=:id",{id:'@id'});
  })
  .factory('SuministroTipoEstadoDeposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministro?tipo.id=:idTipo&&estado.id=:idEstado&&deposito.id=:idDeposito",{idTipo:'@idTipo', idEstado:'@idEstado',idDeposito:'@idDeposito'});
  })
  .factory('SuministroTipoEstadoDepositoPorDetalle', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/detallemovimiento?tipoMovimiento.id=:idTipoMovimiento&&tipoSuministro.id=:idTipo&&estadoSuministro.id=:idEstado&&deposito.id=:idDeposito",{idTipoMovimiento:'@idTipoMovimiento', idTipoSuministro:'@idTipoSuministro', idEstado:'@idEstado',idDeposito:'@idDeposito'});
  })

  //Este se usa para filtrar por 2 tipos de movimientos y 2 estados de suministros, 1 deposito y 1 tipoSuministro
  .factory('SuministroPor2TipoMovimientoEstadoSuministroTipoSuministroDepositoPorDetalle', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/detallemovimiento/suministros/:idTipoMovimiento1/:idTipoMovimiento2/:idTipoSuministro/:idEstadoSuministro/:idDeposito",{idTipoMovimiento1:'@idTipoMovimiento1', idTipoMovimiento2:'@idTipoMovimiento2', idTipoSuministro:'@idTipoSuministro', idEstadoSuministro: '@idEstadoSuministro', idDeposito:'@idDeposito'});
  })

  //Este se usa para importar sólo detalles cuyos suministros no estén ligados a otro movimiento no cerrado
  .factory('SuministroPor2TipoMovimientoEstadoSuministroTipoSuministroDepositoPorDetalleComprobado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/detallemovimiento/suministrosComprobados/:idTipoMovimiento1/:idTipoMovimiento2/:idTipoSuministro/:idEstadoSuministro/:idDeposito",{idTipoMovimiento1:'@idTipoMovimiento1', idTipoMovimiento2:'@idTipoMovimiento2', idTipoSuministro:'@idTipoSuministro', idEstadoSuministro: '@idEstadoSuministro', idDeposito:'@idDeposito'});
  })

  .factory('SuministroContarStockTipoEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministro?tipo.id=:idTipo&&estado.id=:idEstado&&contar=false",{idTipo:'@idTipo', idEstado:'@idEstado'});
  })
  .factory('SuministroInventariableTipoEstadoDepositoCaja', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministroinventariable?tipo.id=:idTipo&&estado.id=:idEstado&&deposito.id=:idDeposito&&caja:=caja",{idTipo:'@idTipo', idEstado:'@idEstado',idDeposito:'@idDeposito', caja:'@caja'});
  })
  .factory('SuministroInventariableContarStockTipoEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministroinventariable?tipo.id=:idTipo&&estado.id=:idEstado&&contar=false",{idTipo:'@idTipo', idEstado:'@idEstado'});
  })
  .factory('CantidadDespachadaConTope', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/detallemovimiento/cantidades/:idSucursal/:idTipo",{idTipo:'@idTipo', idEstado:'@idEstado'});
  });
(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalAgregarSuministroEgresoCtrl', ModalAgregarSuministroEgresoCtrl);

  /** @ngInject */
  function ModalAgregarSuministroEgresoCtrl(NgTableParams, focus, sucursal, empresa, estadoSuministro, tipoMovimientoIngreso, detalles, deposito, TiposPorEmpresa, CantidadDespachadaConTope, SuministroPor2TipoMovimientoEstadoSuministroTipoSuministroDepositoPorDetalle, SuministroInventariableTipoEstadoDepositoCaja, SuministroInventariableContarStockTipoEstado, SuministroTipoEstadoDeposito, SuministroContarStockTipoEstado, SuministroPorInventarioEmpresa, SuministroPorTipoInventario, SuministroTipoEstadoDepositoPorDetalle, SuministroPorTipo, SuministroPorTipoEstado, ServicioModales, $uibModalInstance, HeaderBarService, TipoSuministroFamilia, FamiliaSuministroGrupo, TipoSuministro, grupos, $timeout, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.grupos = orderByFilter(grupos,'nombre',false);
    vm.empresaId = empresa;
    vm.filtrarBienes = filtrarBienes;
    vm.detalles = detalles;
    vm.idDeposito = deposito;
    vm.sucursal = sucursal;

    vm.tipoMovimientoIngreso = tipoMovimientoIngreso;

    vm.cantidadStockTipo = cantidadStockTipo;
    vm.cantidadStockBienes = cantidadStockBienes;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.ubicacionCompleta = ubicacionCompleta;
    vm.agregar = agregar;
    vm.cerrar = cerrar;
    vm.totalSuministros = totalSuministros;
    vm.comprobarCantidadSolicitada = comprobarCantidadSolicitada;
    vm.comprobarTotalSuministro = vm.comprobarTotalSuministro;
    vm.cambioRadio = cambioRadio;
    vm.obtenerColor = obtenerColor;
    vm.validarCantidadMaximaInventariables = validarCantidadMaximaInventariables;
    vm.agregarBienFiltrado = agregarBienFiltrado;
    vm.agregarBienesPorCantidad = agregarBienesPorCantidad;
    vm.listaInventariables = [];

    vm.eliminar = eliminar;
    vm.radio = 'jerarquizada';

    vm.verFoto = verFoto;

    function agregarBienesPorCantidad(){
      var cant = angular.copy(vm.cantidadInventariables);
      if (vm.cantidadInventariables <= 0) return;
      vm.bienes.forEach(function(bien){
        var ban = false;
        vm.listaInventariables.forEach(function(seleccionado){
          if (seleccionado.id == bien.id){
            ban = true;
          }
        });
        if (!ban && cant>0){
          vm.listaInventariables.push(angular.copy(bien));
          cant--;
        }
      });
      vm.cantidadInventariables = null;
      focus('cantidadBien');
    }

    function validarCantidadMaximaInventariables() {
      var cantMax = vm.cantidadStockBienes();
      return (vm.cantidadInventariables+vm.listaInventariables.length)>cantMax;
    }

    function obtenerColor(suministro){
      if (suministro.cantidadOriginal!=suministro.cantidad){
        return {"color":"red"};
      } else {
        return {"color": "blue"};
      }
    }

    function verFoto(){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalMostrarFotoSuministro({
        onResult: function(resultado) {
          console.log(resultado);
        },
        tipoSuministro: vm.tipoSuministro
      });
    }

    function cambioRadio(){
      if (vm.radio=='jerarquizada'){
        vm.tipoSuministroCompleto=null;
      } else {
        if (vm.tipoSuministro && vm.tipoSuministro.id) vm.tipoSuministro=null;
        if (vm.familiaSuministro && vm.familiaSuministro.id) vm.familiaSuministro=null;
        if (vm.grupo && vm.grupo.id) vm.grupo=null;
      }
    }

    ServicioDialogos.cerrarDialogoCargando();

    function ubicacionNaveNumeroOrden(suministro){
      if (suministro.ubicacion && suministro.ubicacion.nivel) {
        return "Nave: "+suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+suministro.ubicacion.numeroOrden;
      } else {
        return "El suministro no posee una ubicación actual";
      }
    }

    function ubicacionCompleta(suministro){
      if (suministro.ubicacion && suministro.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación completa",
        "Nave: "+suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+suministro.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+suministro.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+suministro.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+suministro.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+suministro.ubicacion.numeroUbicacion+
        "\nN° de orden: "+suministro.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+suministro.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+suministro.ubicacion.categoriaPeso.nombre.toUpperCase());
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "El suministro no posee ubicación asignada");
      }
    }

    function filtrarBienes(valor) {
      if (!valor) return;
      var bienesFiltrados = [];
      for (var i=0; i< vm.bienes.length; i++) {
        if (vm.bienes[i].serie.toLowerCase().indexOf(valor.toLowerCase()) != -1 || vm.bienes[i].inventario.toString().toLowerCase().indexOf(valor.toLowerCase()) != -1 ) {
          bienesFiltrados.push(vm.bienes[i]);
        }
      }
      return bienesFiltrados;
    }

    function eliminar(index){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(
        null,
        "¿Está seguro que desea eliminar el bien de la lista?",
        function(){
          vm.listaInventariables.splice(index, 1);
          actualizarTablaInventariables(vm.listaInventariables);
        }
      );
    }

    function actualizarTablaInventariables(detalles){
      vm.tableParamsInventariable.settings({
        data: detalles
      });
      vm.tableParamsInventariable.reload();
    }

    function actualizarTabla(detalles){
      vm.tableParams.settings({
        data: detalles
      });
      vm.tableParams.reload();
    }

    function agregarBienFiltrado(){
      if (!controlarBienInventariable(vm.bien)){
        vm.listaInventariables.push(angular.copy(vm.bien));
        vm.bien=null;
        focus('bien');
        vm.form.$setPristine();
      } else {
        ServicioDialogos.mostrarDialogoError(null,"El bien ya fue ingresado");
      }
    }

    function controlarBienInventariable(bienNuevo){
      var ban = false;
      vm.listaInventariables.forEach(function(bien){
        if (bien.inventario==bienNuevo.inventario){
          ban = true;
        }
      });
      for (var i = 0; i < vm.detalles.length; i++) {
        if (vm.detalles[i].suministroInventariable){
          if (vm.detalles[i].suministroInventariable.inventario == bienNuevo.inventario){
            ban = true;
          }
        }
      }
      return ban;
    }

    function comprobarTotalSuministro(){
      //console.log(vm.totalSuministros());
      return vm.totalSuministros()>=vm.cantidad;
    }

    function comprobarCantidadSolicitada(){
      if (!vm.listaNoInventariables) return;
      var cantidades = 0;
      var bandera = true;
      vm.listaNoInventariables.forEach(function(sum){
        if (sum.cantidadSolicitada>sum.cantidad) bandera=false;
        var cant = sum.cantidadSolicitada? sum.cantidadSolicitada : 0;
        cantidades = cantidades + cant;
      });
      return cantidades>0 && bandera;
    }

    function totalSuministros(){
      if (!vm.listaNoInventariables) return;
      var cantidades = 0;
      vm.listaNoInventariables.forEach(function(sum){
        var cant = sum.cantidadSolicitada? sum.cantidadSolicitada : 0;
        cantidades = cantidades + cant;
      });
      return cantidades? cantidades : "-";
    }

    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.dismiss();
    }

    $scope.$watch('vm.grupo.nombre', function(){
      if (vm.familiaSuministro) vm.familiaSuministro=null;
      if (!vm.grupo) return;
      vm.tipoRepetido=false;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupo.id}, function(data){
        vm.familias = orderByFilter(data,'nombre',false);
        focus('familia');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    function controlarSuministroIngresado(){
      var bandera = true;
      vm.detalles.forEach(function(det){
        if (det.suministro && det.suministro.tipoSuministro && det.suministro.tipoSuministro.id==vm.tipoSuministro.id){
          bandera = false;
        }
      });
      return bandera;
    }

    function limpiarCamposInventariables(){
      vm.listaInventariables = [];
    }


    $scope.$watch('vm.tipoSuministroCompleto.nombre', function(){
      vm.tipoSuministro=vm.tipoSuministroCompleto;
      //if (!vm.tipoSuministroCompleto || vm.tipoSuministroCompleto.inventariable===false) return;
    });

    $scope.$watch('vm.tipoSuministro.nombre', function(){
      limpiarCamposInventariables();
      if (!vm.tipoSuministro) return;
      vm.tipoRepetido=false;
      if (controlarSuministroIngresado()){
        if (vm.tipoSuministro.inventariable===false) {
          buscarNoInventariables();
        } else {
          buscarInventariables();
        }
      } else {
        vm.tipoRepetido=true;
      }

    });

    $scope.$watch('vm.radio', function(){
      if (vm.radio=='directa') {
        ServicioDialogos.abrirDialogoCargando();
        TiposPorEmpresa.query({idEmpresa:vm.empresaId}, function(data){
          vm.tiposCompletos = orderByFilter(data,'nombre',false);
          ServicioDialogos.cerrarDialogoCargando();
        }, function(err){
          console.log(err);
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError();
        });

      }
    });

    $scope.$watch('vm.familiaSuministro.nombre', function(){

      if (vm.tipoSuministro) vm.tipoSuministro=null;
      if (!vm.familiaSuministro) return;
      vm.tipoRepetido=false;
      ServicioDialogos.abrirDialogoCargando();
      TipoSuministroFamilia.query({id:vm.familiaSuministro.id}, function(data){
        vm.tipos = orderByFilter(data,'nombre',false);
        focus('tipo');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    function comprobarTopeAnual(){
      vm.topeAlcanzado = false;
      vm.topeAnualAlcanzado = false;
      if (vm.periodicidad && vm.cantidadTope && vm.consumoTope>=vm.cantidadTope){
        vm.topeAlcanzado=true;
        ServicioDialogos.mostrarDialogoInformacion("Atención", "La cantidad despachada en el período, es igual o supera a la indicada en el tope");
      } else if (!vm.periodicidad && vm.cantidadTope && vm.cantidadAnual>=vm.cantidadTope){
        ServicioDialogos.mostrarDialogoInformacion("Atención", "La cantidad despachada en año el vigente, es igual o supera a la indicada en el tope");
        vm.topeAnualAlcanzado=true;
      }
    }

    function buscarInventariables(){
      ServicioDialogos.abrirDialogoCargando();
      SuministroInventariableTipoEstadoDepositoCaja.query({idTipo:vm.tipoSuministro.id, idEstado:estadoSuministro, idDeposito:vm.idDeposito, caja:false}, function(data){
        SuministroInventariableContarStockTipoEstado.query({idTipo:vm.tipoSuministro.id, idEstado:estadoSuministro}, function(datos){
          if (sucursal && sucursal.id) {
            CantidadDespachadaConTope.get({idSucursal:sucursal.id, idTipo:vm.tipoSuministro.id}, function(cantidades){
              vm.consumoTope = cantidades.consumoTope;
              vm.periodicidad = cantidades.periodicidad;
              vm.cantidadMes = cantidades.cantidadMes;
              vm.cantidadAnual = cantidades.cantidadAnual;
              vm.cantidadTope = cantidades.cantidadTope;
              comprobarTopeAnual();
              vm.cantidadUltimos30Dias = cantidades.cantidadUltimos30Dias;
              vm.cantidadUltimos60Dias = cantidades.cantidadUltimos60Dias;
              vm.cantidadUltimos90Dias = cantidades.cantidadUltimos90Dias;
              vm.cantidadTotalStockTipo = datos[0];
              vm.bienes = orderByFilter(data, 'inventario', false);
              focus('bien');
              ServicioDialogos.cerrarDialogoCargando();
            }, function(err){
              console.log(err);
              ServicioDialogos.cerrarDialogoCargando();
              ServicioDialogos.mostrarDialogoError();
            });
          } else {
            vm.cantidadTotalStockTipo = datos[0];
            vm.bienes = orderByFilter(data, 'inventario', false);
            focus('bien');
            ServicioDialogos.cerrarDialogoCargando();
          }
        }, function(err){
          console.log(err);
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError();
        });
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    }

    function ordenarPorCercania(data){
      var cercania = null;
      var distancia = null;
      cercania = Math.abs(data[0].ubicacion.numeroOrden - vm.detalles[0].suministro.ubicacion.numeroOrden);
      data.forEach(function(item){
        vm.detalles.forEach(function(detalle){
          distancia = Math.abs(item.ubicacion.numeroOrden-detalle.suministro.ubicacion.numeroOrden);
          cercania = Math.abs(item.ubicacion.numeroOrden-detalle.suministro.ubicacion.numeroOrden);
          if (cercania>distancia){
            cercania = distancia;
          }
        });
        item.cercania=cercania;
      });
      vm.listaNoInventariables = orderByFilter(data, 'cercania',false);
      actualizarTabla(vm.listaNoInventariables);
    }

    function ordenarListaNoInventariables(data){
      if (vm.detalles.length===0){
        vm.listaNoInventariables = orderByFilter(data, 'fechaVencimiento', false);
        actualizarTabla(vm.listaNoInventariables);
      } else {
        if (data.length>0){
          ordenarPorCercania(data);
        } else {
          vm.listaNoInventariables = [];
        }
      }
    }

    function armarListaNoInventariable(data){
      var lista = [];
      data.forEach(function(item){
        item.suministro.fecha = item.fecha;
        item.suministro.cantidadOriginal = item.cantidad;
        lista.push(item.suministro);
      });
      ordenarListaNoInventariables(lista);
    }

    function buscarNoInventariables(){
      ServicioDialogos.abrirDialogoCargando();
      SuministroPor2TipoMovimientoEstadoSuministroTipoSuministroDepositoPorDetalle.query({idTipoMovimiento1:tipoMovimientoIngreso, idTipoMovimiento2:5, idTipoSuministro:vm.tipoSuministro.id, idEstadoSuministro:estadoSuministro, idDeposito:vm.idDeposito}, function(data){
        SuministroContarStockTipoEstado.query({idTipo:vm.tipoSuministro.id, idEstado:estadoSuministro}, function(datos){
          if (sucursal && sucursal.id){
            CantidadDespachadaConTope.get({idSucursal:sucursal.id, idTipo:vm.tipoSuministro.id}, function(cantidades){
              vm.consumoTope = cantidades.consumoTope;
              vm.periodicidad = cantidades.periodicidad;
              vm.cantidadMes = cantidades.cantidadMes;
              vm.cantidadAnual = cantidades.cantidadAnual;
              vm.cantidadTope = cantidades.cantidadTope;
              comprobarTopeAnual();
              vm.cantidadUltimos30Dias = cantidades.cantidadUltimos30Dias;
              vm.cantidadUltimos60Dias = cantidades.cantidadUltimos60Dias;
              vm.cantidadUltimos90Dias = cantidades.cantidadUltimos90Dias;
              vm.cantidadTotalStockTipo = datos[0];

              armarListaNoInventariable(data);
              ServicioDialogos.cerrarDialogoCargando();
            }, function(err){
              console.log(err);
              ServicioDialogos.cerrarDialogoCargando();
              ServicioDialogos.mostrarDialogoError();
            });
          } else {
            vm.cantidadTotalStockTipo = datos[0];
            armarListaNoInventariable(data);
            ServicioDialogos.cerrarDialogoCargando();
          }
        }, function(err){
          console.log(err);
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError();
        });
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    }

    function cantidadStockTipo(){
      var cantidad = 0;
      if (vm.listaNoInventariables && vm.listaNoInventariables.length>0){
        vm.listaNoInventariables.forEach(function(suministro){
          cantidad = cantidad + suministro.cantidad;
        });
      }
      return cantidad? cantidad : "0";
    }

    function cantidadStockBienes(){
      var cantidad = 0;
      if (vm.bienes && vm.bienes.length>0){
        vm.bienes.forEach(function(bien){
          cantidad = cantidad + bien.suministro.cantidad;
        });
      }
      return cantidad? cantidad : "0";
    }

    function comprobarExistencia(){
      var ban = false;
      vm.detalles.forEach(function(detalle){
        if (detalle.tipoSuministro.id==vm.tipoSuministro.id){
          ban = true;
        }
      });
      return ban;
    }

    function buscarSuministrosSolicitados(){
      var detalles = [];
      vm.listaNoInventariables.forEach(function(sum){
        if (sum.cantidadSolicitada && sum.cantidadSolicitada>0 && sum.cantidadSolicitada<=sum.cantidad){
          detalles.push(sum);
        }
      });
      return detalles;
    }

    function comprobarRepetidoNoInventariable(suministro){
      var ban = true;
      vm.detalles.forEach(function(item){
        if (item.suministro && item.suministro.id == suministro.id){
          ban = false;
        }
      });
      return ban;
    }

    function agregarNoInventariable(){
      var suministros = buscarSuministrosSolicitados();
      suministros.forEach(function(sum){
        if (comprobarRepetidoNoInventariable(sum)){
          vm.detalles.push({
            suministro : sum,
            cantidad: sum.cantidadSolicitada,
            fecha: new Date()
          });
        }
      });
      $('.modal-backdrop').remove();
      $uibModalInstance.close({detalles:vm.detalles});
    }

    function agregarInventariable(){
      vm.listaInventariables.forEach(function(inventariable){
        vm.detalles.push({
          suministro: inventariable.suministro,
          suministroInventariable: inventariable,
          cantidad: 1,
          fecha: new Date()
        });
      });
      $('.modal-backdrop').remove();
      $uibModalInstance.close({detalles:vm.detalles});
    }

    function agregar(){
      if (!vm.tipoSuministro.inventariable) {
        agregarNoInventariable();
      } else {
        agregarInventariable();
      }
    }
    
    vm.tableParams = new NgTableParams({
      page: 1,
      count: 1000,
      noPager: true
    });

    vm.tableParamsInventariable = new NgTableParams({
      page: 1,
      count: 1000,
      noPager: true
    });
   
  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoAgregarSuministroEgresoCajas',DialogoAgregarSuministroEgresoCajas);

  function DialogoAgregarSuministroEgresoCajas($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/agregar-suministro-egreso-cajas/modal-agregar-suministro-egreso-cajas.html',
        controller: 'ModalAgregarSuministroEgresoCajasCtrl as vm',
        resolve: {
          cajasAsignadas: function(){
            return config.cajasAsignadas;
          },
          deposito: function(){
            return config.deposito;
          },
          empresa: function(){
            return config.empresa.id;
          },
          tipo: function(){
            //EGR
            return 1;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

'use strict';
angular.module('proyecto-az-suministro')
  .factory('NumeroCajaCerradaUtilizadoEmpresaDeposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/numerocajacerradautilizado?empresa.id=:idEmpresa&&numero=:numero&&deposito.id=:idDeposito",{idEmpresa:'@idEmpresa', numero:'@numero', idDeposito:'@idDeposito'});
  })
  .factory('MovimientoDetalleCajaCerradaNumeroCajaEmpresaDeposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/detallemovimiento?empresa.id=:idEmpresa&&numeroCaja=:numero&&deposito.id=:idDeposito&&tipo.id=:idTipo",{idEmpresa:'@idEmpresa', numero:'@numero', idDeposito:'@idDeposito', idTipo:'@idTipo'});
  })
  .factory('UltimoIngresoDetalleCajaCerradaNumeroCajaEmpresaDeposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/detallemovimiento?empresa.id=:idEmpresa&&numeroCaja=:numero&&deposito.id=:idDeposito",{idEmpresa:'@idEmpresa', numero:'@numero', idDeposito:'@idDeposito'});
  });
(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalAgregarSuministroEgresoCajasCtrl', ModalAgregarSuministroEgresoCajasCtrl);

  /** @ngInject */
  function ModalAgregarSuministroEgresoCajasCtrl(NgTableParams, focus, empresa, cajasAsignadas, tipo, deposito, UltimoIngresoDetalleCajaCerradaNumeroCajaEmpresaDeposito, Egreso, NumeroCajaCerradaUtilizadoEmpresaDeposito, ServicioModales, $uibModalInstance, HeaderBarService, $timeout, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.empresaId = empresa;
    vm.cajasAsignadas = cajasAsignadas;
    vm.idDeposito = deposito;
    vm.idTipo = tipo;

    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.ubicacionCompleta = ubicacionCompleta;
    vm.agregar = agregar;
    vm.cerrar = cerrar;
    vm.cambiarNumero = cambiarNumero;
    vm.comprobarNumeroCaja = comprobarNumeroCaja;

    vm.numeroComprobado = null;
    vm.bandera = false;

    vm.palletsInventariables = [];

    inicializar();
    ServicioDialogos.cerrarDialogoCargando();

    function inicializar(){
      crearTablas();
    }

    function comprobarNumeroCaja(){
      if (!estaNumeroCajas()){
        ServicioDialogos.abrirDialogoCargando();
        NumeroCajaCerradaUtilizadoEmpresaDeposito.query({'numero':vm.numeroCaja, 'idEmpresa':vm.empresaId, 'idDeposito':vm.idDeposito}, function(data){
          if (data.length===0){
            ServicioDialogos.cerrarDialogoCargando();
            ServicioDialogos.mostrarDialogoError(null, "El número de caja cerrada ingresado no corresponde con ninguna caja cerrada en el depósito");
          } else {
            if (data[0].disponible){
              ServicioDialogos.cerrarDialogoCargando();
              ServicioDialogos.mostrarDialogoError(null, "No hay en el ninguna caja cerrada en el depósito que corresponda con el número de caja cerrada ingresado");
            } else {
              buscarMovimientos();
            }
          }
        });
      } else {
        ServicioDialogos.mostrarDialogoError(null, "El número de caja cerrada ingresado ya fue utilizado");

      }
    }

    function buscarMovimientos(){
      UltimoIngresoDetalleCajaCerradaNumeroCajaEmpresaDeposito.get({'numero':vm.numeroCaja, 'idEmpresa':vm.empresaId, 'idDeposito':vm.idDeposito}, function(data){
        if (data.estadoMovimiento.id==6){
          Egreso.get({id:data.id}, function(mov){
            cargarDetalles(mov.detalles);
            vm.numeroComprobado = true;
            vm.bandera = true;
            ServicioDialogos.cerrarDialogoCargando();
          }, function(err){
            console.log(err);
            ServicioDialogos.cerrarDialogoCargando();
            ServicioDialogos.mostrarDialogoError();
          });
        } else {
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError(null, "La caja cerrada N°"+vm.numeroCaja+" ingresó pero aún no se le asignó una ubicación");
        }
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    }

    function estaNumeroCajas(){
      var esta = false;
      vm.cajasAsignadas.forEach(function(numero){
        if (vm.numeroCaja==numero) {
          esta = true;
        }
      });
      return esta;
    }

    function cambiarNumero(){
      vm.bandera=false;
      vm.numeroComprobado=false;
      vm.detallesInventariables=[];
      vm.palletsInventariables=[];
    }

    function armarDetalles(){
      var detalles = [];
      vm.detallesInventariables.forEach(function(det){
        detalles.push({
          cantidad: 1,
          suministro: det.suministro,
          suministroInventariable: det.suministroInventariable,
          numeroCaja: det.numeroCaja,
          fecha: new Date()
        });
      });
      return detalles;
    }

    function agregar(){
      vm.cajasAsignadas.push(vm.numeroCaja);
      $('.modal-backdrop').remove();
      $uibModalInstance.close({detalles:armarDetalles(), cajasAsignadas:vm.cajasAsignadas});
    }

    function ubicacionNaveNumeroOrden(suministro){
      if (suministro.ubicacion && suministro.ubicacion.nivel) {
        return "Nave: "+suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+suministro.ubicacion.numeroOrden;
      } else {
        return "El suministro no posee una ubicación actual";
      }
    }

    function ubicacionCompleta(suministro){
      if (suministro.ubicacion && suministro.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación completa",
        "Nave: "+suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+suministro.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+suministro.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+suministro.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+suministro.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+suministro.ubicacion.numeroUbicacion+
        "\nN° de orden: "+suministro.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+suministro.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+suministro.ubicacion.categoriaPeso.nombre.toUpperCase());
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "El suministro no posee ubicación asignada");
      }
    }

    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.dismiss();
    }

    function filtrarPorNumeroCaja(detalles){
      var filtrados = [];
      detalles.forEach(function(det){
        if (det.numeroCaja===vm.numeroCaja){
          filtrados.push(det);
        }
      });
      return filtrados;
    }

    function cargarDetalles(detalles){
      vm.detallesInventariables = filtrarPorNumeroCaja(angular.copy(detalles));
      armarPallets();
    }

    function armarPallets(){
      crearPallets();
      vm.palletsInventariables.forEach(function(pallet){
        vm.detallesInventariables.forEach(function(detalle){
          if (pallet.numeroRow===detalle.numeroRow){
            pallet.detalles.push(detalle);
            pallet.tipoSuministro=detalle.suministro.tipoSuministro;
            pallet.numeroCaja=detalle.numeroCaja;
            pallet.ubicacion = detalle.suministro.ubicacion;
            pallet.cantidad += detalle.cantidad;
            pallet.precioTotal += detalle.suministro.precioUnitario;
          }
        });
      });
      actualizarTablaInventariables();
    }

    function crearPallets(){
      var esta = false;
      vm.palletsInventariables = [];
      vm.detallesInventariables.forEach(function(detalle){
        esta = false;
        vm.palletsInventariables.forEach(function(usado){
          if (detalle.numeroRow==usado.numeroRow){
            esta = true;
          }
        });
        if (!esta){
          vm.palletsInventariables.push({numeroRow:detalle.numeroRow, detalles:[], numeroCaja:null, tipoSuministro:null, ubicacion:null, cantidad:null, precioTotal:null});
        }
      });
    }

    function actualizarTablaInventariables(){
      vm.tableParamsCajas.settings({
        data: vm.palletsInventariables,
        noPager: true,
        counts: []
      });
      vm.tableParamsCajas.reload();
    }

    function crearTablas(){
      vm.tableParamsCajas = new NgTableParams({
        group: "numeroCaja",
        page: 1,
        count: 50
      });
    }


  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoAgregarQuitarSuministroEgresoSucursal',DialogoAgregarQuitarSuministroEgresoSucursal);

  function DialogoAgregarQuitarSuministroEgresoSucursal($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/agregar-quitar-suministro-egreso-sucursal/agregar-quitar-suministro-egreso-sucursal.html',
        controller: 'ModalAgregarQuitarSuministroEgresoSucursalCtrl as vm',
        resolve: {
          inventariable: function(){
            return config.inventariable;
          },
          detalles: function(){
            return config.detalles;
          },
          cantidades: function(CantidadDespachadaConTope){
            return CantidadDespachadaConTope.get({idSucursal:config.sucursal.id, idTipo:config.tipo.id}).$promise.then(function(cantidades){
              return cantidades;
            });
          },
          sucursal: function(){
            return config.sucursal;
          },
          suministros: function(){
            return config.suministros;
          },
          deposito: function(){
            return config.deposito;
          },
          tipo: function(){
            return config.tipo;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();


(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalAgregarQuitarSuministroEgresoSucursalCtrl', ModalAgregarQuitarSuministroEgresoSucursalCtrl);

  /** @ngInject */
  function ModalAgregarQuitarSuministroEgresoSucursalCtrl(NgTableParams, cantidades, focus, tipo, deposito, inventariable, detalles, sucursal, suministros, ServicioModales, $uibModalInstance, HeaderBarService, $timeout, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.inventariable = inventariable;
    vm.sucursal = sucursal;
    vm.tipoCompleto = tipo.nombre.toUpperCase()+" - "+tipo.familiaSuministro.nombre.toUpperCase()+" - "+tipo.familiaSuministro.grupoSuministro.nombre.toUpperCase();
    vm.detalles = angular.copy(detalles);
    vm.deposito = deposito;
    vm.eliminarNoInventariable = eliminarNoInventariable;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.ubicacionCompleta = ubicacionCompleta;
    vm.cantidadNoInventariableSeleccionable = cantidadNoInventariableSeleccionable;
    vm.cantidadInventariableSeleccionable = cantidadInventariableSeleccionable;
    vm.cantidadAsignadaNoInventariable = cantidadAsignadaNoInventariable;
    vm.agregarNoInventariable = agregarNoInventariable;
    vm.agregar = agregar;
    vm.cerrar = cerrar;
    vm.filtrarBienes = filtrarBienes;
    vm.agregarBienFiltrado = agregarBienFiltrado;
    vm.quitarInventariableAsignado = quitarInventariableAsignado;

    inicializar();

    ServicioDialogos.cerrarDialogoCargando();

    function inicializar(){
      armarCantidadesDespachadasPorSucursalYTipo();
      armarListas();
      vm.empresa = vm.sucursal.empresa;
      crearTablas();
      actualizarTablas();

    }

    function armarCantidadesDespachadasPorSucursalYTipo(){
      vm.consumoTope = cantidades.consumoTope;
      vm.periodicidad = cantidades.periodicidad;
      vm.cantidadMes = cantidades.cantidadMes;
      vm.cantidadAnual = cantidades.cantidadAnual;
      vm.cantidadTope = cantidades.cantidadTope;
      vm.cantidadUltimos30Dias = cantidades.cantidadUltimos30Dias;
      vm.cantidadUltimos60Dias = cantidades.cantidadUltimos60Dias;
      vm.cantidadUltimos90Dias = cantidades.cantidadUltimos90Dias;
    }


    function armarListas(){
      if (!esInventariable()){
        vm.listaNoInventariables = angular.copy(suministros);
      } else {
        vm.listaInventariables = angular.copy(suministros);
      }
    }

    function actualizarTablas(){
      if (esInventariable()){
        actualizarTablaInventariable();
      } else {
        actualizarTablaNoInventariable();
      }
    }

    function actualizarTablaInventariable(){
      vm.tableParamsAsignadoInventariable.settings({
        data: vm.detalles,
      });
      vm.tableParamsAsignadoInventariable.reload();
    }

    function actualizarTablaNoInventariable(){
      vm.tableParamsNoInventariables.settings({
        data: vm.listaNoInventariables,
      });
      vm.tableParamsNoInventariables.reload();

      vm.tableParamsAsignadoNoInventariable.settings({
        data: vm.detalles,
      });
      vm.tableParamsAsignadoNoInventariable.reload();
    }

    function agregarBienFiltrado(){
      if (!controlarBienInventariable(vm.bien)){
        vm.detalles.push({
          suministro: angular.copy(vm.bien.suministro),
          suministroInventariable : angular.copy(vm.bien),
          cantidad: 1
        });
        limpiarInventariable(vm.bien);
        vm.bien=null;
        focus('bien');
        vm.form.$setPristine();
      } else {
        ServicioDialogos.mostrarDialogoError(null,"El bien ya fue ingresado");
      }
    }

    function agregarInventariable(bien){
      vm.listaInventariables.push(bien);
    }

    function quitarInventariable(bien){
      var i = null;
      vm.detalles.forEach(function(item, index){
        if (item.suministroInventariable.id==bien.id){
          i = index;
        }
      });
      if (i!==null){
        vm.detalles.splice(i,1);
      }
    }

    function quitarInventariableAsignado(bien){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "Si quita el bien, pasará a ser elegible nuevamente.\n¿Está seguro que desea continuar?", function(){
        $timeout(function(){
          quitarInventariable(bien);
          actualizarTablaInventariable();
          agregarInventariable(bien);
        },100);
      });
    }

    function cantidadAsignadaNoInventariable(){
      var cant = 0;
      vm.detalles.forEach(function(item){
        cant += item.cantidad;
      });
      return cant>0? cant : "0";
    }

    function limpiarInventariable(bien){
      var index = null;
      vm.listaInventariables.forEach(function(item, i){
        if (item.id==bien.id){
          index = i;
        }
      });
      if (index!==null){
        vm.listaInventariables.splice(index,1);
      }
    }

    function controlarBienInventariable(bienNuevo){
      var ban = false;
      for (var i = 0; i < vm.detalles.length; i++) {
        if (vm.detalles[i].suministroInventariable){
          if (vm.detalles[i].suministroInventariable.inventario == bienNuevo.inventario){
            ban = true;
          }
        }
      }
      return ban;
    }

    function filtrarBienes(valor) {
      if (!valor) return;
      var bienesFiltrados = [];
      for (var i=0; i< vm.listaInventariables.length; i++) {
        if (vm.listaInventariables[i].serie.toLowerCase().indexOf(valor.toLowerCase()) != -1 || vm.listaInventariables[i].inventario.toString().toLowerCase().indexOf(valor.toLowerCase()) != -1 ) {
          bienesFiltrados.push(vm.listaInventariables[i]);
        }
      }
      return bienesFiltrados;
    }


    function agregar(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "Los cambios efectuados, se verán reflejados. ¿Está seguro que desea continuar?", function(){
        $('.modal-backdrop').remove();
        $uibModalInstance.close({
          detalles: vm.detalles,
          suministros : esInventariable()? vm.listaInventariables : vm.listaNoInventariables
        });
        limpiarCampos();
      });
    }

    function agregarNoInventariable(suministro){
      var ban = false;
      vm.detalles.forEach(function(item){
        if (item.suministro.id==suministro.id){
          ban = true;
          item.cantidad += suministro.cantidadSolicitada;
        }
      });
      if (!ban){
        vm.detalles.push({
          suministro: suministro,
          cantidad: suministro.cantidadSolicitada
        });
      }
      suministro.cantidad = suministro.cantidad-suministro.cantidadSolicitada;
      suministro.cantidadSolicitada = null;
      actualizarTablaNoInventariable();
    }

    function cantidadNoInventariableSeleccionable(){
      var cantidad = 0;
      if (vm.listaNoInventariables && vm.listaNoInventariables.length>0){
        vm.listaNoInventariables.forEach(function(suministro){
          cantidad = cantidad + suministro.cantidad;
        });
      }
      return cantidad? cantidad : "0";
    }

    function cantidadInventariableSeleccionable(){
      return vm.listaInventariables.length;
    }

    function esInventariable(){
      return vm.inventariable;
    }

    function quitarAsignadoNoInventariable(idSuministro){
      var i = null;
      vm.detalles.forEach(function(det, index){
        if (det.suministro.id==idSuministro){
          i = index;
        }
      });
      if (i!==null){
        vm.detalles.splice(i,1);
      }
    }

    function recuperarCantidadNoInventariable(idSuministro, cantidad){
      vm.listaNoInventariables.forEach(function(suministro){
        if (suministro.id==idSuministro){
          suministro.cantidad += cantidad;
        }
      });
    }

    function eliminarNoInventariable(item){
      var cantidad = item.cantidad;
      quitarAsignadoNoInventariable(item.suministro.id);
      recuperarCantidadNoInventariable(item.suministro.id, cantidad);
    }

    function ubicacionNaveNumeroOrden(suministro){
      if (suministro.ubicacion && suministro.ubicacion.nivel) {
        return "Nave: "+suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+suministro.ubicacion.numeroOrden;
      } else {
        return "El suministro no posee una ubicación actual";
      }
    }

    function ubicacionCompleta(suministro){
      if (suministro.ubicacion && suministro.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación completa",
        "Nave: "+suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+suministro.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+suministro.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+suministro.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+suministro.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+suministro.ubicacion.numeroUbicacion+
        "\nN° de orden: "+suministro.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+suministro.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+suministro.ubicacion.categoriaPeso.nombre.toUpperCase());
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "El suministro no posee ubicación asignada");
      }
    }

    function limpiarCampos(){
      if (!esInventariable()){
        vm.listaNoInventariables.forEach(function(item){
          item.cantidadSolicitada = null;
        });
      }
    }

    function cerrar(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "Si cierra, no se guardarán los cambios.\n¿Está seguro que desea cerrar?", function(){
        limpiarCampos();
        $('.modal-backdrop').remove();
        $uibModalInstance.dismiss();
      });
    }

    function crearTablas(){
      if (esInventariable()){
        vm.tableParamsAsignadoInventariable = new NgTableParams({
          page: 1,
          count: 1000,
          noPager: true,
          counts: []
        });
      } else {
        vm.tableParamsNoInventariables = new NgTableParams({
          page: 1,
          count: 1000,
          noPager: true,
          counts: []
        });

        vm.tableParamsAsignadoNoInventariable = new NgTableParams({
          page: 1,
          count: 1000,
          noPager: true,
          counts: []
        });
      }
    }
   
  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoAgregarQuitarSuministroEgresoPedido',DialogoAgregarQuitarSuministroEgresoPedido);

  function DialogoAgregarQuitarSuministroEgresoPedido($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/agregar-quitar-suministro-egreso-pedido/agregar-quitar-suministro-egreso-pedido.html',
        controller: 'ModalAgregarQuitarSuministroEgresoPedidoCtrl as vm',
        resolve: {
          listaNoInventariable: function(SuministroPor2TipoMovimientoEstadoSuministroTipoSuministroDepositoPorDetalle){
            return SuministroPor2TipoMovimientoEstadoSuministroTipoSuministroDepositoPorDetalle.query({idTipoMovimiento1:2, idTipoMovimiento2:5, idTipoSuministro:config.tipo.id, idEstadoSuministro:2, idDeposito:config.deposito.id}).$promise.then(function(data){
              return data;
            });
          },
          cantidades: function(CantidadDespachadaConTope){
            return CantidadDespachadaConTope.get({idSucursal:config.sucursal.id, idTipo:config.tipo.id}).$promise.then(function(cantidades){
              return cantidades;
            });
          },
          suministrosAsignados: function(){
            return config.suministrosAsignados? config.suministrosAsignados : [];
          },
          deposito: function(){
            return config.deposito;
          },
          sucursal: function(){
            return config.sucursal;
          },
          tipo: function(){
            return config.tipo;
          },
          cantidadPedido: function(){
            return config.cantidadPedido;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalAgregarQuitarSuministroEgresoPedidoCtrl', ModalAgregarQuitarSuministroEgresoPedidoCtrl);

  /** @ngInject */
  function ModalAgregarQuitarSuministroEgresoPedidoCtrl(NgTableParams, $filter, cantidades, cantidadPedido, sucursal, SuministroContarStockTipoEstado, focus, tipo, deposito, listaNoInventariable, suministrosAsignados, ServicioModales, $uibModalInstance, HeaderBarService, $timeout, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.tipoCompleto = tipo.nombre.toUpperCase()+" - "+tipo.familiaSuministro.nombre.toUpperCase()+" - "+tipo.familiaSuministro.grupoSuministro.nombre.toUpperCase();
    vm.listaNoInventariable = listaNoInventariable;
    vm.deposito = deposito;
    vm.cantidadPedido = cantidadPedido;
    vm.sucursal = sucursal;
    vm.empresa = sucursal.empresa;
    vm.suministrosAsignados = angular.copy(suministrosAsignados);
    vm.eliminarNoInventariable = eliminarNoInventariable;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.ubicacionCompleta = ubicacionCompleta;
    vm.cantidadNoInventariableSeleccionable = cantidadNoInventariableSeleccionable;
    vm.cantidadAsignadaNoInventariable = cantidadAsignadaNoInventariable;
    vm.agregarNoInventariable = agregarNoInventariable;
    vm.agregar = agregar;
    vm.cerrar = cerrar;

    inicializar();

    ServicioDialogos.cerrarDialogoCargando();


    function inicializar(){
      crearTablas();
      actualizarSuministros();
      actualizarTablaNoInventariable();
      armarCantidadesDespachadasPorSucursalYTipo();
    }

    function armarCantidadesDespachadasPorSucursalYTipo(){
      vm.consumoTope = cantidades.consumoTope;
      vm.periodicidad = cantidades.periodicidad;
      vm.cantidadMes = cantidades.cantidadMes;
      vm.cantidadAnual = cantidades.cantidadAnual;
      vm.cantidadTope = cantidades.cantidadTope;
      vm.cantidadUltimos30Dias = cantidades.cantidadUltimos30Dias;
      vm.cantidadUltimos60Dias = cantidades.cantidadUltimos60Dias;
      vm.cantidadUltimos90Dias = cantidades.cantidadUltimos90Dias;
    }

    function actualizarSuministros(){
      vm.suministrosAsignados.forEach(function(asignado){
        vm.listaNoInventariable.forEach(function(item){
          if (asignado.suministro.id==item.suministro.id){
            item.suministro.cantidad-=asignado.cantidad;
          }
        });
      });
    }

    function actualizarTablaNoInventariable(){
      vm.tableParamsNoInventariables.settings({
        data: $filter('orderBy')(vm.listaNoInventariable,["suministro.fechaVencimiento", "fecha", "suministro.cantidad"], false)
      });
      vm.tableParamsNoInventariables.reload();

      vm.tableParamsAsignadoNoInventariable.settings({
        data: vm.suministrosAsignados,
      });
      vm.tableParamsAsignadoNoInventariable.reload();
    }

    function cantidadAsignadaNoInventariable(){
      var cant = 0;
      vm.suministrosAsignados.forEach(function(item){
        cant += item.cantidad;
      });
      return cant>0? cant : "0";
    }

    function agregar(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "Los cambios efectuados, se verán reflejados. ¿Está seguro que desea continuar?", function(){
        if ($('.modal.in').length<=1){
          $('.modal-backdrop').remove();
        }
        $uibModalInstance.close({
          suministrosAsignados: vm.suministrosAsignados,
        });
        limpiarCampos();
      });
    }

    function agregarNoInventariable(suministro){
      var ban = false;
      vm.suministrosAsignados.forEach(function(item){
        if (item.suministro.id==suministro.id){
          ban = true;
          item.cantidad += suministro.cantidadSolicitada;
        }
      });
      if (!ban){
        var fecha = new Date();
        vm.suministrosAsignados.push({
          suministro: suministro,
          cantidad: suministro.cantidadSolicitada,
          fecha: fecha
        });
      }
      suministro.cantidad = suministro.cantidad-suministro.cantidadSolicitada;
      suministro.cantidadSolicitada = null;
      actualizarTablaNoInventariable();
    }

    function cantidadNoInventariableSeleccionable(){
      var cantidad = 0;
      if (vm.listaNoInventariable && vm.listaNoInventariable.length>0){
        vm.listaNoInventariable.forEach(function(suministro){
          cantidad = cantidad + suministro.suministro.cantidad;
        });
      }
      return cantidad? cantidad : "0";
    }

    function quitarAsignadoNoInventariable(idSuministro){
      var i = null;
      vm.suministrosAsignados.forEach(function(det, index){
        if (det.suministro.id==idSuministro){
          i = index;
        }
      });
      if (i!==null){
        vm.suministrosAsignados.splice(i,1);
      }
    }

    function recuperarCantidadNoInventariable(idSuministro, cantidad){
      vm.listaNoInventariable.forEach(function(suministro){
        if (suministro.suministro.id==idSuministro){
          suministro.suministro.cantidad += cantidad;
        }
      });
    }

    function eliminarNoInventariable(item){
      var cantidad = item.cantidad;
      quitarAsignadoNoInventariable(item.suministro.id);
      recuperarCantidadNoInventariable(item.suministro.id, cantidad);
    }

    function ubicacionNaveNumeroOrden(suministro){
      if (suministro.ubicacion && suministro.ubicacion.nivel) {
        return "Nave: "+suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+suministro.ubicacion.numeroOrden;
      } else {
        return "El suministro no posee una ubicación actual";
      }
    }

    function ubicacionCompleta(suministro){
      if (suministro.ubicacion && suministro.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación completa",
        "Nave: "+suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+suministro.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+suministro.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+suministro.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+suministro.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+suministro.ubicacion.numeroUbicacion+
        "\nN° de orden: "+suministro.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+suministro.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+suministro.ubicacion.categoriaPeso.nombre.toUpperCase());
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "El suministro no posee ubicación asignada");
      }
    }

    function limpiarCampos(){
      vm.listaNoInventariable.forEach(function(item){
        item.cantidadSolicitada = null;
      });
    }

    function cerrar(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "Si cierra, no se guardarán los cambios.\n¿Está seguro que desea cerrar?", function(){
        limpiarCampos();
        if ($('.modal.in').length<=1){
          $('.modal-backdrop').remove();
        }
        $uibModalInstance.dismiss();
      });
    }

    function crearTablas(){
      vm.tableParamsNoInventariables = new NgTableParams({
        page: 1,
        count: 1000,
        noPager: true,
        counts: []
      });

      vm.tableParamsAsignadoNoInventariable = new NgTableParams({
        page: 1,
        count: 1000,
        noPager: true,
        counts: []
      });
    }
   
  }
})();

(function() {
  'use strict';
  angular
  .module('proyecto-az-suministro')
  .service('DialogoAgregarPesoCantidadPaqueteEgresos',DialogoAgregarPesoCantidadPaqueteEgresos);

  function DialogoAgregarPesoCantidadPaqueteEgresos($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/agregar-peso-cantidad-egreso/modal-agregar-peso-cantidad-egreso.html',
        controller: 'ModalAgregarPesoCantidadPaqueteEgresosCtrl as vm',
        resolve: {
          empresasLogistica: function(EmpresaLogisticaEmpresa){
            return EmpresaLogisticaEmpresa.query({idEmpresa:config.empresa.id}).$promise.then(function(data){
              return data;
            });
          },
          egresos: function(){
            return config.egresos;
          },
          deposito: function(){
            return config.deposito;
          },
          empresa: function(){
            return config.empresa;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

'use strict';
angular.module('proyecto-az-suministro')
  .factory('EgresoGuardar', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/egreso/:id", {id:"@id"});
  })
  .factory('UltimoEgreso', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/egreso/ultimo", {id:"@id"});
  });
(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalAgregarPesoCantidadPaqueteEgresosCtrl', ModalAgregarPesoCantidadPaqueteEgresosCtrl);

  /** @ngInject */
  function ModalAgregarPesoCantidadPaqueteEgresosCtrl(NgTableParams, URL_SERVIDOR, $http, HeaderBarService, focus, UltimoEgreso, EgresoGuardar, PersonaEmpresaLogisticaEmpresa, empresasLogistica, deposito, empresa, egresos, $uibModalInstance, $stateParams, $filter, $scope, orderByFilter, $state, ServicioDialogos, ServicioModales) {

    var vm = this;
    vm.egresos = egresos;
    vm.empresa = empresa;
    vm.empresasLogistica = empresasLogistica;
    vm.deposito = deposito;
    vm.cerrar = cerrar;
    vm.comprobarEgreso = comprobarEgreso;

    vm.visualizarEgreso = visualizarEgreso;

    vm.pesoTotalEgreso = pesoTotalEgreso;
    vm.paquetesTotalEgreso = paquetesTotalEgreso;
    vm.verificarCantidadesYPeso = verificarCantidadesYPeso;
    vm.calcularPesoEstimado = calcularPesoEstimado;
    vm.verPesoEstimado = verPesoEstimado;
    vm.calcularPeso = calcularPeso;
    vm.simularEtiquetas = simularEtiquetas;

    vm.detalles = [];
    vm.detallesAgrupados = [];

    inicializar();
    ServicioDialogos.cerrarDialogoCargando();

    vm.comprobarPaquetesYPeso = comprobarPaquetesYPeso;
    vm.comprobarSimulacionPaquetesYPeso = comprobarSimulacionPaquetesYPeso;

    function comprobarPaquetesYPeso(){
      var cont = 0;
      var bandera = false;
      vm.egresos.forEach(function(item){
        if (item.cantidadPaquetes==0 || item.cantidadPaquetes!=null) cont+=1;
        if (item.pesoPaquetes==0 || item.pesoPaquetes!=null) cont+=1;
        if (( item.pesoPaquetes==0 || item.pesoPaquetes!=null || !angular.isUndefined(item.pesoPaquetes)? 1 : 0 ) ^ ( item.cantidadPaquetes==0 || item.cantidadPaquetes!=null || !angular.isUndefined(item.cantidadPaquetes)? 1 : 0 )){
          bandera = true;
        }
      });
      return bandera || (cont>0 && cont!=vm.egresos.length*2);
    }

    function comprobarSimulacionPaquetesYPeso(){
      var cont = 0;
      vm.egresos.forEach(function(item){
        if (item.cantidadPaquetes==0 || item.cantidadPaquetes!=null) cont+=1;
        if (item.pesoPaquetes==0 || item.pesoPaquetes!=null) cont+=1;
      });
      return (cont==vm.egresos.length*2);
    }

    function simularEtiquetas(){
      var lista = [];
      var solicitante;
      vm.egresos.forEach(function(movimiento){
        solicitante = movimiento.solicita? "Solicitó: "+movimiento.solicita.apellido.toUpperCase()+", "+movimiento.solicita.nombre.toUpperCase():"";
        for (var i = 0; i < movimiento.cantidadPaquetes; i++) {
          lista.push({
            solicitante: solicitante,
            numeroMovimiento: movimiento.numeroMovimiento,
            bulto: "Bulto "+(i+1)+"/"+movimiento.cantidadPaquetes,
            sucursal: movimiento.sucursal,
            sector: movimiento.sector
          });
        }
      });
      if (lista.length>0){
        lista = orderByFilter(lista, 'sucursal.nombre', false);
        armarReporteEtiquetasA4(lista);
      } else {
        ServicioDialogos.mostrarDialogoError(null, "Ingrese la cantidad de paquetes");
      }
    }

    function armarReporteEtiquetasA4(lista){
      var reporte = {
        detallesReporte: lista,
        deposito: vm.deposito.nombre.toUpperCase(),
        empresaLogistica: vm.empresaLogistica.nombre.toUpperCase(),
        numeroGuia: vm.numeroGuia,
        fecha: $filter('date')(new Date(), "dd/MM/yyyy HH:mm")
      };
      mostrarReporteEtiquetasA4(reporte);
    }

    function mostrarReporteEtiquetasA4(reporte){
      ServicioDialogos.abrirDialogoCargando();
      var Url = URL_SERVIDOR+"/reportes/paquetesA4Simulacion";
      $http.post(Url, reporte,
      {
        responseType: 'arraybuffer'
      }).then(function(response){
        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        var fileUrl = URL.createObjectURL(file);
        window.open(fileUrl);
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.mostrarDialogoError();
        ServicioDialogos.cerrarDialogoCargando();
      });
    }

    function calcularPeso(egreso){
      var ban = false;
      if (egreso.pesoPaquetes){
        if (egreso.pesoPaquetes>=calcularPesoEstimado(egreso) && Math.abs(egreso.pesoPaquetes-calcularPesoEstimado(egreso))<=1.5){
          ban = true;
        }
      }
      return ban;
    }

    function verPesoEstimado(egreso){
      if (egreso.pesoPaquetes && egreso.pesoPaquetes>=calcularPesoEstimado(egreso) && Math.abs(egreso.pesoPaquetes-calcularPesoEstimado(egreso))<=1.5){
        ServicioDialogos.mostrarDialogoInformacion("Atención", "El peso indicado, es igual al estimado o lo sólo supera en 1.5 kg",null);
      } else if (egreso.pesoPaquetes && egreso.pesoPaquetes<=calcularPesoEstimado(egreso)){
        ServicioDialogos.mostrarDialogoError("Atención", "El peso indicado, no supera al peso estimado que deberían tener los paquetes");
      } else if (egreso.pesoPaquetes && Math.abs(egreso.pesoPaquetes-calcularPesoEstimado(egreso))>1.5){
        ServicioDialogos.mostrarDialogoError("Atención", "El peso indicado, supera al peso estimado que deberían tener los paquetes en al menos 1.5 kg");
      } else {
        ServicioDialogos.mostrarDialogoError("Error", "No ha ingresado nada");
      }
    }

    function calcularPesoEstimado(egreso){
      var total = 0;
      egreso.detalles.forEach(function(detalle){
        total += detalle.suministro.tipoSuministro.pesoEstimado ? detalle.suministro.tipoSuministro.pesoEstimado*detalle.cantidad : 0;
      });
      return total.toFixed(3);
    }

    function comprobarEgreso(){
      return vm.empresaLogistica && vm.empresaLogistica.id;
    }

    function verificarCantidadesYPeso(){
      var peso = false;
      var cantidad = false;
      vm.egresos.forEach(function(egreso){
        if (!egreso.cantidadPaquetes || egreso.cantidadPaquetes===0){
          cantidad = true;
        }
        if (!egreso.pesoPaquetes || egreso.pesoPaquetes===0){
          peso = true;
        }
      });
      if (peso && cantidad){
        mensajeAmbos();
      } else if (!peso && cantidad){
        mensajeCantidad();
      } else if (peso && !cantidad){
        mensajePeso();
      } else {
        mensajeCompleto();
      }
    }

    function mensajeCantidad(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "No ha ingresado todas las cantidades de los paquetes en el egreso.\n¿Está seguro que desea guardar de todos modos?", function(){
        guardarEgreso();
      }, null, false);
    }

    function mensajeCompleto(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "¿Está seguro que desea registrar el egreso?", function(){
        guardarEgreso();
      }, null, false);
    }

    function mensajePeso(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "No ha ingresado todos los pesajes de los paquetes en el egreso.\n¿Está seguro que desea guardar de todos modos?", function(){
        guardarEgreso();
      }, null, false);
    }

    function mensajeAmbos(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "No ha ingresado todos los pesajes y cantidades de los paquetes en el egreso.\n¿Está seguro que desea guardar de todos modos?", function(){
        guardarEgreso();
      }, null, false);
    }

    function armarEgreso(callback){
      obtenerNumeroEgreso(function(data){
        var egreso = {};
        egreso.nroGuia = vm.numeroGuia;
        egreso.fecha = new Date();
        egreso.cantidadPaquetes = paquetesTotalEgreso();
        egreso.pesoTotal = pesoTotalEgreso();
        egreso.empresaLogistica = vm.empresaLogistica;
        egreso.personaEmpresaLogistica = vm.personaEmpresaLogistica;
        egreso.movimientos = [];
        egreso.deposito = vm.deposito;
        egreso.empresa = vm.empresa;
        egreso.numeroEgreso = data;
        egreso.estadoEgreso = obtenerEstadoEgreso();
        vm.egresos.forEach(function(item){
          egreso.movimientos.push(item);
        });
        callback(egreso);
      });
    }

    function obtenerEstadoEgreso(){
      var idTipo = vm.egresos[0].tipoMovimiento.id;
      if (idTipo==7){
        return {id:3};
      } else if (idTipo==8){
        return {id:3};
      } else {
        return {id:1};
      }
    }

    function obtenerNumeroEgreso(callback){
      UltimoEgreso.get({}, function(data){
        if (data && !isNaN(data.id)){
          callback(data.id + 10001);
        } else {
          callback(10001);
        }
      }, function (err){
        console.log(err);
      });
    }

    function guardarEgreso(){
      armarEgreso(function(egreso){
        EgresoGuardar.save(egreso, function(data){
          ServicioDialogos.mostrarDialogoGuardadoExito(null, "Se ha guardado correctamente el egreso", function(){
            ServicioDialogos.abrirDialogoCargando();
            ServicioModales.abrirModalMostrarRespuestaEgresoGuardado({
              onResult: function(resultado) {
                $('.modal-backdrop').remove();
                $uibModalInstance.close({});
              },
              respuesta: data,
            });
          });
        }, function(err){
          console.log(err);
          ServicioDialogos.mostrarDialogoError();
        });
      });
    }

    function pesoTotalEgreso(){
      var total = 0;
      vm.egresos.forEach(function(egreso){
        total += egreso.pesoPaquetes?egreso.pesoPaquetes:0;
      });
      return total ? total.toFixed(3) : 0;
    }

    function paquetesTotalEgreso(){
      var total = 0;
      vm.egresos.forEach(function(egreso){
        total += egreso.cantidadPaquetes? egreso.cantidadPaquetes : 0;
      });
      return total;
    }

    $scope.$watch('vm.empresaLogistica.id', function(){
      if (vm.personaEmpresaLogistica) vm.personaEmpresaLogistica=null;
      if (!vm.empresaLogistica || !vm.empresaLogistica.id) return;
      ServicioDialogos.abrirDialogoCargando();
      PersonaEmpresaLogisticaEmpresa.query({id:vm.empresaLogistica.id}, function(data){
        vm.personas = data;
        focus('personaEmpresaLogistica');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    function visualizarEgreso(egreso){
      ServicioDialogos.abrirDialogoCargando();
      ServicioModales.abrirModalVisualizarEgreso({
        onResult: function(resultado) {
          console.log(resultado);
        },
        egreso: egreso
      });
    }

    function inicializar(){
      crearTablas();
      armarDetalles();
      actualizarTabla();
    }

    function armarDetalles(){
      crearDetalles();
      obtenerUbicacionesUtilizadas();
      armarDetallesAgrupados();
      actualizarTablaAgrupados();
    }

    function armarDetallesAgrupados(){
      vm.detallesAgrupados.forEach(function(agrupado){
        vm.detalles.forEach(function(detalle){
          if (agrupado.ubicacion.id===detalle.suministro.ubicacion.id){
            agrupado.detalles.push({suministro:detalle.suministro, suministroInventariable:detalle.suministroInventariable?detalle.suministroInventariable:null,cantidad:detalle.cantidad});
          }
        });
      });
    }

    function crearDetalles(){
      vm.egresos.forEach(function(item){
        item.detalles.forEach(function(detalle){
          vm.detalles.push(detalle);
        });
      });
    }

    function obtenerUbicacionesUtilizadas(){
      var esta = false;
      vm.detalles.forEach(function(detalle){
        esta = false;
        vm.detallesAgrupados.forEach(function(agrupado){
          if (detalle.suministro.ubicacion.id==agrupado.ubicacion.id){
            esta = true;
          }
        });
        if (!esta){
          vm.detallesAgrupados.push({ubicacion:detalle.suministro.ubicacion, detalles:[]});
        }
      });
    }

    function cerrar(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null,"Si cierra la ventana, perderá los datos ingresados. ¿Está seguro que desea cerrar?", function(){
        $('.modal-backdrop').remove();
        $uibModalInstance.dismiss();
      });
    }

    function actualizarTablaAgrupados(){
      vm.tableParamsAgrupado.settings({
        data: $filter('orderBy')(vm.detallesAgrupados, ['ubicacion.nivel.estructura.pasillo.nave.nombre', 'ubicacion.numeroOrden']),
        noPager: true,
        counts: []
      });
      vm.tableParamsAgrupado.reload();
    }

    function actualizarTabla(){
      vm.tableParamsEgresos.settings({
        data: orderByFilter(vm.egresos,'fecha', false),
        noPager: true,
        count: []
      });
      vm.tableParamsEgresos.reload();
    }

    function crearTablas(){
      vm.tableParamsAgrupado = new NgTableParams({
        page: 1,
        count: 10,
        group:{
          tipoSuministro: 'desc'
        }
      });
      vm.tableParamsEgresos = new NgTableParams({
        page:1,
        count:20
      });
    }

  }
})();

(function() {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('DialogoAgregarQuitarSuministroEgresoKit',DialogoAgregarQuitarSuministroEgresoKit);

  function DialogoAgregarQuitarSuministroEgresoKit($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/agregar-quitar-suministro-egreso-kit/agregar-quitar-suministro-egreso-kit.html',
        controller: 'ModalAgregarQuitarSuministroEgresoKitCtrl as vm',
        resolve: {
          listaNoInventariable: function(SuministroPor2TipoMovimientoEstadoSuministroTipoSuministroDepositoPorDetalle){
            return SuministroPor2TipoMovimientoEstadoSuministroTipoSuministroDepositoPorDetalle.query({idTipoMovimiento1:2, idTipoMovimiento2:5, idTipoSuministro:config.tipo.id, idEstadoSuministro:2, idDeposito:config.deposito.id}).$promise.then(function(data){
              return data;
            });
          },
          cantidades: function(CantidadDespachadaConTope){
            return CantidadDespachadaConTope.get({idSucursal:config.sucursal.id, idTipo:config.tipo.id}, function(cantidades){
              return cantidades;
            });
          },
          suministrosAsignados: function(){
            return config.suministrosAsignados? config.suministrosAsignados : [];
          },
          deposito: function(){
            return config.deposito;
          },
          sucursal: function(){
            return config.sucursal;
          },
          tipo: function(){
            return config.tipo;
          },
          cantidadKit: function(){
            return config.cantidadKit;
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalAgregarQuitarSuministroEgresoKitCtrl', ModalAgregarQuitarSuministroEgresoKitCtrl);

  /** @ngInject */
  function ModalAgregarQuitarSuministroEgresoKitCtrl(NgTableParams, $filter, cantidades, cantidadKit, sucursal, SuministroContarStockTipoEstado, focus, tipo, deposito, listaNoInventariable, suministrosAsignados, ServicioModales, $uibModalInstance, HeaderBarService, $timeout, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {

    var vm = this;
    vm.tipoCompleto = tipo.nombre.toUpperCase()+" - "+tipo.familiaSuministro.nombre.toUpperCase()+" - "+tipo.familiaSuministro.grupoSuministro.nombre.toUpperCase();
    vm.listaNoInventariable = listaNoInventariable;
    vm.deposito = deposito;
    vm.cantidadKit = cantidadKit;
    vm.sucursal = sucursal;
    vm.empresa = sucursal.empresa;
    vm.suministrosAsignados = angular.copy(suministrosAsignados);
    vm.eliminarNoInventariable = eliminarNoInventariable;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.ubicacionCompleta = ubicacionCompleta;
    vm.cantidadNoInventariableSeleccionable = cantidadNoInventariableSeleccionable;
    vm.cantidadAsignadaNoInventariable = cantidadAsignadaNoInventariable;
    vm.agregarNoInventariable = agregarNoInventariable;
    vm.agregar = agregar;
    vm.cerrar = cerrar;

    inicializar();

    ServicioDialogos.cerrarDialogoCargando();


    function inicializar(){
      crearTablas();
      actualizarSuministros();
      actualizarTablaNoInventariable();
      armarCantidadesDespachadasPorSucursalYTipo();
    }

    function armarCantidadesDespachadasPorSucursalYTipo(){
      vm.consumoTope = cantidades.consumoTope;
      vm.periodicidad = cantidades.periodicidad;
      vm.cantidadMes = cantidades.cantidadMes;
      vm.cantidadAnual = cantidades.cantidadAnual;
      vm.cantidadTope = cantidades.cantidadTope;
      vm.cantidadUltimos30Dias = cantidades.cantidadUltimos30Dias;
      vm.cantidadUltimos60Dias = cantidades.cantidadUltimos60Dias;
      vm.cantidadUltimos90Dias = cantidades.cantidadUltimos90Dias;
    }

    function actualizarSuministros(){
      vm.suministrosAsignados.forEach(function(asignado){
        vm.listaNoInventariable.forEach(function(item){
          if (asignado.suministro.id==item.suministro.id){
            item.suministro.cantidad-=asignado.cantidad;
          }
        });
      });
    }

    function actualizarTablaNoInventariable(){
      vm.tableParamsNoInventariables.settings({
        data: $filter('orderBy')(vm.listaNoInventariable,["suministro.fechaVencimiento", "fecha", "suministro.cantidad"], false)
      });
      vm.tableParamsNoInventariables.reload();

      vm.tableParamsAsignadoNoInventariable.settings({
        data: vm.suministrosAsignados,
      });
      vm.tableParamsAsignadoNoInventariable.reload();
    }

    function cantidadAsignadaNoInventariable(){
      var cant = 0;
      vm.suministrosAsignados.forEach(function(item){
        cant += item.cantidad;
      });
      return cant>0? cant : "0";
    }

    function agregar(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "Los cambios efectuados, se verán reflejados. ¿Está seguro que desea continuar?", function(){
        if ($('.modal.in').length<=1){
          $('.modal-backdrop').remove();
        }
        $uibModalInstance.close({
          suministrosAsignados: vm.suministrosAsignados,
        });
        limpiarCampos();
      });
    }

    function agregarNoInventariable(suministro){
      var ban = false;
      vm.suministrosAsignados.forEach(function(item){
        if (item.suministro.id==suministro.id){
          ban = true;
          item.cantidad += suministro.cantidadSolicitada;
        }
      });
      if (!ban){
        var fecha = new Date();
        vm.suministrosAsignados.push({
          suministro: suministro,
          cantidad: suministro.cantidadSolicitada,
          fecha: fecha
        });
      }
      suministro.cantidad = suministro.cantidad-suministro.cantidadSolicitada;
      suministro.cantidadSolicitada = null;
      actualizarTablaNoInventariable();
    }

    function cantidadNoInventariableSeleccionable(){
      var cantidad = 0;
      if (vm.listaNoInventariable && vm.listaNoInventariable.length>0){
        vm.listaNoInventariable.forEach(function(suministro){
          cantidad = cantidad + suministro.suministro.cantidad;
        });
      }
      return cantidad? cantidad : "0";
    }

    function quitarAsignadoNoInventariable(idSuministro){
      var i = null;
      vm.suministrosAsignados.forEach(function(det, index){
        if (det.suministro.id==idSuministro){
          i = index;
        }
      });
      if (i!==null){
        vm.suministrosAsignados.splice(i,1);
      }
    }

    function recuperarCantidadNoInventariable(idSuministro, cantidad){
      vm.listaNoInventariable.forEach(function(suministro){
        if (suministro.suministro.id==idSuministro){
          suministro.suministro.cantidad += cantidad;
        }
      });
    }

    function eliminarNoInventariable(item){
      var cantidad = item.cantidad;
      quitarAsignadoNoInventariable(item.suministro.id);
      recuperarCantidadNoInventariable(item.suministro.id, cantidad);
    }

    function ubicacionNaveNumeroOrden(suministro){
      if (suministro.ubicacion && suministro.ubicacion.nivel) {
        return "Nave: "+suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+suministro.ubicacion.numeroOrden;
      } else {
        return "El suministro no posee una ubicación actual";
      }
    }

    function ubicacionCompleta(suministro){
      if (suministro.ubicacion && suministro.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación completa",
        "Nave: "+suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+suministro.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+suministro.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+suministro.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+suministro.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+suministro.ubicacion.numeroUbicacion+
        "\nN° de orden: "+suministro.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+suministro.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+suministro.ubicacion.categoriaPeso.nombre.toUpperCase());
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "El suministro no posee ubicación asignada");
      }
    }

    function limpiarCampos(){
      vm.listaNoInventariable.forEach(function(item){
        item.cantidadSolicitada = null;
      });
    }

    function cerrar(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "Si cierra, no se guardarán los cambios.\n¿Está seguro que desea cerrar?", function(){
        limpiarCampos();
        if ($('.modal.in').length<=1){
          $('.modal-backdrop').remove();
        }
        $uibModalInstance.dismiss();
      });
    }

    function crearTablas(){
      vm.tableParamsNoInventariables = new NgTableParams({
        page: 1,
        count: 1000,
        noPager: true,
        counts: []
      });

      vm.tableParamsAsignadoNoInventariable = new NgTableParams({
        page: 1,
        count: 1000,
        noPager: true,
        counts: []
      });
    }
   
  }
})();

(function() {
  'use strict';
  angular
  .module('proyecto-az-suministro')
  .service('DialogoAgregarDetalleTransferencia',DialogoAgregarDetalleTransferencia);

  function DialogoAgregarDetalleTransferencia($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/agregar-detalle-transferencia/agregar-detalle-transferencia.html',
        controller: 'ModalAgregarDetalleTransferenciaCtrl as vm',
        resolve: {
          grupos: function(GrupoEmpresa){
            return GrupoEmpresa.query({id:config.empresa.id}).$promise.then(function(data) {
              return data;
            });
          },
          detalles: function(){
            return config.detalles;
          },
          deposito: function(){
            return config.deposito.id;
          },
          empresa: function(){
            return config.empresa.id;
          },
          tipoMovimientoIngreso: function(){
            return config.tipoMovimiento;
          },
          estadoSuministro: function(){
            if (config.tipoMovimiento==2){
              return 2;
            } else if (config.tipoMovimiento==3){
              return 4;
            } else {
              return 7;
            }
          }
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalAgregarDetalleTransferenciaCtrl', ModalAgregarDetalleTransferenciaCtrl);

  /** @ngInject */
  function ModalAgregarDetalleTransferenciaCtrl(NgTableParams, focus, tipoMovimientoIngreso, empresa, SuministroPor2TipoMovimientoEstadoSuministroTipoSuministroDepositoPorDetalleComprobado , estadoSuministro, detalles, deposito, TiposPorEmpresa, CantidadDespachadaConTope, SuministroPor2TipoMovimientoEstadoSuministroTipoSuministroDepositoPorDetalle, SuministroInventariableTipoEstadoDepositoCaja, SuministroInventariableContarStockTipoEstado, SuministroTipoEstadoDeposito, SuministroContarStockTipoEstado, SuministroPorInventarioEmpresa, SuministroPorTipoInventario, SuministroTipoEstadoDepositoPorDetalle, SuministroPorTipo, SuministroPorTipoEstado, ServicioModales, $uibModalInstance, HeaderBarService, TipoSuministroFamilia, FamiliaSuministroGrupo, TipoSuministro, grupos, $timeout, $stateParams, $scope, orderByFilter, $state, ServicioDialogos) {
  var vm = this;
    vm.grupos = orderByFilter(grupos,'nombre',false);
    vm.empresaId = empresa;
    vm.filtrarBienes = filtrarBienes;
    vm.detalles = detalles;
    vm.idDeposito = deposito;

    vm.cantidadStockTipo = cantidadStockTipo;
    vm.validarNoInventariables = validarNoInventariables;

    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.ubicacionCompleta = ubicacionCompleta;
    vm.agregar = agregar;
    vm.cerrar = cerrar;
    vm.cambioRadio = cambioRadio;

    vm.agregarBienFiltrado = agregarBienFiltrado;
    vm.listaInventariables = [];

    vm.eliminar = eliminar;
    vm.radio = 'jerarquizada';

    ServicioDialogos.cerrarDialogoCargando();

    function cambioRadio(){
      if (vm.radio=='jerarquizada'){
        vm.tipoSuministroCompleto=null;
      } else {
        if (vm.tipoSuministro && vm.tipoSuministro.id) vm.tipoSuministro=null;
        if (vm.familiaSuministro && vm.familiaSuministro.id) vm.familiaSuministro=null;
        if (vm.grupo && vm.grupo.id) vm.grupo=null;
      }
    }

    function ordenarPorCercania(data){
      var cercania = null;
      var distancia = null;
      cercania = Math.abs(data[0].ubicacion.numeroOrden - vm.detalles[0].suministro.ubicacion.numeroOrden);
      data.forEach(function(item){
        vm.detalles.forEach(function(detalle){
          distancia = Math.abs(item.ubicacion.numeroOrden-detalle.suministro.ubicacion.numeroOrden);
          cercania = Math.abs(item.ubicacion.numeroOrden-detalle.suministro.ubicacion.numeroOrden);
          if (cercania>distancia){
            cercania = distancia;
          }
        });
        item.cercania=cercania;
      });
      vm.listaNoInventariables = orderByFilter(data, 'cercania',false);
      actualizarTabla(vm.listaNoInventariables);
    }

    function ordenarListaNoInventariables(data){
      if (vm.detalles.length===0){
        vm.listaNoInventariables = orderByFilter(data, 'fechaVencimiento', false);
        actualizarTabla(vm.listaNoInventariables);
      } else {
        if (data.length>0){
          ordenarPorCercania(data);
        } else {
          vm.listaNoInventariables = [];
        }
      }
    }

    function armarListaNoInventariable(data, comprobados){
      var lista = [];
      var ban;
      data.forEach(function(item){
        ban = true;
        comprobados.forEach(function(comprobado){
          if (comprobado.id==item.id) ban = false;
        });
        item.suministro.comprobado = false;
        if (ban){
          item.suministro.comprobado = true;
        }
        item.suministro.fecha = item.fecha;
        lista.push(item.suministro);
      });
      ordenarListaNoInventariables(lista);
    }

    function buscarNoInventariables(){
      ServicioDialogos.abrirDialogoCargando();
      SuministroPor2TipoMovimientoEstadoSuministroTipoSuministroDepositoPorDetalle.query({idTipoMovimiento1:tipoMovimientoIngreso, idTipoMovimiento2:5, idTipoSuministro:vm.tipoSuministro.id, idEstadoSuministro:estadoSuministro, idDeposito:vm.idDeposito}, function(data){
        SuministroPor2TipoMovimientoEstadoSuministroTipoSuministroDepositoPorDetalleComprobado.query({idTipoMovimiento1:tipoMovimientoIngreso, idTipoMovimiento2:5, idTipoSuministro:vm.tipoSuministro.id, idEstadoSuministro:estadoSuministro, idDeposito:vm.idDeposito}, function(comprobados){
          SuministroContarStockTipoEstado.query({idTipo:vm.tipoSuministro.id, idEstado:estadoSuministro}, function(datos){
            vm.cantidadTotalStockTipo = datos[0];
            armarListaNoInventariable(data, comprobados);
            ServicioDialogos.cerrarDialogoCargando();
          }, function(err){
            console.log(err);
            ServicioDialogos.cerrarDialogoCargando();
            ServicioDialogos.mostrarDialogoError();
          });
        }, function(err){
          console.log(err);
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError();
        });
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    }

    function cantidadStockTipo(){
      var cantidad = 0;
      if (vm.listaNoInventariables && vm.listaNoInventariables.length>0){
        vm.listaNoInventariables.forEach(function(suministro){
          cantidad = cantidad + suministro.cantidad;
        });
      }
      return cantidad? cantidad : "0";
    }


    function ubicacionNaveNumeroOrden(suministro){
      if (suministro.ubicacion && suministro.ubicacion.nivel) {
        return "Nave: "+suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+suministro.ubicacion.numeroOrden;
      } else {
        return "El suministro no posee una ubicación actual";
      }
    }

    function ubicacionCompleta(suministro){
      if (suministro.ubicacion && suministro.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación completa",
        "Nave: "+suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+suministro.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+suministro.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+suministro.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+suministro.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+suministro.ubicacion.numeroUbicacion+
        "\nN° de orden: "+suministro.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+suministro.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+suministro.ubicacion.categoriaPeso.nombre.toUpperCase());
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "El suministro no posee ubicación asignada");
      }
    }

    function filtrarBienes(valor) {
      if (!valor) return;
      var bienesFiltrados = [];
      for (var i=0; i< vm.bienes.length; i++) {
        if (vm.bienes[i].serie.toLowerCase().indexOf(valor.toLowerCase()) != -1 || vm.bienes[i].inventario.toString().toLowerCase().indexOf(valor.toLowerCase()) != -1 ) {
          bienesFiltrados.push(vm.bienes[i]);
        }
      }
      return bienesFiltrados;
    }

    function eliminar(index){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(
        null,
        "¿Está seguro que desea eliminar el bien de la lista?",
        function(){
          vm.listaInventariables.splice(index, 1);
          actualizarTablaInventariables(vm.listaInventariables);
        }
      );
    }

    function actualizarTablaInventariables(detalles){
      vm.tableParamsInventariable.settings({
        data: detalles
      });
      vm.tableParamsInventariable.reload();
    }

    function actualizarTabla(detalles){
      vm.tableParams.settings({
        data: detalles
      });
      vm.tableParams.reload();
    }

    function agregarBienFiltrado(){
      if (!controlarBienInventariable(vm.bien)){
        vm.listaInventariables.push(angular.copy(vm.bien));
        vm.bien=null;
        focus('bien');
        vm.form.$setPristine();
      } else {
        ServicioDialogos.mostrarDialogoError(null,"El bien ya fue ingresado");
      }
    }

    function controlarBienInventariable(bienNuevo){
      var ban = false;
      vm.listaInventariables.forEach(function(bien){
        if (bien.inventario==bienNuevo.inventario){
          ban = true;
        }
      });
      for (var i = 0; i < vm.detalles.length; i++) {
        if (vm.detalles[i].suministroInventariable){
          if (vm.detalles[i].suministroInventariable.inventario == bienNuevo.inventario){
            ban = true;
          }
        }
      }
      return ban;
    }

    function cerrar(){
      $('.modal-backdrop').remove();
      $uibModalInstance.dismiss();
    }

    $scope.$watch('vm.grupo.nombre', function(){
      if (vm.familiaSuministro) vm.familiaSuministro=null;
      if (!vm.grupo) return;
      vm.tipoRepetido=false;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupo.id}, function(data){
        vm.familias = orderByFilter(data,'nombre',false);
        focus('familia');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    function controlarSuministroIngresado(){
      var bandera = true;
      vm.detalles.forEach(function(det){
        if (det.suministro && det.suministro.tipoSuministro && det.suministro.tipoSuministro.id==vm.tipoSuministro.id){
          bandera = false;
        }
      });
      return bandera;
    }

    function limpiarCamposInventariables(){
      vm.listaInventariables = [];
    }


    $scope.$watch('vm.tipoSuministroCompleto.nombre', function(){
      vm.tipoSuministro=vm.tipoSuministroCompleto;
      //if (!vm.tipoSuministroCompleto || vm.tipoSuministroCompleto.inventariable===false) return;
    });

    $scope.$watch('vm.tipoSuministro.nombre', function(){
      limpiarCamposInventariables();
      if (!vm.tipoSuministro) return;
      vm.tipoRepetido=false;
      if (controlarSuministroIngresado()){
        if (vm.tipoSuministro.inventariable===false) {
          buscarNoInventariables();
        } else {
          buscarInventariables();
        }
      } else {
        vm.tipoRepetido=true;
      }

    });

    $scope.$watch('vm.radio', function(){
      if (vm.radio=='directa') {
        ServicioDialogos.abrirDialogoCargando();
        TiposPorEmpresa.query({idEmpresa:vm.empresaId}, function(data){
          vm.tiposCompletos = orderByFilter(data,'nombre',false);
          ServicioDialogos.cerrarDialogoCargando();
        }, function(err){
          console.log(err);
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError();
        });

      }
    });

    $scope.$watch('vm.familiaSuministro.nombre', function(){

      if (vm.tipoSuministro) vm.tipoSuministro=null;
      if (!vm.familiaSuministro) return;
      vm.tipoRepetido=false;
      ServicioDialogos.abrirDialogoCargando();
      TipoSuministroFamilia.query({id:vm.familiaSuministro.id}, function(data){
        vm.tipos = orderByFilter(data,'nombre',false);
        focus('tipo');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    function buscarInventariables(){
      ServicioDialogos.abrirDialogoCargando();
      SuministroInventariableTipoEstadoDepositoCaja.query({idTipo:vm.tipoSuministro.id, idEstado:estadoSuministro, idDeposito:vm.idDeposito, caja:false}, function(data){
        SuministroInventariableContarStockTipoEstado.query({idTipo:vm.tipoSuministro.id, idEstado:estadoSuministro}, function(datos){
          vm.cantidadTotalStockTipo = datos[0];
          vm.bienes = orderByFilter(data, 'inventario', false);
          focus('bien');
          ServicioDialogos.cerrarDialogoCargando();
        }, function(err){
          console.log(err);
          ServicioDialogos.cerrarDialogoCargando();
          ServicioDialogos.mostrarDialogoError();
        });
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    }

    function validarNoInventariables(){
      if (!vm.listaNoInventariables) return;
      var bandera = false;
      vm.listaNoInventariables.forEach(function(sum){
        if (sum.seleccionado) bandera=true;
      });
      return bandera;
    }

    function cantidadStockBienes(){
      var cantidad = 0;
      if (vm.bienes && vm.bienes.length>0){
        vm.bienes.forEach(function(bien){
          cantidad = cantidad + bien.suministro.cantidad;
        });
      }
      return cantidad? cantidad : "0";
    }

    function comprobarExistencia(){
      var ban = false;
      vm.detalles.forEach(function(detalle){
        if (detalle.tipoSuministro.id==vm.tipoSuministro.id){
          ban = true;
        }
      });
      return ban;
    }

    function buscarSuministrosSolicitados(){
      var detalles = [];
      vm.listaNoInventariables.forEach(function(sum){
        if (sum.seleccionado){
          detalles.push(sum);
        }
      });
      return detalles;
    }

    function comprobarRepetidoNoInventariable(suministro){
      var ban = true;
      vm.detalles.forEach(function(item){
        if (item.suministro && item.suministro.id == suministro.id){
          ban = false;
        }
      });
      return ban;
    }

    function agregarNoInventariable(){
      var suministros = buscarSuministrosSolicitados();
      suministros.forEach(function(sum){
        if (comprobarRepetidoNoInventariable(sum)){
          vm.detalles.push({
            suministro : sum,
            fecha: new Date()
          });
        }
      });
      $('.modal-backdrop').remove();
      $uibModalInstance.close({detalles:vm.detalles});
    }

    function agregarInventariable(){
      vm.listaInventariables.forEach(function(inventariable){
        vm.detalles.push({
          suministroInventariable: inventariable,
          fecha: new Date()
        });
      });
    }

    function agregar(){
      if (vm.tipoSuministro.inventariable){
        agregarInventariable();
      } else {
        agregarNoInventariable();
      }
      $('.modal-backdrop').remove();
      $uibModalInstance.close({detalles:vm.detalles});
    }

    vm.tableParamsInventariable = new NgTableParams({
      page: 1,
      count: 1000,
      noPager: true
    });

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 1000,
      noPager: true
    });
       
  }
})();

(function() {
  'use strict';
  angular
  .module('proyecto-az-suministro')
  .service('DialogoAgregarDetalleReparacion',DialogoAgregarDetalleReparacion);

  function DialogoAgregarDetalleReparacion($uibModal) {

    var vm = this;

    vm.abrir = abrir;

    function abrir(config) {
      var respuesta = $uibModal.open({
        backdrop : 'static',
        keyboard: false,
        size: 'lg',
        windowClass : 'modal-cargando',
        templateUrl: 'app/components/modales/agregar-detalle-reparacion/agregar-detalle-reparacion.html',
        controller: 'ModalAgregarDetalleReparacionCtrl as vm',
        resolve: {
          detalles: function(){
            return config.detalles;
          },
          deposito: function(){
            return config.deposito;
          },
          empresas: function(Empresa){
            return Empresa.query().$promise.then(function(data) {
              return data;
            });
          },
        }
      });
      respuesta.result.then(config.onResult);
      return respuesta;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ModalAgregarDetalleReparacionCtrl', ModalAgregarDetalleReparacionCtrl);

  /** @ngInject */
  function ModalAgregarDetalleReparacionCtrl(NgTableParams,  $timeout, focus, deposito, empresas, detalles, orderByFilter, TipoSuministroFamiliaInventariable, FamiliaSuministroGrupo, GrupoEmpresa, SuministroEmpresaInventario, SuministroTipoSerie, ServicioModales, ServicioDialogos, $uibModalInstance, $stateParams, $scope) {

    var vm = this;

    vm.empresas = empresas;
    vm.detalles = detalles;
    vm.deposito = deposito;
    vm.radio = "etiqueta";
    vm.bandera=false;

    vm.agregar = agregar;
    vm.seleccionar = seleccionar;
    vm.abrirSeleccionFoto = abrirSeleccionFoto;
    vm.quitarFoto = quitarFoto;
    vm.buscar = buscar;
    vm.cerrar = cerrar;
    vm.cambioRadio = cambioRadio;
    vm.corroborarEstadoSuministro = corroborarEstadoSuministro;
    vm.ubicacionNaveNumeroOrden = ubicacionNaveNumeroOrden;
    vm.ubicacionCompleta = ubicacionCompleta;
    vm.cambiarSeleccion = cambiarSeleccion;

    inicializar();
    ServicioDialogos.cerrarDialogoCargando();

    function seleccionar(bien){
      if (comprobarBienElegido(bien)) {
        vm.seleccion = true;
        vm.bien = bien;
      } else {
        ServicioDialogos.mostrarDialogoError(null, "El bien ya fue seleccionado");
      }
    }

    function comprobarBienElegido(bien) {
      var ban = true;
      vm.detalles.forEach(function(item){
        if (item.suministroInventariable.id==bien.id){
          ban = false;
        }
      });
      return ban;
    }

    function abrirSeleccionFoto(){
      ServicioModales.abrirModalSeleccionarFoto({
        onResult: function(res) {
          vm.detalle.encabezadoFoto = res.encabezadoFoto;
          vm.detalle.cuerpoFoto = res.cuerpoFoto;
          vm.foto = vm.detalle.encabezadoFoto + vm.detalle.cuerpoFoto;
        },
      });
    }

    function cambiarSeleccion(){
      ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "Si cambia de selección, perderá la descripción y la fotografía en caso de que haya sido cargada.\n¿Está seguro que desea continuar?", function(){
        $timeout(function() {
          vm.detalle.descripcion = null;
          vm.detalle.encabezadoFoto = null;
          vm.detalle.cuerpoFoto = null;
          vm.bien = null;
          vm.seleccion = false;
        }, 100);
      });
    }


    function ubicacionNaveNumeroOrden(suministro){
      if (suministro.ubicacion && suministro.ubicacion.nivel) {
        return "Nave: "+suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+". Número orden: "+suministro.ubicacion.numeroOrden;
      } else {
        return "El suministro no posee una ubicación actual";
      }
    }

    function ubicacionCompleta(suministro){
      if (suministro.ubicacion && suministro.ubicacion.nivel) {
        ServicioDialogos.mostrarDialogoInformacion("Ubicación completa",
        "Nave: "+suministro.ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase()+
        "\nPasillo: "+suministro.ubicacion.nivel.estante.estructura.pasillo.numeroPasillo+
        "\nEstructura: "+suministro.ubicacion.nivel.estante.estructura.identificadorEstructura+
        "\nEstantería: "+suministro.ubicacion.nivel.estante.numeroEstante+
        "\nEstante: "+suministro.ubicacion.nivel.numeroNivel+
        "\nUbicación N°: "+suministro.ubicacion.numeroUbicacion+
        "\nN° de orden: "+suministro.ubicacion.numeroOrden+
        "\nEstado de la ubicación: "+suministro.ubicacion.estadoUbicacion.nombre.toUpperCase()+
        "\nCategoría de peso: "+suministro.ubicacion.categoriaPeso.nombre.toUpperCase());
      } else {
        ServicioDialogos.mostrarDialogoError("Atención" , "El suministro no posee ubicación asignada");
      }
    }

    function corroborarEstadoSuministro(bien){
      return bien.ubicacion && bien.ubicacion.id && vm.deposito.id == bien.ubicacion.nivel.estante.estructura.pasillo.nave.deposito.id;
    }

    function cambioRadio(){
      if (vm.seleccion){
        ServicioDialogos.mostrarDialogoConfirmacionWarning(null, "Si cambia de criterio de búsqueda, perderá la selección de bien actual. \n¿Está seguro que desea continuar?", function(){
          $timeout(function() {
            setearObjetos();
          }, 100);
        }, function(){
          $timeout(function() {
            if (vm.radio=='etiqueta'){
              vm.radio='serie';
            } else {
              vm.radio='etiqueta';
            }
          }, 100);
        });
      } else {
        setearObjetos();
      }
    }

    function setearObjetos(){
      vm.suministros = [];
      vm.bien = null;
      vm.seleccion = false;
      vm.detalle.encabezadoFoto = null;
      vm.detalle.descripcion = null;
      vm.detalle.cuerpoFoto = null;
      vm.bandera=false;
      if (vm.radio=="etiqueta"){
        if (vm.empresa1 && vm.empresa1.id) vm.empresa1=null;
        vm.serie=null;
      } else {
        if (vm.empresa && vm.empresa.id) vm.empresa=null;
        vm.etiqueta=null;
      }
    }

    function filtrarPorDeposito(){
      var suministros = [];
      vm.suministros.forEach(function(item){
        if (item.suministro.ubicacion && item.suministro.ubicacion.id && item.suministro.ubicacion.nivel.estante.estructura.pasillo.nave.deposito.id==vm.deposito.id) {
          suministros.push(item);
        }
      });
      return suministros;
    }
    

    function actualizarTabla(){
      vm.bandera=true;
      vm.suministros = filtrarPorDeposito();
      vm.suministros = orderByFilter(vm.suministros,'suministro.tipoSuministro.nombre',false);
      vm.tableParams.settings({
        data: vm.suministros,
        noPager: true,
        counts: []
      });
      vm.tableParams.reload();
    }

    function buscarPorInventario(){
      ServicioDialogos.abrirDialogoCargando();
      SuministroEmpresaInventario.query({idEmpresa:vm.empresa.id, inventario:vm.etiqueta,inventariable:true},function(data){
        vm.suministros = data;
        actualizarTabla();
        ServicioDialogos.cerrarDialogoCargando();
      },
      function(err){
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError(null, "No se puede buscar los suministros");
      });
    }

    function buscarPorSerie(){
      ServicioDialogos.abrirDialogoCargando();
      SuministroTipoSerie.query({idTipo:vm.tipoSuministro.id, serie:vm.serie},function(data){
        vm.suministros = data;
        actualizarTabla();
        ServicioDialogos.cerrarDialogoCargando();
      },
      function(err){
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError(null, "No se puede buscar los suministros");
      });
    }

    function buscar(){
      if (vm.radio=="etiqueta"){
        buscarPorInventario();
      } else if (vm.radio=="serie"){
        buscarPorSerie();
      } else {
        ServicioDialogos.mostrarDialogoError(null, "No se puede buscar");
      }
    }

    function agregarDetalle(){
      $('.modal-backdrop').remove();
      $uibModalInstance.close({detalles:vm.detalles});
    }

    $scope.$watch('vm.empresa1.nombre', function(){
      if (vm.grupoSuministro && vm.grupoSuministro.id) vm.grupoSuministro=null;
      if (vm.familiaSuministro && vm.familiaSuministro.id) vm.familiaSuministro=null;
      if (vm.tipoSuministro && vm.tipoSuministro.id) vm.tipoSuministro=null;
      if (!vm.empresa1) return;
      ServicioDialogos.abrirDialogoCargando();
      GrupoEmpresa.query({id:vm.empresa1.id}, function(data) {
        vm.grupos = data;
        focus('grupoSuministro');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.grupoSuministro.nombre', function(){
      if (vm.familiaSuministro && vm.familiaSuministro.id) vm.familiaSuministro=null;
      if (vm.tipoSuministro &&vm.tipoSuministro.id) vm.tipoSuministro=null;
      if (!vm.grupoSuministro) return;
      ServicioDialogos.abrirDialogoCargando();
      FamiliaSuministroGrupo.query({id:vm.grupoSuministro.id}, function(data){
        vm.familias = data;
        focus('familiaSuministro');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    $scope.$watch('vm.tipoSuministro.nombre', function(){
      if (!vm.tipoSuministro) return;
      focus('serie');
    });

    $scope.$watch('vm.familiaSuministro.nombre', function(){
      if (vm.tipoSuministro && vm.tipoSuministro.id) vm.tipoSuministro=null;
      if (!vm.familiaSuministro) return;
      ServicioDialogos.abrirDialogoCargando();
      TipoSuministroFamiliaInventariable.query({idFamilia:vm.familiaSuministro.id, inventariable:true}, function(data){
        vm.tipos = data;
        focus('tipoSuministro');
        ServicioDialogos.cerrarDialogoCargando();
      }, function(err){
        console.log(err);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError();
      });
    });

    function quitarFoto(){
        vm.foto=null;
        vm.detalle.encabezadoFoto = null;
        vm.detalle.cuerpoFoto = null;
    }

    function cerrar(){
      if ($('.modal.in').length<=1){
        $('.modal-backdrop').remove();
      }
      $uibModalInstance.dismiss();
    }

    function inicializarTabla(){
      vm.tableParams = new NgTableParams({
        page: 1,
        count: 10
      });
      vm.tableParams.settings({
        data: vm.suministros,
        noPager: true,
        counts: []
      });
      vm.tableParams.reload();
    }

    function inicializar(){
      vm.titulo = "Seleccionar bien reparado";
      vm.detalle = {};
      if (vm.detalles===undefined) vm.detalles = [];
      //vm.foto = vm.tipo.encabezadoFoto + vm.tipo.cuerpoFoto;
      inicializarTabla();
    }


    function agregar() {
      ServicioDialogos.mostrarDialogoConfirmacionInfo(null, '¿Está seguro que desea agregar el detalle de reparación de este bien?', function(){
        vm.detalle.suministroInventariable = vm.bien;
        vm.detalles.push(vm.detalle);
        agregarDetalle();
      });
    }

    
  }
})();

(function() {
	'use strict';
	angular.module('proyecto-az-suministro')
	.directive('listaEmails', listaEmails);

	function listaEmails() {
		return {
			restrict: 'E',
			templateUrl: 'app/components/campos-personalizados/lista-emails/lista-emails.html',
			controller: 'ListaEmailsCtrl as vm',
			bindToController: true,
			scope: {
				objetos: '=ngModel', //array de strings que se van a usar para llenar la tabla
				tituloColumna: '@tituloColumna', //título de la columna
				nombreCampo: '@nombreCampo', //para usar focus 
				titulo: '@titulo', //título del panel
				placeholder: '@placeholder', //placeholder para mostrar en el input para agregar strings
				tipoObjeto: '@tipoObjeto' //nombre del tipo de objeto para mostrarlo en el msj de error "el tipoObjeto ya existe"
			}
		};
	}

})();
(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('ListaEmailsCtrl', ListaEmailsCtrl);

  /** @ngInject */
  function ListaEmailsCtrl($scope, focus, ServicioDialogos) {
    var vm = this;
    
    inicializar();

    vm.agregar = agregar;
    vm.editar = editar;
    vm.eliminar = eliminar;
    vm.guardar = guardar;
    vm.resetSeleccionado = resetSeleccionado;
    vm.getTemplate = getTemplate;
    vm.habilitarBotonAgregar = habilitarBotonAgregar;

    function agregar() {
      if(!yaExiste(-1, vm.nuevoObjeto)){
        vm.objetos.unshift(vm.nuevoObjeto);
        resetNuevoObjeto();
        setPagingData(vm.paginaActual);
        focus(vm.nombreCampo);
      } else {
        ServicioDialogos.mostrarDialogoError(null, "El " + vm.tipoObjeto + " " + vm.nuevoObjeto + " ya existe en la lista.");
      }
    }

    function editar(index, objetoAEditar) {
        vm.seleccionado = angular.copy(objetoAEditar);
        vm.indiceSeleccionado = index;
    }

    function eliminar(index) {
        vm.objetos.splice(index,1);
        setPagingData(vm.paginaActual);
    }

    function guardar(index) {
        var objetoAGuardar = vm.seleccionado;
        if(yaExiste(index, objetoAGuardar)){
          ServicioDialogos.mostrarDialogoError(null, "El " + vm.tipoObjeto + " " + objetoAGuardar + " ya existe en la lista.");
        } else {
          vm.objetos[index] = angular.copy(objetoAGuardar);
        }
        resetSeleccionado();
        setPagingData(vm.paginaActual);
    }

    function resetSeleccionado() {
        vm.seleccionado = null;
        vm.indiceSeleccionado = null;
    }
    
    function resetNuevoObjeto() {
      vm.nuevoObjeto = null;
    }

    function yaExiste(index, objetoAGuardar) {
      var existe = false;
      vm.objetos.forEach(function(obj, i){
        if (obj == objetoAGuardar && index != i) {
           existe = true;
        }
      });
      return existe;
    }

    function esElMismo(index, objeto) {
      return vm.objetos[index] == objeto;
    }

    function getTemplate(index, objeto) {
        if (index === vm.indiceSeleccionado){
          return 'editarMail';
        } else {
          return 'mostrarMail';
        }
    }

    function habilitarBotonAgregar() {
      return vm.nuevoObjeto === null || vm.indiceSeleccionado !== null || vm.objetos.length>=3;
    }


    $scope.$watch("vm.paginaActual", function() {
      setPagingData(vm.paginaActual);
    });

    $scope.$watch("vm.nuevoObjeto", function() {
      habilitarBotonAgregar();
    });

    $scope.$watch("vm.seleccionado", function() {
      habilitarBotonAgregar();
    });

    function setPagingData(page) {
      var pagedData = vm.objetos.slice(
        (page - 1) * vm.itemsPorPagina,
        page * vm.itemsPorPagina
      );
      vm.paginaObjetos = pagedData;
      vm.totalItems = vm.objetos.length;
    }

    function inicializarParametros(){
      if (!vm.objetos) {
        vm.objetos = [];
      }

      if (!vm.tituloColumna){
        vm.tituloColumna = "Email";
      }

      if (!vm.titulo){
        vm.titulo = "Emails";
      }

      if (!vm.placeholder){
        vm.placeholder = "Ingrese el email";
      }

      if (!vm.tipoObjeto){
        vm.tipoObjeto = "email";
      }

      if (!vm.nombreCampo){
        vm.nombreCampo = "email";
      }
    }

    function inicializar() {
      inicializarParametros();

      vm.nuevoObjeto = null;
      vm.seleccionado = {};
      vm.indiceSeleccionado = null;

      vm.totalItems = vm.objetos.length;
      vm.paginaActual = 1;
      vm.itemsPorPagina = 3;
    }
  }
})();

'use strict';
angular.module('proyecto-az-suministro')
  .factory('DepositoId', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/deposito/:id",{id:'@id'});
  })
  .factory('PasilloId', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/pasillo/:id",{id:'@id'});
  })
  .factory('PasilloHastaUbicacion', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/pasillo/hastaUbicacion/:id",{id:'@id'});
  })
  .factory('PasilloHastaEstructura', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/pasillo/hastaEstructura/:id",{id:'@id'});
  })
  .factory('EstructuraId', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/estructura/:id",{id:'@id'});
  })
  .factory('EstructuraHastaUbicacion', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/estructura/hastaUbicacion/:id",{id:'@id'});
  })
  .factory('EstructuraHastaEstante', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/estructura/hastaEstante/:id",{id:'@id'});
  })
  .factory('EstadoUbicacion', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/estadoubicacion/:id",{id:'@id'});
  })
  .factory('NivelId', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/nivel/:id",{id:'@id'});
  })
  .factory('EstanteId', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/estante/:id",{id:'@id'});
  })
  .factory('EstanteHastaUbicacion', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/estante/hastaUbicacion/:id",{id:'@id'});
  })
  .factory('EstanteHastaNivel', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/estante/hastaNivel/:id",{id:'@id'});
  })
  .factory('NaveId', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/nave/:id",{id:'@id'});
  })
  .factory('PasilloNave', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/pasillo?nave.id=:id",{id:'@id'});
  })
  .factory('PasilloNaveHastaUbicacion', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/pasillo/hastaUbicacion?nave.id=:id",{id:'@id'});
  })
  .factory('PasilloNaveTodos', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/pasillo?todos=:id",{id:'@id'});
  })
  .factory('PasilloNaveTodosHastaEstructura', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/pasillo/hastaEstructura?todos=:id",{id:'@id'});
  })
  .factory('UbicacionNivelTodos', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/ubicacion?todos=:id",{id:'@id'});
  })
  .factory('EstructuraPasilloTodos', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/estructura?todos=:id",{id:'@id'});
  })
  .factory('EstructuraPasilloTodosHastaEstante', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/estructura/hastaEstante?todos=:id",{id:'@id'});
  })
  .factory('EstanteEstructuraTodos', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/estante?todos=:id",{id:'@id'});
  })
  .factory('EstanteEstructuraTodosHastaNivel', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/estante/hastaNivel?todos=:id",{id:'@id'});
  })
  .factory('NivelEstanteTodos', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/nivel?todos=:id",{id:'@id'});
  })
  .factory('EstructuraPasillo', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/estructura?pasillo.id=:id",{id:'@id'});
  })
  .factory('EstructuraPasilloHastaUbicacion', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/estructura/hastaUbicacion?pasillo.id=:id",{id:'@id'});
  })
  .factory('EstanteEstructura', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/estante?estructura.id=:id",{id:'@id'});
  })
  .factory('EstanteEstructuraHastaUbicacion', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/estante/hastaUbicacion?estructura.id=:id",{id:'@id'});
  })
  .factory('NivelEstanteHastaUbicacion', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/nivel/hastaUbicacion?estante.id=:id",{id:'@id'});
  })
  .factory('NivelEstante', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/nivel?estante.id=:id",{id:'@id'});
  })
  .factory('Ubicacion', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/ubicacion/:id",{id:'@id'});
  })
  .factory('UbicacionNivel', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/ubicacion?nivel.id=:id",{id:'@id'});
  })
  .factory('UbicacionNumeroNivel', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/ubicacion?numeroUbicacion=:numeroUbicacion&&nivel.id=:id", {numeroUbicacion:"@numeroUbicacion", id:"@id"});
  })
  .factory('NivelNumeroEstante', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/nivel?numeroNivel=:numeroNivel&&estante.id=:id", {numeroNivel:"@numeroNivel", id:"@id"});
  })
  .factory('EstanteNumeroEstructura', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/estante?numeroEstante=:numeroEstante&&estructura.id=:id", {numeroEstante:"@numeroEstante", id:"@id"});
  })
  .factory('EstanteNumeroEstructuraHastaNivel', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/estante/hastaNivel?numeroEstante=:numeroEstante&&estructura.id=:id", {numeroEstante:"@numeroEstante", id:"@id"});
  })
  .factory('EstructuraNumeroPasillo', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/estructura?identificadorEstructura=:identificadorEstructura&&pasillo.id=:id", {identificadorEstructura:"@identificadorEstructura", id:"@id"});
  })
  .factory('EstructuraNumeroPasilloHastaEstante', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/estructura/hastaEstante?identificadorEstructura=:identificadorEstructura&&pasillo.id=:id", {identificadorEstructura:"@identificadorEstructura", id:"@id"});
  })
  .factory('PasilloNumeroNave', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/pasillo?numeroPasillo=:numeroPasillo&&nave.id=:id", {numeroPasillo:"@numeroPasillo", id:"@id"});
  })
  .factory('PasilloNumeroNaveHastaEstructura', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/pasillo/hastaEstructura?numeroPasillo=:numeroPasillo&&nave.id=:id", {numeroPasillo:"@numeroPasillo", id:"@id"});
  })
  .factory('CambiarEstadoUbicacion', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/ubicacion/cambiarEstado/:idUbicacion/:idEstadoUbicacion", {idUbicacion:"@idUbicacion", idEstadoUbicacion:"@idEstadoUbicacion"});
  });


'use strict';
angular.module('proyecto-az-suministro')
  .factory('StockTipoSuministroDeposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministro/cantidad?deposito.id=:idDeposito&&tipo.id=:idTipo", {idDeposito:"@idDeposito", idTipo:"@idTipo"});
  })
  .factory('SuministroEmpresaActivos', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministro/empresa-activos/:idEmpresa", {idEmpresa:"@idEmpresa"});
  })
  .factory('SuministroDepositoEmpresaExistencias', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministro/existencias/:idDeposito/:idEmpresa", {idDeposito:"@idDeposito", idEmpresa:"@idEmpresa"});
  })
  .factory('SuministroDepositoEmpresaInventariables', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministroinventariable/existencias/:idDeposito/:idEmpresa", {idDeposito:"@idDeposito", idEmpresa:"@idEmpresa"});
  })
  .factory('SuministroDepositoFamilia', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministro/existenciasFamilia/:idDeposito/:idFamilia", {idDeposito:"@idDeposito", idFamilia:"@idFamilia"});
  })
  .factory('SuministroStockEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministro/stock-empresa/:idEmpresa", {idEmpresa:"@idEmpresa"});
  })
  .factory('TopesSucursalGrupo', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/reportes/lista-topes-sucursal-grupo/:idSucursal/:idGrupo", {idSucursal:"@idSucursal", idGrupo:"@idGrupo"});
  })
  .factory('TopesSucursalFamilia', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/reportes/lista-topes-sucursal-familia/:idSucursal/:idFamilia", {idSucursal:"@idSucursal", idFamilia:"@idFamilia"});
  })
  .factory('DetalleMovimientoGrupoFechas', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/detallemovimiento?idGrupo=:idGrupo&&idTipoMovimiento=:idTipoMovimiento&&fechaDesde=:fechaDesde&&fechaHasta=:fechaHasta", {idGrupo:"@idGrupo",fechaDesde:"@fechaDesde", fechaHasta:"@fechaHasta", idTipoMovimiento:"@idTipoMovimiento"});
  })
  .factory('DetalleMovimientoFamiliaFechas', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/detallemovimiento?idEmpresa=:idEmpresa&&idTipoMovimiento=:idTipoMovimiento&&idFamilia=:idFamilia&&fechaDesde=:fechaDesde&&fechaHasta=:fechaHasta", {idEmpresa:"@idEmpresa",fechaDesde:"@fechaDesde", fechaHasta:"@fechaHasta", idTipoMovimiento:"@idTipoMovimiento", idFamilia:"@idFamilia"});
  })
  .factory('ReportePesoBultos', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/reportes/obtener-reporte-peso-bultos/:idEmpresa/:ano", {idEmpresa:"@idEmpresa", ano:"@ano"});
  })
  .factory('ReporteAnualSemestral', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/reportes/obtener-reporte-anual-semestral/:idFamilia/:semestral", {idFamilia:"@idFamilia", semestral:"@semestral"});
  })
  .factory('ReporteAgotamiento', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/reportes/obtener-agotamiento/:idFamilia", {idFamilia:"@idFamilia"});
  })
  .factory('ReporteProblemasIngresos', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/reportes/obtener-problemas-ingresos/:idEmpresa/:ano", {idEmpresa:"@idEmpresa", ano:"@ano"});
  })
  .factory('ListaMovimientosEntreFechaEstado', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/reporte-tiempos?idDeposito=:idDeposito&&fechaDesde=:fechaDesde&&fechaHasta=:fechaHasta", {idDeposito:"@idDeposito",fechaDesde:"@fechaDesde", fechaHasta:"@fechaHasta"});
  })

  .factory('ListaMovimientosEntreFechaEstadoPreparacion', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/reporte-preparacion?idDeposito=:idDeposito&&fechaDesde=:fechaDesde&&fechaHasta=:fechaHasta", {idDeposito:"@idDeposito",fechaDesde:"@fechaDesde", fechaHasta:"@fechaHasta"});
  })
  .factory('ListaInventariablesDonacionScrap', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministroinventariable/lista-reportes/:idDeposito/:idEmpresa/:idTipoStock", {idDeposito:"@idDeposito",idEmpresa:"@idEmpresa", idTipoStock:"@idTipoStock"});
  })
  .factory('ListaExistenciasDonacionScrap', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/suministro/existencias-donacion-scrap/:idDeposito/:idEmpresa/:idTipoStock", {idDeposito:"@idDeposito",idEmpresa:"@idEmpresa", idTipoStock:"@idTipoStock"});
  })
  .factory('ReporteConfirmacionRecepcion', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/reportes/obtener-reporte-confirmacion-recepcion/:idEmpresa/:ano", {idEmpresa:"@idEmpresa", ano:"@ano"});
  })
  .factory('ListaReporteConsumo', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/reportes/lista-reporte-consumo?idFamilia=:idFamilia&&fechaDesde=:fechaDesde&&fechaHasta=:fechaHasta", {idFamilia:"@idFamilia",fechaDesde:"@fechaDesde", fechaHasta:"@fechaHasta"});
  })
  .factory('ListaReporteConsumosTotales', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/reportes/consumos-totales?familia.id=:idFamilia&&grupo.id=:idGrupo&&empresa.id=:idEmpresa&&fechaDesde=:fechaDesde&&fechaHasta=:fechaHasta", {idFamilia:"@idFamilia",idGrupo:"@idGrupo",idEmpresa:"@idEmpresa",fechaDesde:"@fechaDesde", fechaHasta:"@fechaHasta"});
  })
  .factory('BienesPorSucursal', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/reportes/lista-inventariables-sucursales/:idEmpresa", {idEmpresa:"@idEmpresa"});
  })
  .factory('DetallesPorTipoSuministroEntreFechas', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/detallemovimiento?idTipo=:idTipo&&fechaDesde=:fechaDesde&&fechaHasta=:fechaHasta", {idTipo:"@idTipo",fechaDesde:"@fechaDesde", fechaHasta:"@fechaHasta"});
  });

'use strict';
angular.module('proyecto-az-suministro')
  .factory('Pedido', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/pedido/:id",{id:'@id'});
  })
  .factory('AnularPedido', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/pedido/anular/:id",{id:'@id'});
  })
  .factory('RechazarPedido', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/pedido/rechazar/:id",{id:'@id'});
  })
  .factory('UltimoPedido', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/pedido/ultimo",{id:"@id"});
  })
  .factory('ProductosTopesSucursal', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/topeProducto/productos?sucursal.id=:idSucursal&&deposito.id=:idDeposito",{idSucursal:'@idSucursal', idDeposito:'@idDeposito'});
  })

  .factory('ProductosTopesSucursalSolicitante', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/topeProducto/productos?sucursal.id=:idSucursal&&deposito.id=:idDeposito&&solicitante.id=:idSolicitante",{idSucursal:'@idSucursal', idDeposito:'@idDeposito', idSolicitante:'@idSolicitante'});
  })
  .factory('SucursalesTopesProducto', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/topeProducto/sucursales?tipo.id=:idTipo&&deposito.id=:idDeposito",{idTipo:'@idTipo', idDeposito:'@idDeposito'});
  })
  .factory('PedidosUsuario', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/pedido?usuario.id=:idUsuario",{idUsuario:'@idUsuario'});
  })
  .factory('PedidosUsuarioUltimos10', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/pedido/ultimos10?usuario.id=:idUsuario",{idUsuario:'@idUsuario'});
  })
  .factory('PedidosUltimos', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/pedido/ultimos",{});
  })
  .factory('PedidosUltimosDeposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/pedido/ultimos?deposito.id=:idDeposito",{idDeposito:'@idDeposito'});
  })
  .factory('PedidosUltimosDepositoEmpresa', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/pedido/ultimos?deposito.id=:idDeposito&&empresa.id=:idEmpresa",{idDeposito:'@idDeposito', idEmpresa:'@idEmpresa'});
  })
  .factory('PedidoSucursalComprobar', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/pedido/comprobar/:idSucursal",{idSucursal:'@idSucursal'});
  })
  .factory('CantidadPedidosDeposito', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/pedido/cantidad/:idDeposito/:idEstado",{idDeposito:'@idDeposito', idEstado:'@idEstado'});
  })
  .factory('ComprobarMovimientoPedido', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/movimiento/pedido/:idPedido",{idPedido:'@idPedido'});
  });
  
(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.home', {
        url: 'home',
        templateUrl: 'app/app/main/home/home.html',
        controller: 'HomeController',
        controllerAs: 'home',
        params:{
          titulo:'Página principal',
          subtitulo:'Home'
        },
        resolve: {
          rol: function(Usuario, $timeout){
            return $timeout(function() {
              return Usuario.obtenerUsuario().$promise.then(function(usuario){
                return usuario.rol;
              });
            }, 1000);
          }
        }
      });
  }
})();


(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('HomeController', HomeController);

  /** @ngInject */
  function HomeController(HeaderBarService, rol, $state, $stateParams) {
    HeaderBarService.setTitulo($stateParams.titulo);
    HeaderBarService.setSubTitulo($stateParams.subtitulo);

    var home = this;

    home.irNuevoIngreso = irNuevoIngreso;
    home.irNuevoEgreso = irNuevoEgreso;
    home.irListadoIngresos = irListadoIngresos;
    home.irListadoEgresos = irListadoEgresos;
    home.irNuevoPedido = irNuevoPedido;
    home.irListadoPedidos = irListadoPedidos;

    home.rol = rol;

    function irListadoPedidos(){
      $state.go('home.lista-pedidos');
    }

    function irNuevoPedido(){
      $state.go('home.editar-pedido');
    }
    
    function irNuevoEgreso(){
      $state.go('home.editar-egreso');
    }

    function irNuevoIngreso(){
      $state.go('home.editar-ingreso');
    }

    function irListadoEgresos(){
      $state.go('home.lista-egreso');
    }

    function irListadoIngresos(){
      $state.go('home.lista-ingreso');
    }
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').factory('Cliente', Cliente);

  function Cliente($resource, URL_SERVIDOR) {
    return $resource(URL_SERVIDOR +"/clientes/:id",{id:'@id'});
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .run(runBlock);

  /** @ngInject */
  function runBlock(formlyValidationMessages, formlyConfig) {
    formlyConfig.extras.errorExistsAndShouldBeVisibleExpression = 'fc.$touched || form.$submitted';

    formlyValidationMessages.addStringMessage('required', 'Este campo es requerido.');

    formlyConfig.setType({
      name: 'typeahead',
      templateUrl: 'app/config/formly/plantillas/typeahead.html',
      wrapper: ['bootstrapLabel', 'bootstrapHasError']
    });

    formlyConfig.setType({
      name: 'momentPicker',
      extends: 'input',
      defaultOptions: {
        templateOptions: {
          momentPicker: true
        },
        ngModelAttrs: {
          momentPicker: {
            bound: 'moment-picker',
            attribute: 'moment-picker'
          }
        }
      }
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .config(config);

  /** @ngInject */
  function config(formlyConfigProvider) {
    formlyConfigProvider.setWrapper({
        name: 'validation',
        types: ['input', 'typeahead', 'momentPicker'],
        templateUrl: 'app/config/formly/plantillas/error.html'
      });
  }

})();

(function () {
  'use strict';

	angular
	.module('proyecto-az-suministro')
	.directive('importSheetJs', function() {
		return {
			scope:{
				opts: '='
			},
			link: function ($scope, $elm) {
				$elm.on('change', function (changeEvent) {
					var reader = new FileReader();
					reader.onload = function (e) {
						/* read workbook */
						var bstr = e.target.result;
						var workbook = XLSX.read(bstr, {type:'binary'});
						var first_sheet_name = workbook.SheetNames[0];
						var worksheet = workbook.Sheets[first_sheet_name];
						return worksheet;

					};
					reader.readAsBinaryString(changeEvent.target.files[0]);
				});
			}
		};
	});
})();

(function () {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('Util', Util);

  function Util(orderByFilter, $q, NaveHastaUbicacion, Ubicacion) {
    var vm = this;
    vm.contarNoBorrados = contarNoBorrados;
    vm.obtenerAnos = obtenerAnos;
    vm.traerNoBorrados = traerNoBorrados;
    vm.contarUbicacionesPorNivel = contarUbicacionesPorNivel;
    vm.contarUbicacionesPorEstante = contarUbicacionesPorEstante;
    vm.ubicacionesCompletasPorPasillo = ubicacionesCompletasPorPasillo;
    vm.ubicacionesCompletasPorNave = ubicacionesCompletasPorNave;
    vm.ubicacionesCompletasPorEstructura = ubicacionesCompletasPorEstructura;
    vm.ubicacionesCompletasPorNivel = ubicacionesCompletasPorNivel;
    vm.ubicacionesCompletasPorEstante = ubicacionesCompletasPorEstante;
    vm.actualizarNroOrden = actualizarNroOrden;
    vm.quitarCaracteresEspeciales = quitarCaracteresEspeciales;
    vm.validarPassword = validarPassword;

    vm.contadorOrden = 0;

    function quitarCaracteresEspeciales(cadena){
      return cadena.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
    }

    function validarPassword (pw, options) {
      var o = {
        minimo:   8,
        maximo:   25,
        lower:    1,
        upper:    1,
        numeric:  1,
        special:  1,
        badWords: ["password"],
        badSequenceLength: 4,
        alpha:    0,
        custom:   [ /^\S+$/g ],
        noQwertySequences: true,
        noSequential:      true
      };

      for (var property in options)
        o[property] = options[property];

      var re = {
          lower:   /[a-z]/g,
          upper:   /[A-Z]/g,
          alpha:   /[A-Z]/gi,
          numeric: /[0-9]/g,
          special: /[\W_]/g
        },
        rule, i,
        response = {
          validation: true,
          mensaje: "OK"
        };

      if (pw.length < o.minimo){
        response.validation = false;
        response.mensaje = "El password debe tener un mínimo de "+o.minimo+" caracteres";
        return response;
      }

      if (pw.length > o.maximo){
        response.validation = false;
        response.mensaje = "El password debe tener un máximo de "+o.maximo+" caracteres";
        return response;
      }

      for (rule in re) {
        if ((pw.match(re[rule]) || []).length < o[rule]){
          response.validation = false;
          response.mensaje = "El password debe poseer al menos una minúscula, una mayúscula, un número y un caracter especial";
          return response;
        }
      }

      for (i = 0; i < o.badWords.length; i++) {
        if (pw.toLowerCase().indexOf(o.badWords[i].toLowerCase()) > -1){
          response.validation = false;
          response.mensaje = "El password posee una palabra no permitida";
          return response;
        }
      }

      if (o.noSequential && /([\S\s][\S\s])\1/.test(pw)){
          response.validation = false;
          response.mensaje = "El password posee repeticiones secuenciales no permitidas.\n (No puede poseer por ejemplo 'aaaa', '1111', 'AAAA' o '!!!!')";
          return response;
      }

      if (o.badSequenceLength) {
        var lower   = "abcdefghijklmnopqrstuvwxyz";
        var splitLower = lower.split("");
        var reverseArray = splitLower.reverse();
        var lowerReverse = reverseArray.join("");
        var upper   = lower.toUpperCase();
        var upperReverse = lowerReverse.toUpperCase();
        var numbers = "0123456789",
        numbersReverse = "0987654321",
        qwerty  = "qwertyuiopasdfghjklzxcvbnm",
        qwertyReverse = "mnbvcxzlkjhgfdsapoiuytrewq",
        start   = o.badSequenceLength - 1,
        seq     = "_" + pw.slice(0, start);
        for (i = start; i < pw.length; i++) {
          seq = seq.slice(1) + pw.charAt(i);
          if (
            lower.indexOf(seq)   > -1 ||
            lowerReverse.indexOf(seq)   > -1 ||
            upperReverse.indexOf(seq)   > -1 ||
            numbersReverse.indexOf(seq)   > -1 ||
            qwertyReverse.indexOf(seq)   > -1 ||
            upper.indexOf(seq)   > -1 ||
            numbers.indexOf(seq) > -1 ||
            (o.noQwertySequences && qwerty.indexOf(seq) > -1)
          ) {
            response.validation = false;
            response.mensaje = "El password posee secuencias no permitidas.\n  (No puede poseer por ejemplo '1234', '5432', 'qwer', 'rewq', 'ASDF' o 'FDSA')";
            return response;
          }
        }
      }

      for (i = 0; i < o.custom.length; i++) {
        rule = o.custom[i];
        if (rule instanceof RegExp) {
          if (!rule.test(pw)){
            response.validation = false;
            response.mensaje = "El password no puede contener espacios en blanco";
            return response;
          }
        } else if (rule instanceof Function) {
          if (!rule(pw)){
            response.validation = false;
            response.mensaje = "El password no puede contener espacios en blanco";
            return response;
          }
        }
      }

      response.validation = true;
      response.mensaje = "El password cumple con los requisitos";
      return response;
    }


    function obtenerAnos(){
      var anoActual = new Date().getFullYear();
      var anos = [];
      var dif = anoActual-2018;
      for (var i = 0; i <= dif; i++) {
        anos.push((anoActual-i).toFixed());
      }
      return anos;
    }

    function actualizarNroOrden(nave){
      //console.log("ACTUALIZAR NRO ORDEN");
      var defer = $q.defer();
      var promise = defer.promise;
      NaveHastaUbicacion.get({id:nave.id},function(nave){
        return buscarPasillos(nave).then(function(){
          vm.contadorOrden = 0;
          defer.resolve(true);
        });
      });
      return promise;
    }

    function buscarPasillos(nave){
      var defer = $q.defer();
      var promise = defer.promise;
      var pasillos = orderByFilter(nave.pasillos, 'numeroPasillo', false);
      pasillos.forEach(function(pasillo) {
        promise = promise.then(function(){
          return buscarEstructuras(pasillo).then(function(){
            //console.log("PAS");
          });
        });
      });
      defer.resolve(true);
      return promise;
    }

    function buscarEstructuras(pasillo){
      var defer = $q.defer();
      var promise = defer.promise;
      var estructuras = orderByFilter(pasillo.estructuras, 'identificadorEstructura',false);
      estructuras.forEach(function(estructura){
        promise = promise.then(function(){
          return buscarEstantes(estructura).then(function(){
            //console.log("ESTR");
          });
        });
      });
      defer.resolve(true);
      return promise;
    }

    function buscarEstantes(estructura){
      var defer = $q.defer();
      var promise = defer.promise;
      var estantes = orderByFilter(estructura.estantes, 'numeroEstante', false);
      estantes.forEach(function(estante){
        promise = promise.then(function(){
          return buscarNiveles(estante).then(function(){
            //console.log("EST");
          });
        });
      });
      defer.resolve(true);
      return promise;
    }

    function buscarNiveles(estante){
      var defer = $q.defer();
      var promise = defer.promise;
      var niveles = orderByFilter(estante.niveles, 'numeroNivel', false);
      niveles.forEach(function(nivel){
        promise = promise.then(function(){
          return buscarUbicaciones(nivel).then(function(){
            //console.log("NIV");
          });
        });
      });
      defer.resolve(true);
      return promise;
    }

    function buscarUbicaciones(nivel){
      var defer = $q.defer();
      var promise = defer.promise;
      var ubicaciones = orderByFilter(nivel.ubicaciones, 'numeroUbicacion',false);
      ubicaciones.forEach(function(ubicacion){
        if (!ubicacion.borrado){
          promise = promise.then(function(){
            return editarNroOrden(ubicacion).then(function(){
              defer.resolve(true);
            });
          });
        }
      });
      defer.resolve(true);
      return promise;
    }

    function editarNroOrden(ubi){
      var defered = $q.defer();
      var promesa = defered.promise;
      Ubicacion.get({id:ubi.id},function(ubicacion){
        vm.contadorOrden = vm.contadorOrden + 1;
        ubicacion.numeroOrden = vm.contadorOrden;
        Ubicacion.update(ubicacion, function(res){
          defered.resolve(true);
        }, function(err){
          console.log(err);
          return $q.reject();
        });
      }, function(err){
        console.log(err);
        return $q.reject();
      });
      return promesa;
    }

    function contarNoBorrados(array) {
      var contador = 0;
      for (var i = array.length - 1; i >= 0; i--) {
        if (array[i].borrado===false){
          contador = contador + 1;
        }
      }
      return contador;
    }

    function traerNoBorrados(array){
      var noBorrados = [];
      for (var i = array.length - 1; i >= 0; i--) {
        if (array[i].borrado===false){
          noBorrados.push(array[i]);
        }
      }
      return noBorrados;
    }

    function contarUbicacionesPorNivel(nivel){
      var ubicaciones = [];
      nivel.ubicaciones.forEach(function(ubicacion){
        ubicaciones.push(ubicacion);
      });
      return contarNoBorrados(ubicaciones);
    }

    function contarUbicacionesPorEstante(estante){
      var ubicaciones = [];
      estante.niveles.forEach(function(nivel){
        nivel.ubicaciones.forEach(function(ubicacion){
          ubicaciones.push(ubicacion);
        });
      });
      return contarNoBorrados(ubicaciones);
    }

    function ubicacionesCompletasPorEstructura(estructura){
      var libres = 0;
      var ocupados = 0;
      var semi = 0;
      estructura.estantes.forEach(function(estante){
        if (estante.borrado===false){
          estante.niveles.forEach(function(nivel){
            if (nivel.borrado===false){
              nivel.ubicaciones.forEach(function(ubicacion){
                if (ubicacion.borrado===false){
                  switch (ubicacion.estadoUbicacion.id) {
                    case 1:
                      libres = libres + 1;
                      break;
                    case 2:
                      ocupados = ocupados + 1;
                      break;
                    case 3:
                      semi = semi + 1;
                      break;
                    default:
                      break;
                  }
                }
              });
            }
          });
        }
      });
      var cantidades = {
        'totales' : libres + ocupados + semi,
        'libres' : libres,
        'ocupados' : ocupados,
        'semi' : semi
      };
      return cantidades;
    }
    
    function ubicacionesCompletasPorEstante(estante){
      var libres = 0;
      var ocupados = 0;
      var semi = 0;
      estante.niveles.forEach(function(nivel){
        if (nivel.borrado===false){
          nivel.ubicaciones.forEach(function(ubicacion){
            if (ubicacion.borrado===false){
              switch (ubicacion.estadoUbicacion.id) {
                case 1:
                  libres = libres + 1;
                  break;
                case 2:
                  ocupados = ocupados + 1;
                  break;
                case 3:
                  semi = semi + 1;
                  break;
                default:
                  break;
              }
            }
          });
        }
      });
      var cantidades = {
        'totales' : libres + ocupados + semi,
        'libres' : libres,
        'ocupados' : ocupados,
        'semi' : semi
      };
      return cantidades;
    }
    
    function ubicacionesCompletasPorNivel(nivel){
      var libres = 0;
      var ocupados = 0;
      var semi = 0;
      nivel.ubicaciones.forEach(function(ubicacion){
        if (ubicacion.borrado===false){
          switch (ubicacion.estadoUbicacion.id) {
            case 1:
              libres = libres + 1;
              break;
            case 2:
              ocupados = ocupados + 1;
              break;
            case 3:
              semi = semi + 1;
              break;
            default:
              break;
          }
        }
      });
      var cantidades = {
        'totales' : libres + ocupados + semi,
        'libres' : libres,
        'ocupados' : ocupados,
        'semi' : semi
      };
      return cantidades;
    }

    function ubicacionesCompletasPorPasillo(pasillo){
      var libres = 0;
      var ocupados = 0;
      var semi = 0;
      pasillo.estructuras.forEach(function(estructura){
        if (estructura.borrado===false){
          estructura.estantes.forEach(function(estante){
            if (estante.borrado===false){
              estante.niveles.forEach(function(nivel){
                if (nivel.borrado===false){
                  nivel.ubicaciones.forEach(function(ubicacion){
                    if (ubicacion.borrado===false){
                      switch (ubicacion.estadoUbicacion.id) {
                        case 1:
                          libres = libres + 1;
                          break;
                        case 2:
                          ocupados = ocupados + 1;
                          break;
                        case 3:
                          semi = semi + 1;
                          break;
                        default:
                          break;
                      }
                    }
                  });
                }
              });
            }
          });
        }
      });
      var cantidades = {
        'totales' : libres + ocupados + semi,
        'libres' : libres,
        'ocupados' : ocupados,
        'semi' : semi
      };
      return cantidades;
    }

    function ubicacionesCompletasPorNave(nave){
      var libres = 0;
      var ocupados = 0;
      var semi = 0;
      nave.pasillos.forEach(function(pasillo){
        if (pasillo.borrado===false){
          pasillo.estructuras.forEach(function(estructura){
            if (estructura.borrado===false){
              estructura.estantes.forEach(function(estante){
                if (estante.borrado===false){
                  estante.niveles.forEach(function(nivel){
                    if (nivel.borrado===false){
                      nivel.ubicaciones.forEach(function(ubicacion){
                        if (ubicacion.borrado===false){
                          switch (ubicacion.estadoUbicacion.id) {
                            case 1:
                              libres = libres + 1;
                              break;
                            case 2:
                              ocupados = ocupados + 1;
                              break;
                            case 3:
                              semi = semi + 1;
                              break;
                            default:
                              break;
                          }
                        }
                      });
                    }
                  });
                }
              });
            }
          });
        }
      })
      var cantidades = {
        'totales' : libres + ocupados + semi,
        'libres' : libres,
        'ocupados' : ocupados,
        'semi' : semi
      };
      return cantidades;
    }
  }
})();

(function () {
  'use strict';

	angular
	.module('proyecto-az-suministro')
	.directive('focusOn', function() {
	    return function(scope, elem, attr) {
	      scope.$on('focusOn', function(e, name) {
	        if(name === attr.focusOn) {
	          elem[0].focus();
	          if (elem[0].type==='date' || elem[0].type==='number' || elem[0].type==='submit' || elem[0].type==='email') return;
			  elem[0].setSelectionRange(0, elem[0].value.length);

	        }
	      });
	   	};
	});
})();
(function () {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .factory('focus', function ($rootScope, $timeout) {
    return function(name) {
      $timeout(function (){
        $rootScope.$broadcast('focusOn', name);
      },1000);
    }
  });
  
})();
(function () {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .filter('filtroNoBorrados', function() {

  return function(array) {
    var noBorrados = [];

    array.forEach(function(item){
		if (item.borrado===false) {
			noBorrados.push(item);
		}
    });
    return noBorrados;
    
  };
});

})();

(function () {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('ComprobarRol', ComprobarRol);

  function ComprobarRol(AlmacenUsuarios, $state) {
    var vm = this;

    vm.comprobar = comprobar;

    function comprobar(){
      var rol = AlmacenUsuarios.obtenerRol();
      return (rol && rol.id!=1 && rol.id!=2);
      
    }


  }

})();
(function(){
'use strict';

angular.module('proyecto-az-suministro')
.factory('UserJWT', function ($resource, URL_SERVIDOR) {
  return $resource(URL_SERVIDOR + "/login/:id", {id:"@id"},{
    obtenerUsuario: {
      url: URL_SERVIDOR + '/login/actual',
      method: 'GET'
    },
    obtenerToken: {
      url: URL_SERVIDOR + '/login',
      method: 'POST',
      headers: {
       'Content-Type': undefined
      },
    }
  });
});

})();
(function(){
'use strict';
angular.module('proyecto-az-suministro')
    .factory('AuthInterceptor', function ($q, $injector, AlmacenUsuariosJWT) {
        var inflightAuthRequest = null;
        return {
            responseError: function(response) {
                if (response.status===401) {
                    AlmacenUsuariosJWT.limpiar();
                    $injector.get("$state").go('login');
                }
                return $q.reject(response);
            }

        };
    })
    // Register the previously created AuthInterceptor.
    .config(function ($httpProvider) {
        $httpProvider.interceptors.push('AuthInterceptor');
    });
})();
(function(){
'use strict';
angular.module('proyecto-az-suministro')
 .service('AutenticacionJWT', function ($q, $timeout, AlmacenUsuariosJWT, $http, URL_SERVIDOR, UserJWT, ServicioDialogos) {

    var vm = this;

    vm.login = login;

    vm.getAutenticacion = getAutenticacion;

    function login(nombreUsuario, password, recordar) {
        var defer = $q.defer();
        var promise = defer.promise;
        $http({
            method: 'POST',
            url: URL_SERVIDOR+"/login",
            data: {nombreUsuario: nombreUsuario, password: password},
            headers: {
                'Content-Type': undefined
            }
        }).then(function (success) {
            if (success.status && success.status!==200){
                defer.reject();
                return promise;
            }
            AlmacenUsuariosJWT.guardarToken(nombreUsuario, success.headers("authorization"), recordar);
            defer.resolve(success);
            return promise;
        }, function (err) {
            console.log(err);
            defer.reject();
            return promise;
        });
        return promise;
    }

    function getAutenticacion() {
        return AlmacenUsuariosJWT.getAutenticacion();
    }
});
})();
(function() {
'use strict';


angular.module('proyecto-az-suministro')
    .service('AlmacenUsuariosJWT', function ($base64, $localStorage, $sessionStorage) {

        var vm = this;

        // Datos del usuario que se almacenan persistentemente.
        var autenticacion;
        // Los datos del usuario logueado.
        var usuario;

        var rol;

        var recuperar = function () {
            autenticacion = $sessionStorage.autenticacion || $localStorage.autenticacion;
            if (!autenticacion) {
                autenticacion = {};
            }
        };

        this.obtenerRol = function(){
            return rol;
        };

        this.limpiar = function () {
            $sessionStorage.autenticacion = null;
            $localStorage.autenticacion = null;
            $sessionStorage.usuario = null;
            autenticacion = undefined;
            usuario = undefined;
            recuperar();
        };

        this.guardarToken = function (nombreUsuario, token, recordar) {
            if (token) {
                autenticacion.encabezado = token;
                autenticacion.usuario = nombreUsuario;
                if (recordar) {
                    $localStorage.autenticacion = autenticacion;
                } else {
                    $sessionStorage.autenticacion = autenticacion;
                }
            }
        };

        this.getUsuario = function () {
            return $sessionStorage.autenticacion && $sessionStorage.autenticacion.usuario ? $sessionStorage.autenticacion.usuario : $localStorage.autenticacion.usuario;
        };

        this.getAutenticacion = function () {
            if (!validarAutenticacion()) {
                return undefined;
            }
            return autenticacion.encabezado;
        };

        var validarAutenticacion = function () {
            return autenticacion && autenticacion.encabezado;
        };

        recuperar();

    });
})();
(function() {
  'use strict';

  angular.module('proyecto-az-suministro')
  .factory('CamposMenu', function($resource) {
    return $resource("app/components/side-bar/opciones.json",{});
  });
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').directive('sideBar', sideBar);

  function sideBar() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/side-bar/sidebar.html',
      replace : true,
      controller: 'SidebarCtrl as sidebar',
      bindToController:true
    };
  }

})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').controller('SidebarCtrl', SidebarCtrl);

  function SidebarCtrl($scope, $cookies, $window, $state, $http, Usuario) {
    var sidebar = this;
    var mobileView = 992;

    sidebar.toggleSidebar = toggleSidebar;
    sidebar.ir = ir;
    sidebar.getIcono = getIcono;

    $http.get('app/components/side-bar/opciones.json').then(function(data) {
      Usuario.obtenerUsuario().$promise.then(function(usuario){
        var menu = [];
        if (usuario.rol && (usuario.rol.id===3)){
          menu = obtenerMenuOperativo(angular.copy(data.data));
        } else if (usuario.rol && usuario.rol.id===29){
          menu = obtenerMenuConsulta(angular.copy(data.data));
        } else if (usuario.rol && usuario.rol.id===30){
          menu = obtenerMenuPedidos(angular.copy(data.data));
        } else {
          menu = obtenerMenuAdmin(angular.copy(data.data));
        }
        sidebar.opciones = menu;
      });
    });

    function obtenerMenuAdmin(data){
      var menu = [];
      data.forEach(function(item){
        var hijos = [];
        item.hijos.forEach(function(hijo){
          if (hijo.ocultar!="true"){
            hijos.push(hijo);
          }
        });
        menu.push({
          nombre : item.nombre,
          hijos : hijos,
          icono : item.icono,
        });
      });
      return menu;
    }

    function obtenerMenuPedidos(data){
      var menu = [];
      data.forEach(function(item){
        if (item.rolPedidos=="true"){
          var hijos = [];
          item.hijos.forEach(function(hijo){
            if (hijo.rolPedidos=="true"){
              hijos.push(hijo);
            }
          });
          menu.push({
            nombre : item.nombre,
            hijos : hijos,
            icono : item.icono,
          });
        }
      });
      return menu;
    }

    function obtenerMenuConsulta(data){
      var menu = [];
      data.forEach(function(item){
        if (item.rolConsulta=="true"){
          var hijos = [];
          item.hijos.forEach(function(hijo){
            if (hijo.rolConsulta=="true"){
              hijos.push(hijo);
            }
          });
          menu.push({
            nombre : item.nombre,
            hijos : hijos,
            icono : item.icono,
          });
        }
      });
      return menu;
    }

    function obtenerMenuOperativo(data){
      var menu = [];
      data.forEach(function(item){
        if (item.noMostrar!="true" || item.rolOperativo=="true"){
          var hijos = [];
          item.hijos.forEach(function(hijo){
            if ((hijo.rolOperativo=="true" || hijo.noMostrar!="true") && hijo.ocultar!="true"){
              hijos.push(hijo);
            }
          });
          menu.push({
            nombre : item.nombre,
            hijos : hijos,
            icono : item.icono,
          });
        }
      });
      return menu;
    }

    function getWidth() {
      return $window.innerWidth;
    }

    $scope.$watch(getWidth, function(newValue) {
      if (newValue >= mobileView) {
        if (angular.isDefined($cookies.get('toggle'))) {
          $scope.toggle = !$cookies.get('toggle') ? false : true;
        } else {
          $scope.toggle = true;
        }
      } else {
        $scope.toggle = false;
      }

    });

    function toggleSidebar() {
      $scope.toggle = !$scope.toggle;
      $cookies.put('toggle', $scope.toggle);
    }

    $window.onresize = function() {
      $scope.$apply();
    };

    function ir(estado) {
      $state.go(estado);
    }

    function getIcono(estaAbierto) {
      if (estaAbierto) {
        return 'glyphicon glyphicon-chevron-down';
      }else{
        return 'glyphicon glyphicon-chevron-right';
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .service('ServicioModales', ServicioModales);

  function ServicioModales($uibModal, DialogoGenerarRotulosChicos, DialogoPedidosAnteriores, DialogoCargarSucursalesEgresoMultipleExcel, DialogoEgresoMultipleAutomatico, DialogoFiltroIngresoFechaManual, DialogoEditarEgreso, DialogoVisualizarSeleccionadosPedido, DialogoMostrarRespuestaInventariablesExcel, DialogoCargarInventariablesExcel, DialogoFiltroEgresos, DialogoRespuestaTopesExcel, DialogoCargarTopesExcel, DialogoVisualizarEgresoPedido, DialogoConfirmarReclamarPedido, DialogoAgregarQuitarSuministroEgresoPedido, DialogoAgregarSuministroEgresoPedido, DialogoRechazarPedido, DialogoVisualizarResumenPedido, DialogoVisualizarPedido, DialogoAgregarDetalleTransferencia, DialogoVisualizarTransferencia, DialogoAtencionReclamo, DialogoVisualizarHistorialReparacion, DialogoAgregarDetalleReparacion, DialogoIngresosRemitoOrden, DialogoFiltroIngresoOrdenCompra, DialogoElegirTipoSuministro, DialogoInformeEgresosEnPreparacion, DialogoEditarMovimiento, DialogoFiltroIngresoRemito, DialogoFiltroNumeroMovimiento, DialogoCambiarUbicacionVariosSuministros, DialogoFiltroBusquedaEgresoSuministro, DialogoFiltroBusquedaIngresoSuministro, DialogoEditarProblemasIngreso, DialogoVisualizarIngreso, DialogoAgregarQuitarSuministroEgresoKit, DialogoAgregarSuministroEgresoKit, DialogoVisualizarKitPrearmado, DialogoSeleccionarTipoSuministroKit, DialogoAgregarSuministroIngresoConciliacion, DialogoAgregarSuministroEgresoConciliacion, DialogoMostrarRespuestaSuministroIngresoExcel, DialogoAgregarSuministroIngresoExcel, DialogoCambiarUbicacionSuministro, DialogoAgregarSuministroEgresoCajas, DialogoAgregarQuitarSuministroEgresoSucursal, DialogoVisualizarSuministrosAsignados, DialogoSeleccionarTipoSuministro, DialogoMostrarRespuestaEgresoGuardado, DialogoAgregarFotoProblema, DialogoVisualizarDespacho, DialogoAgregarPesoCantidadPaqueteEgresos, DialogoVisualizarInformeRecorrido, DialogoVisualizarEgreso, DialogoFiltroBusquedaEgreso, DialogoAgregarSuministroEgreso, DialogoFiltroHistorialSuministro, DialogoMostrarFotoSuministro, DialogoSeleccionarFoto, DialogoEditarSuministroNoInventariable, DialogoEditarSuministros, DialogoFiltroBusquedaIngreso, DialogoOcuparUbicacionesCajas, DialogoAsignarUbicacionesCajas, DialogoAsignarUbicacionIndividualCajas, DialogoFiltroBusquedaIngresoCajas, DialogoMostrarSuministroUbicaciones, DialogoAgregarSuministro, DialogoAsignarUbicacionIndividual, DialogoAsignarUbicaciones, DialogoCambioPassword, DialogoAgregarSuministroIngreso) {
    var vm = this;

    vm.abrirModalAgregarPedido = abrirModalAgregarPedido;
    vm.abrirModalAgregarSuministroIngreso = abrirModalAgregarSuministroIngreso;
    vm.abrirModalCambioPassword = abrirModalCambioPassword;
    vm.abrirModalAsignarUbicacionIndividual = abrirModalAsignarUbicacionIndividual;
    vm.abrirModalAsignarUbicacionIndividualCajas = abrirModalAsignarUbicacionIndividualCajas;
    vm.abrirModalAsignarUbicaciones = abrirModalAsignarUbicaciones;
    vm.abrirModalAsignarUbicacionesCajas = abrirModalAsignarUbicacionesCajas;
    vm.abrirModalSuministroUbicaciones = abrirModalSuministroUbicaciones;
    vm.abrirModalFiltroBusquedaIngreso = abrirModalFiltroBusquedaIngreso;
    vm.abrirModalFiltroBusquedaIngresoCajas = abrirModalFiltroBusquedaIngresoCajas;
    vm.abrirModalOcuparUbicacionesCajas = abrirModalOcuparUbicacionesCajas;
    vm.abrirModalEditarSuministro = abrirModalEditarSuministro;
    vm.abrirModalSeleccionarFoto = abrirModalSeleccionarFoto;
    vm.abrirModalEditarSuministroNoInventariable = abrirModalEditarSuministroNoInventariable;
    vm.abrirModalMostrarFotoSuministro = abrirModalMostrarFotoSuministro;
    vm.abrirModalHistorialSuministro = abrirModalHistorialSuministro;
    vm.abrirModalAgregarSuministroEgreso = abrirModalAgregarSuministroEgreso;
    vm.abrirModalFiltroBusquedaEgreso = abrirModalFiltroBusquedaEgreso;
    vm.abrirModalVisualizarEgreso = abrirModalVisualizarEgreso;
    vm.abrirModalVisualizarIngreso = abrirModalVisualizarIngreso;
    vm.abrirModalVisualizarInformeRecorrido = abrirModalVisualizarInformeRecorrido;
    vm.abrirModalCargaPesoCantidadPaqueteEgresos = abrirModalCargaPesoCantidadPaqueteEgresos;
    vm.abrirModalVisualizarDespacho = abrirModalVisualizarDespacho;
    vm.abrirModalFotoProblema = abrirModalFotoProblema;
    vm.abrirModalMostrarRespuestaEgresoGuardado = abrirModalMostrarRespuestaEgresoGuardado;
    vm.abrirModalSeleccionTipoSuministro = abrirModalSeleccionTipoSuministro;
    vm.abrirModalVisualizarSuministroAsignado = abrirModalVisualizarSuministroAsignado;
    vm.abrirModalAgregarQuitarSuministroEgresoSucursal = abrirModalAgregarQuitarSuministroEgresoSucursal;
    vm.abrirModalAgregarSuministroEgresoCajas = abrirModalAgregarSuministroEgresoCajas;
    vm.abrirModalCambiarUbicacionSuministro = abrirModalCambiarUbicacionSuministro;
    vm.abrirModalAgregarSuministroIngresoExcel = abrirModalAgregarSuministroIngresoExcel;
    vm.abrirModalMostrarSuministrosIngresoExcel = abrirModalMostrarSuministrosIngresoExcel;
    vm.abrirModalAgregarSuministroEgresoConciliacion = abrirModalAgregarSuministroEgresoConciliacion;
    vm.abrirModalAgregarSuministroIngresoConciliacion = abrirModalAgregarSuministroIngresoConciliacion;
    vm.abrirModalSeleccionTipoSuministroKit = abrirModalSeleccionTipoSuministroKit;
    vm.abrirModalVisualizarKitPrearmado = abrirModalVisualizarKitPrearmado;
    vm.abrirModalAgregarSuministroEgresoKit = abrirModalAgregarSuministroEgresoKit;
    vm.abrirModalAgregarQuitarSuministroKit = abrirModalAgregarQuitarSuministroKit;
    vm.abrirModalEditarProblemasIngreso = abrirModalEditarProblemasIngreso;
    vm.abrirModalFiltroBusquedaIngresoSuministro = abrirModalFiltroBusquedaIngresoSuministro;
    vm.abrirModalFiltroBusquedaEgresoSuministro = abrirModalFiltroBusquedaEgresoSuministro;
    vm.abrirModalCambiarUbicacionVariosSuministros = abrirModalCambiarUbicacionVariosSuministros;
    vm.abrirModalFiltroIngresoNumeroMovimiento = abrirModalFiltroIngresoNumeroMovimiento;
    vm.abrirModalFiltroIngresoRemito = abrirModalFiltroIngresoRemito;
    vm.abrirModalEditarMovimiento = abrirModalEditarMovimiento;
    vm.abrirModalInformeEgresosEnPreparacion = abrirModalInformeEgresosEnPreparacion;
    vm.abrirModalElegirTipoSuministro = abrirModalElegirTipoSuministro;
    vm.abrirModalFiltroIngresoOrdenCompra = abrirModalFiltroIngresoOrdenCompra;
    vm.abrirModalIngresosRemitoOrden = abrirModalIngresosRemitoOrden;
    vm.abrirModalAgregarDetalleReparacion = abrirModalAgregarDetalleReparacion;
    vm.abrirVisualizarHistorialReparacion = abrirVisualizarHistorialReparacion;
    vm.abrirModalAtencionReclamoEgreso = abrirModalAtencionReclamoEgreso;
    vm.abrirModalVisualizarTransferencia = abrirModalVisualizarTransferencia;
    vm.abrirModalAgregarDetalleTransferencia = abrirModalAgregarDetalleTransferencia;
    vm.abrirModalPedido = abrirModalPedido;
    vm.abrirModalVisualizarResumenPedido = abrirModalVisualizarResumenPedido;
    vm.abrirModalRechazarPedido = abrirModalRechazarPedido;
    vm.abrirModalAgregarSuministroPedido = abrirModalAgregarSuministroPedido;
    vm.abrirModalAgregarQuitarSuministroPedido = abrirModalAgregarQuitarSuministroPedido;
    vm.abrirModalConfirmarReclamarPedido = abrirModalConfirmarReclamarPedido;
    vm.abrirVisualizarEgresoPedido = abrirVisualizarEgresoPedido;
    vm.abrirModalCargarTopesExcel = abrirModalCargarTopesExcel;
    vm.abrirModalRespuestaTopesExcel = abrirModalRespuestaTopesExcel;
    vm.abrirModalFiltrosEgreso = abrirModalFiltrosEgreso;
    vm.abrirModalCargarInventariablesExcel = abrirModalCargarInventariablesExcel;
    vm.abrirModalRespuestaInventariablesExcel = abrirModalRespuestaInventariablesExcel;
    vm.abrirModalSeleccionadosPedido = abrirModalSeleccionadosPedido;
    vm.abrirModalEditarEgreso = abrirModalEditarEgreso;
    vm.abrirModalFechaIngresoManual = abrirModalFechaIngresoManual;
    vm.abrirModalEgresoMultipleAutomatico = abrirModalEgresoMultipleAutomatico;
    vm.abrirModalCargarSucursalesEgresoMultipleExcel = abrirModalCargarSucursalesEgresoMultipleExcel;
    vm.abrirModalPedidosAnteriores = abrirModalPedidosAnteriores;
    vm.abrirModalGenerarRotulosChicos = abrirModalGenerarRotulosChicos;
    
    var respuesta = null;

    function abrirModalGenerarRotulosChicos(config){
      if (!config) config = {};
      return DialogoGenerarRotulosChicos.abrir(config);
    }

    function abrirModalPedidosAnteriores(config){
      if (!config) config = {};
      return DialogoPedidosAnteriores.abrir(config);
    }

    function abrirModalCargarSucursalesEgresoMultipleExcel(config){
      if (!config) config = {};
      return DialogoCargarSucursalesEgresoMultipleExcel.abrir(config);
    }

    function abrirModalEgresoMultipleAutomatico(config){
      if (!config) config = {};
      return DialogoEgresoMultipleAutomatico.abrir(config);
    }

    function abrirModalFechaIngresoManual(config){
      if (!config) config = {};
      return DialogoFiltroIngresoFechaManual.abrir(config);
    }

    function abrirModalEditarEgreso(config){
      if (!config) config = {};
      return DialogoEditarEgreso.abrir(config);
    }

    function abrirModalSeleccionadosPedido(config){
      if (!config) config = {};
      return DialogoVisualizarSeleccionadosPedido.abrir(config);
    }

    function abrirModalRespuestaInventariablesExcel(config){
      if (!config) config = {};
      return DialogoMostrarRespuestaInventariablesExcel.abrir(config);
    }

    function abrirModalCargarInventariablesExcel(config){
      if (!config) config = {};
      return DialogoCargarInventariablesExcel.abrir(config);
    }

    function abrirModalFiltrosEgreso(config){
      if (!config) config = {};
      return DialogoFiltroEgresos.abrir(config);
    }

    function abrirModalRespuestaTopesExcel(config){
      if (!config) config = {};
      return DialogoRespuestaTopesExcel.abrir(config);
    }

    function abrirModalCargarTopesExcel(config){
      if (!config) config = {};
      return DialogoCargarTopesExcel.abrir(config);
    }

    function abrirVisualizarEgresoPedido(config){
      if (!config) config = {};
      return DialogoVisualizarEgresoPedido.abrir(config);
    }

    function abrirModalConfirmarReclamarPedido(config){
      if (!config) config = {};
      return DialogoConfirmarReclamarPedido.abrir(config);
    }

    function abrirModalAgregarQuitarSuministroPedido(config){
      if (!config) config = {};
      return DialogoAgregarQuitarSuministroEgresoPedido.abrir(config);
    }

    function abrirModalAgregarSuministroPedido(config){
      if (!config) config = {};
      return DialogoAgregarSuministroEgresoPedido.abrir(config);
    }

    function abrirModalRechazarPedido(config){
      if (!config) config = {};
      return DialogoRechazarPedido.abrir(config);
    }

    function abrirModalVisualizarResumenPedido(config){
      if (!config) config = {};
      return DialogoVisualizarResumenPedido.abrir(config);
    }

    function abrirModalPedido(config){
      if (!config) config = {};
      return DialogoVisualizarPedido.abrir(config);
    }


    function abrirModalAgregarDetalleTransferencia(config){
      if (!config) config = {};
      return DialogoAgregarDetalleTransferencia.abrir(config);
    }

    function abrirModalVisualizarTransferencia(config){
      if (!config) config = {};
      return DialogoVisualizarTransferencia.abrir(config);
    }

    function abrirModalAtencionReclamoEgreso(config){
      if (!config) config = {};
      return DialogoAtencionReclamo.abrir(config);
    }

    function abrirVisualizarHistorialReparacion(config){
      if (!config) config = {};
      return DialogoVisualizarHistorialReparacion.abrir(config);
    }

    function abrirModalAgregarDetalleReparacion(config){
      if (!config) config = {};
      return DialogoAgregarDetalleReparacion.abrir(config);
    }

    function abrirModalIngresosRemitoOrden(config){
      if (!config) config = {};
      return DialogoIngresosRemitoOrden.abrir(config);
    }

    function abrirModalFiltroIngresoOrdenCompra(config){
      if (!config) config = {};
      return DialogoFiltroIngresoOrdenCompra.abrir(config);
    }

    function abrirModalElegirTipoSuministro(config){
      if (!config) config = {};
      return DialogoElegirTipoSuministro.abrir(config);
    }

    function abrirModalInformeEgresosEnPreparacion(config){
      if (!config) config = {};
      return DialogoInformeEgresosEnPreparacion.abrir(config);
    }

    function abrirModalEditarMovimiento(config){
      if (!config) config = {};
      return DialogoEditarMovimiento.abrir(config);
    }

    function abrirModalFiltroIngresoRemito(config){
      if (!config) config = {};
      return DialogoFiltroIngresoRemito.abrir(config);
    }

    function abrirModalFiltroIngresoNumeroMovimiento(config){
      if (!config) config = {};
      return DialogoFiltroNumeroMovimiento.abrir(config);
    }

    function abrirModalCambiarUbicacionVariosSuministros(config){
      if (!config) config = {};
      return DialogoCambiarUbicacionVariosSuministros.abrir(config);
    }

    function abrirModalFiltroBusquedaEgresoSuministro(config){
      if (!config) config = {};
      return DialogoFiltroBusquedaEgresoSuministro.abrir(config);
    }

    function abrirModalFiltroBusquedaIngresoSuministro(config){
      if (!config) config = {};
      return DialogoFiltroBusquedaIngresoSuministro.abrir(config);
    }

    function abrirModalEditarProblemasIngreso(config){
      if (!config) config = {};
      return DialogoEditarProblemasIngreso.abrir(config);
    }

    function abrirModalVisualizarIngreso(config){
      if (!config) config = {};
      return DialogoVisualizarIngreso.abrir(config);
    }

    function abrirModalAgregarQuitarSuministroKit(config){
      if (!config) config = {};
      return DialogoAgregarQuitarSuministroEgresoKit.abrir(config);
    }

    function abrirModalAgregarSuministroEgresoKit(config){
      if (!config) config = {};
      return DialogoAgregarSuministroEgresoKit.abrir(config);
    }

    function abrirModalVisualizarKitPrearmado(config){
      if (!config) config = {};
      return DialogoVisualizarKitPrearmado.abrir(config);
    }

    function abrirModalSeleccionTipoSuministroKit(config){
      if (!config) config = {};
      return DialogoSeleccionarTipoSuministroKit.abrir(config);
    }

    function abrirModalAgregarSuministroIngresoConciliacion(config){
      if (!config) config = {};
      return DialogoAgregarSuministroIngresoConciliacion.abrir(config);
    }

    function abrirModalAgregarSuministroEgresoConciliacion(config){
      if (!config) config = {};
      return DialogoAgregarSuministroEgresoConciliacion.abrir(config);
    }

    function abrirModalMostrarSuministrosIngresoExcel(config){
      if (!config) congig = {};
      return DialogoMostrarRespuestaSuministroIngresoExcel.abrir(config);
    }

    function abrirModalAgregarSuministroIngresoExcel(config){
      if (!config) config = {};
      return DialogoAgregarSuministroIngresoExcel.abrir(config);
    }

    function abrirModalCambiarUbicacionSuministro(config){
      if (!config) config = {};
      return DialogoCambiarUbicacionSuministro.abrir(config);
    }

    function abrirModalAgregarSuministroEgresoCajas(config){
      if (!config) config = {};
      return DialogoAgregarSuministroEgresoCajas.abrir(config);
    }

    function abrirModalAgregarQuitarSuministroEgresoSucursal(config){
      if (!config) config = {};
      return DialogoAgregarQuitarSuministroEgresoSucursal.abrir(config);
    }

    function abrirModalVisualizarSuministroAsignado(config){
      if (!config) config = {};
      return DialogoVisualizarSuministrosAsignados.abrir(config);
    }

    function abrirModalSeleccionTipoSuministro(config){
      if (!config) config = {};
      return DialogoSeleccionarTipoSuministro.abrir(config);
    }

    function abrirModalMostrarRespuestaEgresoGuardado(config){
      if (!config) config = {};
      return DialogoMostrarRespuestaEgresoGuardado.abrir(config);
    }

    function abrirModalFotoProblema(config){
      if (!config) config = {};
      return DialogoAgregarFotoProblema.abrir(config);
    }

    function abrirModalVisualizarDespacho(config){
      if (!config) config = {};
      return DialogoVisualizarDespacho.abrir(config);
    }
    function abrirModalCargaPesoCantidadPaqueteEgresos(config){
      if (!config) config = {};
      return DialogoAgregarPesoCantidadPaqueteEgresos.abrir(config);
    }

    function abrirModalVisualizarInformeRecorrido(config){
      if (!config) config = {};
      return DialogoVisualizarInformeRecorrido.abrir(config);
    }

    function abrirModalVisualizarEgreso(config){
      if (!config) config = {};
      return DialogoVisualizarEgreso.abrir(config);
    }

    function abrirModalAgregarSuministroEgreso(config){
      if (!config) config = {};
      return DialogoAgregarSuministroEgreso.abrir(config);
    }
    
    function abrirModalHistorialSuministro(config){
      if (!config) config = {};
      return DialogoFiltroHistorialSuministro.abrir(config);
    }

    function abrirModalMostrarFotoSuministro(config){
      if (!config) config = {};
      return DialogoMostrarFotoSuministro.abrir(config);
    }

    function abrirModalEditarSuministroNoInventariable(config){
      if (!config) config = {};
      return DialogoEditarSuministroNoInventariable.abrir(config);
    }
    function abrirModalSeleccionarFoto(config){
      if (!config) config = {};
      return DialogoSeleccionarFoto.abrir(config);
    }

    function abrirModalEditarSuministro(config){
      if (!config) config = {};
      return DialogoEditarSuministros.abrir(config);
    }

    function abrirModalOcuparUbicacionesCajas(config){
      if (!config) config = {};
      return DialogoOcuparUbicacionesCajas.abrir(config);
    }

    function abrirModalAsignarUbicacionesCajas(config){
      if (!config) config = {};
      return DialogoAsignarUbicacionesCajas.abrir(config);
    }

    function abrirModalAsignarUbicacionIndividualCajas(config){
      if (!config) config = {};
      return DialogoAsignarUbicacionIndividualCajas.abrir(config);
    }

    function abrirModalAgregarPedido(config) {
      if (!config) config = {};
      return DialogoAgregarSuministro.abrir(config);
    }

    function abrirModalFiltroBusquedaIngreso(config){
      if (!config) config = {};
      return DialogoFiltroBusquedaIngreso.abrir(config);
    }

    function abrirModalFiltroBusquedaEgreso(config){
      if (!config) config = {};
      return DialogoFiltroBusquedaEgreso.abrir(config);
    }

    function abrirModalFiltroBusquedaIngresoCajas(config){
      if (!config) config = {};
      return DialogoFiltroBusquedaIngresoCajas.abrir(config);
    }

    function abrirModalAgregarSuministroIngreso(config) {
      if (!config) config = {};
      return DialogoAgregarSuministroIngreso.abrir(config);
    }

    function abrirModalAsignarUbicaciones(config) {
      if (!config) config = {};
      return DialogoAsignarUbicaciones.abrir(config);
    }

    function abrirModalCambioPassword(config) {
      if (!config) config = {};
      return DialogoCambioPassword.abrir(config);
    }

    function abrirModalAsignarUbicacionIndividual(config){
      if (!config) config = {};
      return DialogoAsignarUbicacionIndividual.abrir(config);
    }

    function abrirModalSuministroUbicaciones(config){
      if (!config) config = {};
      return DialogoMostrarSuministroUbicaciones.abrir(config);
    }
  }
})();

(function(){
'use strict';

angular.module('proyecto-az-suministro')
.factory('Usuario', function ($resource, URL_SERVIDOR) {
  return $resource(URL_SERVIDOR + "/login/:id", {id:"@id"},{
    obtenerUsuario: {
      url: URL_SERVIDOR + '/login/actual',
      method: 'GET'
    }
  });
});
})();
(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .service('ServicioDialogos', ServicioDialogos);

  function ServicioDialogos($uibModal, $uibModalStack) {
    var vm = this;
    vm.mostrarDialogoExito = mostrarDialogoExito;
    vm.mostrarDialogoExitoNoCerrar = mostrarDialogoExitoNoCerrar;
    vm.mostrarDialogoError = mostrarDialogoError;
    vm.mostrarDialogoConfirmacionWarning = mostrarDialogoConfirmacionWarning;
    vm.mostrarDialogoConfirmacionInfo = mostrarDialogoConfirmacionInfo;
    vm.mostrarDialogoAtencion = mostrarDialogoAtencion;
    vm.mostrarDialogoInformacion = mostrarDialogoInformacion;
    vm.mostrarDialogoGuardadoExito = mostrarDialogoGuardadoExito;
    vm.abrirDialogoCargando = abrirDialogoCargando;
    vm.cerrarDialogoCargando = cerrarDialogoCargando;
    vm.mostrarDialogoInformacionConFuncion = mostrarDialogoInformacionConFuncion;
    vm.mostrarDialogoInformacionConHtml = mostrarDialogoInformacionConHtml;

    vm.cerrarTodosLosDialogos = cerrarTodosLosDialogos;

    var respuesta = null;

    function cerrarTodosLosDialogos(){
      $uibModalStack.dismissAll();
    }

    function abrirDialogoCargando() {
        respuesta = $uibModal.open({
          backdrop : 'static',
          keyboard: false,
          size: 'sm',
          windowClass : 'modal-cargando',
          templateUrl: 'app/components/dialogos/dialogo-cargando.html',
          controllerAs: 'vm',
          controller: function() {
              var vm = this;
          }
        });
    }

    function cerrarDialogoCargando(funcion){
      respuesta.close(function(){
        console.log("entré");
        funcion();
      });
    }

    function mostrarDialogoExito(titulo, cuerpo, funcionSi) {
      var tituloExito = titulo ? titulo : 'Éxito';
      var cuerpoExito = cuerpo ? cuerpo : 'Operación exitosa';
      if (!funcionSi) {
        funcionSi = function() {};
      }
      var config = {
        confirmButtonColor: "#1ec923",
        confirmButtonText: "Aceptar",
        title: tituloExito,
        text: cuerpoExito,
        type: "success"
      };
      var previousWindowKeyDown = window.onkeydown;
      return swal(config, function(isConfirm) {
        window.onkeydown = previousWindowKeyDown;
        window.onfocus = null;
        if (isConfirm) {
          funcionSi();
        }
      });
    }

    function mostrarDialogoGuardadoExito(titulo, cuerpo, funcionSi) {
      var tituloExito = titulo ? titulo : 'Éxito';
      var cuerpoExito = cuerpo ? cuerpo : 'Operación exitosa';
      var config = {
        title: tituloExito,
        text: cuerpoExito,
        type: "success",
        showCancelButton: false,
        confirmButtonColor: "#1ec923",
        confirmButtonText: "Aceptar",
        closeOnConfirm: true
      };
      var previousWindowKeyDown = window.onkeydown;
      return swal(config, function(isConfirm) {
        window.onkeydown = previousWindowKeyDown;
        window.onfocus = null;
        if (isConfirm) {
          funcionSi();
        }
      });
    }

    function mostrarDialogoInformacion(titulo, cuerpo) {
      var tituloExito = titulo ? titulo : 'Atención';
      var cuerpoExito = cuerpo ? cuerpo : 'Información';
      var config = {
        confirmButtonColor: "#9cbbed",
        confirmButtonText: "Aceptar",
        title: tituloExito,
        text: cuerpoExito,
        type: "info"
      };
      return swal(config);
    }

    function mostrarDialogoInformacionConHtml(titulo, cuerpo) {
      var tituloExito = titulo ? titulo : 'Atención';
      var cuerpoExito = cuerpo ? cuerpo : 'Información';
      var config = {
        confirmButtonColor: "#9cbbed",
        confirmButtonText: "Aceptar",
        title: null,
        text: cuerpoExito,
        html: true,
      };
      return swal(config);
    }

    function mostrarDialogoInformacionConFuncion(titulo, cuerpo, funcionSi) {
      var tituloExito = titulo ? titulo : 'Atención';
      var cuerpoExito = cuerpo ? cuerpo : 'Información';
      if (!funcionSi) {
        funcionSi = function() {};
      }
      var config = {
        confirmButtonColor: "#9cbbed",
        confirmButtonText: "Aceptar",
        title: tituloExito,
        text: cuerpoExito,
        type: "info",
        closeOnConfirm: true
      };
      var previousWindowKeyDown = window.onkeydown;
      return swal(config, function(isConfirm) {
        window.onkeydown = previousWindowKeyDown;
        window.onfocus = null;
        if (isConfirm) {
          funcionSi();
        }
      });
    }

    function mostrarDialogoError(titulo, cuerpo) {
      var tituloExito = titulo ? titulo : 'Error';
      var cuerpoExito = cuerpo ? cuerpo : 'No se pudo realizar la solicitud';
      var config = {
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Aceptar",
        title: tituloExito,
        text: cuerpoExito,
        type: "error"
      };
      return swal(config);
    }

    function mostrarDialogoAtencion(titulo, cuerpo) {
      var tituloExito = titulo ? titulo : 'Atención';
      var cuerpoExito = cuerpo ? cuerpo : 'Proceda con precaución';
      var config = {
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Aceptar",
        title: tituloExito,
        text: cuerpoExito,
        type: "info"
      };
      return swal(config);
    }

    function mostrarDialogoExitoNoCerrar(titulo, cuerpo, funcionSi) {
      var tituloExito = titulo ? titulo : 'Éxito';
      var cuerpoExito = cuerpo ? cuerpo : 'Operación exitosa';
      if (!funcionSi) {
        funcionSi = function() {};
      }
      var config = {
        confirmButtonColor: "#1ec923",
        confirmButtonText: "Aceptar",
        title: tituloExito,
        text: cuerpoExito,
        type: "success",
        closeOnConfirm: false,
        showLoaderOnConfirm: false
      };
      var previousWindowKeyDown = window.onkeydown;
      return swal(config, function(isConfirm) {
        window.onkeydown = previousWindowKeyDown;
        window.onfocus = null;
        if (isConfirm) {
          funcionSi();
        }
      });
    }

    function mostrarDialogoConfirmacionWarning(titulo, cuerpo, funcionSi, funcionNo, cerrar) {
      mostrarDialogoConfirmacion(titulo, cuerpo, funcionSi, funcionNo, cerrar, false);
    }

    function mostrarDialogoConfirmacionInfo(titulo, cuerpo, funcionSi, funcionNo, cerrar, textoSi, textoNo) {
      mostrarDialogoConfirmacion(titulo, cuerpo, funcionSi, funcionNo, cerrar, true, textoSi, textoNo);
    }

    function mostrarDialogoConfirmacion(titulo, cuerpo, funcionSi, funcionNo, cerrar, esInfo, textoSi, textoNo) {
      var cerrarDialogo = cerrar;
      var textoAceptar = textoSi ? textoSi : "Si, estoy seguro.";
      var textoCancelar = textoNo ? textoNo : "No";
      var tipo = "warning";
      var color = "#f8bb86";
      var tituloExito = titulo ? titulo : 'Atención';
      var cuerpoExito = cuerpo ? cuerpo : '¿Está seguro que quiere realizar esta operación?';
      if (!funcionSi) {
        funcionSi = function() {};
      }
      if (!funcionNo) {
        funcionNo = function() {};
      }
      if (esInfo) {
        tipo = "info";
        color = "#9cbbed";
      }
      var config = {
        title: tituloExito,
        text: cuerpoExito,
        type: tipo,
        showCancelButton: true,
        confirmButtonColor: color,
        confirmButtonText: textoAceptar,
        cancelButtonText: textoCancelar,
        closeOnConfirm: cerrarDialogo,
        showLoaderOnConfirm: !cerrarDialogo,
        closeOnCancel: true
      };
      var previousWindowKeyDown = window.onkeydown;
      return swal(config, function(isConfirm) {
        window.onkeydown = previousWindowKeyDown;
        window.onfocus = null;
        if (isConfirm) {
          funcionSi();
        } else {
          funcionNo();
        }
      });
    }

  }
})();

(function () {
  'use strict';

  angular
  .module('proyecto-az-suministro')
  .service('HeaderBarService', HeaderBarService);

  function HeaderBarService($rootScope) {
    var vm = this;
    $rootScope.titulo = 'Título';
    $rootScope.subtitulo = 'Subtítulo';
    $rootScope.cantidadReclamos = 0;
    $rootScope.cantidadPedidos = 0;
    vm.getTitulo = getTitulo;
    vm.setTitulo = setTitulo;
    vm.getSubTitulo = getSubTitulo;
    vm.setSubTitulo = setSubTitulo;
    vm.setCantidadReclamo = setCantidadReclamo;
    vm.getCantidadReclamo = getCantidadReclamo;
    vm.setCantidadPedido = setCantidadPedido;
    vm.getCantidadPedido = getCantidadPedido;
    vm.getRolUsuario = getRolUsuario;

    function getRolUsuario(){
      return $rootScope.rolUsuario;
    }

    function getCantidadPedido(){
      return $rootScope.cantidadPedidos;
    }

    function setCantidadPedido(cant){
      $rootScope.cantidadPedidos = cant;
    }

    function getCantidadReclamo(){
      return $rootScope.cantidadReclamos;
    }

    function setCantidadReclamo(cant){
      $rootScope.cantidadReclamos = cant;
    }

    function getTitulo() {
      return $rootScope.titulo;
    }

    function setTitulo(t) {
      $rootScope.titulo = t;
    }

    function getSubTitulo() {
      return $rootScope.subtitulo;
    }

    function setSubTitulo(st) {
      $rootScope.subtitulo = st;
    }
  }
})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').directive('headerBar', headerBar);

  function headerBar() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/header-bar/header-bar.html',
      replace : true,
      controller: 'HeaderBarCtrl as header',
      bindToController:true
    };
  }

})();

(function() {
  'use strict';

  angular.module('proyecto-az-suministro').controller('HeaderBarCtrl', HeaderBarCtrl);

  function HeaderBarCtrl($rootScope, HeaderBarService, $state, AlmacenUsuariosJWT, $timeout, ServicioDialogos) {
    var header = this;
    header.titulo = HeaderBarService.getTitulo();
    header.subtitulo = HeaderBarService.getSubTitulo();
    header.cantidadReclamos = HeaderBarService.getCantidadReclamo();
    header.cantidadPedidos = HeaderBarService.getCantidadPedido();
    header.rol = HeaderBarService.getRolUsuario();

	header.usuario = {
		nombre: AlmacenUsuariosJWT.getUsuario()
	};

	header.cerrarSesion = cerrarSesion;
	header.renovarPassword = renovarPassword;
	header.irAReclamos = irAReclamos;
	header.irAPedidos = irAPedidos;


    $rootScope.$on('cantidadReclamos', function(event, cantidadReclamo){
      header.cantidadReclamos = cantidadReclamo.cantidad;
    });

    $rootScope.$on('cantidadPedidos', function(event, cantidadPedido){
      header.cantidadPedidos = cantidadPedido.cantidad;
    });

    $rootScope.$on('rolUsuario', function(event, rolUsuario){
      header.rol = rolUsuario.rolUsuario;
    });
    

	function irAReclamos(){
		$state.go('home.lista-reclamos');
	}

	function irAPedidos(){
		$state.go('home.lista-pedidos');
	}

	function renovarPassword(){
		$state.go('home.renovar-password');
	}

	function cerrarSesion(){
		AlmacenUsuariosJWT.limpiar();
		$state.go('login');
	}


  }

})();

(function() {
	'use strict';

	angular.module('proyecto-az-suministro').config(estado);

	function estado($stateProvider) {
		$stateProvider.state('login', {
			url: '/login',
			templateUrl: 'app/app/login/login.html',
			controller: 'LoginCtrl as vm',
			resolve: {
				mensaje: function($q, $timeout, ServicioDialogos, AutenticacionJWT) {
					return $timeout(function() {
						if (!AutenticacionJWT.getAutenticacion()) {
								ServicioDialogos.cerrarTodosLosDialogos();
								return {mensaje: 'El usuario no está logueado', 'estado' : 'No logueado'};
						} else {
							ServicioDialogos.cerrarTodosLosDialogos();
							return $q.reject({mensaje: 'El usuario ya está logueado', 'estado' : 'Ya logueado'});
						}
					}, 500);
				}
			}
		});
	}

})();
(function() {
'use strict';
angular.module('proyecto-az-suministro')
    .controller('LoginCtrl', function ($state, focus, $http, URL_SERVIDOR, ServicioDialogos, AutenticacionJWT) {
        var vm = this;
        vm.iniciarSesion = iniciarSesion;
        vm.login = {
            nombreUsuario: null,
            password: null
        };
        vm.nombreBoton="Ingresar";
        focus('nombreUsuario');
        ServicioDialogos.cerrarDialogoCargando();

        function iniciarSesion () {
            vm.nombreBoton="Ingresando...";
            AutenticacionJWT.login(vm.login.nombreUsuario,vm.login.password,vm.login.recordar).then(function (data){
                $state.go('home.home');
            }, function (error) {
                vm.nombreBoton="Ingresar";
                ServicioDialogos.mostrarDialogoError("Atención",'El usuario y/o la contraseña no son correctos');
            });

        }


    });
})();
(function() {
  'use strict';

  angular.module('proyecto-az-suministro').config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home', {
        url: '/',
        templateUrl: 'app/app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main',
        resolve: {
          rol: function(Usuario, $timeout, $state, AlmacenUsuariosJWT, ServicioDialogos){
            return $timeout(function() {
              return Usuario.obtenerUsuario().$promise.then(function(usuario){
                return usuario.rol;
              }, function(err){
                ServicioDialogos.cerrarDialogoCargando();
                AlmacenUsuariosJWT.limpiar();
                $state.go('login');
                ServicioDialogos.cerrarDialogoCargando();
              });
            }, 1000);
          }
        }
      });
  }
})();

(function() {
'use strict';
angular.module('proyecto-az-suministro')
  .factory('Conexion', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR + "/categoriapeso", {});
  });
})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController(HeaderBarService, $stateParams) {
    var main = this;



  }
})();

(function() {
	'use strict';

	angular.module('proyecto-az-suministro').config(estado);

	function estado($stateProvider) {
		$stateProvider.state('aviso-despacho', {
			url: '/notificar/:movimiento/:mail',
			templateUrl: 'app/app/aviso-despacho/aviso-despacho.html',
			controller: 'AvisoDespachoCtrl as vm',
			resolve: {
				confirmacion: function($stateParams, AvisoDespacho) {
					return AvisoDespacho.get({movimiento:$stateParams.movimiento, mail:$stateParams.mail}).$promise.then(function(data) {
						return data;
					});
				}
			}
		});
	}

})();
'use strict';
angular.module('proyecto-az-suministro')
  .factory('AvisoDespacho', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/notificar?m=:movimiento&&ma=:mail", {movimiento:"@movimiento", id:"@id"});
  })
  .factory('ConfirmarRecepcionEgreso', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/notificar/confirmar-recepcion/:id", {id:"@id"});
  })
  .factory('ReclamoEgreso', function ($resource, URL_SERVIDOR) {
      return $resource(URL_SERVIDOR+"/notificar/reclamar/:id", {id:"@id"});
  });

(function() {
'use strict';
angular.module('proyecto-az-suministro')
    .controller('AvisoDespachoCtrl', AvisoDespachoCtrl);

  /** @ngInject */
  function AvisoDespachoCtrl(confirmacion, ConfirmarRecepcionEgreso, ReclamoEgreso, ServicioDialogos) {
        var vm = this;
        vm.confirmar = confirmar;
        vm.reclamar = reclamar;

        inicializar();

        function inicializar(){
            vm.moduloReclamo = false;
            vm.numeroMovimiento = confirmacion.numeroMovimiento;
            if (confirmacion.codigo==1){
                vm.mostrar = true;
                vm.aviso = false;
            } else if (confirmacion.codigo==2){
                vm.mostrar = false;
                vm.aviso = true;
                vm.fechaConfirmacion = confirmacion.fechaConfirmacion;
            } else if (confirmacion.codigo==4){
                vm.mostrar = false;
                vm.aviso = true;
                if (confirmacion.mensajeReclamo){
                    vm.reclamo = true;
                    vm.fechaConfirmacion = confirmacion.fechaConfirmacion;
                    vm.atencionReclamo = confirmacion.atencionReclamo;
                    vm.fechaAtencionReclamo = confirmacion.fechaAtencionReclamo;
                    vm.encargadoSucursal = confirmacion.encargadoSucursal;
                    vm.mensajeReclamo = confirmacion.mensajeReclamo;
                } else {
                    vm.reclamo = false;
                    vm.fechaConfirmacion = confirmacion.fechaConfirmacion;
                }
            } else if (confirmacion.codigo==10){
                vm.mostrar = false;
                vm.aviso = false;
                vm.expirado = true;
            } else {
                vm.mostrar = false;
                vm.aviso = false;
            }
        }

        function obtenerMovimiento(){
            var movimiento = {
                id : confirmacion.idMovimiento,
                mailDestinatarioConfirmacion : confirmacion.mailDestinatario,
                mailIngresadoConfirmacion : vm.mailConfirmacion,
                fechaConfirmacion : new Date(),
                nombreConfirmacion : vm.nombreConfirmacion
            };
            return movimiento;
        }

        function obtenerMovimientoReclamo(){
            var movimiento = {
                id : confirmacion.idMovimiento,
                mailDestinatarioConfirmacion : confirmacion.mailDestinatario,
                mailIngresadoConfirmacion : vm.mailConfirmacion,
                fechaConfirmacion : new Date(),
                nombreConfirmacion : vm.nombreConfirmacion,
                descripcionReclamo : vm.descripcionReclamo
            };
            return movimiento;
        }

        function reclamar(){
            ServicioDialogos.abrirDialogoCargando();
            ReclamoEgreso.update(obtenerMovimientoReclamo(), function(data){
                ServicioDialogos.cerrarDialogoCargando();
                window.location.reload();
            }, function(err){
                ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar el reclamo");
                ServicioDialogos.cerrarDialogoCargando();
            });

        }

        function confirmar(){
            ServicioDialogos.abrirDialogoCargando();
            ConfirmarRecepcionEgreso.update(obtenerMovimiento(), function(data){
                ServicioDialogos.cerrarDialogoCargando();
                window.location.reload();
            }, function(err){
                ServicioDialogos.mostrarDialogoError(null, "No se ha podido registrar la recepción");
                ServicioDialogos.cerrarDialogoCargando();
            });
        }


  }
})();
(function(){
  'use strict';

  angular.module('proyecto-az-suministro').run(run);

  function run($rootScope,$state,ServicioDialogos, Usuario, AlmacenUsuariosJWT, $timeout, CantidadPedidosDeposito, CantidadReclamosDeposito, HeaderBarService, CantidadReclamos) {
    $rootScope.$on('$stateChangeStart',function(event,toState,toStateParams,fromState){
      ServicioDialogos.abrirDialogoCargando();
      if (AlmacenUsuariosJWT.getAutenticacion()){
        Usuario.obtenerUsuario().$promise.then(function(usuario){
          $rootScope.$broadcast('rolUsuario', {
            rolUsuario : usuario.rol
          });
          if (usuario.rol.id<=3){
            var deposito = usuario.empleado.deposito;
            if (deposito){
              CantidadReclamosDeposito.get({'idDeposito':deposito.id}).$promise.then(function(data){
                CantidadPedidosDeposito.get({'idDeposito':deposito.id, 'idEstado':1}).$promise.then(function(pedidos){
                  $rootScope.$broadcast('cantidadPedidos', {
                    cantidad : pedidos.cantidad
                  });
                  $rootScope.$broadcast('cantidadReclamos', {
                    cantidad : data.cantidad
                  });
                }, function(error){
                  console.log();
                });
              }, function(error){
                console.log();
              });
            } else {
              CantidadReclamos.get({}).$promise.then(function(data){
                $rootScope.$broadcast('cantidadReclamos', {
                  cantidad : data.cantidad
                });
              }, function(error){
                console.log();
              });
            }
          }
        }, function(error){
          //console.log(error);
          ServicioDialogos.cerrarDialogoCargando();
          AlmacenUsuariosJWT.limpiar();
          ServicioDialogos.cerrarDialogoCargando();
        });
      }
    });

    $rootScope.$on('$stateChangeSuccess',function(event,toState, toStateParams,fromState){
      ServicioDialogos.cerrarDialogoCargando();
    });

    $rootScope.$on('$stateChangeError',function(event,toState,toStateParams,fromState,fromStateParams,error){
      if (error && error.status === 401) {
        event.preventDefault();
        ServicioDialogos.cerrarDialogoCargando();
        AlmacenUsuariosJWT.limpiar();
        $state.go('login');
        ServicioDialogos.cerrarDialogoCargando();
      } else if (error && error.estado === 'Ya logueado') {
        event.preventDefault();
        ServicioDialogos.cerrarDialogoCargando();
        $state.go('home.home');
        ServicioDialogos.cerrarDialogoCargando();
      } else {
        console.error(error);
        ServicioDialogos.cerrarDialogoCargando();
        ServicioDialogos.mostrarDialogoError(null,'No se puede conectar con el servidor');
      }
    });
  }

})();

(function() {

  'use strict';

  //angular.module('proyecto-az-suministro').value('URL_SERVIDOR', 'http://131.255.6.47:8088'); //SERVER BAE
  angular.module('proyecto-az-suministro').value('URL_SERVIDOR', 'https://suministros.azarchivos.com.ar/backend'); //SERVER BAE
  //angular.module('proyecto-az-suministro').value('URL_SERVIDOR', 'https://suministros.azarchivos.com.ar:8088'); //SERVER BAE
  //angular.module('proyecto-az-suministro').value('URL_SERVIDOR', 'http://localhost:8080'); //LOCAL
})();

(function(){
	'use strict';

	angular.module('proyecto-az-suministro')
	.run(runAutenticacion);
	//.run(runStateChangeEnd);


	function runAutenticacion($http, AlmacenUsuariosJWT) {
		$http.defaults.headers.common['Authorization'] = AlmacenUsuariosJWT.getAutenticacion;
	}

/*	function runStateChangeEnd($rootScope) {
		$rootScope.$on('$stateChangeSuccess',function(event, toState) {
			//console.log(toState);
		});
	}*/

})();

(function(){
	'use strict';

	angular.module('proyecto-az-suministro')
	.config(configResource)
	.config(configRouter)
	.config(configStorage);


	function configResource($resourceProvider) {
		angular.extend($resourceProvider.defaults.actions, {
			update: {
				method: 'PUT'
			}
		});
	}

	function configRouter($urlRouterProvider) {
		$urlRouterProvider.otherwise('/home');
	}

	function configStorage($localStorageProvider,$sessionStorageProvider) {
		$localStorageProvider.setKeyPrefix('aZSuministro.');
		$sessionStorageProvider.setKeyPrefix('aZSuministro.');
	}

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {
    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise('/home');
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .constant('malarkey', malarkey)
    .constant('moment', moment);
    //.value('URL_SERVIDOR', "http://localhost:8080");

})();

(function() {
  'use strict';

  angular
    .module('proyecto-az-suministro')
    .config(config);

  /** @ngInject */
  function config($resourceProvider, $httpProvider) {
    //$httpProvider.defaults.headers.common.Authorization = 'Basic dXNlcjpjb250cmFzZcOxYQ==';
    //$httpProvider.defaults.timeout = 60000;

    angular.extend($resourceProvider.defaults.actions, {
      update: {
        method: 'PUT'
      }
    });
  }

})();

angular.module("proyecto-az-suministro").run(["$templateCache", function($templateCache) {$templateCache.put("app/app/aviso-despacho/aviso-despacho.html","<div class=\"row col-lg-12\" style=\"background: url(app/imagenes/imagenes-login/imagen-login-large.jpg); \r\n  background-repeat: no-repeat;\r\n  background-position: center center;\r\n  background-size: cover;\r\n  background-color: #7C0700;\r\n  background-attachment: fixed;\r\n  width: 100%;\r\n  min-height: 100%;\r\n  height: auto;\r\n  position: fixed;\r\n  top:0; \r\n  left:0\"><br><br><div class=\"well well-lg col-md-10 col-md-offset-1\" style=position:fixed><div class=col-lg-12><div style=\"float: left\"><img src=app/imagenes/imagenes-login/logo-az.png alt=\"Sustituye animación\"></div><div style=\"float: right\"><h3><b>Módulo de gestión de confirmación y reclamo</b></h3></div></div><br><br><br><hr><div ng-if=vm.numeroMovimiento><label><b>N° Movimiento: {{vm.numeroMovimiento}}</b></label></div><div ng-if=vm.mostrar><div><uib-tabset active=activeJustified justified=true><uib-tab index=0 disable=!vm.moduloReclamo ng-click=\"vm.moduloReclamo = false\"><uib-tab-heading>Confirmación <i ng-class=\"{\'fa-chevron-right\': vm.moduloReclamo, \'fa-chevron-down\':!vm.moduloReclamo}\" class=\"fa pull-right\"></i></uib-tab-heading><div class=\"panel panel-default\" style=padding:20px><div uib-alert type=info><i class=\"fa fa-info-circle\"></i> &nbsp; Confirme la recepción en caso que lo solicitado coincida correctamente con lo recibido.</div><div><form name=formulario><div class=form-group><div class=\"form-group col-md-6\"><label>Nombre y apellido:</label><input class=form-control type=text placeholder=\"Nombre y apellido de quién confirma la recepción\" ng-model=vm.nombreConfirmacion required name=nombreConfirmacion ng-minlength=5> <span uib-alert class=danger ng-show=\"formulario.nombreConfirmacion.$error.required && formulario.nombreConfirmacion.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"formulario.nombreConfirmacion.$error.minlength && formulario.nombreConfirmacion.$dirty\">Este campo debe tener al menos 5 caracteres.</span></div><div class=\"form-group col-md-6\"><label>Email:</label><input class=form-control type=text placeholder=\"Ingrese el email de quién confirma la recepción\" ng-pattern=/[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$/ ng-model=vm.mailConfirmacion ng-minlength=5 required name=mailConfirmacion> <span uib-alert ng-show=\"formulario.mailConfirmacion.$error.required && formulario.mailConfirmacion.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"formulario.mailConfirmacion.$error.minlength && formulario.mailConfirmacion.$dirty\">Este campo debe tener al menos 5 caracteres. </span><span uib-alert class=danger ng-if=\"formulario.mailConfirmacion.$error.pattern && formulario.mailConfirmacion.$dirty\">Ingrese un mail válido.</span></div></div><br><center><button class=\"center-block btn btn-primary\" ng-disabled=formulario.$invalid ng-click=vm.confirmar();><i class=\"fa fa-check\"></i> Confirmar</button></center></form></div></div></uib-tab><uib-tab index=1 disable=vm.moduloReclamo ng-click=\"vm.moduloReclamo = true\"><uib-tab-heading>Reclamo <i ng-class=\"{\'fa-chevron-right\': !vm.moduloReclamo, \'fa-chevron-down\':vm.moduloReclamo}\" class=\"fa pull-right\"></i></uib-tab-heading><div class=\"panel panel-default\" style=padding:20px><div uib-alert><i class=\"fa fa-info-circle\"></i> Efectúe un reclamo sólo cuando la cantidad de paquetes que llegaron a su sucursal, coincide con la indicada en el mail que informa el despacho, pero los suministros entregados no coinciden con el remito.<br>Si falta algún paquete completo, por favor efectúe un reclamo en la empresa de logística encargada del despacho</div><div><form name=formularioReclamo><div class=form-group><div class=\"form-group col-md-3\"><label>Nombre y apellido:</label><input class=form-control type=text placeholder=\"Nombre y apellido de quién efectúa el reclamo\" ng-model=vm.nombreConfirmacion required name=nombreConfirmacion ng-minlength=5> <span uib-alert class=danger ng-show=\"formularioReclamo.nombreConfirmacion.$error.required && formularioReclamo.nombreConfirmacion.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"formularioReclamo.nombreConfirmacion.$error.minlength && formularioReclamo.nombreConfirmacion.$dirty\">Este campo debe tener al menos 5 caracteres.</span></div><div class=\"form-group col-md-3\"><label>Email:</label><input class=form-control type=text placeholder=\"Ingrese el email de quién efectúa el reclamo\" ng-pattern=/[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$/ ng-model=vm.mailConfirmacion ng-minlength=5 required name=mailConfirmacion> <span uib-alert ng-show=\"formularioReclamo.mailConfirmacion.$error.required && formularioReclamo.mailConfirmacion.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"formularioReclamo.mailConfirmacion.$error.minlength && formularioReclamo.mailConfirmacion.$dirty\">Este campo debe tener al menos 5 caracteres. </span><span uib-alert class=danger ng-if=\"formularioReclamo.mailConfirmacion.$error.pattern && formularioReclamo.mailConfirmacion.$dirty\">Ingrese un mail válido.</span></div><div class=\"form-group col-md-6\"><label>Descripción del reclamo:</label><textarea class=form-control type=text style=resize:vertical placeholder=\"Describa el reclamo\" ng-model=vm.descripcionReclamo ng-minlength=5 ng-maxlength=300 required name=descripcionReclamo></textarea><span uib-alert ng-show=\"formularioReclamo.descripcionReclamo.$error.required && formularioReclamo.descripcionReclamo.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"formularioReclamo.descripcionReclamo.$error.minlength && formularioReclamo.descripcionReclamo.$dirty\">Este campo debe tener al menos 5 caracteres. </span><span uib-alert class=danger ng-if=\"formularioReclamo.descripcionReclamo.$error.maxlength && formularioReclamo.descripcionReclamo.$dirty\">Este campo no puede superar los 300 caracteres.</span></div></div><br><center><button class=\"center-block btn btn-warning\" ng-disabled=formularioReclamo.$invalid ng-click=vm.reclamar();><i class=\"fa fa-check\"></i> &nbsp;Efectuar reclamo</button></center></form></div></div></uib-tab></uib-tabset></div></div><div class=\"container row col-md-12\" ng-if=\"!vm.mostrar && vm.aviso\"><div uib-alert type=info ng-if=!vm.reclamo><i class=\"fa fa-info-circle 5x\"></i> Se confirmó la recepción con éxito.<br>Fecha: {{vm.fechaConfirmacion | date:\"dd/MM/yyyy HH:mm\"}}</div><div ng-if=vm.reclamo><div uib-alert><i class=\"fa fa-info-circle 5x\"></i> Reclamo:<br>Fecha: {{vm.fechaConfirmacion | date:\"dd/MM/yyyy HH:mm\"}}<br>Reclamó: {{vm.encargadoSucursal}}<br>{{vm.mensajeReclamo}}</div><div uib-alert type=info ng-if=vm.atencionReclamo><i class=\"fa fa-info-circle 5x\"></i> Respuesta al reclamo:<br>Fecha: {{vm.fechaAtencionReclamo | date:\"dd/MM/yyyy HH:mm\"}}<br>{{vm.atencionReclamo}}</div><div uib-alert type=danger ng-if=!vm.atencionReclamo>Aún no se ha respondido el reclamo</div></div></div><div class=\"container row col-md-12\" ng-if=\"!vm.mostrar && !vm.aviso\"><div uib-alert ng-if=!vm.expirado><i class=\"fa fa-remove 5x\"></i> No se puede encontrar el despacho.</div><div uib-alert ng-if=vm.expirado><i class=\"fa fa-times-circle-o\"></i> Ha expirado el tiempo para poder confirmar o reclamar el despacho</div></div><br></div></div>");
$templateCache.put("app/app/login/login.html","<div class=\"row col-lg-12\" style=\"background: url(app/imagenes/imagenes-login/imagen-login-large.jpg); \r\n  background-repeat: no-repeat;\r\n  background-position: center center;\r\n  background-size: cover;\r\n  background-color: #7C0700;\r\n  background-attachment: fixed;\r\n  width: 100%;\r\n  min-height: 100%;\r\n  height: auto;\r\n  position: fixed;\r\n  top:0; \r\n  left:0\"><br><br><br><br><div class=\"well well-md col-md-6 col-md-offset-3\" style=position:auto><div><center><img src=app/imagenes/imagenes-login/logo-az.png alt=\"Sustituye animación\"></center><br><br></div><form name=formulario><div class=\"container row col-md-12\"><div class=form-group><div class=\"form-group col-md-12\"><label>Usuario:</label><input class=form-control ng-disabled=\"vm.nombreBoton==\'Ingresando...\'\" focus-on=nombreUsuario type=text pattern=\"^[a-zA-Z- -ñ-´]*$\" placeholder=Usuario ng-model=vm.login.nombreUsuario required> <span uib-alert class=danger ng-show=\"formulario.marca.$error.required && formulario.$pristine\">Este campo es requerido.</span></div><div class=\"form-group col-md-12\"><label>Contraseña:</label><input class=form-control type=password placeholder=Contraseña ng-model=vm.login.password ng-minlength=5 required name=password ng-disabled=\"vm.nombreBoton==\'Ingresando...\'\"> <span uib-alert class=danger ng-show=\"formulario.password.$error.required && formulario.$valid\">Este campo es requerido.</span></div><div class=\"checkbox form-group col-md-12\"><label><input type=checkbox ng-model=vm.login.recordar ng-disabled=\"vm.nombreBoton==\'Ingresando...\'\"> Recordar Usuario</label></div></div></div></form><br><br><center><button class=\"center-block btn btn-primary\" ng-disabled=\"formulario.$invalid || vm.nombreBoton==\'Ingresando...\'\" ng-click=vm.iniciarSesion();><i ng-if=\"vm.nombreBoton==\'Ingresar\'\" class=\"fa fa-sign-in\"></i><div ng-if=\"vm.nombreBoton==\'Ingresando...\'\" class=spinner><div class=double-bounce1></div><div class=double-bounce2></div></div>&nbsp;{{vm.nombreBoton}}</button></center><br></div></div>");
$templateCache.put("app/app/main/main.html","<div id=page-wrapper ng-class=\"{\'open\': toggle}\" ng-cloak><!-- Sidebar --><side-bar></side-bar><div id=content-wrapper><div class=page-content><!-- Header Bar --><header-bar></header-bar><!-- End Header Bar --><!-- Main Content --><div ui-view></div></div><!-- End Page Content --></div><!-- End Content Wrapper --></div><!-- End Page Wrapper -->");
$templateCache.put("app/components/dialogos/dialogo-cargando.html","<div class=modal-header><center><h3 class=modal-title>Cargando</h3></center></div><center><div class=modal-body>Por favor, aguarde un momento<div class=spinner><div class=double-bounce1></div><div class=double-bounce2></div></div></div></center>");
$templateCache.put("app/components/header-bar/header-bar.html","<div class=\"row header\"><div class=\"col-xs-12 cuerpo-header\"><div class=\"user pull-right\"><div class=\"item dropdown\" uib-dropdown><a href=# class=dropdown-toggle uib-dropdown-toggle><img src=app/imagenes/imagenes-header/contacto.png></a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=dropdown-header><i class=\"icon fa fa-user\"></i> {{header.usuario.nombre}}</li><li class=divider></li><li class=link><a class=btn ng-click=header.renovarPassword();><i class=\"fa fa-refresh\"></i> Renovar Password</a></li><li class=divider></li><li class=link><a class=btn ng-click=header.cerrarSesion()><i class=\"fa fa-sign-out\"></i> Cerrar sesión</a></li></ul></div><div class=\"item dropdown\" uib-dropdown ng-if=\"header.rol.id<=3\"><a href=# class=dropdown-toggle uib-dropdown-toggle><i class=\"fa fa-bell-o\"></i><span class=\"badge badge-warning\"><span ng-if=\"header.cantidadReclamos>0\" class=\"fa fa-exclamation fa-xs\"></span></span></a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=dropdown-header><b>Reclamos</b></li><li class=divider></li><li><a class=btn ng-click=header.irAReclamos()><div ng-if=\"header.cantidadReclamos==0\">No hay reclamos sin atender</div><div ng-if=\"header.cantidadReclamos>0\">Hay {{header.cantidadReclamos>0? header.cantidadReclamos : \"0\"}} {{header.cantidadReclamos==1? \"reclamo\" : \"reclamos\"}} sin atender</div></a></li></ul></div><div class=\"item dropdown\" uib-dropdown ng-if=\"header.rol.id<=3\"><a href=# class=dropdown-toggle uib-dropdown-toggle><i class=\"fa fa-list-alt\"></i><span class=\"badge badge-warning\"><span ng-if=\"header.cantidadPedidos>0\" class=\"fa fa-exclamation fa-xs\"></span></span></a><ul class=\"dropdown-menu dropdown-menu-right\"><li class=dropdown-header><b>Pedidos</b></li><li class=divider></li><li><a class=btn ng-click=header.irAPedidos()><div ng-if=\"header.cantidadPedidos==0\">No hay pedidos sin atender</div><div ng-if=\"header.cantidadPedidos>0\">Hay {{header.cantidadPedidos>0? header.cantidadPedidos : \"0\"}} {{header.cantidadPedidos==1? \"pedido\" : \"pedidos\"}} sin atender</div></a></li></ul></div></div><div class=meta><div ng-bind=titulo class=page></div><div ng-bind=subtitulo class=breadcrumb-links></div></div></div></div>");
$templateCache.put("app/components/side-bar/sidebar.html","<div id=sidebar-wrapper><ul class=\"sidebar cuerpo-sidebar\"><li class=sidebar-main><a ng-click=sidebar.toggleSidebar() class=titulo-sidebar>AZ - Suministros <span class=\"menu-icon fa fa-bars\"></span></a></li><div ng-repeat=\"opcion in sidebar.opciones\"><li class=sidebar-list><a class=lista-sidebar ng-click=\"opcion.estaAbierto = !opcion.estaAbierto\">{{opcion.nombre}} <span class=menu-icon ng-class=sidebar.getIcono(opcion.estaAbierto)></span></a></li><div ng-repeat=\"hijo in opcion.hijos\" uib-collapse=!opcion.estaAbierto><li class=sidebar-list><a style=font-size:92% class=lista-hijos-sidebar ng-click=sidebar.ir(hijo.estado)>&nbsp;&nbsp;{{hijo.nombre}} <span class=\"menu-icon {{hijo.icono}}\"></span></a></li></div></div></ul></div>");
$templateCache.put("app/app/main/home/home.html","<div class=col-lg-12><div class=row><div class=\"col-lg-6 col-md-6\" ng-if=\"home.rol.id<=3\" ng-click=home.irNuevoIngreso();><div class=\"panel panel-info\"><div class=panel-heading><div class=row><div class=col-xs-2><i class=\"fa fa-plus fa-5x\"></i></div><div class=\"col-xs-10 text-right\"><div>Nuevo ingreso</div></div></div></div></div></div><div class=\"col-lg-6 col-md-6\" ng-click=home.irListadoIngresos(); ng-if=\"home.rol.id!=30\"><div class=\"panel panel-success\"><div class=panel-heading><div class=row><div class=col-xs-2><i class=\"fa fa-sign-in fa-5x\"></i></div><div class=\"col-xs-10 text-right\"><div>Listado de Ingresos</div></div></div></div></div></div></div><div class=row><div class=\"col-lg-6 col-md-6\" ng-click=home.irNuevoEgreso(); ng-if=\"home.rol.id<=3\"><div class=\"panel panel-warning\"><div class=panel-heading><div class=row><div class=col-xs-2><i class=\"fa fa-plus fa-5x\"></i></div><div class=\"col-xs-10 text-right\"><div>Nuevo egreso</div></div></div></div></div></div><div class=\"col-lg-6 col-md-6\" ng-click=home.irListadoEgresos(); ng-if=\"home.rol.id!=30\"><div class=\"panel panel-danger\"><div class=panel-heading><div class=row><div class=col-xs-2><i class=\"fa fa-sign-out fa-5x\"></i></div><div class=\"col-xs-10 text-right\"><div>Listado de Egresos</div></div></div></div></div></div></div><div class=row><div class=\"col-lg-6 col-md-6\" ng-click=home.irNuevoPedido(); ng-if=\"home.rol.id==30\"><div class=\"panel panel-info\"><div class=panel-heading><div class=row><div class=col-xs-2><i class=\"fa fa-plus fa-5x\"></i></div><div class=\"col-xs-10 text-right\"><div>Nuevo pedido</div></div></div></div></div></div><div class=\"col-lg-6 col-md-6\" ng-click=home.irListadoPedidos(); ng-if=\"home.rol.id==30\"><div class=\"panel panel-success\"><div class=panel-heading><div class=row><div class=col-xs-2><i class=\"fa fa-sign-in fa-5x\"></i></div><div class=\"col-xs-10 text-right\"><div>Listado de pedidos</div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/campos-personalizados/lista-emails/lista-emails.html","<div><div class=\"panel panel-default\"><div class=\"panel-heading clearfix\"><div class=\"col-xs-4 col-sm-4\">{{vm.titulo}}</div><div class=\"col-xs-8 col-sm-8\"><form name=mailForm><div class=\"pull-right input-group\" ng-class=\"{\'has-error\' : mailForm.email.$error.email, \'has-error\' : mailForm.email.$error.pattern}\"><input type=email class=form-control focus-on={{vm.nombreCampo}} name={{vm.nombreCampo}} ng-model=vm.nuevoObjeto placeholder={{vm.placeholder}} ng-disabled=\"vm.objetos.length>=3\" ng-pattern=/[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$/ > <span class=input-group-btn><button type=button class=\"btn btn-info\" ng-click=vm.agregar() ng-disabled=\"vm.habilitarBotonAgregar() || !vm.nuevoObjeto || mailForm.email.$error.email\"><span class=\"fa fa-plus\"></span></button></span></div><ng-messages for=mailForm.email.$error><ng-message when=pattern ng-class=\"{\'text-danger\' : true}\">Ingrese un mail válido</ng-message></ng-messages></form></div></div><div class=panel-body><div uib-alert ng-if=\"vm.objetos.length==0\">No se ha agregado ningún email.</div><table ng-if=\"vm.objetos.length>0\" class=\"table table-hover\"><thead><tr><th class=col-sm-8>{{vm.tituloColumna}}</th><th class=col-sm-4><div align=center>Acciones</div></th></tr></thead><tbody><tr ng-repeat=\"objeto in vm.paginaObjetos\" ng-include=\"vm.getTemplate($index, objeto)\"></tr></tbody></table><uib-pagination total-items=vm.totalItems ng-if=\"vm.objetos.length>3\" ng-model=vm.paginaActual items-per-page=vm.itemsPorPagina previous-text=Anterior next-text=Siguiente><uib-pagination></uib-pagination></uib-pagination></div></div></div><script type=text/ng-template id=mostrarMail><td class=\"col-sm-8\">\r\n        {{objeto}}\r\n    </td>\r\n    <td class=\"col-sm-4\" align=\"center\">\r\n        <span class=\"btn-group\">\r\n            <button class=\"btn btn-success\" type=\"button\" ng-click=\"vm.editar($index, objeto)\">\r\n              <span class=\"fa fa-pencil\"></span>\r\n          </button>\r\n          <button class=\"btn btn-danger\" type=\"button\" ng-click=\"vm.eliminar($index)\">\r\n              <span class=\"fa fa-trash\"></span>\r\n          </button>\r\n      </span>\r\n    </td></script><script type=text/ng-template id=editarMail><td class=\"col-xs-4 col-sm-8\">\r\n    <ng-form name=\"editMailForm\">\r\n      <input type=\"email\" name=\"editMail\" ng-class=\"{\'error\' : editMailForm.editMail.$error.email}\" class=\"form-control\" ng-model=\"vm.seleccionado\" ng-pattern=\"/[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$/\"/>\r\n      <div ng-if=\"editMailForm.editMail.$error.email || editMailForm.editMail.$error.pattern\" ng-class=\"{\'text-danger\' : editMailForm.editMail.$error.email, \'text-danger\' : editMailForm.editMail.$error.pattern}\">\r\n        Email inválido\r\n      </div> \r\n    </td>\r\n    <td class=\"col-sm-4\" align=\"center\">\r\n      <span class=\"btn-group\">\r\n          <button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"!vm.seleccionado || editMailForm.$invalid\" ng-click=\"vm.guardar($index)\">\r\n            <span class=\"fa fa-save\"></span>\r\n        </button>\r\n        <button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.resetSeleccionado()\">\r\n            <span class=\"fa fa-ban\"></span>\r\n        </button>\r\n      </span>\r\n    </ng-form>\r\n  </td></script>");
$templateCache.put("app/components/modales/agregar-detalle-reparacion/agregar-detalle-reparacion.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading>{{vm.titulo}}</div><div class=panel-body><div class=container-fluid><div class=row><div class=col-lg-12><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.deposito.nombre class=\"form-control text-uppercase\"></div></div><div class=row><div class=col-lg-12><label>Buscar por N° de bien:</label></div><div class=\"col-lg-1 form-group\"><input type=radio ng-model=vm.radio value=etiqueta ng-change=vm.cambioRadio()></div><div class=\"col-lg-6 form-group\"><label>Empresa</label><input ng-disabled=\"vm.radio!=\'etiqueta\'\" type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=empresa typeahead-editable=false required> <span uib-alert ng-show=\"vm.radio==\'etiqueta\' && vm.form.empresa.$error.required && vm.form.empresa.$dirty\">Campo requerido</span></div><div class=\"col-lg-5 form-group\"><label>N° de inventario</label><input ng-disabled=\"vm.radio!=\'etiqueta\' && !vm.empresa\" type=number name=etiqueta ng-model=vm.etiqueta placeholder=\"Ingrese el N° inventario\" ng-pattern=/^[0-9]{0}/ required name=etiqueta class=form-control> <span uib-alert class=danger ng-show=\"vm.radio==\'etiqueta\' && vm.form.etiqueta.$error.required && vm.form.etiqueta.$dirty\">Campo requerido. </span><span uib-alert ng-if=\"vm.radio==\'etiqueta\' && (vm.form.etiqueta.$error.pattern || vm.form.etiqueta.$error.number) && vm.form.etiqueta.$dirty\">Valor inválido.</span></div></div><div class=\"row align-items-center\"><div class=col-lg-12><label>Buscar por N° de serie:</label></div><div class=\"col-lg-1 form-group\"><input type=radio ng-model=vm.radio value=serie ng-change=vm.cambioRadio()></div><div class=\"col-lg-11 form-group\"><div class=col-lg-12><div class=col-lg-4><label>Empresa</label><input ng-disabled=\"vm.radio!=\'serie\'\" type=text ng-model=vm.empresa1 placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=empresa1 typeahead-editable=false required> <span uib-alert ng-if=\"vm.radio==\'serie\' && vm.form.empresa1.$error.required && vm.form.empresa1.$dirty\">Campo requerido.</span></div><div class=col-lg-4><label>Grupo de suministro</label><input ng-disabled=\"vm.radio!=\'serie\' && !vm.empresa1.id\" type=text ng-model=vm.grupoSuministro placeholder=\"Seleccione o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase() for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=grupo typeahead-editable=false required focus-on=grupoSuministro> <span uib-alert ng-if=\"vm.radio==\'serie\' && vm.empresa1.id && vm.form.grupo.$error.required && vm.form.grupo.$dirty\">Campo requerido.</span></div><div class=col-lg-4><label>Familia de suministro</label><input ng-disabled=\"vm.radio!=\'serie\' && !vm.empresa1 && !vm.grupoSuministro\" type=text ng-model=vm.familiaSuministro placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familia as familia.nombre.toUpperCase() for familia in vm.familias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=familia typeahead-editable=false required focus-on=familiaSuministro> <span uib-alert ng-if=\"vm.radio==\'serie\' && vm.form.familia.$error.required && vm.form.familia.$dirty && vm.empresa1.id && vm.grupoSuministro.id\">Campo requerido.</span></div></div><br><br><br><br><div class=col-lg-12><div class=col-lg-7><label>Tipo de suministro</label><input ng-disabled=\"vm.radio!=\'serie\' && !vm.empresa1.id && !vm.grupoSuministro.id && !vm.familiaSuministro.id\" type=text ng-model=vm.tipoSuministro placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"tipo as tipo.nombre.toUpperCase() for tipo in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=tipo typeahead-editable=false required focus-on=tipoSuministro> <span uib-alert ng-if=\"vm.radio==\'serie\' && vm.form.tipo.$error.required && vm.form.tipo.$dirty && vm.empresa1.id && vm.familiaSuministro.id && vm.grupoSuministro.id\">Campo requerido.</span></div><div class=col-lg-5><label>N° de serie</label><input type=text ng-disabled=\"vm.radio!=\'serie\'\" placeholder=\"Ingrese el N° de serie\" ng-model=vm.serie class=form-control required focus-on=serie> <span uib-alert ng-if=\"vm.radio==\'serie\' && vm.form.tipo.$error.required && vm.form.tipo.$dirty && vm.empresa1.id && vm.familiaSuministro.id && vm.grupoSuministro.id && vm.tipoSuministro.id\">Campo requerido.</span></div></div></div></div><div class=col-lg-12><center><button class=\"btn btn-primary\" ng-click=vm.buscar() ng-disabled=\"!(vm.radio==\'serie\' && vm.empresa1.id && vm.familiaSuministro.id && vm.grupoSuministro.id && vm.tipoSuministro.id && vm.serie) && !(vm.radio==\'etiqueta\' && vm.empresa.id && vm.etiqueta)\"><i class=\"fa fa-search\"></i> Buscar suministro</button></center></div></div><br><br><label class=col-lg-12 ng-if=\"vm.suministros.length>0 && vm.bandera\">Resultados de la búsqueda:</label><div class=col-lg-12 ng-if=\"vm.suministros.length==0 && vm.bandera\"><span uib-alert>No hay suministros que correspondan con la búsqueda.</span></div><div class=col-lg-12 ng-if=\"vm.suministros.length>0\"><table ng-table=vm.tableParams id=table1 show-filter=true class=table><tr ng-repeat=\"bien in $data\"><td data-title=\"\'Grupo suministro\'\" align=center>{{bien.suministro.tipoSuministro.familiaSuministro.grupoSuministro ? bien.suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase() : \"-\" }}</td><td data-title=\"\'Familia suministro\'\" align=center>{{bien.suministro.tipoSuministro.familiaSuministro ? bien.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase() : \"-\" }}</td><td data-title=\"\'Tipo suministro\'\" align=center>{{bien.suministro.tipoSuministro ? bien.suministro.tipoSuministro.nombre.toUpperCase() : \"-\" }}</td><td data-title=\"\'N° inventario\'\" align=center>{{bien.inventario ? bien.inventario : \"-\"}}</td><td data-title=\"\'N° serie\'\" align=center>{{bien.serie ? bien.serie : \"-\"}}</td><td data-title=\"\'¿Nuevo?\'\" align=center>{{bien.nuevo? \"SI\" : \"NO\" }}</td><td data-title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !bien.suministro.ubicacion.numeroOrden, \'has-success\':bien.suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(bien.suministro) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(bien.suministro)}}</div></div></td><td data-title=\"\'\'\" align=center><button type=button ng-disabled=\"(vm.bien && vm.seleccion) || vm.corroborarEstadoSuministro(bien) || !bien.suministro.ubicacion\" class=\"btn btn-primary btn-block\" ng-click=vm.seleccionar(bien)><span class=\"fa fa-check\"></span></button></td></tr></table></div><div ng-if=vm.bien.id><form name=vm.form><div class=col-lg-12><center><button style=width:50% class=\"btn btn-warning btn-block\" ng-click=vm.cambiarSeleccion()><i class=\"fa fa-exchange\"></i> Cambiar bien seleccionado</button></center></div><div class=col-lg-12><label>Bien seleccionado:</label><div style=\"overflow-x: auto\" class=form-control class=form-control style=\"word-wrap: white\">{{vm.bien.suministro.tipoSuministro.nombre.toUpperCase()+\" (\"+vm.bien.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase()+\" - \"+vm.bien.suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+\") - N° Inventario: \"+vm.bien.inventario+\". - N° Serie: \"+vm.bien.serie}}</div></div><div class=col-lg-12><label>Descripción de la reparación:</label><textarea class=form-control ng-maxlength=500 ng-minlength=5 ng-model=vm.detalle.descripcion placeholder=\"Ingrese una observación\" type=text name=descripcion style=resize:vertical></textarea><span uib-alert class=danger required ng-if=\"vm.form.descripcion.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.descripcion.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 500 caracteres. </span><span uib-alert class=danger ng-if=\"vm.form.descripcion.$error.minlength && vm.form.$dirty\">Este campo debe tener al menos 5 caracteres.</span></div><div class=\"col-lg-12 row\" ng-if=vm.detalle.encabezadoFoto><center><div ng-if=vm.foto><img ng-src={{vm.foto}} class=img-thumbnail> <button class=\"btn btn-danger\" ng-click=vm.quitarFoto();><i class=\"fa fa-close\"></i></button></div><br></center></div><div class=col-lg-12><button type=button class=\"btn btn-primary btn-block\" ng-click=vm.abrirSeleccionFoto()><span class=\"glyphicon glyphicon-camera\"></span> Seleccionar foto</button></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><center><button type=button class=\"btn btn-success\" ng-disabled=\"!vm.detalle.descripcion || !vm.bien.id\" ng-click=vm.agregar()><span class=\"fa fa-plus\"></span> Agregar</button> <button type=button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></center></div></div></div></div>");
$templateCache.put("app/components/modales/agregar-quitar-suministro-egreso-kit/agregar-quitar-suministro-egreso-kit.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Agregar o quitar suministros para kit</div><div class=panel-body><div class=col-lg-12><div class=\"form-group col-lg-6\"><label>Depósito:</label><input type=text ng-model=vm.deposito.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-12\"><label>Sucursal:</label><input type=text ng-model=vm.sucursal.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-12\"><label>Tipo de suministro:</label><div type=text style=\"word-wrap: white\" class=\"form-control text-uppercase\" ng-readonly=true>{{vm.tipoCompleto}}</div></div></div><!-- PARA SUMINISTROS NO INVENTARIABLES!!! --><div class=col><div class=col-lg-12><label>Suministros seleccionables:</label></div><div uib-alert type=info class=col-lg-12><label ng-style=\"vm.cantidadNoInventariableSeleccionable()==0 && {\'color\':\'red\'}\">Cantidad seleccionable: {{vm.cantidadNoInventariableSeleccionable();}}</label><br><label>Cantidad indicada en el Kit: {{vm.cantidadKit;}}</label><br><label>Total asignado: {{ vm.cantidadAsignadaNoInventariable(); }}</label></div><div uib-alert type=success class=col-lg-12>Cantidad tope para el producto: <b>{{vm.cantidadTope? vm.cantidadTope:\"No indicado\";}}</b><br>Periodicidad del tope: <b>{{vm.periodicidad}}</b><br>Despachado a la sucursal <b>{{vm.sucursal.nombre.toUpperCase()}}</b>:<br>&nbsp;&nbsp;&nbsp;Mes vigente: <b>{{vm.cantidadMes}}</b><br>&nbsp;&nbsp;&nbsp;Consumo en el período del tope: <b>{{vm.consumoTope}}</b><br>&nbsp;&nbsp;&nbsp;Últimos 30 días: <b>{{vm.cantidadUltimos30Dias}}</b><br>&nbsp;&nbsp;&nbsp;Últimos 60 días: <b>{{vm.cantidadUltimos60Dias}}</b><br>&nbsp;&nbsp;&nbsp;Últimos 90 días: <b>{{vm.cantidadUltimos90Dias}}</b><br>&nbsp;&nbsp;&nbsp;Año vigente: <b>{{vm.cantidadAnual;}}</b></div><div class=col-lg-12 ng-if=\"vm.listaNoInventariable.length>0 && vm.cantidadNoInventariableSeleccionable()>0\"><table ng-table=vm.tableParamsNoInventariables id=table show-filter=true class=table><tr ng-repeat=\"item in $data track by $index\" ng-if=\"item.suministro.cantidad>0\"><td data-title=\"\'Marca\'\" align=center data-sortable=\"\'marca\'\">{{item.suministro.marca ? item.suministro.marca.toUpperCase() : \"-\" }}</td><td data-title=\"\'Fecha vencimiento\'\" align=center data-sortable=\"\'fechaVencimiento\'\">{{item.suministro.fechaVencimiento? item.suministro.fechaVencimiento : \"-\" | date : \"dd/MM/yyyy\" }}</td><td data-title=\"\'Precio\'\" align=center>${{item.suministro.precioUnitario ? item.suministro.precioUnitario : \"-\"}}</td><td data-title=\"\'Fecha ingreso\'\" align=center data-sortable=\"\'fecha\'\">{{item.fecha? item.fecha : \"-\" | date : \"dd/MM/yyyy\" }}</td><td data-title=\"\'Cantidad disponible\'\" align=center>{{item.suministro.cantidad ? item.suministro.cantidad : \"-\"}}</td><td style=width:30% data-title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !item.suministro.ubicacion.numeroOrden, \'has-success\':item.suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(item.suministro) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(item.suministro)}}</div></div></td><td align=center data-title=\"\'Empezado\'\">{{item.cantidad!=item.suministro.cantidad ? \"SI\": \"NO\"}}</td><td style=width:15% data-title=\"\'Cantidad solicitada\'\"><ng-form name=camposForm><div><input class=form-control ng-pattern=/^[1-9][0-9]*$/ type=number name=cantidades ng-model=item.suministro.cantidadSolicitada placeholder=\"Ingrese cantidad\"> <span uib-alert class=danger ng-if=\"item.suministro.cantidadSolicitada>item.suministro.cantidad\">La cantidad solicitada debe ser menor o igual a la cantidad disponible. </span><span uib-alert class=danger ng-if=\"(camposForm.cantidades.$error.number || camposForm.cantidades.$error.pattern) && camposForm.cantidades.$dirty\">Ingrese un valor válido.</span></div></ng-form></td><td align=center><div class=btn-group><a class=\"btn btn-success form-group\" ng-disabled=\"!item.suministro.cantidadSolicitada || item.suministro.cantidadSolicitada<=0 || item.suministro.cantidadSolicitada>item.suministro.cantidad\" ng-click=\"!item.suministro.cantidadSolicitada || item.suministro.cantidadSolicitada<=0 || item.suministro.cantidadSolicitada>item.suministro.cantidad || vm.agregarNoInventariable(item.suministro)\"><i class=\"fa fa-plus\"></i></a></div></td></tr></table></div><div class=col-lg-12><div uib-alert type=danger class=col-lg-12 ng-if=\"vm.suministrosAsignados.length==0\">No ha agregado ningún suministro en esta sucursal</div><div ng-if=\"vm.suministrosAsignados.length>0\"><label>Suministros asignados:</label></div><div ng-if=\"vm.suministrosAsignados.length>0\"><table ng-table=vm.tableParamsAsignadoNoInventariable class=\"table table-striped\" id=table1 show-filter=true><tr ng-repeat=\"item in vm.suministrosAsignados track by $index\"><td data-title=\"\'Marca\'\" align=center data-sortable=\"\'marca\'\">{{item.suministro.marca ? item.suministro.marca.toUpperCase() : \"-\" }}</td><td data-title=\"\'Fecha vencimiento\'\" align=center data-sortable=\"\'fechaVencimiento\'\">{{item.suministro.fechaVencimiento? item.suministro.fechaVencimiento : \"-\" | date : \"dd/MM/yyyy\" }}</td><td data-title=\"\'Precio\'\" align=center>${{item.suministro.precioUnitario ? item.suministro.precioUnitario : \"-\"}}</td><td data-title=\"\'Fecha ingreso\'\" align=center data-sortable=\"\'fecha\'\">{{item.suministro.fecha? item.suministro.fecha : \"-\" | date : \"dd/MM/yyyy\" }}</td><td style=width:30% data-title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !item.suministro.ubicacion.numeroOrden, \'has-success\':item.suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(item.suministro) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(item.suministro)}}</div></div></td><td data-title=\"\'Cantidad solicitada\'\" align=center>{{item.cantidad ? item.cantidad : \"-\"}}</td><td data-title=\"\'Eliminar\'\" align=center><div class=btn-group><a class=\"btn btn-danger\" ng-click=vm.eliminarNoInventariable(item)><i class=\"fa fa-remove\"></i></a></div></td></tr></table></div></div></div><br></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-primary\" ng-click=vm.agregar()><span class=\"fa fa-plus\"></span> Aceptar</button> <button type=button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/agregar-quitar-suministro-egreso-pedido/agregar-quitar-suministro-egreso-pedido.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Agregar o quitar suministros para el pedido</div><div class=panel-body><div class=col-lg-12><div class=\"form-group col-lg-6\"><label>Depósito:</label><input type=text ng-model=vm.deposito.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-12\"><label>Sucursal:</label><input type=text ng-model=vm.sucursal.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-12\"><label>Tipo de suministro:</label><div type=text style=\"word-wrap: white\" class=\"form-control text-uppercase\" ng-readonly=true>{{vm.tipoCompleto}}</div></div></div><!-- PARA SUMINISTROS NO INVENTARIABLES!!! --><div class=col><div class=col-lg-12><label>Suministros seleccionables:</label></div><div uib-alert type=info class=col-lg-12><label>Cantidad seleccionable: {{vm.cantidadNoInventariableSeleccionable();}}</label><br><label>Cantidad pedido: {{vm.cantidadPedido;}}</label><br><label>Total asignado: {{ vm.cantidadAsignadaNoInventariable(); }}</label></div><div uib-alert type=success class=col-lg-12>Cantidad tope para el producto: <b>{{vm.cantidadTope? vm.cantidadTope:\"No indicado\";}}</b><br>Periodicidad del tope: <b>{{vm.periodicidad}}</b><br>Despachado a la sucursal <b>{{vm.sucursal.nombre.toUpperCase()}}</b>:<br>&nbsp;&nbsp;&nbsp;Mes vigente: <b>{{vm.cantidadMes}}</b><br>&nbsp;&nbsp;&nbsp;Consumo en el período del tope: <b>{{vm.consumoTope}}</b><br>&nbsp;&nbsp;&nbsp;Últimos 30 días: <b>{{vm.cantidadUltimos30Dias}}</b><br>&nbsp;&nbsp;&nbsp;Últimos 60 días: <b>{{vm.cantidadUltimos60Dias}}</b><br>&nbsp;&nbsp;&nbsp;Últimos 90 días: <b>{{vm.cantidadUltimos90Dias}}</b><br>&nbsp;&nbsp;&nbsp;Año vigente: <b>{{vm.cantidadAnual;}}</b></div><div class=col-lg-12 ng-if=\"vm.listaNoInventariable.length>0\"><table ng-table=vm.tableParamsNoInventariables id=table show-filter=true class=table><tr ng-repeat=\"item in $data track by $index\" ng-if=\"item.suministro.cantidad>0\"><td data-title=\"\'Marca\'\" align=center data-sortable=\"\'marca\'\">{{item.suministro.marca ? item.suministro.marca.toUpperCase() : \"-\" }}</td><td data-title=\"\'Fecha vencimiento\'\" align=center data-sortable=\"\'fechaVencimiento\'\">{{item.suministro.fechaVencimiento? item.suministro.fechaVencimiento : \"-\" | date : \"dd/MM/yyyy\" }}</td><td data-title=\"\'Precio\'\" align=center>${{item.suministro.precioUnitario ? item.suministro.precioUnitario : \"-\"}}</td><td data-title=\"\'Fecha ingreso\'\" align=center data-sortable=\"\'fecha\'\">{{item.fecha? item.fecha : \"-\" | date : \"dd/MM/yyyy\" }}</td><td data-title=\"\'Cantidad disponible\'\" align=center>{{item.suministro.cantidad ? item.suministro.cantidad : \"-\"}}</td><td style=width:30% data-title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !item.suministro.ubicacion.numeroOrden, \'has-success\':item.suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(item.suministro) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(item.suministro)}}</div></div></td><td align=center data-title=\"\'Empezado\'\">{{item.cantidad!=item.suministro.cantidad ? \"SI\": \"NO\"}}</td><td style=width:15% data-title=\"\'Cantidad solicitada\'\"><ng-form name=camposForm><div><input class=form-control ng-pattern=/^[1-9][0-9]*$/ type=number name=cantidades ng-model=item.suministro.cantidadSolicitada placeholder=\"Ingrese cantidad\"> <span uib-alert class=danger ng-if=\"item.suministro.cantidadSolicitada>item.suministro.cantidad\">La cantidad solicitada debe ser menor o igual a la cantidad disponible. </span><span uib-alert class=danger ng-if=\"(camposForm.cantidades.$error.number || camposForm.cantidades.$error.pattern) && camposForm.cantidades.$dirty\">Ingrese un valor válido.</span></div></ng-form></td><td align=center><div class=btn-group><a class=\"btn btn-success form-group\" ng-disabled=\"!item.suministro.cantidadSolicitada || item.suministro.cantidadSolicitada<=0 || item.suministro.cantidadSolicitada>item.suministro.cantidad\" ng-click=\"!item.suministro.cantidadSolicitada || item.suministro.cantidadSolicitada<=0 || item.suministro.cantidadSolicitada>item.suministro.cantidad || vm.agregarNoInventariable(item.suministro)\"><i class=\"fa fa-plus\"></i></a></div></td></tr></table></div><div class=col-lg-12><div uib-alert type=danger class=col-lg-12 ng-if=\"vm.suministrosAsignados.length==0\">No ha agregado ningún suministro en esta sucursal</div><div ng-if=\"vm.suministrosAsignados.length>0\"><label>Suministros asignados:</label></div><div ng-if=\"vm.suministrosAsignados.length>0\"><table ng-table=vm.tableParamsAsignadoNoInventariable class=\"table table-striped\" id=table1 show-filter=true><tr ng-repeat=\"item in vm.suministrosAsignados track by $index\"><td data-title=\"\'Marca\'\" align=center data-sortable=\"\'marca\'\">{{item.suministro.marca ? item.suministro.marca.toUpperCase() : \"-\" }}</td><td data-title=\"\'Fecha vencimiento\'\" align=center data-sortable=\"\'fechaVencimiento\'\">{{item.suministro.fechaVencimiento? item.suministro.fechaVencimiento : \"-\" | date : \"dd/MM/yyyy\" }}</td><td data-title=\"\'Precio\'\" align=center>${{item.suministro.precioUnitario ? item.suministro.precioUnitario : \"-\"}}</td><td data-title=\"\'Fecha ingreso\'\" align=center data-sortable=\"\'fecha\'\">{{item.suministro.fecha? item.suministro.fecha : \"-\" | date : \"dd/MM/yyyy\" }}</td><td style=width:30% data-title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !item.suministro.ubicacion.numeroOrden, \'has-success\':item.suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(item.suministro) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(item.suministro)}}</div></div></td><td data-title=\"\'Cantidad solicitada\'\" align=center>{{item.cantidad ? item.cantidad : \"-\"}}</td><td data-title=\"\'Eliminar\'\" align=center><div class=btn-group><a class=\"btn btn-danger\" ng-click=vm.eliminarNoInventariable(item)><i class=\"fa fa-remove\"></i></a></div></td></tr></table></div></div></div><br></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-primary\" ng-click=vm.agregar()><span class=\"fa fa-plus\"></span> Aceptar</button> <button type=button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/agregar-detalle-transferencia/agregar-detalle-transferencia.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Seleccione el suministro</div><div class=panel-body><div><label>Búsqueda jerarquizada:</label><div class=col-lg-12><div class=col-lg-1><div class=form-group><input type=radio ng-model=vm.radio value=jerarquizada ng-change=vm.cambioRadio()></div></div><div class=col-lg-11><div class=\"form-group col-lg-6\"><label>Grupo de suministro:</label><input type=text ng-disabled=\"vm.radio!=\'jerarquizada\'\" ng-model=vm.grupo placeholder=\"Seleccione o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase()+\' (\'+grupo.empresa.nombre.toUpperCase()+\')\' for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Familia de suministro:</label><input ng-disabled=\"!vm.grupo.nombre || vm.radio!=\'jerarquizada\'\" focus-on=familia type=text ng-model=vm.familiaSuministro placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familiaSuministro as familiaSuministro.nombre.toUpperCase() for familiaSuministro in vm.familias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-12\"><label>Tipo de suministro:</label><input ng-if=\"vm.radio==\'jerarquizada\'\" ng-disabled=\"!vm.grupo.nombre || !vm.familiaSuministro.nombre || vm.radio!=\'jerarquizada\'\" type=text focus-on=tipo ng-model=vm.tipoSuministro placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase() for suministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <input ng-if=\"vm.radio==\'directa\'\" ng-disabled=\"!vm.grupo.nombre || !vm.familiaSuministro.nombre || vm.radio!=\'jerarquizada\'\" type=text ng-model=vm.tipoSuministro1 placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase() for suministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div><div><label>Búsqueda directa:</label><div class=col-lg-12 ng-disabled=\"\"><div class=\"form-group col-lg-1\"><input type=radio ng-model=vm.radio value=directa ng-change=vm.cambioRadio()></div><div class=\"form-group col-lg-11\"><label>Tipo de suministro:</label><input type=text ng-disabled=\"vm.radio!=\'directa\'\" ng-model=vm.tipoSuministroCompleto placeholder=\"Seleccione o busque el tipo de suministro por su nombre\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase()+\' (\'+suministro.familiaSuministro.nombre.toUpperCase()+\') - (\'+suministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+\')\' for suministro in vm.tiposCompletos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div><div class=col-lg-12 uib-alert ng-if=vm.tipoRepetido>El tipo de suministro que seleccionó ya fue ingresado. Si desea editar, debe eliminar la selección previa de este tipo de suministro.</div><!-- PARA SUMINISTROS NO INVENTARIABLES!!! --><div class=col-lg-12 uib-alert ng-if=\"vm.tipoSuministro && !vm.tipoSuministro.inventariable && vm.cantidadStockTipo()==0\">No hay stock de este tipo de suministro en el depósito.</div><div class=col ng-if=\"vm.tipoSuministro && !vm.tipoSuministro.inventariable && vm.cantidadTotalStockTipo>0\"><div class=col-lg-12 ng-if=\"vm.tipoSuministro && !vm.tipoSuministro.inventariable && vm.cantidadStockTipo>0\"><br><label>Total solicitado: {{ vm.totalSuministros() }}</label></div><div class=col-lg-12 ng-if=\"!vm.tipoSuministro.inventariable && vm.cantidadStockTipo()>0\"><table ng-table=vm.tableParams id=table show-filter=true class=table><tr ng-repeat=\"suministro in $data track by $index\" ng-if=\"suministro.cantidad>0\" ng-disabled=suministro.comprobado ng-class=\"{\'azul-claro\': suministro.seleccionado, \'rojo-claro\':suministro.comprobado}\"><td data-title=\"\'Marca\'\" align=center data-sortable=\"\'marca\'\">{{suministro.marca ? suministro.marca.toUpperCase() : \"-\" }}</td><td data-title=\"\'Fecha vencimiento\'\" align=center data-sortable=\"\'fechaVencimiento\'\">{{suministro.fechaVencimiento? suministro.fechaVencimiento : \"-\" | date : \"dd/MM/yyyy\" }}</td><td data-title=\"\'Precio\'\" align=center>${{suministro.precioUnitario ? suministro.precioUnitario : \"-\"}}</td><td data-title=\"\'Fecha ingreso\'\" align=center data-sortable=\"\'fecha\'\">{{suministro.fecha? suministro.fecha : \"-\" | date : \"dd/MM/yyyy\" }}</td><td data-title=\"\'Cantidad\'\" align=center>{{suministro.cantidad ? suministro.cantidad : \"-\"}}</td><td style=width:30% data-title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !suministro.ubicacion.numeroOrden, \'has-success\':suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(suministro) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(suministro)}}</div></div></td><td data-title=\"\'Seleccionar\'\" align=center><div><input type=checkbox ng-disabled=suministro.comprobado ng-model=suministro.seleccionado><div ng-if=suministro.comprobado>El suministro está vinculado a un movimiento no cerrado</div></div></td></tr></table></div></div><!-- PARA SUMINISTROS INVENTARIABLES!!! --><div class=col-lg-12 uib-alert ng-if=\"vm.tipoSuministro && vm.tipoSuministro.inventariable && vm.bienes.length==0\">No hay stock de este tipo de suministro en el depósito.</div><div ng-if=\"vm.tipoSuministro && vm.tipoSuministro.inventariable && vm.bienes.length>0\"><div class=col-lg-12><br><label>Total solicitado: {{ vm.listaInventariables.length }}</label></div><div class=\"col-lg-12 form-group\"><label>Busque el bien por número de inventario o serie:</label><div class=col-lg-12><div class=col-lg-10><input focus-on=bien type=text ng-model=vm.bien placeholder=\"Seleccione o busque el bien por número de inventario\" uib-typeahead=\"bien as (\'N° inventario: \'+bien.inventario+\' - N° serie: \'+bien.serie+\' - Marca: \'+bien.suministro.marca.toUpperCase()) for bien in vm.filtrarBienes($viewValue)\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=col-lg-2 style=length:100%><button ng-disabled=!vm.bien class=\"btn btn-success\" ng-click=vm.agregarBienFiltrado()><span class=\"fa fa-check\"></span></button></div></div></div><div class=col-lg-12 ng-if=\"vm.tipoSuministro.inventariable && vm.listaInventariables.length>0\"><table ng-table=vm.tableParamsInventariable id=table2 show-filter=true class=table><tr ng-repeat=\"bien in vm.listaInventariables track by $index\"><td data-title=\"\'Marca\'\" align=center>{{bien.suministro.marca ? bien.suministro.marca.toUpperCase() : \"-\" }}</td><td data-title=\"\'N° inventario\'\" align=center>{{bien.inventario ? bien.inventario : \"-\"}}</td><td data-title=\"\'N° serie\'\" align=center>{{bien.serie ? bien.serie : \"-\"}}</td><td data-title=\"\'Precio\'\" align=center>${{bien.suministro.precioUnitario ? bien.suministro.precioUnitario : \"-\"}}</td><td style=width:30% data-title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !bien.suministro.ubicacion.numeroOrden, \'has-success\':bien.suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(bien.suministro) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(bien.suministro)}}</div></div></td><td align=center><div class=btn-group><a class=\"btn btn-danger\" ng-click=vm.eliminar($index)><i class=\"fa fa-trash\"></i></a></div></td></tr></table></div></div><br><br></div><div class=panel-footer><div class=form-group><center><button ng-disabled=\"(vm.radio!=\'directa\' && !vm.grupo.nombre) || (vm.radio!=\'directa\' && !vm.familiaSuministro.nombre) || !vm.tipoSuministro.nombre || ((!vm.tipoSuministro.inventariable && !vm.validarNoInventariables())) || (vm.tipoSuministro.inventariable && !vm.listaInventariables.length>0)\" class=\"btn btn-primary\" ng-click=vm.agregar()><span class=\"fa fa-plus\"></span> Agregar</button> <button type=button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/agregar-peso-cantidad-egreso/modal-agregar-peso-cantidad-egreso.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Agregar cantidad y peso de paquetes al egreso</div><div class=panel-body><div class=col-lg-12><div class=\"panel panel-default\"><br><div class=col-lg-12><center><button ng-disabled=\"!vm.empresaLogistica.id || camposCantidad.$invalid || camposKg.$invalid  || vm.comprobarPaquetesYPeso()\" ng-click=vm.verificarCantidadesYPeso(); class=\"btn btn-success\"><i class=\"fa fa-check\"></i> Guardar egreso</button> <button ng-disabled=\"!vm.empresaLogistica.id || camposCantidad.$invalid || camposKg.$invalid  || !vm.comprobarSimulacionPaquetesYPeso()\" ng-click=vm.simularEtiquetas(); class=\"btn btn-primary\"><i class=\"fa fa-files-o\"></i> Generar etiquetas A4</button></center></div><br><div class=panel-body><div class=\"col-lg-6 form 3.-group\" ng-show=vm.deposito><label>Depósito</label><input type=text ng-readonly=true ng-model=vm.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"col-lg-6 form-group\" ng-show=vm.empresa><label>Empresa</label><input type=text ng-readonly=true ng-model=vm.empresa.nombre class=\"form-control text-uppercase\"></div><div class=\"col-lg-6 form-group\"><label>Empresa logística:</label><input type=text ng-model=vm.empresaLogistica placeholder=\"Seleccione o busque la empresa de logístca\" uib-typeahead=\"empresaLogistica as empresaLogistica.nombre.toUpperCase() for empresaLogistica in vm.empresasLogistica | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"col-lg-6 form-group\"><label>Persona que retira:</label><input type=text ng-model=vm.personaEmpresaLogistica placeholder=\"Seleccione o busque la persona de la empresa de logístca\" uib-typeahead=\"persona as persona.apellido.toUpperCase()+\', \'+persona.nombre.toUpperCase() for persona in vm.personas | filter:{nombre:$viewValue}\" class=form-control focus-on=personaEmpresaLogistica typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"col-lg-12 form-group\"><label>N° de guía</label><input type=text ng-model=vm.numeroGuia class=form-control placeholder=\"Ingrese número de guía\"></div><div class=\"col-lg-6 form-group\"><label>Cantidad total de paquetes:</label><br><h3><b>{{vm.paquetesTotalEgreso()==1? vm.paquetesTotalEgreso() + \" paquete\" : vm.paquetesTotalEgreso() + \" paquetes\"}}</b></h3></div><div class=\"col-lg-6 form-group\"><label>Peso total de paquetes:</label><br><h3><b>{{vm.pesoTotalEgreso();}} Kg.</b></h3></div></div></div></div><div class=col-lg-12><div class=\"col-lg-12 form-group\" ng-show=\"vm.egresos.length>0\"><label>Egresos seleccionados</label><table show-filter=true ng-table=vm.tableParamsEgresos class=table><tr ng-repeat=\"egresos in $data\"><td data-title=\"\'N° movimiento\'\" align=center>{{egresos.numeroMovimiento}}</td><td data-title=\"\'Fecha\'\" align=center>{{egresos.fecha | date:\"dd/MM/yyyy HH:mm\"}}</td><td data-title=\"\'Empresa\'\" align=center>{{egresos.empresa.nombre.toUpperCase();}}</td><td data-title=\"\'Sucursal\'\" align=center>{{egresos.sucursal? egresos.sucursal.nombre.toUpperCase():\"-\"}}</td><td data-title=\"\'Ver\'\" align=center><div class=btn-group><button class=\"btn btn-info\" ng-click=vm.visualizarEgreso(egresos)><i class=\"fa fa-search\"></i></button></div></td><td data-title=\"\'Kg estimado\'\" align=center ng-class=\"{\'rojo-claro\': !vm.calcularPeso(egresos),\'verde-claro\':vm.calcularPeso(egresos)}\">{{vm.calcularPesoEstimado(egresos);}} Kg.<div class=\"btn btn-light\" ng-click=vm.verPesoEstimado(egresos);><i class=\"fa fa-search\"></i></div></td><td data-title=\"\'Cantidad Paquetes\'\" align=center style=width:12% ng-class=\"{\'gris-claro\': true}\"><ng-form name=camposCantidad><input type=number ng-pattern=/^[1-9][0-9]{0}/ class=form-control ng-model=egresos.cantidadPaquetes name=cantidadPaquetes placeholder=\"Cantidad paquetes\"> <span uib-alert ng-if=\"(camposCantidad.cantidadPaquetes.$error.number || camposCantidad.cantidadPaquetes.$error.pattern) && camposCantidad.cantidadPaquetes.$dirty\">Ingrese un valor válido</span></ng-form></td><td data-title=\"\'Kg Paquetes\'\" align=center style=width:20% ng-class=\"{\'gris-claro\': true}\"><ng-form name=camposKg><input type=number placeholder=\"Kg paquetes\" class=form-control ng-model=egresos.pesoPaquetes ng-pattern=/^[0-9]+(\\.[0-9]{1,3})?$/ step=0.01 name=pesoPaquetes> <span uib-alert ng-if=\"(camposKg.pesoPaquetes.$error.number || camposKg.pesoPaquetes.$error.pattern) && camposKg.pesoPaquetes.$dirty\">Ingrese un valor válido</span></ng-form></td></tr></table><div uib-alert class=col-lg-12 ng-if=vm.comprobarPaquetesYPeso();>Debe ingresar todos los pesos y cantidades</div></div></div></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cerrar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/agregar-suministro-egreso/modal-agregar-suministro-egreso.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Seleccione el suministro</div><div class=panel-body><div><label>Búsqueda jerarquizada:</label><div class=col-lg-12><div class=col-lg-1><div class=form-group><input type=radio ng-model=vm.radio value=jerarquizada ng-change=vm.cambioRadio()></div></div><div class=col-lg-11><div class=\"form-group col-lg-6\"><label>Grupo de suministro:</label><input type=text ng-disabled=\"vm.radio!=\'jerarquizada\'\" ng-model=vm.grupo placeholder=\"Seleccione o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase()+\' (\'+grupo.empresa.nombre.toUpperCase()+\')\' for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Familia de suministro:</label><input ng-disabled=\"!vm.grupo.nombre || vm.radio!=\'jerarquizada\'\" focus-on=familia type=text ng-model=vm.familiaSuministro placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familiaSuministro as familiaSuministro.nombre.toUpperCase() for familiaSuministro in vm.familias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-12\"><label>Tipo de suministro:</label><input ng-if=\"vm.radio==\'jerarquizada\'\" ng-disabled=\"!vm.grupo.nombre || !vm.familiaSuministro.nombre || vm.radio!=\'jerarquizada\'\" type=text focus-on=tipo ng-model=vm.tipoSuministro placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase() for suministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <input ng-if=\"vm.radio==\'directa\'\" ng-disabled=\"!vm.grupo.nombre || !vm.familiaSuministro.nombre || vm.radio!=\'jerarquizada\'\" type=text ng-model=vm.tipoSuministro1 placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase() for suministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div><div><label>Búsqueda directa:</label><div class=col-lg-12 ng-disabled=\"\"><div class=\"form-group col-lg-1\"><input type=radio ng-model=vm.radio value=directa ng-change=vm.cambioRadio()></div><div class=\"form-group col-lg-11\"><label>Tipo de suministro:</label><input type=text ng-disabled=\"vm.radio!=\'directa\'\" ng-model=vm.tipoSuministroCompleto placeholder=\"Seleccione o busque el tipo de suministro por su nombre\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase()+\' (\'+suministro.familiaSuministro.nombre.toUpperCase()+\') - (\'+suministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+\')\' for suministro in vm.tiposCompletos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div><div class=col-lg-12 uib-alert ng-if=vm.tipoRepetido>El tipo de suministro que seleccionó ya fue ingresado. Si desea editar, debe eliminar la selección previa de este tipo de suministro.</div><div class=col-lg-12 ng-if=vm.tipoSuministro.id><center><button ng-click=vm.verFoto(); ng-disabled=!vm.tipoSuministro.encabezadoFoto class=\"btn btn-primary\"><i class=\"fa fa-photo\"></i> Ver imagen del tipo de suministro elegido</button><br><br></center></div><!-- PARA SUMINISTROS NO INVENTARIABLES!!! --><div class=col-lg-12 uib-alert ng-if=\"vm.tipoSuministro && !vm.tipoSuministro.inventariable && vm.cantidadStockTipo()===\'0\'\">No hay stock de este tipo de suministro en el depósito.</div><div class=col ng-if=\"vm.tipoSuministro && !vm.tipoSuministro.inventariable && vm.cantidadTotalStockTipo>0\"><div uib-alert type=info class=col-lg-12><label>Stock en depósito: {{vm.cantidadStockTipo();}}</label><br><label>Stock mínimo: {{vm.tipoSuministro.stockMinimo}}</label><br><label>Stock total: {{vm.cantidadTotalStockTipo;}}</label></div><div uib-alert type=success class=col-lg-12 ng-if=\"vm.tipoMovimientoIngreso==2\">Cantidad tope para el producto: <b>{{vm.cantidadTope? vm.cantidadTope:\"No indicado\";}}</b><br>Periodicidad del tope: <b>{{vm.periodicidad}}</b><br>Despachado a la sucursal <b>{{vm.sucursal.nombre.toUpperCase()}}</b>:<br>&nbsp;&nbsp;&nbsp;Mes vigente: <b>{{vm.cantidadMes}}</b><br>&nbsp;&nbsp;&nbsp;Consumo en el período del tope: <b>{{vm.consumoTope}}</b><br>&nbsp;&nbsp;&nbsp;Últimos 30 días: <b>{{vm.cantidadUltimos30Dias}}</b><br>&nbsp;&nbsp;&nbsp;Últimos 60 días: <b>{{vm.cantidadUltimos60Dias}}</b><br>&nbsp;&nbsp;&nbsp;Últimos 90 días: <b>{{vm.cantidadUltimos90Dias}}</b><br>&nbsp;&nbsp;&nbsp;Año vigente: <b>{{vm.cantidadAnual;}}</b></div><div class=col-lg-12 ng-if=\"vm.tipoSuministro && !vm.tipoSuministro.inventariable && vm.cantidadTotalStockTipo>0\"><br><label ng-if=\"vm.cantidadStockTipo()>0\">Total solicitado: {{ vm.totalSuministros() }}</label><div ng-if=vm.topeAlcanzado uib-alert><i class=\"fa fa-exclamation-circle\"></i> La cantidad despachada en el período, es igual o supera a la indicada en el tope</div><div ng-if=\"!vm.topeAlcanzado && vm.cantidadTope && vm.cantidadTope<=vm.totalSuministros()\" uib-alert><i class=\"fa fa-exclamation-circle\"></i> Si despacha esta cantidad se alcanza el tope para este producto</div><div ng-if=vm.topeAnualAlcanzado uib-alert><i class=\"fa fa-exclamation-circle\"></i> La cantidad despachada en año el vigente, es igual o supera a la indicada en el tope.</div></div><div class=col-lg-12 ng-if=\"!vm.tipoSuministro.inventariable && vm.cantidadStockTipo()>0\"><table ng-table=vm.tableParams id=table show-filter=true class=table><tr ng-repeat=\"suministro in $data track by $index\" ng-if=\"suministro.cantidad>0\"><td data-title=\"\'Marca\'\" align=center data-sortable=\"\'marca\'\">{{suministro.marca ? suministro.marca.toUpperCase() : \"-\" }}</td><td data-title=\"\'Fecha vencimiento\'\" align=center data-sortable=\"\'fechaVencimiento\'\">{{suministro.fechaVencimiento? suministro.fechaVencimiento : \"-\" | date : \"dd/MM/yyyy\" }}</td><td data-title=\"\'Precio\'\" align=center>${{suministro.precioUnitario ? suministro.precioUnitario : \"-\"}}</td><td data-title=\"\'Fecha ingreso\'\" align=center data-sortable=\"\'fecha\'\">{{suministro.fecha? suministro.fecha : \"-\" | date : \"dd/MM/yyyy\" }}</td><td data-title=\"\'Cercanía\'\" align=center data-sortable=\"\'cercania\'\">{{suministro.cercania ? suministro.cercania : \"-\" }}</td><td data-title=\"\'Cantidad disponible\'\" align=center>{{suministro.cantidad ? suministro.cantidad : \"-\"}}</td><td style=width:30% data-title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !suministro.ubicacion.numeroOrden, \'has-success\':suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(suministro) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(suministro)}}</div></div></td><td align=center data-title=\"\'Empezado\'\" ng-style=vm.obtenerColor(suministro);>{{suministro.cantidadOriginal!=suministro.cantidad ? \"SI\": \"NO\"}}</td><td style=width:15% data-title=\"\'Cantidad solicitada\'\"><ng-form name=vm.camposForm><div><input class=form-control ng-pattern=/^[1-9][0-9]*$/ type=number name=cantidades ng-model=suministro.cantidadSolicitada placeholder=\"Ingrese cantidad\"> <span uib-alert class=danger ng-if=\"suministro.cantidadSolicitada>suministro.cantidad\">La cantidad solicitada debe ser menor o igual a la cantidad disponible. </span><span uib-alert class=danger ng-if=\"(vm.camposForm.cantidades.$error.number || vm.camposForm.cantidades.$error.pattern) && vm.camposForm.$dirty\">Ingrese un valor válido.</span></div></ng-form></td></tr></table></div></div><!-- PARA SUMINISTROS INVENTARIABLES!!! --><div class=col-lg-12 uib-alert ng-if=\"vm.tipoSuministro && vm.tipoSuministro.inventariable && vm.bienes.length==0\">No hay stock de este tipo de suministro en el depósito.</div><div class=\"col-lg-12 form-group\" ng-if=\"vm.tipoSuministro && vm.tipoSuministro.inventariable && vm.cantidadTotalStockTipo>0\"><div uib-alert type=info class=col-lg-12><label>Stock en depósito: {{vm.cantidadStockBienes();}}</label><br><label>Stock mínimo: {{vm.tipoSuministro.stockMinimo}}</label><br><label>Stock total: {{vm.cantidadTotalStockTipo;}}</label></div><div uib-alert type=success class=col-lg-12>Cantidad tope para el producto: <b>{{vm.cantidadTope? vm.cantidadTope:\"No indicado\";}}</b><br>Periodicidad del tope: <b>{{vm.periodicidad}}</b><br>Despachado a la sucursal <b>{{vm.sucursal.nombre.toUpperCase()}}</b>:<br>&nbsp;&nbsp;&nbsp;Mes vigente: <b>{{vm.cantidadMes}}</b><br>&nbsp;&nbsp;&nbsp;Consumo en el período del tope: <b>{{vm.consumoTope}}</b><br>&nbsp;&nbsp;&nbsp;Últimos 30 días: <b>{{vm.cantidadUltimos30Dias}}</b><br>&nbsp;&nbsp;&nbsp;Últimos 60 días: <b>{{vm.cantidadUltimos60Dias}}</b><br>&nbsp;&nbsp;&nbsp;Últimos 90 días: <b>{{vm.cantidadUltimos90Dias}}</b><br>&nbsp;&nbsp;&nbsp;Año vigente: <b>{{vm.cantidadAnual;}}</b></div></div><div ng-if=\"vm.tipoSuministro && vm.tipoSuministro.inventariable && vm.bienes.length>0\"><div class=col-lg-12><br><label>Total solicitado: {{ vm.listaInventariables.length }}</label><div ng-if=vm.topeAlcanzado uib-alert><i class=\"fa fa-exclamation-circle\"></i> La cantidad despachada en el período, es igual o supera a la indicada en el tope</div><div ng-if=\"!vm.topeAlcanzado && vm.cantidadTope && vm.cantidadTope<=vm.listaInventariables.length\" uib-alert><i class=\"fa fa-exclamation-circle\"></i> Si despacha esta cantidad se alcanza el tope para este producto</div><div ng-if=vm.topeAnualAlcanzado uib-alert><i class=\"fa fa-exclamation-circle\"></i> La cantidad despachada en año el vigente, es igual o supera a la indicada en el tope.</div></div><div class=\"col-lg-12 form-group\"><label>Busque el bien por número de inventario o serie:</label><div class=col-lg-12><div class=col-lg-10><input focus-on=bien type=text ng-model=vm.bien placeholder=\"Seleccione o busque el bien por número de inventario\" uib-typeahead=\"bien as (\'N° inventario: \'+bien.inventario+\' - N° serie: \'+bien.serie+\' - Marca: \'+bien.suministro.marca.toUpperCase()) for bien in vm.filtrarBienes($viewValue)\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=col-lg-2 style=length:100%><button ng-disabled=!vm.bien class=\"btn btn-success\" ng-click=vm.agregarBienFiltrado()><span class=\"fa fa-check\"></span></button></div></div></div><div class=\"col-lg-12 form-group\"><label>Ingrese por cantidad:</label><div class=col-lg-12><div class=col-lg-10><input focus-on=cantidadBien ng-pattern=/^[1-9][0-9]*$/ type=number class=form-control ng-model=vm.cantidadInventariables placeholder=\"Ingrese la cantidad\" name=cantidadBien> <span uib-alert class=danger ng-if=vm.validarCantidadMaximaInventariables();>La cantidad supera al stock actual y/o ya seleccionado. </span><span uib-alert class=danger ng-if=\"(vm.form.cantidadBien.$error.number || vm.form.cantidadBien.$error.pattern) && vm.form.$dirty\">Ingrese un valor válido.</span></div><div class=col-lg-2 style=length:100%><button ng-disabled=\"!vm.cantidadInventariables || vm.validarCantidadMaximaInventariables()\" class=\"btn btn-primary\" ng-click=vm.agregarBienesPorCantidad()><span class=\"fa fa-plus\"></span></button></div></div></div><div class=col-lg-12 ng-if=\"vm.tipoSuministro.inventariable && vm.listaInventariables.length>0\"><table ng-table=vm.tableParamsInventariable id=table2 show-filter=true class=table><tr ng-repeat=\"bien in vm.listaInventariables track by $index\"><td data-title=\"\'Marca\'\" align=center>{{bien.suministro.marca ? bien.suministro.marca.toUpperCase() : \"-\" }}</td><td data-title=\"\'N° inventario\'\" align=center>{{bien.inventario ? bien.inventario : \"-\"}}</td><td data-title=\"\'N° serie\'\" align=center>{{bien.serie ? bien.serie : \"-\"}}</td><td data-title=\"\'Precio\'\" align=center>${{bien.suministro.precioUnitario ? bien.suministro.precioUnitario : \"-\"}}</td><td style=width:30% data-title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !bien.suministro.ubicacion.numeroOrden, \'has-success\':bien.suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(bien.suministro) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(bien.suministro)}}</div></div></td><td align=center><div class=btn-group><a class=\"btn btn-danger\" ng-click=vm.eliminar($index)><i class=\"fa fa-trash\"></i></a></div></td></tr></table></div></div><br><br></div><div class=panel-footer><div class=form-group><center><button ng-disabled=\"(vm.radio!=\'directa\' && !vm.grupo.nombre) || (vm.radio!=\'directa\' && !vm.familiaSuministro.nombre) || !vm.tipoSuministro.nombre || ((!vm.tipoSuministro.inventariable && !vm.comprobarCantidadSolicitada()) || (!vm.tipoSuministro.inventariable && (vm.form.$invalid || vm.camposForm.$invalid))) || (vm.tipoSuministro.inventariable && !vm.listaInventariables.length>0)\" class=\"btn btn-primary\" ng-click=vm.agregar()><span class=\"fa fa-plus\"></span> Agregar</button> <button type=button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/agregar-quitar-suministro-egreso-sucursal/agregar-quitar-suministro-egreso-sucursal.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Agregar o quitar suministros</div><div class=panel-body><div class=col-lg-12><div class=\"form-group col-lg-6\"><label>Depósito:</label><input type=text ng-model=vm.deposito class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-12\"><label>Sucursal:</label><input type=text ng-model=vm.sucursal.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-12\"><label>Tipo de suministro:</label><div type=text style=\"word-wrap: white\" class=\"form-control text-uppercase\" ng-readonly=true>{{vm.tipoCompleto}}</div></div></div><!-- PARA SUMINISTROS NO INVENTARIABLES!!! --><div class=col ng-if=!vm.inventariable><div class=col-lg-12><label>Suministros seleccionables:</label></div><div uib-alert type=info class=col-lg-12><label ng-style=\"vm.cantidadNoInventariableSeleccionable()==0 && {\'color\':\'red\'}\">Cantidad seleccionable: {{vm.cantidadNoInventariableSeleccionable();}}</label><br><label>Total asignado: {{ vm.cantidadAsignadaNoInventariable(); }}</label></div><div uib-alert type=success class=col-lg-12>Cantidad tope para el producto: <b>{{vm.cantidadTope? vm.cantidadTope:\"No indicado\";}}</b><br>Periodicidad del tope: <b>{{vm.periodicidad}}</b><br>Despachado a la sucursal <b>{{vm.sucursal.nombre.toUpperCase()}}</b>:<br>&nbsp;&nbsp;&nbsp;Mes vigente: <b>{{vm.cantidadMes}}</b><br>&nbsp;&nbsp;&nbsp;Consumo en el período del tope: <b>{{vm.consumoTope}}</b><br>&nbsp;&nbsp;&nbsp;Últimos 30 días: <b>{{vm.cantidadUltimos30Dias}}</b><br>&nbsp;&nbsp;&nbsp;Últimos 60 días: <b>{{vm.cantidadUltimos60Dias}}</b><br>&nbsp;&nbsp;&nbsp;Últimos 90 días: <b>{{vm.cantidadUltimos90Dias}}</b><br>&nbsp;&nbsp;&nbsp;Año vigente: <b>{{vm.cantidadAnual;}}</b></div><div class=col-lg-12 ng-if=\"!vm.inventariable && vm.cantidadNoInventariableSeleccionable()>0\"><table ng-table=vm.tableParamsNoInventariables id=table show-filter=true class=table><tr ng-repeat=\"suministro in $data track by $index\" ng-if=\"suministro.cantidad>0\"><td data-title=\"\'Marca\'\" align=center data-sortable=\"\'marca\'\">{{suministro.marca ? suministro.marca.toUpperCase() : \"-\" }}</td><td data-title=\"\'Fecha vencimiento\'\" align=center data-sortable=\"\'fechaVencimiento\'\">{{suministro.fechaVencimiento? suministro.fechaVencimiento : \"-\" | date : \"dd/MM/yyyy\" }}</td><td data-title=\"\'Precio\'\" align=center>${{suministro.precioUnitario ? suministro.precioUnitario : \"-\"}}</td><td data-title=\"\'Fecha ingreso\'\" align=center data-sortable=\"\'fecha\'\">{{suministro.fecha? suministro.fecha : \"-\" | date : \"dd/MM/yyyy\" }}</td><td data-title=\"\'Cantidad disponible\'\" align=center>{{suministro.cantidad ? suministro.cantidad : \"-\"}}</td><td style=width:30% data-title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !suministro.ubicacion.numeroOrden, \'has-success\':suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(suministro) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(suministro)}}</div></div></td><td align=center data-title=\"\'Empezado\'\">{{suministro.cantidadOriginal!=suministro.cantidad ? \"SI\": \"NO\"}}</td><td style=width:15% data-title=\"\'Cantidad solicitada\'\"><ng-form name=vm.camposForm><div><input class=form-control ng-pattern=/^[1-9][0-9]*$/ type=number name=cantidades ng-model=suministro.cantidadSolicitada placeholder=\"Ingrese cantidad\"> <span uib-alert class=danger ng-if=\"suministro.cantidadSolicitada>suministro.cantidad\">La cantidad solicitada debe ser menor o igual a la cantidad disponible. </span><span uib-alert class=danger ng-if=\"(vm.camposForm.cantidades.$error.number || vm.camposForm.cantidades.$error.pattern) && vm.camposForm.$dirty\">Ingrese un valor válido.</span></div></ng-form></td><td align=center><div class=btn-group><a class=\"btn btn-success form-group\" ng-disabled=\"!suministro.cantidadSolicitada || suministro.cantidadSolicitada<=0 || suministro.cantidadSolicitada>suministro.cantidad\" ng-click=\"!suministro.cantidadSolicitada || suministro.cantidadSolicitada<=0 || suministro.cantidadSolicitada>suministro.cantidad || vm.agregarNoInventariable(suministro)\"><i class=\"fa fa-plus\"></i></a></div></td></tr></table></div><div class=col-lg-12 ng-if=\"vm.cantidadNoInventariableSeleccionable()>0\"><div uib-alert type=danger class=col-lg-12 ng-if=\"vm.detalles.length==0\">No ha agregado ningún suministro en esta sucursal</div><div ng-if=\"vm.detalles.length>0\"><label>Suministros asignados:</label></div><div ng-if=\"vm.detalles.length>0\"><table ng-table=vm.tableParamsAsignadoNoInventariable class=\"table table-striped\" id=table1 show-filter=true><tr ng-repeat=\"item in vm.detalles track by $index\"><td data-title=\"\'Marca\'\" align=center data-sortable=\"\'marca\'\">{{item.suministro.marca ? item.suministro.marca.toUpperCase() : \"-\" }}</td><td data-title=\"\'Fecha vencimiento\'\" align=center data-sortable=\"\'fechaVencimiento\'\">{{item.suministro.fechaVencimiento? item.suministro.fechaVencimiento : \"-\" | date : \"dd/MM/yyyy\" }}</td><td data-title=\"\'Precio\'\" align=center>${{item.suministro.precioUnitario ? item.suministro.precioUnitario : \"-\"}}</td><td data-title=\"\'Fecha ingreso\'\" align=center data-sortable=\"\'fecha\'\">{{item.suministro.fecha? item.suministro.fecha : \"-\" | date : \"dd/MM/yyyy\" }}</td><td style=width:30% data-title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !item.suministro.ubicacion.numeroOrden, \'has-success\':item.suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(item.suministro) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(item.suministro)}}</div></div></td><td data-title=\"\'Cantidad solicitada\'\" align=center>{{item.cantidad ? item.cantidad : \"-\"}}</td><td data-title=\"\'Eliminar\'\" align=center><div class=btn-group><a class=\"btn btn-danger\" ng-click=vm.eliminarNoInventariable(item)><i class=\"fa fa-remove\"></i></a></div></td></tr></table></div></div></div><!-- PARA SUMINISTROS INVENTARIABLES!!! --><div class=\"col-lg-12 form-group\" ng-if=vm.inventariable><div uib-alert type=info class=col-lg-12><label>Cantidad seleccionable: {{vm.cantidadInventariableSeleccionable();}}</label><br><label>Total asignado: {{ vm.detalles.length }}</label></div><div uib-alert type=success class=col-lg-12>Cantidad tope para el producto: <b>{{vm.cantidadTope? vm.cantidadTope:\"No indicado\";}}</b><br>Periodicidad del tope: <b>{{vm.periodicidad}}</b><br>Despachado a la sucursal <b>{{vm.sucursal.nombre.toUpperCase()}}</b>:<br>&nbsp;&nbsp;&nbsp;Mes vigente: <b>{{vm.cantidadMes}}</b><br>&nbsp;&nbsp;&nbsp;Consumo en el período del tope: <b>{{vm.consumoTope}}</b><br>&nbsp;&nbsp;&nbsp;Últimos 30 días: <b>{{vm.cantidadUltimos30Dias}}</b><br>&nbsp;&nbsp;&nbsp;Últimos 60 días: <b>{{vm.cantidadUltimos60Dias}}</b><br>&nbsp;&nbsp;&nbsp;Últimos 90 días: <b>{{vm.cantidadUltimos90Dias}}</b><br>&nbsp;&nbsp;&nbsp;Año vigente: <b>{{vm.cantidadAnual;}}</b></div><div class=\"col-lg-12 form-group\"><label>Busque el bien por número de inventario o serie:</label><div class=col-lg-12><div class=col-lg-10><input focus-on=bien type=text ng-model=vm.bien placeholder=\"Seleccione o busque el bien por número de inventario\" uib-typeahead=\"bien as (\'N° inventario: \'+bien.inventario+\' - N° serie: \'+bien.serie+\' - Marca: \'+bien.suministro.marca.toUpperCase()) for bien in vm.filtrarBienes($viewValue)\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=col-lg-2 style=length:100%><button ng-disabled=!vm.bien class=\"btn btn-success\" ng-click=vm.agregarBienFiltrado()><span class=\"fa fa-check\"></span></button></div></div></div><div class=col-lg-12 ng-if=\"vm.inventariable && vm.detalles.length>0\"><div uib-alert type=danger class=col-lg-12 ng-if=\"vm.detalles.length==0\">No ha agregado ningún bien en esta sucursal</div><div class=col-lg-12 ng-if=\"vm.detalles.length>0\"><label>Bienes asignados:</label></div><table ng-table=vm.tableParamsAsignadoInventariable id=table2 show-filter=true class=table><tr ng-repeat=\"bien in vm.detalles track by $index\"><td data-title=\"\'Marca\'\" align=center>{{bien.suministro.marca ? bien.suministro.marca.toUpperCase() : \"-\" }}</td><td data-title=\"\'N° inventario\'\" align=center>{{bien.suministroInventariable.inventario ? bien.suministroInventariable.inventario : \"-\"}}</td><td data-title=\"\'N° serie\'\" align=center>{{bien.suministroInventariable.serie ? bien.suministroInventariable.serie : \"-\"}}</td><td data-title=\"\'Precio\'\" align=center>${{bien.suministro.precioUnitario ? bien.suministro.precioUnitario : \"-\"}}</td><td style=width:30% data-title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !bien.suministro.ubicacion.numeroOrden, \'has-success\':bien.suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(bien.suministro) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(bien.suministro)}}</div></div></td><td align=center><div class=btn-group><a class=\"btn btn-danger\" ng-click=vm.quitarInventariableAsignado(bien.suministroInventariable)><i class=\"fa fa-trash\"></i></a></div></td></tr></table></div></div><br><br></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-primary\" ng-click=vm.agregar()><span class=\"fa fa-plus\"></span> Aceptar</button> <button type=button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/agregar-suministro-egreso-cajas/modal-agregar-suministro-egreso-cajas.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Busque el número de caja cerrada</div><div class=panel-body><div class=col-lg-12><div class=col-lg-8><div class=form-group><label ng-if=!vm.bandera>Número de caja cerrada:</label><label ng-if=vm.bandera>Número de caja ingresado:</label><input type=text ng-disabled=vm.bandera placeholder=\"Ingrese número de caja cerrada\" class=form-control required ng-model=vm.numeroCaja></div></div><br><div class=col-lg-4 ng-if=!vm.bandera><button style=width:100% class=\"btn btn-primary\" ng-disabled=!vm.numeroCaja ng-click=vm.comprobarNumeroCaja();><i class=\"fa fa-search\"></i> Comprobar número</button></div><div class=col-lg-4 ng-if=vm.bandera><button style=width:100% class=\"btn btn-warning\" ng-click=vm.cambiarNumero();><i class=\"fa fa-exchange\"></i> Cambiar número</button></div><br><br><div class=col-lg-12 ng-if=\"vm.numeroComprobado==true\"><div uib-alert type=success><i class=\"fa fa-check\"></i> Caja encontrada</div></div></div><div class=col-lg-12 ng-show=\"vm.detallesInventariables.length>0\"><table ng-table=vm.tableParamsCajas class=\"table table-hover\" ng-init=\"pallet.$hideRows = true\" show-group=false><tr class=ng-table-group ng-repeat-start=\"pallet in $data\"><td colspan=4><a href=\"\" ng-click=\"pallet.$hideRows = !pallet.$hideRows\"><span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': pallet.$hideRows, \'glyphicon-chevron-down\': !pallet.$hideRows }\"></span> Caja cerrada N° {{pallet.numeroCaja}}<br>Tipo de suministro: {{ pallet.tipoSuministro.nombre.toUpperCase() }}<br>Familia de suministro: {{ pallet.tipoSuministro.familiaSuministro.nombre.toUpperCase();}}</a></td><td style=width:35% title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\"><label class=control-label>Ubicación</label><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(pallet)>{{pallet.ubicacion? vm.ubicacionNaveNumeroOrden(pallet) : \"No asignó ninguna.\" }}</div><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i></div></td><td title=\"Cantidad solicitada\">Cantidad solicitada total: {{pallet.cantidad}}</td><td title=\"Precio total\">Precio total: <b>${{pallet.precioTotal}}</b></td></tr><tr ng-hide=pallet.$hideRows ng-repeat=\"detalle in pallet.detalles\" ng-repeat-end><td title=\"\'Marca\'\" align=center>{{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'N° serie\'\" align=center>{{detalle.suministroInventariable.serie ? detalle.suministroInventariable.serie : \"-\" }}</td><td title=\"\'N° inventario\'\" align=center>{{detalle.suministroInventariable.inventario ? detalle.suministroInventariable.inventario : \"-\" }}</td><td title=\"\'Precio\'\" align=center>${{detalle.suministro.precioUnitario}}</td></tr></table></div></div><div class=panel-footer><div class=form-group><center><button ng-disabled=\"vm.form.$invalid || vm.detallesInventariables.length==0\" class=\"btn btn-primary\" ng-click=vm.agregar()><span class=\"fa fa-plus\"></span> Agregar</button> <button type=button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/agregar-suministro-ingreso/modal-agregar-suministro-ingreso.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Ingrese los suministros</div><div class=panel-body><div><label>Búsqueda jerarquizada:</label><div class=col-lg-12><div class=col-lg-1><div class=form-group><input type=radio ng-model=vm.radio value=jerarquizada ng-change=vm.cambioRadio()></div></div><div class=col-lg-11><div class=\"form-group col-lg-6\"><label>Grupo de suministro:</label><input type=text ng-disabled=\"vm.radio!=\'jerarquizada\'\" ng-model=vm.grupo placeholder=\"Seleccione o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase()+\' (\'+grupo.empresa.nombre.toUpperCase()+\')\' for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Familia de suministro:</label><input ng-disabled=\"!vm.grupo.nombre || vm.radio!=\'jerarquizada\'\" focus-on=familia type=text ng-model=vm.familiaSuministro placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familiaSuministro as familiaSuministro.nombre.toUpperCase() for familiaSuministro in vm.familias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-12\"><label>Tipo de suministro:</label><input ng-if=\"vm.radio==\'jerarquizada\'\" ng-disabled=\"!vm.grupo.nombre || !vm.familiaSuministro.nombre || vm.radio!=\'jerarquizada\'\" type=text focus-on=tipo ng-model=vm.tipoSuministro placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase() for suministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <input ng-if=\"vm.radio==\'directa\'\" ng-disabled=\"!vm.grupo.nombre || !vm.familiaSuministro.nombre || vm.radio!=\'jerarquizada\'\" type=text focus-on=tipo ng-model=vm.tipoSuministro1 placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase() for suministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div><div><label>Búsqueda directa:</label><div class=col-lg-12 ng-disabled=\"\"><div class=\"form-group col-lg-1\"><input type=radio ng-model=vm.radio value=directa ng-change=vm.cambioRadio()></div><div class=\"form-group col-lg-11\"><label>Tipo de suministro:</label><input type=text ng-disabled=\"vm.radio!=\'directa\'\" ng-model=vm.tipoSuministroCompleto placeholder=\"Seleccione o busque el tipo de suministro por su nombre\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase()+\' (\'+suministro.familiaSuministro.nombre.toUpperCase()+\') - (\'+suministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+\')\' for suministro in vm.tiposCompletos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div><div class=col-lg-12 ng-if=vm.caja><div class=col-lg-8><div class=form-group><label ng-if=!vm.bandera>Número de caja cerrada:</label><label ng-if=vm.bandera>Número de caja ingresado:</label><input type=text ng-disabled=vm.bandera placeholder=\"Ingrese número de caja cerrada\" class=form-control required ng-model=vm.numeroCaja></div></div><br><div class=col-lg-4 ng-if=!vm.bandera><button style=width:100% class=\"btn btn-primary\" ng-disabled=!vm.numeroCaja ng-click=vm.comprobarNumeroCaja();><i class=\"fa fa-search\"></i> Comprobar</button></div><div class=col-lg-4 ng-if=vm.bandera><button style=width:100% class=\"btn btn-warning\" ng-click=vm.cambiarNumero();><i class=\"fa fa-exchange\"></i> Cambiar número</button></div><br><br><div class=col-lg-12 ng-if=\"vm.numeroComprobado==true\"><div uib-alert type=success><i class=\"fa fa-check\"></i> El número de caja está disponible</div></div></div><div uib-alert class=col-lg-12 ng-if=\"vm.caja && vm.tipoSuministro && !vm.tipoSuministro.inventariable\">Si es una caja cerrada, debe ingresar suministros inventariables</div><div class=col-lg-12 ng-if=vm.tipoSuministro.id><center><button ng-click=vm.verFoto(); ng-disabled=!vm.tipoSuministro.encabezadoFoto class=\"btn btn-primary\"><i class=\"fa fa-photo\"></i> Ver imagen del tipo de suministro elegido</button><br><br></center></div><!-- PARA SUMINISTROS NO INVENTARIABLES!!! --><div class=col-lg-4 ng-if=\"!vm.caja && vm.tipoSuministro && !vm.tipoSuministro.inventariable\"><label>Marca:</label><input class=form-control ng-maxlength=100 type=text name=marca ng-model=vm.marca> <span uib-alert class=danger ng-if=\"vm.form.marca.$error.maxlength && vm.form.marca.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><div class=col-lg-4 ng-if=\"!vm.caja && vm.tipoSuministro && !vm.tipoSuministro.inventariable\"><label>Fecha vencimiento:</label><input type=date name=fechaVencimiento class=form-control ng-model=vm.fechaVencimiento> <span uib-alert class=danger ng-if=\"vm.form.fechaVencimiento.$error.date && vm.form.fechaVencimiento.$dirty\">La fecha ingresada no es válida.</span></div><div class=col-lg-4 ng-if=\"!vm.caja && vm.tipoSuministro && !vm.tipoSuministro.inventariable\"><label>Precio unitario:</label><div class=input-group><input class=form-control min=0 ng-min=0.01 ng-maxlength=15 ng-model=vm.precioUnitario placeholder=\"Ingrese el precio por unidad\" type=number name=precioUnitario required ng-pattern=/^[0-9]+(\\.[0-9]{1,2})?$/ step=0.01><div class=input-group-btn><button class=\"btn btn-default\" ng-click=vm.obtenerUltimoPrecio()><i class=\"glyphicon glyphicon-search\"></i></button></div></div><span uib-alert class=danger ng-show=\"vm.form.precioUnitario.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-show=\"vm.form.precioUnitario.$error.number && vm.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.precioUnitario.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 15 caracteres. </span><span uib-alert class=danger ng-if=\"vm.form.precioUnitario.$error.pattern && vm.form.$dirty\">Este campo no puede tener mas de 2 decimales. </span><span uib-alert class=danger ng-if=\"vm.form.precioUnitario.$error.min && vm.form.$dirty\">Este campo no puede tener valores negativos.</span></div><div class=col-lg-8 ng-if=\"!vm.caja && vm.tipoSuministro && !vm.tipoSuministro.inventariable\"><br><label>Cantidad de pallets:</label><input class=form-control ng-maxlength=2 ng-model=vm.cantidadPallets placeholder=\"Cantidad de pallets\" type=number name=cantidadPallets ng-pattern=/^[1-9][0-9]{0}/ required> <span uib-alert class=danger ng-if=\"vm.form.cantidadPallets.$error.required && vm.form.cantidadPallets.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.cantidadPallets.$error.maxlength && vm.form.cantidadPallets.$dirty\">Este campo no puede superar los 3 caracteres. </span><span uib-alert class=danger ng-if=\"(vm.form.cantidadPallets.$error.number || vm.form.cantidadPallets.$error.pattern) && vm.form.$dirty\">Ingrese un valor válido.</span></div><div class=col-lg-4 ng-show=\"!vm.caja && vm.tipoSuministro && !vm.tipoSuministro.inventariable\"><br><br><button ng-disabled=\"vm.cantidadPallets<1\" class=\"btn btn-primary\" ng-click=vm.cantidadPorPallets()><span class=\"fa fa-check\"></span> Confirmar</button></div><div class=col-lg-12 ng-if=\"vm.campos.length>0\"><br><label>Total: {{ vm.totalSuministros() }}</label></div><br><table id=table1 class=table show-filter=true ng-if=\"!vm.tipoSuministro.inventariable && vm.campos.length>0\"><tr ng-repeat=\"cantidades in vm.campos | orderBy:\'-\'\" ng-if=\"vm.campos.length>0\"><td><ng-form name=camposForm><label class=col-lg-12>Pallet {{$index+1}}</label><br><div class=col-lg-4><label>Cantidad por pallet:</label><input class=form-control ng-pattern=/^[1-9][0-9]*$/ type=number name=cantidades ng-model=cantidades.cantidad required> <span uib-alert class=danger ng-if=\"camposForm.cantidades.$error.required && camposForm.cantidades.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"(camposForm.cantidades.$error.number || camposForm.cantidades.$error.pattern) && camposForm.$dirty\">Ingrese un valor válido.</span></div></ng-form></td></tr></table><div class=col-lg-12><span uib-alert class=danger ng-if=\"!vm.comprobarCantidadPorPallets() && vm.campos.length>0\">Debe completar las cantidades en todos los pallets.</span></div><!-- PARA SUMINISTROS INVENTARIABLES!!! --><div class=col-lg-12><span uib-alert type=success ng-if=\"!vm.caja && vm.tipoSuministro && vm.tipoSuministro.inventariable\">Los ingresos de suministros inventariables, se cargan de manera individual.</span></div><div class=\"col-lg-12 form-group\" ng-if=\"(vm.caja && vm.numeroCaja && vm.numeroComprobado==true) && vm.tipoSuministro && vm.tipoSuministro.inventariable || (!vm.caja && vm.tipoSuministro && vm.tipoSuministro.inventariable)\"><div class=\"col-lg-12 form-group\"><div class=form-group><input type=radio ng-model=vm.buscar.valor value=inventario ng-click=vm.limpiar()><label>Buscar bien por número de inventario o serie:</label></div><div class=col><div class=\"form-group col-lg-6\"><input ng-disabled=\"vm.buscar.valor!=\'inventario\'\" focus-on=bien type=text ng-model=vm.bien placeholder=\"Seleccione o busque el bien por número de inventario\" uib-typeahead=\"bien as (\'N° inventario: \'+bien.inventario+\' - N° serie: \'+bien.serie+\' - Marca: \'+bien.suministro.marca.toUpperCase()) for bien in vm.filtrarBienes($viewValue)\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-4\"><input ng-disabled=\"vm.buscar.valor!=\'inventario\'\" focus-on=sucursal type=text ng-model=vm.sucursalBien placeholder=\"Seleccione o busque la sucursal de origen\" uib-typeahead=\"sucursal as sucursal.nombre.toUpperCase() for sucursal in vm.sucursales | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-1\"><label>¿Nuevo?</label><input type=checkbox ng-model=vm.nuevo></div><div class=\"form-group col-lg-1\"><button ng-disabled=\"vm.buscar.valor!=\'inventario\' || !vm.bien\" class=\"btn btn-success\" ng-click=vm.agregarBienFiltrado()><span class=\"fa fa-check\"></span></button></div></div></div><div class=\"col-lg-12 form-group\"><div class=form-group><input type=radio ng-model=vm.buscar.valor value=nuevo ng-click=vm.limpiar()><label>Ingresar bien nuevo:</label></div><div class=col><div class=col-lg-2><label>Marca:</label><input type=text focus-on=marca ng-disabled=\"vm.buscar.valor!=\'nuevo\'\" class=form-control placeholder=Marca ng-model=vm.nuevoBien.marca name=marcaBien required> <span uib-alert class=danger ng-show=\"vm.buscar.valor==\'nuevo\' && vm.form.marcaBien.$error.required && vm.form.marcaBien.$dirty\">Campo requerido.</span></div><div class=col-lg-2><label>N° inventario:</label><input type=number ng-disabled=\"vm.buscar.valor!=\'nuevo\'\" class=form-control placeholder=\"N° inventario\" ng-pattern=/^[0-9]{0}/ ng-model=vm.nuevoBien.inventario required name=inventario> <span uib-alert class=danger ng-show=\"vm.buscar.valor==\'nuevo\' && vm.form.inventario.$error.required && vm.form.inventario.$dirty\">Campo requerido. </span><span uib-alert class=danger ng-if=\"vm.buscar.valor==\'nuevo\' && vm.form.inventario.$error.pattern && vm.form.inventario.$dirty\">Valor inválido. </span><span uib-alert class=danger ng-if=\"vm.buscar.valor==\'nuevo\' && vm.form.inventario.$error.number && vm.form.inventario.$dirty\">Valor inválido.</span></div><div class=col-lg-2><label>N° serie:</label><input type=text ng-disabled=\"vm.buscar.valor!=\'nuevo\'\" placeholder=\"N° serie\" class=form-control ng-model=vm.nuevoBien.serie name=serieBien required> <span uib-alert class=danger ng-show=\"vm.buscar.valor==\'nuevo\' && vm.form.serieBien.$error.required && vm.form.serieBien.$dirty\">Campo requerido.</span></div><div class=col-lg-2><label>Precio:</label><div class=input-group><input ng-disabled=\"vm.buscar.valor!=\'nuevo\'\" class=form-control min=0 ng-min=0.01 ng-maxlength=15 ng-model=vm.nuevoBien.precio placeholder=Precio type=number name=precioBien required ng-pattern=/^[0-9]+(\\.[0-9]{1,2})?$/ step=0.01><div class=input-group-btn><button class=\"btn btn-default\" ng-click=vm.obtenerUltimoPrecio() ng-disabled=\"vm.buscar.valor!=\'nuevo\'\"><i class=\"glyphicon glyphicon-search\"></i></button></div></div><span uib-alert class=danger ng-show=\"vm.buscar.valor==\'nuevo\' && vm.form.precioBien.$error.required && vm.form.precioBien.$dirty\">Campo requerido. </span><span uib-alert class=danger ng-show=\"vm.buscar.valor==\'nuevo\' && vm.form.precioBien.$error.number && vm.form.precioBien.$dirty\">Valor inválido. </span><span uib-alert class=danger ng-if=\"vm.buscar.valor==\'nuevo\' && vm.form.precioBien.$error.maxlength && vm.form.precioBien.$dirty\">Longitud máxima. </span><span uib-alert class=danger ng-if=\"vm.buscar.valor==\'nuevo\' && vm.form.precioBien.$error.pattern && vm.form.precioBien.$dirty\">Valor inválido. </span><span uib-alert class=danger ng-if=\"vm.buscar.valor==\'nuevo\' && vm.form.precioBien.$error.min && vm.form.precioBien.$dirty\">Valor negativo.</span></div><div class=col-lg-2><label>Sucursal anterior</label><input ng-disabled=\"vm.buscar.valor!=\'nuevo\'\" type=text ng-model=vm.sucursalNuevo placeholder=\"Seleccione o busque la sucursal de origen\" uib-typeahead=\"sucursal as sucursal.nombre.toUpperCase() for sucursal in vm.sucursales | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=col-lg-1><label>¿Nuevo?</label><center><input type=checkbox ng-model=vm.nuevoBien.nuevo checked></center></div><div class=col-lg-1><button ng-disabled=\"vm.buscar.valor!=\'nuevo\' || vm.form.$invalid\" class=\"btn btn-success\" ng-click=vm.agregarNuevoBien()><span class=\"fa fa-check\"></span></button></div></div></div><div class=col-lg-12 ng-if=\"vm.tipoSuministro.inventariable && vm.listaInventariables.length>0\"><table ng-table=vm.tableParams id=table2 show-filter=true class=table><tr ng-repeat=\"bien in vm.listaInventariables track by $index\"><td data-title=\"\'Marca\'\" align=center>{{bien.suministro.marca ? bien.suministro.marca.toUpperCase() : \"-\" }}</td><td data-title=\"\'N° inventario\'\" align=center>{{bien.inventario ? bien.inventario : \"-\"}}</td><td data-title=\"\'N° serie\'\" align=center>{{bien.serie ? bien.serie : \"-\"}}</td><td data-title=\"\'Precio\'\" align=center>${{bien.suministro.precioUnitario ? bien.suministro.precioUnitario : \"-\"}}</td><td data-title=\"\'Sucursal de origen\'\" align=center>{{bien.sucursal ? bien.sucursal.nombre.toUpperCase() : \"-\"}}</td><td data-title=\"\'¿Nuevo?\'\" align=center>{{bien.nuevo? \"SI\" : \"NO\" }}</td><td align=center><div class=btn-group><a class=\"btn btn-danger\" ng-click=vm.eliminar($index)><i class=\"fa fa-trash\"></i></a></div></td></tr></table></div></div><br><br></div><div class=panel-footer><div class=form-group><center><button ng-disabled=\"(vm.radio!=\'directa\' && !vm.grupo.nombre) || (vm.radio!=\'directa\' && !vm.familiaSuministro.nombre) || !vm.tipoSuministro.nombre || ((!vm.tipoSuministro.inventariable && !vm.comprobarCantidadPorPallets()) || (!vm.tipoSuministro.inventariable && !vm.campos.length>0) || (!vm.tipoSuministro.inventariable && vm.form.$invalid)) || (vm.tipoSuministro.inventariable && !vm.listaInventariables.length>0) || (vm.caja && !vm.numeroCaja && !vm.numeroComprobado)\" class=\"btn btn-primary\" ng-click=vm.agregar()><span class=\"fa fa-plus\"></span> Agregar</button> <button type=button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/agregar-suministro-ingreso-conciliacion/modal-agregar-suministro-ingreso-conciliacion.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Seleccione el suministro</div><div class=panel-body><div><label>Búsqueda jerarquizada:</label><div class=col-lg-12><div class=col-lg-1><div class=form-group><input type=radio ng-model=vm.radio value=jerarquizada ng-change=vm.cambioRadio()></div></div><div class=col-lg-11><div class=\"form-group col-lg-6\"><label>Grupo de suministro:</label><input type=text ng-disabled=\"vm.radio!=\'jerarquizada\'\" ng-model=vm.grupo placeholder=\"Seleccione o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase()+\' (\'+grupo.empresa.nombre.toUpperCase()+\')\' for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Familia de suministro:</label><input ng-disabled=\"!vm.grupo.nombre || vm.radio!=\'jerarquizada\'\" focus-on=familia type=text ng-model=vm.familiaSuministro placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familiaSuministro as familiaSuministro.nombre.toUpperCase() for familiaSuministro in vm.familias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-12\"><label>Tipo de suministro:</label><input ng-if=\"vm.radio==\'jerarquizada\'\" ng-disabled=\"!vm.grupo.nombre || !vm.familiaSuministro.nombre || vm.radio!=\'jerarquizada\'\" type=text focus-on=tipo ng-model=vm.tipoSuministro placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase() for suministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <input ng-if=\"vm.radio==\'directa\'\" ng-disabled=\"!vm.grupo.nombre || !vm.familiaSuministro.nombre || vm.radio!=\'jerarquizada\'\" type=text ng-model=vm.tipoSuministro1 placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase() for suministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div><div><label>Búsqueda directa:</label><div class=col-lg-12 ng-disabled=\"\"><div class=\"form-group col-lg-1\"><input type=radio ng-model=vm.radio value=directa ng-change=vm.cambioRadio()></div><div class=\"form-group col-lg-11\"><label>Tipo de suministro:</label><input type=text ng-disabled=\"vm.radio!=\'directa\'\" ng-model=vm.tipoSuministroCompleto placeholder=\"Seleccione o busque el tipo de suministro por su nombre\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase()+\' (\'+suministro.familiaSuministro.nombre.toUpperCase()+\') - (\'+suministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+\')\' for suministro in vm.tiposCompletos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div><div class=col-lg-12 uib-alert ng-if=\"vm.tipoSuministro && vm.tipoSuministro.inventariable\">Debe seleccionar un tipo de suministro no inventariable.</div><div class=col-lg-12 ng-if=vm.tipoSuministro.id><center><button ng-click=vm.verFoto(); ng-disabled=!vm.tipoSuministro.encabezadoFoto class=\"btn btn-primary\"><i class=\"fa fa-photo\"></i> Ver imagen del tipo de suministro elegido</button><br><br></center></div><!-- PARA SUMINISTROS NO INVENTARIABLES!!! --><div class=col ng-if=\"vm.tipoSuministro && !vm.tipoSuministro.inventariable\"><div class=col-lg-12 ng-if=\"vm.tipoSuministro && !vm.tipoSuministro.inventariable && vm.listaNoInventariables.length>0\"><br><label>Total a conciliar: {{ vm.totalSuministros() }}</label></div><div class=\"col-lg-12 panel panel-footer\" ng-if=!vm.tipoSuministro.inventariable><div><div class=col-lg-4><label>Marca:</label><input class=form-control ng-readonly=vm.ban ng-maxlength=100 type=text name=marca ng-model=vm.suministro.marca> <span uib-alert class=danger ng-if=\"vm.form.marca.$error.maxlength && vm.form.marca.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><div class=col-lg-4><label>Fecha vencimiento:</label><input type=date name=fechaVencimiento class=form-control ng-model=vm.suministro.fechaVencimiento ng-readonly=vm.ban> <span uib-alert class=danger ng-if=\"vm.form.fechaVencimiento.$error.date && vm.form.fechaVencimiento.$dirty\">La fecha ingresada no es válida.</span></div><div class=col-lg-4><label>Precio unitario:</label><input class=form-control min=0 ng-min=0.01 ng-maxlength=15 ng-model=vm.suministro.precioUnitario placeholder=\"Ingrese el precio por unidad\" type=number name=precioUnitario required ng-pattern=/^[0-9]+(\\.[0-9]{1,2})?$/ step=0.01 ng-readonly=vm.ban> <span uib-alert class=danger ng-show=\"vm.form.precioUnitario.$error.required && vm.form.precioUnitario.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-show=\"vm.form.precioUnitario.$error.number && vm.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.precioUnitario.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 15 caracteres. </span><span uib-alert class=danger ng-if=\"vm.form.precioUnitario.$error.pattern && vm.form.$dirty\">Este campo no puede tener mas de 2 decimales. </span><span uib-alert class=danger ng-if=\"vm.form.precioUnitario.$error.min && vm.form.$dirty\">Este campo no puede tener valores negativos.</span></div><div class=col-lg-8><label>Cantidad para conciliar:</label><input class=form-control ng-pattern=/^[1-9][0-9]*$/ type=number name=cantidadSolicitada ng-model=vm.cantidadSolicitada required> <span uib-alert class=danger ng-if=\"vm.form.cantidadSolicitada.$error.required && vm.form.cantidadSolicitada.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"(vm.form.cantidadSolicitada.$error.number || vm.form.cantidadSolicitada.$error.pattern) && vm.form.cantidadSolicitada.$dirty\">Ingrese un valor válido.</span></div><div class=col-lg-4 ng-if=!vm.ban><br><button class=\"btn btn-success\" ng-disabled=vm.form.$invalid ng-click=\"vm.ban=!vm.ban\"><i class=\"fa fa-check\"></i> Confirmar</button></div><div class=col-lg-4 ng-if=vm.ban><br><button class=\"btn btn-warning\" ng-click=\"vm.ban=!vm.ban\"><i class=\"fa fa-exchange\"></i> Cambiar</button></div></div></div></div><div class=col-lg-12 ng-if=vm.ban><br><center><div><button style=width:60% class=\"btn btn-primary\" ng-disabled=!vm.ban ng-click=vm.asignarIndividual()><i class=\"fa fa-map-marker\"></i> Asignar ubicación</button></div></center><br><div class=col-lg-10><label>Ubicación:</label><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !vm.suministro.ubicacion.numeroOrden, \'has-success\':vm.suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta() class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden()}}</div></div></div><div class=col-lg-2><label>¿Ocupar ubicación?</label><input type=checkbox ng-model=vm.ocuparUbicacion></div></div><br></div><div class=panel-footer><div class=form-group><center><button ng-disabled=\"vm.form.$invalid || !vm.cantidadSolicitada || !vm.suministro.ubicacion.id\" class=\"btn btn-primary\" ng-click=vm.agregar()><span class=\"fa fa-plus\"></span> Agregar</button> <button type=button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/agregar-suministro-egreso-conciliacion/modal-agregar-suministro-egreso-conciliacion.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Seleccione el suministro</div><div class=panel-body><div><label>Búsqueda jerarquizada:</label><div class=col-lg-12><div class=col-lg-1><div class=form-group><input type=radio ng-model=vm.radio value=jerarquizada ng-change=vm.cambioRadio()></div></div><div class=col-lg-11><div class=\"form-group col-lg-6\"><label>Grupo de suministro:</label><input type=text ng-disabled=\"vm.radio!=\'jerarquizada\'\" ng-model=vm.grupo placeholder=\"Seleccione o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase()+\' (\'+grupo.empresa.nombre.toUpperCase()+\')\' for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Familia de suministro:</label><input ng-disabled=\"!vm.grupo.nombre || vm.radio!=\'jerarquizada\'\" focus-on=familia type=text ng-model=vm.familiaSuministro placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familiaSuministro as familiaSuministro.nombre.toUpperCase() for familiaSuministro in vm.familias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-12\"><label>Tipo de suministro:</label><input ng-if=\"vm.radio==\'jerarquizada\'\" ng-disabled=\"!vm.grupo.nombre || !vm.familiaSuministro.nombre || vm.radio!=\'jerarquizada\'\" type=text focus-on=tipo ng-model=vm.tipoSuministro placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase() for suministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <input ng-if=\"vm.radio==\'directa\'\" ng-disabled=\"!vm.grupo.nombre || !vm.familiaSuministro.nombre || vm.radio!=\'jerarquizada\'\" type=text ng-model=vm.tipoSuministro1 placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase() for suministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div><div><label>Búsqueda directa:</label><div class=col-lg-12 ng-disabled=\"\"><div class=\"form-group col-lg-1\"><input type=radio ng-model=vm.radio value=directa ng-change=vm.cambioRadio()></div><div class=\"form-group col-lg-11\"><label>Tipo de suministro:</label><input type=text ng-disabled=\"vm.radio!=\'directa\'\" ng-model=vm.tipoSuministroCompleto placeholder=\"Seleccione o busque el tipo de suministro por su nombre\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase()+\' (\'+suministro.familiaSuministro.nombre.toUpperCase()+\') - (\'+suministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+\')\' for suministro in vm.tiposCompletos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div><div class=col-lg-12 uib-alert ng-if=vm.tipoRepetido>El tipo de suministro que seleccionó ya fue ingresado. Si desea editar, debe eliminar la selección previa de este tipo de suministro.</div><div class=col-lg-12 uib-alert ng-if=\"vm.tipoSuministro && vm.tipoSuministro.inventariable\">Debe seleccionar un tipo de suministro no inventariable.</div><div class=col-lg-12 ng-if=vm.tipoSuministro.id><center><button ng-click=vm.verFoto(); ng-disabled=!vm.tipoSuministro.encabezadoFoto class=\"btn btn-primary\"><i class=\"fa fa-photo\"></i> Ver imagen del tipo de suministro elegido</button><br><br></center></div><!-- PARA SUMINISTROS NO INVENTARIABLES!!! --><div class=col-lg-12 uib-alert ng-if=\"vm.tipoSuministro && !vm.tipoSuministro.inventariable && vm.cantidadStockTipo()==0\">No hay stock de este tipo de suministro en el depósito.</div><div class=col ng-if=\"vm.tipoSuministro && !vm.tipoSuministro.inventariable && vm.cantidadTotalStockTipo>0\"><div uib-alert type=info class=col-lg-12><label>Stock en depósito: {{vm.cantidadStockTipo();}}</label><br><label>Stock mínimo: {{vm.tipoSuministro.stockMinimo}}</label><br><label>Stock total: {{vm.cantidadTotalStockTipo;}}</label></div><div class=col-lg-12 ng-if=\"vm.tipoSuministro && !vm.tipoSuministro.inventariable && vm.cantidadStockTipo()>0\"><br><label>Total a conciliar: {{ vm.totalSuministros() }}</label></div><div class=col-lg-12 ng-if=\"!vm.tipoSuministro.inventariable && vm.cantidadStockTipo()>0\"><table ng-table=vm.tableParams id=table show-filter=true class=table><tr ng-repeat=\"suministro in $data track by $index\" ng-if=\"suministro.cantidad>0\"><td data-title=\"\'Marca\'\" align=center data-sortable=\"\'marca\'\">{{suministro.marca ? suministro.marca.toUpperCase() : \"-\" }}</td><td data-title=\"\'Fecha vencimiento\'\" align=center data-sortable=\"\'fechaVencimiento\'\">{{suministro.fechaVencimiento? suministro.fechaVencimiento : \"-\" | date : \"dd/MM/yyyy\" }}</td><td data-title=\"\'Precio\'\" align=center>${{suministro.precioUnitario ? suministro.precioUnitario : \"-\"}}</td><td data-title=\"\'Fecha ingreso\'\" align=center data-sortable=\"\'fecha\'\">{{suministro.fecha? suministro.fecha : \"-\" | date : \"dd/MM/yyyy\" }}</td><td data-title=\"\'Cercanía\'\" align=center data-sortable=\"\'cercania\'\">{{suministro.cercania ? suministro.cercania : \"-\" }}</td><td data-title=\"\'Cantidad disponible\'\" align=center>{{suministro.cantidad ? suministro.cantidad : \"-\"}}</td><td style=width:30% data-title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !suministro.ubicacion.numeroOrden, \'has-success\':suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(suministro) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(suministro)}}</div></div></td><td align=center data-title=\"\'Empezado\'\">{{suministro.cantidadOriginal!=suministro.cantidad ? \"SI\": \"NO\"}}</td><td style=width:15% data-title=\"\'Cantidad solicitada\'\"><ng-form name=vm.camposForm><div><input class=form-control ng-pattern=/^[1-9][0-9]*$/ type=number name=cantidades ng-model=suministro.cantidadSolicitada placeholder=\"Ingrese cantidad\"> <span uib-alert class=danger ng-if=\"suministro.cantidadSolicitada>suministro.cantidad\">La cantidad solicitada debe ser menor o igual a la cantidad disponible. </span><span uib-alert class=danger ng-if=\"(vm.camposForm.cantidades.$error.number || vm.camposForm.cantidades.$error.pattern) && vm.camposForm.$dirty\">Ingrese un valor válido.</span></div></ng-form></td></tr></table></div></div><br><br></div><div class=panel-footer><div class=form-group><center><button ng-disabled=\"(vm.radio!=\'directa\' && !vm.grupo.nombre) || (vm.radio!=\'directa\' && !vm.familiaSuministro.nombre) || !vm.tipoSuministro.nombre || ((!vm.tipoSuministro.inventariable && !vm.comprobarCantidadSolicitada()) || (!vm.tipoSuministro.inventariable && (vm.form.$invalid || vm.camposForm.$invalid))) || (vm.tipoSuministro.inventariable && !vm.listaInventariables.length>0)\" class=\"btn btn-primary\" ng-click=vm.agregar()><span class=\"fa fa-plus\"></span> Agregar</button> <button type=button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/agregar-suministros-egreso-pedido/agregar-suministros-egreso-pedido.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Agregar suministros - Pedidos</div><div class=panel-body><div class=\"form-group col-lg-6\"><label>Deposito:</label><input type=text ng-model=vm.deposito.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.sucursal.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-8\"><label>Sucursal:</label><input type=text ng-readonly=true ng-model=vm.sucursal.nombre class=\"form-control text-uppercase\" name=sucursal></div><div class=\"form-group col-lg-4\"><label>N° Pedido:</label><div class=input-group><input type=text ng-readonly=true ng-model=vm.pedido.numeroPedido class=\"form-control text-uppercase\" name=pedido><div class=input-group-btn><button class=\"btn btn-default\" ng-click=vm.visualizarPedido()><i class=\"fa fa-search\"></i></button></div></div></div><div class=\"col-lg-12 form-group\" ng-if=\"vm.pedido.detalles.length>0\"><br><center><div class=col-lg-12><button class=\"btn btn-primary\" ng-click=vm.asignarSuministrosAutomaticamente();><i class=\"fa fa-magic\"></i> Asignar suministros automáticamente</button></div></center><br><label>Detalles del pedido:</label><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.pedido.detalles.length>0\"><tr ng-repeat=\"tipo in $data\" ng-disabled=tipo.ocupado ng-class=\"{\'rojo-claro\':tipo.ocupado, \'verde-claro\':!tipo.ocupado&&tipo.cantidadSolicitada>0}\"><td title=\"\'Grupo suministro\'\" align=center>{{tipo.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase();}} - ({{tipo.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase()}})</td><td title=\"\'Familia suministro\'\" align=center>{{tipo.tipoSuministro.familiaSuministro.nombre.toUpperCase();}}</td><td title=\"\'Tipo suministro\'\" align=center>{{tipo.tipoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Cantidad pedido\'\" align=center>{{tipo.cantidad}}</td><td data-title=\"\'Cantidad seleccionada\'\">{{tipo.cantidadSolicitada>0? tipo.cantidadSolicitada+\" \" : \"0 \"}} <button class=\"btn btn-info\" ng-click=\"tipo.ocupado || tipo.cantidadSolicitada<=0 || (tipo.cantidadSolicitada==undefined || tipo.cantidadSolicitada==null || tipo.cantidadSolicitad<=0) || vm.mostrarSuministrosAsignados(tipo);\" ng-disabled=\"tipo.ocupado || tipo.cantidadSolicitada<=0 || (tipo.cantidadSolicitada==undefined || tipo.cantidadSolicitada==null || tipo.cantidadSolicitad<=0)\"><i class=\"fa fa-search\"></i></button></td><td title=\"\'Acciones\'\" style=width:20% align=center><div class=btn-group><a class=\"btn btn-primary\" ng-click=\"tipo.ocupado || vm.asignarSuministros(tipo)\" ng-disabled=tipo.ocupado><i class=\"fa fa-plus\"></i> Asignar o quitar suministros</a></div></td></tr></table></div></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-primary\" ng-click=vm.comprobarAgregar()><span class=\"glyphicon glyphicon-plus\"></span> Agregar</button> <button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cerrar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/agregar-suministros/modal-agregar-suministro.html","<div><form name=mod.form><div class=\"panel panel-default\"><div class=panel-heading>Agregar suministros..</div><div class=panel-body><div class=\"form-group col-lg-6\"><label>Grupo de suministro:</label><input type=text ng-model=mod.grupo placeholder=\"Seleccione o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase()+\' (\'+grupo.empresa.nombre.toUpperCase()+\')\' for grupo in mod.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Familia de suministro:</label><input ng-disabled=!mod.grupo.nombre type=text ng-model=mod.familiaSuministro placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familiaSuministro as familiaSuministro.nombre.toUpperCase() for familiaSuministro in mod.familias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-8\"><label>Suministro:</label><input ng-disabled=\"!mod.grupo.nombre || !mod.familiaSuministro.nombre\" type=text ng-model=mod.suministro placeholder=\"Seleccione o busque el suministro\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase() for suministro in mod.suministros | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"col-lg-4 form-group\"><label>Cantidad:</label><input class=form-control ng-maxlength=2 ng-model=mod.cantidad placeholder=Cantidad type=number name=cantidad ng-pattern=/^[1-9][0-9]{0}/ required> <span uib-alert class=danger ng-if=\"mod.form.cantidad.$error.required && mod.form.cantidad.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"mod.form.cantidad.$error.maxlength && mod.form.cantidad.$dirty\">Este campo no puede superar los 3 caracteres. </span><span uib-alert class=danger ng-if=\"(mod.form.cantidad.$error.number || mod.form.cantidad.$error.pattern) && mod.form.$dirty\">Ingrese un valor válido.</span></div><div class=form-group><center><button ng-disabled=\"!mod.grupo.nombre || !mod.familiaSuministro.nombre || !mod.suministro.nombre || mod.form.$invalid\" class=\"btn btn-primary\" ng-click=mod.agregar()><span class=\"fa fa-plus\"></span> Agregar</button> <button type=button class=\"btn btn-danger\" ng-click=mod.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/agregar-suministros-excel/modal-agregar-suministro-excel.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Ingrese los suministros</div><div class=panel-body><div><label>Búsqueda jerarquizada:</label><div class=col-lg-12><div class=col-lg-1><div class=form-group><input type=radio ng-model=vm.radio value=jerarquizada ng-change=vm.cambioRadio()></div></div><div class=col-lg-11><div class=\"form-group col-lg-6\"><label>Grupo de suministro:</label><input type=text ng-disabled=\"vm.radio!=\'jerarquizada\'\" ng-model=vm.grupo placeholder=\"Seleccione o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase()+\' (\'+grupo.empresa.nombre.toUpperCase()+\')\' for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Familia de suministro:</label><input ng-disabled=\"!vm.grupo.nombre || vm.radio!=\'jerarquizada\'\" focus-on=familia type=text ng-model=vm.familiaSuministro placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familiaSuministro as familiaSuministro.nombre.toUpperCase() for familiaSuministro in vm.familias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-12\"><label>Tipo de suministro:</label><input ng-if=\"vm.radio==\'jerarquizada\'\" ng-disabled=\"!vm.grupo.nombre || !vm.familiaSuministro.nombre || vm.radio!=\'jerarquizada\'\" type=text focus-on=tipo ng-model=vm.tipoSuministro placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase() for suministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <input ng-if=\"vm.radio==\'directa\'\" ng-disabled=\"!vm.grupo.nombre || !vm.familiaSuministro.nombre || vm.radio!=\'jerarquizada\'\" type=text focus-on=tipo ng-model=vm.tipoSuministro1 placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase() for suministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div><div><label>Búsqueda directa:</label><div class=col-lg-12 ng-disabled=\"\"><div class=\"form-group col-lg-1\"><input type=radio ng-model=vm.radio value=directa ng-change=vm.cambioRadio()></div><div class=\"form-group col-lg-11\"><label>Tipo de suministro:</label><input type=text ng-disabled=\"vm.radio!=\'directa\'\" ng-model=vm.tipoSuministroCompleto placeholder=\"Seleccione o busque el tipo de suministro por su nombre\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase()+\' (\'+suministro.familiaSuministro.nombre.toUpperCase()+\') - (\'+suministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+\')\' for suministro in vm.tiposCompletos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div><div class=col-lg-12 ng-if=vm.tipoSuministro.id><center><button ng-click=vm.verFoto(); ng-disabled=!vm.tipoSuministro.encabezadoFoto class=\"btn btn-primary\"><i class=\"fa fa-photo\"></i> Ver imagen del tipo de suministro elegido</button><br><br></center></div><div class=col-lg-12 ng-if=vm.caja><div class=col-lg-8><div class=form-group><label ng-if=!vm.bandera>Número de caja cerrada:</label><label ng-if=vm.bandera>Número de caja ingresado:</label><input type=text ng-disabled=vm.bandera placeholder=\"Ingrese número de caja cerrada\" class=form-control required ng-model=vm.numeroCaja></div></div><br><div class=col-lg-4 ng-if=!vm.bandera><button style=width:100% class=\"btn btn-primary\" ng-disabled=!vm.numeroCaja ng-click=vm.comprobarNumeroCaja();><i class=\"fa fa-search\"></i> Comprobar</button></div><div class=col-lg-4 ng-if=vm.bandera><button style=width:100% class=\"btn btn-warning\" ng-click=vm.cambiarNumero();><i class=\"fa fa-exchange\"></i> Cambiar número</button></div><br><br><div class=col-lg-12 ng-if=\"vm.numeroComprobado==true\"><div uib-alert type=success><i class=\"fa fa-check\"></i> El número de caja está disponible</div></div></div><div uib-alert class=col-lg-12 ng-if=\"vm.caja && vm.tipoSuministro && !vm.tipoSuministro.inventariable\">Si es una caja cerrada, debe ingresar suministros inventariables</div><div uib-alert class=col-lg-12 ng-if=\"vm.tipoSuministro && !vm.tipoSuministro.inventariable\">Debe seleccionar un tipo de suministro inventariable</div><!-- PARA SUMINISTROS INVENTARIABLES!!! --><div class=col-lg-12><span uib-alert type=success ng-if=\"!vm.caja && vm.tipoSuministro && vm.tipoSuministro.inventariable\">Los ingresos de suministros inventariables, se cargan de manera individual.</span></div><div class=\"col-lg-12 form-group\" ng-if=\"(vm.caja && vm.numeroCaja && vm.numeroComprobado==true) && vm.tipoSuministro && vm.tipoSuministro.inventariable || (!vm.caja && vm.tipoSuministro && vm.tipoSuministro.inventariable)\"><div class=\"col-lg-12 form-group\"><label>Ingrese el archivo Excel (.xlsx):</label><div class=col-lg-12><div class=col-lg-1><input type=radio ng-model=vm.buscar.valor value=inventario ng-click=vm.limpiar()></div><div class=col-lg-9><input ng-disabled=\"vm.buscar.valor!=\'inventario\'\" class=form-control type=file accept=application/vnd.openxmlformats-officedocument.spreadsheetml.sheet id=fileInput onchange=angular.element(this).scope().cargarArchivo(this.files[0])></div><div class=col-lg-2><button ng-disabled=\"vm.buscar.valor!=\'inventario\'\" class=\"btn btn-primary\" ng-click=vm.buscarExcel()><i class=\"fa fa-check\"></i> Procesar archivo</button></div></div></div><div class=\"col-lg-12 form-group\"><label>Ingresar bien nuevo:</label><div class=col-lg-12><div class=col-lg-1><input type=radio ng-model=vm.buscar.valor value=nuevo ng-click=vm.limpiar()></div><div class=col-lg-10><div class=col-lg-2><label>Marca:</label><input type=text focus-on=marca ng-disabled=\"vm.buscar.valor!=\'nuevo\'\" class=form-control placeholder=Marca ng-model=vm.nuevoBien.marca name=marcaBien required> <span uib-alert class=danger ng-show=\"vm.buscar.valor==\'nuevo\' && vm.form.marcaBien.$error.required && vm.form.marcaBien.$dirty\">Campo requerido.</span></div><div class=col-lg-3><label>N° inventario:</label><input type=number ng-disabled=\"vm.buscar.valor!=\'nuevo\'\" class=form-control placeholder=\"N° inventario\" ng-pattern=/^[0-9]{0}/ ng-model=vm.nuevoBien.inventario required name=inventario> <span uib-alert class=danger ng-show=\"vm.buscar.valor==\'nuevo\' && vm.form.inventario.$error.required && vm.form.inventario.$dirty\">Campo requerido. </span><span uib-alert class=danger ng-if=\"vm.buscar.valor==\'nuevo\' && vm.form.inventario.$error.pattern && vm.form.inventario.$dirty\">Valor inválido. </span><span uib-alert class=danger ng-if=\"vm.buscar.valor==\'nuevo\' && vm.form.inventario.$error.number && vm.form.inventario.$dirty\">Valor inválido.</span></div><div class=col-lg-3><label>N° serie:</label><input type=text ng-disabled=\"vm.buscar.valor!=\'nuevo\'\" placeholder=\"N° serie\" class=form-control ng-model=vm.nuevoBien.serie name=serieBien required> <span uib-alert class=danger ng-show=\"vm.buscar.valor==\'nuevo\' && vm.form.serieBien.$error.required && vm.form.serieBien.$dirty\">Campo requerido.</span></div><div class=col-lg-3><label>Precio:</label><input ng-disabled=\"vm.buscar.valor!=\'nuevo\'\" class=form-control min=0 ng-min=0.01 ng-maxlength=15 ng-model=vm.nuevoBien.precio placeholder=Precio type=number name=precioBien required ng-pattern=/^[0-9]+(\\.[0-9]{1,2})?$/ step=0.01> <span uib-alert class=danger ng-show=\"vm.buscar.valor==\'nuevo\' && vm.form.precioBien.$error.required && vm.form.precioBien.$dirty\">Campo requerido. </span><span uib-alert class=danger ng-show=\"vm.buscar.valor==\'nuevo\' && vm.form.precioBien.$error.number && vm.form.precioBien.$dirty\">Valor inválido. </span><span uib-alert class=danger ng-if=\"vm.buscar.valor==\'nuevo\' && vm.form.precioBien.$error.maxlength && vm.form.precioBien.$dirty\">Longitud máxima. </span><span uib-alert class=danger ng-if=\"vm.buscar.valor==\'nuevo\' && vm.form.precioBien.$error.pattern && vm.form.precioBien.$dirty\">Valor inválido. </span><span uib-alert class=danger ng-if=\"vm.buscar.valor==\'nuevo\' && vm.form.precioBien.$error.min && vm.form.precioBien.$dirty\">Valor negativo.</span></div><div class=col-lg-1><label>¿Nuevo?</label><center><input type=checkbox ng-model=vm.nuevoBien.nuevo checked></center></div></div><div class=col-lg-1><button ng-disabled=\"vm.buscar.valor!=\'nuevo\' || vm.form.$invalid\" class=\"btn btn-success\" ng-click=vm.agregarNuevoBien()><span class=\"fa fa-check\"></span></button></div></div></div><div class=col-lg-12 ng-if=\"vm.tipoSuministro.inventariable && vm.listaInventariables.length>0\"><table ng-table=vm.tableParams id=table2 show-filter=true class=table><tr ng-repeat=\"bien in vm.listaInventariables track by $index\"><td data-title=\"\'Marca\'\" align=center>{{bien.suministro.marca ? bien.suministro.marca.toUpperCase() : \"-\" }}</td><td data-title=\"\'N° inventario\'\" align=center>{{bien.inventario ? bien.inventario : \"-\"}}</td><td data-title=\"\'N° serie\'\" align=center>{{bien.serie ? bien.serie : \"-\"}}</td><td data-title=\"\'Precio\'\" align=center>${{bien.suministro.precioUnitario ? bien.suministro.precioUnitario : \"-\"}}</td><td data-title=\"\'¿Nuevo?\'\" align=center>{{bien.nuevo? \"SI\" : \"NO\" }}</td><td align=center><div class=btn-group><a class=\"btn btn-danger\" ng-click=vm.eliminar($index)><i class=\"fa fa-trash\"></i></a></div></td></tr></table></div></div><br><br></div><div class=panel-footer><div class=form-group><center><button ng-disabled=\"(vm.radio!=\'directa\' && !vm.grupo.nombre) || (vm.radio!=\'directa\' && !vm.familiaSuministro.nombre) || !vm.tipoSuministro.nombre || ((!vm.tipoSuministro.inventariable && !vm.comprobarCantidadPorPallets()) || (!vm.tipoSuministro.inventariable && !vm.campos.length>0) || (!vm.tipoSuministro.inventariable && vm.form.$invalid)) || (vm.tipoSuministro.inventariable && !vm.listaInventariables.length>0) || (vm.caja && !vm.numeroCaja && !vm.numeroComprobado)\" class=\"btn btn-primary\" ng-click=vm.agregar()><span class=\"fa fa-plus\"></span> Agregar</button> <button type=button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/asignar-foto-problema/asignar-foto-problema.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Fotografía del problema: {{vm.problema.tipoProblema.nombre.toUpperCase();}}</div><div class=panel-body><div class=col-lg-12 ng-if=vm.problema.encabezadoFoto><center><div ng-if=vm.foto><img ng-src={{vm.foto}} class=img-thumbnail> <button class=\"btn btn-danger\" ng-click=vm.quitarFoto();><i class=\"fa fa-close\"></i></button></div></center></div><div class=col-lg-12 ng-if=!vm.foto><span uib-alert>El problema no posee fotografía </span><button type=button class=\"btn btn-primary btn-block\" ng-click=vm.abrirSeleccionFoto()><span class=\"glyphicon glyphicon-camera\"></span> Seleccionar foto</button></div></div><div class=panel-footer><div class=form-group><center><button type=button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cerrar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/asignar-ubicacion-individual/modal-asignar-ubicacion-individual.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Asignar ubicación individual</div><div class=panel-body><div class=col-lg-12><div class=col-lg-12><i class=\"fa-sitemap fa\"></i> <i>Depósito: {{vm.deposito.nombre.toUpperCase();}}</i><br><br></div><div class=\"form-group col-lg-12\"><label>Seleccione la nave:</label><input type=text ng-model=vm.nave placeholder=\"Seleccione o busque la nave\" uib-typeahead=\"nave as nave.nombre.toUpperCase() for nave in vm.naves | filter:{nombre:$viewValue} | filter: {borrado:false}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <span uib-alert class=danger ng-if=\"vm.nave.nombre && !vm.corroborarExistenciaUbicacionesNave();\">No hay ubicaciones elegibles en la nave seleccionada</span></div></div><div class=col-lg-4 ng-if=\"vm.nave.nombre && vm.corroborarExistenciaUbicacionesNave();\"><div class=\"form-group col-lg-12\" ng-if=\"vm.nave.nombre && vm.corroborarExistenciaUbicacionesNave();\"><label>Pasillo:</label><input type=text ng-disabled=true ng-model=vm.pasillo placeholder=\"Pasillo elegido\" uib-typeahead=\"pasillo as pasillo.numeroPasillo for pasillo in vm.pasillos | filter:{numeroPasillo:$viewValue} | filter: {borrado:false}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <span uib-alert class=danger ng-if=\"vm.pasillos.length==0 && vm.nave.id\">No hay pasillos elegibles </span><span uib-alert class=danger ng-if=\"vm.pasillo.id && !vm.corroborarExistenciaUbicacionesPasillo();\">No hay ubicaciones elegibles en el pasillo seleccionado</span></div><div class=\"form-group col-lg-12\" ng-if=vm.pasillo.numeroPasillo><label>Estructura:</label><input type=text ng-disabled=true ng-model=vm.estructura placeholder=\"Estructura elegida\" uib-typeahead=\"estructura as estructura.identificadorEstructura for estructura in vm.estructuras | filter:{identificadorEstructura:$viewValue} | filter: {borrado:false}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <span uib-alert class=danger ng-if=\"vm.estructuras.length==0 && vm.pasillo.id\">No hay estructuras elegibles </span><span uib-alert class=danger ng-if=\"vm.estructura.id && !vm.corroborarExistenciaUbicacionesEstructura();\">No hay ubicaciones elegibles en la estructura seleccionada</span></div><div class=\"form-group col-lg-12\" ng-if=vm.estructura.identificadorEstructura><label>Estantería:</label><input type=text ng-disabled=true ng-model=vm.estante placeholder=\"Estantería elegida\" uib-typeahead=\"estante as estante.numeroEstante for estante in vm.estantes | filter:{numeroEstante:$viewValue} | filter: {borrado:false}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <span uib-alert class=danger ng-if=\"vm.estantes.length==0 && vm.estructura.id\">No hay estanterías elegibles </span><span uib-alert class=danger ng-if=\"vm.estante.id && !vm.corroborarExistenciaUbicacionesEstante();\">No hay ubicaciones elegibles en la estantería seleccionada</span></div><div class=\"form-group col-lg-12\" ng-if=vm.estante.numeroEstante><label>Estante:</label><input type=text ng-disabled=true ng-model=vm.nivel placeholder=\"Estante elegido\" uib-typeahead=\"nivel as nivel.numeroNivel+\'. - Categoría: \'+nivel.ubicaciones[0].categoriaPeso.nombre.toUpperCase() for nivel in vm.niveles | filter:{numeroNivel:$viewValue} | filter: {borrado:false}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <span uib-alert class=danger ng-if=\"vm.niveles.length==0 && vm.estante.id\">No hay estantes elegibles </span><span uib-alert class=danger ng-if=\"vm.nivel.id && !vm.corroborarExistenciaUbicacionesNivel();\">No hay ubicaciones elegibles en el estante seleccionado</span></div><div class=\"form-group col-lg-12\" ng-if=vm.nivel.numeroNivel><label>Ubicación:</label><input type=text ng-disabled=true ng-model=vm.ubicacion placeholder=\"Ubicación elegida\" uib-typeahead=\"ubicacion as \'N°: \'+ubicacion.numeroUbicacion+\'. - N° Orden: \'+ubicacion.numeroOrden+\'. - \'+ubicacion.estadoUbicacion.nombre.toUpperCase() for ubicacion in vm.ubicaciones | filter:{numeroUbicacion:$viewValue} | filter: {borrado:false}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <span uib-alert class=danger ng-if=\"vm.ubicaciones.length==0 && vm.nivel.id\">No hay ubicaciones elegibles</span></div></div><div class=col-lg-8 ng-if=\"vm.nave.nombre && vm.corroborarExistenciaUbicacionesNave()\"><div class=col-lg-12><button type=button ng-disabled=!vm.pasillo class=\"btn btn-danger\" ng-click=vm.atras()><span class=\"glyphicon glyphicon-arrow-left\"></span> Anular selección</button></div><br><br><!--PASILLOS!--><div class=col-lg-12 ng-if=\"vm.nave.nombre && vm.corroborarExistenciaUbicacionesNave() && !vm.pasillo && !vm.estante && !vm.estructura && !vm.nivel && !vm.ubicacion\"><div class=borde><div ng-repeat=\"pasillo in vm.pasillos | orderBy:\'numeroPasillo*1\'\"><div ng-show=\"pasillo.borrado===false\"><div class=\"pasillo btn btn-muted\" ng-style=vm.clasePasillos(); ng-click=\"vm.corroborarExistenciaUbicacionesPasilloMapa(pasillo) && vm.elegirPasillo(pasillo)\" ng-disabled=!vm.corroborarExistenciaUbicacionesPasilloMapa(pasillo);>Pasillo N° {{pasillo.numeroPasillo}}</div></div></div></div></div><!--ESTRUCTURAS!--><div class=col-lg-12 ng-if=\"vm.pasillo && !vm.estructura && !vm.estante && !vm.nivel && !vm.ubicacion\"><div class=\"borde flex-columnas\"><div ng-repeat=\"estructura in vm.estructuras | orderBy:\'identificadorEstructura*1\'\"><div ng-if=\"estructura.borrado===false\"><div class=\"estructura-vista btn btn-warning\" style=\"font-weight: bold\" ng-click=\"vm.corroborarExistenciaUbicacionesEstructuraMapa(estructura) && vm.elegirEstructura(estructura); $event.stopPropagation();\" ng-disabled=!vm.corroborarExistenciaUbicacionesEstructuraMapa(estructura)>Estructura N° {{estructura.identificadorEstructura}}</div></div></div></div></div><!--ESTANTES!--><div class=col-lg-12 ng-if=\"!vm.estante && vm.estructura && vm.pasillo && !vm.nivel && !vm.ubicacion\"><div class=borde><div ng-repeat=\"estante in vm.estantes | orderBy:\'numeroEstante\'\"><div ng-if=\"estante.borrado===false\"><div class=\"estantes-vista btn btn-danger\" style=\"font-weight: bold\" ng-click=\"vm.corroborarExistenciaUbicacionesEstanteMapa(estante) && vm.elegirEstante(estante); $event.stopPropagation();\" ng-style=vm.claseEstante(estante); ng-disabled=!vm.corroborarExistenciaUbicacionesEstanteMapa(estante);>Estantería<br>{{estante.numeroEstante}}</div></div></div></div></div><!--NIVELES!--><div class=col-lg-12 ng-if=\"vm.estante && vm.estructura && vm.pasillo && !vm.nivel && !vm.ubicacion\"><div class=borde><div ng-repeat=\"nivel in vm.niveles | orderBy:\'numeroNivel\'\"><div ng-if=\"nivel.borrado===false\"><div class=\"estantes-vista btn btn-primary\" style=\"font-weight: bold\" ng-click=\"vm.corroborarExistenciaUbicacionesNivelMapa(nivel) && vm.elegirNivel(nivel)\" ng-style=vm.claseNivel(nivel); ng-disabled=!vm.corroborarExistenciaUbicacionesNivelMapa(nivel);>Estante N° {{nivel.numeroNivel}}</div></div></div></div></div><!--UBICACIONES!--><div class=col-lg-12 ng-if=\"vm.estante && vm.estructura && vm.pasillo && vm.nivel && !vm.ubicacion\"><div class=borde><div ng-repeat=\"ubicacion in vm.ubicaciones | orderBy:\'+\'\"><div ng-if=\"ubicacion.borrado===false\"><div class=\"grilla ubicacion-vista btn btn-muted\" style=\"color: white\" ng-click=vm.elegirUbicacion(ubicacion) ng-style=vm.claseUbicaciones(); ng-class=\"{verde: ubicacion.estadoUbicacion.id==1, rojo: ubicacion.estadoUbicacion.id == 2, amarillo:ubicacion.estadoUbicacion.id==3}\" ng-disabled=vm.desabilitarUbicacion(ubicacion)>Ubicación N° {{ubicacion.numeroUbicacion}}<br>N° Orden: {{ubicacion.numeroOrden}}</div></div></div></div></div><!--UBICACIÓN ELEGIDA!--><div class=col-lg-12 ng-if=\"vm.ubicacion && vm.estante && vm.estructura && vm.pasillo && vm.nivel\"><div class=borde><div class=\"grilla ubicacion-vista btn btn-muted\" ng-model=vm.ubicacion style=\"color: white; width:100%\" ng-class=\"{verde: vm.ubicacion.estadoUbicacion.id==1, rojo: vm.ubicacion.estadoUbicacion.id == 2, amarillo: vm.ubicacion.estadoUbicacion.id==3}\">UBICACIÓN SELECCIONADA:<br>Ubicación N° {{vm.ubicacion.numeroUbicacion}}<br>N° Orden: {{vm.ubicacion.numeroOrden}}<br>Categoría de peso: {{vm.ubicacion.categoriaPeso.nombre.toUpperCase()}}<br>Estado: {{vm.ubicacion.estadoUbicacion.nombre.toUpperCase();}}</div></div></div></div></div><div class=panel-footer><div class=form-group><center><button ng-disabled=!vm.ubicacion.numeroUbicacion class=\"btn btn-primary\" ng-click=vm.asignar()><span class=\"fa fa-plus\"></span> Asignar</button> <button type=button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/asignar-ubicaciones/modal-asignar-ubicaciones.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Asignar ubicaciones automáticamente</div><div class=panel-body><div class=col-lg-12><i class=\"fa-sitemap fa\"></i> <i>Depósito: {{vm.deposito.nombre.toUpperCase();}}</i><br><br></div><div class=\"form-group col-lg-12\"><label>Elegir la nave:</label><input type=text ng-model=vm.nave placeholder=\"Seleccione o busque la nave\" uib-typeahead=\"nave as nave.nombre.toUpperCase() for nave in vm.naves | filter:{nombre:$viewValue} | filter: {borrado:false}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <span uib-alert class=danger ng-if=\"vm.nave.nombre && !vm.corroborarExistenciaUbicaciones();\">No hay ubicaciones elegibles en la nave</span></div></div><div class=panel-footer><div class=form-group><center><button ng-disabled=\"!vm.nave.nombre || !vm.corroborarExistenciaUbicaciones();\" class=\"btn btn-primary\" ng-click=vm.asignar()><span class=\"fa fa-plus\"></span> Asignar</button> <button type=button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/asignar-ubicacion-individual-cajas/modal-asignar-ubicacion-individual-cajas.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Asignar una ubicación individual</div><div class=panel-body><div class=col-lg-12><div class=col-lg-12><i class=\"fa-sitemap fa\"></i> <i>Depósito: {{vm.deposito.nombre.toUpperCase();}}</i><br><br></div><div class=\"form-group col-lg-12\"><label>Seleccione la nave:</label><input type=text ng-model=vm.nave placeholder=\"Seleccione o busque la nave\" uib-typeahead=\"nave as nave.nombre.toUpperCase() for nave in vm.naves | filter:{nombre:$viewValue} | filter: {borrado:false}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <span uib-alert class=danger ng-if=\"vm.nave.nombre && !vm.corroborarExistenciaUbicacionesNave();\">No hay ubicaciones elegibles en la nave seleccionada</span></div></div><div class=col-lg-4 ng-if=\"vm.nave.nombre && vm.corroborarExistenciaUbicacionesNave();\"><div class=\"form-group col-lg-12\" ng-if=\"vm.nave.nombre && vm.corroborarExistenciaUbicacionesNave();\"><label>Pasillo:</label><input type=text ng-disabled=true ng-model=vm.pasillo placeholder=\"Pasillo elegido\" uib-typeahead=\"pasillo as pasillo.numeroPasillo for pasillo in vm.pasillos | filter:{numeroPasillo:$viewValue} | filter: {borrado:false}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <span uib-alert class=danger ng-if=\"vm.pasillos.length==0 && vm.nave.id\">No hay pasillos elegibles </span><span uib-alert class=danger ng-if=\"vm.pasillo.id && !vm.corroborarExistenciaUbicacionesPasillo();\">No hay ubicaciones elegibles en el pasillo seleccionado</span></div><div class=\"form-group col-lg-12\" ng-if=vm.pasillo.numeroPasillo><label>Estructura:</label><input type=text ng-disabled=true ng-model=vm.estructura placeholder=\"Estructura elegida\" uib-typeahead=\"estructura as estructura.identificadorEstructura for estructura in vm.estructuras | filter:{identificadorEstructura:$viewValue} | filter: {borrado:false}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <span uib-alert class=danger ng-if=\"vm.estructuras.length==0 && vm.pasillo.id\">No hay estructuras elegibles </span><span uib-alert class=danger ng-if=\"vm.estructura.id && !vm.corroborarExistenciaUbicacionesEstructura();\">No hay ubicaciones elegibles en la estructura seleccionada</span></div><div class=\"form-group col-lg-12\" ng-if=vm.estructura.identificadorEstructura><label>Estantería:</label><input type=text ng-disabled=true ng-model=vm.estante placeholder=\"Estantería elegida\" uib-typeahead=\"estante as estante.numeroEstante for estante in vm.estantes | filter:{numeroEstante:$viewValue} | filter: {borrado:false}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <span uib-alert class=danger ng-if=\"vm.estantes.length==0 && vm.estructura.id\">No hay estanterías elegibles </span><span uib-alert class=danger ng-if=\"vm.estante.id && !vm.corroborarExistenciaUbicacionesEstante();\">No hay ubicaciones elegibles en la estantería seleccionada</span></div><div class=\"form-group col-lg-12\" ng-if=vm.estante.numeroEstante><label>Estante:</label><input type=text ng-disabled=true ng-model=vm.nivel placeholder=\"Estante elegido\" uib-typeahead=\"nivel as nivel.numeroNivel+\'. - Categoría: \'+nivel.ubicaciones[0].categoriaPeso.nombre.toUpperCase() for nivel in vm.niveles | filter:{numeroNivel:$viewValue} | filter: {borrado:false}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <span uib-alert class=danger ng-if=\"vm.niveles.length==0 && vm.estante.id\">No hay estantes elegibles </span><span uib-alert class=danger ng-if=\"vm.nivel.id && !vm.corroborarExistenciaUbicacionesNivel();\">No hay ubicaciones elegibles en el estante seleccionado</span></div><div class=\"form-group col-lg-12\" ng-if=vm.nivel.numeroNivel><label>Ubicación:</label><input type=text ng-disabled=true ng-model=vm.ubicacion placeholder=\"Ubicación elegida\" uib-typeahead=\"ubicacion as \'N°: \'+ubicacion.numeroUbicacion+\'. - N° Orden: \'+ubicacion.numeroOrden+\'. - \'+ubicacion.estadoUbicacion.nombre.toUpperCase() for ubicacion in vm.ubicaciones | filter:{numeroUbicacion:$viewValue} | filter: {borrado:false}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <span uib-alert class=danger ng-if=\"vm.ubicaciones.length==0 && vm.nivel.id\">No hay ubicaciones elegibles</span></div></div><div class=col-lg-8 ng-if=\"vm.nave.nombre && vm.corroborarExistenciaUbicacionesNave()\"><div class=col-lg-12><button type=button ng-disabled=!vm.pasillo class=\"btn btn-danger\" ng-click=vm.atras()><span class=\"glyphicon glyphicon-arrow-left\"></span> Anular selección</button></div><br><br><!--PASILLOS!--><div class=col-lg-12 ng-if=\"vm.nave.nombre && vm.corroborarExistenciaUbicacionesNave() && !vm.pasillo && !vm.estante && !vm.estructura && !vm.nivel && !vm.ubicacion\"><div class=borde><div ng-repeat=\"pasillo in vm.pasillos | orderBy:\'numeroPasillo*1\'\"><div ng-show=\"pasillo.borrado===false\"><div class=\"pasillo btn btn-muted\" ng-style=vm.clasePasillos(); ng-click=\"vm.corroborarExistenciaUbicacionesPasilloMapa(pasillo) && vm.elegirPasillo(pasillo)\" ng-disabled=!vm.corroborarExistenciaUbicacionesPasilloMapa(pasillo);>Pasillo N° {{pasillo.numeroPasillo}}</div></div></div></div></div><!--ESTRUCTURAS!--><div class=col-lg-12 ng-if=\"vm.pasillo && !vm.estructura && !vm.estante && !vm.nivel && !vm.ubicacion\"><div class=\"borde flex-columnas\"><div ng-repeat=\"estructura in vm.estructuras | orderBy:\'identificadorEstructura*1\'\"><div ng-if=\"estructura.borrado===false\"><div class=\"estructura-vista btn btn-warning\" style=\"font-weight: bold\" ng-click=\"vm.corroborarExistenciaUbicacionesEstructuraMapa(estructura) && vm.elegirEstructura(estructura); $event.stopPropagation();\" ng-disabled=!vm.corroborarExistenciaUbicacionesEstructuraMapa(estructura)>Estructura N° {{estructura.identificadorEstructura}}</div></div></div></div></div><!--ESTANTES!--><div class=col-lg-12 ng-if=\"!vm.estante && vm.estructura && vm.pasillo && !vm.nivel && !vm.ubicacion\"><div class=borde><div ng-repeat=\"estante in vm.estantes | orderBy:\'numeroEstante\'\"><div ng-if=\"estante.borrado===false\"><div class=\"estantes-vista btn btn-danger\" style=\"font-weight: bold\" ng-click=\"vm.corroborarExistenciaUbicacionesEstanteMapa(estante) && vm.elegirEstante(estante); $event.stopPropagation();\" ng-style=vm.claseEstante(estante); ng-disabled=!vm.corroborarExistenciaUbicacionesEstanteMapa(estante);>Estantería<br>{{estante.numeroEstante}}</div></div></div></div></div><!--NIVELES!--><div class=col-lg-12 ng-if=\"vm.estante && vm.estructura && vm.pasillo && !vm.nivel && !vm.ubicacion\"><div class=borde><div ng-repeat=\"nivel in vm.niveles | orderBy:\'numeroNivel\'\"><div ng-if=\"nivel.borrado===false\"><div class=\"estantes-vista btn btn-primary\" style=\"font-weight: bold\" ng-click=\"vm.corroborarExistenciaUbicacionesNivelMapa(nivel) && vm.elegirNivel(nivel)\" ng-style=vm.claseNivel(nivel); ng-disabled=!vm.corroborarExistenciaUbicacionesNivelMapa(nivel);>Estante N° {{nivel.numeroNivel}}</div></div></div></div></div><!--UBICACIONES!--><div class=col-lg-12 ng-if=\"vm.estante && vm.estructura && vm.pasillo && vm.nivel && !vm.ubicacion\"><div class=borde><div ng-repeat=\"ubicacion in vm.ubicaciones | orderBy:\'+\'\"><div ng-if=\"ubicacion.borrado===false\"><div class=\"grilla ubicacion-vista btn btn-muted\" style=\"color: white\" ng-click=vm.elegirUbicacion(ubicacion) ng-style=vm.claseUbicaciones(); ng-class=\"{verde: ubicacion.estadoUbicacion.id==1, rojo: ubicacion.estadoUbicacion.id == 2, amarillo:ubicacion.estadoUbicacion.id==3}\" ng-disabled=vm.desabilitarUbicacion(ubicacion)>Ubicación N° {{ubicacion.numeroUbicacion}}<br>N° Orden: {{ubicacion.numeroOrden}}</div></div></div></div></div><!--UBICACIÓN ELEGIDA!--><div class=col-lg-12 ng-if=\"vm.ubicacion && vm.estante && vm.estructura && vm.pasillo && vm.nivel\"><div class=borde><div class=\"grilla ubicacion-vista btn btn-muted\" ng-model=vm.ubicacion style=\"color: white; width:100%\" ng-class=\"{verde: vm.ubicacion.estadoUbicacion.id==1, rojo: vm.ubicacion.estadoUbicacion.id == 2, amarillo: vm.ubicacion.estadoUbicacion.id==3}\">UBICACIÓN SELECCIONADA:<br>Ubicación N° {{vm.ubicacion.numeroUbicacion}}<br>N° Orden: {{vm.ubicacion.numeroOrden}}<br>Categoría de peso: {{vm.ubicacion.categoriaPeso.nombre.toUpperCase()}}<br>Estado: {{vm.ubicacion.estadoUbicacion.nombre.toUpperCase();}}</div></div></div></div></div><div class=panel-footer><div class=form-group><center><button ng-disabled=!vm.ubicacion.numeroUbicacion class=\"btn btn-primary\" ng-click=vm.asignar()><span class=\"fa fa-plus\"></span> Asignar</button> <button type=button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/atencion-reclamo/modal.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading>Atención de reclamo de egreso N°: {{vm.egreso.numeroMovimiento}}</div><div class=panel-body><div class=container-fluid><div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><label>Detalles del reclamo</label><div class=container-fluid><div class=\"form-group col-md-6\"><label>Nombre y apellido:</label><input class=form-control type=text ng-readonly=true placeholder=\"Nombre y apellido de quién efectúa el reclamo\" ng-model=vm.egreso.nombreConfirmacion></div><div class=\"form-group col-md-6\"><label>Email:</label><input class=form-control type=text ng-readonly=true ng-model=vm.egreso.mailIngresadoConfirmacion></div><div class=\"form-group col-md-12\"><label>Reclamo:</label><textarea class=form-control type=text ng-readonly=true style=resize:vertical ng-model=vm.egreso.descripcionReclamo></textarea></div></div></div><hr><div class=panel-body><form name=vm.form><div class=\"form-group col-md-12\"><label>Atención de reclamo:</label><textarea class=form-control type=text style=resize:vertical placeholder=\"Ingrese la atención al reclamo efectuado\" ng-model=vm.egreso.atencionReclamo ng-minlength=5 ng-maxlength=300 required name=atencionReclamo></textarea><span uib-alert ng-show=\"vm.form.atencionReclamo.$error.required && vm.form.atencionReclamo.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.atencionReclamo.$error.minlength && vm.form.atencionReclamo.$dirty\">Este campo debe tener al menos 5 caracteres. </span><span uib-alert class=danger ng-if=\"vm.form.atencionReclamo.$error.maxlength && vm.form.atencionReclamo.$dirty\">Este campo no puede superar los 300 caracteres.</span></div></form></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.actualizarReclamo() ng-disabled=vm.form.$invalid><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/modales/asignar-ubicaciones-cajas/modal-asignar-ubicaciones-cajas.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Asignar una ubicación individual</div><div class=panel-body><div class=col-lg-12><div class=col-lg-12><i class=\"fa-sitemap fa\"></i> <i>Depósito: {{vm.deposito.nombre.toUpperCase();}}</i><br><br></div><div class=\"form-group col-lg-12\"><label>Seleccione la nave:</label><input type=text ng-model=vm.nave placeholder=\"Seleccione o busque la nave\" uib-typeahead=\"nave as nave.nombre.toUpperCase() for nave in vm.naves | filter:{nombre:$viewValue} | filter: {borrado:false}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <span uib-alert class=danger ng-if=\"vm.nave.nombre && !vm.corroborarExistenciaUbicacionesNave();\">No hay ubicaciones elegibles en la nave seleccionada</span></div></div><div class=col-lg-4 ng-if=\"vm.nave.nombre && vm.corroborarExistenciaUbicacionesNave();\"><div class=\"form-group col-lg-12\" ng-if=\"vm.nave.nombre && vm.corroborarExistenciaUbicacionesNave();\"><label>Pasillo:</label><input type=text ng-disabled=true ng-model=vm.pasillo placeholder=\"Pasillo elegido\" uib-typeahead=\"pasillo as pasillo.numeroPasillo for pasillo in vm.pasillos | filter:{numeroPasillo:$viewValue} | filter: {borrado:false}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <span uib-alert class=danger ng-if=\"vm.pasillos.length==0 && vm.nave.id\">No hay pasillos elegibles </span><span uib-alert class=danger ng-if=\"vm.pasillo.id && !vm.corroborarExistenciaUbicacionesPasillo();\">No hay ubicaciones elegibles en el pasillo seleccionado</span></div><div class=\"form-group col-lg-12\" ng-if=vm.pasillo.numeroPasillo><label>Estructura:</label><input type=text ng-disabled=true ng-model=vm.estructura placeholder=\"Estructura elegida\" uib-typeahead=\"estructura as estructura.identificadorEstructura for estructura in vm.estructuras | filter:{identificadorEstructura:$viewValue} | filter: {borrado:false}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <span uib-alert class=danger ng-if=\"vm.estructuras.length==0 && vm.pasillo.id\">No hay estructuras elegibles </span><span uib-alert class=danger ng-if=\"vm.estructura.id && !vm.corroborarExistenciaUbicacionesEstructura();\">No hay ubicaciones elegibles en la estructura seleccionada</span></div><div class=\"form-group col-lg-12\" ng-if=vm.estructura.identificadorEstructura><label>Estantería:</label><input type=text ng-disabled=true ng-model=vm.estante placeholder=\"Estantería elegida\" uib-typeahead=\"estante as estante.numeroEstante for estante in vm.estantes | filter:{numeroEstante:$viewValue} | filter: {borrado:false}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <span uib-alert class=danger ng-if=\"vm.estantes.length==0 && vm.estructura.id\">No hay estanterías elegibles </span><span uib-alert class=danger ng-if=\"vm.estante.id && !vm.corroborarExistenciaUbicacionesEstante();\">No hay ubicaciones elegibles en la estantería seleccionada</span></div><div class=\"form-group col-lg-12\" ng-if=vm.estante.numeroEstante><label>Estante:</label><input type=text ng-disabled=true ng-model=vm.nivel placeholder=\"Estante elegido\" uib-typeahead=\"nivel as nivel.numeroNivel+\'. - Categoría: \'+nivel.ubicaciones[0].categoriaPeso.nombre.toUpperCase() for nivel in vm.niveles | filter:{numeroNivel:$viewValue} | filter: {borrado:false}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <span uib-alert class=danger ng-if=\"vm.niveles.length==0 && vm.estante.id\">No hay estantes elegibles </span><span uib-alert class=danger ng-if=\"vm.nivel.id && !vm.corroborarExistenciaUbicacionesNivel();\">No hay ubicaciones elegibles en el estante seleccionado</span></div><div class=\"form-group col-lg-12\" ng-if=vm.nivel.numeroNivel><label>Ubicación:</label><input type=text ng-disabled=true ng-model=vm.ubicacion placeholder=\"Ubicación elegida\" uib-typeahead=\"ubicacion as \'N°: \'+ubicacion.numeroUbicacion+\'. - N° Orden: \'+ubicacion.numeroOrden+\'. - \'+ubicacion.estadoUbicacion.nombre.toUpperCase() for ubicacion in vm.ubicaciones | filter:{numeroUbicacion:$viewValue} | filter: {borrado:false}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <span uib-alert class=danger ng-if=\"vm.ubicaciones.length==0 && vm.nivel.id\">No hay ubicaciones elegibles</span></div></div><div class=col-lg-8 ng-if=\"vm.nave.nombre && vm.corroborarExistenciaUbicacionesNave()\"><div class=col-lg-12><button type=button ng-disabled=!vm.pasillo class=\"btn btn-danger\" ng-click=vm.atras()><span class=\"glyphicon glyphicon-arrow-left\"></span> Anular selección</button></div><br><br><!--PASILLOS!--><div class=col-lg-12 ng-if=\"vm.nave.nombre && vm.corroborarExistenciaUbicacionesNave() && !vm.pasillo && !vm.estante && !vm.estructura && !vm.nivel && !vm.ubicacion\"><div class=borde><div ng-repeat=\"pasillo in vm.pasillos | orderBy:\'numeroPasillo*1\'\"><div ng-show=\"pasillo.borrado===false\"><div class=\"pasillo btn btn-muted\" ng-style=vm.clasePasillos(); ng-click=\"vm.corroborarExistenciaUbicacionesPasilloMapa(pasillo) && vm.elegirPasillo(pasillo)\" ng-disabled=!vm.corroborarExistenciaUbicacionesPasilloMapa(pasillo);>Pasillo N° {{pasillo.numeroPasillo}}</div></div></div></div></div><!--ESTRUCTURAS!--><div class=col-lg-12 ng-if=\"vm.pasillo && !vm.estructura && !vm.estante && !vm.nivel && !vm.ubicacion\"><div class=\"borde flex-columnas\"><div ng-repeat=\"estructura in vm.estructuras | orderBy:\'identificadorEstructura*1\'\"><div ng-if=\"estructura.borrado===false\"><div class=\"estructura-vista btn btn-warning\" style=\"font-weight: bold\" ng-click=\"vm.corroborarExistenciaUbicacionesEstructuraMapa(estructura) && vm.elegirEstructura(estructura); $event.stopPropagation();\" ng-disabled=!vm.corroborarExistenciaUbicacionesEstructuraMapa(estructura)>Estructura N° {{estructura.identificadorEstructura}}</div></div></div></div></div><!--ESTANTES!--><div class=col-lg-12 ng-if=\"!vm.estante && vm.estructura && vm.pasillo && !vm.nivel && !vm.ubicacion\"><div class=borde><div ng-repeat=\"estante in vm.estantes | orderBy:\'numeroEstante\'\"><div ng-if=\"estante.borrado===false\"><div class=\"estantes-vista btn btn-danger\" style=\"font-weight: bold\" ng-click=\"vm.corroborarExistenciaUbicacionesEstanteMapa(estante) && vm.elegirEstante(estante); $event.stopPropagation();\" ng-style=vm.claseEstante(estante); ng-disabled=!vm.corroborarExistenciaUbicacionesEstanteMapa(estante);>Estantería<br>{{estante.numeroEstante}}</div></div></div></div></div><!--NIVELES!--><div class=col-lg-12 ng-if=\"vm.estante && vm.estructura && vm.pasillo && !vm.nivel && !vm.ubicacion\"><div class=borde><div ng-repeat=\"nivel in vm.niveles | orderBy:\'numeroNivel\'\"><div ng-if=\"nivel.borrado===false\"><div class=\"estantes-vista btn btn-primary\" style=\"font-weight: bold\" ng-click=\"vm.corroborarExistenciaUbicacionesNivelMapa(nivel) && vm.elegirNivel(nivel)\" ng-style=vm.claseNivel(nivel); ng-disabled=!vm.corroborarExistenciaUbicacionesNivelMapa(nivel);>Estante N° {{nivel.numeroNivel}}</div></div></div></div></div><!--UBICACIONES!--><div class=col-lg-12 ng-if=\"vm.estante && vm.estructura && vm.pasillo && vm.nivel && !vm.ubicacion\"><div class=borde><div ng-repeat=\"ubicacion in vm.ubicaciones | orderBy:\'+\'\"><div ng-if=\"ubicacion.borrado===false\"><div class=\"grilla ubicacion-vista btn btn-muted\" style=\"color: white\" ng-click=vm.elegirUbicacion(ubicacion) ng-style=vm.claseUbicaciones(); ng-class=\"{verde: ubicacion.estadoUbicacion.id==1, rojo: ubicacion.estadoUbicacion.id == 2, amarillo:ubicacion.estadoUbicacion.id==3}\" ng-disabled=vm.desabilitarUbicacion(ubicacion)>Ubicación N° {{ubicacion.numeroUbicacion}}<br>N° Orden: {{ubicacion.numeroOrden}}</div></div></div></div></div><!--UBICACIÓN ELEGIDA!--><div class=col-lg-12 ng-if=\"vm.ubicacion && vm.estante && vm.estructura && vm.pasillo && vm.nivel\"><div class=borde><div class=\"grilla ubicacion-vista btn btn-muted\" ng-model=vm.ubicacion style=\"color: white; width:100%\" ng-class=\"{verde: vm.ubicacion.estadoUbicacion.id==1, rojo: vm.ubicacion.estadoUbicacion.id == 2, amarillo: vm.ubicacion.estadoUbicacion.id==3}\">UBICACIÓN SELECCIONADA:<br>Ubicación N° {{vm.ubicacion.numeroUbicacion}}<br>N° Orden: {{vm.ubicacion.numeroOrden}}<br>Categoría de peso: {{vm.ubicacion.categoriaPeso.nombre.toUpperCase()}}<br>Estado: {{vm.ubicacion.estadoUbicacion.nombre.toUpperCase();}}</div></div></div></div></div><div class=panel-footer><div class=form-group><center><button ng-disabled=!vm.ubicacion.numeroUbicacion class=\"btn btn-primary\" ng-click=vm.asignar()><span class=\"fa fa-plus\"></span> Asignar</button> <button type=button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/cambiar-ubicacion-suministro/cambiar-ubicacion-suministro.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading>Reasignar ubicación a suministro</div><div class=panel-body><div class=container-fluid><div class=col-lg-12 ng-if=\"!vm.comprobarSuministro() && !vm.noUbicacion\"><div uib-alert>El suministro indicado no es correcto</div><div></div></div><div class=col-lg-12 ng-if=vm.noUbicacion><div uib-alert>El suministro no posee ubicación</div><div></div></div><div class=col-lg-12 ng-if=\"vm.comprobarSuministro() && vm.ubicacion.id\"><div class=col-lg-12 ng-if=vm.inventariable><h3>Suministro seleccionado:</h3><div class=\"panel panel-default panel-body\"><div class=container-fluid><table ng-table=vm.tableParamsSuministro class=table ng-show=vm.suministro.id><tr ng-repeat=\"suministro in $data\"><td title=\"\'Empresa\'\" align=center>{{suministro.suministro.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase();}}</td><td title=\"\'Grupo suministro\'\" align=center>{{suministro.suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Familia suministro\'\" align=center>{{suministro.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase();}}</td><td title=\"\'Tipo suministro\'\" align=center>{{suministro.suministro.tipoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Marca\'\" align=center>{{suministro.suministro.marca? suministro.suministro.marca.toUpperCase():\"-\"}}</td><td title=\"\'N° serie\'\" align=center ng-if=vm.inventariable>{{suministro.serie? suministro.serie.toUpperCase() : \"-\"}}</td><td title=\"\'N° inventario\'\" align=center ng-if=vm.inventariable>{{suministro.inventario ? suministro.inventario : \"-\"}}</td><!--                <td title=\"\'¿Activo?\'\" align=\"center\">\r\n            {{suministro.suministro.estadoSuministro==2? \"SI\" : \"NO\" }}\r\n        </td> --><td title=\"\'¿Nuevo?\'\" align=center ng-if=vm.inventariable>{{suministro.nuevo? \"SI\":\"NO\"}}</td><td title=\"\'Ver información\'\" align=center><div class=btn-group><a class=\"btn btn-primary\" ng-click=vm.mostrarInformacionSuministro()><i class=\"fa fa-search\"></i></a></div></td></tr></table></div></div></div><div class=col-lg-12 ng-if=!vm.inventariable><h3>Suministro seleccionado:</h3><div class=\"panel panel-default panel-body\"><div class=container-fluid><table ng-table=vm.tableParamsSuministro class=table ng-show=vm.suministro.id><tr ng-repeat=\"suministro in $data\"><td title=\"\'Empresa\'\" align=center>{{suministro.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase();}}</td><td title=\"\'Grupo suministro\'\" align=center>{{suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Familia suministro\'\" align=center>{{suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase();}}</td><td title=\"\'Tipo suministro\'\" align=center>{{suministro.tipoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Marca\'\" align=center>{{suministro.marca? suministro.marca.toUpperCase():\"-\"}}</td><td title=\"\'Ver información\'\" align=center><div class=btn-group><a class=\"btn btn-primary\" ng-click=vm.mostrarInformacionSuministro()><i class=\"fa fa-search\"></i></a></div></td></tr></table></div></div></div><div class=col-lg-12><h3>Ubicación Actual:</h3></div><div class=col-lg-12 ng-if=vm.comprobarSuministro()><div class=\"form-group has-feedback\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(vm.ubicacion) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(vm.ubicacion)}}</div></div><br><div class=col-lg-12><center><div><button style=width:60% class=\"btn btn-primary\" ng-click=vm.asignarIndividual()><i class=\"fa fa-map-marker\"></i> Buscar ubicación nueva</button></div></center></div></div><div class=col-lg-12 ng-if=!vm.nuevaUbicacion.id><br><br><div uib-alert>Todavía no seleccionó una nueva ubicación</div></div><div class=col-lg-12 ng-if=vm.nuevaUbicacion.id><br><br><div class=col-lg-10><div class=\"form-group has-feedback\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(vm.nuevaUbicacion) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(vm.nuevaUbicacion)}}</div></div></div><div class=col-lg-2><label>¿Ocupar?</label><input type=checkbox ng-model=vm.ocupar></div></div></div></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button ng-click=vm.actualizarUbicacion(); ng-disabled=!vm.nuevaUbicacion.id class=\"btn btn-success\"><i class=\"fa fa-exchange\"></i> Actualizar ubicación</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/components/modales/cargar-inventariables-excel/cargar-inventariables-excel.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading>Cargar suministros inventariables vía excel</div><div class=panel-body><div class=container-fluid><form name=vm.form><div class=\"form-group col-lg-12\"><label>Empresa:</label><input type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0></div><div class=\"col-lg-12 form-group\"><label>Ingrese el archivo Excel (.xlsx):</label><div class=col-lg-12><div class=col-lg-10><input ng-disabled=!vm.empresa class=form-control type=file accept=application/vnd.openxmlformats-officedocument.spreadsheetml.sheet id=fileInput onchange=angular.element(this).scope().cargarArchivo(this.files[0])></div><div class=col-lg-2><button class=\"btn btn-primary\" ng-click=vm.buscarExcel()><i class=\"fa fa-check\"></i> Procesar archivo</button></div></div></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-5 col-sm-2\"><button ng-disabled=!vm.empresa type=button class=\"btn btn-danger btn-block\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cerrar</button></div></div></div></div></div>");
$templateCache.put("app/components/modales/cargar-topes-excel/cargar-topes-excel.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading>Cargar topes de suministros vía excel</div><div class=panel-body><div class=container-fluid><form name=vm.form><div class=\"form-group col-lg-12\"><label>Empresa:</label><input type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0></div><div class=\"col-lg-12 form-group\"><label>Ingrese el archivo Excel (.xlsx):</label><div class=col-lg-12><div class=col-lg-10><input class=form-control type=file accept=application/vnd.openxmlformats-officedocument.spreadsheetml.sheet id=fileInput onchange=angular.element(this).scope().cargarArchivo(this.files[0])></div><div class=col-lg-2><button ng-disabled=!vm.empresa class=\"btn btn-primary\" ng-click=vm.buscarExcel()><i class=\"fa fa-check\"></i> Procesar archivo</button></div></div></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-5 col-sm-2\"><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cerrar</button></div></div></div></div></div>");
$templateCache.put("app/components/modales/cambiar-ubicacion-varios-suministros/cambiar-ubicacion-varios-suministros.html","<script type=text/ng-template id=headerCheckbox.html><input type=\"checkbox\" ng-click=\"vm.marcarTodo();\" ng-model=\"vm.check\" ng-value=\"vm.check.valor\"/></script><div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading>Reasignar ubicación de varios suministros</div><div class=panel-body><div class=container-fluid><div><div class=col-lg-12><h3>Suministros:</h3><div><div class=container-fluid><table ng-table=vm.tableParams class=table><tr ng-repeat=\"suministro in $data\" ng-class=\"{\'azul-claro\': suministro.seleccionado}\"><td title=\"\'Grupo suministro\'\" align=center>{{suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase();}}-{{suministro.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase();}}</td><td title=\"\'Familia\'\" align=center>{{suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase();}}</td><td title=\"\'Tipo\'\" align=center>{{suministro.tipoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Marca\'\" align=center>{{suministro.marca.toUpperCase();}}</td><td title=\"\'N° serie\'\" align=center>{{suministro.serie? suministro.serie.toUpperCase() : \"-\"}}</td><td title=\"\'N° inventario\'\" align=center>{{suministro.inventario ? suministro.inventario : \"-\"}}</td><td title=\"\'Cant.\'\" align=center>{{suministro.cantidad>0? suministro.cantidad : \"-\"}}</td><td title=\"\'Ver\'\" align=center><div class=btn-group><a class=\"btn btn-primary\" ng-click=vm.mostrarInformacionSuministro(suministro)><i class=\"fa fa-search\"></i></a></div></td><td header=\"\'headerCheckbox.html\'\" align=center><input type=checkbox ng-click=vm.comprobarCantidadSeleccionada(suministro); ng-model=suministro.seleccionado></td></tr></table></div><div class=col-lg-12><div uib-alert type=info>Cantidad seleccionados: {{vm.cantidadSeleccionada();}}</div></div></div></div><div class=col-lg-12><h3>Ubicación Actual:</h3></div><div class=col-lg-12><div class=\"form-group has-feedback\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(vm.ubicacion) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(vm.ubicacion)}}</div></div><br><div class=col-lg-12><center><div><button style=width:60% ng-disabled=\"vm.cantidadSeleccionada()<=0\" class=\"btn btn-primary\" ng-click=vm.asignarIndividual()><i class=\"fa fa-map-marker\"></i> Buscar ubicación nueva</button></div></center></div></div><div class=col-lg-12 ng-if=!vm.nuevaUbicacion.id><br><br><div uib-alert>Todavía no seleccionó una nueva ubicación</div></div><div class=col-lg-12 ng-if=vm.nuevaUbicacion.id><br><br><div class=col-lg-10><div class=\"form-group has-feedback\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(vm.nuevaUbicacion) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(vm.nuevaUbicacion)}}</div></div></div><div class=col-lg-2><label>¿Ocupar?</label><input type=checkbox ng-model=vm.ocupar></div></div></div></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button ng-click=vm.actualizarUbicacion(); ng-disabled=!vm.nuevaUbicacion.id class=\"btn btn-success\"><i class=\"fa fa-exchange\"></i> Actualizar ubicación</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/components/modales/cambio-password/modal-cambio-password.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading>Renovar password..</div><div class=panel-body><div class=container-fluid><form name=vm.form><div class=\"form-group col-lg-12\" ng-if=false><label>Password actual:</label><input class=form-control ng-maxlength=26 ng-minlength=6 ng-model=vm.renovar.passwordActual placeholder=Password type=password name=passwordActual required> <span uib-alert class=danger ng-if=\"vm.form.passwordActual.$error.maxlength && vm.form.passwordActual.$dirty\">Este campo no puede superar los 26 caracteres. </span><span uib-alert class=danger ng-if=\"vm.form.passwordActual.$error.required && vm.form.passwordActual.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.passwordActual.$error.minlength && vm.form.passwordActual.$dirty\">Este campo debe tener al menos 6 caracteres.</span></div><div class=\"form-group col-lg-12\"><label>Nueva Password:</label><input class=form-control ng-maxlength=26 ng-minlength=1 ng-model=vm.renovar.nuevaPassword placeholder=Password type=password name=nuevaPassword required> <span uib-alert class=danger ng-if=\"!vm.validarPassword().validation && vm.form.nuevaPassword.$dirty\">{{vm.validarPassword().mensaje}} </span><span uib-alert type=success ng-if=\"vm.validarPassword().validation && vm.form.nuevaPassword.$dirty\">{{vm.validarPassword().mensaje}}</span></div><div class=\"form-group col-lg-12\"><label>Repita Nueva Password:</label><input class=form-control ng-model=vm.renovar.repiteNuevaPassword placeholder=\"Repita Password\" type=password name=repiteNuevaPassword required> <span uib-alert class=danger ng-if=\"vm.form.repiteNuevaPassword.$error.required && vm.form.repiteNuevaPassword.$dirty\">Este campo es requerido.</span></div><span class=col-xs-12 uib-alert class=danger ng-if=\"vm.renovar.nuevaPassword !== vm.renovar.repiteNuevaPassword && vm.form.repiteNuevaPassword.$dirty\">Las contraseñas deben ser iguales.</span></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.guardar() ng-disabled=\"vm.form.$invalid || vm.renovar.nuevaPassword !== vm.renovar.repiteNuevaPassword || !vm.validarPassword().validation\"><span class=\"glyphicon glyphicon-ok\"></span> Renovar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/components/modales/confirmar-reclamar-pedido/confirmar-reclamar-pedido.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading>Confirmar o reclamar</div><div class=panel-body><div><uib-tabset active=activeJustified justified=true><uib-tab index=0 disable=!vm.moduloReclamo ng-click=\"vm.moduloReclamo = false\"><uib-tab-heading>Confirmación <i ng-class=\"{\'fa-chevron-right\': vm.moduloReclamo, \'fa-chevron-down\':!vm.moduloReclamo}\" class=\"fa pull-right\"></i></uib-tab-heading><div class=\"panel panel-default\" style=padding:20px><div uib-alert type=info><i class=\"fa fa-info-circle\"></i> &nbsp; Confirme la recepción en caso que lo solicitado coincida correctamente con lo recibido.</div><div><form name=formulario><div class=form-group><div class=\"form-group col-md-6\"><label>N° pedido:</label><div class=input-group><input type=text ng-readonly=true ng-model=vm.numeroPedido class=\"form-control text-uppercase\" name=numeroPedido><div class=input-group-btn><button class=\"btn btn-default\" ng-disabled=!vm.numeroPedido ng-click=vm.visualizarPedido()><i class=\"fa fa-search\"></i></button></div></div></div><div class=\"form-group col-md-6\"><label>N° movimiento:</label><div class=input-group><input type=text ng-readonly=true ng-model=vm.numeroMovimiento class=\"form-control text-uppercase\" name=numeroMovimiento><div class=input-group-btn><button class=\"btn btn-default\" ng-disabled=!vm.numeroMovimiento ng-click=vm.visualizarMovimiento()><i class=\"fa fa-search\"></i></button></div></div></div><div class=\"form-group col-md-6\"><label>Nombre y apellido:</label><input class=form-control type=text class=\"form-control text-uppercase\" ng-readonly=true ng-model=vm.nombreConfirmacion name=nombreConfirmacion></div><div class=\"form-group col-md-6\"><label>Fecha:</label><input class=form-control type=text class=\"form-control text-uppercase\" ng-readonly=true ng-model=vm.fecha required name=fecha></div></div><br><center><button class=\"center-block btn btn-primary\" ng-disabled=formulario.$invalid ng-click=vm.confirmar();><i class=\"fa fa-check\"></i> Confirmar</button></center></form></div></div></uib-tab><uib-tab index=1 disable=vm.moduloReclamo ng-click=\"vm.moduloReclamo = true\"><uib-tab-heading>Reclamo <i ng-class=\"{\'fa-chevron-right\': !vm.moduloReclamo, \'fa-chevron-down\':vm.moduloReclamo}\" class=\"fa pull-right\"></i></uib-tab-heading><div class=\"panel panel-default\" style=padding:20px><div uib-alert><i class=\"fa fa-info-circle\"></i> Efectúe un reclamo sólo cuando la cantidad de paquetes que llegaron a su sucursal, coincide con la indicada en el mail que informa el despacho, pero los suministros entregados no coinciden con el remito.<br>Si falta algún paquete completo, por favor efectúe un reclamo en la empresa de logística encargada del despacho</div><div class=col><form name=formularioReclamo><div class=form-group><div class=\"form-group col-md-6\"><label>N° pedido:</label><div class=input-group><input type=text ng-readonly=true ng-model=vm.numeroPedido class=\"form-control text-uppercase\" name=numeroPedido><div class=input-group-btn><button class=\"btn btn-default\" ng-disabled=!vm.numeroPedido ng-click=vm.visualizarPedido()><i class=\"fa fa-search\"></i></button></div></div></div><div class=\"form-group col-md-6\"><label>N° movimiento:</label><div class=input-group><input type=text ng-readonly=true ng-model=vm.numeroMovimiento class=\"form-control text-uppercase\" name=numeroMovimiento><div class=input-group-btn><button class=\"btn btn-default\" ng-disabled=!vm.numeroMovimiento ng-click=vm.visualizarMovimiento()><i class=\"fa fa-search\"></i></button></div></div></div><div class=\"form-group col-md-6\"><label>Nombre y apellido:</label><input class=form-control type=text class=\"form-control text-uppercase\" ng-readonly=true ng-model=vm.nombreConfirmacion name=nombreConfirmacion></div><div class=\"form-group col-md-6\"><label>Fecha:</label><input class=form-control type=text class=\"form-control text-uppercase\" ng-readonly=true ng-model=vm.fecha required name=fecha></div><div class=\"form-group col-md-12\"><label>Descripción del reclamo:</label><textarea class=form-control type=text style=resize:vertical placeholder=\"Describa el reclamo\" ng-model=vm.descripcionReclamo ng-minlength=10 ng-maxlength=300 required name=descripcionReclamo></textarea><span uib-alert ng-show=\"formularioReclamo.descripcionReclamo.$error.required && formularioReclamo.descripcionReclamo.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"formularioReclamo.descripcionReclamo.$error.minlength && formularioReclamo.descripcionReclamo.$dirty\">Este campo debe tener al menos 10 caracteres. </span><span uib-alert class=danger ng-if=\"formularioReclamo.descripcionReclamo.$error.maxlength && formularioReclamo.descripcionReclamo.$dirty\">Este campo no puede superar los 300 caracteres.</span></div></div><br><center><button class=\"center-block btn btn-warning\" ng-disabled=formularioReclamo.$invalid ng-click=vm.reclamar();><i class=\"fa fa-check\"></i> &nbsp;Efectuar reclamo</button></center></form></div></div></uib-tab></uib-tabset></div></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cerrar</button></center></div></div></div></div>");
$templateCache.put("app/components/modales/editar-egreso/editar-egreso.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading>Editar despacho N°: {{vm.egreso.numeroEgreso}}</div><div class=panel-body><div class=container-fluid><div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=\"col-lg-12 form-group\"><label>N° de guía</label><input type=text ng-model=vm.egreso.nroGuia class=form-control placeholder=\"Ingrese número de guía\"></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.editarObjeto() ng-disabled=vm.form.$invalid><span class=\"glyphicon glyphicon-ok\"></span> Editar atributos</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/modales/editar-movimiento/editar-movimiento.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading>Editar {{vm.movimiento.tipoMovimiento.nombre}} N°: {{vm.movimiento.numeroMovimiento}}</div><div class=panel-body><div class=container-fluid><div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=\"form-group col-lg-6\" ng-if=\"vm.movimiento.tipoMovimiento.id==2\"><label>Número de remito:</label><input type=text ng-maxlength=100 ng-model=vm.movimiento.numeroRemito class=form-control placeholder=\"Ingrese número de remito\" name=numeroRemito> <span uib-alert class=danger ng-if=\"vm.form.numeroRemito.$error.maxlength && vm.form.numeroRemito.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><div class=\"form-group col-lg-6\" ng-if=\"vm.movimiento.tipoMovimiento.id==2\"><label>Numero de orden de compra:</label><input type=text name=numeroOrden ng-maxlength=100 ng-model=vm.movimiento.numeroOrden class=form-control placeholder=\"Ingrese número de orden de compra\"> <span uib-alert class=danger ng-if=\"vm.form.numeroOrden.$error.maxlength && vm.form.numeroOrden.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><div class=\"form-group col-lg-6\" ng-if=\"vm.movimiento.tipoMovimiento.id==2\"><label>Numero de Vale Ingreso:</label><input type=text name=numeroOrden ng-maxlength=100 ng-model=vm.movimiento.numeroIngresoVale class=form-control placeholder=\"Ingrese número de vale de ingreso\"> <span uib-alert class=danger ng-if=\"vm.form.numeroIngresoVale.$error.maxlength && vm.form.numeroIngresoVale.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><div class=\"form-group col-lg-6\" ng-if=\"vm.movimiento.tipoMovimiento.id==2\"><label>Fecha ingreso manual:</label><input type=date id=fechaIngreso name=fechaIngreso class=form-control ng-model=vm.fechaIngreso> <span uib-alert class=danger ng-if=\"vm.form.fechaIngreso.$error.date && vm.form.fechaIngreso.$dirty\">La fecha ingresada no es válida. </span><span uib-alert class=danger ng-if=\"vm.fechaIngreso && vm.fechaIngreso>vm.fechaActual && vm.form.fechaIngreso.$dirty\">La fecha ingresada debe ser menor a la fecha actual.</span></div><div class=\"form-group col-lg-4\" ng-if=\"vm.movimiento.tipoMovimiento.id==1\"><label>Número de Vale:</label><input class=form-control ng-maxlength=100 ng-model=vm.movimiento.numeroVale type=text name=numeroVale placeholder=\"Ingrese número de Vale\"> <span uib-alert class=danger ng-if=\"vm.form.numeroVale.$error.maxlength && vm.form.numeroVale.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><div class=\"form-group col-lg-4\" ng-if=\"vm.movimiento.tipoMovimiento.id==1\"><label>Número de seguimiento por mail:</label><input type=text class=form-control ng-maxlength=100 ng-model=vm.movimiento.numeroMail placeholder=\"Ingrese el número de seguimiento por mail\" name=numeroMail> <span uib-alert class=danger ng-if=\"vm.form.numeroMail.$error.maxlength && vm.form.numeroMail.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><div class=\"form-group col-lg-4\" ng-if=\"vm.movimiento.tipoMovimiento.id==1\"><label>Sector:</label><input type=text class=form-control ng-maxlength=100 ng-model=vm.movimiento.sector placeholder=\"Ingrese el sector\" name=sector> <span uib-alert class=danger ng-if=\"vm.form.sector.$error.maxlength && vm.form.sector.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=form-control ng-maxlength=500 ng-model=vm.movimiento.observacion type=text name=observacion style=resize:vertical placeholder=\"Ingrese observación\"></textarea><span uib-alert class=danger ng-if=\"vm.form.observacion.$error.maxlength && vm.form.observacion.$dirty\">Este campo no puede superar los 500 caracteres.</span></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.editarObjeto() ng-disabled=\"vm.form.$invalid || (vm.fechaIngreso && vm.fechaIngreso>vm.fechaActual)\"><span class=\"glyphicon glyphicon-ok\"></span> Editar atributos</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/modales/editar-suministro/editar-suministro.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading>Editar suministro</div><div class=panel-body><div class=container-fluid><div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=\"col-lg-6 form-group\" ng-if=\"vm.modo!=\'editar\'\"><label>Empresa</label><input type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=empresa typeahead-editable=false required> <span uib-alert ng-if=\"vm.form.empresa.$error.required && vm.form.empresa.$dirty\">Campo requerido</span></div><div class=\"col-lg-6 form-group\" ng-if=\"vm.modo==\'editar\'\"><label>Empresa</label><input type=text ng-disabled=\"vm.modo==\'editar\'\" class=form-control ng-model=vm.empresaMayus></div><div class=\"form-group col-lg-6\" ng-if=\"vm.modo!=\'editar\'\"><label>Grupo de suministro:</label><input ng-disabled=\"vm.modo==\'editar\' || !vm.empresa\" type=text ng-model=vm.grupoSuministro placeholder=\"Ingrese o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase() for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 required name=grupo typeahead-editable=false focus-on=grupoSuministro> <span uib-alert class=danger ng-show=\"(!vm.grupoSuministro.nombre && vm.form.grupoSuministro.$dirty) || (vm.form.grupoSuministro.$error.required && vm.form.grupoSuministro.$dirty)\">Este campo es requerido.</span></div><div class=\"col-lg-6 form-group\" ng-if=\"vm.modo==\'editar\'\"><label>Grupo de suministro:</label><input type=text class=form-control ng-disabled=\"vm.modo==\'editar\'\" ng-model=vm.grupoMayus></div><div class=\"form-group col-lg-6\" ng-if=\"vm.modo!=\'editar\'\"><label>Familia de suministro:</label><input ng-disabled=\"vm.modo==\'editar\' || !vm.empresa || !vm.grupoSuministro\" type=text ng-model=vm.familiaSuministro placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familiaSuministro as familiaSuministro.nombre.toUpperCase() for familiaSuministro in vm.familias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=familiaSuministro typeahead-editable=false focus-on=familiaSuministro> <span uib-alert class=danger ng-show=\"(!vm.familiaSuministro.nombre && vm.form.familiaSuministro.$dirty)|| (vm.form.familiaSuministro.$error.required && vm.form.familiaSuministro.$dirty)\">Este campo es requerido.</span></div><div class=\"col-lg-6 form-group\" ng-if=\"vm.modo==\'editar\'\"><label>Familia de suministro:</label><input type=text class=form-control ng-disabled=\"vm.modo==\'editar\'\" ng-model=vm.familiaMayus></div><div class=\"form-group col-lg-6\"><label>Tipo de suministro:</label><input ng-disabled=\"(vm.modo!=\'editar\' && (!vm.grupoSuministro || !vm.familiaSuministro))\" type=text ng-model=vm.suministro.suministro.tipoSuministro placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"tipoSuministro as tipoSuministro.nombre.toUpperCase() for tipoSuministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=tipoSuministro typeahead-editable=false focus-on=tipoSuministro> <span uib-alert class=danger ng-show=\"vm.form.tipoSuministro.$error.required && vm.form.tipoSuministro.$dirty\">Este campo es requerido.</span></div><div class=row><div class=\"form-group col-lg-2\"><label>¿Nuevo?: &nbsp;&nbsp;</label><br><toggle ng-model=vm.suministro.nuevo on=SI off=NO onstyle=btn-success offstyle=btn-danger></toggle></div><div class=col-lg-4><label>Precio:</label><input ng-disabled=\"vm.modo==\'editar\'\" class=form-control min=0 ng-min=0.01 ng-maxlength=15 ng-model=vm.suministro.suministro.precioUnitario placeholder=\"Precio unitario\" type=number name=precioBien required ng-pattern=/^[0-9]+(\\.[0-9]{1,2})?$/ step=0.01> <span uib-alert class=danger ng-show=\"vm.modo!=\'editar\' && vm.form.precioBien.$error.required && vm.form.precioBien.$dirty\">Campo requerido. </span><span uib-alert class=danger ng-show=\"vm.modo!=\'editar\' && vm.form.precioBien.$error.number && vm.form.precioBien.$dirty\">Valor inválido. </span><span uib-alert class=danger ng-if=\"vm.modo!=\'editar\' && vm.form.precioBien.$error.maxlength && vm.form.precioBien.$dirty\">Longitud máxima. </span><span uib-alert class=danger ng-if=\"vm.modo!=\'editar\' && vm.form.precioBien.$error.pattern && vm.form.precioBien.$dirty\">Valor inválido. </span><span uib-alert class=danger ng-if=\"vm.modo!=\'editar\' && vm.form.precioBien.$error.min && vm.form.precioBien.$dirty\">Valor negativo.</span></div><div class=col-lg-6><label>Marca:</label><input type=text name=marca ng-maxlength=100 class=form-control ng-model=vm.suministro.suministro.marca placeholder=\"Ingrese la marca\" required> <span uib-alert ng-if=\"vm.form.marca.$error.required && vm.form.marca.$dirty\">Este campo es requerido </span><span uib-alert class=danger ng-if=\"vm.form.marca.$error.maxlength && vm.form.marca.$dirty\">Este campo no puede superar los 100 caracteres.</span></div></div><div class=\"form-group col-lg-6\"><label>Ingrese el número de serie:</label><input class=form-control ng-maxlength=100 ng-model=vm.suministro.serie placeholder=\"Ingrese el número de serie\" type=text name=serie required> <span uib-alert class=danger ng-show=\"vm.form.serie.$error.required && vm.form.serie.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.serie.$error.maxlength && vm.form.serie.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><div class=\"form-group col-lg-6\"><label>Ingrese el número de inventario:</label><input class=form-control min=0 ng-min=0 ng-maxlength=9 ng-model=vm.suministro.inventario placeholder=\"Ingrese el número de inventario\" type=number name=inventario required step=1> <span uib-alert class=danger ng-show=\"vm.form.inventario.$error.required && vm.inventario.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-show=\"vm.form.inventario.$error.number && vm.form.inventario.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.inventario.$error.maxlength && vm.form.inventario.form.$dirty\">Este campo no puede superar los 10 caracteres. </span><span uib-alert class=danger ng-if=\"vm.form.inventario.$error.pattern && vm.form.inventario.form.$dirty\">Este campo no puede tener decimales. </span><span uib-alert class=danger ng-if=\"vm.form.inventario.$error.min && vm.form.inventario.form.$dirty\">Este campo no puede tener valores negativos.</span></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.editarObjeto() ng-disabled=\"vm.form.$invalid || !vm.suministro.suministro.tipoSuministro.nombre\"><span class=\"glyphicon glyphicon-ok\"></span> Editar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/modales/editar-problemas-ingreso/editar-problemas-ingreso.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Editar problemas del ingreso</div><div class=panel-body><div class=col-lg-12 ng-if=vm.comprobarIngresoCerrado()><div class=\"panel panel-default\"><div class=panel-body><div class=\"form-group col-lg-12\"><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.ingreso.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.ingreso.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Autorizó:</label><input type=text ng-model=vm.ingreso.solicitante class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Proveedor:</label><input type=text ng-readonly=true ng-model=vm.ingreso.proveedor.nombre class=\"form-control text-uppercase\" name=proveedor></div><div class=\"form-group col-lg-6\"><label>Persona Proveedor:</label><input type=text ng-readonly=true ng-model=vm.personaProveedor class=\"form-control text-uppercase\" name=proveedor></div><div class=\"form-group col-lg-3\"><label>Número de movimiento:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroMovimiento type=text name=numeroMovimiento></div><div class=\"form-group col-lg-3\"><label>Número de orden de compra:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroOrden type=text name=numeroOrden></div><div class=\"form-group col-lg-3\"><label>Fecha:</label><input class=form-control ng-readonly=true ng-model=vm.fecha type=text name=fecha></div><div class=\"form-group col-lg-3\"><label>Monto total:</label><input class=form-control ng-readonly=true ng-model=vm.montoTotal type=text name=montoTotal></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=form-control ng-readonly=true ng-model=vm.ingreso.observacion type=text name=observacion style=resize:vertical></textarea></div></div></div><br><div class=col-lg-12><label>Agregar problemas:</label><div class=col-lg-12><div class=col-lg-10><input type=text ng-model=vm.tipoProblema placeholder=\"Seleccione el problema\" uib-typeahead=\"tipoProblema as tipoProblema.nombre.toUpperCase() for tipoProblema in vm.tiposProblema\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=col-lg-2><button class=\"btn btn-success\" ng-disabled=!vm.tipoProblema.id ng-click=vm.agregarProblema()><span class=\"fa fa-check\"></span> Agregar</button></div></div></div><br><br><br><br><div class=col-lg-12 ng-show=\"vm.comprobarIngresoCerrado() && vm.ingreso.problemas.length==0\"><span class=danger uib-alert>El ingreso no tiene problemas asignados.</span></div><br><div class=\"col-lg-12 form-group\" ng-if=\"vm.comprobarIngresoCerrado() && vm.ingreso.problemas.length>0\"><label>Problemas asignados</label></div><form name=vm.form ng-show=true ng-if=vm.comprobarIngresoCerrado();><div class=col-lg-12 ng-show=\"vm.ingreso.problemas.length>0\"><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.ingreso.problemas.length>0\"><tr ng-repeat=\"problema in $data track by $index\"><div><td title=\"\'Problema\'\" align=center>{{problema.tipoProblema.nombre.toUpperCase();}}</td><td title=\"\'¿Foto?\'\" align=center>{{problema.encabezadoFoto? \"SI\" : \"NO\"}}</td><td data-title=\"\'Acciones\'\" align=center><div class=btn-group><!-- 								<a class=\"btn btn-info\" ng-click=\"vm.verProblema(problema)\">\r\n					<i class=\"fa fa-search\"></i>\r\n				</a> --> <a class=\"btn btn-primary\" ng-click=vm.verProblema(problema)><i class=\"fa fa-camera\"></i> </a><a class=\"btn btn-danger\" ng-click=vm.eliminarProblema($index)><i class=\"fa fa-remove\"></i></a></div></td></div></tr></table></div><div class=\"form-group col-lg-12\"><label>Descripción del problema:</label><textarea class=form-control ng-maxlength=1000 ng-model=vm.ingreso.observacionProblema placeholder=\"Ingrese una descripción de los problemas observados\" type=text name=observacion style=resize:vertical></textarea><span uib-alert class=danger ng-if=\"vm.form.observacion.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.observacion.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 1000 caracteres.</span></div><!-- 		<div class=\"col-lg-12 row \" ng-if=\"vm.ingreso.encabezadoFoto\">\r\n					<center>\r\n						<div ng-if=\"vm.foto\" class=\"marco-imagenes\">\r\n							<img ng-src=\"{{vm.foto}}\" />\r\n						</div>  \r\n					</center>  \r\n				            <button class=\"btn btn-danger\" ng-click=\"vm.quitarFoto();\">\r\n				              <i class=\"fa fa-close\"></i>\r\n				            </button>         \r\n				</div>\r\n				<button type=\"button\" class=\"btn btn-primary btn-block\" ng-click=\"vm.abrirSeleccionFoto()\">\r\n					<span class=\"glyphicon glyphicon-camera\"></span> \r\n					Seleccionar foto\r\n				</button> --></form></div><div ng-if=!vm.comprobarIngresoCerrado() class=col-lg-12><span uib-alert class=danger>El ingreso todavía no tiene ubicaciones asignadas.</span></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.editarProblemas()><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></form></div>");
$templateCache.put("app/components/modales/editar-suministro-no-inventariable/editar-suministro-no-inventariable.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading>Editar suministro</div><div class=panel-body><div class=container-fluid><div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=\"col-lg-6 form-group\" ng-if=\"vm.modo!=\'editar\'\"><label>Empresa</label><input type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=empresa typeahead-editable=false required> <span uib-alert ng-if=\"vm.form.empresa.$error.required && vm.form.empresa.$dirty\">Campo requerido</span></div><div class=\"col-lg-6 form-group\" ng-if=\"vm.modo==\'editar\'\"><label>Empresa</label><input type=text ng-disabled=\"vm.modo==\'editar\'\" class=form-control ng-model=vm.empresaMayus></div><div class=\"form-group col-lg-6\" ng-if=\"vm.modo!=\'editar\'\"><label>Grupo de suministro:</label><input ng-disabled=\"vm.modo==\'editar\' || !vm.empresa\" type=text ng-model=vm.grupoSuministro placeholder=\"Ingrese o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase() for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 required name=grupo typeahead-editable=false focus-on=grupoSuministro> <span uib-alert class=danger ng-show=\"(!vm.grupoSuministro.nombre && vm.form.grupoSuministro.$dirty) || (vm.form.grupoSuministro.$error.required && vm.form.grupoSuministro.$dirty)\">Este campo es requerido.</span></div><div class=\"col-lg-6 form-group\" ng-if=\"vm.modo==\'editar\'\"><label>Grupo de suministro:</label><input type=text class=form-control ng-disabled=\"vm.modo==\'editar\'\" ng-model=vm.grupoMayus></div><div class=\"form-group col-lg-6\" ng-if=\"vm.modo!=\'editar\'\"><label>Familia de suministro:</label><input ng-disabled=\"vm.modo==\'editar\' || !vm.empresa || !vm.grupoSuministro\" type=text ng-model=vm.familiaSuministro placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familiaSuministro as familiaSuministro.nombre.toUpperCase() for familiaSuministro in vm.familias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=familiaSuministro typeahead-editable=false focus-on=familiaSuministro> <span uib-alert class=danger ng-show=\"(!vm.familiaSuministro.nombre && vm.form.familiaSuministro.$dirty)|| (vm.form.familiaSuministro.$error.required && vm.form.familiaSuministro.$dirty)\">Este campo es requerido.</span></div><div class=\"col-lg-6 form-group\" ng-if=\"vm.modo==\'editar\'\"><label>Familia de suministro:</label><input type=text class=form-control ng-disabled=\"vm.modo==\'editar\'\" ng-model=vm.familiaMayus></div><div class=\"form-group col-lg-6\"><label>Tipo de suministro:</label><input ng-disabled=\"(vm.modo!=\'editar\' && (!vm.grupoSuministro || !vm.familiaSuministro))\" type=text ng-model=vm.suministro.tipoSuministro placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"tipoSuministro as tipoSuministro.nombre.toUpperCase() for tipoSuministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=tipoSuministro typeahead-editable=false focus-on=tipoSuministro> <span uib-alert class=danger ng-show=\"vm.form.tipoSuministro.$error.required && vm.form.tipoSuministro.$dirty\">Este campo es requerido.</span></div><div class=row><div class=col-lg-3><label>Precio:</label><input ng-disabled=\"vm.modo==\'editar\'\" class=form-control min=0 ng-min=0.01 ng-maxlength=15 ng-model=vm.suministro.precioUnitario placeholder=\"Precio unitario\" type=number name=precioBien required ng-pattern=/^[0-9]+(\\.[0-9]{1,2})?$/ step=0.01> <span uib-alert class=danger ng-show=\"vm.modo!=\'editar\' && vm.form.precioBien.$error.required && vm.form.precioBien.$dirty\">Campo requerido. </span><span uib-alert class=danger ng-show=\"vm.modo!=\'editar\' && vm.form.precioBien.$error.number && vm.form.precioBien.$dirty\">Valor inválido. </span><span uib-alert class=danger ng-if=\"vm.modo!=\'editar\' && vm.form.precioBien.$error.maxlength && vm.form.precioBien.$dirty\">Longitud máxima. </span><span uib-alert class=danger ng-if=\"vm.modo!=\'editar\' && vm.form.precioBien.$error.pattern && vm.form.precioBien.$dirty\">Valor inválido. </span><span uib-alert class=danger ng-if=\"vm.modo!=\'editar\' && vm.form.precioBien.$error.min && vm.form.precioBien.$dirty\">Valor negativo.</span></div><div class=col-lg-5><label>Marca:</label><input type=text name=marca ng-maxlength=100 class=form-control ng-model=vm.suministro.marca placeholder=\"Ingrese la marca\" required> <span uib-alert ng-if=\"vm.form.marca.$error.required && vm.form.marca.$dirty\">Este campo es requerido </span><span uib-alert class=danger ng-if=\"vm.form.marca.$error.maxlength && vm.form.marca.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><div class=col-lg-4><label>Fecha vencimiento:</label><input type=date name=fechaVencimiento class=form-control ng-model=vm.suministro.fechaVencimiento> <span uib-alert class=danger ng-if=\"vm.form.fechaVencimiento.$error.date && vm.form.fechaVencimiento.$dirty\">La fecha ingresada no es válida.</span></div></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.editarObjeto() ng-disabled=\"vm.form.$invalid || !vm.suministro.tipoSuministro.nombre\"><span class=\"glyphicon glyphicon-ok\"></span> Editar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/modales/egreso-multiple-excel/egreso-multiple-excel.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading>Seleccionar sucursales y cantidades vía excel</div><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12 ng-if=!vm.resultado><div class=\"panel panel-default\"><div class=panel-body><div class=\"form-group col-lg-12\"><label>Tipo de suministro:</label><input type=text ng-readonly=true ng-model=vm.tipoSuministroSeleccionado class=\"form-control text-uppercase\"></div></div></div><div class=\"col-lg-12 form-group\"><label>Ingrese el archivo Excel (.xlsx):</label><div class=col-lg-12><div class=col-lg-10><input class=form-control type=file accept=application/vnd.openxmlformats-officedocument.spreadsheetml.sheet id=fileInput onchange=angular.element(this).scope().cargarArchivo(this.files[0])></div><div class=col-lg-2><button class=\"btn btn-primary\" ng-click=vm.buscarExcel()><i class=\"fa fa-check\"></i> Procesar archivo</button></div></div></div></div><div class=col-lg-12 ng-if=vm.resultado><div ng-if=!vm.formatoIncorrecto><div class=col-lg-12><div uib-alert type=success><i class=\"fa fa-success\"></i> Se ha procesado el documento <b>{{vm.file.name}}</b> con éxito!</div></div><div class=col-lg-12><div uib-alert type=info><i class=\"fa fa-info\"></i> Se leyeron <b>{{vm.correctos.length+vm.erroneos.length+vm.incompletos.length}}</b> registros<div ng-class=\"{\'danger\':vm.correctos.length==0}\">Registros correctos: {{vm.correctos.length>0? vm.correctos.length : \"No hubo\" }}</div><div ng-class=\"{\'danger\':vm.incompletos.length==0}\">Registros incompletos: {{vm.incompletos.length>0? vm.incompletos.length : \"No hubo\" }}</div><div ng-class=\"{\'danger\':vm.erroneos.length==0}\">Registros erróneos: {{vm.erroneos.length>0? vm.erroneos.length : \"No hubo\" }}</div><div ng-class=\"{\'danger\':vm.seleccionados.length==0}\">Sucursales seleccionadas: {{vm.seleccionados.length>0? vm.seleccionados.length : \"No hubo\" }}</div><div>Cantidad asignada total: {{vm.cantidadTotal }}</div></div></div><div class=col-lg-12 ng-if=\"vm.correctos.length>0\"><div class=\"panel panel-default\"><div class=panel-heading>Correctos:</div><div class=panel-body><div class=col-lg-12><div uib-alert type=success><i class=\"fa fa-check\"></i> Se pudo leer correctamente los siguientes registros:</div></div><table show-filter=true ng-table=vm.tableParamsCorrectos class=table><tr ng-repeat=\"correcto in $data track by $index\"><td data-title=\"\'Sucursal\'\" align=center>{{correcto.sucursal? correcto.sucursal.nombre.toUpperCase()+\" - (\"+correcto.sucursal.codigoSucursal.toUpperCase()+\")\" : \"correcto.codigoSucursal\"}}</td><td data-title=\"\'Cantidad\'\" align=center>{{correcto.cantidad}}</td><td data-title=\"\'Estado\'\" align=center ng-class=\"{\'danger\':correcto.estado!=\'Asignado\', \'success\': correcto.estado==\'Asignado\'}\">{{correcto.estado}}</td></tr></table></div></div></div><div class=col-lg-12 ng-if=\"vm.erroneos.length>0\"><div class=\"panel panel-default\"><div class=panel-heading>Suministros erróneos:</div><div class=panel-body><div class=col-lg-12><div uib-alert>El campo \'cantidad\' no es numérica y/o los códigos de sucursal no son correctos o no existen</div></div><table show-filter=true ng-table=vm.tableParamsErroneos class=table><tr ng-repeat=\"erroneo in $data track by $index\"><td data-title=\"\'Código sucursal\'\" align=center>{{erroneo.codigoSucursal}}</td><td data-title=\"\'Cantidad\'\" align=center>{{erroneo.cantidad}}</td><td data-title=\"\'Causa\'\" align=center>{{erroneo.estado}}</td></tr></table></div></div></div><div class=col-lg-12 ng-if=\"vm.incompletos.length>0\"><div class=\"panel panel-default\"><div class=panel-heading>Suministros incompletos:</div><div class=panel-body><div class=col-lg-12><div uib-alert>Faltan los datos marcados</div></div><table show-filter=true ng-table=vm.tableParamsIncompletos class=table><tr ng-repeat=\"imcompleto in $data track by $index\"><td data-title=\"\'Código sucursal\'\" align=center ng-class=\"{\'danger\' : !imcompleto.codigoSucursal}\">{{imcompleto.codigoSucursal}}</td><td data-title=\"\'Cantidad\'\" align=center ng-class=\"{\'danger\' : !imcompleto.cantidad}\">{{imcompleto.cantidad}}</td></tr></table></div></div></div></div><div ng-if=vm.formatoIncorrecto><div class=col-lg-12><div uib-alert><i class=\"fa fa-danger\"></i><br>El documento <b>{{vm.file.name}}</b> no posee registros válidos !<br>Debe subir una hoja de cálculo en formato .xlsx, que utilice desde la columna \'A\' hasta la \'B\'. Y que correspondan con los datos: \'codigoSucursal\' y \'cantidad\'.<br>En la columna \'cantidad\' debe ingresar un tipo de dato numérico y entero.</div></div></div></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-5 col-sm-2\"><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cerrar</button></div></div></div></div></div>");
$templateCache.put("app/components/modales/filtros-busqueda-egreso/filtros-busqueda-egreso.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading>Filtros de egresos..</div><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><div><label>Filtrar por depósito:</label><div class=col-lg-12><div class=\"form-group col-lg-2\"><input type=checkbox ng-disabled=vm.depositoUsuario.id ng-model=vm.buscarDeposito ng-click=vm.busquedaDeposito()></div><div class=\"form-group col-lg-10\"><input type=text ng-disabled=\"!vm.buscarDeposito || vm.depositoUsuario.id\" ng-model=vm.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div><div><label>Filtrar por empresa y sucursal:</label><div class=col-lg-12><div class=\"form-group col-lg-2\"><input type=checkbox ng-model=vm.buscarSucursal ng-click=vm.busquedaSucursal()></div><div class=\"form-group col-lg-5\"><input ng-disabled=!vm.buscarSucursal type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-5\"><input ng-disabled=\"!vm.buscarSucursal || !vm.empresa\" type=text ng-model=vm.sucursal placeholder=\"Seleccione o busque el sucursal\" uib-typeahead=\"sucursal as sucursal.nombre.toUpperCase() for sucursal in vm.sucursales | filter:{nombre:$viewValue}\" focus-on=sucursal class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div><div><label>Filtrar por fecha:</label><div class=col-lg-12><div class=\"form-group col-lg-2\"><input type=checkbox ng-model=vm.buscarFecha ng-click=vm.busquedaFecha()></div><div class=\"form-group col-lg-5\"><label>Desde:</label><input type=date id=fechaDesde ng-disabled=!vm.buscarFecha name=fechaDesde class=form-control ng-model=vm.fechaDesde> <span uib-alert class=danger ng-if=\"vm.form.fechaDesde.$error.date && vm.form.fechaDesde.$dirty && vm.buscarFecha\">La fecha ingresada no es válida. </span><span uib-alert class=danger ng-if=\"vm.fechaDesde && vm.fechaDesde>vm.fechaActual && vm.form.fechaDesde.$dirty && vm.buscarFecha\">La fecha ingresada debe ser menor a la fecha actual.</span></div><div class=\"form-group col-lg-5\"><label>Hasta:</label><input type=date id=fechaHasta ng-disabled=!vm.buscarFecha name=fechaHasta class=form-control ng-model=vm.fechaHasta> <span uib-alert class=danger ng-if=\"vm.form.fechaHasta.$error.date && vm.form.fechaHasta.$dirty && vm.buscarFecha\">La fecha ingresada no es válida. </span><span uib-alert class=danger ng-if=\"vm.fechaHasta && vm.fechaHasta>vm.fechaActual && vm.form.fechaHasta.$dirty && vm.buscarFecha\">La fecha ingresada debe ser menor a la fecha actual.</span></div></div><div class=col-lg-12><span uib-alert ng-if=\"(vm.form.fechaDesde.$dirty || vm.form.fechaHasta.$dirty)  && (!vm.fechaHasta || !vm.fechaDesde) && vm.buscarFecha\">Debe completar ambas fechas </span><span uib-alert ng-if=\"!vm.form.fechaDesde.$error.date && !vm.form.fechaHasta.$error.date && vm.fechaDesde>vm.fechaHasta && vm.buscarFecha\">La fecha Desde, debe ser menor a la fecha Hasta. </span><span uib-alert ng-if=\"vm.fechaDesde && vm.fechaHasta && !vm.comprobarPeriodoFechas()\">El periodo seleccionado no puede superar un año y medio</span></div></div><div><label>Filtrar por Estado:</label><div class=col-lg-12><div class=\"form-group col-lg-2\"><input type=checkbox ng-model=vm.buscarEstado ng-click=vm.busquedaEstado()></div><div class=\"form-group col-lg-10\"><input ng-disabled=!vm.buscarEstado type=text ng-model=vm.estado placeholder=\"Seleccione o busque el estado\" uib-typeahead=\"estado as estado.nombre.toUpperCase() for estado in vm.estados | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button ng-disabled=\"vm.validarFiltros() || !vm.comprobarPeriodoFechas()\" class=\"btn btn-success btn-block\" ng-click=vm.filtrar()><span class=\"glyphicon glyphicon-ok\"></span> Aplicar filtros</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/components/modales/egreso-multiple-automatico/egreso-multiple-automatico.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Egreso múltiple automático</div><div class=panel-body><div class=col-lg-12><center><button class=\"btn btn-success\" ng-disabled=\"!vm.habilitarBoton() || vm.form.$invalid\" ng-click=vm.armarDetalles()><span class=\"fa fa-magic\"></span> Armar detalles automáticamente</button><br><br></center><div class=\"panel panel-default\"><div class=panel-body><div class=\"form-group col-lg-12\"><label>Tipo de suministro:</label><input type=text ng-readonly=true ng-model=vm.tipoSuministroSeleccionado class=\"form-control text-uppercase\"></div></div></div><div class=\"col-lg-12 form-group\"><div uib-alert type=info>Cantidad disponible: <b>{{vm.cantidadTotal}}</b><br>Cantidad seleccionada: <b>{{vm.cantidadSeleccionada()}}</b></div><div uib-alert ng-if=\"vm.cantidadTotal<vm.cantidadSeleccionada()\"><br>La cantidad disponible no puede ser menor que la cantidad seleccionada</div></div><div class=col-lg-12><center><button class=\"btn btn-primary\" ng-click=vm.asignarSucursalesExcel()><span class=\"fa fa-excel-o\"></span> Asignar vía Excel (.xlsx)</button></center></div><div class=\"col-lg-12 form-group\"><label>Sucursales</label></div><div class=col-lg-12 ng-show=\"vm.sucursalesConsumoTope.length>0\"><table ng-table=vm.tableParams class=table show-filter=true><tr ng-repeat=\"detalle in $data track by $index\" ng-class=\"{\'azul-claro\': detalle.seleccionado, \'rojo-claro\': (detalle.asignado || (detalle.cantidadTope!=null && detalle.consumido+detalle.cantidadSolicitada>detalle.cantidadTope))}\"><div><td title=\"\'Nombre\'\" data-sortable=\"\'sucursal.nombre\'\" filter=\"{\'sucursal.nombre\': \'text\'}\" align=center>{{detalle.sucursal.nombre.toUpperCase();}}</td><td title=\"\'Código detalle\'\" filter=\"{\'sucursal.codigoSucursal\': \'text\'}\" data-sortable=\"\'sucursal.codigoSucursal\'\" align=center>{{detalle.sucursal.codigoSucursal.toUpperCase();}}</td><td title=\"\'Tope\'\" data-sortable=\"\'cantidadTope\'\" align=center>{{detalle.cantidadTope!=null ? detalle.cantidadTope : \"-\"}}<p ng-class=\"{\'rojo-claro\': (detalle.asignado || (detalle.cantidadTope!=null && detalle.consumido+detalle.cantidadSolicitada>detalle.cantidadTope))}\" ng-if=\"(detalle.asignado || (detalle.cantidadTope!=null && detalle.consumido+detalle.cantidadSolicitada>detalle.cantidadTope))\">¡Superado!</p></td><td title=\"\'Consumido\'\" align=center>{{detalle.consumido}}</td><td title=\"\'Seleccionar\'\" align=center><input type=checkbox ng-click=vm.tildar(detalle) ng-model=detalle.seleccionado ng-disabled=detalle.asignado></td><td style=width:12% data-title=\"\'Cantidad solicitada\'\"><ng-form name=camposForm><div><input class=form-control ng-pattern=/^[1-9][0-9]*$/ type=number name=cantidades ng-model=detalle.cantidadSolicitada placeholder=\"Ingrese cantidad\" ng-disabled=!detalle.seleccionado> <span uib-alert class=danger ng-if=\"(camposForm.cantidades.$error.number || camposForm.cantidades.$error.pattern) && camposForm.cantidades.$dirty\">Ingrese un valor válido.</span></div></ng-form></td></div></tr></table></div></div></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cerrar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/elegir-tipo-suministro/modal-elegir-tipo-suministro.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Seleccione el tipo de suministro</div><div class=panel-body><div><label>Búsqueda jerarquizada:</label><div class=col-lg-12><div class=col-lg-1><div class=form-group><input type=radio ng-model=vm.radio value=jerarquizada ng-change=vm.cambioRadio()></div></div><div class=col-lg-11><div class=\"form-group col-lg-6\"><label>Grupo de suministro:</label><input type=text ng-disabled=\"vm.radio!=\'jerarquizada\'\" ng-model=vm.grupo placeholder=\"Seleccione o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase()+\' (\'+grupo.empresa.nombre.toUpperCase()+\')\' for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Familia de suministro:</label><input ng-disabled=\"!vm.grupo.nombre || vm.radio!=\'jerarquizada\'\" focus-on=familia type=text ng-model=vm.familiaSuministro placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familiaSuministro as familiaSuministro.nombre.toUpperCase() for familiaSuministro in vm.familias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-12\"><label>Tipo de suministro:</label><input ng-if=\"vm.radio==\'jerarquizada\'\" ng-disabled=\"!vm.grupo.nombre || !vm.familiaSuministro.nombre || vm.radio!=\'jerarquizada\'\" type=text focus-on=tipo ng-model=vm.tipoSuministro placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase() for suministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <input ng-if=\"vm.radio==\'directa\'\" ng-disabled=\"!vm.grupo.nombre || !vm.familiaSuministro.nombre || vm.radio!=\'jerarquizada\'\" type=text focus-on=tipo ng-model=vm.tipoSuministro1 placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase() for suministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div><div><label>Búsqueda directa:</label><div class=col-lg-12 ng-disabled=\"\"><div class=\"form-group col-lg-1\"><input type=radio ng-model=vm.radio value=directa ng-change=vm.cambioRadio()></div><div class=\"form-group col-lg-11\"><label>Tipo de suministro:</label><input type=text ng-disabled=\"vm.radio!=\'directa\'\" ng-model=vm.tipoSuministroCompleto placeholder=\"Seleccione o busque el tipo de suministro por su nombre\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase()+\' (\'+suministro.familiaSuministro.nombre.toUpperCase()+\') - (\'+suministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+\')\' for suministro in vm.tiposCompletos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div><div class=panel-footer><div class=form-group><center><button ng-disabled=\"vm.form.$invalid || !vm.tipoSuministro\" class=\"btn btn-primary\" ng-click=vm.agregar()><span class=\"fa fa-check\"></span> Seleccionar</button> <button type=button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/filtros-busqueda-ingreso/filtros-busqueda-ingreso.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading>Filtros de ingresos..</div><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><div><label>Filtrar por depósito:</label><div class=col-lg-12><div class=\"form-group col-lg-2\"><input type=checkbox ng-disabled=vm.depositoUsuario.id ng-model=vm.buscarDeposito ng-click=vm.busquedaDeposito()></div><div class=\"form-group col-lg-10\"><input type=text ng-disabled=\"!vm.buscarDeposito  || vm.depositoUsuario.id\" ng-model=vm.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div><div><label>Filtrar por empresa y proveedor:</label><div class=col-lg-12><div class=\"form-group col-lg-2\"><input type=checkbox ng-model=vm.buscarProveedor ng-click=vm.busquedaProveedor()></div><div class=\"form-group col-lg-5\"><input ng-disabled=!vm.buscarProveedor type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-5\"><input ng-disabled=\"!vm.buscarProveedor || !vm.empresa\" type=text ng-model=vm.proveedor placeholder=\"Seleccione o busque el proveedor\" uib-typeahead=\"proveedor as proveedor.nombre.toUpperCase() for proveedor in vm.proveedores | filter:{nombre:$viewValue}\" focus-on=proveedor class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div><div><label>Filtrar por fecha:</label><div class=col-lg-12><div class=\"form-group col-lg-2\"><input type=checkbox ng-model=vm.buscarFecha ng-click=vm.busquedaFecha()></div><div class=\"form-group col-lg-5\"><label>Desde:</label><input type=date id=fechaDesde ng-disabled=!vm.buscarFecha name=fechaDesde class=form-control ng-model=vm.fechaDesde> <span uib-alert class=danger ng-if=\"vm.form.fechaDesde.$error.date && vm.form.fechaDesde.$dirty && vm.buscarFecha\">La fecha ingresada no es válida. </span><span uib-alert class=danger ng-if=\"vm.fechaDesde && vm.fechaDesde>vm.fechaActual && vm.form.fechaDesde.$dirty && vm.buscarFecha\">La fecha ingresada debe ser menor a la fecha actual.</span></div><div class=\"form-group col-lg-5\"><label>Hasta:</label><input type=date id=fechaHasta ng-disabled=!vm.buscarFecha name=fechaHasta class=form-control ng-model=vm.fechaHasta> <span uib-alert class=danger ng-if=\"vm.form.fechaHasta.$error.date && vm.form.fechaHasta.$dirty && vm.buscarFecha\">La fecha ingresada no es válida. </span><span uib-alert class=danger ng-if=\"vm.fechaHasta && vm.fechaHasta>vm.fechaActual && vm.form.fechaHasta.$dirty && vm.buscarFecha\">La fecha ingresada debe ser menor a la fecha actual.</span></div></div><div class=col-lg-12><span uib-alert ng-if=\"(vm.form.fechaDesde.$dirty || vm.form.fechaHasta.$dirty)  && (!vm.fechaHasta || !vm.fechaDesde) && vm.buscarFecha\">Debe completar ambas fechas </span><span uib-alert ng-if=\"!vm.form.fechaDesde.$error.date && !vm.form.fechaHasta.$error.date && vm.fechaDesde>vm.fechaHasta && vm.buscarFecha\">La fecha Desde, debe ser menor a la fecha Hasta. </span><span uib-alert ng-if=\"vm.fechaDesde && vm.fechaHasta && !vm.comprobarPeriodoFechas()\">El periodo seleccionado no puede superar un año y medio</span></div></div><div><label>Filtrar por Estado:</label><div class=col-lg-12><div class=\"form-group col-lg-2\"><input type=checkbox ng-model=vm.buscarEstado ng-click=vm.busquedaEstado()></div><div class=\"form-group col-lg-10\"><input ng-disabled=!vm.buscarEstado type=text ng-model=vm.estado placeholder=\"Seleccione o busque el estado\" uib-typeahead=\"estado as estado.nombre.toUpperCase() for estado in vm.estados | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button ng-disabled=\"vm.validarFiltros() || !vm.comprobarPeriodoFechas()\" class=\"btn btn-success btn-block\" ng-click=vm.filtrar()><span class=\"glyphicon glyphicon-ok\"></span> Aplicar filtros</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/components/modales/filtros-busqueda-egreso-suministro/filtros-busqueda-egreso-suministro.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading>Filtros de egresos por tipo de suministro</div><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading><label>Depósito y empresa</label></div><div class=panel-body><div class=col-lg-6><label>Seleccione el depósito:</label><div class=\"form-group col-lg-12\"><input type=text ng-model=vm.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div class=col-lg-6><label>Seleccione la empresa:</label><div class=\"form-group col-lg-12\"><input type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div><div class=\"panel panel-default\" ng-if=\"vm.empresa.id && vm.deposito.id\"><div class=\"panel panel-heading\"><label>Seleccione el tipo de suministro:</label></div><div class=panel-body><div><label>Búsqueda jerarquizada:</label><div class=col-lg-12><div class=col-lg-1><div class=form-group><input type=radio ng-model=vm.radio value=jerarquizada ng-change=vm.cambioRadio()></div></div><div class=col-lg-11><div class=\"form-group col-lg-6\"><label>Grupo de suministro:</label><input type=text ng-disabled=\"vm.radio!=\'jerarquizada\'\" focus-on=grupo ng-model=vm.grupo placeholder=\"Seleccione o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase()+\' (\'+grupo.empresa.nombre.toUpperCase()+\')\' for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Familia de suministro:</label><input ng-disabled=\"!vm.grupo.nombre || vm.radio!=\'jerarquizada\'\" focus-on=familia type=text ng-model=vm.familiaSuministro placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familiaSuministro as familiaSuministro.nombre.toUpperCase() for familiaSuministro in vm.familias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-12\"><label>Tipo de suministro:</label><input ng-if=\"vm.radio==\'jerarquizada\'\" ng-disabled=\"!vm.grupo.nombre || !vm.familiaSuministro.nombre || vm.radio!=\'jerarquizada\'\" type=text focus-on=tipo ng-model=vm.tipoSuministro placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase() for suministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <input ng-if=\"vm.radio==\'directa\'\" ng-disabled=\"!vm.grupo.nombre || !vm.familiaSuministro.nombre || vm.radio!=\'jerarquizada\'\" type=text focus-on=tipo ng-model=vm.tipoSuministro1 placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase() for suministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div><div><label>Búsqueda directa:</label><div class=col-lg-12 ng-disabled=\"\"><div class=\"form-group col-lg-1\"><input type=radio ng-model=vm.radio value=directa ng-change=vm.cambioRadio()></div><div class=\"form-group col-lg-11\"><label>Tipo de suministro:</label><input type=text ng-disabled=\"vm.radio!=\'directa\'\" ng-model=vm.tipoSuministroCompleto placeholder=\"Seleccione o busque el tipo de suministro por su nombre\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase()+\' (\'+suministro.familiaSuministro.nombre.toUpperCase()+\') - (\'+suministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+\')\' for suministro in vm.tiposCompletos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div></div><div ng-if=vm.tipoSuministro.id class=\"panel panel-default\"><div class=panel-heading><label>Ingrese las fechas:</label></div><div class=panel-body><div class=col-lg-12><div class=\"form-group col-lg-6\"><label>Desde:</label><input type=date id=fechaDesde name=fechaDesde class=form-control ng-model=vm.fechaDesde> <span uib-alert class=danger ng-if=\"vm.form.fechaDesde.$error.date && vm.form.fechaDesde.$dirty\">La fecha ingresada no es válida. </span><span uib-alert class=danger ng-if=\"vm.fechaDesde && vm.fechaDesde>vm.fechaActual && vm.form.fechaDesde.$dirty\">La fecha ingresada debe ser menor a la fecha actual.</span></div><div class=\"form-group col-lg-6\"><label>Hasta:</label><input type=date id=fechaHasta name=fechaHasta class=form-control ng-model=vm.fechaHasta> <span uib-alert class=danger ng-if=\"vm.form.fechaHasta.$error.date && vm.form.fechaHasta.$dirty\">La fecha ingresada no es válida. </span><span uib-alert class=danger ng-if=\"vm.fechaHasta && vm.fechaHasta>vm.fechaActual && vm.form.fechaHasta.$dirty\">La fecha ingresada debe ser menor a la fecha actual.</span></div></div><div class=col-lg-12><span uib-alert ng-if=\"(vm.form.fechaDesde.$dirty || vm.form.fechaHasta.$dirty)  && (!vm.fechaHasta || !vm.fechaDesde)\">Debe completar ambas fechas </span><span uib-alert ng-if=\"!vm.form.fechaDesde.$error.date && !vm.form.fechaHasta.$error.date && vm.fechaDesde>vm.fechaHasta\">La fecha Desde, debe ser menor a la fecha Hasta. </span><span uib-alert ng-if=\"vm.fechaDesde && vm.fechaHasta && !vm.comprobarPeriodoFechas()\">El periodo seleccionado no puede superar un año y medio</span></div></div></div></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button ng-disabled=\"vm.form.$invalid || !vm.validarFiltros() || !vm.comprobarPeriodoFechas()\" class=\"btn btn-success btn-block\" ng-click=vm.filtrar()><span class=\"glyphicon glyphicon-ok\"></span> Aplicar filtro</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/components/modales/filtros-busqueda-ingreso-cajas/filtros-busqueda-ingreso-cajas.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading>{{vm.numeroVale? \"Filtrar por Número de Vale\" : \"Filtrar por Número de Caja\"}}</div><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><div ng-if=\"vm.numeroVale!=true\"><label>Ingrese el Número de Caja:</label><div class=col-lg-12><div class=\"form-group col-lg-12\"><input type=text ng-model=vm.numeroCaja class=form-control placeholder=\"Ingrese el número de caja\" required></div></div></div><div ng-if=\"vm.numeroVale==true\"><label>Ingrese el Número de Vale:</label><div class=col-lg-12><div class=\"form-group col-lg-12\"><input type=text ng-model=vm.vale class=form-control placeholder=\"Ingrese el número de Vale\" required></div></div></div><div><label>Ingrese el Depósito:</label><div class=col-lg-12><div class=\"form-group col-lg-12\"><input type=text ng-model=vm.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false required></div></div></div><div><label>Ingrese la Empresa:</label><div class=col-lg-12><div class=\"form-group col-lg-12\"><input type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false required></div></div></div></div><div class=col-lg-12 ng-if=false><div><label>Filtrar por depósito:</label><div class=col-lg-12><div class=\"form-group col-lg-2\"><input type=checkbox ng-model=vm.buscarDeposito ng-click=vm.busquedaDeposito()></div><div class=\"form-group col-lg-10\"><input type=text ng-disabled=!vm.buscarDeposito ng-model=vm.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div><div><label>Filtrar por empresa y proveedor:</label><div class=col-lg-12><div class=\"form-group col-lg-2\"><input type=checkbox ng-model=vm.buscarProveedor ng-click=vm.busquedaProveedor()></div><div class=\"form-group col-lg-5\"><input ng-disabled=!vm.buscarProveedor type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-5\"><input ng-disabled=\"!vm.buscarProveedor || !vm.empresa\" type=text ng-model=vm.proveedor placeholder=\"Seleccione o busque el proveedor\" uib-typeahead=\"proveedor as proveedor.nombre.toUpperCase() for proveedor in vm.proveedores | filter:{nombre:$viewValue}\" focus-on=proveedor class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div><div><label>Filtrar por fecha:</label><div class=col-lg-12><div class=\"form-group col-lg-2\"><input type=checkbox ng-model=vm.buscarFecha ng-click=vm.busquedaFecha()></div><div class=\"form-group col-lg-5\"><label>Desde:</label><input type=date id=fechaDesde ng-disabled=!vm.buscarFecha name=fechaDesde class=form-control ng-model=vm.fechaDesde> <span uib-alert class=danger ng-if=\"vm.form.fechaDesde.$error.date && vm.form.fechaDesde.$dirty && vm.buscarFecha\">La fecha ingresada no es válida. </span><span uib-alert class=danger ng-if=\"vm.fechaDesde && vm.fechaDesde>vm.fechaActual && vm.form.fechaDesde.$dirty && vm.buscarFecha\">La fecha ingresada debe ser menor a la fecha actual.</span></div><div class=\"form-group col-lg-5\"><label>Hasta:</label><input type=date id=fechaHasta ng-disabled=!vm.buscarFecha name=fechaHasta class=form-control ng-model=vm.fechaHasta> <span uib-alert class=danger ng-if=\"vm.form.fechaHasta.$error.date && vm.form.fechaHasta.$dirty && vm.buscarFecha\">La fecha ingresada no es válida. </span><span uib-alert class=danger ng-if=\"vm.fechaHasta && vm.fechaHasta>vm.fechaActual && vm.form.fechaHasta.$dirty && vm.buscarFecha\">La fecha ingresada debe ser menor a la fecha actual.</span></div></div><div class=col-lg-12><span uib-alert ng-if=\"(vm.form.fechaDesde.$dirty || vm.form.fechaHasta.$dirty)  && (!vm.fechaHasta || !vm.fechaDesde) && vm.buscarFecha\">Debe completar ambas fechas </span><span uib-alert ng-if=\"!vm.form.fechaDesde.$error.date && !vm.form.fechaHasta.$error.date && vm.fechaDesde>vm.fechaHasta && vm.buscarFecha\">La fecha Desde, debe ser menor a la fecha Hasta.</span></div></div><div><label>Filtrar por Estado:</label><div class=col-lg-12><div class=\"form-group col-lg-2\"><input type=checkbox ng-model=vm.buscarEstado ng-click=vm.busquedaEstado()></div><div class=\"form-group col-lg-10\"><input ng-disabled=!vm.buscarEstado type=text ng-model=vm.estado placeholder=\"Seleccione o busque el estado\" uib-typeahead=\"estado as estado.nombre.toUpperCase() for estado in vm.estados | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button ng-disabled=vm.form.$invalid class=\"btn btn-success btn-block\" ng-click=vm.filtrarNuevo()><span class=\"glyphicon glyphicon-ok\"></span> Aplicar filtros</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/components/modales/filtros-egresos/filtros-egresos.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading>Filtros de egresos..</div><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><div><label>Depósito:</label><div class=col-lg-12><div class=form-group><input type=text ng-model=vm.deposito.nombre placeholder=\"Seleccione o busque el depósito\" ng-readonly=true class=\"form-control text-uppercase\"></div></div></div><div><label>Filtrar por fecha:</label><div class=col-lg-12><div class=\"form-group col-lg-2\"><input type=radio ng-model=vm.radio value=fechas ng-change=vm.cambioFiltro()></div><div class=\"form-group col-lg-5\"><label>Desde:</label><input type=date id=fechaDesde ng-disabled=\"vm.radio!=\'fechas\'\" name=fechaDesde class=form-control ng-model=vm.fechaDesde> <span uib-alert class=danger ng-if=\"vm.form.fechaDesde.$error.date && vm.form.fechaDesde.$dirty && vm.radio==\'fechas\'\">La fecha ingresada no es válida. </span><span uib-alert class=danger ng-if=\"vm.fechaDesde && vm.fechaDesde>vm.fechaActual && vm.form.fechaDesde.$dirty && vm.radio==\'fechas\'\">La fecha ingresada debe ser menor a la fecha actual.</span></div><div class=\"form-group col-lg-5\"><label>Hasta:</label><input type=date id=fechaHasta ng-disabled=\"vm.radio!=\'fechas\'\" name=fechaHasta class=form-control ng-model=vm.fechaHasta> <span uib-alert class=danger ng-if=\"vm.form.fechaHasta.$error.date && vm.form.fechaHasta.$dirty && vm.radio==\'fechas\'\">La fecha ingresada no es válida. </span><span uib-alert class=danger ng-if=\"vm.fechaHasta && vm.fechaHasta>vm.fechaActual && vm.form.fechaHasta.$dirty && vm.radio==\'fechas\'\">La fecha ingresada debe ser menor a la fecha actual.</span></div></div><div class=col-lg-12><span uib-alert ng-if=\"(vm.form.fechaDesde.$dirty || vm.form.fechaHasta.$dirty)  && (!vm.fechaHasta || !vm.fechaDesde) && vm.radio==\'fechas\'\">Debe completar ambas fechas </span><span uib-alert ng-if=\"!vm.form.fechaDesde.$error.date && !vm.form.fechaHasta.$error.date && vm.fechaDesde>vm.fechaHasta && vm.radio==\'fechas\'\">La fecha Desde, debe ser menor a la fecha Hasta. </span><span uib-alert ng-if=\"vm.fechaDesde && vm.fechaHasta && !vm.comprobarPeriodoFechas()\">El periodo seleccionado no puede superar un año y medio</span></div></div><div><label>Filtrar por número de egreso:</label><div class=col-lg-12><div class=\"form-group col-lg-2\"><input type=radio ng-model=vm.radio value=numero ng-change=vm.cambioFiltro()></div><div class=\"form-group col-lg-10\"><input ng-disabled=\"vm.radio!=\'numero\'\" type=text ng-model=vm.numeroEgreso placeholder=\"Ingrese el númerp de egreso\" class=form-control></div></div></div></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button ng-disabled=\"(vm.radio==\'fechas\' && !vm.validarFiltrosFechas()) || (vm.radio==\'numero\' && !vm.validadFiltrosNumero())\" class=\"btn btn-success btn-block\" ng-click=vm.filtrar()><span class=\"glyphicon glyphicon-ok\"></span> Filtrar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/components/modales/filtros-historial-suministro/filtros-historial-suministro.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading>{{vm.titulo}}</div><div class=panel-body><div class=container-fluid><div class=col-lg-12><div><label>Buscar por N° de bien:</label></div><div class=\"col-lg-1 form-group\"><input type=radio ng-model=vm.radio value=etiqueta ng-change=vm.cambioRadio()></div><div class=\"col-lg-6 form-group\"><label>Empresa</label><input ng-disabled=\"vm.radio!=\'etiqueta\'\" type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=empresa typeahead-editable=false required> <span uib-alert ng-show=\"vm.radio==\'etiqueta\' && vm.form.empresa.$error.required && vm.form.empresa.$dirty\">Campo requerido</span></div><div class=\"col-lg-5 form-group\"><label>N° de inventario</label><input ng-disabled=\"vm.radio!=\'etiqueta\' && !vm.empresa\" type=number name=etiqueta ng-model=vm.etiqueta placeholder=\"Ingrese el N° inventario\" ng-pattern=/^[0-9]{0}/ required name=etiqueta class=form-control> <span uib-alert class=danger ng-show=\"vm.radio==\'etiqueta\' && vm.form.etiqueta.$error.required && vm.form.etiqueta.$dirty\">Campo requerido. </span><span uib-alert ng-if=\"vm.radio==\'etiqueta\' && (vm.form.etiqueta.$error.pattern || vm.form.etiqueta.$error.number) && vm.form.etiqueta.$dirty\">Valor inválido.</span></div></div><div class=col-lg-12><div><label>Buscar por N° de serie:</label></div><div class=\"col-lg-1 form-group\"><input type=radio ng-model=vm.radio value=serie ng-change=vm.cambioRadio()></div><div class=\"col-lg-11 form-group\"><div><div class=\"col-xs-4 form-group\"><label>Empresa</label><input ng-disabled=\"vm.radio!=\'serie\'\" type=text ng-model=vm.empresa1 placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=empresa1 typeahead-editable=false required> <span uib-alert ng-if=\"vm.radio==\'serie\' && vm.form.empresa1.$error.required && vm.form.empresa1.$dirty\">Campo requerido.</span></div><div class=\"col-xs-4 form-group\"><label>Grupo de suministro</label><input ng-disabled=\"vm.radio!=\'serie\' && !vm.empresa1.id\" type=text ng-model=vm.grupoSuministro placeholder=\"Seleccione o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase() for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=grupo typeahead-editable=false required focus-on=grupoSuministro> <span uib-alert ng-if=\"vm.radio==\'serie\' && vm.empresa1.id && vm.form.grupo.$error.required && vm.form.grupo.$dirty\">Campo requerido.</span></div><div class=\"col-xs-4 form-group\"><label>Familia de suministro</label><input ng-disabled=\"vm.radio!=\'serie\' && !vm.empresa1 && !vm.grupoSuministro\" type=text ng-model=vm.familiaSuministro placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familia as familia.nombre.toUpperCase() for familia in vm.familias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=familia typeahead-editable=false required focus-on=familiaSuministro> <span uib-alert ng-if=\"vm.radio==\'serie\' && vm.form.familia.$error.required && vm.form.familia.$dirty && vm.empresa1.id && vm.grupoSuministro.id\">Campo requerido.</span></div></div><br><br><br><br><div><div class=\"col-xs-7 form-group\"><label>Tipo de suministro</label><input ng-disabled=\"vm.radio!=\'serie\' && !vm.empresa1.id && !vm.grupoSuministro.id && !vm.familiaSuministro.id\" type=text ng-model=vm.tipoSuministro placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"tipo as tipo.nombre.toUpperCase() for tipo in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=tipo typeahead-editable=false required focus-on=tipoSuministro> <span uib-alert ng-if=\"vm.radio==\'serie\' && vm.form.tipo.$error.required && vm.form.tipo.$dirty && vm.empresa1.id && vm.familiaSuministro.id && vm.grupoSuministro.id\">Campo requerido.</span></div><div class=\"col-xs-5 form-group\"><label>N° de serie</label><input type=text ng-disabled=\"vm.radio!=\'serie\'\" placeholder=\"Ingrese el N° de serie\" ng-model=vm.serie class=form-control required focus-on=serie> <span uib-alert ng-if=\"vm.radio==\'serie\' && vm.form.tipo.$error.required && vm.form.tipo.$dirty && vm.empresa1.id && vm.familiaSuministro.id && vm.grupoSuministro.id && vm.tipoSuministro.id\">Campo requerido.</span></div></div></div></div><div class=col-lg-12><center><button class=\"btn btn-primary\" ng-click=vm.buscar() ng-disabled=\"!(vm.radio==\'serie\' && vm.empresa1.id && vm.familiaSuministro.id && vm.grupoSuministro.id && vm.tipoSuministro.id && vm.serie) && !(vm.radio==\'etiqueta\' && vm.empresa.id && vm.etiqueta)\"><i class=\"fa fa-search\"></i> Buscar suministro</button></center></div></div><br><br><label class=col-lg-12 ng-if=\"vm.suministros.length>0 && vm.bandera\">Resultados de la búsqueda:</label><div class=col-lg-12 ng-if=\"vm.suministros.length==0 && vm.bandera\"><span uib-alert>No hay suministros que correspondan con la búsqueda.</span></div><div class=col-lg-12 ng-if=\"vm.suministros.length>0\"><table ng-table=vm.tableParams id=table1 show-filter=true class=table><tr ng-repeat=\"bien in $data\"><td data-title=\"\'Grupo suministro\'\" align=center>{{bien.suministro.tipoSuministro.familiaSuministro.grupoSuministro ? bien.suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase() : \"-\" }}</td><td data-title=\"\'Familia suministro\'\" align=center>{{bien.suministro.tipoSuministro.familiaSuministro ? bien.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase() : \"-\" }}</td><td data-title=\"\'Tipo suministro\'\" align=center>{{bien.suministro.tipoSuministro ? bien.suministro.tipoSuministro.nombre.toUpperCase() : \"-\" }}</td><td data-title=\"\'N° inventario\'\" align=center>{{bien.inventario ? bien.inventario : \"-\"}}</td><td data-title=\"\'N° serie\'\" align=center>{{bien.serie ? bien.serie : \"-\"}}</td><td data-title=\"\'¿Nuevo?\'\" align=center>{{bien.nuevo? \"SI\" : \"NO\" }}</td><td data-title=\"\'Estado\'\" align=center>{{bien.suministro? bien.suministro.estadoSuministro.nombre.toUpperCase() : \"-\" }}</td><td data-title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !bien.suministro.ubicacion.numeroOrden, \'has-success\':bien.suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(bien.suministro) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(bien.suministro)}}</div></div></td><td data-title=\"\'Filtrar\'\" align=center ng-if=\"vm.modo==\'filtrar\'\"><button type=button class=\"btn btn-primary btn-block\" ng-click=vm.filtrarNuevo(bien)><span class=\"fa fa-filter\"></span> Filtrar</button></td><td data-title=\"\'Nuevo\'\" align=center ng-if=\"vm.modo==\'nuevo\'\"><button type=button ng-disabled=\"vm.corroborarEstadoSuministro(bien) || !bien.suministro.ubicacion\" class=\"btn btn-primary btn-block\" ng-click=vm.nuevaReparacion(bien)><span class=\"fa fa-plus\"></span> Nueva reparación</button></td></tr></table></div></div><div class=panel-footer><div class=\"container-fluid row\"><center><button type=button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></center></div></div></div></div>");
$templateCache.put("app/components/modales/filtros-busqueda-ingreso-suministro/filtros-busqueda-ingreso-suministro.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading>Filtros de ingresos por tipo de suministro</div><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading><label>Depósito y empresa</label></div><div class=panel-body><div class=col-lg-6><label>Seleccione el depósito:</label><div class=\"form-group col-lg-12\"><input type=text ng-model=vm.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div class=col-lg-6><label>Seleccione la empresa:</label><div class=\"form-group col-lg-12\"><input type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div><div class=\"panel panel-default\" ng-if=\"vm.empresa.id && vm.deposito.id\"><div class=\"panel panel-heading\"><label>Seleccione el tipo de suministro:</label></div><div class=panel-body><div><label>Búsqueda jerarquizada:</label><div class=col-lg-12><div class=col-lg-1><div class=form-group><input type=radio ng-model=vm.radio value=jerarquizada ng-change=vm.cambioRadio()></div></div><div class=col-lg-11><div class=\"form-group col-lg-6\"><label>Grupo de suministro:</label><input type=text ng-disabled=\"vm.radio!=\'jerarquizada\'\" focus-on=grupo ng-model=vm.grupo placeholder=\"Seleccione o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase()+\' (\'+grupo.empresa.nombre.toUpperCase()+\')\' for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Familia de suministro:</label><input ng-disabled=\"!vm.grupo.nombre || vm.radio!=\'jerarquizada\'\" focus-on=familia type=text ng-model=vm.familiaSuministro placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familiaSuministro as familiaSuministro.nombre.toUpperCase() for familiaSuministro in vm.familias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-12\"><label>Tipo de suministro:</label><input ng-if=\"vm.radio==\'jerarquizada\'\" ng-disabled=\"!vm.grupo.nombre || !vm.familiaSuministro.nombre || vm.radio!=\'jerarquizada\'\" type=text focus-on=tipo ng-model=vm.tipoSuministro placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase() for suministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <input ng-if=\"vm.radio==\'directa\'\" ng-disabled=\"!vm.grupo.nombre || !vm.familiaSuministro.nombre || vm.radio!=\'jerarquizada\'\" type=text focus-on=tipo ng-model=vm.tipoSuministro1 placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase() for suministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div><div><label>Búsqueda directa:</label><div class=col-lg-12 ng-disabled=\"\"><div class=\"form-group col-lg-1\"><input type=radio ng-model=vm.radio value=directa ng-change=vm.cambioRadio()></div><div class=\"form-group col-lg-11\"><label>Tipo de suministro:</label><input type=text ng-disabled=\"vm.radio!=\'directa\'\" ng-model=vm.tipoSuministroCompleto placeholder=\"Seleccione o busque el tipo de suministro por su nombre\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase()+\' (\'+suministro.familiaSuministro.nombre.toUpperCase()+\') - (\'+suministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+\')\' for suministro in vm.tiposCompletos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div></div><div ng-if=vm.tipoSuministro.id class=\"panel panel-default\"><div class=panel-heading><label>Ingrese las fechas:</label></div><div class=panel-body><div class=col-lg-12><div class=\"form-group col-lg-6\"><label>Desde:</label><input type=date id=fechaDesde name=fechaDesde class=form-control ng-model=vm.fechaDesde> <span uib-alert class=danger ng-if=\"vm.form.fechaDesde.$error.date && vm.form.fechaDesde.$dirty\">La fecha ingresada no es válida. </span><span uib-alert class=danger ng-if=\"vm.fechaDesde && vm.fechaDesde>vm.fechaActual && vm.form.fechaDesde.$dirty\">La fecha ingresada debe ser menor a la fecha actual.</span></div><div class=\"form-group col-lg-6\"><label>Hasta:</label><input type=date id=fechaHasta name=fechaHasta class=form-control ng-model=vm.fechaHasta> <span uib-alert class=danger ng-if=\"vm.form.fechaHasta.$error.date && vm.form.fechaHasta.$dirty\">La fecha ingresada no es válida. </span><span uib-alert class=danger ng-if=\"vm.fechaHasta && vm.fechaHasta>vm.fechaActual && vm.form.fechaHasta.$dirty\">La fecha ingresada debe ser menor a la fecha actual.</span></div></div><div class=col-lg-12><span uib-alert ng-if=\"(vm.form.fechaDesde.$dirty || vm.form.fechaHasta.$dirty)  && (!vm.fechaHasta || !vm.fechaDesde)\">Debe completar ambas fechas </span><span uib-alert ng-if=\"!vm.form.fechaDesde.$error.date && !vm.form.fechaHasta.$error.date && vm.fechaDesde>vm.fechaHasta\">La fecha Desde, debe ser menor a la fecha Hasta. </span><span uib-alert ng-if=\"vm.fechaDesde && vm.fechaHasta && !vm.comprobarPeriodoFechas()\">El periodo seleccionado no puede superar un año y medio</span></div></div></div></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button ng-disabled=\"vm.form.$invalid || !vm.validarFiltros() || !vm.comprobarPeriodoFechas()\" class=\"btn btn-success btn-block\" ng-click=vm.filtrar()><span class=\"glyphicon glyphicon-ok\"></span> Aplicar filtro</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/components/modales/filtros-ingreso-fecha-manual/filtros-ingreso-fecha-manual.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading>Filtros de ingresos por fecha de ingreso manual</div><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-6><label>Depósito:</label><div class=form-group><input type=text ng-disabled=vm.depositoUsuario.id ng-model=vm.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div class=col-lg-6><label>Empresa:</label><div class=form-group><input type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div><div class=\"form-group col-lg-6\"><label>Fecha ingreso manual desde:</label><input type=date id=fechaDesde name=fechaDesde class=form-control ng-model=vm.fechaDesde> <span uib-alert class=danger ng-if=\"vm.form.fechaDesde.$error.date && vm.form.fechaDesde.$dirty\">La fecha ingresada no es válida. </span><span uib-alert class=danger ng-if=\"vm.fechaDesde && vm.fechaDesde>vm.fechaActual && vm.form.fechaDesde.$dirty\">La fecha ingresada debe ser menor a la fecha actual.</span></div><div class=\"form-group col-lg-6\"><label>Fecha ingreso manual hasta:</label><input type=date id=fechaHasta name=fechaHasta class=form-control ng-model=vm.fechaHasta> <span uib-alert class=danger ng-if=\"vm.form.fechaHasta.$error.date && vm.form.fechaHasta.$dirty\">La fecha ingresada no es válida. </span><span uib-alert class=danger ng-if=\"vm.fechaHasta && vm.fechaHasta>vm.fechaActual && vm.form.fechaHasta.$dirty\">La fecha ingresada debe ser menor a la fecha actual.</span></div><div class=col-lg-12><span uib-alert ng-if=\"(vm.form.fechaDesde.$dirty || vm.form.fechaHasta.$dirty)  && (!vm.fechaHasta || !vm.fechaDesde)\">Debe completar ambas fechas </span><span uib-alert ng-if=\"!vm.form.fechaDesde.$error.date && !vm.form.fechaHasta.$error.date && vm.fechaDesde>vm.fechaHasta\">La fecha Desde, debe ser menor a la fecha Hasta. </span><span uib-alert ng-if=\"vm.fechaDesde && vm.fechaHasta && !vm.comprobarPeriodoFechas()\">El periodo seleccionado no puede superar un año y medio</span></div></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button ng-disabled=\"vm.validarFiltros() || !vm.comprobarPeriodoFechas()\" class=\"btn btn-success btn-block\" ng-click=vm.filtrar()><span class=\"glyphicon glyphicon-ok\"></span> Aplicar filtros</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/components/modales/filtros-ingreso-numero-remito/filtros-ingreso-numero-remito.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading>Filtrar por número de remito</div><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><div><label>Ingrese el número de remito:</label><div class=col-lg-12><div class=\"form-group col-lg-12\"><input type=number ng-model=vm.numeroRemito class=form-control placeholder=\"Ingrese el número de remito\" required ng-pattern=/^[1-9][0-9]*$/ name=numeroRemito> <span uib-alert ng-if=\"(vm.form.numeroRemito.$error.number || vm.form.numeroRemito.$error.pattern) && vm.form.numeroRemito.$dirty\">Ingrese un valor válido</span></div></div></div><div><label>Ingrese el Depósito:</label><div class=col-lg-12><div class=\"form-group col-lg-12\"><input type=text ng-model=vm.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false required></div></div></div><div><label>Ingrese la Empresa:</label><div class=col-lg-12><div class=\"form-group col-lg-12\"><input type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false required></div></div></div></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button ng-disabled=vm.form.$invalid class=\"btn btn-success btn-block\" ng-click=vm.filtrar()><span class=\"glyphicon glyphicon-ok\"></span> Aplicar filtros</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/components/modales/filtros-ingreso-orden-compra/filtros-ingreso-orden-compra.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading>Filtrar por número de orden de compra</div><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><div><label>Ingrese el número de orden de compra:</label><div class=col-lg-12><div class=\"form-group col-lg-12\"><input type=text ng-model=vm.numeroOrdenCompra class=form-control placeholder=\"Ingrese el número de orden de compra\" required name=numeroOrdenCompra></div></div></div><div><label>Ingrese el Depósito:</label><div class=col-lg-12><div class=\"form-group col-lg-12\"><input type=text ng-model=vm.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false required></div></div></div><div class=\"form-group col-lg-6\"><label>Ingrese la Empresa:</label><div class=col-lg-12><div class=\"form-group col-lg-12\"><input type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false required></div></div></div><div class=\"form-group col-lg-6\"><label>Ingrese el Proveedor:</label><input type=text ng-disabled=!vm.empresa.id focus-on=proveedor ng-model=vm.proveedor placeholder=\"Seleccione o busque el proveedor\" uib-typeahead=\"proveedor as proveedor.nombre.toUpperCase() for proveedor in vm.proveedores | filter:{nombre:$viewValue}\" class=form-control typeahead-editable=false typeahead-show-hint=true typeahead-min-length=0 required name=proveedor></div></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button ng-disabled=vm.form.$invalid class=\"btn btn-success btn-block\" ng-click=vm.filtrar()><span class=\"glyphicon glyphicon-ok\"></span> Aplicar filtros</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/components/modales/mostrar-respuesta-egreso/mostrar-respuesta-egreso.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Egrego despachado</div><div class=panel-body><div class=col-lg-12><div uib-alert type=success><i class=\"fa fa-success\"></i> Se ha guardado el egreso con éxito!</div></div><div class=col-lg-12><center><button class=\"btn btn-primary\" ng-click=vm.reporteEtiquetas();><i class=\"fa fa-print\"></i> Imprimir etiquetas</button><br></center></div><div class=col-lg-12><div><label>Egreso guardado:</label><table show-filter=true ng-table=vm.tableParamsEgreso class=table><tr ng-repeat=\"egresos in $data track by $index\"><td data-title=\"\'Empresa\'\" align=center>{{egresos.empresa.nombre.toUpperCase();}}</td><td data-title=\"\'N° egreso\'\" align=center>{{egresos.numeroEgreso}}</td><td data-title=\"\'Fecha creado\'\" align=center>{{egresos.fecha | date:\"dd/MM/yyyy HH:mm\"}}</td><td data-title=\"\'Empresa Logística\'\" align=center>{{egresos.empresaLogistica.nombre.toUpperCase();}}</td><td data-title=\"\'Cantidad Paquetes\'\" align=center style=width:15%>{{egresos.cantidadPaquetes? egresos.cantidadPaquetes : \"0\"}}</td><td data-title=\"\'Kg Paquetes\'\" align=center style=width:15%>{{egresos.pesoTotal? egresos.pesoTotal : \"0\"}}</td><td data-title=\"\'Ver\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.visualizarEgreso(egresos)><i class=\"fa fa-search\"></i></a></div></td></tr></table></div></div><div class=col-lg-12 ng-if=\"vm.ubicacionesModificadas.length>0\"><div><label>Al despechar los suministros, se liberaron las siguientes ubicaciones:</label><table ng-table=vm.tableParamsUbicaciones class=table><tr ng-repeat=\"ubicacion in vm.ubicacionesModificadas track by $index\"><td data-title=\"\'Depósito\'\" align=center>{{ubicacion.nivel.estante.estructura.pasillo.nave.deposito.nombre.toUpperCase();}}</td><td data-title=\"\'Nave\'\" align=center>{{ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase();}}</td><td data-title=\"\'Pasillo\'\" align=center>{{ubicacion.nivel.estante.estructura.pasillo.numeroPasillo;}}</td><td data-title=\"\'Estructura\'\" align=center>{{ubicacion.nivel.estante.estructura.identificadorEstructura}}</td><td data-title=\"\'Estantería\'\" align=center>{{ubicacion.nivel.estante.numeroEstante}}</td><td data-title=\"\'Estante\'\" align=center>{{ubicacion.nivel.numeroNivel}}</td><td data-title=\"\'Número ubicación\'\" align=center>{{ubicacion.numeroUbicacion}}</td><td data-title=\"\'Número órden\'\" align=center>{{ubicacion.numeroOrden}}</td><td data-title=\"\'Estado\'\" align=center style=width:15%>{{ubicacion.estadoUbicacion.nombre.toUpperCase();}}</td></tr></table></div></div></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-success\" ng-click=vm.cerrar()><span class=\"fa fa-check\"></span> Aceptar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/mostrar-respuesta-ingreso-suministro-excel/mostrar-respuesta-ingreso-suministro-excel.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Ingreso de suministros por hoja de cálculo Excel</div><div class=panel-body><div ng-if=!vm.formatoIncorrecto><div class=col-lg-12><div uib-alert type=success><i class=\"fa fa-success\"></i> Se ha procesado el documento <b>{{vm.nombreDocumento}}</b> con éxito!<br>Los suministros corresponden al tipo de suministro: <b>{{vm.tipoSuministro.nombre.toUpperCase()}}</b> - ({{vm.tipoSuministro.familiaSuministro.nombre.toUpperCase()}} - {{vm.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()}})</div></div><div class=col-lg-12><div uib-alert type=info><i class=\"fa fa-info\"></i> Se leyeron <b>{{vm.correctos.length+vm.erroneos.length+vm.incompletos.length+vm.repetidos.length}}</b> registros<div ng-class=\"{\'danger\':vm.correctos.length==0}\">Suministros correctos: {{vm.correctos.length>0? vm.correctos.length : \"No hubo\" }}</div><div ng-class=\"{\'danger\':vm.incompletos.length==0}\">Suministros incompletos: {{vm.incompletos.length>0? vm.incompletos.length : \"No hubo\" }}</div><div ng-class=\"{\'danger\':vm.erroneos.length==0}\">Suministros erróneos: {{vm.erroneos.length>0? vm.erroneos.length : \"No hubo\" }}</div><div ng-class=\"{\'danger\':vm.repetidos.length==0}\">Suministros repetidos: {{vm.repetidos.length>0? vm.repetidos.length : \"No hubo\" }}</div></div></div><div class=col-lg-12 ng-if=\"vm.correctos.length>0\"><div class=\"panel panel-default\"><div class=panel-heading>Suministros correctos:</div><div class=panel-body><div class=col-lg-12><div uib-alert type=success><i class=\"fa fa-success\"></i> Suministros agregados correctamente!</div></div><table show-filter=true ng-table=vm.tableParamosCorrectos class=table><tr ng-repeat=\"correcto in vm.correctos track by $index\"><td data-title=\"\'N° inventario\'\" align=center>{{correcto.inventario}}</td><td data-title=\"\'N° serie\'\" align=center>{{correcto.serie}}</td><td data-title=\"\'Marca\'\" align=center>{{correcto.suministro.marca}}</td><td data-title=\"\'¿Nuevo?\'\" align=center>{{correcto.nuevo? \"SI\" : \"NO\"}}</td><td data-title=\"\'Precio\'\" align=center style=width:15%>{{correcto.suministro.precioUnitario}}</td></tr></table></div></div></div><div class=col-lg-12 ng-if=\"vm.erroneos.length>0\"><div class=\"panel panel-default\"><div class=panel-heading>Suministros erróneos:</div><div class=panel-body><div class=col-lg-12><div uib-alert>El campo \'precio\' no es numérico y/o el campo \'inventario\' no es entero</div></div><table show-filter=true ng-table=vm.tableParamosErroneos class=table><tr ng-repeat=\"erroneo in vm.erroneos track by $index\"><td data-title=\"\'N° inventario\'\" align=center ng-class=\"{\'danger\':erroneo.errorInv}\">{{erroneo.inventario}}</td><td data-title=\"\'N° serie\'\" align=center>{{erroneo.serie}}</td><td data-title=\"\'Marca\'\" align=center>{{erroneo.marca}}</td><td data-title=\"\'¿Nuevo?\'\" align=center>{{erroneo.nuevo? \"SI\" : \"NO\"}}</td><td data-title=\"\'Precio\'\" align=center style=width:15% ng-class=\"{\'danger\' : erroneo.errorPrecio}\">{{erroneo.precio}}</td></tr></table></div></div></div><div class=col-lg-12 ng-if=\"vm.incompletos.length>0\"><div class=\"panel panel-default\"><div class=panel-heading>Suministros incompletos:</div><div class=panel-body><div class=col-lg-12><div uib-alert>Faltan los datos marcados</div></div><table show-filter=true ng-table=vm.tableParamosIncompletos class=table><tr ng-repeat=\"imcompleto in vm.incompletos track by $index\"><td data-title=\"\'N° inventario\'\" align=center ng-class=\"{\'danger\' : !imcompleto.inventario}\">{{imcompleto.inventario}}</td><td data-title=\"\'N° serie\'\" align=center ng-class=\"{\'danger\' : !imcompleto.serie}\">{{imcompleto.serie}}</td><td data-title=\"\'Marca\'\" align=center ng-class=\"{\'danger\' : !imcompleto.marca}\">{{imcompleto.marca}}</td><td data-title=\"\'¿Nuevo?\'\" align=center>{{imcompleto.nuevo? \"SI\" : \"NO\"}}</td><td data-title=\"\'Precio\'\" align=center style=width:15% ng-class=\"{\'danger\' : !imcompleto.precio}\">{{imcompleto.precio}}</td></tr></table></div></div></div><div class=col-lg-12 ng-if=\"vm.repetidos.length>0\"><div class=\"panel panel-default\"><div class=panel-heading>Suministros repetidos:</div><div class=panel-body><div class=col-lg-12><div uib-alert>Los N° de inventarios ingresados ya existen</div></div><table show-filter=true ng-table=vm.tableParamosRepetidos class=table><tr ng-repeat=\"repetido in vm.repetidos track by $index\"><td data-title=\"\'N° inventario\'\" align=center class=danger>{{repetido.inventario}}</td><td data-title=\"\'N° serie\'\" align=center>{{repetido.serie}}</td><td data-title=\"\'Marca\'\" align=center>{{repetido.suministro.marca}}</td><td data-title=\"\'¿Nuevo?\'\" align=center>{{repetido.nuevo? \"SI\" : \"NO\"}}</td><td data-title=\"\'Precio\'\" align=center style=width:15%>{{repetido.suministro.precioUnitario}}</td></tr></table></div></div></div></div><div ng-if=vm.formatoIncorrecto><div class=col-lg-12><div uib-alert><i class=\"fa fa-danger\"></i><br>El documento <b>{{vm.nombreDocumento}}</b> no posee el formato correcto!<br>Debe subir una hoja de cálculo en formato .xlsx, que utilice desde la columna \'A\' hasta la \'E\'. Y que correspondan con los datos: \'inventario\', \'serie\', \'nuevo\', \'marca\' y \'precio\'.<br>En la columna \'precio\' debe ingresar un tipo de dato numérico. Y en a columna \'nuevo\' debe ingresar un 1 si el suministro es nuevo y un 0 si no lo es.</div></div></div></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-success\" ng-click=vm.cerrar()><span class=\"fa fa-check\"></span> Aceptar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/filtros-numero-movimiento/filtros-numero-movimiento.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading>Filtrar por número de movimiento</div><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><div><label>Ingrese el número de movimiento:</label><div class=col-lg-12><div class=\"form-group col-lg-12\"><input type=number ng-model=vm.numeroMovimiento class=form-control placeholder=\"Ingrese el número de movimiento\" required ng-pattern=/^[1-9][0-9]*$/ name=numeroMovimiento> <span uib-alert ng-if=\"(vm.form.numeroMovimiento.$error.number || vm.form.numeroMovimiento.$error.pattern) && vm.form.numeroMovimiento.$dirty\">Ingrese un valor válido</span></div></div></div><div><label>Ingrese el Depósito:</label><div class=col-lg-12><div class=\"form-group col-lg-12\"><input type=text ng-model=vm.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false required></div></div></div><div><label>Ingrese la Empresa:</label><div class=col-lg-12><div class=\"form-group col-lg-12\"><input type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false required></div></div></div></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button ng-disabled=vm.form.$invalid class=\"btn btn-success btn-block\" ng-click=vm.filtrar()><span class=\"glyphicon glyphicon-ok\"></span> Aplicar filtros</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/components/modales/mostrar-foto-suministro/mostrar-foto-suministro.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Foto del tipo de suministro: {{vm.tipoSuministro.nombre.toUpperCase()}}</div><div class=panel-body><div class=col-lg-12><center><div ng-if=vm.foto><img ng-src={{vm.foto}} class=img-thumbnail></div></center></div><div class=col-lg-12 ng-if=!vm.foto><span uib-alert>El tipo de suministro no posee fotografía</span></div></div><div class=panel-footer><div class=form-group><center><button type=button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cerrar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/mostrar-respuesta-inventariable-excel/mostrar-respuesta-inventariable-excel.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Alta y/o actualización de inventariables por hoja de cálculo Excel</div><div class=panel-body><div ng-if=!vm.formatoIncorrecto><div class=col-lg-12><div uib-alert type=success><i class=\"fa fa-success\"></i> Se ha procesado el documento <b>{{vm.nombreDocumento}}</b> con éxito!</div></div><div class=col-lg-12><div uib-alert type=info><i class=\"fa fa-info\"></i> Se leyeron <b>{{vm.nuevos.length+vm.existentes.length+vm.erroneos.length+vm.incompletos.length}}</b> registros<div ng-class=\"{\'danger\':vm.correctos.length==0}\">Registros correctos: {{vm.nuevos.length+vm.existentes.length>0? vm.nuevos.length+vm.existentes.length : \"No hubo\" }}</div><div ng-class=\"{\'danger\':vm.incompletos.length==0}\">Registros incompletos: {{vm.incompletos.length>0? vm.incompletos.length : \"No hubo\" }}</div><div ng-class=\"{\'danger\':vm.erroneos.length==0}\">Registros erróneos: {{vm.erroneos.length>0? vm.erroneos.length : \"No hubo\" }}</div><div ng-class=\"{\'danger\':vm.existentes.length==0}\">Actualizados: {{vm.existentes.length>0? vm.existentes.length : \"No hubo\" }}</div><div ng-class=\"{\'danger\':vm.nuevos.length==0}\">Nuevos: {{vm.nuevos.length>0? vm.nuevos.length : \"No hubo\" }}</div></div></div><div class=col-lg-12 ng-if=\"vm.nuevos.length>0\"><div class=\"panel panel-default\"><div class=panel-heading>Suministros nuevos:</div><div class=panel-body><div class=col-lg-12><div uib-alert type=success><i class=\"fa fa-success\"></i> Suministros nuevos agregados correctamente!</div></div><table show-filter=true ng-table=vm.tableParamsNuevos class=table><tr ng-repeat=\"correcto in $data track by $index\"><td data-title=\"\'Sucursal\'\" align=center>{{correcto.sucursal.nombre.toUpperCase()}}</td><td data-title=\"\'Tipo suministro\'\" align=center>{{correcto.suministro.tipoSuministro.nombre.toUpperCase()}}</td><td data-title=\"\'N° inventario\'\" align=center>{{correcto.inventario}}</td><td data-title=\"\'N° serie\'\" align=center>{{correcto.serie}}</td><td data-title=\"\'Marca\'\" align=center>{{correcto.suministro.marca}}</td><td data-title=\"\'¿Nuevo?\'\" align=center>{{correcto.nuevo? \"SI\" : \"NO\"}}</td><td data-title=\"\'Precio\'\" align=center style=width:15%>{{correcto.suministro.precioUnitario}}</td></tr></table></div></div></div><div class=col-lg-12 ng-if=\"vm.existentes.length>0\"><div class=\"panel panel-default\"><div class=panel-heading>Suministros actualizados:</div><div class=panel-body><div class=col-lg-12><div uib-alert type=success><i class=\"fa fa-success\"></i> Suministros actualizados correctamente</div></div><table show-filter=true ng-table=vm.tableParamsExistentes class=table><tr ng-repeat=\"correcto in $data track by $index\"><td data-title=\"\'Sucursal\'\" align=center>{{correcto.sucursal.nombre.toUpperCase()}}</td><td data-title=\"\'Tipo suministro\'\" align=center>{{correcto.suministro.tipoSuministro.nombre.toUpperCase()}}</td><td data-title=\"\'N° inventario\'\" align=center>{{correcto.inventario}}</td><td data-title=\"\'N° serie\'\" align=center>{{correcto.serie}}</td><td data-title=\"\'Marca\'\" align=center>{{correcto.suministro.marca}}</td><td data-title=\"\'¿Nuevo?\'\" align=center>{{correcto.nuevo? \"SI\" : \"NO\"}}</td><td data-title=\"\'Precio\'\" align=center style=width:15%>{{correcto.suministro.precioUnitario}}</td></tr></table></div></div></div><div class=col-lg-12 ng-if=\"vm.erroneos.length>0\"><div class=\"panel panel-default\"><div class=panel-heading>Suministros erróneos:</div><div class=panel-body><table show-filter=true ng-table=vm.tableParamsErroneos class=table><tr ng-repeat=\"erroneo in $data track by $index\"><td data-title=\"\'Código sucursal\'\" align=center>{{erroneo.codigoSucursal}}</td><td data-title=\"\'Código producto\'\" align=center>{{erroneo.codigoProducto}}</td><td data-title=\"\'N° inventario\'\" align=center>{{erroneo.inventario}}</td><td data-title=\"\'N° serie\'\" align=center>{{erroneo.serie}}</td><td data-title=\"\'Marca\'\" align=center>{{erroneo.marca}}</td><td data-title=\"\'¿Nuevo?\'\" align=center>{{erroneo.nuevo? \"SI\" : \"NO\"}}</td><td data-title=\"\'Precio\'\" align=center style=width:15%>{{erroneo.precio}}</td><td data-title=\"\'Causa\'\" align=center>{{erroneo.causa? erroneo.causa : \"-\"}}</td></tr></table></div></div></div><div class=col-lg-12 ng-if=\"vm.incompletos.length>0\"><div class=\"panel panel-default\"><div class=panel-heading>Suministros incompletos:</div><div class=panel-body><div class=col-lg-12><div uib-alert>Faltan los datos marcados</div></div><table show-filter=true ng-table=vm.tableParamsIncompletos class=table><tr ng-repeat=\"incompleto in $data track by $index\"><td data-title=\"\'Código sucursal\'\" align=center ng-class=\"{\'danger\':!incompleto.codigoSucursal}\">{{incompleto.codigoSucursal}}</td><td data-title=\"\'Código producto\'\" align=center ng-class=\"{\'danger\':!incompleto.codigoProducto}\">{{incompleto.codigoProducto}}</td><td data-title=\"\'N° inventario\'\" align=center ng-class=\"{\'danger\' : !incompleto.inventario}\">{{incompleto.inventario}}</td><td data-title=\"\'N° serie\'\" align=center ng-class=\"{\'danger\' : !incompleto.serie}\">{{incompleto.serie}}</td><td data-title=\"\'Marca\'\" align=center ng-class=\"{\'danger\' : !incompleto.marca}\">{{incompleto.marca}}</td><td data-title=\"\'¿Nuevo?\'\" align=center>{{incompleto.nuevo? \"SI\" : \"NO\"}}</td><td data-title=\"\'Precio\'\" align=center style=width:15% ng-class=\"{\'danger\' : !incompleto.precio}\">{{incompleto.precio}}</td></tr></table></div></div></div></div><div ng-if=vm.formatoIncorrecto><div class=col-lg-12><div uib-alert><i class=\"fa fa-danger\"></i><br>El documento <b>{{vm.nombreDocumento}}</b> no posee el formato correcto!<br>Debe subir una hoja de cálculo en formato .xlsx, que utilice desde la columna \'A\' hasta la \'G\'. Y que correspondan con los datos: \'codigoSucursal\', \'codigoProducto\', \'inventario\', \'serie\', \'nuevo\', \'marca\' y \'precio\'.<br>En la columna \'precio\' debe ingresar un tipo de dato numérico. Y en a columna \'nuevo\' debe ingresar un 1 si el suministro es nuevo y un 0 si no lo es.<br>La columna \'inventario\' debe poseer un número entero.</div></div></div></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-success\" ng-click=vm.cerrar()><span class=\"fa fa-check\"></span> Aceptar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/mostrar-respuesta-topes-excel/mostrar-respuesta-topes-excel.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Carga de topes de suministro por hoja de cálculo Excel</div><div class=panel-body><div ng-if=!vm.formatoIncorrecto><div class=col-lg-12><div uib-alert type=success><i class=\"fa fa-success\"></i> Se ha procesado el documento <b>{{vm.nombreDocumento}}</b> con éxito!</div></div><div class=col-lg-12><div uib-alert type=info><i class=\"fa fa-info\"></i> Se leyeron <b>{{vm.nuevos.length+vm.existentes.length+vm.erroneos.length+vm.incompletos.length}}</b> registros<div ng-class=\"{\'danger\':vm.correctos.length==0}\">Registros correctos: {{vm.nuevos.length+vm.existentes.length>0? vm.nuevos.length+vm.existentes.length : \"No hubo\" }}</div><div ng-class=\"{\'danger\':vm.incompletos.length==0}\">Registros incompletos: {{vm.incompletos.length>0? vm.incompletos.length : \"No hubo\" }}</div><div ng-class=\"{\'danger\':vm.erroneos.length==0}\">Registros erróneos: {{vm.erroneos.length>0? vm.erroneos.length : \"No hubo\" }}</div><div ng-class=\"{\'danger\':vm.existentes.length==0}\">Topes ya existentes: {{vm.existentes.length>0? vm.existentes.length : \"No hubo\" }}</div><div ng-class=\"{\'danger\':vm.nuevos.length==0}\">Topes nuevos: {{vm.nuevos.length>0? vm.nuevos.length : \"No hubo\" }}</div></div></div><div class=col-lg-12 ng-if=\"vm.nuevos.length>0\"><div class=\"panel panel-default\"><div class=panel-heading>Topes de suministros agregados:</div><div class=panel-body><div class=col-lg-12><div uib-alert type=success><i class=\"fa fa-check\"></i> Los topes fueron creados correctamente</div></div><table show-filter=true ng-table=vm.tableParamsNuevos class=table><tr ng-repeat=\"correcto in $data track by $index\"><td data-title=\"\'Sucursal\'\" align=center>{{correcto.tope.sucursal.nombre.toUpperCase()}}- ({{correcto.tope.sucursal.codigoSucursal.toUpperCase()}})</td><td data-title=\"\'Tipo de suministro\'\" align=center>{{correcto.tope.tipoSuministro.codigoProducto.toUpperCase()}} - {{correcto.tope.tipoSuministro.nombre.toUpperCase()}} - ({{correcto.tope.tipoSuministro.familiaSuministro.nombre.toUpperCase()}})</td><td data-title=\"\'Cantidad tope\'\" align=center>{{correcto.tope.cantidadTope}}</td><td data-title=\"\'Condición\'\" align=center>{{correcto.existente==\"SI\"? \"Existente\" : \"Nuevo\"}}</td></tr></table></div></div></div><div class=col-lg-12 ng-if=\"vm.existentes.length>0\"><div class=\"panel panel-default\"><div class=panel-heading>Topes de suministros actualizados:</div><div class=panel-body><div class=col-lg-12><div uib-alert type=info><i class=\"fa fa-check\"></i> Los topes fueron actualizados correctamente</div></div><table show-filter=true ng-table=vm.tableParamsExistentes class=table><tr ng-repeat=\"correcto in $data track by $index\"><td data-title=\"\'Sucursal\'\" align=center>{{correcto.tope.sucursal.nombre.toUpperCase()}}- ({{correcto.tope.sucursal.codigoSucursal.toUpperCase()}})</td><td data-title=\"\'Tipo de suministro\'\" align=center>{{correcto.tope.tipoSuministro.codigoProducto.toUpperCase()}} - {{correcto.tope.tipoSuministro.nombre.toUpperCase()}} - ({{correcto.tope.tipoSuministro.familiaSuministro.nombre.toUpperCase()}})</td><td data-title=\"\'Cantidad tope\'\" align=center>{{correcto.tope.cantidadTope}}</td><td data-title=\"\'Condición\'\" align=center>{{correcto.existente==\"SI\"? \"Existente\" : \"Nuevo\"}}</td></tr></table></div></div></div><div class=col-lg-12 ng-if=\"vm.erroneos.length>0\"><div class=\"panel panel-default\"><div class=panel-heading>Suministros erróneos:</div><div class=panel-body><div class=col-lg-12><div uib-alert>El campo \'cantidad\' no es numérico y/o los códigos de sucursal y/o tipo de suministro no son correctos o no existen</div></div><table show-filter=true ng-table=vm.tableParamsErroneos class=table><tr ng-repeat=\"erroneo in $data track by $index\"><td data-title=\"\'Código sucursal\'\" align=center ng-class=\"{\'danger\':erroneo.error}\">{{erroneo.codigoSucursal? erroneo.codigoSucursal : erroneo.sucursal}}</td><td data-title=\"\'Código tipo suministro\'\" align=center>{{erroneo.codigoProducto? erroneo.codigoProducto : erroneo.codigoProducto}}</td><td data-title=\"\'Cantidad\'\" align=center>{{erroneo.cantidad? erroneo.cantidad : erroneo.cantidadTope}}</td><td data-title=\"\'Causa\'\" align=center>{{erroneo.causa}}</td></tr></table></div></div></div><div class=col-lg-12 ng-if=\"vm.incompletos.length>0\"><div class=\"panel panel-default\"><div class=panel-heading>Suministros incompletos:</div><div class=panel-body><div class=col-lg-12><div uib-alert>Faltan los datos marcados</div></div><table show-filter=true ng-table=vm.tableParamsIncompletos class=table><tr ng-repeat=\"imcompleto in $data track by $index\"><td data-title=\"\'Código sucursal\'\" align=center ng-class=\"{\'danger\' : !imcompleto.codigoSucursal}\">{{imcompleto.codigoSucursal}}</td><td data-title=\"\'Código tipo suministro\'\" align=center ng-class=\"{\'danger\' : !imcompleto.codigoProducto}\">{{imcompleto.codigoProducto}}</td><td data-title=\"\'Cantidad tope\'\" align=center ng-class=\"{\'danger\' : !imcompleto.cantidad}\">{{imcompleto.cantidad}}</td></tr></table></div></div></div></div><div ng-if=vm.formatoIncorrecto><div class=col-lg-12><div uib-alert><i class=\"fa fa-danger\"></i><br>El documento <b>{{vm.nombreDocumento}}</b> no posee el formato correcto!<br>Debe subir una hoja de cálculo en formato .xlsx, que utilice desde la columna \'A\' hasta la \'C\'. Y que correspondan con los datos: \'codigoSucursal\', \'codigoProducto\' y \'cantidad\'.<br>En la columna \'cantidad\' debe ingresar un tipo de dato numérico y entero.</div></div></div></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-success\" ng-click=vm.cerrar()><span class=\"fa fa-check\"></span> Aceptar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/mostrar-suministro-ubicaciones/modal-mostrar-suministro-ubicaciones.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Suministros de la ubicación N° {{vm.ubicacion.numeroUbicacion}} - N° orden: {{vm.ubicacion.numeroOrden }}</div><div class=panel-body><div class=col-lg-12><center><button class=\"btn btn-primary\" ng-click=vm.reasignarUbicacionVarios();><i class=\"fa fa-exchange\"></i> Reasignar varios suministros a otra ubicación</button></center></div><div class=col-lg-12 ng-if=\"vm.suministros.length>0\"><table id=table1 ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.suministros.length>0\"><tr ng-repeat=\"suministro in $data\"><td title=\"\'Familia suministro\'\" align=center>{{suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase();}}</td><td title=\"\'Tipo suministro\'\" align=center>{{suministro.tipoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Marca\'\" align=center>{{suministro.marca ? suministro.marca.toUpperCase() : \"-\" }}</td><!-- 					        <td title=\"\'Fecha vencimiento\'\" align=\"center\">\r\n    {{suministro.fechaVencimiento? suministro.fechaVencimiento : \"-\" | date: \"dd/MM/yyyy\"}}\r\n</td> --><!-- 					        <td title=\"\'Precio unitario\'\" align=\"center\">\r\n    ${{suministro.precioUnitario? suministro.precioUnitario : \"-\"}}\r\n</td> --><td title=\"\'Inventario\'\" align=center>{{suministro.inventario? suministro.inventario:\"-\"}}</td><td title=\"\'Serie\'\" align=center>{{suministro.serie? suministro.serie:\"-\"}}</td><!-- 					        <td title=\"\'¿Nuevo?\'\" align=\"center\">\r\n    {{suministro.tipoSuministro.inventariable? suministro.nuevo? \"SI\" : \"NO\" : \"-\"}}\r\n</td> --><td title=\"\'Cantidad\'\" align=center>{{suministro.cantidad? suministro.cantidad:\"-\"}}</td><td title=\"\'Editar\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.mostrarInformacion(suministro)><i class=\"fa fa-search\"></i> </a><a class=\"btn btn-warning\" ng-click=vm.editarSuministro(suministro)><i class=\"fa fa-pencil\"></i> </a><a class=\"btn btn-primary\" ng-click=vm.irACambiarUbicacionSuministro(suministro)><i class=\"fa fa-exchange\"></i></a></div></td></tr></table></div><div class=col-lg-12 ng-if=\"vm.ubicacion.suministros.length==0\"><span class=\"col-lg-12 danger\" uib-alert>No hay suministros en esta ubicación</span></div></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cerrar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/rechazar-pedido/rechazar-pedido.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Rechazar pedido - N° {{vm.pedido.numeroPedido}}</div><div class=panel-body><div class=col-lg-12><form name=vm.form><div class=\"form-group col-lg-12\"><label>Motivo de rechazo:</label><textarea class=form-control ng-maxlength=500 ng-minlength=10 ng-model=vm.motivo placeholder=\"Ingrese el motivo de rechazo del pedido\" type=text name=motivo style=resize:vertical></textarea><span uib-alert class=danger ng-if=\"vm.form.motivo.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.motivo.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 500 caracteres. </span><span uib-alert class=danger ng-if=\"vm.form.motivo.$error.minlength && vm.form.$dirty\">Este campo debe tener al menos 10 caracteres.</span></div></form></div></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-danger\" ng-click=vm.rechazar() ng-disabled=\"vm.form.$invalid || !vm.motivo\"><span class=\"glyphicon glyphicon-remove\"></span> Rechazar</button> <button class=\"btn btn-warning\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-arrow-left\"></span> Cancelar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/reporte-rotulos-chicos/reporte-rotulos-chicos.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading>Generar rótulos chicos para {{vm.movimiento.tipoMovimiento.nombre}} N°: {{vm.movimiento.numeroMovimiento}}</div><div class=panel-body><div class=container-fluid><div class=col-lg-12><form name=vm.form><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.detalles.length>0\"><tr ng-repeat=\"detalle in $data track by $index\"><div><td title=\"\'Tipo Suministro\'\" sortable align=center>{{detalle.suministro.tipoSuministro.nombre.toUpperCase();}} ({{detalle.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase();}})</td><td title=\"\'N° Inventario\'\" align=center>{{detalle.suministroInventariable? detalle.suministroInventariable.inventario : \'-\'}}</td><td title=\"\'N° Serie\'\" align=center>{{detalle.suministroInventariable? detalle.suministroInventariable.serie : \'-\'}}</td><td title=\"\'Seleccionar\'\" align=center><input type=checkbox ng-model=detalle.seleccionado></td><td style=width:12% data-title=\"\'Cantidad rótulos\'\"><ng-form name=camposForm ng-if=!detalle.suministro.tipoSuministro.inventariable><div><input class=form-control ng-pattern=/^[1-9][0-9]*$/ type=number name=cantidades ng-model=detalle.cantidadRotulos placeholder=\"Ingrese cantidad\" ng-disabled=!detalle.seleccionado> <span uib-alert class=danger ng-if=\"(camposForm.cantidades.$error.number || camposForm.cantidades.$error.pattern) && camposForm.cantidades.$dirty\">Ingrese un valor válido.</span></div></ng-form><div ng-if=detalle.suministro.tipoSuministro.inventariable>-</div></td></div></tr></table></form></div></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.generarRotulos() ng-disabled=\"vm.form.$invalid || !vm.habilitarBoton()\"><span class=\"fa fa-file-pdf-o\"></span> Generar rótulos</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/components/modales/ocupar-ubicaciones-cajas/ocupar-ubicaciones-cajas.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Seleccione si desea ocupar las ubicaciones seleccionadas</div><div class=panel-body><div class=col-lg-12 ng-if=\"vm.ubicaciones.length>0\"><table id=table1 ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.ubicaciones.length>0\"><tr ng-repeat=\"ubicacion in $data\"><td title=\"\'Nave\'\" align=center>{{ubicacion.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase();}}</td><td title=\"\'Pasillo\'\" align=center>{{ubicacion.nivel.estante.estructura.pasillo.numeroPasillo;}}</td><td title=\"\'Estructura\'\" align=center>{{ubicacion.nivel.estante.estructura.identificadorEstructura; }}</td><td title=\"\'Estantería\'\" align=center>{{ubicacion.nivel.estante.numeroEstante}}</td><td title=\"\'Estante\'\" align=center>{{ubicacion.nivel.numeroNivel}}</td><td title=\"\'Ubicación\'\" align=center>{{ubicacion.numeroUbicacion}}</td><td title=\"\'N° Orden\'\" align=center>{{ubicacion.numeroOrden}}</td><td title=\"\'¿Ocupar?\'\" align=center><input type=checkbox ng-model=ubicacion.ocupar></td></tr></table></div></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-success\" ng-click=vm.guardar()><span class=\"fa fa-check\"></span> Guardar</button> <button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/seleccionar-suministro-egreso-kit/seleccionar-suministro-egreso-kit.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Agregar suministros - Kit pre-armado</div><div class=panel-body><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.sucursal.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Sucursal:</label><input type=text ng-readonly=true ng-model=vm.sucursal.nombre class=\"form-control text-uppercase\" name=sucursal><br></div><div class=col-lg-12><div class=col-lg-8><label ng-if=vm.bandera>Seleccione el Kit:</label><label ng-if=!vm.bandera>Kit seleccionado:</label><div class=input-group><input type=text name=kit ng-model=vm.kit placeholder=\"Seleccione o busque el kit\" uib-typeahead=\"kit as kit.nombre.toUpperCase() for kit in vm.kits | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false ng-disabled=vm.bandera focus-on=kit> <span class=\"input-group-addon btn btn-info\" ng-disabled=!vm.kit.id ng-click=\"!vm.kit.id || vm.visualizarKit();\"><i class=\"fa fa-search\"></i></span></div><span uib-alert ng-if=\"!vm.kit.id && vm.form.kit.$dirty\">Seleccione el kit.</span></div><div class=col-lg-4><br><button style=width:100% ng-if=!vm.bandera class=\"btn btn-primary\" ng-click=vm.seleccionarKit(); ng-disabled=!vm.kit.id><i class=\"fa fa-check\"></i> Seleccionar</button> <button style=width:100% ng-if=vm.bandera class=\"btn btn-warning\" ng-click=vm.cambiarKit();><i class=\"fa fa-exchange\"></i> Cambiar selección</button></div></div><div class=\"col-lg-12 form-group\" ng-if=vm.bandera><br><center><div class=col-lg-12><button class=\"btn btn-primary\" ng-click=vm.asignarSuministrosAutomaticamente();><i class=\"fa fa-magic\"></i> Asignar suministros automáticamente</button></div></center><br><label>Detalles del kit:</label><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.kit.detalles.length>0\"><tr ng-repeat=\"tipo in $data\" ng-disabled=tipo.ocupado ng-class=\"{\'rojo-claro\':tipo.ocupado, \'verde-claro\':!tipo.ocupado&&tipo.cantidadSolicitada>0}\"><td title=\"\'Grupo suministro\'\" align=center>{{tipo.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase();}} - ({{tipo.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase()}})</td><td title=\"\'Familia suministro\'\" align=center>{{tipo.tipoSuministro.familiaSuministro.nombre.toUpperCase();}}</td><td title=\"\'Tipo suministro\'\" align=center>{{tipo.tipoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Cantidad sugerida\'\" align=center>{{tipo.cantidad}}</td><td data-title=\"\'Cantidad solicitada\'\" align=center>{{tipo.cantidadSolicitada>0? tipo.cantidadSolicitada+\" \" : \"0 \"}} <button class=\"btn btn-info\" ng-click=\"tipo.ocupado || tipo.cantidadSolicitada<=0 || (tipo.cantidadSolicitada==undefined || tipo.cantidadSolicitada==null || tipo.cantidadSolicitad<=0) || vm.mostrarSuministrosAsignados(tipo);\" ng-disabled=\"tipo.ocupado || tipo.cantidadSolicitada<=0 || (tipo.cantidadSolicitada==undefined || tipo.cantidadSolicitada==null || tipo.cantidadSolicitad<=0)\"><i class=\"fa fa-search\"></i></button></td><td title=\"\'Acciones\'\" style=width:20% align=center><div class=btn-group><a class=\"btn btn-primary\" ng-click=\"tipo.ocupado || vm.asignarSuministros(tipo)\" ng-disabled=tipo.ocupado><i class=\"fa fa-plus\"></i> Asignar o quitar suministros</a></div></td></tr></table></div></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-primary\" ng-click=vm.comprobarAgregar()><span class=\"glyphicon glyphicon-plus\"></span> Agregar</button> <button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cerrar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/seleccionar-tipo-suministro/modal-seleccionar-tipo-suministro.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Seleccione el tipo de suministro</div><div class=panel-body><div><label>Búsqueda jerarquizada:</label><div class=col-lg-12><div class=col-lg-1><div class=form-group><input type=radio ng-model=vm.radio value=jerarquizada ng-change=vm.cambioRadio()></div></div><div class=col-lg-11><div class=\"form-group col-lg-6\"><label>Grupo de suministro:</label><input type=text ng-disabled=\"vm.radio!=\'jerarquizada\'\" ng-model=vm.grupo placeholder=\"Seleccione o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase()+\' (\'+grupo.empresa.nombre.toUpperCase()+\')\' for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Familia de suministro:</label><input ng-disabled=\"!vm.grupo.nombre || vm.radio!=\'jerarquizada\'\" focus-on=familia type=text ng-model=vm.familiaSuministro placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familiaSuministro as familiaSuministro.nombre.toUpperCase() for familiaSuministro in vm.familias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-12\"><label>Tipo de suministro:</label><input ng-if=\"vm.radio==\'jerarquizada\'\" ng-disabled=\"!vm.grupo.nombre || !vm.familiaSuministro.nombre || vm.radio!=\'jerarquizada\'\" type=text focus-on=tipo ng-model=vm.tipoSuministro placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase() for suministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <input ng-if=\"vm.radio==\'directa\'\" ng-disabled=\"!vm.grupo.nombre || !vm.familiaSuministro.nombre || vm.radio!=\'jerarquizada\'\" type=text focus-on=tipo ng-model=vm.tipoSuministro1 placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase() for suministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div><div><label>Búsqueda directa:</label><div class=col-lg-12 ng-disabled=\"\"><div class=\"form-group col-lg-1\"><input type=radio ng-model=vm.radio value=directa ng-change=vm.cambioRadio()></div><div class=\"form-group col-lg-11\"><label>Tipo de suministro:</label><input type=text ng-disabled=\"vm.radio!=\'directa\'\" ng-model=vm.tipoSuministroCompleto placeholder=\"Seleccione o busque el tipo de suministro por su nombre\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase()+\' (\'+suministro.familiaSuministro.nombre.toUpperCase()+\') - (\'+suministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+\')\' for suministro in vm.tiposCompletos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div><br><div class=col-lg-12><br><div uib-alert type=success ng-if=\"(vm.tipoSuministro && !vm.tipoSuministro.inventariable && vm.cantidadStockTipo()>0) || (vm.tipoSuministro && vm.tipoSuministro.inventariable && vm.cantidadStockBienes()>0)\"><i class=\"fa fa-check\"></i> El tipo de suministro es elegible. Hay stock en el depósito</div></div><div class=col ng-if=\"vm.tipoSuministro && !vm.tipoSuministro.inventariable && vm.cantidadTotalStockTipo>0\"><div uib-alert type=info class=col-lg-12><label>Stock en depósito: {{vm.cantidadStockTipo();}}</label><br><label>Stock mínimo: {{vm.tipoSuministro.stockMinimo}}</label><br><label>Stock total: {{vm.cantidadTotalStockTipo;}}</label></div></div><div uib-alert class=col-lg-12 ng-if=\"vm.tipoSuministro && !vm.tipoSuministro.inventariable && vm.cantidadStockTipo()==0\">No hay stock de este tipo de suministro en el depósito seleccionado</div><div class=col-lg-12 uib-alert ng-if=\"vm.tipoSuministro && vm.tipoSuministro.inventariable && vm.bienes.length==0\">No hay stock de este tipo de suministro en el depósito seleccionado.</div><div class=\"col-lg-12 form-group\" ng-if=\"vm.tipoSuministro && vm.tipoSuministro.inventariable && vm.cantidadStockBienes()>0\"><div uib-alert type=info class=col-lg-12><label>Stock en depósito: {{vm.cantidadStockBienes();}}</label><br><label>Stock mínimo: {{vm.tipoSuministro.stockMinimo}}</label><br><label>Stock total: {{vm.cantidadTotalStockTipo;}}</label></div></div></div><div class=panel-footer><div class=form-group><center><button ng-disabled=\"!vm.tipoSuministro || (vm.tipoSuministro.inventariable && vm.cantidadStockBienes()==0) || ( !vm.tipoSuministro.inventariable && vm.cantidadStockTipo()==0)\" class=\"btn btn-primary\" ng-click=vm.agregar()><span class=\"fa fa-check\"></span> Seleccionar</button> <button type=button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/seleccion-foto/seleccion-foto.html","<div><div class=modal-header><h5 class=modal-title>Agregar fotografía</h5></div><div class=modal-body><form name=vm.form><center><div>Seleccione una fotografía (menor a 1 MB de tamaño): <input type=file accept=image/* id=fileInput onchange=angular.element(this).scope().cargarFoto(this.files[0])></div><div style=\"background: #E4E4E4; overflow: hidden; width:500px; height:350px\"><img-crop area-type=square image=vm.imagenCargada result-image=vm.imagenRecortada></img-crop></div><div>Fotografía recortada:</div><div><img ng-src={{vm.imagenRecortada}}></div></center></form></div><div class=modal-footer><div class=row><div class=\"col-md-3 col-md-offset-3 col-lg-2 col-lg-offset-4 col-xs-6\"><button type=button class=\"btn btn-success btn-block\" data-dismiss=modal ng-click=vm.si() ng-disabled=!vm.bandera><span class=\"glyphicon glyphicon-ok\"></span> Aceptar</button></div><div class=\"col-md-3 col-lg-2 col-xs-6\"><button type=button class=\"btn btn-danger btn-block\" data-dismiss=modal ng-click=vm.no()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div>");
$templateCache.put("app/components/modales/seleccionar-tipo-suministro-kit/modal-seleccionar-tipo-suministro.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>{{vm.modo==\'editar\'? \"Ingrese cantidad\" : \"Seleccione el tipo de suministro\"}}</div><div class=panel-body><div ng-if=\"vm.modo!=\'editar\'\"><label>Búsqueda jerarquizada:</label><div class=col-lg-12><div class=col-lg-1><div class=form-group><input type=radio ng-model=vm.radio value=jerarquizada ng-change=vm.cambioRadio()></div></div><div class=col-lg-11><div class=\"form-group col-lg-6\"><label>Grupo de suministro:</label><input type=text ng-disabled=\"vm.radio!=\'jerarquizada\'\" ng-model=vm.grupo placeholder=\"Seleccione o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase()+\' (\'+grupo.empresa.nombre.toUpperCase()+\')\' for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Familia de suministro:</label><input ng-disabled=\"!vm.grupo.nombre || vm.radio!=\'jerarquizada\'\" focus-on=familia type=text ng-model=vm.familiaSuministro placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familiaSuministro as familiaSuministro.nombre.toUpperCase() for familiaSuministro in vm.familias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-12\"><label>Tipo de suministro:</label><input ng-if=\"vm.radio==\'jerarquizada\'\" ng-disabled=\"!vm.grupo.nombre || !vm.familiaSuministro.nombre || vm.radio!=\'jerarquizada\'\" type=text focus-on=tipo ng-model=vm.tipoSuministro placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase() for suministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <input ng-if=\"vm.radio==\'directa\'\" ng-disabled=\"!vm.grupo.nombre || !vm.familiaSuministro.nombre || vm.radio!=\'jerarquizada\'\" type=text focus-on=tipo ng-model=vm.tipoSuministro1 placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase() for suministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div><div ng-if=\"vm.modo!=\'editar\'\"><label>Búsqueda directa:</label><div class=col-lg-12 ng-disabled=\"\"><div class=\"form-group col-lg-1\"><input type=radio ng-model=vm.radio value=directa ng-change=vm.cambioRadio()></div><div class=\"form-group col-lg-11\"><label>Tipo de suministro:</label><input type=text ng-disabled=\"vm.radio!=\'directa\'\" ng-model=vm.tipoSuministroCompleto placeholder=\"Seleccione o busque el tipo de suministro por su nombre\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase()+\' (\'+suministro.familiaSuministro.nombre.toUpperCase()+\') - (\'+suministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+\')\' for suministro in vm.tiposCompletos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div><div ng-if=\"vm.modo==\'editar\'\"><input type=text ng-model=vm.tipoEditar ng-readonly=true class=\"form-control text-uppercase\"><br></div><div ng-if=\"vm.tipoSuministro.id && !vm.tipoSuministro.inventariable\"><label>Ingrese la cantidad de suministro para el kit</label><input class=form-control ng-pattern=/^[1-9][0-9]*$/ type=number name=cantidad ng-model=vm.cantidad placeholder=\"Ingrese cantidad\" required> <span uib-alert class=danger ng-if=\"(vm.form.cantidad.$error.number || vm.form.$error.pattern) && vm.form.cantidad.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.cantidad.$error.required && vm.form.$dirty\">Este campo es requerido.</span></div><div class=col-lg-12 uib-alert ng-if=\"vm.tipoSuministro && vm.tipoSuministro.inventariable\">El tipo de suministro seleccionado debe ser no inventariable</div></div><div class=panel-footer><div class=form-group><center><button ng-disabled=\"vm.form.$invalid || !vm.tipoSuministro || (vm.tipoSuministro.inventariable) || ( !vm.tipoSuministro.inventariable && vm.cantidadSolicitada<=0)\" class=\"btn btn-primary\" ng-click=vm.agregar()><span class=\"fa fa-check\"></span> Aceptar</button> <button type=button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/visualizar-despacho/visualizar-despacho.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Visualizar despacho</div><div class=panel-body><div class=col-lg-12><center><button class=\"btn btn-primary\" ng-click=vm.reporteEgreso();><i class=\"fa fa-print\"></i> Imprimir reporte despacho</button><div class=\"btn-group btn-inverse\" uib-dropdown><button type=\"button btn-inverse\" class=\"btn btn-default\" uib-dropdown-toggle>Etiquetas <span class=caret></span></button><ul class=dropdown-menu><li><a class=\"btn btn btn-inverse\" style=width:100% ng-click=vm.reporteEtiquetas();><i class=\"fa fa-sticky-note-o\"></i> Imprimir etiquetas</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-click=vm.reporteEtiquetasA4();><i class=\"fa fa-files-o\"></i> Imprimir etiquetas (A4)</a></li></ul></div><button class=\"btn btn-primary\" ng-click=vm.reporteEgresoMultiples(); ng-disabled=\"!vm.egreso.movimientos.length>0\"><i class=\"fa fa-print\"></i> Imprimir reporte egresos</button> <button class=\"btn btn-warning\" ng-click=vm.editarEgreso()><i class=\"fa fa-pencil\"></i> Editar despacho</button></center><br></div><div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=\"col-lg-6 form-group\"><label>Depósito</label><input type=text ng-readonly=true ng-model=vm.egreso.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"col-lg-6 form-group\"><label>Empresa</label><input type=text ng-readonly=true ng-model=vm.egreso.empresa.nombre class=\"form-control text-uppercase\"></div><div class=\"col-lg-6 form-group\"><label>Empresa logística:</label><input type=text ng-readonly=true ng-model=vm.egreso.empresaLogistica.nombre class=\"form-control text-uppercase\"></div><div class=\"col-lg-6 form-group\"><label>Retiró:</label><input type=text ng-readonly=true ng-model=vm.persona class=\"form-control text-uppercase\"></div><div class=\"col-lg-6 form-group\"><label>N° Egreso</label><input type=text ng-readonly=true ng-model=vm.egreso.numeroEgreso class=\"form-control text-uppercase\"></div><div class=\"col-lg-6 form-group\"><label>Fecha despacho</label><input type=text ng-readonly=true ng-model=vm.fecha class=\"form-control text-uppercase\"></div><div class=\"col-lg-9 form-group\"><label>N° Guía</label><input type=text ng-readonly=true ng-model=vm.egreso.nroGuia class=\"form-control text-uppercase\"></div><div class=\"col-lg-3 form-group\"><label>Estado egreso</label><input type=text ng-readonly=true ng-model=vm.egreso.estadoEgreso.nombre class=\"form-control text-uppercase\"></div><div class=\"col-lg-6 form-group\"><label>Cantidad total de paquetes:</label><br><h3><b>{{vm.egreso.cantidadPaquetes==1? vm.egreso.cantidadPaquetes + \" paquete\" : vm.egreso.cantidadPaquetes + \" paquetes\"}}</b></h3></div><div class=\"col-lg-6 form-group\"><label>Peso total de paquetes:</label><br><h3><b>{{vm.egreso.pesoTotal}} Kg.</b></h3></div></div></div></div><div class=col-lg-12><div class=\"col-lg-12 form-group\" ng-show=\"vm.egreso.movimientos.length>0\"><label>Egresos despachados</label><table show-filter=true ng-table=vm.tableParamsEgresos class=table><tr ng-repeat=\"egresos in $data\"><td data-title=\"\'N° movimiento\'\" align=center>{{egresos.numeroMovimiento}}</td><td data-title=\"\'Fecha creado\'\" align=center>{{egresos.fecha | date:\"dd/MM/yyyy HH:mm\"}}</td><td data-title=\"\'Empresa\'\" align=center>{{egresos.empresa.nombre.toUpperCase();}}</td><td data-title=\"\'Sucursal\'\" align=center>{{egresos.sucursal? egresos.sucursal.nombre.toUpperCase():\"-\"}}</td><td data-title=\"\'Cantidad Paquetes\'\" align=center style=width:15%>{{egresos.cantidadPaquetes? egresos.cantidadPaquetes : \"0\"}}</td><td data-title=\"\'Kg Paquetes\'\" align=center style=width:15%>{{egresos.pesoPaquetes? egresos.pesoPaquetes : \"0\"}}</td><td data-title=\"\'Ver\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.visualizarEgreso(egresos)><i class=\"fa fa-search\"></i></a></div></td></tr></table></div></div></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cerrar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/visualizar-egreso-modal/visualizar-egreso-modal.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Información del egreso</div><div class=panel-body><div class=col-lg-12 ng-if=vm.comprobarEgresoGenerado()><div><center><button class=\"btn btn-primary\" ng-click=vm.obtenerInforme()><i class=\"fa fa-file-text\"></i> Imprimir reporte</button> <button class=\"btn btn-warning\" ng-click=vm.abrirModalEditarMovimiento()><i class=\"fa fa-pencil\"></i> Editar egreso</button> <button class=\"btn btn-dark\" ng-click=vm.exportarCantidadesEgreso()><i class=\"fa fa-file-excel-o\"></i> Exportar cantidades</button> <button class=\"btn btn-info\" ng-disabled=!vm.egreso.egreso ng-click=vm.copiarDatosSalida() uib-tooltip=\"{{vm.copiado || \'Click para copiar\'}}\" tooltip-placement=right><i class=\"fa fa-copy\"></i> Copiar datos salida</button></center><br></div><div class=\"panel panel-default\"><div class=panel-body><div class=\"form-group col-lg-12\"><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.egreso.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-4\"><label>Empresa:</label><input type=text ng-model=vm.egreso.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-5\" ng-if=vm.egreso.sucursal.id><label>Sucursal:</label><input type=text ng-model=vm.egreso.sucursal.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-3\"><label>Sector:</label><input type=text ng-model=vm.egreso.sector class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Solicitó:</label><input type=text ng-model=vm.solicitante class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Autorizó:</label><input type=text ng-model=vm.egreso.solicitante class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-4\"><label>Número de movimiento:</label><input class=form-control ng-readonly=true ng-model=vm.egreso.numeroMovimiento type=text name=numeroMovimiento></div><div class=\"form-group col-lg-4\"><label>Fecha:</label><input class=form-control ng-readonly=true ng-model=vm.fecha type=text name=fecha></div><div class=\"form-group col-lg-4\"><label>¿Es egreso de cajas cerradas?:</label><input class=form-control ng-readonly=true ng-model=vm.caja type=text name=caja></div><div class=\"form-group col-lg-4\"><label>Monto total:</label><input class=form-control ng-readonly=true ng-model=vm.montoTotal type=text name=montoTotal></div><div class=\"form-group col-lg-4\"><label>Fecha despacho:</label><input class=form-control ng-readonly=true ng-model=vm.fechaDespacho type=text name=fecha></div><div class=\"form-group col-lg-4\"><label>Estado:</label><input class=form-control ng-readonly=true ng-model=vm.egreso.estadoMovimiento.nombre type=text name=estado></div><div class=\"form-group col-lg-4\"><label>Número de Vale:</label><input class=form-control ng-readonly=true ng-model=vm.egreso.numeroVale type=text name=numeroVale></div><div class=\"form-group col-lg-4\"><label>N° Pedido:</label><div class=input-group><input type=text ng-readonly=true ng-model=vm.egreso.pedido.numeroPedido class=\"form-control text-uppercase\" name=pedido><div class=input-group-btn><button class=\"btn btn-default\" ng-disabled=!vm.egreso.pedido.numeroPedido ng-click=vm.visualizarPedido()><i class=\"fa fa-search\"></i></button></div></div></div><div class=\"form-group col-lg-4\"><label>Número de seguimiento para mail:</label><input class=form-control ng-readonly=true ng-model=vm.egreso.numeroMail type=text name=numeroMail></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=form-control ng-readonly=true ng-model=vm.egreso.observacion type=text name=observacion style=resize:vertical></textarea></div></div></div><div ng-if=!vm.egreso.caja><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesNoInventariablesAgrupados.length>0\"><label>Detalle de suministros no inventariables</label></div><form ng-show=true><div class=col-lg-12 ng-show=\"vm.detallesNoInventariablesAgrupados.length>0\"><table ng-table=vm.tableParamsNoInventariableAgrupado class=\"table table-hover\" ng-init=\"agrupado.$hideRows = true\" show-group=false><tr class=ng-table-group ng-repeat-start=\"agrupado in $data\"><td colspan=6><a href=\"\" ng-click=\"agrupado.$hideRows = !agrupado.$hideRows\"><span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': agrupado.$hideRows, \'glyphicon-chevron-down\': !agrupado.$hideRows }\"></span> Tipo de suministro: {{ agrupado.tipoSuministro.nombre.toUpperCase() }}</a></td><td title=\"Precio total\">Precio total por tipo de suministro: <b>${{agrupado.precioTotal.toFixed(2)}}</b></td><td title=\"Cantidad solicitada\">Cantidad solicitada total: {{agrupado.cantidad}}</td><!-- 							        <td title=\"\'Acciones\'\" align=\"center\">\r\n											<div class=\"btn-group\">\r\n												<a class=\"btn btn-danger\" ng-click=\"vm.quitarTipo(agrupado)\">\r\n													<i class=\"fa fa-remove\"></i>\r\n												</a>\r\n											</div>\r\n	</td> --></tr><tr ng-hide=agrupado.$hideRows ng-repeat=\"detalle in agrupado.detalles\" ng-repeat-end><td title=\"\'Marca\'\" align=center>{{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'Cantidad solicitada\'\" align=center>{{detalle.cantidad}}</td><td title=\"\'Precio\'\" align=center>${{detalle.suministro.precioUnitario}}</td><td style=width:35% title=\"\'Ubicación\'\" ng-if=\"vm.egreso.estadoMovimiento.id!=4\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !detalle.suministro.ubicacion.numeroOrden, \'has-success\':detalle.suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(detalle) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(detalle)}}</div></div></td></tr></table></div></form><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesInventariablesAgrupados.length>0\"><label>Detalle de suministros inventariables</label></div><form ng-show=true><div class=col-lg-12 ng-show=\"vm.detallesInventariablesAgrupados.length>0\"><table ng-table=vm.tableParamsInventariableAgrupado class=\"table table-hover\" ng-init=\"agrupado.$hideRows = true\" show-group=false><tr class=ng-table-group ng-repeat-start=\"agrupado in $data\"><td colspan=6><a href=\"\" ng-click=\"agrupado.$hideRows = !agrupado.$hideRows\"><span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': agrupado.$hideRows, \'glyphicon-chevron-down\': !agrupado.$hideRows }\"></span> Tipo de suministro: {{ agrupado.tipoSuministro.nombre.toUpperCase() }}</a></td><td title=\"Cantidad solicitada\">Cantidad solicitada total: {{agrupado.cantidad}}</td><td title=\"Precio total\">Precio total por tipo de suministro: <b>${{agrupado.precioTotal.toFixed(2)}}</b></td></tr><tr ng-hide=agrupado.$hideRows ng-repeat=\"detalle in agrupado.detalles\" ng-repeat-end><td title=\"\'Marca\'\" align=center>{{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'N° serie\'\" data-sortable=\"\'suministroInventariable.serie\'\" align=center>{{detalle.suministroInventariable.serie ? detalle.suministroInventariable.serie : \"-\" }}</td><td title=\"\'N° inventario\'\" data-sortable=\"\'suministroInventariable.inventario\'\" align=center>{{detalle.suministroInventariable.inventario ? detalle.suministroInventariable.inventario : \"-\" }}</td><td title=\"\'Precio\'\" align=center>${{detalle.suministro.precioUnitario}}</td><td style=width:35% title=\"\'Ubicación\'\" ng-if=detalle.suministro.ubicacion.numeroOrden><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !detalle.suministro.ubicacion.numeroOrden, \'has-success\':detalle.suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(detalle) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(detalle)}}</div></div></td></tr></table></div><form></form></form></div><div ng-if=vm.egreso.caja><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesInventariablesAgrupadosCajas.length>0\"><label>Detalle de cajas cerradas</label></div><form ng-show=true><div class=col-lg-12 ng-show=\"vm.detallesInventariablesAgrupadosCajas.length>0\"><table ng-table=vm.tableParamsInventariableAgrupadoCajas class=\"table table-hover\" ng-init=\"agrupado.$hideRows = true\" show-group=false><tr class=ng-table-group ng-repeat-start=\"agrupado in $data\"><td colspan=6><a href=\"\" ng-click=\"agrupado.$hideRows = !agrupado.$hideRows\"><span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': agrupado.$hideRows, \'glyphicon-chevron-down\': !agrupado.$hideRows }\"></span> Caja cerrada N°: {{agrupado.numeroCaja}}<br>Tipo de suministro: {{ agrupado.tipoSuministro.nombre.toUpperCase() }}<br>Familia de suministro: {{ agrupado.tipoSuministro.familiaSuministro.nombre.toUpperCase();}}</a></td><td style=width:35% title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\"><label class=control-label>Ubicación</label><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompletaCaja(agrupado)>{{agrupado.ubicacion? vm.ubicacionNaveNumeroOrdenCaja(agrupado) : \"No asignó ninguna.\" }}</div><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i></div></td><td title=\"Cantidad total\">Cantidad total: {{agrupado.cantidad}}</td><td title=\"Precio total\">Precio total: <b>${{agrupado.precioTotal.toFixed(2)}}</b></td></tr><tr ng-hide=agrupado.$hideRows ng-repeat=\"detalle in agrupado.detalles\" ng-repeat-end><td title=\"\'Marca\'\" align=center>{{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'N° serie\'\" align=center>{{detalle.suministroInventariable.serie ? detalle.suministroInventariable.serie : \"-\" }}</td><td title=\"\'N° inventario\'\" align=center>{{detalle.suministroInventariable.inventario ? detalle.suministroInventariable.inventario : \"-\" }}</td><td title=\"\'Precio\'\" align=center>${{detalle.suministro.precioUnitario}}</td></tr></table></div></form></div></div><div ng-if=!vm.comprobarEgresoGenerado() class=col-lg-12><span uib-alert class=danger>El egreso no puede visualizarse</span></div></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cerrar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/visualizar-egreso-pedido/visualizar-egreso-pedido.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Información del egreso</div><div class=panel-body><div class=col-lg-12 ng-if=vm.comprobarEgresoGenerado()><div class=\"panel panel-default\"><div class=panel-body><div class=\"form-group col-lg-12\"><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.egreso.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-4\"><label>Empresa:</label><input type=text ng-model=vm.egreso.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-5\" ng-if=vm.egreso.sucursal.id><label>Sucursal:</label><input type=text ng-model=vm.egreso.sucursal.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-3\"><label>Sector:</label><input type=text ng-model=vm.egreso.sector class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Solicitó:</label><input type=text ng-model=vm.solicitante class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Autorizó:</label><input type=text ng-model=vm.egreso.solicitante class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Número de movimiento:</label><input class=form-control ng-readonly=true ng-model=vm.egreso.numeroMovimiento type=text name=numeroMovimiento></div><div class=\"form-group col-lg-6\"><label>Fecha:</label><input class=form-control ng-readonly=true ng-model=vm.fecha type=text name=fecha></div><div class=\"form-group col-lg-6\"><label>Estado:</label><input class=form-control ng-readonly=true ng-model=vm.egreso.estadoMovimiento.nombre type=text name=estado></div><div class=\"form-group col-lg-6\"><label>Fecha despacho:</label><input class=form-control ng-readonly=true ng-model=vm.fechaDespacho type=text name=fecha></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=form-control ng-readonly=true ng-model=vm.egreso.observacion type=text name=observacion style=resize:vertical></textarea></div></div></div><div ng-if=\"vm.egreso.cantidadPaquetes && vm.egreso.pesoPaquetes\"><div class=\"col-lg-6 form-group\"><label>Cantidad total de paquetes:</label><br><h3><b>{{vm.egreso.cantidadPaquetes==1? vm.egreso.cantidadPaquetes + \" paquete\" : vm.egreso.cantidadPaquetes + \" paquetes\"}}</b></h3></div><div class=\"col-lg-6 form-group\"><label>Peso total de paquetes:</label><br><h3><b>{{vm.egreso.pesoPaquetes}} Kg.</b></h3></div></div><div ng-if=!vm.egreso.caja><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesNoInventariablesAgrupados.length>0\"><label>Detalle</label></div><form ng-show=true><div class=col-lg-12 ng-show=\"vm.detallesNoInventariablesAgrupados.length>0\"><table ng-table=vm.tableParamsNoInventariableAgrupado class=\"table table-hover\" ng-init=\"agrupado.$hideRows = true\" show-group=false><tr class=ng-table-group ng-repeat-start=\"agrupado in $data\"><td colspan=6><a href=\"\" ng-click=\"agrupado.$hideRows = !agrupado.$hideRows\"><span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': agrupado.$hideRows, \'glyphicon-chevron-down\': !agrupado.$hideRows }\"></span> Tipo de suministro: {{ agrupado.tipoSuministro.nombre.toUpperCase() }}</a></td><td title=\"Cantidad solicitada\">Cantidad solicitada total: {{agrupado.cantidad}}</td></tr><tr ng-hide=agrupado.$hideRows ng-repeat=\"detalle in agrupado.detalles\" ng-repeat-end><td title=\"\'Marca\'\" align=center>{{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'Cantidad solicitada\'\" align=center>{{detalle.cantidad}}</td></tr></table></div></form></div></div><div ng-if=!vm.comprobarEgresoGenerado() class=col-lg-12><span uib-alert class=danger>El egreso no puede visualizarse</span></div></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cerrar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/visualizar-historial-reparacion/modal.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Información del historial de reparación de suministros</div><div class=panel-body><div class=col-lg-12><div class=\"form-group col-lg-6\"><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.historial.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-6\"><label>Fecha:</label><input type=text ng-model=vm.fecha class=form-control ng-readonly=true></div><div class=\"form-group col-lg-12\" ng-if=\"vm.historial.detalles.length>0\"><label>Personal que realizó la reparación:</label><input type=text ng-readonly=true ng-model=vm.historial.personal class=\"form-control text-uppercase\" name=personal></div><div class=\"form-group col-lg-12\" ng-if=\"vm.historial.detalles.length>0\"><label>Descripción general:</label><input type=text ng-readonly=true ng-model=vm.historial.descripcion class=form-control name=descripcion></div></div><br><label>Detalles del historial:</label><div class=\"col-lg-12 form-group\"><br><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.detalles.length>0\"><tr ng-repeat=\"detalle in $data\"><td title=\"\'Grupo suministro\'\" align=center>{{detalle.suministroInventariable.suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase();}} - ({{detalle.suministroInventariable.suministro.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase()}})</td><td title=\"\'Familia suministro\'\" align=center>{{detalle.suministroInventariable.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase();}}</td><td title=\"\'Tipo suministro\'\" align=center>{{detalle.suministroInventariable.suministro.tipoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Inventario\'\" align=center>{{detalle.suministroInventariable.inventario}}</td><td title=\"\'Serie\'\" align=center>{{detalle.suministroInventariable.serie}}</td><td title=\"\'Reparación\'\" style=width:40% align=center>{{detalle.descripcion}}</td><td title=\"\'¿Foto?\'\" align=center>{{detalle.encabezadoFoto? \"SI\" : \"NO\"}} <button class=btn ng-if=detalle.encabezadoFoto ng-click=vm.mostrarFoto(detalle)><i class=\"fa fa-camera\"></i></button></td></tr></table></div></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-danger\" ng-click=vm.volver()><span class=\"glyphicon glyphicon-remove\"></span> Cerrar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/visualizar-informe-recorrido/visualizar-informe-recorrido.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Informe de ubicaciones para recorrido, por suministros de egresos seleccionados</div><div class=panel-body><div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=col-lg-12><center><button class=\"btn btn-primary\" ng-click=vm.obtenerInforme()><span class=\"fa fa-file-text-o\"></span> Obtener Informe</button></center></div><div class=\"col-lg-12 form-group\"><label>Depósito</label><input type=text ng-readonly=true ng-model=vm.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"col-lg-12 form-group\" ng-show=\"vm.egresos.length>0\"><label>Egresos seleccionados</label><table show-filter=true ng-table=vm.tableParamsEgresos class=\"table table-hover\"><tr ng-repeat=\"egresos in $data\"><td data-title=\"\'N° movimiento\'\" align=center>{{egresos.numeroMovimiento}}</td><td data-title=\"\'Fecha\'\" align=center>{{egresos.fecha | date:\"dd/MM/yyyy HH:mm\"}}</td><td data-title=\"\'Empresa\'\" align=center>{{egresos.empresa.nombre.toUpperCase();}}</td><td date-title=\"\'Sucursal\'\" align=center>{{egresos.sucursal.nombre.toUpperCase();}}</td><td title=\"\'Ver\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-disabled=\"(egresos.estadoMovimiento.id!=1 && egresos.estadoMovimiento.id!=17 && egresos.estadoMovimiento.id!=21)\" ng-click=\"(egresos.estadoMovimiento.id!=1 && egresos.estadoMovimiento.id!=17 && egresos.estadoMovimiento.id!=21) || vm.visualizarEgreso(egresos)\"><i class=\"fa fa-search\"></i></a></div></td></tr></table></div></div></div><div class=col-lg-12><label>Listado de ubicaciones</label></div><form ng-show=true><div class=col-lg-12 ng-show=\"vm.detallesAgrupados.length>0\"><table ng-table=vm.tableParamsAgrupado class=\"table table-hover\" ng-init=\"agrupado.$hideRows = true\" show-group=false><tr class=ng-table-group ng-repeat-start=\"agrupado in $data\"><td colspan=6><a href=\"\" ng-click=\"agrupado.$hideRows = !agrupado.$hideRows\"><span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': agrupado.$hideRows, \'glyphicon-chevron-down\': !agrupado.$hideRows }\"></span> UBICACIÓN</a></td><td style=width:45% title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !agrupado.ubicacion.numeroOrden, \'has-success\':agrupado.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(agrupado) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(agrupado)}}</div></div></td></tr><tr ng-hide=agrupado.$hideRows ng-repeat=\"detalle in agrupado.detalles\" ng-repeat-end><td title=\"\'Tipo de suministro\'\" align=center>{{detalle.suministro.tipoSuministro.nombre.toUpperCase(); }}<br ng-if=detalle.numeroLote><label ng-if=detalle.numeroLote>N° Lote:</label>{{detalle.numeroLote? detalle.numeroLote:\"\"}}<br ng-if=detalle.suministro.marca><label ng-if=detalle.suministro.marca>Marca:</label>{{detalle.suministro.marca? detalle.suministro.marca.toUpperCase():\"\"}}<br ng-if=detalle.suministro.fechaVencimiento><label ng-if=detalle.suministro.fechaVencimiento>Fecha vencimiento:</label>{{detalle.suministro.fechaVencimiento? detalle.suministro.fechaVencimiento : \"\" | date : \"dd/MM/yyyy\" }}<br ng-if=detalle.suministroInventariable.inventario><label ng-if=detalle.suministroInventariable.inventario>N° inventario:</label>{{ detalle.suministroInventariable.inventario? detalle.suministroInventariable.inventario:\'\'}}<br ng-if=detalle.suministroInventariable.serie><label ng-if=detalle.suministroInventariable.serie>N° serie:</label>{{detalle.suministroInventariable.serie? detalle.suministroInventariable.serie : \"\"}}<br ng-if=detalle.numeroCaja><label ng-if=detalle.numeroCaja>Pertenece a caja cerrada N°:</label>{{detalle.numeroCaja}}</td><td title=\"\'Cantidad\'\" align=center>{{detalle.cantidad}}</td></tr></table></div></form></div></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cerrar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/visualizar-egresos-en-preparacion/visualizar-egresos-en-preparacion.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>{{vm.bandera? \"Egresos seleccionados\":\"Egresos en preparación seleccionados\"}}</div><div class=panel-body><div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=col-lg-12><center><button class=\"btn btn-primary\" ng-click=vm.obtenerInforme()><span class=\"fa fa-file-text-o\"></span> Obtener Informe</button></center></div><div class=\"col-lg-12 form-group\"><label>Depósito</label><input type=text ng-readonly=true ng-model=vm.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"col-lg-12 form-group\" ng-show=\"vm.egresos.length>0\"><label>Egresos seleccionados</label><table show-filter=true ng-table=vm.tableParamsEgresos class=\"table table-hover\"><tr ng-repeat=\"egresos in $data\"><td data-title=\"\'N° movimiento\'\" align=center>{{egresos.numeroMovimiento}}</td><td data-title=\"\'Fecha\'\" align=center>{{egresos.fecha | date:\"dd/MM/yyyy HH:mm\"}}</td><td data-title=\"\'Empresa\'\" align=center>{{egresos.empresa.nombre.toUpperCase();}}</td><td date-title=\"\'Sucursal\'\" align=center>{{egresos.sucursal.nombre.toUpperCase();}}</td><td title=\"\'Ver\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.visualizarEgreso(egresos)><i class=\"fa fa-search\"></i></a></div></td></tr></table></div></div></div></div></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cerrar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/visualizar-ingresos-orden-remito/visualizar-ingresos-orden-remito.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Ingresos seleccionados</div><div class=\"panel panel-body\"><div class=col-lg-12><div><center><div class=btn-group uib-dropdown><button type=button class=\"btn btn-primary\" uib-dropdown-toggle ng-disabled=\"!vm.cantidadIngresos>0\"><i class=\"fa fa-file-text\"></i> Imprimir reporte <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li style=width:100%><a class=\"btn btn btn-inverse\" ng-click=\"!vm.cantidadIngresos>0 || vm.mostrarReporte();\" ng-disabled=\"!vm.cantidadIngresos>0\"><i class=\"fa fa-file-pdf-o\"></i> Exportar a PDF</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-click=\"!vm.cantidadIngresos>0 || vm.mostrarReporteExcel();\" ng-disabled=\"!vm.cantidadIngresos>0\"><i class=\"fa fa-file-excel-o\"></i> Exportar a Excel</a></li></ul></div></center><br></div><div class=\"panel panel-default\"><div class=panel-body><div class=\"form-group col-lg-12\"><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-12\"><label>Empresa:</label><input type=text ng-model=vm.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Monto total:</label><input class=form-control ng-readonly=true ng-model=vm.montoTotal type=text name=montoTotal></div><div class=\"form-group col-lg-6\"><label>Cantidad de ingresos:</label><input class=form-control ng-readonly=true ng-model=vm.cantidadIngresos type=text name=cantidadIngresos></div><br><br><div class=col-lg-12 ng-if=\"vm.ingresos.length>0\"><label>Ingresos</label><table ng-table=vm.tableParamsIngresos class=\"table table-condensed\" show-filter=true><tr ng-repeat=\"ingresos in vm.ingresos\"><div><td data-title=\"\'Fecha\'\" align=center data-sortable=\"\'fecha\'\">{{ingresos.fecha | date : \"dd/MM/yyyy\" }}</td><td data-title=\"\'Proveedor\'\" align=center>{{ingresos.proveedor.nombre.toUpperCase()}}</td><td data-title=\"\'N° Movimiento\'\" style=width:5% align=center>{{ingresos.numeroMovimiento}}</td><td title=\"\'N° Remito\'\" align=center>{{ingresos.numeroRemito}}</td><td title=\"\'N° Orden\'\" align=center>{{ingresos.numeroOrden}}</td><td data-title=\"\'Estado\'\" style=width:5% align=center>{{ingresos.estadoMovimiento.nombre.toUpperCase();}}</td><td data-title=\"\'Ver\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.visualizarIngreso(ingresos)><i class=\"fa fa-search\"></i></a></div></td></div></tr></table></div></div></div><div class=col-lg-12 ng-if=\"vm.ingresos.length<=0\"><div uib-alert>No hay ingresos correspondientes con los criterios de búsqueda solicitados.</div></div><div><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesAgrupados.length>0\"><label>Detalle de ingresos</label></div><form ng-show=true><div class=col-lg-12 ng-show=\"vm.detallesAgrupados.length>0\"><table ng-table=vm.tableParamsIngresosAgrupado class=\"table table-hover\" show-group=false><tr ng-repeat=\"detalle in vm.detallesAgrupados\"><td title=\"\'Fecha\'\" align=center>{{detalle.movimiento.fecha | date: \"dd/MM/yyyy\" }}</td><td title=\"\'N° Movimiento\'\" style=width:5% align=center>{{detalle.movimiento.numeroMovimiento}}</td><td title=\"\'Proveedor\'\" align=center>{{detalle.movimiento.proveedor.nombre.toUpperCase()}}</td><td title=\"\'N° Remito\'\" align=center>{{detalle.movimiento.numeroRemito}}</td><td title=\"\'N° Orden\'\" align=center>{{detalle.movimiento.numeroOrden}}</td><td title=\"\'Suministro\'\" align=center>({{detalle.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()}} - {{detalle.tipoSuministro.familiaSuministro.nombre.toUpperCase()}}) {{detalle.tipoSuministro.nombre.toUpperCase()}}</td><td title=\"\'Cantidad\'\" align=center>{{detalle.cantidad}}</td><td title=\"\'Precio unitario\'\" align=center>${{detalle.suministro.precioUnitario}}</td><td title=\"\'Precio total\'\" align=center>${{detalle.precio}}</td></tr></table></div></form></div></div></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cerrar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/visualizar-kit-prearmado/visualizar-kit-prearmado.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Información del kit</div><div class=panel-body><div class=col-lg-12><div class=\"form-group col-lg-6\"><label>Nombre:</label><input type=text ng-readonly=true ng-model=vm.kit.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.kit.sucursal.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-12\"><label>Sucursal:</label><input type=text ng-readonly=true ng-model=vm.kit.sucursal.nombre class=\"form-control text-uppercase\" name=sucursal></div></div><br><label>Detalles del kit:</label><div class=\"col-lg-12 form-group\"><br><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.kit.detalles.length>0\"><tr ng-repeat=\"tipo in $data\"><td title=\"\'Grupo suministro\'\" align=center>{{tipo.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase();}} - ({{tipo.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase()}})</td><td title=\"\'Familia suministro\'\" align=center>{{tipo.tipoSuministro.familiaSuministro.nombre.toUpperCase();}}</td><td title=\"\'Tipo suministro\'\" align=center>{{tipo.tipoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Cantidad\'\" align=center>{{tipo.cantidad}}</td></tr></table></div></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-danger\" ng-click=vm.volver()><span class=\"glyphicon glyphicon-remove\"></span> Cerrar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/visualizar-ingreso-modal/visualizar-ingreso-modal.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Información del ingreso</div><div class=panel-body><div class=col-lg-12 ng-if=vm.comprobarIngresoCerrado()><div><center><button class=\"btn btn-primary\" ng-click=vm.obtenerInforme()><i class=\"fa fa-file-text\"></i> Imprimir reporte</button> <button class=\"btn btn-warning\" ng-click=vm.abrirModalEditarMovimiento()><i class=\"fa fa-pencil\"></i> Editar ingreso</button><div class=btn-group uib-dropdown><button type=button class=\"btn btn-info\" uib-dropdown-toggle><i class=\"fa fa-file-text\"></i> Imprimir rótulos <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li style=width:100%><a class=\"btn btn btn-inverse\" ng-click=vm.rotulosA4();><i class=\"fa fa-file-pdf-o\"></i> Rótulos A4</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-click=vm.rotulosChicos();><i class=\"fa fa-file-excel-o\"></i> Rótulos chicos</a></li></ul></div></center><br></div><div class=\"panel panel-default\"><div class=panel-body><div class=\"form-group col-lg-12\"><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.ingreso.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-5\"><label>Empresa:</label><input type=text ng-model=vm.ingreso.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-3\"><label>Número de movimiento:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroMovimiento type=text name=numeroMovimiento></div><div class=\"form-group col-lg-2\"><label>Fecha:</label><input class=form-control ng-readonly=true ng-model=vm.fecha type=text name=fecha></div><div class=\"form-group col-lg-2\"><label>Fecha ingreso manual:</label><input class=form-control ng-readonly=true ng-model=vm.fechaIngreso type=text name=fecha></div><div class=\"form-group col-lg-6\"><label>Proveedor:</label><input type=text ng-readonly=true ng-model=vm.ingreso.proveedor.nombre class=\"form-control text-uppercase\" name=proveedor></div><div class=\"form-group col-lg-6\"><label>Persona Proveedor:</label><input type=text ng-readonly=true ng-model=vm.personaProveedor class=\"form-control text-uppercase\" name=personaProveedor></div><div class=\"form-group col-lg-6\"><label>Empresa logística:</label><input type=text ng-readonly=true ng-model=vm.ingreso.empresaLogistica.nombre class=\"form-control text-uppercase\" name=empresaLogistica></div><div class=\"form-group col-lg-6\"><label>Persona Empresa logística:</label><input type=text ng-readonly=true ng-model=vm.personaEmpresaLogistica class=\"form-control text-uppercase\" name=personaEmpresaLogistica></div><div class=\"form-group col-lg-3\"><label>Autorizó:</label><input type=text ng-model=vm.ingreso.solicitante class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-3\"><label>Número de orden de compra:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroOrden type=text name=numeroOrden></div><div class=\"form-group col-lg-3\"><label>Número de remito:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroRemito type=text name=numeroRemito></div><div class=\"form-group col-lg-3\"><label>Monto total:</label><input class=form-control ng-readonly=true ng-model=vm.montoTotal type=text name=montoTotal></div><div class=\"form-group col-lg-3\"><label>Número Vale Ingreso:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroIngresoVale type=text name=numeroIngresoVale></div><div class=\"form-group col-lg-4\"><label>Número guía</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroGuia type=text name=numeroGuia></div><div class=\"form-group col-lg-5\"><label>Sucursal de origen</label><input class=\"form-control text-uppercase\" ng-readonly=true ng-model=vm.ingreso.sucursal.nombre type=text name=sucursal></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=form-control ng-readonly=true ng-model=vm.ingreso.observacion type=text name=observacion style=resize:vertical></textarea></div></div></div><div ng-if=\"vm.rol.id<=3\"><uib-accordion><div uib-accordion-group class=panel-default is-open=status.isCustomHeaderOpen><uib-accordion-heading>Problemas <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.isCustomHeaderOpen, \'glyphicon-chevron-right\': !status.isCustomHeaderOpen}\"></i></uib-accordion-heading><div class=col-lg-12><div ng-if=\"vm.ingreso.problemas.length==0\"><span uib-alert type=info>No posee ningún problema asignado</span></div><div><center><button class=\"btn btn-primary\" ng-click=vm.editarProblemas();><i class=\"fa fa-pencil-square\"></i> Agregar o quitar problemas</button></center></div><div ng-if=\"vm.ingreso.problemas.length>0\"><label>Problemas asignados:</label><table ng-table=vm.tableParams1 class=table><tr ng-repeat=\"problema in $data track by $index\"><td>{{problema.tipoProblema.nombre.toUpperCase();}}</td></tr></table><div class=col-lg-12 ng-if=vm.comprobarFotoProblema()><div uib-carousel active=0 interval=0 no-wrap=false><div uib-slide ng-repeat=\"problema in vm.problemas track by $index\" index=problema.ind><img ng-src={{problema.foto}} style=margin:auto><div><h4>{{problema.tipoProblema.nombre.toUpperCase();}}</h4></div></div></div><br></div><label>Descripción de problemas:</label><textarea class=form-control ng-readonly=true ng-disabled=true ng-model=vm.ingreso.observacionProblema type=text name=observacionProblema style=resize:vertical>\r\n										</textarea></div></div></div></uib-accordion></div><br><div class=\"col-lg-12 form-group\" ng-if=vm.comprobarIngresoCerrado();><label>Detalle de suministros del ingreso</label></div><form ng-show=true ng-if=vm.comprobarIngresoCerrado();><div class=col-lg-12 ng-show=\"vm.ingreso.detalles.length>0\"><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.ingreso.detalles.length>0\"><tr ng-repeat=\"detalles in $data track by $index\"><div><td title=\"\'Tipo Suministro\'\" sortable align=center>{{detalles.suministro.tipoSuministro.nombre.toUpperCase();}} ({{detalles.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase();}})</td><td title=\"\'Marca\'\" align=center>{{detalles.suministro.marca ? detalles.suministro.marca.toUpperCase() : \"-\" }}</td><!-- 								        <td title=\"\'Fecha vencimiento\'\" align=\"center\">\r\n    {{detalles.suministro.fechaVencimiento ? detalles.suministro.fechaVencimiento : \"-\" | date : \"dd/MM/yyyy\" }}\r\n</td> --><td title=\"\'N° Inventario\'\" align=center>{{detalles.suministroInventariable? detalles.suministroInventariable.inventario : \'-\'}}</td><td title=\"\'N° Serie\'\" align=center>{{detalles.suministroInventariable? detalles.suministroInventariable.serie : \'-\'}}</td><td title=\"\'Cantidad\'\" align=center>{{detalles.cantidad}}</td><td ng-if=\"vm.rol.id<=3\" title=\"\'Precio por unidad\'\" align=center>${{detalles.suministro.precioUnitario.toFixed(2)}}</td><td ng-if=\"vm.rol.id<=3\" title=\"\'Total\'\" align=center>${{(detalles.suministro.precioUnitario*detalles.cantidad).toFixed(2)}}</td><td title=\"\'N° Caja\'\" align=center ng-if=vm.ingreso.caja>{{detalles.numeroCaja? detalles.numeroCaja : \'-\'}}</td><!-- 				        <td title=\"\'¿Activo?\'\" align=\"center\">\r\n				    {{detalles.suministro.estadoSuministro.id==2? \"SI\" : \"NO\"}}\r\n				</td> --><!-- 								        <td title=\"\'¿Nuevo?\'\" align=\"center\">\r\n    {{detalles.suministroInventariable? detalles.suministroInventariable.nuevo? \"SI\" : \"NO\" : \"-\"}}\r\n</td> --><td ng-if=\"vm.rol.id<=3\" title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !detalles.suministro.ubicacion.numeroOrden, \'has-success\':detalles.suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(detalles) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(detalles)}}</div></div></td><td ng-if=\"vm.rol.id<=3\" style=width:15% data-title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-primary\" ng-click=vm.reporteNombre(detalles)><i class=\"fa fa-file-text\"></i> </a><a class=\"btn btn-warning\" ng-click=vm.editarSuministro(detalles)><i class=\"fa fa-pencil\"></i></a></div></td></div></tr></table></div></form></div><div ng-if=!vm.comprobarIngresoCerrado() class=col-lg-12><span uib-alert class=danger>El ingreso no puede visualizarse porque aún no asignó las ubicaciones a los suministros</span></div></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cerrar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/visualizar-pedido/visualizar-pedido.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Información del pedido</div><div class=panel-body><div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=\"form-group col-lg-12\"><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.pedido.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.pedido.sucursal.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-3\"><label>Número de pedido:</label><input class=form-control ng-readonly=true ng-model=vm.pedido.numeroPedido type=text name=numeroPedido></div><div class=\"form-group col-lg-3\"><label>Fecha:</label><input class=form-control ng-readonly=true ng-model=vm.fecha type=text name=fecha></div><div class=\"form-group col-lg-6\"><label>Sucursal:</label><input type=text ng-readonly=true ng-model=vm.pedido.sucursal.nombre class=\"form-control text-uppercase\" name=sucursal></div><div class=\"form-group col-lg-3\"><label>Solicitó:</label><input type=text ng-model=vm.solicitante class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-3\"><label>Estado:</label><input type=text ng-model=vm.estado class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=form-control ng-readonly=true ng-model=vm.pedido.observacion type=text name=observacion style=resize:vertical></textarea></div></div></div><br ng-if=vm.movimiento.id><label ng-if=vm.movimiento.id>Movimiento:</label><div class=\"panel panel-default\" ng-if=vm.movimiento.id><div class=panel-body><div class=\"form-group col-lg-12\"><label>N° Movimiento:</label><div class=input-group><input type=text ng-readonly=true ng-model=vm.movimiento.numeroMovimiento class=\"form-control text-uppercase\" name=numeroMovimiento><div class=input-group-btn><button class=\"btn btn-default\" ng-disabled=!vm.movimiento.numeroMovimiento ng-click=vm.visualizarMovimiento()><i class=\"fa fa-search\"></i></button></div></div></div></div></div><br ng-if=vm.pedido.motivoRechazoAnulacion><label ng-if=vm.pedido.motivoRechazoAnulacion>Rechazo:</label><div class=\"panel panel-default\" ng-if=vm.pedido.motivoRechazoAnulacion><div class=panel-body><div class=\"form-group col-lg-9\"><label>Motivo rechazo:</label><textarea class=form-control ng-readonly=true ng-model=vm.pedido.motivoRechazoAnulacion type=text name=motivoRechazoAnulacion style=resize:vertical></textarea></div><div class=\"form-group col-lg-3\"><label>Rechazado por:</label><input type=text ng-model=vm.usuarioRechazo class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-3\"><label>Fecha rechazo:</label><input type=text ng-model=vm.fechaRechazo class=\"form-control text-uppercase\" ng-readonly=true></div></div></div><br ng-if=\"vm.movimiento.nombreConfirmacion && !vm.movimiento.descripcionReclamo\"><label ng-if=\"vm.movimiento.nombreConfirmacion && !vm.movimiento.descripcionReclamo\">Confirmación de recepción:</label><div class=\"panel panel-default\" ng-if=\"vm.movimiento.nombreConfirmacion && !vm.movimiento.descripcionReclamo\"><div class=panel-body><div class=\"form-group col-lg-7\"><label>Recepción confirmada por:</label><input type=text ng-model=vm.movimiento.nombreConfirmacion class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-5\"><label>Fecha confirmación:</label><input type=text ng-model=vm.fechaConfirmacion class=\"form-control text-uppercase\" ng-readonly=true></div></div></div><br ng-if=\"vm.movimiento.nombreConfirmacion && vm.movimiento.descripcionReclamo\"><label ng-if=\"vm.movimiento.nombreConfirmacion && vm.movimiento.descripcionReclamo\">Reclamo:</label><div class=\"panel panel-default\" ng-if=\"vm.movimiento.nombreConfirmacion && vm.movimiento.descripcionReclamo\"><div class=panel-body><div class=\"form-group col-lg-7\"><label>Reclamado por:</label><input type=text ng-model=vm.movimiento.nombreConfirmacion class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-5\"><label>Fecha reclamo:</label><input type=text ng-model=vm.fechaConfirmacion class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-12\"><label>Reclamo:</label><textarea class=form-control ng-readonly=true ng-model=vm.movimiento.descripcionReclamo type=text name=descripcionReclamo style=resize:vertical></textarea></div></div></div><br ng-if=\"vm.movimiento.nombreConfirmacion && vm.movimiento.descripcionReclamo && vm.movimiento.fechaAtencionReclamo\"><label ng-if=\"vm.movimiento.nombreConfirmacion && vm.movimiento.descripcionReclamo && vm.movimiento.fechaAtencionReclamo\">Atención de reclamo:</label><div class=\"panel panel-default\" ng-if=\"vm.movimiento.nombreConfirmacion && vm.movimiento.descripcionReclamo && vm.movimiento.fechaAtencionReclamo\"><div class=panel-body><div class=\"form-group col-lg-7\"><label>Reclamo atendido por:</label><input type=text ng-model=vm.usuarioAtencionReclamo class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-5\"><label>Fecha atención:</label><input type=text ng-model=vm.fechaAtencionReclamo class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-12\"><label>Atención de reclamo:</label><textarea class=form-control ng-readonly=true ng-model=vm.movimiento.atencionReclamo type=text name=atencionReclamo style=resize:vertical></textarea></div></div></div><div class=\"col-lg-12 form-group\"><label>Detalle del pedido</label></div><form ng-show=true ng-if=vm.comprobarIngresoCerrado();><div class=col-lg-12 ng-show=\"vm.pedido.detalles.length>0\"><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.pedido.detalles.length>0\"><tr ng-repeat=\"detalles in $data track by $index\"><div><td title=\"\'Tipo Suministro\'\" data-sortable=\"\'tipoSuministro.nombre\'\" align=center>{{detalles.tipoSuministro.nombre.toUpperCase();}} ({{detalles.tipoSuministro.familiaSuministro.nombre.toUpperCase();}})</td><td title=\"\'Cantidad\'\" align=center>{{detalles.cantidad}}</td></div></tr></table></div></form></div></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cerrar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/visualizar-pedidos-anteriores/visualizar-pedidos-anteriores.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Repetir pedidos anteriores</div><div class=panel-body><div class=col-lg-12><div class=form-group ng-show=\"vm.pedidos.length>0\"><label>Lista de los últimos 10 pedidos</label><table show-filter=true ng-table=vm.tableParams class=\"table table-hover\"><tr ng-repeat=\"pedido in $data\"><td data-title=\"\'Fecha\'\" align=center>{{pedido.fecha | date:\"dd/MM/yyyy HH:mm\"}}</td><td data-title=\"\'Depósito\'\" data-sortable=\"\'deposito.nombre\'\" filter=\"{\'deposito.nombre\': \'text\'}\" align=center>{{pedido.deposito.nombre.toUpperCase();}}</td><td data-title=\"\'Empresa\'\" data-sortable=\"\'empresa.nombre\'\" filter=\"{\'empresa.nombre\': \'text\'}\" align=center>{{pedido.empresa.nombre.toUpperCase();}}</td><td data-title=\"\'Sucursal\'\" filter=\"{\'sucursal.nombre\': \'text\'}\" data-sortable=\"\'sucursal.nombre\'\" align=center>{{pedido.sucursal.nombre.toUpperCase();}}</td><td data-title=\"\'N° Pedido\'\" style=width:10% align=center filter=\"{\'numeroPedido\':\'text\'}\" data-sortable=\"\'numeroPedido\'\">{{pedido.numeroPedido}}</td><td data-title=\"\'Estado\'\" style=width:10% data-sortable=\"\'estado.nombre\'\" filter=\"{\'estado.nombre\': \'text\'}\" align=center data-sortable=\"\'estado\'\">{{pedido.estado.nombre.toUpperCase();}} {{ (pedido.estadoMovimiento==\'EN PREPARACIÓN\' || pedido.estadoMovimiento==\'PREPARADA\' || pedido.estado.id==6)? \" - \"+pedido.estadoMovimiento : \"\" }}</td><td data-title=\"\'Ver\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.visualizarPedido(pedido)><i class=\"fa fa-search\"></i></a></div></td><td title=\"\'Seleccionar\'\" align=center><div class=btn-group><a class=\"btn btn-primary\" ng-click=vm.seleccionar(pedido)><i class=\"fa fa-check\"></i> Seleccionar</a></div></td></tr></table></div><div ng-if=\"vm.pedidos.length==0\"><div uib-alert><i class=\"fa fa-exclamation\"></i> No hay registros para mostrar</div></div></div></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cerrar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/visualizar-resumen-pedido/visualizar-resumen-pedido.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Pedido</div><div class=panel-body><div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=\"form-group col-lg-12\"><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.pedido.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-5\"><label>Empresa:</label><input type=text ng-model=vm.pedido.sucursal.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-3\"><label>Fecha:</label><input class=form-control ng-readonly=true ng-model=vm.fecha type=text name=fecha></div><div class=\"form-group col-lg-4\"><label>Solicita:</label><input type=text ng-model=vm.solicitante class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-7\"><label>Sucursal:</label><input type=text ng-readonly=true ng-model=vm.pedido.sucursal.nombre class=\"form-control text-uppercase\" name=sucursal></div><div class=\"form-group col-lg-5\"><label>Sector:</label><input type=text ng-readonly=true ng-model=vm.pedido.sector class=\"form-control text-uppercase\" name=sector></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=form-control ng-readonly=true ng-model=vm.pedido.observacion type=text name=observacion style=resize:vertical></textarea></div></div></div><div class=\"col-lg-12 form-group\" ng-if=vm.comprobarIngresoCerrado();><label>Detalle del pedido</label></div><form ng-show=true ng-if=vm.comprobarIngresoCerrado();><div class=col-lg-12 ng-show=\"vm.pedido.detalles.length>0\"><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.pedido.detalles.length>0\"><tr ng-repeat=\"detalles in $data track by $index\"><div><td title=\"\'Tipo Suministro\'\" data-sortable=\"\'tipoSuministro.nombre\'\" align=center>{{detalles.tipoSuministro.nombre.toUpperCase();}} ({{detalles.tipoSuministro.familiaSuministro.nombre.toUpperCase();}})</td><td title=\"\'Cantidad\'\" align=center>{{detalles.cantidad}}</td></div></tr></table></div></form></div></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-success\" ng-click=vm.guardar()><span class=\"fa fa-check\"></span> Guardar</button> <button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cerrar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/visualizar-seleccionados-pedido/visualizar-seleccionados-pedido.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Suministros seleccionados</div><div class=panel-body><div class=col-lg-12><div class=\"col-lg-12 form-group\" ng-if=vm.comprobarIngresoCerrado();><label>Listado</label></div><form ng-show=true ng-if=vm.comprobarIngresoCerrado();><div class=col-lg-12 ng-show=\"vm.seleccionados.length>0\"><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.seleccionados.length>0\"><tr ng-repeat=\"detalles in $data track by $index\"><div><td title=\"\'Tipo Suministro\'\" data-sortable=\"\'tipoSuministro.nombre\'\" align=center>{{detalles.tipoSuministro.nombre.toUpperCase();}} ({{detalles.tipoSuministro.familiaSuministro.nombre.toUpperCase();}})</td><td title=\"\'Cantidad\'\" align=center>{{detalles.cantidad}}</td></div></tr></table></div></form></div></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cerrar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/visualizar-suministros-asignados/visualizar-suministros-asignados.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Suministros asignados</div><div class=panel-body><div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=\"form-group col-lg-12\"><label>Sucursal:</label><input type=text ng-model=vm.sucursal.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-12\"><label>Tipo de suministro:</label><div type=text style=\"word-wrap: white\" class=\"form-control text-uppercase\" ng-readonly=true>{{vm.tipoCompleto}}</div></div></div></div><div class=\"col-lg-12 form-group\"><label>Detalle de suministros asignados</label></div><form><div class=col-lg-12 ng-if=\"vm.detallesInventariables.length>0\"><div uib-alert type=info>Cantidad de suministros asignados: {{vm.detallesInventariables.length>0? vm.detallesInventariables.length : \"0\" }}</div></div><div class=col-lg-12 ng-if=\"vm.detallesInventariables.length>0\"><table ng-table=vm.tableParamsInventariable class=table show-filter=true ng-show=\"vm.detallesInventariables.length>0\"><tr ng-repeat=\"detalle in vm.detallesInventariables track by $index\"><div><td title=\"\'Marca\'\" data-sortable=\"\'detalles.suministro.marca\'\" align=center>{{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'N° serie\'\" data-sortable=\"\'suministroInventariable.serie\'\" align=center>{{detalle.suministroInventariable.serie ? detalle.suministroInventariable.serie : \"-\" }}</td><td title=\"\'N° inventario\'\" data-sortable=\"\'suministroInventariable.inventario\'\" align=center>{{detalle.suministroInventariable.inventario ? detalle.suministroInventariable.inventario : \"-\" }}</td><td style=width:35% title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !detalle.suministro.ubicacion.numeroOrden, \'has-success\':detalle.suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(detalle) style=\"word-wrap: white\">{{detalle.suministro.ubicacion? vm.ubicacionNaveNumeroOrden(detalle) : \"No asignó ninguna.\" }}</div></div></td></div></tr></table></div><div class=col-lg-12 ng-if=\"vm.detallesNoInventariables.length>0\"><div uib-alert type=info>Cantidad de suministros asignados: {{vm.cantidadNoInventariable }}</div></div><div class=col-lg-12 ng-if=\"vm.detallesNoInventariables.length>0\"><table ng-table=vm.tableParamsNoInventariable class=table show-filter=true ng-show=\"vm.detallesNoInventariables.length>0\"><tr ng-repeat=\"detalles in $data track by $index\" ng-if=\"vm.tipoSuministro.inventariable!==true\"><div><td data-title=\"\'Marca\'\" align=center data-sortable=\"\'marca\'\">{{detalles.suministro.marca ? detalles.suministro.marca.toUpperCase() : \"-\" }}</td><td data-title=\"\'Fecha vencimiento\'\" align=center data-sortable=\"\'fechaVencimiento\'\">{{detalles.suministro.fechaVencimiento? detalles.suministro.fechaVencimiento : \"-\" | date : \"dd/MM/yyyy\" }}</td><td data-title=\"\'Precio\'\" align=center>${{detalles.suministro.precioUnitario ? detalles.suministro.precioUnitario : \"-\"}}</td><td data-title=\"\'Cantidad asignada\'\" align=center>{{detalles.cantidad ? detalles.cantidad : \"-\"}}</td><td style=width:30% data-title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !detalles.suministro.ubicacion.numeroOrden, \'has-success\':detalles.suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(detalles) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(detalles)}}</div></div></td></div></tr></table></div></form></div></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cerrar</button></center></div></div></div></form></div>");
$templateCache.put("app/components/modales/visualizar-transferencia/modal.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Información de la transferencia</div><div class=panel-body><div class=col-lg-12 ng-if=vm.comprobarIngresoCerrado()><div class=\"panel panel-default\"><div class=panel-body><div class=\"form-group col-lg-12\"><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.transferencia.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.transferencia.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Tipo de transferencia:</label><input type=text ng-model=vm.tipoTransferencia class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Número de transferencia:</label><input class=form-control ng-readonly=true ng-model=vm.transferencia.numeroTransferencia type=text name=numeroTransferencia></div><div class=\"form-group col-lg-6\"><label>Fecha:</label><input class=form-control ng-readonly=true ng-model=vm.fecha type=text name=fecha></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=form-control ng-readonly=true ng-model=vm.transferencia.observacion type=text name=observacion style=resize:vertical></textarea></div></div></div><br><div class=\"col-lg-12 form-group\" ng-if=vm.comprobarIngresoCerrado();><label>Detalle de suministros transferidos</label></div><form ng-show=true ng-if=vm.comprobarIngresoCerrado();><div class=col-lg-12 ng-show=\"vm.transferencia.detalles.length>0\"><table ng-table=vm.tableParamsStock class=table show-filter=true ng-show=\"vm.transferencia.detalles.length>0\"><tr ng-repeat=\"detalles in $data track by $index\"><div><td title=\"\'Tipo Suministro\'\" data-sortable=\"\'suministro.tipoSuministro.nombre\'\" align=center>{{detalles.suministroInventariable? detalles.suministroInventariable.suministro.tipoSuministro.nombre.toUpperCase() : detalles.suministro.tipoSuministro.nombre.toUpperCase();}} ({{detalles.suministroInventariable? detalles.suministroInventariable.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase(): detalles.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase()}})</td><td title=\"\'Marca\'\" align=center>{{detalles.suministroInventariable ? detalles.suministroInventariable.suministro.marca ? detalles.suministroInventariable.suministro.marca.toUpperCase() : \"-\": detalles.suministro.marca ? detalles.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'N° Inventario\'\" align=center>{{detalles.suministroInventariable? detalles.suministroInventariable.inventario : \'-\'}}</td><td title=\"\'N° Serie\'\" align=center>{{detalles.suministroInventariable? detalles.suministroInventariable.serie : \'-\'}}</td><td ng-if=\"vm.rol.id<=3\" title=\"\'Precio\'\" align=center>${{detalles.suministroInventariable? detalles.suministroInventariable.suministro.precioUnitario.toFixed(2) : vm.obtenerPrecioTotal(detalles.suministro);}}</td><td title=\"\'Cantidad\'\" align=center>{{detalles.suministro?detalles.suministro.cantidad:\"-\"}}</td><td ng-if=\"vm.rol.id<=3\" title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(detalles) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(detalles)}}</div></div></td><td ng-if=\"vm.rol.id<=3\" data-title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-warning\" ng-click=vm.editarSuministro(detalles)><i class=\"fa fa-pencil\"></i></a></div></td></div></tr></table></div></form></div><div ng-if=!vm.comprobarIngresoCerrado() class=col-lg-12><span uib-alert class=danger>La transferencia no puede visualizarse</span></div></div><div class=panel-footer><div class=form-group><center><button class=\"btn btn-danger\" ng-click=vm.cerrar()><span class=\"glyphicon glyphicon-remove\"></span> Cerrar</button></center></div></div></div></form></div>");
$templateCache.put("app/config/formly/plantillas/error.html","<formly-transclude></formly-transclude><div ng-messages=fc.$error ng-if=\"form.$submitted || options.formControl.$touched\" class=error-messages><div ng-message=\"{{ ::name }}\" ng-repeat=\"(name, message) in ::options.validation.messages\" class=message>{{ message(fc.$viewValue, fc.$modelValue, this)}}</div></div>");
$templateCache.put("app/config/formly/plantillas/typeahead.html","<input type=text ng-model=model[options.key] uib-typeahead=\"item as item[to.propiedad] for item in to.options | filter:$viewValue | limitTo:8 \" typeahead-editable=false class=form-control>");
$templateCache.put("app/app/main/cliente/editar/editar.html","<div><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><formly-form model=vm.objeto fields=vm.campos form=vm.form></formly-form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-primary btn-block\" ng-click=vm.guardar() ng-disabled=vm.form.$invalid><span class=\"glyphicon glyphicon-ok\"></span> Aceptar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cerrar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.guardar()><span class=\"glyphicon glyphicon-remove\"></span> Abrir</button></div></div></div></div></div>");
$templateCache.put("app/app/main/cliente/lista/lista.html","<div class=row><div class=col-lg-12><div class=\"panel panel-default\"><div class=\"panel-footer clearfix\"><div class=\"col-sm-offset-4 col-sm-4\"><button type=button class=\"btn btn-primary btn-bprodk\" ng-click=vm.nuevoObjeto()><span class=\"glyphicon glyphicon-plus\"></span> Nuevo Cliente</button></div><div class=pull-right><button type=button class=\"btn btn-info\" ng-click=\"vm.verFiltro = !vm.verFiltro\"><span class=\"fa fa-filter\"></span></button></div></div></div><table ng-table=vm.tableParams class=\"table table-bordered\" show-filter=vm.verFiltro><tr ng-repeat=\"obj in $data\"><td data-title=\"\'Nombre\'\" filter=\"{nombre: \'text\'}\" sortable>{{obj.nombre}}</td><td data-title=\"\'Apellido\'\" filter=\"{apellido: \'text\'}\" sortable>{{obj.apellido}}</td><td data-title=\"\'Tel\'\">{{obj.nroTelefono}}</td><td data-title=\"\'Acciones\'\" align=center><span class=btn-group><button class=\"btn btn-success\" type=button ng-click=vm.editarObjeto(obj)><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-danger\" type=button ng-click=vm.confirmarEliminacion(obj)><span class=\"glyphicon glyphicon-trash\"></span></button></span></td></tr></table></div></div>");
$templateCache.put("app/app/main/pedidos/atender-pedido/atender-pedido.html","<div class=col-lg-12><div class=form-group><center><button ng-click=vm.guardar() class=\"btn btn-success\" ng-disabled=vm.form.$invalid style=width:30%><i class=\"fa fa-check\"></i> Guardar</button> <button ng-click=vm.volver() class=\"btn btn-warning\" style=width:30%><i class=\"fa fa-arrow-left\"></i> Volver</button></center></div><form name=vm.form><div class=col-lg-12><div class=\"form-group col-lg-6\"><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.egreso.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.egreso.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-8\"><label>Sucursal:</label><input type=text ng-readonly=true ng-model=vm.egreso.sucursal.nombre class=\"form-control text-uppercase\" name=sucursal></div><div class=\"form-group col-lg-4\"><label>Sector:</label><input type=text ng-readonly=true ng-model=vm.egreso.sector class=\"form-control text-uppercase\" name=sector></div><div class=\"form-group col-lg-6\"><label>Solicitó:</label><input type=text ng-model=vm.solicitante class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Autoriza:</label><input class=form-control ng-maxlength=100 focus-on=solicitante ng-model=vm.egreso.solicitante placeholder=\"Ingrese quién autoriza el egreso\" type=text name=solicitante> <span uib-alert class=danger ng-if=\"vm.form.solicitante.$error.maxlength && vm.form.solicitante.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><div class=\"form-group col-lg-3\"><label>Fecha:</label><input class=form-control ng-readonly=true ng-model=vm.fecha type=text name=fecha></div><div class=\"form-group col-lg-3\"><label>Número pedido</label><div class=input-group><input type=text ng-readonly=true ng-model=vm.numeroPedido class=\"form-control text-uppercase\" name=sucursal><div class=input-group-btn><button class=\"btn btn-default\" ng-click=vm.visualizarPedido()><i class=\"fa fa-search\"></i></button></div></div></div><div class=\"form-group col-lg-3\"><label>Número de Vale</label><input type=text class=form-control ng-maxlength=100 ng-model=vm.egreso.numeroVale placeholder=\"Ingrese el número de Vale\" name=numeroVale> <span uib-alert class=danger ng-if=\"vm.form.numeroVale.$error.maxlength && vm.form.numeroVale.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><div class=\"form-group col-lg-3\"><label>Número de seguimiento por mail</label><input type=text class=form-control ng-maxlength=100 ng-model=vm.egreso.numeroMail placeholder=\"Ingrese el número de seguimiento por mail\" name=numeroMail> <span uib-alert class=danger ng-if=\"vm.form.numeroMail.$error.maxlength && vm.form.numeroMail.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=form-control ng-maxlength=500 ng-model=vm.egreso.observacion placeholder=\"Ingrese una observación\" type=text name=observacion style=resize:vertical></textarea><span uib-alert class=danger ng-if=\"vm.form.observacion.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.observacion.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 500 caracteres.</span></div><br><br><div class=\"form-group col-lg-12\"><center><button ng-click=vm.abrirModalAgregarSuministroPedido() class=\"btn btn-warning\" style=width:25%><i class=\"fa fa-list-alt\"></i> Agregar suministros por pedido</button> <button ng-if=false ng-click=vm.abrirModal() class=\"btn btn-primary\" style=width:25%><i class=\"fa fa-plus\"></i> Agregar suministros..</button></center></div><div class=col-lg-12 ng-show=\"vm.detalles.length==0\"><span uib-alert class=danger>No ha agregado ningún suministro.</span></div><div class=\"col-lg-12 form-group\" ng-show=\"vm.detalles.length>0\"><label>Total: ${{ vm.montoTotal() }}</label></div><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesNoInventariablesAgrupados.length>0\"><label>Detalle de suministros no inventariables</label></div><div class=col-lg-12 ng-show=\"vm.detallesNoInventariablesAgrupados.length>0\"><table ng-table=vm.tableParamsNoInventariableAgrupado class=\"table table-hover\" ng-init=\"agrupado.$hideRows = true\" show-group=false><tr class=ng-table-group ng-repeat-start=\"agrupado in $data\"><td colspan=6><a href=\"\" ng-click=\"agrupado.$hideRows = !agrupado.$hideRows\"><span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': agrupado.$hideRows, \'glyphicon-chevron-down\': !agrupado.$hideRows }\"></span> Tipo de suministro: {{ agrupado.tipoSuministro.nombre.toUpperCase() }}</a></td><td title=\"Precio total\">Precio total por tipo de suministro: <b>${{agrupado.precioTotal}}</b></td><td title=\"Cantidad solicitada\">Cantidad solicitada total: {{agrupado.cantidad}}</td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-danger\" ng-click=vm.quitarTipo(agrupado)><i class=\"fa fa-remove\"></i></a></div></td></tr><tr ng-hide=agrupado.$hideRows ng-repeat=\"detalle in agrupado.detalles\" ng-repeat-end><td title=\"\'Marca\'\" align=center>{{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'Cantidad actual\'\" align=center>{{detalle.suministro.cantidad}}</td><td title=\"\'Cantidad solicitada\'\" align=center>{{detalle.cantidad}}</td><td style=width:35% title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !detalle.suministro.ubicacion.numeroOrden, \'has-success\':detalle.suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(detalle) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(detalle)}}</div></div></td></tr></table></div></div></form></div>");
$templateCache.put("app/app/main/pedidos/editar/editar.html","<div class=col-lg-12><div class=form-group><center><button ng-click=vm.guardar() ng-disabled=\"!vm.habilitarBoton() || vm.form.$invalid\" class=\"btn btn-success btn-sm\" style=width:30%><i class=\"fa fa-check\"></i> Guardar</button> <button ng-click=vm.cancelar() class=\"btn btn-warning btn-sm\" style=width:30%><i class=\"fa fa-arrow-left\"></i> Cancelar</button></center></div><div class=col-lg-12><div class=panel-default><div class=\"form-group col-lg-3\"><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.pedido.deposito.nombre class=\"form-control text-uppercase input-sm\"></div><div class=\"form-group col-lg-3\"><label>Empresa:</label><input type=text ng-model=vm.pedido.empresa.nombre class=\"form-control input-sm text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-4\"><label>Solicita:</label><input type=text ng-model=vm.solicitante class=\"form-control text-uppercase input-sm\" ng-readonly=true></div><div class=\"form-group col-lg-2\"><label>Fecha:</label><input class=\"form-control input-sm\" ng-readonly=true ng-model=vm.fecha type=text name=fecha></div></div><br><form name=vm.form><div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=\"form-group col-lg-4\"><label>Sucursal:</label><input type=text ng-disabled=\"!vm.pedido.empresa.nombre || vm.bandera || vm.tieneSucursal\" ng-model=vm.pedido.sucursal placeholder=\"Seleccione la sucursal\" uib-typeahead=\"sucursal as sucursal.nombre.toUpperCase()+\' - (\'+sucursal.codigoSucursal+\')\' for sucursal in vm.sucursales | filter:{nombre:$viewValue}\" class=\"form-control input-sm\" typeahead-show-hint=true typeahead-min-length=0 required name=sucursal typeahead-editable=false focus-on=sucursal> <span uib-alert class=danger ng-show=\"vm.form.sucursal.$error.required && vm.form.sucursal.$dirty\">Este campo es requerido.</span></div><div class=\"form-group col-lg-3\"><label>Sector:</label><input type=text ng-model=vm.pedido.sector class=\"form-control input-sm\" ng-maxlength=100 placeholder=\"Ingrese el sector\" name=sector></div><span uib-alert class=danger ng-if=\"vm.form.sector.$error.maxlength && vm.form.sector.$dirty\">Sector no puede superar los 100 caracteres.</span><div class=\"form-group col-lg-3\"><label>Autoriza:</label><input type=text ng-model=vm.pedido.autoriza class=\"form-control input-sm\" ng-maxlength=100 placeholder=\"Ingrese quién autoriza\" name=sector></div><span uib-alert class=danger ng-if=\"vm.form.sector.$error.maxlength && vm.form.sector.$dirty\">Este campo no puede superar los 100 caracteres.</span><br><div class=col-lg-2 ng-if=!vm.bandera><button style=width:100% ng-disabled=\"!vm.pedido.deposito.id || !vm.pedido.empresa.id || !vm.pedido.sucursal.id \" ng-click=vm.seleccionar() class=\"btn btn-primary btn-sm\"><i class=\"fa fa-check\"></i> Seleccionar</button></div><div class=col-lg-2 ng-if=vm.bandera><button style=width:100% ng-disabled=vm.tieneSucursal ng-click=vm.cambiarSeleccion() class=\"btn btn-warning btn-sm\"><i class=\"fa fa-exchange\"></i> Cambiar</button></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=\"form-control input-sm\" placeholder=\"Ingrese una observación o comentario\" ng-model=vm.pedido.observacion type=text ng-maxlength=500 name=observacion style=resize:vertical></textarea><span uib-alert class=danger ng-if=\"vm.form.observacion.$error.maxlength && vm.form.observacion.$dirty\">Esta campo no puede superar los 500 caracteres</span></div></div></div></div><div class=col-lg-12><center><button class=\"btn btn-xs btn-primary\" ng-disabled=\"!vm.habilitarBoton() || vm.form.$invalid\" style=width:20% ng-click=vm.visualizarSeleccionados();><i class=\"fa fa-list\"></i> Ver seleccionados</button> &nbsp;|&nbsp; <button class=\"btn btn-xs btn-success\" style=width:20% ng-disabled=\"!vm.habilitarBoton() || vm.form.$invalid\" ng-click=vm.verPedidosAnteriores();><i class=\"fa fa-refresh\"></i> Repetir pedidos anteriores</button></center></div><div ng-if=\"vm.productos.length>0 && vm.bandera\"><div style=\"height:500px; overflow-y:scroll; width:100%\"><table ng-table=vm.tableParams class=table show-filter=true><tr ng-repeat=\"detalle in $data\" ng-if=\"detalle.tipoSuministro.inventariable!==true\" ng-class=\"{\'azul-claro\': detalle.seleccionado, \'rojo-claro\': detalle.cantidadTope==0 || (detalle.consumido!=null && detalle.cantidadTope!=null && detalle.consumido>=0 && detalle.cantidadTope>=0 && detalle.consumido>=detalle.cantidadTope) || detalle.stockActual<=0}\"><div><td title=\"\'Familia\'\" data-sortable=\"\'tipoSuministro.familiaSuministro.nombre\'\" align=center>{{detalle.tipoSuministro.familiaSuministro.nombre.toUpperCase();}}</td><td title=\"\'Tipo Suministro\'\" style=width:40% filter=\"{\'tipoSuministro.nombre\': \'text\'}\" data-sortable=\"\'tipoSuministro.nombre\'\" align=center>{{detalle.tipoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Código\'\" filter=\"{\'codigoProducto\': \'text\'}\" data-sortable=\"\'codigoProducto\'\" align=center>{{detalle.codigoProducto.toUpperCase();}}</td><td title=\"\'Tope\'\" data-sortable=\"\'cantidadTope\'\" align=center>{{detalle.cantidadTope!=null ? detalle.cantidadTope : \"-\"}} <span class=badge style=\"background-color: red\" ng-if=\"detalle.cantidadTope==0\">No habilitado</span></td><td title=\"\'Consumido\'\" align=center>{{detalle.consumido}} <span class=badge style=\"background-color: red\" ng-if=\"(detalle.consumido!=null && detalle.cantidadTope!=null && detalle.consumido>=0 && detalle.cantidadTope>=0 && detalle.consumido>=detalle.cantidadTope)\">Tope superado</span></td><td title=\"\'Stock\'\" align=center><i style=color:red class=\"fa fa-remove\" ng-if=\"detalle.stockActual<=0\"></i> <i style=color:green class=\"fa fa-check\" ng-if=\"detalle.stockActual>0\"></i></td><td title=\"\'Seleccionar\'\" align=center><input type=checkbox ng-model=detalle.seleccionado ng-disabled=\"detalle.cantidadTope==0 || (detalle.consumido!=null && detalle.cantidadTope!=null && detalle.consumido>=0 && detalle.cantidadTope>=0 && detalle.consumido>=detalle.cantidadTope) || detalle.stockActual<=0\"></td><td style=width:12% data-title=\"\'Cantidad solicitada\'\"><ng-form name=camposForm><div><input class=form-control ng-pattern=/^[1-9][0-9]*$/ type=number name=cantidades ng-model=detalle.cantidadSolicitada placeholder=\"Ingrese cantidad\" ng-disabled=!detalle.seleccionado> <span uib-alert class=danger ng-if=\"detalle.cantidadSolicitada && (detalle.cantidadTope && detalle.cantidadSolicitada>(detalle.cantidadTope-detalle.consumido))\">La cantidad solicitada supera el máximo disponible. </span><span uib-alert class=danger ng-if=\"(camposForm.cantidades.$error.number || camposForm.cantidades.$error.pattern) && camposForm.cantidades.$dirty\">Ingrese un valor válido.</span></div></ng-form></td></div></tr></table></div></div></form></div></div>");
$templateCache.put("app/app/main/pedidos/lista/lista.html","<div><form><div class=\"form-group col-lg-12\"><div class=form-group ng-if=\"vm.rol.id==30\"><center><button ng-click=vm.crearNuevo() ng-disabled=\"vm.pedidosSinConfirmar && !vm.pedidosSinConfirmar.comprobar\" class=\"btn btn-success\" style=width:50% title=\"No puede realizar un nuevo pedido mientras haya pedidos que no estén cerrados\"><i class=\"fa fa-plus\"></i> NUEVO PEDIDO</button></center><center><br><div class=col-lg-12 uib-alert ng-if=\"vm.pedidosSinConfirmar && !vm.pedidosSinConfirmar.comprobar\"><i class=\"fa fa-info\"></i> No puede realizar un nuevo pedido mientras haya pedidos que no estén cerrados</div><div class=col-lg-12 uib-alert ng-if=\"vm.pedidos.length==0\"><i class=\"fa fa-info\"></i> No hay pedidos para mostrar</div></center></div></div><div class=col-lg-12><table ng-table=vm.tableParams class=\"table table-condensed\" show-filter=true ng-show=\"vm.pedidos.length>0\"><tr ng-repeat=\"pedidos in $data\" ng-class=\"{\'verde-claro\': pedidos.estado.id==4, \'amarillo-claro\':pedidos.estado.id==1, \'rojo-claro\': pedidos.estado.id==2 || pedidos.estado.id==3, \'azul-claro\': pedidos.estado.id==5}\"><div><td data-title=\"\'Fecha\'\" align=center data-sortable=\"\'fecha\'\">{{pedidos.fecha | date : \"dd/MM/yyyy HH:mm\" }}</td><td data-title=\"\'Depósito\'\" data-sortable=\"\'deposito.nombre\'\" filter=\"{\'deposito.nombre\': \'text\'}\" align=center>{{pedidos.deposito.nombre.toUpperCase();}}</td><td data-title=\"\'Empresa\'\" data-sortable=\"\'empresa.nombre\'\" filter=\"{\'empresa.nombre\': \'text\'}\" align=center>{{pedidos.empresa.nombre.toUpperCase();}}</td><td data-title=\"\'Sucursal\'\" filter=\"{\'sucursal.nombre\': \'text\'}\" data-sortable=\"\'sucursal.nombre\'\" align=center>{{pedidos.sucursal.nombre.toUpperCase();}}</td><td data-title=\"\'N° Pedido\'\" style=width:10% align=center filter=\"{\'numeroPedido\':\'text\'}\" data-sortable=\"\'numeroPedido\'\">{{pedidos.numeroPedido}}</td><td data-title=\"\'Estado\'\" style=width:10% data-sortable=\"\'estado.nombre\'\" filter=\"{\'estado.nombre\': \'text\'}\" align=center data-sortable=\"\'estado\'\">{{pedidos.estado.nombre.toUpperCase();}} {{ (pedidos.estadoMovimiento==\'EN PREPARACIÓN\' || pedidos.estadoMovimiento==\'PREPARADA\' || pedidos.estado.id==6)? \" - \"+pedidos.estadoMovimiento : \"\" }}</td><td data-title=\"\'Acciones\'\" align=center style=width:18%><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.visualizarPedido(pedidos)><i class=\"fa fa-search\"></i> </a><a class=\"btn btn-success\" ng-if=\"vm.rol.id<=3\" ng-disabled=\"pedidos.estado.id!=1\" ng-click=\"pedidos.estado.id!=1 || vm.atenderPedido(pedidos)\"><i class=\"fa fa-check-circle-o\"></i> </a><a class=\"btn btn-warning\" ng-if=\"vm.rol.id<=3\" ng-disabled=\"pedidos.estado.id!=1\" ng-click=\"pedidos.estado.id!=1 || vm.rechazar(pedidos)\"><i class=\"fa fa-minus-circle\"></i> </a><a ng-if=\"vm.rol.id==30\" ng-disabled=\"pedidos.estado.id!=1\" class=\"btn btn-danger\" ng-click=\"pedidos.estado.id!=1 || vm.anular(pedidos)\"><i class=\"fa fa-minus-circle\"></i> </a><a ng-if=\"vm.rol.id==30\" ng-disabled=\"pedidos.estado.id!=5\" class=\"btn btn-warning\" ng-click=\"pedidos.estado.id!=5 || vm.confirmarReclamar(pedidos)\"><i class=\"fa fa-check\"></i></a></div></td></div></tr></table></div></form></div>");
$templateCache.put("app/app/main/usuarios/renovar-password/renovar-password.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=\"form-group col-lg-12\"><label>Password actual:</label><input class=form-control ng-maxlength=26 ng-minlength=6 ng-model=vm.renovar.passwordActual placeholder=Password type=password name=passwordActual required> <span uib-alert class=danger ng-if=\"vm.form.passwordActual.$error.maxlength && vm.form.passwordActual.$dirty\">Este campo no puede superar los 26 caracteres. </span><span uib-alert class=danger ng-if=\"vm.form.passwordActual.$error.required && vm.form.passwordActual.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.passwordActual.$error.minlength && vm.form.passwordActual.$dirty\">Este campo debe tener al menos 6 caracteres.</span></div><div class=\"form-group col-lg-12\"><label>Nueva Password:</label><input class=form-control ng-maxlength=26 ng-minlength=1 ng-model=vm.renovar.nuevaPassword placeholder=Password type=password name=nuevaPassword required> <span uib-alert class=danger ng-if=\"!vm.validarPassword().validation && vm.form.nuevaPassword.$dirty\">{{vm.validarPassword().mensaje}} </span><span uib-alert type=success ng-if=\"vm.validarPassword().validation && vm.form.nuevaPassword.$dirty\">{{vm.validarPassword().mensaje}}</span></div><div class=\"form-group col-lg-12\"><label>Repita Nueva Password:</label><input class=form-control ng-model=vm.renovar.repiteNuevaPassword placeholder=\"Repita Password\" type=password name=repiteNuevaPassword required> <span uib-alert class=danger ng-if=\"vm.form.repiteNuevaPassword.$error.required && vm.form.repiteNuevaPassword.$dirty\">Este campo es requerido.</span></div><span class=col-xs-12 uib-alert class=danger ng-if=\"vm.renovar.nuevaPassword !== vm.renovar.repiteNuevaPassword && vm.form.repiteNuevaPassword.$dirty\">Las contraseñas deben ser iguales.</span></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.guardar() ng-disabled=\"vm.form.$invalid || vm.renovar.nuevaPassword !== vm.renovar.repiteNuevaPassword || !vm.validarPassword().validation\"><span class=\"glyphicon glyphicon-ok\"></span> Renovar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/reportes/lista/lista.html","<div><form><div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading>Seleccione el reporte</div><div class=panel-body><div class=row><div class=\"col-lg-4 col-md-6\" ng-click=vm.irAReporteExistencias();><div class=\"panel panel-primary\"><div class=panel-heading><div class=row><div class=col-xs-2><h1>1</h1></div><div class=\"col-xs-10 text-right\"><div>Reporte de existencias por grupo de suministros en un depósito</div></div></div></div></div></div><div class=\"col-lg-4 col-md-6\" ng-click=vm.irAReporteSuministroDeposito();><div class=\"panel panel-info\"><div class=panel-heading><div class=row><div class=col-xs-2><h1>2</h1></div><div class=\"col-xs-10 text-right\"><div>Reporte existencias por familia y tipo de suministro en un depósito</div></div></div></div></div></div><div class=\"col-lg-4 col-md-6\" ng-click=vm.irAReporteStockMinimo();><div class=\"panel panel-danger\"><div class=panel-heading><div class=row><div class=col-xs-2><h1>3</h1></div><div class=\"col-xs-10 text-right\"><div>Reporte stock de suministros contra stock mínimo</div></div></div></div></div></div><div class=\"col-lg-4 col-md-6\" ng-click=vm.irAReporteOcupacionUbicaciones();><div class=\"panel panel-success\"><div class=panel-heading><div class=row><div class=col-xs-2><h1>4</h1></div><div class=\"col-xs-10 text-right\"><div>Reporte ocupación de ubicaciones por grupo y familias de suministro</div></div></div></div></div></div><div class=\"col-lg-4 col-md-6\" ng-click=vm.irAReporteTopeSucursal();><div class=\"panel panel-warning\"><div class=panel-heading><div class=row><div class=col-xs-2><h1>5</h1></div><div class=\"col-xs-10 text-right\"><div>Reporte tope de suministros por sucursal y familia de suministro</div></div></div></div></div></div><div class=\"col-lg-4 col-md-6\" ng-click=vm.irAReporteIngresosOrdenRemito();><div class=\"panel panel-default\"><div class=panel-heading><div class=row><div class=col-xs-2><h1>6</h1></div><div class=\"col-xs-10 text-right\"><div>Reporte de ingresos por orden de compra o remito</div></div></div></div></div></div><div class=\"col-lg-4 col-md-6\" ng-click=vm.irAReporteEmpresaActivos();><div class=panel style=\"border:solid 1px lightgray\"><div class=panel-heading><div class=row><div class=col-xs-2><h1>7</h1></div><div class=\"col-xs-10 text-right\"><div>Reporte activos de una empresa</div></div></div></div></div></div><div class=\"col-lg-4 col-md-6\" ng-click=vm.irAReportePesoYBultos();><div class=\"panel panel-primary\"><div class=panel-heading><div class=row><div class=col-xs-2><h1>8</h1></div><div class=\"col-xs-10 text-right\"><div>Reporte cantidad bultos y peso por sucursal</div></div></div></div></div></div><div class=\"col-lg-4 col-md-6\" ng-click=vm.irAReporteAnualSemestral();><div class=\"panel panel-info\"><div class=panel-heading><div class=row><div class=col-xs-2><h1>9</h1></div><div class=\"col-xs-10 text-right\"><div>Reporte anual o semestral de familia de suministro</div></div></div></div></div></div><div class=\"col-lg-4 col-md-6\" ng-click=vm.irAReporteEntregasEntreFechas();><div class=\"panel panel-danger\"><div class=panel-heading><div class=row><div class=col-xs-2><h1>10</h1></div><div class=\"col-xs-10 text-right\"><div>Reporte de entregas entre fechas</div></div></div></div></div></div><div class=\"col-lg-4 col-md-6\" ng-click=vm.irAReporteIngresosEntreFechas();><div class=\"panel panel-success\"><div class=panel-heading><div class=row><div class=col-xs-2><h1>11</h1></div><div class=\"col-xs-10 text-right\"><div>Reporte de ingresos entre fechas</div></div></div></div></div></div><div class=\"col-lg-4 col-md-6\" ng-click=vm.irAReporteAgotamiento();><div class=\"panel panel-warning\"><div class=panel-heading><div class=row><div class=col-xs-2><h1>12</h1></div><div class=\"col-xs-10 text-right\"><div>Reporte de agotamiento de suministros</div></div></div></div></div></div><div class=\"col-lg-4 col-md-6\" ng-click=vm.irAReporteProblemasIngresos();><div class=\"panel panel-default\"><div class=panel-heading><div class=row><div class=col-xs-2><h1>13</h1></div><div class=\"col-xs-10 text-right\"><div>Reporte de problemas en ingresos por proveedor</div></div></div></div></div></div><div class=\"col-lg-4 col-md-6\" ng-click=vm.irAReporteTiemposDeSalidas();><div class=panel style=\"border:solid 1px lightgray\"><div class=panel-heading><div class=row><div class=col-xs-2><h1>14</h1></div><div class=\"col-xs-10 text-right\"><div>Reporte tiempo de despacho de salidas</div></div></div></div></div></div><div class=\"col-lg-4 col-md-6\" ng-click=vm.irAReporteExistenciasDonacionScrap();><div class=\"panel panel-primary\"><div class=panel-heading><div class=row><div class=col-xs-2><h1>15</h1></div><div class=\"col-xs-10 text-right\"><div>Reporte existencias de suministros para donación o scrap en un depósito</div></div></div></div></div></div><div class=\"col-lg-4 col-md-6\" ng-click=vm.irAReporteConfirmacionSucursales();><div class=\"panel panel-info\"><div class=panel-heading><div class=row><div class=col-xs-2><h1>16</h1></div><div class=\"col-xs-10 text-right\"><div>Reporte confirmación de recepción de entregas por sucursales</div></div></div></div></div></div><div class=\"col-lg-4 col-md-6\" ng-click=vm.irAReporteConsumo();><div class=\"panel panel-danger\"><div class=panel-heading><div class=row><div class=col-xs-2><h1>17</h1></div><div class=\"col-xs-10 text-right\"><div>Reporte consumos e ingresos por familia de suministro en periodo de tiempo</div></div></div></div></div></div><div class=\"col-lg-4 col-md-6\" ng-click=vm.irAReporteConsumoTotales();><div class=\"panel panel-success\"><div class=panel-heading><div class=row><div class=col-xs-2><h1>18</h1></div><div class=\"col-xs-10 text-right\"><div>Reporte consumos totales por sucursales</div></div></div></div></div></div><div class=\"col-lg-4 col-md-6\" ng-click=vm.irAReporteBienesPorSucursal();><div class=\"panel panel-warning\"><div class=panel-heading><div class=row><div class=col-xs-2><h1>19</h1></div><div class=\"col-xs-10 text-right\"><div>Reporte bienes por sucursales</div></div></div></div></div></div><div class=\"col-lg-4 col-md-6\" ng-click=vm.irAReporteIngresosYSalidasEntreFechas();><div class=\"panel panel-default\"><div class=panel-heading><div class=row><div class=col-xs-2><h1>20</h1></div><div class=\"col-xs-10 text-right\"><div>Reporte ingresos y salidas por tipo suministro entre fechas</div></div></div></div></div></div><div class=\"col-lg-4 col-md-6\" ng-click=vm.irAReporteTiemposPreparacion();><div class=panel style=\"border:solid 1px lightgray\"><div class=panel-heading><div class=row><div class=col-xs-2><h1>21</h1></div><div class=\"col-xs-10 text-right\"><div>Reporte tiempos de preparación de salidas entre fechas</div></div></div></div></div></div></div></div></div></div></form></div>");
$templateCache.put("app/app/main/reportes/reporte-agotamiento/reporte-agotamiento.html","<div class=col-lg-12><div class=col-lg-12><div class=form-group><label>Empresa:</label><input ng-disabled=vm.bandera type=text ng-model=vm.empresa placeholder=\"Ingrese o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Grupo de suministro:</label><input type=text focus-on=grupo ng-model=vm.grupo placeholder=\"Ingrese o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase()+\' (\'+grupo.empresa.nombre.toUpperCase()+\')\' for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Familia de suministro:</label><input ng-disabled=!vm.grupo.nombre focus-on=familia type=text ng-model=vm.familiaSuministro placeholder=\"Ingrese o busque la familia de suministro\" uib-typeahead=\"familiaSuministro as familiaSuministro.nombre.toUpperCase() for familiaSuministro in vm.familias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div style=widht:60%><center><div class=btn-group uib-dropdown><button type=button class=\"btn btn-primary\" uib-dropdown-toggle ng-disabled=\"!vm.empresa.id || !vm.grupo.id || !vm.familiaSuministro.id\"><i class=\"fa fa-file-text\"></i> Ver reporte <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li style=width:100%><a class=\"btn btn btn-inverse\" ng-click=\"!vm.empresa.id || !vm.grupo.id || !vm.familiaSuministro.id || vm.mostrarReporte();\" ng-disabled=\"!vm.empresa.id || !vm.grupo.id || !vm.familiaSuministro.id\"><i class=\"fa fa-file-pdf-o\"></i> Exportar a PDF</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-click=\"!vm.empresa.id || !vm.grupo.id || !vm.familiaSuministro.id || vm.mostrarReporteExcel();\" ng-disabled=\"!vm.empresa.id || !vm.grupo.id || !vm.familiaSuministro.id\"><i class=\"fa fa-file-excel-o\"></i> Exportar a Excel</a></li></ul></div></center></div><button class=\"btn btn-info\" ng-click=vm.volver()><i class=\"fa fa-arrow-left\"></i> Volver</button></div>");
$templateCache.put("app/app/main/reportes/reporte-anual/reporte-anual.html","<div class=col-lg-12><div class=col-lg-12><div class=form-group><label>Empresa:</label><input ng-disabled=vm.bandera type=text ng-model=vm.empresa placeholder=\"Ingrese o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Grupo de suministro:</label><input type=text ng-disabled=!vm.empresa.id focus-on=grupo ng-model=vm.grupo placeholder=\"Ingrese o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase()+\' (\'+grupo.empresa.nombre.toUpperCase()+\')\' for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Familia de suministro:</label><input ng-disabled=!vm.grupo.nombre focus-on=familia type=text ng-model=vm.familiaSuministro placeholder=\"Ingrese o busque la familia de suministro\" uib-typeahead=\"familiaSuministro as familiaSuministro.nombre.toUpperCase() for familiaSuministro in vm.familias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div style=widht:60%><center><div class=btn-group uib-dropdown><button type=button class=\"btn btn-primary\" uib-dropdown-toggle ng-disabled=\"!vm.empresa.id || !vm.grupo.id || !vm.familiaSuministro.id\"><i class=\"fa fa-file-text\"></i> Reporte 12 meses <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li style=width:100%><a class=\"btn btn btn-inverse\" ng-click=\"!vm.empresa.id || !vm.grupo.id || !vm.familiaSuministro.id || vm.mostrarReporte12Meses();\" ng-disabled=\"!vm.empresa.id || !vm.grupo.id || !vm.familiaSuministro.id\"><i class=\"fa fa-file-pdf-o\"></i> Exportar a PDF</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-click=\"!vm.empresa.id || !vm.grupo.id || !vm.familiaSuministro.id || vm.mostrarReporte12MesesExcel();\" ng-disabled=\"!vm.empresa.id || !vm.grupo.id || !vm.familiaSuministro.id\"><i class=\"fa fa-file-excel-o\"></i> Exportar a Excel</a></li></ul></div><div class=btn-group uib-dropdown><button type=button class=\"btn btn-success\" uib-dropdown-toggle ng-disabled=\"!vm.empresa.id || !vm.grupo.id || !vm.familiaSuministro.id\"><i class=\"fa fa-file-text\"></i> Reporte 6 meses <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li><a class=\"btn btn btn-inverse\" style=width:100% ng-click=\"!vm.empresa.id || !vm.grupo.id || !vm.familiaSuministro.id || vm.mostrarReporte6Meses();\" ng-disabled=\"!vm.empresa.id || !vm.grupo.id || !vm.familiaSuministro.id\"><i class=\"fa fa-file-pdf-o\"></i> Exportar a PDF</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-disabled=\"!vm.empresa.id || !vm.grupo.id || !vm.familiaSuministro.id\" ng-click=\"!vm.empresa.id || !vm.grupo.id || !vm.familiaSuministro.id ||vm.mostrarReporte6MesesExcel();\"><i class=\"fa fa-file-excel-o\"></i> Exportar a Excel</a></li></ul></div></center></div><button class=\"btn btn-info\" ng-click=vm.volver()><i class=\"fa fa-arrow-left\"></i> Volver</button></div>");
$templateCache.put("app/app/main/reportes/reporte-bienes-sucursal/reporte-bienes-sucursal.html","<div class=col-lg-12><div class=col-lg-12><div class=form-group><label>Seleccione la empresa:</label><input ng-disabled=vm.bandera type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" focus-on=empresa class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div style=widht:60%><center><div class=btn-group uib-dropdown><button type=button class=\"btn btn-primary\" uib-dropdown-toggle ng-disabled=!vm.empresa.id><i class=\"fa fa-file-text\"></i> Ver reporte <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li style=width:100%><a class=\"btn btn btn-inverse\" ng-click=\"!vm.empresa.id || vm.mostrarReporteCompleto();\" ng-disabled=!vm.empresa.id><i class=\"fa fa-file-pdf-o\"></i> Exportar a PDF</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-click=\"!vm.empresa.id || vm.mostrarReporteCompletoExcel();\" ng-disabled=!vm.empresa.id><i class=\"fa fa-file-excel-o\"></i> Exportar a Excel</a></li></ul></div></center></div><button class=\"btn btn-info\" ng-click=vm.volver()><i class=\"fa fa-arrow-left\"></i> Volver</button></div>");
$templateCache.put("app/app/main/reportes/reporte-bultos-peso-empresa/reporte.html","<div class=col-lg-12><div class=col-lg-12><div class=\"form-group col-lg-6\"><label>Seleccione la empresa:</label><input type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" focus-on=empresa class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Seleccione el año:</label><input type=text ng-model=vm.ano placeholder=\"Seleccione el año\" focus-on=ano class=form-control uib-typeahead=\"ano as ano for ano in vm.anos\" typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div style=widht:60%><center><div class=btn-group uib-dropdown><button type=button class=\"btn btn-primary\" uib-dropdown-toggle ng-disabled=\"!vm.empresa.id || !vm.ano\"><i class=\"fa fa-file-text\"></i> Ver reporte <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li style=width:100%><a class=\"btn btn btn-inverse\" ng-click=\"!vm.empresa.id || !vm.ano || vm.armarReporte();\" ng-disabled=\"!vm.empresa.id || !vm.ano\"><i class=\"fa fa-file-pdf-o\"></i> Exportar a PDF</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-click=\"!vm.empresa.id || !vm.ano || vm.armarReporteExcel();\" ng-disabled=\"!vm.empresa.id || !vm.ano\"><i class=\"fa fa-file-excel-o\"></i> Exportar a Excel</a></li></ul></div></center></div><button class=\"btn btn-info\" ng-click=vm.volver()><i class=\"fa fa-arrow-left\"></i> Volver</button></div>");
$templateCache.put("app/app/main/reportes/reporte-confirmacion-sucursales/reporte.html","<div class=col-lg-12><div class=col-lg-12><div class=\"form-group col-lg-6\"><label>Seleccione la empresa:</label><input type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" focus-on=empresa class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Seleccione el año:</label><input type=text ng-model=vm.ano placeholder=\"Seleccione el año\" focus-on=ano class=form-control uib-typeahead=\"ano as ano for ano in vm.anos\" typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div style=widht:60%><center><div class=btn-group uib-dropdown><button type=button class=\"btn btn-primary\" uib-dropdown-toggle ng-disabled=\"!vm.empresa.id || !vm.ano\"><i class=\"fa fa-file-text\"></i> Ver reporte <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li style=width:100%><a class=\"btn btn btn-inverse\" ng-click=\"!vm.empresa.id || !vm.ano || vm.armarReporte();\" ng-disabled=\"!vm.empresa.id || !vm.ano\"><i class=\"fa fa-file-pdf-o\"></i> Exportar a PDF</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-click=\"!vm.empresa.id || !vm.ano || vm.armarReporteExcel();\" ng-disabled=\"!vm.empresa.id || !vm.ano\"><i class=\"fa fa-file-excel-o\"></i> Exportar a Excel</a></li></ul></div></center></div><button class=\"btn btn-info\" ng-click=vm.volver()><i class=\"fa fa-arrow-left\"></i> Volver</button></div>");
$templateCache.put("app/app/main/reportes/reporte-consumo/reporte-consumo.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading><label>Empresa y fechas</label></div><div class=panel-body><div class=col-lg-6><label>Seleccione la empresa:</label><div class=\"form-group col-lg-12\"><input type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div class=col-lg-6><div class=\"form-group col-lg-6\"><label>Fecha desde:</label><input type=date focus-on=fechaDesde id=fechaDesde name=fechaDesde class=form-control ng-model=vm.fechaDesde> <span uib-alert class=danger ng-if=\"vm.form.fechaDesde.$error.date && vm.form.fechaDesde.$dirty\">La fecha ingresada no es válida. </span><span uib-alert class=danger ng-if=\"vm.fechaDesde && vm.fechaDesde>vm.fechaActual && vm.form.fechaDesde.$dirty\">La fecha ingresada debe ser menor a la fecha actual.</span></div><div class=\"form-group col-lg-6\"><label>Fecha hasta:</label><input type=date id=fechaHasta name=fechaHasta class=form-control ng-model=vm.fechaHasta> <span uib-alert class=danger ng-if=\"vm.form.fechaHasta.$error.date && vm.form.fechaHasta.$dirty\">La fecha ingresada no es válida. </span><span uib-alert class=danger ng-if=\"vm.fechaHasta && vm.fechaHasta>vm.fechaActual && vm.form.fechaHasta.$dirty\">La fecha ingresada debe ser menor a la fecha actual.</span></div><div class=col-lg-12><span uib-alert ng-if=\"(vm.form.fechaDesde.$dirty || vm.form.fechaHasta.$dirty)  && (!vm.fechaHasta || !vm.fechaDesde)\">Debe completar ambas fechas </span><span uib-alert ng-if=\"!vm.form.fechaDesde.$error.date && !vm.form.fechaHasta.$error.date && vm.fechaDesde>vm.fechaHasta\">La fecha Desde, debe ser menor a la fecha Hasta. </span><span uib-alert ng-if=\"vm.fechaDesde && vm.fechaHasta && !vm.comprobarPeriodoFechas()\">El periodo seleccionado no puede superar un año y medio</span></div></div></div></div><div class=\"panel panel-default\" ng-if=vm.empresa.id><div class=\"panel panel-heading\"><label>Seleccione la familia de suministro:</label></div><div class=panel-body><div class=col-lg-12><div class=\"form-group col-lg-6\"><label>Grupo de suministro:</label><input type=text focus-on=grupo ng-model=vm.grupo placeholder=\"Seleccione o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase()+\' (\'+grupo.empresa.nombre.toUpperCase()+\')\' for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Familia de suministro:</label><input ng-disabled=!vm.grupo.nombre focus-on=familia type=text ng-model=vm.familiaSuministro placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familiaSuministro as familiaSuministro.nombre.toUpperCase() for familiaSuministro in vm.familias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div><div><center><div class=btn-group uib-dropdown><button type=button class=\"btn btn-primary\" uib-dropdown-toggle ng-disabled=\"!vm.validarFiltros() || !vm.familiaSuministro.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas()\"><i class=\"fa fa-file-text\"></i> Ver reporte <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li style=width:100%><a class=\"btn btn btn-inverse\" ng-click=\"!vm.validarFiltros() || !vm.familiaSuministro.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas() || vm.mostrarReporte();\" ng-disabled=\"!vm.validarFiltros() || !vm.familiaSuministro.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas()\"><i class=\"fa fa-file-pdf-o\"></i> Exportar a PDF</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-click=\"!vm.validarFiltros() || !vm.familiaSuministro.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas() || vm.mostrarReporteExcel();\" ng-disabled=\"!vm.validarFiltros() || !vm.familiaSuministro.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas()\"><i class=\"fa fa-file-excel-o\"></i> Exportar a Excel</a></li></ul></div></center></div></div></form></div></div></div><div class=col-lg-12><button class=\"btn btn-info\" ng-click=vm.volver()><i class=\"fa fa-arrow-left\"></i> Volver</button></div></div>");
$templateCache.put("app/app/main/reportes/reporte-empresa-activos/reporte-empresa-activos.html","<div class=col-lg-12><div class=col-lg-12><div class=form-group><label>Seleccione la empresa:</label><input type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" focus-on=empresa class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div style=widht:60%><center><div class=btn-group uib-dropdown><button type=button class=\"btn btn-primary\" uib-dropdown-toggle ng-disabled=!vm.empresa.id><i class=\"fa fa-file-text\"></i> Ver reporte de activos <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li style=width:100%><a class=\"btn btn btn-inverse\" ng-click=\"!vm.empresa.id || vm.armarReporte(true);\" ng-disabled=!vm.empresa.id><i class=\"fa fa-file-pdf-o\"></i> Exportar a PDF</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-click=\"!vm.empresa.id || vm.armarReporte(false);\" ng-disabled=!vm.empresa.id><i class=\"fa fa-file-excel-o\"></i> Exportar a Excel</a></li></ul></div></center></div><button class=\"btn btn-info\" ng-click=vm.volver()><i class=\"fa fa-arrow-left\"></i> Volver</button></div>");
$templateCache.put("app/app/main/reportes/reporte-consumos-totales/reporte-consumos-totales.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading><label>Empresa y fechas</label></div><div class=panel-body><div class=col-lg-6><label>Seleccione la empresa:</label><div class=\"form-group col-lg-12\"><input type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div class=col-lg-6><div class=\"form-group col-lg-6\"><label>Fecha desde:</label><input type=date focus-on=fechaDesde id=fechaDesde name=fechaDesde class=form-control ng-model=vm.fechaDesde> <span uib-alert class=danger ng-if=\"vm.form.fechaDesde.$error.date && vm.form.fechaDesde.$dirty\">La fecha ingresada no es válida. </span><span uib-alert class=danger ng-if=\"vm.fechaDesde && vm.fechaDesde>vm.fechaActual && vm.form.fechaDesde.$dirty\">La fecha ingresada debe ser menor a la fecha actual.</span></div><div class=\"form-group col-lg-6\"><label>Fecha hasta:</label><input type=date id=fechaHasta name=fechaHasta class=form-control ng-model=vm.fechaHasta> <span uib-alert class=danger ng-if=\"vm.form.fechaHasta.$error.date && vm.form.fechaHasta.$dirty\">La fecha ingresada no es válida. </span><span uib-alert class=danger ng-if=\"vm.fechaHasta && vm.fechaHasta>vm.fechaActual && vm.form.fechaHasta.$dirty\">La fecha ingresada debe ser menor a la fecha actual.</span></div><div class=col-lg-12><span uib-alert ng-if=\"(vm.form.fechaDesde.$dirty || vm.form.fechaHasta.$dirty)  && (!vm.fechaHasta || !vm.fechaDesde)\">Debe completar ambas fechas </span><span uib-alert ng-if=\"!vm.form.fechaDesde.$error.date && !vm.form.fechaHasta.$error.date && vm.fechaDesde>vm.fechaHasta\">La fecha Desde, debe ser menor a la fecha Hasta. </span><span uib-alert ng-if=\"vm.fechaDesde && vm.fechaHasta && !vm.comprobarPeriodoFechas()\">El periodo seleccionado no puede superar un año y medio</span></div></div></div></div><div class=\"panel panel-default\" ng-if=vm.empresa.id><div class=\"panel panel-heading\"><label>Seleccione la familia de suministro:</label></div><div class=panel-body><div class=col-lg-12><div class=\"form-group col-lg-6\"><label>Grupo de suministro:</label><input type=text focus-on=grupo ng-model=vm.grupo placeholder=\"Seleccione o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase()+\' (\'+grupo.empresa.nombre.toUpperCase()+\')\' for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Familia de suministro:</label><input ng-disabled=!vm.grupo.nombre focus-on=familia type=text ng-model=vm.familiaSuministro placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familiaSuministro as familiaSuministro.nombre.toUpperCase() for familiaSuministro in vm.familias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div><div><center><div class=btn-group uib-dropdown><button type=button class=\"btn btn-primary\" uib-dropdown-toggle ng-disabled=\"!vm.validarFiltros() || (!vm.empresa.id && !vm.grupo.id && !vm.familiaSuministro.id) || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas()\"><i class=\"fa fa-file-text\"></i> Ver reporte<span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li style=width:100%><a class=\"btn btn btn-inverse\" ng-click=\"!vm.validarFiltros() || (!vm.empresa.id && !vm.grupo.id && !vm.familiaSuministro.id) || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas() || vm.mostrarReporte();\" ng-disabled=\"!vm.validarFiltros() || (!vm.empresa.id && !vm.grupo.id && !vm.familiaSuministro.id) || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas()\"><i class=\"fa fa-file-pdf-o\"></i> Exportar a PDF</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-click=\"!vm.validarFiltros() || (!vm.empresa.id && !vm.grupo.id && !vm.familiaSuministro.id) || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas() || vm.mostrarReporteExcel();\" ng-disabled=\"!vm.validarFiltros() || (!vm.empresa.id && !vm.grupo.id && !vm.familiaSuministro.id) || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas()\"><i class=\"fa fa-file-excel-o\"></i> Exportar a Excel</a></li></ul></div></center></div></div></form></div></div></div><div class=col-lg-12><button class=\"btn btn-info\" ng-click=vm.volver()><i class=\"fa fa-arrow-left\"></i> Volver</button></div></div>");
$templateCache.put("app/app/main/reportes/reporte-entregas-entre-fechas/reporte-entregas-entre-fechas.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading><label>Empresa y fechas</label></div><div class=panel-body><div class=col-lg-6><label>Seleccione la empresa:</label><div class=\"form-group col-lg-12\"><input type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div class=col-lg-6><div class=\"form-group col-lg-6\"><label>Fecha desde:</label><input type=date focus-on=fechaDesde id=fechaDesde name=fechaDesde class=form-control ng-model=vm.fechaDesde> <span uib-alert class=danger ng-if=\"vm.form.fechaDesde.$error.date && vm.form.fechaDesde.$dirty\">La fecha ingresada no es válida. </span><span uib-alert class=danger ng-if=\"vm.fechaDesde && vm.fechaDesde>vm.fechaActual && vm.form.fechaDesde.$dirty\">La fecha ingresada debe ser menor a la fecha actual.</span></div><div class=\"form-group col-lg-6\"><label>Fecha hasta:</label><input type=date id=fechaHasta name=fechaHasta class=form-control ng-model=vm.fechaHasta> <span uib-alert class=danger ng-if=\"vm.form.fechaHasta.$error.date && vm.form.fechaHasta.$dirty\">La fecha ingresada no es válida. </span><span uib-alert class=danger ng-if=\"vm.fechaHasta && vm.fechaHasta>vm.fechaActual && vm.form.fechaHasta.$dirty\">La fecha ingresada debe ser menor a la fecha actual.</span></div><div class=col-lg-12><span uib-alert ng-if=\"(vm.form.fechaDesde.$dirty || vm.form.fechaHasta.$dirty)  && (!vm.fechaHasta || !vm.fechaDesde)\">Debe completar ambas fechas </span><span uib-alert ng-if=\"!vm.form.fechaDesde.$error.date && !vm.form.fechaHasta.$error.date && vm.fechaDesde>vm.fechaHasta\">La fecha Desde, debe ser menor a la fecha Hasta. </span><span uib-alert ng-if=\"vm.fechaDesde && vm.fechaHasta && !vm.comprobarPeriodoFechas()\">El periodo seleccionado no puede superar un año y medio</span></div></div></div></div><div class=\"panel panel-default\" ng-if=vm.empresa.id><div class=\"panel panel-heading\"><label>Seleccione la familia de suministro:</label></div><div class=panel-body><div class=col-lg-12><div class=\"form-group col-lg-6\"><label>Grupo de suministro:</label><input type=text focus-on=grupo ng-model=vm.grupo placeholder=\"Seleccione o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase()+\' (\'+grupo.empresa.nombre.toUpperCase()+\')\' for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Familia de suministro:</label><input ng-disabled=!vm.grupo.nombre focus-on=familia type=text ng-model=vm.familiaSuministro placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familiaSuministro as familiaSuministro.nombre.toUpperCase() for familiaSuministro in vm.familias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div><div><center><div class=btn-group uib-dropdown><button type=button class=\"btn btn-info\" uib-dropdown-toggle ng-disabled=\"!vm.validarFiltros() || !vm.familiaSuministro.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas()\"><i class=\"fa fa-file-text\"></i> Ver reporte por familia detallado <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li style=width:100%><a class=\"btn btn btn-inverse\" ng-click=\"!vm.validarFiltros() || !vm.familiaSuministro.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas() || vm.mostrarReporte(true);\" ng-disabled=\"!vm.validarFiltros() || !vm.familiaSuministro.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas()\"><i class=\"fa fa-file-pdf-o\"></i> Exportar a PDF</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-click=\"!vm.validarFiltros() || !vm.familiaSuministro.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas() || vm.mostrarReporteExcel();\" ng-disabled=\"!vm.validarFiltros() || !vm.familiaSuministro.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas()\"><i class=\"fa fa-file-excel-o\"></i> Exportar a Excel</a></li></ul></div><div class=btn-group uib-dropdown><button type=button class=\"btn btn-primary\" uib-dropdown-toggle ng-disabled=\"!vm.validarFiltros() || !vm.familiaSuministro.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas()\"><i class=\"fa fa-file-text\"></i> Ver reporte por familia totales <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li style=width:100%><a class=\"btn btn btn-inverse\" ng-click=\"!vm.validarFiltros() || !vm.familiaSuministro.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas() || vm.mostrarReporteTotales();\" ng-disabled=\"!vm.validarFiltros() || !vm.familiaSuministro.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas()\"><i class=\"fa fa-file-pdf-o\"></i> Exportar a PDF</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-click=\"!vm.validarFiltros() || !vm.familiaSuministro.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas() || vm.mostrarReporteTotalesExcel();\" ng-disabled=\"!vm.validarFiltros() || !vm.familiaSuministro.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas()\"><i class=\"fa fa-file-excel-o\"></i> Exportar a Excel</a></li></ul></div><div class=btn-group uib-dropdown><button type=button class=\"btn btn-success\" uib-dropdown-toggle ng-disabled=\"!vm.validarFiltros() || !vm.grupo.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas()\"><i class=\"fa fa-file-text\"></i> Ver reporte por grupo detallado <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li style=width:100%><a class=\"btn btn btn-inverse\" ng-click=\"!vm.validarFiltros() || !vm.grupo.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas() || vm.mostrarReporteGrupoDetalle();\" ng-disabled=\"!vm.validarFiltros() || !vm.grupo.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas()\"><i class=\"fa fa-file-pdf-o\"></i> Exportar a PDF</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-click=\"!vm.validarFiltros() || !vm.grupo.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas() || vm.mostrarReporteGrupoDetalleExcel();\" ng-disabled=\"!vm.validarFiltros() || !vm.grupo.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas()\"><i class=\"fa fa-file-excel-o\"></i> Exportar a Excel</a></li></ul></div></center></div></div></form></div></div></div><div class=col-lg-12><button class=\"btn btn-info\" ng-click=vm.volver()><i class=\"fa fa-arrow-left\"></i> Volver</button></div></div>");
$templateCache.put("app/app/main/reportes/reporte-existencias/reporte-existencias.html","<div class=col-lg-12><div class=col-lg-6><div class=form-group><label>Seleccione el depósito:</label><input type=text ng-disabled=vm.bandera ng-model=vm.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div class=col-lg-6><div class=form-group><label>Seleccione la empresa:</label><input ng-disabled=\"!vm.deposito.id || vm.bandera\" type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" focus-on=empresa class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div style=widht:60%><center><div class=btn-group uib-dropdown><button type=button class=\"btn btn-primary\" uib-dropdown-toggle ng-disabled=\"!vm.deposito.id || !vm.empresa.id\"><i class=\"fa fa-file-text\"></i> Ver reporte existencias <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li style=width:100%><a class=\"btn btn btn-inverse\" ng-click=\"!vm.deposito.id || !vm.empresa.id || vm.mostrarReporte();\" ng-disabled=\"!vm.deposito.id || !vm.empresa.id\"><i class=\"fa fa-file-pdf-o\"></i> Exportar a PDF</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-click=\"!vm.deposito.id || !vm.empresa.id || vm.mostrarReporteExcel();\" ng-disabled=\"!vm.deposito.id || !vm.empresa.id\"><i class=\"fa fa-file-excel-o\"></i> Exportar a Excel</a></li></ul></div><div class=btn-group uib-dropdown><button type=button class=\"btn btn-success\" uib-dropdown-toggle ng-disabled=\"!vm.deposito.id || !vm.empresa.id\"><i class=\"fa fa-file-text\"></i> Ver reporte inventariables <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li><a class=\"btn btn btn-inverse\" style=width:100% ng-click=\"!vm.deposito.id || !vm.empresa.id || vm.mostrarReporteInventariables();\" ng-disabled=\"!vm.deposito.id || !vm.empresa.id\"><i class=\"fa fa-file-pdf-o\"></i> Exportar a PDF</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-disabled=\"!vm.deposito.id || !vm.empresa.id\" ng-click=\"!vm.deposito.id || !vm.empresa.id ||vm.mostrarReporteInventariablesExcel();\"><i class=\"fa fa-file-excel-o\"></i> Exportar a Excel</a></li></ul></div></center></div><button class=\"btn btn-info\" ng-click=vm.volver()><i class=\"fa fa-arrow-left\"></i> Volver</button></div>");
$templateCache.put("app/app/main/reportes/reporte-existencias-donacion-scrap/reporte-existencias-donacion-scrap.html","<div class=col-lg-12><div class=col-lg-4><div class=form-group><label>Seleccione el depósito:</label><input type=text ng-model=vm.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div class=col-lg-4><div class=form-group><label>Seleccione la empresa:</label><input ng-disabled=!vm.deposito.id type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" focus-on=empresa class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div class=col-lg-4><div class=form-group><label>Seleccione tipo de stock:</label><input type=text ng-model=vm.tipoStock placeholder=\"Seleccione o busque el tipo de stock\" uib-typeahead=\"tipo as tipo.nombre.toUpperCase() for tipo in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div style=widht:60%><center><div class=btn-group uib-dropdown><button type=button class=\"btn btn-primary\" uib-dropdown-toggle ng-disabled=\"!vm.deposito.id || !vm.empresa.id || !vm.tipoStock.id\"><i class=\"fa fa-file-text\"></i> Ver reporte <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li style=width:100%><a class=\"btn btn btn-inverse\" ng-click=\"!vm.deposito.id || !vm.empresa.id || !vm.tipoStock.id || vm.mostrarReporteTotales();\" ng-disabled=\"!vm.deposito.id || !vm.empresa.id || !vm.tipoStock.id\"><i class=\"fa fa-file-pdf-o\"></i> Exportar a PDF</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-click=\"!vm.deposito.id || !vm.empresa.id || !vm.tipoStock.id || vm.mostrarReporteTotalesExcel();\" ng-disabled=\"!vm.deposito.id || !vm.empresa.id || !vm.tipoStock.id\"><i class=\"fa fa-file-excel-o\"></i> Exportar a Excel</a></li></ul></div><div class=btn-group uib-dropdown><button type=button class=\"btn btn-success\" uib-dropdown-toggle ng-disabled=\"!vm.deposito.id || !vm.empresa.id || !vm.tipoStock.id\"><i class=\"fa fa-file-text\"></i> Ver reporte inventariables <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li><a class=\"btn btn btn-inverse\" style=width:100% ng-click=\"!vm.deposito.id || !vm.empresa.id || !vm.tipoStock.id || vm.mostrarReporteDetalladoInventariables();\" ng-disabled=\"!vm.deposito.id || !vm.empresa.id || !vm.tipoStock.id\"><i class=\"fa fa-file-pdf-o\"></i> Exportar a PDF</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-disabled=\"!vm.deposito.id || !vm.empresa.id || !vm.tipoStock.id\" ng-click=\"!vm.deposito.id || !vm.empresa.id || !vm.tipoStock.id || vm.mostrarReporteDetalladoInventariablesExcel();\"><i class=\"fa fa-file-excel-o\"></i> Exportar a Excel</a></li></ul></div></center></div><button class=\"btn btn-info\" ng-click=vm.volver()><i class=\"fa fa-arrow-left\"></i> Volver</button></div>");
$templateCache.put("app/app/main/reportes/reporte-ingresos-entre-fechas/reporte-ingresos-entre-fechas.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading><label>Empresa y fechas</label></div><div class=panel-body><div class=col-lg-6><label>Seleccione la empresa:</label><div class=\"form-group col-lg-12\"><input type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div class=col-lg-6><div class=\"form-group col-lg-6\"><label>Fecha desde:</label><input type=date focus-on=fechaDesde id=fechaDesde name=fechaDesde class=form-control ng-model=vm.fechaDesde> <span uib-alert class=danger ng-if=\"vm.form.fechaDesde.$error.date && vm.form.fechaDesde.$dirty\">La fecha ingresada no es válida. </span><span uib-alert class=danger ng-if=\"vm.fechaDesde && vm.fechaDesde>vm.fechaActual && vm.form.fechaDesde.$dirty\">La fecha ingresada debe ser menor a la fecha actual.</span></div><div class=\"form-group col-lg-6\"><label>Fecha hasta:</label><input type=date id=fechaHasta name=fechaHasta class=form-control ng-model=vm.fechaHasta> <span uib-alert class=danger ng-if=\"vm.form.fechaHasta.$error.date && vm.form.fechaHasta.$dirty\">La fecha ingresada no es válida. </span><span uib-alert class=danger ng-if=\"vm.fechaHasta && vm.fechaHasta>vm.fechaActual && vm.form.fechaHasta.$dirty\">La fecha ingresada debe ser menor a la fecha actual.</span></div><div class=col-lg-12><span uib-alert ng-if=\"(vm.form.fechaDesde.$dirty || vm.form.fechaHasta.$dirty)  && (!vm.fechaHasta || !vm.fechaDesde)\">Debe completar ambas fechas </span><span uib-alert ng-if=\"!vm.form.fechaDesde.$error.date && !vm.form.fechaHasta.$error.date && vm.fechaDesde>vm.fechaHasta\">La fecha Desde, debe ser menor a la fecha Hasta. </span><span uib-alert ng-if=\"vm.fechaDesde && vm.fechaHasta && !vm.comprobarPeriodoFechas()\">El periodo seleccionado no puede superar un año y medio</span></div></div></div></div><div class=\"panel panel-default\" ng-if=vm.empresa.id><div class=\"panel panel-heading\"><label>Seleccione la familia de suministro:</label></div><div class=panel-body><div class=col-lg-12><div class=\"form-group col-lg-6\"><label>Grupo de suministro:</label><input type=text focus-on=grupo ng-model=vm.grupo placeholder=\"Seleccione o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase()+\' (\'+grupo.empresa.nombre.toUpperCase()+\')\' for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Familia de suministro:</label><input ng-disabled=!vm.grupo.nombre focus-on=familia type=text ng-model=vm.familiaSuministro placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familiaSuministro as familiaSuministro.nombre.toUpperCase() for familiaSuministro in vm.familias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div><div><center><div class=btn-group uib-dropdown><button type=button class=\"btn btn-primary\" uib-dropdown-toggle ng-disabled=\"!vm.validarFiltros() || !vm.familiaSuministro.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas()\"><i class=\"fa fa-file-text\"></i> Ver reporte por familia detallado <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li style=width:100%><a class=\"btn btn btn-inverse\" ng-click=\"!vm.validarFiltros() || !vm.familiaSuministro.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas() || vm.mostrarReporte();\" ng-disabled=\"!vm.validarFiltros() || !vm.familiaSuministro.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas()\"><i class=\"fa fa-file-pdf-o\"></i> Exportar a PDF</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-click=\"!vm.validarFiltros() || !vm.familiaSuministro.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas() || vm.mostrarReporteExcel();\" ng-disabled=\"!vm.validarFiltros() || !vm.familiaSuministro.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas()\"><i class=\"fa fa-file-excel-o\"></i> Exportar a Excel</a></li></ul></div></center></div></div></form></div></div></div><div class=col-lg-12><button class=\"btn btn-info\" ng-click=vm.volver()><i class=\"fa fa-arrow-left\"></i> Volver</button></div></div>");
$templateCache.put("app/app/main/reportes/reporte-ingresos-remito-orden/reporte-ingresos-remito-orden.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading><label>Depósito y empresa</label></div><div class=panel-body><div class=col-lg-6><label>Seleccione el depósito:</label><div class=\"form-group col-lg-12\"><input type=text ng-model=vm.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div class=col-lg-6><label>Seleccione la empresa:</label><div class=\"form-group col-lg-12\"><input type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div><div class=\"panel panel-default\" ng-if=\"vm.empresa.id && vm.deposito.id\"><div class=panel-heading><label>Seleccione e ingrese número de orden o de remito</label></div><div class=panel-body><div><label>Número de orden de compra:</label><div class=col-lg-12><div class=\"form-group col-lg-1\"><input type=radio ng-model=vm.radio value=numeroOrden ng-change=vm.cambioRadio()></div><div class=\"form-group col-lg-7\"><input ng-disabled=\"vm.radio!=\'numeroOrden\'\" type=text ng-model=vm.proveedor placeholder=\"Seleccione o busque el proveedor\" uib-typeahead=\"proveedor as proveedor.nombre.toUpperCase() for proveedor in vm.proveedores | filter:{nombre:$viewValue}\" focus-on=proveedor class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-4\"><input class=form-control ng-disabled=\"vm.radio!=\'numeroOrden\'\" ng-maxlength=100 focus-on=numeroOrden ng-model=vm.numeroOrden placeholder=\"Ingrese el número de orden de compra\" type=text name=numeroOrden> <span uib-alert class=danger ng-if=\"vm.form.numeroOrden.$error.maxlength && vm.form.numeroOrden.$dirty\">Este campo no puede superar los 100 caracteres.</span></div></div></div><div><label>Número de remito:</label><div class=col-lg-12><div class=\"form-group col-lg-1\"><input type=radio ng-model=vm.radio value=numeroRemito ng-change=vm.cambioRadio()></div><div class=\"form-group col-lg-11\"><input class=form-control ng-disabled=\"vm.radio!=\'numeroRemito\'\" ng-maxlength=100 focus-on=numeroRemito ng-model=vm.numeroRemito placeholder=\"Ingrese el número de remito\" type=text name=numeroRemito> <span uib-alert class=danger ng-if=\"vm.form.numeroRemito.$error.maxlength && vm.form.numeroRemito.$dirty\">Este campo no puede superar los 100 caracteres.</span></div></div></div></div></div></div></form></div><div><center><button class=\"btn btn-primary\" ng-click=vm.buscarIngresos() ng-disabled=!vm.validarFiltros()><i class=\"fa fa-search\"></i> Buscar ingresos</button></center></div></div></div></div><div class=col-lg-12><button class=\"btn btn-info\" ng-click=vm.volver()><i class=\"fa fa-arrow-left\"></i> Volver</button></div>");
$templateCache.put("app/app/main/reportes/reporte-ingresos-salidas/reporte-ingresos-salidas.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading><label>Empresa y fechas</label></div><div class=panel-body><div class=col-lg-6><label>Seleccione la empresa:</label><div class=\"form-group col-lg-12\"><input type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div class=col-lg-6><div class=\"form-group col-lg-6\"><label>Fecha desde:</label><input type=date focus-on=fechaDesde id=fechaDesde name=fechaDesde class=form-control ng-model=vm.fechaDesde> <span uib-alert class=danger ng-if=\"vm.form.fechaDesde.$error.date && vm.form.fechaDesde.$dirty\">La fecha ingresada no es válida. </span><span uib-alert class=danger ng-if=\"vm.fechaDesde && vm.fechaDesde>vm.fechaActual && vm.form.fechaDesde.$dirty\">La fecha ingresada debe ser menor a la fecha actual.</span></div><div class=\"form-group col-lg-6\"><label>Fecha hasta:</label><input type=date id=fechaHasta name=fechaHasta class=form-control ng-model=vm.fechaHasta> <span uib-alert class=danger ng-if=\"vm.form.fechaHasta.$error.date && vm.form.fechaHasta.$dirty\">La fecha ingresada no es válida. </span><span uib-alert class=danger ng-if=\"vm.fechaHasta && vm.fechaHasta>vm.fechaActual && vm.form.fechaHasta.$dirty\">La fecha ingresada debe ser menor a la fecha actual.</span></div><div class=col-lg-12><span uib-alert ng-if=\"(vm.form.fechaDesde.$dirty || vm.form.fechaHasta.$dirty)  && (!vm.fechaHasta || !vm.fechaDesde)\">Debe completar ambas fechas </span><span uib-alert ng-if=\"!vm.form.fechaDesde.$error.date && !vm.form.fechaHasta.$error.date && vm.fechaDesde>vm.fechaHasta\">La fecha Desde, debe ser menor a la fecha Hasta. </span><span uib-alert ng-if=\"vm.fechaDesde && vm.fechaHasta && !vm.comprobarPeriodoFechas()\">El periodo seleccionado no puede superar un año y medio</span></div></div></div></div><div class=\"panel panel-default\" ng-if=vm.empresa.id><div class=\"panel panel-heading\"><label>Seleccione el tipo de suministro:</label></div><div class=panel-body><div><div class=col-lg-12><div class=col-lg-12><div class=\"form-group col-lg-6\"><label>Grupo de suministro:</label><input type=text ng-disabled=\"\" focus-on=grupo ng-model=vm.grupo placeholder=\"Seleccione o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase()+\' (\'+grupo.empresa.nombre.toUpperCase()+\')\' for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Familia de suministro:</label><input ng-disabled=!vm.grupo.nombre focus-on=familia type=text ng-model=vm.familiaSuministro placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familiaSuministro as familiaSuministro.nombre.toUpperCase() for familiaSuministro in vm.familias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-12\"><label>Tipo de suministro:</label><input ng-disabled=\"!vm.grupo.nombre || !vm.familiaSuministro.nombre\" type=text focus-on=tipo ng-model=vm.tipoSuministro placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase() for suministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div></div></div><div><center><div class=btn-group uib-dropdown><button type=button class=\"btn btn-info\" uib-dropdown-toggle ng-disabled=\"!vm.validarFiltros() || !vm.familiaSuministro.id || !vm.tipoSuministro.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas()\"><i class=\"fa fa-file-text\"></i> Ver reporte <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li style=width:100%><a class=\"btn btn btn-inverse\" ng-click=\"!vm.validarFiltros() || !vm.familiaSuministro.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas() || vm.mostrarReporte(true);\" ng-disabled=\"!vm.validarFiltros() || !vm.familiaSuministro.id || !vm.tipoSuministro.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas()\"><i class=\"fa fa-file-pdf-o\"></i> Exportar a PDF</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-click=\"!vm.validarFiltros() || !vm.familiaSuministro.id || !vm.tipoSuministro.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas() || vm.mostrarReporteExcel();\" ng-disabled=\"!vm.validarFiltros() || !vm.familiaSuministro.id || !vm.tipoSuministro.id || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas()\"><i class=\"fa fa-file-excel-o\"></i> Exportar a Excel</a></li></ul></div></center></div></div></form></div></div></div><div class=col-lg-12><button class=\"btn btn-info\" ng-click=vm.volver()><i class=\"fa fa-arrow-left\"></i> Volver</button></div></div>");
$templateCache.put("app/app/main/reportes/reporte-ocupacion-ubicaciones/reporte-ocupacion-ubicaciones.html","<div class=col-lg-12><div class=col-lg-6><div class=form-group><label>Seleccione el depósito:</label><input type=text ng-disabled=vm.bandera ng-model=vm.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div class=col-lg-6><div class=form-group><label>Seleccione la empresa:</label><input ng-disabled=\"!vm.deposito.id || vm.bandera\" type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" focus-on=empresa class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div style=widht:60%><center><div class=btn-group uib-dropdown><button type=button class=\"btn btn-primary\" uib-dropdown-toggle ng-disabled=\"!vm.deposito.id || !vm.empresa.id\"><i class=\"fa fa-file-text\"></i> Ver reporte de ocupación de ubicaciones <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li style=width:100%><a class=\"btn btn btn-inverse\" ng-click=\"!vm.deposito.id || !vm.empresa.id || vm.armarReporte();\" ng-disabled=\"!vm.deposito.id || !vm.empresa.id\"><i class=\"fa fa-file-pdf-o\"></i> Exportar a PDF</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-click=\"!vm.deposito.id || !vm.empresa.id || vm.armarReporteExcel();\" ng-disabled=\"!vm.deposito.id || !vm.empresa.id\"><i class=\"fa fa-file-excel-o\"></i> Exportar a Excel</a></li></ul></div></center></div><button class=\"btn btn-info\" ng-click=vm.volver()><i class=\"fa fa-arrow-left\"></i> Volver</button></div>");
$templateCache.put("app/app/main/reportes/reporte-problemas-ingresos/reporte.html","<div class=col-lg-12><div class=col-lg-12><div class=\"form-group col-lg-6\"><label>Seleccione la empresa:</label><input type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" focus-on=empresa class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Seleccione el año:</label><input type=text ng-model=vm.ano placeholder=\"Seleccione el año\" focus-on=ano class=form-control uib-typeahead=\"ano as ano for ano in vm.anos\" typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div style=widht:60%><center><div class=btn-group uib-dropdown><button type=button class=\"btn btn-primary\" uib-dropdown-toggle ng-disabled=\"!vm.empresa.id || !vm.ano\"><i class=\"fa fa-file-text\"></i> Ver reporte <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li style=width:100%><a class=\"btn btn btn-inverse\" ng-click=\"!vm.empresa.id || !vm.ano || vm.armarReporte();\" ng-disabled=\"!vm.empresa.id || !vm.ano\"><i class=\"fa fa-file-pdf-o\"></i> Exportar a PDF</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-click=\"!vm.empresa.id || !vm.ano || vm.armarReporteExcel();\" ng-disabled=\"!vm.empresa.id || !vm.ano\"><i class=\"fa fa-file-excel-o\"></i> Exportar a Excel</a></li></ul></div></center></div><button class=\"btn btn-info\" ng-click=vm.volver()><i class=\"fa fa-arrow-left\"></i> Volver</button></div>");
$templateCache.put("app/app/main/reportes/reporte-stock/reporte-stock.html","<div class=col-lg-12><div class=col-lg-12><div class=form-group><label>Seleccione la empresa:</label><input ng-disabled=vm.bandera type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" focus-on=empresa class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div style=widht:60%><center><div class=btn-group uib-dropdown><button type=button class=\"btn btn-primary\" uib-dropdown-toggle ng-disabled=!vm.empresa.id><i class=\"fa fa-file-text\"></i> Reporte stock actual y mínimo <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li style=width:100%><a class=\"btn btn btn-inverse\" ng-click=\"!vm.empresa.id || vm.mostrarReporteCompleto();\" ng-disabled=!vm.empresa.id><i class=\"fa fa-file-pdf-o\"></i> Exportar a PDF</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-click=\"!vm.empresa.id || vm.mostrarReporteCompletoExcel();\" ng-disabled=!vm.empresa.id><i class=\"fa fa-file-excel-o\"></i> Exportar a Excel</a></li></ul></div><div class=btn-group uib-dropdown><button type=button class=\"btn btn-success\" uib-dropdown-toggle ng-disabled=!vm.empresa.id><i class=\"fa fa-file-text\"></i> Reporte sólo stock mínimo <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li><a class=\"btn btn btn-inverse\" style=width:100% ng-click=\"!vm.empresa.id || vm.mostrarReporteStock();\" ng-disabled=!vm.empresa.id><i class=\"fa fa-file-pdf-o\"></i> Exportar a PDF</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-disabled=!vm.empresa.id ng-click=\"!vm.empresa.id || vm.mostrarReporteStockExcel();\"><i class=\"fa fa-file-excel-o\"></i> Exportar a Excel</a></li></ul></div></center></div><button class=\"btn btn-info\" ng-click=vm.volver()><i class=\"fa fa-arrow-left\"></i> Volver</button></div>");
$templateCache.put("app/app/main/reportes/reporte-suministro-deposito/reporte-suministro-deposito.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading><label>Depósito y empresa</label></div><div class=panel-body><div class=col-lg-6><label>Seleccione el depósito:</label><div class=\"form-group col-lg-12\"><input type=text ng-model=vm.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div class=col-lg-6><label>Seleccione la empresa:</label><div class=\"form-group col-lg-12\"><input type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div><div class=\"panel panel-default\" ng-if=\"vm.empresa.id && vm.deposito.id\"><div class=\"panel panel-heading\"><label>Seleccione el tipo de suministro:</label></div><div class=panel-body><div><div class=col-lg-12><div class=col-lg-1 ng-if=false><div class=form-group><input type=radio ng-model=vm.radio value=jerarquizada ng-change=vm.cambioRadio()></div></div><div class=col-lg-12><div class=\"form-group col-lg-6\"><label>Grupo de suministro:</label><input type=text ng-disabled=\"vm.radio!=\'jerarquizada\'\" focus-on=grupo ng-model=vm.grupo placeholder=\"Seleccione o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase()+\' (\'+grupo.empresa.nombre.toUpperCase()+\')\' for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Familia de suministro:</label><input ng-disabled=\"!vm.grupo.nombre || vm.radio!=\'jerarquizada\'\" focus-on=familia type=text ng-model=vm.familiaSuministro placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familiaSuministro as familiaSuministro.nombre.toUpperCase() for familiaSuministro in vm.familias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-12\"><label>Tipo de suministro:</label><input ng-if=\"vm.radio==\'jerarquizada\'\" ng-disabled=\"!vm.grupo.nombre || !vm.familiaSuministro.nombre || vm.radio!=\'jerarquizada\'\" type=text focus-on=tipo ng-model=vm.tipoSuministro placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase() for suministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <input ng-if=\"vm.radio==\'directa\'\" ng-disabled=\"!vm.grupo.nombre || !vm.familiaSuministro.nombre || vm.radio!=\'jerarquizada\'\" type=text focus-on=tipo ng-model=vm.tipoSuministro1 placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase() for suministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div><div ng-if=false><label>Búsqueda directa:</label><div class=col-lg-12 ng-disabled=\"\"><div class=\"form-group col-lg-1\"><input type=radio ng-model=vm.radio value=directa ng-change=vm.cambioRadio()></div><div class=\"form-group col-lg-11\"><label>Tipo de suministro:</label><input type=text ng-disabled=\"vm.radio!=\'directa\'\" ng-model=vm.tipoSuministroCompleto placeholder=\"Seleccione o busque el tipo de suministro por su nombre\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase()+\' (\'+suministro.familiaSuministro.nombre.toUpperCase()+\') - (\'+suministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+\')\' for suministro in vm.tiposCompletos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div></div></div><div><center><div class=btn-group uib-dropdown><button type=button class=\"btn btn-primary\" uib-dropdown-toggle ng-disabled=\"!vm.validarFiltros() || !vm.tipoSuministro.id;\"><i class=\"fa fa-file-text\"></i> Ver reporte detallado <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li style=width:100%><a class=\"btn btn btn-inverse\" ng-click=\"!vm.validarFiltros() || !vm.tipoSuministro.id || vm.mostrarReporte(true)\" ng-disabled=\"!vm.validarFiltros() || !vm.tipoSuministro.id;\"><i class=\"fa fa-file-pdf-o\"></i> Exportar a PDF</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-click=\"!vm.validarFiltros() || !vm.tipoSuministro.id || vm.mostrarReporteExcel()\" ng-disabled=\"!vm.validarFiltros() || !vm.tipoSuministro.id\"><i class=\"fa fa-file-excel-o\"></i> Exportar a Excel</a></li></ul></div><div class=btn-group uib-dropdown><button type=button class=\"btn btn-success\" uib-dropdown-toggle ng-disabled=!vm.validarFiltros()><i class=\"fa fa-file-text\"></i> Ver reporte totales <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li><a class=\"btn btn btn-inverse\" style=width:100% ng-click=\"!vm.validarFiltros() || vm.mostrarReporteSinDetalle();\" ng-disabled=!vm.validarFiltros()><i class=\"fa fa-file-pdf-o\"></i> Exportar a PDF</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-disabled=!vm.validarFiltros() ng-click=\"!vm.validarFiltros() || vm.mostrarReporteSinDetalleExcel();\"><i class=\"fa fa-file-excel-o\"></i> Exportar a Excel</a></li></ul></div></center></div></form></div></div></div><button class=\"btn btn-info\" ng-click=vm.volver()><i class=\"fa fa-arrow-left\"></i> Volver</button></div>");
$templateCache.put("app/app/main/reportes/reporte-tiempo-salidas/reporte-tiempo-salidas.html","<div class=col-lg-12><div class=col-lg-12><form name=vm.form><div class=col-lg-12><div class=col-lg-6><div class=form-group><label>Seleccione el depósito:</label><input type=text ng-disabled=vm.bandera ng-model=vm.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div class=col-lg-6><div class=\"form-group col-lg-6\"><label>Fecha desde:</label><input type=date focus-on=fechaDesde id=fechaDesde name=fechaDesde class=form-control ng-model=vm.fechaDesde> <span uib-alert class=danger ng-if=\"vm.form.fechaDesde.$error.date && vm.form.fechaDesde.$dirty\">La fecha ingresada no es válida. </span><span uib-alert class=danger ng-if=\"vm.fechaDesde && vm.fechaDesde>vm.fechaActual && vm.form.fechaDesde.$dirty\">La fecha ingresada debe ser menor a la fecha actual.</span></div><div class=\"form-group col-lg-6\"><label>Fecha hasta:</label><input type=date id=fechaHasta name=fechaHasta class=form-control ng-model=vm.fechaHasta> <span uib-alert class=danger ng-if=\"vm.form.fechaHasta.$error.date && vm.form.fechaHasta.$dirty\">La fecha ingresada no es válida. </span><span uib-alert class=danger ng-if=\"vm.fechaHasta && vm.fechaHasta>vm.fechaActual && vm.form.fechaHasta.$dirty\">La fecha ingresada debe ser menor a la fecha actual.</span></div><div class=col-lg-12><span uib-alert ng-if=\"(vm.form.fechaDesde.$dirty || vm.form.fechaHasta.$dirty)  && (!vm.fechaHasta || !vm.fechaDesde)\">Debe completar ambas fechas </span><span uib-alert ng-if=\"!vm.form.fechaDesde.$error.date && !vm.form.fechaHasta.$error.date && vm.fechaDesde>vm.fechaHasta\">La fecha Desde, debe ser menor a la fecha Hasta. </span><span uib-alert ng-if=\"vm.fechaDesde && vm.fechaHasta && !vm.comprobarPeriodoFechas()\">El periodo seleccionado no puede superar un año y medio</span></div></div></div><div><center><div class=btn-group uib-dropdown><button type=button class=\"btn btn-primary\" uib-dropdown-toggle ng-disabled=\"!vm.validarFiltros() || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas()\"><i class=\"fa fa-file-text\"></i> Ver reporte <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li style=width:100%><a class=\"btn btn btn-inverse\" ng-click=\"!vm.validarFiltros() || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas() || vm.mostrarReporte();\" ng-disabled=\"!vm.validarFiltros() || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas()\"><i class=\"fa fa-file-pdf-o\"></i> Exportar a PDF</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-click=\"!vm.validarFiltros() || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas() || vm.mostrarReporteExcel();\" ng-disabled=\"!vm.validarFiltros() || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas()\"><i class=\"fa fa-file-excel-o\"></i> Exportar a Excel</a></li></ul></div></center></div></form></div><div class=col-lg-12><button class=\"btn btn-info\" ng-click=vm.volver()><i class=\"fa fa-arrow-left\"></i> Volver</button></div></div>");
$templateCache.put("app/app/main/reportes/reporte-tiempos-preparacion/reporte-tiempos-preparacion.html","<div class=col-lg-12><div class=col-lg-12><form name=vm.form><div class=col-lg-12><div class=col-lg-6><div class=form-group><label>Seleccione el depósito:</label><input type=text ng-disabled=vm.bandera ng-model=vm.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div class=col-lg-6><div class=\"form-group col-lg-6\"><label>Fecha desde:</label><input type=date focus-on=fechaDesde id=fechaDesde name=fechaDesde class=form-control ng-model=vm.fechaDesde> <span uib-alert class=danger ng-if=\"vm.form.fechaDesde.$error.date && vm.form.fechaDesde.$dirty\">La fecha ingresada no es válida. </span><span uib-alert class=danger ng-if=\"vm.fechaDesde && vm.fechaDesde>vm.fechaActual && vm.form.fechaDesde.$dirty\">La fecha ingresada debe ser menor a la fecha actual.</span></div><div class=\"form-group col-lg-6\"><label>Fecha hasta:</label><input type=date id=fechaHasta name=fechaHasta class=form-control ng-model=vm.fechaHasta> <span uib-alert class=danger ng-if=\"vm.form.fechaHasta.$error.date && vm.form.fechaHasta.$dirty\">La fecha ingresada no es válida. </span><span uib-alert class=danger ng-if=\"vm.fechaHasta && vm.fechaHasta>vm.fechaActual && vm.form.fechaHasta.$dirty\">La fecha ingresada debe ser menor a la fecha actual.</span></div><div class=col-lg-12><span uib-alert ng-if=\"(vm.form.fechaDesde.$dirty || vm.form.fechaHasta.$dirty)  && (!vm.fechaHasta || !vm.fechaDesde)\">Debe completar ambas fechas </span><span uib-alert ng-if=\"!vm.form.fechaDesde.$error.date && !vm.form.fechaHasta.$error.date && vm.fechaDesde>vm.fechaHasta\">La fecha Desde, debe ser menor a la fecha Hasta. </span><span uib-alert ng-if=\"vm.fechaDesde && vm.fechaHasta && !vm.comprobarPeriodoFechas()\">El periodo seleccionado no puede superar un año y medio</span></div></div></div><div><center><div class=btn-group uib-dropdown><button type=button class=\"btn btn-primary\" uib-dropdown-toggle ng-disabled=\"!vm.validarFiltros() || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas()\"><i class=\"fa fa-file-text\"></i> Ver reporte <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li style=width:100%><a class=\"btn btn btn-inverse\" ng-click=\"!vm.validarFiltros() || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas() || vm.mostrarReporte();\" ng-disabled=\"!vm.validarFiltros() || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas()\"><i class=\"fa fa-file-pdf-o\"></i> Exportar a PDF</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-click=\"!vm.validarFiltros() || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas() || vm.mostrarReporteExcel();\" ng-disabled=\"!vm.validarFiltros() || vm.fechaDesde>vm.fechaHasta || !vm.comprobarPeriodoFechas()\"><i class=\"fa fa-file-excel-o\"></i> Exportar a Excel</a></li></ul></div></center></div></form></div><div class=col-lg-12><button class=\"btn btn-info\" ng-click=vm.volver()><i class=\"fa fa-arrow-left\"></i> Volver</button></div></div>");
$templateCache.put("app/app/main/reportes/reporte-tope-sucursal/reporte-tope-sucursal.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-heading><label>Empresa</label></div><div class=panel-body><div class=col-lg-6><label>Seleccione la empresa:</label><div class=\"form-group col-lg-12\"><input type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div class=col-lg-6><label>Seleccione la sucursal:</label><div class=\"form-group col-lg-12\"><input type=text ng-disabled=!vm.empresa.id ng-model=vm.sucursal placeholder=\"Seleccione o busque la sucursal\" uib-typeahead=\"sucursal as sucursal.nombre.toUpperCase() for sucursal in vm.sucursales | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false focus-on=sucursal></div></div></div></div><div class=\"panel panel-default\" ng-if=\"vm.empresa.id && vm.sucursal.id\"><div class=\"panel panel-heading\"><label>Seleccione el tipo de suministro:</label></div><div class=panel-body><div><label ng-if=false>Búsqueda jerarquizada:</label><div class=col-lg-12><div class=col-lg-1 ng-if=false><div class=form-group><input type=radio ng-model=vm.radio value=jerarquizada ng-change=vm.cambioRadio()></div></div><div class=col-lg-12><div class=\"form-group col-lg-6\"><label>Grupo de suministro:</label><input type=text ng-disabled=\"vm.radio!=\'jerarquizada\'\" focus-on=grupo ng-model=vm.grupo placeholder=\"Seleccione o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase()+\' (\'+grupo.empresa.nombre.toUpperCase()+\')\' for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Familia de suministro:</label><input ng-disabled=\"!vm.grupo.nombre || vm.radio!=\'jerarquizada\'\" focus-on=familia type=text ng-model=vm.familiaSuministro placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familiaSuministro as familiaSuministro.nombre.toUpperCase() for familiaSuministro in vm.familias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-12\" ng-if=false><label>Tipo de suministro:</label><input ng-if=\"vm.radio==\'jerarquizada\'\" ng-disabled=\"!vm.grupo.nombre || !vm.familiaSuministro.nombre || vm.radio!=\'jerarquizada\'\" type=text focus-on=tipo ng-model=vm.tipoSuministro placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase() for suministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false> <input ng-if=\"vm.radio==\'directa\'\" ng-disabled=\"!vm.grupo.nombre || !vm.familiaSuministro.nombre || vm.radio!=\'jerarquizada\'\" type=text focus-on=tipo ng-model=vm.tipoSuministro1 placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase() for suministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div><div ng-if=false><label>Búsqueda directa:</label><div class=col-lg-12 ng-disabled=\"\"><div class=\"form-group col-lg-1\"><input type=radio ng-model=vm.radio value=directa ng-change=vm.cambioRadio()></div><div class=\"form-group col-lg-11\"><label>Tipo de suministro:</label><input type=text ng-disabled=\"vm.radio!=\'directa\'\" ng-model=vm.tipoSuministroCompleto placeholder=\"Seleccione o busque el tipo de suministro por su nombre\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase()+\' (\'+suministro.familiaSuministro.nombre.toUpperCase()+\') - (\'+suministro.familiaSuministro.grupoSuministro.nombre.toUpperCase()+\')\' for suministro in vm.tiposCompletos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div></div></div></div></div><div><center><div class=btn-group uib-dropdown><button type=button class=\"btn btn-primary\" uib-dropdown-toggle ng-disabled=!vm.validarFiltros()><i class=\"fa fa-file-text\"></i> Ver reporte <span class=caret></span></button><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=single-button><li style=width:100%><a class=\"btn btn btn-inverse\" ng-click=\"!vm.validarFiltros() || vm.mostrarReporte();\" ng-disabled=!vm.validarFiltros()><i class=\"fa fa-file-pdf-o\"></i> Exportar a PDF</a></li><li role=separator class=divider></li><li style=width:100%><a class=\"btn btn-inverse\" ng-click=\"!vm.validarFiltros() || vm.mostrarReporteExcel();\" ng-disabled=!vm.validarFiltros()><i class=\"fa fa-file-excel-o\"></i> Exportar a Excel</a></li></ul></div></center></div></form></div></div></div><button class=\"btn btn-info\" ng-click=vm.volver()><i class=\"fa fa-arrow-left\"></i> Volver</button></div>");
$templateCache.put("app/app/main/ubicaciones/deposito/lista-deposito-ubicaciones.html","<div><form><div class=form-group><!-- 			<center>\r\n	<button ng-click=\"vm.nuevasUbicaciones()\" class=\"btn btn-success\" style=\"width:50%\">\r\n		<i class=\"fa fa-plus\"></i>\r\n		NUEVAS UBICACIONES \r\n	</button>\r\n</center> --></div><!-- 		<button class=\"btn btn-link\" ng-click=\"vm.exportToExcel()\">\r\n        	<span class=\"glyphicon glyphicon-share\"></span> Exportar a Excel\r\n    	</button> --><div class=col-lg-12><table id=table1 ng-table=vm.tableParams class=table show-filter=true ng-show=vm.depositos><tr ng-repeat=\"deposito in $data\"><td title=\"\'Nombre\'\" filter=\"{ nombre: \'text\'}\" data-sortable=\"\'nombre\'\">{{deposito.nombre.toUpperCase();}}</td><td title=\"\'Número\'\" align=center filter=\"{ numeroDeposito: \'text\'}\" data-sortable=\"\'numeroDeposito\'\">{{deposito.numeroDeposito}}</td><td title=\"\'Ubicación\'\">{{deposito.ubicacion}}</td><td title=\"\'Dirección\'\">{{deposito.direccion}}</td><td title=\"\'Cantidad naves\'\" align=center>{{vm.util.contarNoBorrados(deposito.naves)}}</td><td title=\"\'Acciones\'\" align=center><div class=btn-group><button class=\"btn btn-info\" ng-click=vm.verNaves(deposito) ng-disabled=\"deposito.naves.length==0\">Ver naves <i class=\"fa fa-search\"></i></button></div></td></tr></table></div></form></div>");
$templateCache.put("app/app/main/deposito/deposito/editar/editar-deposito.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=form-group><label>Ingrese el nombre del depósito:</label><input class=form-control ng-maxlength=255 ng-model=vm.deposito.nombre placeholder=\"Ingrese el nombre del depósito\" type=text name=proveedor required> <span uib-alert class=danger ng-if=\"vm.form.proveedor.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.proveedor.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=form-group><label>Ingrese el número de depósito:</label><input class=form-control ng-maxlength=255 ng-model=vm.deposito.numeroDeposito placeholder=\"Ingrese el número de depósito\" type=text name=numeroDeposito required> <span uib-alert class=danger ng-if=\"vm.form.numeroDeposito.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.numeroDeposito.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=form-group><label>Ingrese la ubicación del depósito:</label><input class=form-control ng-maxlength=255 ng-model=vm.deposito.ubicacion placeholder=\"Ingrese la ubicación del depósito\" type=text name=ubicacion> <span uib-alert class=danger ng-if=\"vm.form.ubicacion.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=form-group ng-if=vm.esEditar()><label>Seleccione nave por defecto para búsqueda de suministros:</label><input ng-disabled=\"vm.naves.length==0\" type=text ng-model=vm.naveBusqueda placeholder=\"Seleccione la nave por defecto para búsqueda de suministros\" uib-typeahead=\"nave as nave.nombre.toUpperCase() for nave in vm.naves | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.guardar() ng-disabled=vm.form.$invalid><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/deposito/deposito/lista/lista-deposito.html","<div><form><div class=form-group><center><button ng-click=vm.crearNuevo() ng-disabled=vm.bloquearPorRol(); class=\"btn btn-success\" style=width:50%><i class=\"fa fa-plus\"></i> NUEVO DEPÓSITO</button></center></div><button class=\"btn btn-link\" ng-click=vm.exportToExcel()><span class=\"glyphicon glyphicon-share\"></span> Exportar a Excel</button><div class=col-lg-12><table id=table1 ng-table=vm.tableParams class=table show-filter=true ng-show=vm.depositos><tr ng-repeat=\"deposito in $data\"><td title=\"\'Nombre\'\" filter=\"{ nombre: \'text\'}\" data-sortable=\"\'nombre\'\">{{deposito.nombre}}</td><td title=\"\'Número\'\" filter=\"{ numeroDeposito: \'text\'}\" data-sortable=\"\'numeroDeposito\'\">{{deposito.numeroDeposito}}</td><td title=\"\'Ubicación\'\">{{deposito.ubicacion}}</td><td title=\"\'Dirección\'\">{{deposito.direccion}}</td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.mostrarInformacion(deposito)><i class=\"fa fa-search\"></i> </a><a class=\"btn btn-warning\" ng-disabled=vm.bloquearPorRol(); ng-click=\"vm.bloquearPorRol() || vm.editar(deposito)\"><i class=\"fa fa-pencil\"></i> </a><a class=\"btn btn-danger\" ng-disabled=vm.bloquearPorRol(); ng-click=\"vm.bloquearPorRol() || vm.eliminar(deposito)\"><i class=\"fa fa-trash\"></i></a></div></td></tr></table></div></form></div>");
$templateCache.put("app/app/main/deposito/nave/editar/editar-nave.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=form-group><label>Ingrese el nombre de la Nave:</label><input class=form-control ng-maxlength=255 ng-model=vm.nave.nombre placeholder=\"Ingrese el nombre de la nave\" type=text name=nombre required> <span uib-alert class=danger ng-if=\"vm.form.nombre.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.nombre.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=form-group><label>Ingrese o busque el Depósito:</label><input type=text ng-model=vm.nave.deposito placeholder=\"Seleccione o busque el Depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-editable=false typeahead-show-hint=true typeahead-min-length=0 required name=deposito> <span uib-alert class=danger ng-show=\"vm.form.deposito.$error.required && vm.form.$dirty\">Este campo es requerido.</span></div><div class=form-group><label>Ingrese el código de nave:</label><input class=form-control min=0 ng-min=0 ng-maxlength=15 ng-model=vm.nave.numeroNave placeholder=\"Ingrese el código de nave\" type=text name=numeroNave> <span uib-alert class=danger ng-show=\"vm.form.numeroNave.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.numeroNave.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 15 caracteres.</span></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.guardar() ng-disabled=\"vm.form.$invalid || !vm.nave.deposito.nombre\"><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/deposito/nave/lista/lista-nave.html","<!--     <formly-form model=\"vm.user\" fields=\"vm.userFields\">\r\n  <button type=\"submit\" class=\"btn btn-primary col-sm-offset-4 col-sm-4\" ng-click=\"vm.submit(vm.user)\">Submit</button>\r\n</formly-form> --><div><form><div class=\"form-group col-lg-12\"><div class=form-group><center><button ng-click=vm.crearNuevo() class=\"btn btn-success\" style=width:50%><i class=\"fa fa-plus\"></i> NUEVA NAVE</button></center></div><div><label>Filtrar por depósito:</label><div class=col-lg-12><div class=\"form-group col-lg-1\"><input type=checkbox ng-model=vm.buscar ng-click=vm.busqueda()></div><div class=\"form-group col-lg-9\"><input ng-disabled=!vm.buscar type=text ng-model=vm.deposito placeholder=\"Seleccione o busque el deposito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"col-lg-2 form-group\"><button ng-disabled=\"!vm.buscar || !vm.deposito.nombre\" class=\"btn btn-primary\" ng-click=vm.filtrar()><span class=\"fa fa-search\"></span> Buscar</button></div></div></div><br><div ng-show=\"!vm.naves.length>0 && vm.bandera\" uib-alert class=\"danger col-lg-12 form-group\">No hay naves para el deposito seleccionado.</div></div><button class=\"btn btn-link\" ng-click=vm.exportToExcel() ng-show=\"vm.naves.length>0\"><span class=\"glyphicon glyphicon-share\"></span> Exportar a Excel</button><div class=col-lg-12><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.naves.length>0\"><tr ng-repeat=\"naves in $data\"><td title=\"\'Depósito\'\" align=center data-sortable=\"\'deposito.nombre\'\">{{naves.deposito.nombre.toUpperCase();}}</td><td title=\"\'Nombre\'\" filter=\"{ nombre: \'text\'}\" data-sortable=\"\'nombre\'\">{{naves.nombre}}</td><td title=\"\'Número nave\'\" filter=\"{ numeroNave: \'text\'}\" data-sortable=\"\'numeroNave\'\">{{naves.numeroNave}}</td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.mostrarInformacion(naves)><i class=\"fa fa-search\"></i> </a><a class=\"btn btn-warning\" ng-click=vm.editar(naves)><i class=\"fa fa-pencil\"></i> </a><a class=\"btn btn-danger\" ng-click=vm.eliminar(naves)><i class=\"fa fa-trash\"></i></a></div></td></tr></table></div></form></div>");
$templateCache.put("app/app/main/empresa/empresa/editar/editar-empresa.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=form-group><label>Ingrese el nombre de la empresa:</label><input class=form-control ng-maxlength=255 ng-model=vm.empresa.nombre placeholder=\"Ingrese el nombre de la empresa\" type=text name=empresa required> <span uib-alert class=danger ng-if=\"vm.form.empresa.$error.required && vm.form.$dirty\">Este campo es requerido.</span> <span uib-alert class=danger ng-if=\"vm.form.empresa.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=form-group><label>Ingrese la descripción:</label><textarea class=form-control ng-maxlength=500 ng-model=vm.empresa.descripcion placeholder=\"Ingrese la descripción de la empresa\" type=text name=descripcion style=resize:vertical></textarea><span uib-alert class=danger ng-if=\"vm.form.descripcion.$error.required && vm.form.$dirty\">Este campo es requerido.</span> <span uib-alert class=danger ng-if=\"vm.form.descripcion.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 500 caracteres.</span></div><div class=form-group><label>Período para tope de suministros:</label><input type=text ng-model=vm.empresa.tipoTope placeholder=\"Seleccione la periodicidad para los topes de suministros\" uib-typeahead=\"tipoTope as tipoTope.periodo.toUpperCase() for tipoTope in vm.tiposTope | filter:{periodo:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 required name=tipoTope typeahead-editable=false focus-on=tipoTope> <span uib-alert class=danger ng-if=\"vm.form.tipoTope.$error.required && vm.form.$dirty\">Este campo es requerido.</span></div><lista-emails ng-model=vm.emailsEmpresa titulo=\"Emails generales\" class=col-lg-12></lista-emails><div class=form-group><lista-emails ng-model=vm.emailsStock nombre-campo=stock titulo=\"Emails de stock mínimo\" class=\"col-xs-12 col-sm-12 col-md-6\"></lista-emails><lista-emails ng-model=vm.emailsIngresos nombre-campo=ingreso titulo=\"Emails de ingresos\" class=\"col-xs-12 col-sm-12 col-md-6\"></lista-emails></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.guardar() ng-disabled=\"vm.form.$invalid || vm.comprobarMails()\"><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/empresa/empresa/lista/lista-empresa.html","<div><form><div class=form-group><center><button ng-click=vm.crearNuevo() ng-disabled=vm.bloquearPorRol(); class=\"btn btn-success\" style=width:50%><i class=\"fa fa-plus\"></i> NUEVA EMPRESA</button></center></div><button class=\"btn btn-link\" ng-click=vm.exportToExcel()><span class=\"fa fa-file-excel-o\"></span> Exportar a Excel</button> <button class=\"btn btn-link\" ng-click=vm.reportePdf()><span class=\"fa fa-file-pdf-o\"></span> Exportar a PDF</button><div class=col-lg-12><table id=table1 ng-table=vm.tableParams class=table show-filter=true ng-show=vm.empresas><tr ng-repeat=\"empresa in $data\"><td title=\"\'Nombre\'\" filter=\"{ nombre: \'text\'}\" data-sortable=\"\'nombre\'\">{{empresa.nombre}}</td><td title=\"\'Descripción\'\">{{empresa.descripcion}}</td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.mostrarInformacion(empresa)><i class=\"fa fa-search\"></i> </a><a class=\"btn btn-warning\" ng-disabled=vm.bloquearPorRol(); ng-click=\"vm.bloquearPorRol() ||vm.editar(empresa)\"><i class=\"fa fa-pencil\"></i> </a><a class=\"btn btn-danger\" ng-disabled=vm.bloquearPorRol(); ng-click=\"vm.bloquearPorRol() || vm.eliminar(empresa)\"><i class=\"fa fa-trash\"></i></a></div></td></tr></table></div></form></div>");
$templateCache.put("app/app/main/empresa/kit-prearmados/editar/editar.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><div class=\"col-lg-12 panel\"><div class=col-lg-5><div class=form-group><label ng-if=!vm.bandera>Seleccione la empresa:</label><label ng-if=vm.bandera>Empresa seleccionada:</label><input type=text ng-disabled=vm.bandera ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div class=col-lg-5><div class=form-group><label ng-if=!vm.bandera>Seleccione la sucursal:</label><label ng-if=vm.bandera>Sucursal seleccionada:</label><input ng-disabled=\"!vm.empresa.id || vm.bandera\" type=text ng-model=vm.sucursal placeholder=\"Seleccione o busque la sucursal\" uib-typeahead=\"sucursal as sucursal.nombre.toUpperCase() for sucursal in vm.sucursales | filter:{nombre:$viewValue}\" focus-on=sucursal class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><br><div class=col-lg-2 ng-if=!vm.bandera><button style=width:100% ng-disabled=\"!vm.empresa.id || !vm.sucursal.id\" ng-click=vm.seleccionarSucursal() class=\"btn btn-primary\"><i class=\"fa fa-check\"></i> Seleccionar</button></div><div class=col-lg-2 ng-if=vm.bandera><button style=width:100% ng-click=vm.cambiarSucursal() class=\"btn btn-warning\"><i class=\"fa fa-exchange\"></i> Cambiar</button></div></div></div><div class=col-lg-12 ng-if=vm.bandera><div class=form-group><label>Nombre del kit:</label><input type=text ng-model=vm.nombreKit placeholder=\"Ingrese el nombre del kit\" class=form-control name=nombreKit> <span uib-alert ng-if=\"vm.form.nombreKit.$error.required && vm.form.nombreKit.$dirty\">Este campo es requerido.</span></div><div class=form-group><center><div><button class=\"btn btn-primary\" style=width:60% ng-click=vm.abrirModalSeleccionTipoSuministro(); ng-disabled=\"!vm.empresa.id || !vm.sucursal.id || !vm.bandera\">Seleccionar tipo de suministro</button></div></center></div></div></form></div><div class=\"col-lg-12 form-group\" ng-if=vm.bandera><br><div uib-alert ng-if=\"vm.tipos.length<=0\">Aún no ha agregado nada</div><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.tipos.length>0\"><tr ng-repeat=\"tipo in $data\"><td title=\"\'Grupo suministro\'\" align=center>{{tipo.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Familia suministro\'\" align=center>{{tipo.tipoSuministro.familiaSuministro.nombre.toUpperCase();}}</td><td title=\"\'Tipo suministro\'\" align=center>{{tipo.tipoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Cantidad\'\" align=center>{{tipo.cantidad}}</td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-warning\" ng-click=vm.editarDetalle(tipo)><i class=\"fa fa-pencil\"></i> </a><a class=\"btn btn-danger\" ng-click=vm.eliminar(tipo)><i class=\"fa fa-trash\"></i></a></div></td></tr></table></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.guardar() ng-disabled=\"vm.tipos.length<=0  || !vm.nombreKit\"><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/empresa/kit-prearmados/lista/lista.html","<!--     <formly-form model=\"vm.user\" fields=\"vm.userFields\">\r\n  <button type=\"submit\" class=\"btn btn-primary col-sm-offset-4 col-sm-4\" ng-click=\"vm.submit(vm.user)\">Submit</button>\r\n</formly-form> --><div><form><div class=\"form-group col-lg-12\"><div class=form-group><center><button ng-click=vm.crearNuevo() class=\"btn btn-success\" style=width:50%><i class=\"fa fa-plus\"></i> NUEVO KIT PRE-ARMADO</button></center></div><div><label>Filtrar por sucursal:</label><div class=col-lg-12><div class=\"form-group col-lg-1\"><input type=checkbox ng-model=vm.buscar ng-click=vm.busqueda()></div><div class=\"form-group col-lg-4\"><input ng-disabled=!vm.buscar type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0></div><div class=\"form-group col-lg-5\"><input focus-on=sucursal ng-disabled=\"!vm.buscar || !vm.empresa.nombre\" type=text ng-model=vm.sucursal placeholder=\"Seleccione o busque la sucursal\" uib-typeahead=\"sucursal as sucursal.nombre.toUpperCase() for sucursal in vm.sucursales | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0></div><div class=\"col-lg-2 form-group\"><button ng-disabled=\"!vm.buscar || !vm.empresa.id ||!vm.sucursal.id\" class=\"btn btn-primary\" ng-click=vm.filtrar()><span class=\"fa fa-search\"></span> Buscar</button></div></div></div><br><div ng-show=\"!vm.kits.length>0 && vm.bandera\" uib-alert class=\"danger col-lg-12 form-group\">No hay kits para la sucursal seleccionada.</div></div><div class=col-lg-12><table ng-table=vm.tableParams class=table ng-show=\"vm.kits.length>0\"><tr ng-repeat=\"kit in $data\"><td title=\"\'Empresa\'\" filter=\"{ \'sucursal.empresa.nombre\': \'text\'}\" data-sortable=\"\'sucursal.empresa.nombre\'\" align=center>{{kit.sucursal.empresa.nombre.toUpperCase();}}</td><td title=\"\'Sucursal\'\" filter=\"{ \'sucursal.nombre\': \'text\'}\" data-sortable=\"\'sucursal.nombre\'\" align=center>{{kit.sucursal.nombre.toUpperCase();}}</td><td title=\"\'Nombre\'\" filter=\"{ nombre: \'text\'}\" data-sortable=\"\'nombre\'\">{{kit.nombre}}</td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.mostrarInformacion(kit)><i class=\"fa fa-search\"></i> </a><a class=\"btn btn-warning\" ng-disabled=vm.bloquearPorRol(); ng-click=\"vm.bloquearPorRol() || vm.editar(kit)\"><i class=\"fa fa-pencil\"></i> </a><a class=\"btn btn-danger\" ng-disabled=vm.bloquearPorRol(); ng-click=\"vm.bloquearPorRol() || vm.eliminar(kit)\"><i class=\"fa fa-trash\"></i></a></div></td></tr></table></div></form></div>");
$templateCache.put("app/app/main/empresa/kit-prearmados/visualizar/visualizar.html","<div class=col-lg-12><div ng-if=!vm.kit.id><div uib-alert>No se puede visualizar</div><div><button class=\"btn btn-warning\" ng-click=vm.volver()><i class=\"fa fa-arrow-left\"></i> Volver</button></div></div><div class=panel ng-if=vm.kit.id><div class=panel-body><div class=col-lg-12><div class=\"form-group col-lg-6\"><label>Nombre:</label><input type=text ng-readonly=true ng-model=vm.kit.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.kit.sucursal.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-12\"><label>Sucursal:</label><input type=text ng-readonly=true ng-model=vm.kit.sucursal.nombre class=\"form-control text-uppercase\" name=sucursal></div></div><br><label>Detalles del kit:</label><div class=\"col-lg-12 form-group\"><br><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.kit.detalles.length>0\"><tr ng-repeat=\"tipo in $data\"><td title=\"\'Grupo suministro\'\" align=center>{{tipo.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase();}} - ({{tipo.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase()}})</td><td title=\"\'Familia suministro\'\" align=center>{{tipo.tipoSuministro.familiaSuministro.nombre.toUpperCase();}}</td><td title=\"\'Tipo suministro\'\" align=center>{{tipo.tipoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Cantidad\'\" align=center>{{tipo.cantidad}}</td></tr></table></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=col-sm-3><button type=button class=\"btn btn-info btn-block\" ng-click=vm.volver()><span class=\"fa fa-arrow-left\"></span> Volver</button></div></div></div></div></div>");
$templateCache.put("app/app/main/empresa/sucursal/editar/editar-sucursal.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=form-group><label>Ingrese el nombre de la Sucursal:</label><input class=form-control ng-maxlength=255 ng-model=vm.sucursal.nombre placeholder=\"Ingrese el nombre de la sucursal\" type=text name=nombre required> <span uib-alert class=danger ng-if=\"vm.form.nombre.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.nombre.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=form-group><label>Ingrese o busque la Empresa:</label><input type=text ng-model=vm.sucursal.empresa placeholder=\"Seleccione o busque la Empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-editable=false typeahead-min-length=0 required name=empresa> <span uib-alert class=danger ng-show=\"vm.form.empresa.$error.required && vm.form.$dirty\">Este campo es requerido.</span></div><div class=form-group><label>Ingrese el código de sucursal:</label><input class=form-control ng-maxlength=255 ng-model=vm.sucursal.codigoSucursal placeholder=\"Ingrese el código de la sucursal\" type=text name=codigoSucursal required> <span uib-alert class=danger ng-show=\"vm.form.codigoSucursal.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.codigoSucursal.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=form-group><label>Ingrese la dirección de la sucursal:</label><input class=form-control ng-maxlength=255 ng-model=vm.sucursal.direccion placeholder=\"Ingrese la dirección de la sucursal\" type=text name=direccion> <span uib-alert class=danger ng-if=\"vm.form.direccion.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=form-group><label>Ingrese el email:</label><input class=form-control ng-maxlength=80 ng-model=vm.sucursal.mail placeholder=\"Ingrese el email del Encargado\" type=email name=mail required ng-pattern=/[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$/ > <span uib-alert class=danger ng-if=\"vm.form.mail.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 80 caracteres. </span><span uib-alert class=danger ng-if=\"vm.form.mail.$error.pattern && vm.form.$dirty\">Ingrese un mail válido. </span><span uib-alert class=danger ng-if=\"vm.form.mail.$error.required && vm.form.$dirty\">Este campo es requerido.</span></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.guardar() ng-disabled=\"vm.form.$invalid || !vm.sucursal.empresa.nombre\"><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/empresa/sucursal/lista/lista-sucursal.html","<!--     <formly-form model=\"vm.user\" fields=\"vm.userFields\">\r\n  <button type=\"submit\" class=\"btn btn-primary col-sm-offset-4 col-sm-4\" ng-click=\"vm.submit(vm.user)\">Submit</button>\r\n</formly-form> --><div><form><div class=\"form-group col-lg-12\"><div class=form-group><center><button ng-click=vm.crearNuevo() class=\"btn btn-success\" style=width:50%><i class=\"fa fa-plus\"></i> NUEVA SUCURSAL</button></center></div><div><label>Filtrar por empresa:</label><div class=col-lg-12><div class=\"form-group col-lg-1\"><input type=checkbox ng-model=vm.buscar ng-click=vm.busqueda()></div><div class=\"form-group col-lg-9\"><input ng-disabled=!vm.buscar type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0></div><div class=\"col-lg-2 form-group\"><button ng-disabled=\"!vm.buscar || !vm.empresa.nombre\" class=\"btn btn-primary\" ng-click=vm.filtrar()><span class=\"fa fa-search\"></span> Buscar</button></div></div></div><br><div ng-show=\"!vm.sucursales.length>0 && vm.bandera\" uib-alert class=\"danger col-lg-12 form-group\">No hay sucursales para la empresa seleccionada.</div></div><button class=\"btn btn-link\" ng-click=vm.exportToExcel() ng-show=\"vm.sucursales.length>0\"><span class=\"fa fa-file-excel-o\"></span> Exportar a Excel</button> <button class=\"btn btn-link\" ng-click=vm.reportePdf() ng-show=\"vm.sucursales.length>0\"><span class=\"fa fa-file-pdf-o\"></span> Exportar a PDF</button><div class=col-lg-12><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.sucursales.length>0\"><tr ng-repeat=\"sucursales in $data\"><td title=\"\'Empresa\'\" align=center data-sortable=\"\'empresa.nombre\'\">{{sucursales.empresa.nombre.toUpperCase();}}</td><td title=\"\'Nombre\'\" filter=\"{ nombre: \'text\'}\" data-sortable=\"\'nombre\'\">{{sucursales.nombre}}</td><td title=\"\'Código de sucursal\'\" filter=\"{ codigoSucursal: \'text\'}\" data-sortable=\"\'codigoSucursal\'\">{{sucursales.codigoSucursal.toUpperCase();}}</td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-primary\" ng-click=vm.irATopeSuministro(sucursales)><i class=\"fa fa-exclamation\"></i> </a><a class=\"btn btn-info\" ng-click=vm.mostrarInformacion(sucursales)><i class=\"fa fa-search\"></i> </a><a class=\"btn btn-warning\" ng-click=vm.editar(sucursales)><i class=\"fa fa-pencil\"></i> </a><a class=\"btn btn-danger\" ng-disabled=vm.bloquearPorRol(); ng-click=\"vm.bloquearPorRol() || vm.eliminar(sucursales)\"><i class=\"fa fa-trash\"></i></a></div></td></tr></table></div></form></div>");
$templateCache.put("app/app/main/empresa/solicitantes/editar/editar.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=\"col-lg-6 form-group\"><label>Nombre del solicitante:</label><input class=form-control ng-maxlength=255 ng-model=vm.solicitante.nombre placeholder=\"Ingrese el nombre del solicitante\" type=text name=nombre required> <span uib-alert class=danger ng-if=\"vm.form.nombre.$error.required && vm.form.nombre.$dirty\">Este campo es requerido.</span> <span uib-alert class=danger ng-if=\"vm.form.nombre.$error.maxlength && vm.form.nombre.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=\"col-lg-6 form-group\"><label>Apellido del solicitante:</label><input class=form-control ng-maxlength=255 ng-model=vm.solicitante.apellido placeholder=\"Ingrese el apellido del solicitante\" type=text name=apellido required> <span uib-alert class=danger ng-if=\"vm.form.apellido.$error.required && vm.form.apellido.$dirty\">Este campo es requerido.</span> <span uib-alert class=danger ng-if=\"vm.form.apellido.$error.maxlength && vm.form.apellido.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=\"col-lg-6 form-group\"><label>Empresa:</label><input type=text ng-model=vm.solicitante.empresa placeholder=\"Ingrese o busque la Empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 required name=empresa typeahead-editable=false> <span uib-alert class=danger ng-show=\"vm.form.empresa.$error.required && vm.form.empresa.$dirty\">Este campo es requerido.</span></div><div class=\"form-group col-lg-6\"><label>Sucursal:</label><input type=text ng-disabled=!vm.solicitante.empresa.nombre ng-model=vm.solicitante.sucursal placeholder=\"Seleccione o busque la sucursal\" uib-typeahead=\"sucursal as sucursal.nombre.toUpperCase() for sucursal in vm.sucursales | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=sucursal typeahead-editable=false focus-on=sucursal></div><div class=\"col-lg-4 form-group\"><label>N° de DNI del solicitante:</label><input class=form-control ng-maxlength=50 ng-model=vm.solicitante.dni placeholder=\"Ingrese el DNI del solicitante\" type=text name=dni> <span uib-alert class=danger ng-if=\"vm.form.dni.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 50 caracteres.</span></div><div class=\"col-lg-4 form-group\"><label>Teléfono del solicitante:</label><input class=form-control ng-maxlength=50 ng-model=vm.solicitante.telefono placeholder=\"Ingrese el teléfono del solicitante\" type=text name=telefono> <span uib-alert class=danger ng-if=\"vm.form.telefono.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 50 caracteres.</span></div><div class=\"col-lg-4 form-group\"><label>Email del solicitante:</label><input class=form-control ng-maxlength=100 ng-model=vm.solicitante.mail placeholder=\"Ingrese el email del solicitante\" type=email name=mail required ng-pattern=/[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$/ > <span uib-alert class=danger ng-if=\"vm.form.mail.$error.required && vm.form.mail.$dirty\">Este campo es requerido.</span> <span uib-alert class=danger ng-if=\"vm.form.mail.$error.maxlength && vm.form.mail.$dirty\">Este campo no puede superar los 100 caracteres. </span><span uib-alert class=danger ng-if=\"vm.form.mail.$error.pattern && vm.form.mail.$dirty\">Ingrese un mail válido.</span></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.guardar() ng-disabled=vm.form.$invalid><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/empresa/solicitantes/lista/lista.html","<div><form><div class=\"form-group col-lg-12\"><div class=form-group><center><button ng-click=vm.crearNuevo() class=\"btn btn-success\" style=width:50%><i class=\"fa fa-plus\"></i> NUEVO SOLICITANTE</button></center></div><div><label>Filtrar por empresa:</label><div class=col-lg-12><div class=\"form-group col-lg-1\"><input type=checkbox ng-model=vm.buscar ng-click=vm.busqueda()></div><div class=\"form-group col-lg-9\"><input ng-disabled=!vm.buscar type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0></div><div class=\"col-lg-2 form-group\"><button ng-disabled=\"!vm.buscar || !vm.empresa.nombre\" class=\"btn btn-primary\" ng-click=vm.filtrar()><span class=\"fa fa-search\"></span> Buscar</button></div></div></div><br><div ng-show=\"!vm.solicitantes.length>0 && vm.bandera\" uib-alert class=\"danger col-lg-12 form-group\">No hay solicitantes para la empresa seleccionada.</div></div><button class=\"btn btn-link\" ng-click=vm.exportToExcel() ng-show=\"vm.solicitantes.length>0\"><span class=\"glyphicon glyphicon-share\"></span> Exportar a Excel</button><div class=col-lg-12><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.solicitantes.length>0\"><tr ng-repeat=\"solicitantes in $data\"><td title=\"\'Empresa\'\" align=center data-sortable=\"\'empresa.nombre\'\">{{solicitantes.empresa.nombre.toUpperCase();}}</td><td title=\"\'Apellido\'\" filter=\"{ apellido: \'text\'}\" data-sortable=\"\'apellido\'\">{{solicitantes.apellido.toUpperCase();}}</td><td title=\"\'Nombre\'\" filter=\"{ nombre: \'text\'}\" data-sortable=\"\'nombre\'\">{{solicitantes.nombre.toUpperCase();}}</td><td title=\"\'Teléfono\'\">{{solicitantes.telefono? solicitantes.telefono : \"-\"}}</td><td title=\"\'Email\'\">{{solicitantes.mail? solicitantes.mail : \"-\"}}</td><td title=\"\'Sucursal\'\" align=center data-sortable=\"\'sucursal.nombre\'\">{{solicitantes.sucursal? solicitantes.sucursal.nombre.toUpperCase():\"-\"}}</td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-primary\" ng-click=vm.abrirSeleccionTipos(solicitantes)><i class=\"fa fa-filter\"></i> </a><a class=\"btn btn-info\" ng-click=vm.mostrarInformacion(solicitantes)><i class=\"fa fa-search\"></i> </a><a class=\"btn btn-warning\" ng-click=vm.editar(solicitantes)><i class=\"fa fa-pencil\"></i> </a><a class=\"btn btn-danger\" ng-disabled=vm.bloquearPorRol(); ng-click=\"vm.bloquearPorRol() || vm.eliminar(solicitantes)\"><i class=\"fa fa-trash\"></i></a></div></td></tr></table></div></form></div>");
$templateCache.put("app/app/main/empresa/solicitantes/tipos-no-solicitables/tipos-no-solicitables.html","<div class=row><center><button ng-click=vm.actualizar() class=\"btn btn-success\" style=width:25%><i class=\"fa fa-check\"></i> Actualizar</button> <button ng-click=vm.cancelar() class=\"btn btn-danger\" style=width:25%><i class=\"fa fa-remove\"></i> Cancelar</button></center></div><div class=row><div class=col-lg-12><div class=panel-default><div class=\"form-group col-lg-4\"><label>Solicitante:</label><input type=text ng-model=vm.solicitanteString class=\"form-control text-uppercase input-sm\" ng-readonly=true></div><div class=\"form-group col-lg-3\"><label>Empresa:</label><input type=text ng-model=vm.solicitante.empresa.nombre class=\"form-control text-uppercase input-sm\" ng-readonly=true></div><div class=\"form-group col-lg-5\"><label>Sucursal:</label><input type=text ng-model=vm.sucursalString class=\"form-control text-uppercase input-sm\" ng-readonly=true></div></div></div></div><div class=\"row col-lg-12\"><div uib-alert type=info><i class=\"fa fa-info-circle\"></i> Seleccionar los productos que desee que el solicitante <b>NO</b> pueda incluir ni visualizar a la hora de registrar un pedido.</div></div><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><div class=\"panel panel-body\"><div class=col style=\"height:80vh; overflow: auto\" ng-if=\"vm.grupos.length>0\"><div class=col><button class=\"btn btn-default btn-xs\" ng-click=vm.colapsarTodos();><i class=\"fa fa-compress\"></i> Colapsar</button> <button class=\"btn btn-default btn-xs\" ng-click=vm.expandirTodos();><i class=\"fa fa-expand\"></i> Expandir</button></div><table class=\"table table-bordered\" show-group=false style=\"overflow: auto\"><thead><th colspan=2>Nombre</th><th>Marcar como NO solicitable</th></thead><tr class=ng-table-group ng-init=\"grupo.$hideRows = true\" ng-repeat-start=\"grupo in vm.grupos track by $index\" style=\"background-color: white\" ng-class=\"{\'rojo-claro\': grupo.seleccionado}\"><td colspan=2 ng-style=\"\"><a href=\"\" ng-click=\"grupo.$hideRows = !grupo.$hideRows\"><span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': grupo.$hideRows, \'glyphicon-chevron-down\': !grupo.$hideRows }\"></span> {{ grupo.grupo.nombre.toUpperCase(); }}</a></td><td><input type=checkbox ng-model=grupo.seleccionado ng-click=\"vm.seleccionarGrupo(grupo, grupo.seleccionado);\"></td></tr><tr ng-init=\"familia.$hideRows = true\" ng-repeat-start=\"familia in grupo.familias track by familia.familia.id\" style=\"background-color: #f5f5f5\" ng-hide=grupo.$hideRows ng-class=\"{\'rojo-claro\': familia.seleccionado}\"><td colspan=2>&nbsp;&nbsp;<a href=\"\" ng-click=\"familia.$hideRows = !familia.$hideRows\"> <span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': familia.$hideRows, \'glyphicon-chevron-down\': !familia.$hideRows }\"></span> {{ familia.familia.nombre.toUpperCase()+\" - (\"+familia.familia.codigoFamiliaSuministro+\")\" }}</a></td><td><input type=checkbox ng-model=familia.seleccionado ng-click=\"vm.seleccionarFamilia(familia, familia.seleccionado);\"></td></tr><tr ng-init=\"tipo.$hideRows = true\" ng-repeat-start=\"tipo in familia.tipos track by tipo.id\" ng-hide=familia.$hideRows style=background-color:#d9d9d9 ng-class=\"{\'rojo-claro\': tipo.seleccionado}\"><td colspan=2>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ tipo.nombre.toUpperCase()+\" - (\"+tipo.codigoProducto+\")\" }}</td><td><input type=checkbox ng-model=tipo.seleccionado></td></tr><tr ng-repeat-end></tr><tr ng-repeat-end></tr><tr ng-repeat-end></tr></table></div><div ng-if=\"vm.lista.length==0\" uib-alert>No hay registros</div></div></div></div></div>");
$templateCache.put("app/app/main/empresa/tope-suministros/editar/editar.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><div class=col-lg-12><div class=form-group><label>Sucursal:</label><input type=text ng-readonly=true ng-model=vm.sucursal.nombre class=\"form-control text-uppercase\"></div></div><div class=\"col-lg-12 panel\"><label>Tipo de suministro:</label><input ng-if=vm.tipoSuministro.id type=text ng-readonly=true ng-model=vm.tipoFormateado class=\"form-control text-uppercase\"><div class=panel-body><div class=form-group><center><div><button class=\"btn btn-primary\" style=width:60% ng-click=vm.abrirModalSeleccionTipoSuministro();><div ng-if=!vm.tipoSuministro.id><i class=\"fa fa-exchange pull-rigth\"></i> Seleccionar tipo de suministro</div><div ng-if=vm.tipoSuministro.id><i class=\"fa fa-exchange pull-rigth\"></i> Cambiar tipo de suministro</div></button></div></center></div></div></div><div class=col-lg-12><div class=form-group><label>Cantidad tope:</label><input type=number required ng-pattern=/^[0-9]{1,7}$/ class=form-control ng-model=vm.tope.cantidadTope placeholder=\"Ingrese el nombre del kit\" name=cantidadTope> <span uib-alert ng-if=\"vm.form.cantidadTope.$error.required && vm.form.cantidadTope.$dirty\">Este campo es requerido. </span><span uib-alert ng-if=\"(vm.form.cantidadTope.$error.number || vm.form.cantidadTope.$error.pattern) && vm.form.cantidadTope.$dirty\">Ingrese un valor válido</span></div></div></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.guardar() ng-disabled=\"vm.form.$invalid || !vm.tipoSuministro.id\"><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/empresa/tope-suministros/editar-sucursal-tipo/editar-sucursal-tipo.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><div class=col-lg-12><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.empresa ng-disabled=\"vm.esEditar() || vm.tieneEmpresa\" placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 required name=empresa typeahead-editable=false focus-on=empresa></div><div class=\"form-group col-lg-6\"><label>Sucursal:</label><input type=text ng-model=vm.sucursal ng-disabled=!vm.empresa.id placeholder=\"Seleccione o busque la sucursal\" uib-typeahead=\"sucursal as sucursal.nombre.toUpperCase() for sucursal in vm.sucursales | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 required name=sucursal typeahead-editable=false focus-on=sucursal></div></div><div class=\"col-lg-12 panel\"><label>Tipo de suministro:</label><input ng-if=vm.tipoSuministro.id type=text ng-readonly=true ng-model=vm.tipoFormateado class=\"form-control text-uppercase\"><div class=panel-body><div class=form-group><center><div><button ng-disabled=!vm.empresa.id class=\"btn btn-primary\" style=width:60% ng-click=vm.abrirModalSeleccionTipoSuministro();><div ng-if=!vm.tipoSuministro.id><i class=\"fa fa-exchange pull-rigth\"></i> Seleccionar tipo de suministro</div><div ng-if=vm.tipoSuministro.id><i class=\"fa fa-exchange pull-rigth\"></i> Cambiar tipo de suministro</div></button></div></center></div></div></div><div class=col-lg-12><div class=form-group><label>Cantidad tope:</label><input type=number required ng-pattern=/^[0-9]{1,7}$/ class=form-control ng-model=vm.tope.cantidadTope placeholder=\"Ingrese el nombre del kit\" name=cantidadTope> <span uib-alert ng-if=\"vm.form.cantidadTope.$error.required && vm.form.cantidadTope.$dirty\">Este campo es requerido. </span><span uib-alert ng-if=\"(vm.form.cantidadTope.$error.number || vm.form.cantidadTope.$error.pattern) && vm.form.cantidadTope.$dirty\">Ingrese un valor válido</span></div></div></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.guardar() ng-disabled=\"vm.form.$invalid || !vm.tipoSuministro.id\"><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/empresa/tope-suministros/lista/lista.html","<!--     <formly-form model=\"vm.user\" fields=\"vm.userFields\">\r\n  <button type=\"submit\" class=\"btn btn-primary col-sm-offset-4 col-sm-4\" ng-click=\"vm.submit(vm.user)\">Submit</button>\r\n</formly-form> --><div><form><div class=\"form-group col-lg-12\"><div class=form-group><center><button ng-click=vm.crearNuevo() class=\"btn btn-success\" style=width:50%><i class=\"fa fa-plus\"></i> NUEVO TOPE</button></center></div><div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=form-group><label>Sucursal:</label><input type=text ng-readonly=true ng-model=vm.sucursal.nombre class=\"form-control text-uppercase\"></div></div></div></div><br><br><div ng-show=\"!vm.topes.length>0\" uib-alert class=\"danger col-lg-12 form-group\">No hay topes para esta sucursal</div></div><div class=col-lg-12><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.topes.length>0\"><tr ng-repeat=\"tope in $data\"><td title=\"\'Familia de suministro\'\" data-sortable=\"\'tipoSuministro.familiaSuministro.nombre\'\" align=center>{{tope.tipoSuministro.familiaSuministro.nombre.toUpperCase();}}</td><td title=\"\'Tipo de suministro\'\" filter=\"{ \'tipoSuministro.nombre\': \'text\'}\" data-sortable=\"\'tipoSuministro.nombre\'\" align=center>{{tope.tipoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Tope\'\" align=center>{{tope.cantidadTope}}</td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-warning\" ng-click=vm.editar(tope)><i class=\"fa fa-pencil\"></i> </a><a class=\"btn btn-danger\" ng-disabled=vm.bloquearPorRol(); ng-click=\"vm.bloquearPorRol() || vm.eliminar(tope)\"><i class=\"fa fa-trash\"></i></a></div></td></tr></table></div><div class=col-lg-12><button class=\"btn btn-info\" ng-click=vm.volver()><i class=\"fa fa-arrow-left\"></i> Volver</button></div></form></div>");
$templateCache.put("app/app/main/empresa/tope-suministros/lista-sucursal-tipo/lista-sucursal-tipo.html","<!--     <formly-form model=\"vm.user\" fields=\"vm.userFields\">\r\n  <button type=\"submit\" class=\"btn btn-primary col-sm-offset-4 col-sm-4\" ng-click=\"vm.submit(vm.user)\">Submit</button>\r\n</formly-form> --><div><form><div class=\"form-group col-lg-12\"><div class=form-group><center><button ng-click=vm.crearNuevo() class=\"btn btn-primary\" style=width:30%><i class=\"fa fa-plus\"></i> NUEVO TOPE</button> <button ng-click=vm.cargarExcel() class=\"btn btn-success\" style=width:30%><i class=\"fa fa-plus\"></i> CARGAR TOPES DESDE UN EXCEL (.xlsx)</button></center></div><div ng-show=\"!vm.topes.length>0\" uib-alert class=\"danger col-lg-12 form-group\">No hay información para mostrar</div></div><button class=\"btn btn-link\" ng-click=vm.exportToExcel() ng-show=\"vm.topes.length>0\"><span class=\"fa fa-file-excel-o\"></span> Exportar a Excel</button><div class=col-lg-12><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.topes.length>0\"><tr ng-repeat=\"tope in $data\"><td title=\"\'Empresa\'\" data-sortable=\"\'sucursal.empresa.nombre\'\" align=center>{{tope.sucursal.empresa.nombre.toUpperCase();}}</td><td title=\"\'Sucursal\'\" filter=\"{ \'sucursal.nombre\': \'text\'}\" data-sortable=\"\'sucursal.nombre\'\" align=center>{{tope.sucursal.nombre.toUpperCase();}}</td><td title=\"\'Familia de suministro\'\" data-sortable=\"\'tipoSuministro.familiaSuministro.nombre\'\" align=center>{{tope.tipoSuministro.familiaSuministro.nombre.toUpperCase();}}</td><td title=\"\'Tipo de suministro\'\" filter=\"{ \'tipoSuministro.nombre\': \'text\'}\" data-sortable=\"\'tipoSuministro.nombre\'\" align=center>{{tope.tipoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Tope\'\" align=center>{{tope.cantidadTope}}</td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-warning\" ng-click=vm.editar(tope)><i class=\"fa fa-pencil\"></i> </a><a class=\"btn btn-danger\" ng-disabled=vm.bloquearPorRol(); ng-click=\"vm.bloquearPorRol() || vm.eliminar(tope)\"><i class=\"fa fa-trash\"></i></a></div></td></tr></table></div></form></div>");
$templateCache.put("app/app/main/egreso/egreso/lista-despachados/lista-despachados.html","<div><form><div class=col-lg-12><div class=\"col-lg-12 panel\"><div class=col-lg-10><div class=form-group><label ng-if=!vm.bandera>Seleccione el depósito:</label><label ng-if=vm.bandera>Depósito seleccionado:</label><input type=text ng-disabled=vm.bandera ng-model=vm.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><br><div class=col-lg-2 ng-if=!vm.bandera><button style=width:100% ng-disabled=!vm.deposito.id ng-click=vm.buscarPorDeposito() class=\"btn btn-primary\"><i class=\"fa fa-filter\"></i> Filtrar</button></div><div class=col-lg-2 ng-if=vm.bandera><button style=width:100% ng-click=vm.cambiarFiltros() class=\"btn btn-warning\"><i class=\"fa fa-exchange\"></i> Cambiar filtros</button></div></div></div><div class=\"col col-lg-12\" ng-if=\"vm.rol.id<=3 && vm.bandera\"><div class=col><div class=form-check><label class=form-check-label for=filtrosCheckbox>Filtrar despachos &nbsp;&nbsp;</label><input type=checkbox id=filtrosCheckbox class=form-check-input ng-model=vm.buscar ng-click=vm.busqueda()></div><div class=form-group><div class=form-group style=\"display:flex; justify-content: space-between\"><div style=\"width:30%; margin: 0px 2px 0px 2px\"><center><button class=\"btn btn-primary btn-block\" ng-disabled=!vm.buscar ng-click=vm.abrirModalFiltros()><span class=\"fa fa-filter\"></span> Abrir filtros por fechas y número de egreso</button></center></div></div></div></div></div><br><div class=col-lg-12><div uib-alert type=info ng-show=vm.filtrosUsados>FILTROS APLICADOS:<div ng-repeat=\"filtro in vm.filtrosUsados\">{{vm.filtrosUsados[$index]}}</div></div></div><div class=col-lg-12 ng-if=\"vm.deposito.id && vm.egresos.length==0 && vm.bandera\"><span uib-alert>No hay registros para los filtros y/o el depósito seleccionado</span></div><div class=col-lg-12 ng-if=\"vm.deposito.id && vm.egresos.length>0 && vm.bandera\"><div class=col-lg-12><label>Listado de despachos de egresos:</label></div><div class=container-fluid><div class=col-lg-12 ng-if=\"vm.deposito.id && vm.egresos.length>0 && vm.bandera\"><table ng-table=vm.tableParams class=\"table table-condensed\" show-filter=true><tr ng-repeat=\"egresos in $data\"><div><td data-title=\"\'Fecha\'\" align=center sortable>{{egresos.fecha | date : \"dd/MM/yyyy HH:mm\" }}</td><td data-title=\"\'Empresa\'\" align=center sortable filter=\"{\'empresa.nombre\': \'text\'}\">{{egresos.empresa.nombre.toUpperCase();}}</td><td data-title=\"\'Empresa Logística\'\" align=center sortable filter=\"{\'empresaLogistica.nombre\': \'text\'}\">{{egresos.empresaLogistica.nombre.toUpperCase();}}</td><td data-title=\"\'N° Egreso\'\" style=width:5% align=center filter=\"{\'numeroEgreso\':\'text\'}\" sortable>{{egresos.numeroEgreso}}</td><td data-title=\"\'Estado\'\" style=width:5% align=center>{{egresos.estadoEgreso.nombre.toUpperCase();}}</td><td data-title=\"\'Ver\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.visualizarEgreso(egresos)><i class=\"fa fa-search\"></i></a></div></td></div></tr></table></div></div></div></form></div>");
$templateCache.put("app/app/main/egreso/egreso/lista-preparados/lista-preparados.html","<script type=text/ng-template id=headerCheckbox.html><label>Todos</label>\r\n    <input type=\"checkbox\" ng-click=\"vm.marcarTodo();\" ng-model=\"vm.check\" ng-value=\"vm.check.valor\"/></script><div><form><div class=col-lg-12><div class=\"col-lg-12 panel\"><div class=col-lg-5><div class=form-group><label ng-if=!vm.bandera>Seleccione el depósito:</label><label ng-if=vm.bandera>Depósito seleccionado:</label><input type=text ng-disabled=vm.bandera ng-model=vm.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div class=col-lg-5><div class=form-group><label ng-if=!vm.bandera>Seleccione la empresa:</label><label ng-if=vm.bandera>Empresa seleccionada:</label><input ng-disabled=\"!vm.deposito.id || vm.bandera\" type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" focus-on=empresa class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><br><div class=col-lg-2 ng-if=!vm.bandera><button style=width:100% ng-disabled=\"!vm.deposito.id || !vm.empresa.id\" ng-click=vm.buscarPorEmpresaDeposito() class=\"btn btn-primary\"><i class=\"fa fa-filter\"></i> Filtrar</button></div><div class=col-lg-2 ng-if=vm.bandera><button style=width:100% ng-click=vm.cambiarFiltros() class=\"btn btn-warning\"><i class=\"fa fa-exchange\"></i> Cambiar filtros</button></div><div class=col-lg-12 ng-if=\"vm.deposito.id && vm.empresa.id && vm.egresos.length==0 && vm.bandera\"><span uib-alert>No hay egresos generados para el depósito seleccionado</span></div></div></div><div class=form-group ng-if=\"vm.deposito.id && vm.empresa.id && vm.egresos.length>0 && vm.bandera\"><center><button ng-disabled=!vm.comprobarSeleccionado(); ng-click=vm.despacharSeleccionados() class=\"btn btn-primary\" style=width:50%><i class=\"fa fa-truck\"></i> DESPACHAR SELECCIONADOS</button></center></div><div class=col-lg-12 ng-if=\"vm.deposito.id && vm.empresa.id && vm.egresos.length>0 && vm.bandera\"><div class=col-lg-12><label>Listado de egresos preparados:</label></div><div class=container-fluid><div class=col-lg-12 ng-if=\"vm.deposito.id && vm.empresa.id && vm.egresos.length>0 && vm.bandera\"><table ng-table=vm.tableParams class=\"table table-condensed\" show-filter=true><tr ng-repeat=\"egresos in $data\" ng-class=\"{\'azul-claro\': egresos.seleccionado}\"><div><td data-title=\"\'Fecha\'\" align=center sortable>{{egresos.fecha | date : \"dd/MM/yyyy HH:mm\" }}</td><td data-title=\"\'Empresa\'\" align=center>{{egresos.empresa.nombre.toUpperCase();}}</td><td data-title=\"\'Sucursal\'\" sortable filter=\"{\'sucursal.nombre\': \'text\'}\" align=center>{{egresos.sucursal.nombre.toUpperCase();}}</td><td data-title=\"\'¿Cajas?\'\" align=center sortable>{{egresos.caja? \"Si\" : \"No\"}} <button class=btn ng-if=egresos.caja ng-click=vm.verNumeroCajasEgreso(egresos);><i class=\"fa fa-search\"></i></button></td><td data-title=\"\'N° Vale\'\" align=center filter=\"{\'numeroVale\':\'text\'}\" sortable>{{egresos.numeroVale? egresos.numeroVale : \"-\"}}</td><td data-title=\"\'N° Movimiento\'\" style=width:5% align=center filter=\"{\'numeroMovimiento\':\'text\'}\" sortable>{{egresos.numeroMovimiento}}</td><td data-title=\"\'Estado\'\" style=width:5% align=center>{{egresos.estadoMovimiento.nombre.toUpperCase();}}</td><td data-title=\"\'Ver\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-disabled=\"egresos.estadoMovimiento.id!=2\" ng-click=\"egresos.estadoMovimiento.id!=2 || vm.visualizarEgreso(egresos)\"><i class=\"fa fa-search\"></i></a></div></td><td header=\"\'headerCheckbox.html\'\" align=center><input type=checkbox ng-model=egresos.seleccionado></td></div></tr></table></div></div></div></form></div>");
$templateCache.put("app/app/main/egreso/empresa-logistica/editar/editar-empresa-logistica.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=form-group><label>Ingrese el nombre de la empresa de logística:</label><input class=form-control ng-maxlength=255 ng-model=vm.empresa.nombre placeholder=\"Ingrese el nombre de la empresa de logística\" type=text name=proveedor required> <span uib-alert class=danger ng-if=\"vm.form.proveedor.$error.required && vm.form.$dirty\">Este campo es requerido.</span> <span uib-alert class=danger ng-if=\"vm.form.proveedor.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=form-group><label>Ingrese la descripción:</label><input class=form-control ng-maxlength=500 ng-model=vm.empresa.descripcion placeholder=\"Ingrese la descripción de la empresa de logística\" type=text name=descripcion> <span uib-alert class=danger ng-if=\"vm.form.descripcion.$error.required && vm.form.$dirty\">Este campo es requerido.</span> <span uib-alert class=danger ng-if=\"vm.form.descripcion.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 500 caracteres.</span></div><div class=form-group><label>Ingrese o busque la Empresa:</label><input type=text ng-model=vm.empresa.empresa placeholder=\"Seleccione o busque la Empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-editable=false typeahead-show-hint=true typeahead-min-length=0 required name=empresa typeahead-editable=false> <span uib-alert class=danger ng-show=\"vm.form.empresa.$error.required && vm.form.$dirty\">Este campo es requerido.</span></div><div class=form-group><label>Ingrese el email para reclamos:</label><input class=form-control ng-maxlength=80 ng-model=vm.empresa.mailReclamo placeholder=\"Ingrese el email para reclamos\" type=email name=mailReclamo ng-pattern=/[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$/ > <span uib-alert class=danger ng-if=\"vm.form.mailReclamo.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 80 caracteres. </span><span uib-alert class=danger ng-if=\"vm.form.mailReclamo.$error.pattern && vm.form.$dirty\">Ingrese un mail válido.</span></div><br><div class=\"form-group col-xs-6\"><label>Ingrese el nombre del Encargado:</label><input class=form-control ng-maxlength=255 ng-model=vm.empresa.nombreEncargado placeholder=\"Ingrese el nombre del Encargado\" type=text name=nombreEncargado> <span uib-alert class=danger ng-if=\"vm.form.nombreEncargado.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=\"form-group col-xs-6\"><label>Ingrese el apellido del Encargado:</label><input class=form-control ng-maxlength=255 ng-model=vm.empresa.apellidoEncargado placeholder=\"Ingrese el apellido del Encargado\" type=text name=apellidoEncargado> <span uib-alert class=danger ng-if=\"vm.form.apellidoEncargado.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=\"form-group col-xs-6\"><label>Ingrese el teléfono del Encargado:</label><input class=form-control ng-maxlength=20 ng-model=vm.empresa.telefonoEncargado placeholder=\"Ingrese el teléfono del Encargado\" type=text name=telefonoEncargado ng-pattern=/^([0-9])*$/ > <span uib-alert class=danger ng-if=\"vm.form.telefonoEncargado.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 20 caracteres. </span><span uib-alert class=danger ng-if=\"vm.form.telefonoEncargado.$error.pattern && vm.form.$dirty\">Ingrese un valor válido.</span></div><div class=\"form-group col-xs-6\"><label>Ingrese el email del Encargado:</label><input class=form-control ng-maxlength=80 ng-model=vm.empresa.mailEncargado placeholder=\"Ingrese el email del Encargado\" type=email name=mailEncargado ng-pattern=/[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$/ > <span uib-alert class=danger ng-if=\"vm.form.mailEncargado.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 80 caracteres. </span><span uib-alert class=danger ng-if=\"vm.form.mailEncargado.$error.pattern && vm.form.$dirty\">Ingrese un mail válido.</span></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.guardar() ng-disabled=\"vm.form.$invalid || !vm.empresa.empresa.nombre\"><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/egreso/empresa-logistica/lista/lista-empresa-logistica.html","<div><form><div class=form-group><center><button ng-click=vm.crearNuevo() class=\"btn btn-success\" style=width:50%><i class=\"fa fa-plus\"></i> NUEVA EMPRESA DE LOGÍSTICA</button></center></div><button class=\"btn btn-link\" ng-click=vm.exportToExcel()><span class=\"fa fa-file-excel-o\"></span> Exportar a Excel</button> <button class=\"btn btn-link\" ng-click=vm.reportePdf()><span class=\"fa fa-file-pdf-o\"></span> Exportar a PDF</button><div class=col-lg-12><table id=table1 ng-table=vm.tableParams class=table show-filter=true ng-show=vm.empresas><tr ng-repeat=\"empresa in $data\"><td title=\"\'Empresa\'\" data-sortable=\"\'empresa.nombre\'\">{{empresa.empresa.nombre.toUpperCase()}}</td><td title=\"\'Nombre\'\" filter=\"{ nombre: \'text\'}\" data-sortable=\"\'nombre\'\">{{empresa.nombre.toUpperCase();}}</td><td title=\"\'Descripción\'\">{{empresa.descripcion}}</td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.mostrarInformacion(empresa)><i class=\"fa fa-search\"></i> </a><a class=\"btn btn-warning\" ng-click=vm.editar(empresa)><i class=\"fa fa-pencil\"></i> </a><a class=\"btn btn-danger\" ng-disabled=vm.bloquearPorRol(); ng-click=\"vm.bloquearPorRol() || vm.eliminar(empresa)\"><i class=\"fa fa-trash\"></i></a></div></td></tr></table></div></form></div>");
$templateCache.put("app/app/main/egreso/persona-empresa-logistica/editar/editar-persona-empresa-logistica.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=form-group><label>Nombre de la persona:</label><input class=form-control ng-maxlength=255 ng-model=vm.persona.nombre placeholder=\"Ingrese el nombre de la persona\" type=text name=nombre required> <span uib-alert class=danger ng-if=\"vm.form.nombre.$error.required && vm.form.$dirty\">Este campo es requerido.</span> <span uib-alert class=danger ng-if=\"vm.form.nombre.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=form-group><label>Apellido de la persona:</label><input class=form-control ng-maxlength=255 ng-model=vm.persona.apellido placeholder=\"Ingrese el apellido de la persona\" type=text name=apellido required> <span uib-alert class=danger ng-if=\"vm.form.apellido.$error.required && vm.form.$dirty\">Este campo es requerido.</span> <span uib-alert class=danger ng-if=\"vm.form.apellido.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=form-group><label>Ingrese o busque la Empresa de logística:</label><input type=text ng-model=vm.persona.empresaLogistica placeholder=\"Seleccione o busque la Empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase()+\' (\'+empresa.empresa.nombre.toUpperCase()+\')\' for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 required name=empresa typeahead-editable=false> <span uib-alert class=danger ng-show=\"vm.form.empresa.$error.required && vm.form.$dirty\">Este campo es requerido.</span></div><div class=form-group><label>N° de DNI de la persona:</label><input class=form-control ng-maxlength=50 ng-model=vm.persona.dni placeholder=\"Ingrese el DNI de la persona\" type=text name=dni> <span uib-alert class=danger ng-if=\"vm.form.dni.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 50 caracteres.</span></div><div class=form-group><label>Teléfono de la persona:</label><input class=form-control ng-maxlength=50 ng-model=vm.persona.telefono placeholder=\"Ingrese el teléfono de la persona\" type=text name=telefono> <span uib-alert class=danger ng-if=\"vm.form.telefono.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 50 caracteres.</span></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.guardar() ng-disabled=\"vm.form.$invalid || !vm.persona.empresaLogistica.nombre\"><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/egreso/persona-empresa-logistica/lista/lista-persona-empresa-logistica.html","<!--     <formly-form model=\"vm.user\" fields=\"vm.userFields\">\r\n  <button type=\"submit\" class=\"btn btn-primary col-sm-offset-4 col-sm-4\" ng-click=\"vm.submit(vm.user)\">Submit</button>\r\n</formly-form> --><div><form><div class=\"form-group col-lg-12\"><div class=form-group><center><button ng-click=vm.crearNuevo() class=\"btn btn-success\" style=width:50%><i class=\"fa fa-plus\"></i> NUEVA PERSONA DE EMPRESA DE LOGÍSTICA</button></center></div><div><label>Filtrar por empresa de logística:</label><div class=col-lg-12><div class=\"form-group col-lg-1\"><input type=checkbox ng-model=vm.buscar ng-click=vm.busqueda()></div><div class=\"form-group col-lg-9\"><input ng-disabled=!vm.buscar type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase()+\' (\'+empresa.empresa.nombre.toUpperCase()+\')\' for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0></div><div class=\"col-lg-2 form-group\"><button ng-disabled=\"!vm.buscar || !vm.empresa.nombre\" class=\"btn btn-primary\" ng-click=vm.filtrar()><span class=\"fa fa-search\"></span> Buscar</button></div></div></div><br><div ng-show=\"!vm.personas.length>0 && vm.bandera\" uib-alert class=\"danger col-lg-12 form-group\">No hay personas para la empresa de logística seleccionada.</div></div><button class=\"btn btn-link\" ng-click=vm.exportToExcel() ng-show=\"vm.personas.length>0\"><span class=\"glyphicon glyphicon-share\"></span> Exportar a Excel</button><div class=col-lg-12><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.personas.length>0\"><tr ng-repeat=\"personas in $data\"><td title=\"\'Empresa\'\" align=center data-sortable=\"\'empresaLogistica.nombre\'\">{{personas.empresaLogistica.nombre.toUpperCase();}}</td><td title=\"\'Apellido\'\" filter=\"{ apellido: \'text\'}\" data-sortable=\"\'apellido\'\">{{personas.apellido.toUpperCase();}}</td><td title=\"\'Nombre\'\" filter=\"{ nombre: \'text\'}\" data-sortable=\"\'nombre\'\">{{personas.nombre.toUpperCase();}}</td><td title=\"\'Teléfono\'\">{{personas.telefono? personas.telefono : \"-\"}}</td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.mostrarInformacion(personas)><i class=\"fa fa-search\"></i> </a><a class=\"btn btn-warning\" ng-click=vm.editar(personas)><i class=\"fa fa-pencil\"></i> </a><a class=\"btn btn-danger\" ng-disabled=vm.bloquearPorRol(); ng-click=\"vm.bloquearPorRol() || vm.eliminar(personas)\"><i class=\"fa fa-trash\"></i></a></div></td></tr></table></div></form></div>");
$templateCache.put("app/app/main/egreso/solicitud-suministros/editar/editar-solicitud-suministros.html","<div class=col-lg-12><div class=form-group><center><button ng-click=vm.abrirModal() class=\"btn btn-primary\" style=width:30%><i class=\"fa fa-plus\"></i> Agregar suministros..</button> <button ng-click=vm.guardar() class=\"btn btn-success\" style=width:30%><i class=\"fa fa-plus\"></i> Guardar</button></center></div><form name=vm.form><div class=\"panel panel-default\"><div class=panel-heading>Agregar suministros..</div><div class=panel-body><div class=\"form-group col-lg-6\"><label>Grupo de suministro:</label><input type=text ng-model=vm.grupo placeholder=\"Seleccione o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase()+\' (\'+grupo.empresa.nombre.toUpperCase()+\')\' for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Familia de suministro:</label><input ng-disabled=!vm.grupo.nombre type=text ng-model=vm.familiaSuministro placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familiaSuministro as familiaSuministro.nombre.toUpperCase() for familiaSuministro in vm.familias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-8\"><label>Suministro:</label><input ng-disabled=\"!vm.grupo.nombre || !vm.familiaSuministro.nombre\" type=text ng-model=vm.suministro placeholder=\"Seleccione o busque el suministro\" uib-typeahead=\"suministro as suministro.nombre.toUpperCase() for suministro in vm.suministros | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"col-lg-4 form-group\"><label>Cantidad:</label><input class=form-control ng-maxlength=2 ng-model=vm.cantidad placeholder=Cantidad type=number name=cantidad ng-pattern=/^[1-9][0-9]{0}/ required> <span uib-alert class=danger ng-if=\"vm.form.cantidad.$error.required && vm.form.cantidad.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.cantidad.$error.maxlength && vm.form.cantidad.$dirty\">Este campo no puede superar los 3 caracteres. </span><span uib-alert class=danger ng-if=\"(vm.form.cantidad.$error.number || vm.form.cantidad.$error.pattern) && vm.form.$dirty\">Ingrese un valor válido.</span></div><center><div class=form-group style=width:60%><button ng-disabled=\"!vm.grupo.nombre || !vm.familiaSuministro.nombre || !vm.suministro.nombre || vm.form.$invalid\" class=\"btn btn-primary\" ng-click=vm.agregar() style=width:100%><span class=\"fa fa-plus\"></span> Agregar</button></div></center></div></div></form><div class=col-lg-12 ng-show=\"vm.detalles.length==0\"><span uib-alert class=danger>No ha agregado ningún suministro.</span></div><div class=\"col-lg-12 form-group\" ng-show=\"vm.detalles.length>0\"><label>Detalle:</label></div><form ng-show=true><div class=col-lg-12 ng-show=\"vm.detalles.length>0\"><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.detalles.length>0\"><tr ng-repeat=\"detalles in $data\"><td title=\"\'Suministro\'\" sortable>{{detalles.suministro.nombre.toUpperCase();}}</td><td title=\"\'Familia suministro\'\" sortable>{{detalles.suministro.familiaSuministro.nombre.toUpperCase();}}</td><td title=\"\'Grupo suministro\'\" sortable>{{detalles.suministro.familiaSuministro.grupoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Cantidad\'\" filter=\"{ nombre: \'text\'}\" sortable>{{detalles.cantidad}}</td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.mostrarInformacion(detalles)><i class=\"fa fa-search\"></i> </a><!-- 							<a class=\"btn btn-warning\" ng-click=\"vm.editar(detalles)\">\r\n	<i class=\"fa fa-pencil\"></i>\r\n</a> --> <a class=\"btn btn-danger\" ng-click=vm.eliminar($index)><i class=\"fa fa-trash\"></i></a></div></td></tr></table></div></form></div>");
$templateCache.put("app/app/main/ingreso/persona-proveedor/editar/editar-persona-proveedor.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=form-group><label>Nombre de la persona:</label><input class=form-control ng-maxlength=255 ng-model=vm.persona.nombre placeholder=\"Ingrese el nombre de la persona\" type=text name=nombre required> <span uib-alert class=danger ng-if=\"vm.form.nombre.$error.required && vm.form.$dirty\">Este campo es requerido.</span> <span uib-alert class=danger ng-if=\"vm.form.nombre.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=form-group><label>Apellido de la persona:</label><input class=form-control ng-maxlength=255 ng-model=vm.persona.apellido placeholder=\"Ingrese el apellido de la persona\" type=text name=apellido required> <span uib-alert class=danger ng-if=\"vm.form.apellido.$error.required && vm.form.$dirty\">Este campo es requerido.</span> <span uib-alert class=danger ng-if=\"vm.form.apellido.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=form-group><label>Ingrese o busque el Proveedor:</label><input type=text ng-model=vm.persona.proveedor placeholder=\"Seleccione o busque la Empresa\" uib-typeahead=\"proveedor as proveedor.nombre.toUpperCase()+\' (\'+proveedor.empresa.nombre.toUpperCase()+\')\' for proveedor in vm.proveedores | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 required name=proveedor typeahead-editable=false> <span uib-alert class=danger ng-show=\"vm.form.proveedor.$error.required && vm.form.$dirty\">Este campo es requerido.</span></div><div class=form-group><label>N° de DNI de la persona:</label><input class=form-control ng-maxlength=50 ng-model=vm.persona.dni placeholder=\"Ingrese el DNI de la persona\" type=text name=dni> <span uib-alert class=danger ng-if=\"vm.form.dni.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 50 caracteres.</span></div><div class=form-group><label>Teléfono de la persona:</label><input class=form-control ng-maxlength=50 ng-model=vm.persona.telefono placeholder=\"Ingrese el teléfono de la persona\" type=text name=telefono> <span uib-alert class=danger ng-if=\"vm.form.telefono.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 50 caracteres.</span></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.guardar() ng-disabled=\"vm.form.$invalid || !vm.persona.proveedor.nombre\"><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/ingreso/persona-proveedor/lista/lista-persona-proveedor.html","<!--     <formly-form model=\"vm.user\" fields=\"vm.userFields\">\r\n  <button type=\"submit\" class=\"btn btn-primary col-sm-offset-4 col-sm-4\" ng-click=\"vm.submit(vm.user)\">Submit</button>\r\n</formly-form> --><div><form><div class=\"form-group col-lg-12\"><div class=form-group><center><button ng-click=vm.crearNuevo() class=\"btn btn-success\" style=width:50%><i class=\"fa fa-plus\"></i> NUEVA PERSONA DE PROVEEDORES</button></center></div><div><label>Filtrar por proveedor:</label><div class=col-lg-12><div class=\"form-group col-lg-1\"><input type=checkbox ng-model=vm.buscar ng-click=vm.busqueda()></div><div class=\"form-group col-lg-9\"><input ng-disabled=!vm.buscar type=text ng-model=vm.proveedor placeholder=\"Seleccione o busque la proveedor\" uib-typeahead=\"proveedor as proveedor.nombre.toUpperCase()+\' (\'+proveedor.empresa.nombre.toUpperCase()+\')\' for proveedor in vm.proveedores | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0></div><div class=\"col-lg-2 form-group\"><button ng-disabled=\"!vm.buscar || !vm.proveedor.nombre\" class=\"btn btn-primary\" ng-click=vm.filtrar()><span class=\"fa fa-search\"></span> Buscar</button></div></div></div><br><div ng-show=\"!vm.personas.length>0 && vm.bandera\" uib-alert class=\"danger col-lg-12 form-group\">No hay personas para el proveedor seleccionado.</div></div><button class=\"btn btn-link\" ng-click=vm.exportToExcel() ng-show=\"vm.personas.length>0\"><span class=\"glyphicon glyphicon-share\"></span> Exportar a Excel</button><div class=col-lg-12><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.personas.length>0\"><tr ng-repeat=\"personas in $data\"><td title=\"\'Empresa\'\" align=center data-sortable=\"\'proveedor.nombre\'\">{{personas.proveedor.nombre.toUpperCase();}}</td><td title=\"\'Apellido\'\" filter=\"{ apellido: \'text\'}\" data-sortable=\"\'apellido\'\">{{personas.apellido.toUpperCase();}}</td><td title=\"\'Nombre\'\" filter=\"{ nombre: \'text\'}\" data-sortable=\"\'nombre\'\">{{personas.nombre.toUpperCase();}}</td><td title=\"\'Teléfono\'\">{{personas.telefono? personas.telefono : \"-\"}}</td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.mostrarInformacion(personas)><i class=\"fa fa-search\"></i> </a><a class=\"btn btn-warning\" ng-click=vm.editar(personas)><i class=\"fa fa-pencil\"></i> </a><a class=\"btn btn-danger\" ng-disabled=vm.bloquearPorRol() ng-click=\"vm.bloquearPorRol() || vm.eliminar(personas)\"><i class=\"fa fa-trash\"></i></a></div></td></tr></table></div></form></div>");
$templateCache.put("app/app/main/ingreso/proveedor/editar/editar-proveedor.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=form-group><label>Ingrese el nombre del proveedor:</label><input class=form-control ng-maxlength=255 ng-model=vm.proveedor.nombre placeholder=\"Ingrese el nombre del proveedor\" type=text name=proveedor required> <span uib-alert class=danger ng-if=\"vm.form.proveedor.$error.required && vm.form.$dirty\">Este campo es requerido.</span> <span uib-alert class=danger ng-if=\"vm.form.proveedor.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=form-group><label>Ingrese o busque la Empresa:</label><input type=text ng-model=vm.proveedor.empresa placeholder=\"Seleccione o busque la Empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 required name=empresa typeahead-editable=false> <span uib-alert class=danger ng-show=\"vm.form.empresa.$error.required && vm.form.$dirty\">Este campo es requerido.</span></div><div class=form-group><label>Ingrese la descripción:</label><textarea class=form-control ng-maxlength=500 ng-model=vm.proveedor.descripcion placeholder=\"Ingrese la descripción del proveedor\" type=text name=descripcion style=resize:vertical></textarea><span uib-alert class=danger ng-if=\"vm.form.descripcion.$error.required && vm.form.$dirty\">Este campo es requerido.</span> <span uib-alert class=danger ng-if=\"vm.form.descripcion.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 500 caracteres.</span></div><div class=form-group><label>Ingrese el CUIT:</label><input class=form-control ng-maxlength=100 ng-model=vm.proveedor.cuit placeholder=\"Ingrese el CUIT\" type=text name=cuit> <span uib-alert class=danger ng-if=\"vm.form.cuit.$error.required && vm.form.$dirty\">Este campo es requerido.</span> <span uib-alert class=danger ng-if=\"vm.form.cuit.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><br><br><div class=\"form-group col-xs-6\"><label>Ingrese el nombre del Encargado:</label><input class=form-control ng-maxlength=255 ng-model=vm.proveedor.nombreEncargado placeholder=\"Ingrese el nombre del Encargado\" type=text name=nombreEncargado> <span uib-alert class=danger ng-if=\"vm.form.nombreEncargado.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=\"form-group col-xs-6\"><label>Ingrese el apellido del Encargado:</label><input class=form-control ng-maxlength=255 ng-model=vm.proveedor.apellidoEncargado placeholder=\"Ingrese el apellido del Encargado\" type=text name=apellidoEncargado> <span uib-alert class=danger ng-if=\"vm.form.apellidoEncargado.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=\"form-group col-xs-6\"><label>Ingrese el teléfono del Encargado:</label><input class=form-control ng-maxlength=20 ng-model=vm.proveedor.telefonoEncargado placeholder=\"Ingrese el teléfono del Encargado\" type=text name=telefonoEncargado ng-pattern=/^([0-9])*$/ > <span uib-alert class=danger ng-if=\"vm.form.telefonoEncargado.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 20 caracteres. </span><span uib-alert class=danger ng-if=\"vm.form.telefonoEncargado.$error.pattern && vm.form.$dirty\">Ingrese un valor válido.</span></div><div class=\"form-group col-xs-6\"><label>Ingrese el email del Encargado:</label><input class=form-control ng-maxlength=80 ng-model=vm.proveedor.mailEncargado placeholder=\"Ingrese el email del Encargado\" type=email name=mailEncargado ng-pattern=/[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$/ > <span uib-alert class=danger ng-if=\"vm.form.mailEncargado.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 80 caracteres. </span><span uib-alert class=danger ng-if=\"vm.form.mailEncargado.$error.pattern && vm.form.$dirty\">Ingrese un mail válido.</span></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.guardar() ng-disabled=\"vm.form.$invalid || !vm.proveedor.empresa.nombre\"><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/ingreso/proveedor/lista/lista-proveedor.html","<div><form><div class=form-group><center><button ng-click=vm.crearNuevo() class=\"btn btn-success\" style=width:50%><i class=\"fa fa-plus\"></i> NUEVO PROVEEDOR</button></center></div><button class=\"btn btn-link\" ng-click=vm.exportToExcel()><span class=\"fa fa-file-excel-o\"></span> Exportar a Excel</button> <button class=\"btn btn-link\" ng-click=vm.reportePdf()><span class=\"fa fa-file-pdf-o\"></span> Exportar a PDF</button><div class=col-lg-12><table id=table1 ng-table=vm.tableParams class=table show-filter=true ng-show=vm.proveedores><tr ng-repeat=\"proveedor in $data\"><td title=\"\'Empresa\'\" align=center data-sortable=\"\'empresa.nombre\'\">{{proveedor.empresa.nombre.toUpperCase();}}</td><td title=\"\'Nombre\'\" filter=\"{ nombre: \'text\'}\" data-sortable=\"\'nombre\'\">{{proveedor.nombre}}</td><td title=\"\'Descripción\'\">{{proveedor.descripcion}}</td><td title=\"\'CUIT\'\">{{proveedor.cuit}}</td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.mostrarInformacion(proveedor)><i class=\"fa fa-search\"></i> </a><a class=\"btn btn-warning\" ng-click=vm.editar(proveedor)><i class=\"fa fa-pencil\"></i> </a><a class=\"btn btn-danger\" ng-disabled=vm.bloquearPorRol(); ng-click=\"vm.bloquearPorRol() || vm.eliminar(proveedor)\"><i class=\"fa fa-trash\"></i></a></div></td></tr></table></div></form></div>");
$templateCache.put("app/app/main/ingreso/tipo-problema/editar/editar-tipo-problema.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=form-group><label>Ingrese el nombre del problema:</label><input class=form-control ng-maxlength=255 ng-model=vm.tipoProblema.nombre placeholder=\"Ingrese el nombre del problema\" type=text name=problema required> <span uib-alert class=danger ng-if=\"vm.form.problema.$error.required && vm.form.$dirty\">Este campo es requerido.</span> <span uib-alert class=danger ng-if=\"vm.form.problema.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=form-group><label>Ingrese la descripción:</label><textarea class=form-control ng-maxlength=500 ng-model=vm.tipoProblema.descripcion placeholder=\"Ingrese la descripción del problema\" type=text name=descripcion style=resize:vertical></textarea><span uib-alert class=danger ng-if=\"vm.form.descripcion.$error.required && vm.form.$dirty\">Este campo es requerido.</span> <span uib-alert class=danger ng-if=\"vm.form.descripcion.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 500 caracteres.</span></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.guardar() ng-disabled=vm.form.$invalid><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/ingreso/tipo-problema/lista/lista-tipo-problema.html","<div><form><div class=form-group><center><button ng-click=vm.crearNuevo() class=\"btn btn-success\" style=width:50%><i class=\"fa fa-plus\"></i> NUEVO PROBLEMA</button></center></div><button class=\"btn btn-link\" ng-click=vm.exportToExcel()><span class=\"fa fa-file-excel-o\"></span> Exportar a Excel</button> <button class=\"btn btn-link\" ng-click=vm.reportePdf()><span class=\"fa fa-file-pdf-o\"></span> Exportar a PDF</button><div class=col-lg-12><table id=table1 ng-table=vm.tableParams class=table show-filter=true ng-show=vm.tiposProblema><tr ng-repeat=\"problema in $data\"><td title=\"\'Nombre\'\" filter=\"{ nombre: \'text\'}\" data-sortable=\"\'nombre\'\">{{problema.nombre}}</td><td title=\"\'Descripción\'\">{{problema.descripcion}}</td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.mostrarInformacion(problema)><i class=\"fa fa-search\"></i> </a><a class=\"btn btn-warning\" ng-click=vm.editar(problema)><i class=\"fa fa-pencil\"></i> </a><a class=\"btn btn-danger\" ng-disabled=vm.bloquearPorRol(); ng-click=\"vm.bloquearPorRol() || vm.eliminar(problema)\"><i class=\"fa fa-trash\"></i></a></div></td></tr></table></div></form></div>");
$templateCache.put("app/app/main/movimientos/conciliaciones/agregar-suministros/agregar-suministros-conciliaciones.html","<div class=col-lg-12 ng-if=!vm.ocultar><div class=col-lg-12 ng-show=\"vm.detalles.length==0\"><span uib-alert class=danger>Ha recargado la página.</span></div><button ng-click=vm.volver() class=\"btn btn-warning\"><i class=\"fa fa-arrow-left\"></i> Volver a la pantalla de edición</button></div><div class=col-lg-12 ng-if=vm.ocultar><div class=form-group><center><button ng-click=vm.guardar() class=\"btn btn-success\" style=width:30%><i class=\"fa fa-check\"></i> Guardar</button> <button ng-click=vm.volver() class=\"btn btn-warning\" style=width:30%><i class=\"fa fa-arrow-left\"></i> Volver</button></center></div><div class=col-lg-12><div class=\"form-group col-lg-6\"><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.conciliacion.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.conciliacion.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Fecha:</label><input class=form-control ng-readonly=true ng-model=vm.fecha type=text name=fecha></div><div class=\"form-group col-lg-6\"><label>Tipo de conciliación:</label><input class=\"form-control text-uppercase\" ng-readonly=true ng-model=vm.conciliacion.tipoMovimiento.nombre type=text name=numeroVale></div><div class=\"form-group col-lg-12\"><label>Motivo:</label><textarea class=form-control ng-readonly=true ng-model=vm.conciliacion.observacion type=text name=observacion style=resize:vertical></textarea></div><br><br><div class=\"form-group col-lg-12\"><center><button ng-click=vm.abrirModal() ng-disabled=\"vm.detalles.length>0\" class=\"btn btn-primary\" style=width:30%><i class=\"fa fa-plus\"></i> Seleccionar suministros..</button></center></div><div class=col-lg-12 ng-show=\"vm.detalles.length==0\"><span uib-alert class=danger>No ha agregado nada.</span></div><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesNoInventariablesAgrupados.length>0\"><label>Detalle de suministros no inventariables</label></div><form ng-show=true><div class=col-lg-12 ng-show=\"vm.detallesNoInventariablesAgrupados.length>0\"><table ng-table=vm.tableParamsNoInventariableAgrupado class=\"table table-hover\" ng-init=\"agrupado.$hideRows = true\" show-group=false><tr class=ng-table-group ng-repeat-start=\"agrupado in $data\"><td colspan=6><a href=\"\" ng-click=\"agrupado.$hideRows = !agrupado.$hideRows\"><span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': agrupado.$hideRows, \'glyphicon-chevron-down\': !agrupado.$hideRows }\"></span> Tipo de suministro: {{ agrupado.tipoSuministro.nombre.toUpperCase() }}</a></td><td title=\"Precio total\">Precio total por tipo de suministro: <b>${{agrupado.precioTotal}}</b></td><td title=\"Cantidad solicitada\">Cantidad solicitada total: {{agrupado.cantidad}}</td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-danger\" ng-click=vm.quitarTipo(agrupado)><i class=\"fa fa-remove\"></i></a></div></td></tr><tr ng-hide=agrupado.$hideRows ng-repeat=\"detalle in agrupado.detalles\" ng-repeat-end><td title=\"\'Marca\'\" align=center>{{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'Fecha vencimiento\'\" align=center>{{detalle.suministro.fechaVencimiento? detalle.suministro.fechaVencimiento : \"-\" | date : \"dd/MM/yyyy\"}}</td><td title=\"\'Precio unitario\'\" align=center>{{detalle.suministro.precioUnitario? \"$\"+detalle.suministro.precioUnitario : \"-\"}}</td><td title=\"\'Cantidad actual\'\" ng-if=\"vm.conciliacion.tipoMovimiento.id==6\" align=center>{{detalle.suministro.cantidad}}</td><td title=\"\'Cantidad conciliada\'\" ng-if=\"vm.conciliacion.tipoMovimiento.id==6\" align=center>{{detalle.cantidad}}</td><td style=width:35% title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !detalle.suministro.ubicacion.numeroOrden, \'has-success\':detalle.suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(detalle) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(detalle)}}</div></div></td><td title=\"\'¿Ocupar ubicación?\'\" ng-if=\"vm.conciliacion.tipoMovimiento.id==5\" align=center>{{vm.ocuparUbicacion? \"SI\" : \"NO\"}}</td></tr></table></div></form></div></div>");
$templateCache.put("app/app/main/movimientos/conciliaciones/editar/editar-conciliaciones.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=\"form-group col-lg-6\"><label>Depósito:</label><input type=text ng-model=vm.conciliacion.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false name=deposito required> <span uib-alert class=danger ng-show=\"vm.form.deposito.$error.required && vm.form.deposito.$dirty\">Este campo es requerido.</span></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.conciliacion.empresa placeholder=\"Seleccione o busque la Empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 required name=empresa typeahead-editable=false> <span uib-alert class=danger ng-show=\"vm.form.empresa.$error.required && vm.form.empresa.$dirty\">Este campo es requerido.</span></div><div class=\"form-group col-lg-12\"><label>Tipo de conciliación:</label><input type=text ng-model=vm.conciliacion.tipoMovimiento placeholder=\"Seleccione o busque el tipo de conciliación\" uib-typeahead=\"tipo as tipo.nombre.toUpperCase() for tipo in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 required name=tipoMovimiento typeahead-editable=false> <span uib-alert class=danger ng-show=\"vm.form.tipoMovimiento.$error.required && vm.form.tipoMovimiento.$dirty\">Este campo es requerido.</span></div><div class=\"form-group col-lg-12\"><label>Motivo:</label><textarea class=form-control ng-maxlength=500 ng-model=vm.conciliacion.observacion placeholder=\"Ingrese el motivo\" required type=text name=observacion style=resize:vertical></textarea><span uib-alert class=danger ng-if=\"vm.form.observacion.$error.required && vm.form.observacion.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.observacion.$error.maxlength && vm.form.observacion.$dirty\">Este campo no puede superar los 500 caracteres.</span></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.siguiente() ng-disabled=\"vm.form.$invalid || !vm.conciliacion.empresa.nombre\"><span class=\"glyphicon glyphicon-ok\"></span> Siguiente</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/movimientos/conciliaciones/lista/lista-conciliaciones.html","<!--     <formly-form model=\"vm.user\" fields=\"vm.userFields\">\r\n  <button type=\"submit\" class=\"btn btn-primary col-sm-offset-4 col-sm-4\" ng-click=\"vm.submit(vm.user)\">Submit</button>\r\n</formly-form> --><div><form><div class=\"form-group col-lg-12\"><div class=form-group><center><button ng-click=vm.crearNuevo() class=\"btn btn-success\" style=width:50%><i class=\"fa fa-plus\"></i> NUEVA CONCILIACIÓN</button></center></div><!-- 			<div class=\"col-lg-12\">\r\n	<div class=\"col-lg-12\">\r\n		<label>\r\n			Filtrar conciliaciones:\r\n		</label>\r\n		<div class=\"col-lg-12\">\r\n			<div class=\"form-group col-lg-1\">\r\n				<input type=\"checkbox\" ng-model=\"vm.buscar\" ng-click=\"vm.busqueda()\">				\r\n			</div>\r\n			<div class=\"col-lg-11\">\r\n				<center>\r\n					<button class=\"btn btn-primary\" ng-disabled=\"!vm.buscar\" ng-click=\"vm.abrirModalFiltros()\">\r\n			        	<span class=\"fa fa-filter\"></span> Filtros de búsqueda combinados\r\n			    	</button>	\r\n				</center>\r\n			</div>\r\n		</div>\r\n	</div>\r\n</div> --><br><div class=col-lg-12><div uib-alert type=info ng-show=vm.filtrosUsados>FILTROS APLICADOS:<div ng-repeat=\"filtro in vm.filtrosUsados\">{{vm.filtrosUsados[$index]}}</div></div></div><div ng-show=\"!vm.conciliaciones.length>0 && vm.bandera\" uib-alert class=\"danger col-lg-12 form-group\">No hay conciliaciones para los filtros indicados</div></div><!-- 		<div class=\"col-lg-12\" ng-if=\"vm.conciliaciones.length==0\">\r\n	<span uib-alert>\r\n		No hay conciliaciones registrados\r\n	</span>\r\n</div> --><div class=col-lg-12><table ng-table=vm.tableParams class=\"table table-condensed\" show-filter=true ng-show=\"vm.conciliaciones.length>0\"><tr ng-repeat=\"conciliaciones in $data\" ng-class=\"{\'rojo-claro\':conciliaciones.tipoMovimiento.id==6, \'amarillo-claro\': conciliaciones.tipoMovimiento.id==5}\"><div><td data-title=\"\'Fecha\'\" align=center data-sortable=\"\'fecha\'\">{{conciliaciones.fecha | date : \"dd/MM/yyyy HH:mm\" }}</td><td data-title=\"\'Tipo\'\" align=center data-sortable=\"\'tipoMovimiento.nombre\'\" filter=\"{\'tipoMovimiento.nombre\':\'text\'}\">{{conciliaciones.tipoMovimiento.nombre.toUpperCase()}}</td><td data-title=\"\'Depósito\'\" data-sortable=\"\'deposito.nombre\'\" filter=\"{\'deposito.nombre\': \'text\'}\" align=center>{{conciliaciones.deposito.nombre.toUpperCase();}}</td><td data-title=\"\'Empresa\'\" data-sortable=\"\'empresa.nombre\'\" filter=\"{\'empresa.nombre\': \'text\'}\" align=center>{{conciliaciones.empresa.nombre.toUpperCase();}}</td><td data-title=\"\'N° Movimiento\'\" style=width:5% align=center filter=\"{\'numeroMovimiento\':\'text\'}\" data-sortable=\"\'numeroMovimiento\'\">{{conciliaciones.numeroMovimiento}}</td><!-- 				        <td data-title=\"\'Estado\'\"  style=\"width:5%;\" data-sortable=\"\'estadoMovimiento.nombre\'\" filter=\"{\'estadoMovimiento.nombre\': \'text\'}\"align=\"center\" data-sortable=\"\'estado\'\">\r\n    {{conciliaciones.estadoMovimiento.nombre.toUpperCase();}}\r\n</td> --><td data-title=\"\'Acciones\'\" align=center style=width:20%><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.visualizarConciliacion(conciliaciones)><i class=\"fa fa-search\"></i> </a><!-- 								<a class=\"btn btn-success\" ng-disabled=\"!(conciliaciones.estadoMovimiento.id==1 || conciliaciones.estadoMovimiento.id==3)\" ng-click=\"!(conciliaciones.estadoMovimiento.id==1 || conciliaciones.estadoMovimiento.id==3) || vm.cambiarEstado(conciliaciones)\">\r\n	<i class=\"fa fa-archive\" ng-if=\"conciliaciones.estadoMovimiento.id>=2\"></i>\r\n	<i class=\"glyphicon glyphicon-paste\" ng-if=\"conciliaciones.estadoMovimiento.id==1\"></i>\r\n</a> --><!-- 								<a ng-disabled=\"conciliaciones.estadoMovimiento.id!=1\" class=\"btn btn-danger\" ng-click=\"conciliaciones.estadoMovimiento.id!=1 || vm.eliminar(conciliaciones)\">\r\n	<i class=\"fa fa-trash\"></i>\r\n</a> --></div></td></div></tr></table></div></form></div>");
$templateCache.put("app/app/main/movimientos/conciliaciones/visualizar-conciliacion/visualizar-conciliacion.html","<div class=form-group ng-if=vm.comprobarEstadoConciliacion();><center><button ng-click=vm.volver(); class=\"btn btn-info\" style=width:30%><i class=\"fa fa-arrow-left\"></i> Volver al listado</button> <button ng-click=vm.imprimirInforme(); class=\"btn btn-primary\" style=width:30%><i class=\"fa fa-file-text-o\"></i> Obtener informe</button></center></div><div class=col-lg-12 ng-if=vm.comprobarEstadoConciliacion()><div class=\"panel panel-default\"><div class=panel-body><div class=\"form-group col-lg-6\"><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.conciliacion.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.conciliacion.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-12\"><label>Tipo de conciliación:</label><input class=\"form-control text-uppercase\" ng-readonly=true ng-model=vm.conciliacion.tipoMovimiento.nombre type=text name=tipoMovimiento></div><div class=\"form-group col-lg-6\"><label>Número de movimiento:</label><input class=form-control ng-readonly=true ng-model=vm.conciliacion.numeroMovimiento type=text name=numeroMovimiento></div><div class=\"form-group col-lg-6\"><label>Fecha:</label><input class=form-control ng-readonly=true ng-model=vm.fecha type=text name=fecha></div><div class=\"form-group col-lg-12\"><label>Motivo:</label><textarea class=form-control ng-readonly=true ng-model=vm.conciliacion.observacion type=text name=observacion style=resize:vertical></textarea></div></div></div><br><div><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesNoInventariablesAgrupados.length>0\"><label>Detalle de suministros no inventariables</label></div><form ng-show=true><div class=col-lg-12 ng-show=\"vm.detallesNoInventariablesAgrupados.length>0\"><table ng-table=vm.tableParamsNoInventariableAgrupado class=\"table table-hover\" ng-init=\"agrupado.$hideRows = true\" show-group=false><tr class=ng-table-group ng-repeat-start=\"agrupado in $data\"><td colspan=6><a href=\"\" ng-click=\"agrupado.$hideRows = !agrupado.$hideRows\"><span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': agrupado.$hideRows, \'glyphicon-chevron-down\': !agrupado.$hideRows }\"></span> Tipo de suministro: {{ agrupado.tipoSuministro.nombre.toUpperCase() }}</a></td><td title=\"Precio total\">Precio total por tipo de suministro: <b>${{agrupado.precioTotal}}</b></td><td title=\"Cantidad solicitada\">Cantidad solicitada total: <b>{{agrupado.cantidad}}</b></td><!-- 				        <td title=\"\'Acciones\'\" align=\"center\">\r\n							<div class=\"btn-group\">\r\n								<a class=\"btn btn-danger\" ng-click=\"vm.quitarTipo(agrupado)\">\r\n									<i class=\"fa fa-remove\"></i>\r\n								</a>\r\n							</div>\r\n</td> --></tr><tr ng-hide=agrupado.$hideRows ng-repeat=\"detalle in agrupado.detalles\" ng-repeat-end><td title=\"\'Marca\'\" align=center>{{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'Precio\'\" align=center>${{detalle.suministro.precioUnitario}}</td><td title=\"\'Cantidad conciliada\'\" align=center>{{detalle.cantidad}}</td></tr></table></div></form></div></div><div ng-if=!vm.comprobarEstadoConciliacion() class=col-lg-12><span uib-alert class=danger>Esta conciliación no puede visualizarse </span><button ng-click=vm.volver(); class=\"btn btn-warning\" style=width:30%><i class=\"fa fa-arrow-left\"></i> Volver al listado</button></div>");
$templateCache.put("app/app/main/movimientos/egreso/agregar-suministros-egreso/agregar-suministros-egreso.html","<div class=col-lg-12 ng-if=!vm.ocultar><div class=col-lg-12 ng-show=\"vm.detalles.length==0\"><span uib-alert class=danger>Se ha recargado la página.</span></div><button ng-click=vm.volver() class=\"btn btn-warning\"><i class=\"fa fa-arrow-left\"></i> Volver a la pantalla de edición</button></div><div class=col-lg-12 ng-if=vm.ocultar><div class=form-group><center><button ng-click=vm.guardar() class=\"btn btn-success\" style=width:30%><i class=\"fa fa-check\"></i> Guardar</button> <button ng-click=vm.volver() class=\"btn btn-warning\" style=width:30%><i class=\"fa fa-arrow-left\"></i> Volver</button></center></div><div class=col-lg-12><div class=\"form-group col-lg-6\"><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.egreso.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.egreso.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-9\"><label>Sucursal:</label><input type=text ng-readonly=true ng-model=vm.egreso.sucursal.nombre class=\"form-control text-uppercase\" name=sucursal></div><div class=\"form-group col-lg-3\"><label>Sector:</label><input type=text ng-readonly=true ng-model=vm.egreso.sector class=\"form-control text-uppercase\" name=sector></div><div class=\"form-group col-lg-6\"><label>Solicitó:</label><input type=text ng-model=vm.solicitante class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Autorizó:</label><input type=text ng-model=vm.egreso.solicitante class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-3\"><label>Fecha:</label><input class=form-control ng-readonly=true ng-model=vm.fecha type=text name=fecha></div><div class=\"form-group col-lg-3\"><label>¿Egreso de cajas cerradas?</label><input class=form-control ng-readonly=true ng-model=vm.cajaCerrada type=text name=cajaCerrada></div><div class=\"form-group col-lg-3\"><label>Número de Vale:</label><input class=form-control ng-readonly=true ng-model=vm.egreso.numeroVale type=text name=numeroVale></div><div class=\"form-group col-lg-3\"><label>Número de seguimiento mail:</label><input class=form-control ng-readonly=true ng-model=vm.egreso.numeroMail type=text name=numeroVale></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=form-control ng-readonly=true ng-model=vm.egreso.observacion type=text name=observacion style=resize:vertical></textarea></div><br><br><div class=\"form-group col-lg-12\"><center><button ng-click=vm.abrirModal() class=\"btn btn-primary\" style=width:25%><i class=\"fa fa-plus\"></i> Agregar suministros..</button> <button ng-click=vm.abrirModalAgregarSuministroEgresoKit() class=\"btn btn-success\" style=width:25%><i class=\"fa fa-plus-circle\"></i> Agregar por kits</button></center></div><div class=col-lg-12 ng-show=\"vm.detalles.length==0\"><span uib-alert class=danger>No ha agregado ningún suministro.</span></div><div class=\"col-lg-12 form-group\" ng-show=\"vm.detalles.length>0\"><label>Total: ${{ vm.montoTotal() }}</label></div><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesNoInventariablesAgrupados.length>0\"><label>Detalle de suministros no inventariables</label></div><form ng-show=true><div class=col-lg-12 ng-show=\"vm.detallesNoInventariablesAgrupados.length>0\"><table ng-table=vm.tableParamsNoInventariableAgrupado class=\"table table-hover\" ng-init=\"agrupado.$hideRows = true\" show-group=false><tr class=ng-table-group ng-repeat-start=\"agrupado in $data\"><td colspan=6><a href=\"\" ng-click=\"agrupado.$hideRows = !agrupado.$hideRows\"><span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': agrupado.$hideRows, \'glyphicon-chevron-down\': !agrupado.$hideRows }\"></span> Tipo de suministro: {{ agrupado.tipoSuministro.nombre.toUpperCase() }}</a></td><td title=\"Precio total\">Precio total por tipo de suministro: <b>${{agrupado.precioTotal}}</b></td><td title=\"Cantidad solicitada\">Cantidad solicitada total: {{agrupado.cantidad}}</td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-danger\" ng-click=vm.quitarTipo(agrupado)><i class=\"fa fa-remove\"></i></a></div></td></tr><tr ng-hide=agrupado.$hideRows ng-repeat=\"detalle in agrupado.detalles\" ng-repeat-end><td title=\"\'Marca\'\" align=center>{{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'Cantidad actual\'\" align=center>{{detalle.suministro.cantidad}}</td><td title=\"\'Cantidad solicitada\'\" align=center>{{detalle.cantidad}}</td><td style=width:35% title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !detalle.suministro.ubicacion.numeroOrden, \'has-success\':detalle.suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(detalle) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(detalle)}}</div></div></td></tr></table></div></form><!-- \r\n		<div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesNoInventariables.length>0\">\r\n			<label>Detalle de suministros no inventariables</label>\r\n		</div>\r\n		<form ng-show=\"true\">\r\n	    	<div class=\"col-lg-12\" ng-show=\"vm.detallesNoInventariables.length>0\">\r\n	    		<table ng-table=\"vm.tableParams\" class=\"table\" show-filter=\"true\" ng-show=\"vm.detallesNoInventariables.length>0\">\r\n				    <tr ng-repeat=\"detalles in $data track by $index\" ng-if=\"detalles.suministro.tipoSuministro.inventariable!==true\">\r\n					    <div >\r\n					        <td title=\"\'Tipo Suministro\'\" data-sortable=\"\'suministro.tipoSuministro.nombre\'\" align=\"center\">\r\n					            {{detalles.suministro.tipoSuministro.nombre.toUpperCase();}}\r\n					        </td>\r\n					        <td title=\"\'Marca\'\" data-sortable=\"\'suministro.marca\'\" align=\"center\">\r\n					            {{detalles.suministro.marca ? detalles.suministro.marca.toUpperCase() : \"-\" }}\r\n					        </td>\r\n					        <td title=\"\'Fecha vencimiento\'\" data-sortable=\"\'suministro.fechaVencimiento\'\" align=\"center\">\r\n					            {{detalles.suministro.fechaVencimiento ? detalles.suministro.fechaVencimiento : \"-\" | date : \"dd/MM/yyyy\" }}\r\n					        </td>\r\n					        <td title=\"\'Cantidad actual\'\" align=\"center\">\r\n					            {{detalles.suministro.cantidad}}\r\n					        </td>\r\n					        <td title=\"\'Cantidad solicitada\'\" align=\"center\">\r\n					            {{detalles.cantidad}}\r\n					        </td>\r\n					        <td title=\"\'Acciones\'\" align=\"center\">\r\n								<div class=\"btn-group\">\r\n									<a class=\"btn btn-danger\" ng-click=\"vm.eliminar($index)\">\r\n										<i class=\"fa fa-trash\"></i>\r\n									</a>\r\n								</div>\r\n					        </td>\r\n					    </div>\r\n				    </tr>\r\n				</table>\r\n	    	</div>\r\n	    </form> --><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesInventariablesAgrupados.length>0\"><label>Detalle de suministros inventariables</label></div><form ng-show=true><div class=col-lg-12 ng-show=\"vm.detallesInventariablesAgrupados.length>0\"><table ng-table=vm.tableParamsInventariableAgrupado class=\"table table-hover\" ng-init=\"agrupado.$hideRows = true\" show-group=false><tr class=ng-table-group ng-repeat-start=\"agrupado in $data\"><td colspan=6><a href=\"\" ng-click=\"agrupado.$hideRows = !agrupado.$hideRows\"><span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': agrupado.$hideRows, \'glyphicon-chevron-down\': !agrupado.$hideRows }\"></span> Tipo de suministro: {{ agrupado.tipoSuministro.nombre.toUpperCase() }}</a></td><td title=\"Cantidad solicitada\">Cantidad solicitada total: {{agrupado.cantidad}}</td><td title=\"Precio total\">Precio total por tipo de suministro: <b>${{agrupado.precioTotal}}</b></td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-danger\" ng-click=vm.quitarTipo(agrupado)><i class=\"fa fa-remove\"></i></a></div></td></tr><tr ng-hide=agrupado.$hideRows ng-repeat=\"detalle in agrupado.detalles\" ng-repeat-end><td title=\"\'Marca\'\" align=center>{{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'N° serie\'\" data-sortable=\"\'suministroInventariable.serie\'\" align=center>{{detalle.suministroInventariable.serie ? detalle.suministroInventariable.serie : \"-\" }}</td><td title=\"\'N° inventario\'\" data-sortable=\"\'suministroInventariable.inventario\'\" align=center>{{detalle.suministroInventariable.inventario ? detalle.suministroInventariable.inventario : \"-\" }}</td><td title=\"\'Precio\'\" align=center>${{detalle.suministro.precioUnitario}}</td><td style=width:35% title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !detalle.suministro.ubicacion.numeroOrden, \'has-success\':detalle.suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(detalle) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(detalle)}}</div></div></td></tr></table></div></form><!-- \r\n		<form ng-show=\"true\">\r\n	    	<div class=\"col-lg-12\" ng-show=\"vm.detallesInventariables.length>0\">\r\n	    		<table ng-table=\"vm.tableParamsInventariableAgrupado\" class=\"table\" show-filter=\"true\" ng-show=\"vm.detallesInventariables.length>0\">\r\n				    <tr ng-repeat=\"detalle in $data track by $index\" ng-if=\"detalle.suministro.tipoSuministro.inventariable==true\">\r\n					    <div >\r\n					        <td title=\"\'Tipo Suministro\'\" data-sortable=\"\'suministro.tipoSuministro.nombre\'\" align=\"center\">\r\n					            {{detalle.suministro.tipoSuministro.nombre.toUpperCase();}}\r\n					        </td>\r\n					        <td title=\"\'Marca\'\" data-sortable=\"\'suministro.marca\'\" align=\"center\">\r\n					            {{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}\r\n					        </td>\r\n					        <td title=\"\'N° serie\'\" data-sortable=\"\'suministroInventariable.serie\'\" align=\"center\">\r\n					            {{detalle.suministroInventariable.serie ? detalle.suministroInventariable.serie : \"-\" }}\r\n					        </td>\r\n					        <td title=\"\'N° inventario\'\" data-sortable=\"\'suministroInventariable.inventario\'\" align=\"center\">\r\n					            {{detalle.suministroInventariable.inventario ? detalle.suministroInventariable.inventario : \"-\" }}\r\n					        </td>\r\n					        <td title=\"\'Precio\'\" align=\"center\">\r\n					            ${{detalle.suministro.precioUnitario}}\r\n					        </td>\r\n					        <td ng-if=\"!vm.egreso.caja\" title=\"\'Pallet\'\" align=\"center\" groupable=\"numeroRow\">\r\n					            {{detalle.numeroRow}}\r\n					        </td>\r\n					        <td ng-if=\"vm.egreso.caja\" title=\"\'Número caja\'\" align=\"center\" groupable=\"numeroCaja\">\r\n					        					            {{detalle.numeroCaja}}\r\n					        </td>\r\n					        <td title=\"\'Acciones\'\" align=\"center\" groupable=\"\'numeroRow\'\">\r\n								<div class=\"btn-group\">\r\n									<a class=\"btn btn-danger\" ng-click=\"vm.eliminar($index)\">\r\n										<i class=\"fa fa-trash\"></i>\r\n									</a>\r\n								</div>\r\n					        </td>\r\n					    </div>\r\n				    </tr>\r\n				</table>\r\n	    	</div>\r\n	    </form> --></div></div>");
$templateCache.put("app/app/main/movimientos/egreso/agregar-suministros-egreso-cajas/agregar-suministros-egreso-cajas.html","<div class=col-lg-12 ng-if=!vm.ocultar><div class=col-lg-12 ng-show=\"vm.detallesInventariables.length==0\"><span uib-alert class=danger>Ha recargado la página.</span></div><button ng-click=vm.volver() class=\"btn btn-warning\"><i class=\"fa fa-arrow-left\"></i> Volver a la pantalla de edición</button></div><div class=col-lg-12 ng-if=vm.ocultar><div class=form-group><center><button ng-click=vm.guardar() class=\"btn btn-success\" style=width:30%><i class=\"fa fa-check\"></i> Guardar</button> <button ng-click=vm.volver() class=\"btn btn-warning\" style=width:30%><i class=\"fa fa-arrow-left\"></i> Volver</button></center></div><div class=col-lg-12><div class=\"form-group col-lg-6\"><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.egreso.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.egreso.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-9\"><label>Sucursal:</label><input type=text ng-readonly=true ng-model=vm.egreso.sucursal.nombre class=\"form-control text-uppercase\" name=sucursal></div><div class=\"form-group col-lg-3\"><label>Sector:</label><input type=text ng-readonly=true ng-model=vm.egreso.sector class=\"form-control text-uppercase\" name=sector></div><div class=\"form-group col-lg-6\"><label>Solicitó:</label><input type=text ng-model=vm.solicitante class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Autorizó:</label><input type=text ng-model=vm.egreso.solicitante class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Fecha:</label><input class=form-control ng-readonly=true ng-model=vm.fecha type=text name=fecha></div><div class=\"form-group col-lg-6\"><label>¿Egreso de cajas cerradas?</label><input class=form-control ng-readonly=true ng-model=vm.cajaCerrada type=text name=cajaCerrada></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=form-control ng-readonly=true ng-model=vm.egreso.observacion type=text name=observacion style=resize:vertical></textarea></div><br><br><div class=\"form-group col-lg-12\"><center><button ng-click=vm.abrirModal() class=\"btn btn-primary\" style=width:30%><i class=\"fa fa-plus\"></i> Agregar cajas cerradas..</button></center></div><div class=col-lg-12 ng-show=\"vm.detallesInventariables.length==0\"><span uib-alert class=danger>No ha agregado ningún suministro.</span></div><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesInventariables.length>0\"><label>Total: ${{ vm.montoTotal() }}</label></div><!-- \r\n		<div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesNoInventariablesAgrupados.length>0\">\r\n			<label>Detalle de suministros no inventariables</label>\r\n		</div>\r\n		<form ng-show=\"true\">\r\n	    	<div class=\"col-lg-12\" ng-show=\"vm.detallesNoInventariablesAgrupados.length>0\">\r\n		        <table ng-table=\"vm.tableParamsNoInventariableAgrupado\" class=\"table table-hover\"  ng-init=\"agrupado.$hideRows = true\" show-group=\"false\">\r\n		            <tr class=\"ng-table-group\" ng-repeat-start=\"agrupado in $data\">\r\n		              	<td colspan=\"6\">\r\n			                <a href=\"\" ng-click=\"agrupado.$hideRows = !agrupado.$hideRows\">\r\n			                 	<span class=\"glyphicon\" ng-class=\"{ \'glyphicon-chevron-right\': agrupado.$hideRows, \'glyphicon-chevron-down\': !agrupado.$hideRows }\"></span>\r\n			                  	Tipo de suministro: {{ agrupado.tipoSuministro.nombre.toUpperCase() }} \r\n			                </a>\r\n	            	  	</td>\r\n	            	  	<td title=\"Precio total\">\r\n	            	  		Precio total por tipo de suministro: <b>${{agrupado.precioTotal}}</b>\r\n	            	  	</td>\r\n	            	  	<td title=\"Cantidad solicitada\">\r\n	            	  		Cantidad solicitada total: {{agrupado.cantidad}}\r\n	            	  	</td>\r\n				        <td title=\"\'Acciones\'\" align=\"center\">\r\n							<div class=\"btn-group\">\r\n								<a class=\"btn btn-danger\" ng-click=\"vm.quitarTipo(agrupado)\">\r\n									<i class=\"fa fa-remove\"></i>\r\n								</a>\r\n							</div>\r\n				        </td>\r\n		            </tr>\r\n		            <tr ng-hide=\"agrupado.$hideRows\" ng-repeat=\"detalle in agrupado.detalles\" ng-repeat-end>\r\n				        <td title=\"\'Marca\'\" align=\"center\">\r\n				            {{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}\r\n				        </td>\r\n				        <td title=\"\'Cantidad actual\'\" align=\"center\">\r\n				            {{detalle.suministro.cantidad}}\r\n				        </td>\r\n				        <td title=\"\'Cantidad solicitada\'\" align=\"center\">\r\n				            {{detalle.cantidad}}\r\n				        </td>\r\n	            	  	<td style=\"width:35%;\" title=\"\'Ubicación\'\">\r\n	            	  		<div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !detalle.suministro.ubicacion.numeroOrden, \'has-success\':detalle.suministro.ubicacion.numeroOrden}\">\r\n							    <i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i>\r\n							    <div  ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto;\" class=\"form-control\" ng-click=\"vm.ubicacionCompleta(detalle)\" class=\"form-control\" style=\"word-wrap: white;\">\r\n							    	{{vm.ubicacionNaveNumeroOrden(detalle)}}\r\n							    </div>\r\n							</div>\r\n	            	  	</td>\r\n		            </tr>\r\n		        </table>\r\n	    	</div>\r\n	    </form> --><!-- \r\n		<div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesNoInventariables.length>0\">\r\n			<label>Detalle de suministros no inventariables</label>\r\n		</div>\r\n		<form ng-show=\"true\">\r\n	    	<div class=\"col-lg-12\" ng-show=\"vm.detallesNoInventariables.length>0\">\r\n	    		<table ng-table=\"vm.tableParams\" class=\"table\" show-filter=\"true\" ng-show=\"vm.detallesNoInventariables.length>0\">\r\n				    <tr ng-repeat=\"detalles in $data track by $index\" ng-if=\"detalles.suministro.tipoSuministro.inventariable!==true\">\r\n					    <div >\r\n					        <td title=\"\'Tipo Suministro\'\" data-sortable=\"\'suministro.tipoSuministro.nombre\'\" align=\"center\">\r\n					            {{detalles.suministro.tipoSuministro.nombre.toUpperCase();}}\r\n					        </td>\r\n					        <td title=\"\'Marca\'\" data-sortable=\"\'suministro.marca\'\" align=\"center\">\r\n					            {{detalles.suministro.marca ? detalles.suministro.marca.toUpperCase() : \"-\" }}\r\n					        </td>\r\n					        <td title=\"\'Fecha vencimiento\'\" data-sortable=\"\'suministro.fechaVencimiento\'\" align=\"center\">\r\n					            {{detalles.suministro.fechaVencimiento ? detalles.suministro.fechaVencimiento : \"-\" | date : \"dd/MM/yyyy\" }}\r\n					        </td>\r\n					        <td title=\"\'Cantidad actual\'\" align=\"center\">\r\n					            {{detalles.suministro.cantidad}}\r\n					        </td>\r\n					        <td title=\"\'Cantidad solicitada\'\" align=\"center\">\r\n					            {{detalles.cantidad}}\r\n					        </td>\r\n					        <td title=\"\'Acciones\'\" align=\"center\">\r\n								<div class=\"btn-group\">\r\n									<a class=\"btn btn-danger\" ng-click=\"vm.eliminar($index)\">\r\n										<i class=\"fa fa-trash\"></i>\r\n									</a>\r\n								</div>\r\n					        </td>\r\n					    </div>\r\n				    </tr>\r\n				</table>\r\n	    	</div>\r\n	    </form> --><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesInventariablesAgrupados.length>0\"><label>Detalle de cajas cerradas</label></div><form ng-show=true><div class=col-lg-12 ng-show=\"vm.detallesInventariablesAgrupados.length>0\"><table ng-table=vm.tableParamsInventariableAgrupado class=\"table table-hover\" ng-init=\"agrupado.$hideRows = true\" show-group=false><tr class=ng-table-group ng-repeat-start=\"agrupado in $data\"><td colspan=6><a href=\"\" ng-click=\"agrupado.$hideRows = !agrupado.$hideRows\"><span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': agrupado.$hideRows, \'glyphicon-chevron-down\': !agrupado.$hideRows }\"></span> Caja cerrada N°: {{agrupado.numeroCaja}}<br>Tipo de suministro: {{ agrupado.tipoSuministro.nombre.toUpperCase() }}<br>Familia de suministro: {{ agrupado.tipoSuministro.familiaSuministro.nombre.toUpperCase();}}</a></td><td style=width:35% title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\"><label class=control-label>Ubicación</label><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(agrupado)>{{agrupado.ubicacion? vm.ubicacionNaveNumeroOrden(agrupado) : \"No asignó ninguna.\" }}</div><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i></div></td><td title=\"Cantidad total\">Cantidad total: {{agrupado.cantidad}}</td><td title=\"Precio total\">Precio total: <b>${{agrupado.precioTotal}}</b></td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-danger\" ng-click=vm.quitarCaja(agrupado)><i class=\"fa fa-remove\"></i></a></div></td></tr><tr ng-hide=agrupado.$hideRows ng-repeat=\"detalle in agrupado.detalles\" ng-repeat-end><td title=\"\'Marca\'\" align=center>{{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'N° serie\'\" data-sortable=\"\'suministroInventariable.serie\'\" align=center>{{detalle.suministroInventariable.serie ? detalle.suministroInventariable.serie : \"-\" }}</td><td title=\"\'N° inventario\'\" data-sortable=\"\'suministroInventariable.inventario\'\" align=center>{{detalle.suministroInventariable.inventario ? detalle.suministroInventariable.inventario : \"-\" }}</td><td title=\"\'Precio\'\" align=center>${{detalle.suministro.precioUnitario}}</td></tr></table></div></form><!-- \r\n		<form ng-show=\"true\">\r\n	    	<div class=\"col-lg-12\" ng-show=\"vm.detallesInventariables.length>0\">\r\n	    		<table ng-table=\"vm.tableParamsInventariableAgrupado\" class=\"table\" show-filter=\"true\" ng-show=\"vm.detallesInventariables.length>0\">\r\n				    <tr ng-repeat=\"detalle in $data track by $index\" ng-if=\"detalle.suministro.tipoSuministro.inventariable==true\">\r\n					    <div >\r\n					        <td title=\"\'Tipo Suministro\'\" data-sortable=\"\'suministro.tipoSuministro.nombre\'\" align=\"center\">\r\n					            {{detalle.suministro.tipoSuministro.nombre.toUpperCase();}}\r\n					        </td>\r\n					        <td title=\"\'Marca\'\" data-sortable=\"\'suministro.marca\'\" align=\"center\">\r\n					            {{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}\r\n					        </td>\r\n					        <td title=\"\'N° serie\'\" data-sortable=\"\'suministroInventariable.serie\'\" align=\"center\">\r\n					            {{detalle.suministroInventariable.serie ? detalle.suministroInventariable.serie : \"-\" }}\r\n					        </td>\r\n					        <td title=\"\'N° inventario\'\" data-sortable=\"\'suministroInventariable.inventario\'\" align=\"center\">\r\n					            {{detalle.suministroInventariable.inventario ? detalle.suministroInventariable.inventario : \"-\" }}\r\n					        </td>\r\n					        <td title=\"\'Precio\'\" align=\"center\">\r\n					            ${{detalle.suministro.precioUnitario}}\r\n					        </td>\r\n					        <td ng-if=\"!vm.egreso.caja\" title=\"\'Pallet\'\" align=\"center\" groupable=\"numeroRow\">\r\n					            {{detalle.numeroRow}}\r\n					        </td>\r\n					        <td ng-if=\"vm.egreso.caja\" title=\"\'Número caja\'\" align=\"center\" groupable=\"numeroCaja\">\r\n					        					            {{detalle.numeroCaja}}\r\n					        </td>\r\n					        <td title=\"\'Acciones\'\" align=\"center\" groupable=\"\'numeroRow\'\">\r\n								<div class=\"btn-group\">\r\n									<a class=\"btn btn-danger\" ng-click=\"vm.eliminar($index)\">\r\n										<i class=\"fa fa-trash\"></i>\r\n									</a>\r\n								</div>\r\n					        </td>\r\n					    </div>\r\n				    </tr>\r\n				</table>\r\n	    	</div>\r\n	    </form> --></div></div>");
$templateCache.put("app/app/main/movimientos/egreso/editar/editar-egreso.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=\"form-group col-lg-6\"><label>Depósito:</label><input type=text ng-model=vm.egreso.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false name=deposito required> <span uib-alert class=danger ng-show=\"vm.form.deposito.$error.required && vm.form.deposito.$dirty\">Este campo es requerido.</span></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.egreso.empresa placeholder=\"Seleccione o busque la Empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 required name=empresa typeahead-editable=false> <span uib-alert class=danger ng-show=\"vm.form.empresa.$error.required && vm.form.empresa.$dirty\">Este campo es requerido.</span></div><div class=\"form-group col-lg-9\"><label>Sucursal:</label><input type=text ng-disabled=!vm.egreso.empresa.nombre ng-model=vm.egreso.sucursal placeholder=\"Seleccione o busque la sucursal\" uib-typeahead=\"sucursal as sucursal.nombre.toUpperCase() for sucursal in vm.sucursales | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 required name=sucursal typeahead-editable=false focus-on=sucursal> <span uib-alert class=danger ng-show=\"vm.form.sucursal.$error.required && vm.form.sucursal.$dirty\">Este campo es requerido.</span></div><div class=\"form-group col-lg-3\"><label>Sector:</label><input class=form-control ng-maxlength=100 focus-on=sector ng-model=vm.egreso.sector placeholder=\"Ingrese el sector de la sucursal\" type=text name=sector> <span uib-alert class=danger ng-if=\"vm.form.sector.$error.maxlength && vm.form.sector.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><div class=\"form-group col-lg-6\"><label>Solicita:</label><input type=text ng-disabled=!vm.egreso.empresa.nombre ng-model=vm.egreso.solicita placeholder=\"Seleccione o busque quién solicita\" class=form-control uib-typeahead=\"solicita as solicita.apellido.toUpperCase()+\', \'+solicita.nombre.toUpperCase() for solicita in vm.solicitantes | filter:{apellido:$viewValue}\" typeahead-show-hint=true typeahead-min-length=0 name=solicita typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Autoriza:</label><input class=form-control ng-maxlength=100 focus-on=solicitante ng-model=vm.egreso.solicitante placeholder=\"Ingrese quién autoriza el egreso\" type=text name=solicitante> <span uib-alert class=danger ng-if=\"vm.form.solicitante.$error.maxlength && vm.form.solicitante.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><div class=\"form-group col-lg-4\"><label>Número de Vale</label><input type=text class=form-control ng-maxlength=100 ng-model=vm.egreso.numeroVale placeholder=\"Ingrese el número de Vale\" name=numeroVale> <span uib-alert class=danger ng-if=\"vm.form.numeroVale.$error.maxlength && vm.form.numeroVale.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><div class=\"form-group col-lg-4\"><label>Número de seguimiento por mail</label><input type=text class=form-control ng-maxlength=100 ng-model=vm.egreso.numeroMail placeholder=\"Ingrese el número de seguimiento por mail\" name=numeroMail> <span uib-alert class=danger ng-if=\"vm.form.numeroMail.$error.maxlength && vm.form.numeroMail.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><div class=\"form-group col-lg-4\"><label>¿Es un egreso de Cajas Cerradas?</label><br><toggle ng-model=vm.egreso.caja on=SI off=NO onstyle=btn-success offstyle=btn-danger></toggle></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=form-control ng-maxlength=500 ng-model=vm.egreso.observacion placeholder=\"Ingrese una observación\" type=text name=observacion style=resize:vertical></textarea><span uib-alert class=danger ng-if=\"vm.form.observacion.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.observacion.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 500 caracteres.</span></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.siguiente() ng-disabled=\"vm.form.$invalid || !vm.egreso.empresa.nombre\"><span class=\"glyphicon glyphicon-ok\"></span> Siguiente</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/movimientos/egreso/lista/lista-egreso.html","<!--     <formly-form model=\"vm.user\" fields=\"vm.userFields\">\r\n  <button type=\"submit\" class=\"btn btn-primary col-sm-offset-4 col-sm-4\" ng-click=\"vm.submit(vm.user)\">Submit</button>\r\n</formly-form> --><div><form><div class=\"form-group col-lg-12\"><div class=form-group ng-if=\"vm.rol.id<=3\"><center><button ng-click=vm.crearNuevo() class=\"btn btn-success\" style=width:50%><i class=\"fa fa-plus\"></i> NUEVO EGRESO</button></center></div><div class=col ng-if=\"vm.rol.id<=3\"><div class=col><div class=form-check><label class=form-check-label for=filtrosCheckbox>Filtrar egresos &nbsp;&nbsp;</label><input type=checkbox id=filtrosCheckbox class=form-check-input ng-model=vm.buscar ng-click=vm.busqueda()></div><div class=form-group><div class=form-group style=\"display:flex; justify-content: space-between\"><div style=\"width:99%; margin: 0px 2px 0px 2px\"><center><button class=\"btn btn-primary btn-block\" ng-disabled=!vm.buscar ng-click=vm.abrirModalFiltros()><span class=\"fa fa-filter\"></span> Filtros combinados</button></center></div><div style=\"width:99%; margin: 0px 2px 0px 2px\"><center><button class=\"btn btn-primary btn-block\" ng-disabled=!vm.buscar ng-click=vm.abrirModalFiltroCajas()><span class=\"fa fa-filter\"></span> Filtro N° Caja</button></center></div><div style=\"width:99%; margin: 0px 2px 0px 2px\"><center><button class=\"btn btn-primary btn-block\" ng-disabled=!vm.buscar ng-click=vm.abrirModalFiltrosSuministro()><span class=\"fa fa-filter\"></span> Filtro tipo suministro</button></center></div><div style=\"width:99%; margin: 0px 2px 0px 2px\"><center><button class=\"btn btn-primary btn-block\" ng-disabled=!vm.buscar ng-click=vm.abrirModalFiltroNumeroVale()><span class=\"fa fa-filter\"></span> Filtro N° Vale</button></center></div><div style=\"width:99%; margin: 0px 2px 0px 2px\"><center><button class=\"btn btn-primary btn-block\" ng-disabled=!vm.buscar ng-click=vm.abrirModalNumeroMovimiento()><span class=\"fa fa-filter\"></span> Filtro N° movimiento</button></center></div></div></div></div></div><br><div class=col-lg-12><div uib-alert type=info ng-show=vm.filtrosUsados>FILTROS APLICADOS:<div ng-repeat=\"filtro in vm.filtrosUsados\">{{vm.filtrosUsados[$index]}}</div></div></div><div ng-show=\"!vm.egresos.length>0 && vm.bandera\" uib-alert class=\"danger col-lg-12 form-group\">No hay egresos para los filtros indicados</div></div><!-- 		<div class=\"col-lg-12\" ng-if=\"vm.egresos.length==0\">\r\n	<span uib-alert>\r\n		No hay egresos registrados\r\n	</span>\r\n</div> --><div class=col-lg-12><table ng-table=vm.tableParams class=\"table table-condensed\" show-filter=true ng-show=\"vm.egresos.length>0\"><tr ng-repeat=\"egresos in $data\" ng-class=\"{\'verde-claro\': egresos.estadoMovimiento.id==1, \'rojo-claro\':egresos.estadoMovimiento.id==2, \'amarillo-claro\': egresos.estadoMovimiento.id==3, \'azul-claro\':egresos.estadoMovimiento.id==4}\"><div><td data-title=\"\'Fecha\'\" ng-title=\"\'fecha\'\" align=center data-sortable=\"\'fecha\'\">{{egresos.fecha | date : \"dd/MM/yyyy HH:mm\" }}</td><td data-title=\"\'¿Cajas?\'\" align=center data-sortable=\"\'caja\'\">{{egresos.caja? \"Si\" : \"No\"}} <button class=\"btn btn-sm\" ng-if=egresos.caja ng-click=vm.verNumeroCajasEgreso(egresos);><i class=\"fa fa-search\"></i></button></td><td data-title=\"\'Depósito\'\" data-sortable=\"\'deposito.nombre\'\" filter=\"{\'deposito.nombre\': \'text\'}\" align=center>{{egresos.deposito.nombre.toUpperCase();}}</td><td data-title=\"\'Empresa\'\" data-sortable=\"\'empresa.nombre\'\" filter=\"{\'empresa.nombre\': \'text\'}\" align=center>{{egresos.empresa.nombre.toUpperCase();}}</td><td data-title=\"\'Sucursal\'\" filter=\"{\'sucursal.nombre\': \'text\'}\" align=center data-sortable=\"\'sucursal.nombre\'\">{{egresos.sucursal.nombre.toUpperCase();}}</td><td data-title=\"\'Sector\'\" filter=\"{\'sector\': \'text\'}\" align=center data-sortable=\"\'sector\'\">{{egresos.sector.toUpperCase();}}</td><td data-title=\"\'N° Movimiento\'\" style=width:5% align=center filter=\"{\'numeroMovimiento\':\'text\'}\" data-sortable=\"\'numeroMovimiento\'\">{{egresos.numeroMovimiento}}</td><td data-title=\"\'N° Vale\'\" style=width:5% align=center filter=\"{\'numeroVale\':\'text\'}\" data-sortable=\"\'numeroVale\'\">{{egresos.numeroVale? egresos.numeroVale : \"-\"}}</td><td data-title=\"\'N° Mail\'\" style=width:5% align=center filter=\"{\'numeroMail\':\'text\'}\" data-sortable=\"\'numeroMail\'\">{{egresos.numeroMail? egresos.numeroMail : \"-\"}}</td><td data-title=\"\'N° Pedido\'\" style=width:5% align=center filter=\"{\'pedido.numeroPedido\':\'text\'}\" data-sortable=\"\'pedido.numeroPedido\'\">{{egresos.pedido? egresos.pedido.numeroPedido : \"-\"}}</td><td data-title=\"\'Fecha despacho\'\" style=width:7% align=center data-sortable=\"\'egreso.fecha\'\">{{egresos.egreso.fecha? egresos.egreso.fecha : \"-\" | date : \"dd/MM/yyyy HH:mm\" }}</td><td data-title=\"\'Estado\'\" style=width:5% data-sortable=\"\'estadoMovimiento.nombre\'\" filter=\"{\'estadoMovimiento.nombre\': \'text\'}\" align=center>{{egresos.estadoMovimiento.nombre.toUpperCase();}}</td><td data-title=\"\'Recepción\'\" style=width:5% align=center>{{egresos.fechaConfirmacion? \"Si\" : \"No\"}} <button class=\"btn btn-sm\" ng-if=egresos.fechaConfirmacion ng-click=vm.verConfirmacion(egresos);><i class=\"fa fa-search\"></i></button></td><td data-title=\"\'Acciones\'\" align=center style=width:15%><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.visualizarEgreso(egresos)><i class=\"fa fa-search\"></i> </a><a ng-if=\"vm.rol.id<=3\" class=\"btn btn-success\" ng-disabled=\"!(egresos.estadoMovimiento.id==1 || egresos.estadoMovimiento.id==3)\" ng-click=\"!(egresos.estadoMovimiento.id==1 || egresos.estadoMovimiento.id==3) || vm.cambiarEstado(egresos)\"><i class=\"fa fa-archive\" ng-if=\"egresos.estadoMovimiento.id>=2\"></i> <i class=\"glyphicon glyphicon-paste\" ng-if=\"egresos.estadoMovimiento.id==1\"></i> </a><a ng-if=\"vm.rol.id<=3\" ng-disabled=\"!(egresos.estadoMovimiento.id==1 || egresos.estadoMovimiento.id==2 || egresos.estadoMovimiento.id==3)\" class=\"btn btn-danger\" ng-click=\"!(egresos.estadoMovimiento.id==1 || egresos.estadoMovimiento.id==2 || egresos.estadoMovimiento.id==3) || vm.eliminar(egresos)\"><i class=\"fa fa-trash\"></i></a></div></td></div></tr></table></div></form></div>");
$templateCache.put("app/app/main/movimientos/egreso/lista-en-preparacion/lista-en-preparacion.html","<!--     <formly-form model=\"vm.user\" fields=\"vm.userFields\">\r\n  <button type=\"submit\" class=\"btn btn-primary col-sm-offset-4 col-sm-4\" ng-click=\"vm.submit(vm.user)\">Submit</button>\r\n</formly-form> --><script type=text/ng-template id=headerCheckbox.html><label>Todos</label>\r\n    <input type=\"checkbox\" ng-click=\"vm.marcarTodo();\" ng-model=\"vm.check\" ng-value=\"vm.check.valor\"/></script><div><form><div class=\"col-lg-12 panel\"><div class=col-lg-10><div class=form-group><label ng-if=!vm.bandera>Seleccione el depósito:</label><label ng-if=vm.bandera>Depósito seleccionado:</label><input type=text ng-disabled=vm.bandera ng-model=vm.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><br><div class=col-lg-2 ng-if=!vm.bandera><button style=width:100% ng-disabled=!vm.deposito.id ng-click=vm.buscarPorDeposito() class=\"btn btn-primary\"><i class=\"fa fa-filter\"></i> Filtrar</button></div><div class=col-lg-2 ng-if=vm.bandera><button style=width:100% ng-click=vm.cambiarFiltros() class=\"btn btn-warning\"><i class=\"fa fa-exchange\"></i> Cambiar filtros</button></div><div class=col-lg-12 ng-if=\"vm.deposito.id && vm.egresos.length==0 && vm.bandera\"><span uib-alert>No hay egresos en preparación para el depósito seleccionado</span></div></div><div class=form-group ng-if=\"vm.deposito.id && vm.egresos.length>0 && vm.bandera\"><center><button ng-disabled=!vm.comprobarSeleccionado(); ng-click=vm.ubicacionesPorSuministros() class=\"btn btn-primary\" style=width:35%><i class=\"fa fa-file-text\"></i> UBICACIONES POR SUMINISTROS DE EGRESOS SELECCIONADOS</button> <button ng-disabled=!vm.comprobarSeleccionado(); ng-click=vm.reporteEgresosEnPreparacion() class=\"btn btn-success\" style=width:50%><i class=\"fa fa-file-text\"></i> REPORTE EGRESOS EN PREPARACIÓN</button></center></div><div class=col-lg-12 ng-if=\"vm.deposito.id && vm.egresos.length>0 && vm.bandera\"><table ng-table=vm.tableParams class=\"table table-condensed\" show-filter=true><tr ng-repeat=\"egresos in $data\" ng-class=\"{\'azul-claro\': egresos.seleccionado}\"><div><td data-title=\"\'Fecha\'\" align=center data-sortable=\"\'fecha\'\">{{egresos.fecha | date : \"dd/MM/yyyy HH:mm\" }}</td><td data-title=\"\'Empresa\'\" data-sortable=\"\'empresa.nombre\'\" filter=\"{\'empresa.nombre\': \'text\'}\" align=center>{{egresos.empresa.nombre.toUpperCase();}}</td><td data-title=\"\'Sucursal\'\" data-sortable=\"\'sucursal.nombre\'\" filter=\"{\'sucursal.nombre\': \'text\'}\" align=center>{{egresos.sucursal.nombre.toUpperCase();}}</td><td data-title=\"\'¿Cajas?\'\" align=center data-sortable=\"\'caja\'\">{{egresos.caja? \"Si\" : \"No\"}} <button class=btn ng-if=egresos.caja ng-click=vm.verNumeroCajasEgreso(egresos);><i class=\"fa fa-search\"></i></button></td><td data-title=\"\'N° Movimiento\'\" style=width:5% align=center filter=\"{\'numeroMovimiento\':\'text\'}\" data-sortable=\"\'numeroMovimiento\'\">{{egresos.numeroMovimiento}}</td><td data-title=\"\'N° Vale\'\" align=center filter=\"{\'numeroVale\':\'text\'}\" data-sortable=\"\'numeroVale\'\">{{egresos.numeroVale? egresos.numeroVale : \"-\"}}</td><td data-title=\"\'Estado\'\" style=width:5% align=center>{{egresos.estadoMovimiento.nombre.toUpperCase();}}</td><td data-title=\"\'Ver\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-disabled=\"egresos.estadoMovimiento.id!=3\" ng-click=\"egresos.estadoMovimiento.id!=3 || vm.visualizarEgreso(egresos)\"><i class=\"fa fa-search\"></i></a></div></td><td header=\"\'headerCheckbox.html\'\" align=center><input type=checkbox ng-model=egresos.seleccionado></td></div></tr></table></div></form></div>");
$templateCache.put("app/app/main/movimientos/egreso/lista-generados/lista-generados.html","<!--     <formly-form model=\"vm.user\" fields=\"vm.userFields\">\r\n  <button type=\"submit\" class=\"btn btn-primary col-sm-offset-4 col-sm-4\" ng-click=\"vm.submit(vm.user)\">Submit</button>\r\n</formly-form> --><script type=text/ng-template id=headerCheckbox.html><label>Todos</label>\r\n    <input type=\"checkbox\" ng-click=\"vm.marcarTodo();\" ng-model=\"vm.check\" ng-value=\"vm.check.valor\"/></script><div><form><div class=\"col-lg-12 panel\"><div class=col-lg-10><div class=form-group><label ng-if=!vm.bandera>Seleccione el depósito:</label><label ng-if=vm.bandera>Depósito seleccionado:</label><input type=text ng-disabled=vm.bandera ng-model=vm.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><br><div class=col-lg-2 ng-if=!vm.bandera><button style=width:100% ng-disabled=!vm.deposito.id ng-click=vm.buscarPorDeposito() class=\"btn btn-primary\"><i class=\"fa fa-filter\"></i> Filtrar</button></div><div class=col-lg-2 ng-if=vm.bandera><button style=width:100% ng-click=vm.cambiarFiltros() class=\"btn btn-warning\"><i class=\"fa fa-exchange\"></i> Cambiar filtros</button></div><div class=col-lg-12 ng-if=\"vm.deposito.id && vm.egresos.length==0 && vm.bandera\"><span uib-alert>No hay despachos de egresos para el depósito seleccionado</span></div></div><div class=form-group ng-if=\"vm.deposito.id && vm.egresos.length>0 && vm.bandera\"><center><button ng-disabled=!vm.comprobarSeleccionado(); ng-click=vm.ubicacionesPorSuministros() class=\"btn btn-primary\" style=width:35%><i class=\"fa fa-file-text\"></i> UBICACIONES POR SUMINISTROS DE EGRESOS SELECCIONADOS</button> <button ng-disabled=!vm.comprobarSeleccionado(); ng-click=vm.reporteSeleccionados() class=\"btn btn-success\" style=width:35%><i class=\"fa fa-file-text\"></i> OBTENER REMITOS DE MOVIMIENTOS SELECCIONADOS</button></center></div><div class=col-lg-12 ng-if=\"vm.deposito.id && vm.egresos.length>0 && vm.bandera\"><table ng-table=vm.tableParams class=\"table table-condensed\" show-filter=true><tr ng-repeat=\"egresos in $data\" ng-class=\"{\'azul-claro\': egresos.seleccionado}\"><div><td data-title=\"\'Fecha\'\" align=center data-sortable=\"\'fecha\'\">{{egresos.fecha | date : \"dd/MM/yyyy HH:mm\" }}</td><td data-title=\"\'Empresa\'\" data-sortable=\"\'empresa.nombre\'\" filter=\"{\'empresa.nombre\': \'text\'}\" align=center>{{egresos.empresa.nombre.toUpperCase();}}</td><td data-title=\"\'Sucursal\'\" data-sortable=\"\'sucursal.nombre\'\" filter=\"{\'sucursal.nombre\': \'text\'}\" align=center>{{egresos.sucursal.nombre.toUpperCase();}}</td><td data-title=\"\'¿Cajas?\'\" align=center data-sortable=\"\'caja\'\">{{egresos.caja? \"Si\" : \"No\"}} <button class=btn ng-if=egresos.caja ng-click=vm.verNumeroCajasEgreso(egresos);><i class=\"fa fa-search\"></i></button></td><td data-title=\"\'N° Movimiento\'\" style=width:5% align=center filter=\"{\'numeroMovimiento\':\'text\'}\" data-sortable=\"\'numeroMovimiento\'\">{{egresos.numeroMovimiento}}</td><td data-title=\"\'N° Vale\'\" align=center filter=\"{\'numeroVale\':\'text\'}\" data-sortable=\"\'numeroVale\'\">{{egresos.numeroVale? egresos.numeroVale : \"-\"}}</td><td data-title=\"\'Estado\'\" style=width:5% align=center>{{egresos.estadoMovimiento.nombre.toUpperCase();}}</td><td data-title=\"\'Ver\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-disabled=\"egresos.estadoMovimiento.id!=1\" ng-click=\"egresos.estadoMovimiento.id!=1 || vm.visualizarEgreso(egresos)\"><i class=\"fa fa-search\"></i></a></div></td><td header=\"\'headerCheckbox.html\'\" align=center><input type=checkbox ng-model=egresos.seleccionado></td></div></tr></table></div></form></div>");
$templateCache.put("app/app/main/movimientos/egreso/nuevo-egreso-multisucursal/nuevo-egreso-multisucursal.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=\"form-group col-lg-5\"><label>Depósito:</label><input type=text ng-model=vm.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false name=deposito required ng-disabled=vm.bandera> <span uib-alert class=danger ng-show=\"vm.form.deposito.$error.required && vm.form.deposito.$dirty\">Este campo es requerido.</span></div><div class=\"form-group col-lg-5\"><label>Empresa:</label><input type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la Empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 required name=empresa typeahead-editable=false focus-on=empresa ng-disabled=vm.bandera> <span uib-alert class=danger ng-show=\"vm.form.empresa.$error.required && vm.form.empresa.$dirty\">Este campo es requerido.</span></div><br><div class=col-lg-2 ng-if=!vm.bandera><button style=width:100% ng-disabled=\"!vm.deposito.id || !vm.empresa.id\" ng-click=vm.seleccionar() class=\"btn btn-primary\" focus-on=seleccionar><i class=\"fa fa-check\"></i> Seleccionar</button></div><div class=col-lg-2 ng-if=vm.bandera><button style=width:100% ng-click=vm.cambiarSeleccion() class=\"btn btn-warning\"><i class=\"fa fa-exchange\"></i> Cambiar</button></div><div class=\"form-group col-lg-4\"><label>Autoriza:</label><input class=form-control ng-disabled=!vm.bandera ng-maxlength=100 focus-on=autoriza ng-model=vm.autoriza placeholder=\"Ingrese quién autoriza los egresos\" type=text name=autoriza> <span uib-alert class=danger ng-if=\"vm.form.autoriza.$error.maxlength && vm.form.autoriza.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><div class=\"form-group col-lg-4\"><label>Número de seguimiento por mail</label><input type=text class=form-control ng-disabled=!vm.bandera ng-maxlength=100 ng-model=vm.numeroMail placeholder=\"Ingrese el número de seguimiento por mail\" name=numeroMail> <span uib-alert class=danger ng-if=\"vm.form.numeroMail.$error.maxlength && vm.form.numeroMail.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><div class=\"form-group col-lg-4\"><label>Número de Vale</label><input type=text class=form-control ng-disabled=!vm.bandera ng-maxlength=100 ng-model=vm.numeroVale placeholder=\"Ingrese el número de vale\" name=numeroVale> <span uib-alert class=danger ng-if=\"vm.form.numeroVale.$error.maxlength && vm.form.numeroVale.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><div class=\"col-lg-12 form-group\" ng-if=!vm.tipoSuministro.id><center><div><button class=\"btn btn-primary\" style=width:30% ng-click=vm.abrirModalSeleccionTipoSuministro(); ng-disabled=\"!vm.bandera || !vm.deposito.id || !vm.empresa.id\"><i class=\"fa fa-check\"></i> &nbsp;Seleccionar tipo de suministro</button></div></center></div><div class=\"col-lg-12 form-group\" ng-if=vm.tipoSuministro.id><div class=form-group><div class=col-lg-10><label>Tipo de suministro seleccionado:</label><div style=\"overflow-x: auto\" class=form-control style=\"word-wrap: white\">{{vm.verTipoSuministro()}}</div></div></div><div class=col-lg-2><br><div class=form-group><button style=width:100% class=\"btn btn-warning\" ng-click=vm.cambiarTipoSuministro(); ng-disabled=!vm.tipoSuministro.id>Cambiar selección</button></div></div></div><div class=col-lg-12><div class=form-group ng-if=\"vm.tipoSuministro.id && vm.listaNoInventariables.length>0 && !vm.tipoSuministro.inventariable\"><center><button class=\"btn btn-primary\" ng-click=vm.asignarSuministrosAutomaticamente();><i class=\"fa fa-magic\"></i> Asignar suministros automáticamente</button></center></div></div><br><div class=col-lg-12><div class=form-group ng-if=\"vm.tipoSuministro.id && vm.listaNoInventariables.length>0\"><div uib-alert type=info class=col-lg-12><label>Cantidad en disponible para seleccionar: {{vm.cantidadSeleccionableNoInventariable();}}</label><br><label>Cantidad seleccionada: {{vm.cantidadAsignadaNoInventariable>0 ? vm.cantidadAsignadaNoInventariable : \"0\"}}</label></div></div><div class=form-group ng-if=\"vm.tipoSuministro.id && vm.tipoSuministro.inventariable\"><div uib-alert type=info class=col-lg-12><label>Cantidad en disponible para seleccionar: {{vm.cantidadSeleccionableInventariable();}}</label><br><label>Cantidad seleccionada: {{vm.cantidadAsignadaInventariable? vm.cantidadAsignadaInventariable : \"0\"}}</label></div></div></div><!--SELECCIÓN DE SUCURSALES!!!!--><br><div class=col ng-if=vm.tipoSuministro.id><div class=\"form-group col-lg-10\"><label>Sucursales:</label><input type=text ng-model=vm.sucursal placeholder=\"Seleccione o busque la sucursal\" uib-typeahead=\"sucursal as sucursal.nombre.toUpperCase() for sucursal in vm.sucursales | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 required name=sucursal typeahead-editable=false focus-on=sucursal> <span uib-alert class=danger ng-show=\"vm.form.sucursal.$error.required && vm.form.sucursal.$dirty\">Este campo es requerido.</span></div><div class=\"form-group col-lg-2\"><br><button style=width:100% class=\"btn btn-success\" ng-click=vm.comprobarSucursalSeleccionada(); ng-disabled=!vm.sucursal.id><i class=\"fa fa-plus\"></i> Agregar</button></div></div><div class=col-lg-12 ng-if=vm.tipoSuministro.id><table ng-table=vm.tableParams class=\"table table-condensed\" show-filter=false ng-show=\"vm.sucursalesSeleccionadas.length>0\"><tr ng-repeat=\"item in $data\" ng-class=\"{\'verde-claro\': item.detalles.length>0, \'rojo-claro\':item.detalles.length==0}\"><div><td data-title=\"\'Sucursal\'\" style=width:40% data-sortable=\"\'sucursal.nombre\'\" filter=\"{\'sucursal.nombre\': \'text\'}\" align=center>{{item.sucursal.nombre.toUpperCase();}}</td><td data-title=\"\'Sector\'\" align=center><ng-form name=camposForm><div><input class=form-control type=text name=sector ng-model=item.sector placeholder=\"Ingrese sector\"> <span uib-alert class=danger ng-if=\"camposForm.sector.$error.maxlength && camposForm.sector.$dirty\">Este campo no puede superar los 100 caracteres.</span></div></ng-form></td><td data-title=\"\'Acciones\'\" align=center style=width:30%><div class=btn-group><a class=\"btn btn-danger\" ng-click=vm.eliminar(item)><i class=\"fa fa-remove\"></i> </a><a class=\"btn btn-primary\" ng-click=vm.agregarSuministros(item)><i class=\"fa fa-plus\"></i> Agregar o quitar suministros</a></div></td><td data-title=\"\'Asignados\'\" align=center>{{ item.detalles.length>0? vm.calcularAsignadoSucursal(item) : \"No se asignó nada aún\" }}<div class=btn-group><a class=\"btn btn-info\" ng-disabled=\"item.detalles.length==0\" ng-click=\"item.detalles.length==0 || vm.verAsignados(item)\"><i class=\"fa fa-search\"></i></a></div></td></div></tr></table></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.guardar() ng-disabled=\"!vm.tipoSuministro.id || !vm.sucursalesSeleccionadas.length>0 || vm.faltanDatos()\"><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/movimientos/egreso/problemas/editar-problemas.html","<div class=col-lg-12 ng-if=vm.comprobarEgresoCerrado()><div class=\"panel panel-default\"><div class=panel-body><div class=\"form-group col-lg-6\"><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.egreso.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.egreso.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-3\"><label>Número de movimiento:</label><input class=form-control ng-readonly=true ng-model=vm.egreso.numeroMovimiento type=text name=numeroMovimiento></div><div class=\"form-group col-lg-3\"><label>Fecha:</label><input class=form-control ng-readonly=true ng-model=vm.fecha type=text name=fecha></div><div class=\"form-group col-lg-3\"><label>Monto total:</label><input class=form-control ng-readonly=true ng-model=vm.montoTotal type=text name=montoTotal></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=form-control ng-readonly=true ng-model=vm.egreso.observacion type=text name=observacion style=resize:vertical></textarea></div></div></div><br><div class=col-lg-12><label>Agregar problemas:</label><div class=col-lg-12><div class=col-lg-10><input type=text ng-model=vm.problema placeholder=\"Seleccione el problema\" uib-typeahead=\"problema as problema.nombre.toUpperCase() for problema in vm.problemas\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=col-lg-2><button class=\"btn btn-success\" ng-disabled=!vm.problema.id ng-click=vm.agregarProblema()><span class=\"fa fa-check\"></span> Agregar</button></div></div></div><br><br><br><br><div class=col-lg-12 ng-show=\"vm.comprobarEgresoCerrado() && vm.egreso.problemas.length==0\"><span class=danger uib-alert>El egreso no tiene problemas asignados.</span></div><br><div class=\"col-lg-12 form-group\" ng-if=\"vm.comprobarEgresoCerrado() && vm.egreso.problemas.length>0\"><label>Problemas asignados</label></div><form name=vm.form ng-show=true ng-if=vm.comprobarEgresoCerrado();><div class=col-lg-12 ng-show=\"vm.egreso.problemas.length>0\"><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.egreso.problemas.length>0\"><tr ng-repeat=\"problema in $data track by $index\"><div><td title=\"\'Problema\'\" align=center>{{problema.nombre.toUpperCase();}}</td><td data-title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.verProblema(problema)><i class=\"fa fa-search\"></i> </a><a class=\"btn btn-danger\" ng-click=vm.eliminarProblema($index)><i class=\"fa fa-remove\"></i></a></div></td></div></tr></table></div><div class=\"form-group col-lg-12\"><label>Descripción de problemas:</label><textarea class=form-control ng-maxlength=1000 ng-model=vm.egreso.observacionProblema placeholder=\"Ingrese una descripción de los problemas observados\" type=text name=observacion style=resize:vertical></textarea><span uib-alert class=danger ng-if=\"vm.form.observacion.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.observacion.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 1000 caracteres.</span></div></form><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.editarProblemas()><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.volver()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div><div ng-if=!vm.comprobarEgresoCerrado() class=col-lg-12><span uib-alert class=danger>El egreso todavía no tiene ubicaciones asignadas.</span></div>");
$templateCache.put("app/app/main/movimientos/egreso/visualizar-egreso-despachado/visualizar-egreso-despachado.html","<div class=form-group ng-if=vm.comprobarEstadoEgreso();><center><button ng-click=vm.volver(); class=\"btn btn-info\" style=width:30%><i class=\"fa fa-arrow-left\"></i> Volver al listado</button> <button ng-if=\"vm.rol.id<=3\" ng-click=vm.imprimirInforme(); class=\"btn btn-primary\" style=width:30%><i class=\"fa fa-file-text-o\"></i> Obtener informe</button></center></div><div class=col-lg-12 ng-if=vm.comprobarEstadoEgreso()><div class=\"panel panel-default\"><div class=panel-body><div class=\"form-group col-lg-6\"><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.egreso.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.egreso.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-12\"><label>Sucursal:</label><input type=text ng-model=vm.egreso.sucursal.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-12\"><label>Solicitó:</label><input type=text ng-model=vm.egreso.solicitante class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-4\"><label>Número de movimiento:</label><input class=form-control ng-readonly=true ng-model=vm.egreso.numeroMovimiento type=text name=numeroMovimiento></div><div class=\"form-group col-lg-4\"><label>Fecha creación:</label><input class=form-control ng-readonly=true ng-model=vm.fechaCreacion type=text name=fecha></div><div ng-if=\"vm.rol.id<=3\" class=\"form-group col-lg-4\"><label>Monto total:</label><input class=form-control ng-readonly=true ng-model=vm.montoTotal type=text name=montoTotal></div><div class=\"form-group col-lg-12\"><label>Estado:</label><input class=form-control ng-readonly=true ng-model=vm.egreso.estadoMovimiento.nombre type=text name=estado></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=form-control ng-readonly=true ng-model=vm.egreso.observacion type=text name=observacion style=resize:vertical></textarea></div></div></div><div ng-if=false><uib-accordion><div uib-accordion-group class=panel-default is-open=status.isCustomHeaderOpen><uib-accordion-heading>Problemas <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.isCustomHeaderOpen, \'glyphicon-chevron-right\': !status.isCustomHeaderOpen}\"></i></uib-accordion-heading><div class=col-lg-12><div ng-if=\"vm.egreso.problemas.length==0\"><span uib-alert type=info>No posee ningún problema asignado</span></div><div><center><button class=\"btn btn-primary\" ng-click=vm.editarProblemas();><i class=\"fa fa-pencil-square\"></i> Agregar o quitar problemas</button></center></div><div ng-if=\"vm.egreso.problemas.length>0\"><label>Problemas asignados:</label><table ng-table=vm.tableParams1 class=table><tr ng-repeat=\"problema in $data track by $index\"><td>{{problema.nombre.toUpperCase();}}</td></tr></table><label>Descripción de problemas:</label><textarea class=form-control ng-readonly=true ng-model=vm.egreso.observacionProblema type=text name=observacionProblema style=resize:vertical></textarea></div></div></div></uib-accordion></div><br><div><uib-accordion><div uib-accordion-group class=panel-default is-open=status.isCustomHeaderOpen><uib-accordion-heading>Despacho <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.isCustomHeaderOpen, \'glyphicon-chevron-right\': !status.isCustomHeaderOpen}\"></i></uib-accordion-heading><div class=col-lg-12><div class=col-lg-12><center><button style=width:60% class=\"btn btn-primary\" ng-if=vm.egreso.egreso.id ng-click=vm.visualizarEgreso()><i class=\"fa fa-search\"></i> Ver despacho</button></center><br></div><div class=\"col-lg-6 form-group\"><label>Empresa logística:</label><input type=text ng-readonly=true ng-model=vm.egreso.egreso.empresaLogistica.nombre class=\"form-control text-uppercase\"></div><div class=\"col-lg-6 form-group\"><label>Retiró:</label><input type=text ng-readonly=true ng-model=vm.persona class=\"form-control text-uppercase\"></div><div class=\"col-lg-6 form-group\"><label>N° Egreso</label><input type=text ng-readonly=true ng-model=vm.egreso.egreso.numeroEgreso class=\"form-control text-uppercase\"></div><div class=\"col-lg-6 form-group\"><label>Fecha despacho</label><input type=text ng-readonly=true ng-model=vm.fechaDespacho class=\"form-control text-uppercase\"></div><div class=\"col-lg-12 form-group\"><label>N° Guía</label><input type=text ng-readonly=true ng-model=vm.egreso.egreso.nroGuia class=\"form-control text-uppercase\"></div><!-- 					<div class=\"col-lg-6 form-group\">\r\n	<label>Cantidad total de paquetes: </label>\r\n	<br>\r\n	<h3>\r\n		<b>\r\n			{{vm.egreso.egreso.cantidadPaquetes==1? vm.egreso.egreso.cantidadPaquetes + \" paquete\" : vm.egreso.egreso.cantidadPaquetes + \" paquetes\"}} \r\n		</b>\r\n	</h3>\r\n</div>\r\n<div class=\"col-lg-6 form-group\">\r\n	<label>Peso total de paquetes: </label>\r\n	<br>\r\n	<h3>\r\n		<b>\r\n			{{vm.egreso.egreso.pesoTotal}} Kg.\r\n		</b>\r\n	</h3>\r\n</div> --></div></div></uib-accordion></div><br><div><uib-accordion><div uib-accordion-group is-open=status.isCustomHeaderOpen><uib-accordion-heading>Detalle de suministros <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.isCustomHeaderOpen, \'glyphicon-chevron-right\': !status.isCustomHeaderOpen}\"></i></uib-accordion-heading><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesNoInventariablesAgrupados.length>0\"><label>Detalle de suministros no inventariables</label></div><form ng-show=true><div class=col-lg-12 ng-show=\"vm.detallesNoInventariablesAgrupados.length>0\"><table ng-table=vm.tableParamsNoInventariableAgrupado class=\"table table-hover\" ng-init=\"agrupado.$hideRows = true\" show-group=false><tr class=ng-table-group ng-repeat-start=\"agrupado in $data\"><td colspan=6><a href=\"\" ng-click=\"agrupado.$hideRows = !agrupado.$hideRows\"><span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': agrupado.$hideRows, \'glyphicon-chevron-down\': !agrupado.$hideRows }\"></span> Tipo de suministro: {{ agrupado.tipoSuministro.nombre.toUpperCase() }}</a></td><td ng-if=\"vm.rol.id<=3\" title=\"Precio total\">Precio total por tipo de suministro: <b>${{agrupado.precioTotal}}</b></td><td title=\"Cantidad solicitada\">Cantidad solicitada total: <b>{{agrupado.cantidad}}</b></td><!-- 						        <td title=\"\'Acciones\'\" align=\"center\">\r\n									<div class=\"btn-group\">\r\n										<a class=\"btn btn-danger\" ng-click=\"vm.quitarTipo(agrupado)\">\r\n											<i class=\"fa fa-remove\"></i>\r\n										</a>\r\n									</div>\r\n</td> --></tr><tr ng-hide=agrupado.$hideRows ng-repeat=\"detalle in agrupado.detalles\" ng-repeat-end><td title=\"\'Marca\'\" align=center>{{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}</td><td ng-if=\"vm.rol.id<=3\" title=\"\'Precio\'\" align=center>${{detalle.suministro.precioUnitario}}</td><td title=\"\'Cantidad solicitada\'\" align=center>{{detalle.cantidad}}</td><!-- 			            	  	<td style=\"width:35%;\" title=\"\'Ubicación\'\">\r\n	<div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !detalle.suministro.ubicacion.numeroOrden, \'has-success\':detalle.suministro.ubicacion.numeroOrden}\">\r\n									    <i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i>\r\n									    <div  ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto;\" class=\"form-control\" ng-click=\"vm.ubicacionCompleta(detalle)\" class=\"form-control\" style=\"word-wrap: white;\">\r\n									    	{{vm.ubicacionNaveNumeroOrden(detalle)}}\r\n									    </div>\r\n									</div>\r\n</td> --></tr></table></div></form><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesInventariablesAgrupados.length>0\"><label>Detalle de suministros inventariables</label></div><form ng-show=true><div class=col-lg-12 ng-show=\"vm.detallesInventariablesAgrupados.length>0\"><table ng-table=vm.tableParamsInventariableAgrupado class=\"table table-hover\" ng-init=\"agrupado.$hideRows = true\" show-group=false><tr class=ng-table-group ng-repeat-start=\"agrupado in $data\"><td colspan=6><a href=\"\" ng-click=\"agrupado.$hideRows = !agrupado.$hideRows\"><span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': agrupado.$hideRows, \'glyphicon-chevron-down\': !agrupado.$hideRows }\"></span> Tipo de suministro: {{ agrupado.tipoSuministro.nombre.toUpperCase() }}</a></td><td ng-if=\"vm.rol.id<=3\" title=\"Precio total\">Precio total por tipo de suministro: <b>${{agrupado.precioTotal}}</b></td><td title=\"Cantidad solicitada\">Cantidad solicitada total: <b>{{agrupado.cantidad}}</b></td><!-- 				        <td title=\"\'Acciones\'\" align=\"center\">\r\n									<div class=\"btn-group\">\r\n										<a class=\"btn btn-danger\" ng-click=\"vm.quitarTipo(agrupado)\">\r\n											<i class=\"fa fa-remove\"></i>\r\n										</a>\r\n									</div>\r\n		</td> --></tr><tr ng-hide=agrupado.$hideRows ng-repeat=\"detalle in agrupado.detalles\" ng-repeat-end><td title=\"\'Marca\'\" align=center>{{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'N° serie\'\" sortable align=center>{{detalle.suministroInventariable.serie ? detalle.suministroInventariable.serie : \"-\" }}</td><td title=\"\'N° inventario\'\" sortable align=center>{{detalle.suministroInventariable.inventario ? detalle.suministroInventariable.inventario : \"-\" }}</td><td ng-if=\"vm.rol.id<=3\" title=\"\'Precio\'\" align=center>${{detalle.suministro.precioUnitario}}</td><!-- 			            	  	<td style=\"width:35%;\" title=\"\'Ubicación\'\" ng-if=\"vm.comprobarEstadoEgreso();\">\r\n	<div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !detalle.suministro.ubicacion.numeroOrden, \'has-success\':detalle.suministro.ubicacion.numeroOrden}\">\r\n									    <i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i>\r\n									    <div  ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto;\" class=\"form-control\" ng-click=\"vm.ubicacionCompleta(detalle)\" class=\"form-control\" style=\"word-wrap: white;\">\r\n									    	{{vm.ubicacionNaveNumeroOrden(detalle)}}\r\n									    </div>\r\n									</div>\r\n</td> --></tr></table></div><form></form></form></div></uib-accordion></div></div><div ng-if=!vm.comprobarEstadoEgreso() class=col-lg-12><span uib-alert class=danger>El egreso no puede visualizarse </span><button ng-click=vm.volver(); class=\"btn btn-warning\" style=width:30%><i class=\"fa fa-arrow-left\"></i> Volver al listado</button></div>");
$templateCache.put("app/app/main/movimientos/egreso/visualizar-egreso/visualizar-egreso.html","<div class=form-group ng-if=vm.comprobarEstadoEgreso();><center><button ng-click=vm.volver(); class=\"btn btn-info\" style=width:30%><i class=\"fa fa-arrow-left\"></i> Volver al listado</button> <button ng-if=\"vm.rol.id<=3\" ng-click=vm.imprimirInforme(); class=\"btn btn-primary\" style=width:30%><i class=\"fa fa-file-text-o\"></i> Obtener informe</button></center></div><div class=col-lg-12 ng-if=vm.comprobarEstadoEgreso()><div class=\"panel panel-default\"><div class=panel-body><div class=\"form-group col-lg-6\"><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.egreso.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.egreso.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-12\"><label>Sucursal:</label><input type=text ng-model=vm.egreso.sucursal.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-12\"><label>Solicitó:</label><input type=text ng-model=vm.egreso.solicitante class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-4\"><label>Número de movimiento:</label><input class=form-control ng-readonly=true ng-model=vm.egreso.numeroMovimiento type=text name=numeroMovimiento></div><div class=\"form-group col-lg-4\"><label>Fecha:</label><input class=form-control ng-readonly=true ng-model=vm.fecha type=text name=fecha></div><div ng-if=\"vm.rol.id<=3\" class=\"form-group col-lg-4\"><label>Monto total:</label><input class=form-control ng-readonly=true ng-model=vm.montoTotal type=text name=montoTotal></div><div class=\"form-group col-lg-4\"><label>Estado:</label><input class=form-control ng-readonly=true ng-model=vm.egreso.estadoMovimiento.nombre type=text name=estado></div><div class=\"form-group col-lg-4\"><label>Número Vale:</label><input class=form-control ng-readonly=true ng-model=vm.egreso.numeroVale type=text name=numeroVale></div><div class=\"form-group col-lg-4\"><label>¿Es un egreso de cajas cerradas?:</label><input class=form-control ng-readonly=true ng-model=vm.cajas type=text name=cajas></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=form-control ng-readonly=true ng-model=vm.egreso.observacion type=text name=observacion style=resize:vertical></textarea></div></div></div><div ng-if=false><uib-accordion><div uib-accordion-group class=panel-default is-open=status.isCustomHeaderOpen><uib-accordion-heading>Problemas <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.isCustomHeaderOpen, \'glyphicon-chevron-right\': !status.isCustomHeaderOpen}\"></i></uib-accordion-heading><div class=col-lg-12><div ng-if=\"vm.egreso.problemas.length==0\"><span uib-alert type=info>No posee ningún problema asignado</span></div><div><center><button class=\"btn btn-primary\" ng-click=vm.editarProblemas();><i class=\"fa fa-pencil-square\"></i> Agregar o quitar problemas</button></center></div><div ng-if=\"vm.egreso.problemas.length>0\"><label>Problemas asignados:</label><table ng-table=vm.tableParams1 class=table><tr ng-repeat=\"problema in $data track by $index\"><td>{{problema.nombre.toUpperCase();}}</td></tr></table><label>Descripción de problemas:</label><textarea class=form-control ng-readonly=true ng-model=vm.egreso.observacionProblema type=text name=observacionProblema style=resize:vertical></textarea></div></div></div></uib-accordion></div><br><div ng-if=!vm.egreso.caja><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesNoInventariablesAgrupados.length>0\"><label>Detalle de suministros no inventariables</label></div><form ng-show=true><div class=col-lg-12 ng-show=\"vm.detallesNoInventariablesAgrupados.length>0\"><table ng-table=vm.tableParamsNoInventariableAgrupado class=\"table table-hover\" ng-init=\"agrupado.$hideRows = true\" show-group=false><tr class=ng-table-group ng-repeat-start=\"agrupado in $data\"><td colspan=6><a href=\"\" ng-click=\"agrupado.$hideRows = !agrupado.$hideRows\"><span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': agrupado.$hideRows, \'glyphicon-chevron-down\': !agrupado.$hideRows }\"></span> Tipo de suministro: {{ agrupado.tipoSuministro.nombre.toUpperCase() }}</a></td><td ng-if=\"vm.rol.id<=3\" title=\"Precio total\">Precio total por tipo de suministro: <b>${{agrupado.precioTotal}}</b></td><td title=\"Cantidad solicitada\">Cantidad solicitada total: <b>{{agrupado.cantidad}}</b></td><!-- 				        <td title=\"\'Acciones\'\" align=\"center\">\r\n							<div class=\"btn-group\">\r\n								<a class=\"btn btn-danger\" ng-click=\"vm.quitarTipo(agrupado)\">\r\n									<i class=\"fa fa-remove\"></i>\r\n								</a>\r\n							</div>\r\n</td> --></tr><tr ng-hide=agrupado.$hideRows ng-repeat=\"detalle in agrupado.detalles\" ng-repeat-end><td title=\"\'Marca\'\" align=center>{{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}</td><td ng-if=\"vm.rol.id<=3\" title=\"\'Precio\'\" align=center>${{detalle.suministro.precioUnitario}}</td><td title=\"\'Cantidad solicitada\'\" align=center>{{detalle.cantidad}}</td><td ng-if=\"vm.rol.id<=3\" style=width:35% title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !detalle.suministro.ubicacion.numeroOrden, \'has-success\':detalle.suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(detalle) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(detalle)}}</div></div></td></tr></table></div></form><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesInventariablesAgrupados.length>0\"><label>Detalle de suministros inventariables</label></div><form ng-show=true><div class=col-lg-12 ng-show=\"vm.detallesInventariablesAgrupados.length>0\"><table ng-table=vm.tableParamsInventariableAgrupado class=\"table table-hover\" ng-init=\"agrupado.$hideRows = true\" show-group=false><tr class=ng-table-group ng-repeat-start=\"agrupado in $data\"><td colspan=6><a href=\"\" ng-click=\"agrupado.$hideRows = !agrupado.$hideRows\"><span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': agrupado.$hideRows, \'glyphicon-chevron-down\': !agrupado.$hideRows }\"></span> Tipo de suministro: {{ agrupado.tipoSuministro.nombre.toUpperCase() }}</a></td><td ng-if=\"vm.rol.id<=3\" title=\"Precio total\">Precio total por tipo de suministro: <b>${{agrupado.precioTotal}}</b></td><td title=\"Cantidad solicitada\">Cantidad solicitada total: <b>{{agrupado.cantidad}}</b></td><!-- 				        <td title=\"\'Acciones\'\" align=\"center\">\r\n							<div class=\"btn-group\">\r\n								<a class=\"btn btn-danger\" ng-click=\"vm.quitarTipo(agrupado)\">\r\n									<i class=\"fa fa-remove\"></i>\r\n								</a>\r\n							</div>\r\n</td> --></tr><tr ng-hide=agrupado.$hideRows ng-repeat=\"detalle in agrupado.detalles\" ng-repeat-end><td title=\"\'Marca\'\" align=center>{{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'N° serie\'\" sortable align=center>{{detalle.suministroInventariable.serie ? detalle.suministroInventariable.serie : \"-\" }}</td><td title=\"\'N° inventario\'\" sortable align=center>{{detalle.suministroInventariable.inventario ? detalle.suministroInventariable.inventario : \"-\" }}</td><td ng-if=\"vm.rol.id<=3\" title=\"\'Precio\'\" align=center>${{detalle.suministro.precioUnitario}}</td><td ng-if=\"vm.rol.id<=3\" style=width:35% title=\"\'Ubicación\'\" ng-if=vm.comprobarEstadoEgreso();><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !detalle.suministro.ubicacion.numeroOrden, \'has-success\':detalle.suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(detalle) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(detalle)}}</div></div></td></tr></table></div><form></form></form></div><div ng-if=vm.egreso.caja><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesInventariablesAgrupadosCajas.length>0\"><label>Detalle de cajas cerradas</label></div><form ng-show=true><div class=col-lg-12 ng-show=\"vm.detallesInventariablesAgrupadosCajas.length>0\"><table ng-table=vm.tableParamsInventariableAgrupadoCajas class=\"table table-hover\" ng-init=\"agrupado.$hideRows = true\" show-group=false><tr class=ng-table-group ng-repeat-start=\"agrupado in $data\"><td colspan=6><a href=\"\" ng-click=\"agrupado.$hideRows = !agrupado.$hideRows\"><span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': agrupado.$hideRows, \'glyphicon-chevron-down\': !agrupado.$hideRows }\"></span> Caja cerrada N°: {{agrupado.numeroCaja}}<br>Tipo de suministro: {{ agrupado.tipoSuministro.nombre.toUpperCase() }}<br>Familia de suministro: {{ agrupado.tipoSuministro.familiaSuministro.nombre.toUpperCase();}}</a></td><td ng-if=\"vm.rol.id<=3\" style=width:35% title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\"><label class=control-label>Ubicación</label><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompletaCaja(agrupado)>{{agrupado.ubicacion? vm.ubicacionNaveNumeroOrdenCaja(agrupado) : \"No asignó ninguna.\" }}</div><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i></div></td><td title=\"Cantidad total\">Cantidad total: {{agrupado.cantidad}}</td><td ng-if=\"vm.rol.id<=3\" title=\"Precio total\">Precio total: <b>${{agrupado.precioTotal}}</b></td></tr><tr ng-hide=agrupado.$hideRows ng-repeat=\"detalle in agrupado.detalles\" ng-repeat-end><td title=\"\'Marca\'\" align=center>{{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'N° serie\'\" align=center>{{detalle.suministroInventariable.serie ? detalle.suministroInventariable.serie : \"-\" }}</td><td title=\"\'N° inventario\'\" align=center>{{detalle.suministroInventariable.inventario ? detalle.suministroInventariable.inventario : \"-\" }}</td><td ng-if=\"vm.rol.id<=3\" title=\"\'Precio\'\" align=center>${{detalle.suministro.precioUnitario}}</td></tr></table></div></form></div></div><div ng-if=!vm.comprobarEstadoEgreso() class=col-lg-12><span uib-alert class=danger>El egreso no puede visualizarse </span><button ng-click=vm.volver(); class=\"btn btn-warning\" style=width:30%><i class=\"fa fa-arrow-left\"></i> Volver al listado</button></div>");
$templateCache.put("app/app/main/movimientos/ingreso/agregar-suministros/agregar-suministros-ingreso.html","<div class=col-lg-12 ng-if=!vm.ocultar><div class=col-lg-12 ng-show=\"vm.detalles.length==0\"><span uib-alert class=danger>Se ha recargado la página.</span></div><button ng-click=vm.volver() class=\"btn btn-warning\"><i class=\"fa fa-arrow-left\"></i> Volver a la pantalla de edición</button></div><div class=col-lg-12 ng-if=vm.ocultar><div class=form-group><center><button ng-click=vm.guardar() class=\"btn btn-success\" style=width:30%><i class=\"fa fa-check\"></i> Guardar</button> <button ng-click=vm.volver() class=\"btn btn-warning\" style=width:30%><i class=\"fa fa-arrow-left\"></i> Volver</button></center></div><div class=col-lg-12><div class=\"form-group col-lg-12\"><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.ingreso.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.ingreso.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Autorizó:</label><input type=text ng-model=vm.ingreso.solicitante class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Proveedor:</label><input type=text ng-readonly=true ng-model=vm.ingreso.proveedor.nombre class=\"form-control text-uppercase\" name=proveedor></div><div class=\"form-group col-lg-6\"><label>Persona Proveedor:</label><input type=text ng-readonly=true ng-model=vm.personaProveedor class=\"form-control text-uppercase\" name=personaProveedor></div><div class=\"form-group col-lg-6\"><label>Empresa logística:</label><input type=text ng-readonly=true ng-model=vm.ingreso.empresaLogistica.nombre class=\"form-control text-uppercase\" name=empresaLogistica></div><div class=\"form-group col-lg-6\"><label>Persona Empresa logística:</label><input type=text ng-readonly=true ng-model=vm.personaEmpresaLogistica class=\"form-control text-uppercase\" name=personaEmpresaLogistica></div><div class=\"form-group col-lg-3\"><label>Número de remito:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroRemito type=text name=numeroRemito></div><div class=\"form-group col-lg-3\"><label>Número de orden de compra:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroOrden type=text name=numeroOrden></div><div class=\"form-group col-lg-3\"><label>Fecha:</label><input class=form-control ng-readonly=true ng-model=vm.fecha type=text name=fecha></div><div class=\"form-group col-lg-3\"><label>¿Ingreso de cajas cerradas?</label><input class=form-control ng-readonly=true ng-model=vm.cajaCerrada type=text name=cajaCerrada></div><div class=\"form-group col-lg-3\"><label>Número Vale Ingreso:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroIngresoVale type=text name=numeroIngresoVale></div><div class=\"form-group col-lg-4\"><label>Número guía</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroGuia type=text name=numeroGuia></div><div class=\"form-group col-lg-5\"><label>Sucursal de origen</label><input class=\"form-control text-uppercase\" ng-readonly=true ng-model=vm.ingreso.sucursal.nombre type=text name=sucursal></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=form-control ng-readonly=true ng-model=vm.ingreso.observacion type=text name=observacion style=resize:vertical></textarea></div><br><br><div class=\"form-group col-lg-12\"><center><button ng-click=vm.abrirModal() class=\"btn btn-primary\" style=width:30%><i class=\"fa fa-plus\"></i> Agregar suministros..</button> <button ng-click=vm.abrirModalAgregarSuministrosExcel() class=\"btn btn-success\" style=width:30%><i class=\"fa fa-file-excel-o\"></i> Agregar suministros desde un Excel</button></center></div><div class=col-lg-12 ng-show=\"vm.detalles.length==0\"><span uib-alert class=danger>No ha agregado ningún suministro.</span></div><div class=\"col-lg-12 form-group\" ng-show=\"vm.detalles.length>0\"><label>Total: ${{ vm.montoTotal() }}</label></div><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesNoInventariables.length>0\"><label>Detalle de suministros no inventariables</label></div><form ng-show=true><div class=col-lg-12 ng-show=\"vm.detallesNoInventariables.length>0\"><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.detallesNoInventariables.length>0\"><tr ng-repeat=\"detalles in $data track by $index\" ng-if=\"detalles.suministro.tipoSuministro.inventariable!==true\"><div><td title=\"\'Fecha\'\" sortable align=center>{{detalles.fecha | date : \"dd/MM/yyyy\"}}</td><td title=\"\'Tipo Suministro\'\" sortable align=center>{{detalles.suministro.tipoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Marca\'\" sortable align=center>{{detalles.suministro.marca ? detalles.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'Fecha vencimiento\'\" sortable align=center>{{detalles.suministro.fechaVencimiento ? detalles.suministro.fechaVencimiento : \"-\" | date : \"dd/MM/yyyy\" }}</td><td title=\"\'Cantidad\'\" align=center>{{detalles.cantidad}}</td><td title=\"\'Precio por unidad\'\" align=center>${{detalles.suministro.precioUnitario}}</td><td title=\"\'Total\'\" align=center>${{(detalles.suministro.precioUnitario*detalles.cantidad).toFixed(2)}}</td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-danger\" ng-click=vm.eliminar(detalles)><i class=\"fa fa-trash\"></i></a></div></td></div></tr></table></div></form><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesInventariables.length>0\"><label>Detalle de suministros inventariables</label></div><form ng-show=true><div class=col-lg-12 ng-show=\"vm.detallesInventariables.length>0\"><table ng-table=vm.tableParamsStock class=table show-filter=true ng-show=\"vm.detallesInventariables.length>0\"><tr ng-repeat=\"detalle in $data track by $index\" ng-if=\"detalle.suministro.tipoSuministro.inventariable==true\"><div><!-- 				        <td title=\"\'Cantidad\'\" sortable=\"\'cantidad\'\" align=\"center\">\r\n	    {{detalle.cantidad}}\r\n	</td> --><td title=\"\'Tipo Suministro\'\" sortable align=center>{{detalle.suministro.tipoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Marca\'\" sortable align=center>{{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'N° serie\'\" sortable align=center>{{detalle.suministroInventariable.serie ? detalle.suministroInventariable.serie : \"-\" }}</td><td title=\"\'N° inventario\'\" sortable align=center>{{detalle.suministroInventariable.inventario ? detalle.suministroInventariable.inventario : \"-\" }}</td><td title=\"\'Precio\'\" align=center>${{detalle.suministro.precioUnitario}}</td><td title=\"\'Sucursal de origen\'\" align=center>{{detalle.suministroInventariable.sucursal? detalle.suministroInventariable.sucursal.nombre.toUpperCase() : \"-\"}}</td><td ng-if=!vm.ingreso.caja title=\"\'Pallet\'\" align=center groupable=numeroRow>{{detalle.numeroRow}}</td><td ng-if=vm.ingreso.caja title=\"\'Número caja\'\" align=center groupable=numeroCaja>{{detalle.numeroCaja}}</td><td title=\"\'Acciones\'\" align=center groupable=\"\'numeroRow\'\"><div class=btn-group><a class=\"btn btn-danger\" ng-click=vm.eliminar(detalle)><i class=\"fa fa-trash\"></i></a></div></td></div></tr></table></div></form></div></div>");
$templateCache.put("app/app/main/movimientos/ingreso/asignar-ubicaciones/asignar-ubicaciones.html","<div class=form-group ng-if=vm.comprobarIngresoCerrado();><center><button ng-click=vm.comprobarUbicaciones(); class=\"btn btn-success\" style=width:30%><i class=\"fa fa-check\"></i> Guardar</button> <button ng-click=vm.volver() class=\"btn btn-warning\" style=width:30%><i class=\"fa fa-arrow-left\"></i> Volver al listado</button></center></div><div class=col-lg-12 ng-if=vm.comprobarIngresoCerrado()><div class=\"panel panel-default\"><div class=panel-body><div class=\"form-group col-lg-12\"><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.ingreso.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.ingreso.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-3\"><label>Número de movimiento:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroMovimiento type=text name=numeroMovimiento></div><div class=\"form-group col-lg-3\"><label>Fecha:</label><input class=form-control ng-readonly=true ng-model=vm.fecha type=text name=fecha></div><div class=\"form-group col-lg-6\"><label>Proveedor:</label><input type=text ng-readonly=true ng-model=vm.ingreso.proveedor.nombre class=\"form-control text-uppercase\" name=proveedor></div><div class=\"form-group col-lg-6\"><label>Persona Proveedor:</label><input type=text ng-readonly=true ng-model=vm.personaProveedor class=\"form-control text-uppercase\" name=personaProveedor></div><div class=\"form-group col-lg-6\"><label>Empresa logística:</label><input type=text ng-readonly=true ng-model=vm.ingreso.empresaLogistica.nombre class=\"form-control text-uppercase\" name=empresaLogistica></div><div class=\"form-group col-lg-6\"><label>Persona Empresa logística:</label><input type=text ng-readonly=true ng-model=vm.personaEmpresaLogistica class=\"form-control text-uppercase\" name=personaEmpresaLogistica></div><div class=\"form-group col-lg-3\"><label>Autorizó:</label><input type=text ng-model=vm.ingreso.solicitante class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-3\"><label>Número de orden de compra:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroOrden type=text name=numeroOrden></div><div class=\"form-group col-lg-3\"><label>Número de remito:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroRemito type=text name=numeroRemito></div><div class=\"form-group col-lg-3\"><label>Monto total:</label><input class=form-control ng-readonly=true ng-model=vm.montoTotal type=text name=montoTotal></div><div class=\"form-group col-lg-3\"><label>Número Vale Ingreso:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroIngresoVale type=text name=numeroIngresoVale></div><div class=\"form-group col-lg-4\"><label>Número guía</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroGuia type=text name=numeroGuia></div><div class=\"form-group col-lg-5\"><label>Sucursal de origen</label><input class=\"form-control text-uppercase\" ng-readonly=true ng-model=vm.ingreso.sucursal.nombre type=text name=sucursal></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=form-control ng-readonly=true ng-model=vm.ingreso.observacion type=text name=observacion style=resize:vertical></textarea></div></div></div><br><br><div class=form-group ng-if=vm.comprobarIngresoCerrado();><center><button ng-click=vm.asignarAutomaticamente() class=\"btn btn-primary\" style=width:30%><i class=\"fa fa-map-marker\"></i> Asignar ubicaciones automáticamente</button> <button ng-click=vm.limpiarUbicaciones() class=\"btn btn-warning\" style=width:30%><i class=\"fa fa-times\"></i> Remover ubicaciones asignadas</button></center></div><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesNoInventariables.length>0\" ng-if=vm.comprobarIngresoCerrado();><label>Detalle de suministros no inventariables</label></div><form ng-show=true ng-if=vm.comprobarIngresoCerrado();><div class=col-lg-12 ng-show=\"vm.detallesNoInventariables.length>0\"><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.detallesNoInventariables.length>0\"><tr ng-repeat=\"detalles in $data track by $index\" ng-if=\"detalles.suministro.tipoSuministro.inventariable!==true\"><div><td title=\"\'Tipo Suministro\'\" data-sortable=\"\'suministro.tipoSuministro.nombre\'\" align=center>{{detalles.suministro.tipoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Marca\'\" data-sortable=\"\'suministro.marca\'\" align=center>{{detalles.suministro.marca ? detalles.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'Fecha vencimiento\'\" data-sortable=\"\'suministro.fechaVencimiento\'\" align=center>{{detalles.suministro.fechaVencimiento ? detalles.suministro.fechaVencimiento : \"-\" | date : \"dd/MM/yyyy\" }}</td><td title=\"\'Cantidad\'\" align=center>{{detalles.cantidad}}</td><td title=\"\'Precio por unidad\'\" align=center>${{detalles.suministro.precioUnitario}}</td><td title=\"\'Total\'\" align=center>${{(detalles.suministro.precioUnitario*detalles.cantidad).toFixed(2)}}</td><td style=width:35% title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !detalles.ubicacion.numeroOrden, \'has-success\':detalles.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(detalles) class=form-control style=\"word-wrap: white\">{{detalles.ubicacion? vm.ubicacionNaveNumeroOrden(detalles) : \"No asignó ninguna.\" }}</div></div></td><td title=\"\'¿Ocupar ubicación?\'\" align=center><input type=checkbox ng-model=detalles.ocupar ng-change=vm.corroborarOcuparUbicacionRepetida(detalles);></td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-primary\" ng-click=vm.asignarIndividual(detalles)><i class=\"fa fa-map-marker\"></i> </a><a class=\"btn btn-danger\" ng-disabled=\"!(detalles.ubicacion && detalles.ubicacion.id)\" ng-click=vm.removerIndividual(detalles)><i class=\"fa fa-remove\"></i></a></div></td></div></tr></table></div></form><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesInventariables.length>0\" ng-if=vm.comprobarIngresoCerrado();><label>Detalle de suministros inventariables</label></div><form ng-show=true ng-if=vm.comprobarIngresoCerrado();><div class=col-lg-12 ng-show=\"vm.detallesInventariables.length>0\"><table ng-table=vm.tableParamsStock class=\"table table-hover\" ng-init=\"pallet.$hideRows = true\" show-group=false><tr class=ng-table-group ng-repeat-start=\"pallet in $data\"><td colspan=4><a href=\"\" ng-click=\"pallet.$hideRows = !pallet.$hideRows\"><span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': pallet.$hideRows, \'glyphicon-chevron-down\': !pallet.$hideRows }\"></span> Pallet N° {{pallet.numeroRow}} - {{ pallet.tipoSuministro.nombre.toUpperCase() }}</a></td><td style=width:35% title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !pallet.ubicacion.numeroOrden, \'has-success\': pallet.ubicacion.numeroOrden, \'has-warning\': pallet.ubicacion.numeroOrden && pallet.ubicacion.categoriaPeso.id!=pallet.tipoSuministro.categoriaPeso.id}\"><label class=control-label>Ubicación</label><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(pallet)>{{pallet.ubicacion? vm.ubicacionNaveNumeroOrden(pallet) : \"No asignó ninguna.\" }}</div><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i></div></td><td title=\"\'¿Ocupar ubicación?\'\" align=center><div>¿Ocupar<br>ubicación?</div><input type=checkbox ng-model=pallet.ocupar ng-change=vm.corroborarOcuparUbicacionRepetida(pallet);></td><td title=\"\'Asignar\'\" align=center><div class=btn-group><a class=\"btn btn-primary\" ng-click=vm.asignarIndividual(pallet)><i class=\"fa fa-map-marker\"></i> </a><a class=\"btn btn-danger\" ng-disabled=\"!(pallet.ubicacion && pallet.ubicacion.id)\" ng-click=vm.removerIndividual(pallet)><i class=\"fa fa-remove\"></i></a></div></td></tr><tr ng-hide=pallet.$hideRows ng-repeat=\"detalle in pallet.detalles\" ng-repeat-end><td title=\"\'Marca\'\" align=center>{{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'N° serie\'\" align=center>{{detalle.suministroInventariable.serie ? detalle.suministroInventariable.serie : \"-\" }}</td><td title=\"\'N° inventario\'\" align=center>{{detalle.suministroInventariable.inventario ? detalle.suministroInventariable.inventario : \"-\" }}</td><td title=\"\'Precio\'\" align=center>${{detalle.suministro.precioUnitario}}</td></tr></table></div></form></div><div ng-if=!vm.comprobarIngresoCerrado() class=col-lg-12><span uib-alert class=danger>No puede asignarle ubicaciones a un ingreso ya cerrado.</span></div>");
$templateCache.put("app/app/main/movimientos/ingreso/editar/editar-ingreso.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=\"form-group col-lg-6\"><label>Depósito:</label><input type=text ng-model=vm.ingreso.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false required name=deposito focus-on=deposito> <span uib-alert class=danger ng-show=\"vm.form.deposito.$error.required && vm.form.deposito.$dirty\">Este campo es requerido.</span></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.ingreso.empresa placeholder=\"Seleccione o busque la Empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 required name=empresa typeahead-editable=false> <span uib-alert class=danger ng-show=\"vm.form.empresa.$error.required && vm.form.empresa.$dirty\">Este campo es requerido.</span></div><div class=\"form-group col-lg-6\"><label>Proveedor:</label><input type=text ng-disabled=!vm.ingreso.empresa.nombre focus-on=proveedor ng-model=vm.ingreso.proveedor placeholder=\"Seleccione o busque el proveedor\" uib-typeahead=\"proveedor as proveedor.nombre.toUpperCase() for proveedor in vm.proveedores | filter:{nombre:$viewValue}\" class=form-control typeahead-editable=false typeahead-show-hint=true typeahead-min-length=0 required name=proveedor> <span uib-alert class=danger ng-if=\"vm.form.proveedor.$error.required && vm.form.proveedor.$dirty\">Este campo es requerido.</span></div><div class=\"form-group col-lg-6\"><label>Personal proveedor:</label><input type=text ng-disabled=\"!vm.ingreso.proveedor.id || vm.personas.length==0\" focus-on=personaProveedor ng-model=vm.ingreso.personaProveedor placeholder=\"Seleccione o busque personal de proveedor\" uib-typeahead=\"persona as persona.apellido.toUpperCase()+\', \'+persona.nombre.toUpperCase() for persona in vm.personas | filter:{apellido:$viewValue}\" class=form-control typeahead-editable=false typeahead-show-hint=true typeahead-min-length=0 name=persona></div><div class=\"form-group col-lg-6\"><label>Empresa logística:</label><input type=text ng-disabled=!vm.ingreso.empresa.nombre ng-model=vm.ingreso.empresaLogistica placeholder=\"Seleccione o busque la empresa de logística\" uib-typeahead=\"empresaLogistica as empresaLogistica.nombre.toUpperCase() for empresaLogistica in vm.empresasLogistica | filter:{nombre:$viewValue}\" class=form-control typeahead-editable=false typeahead-show-hint=true typeahead-min-length=0 focus-on=empresaLogistica></div><div class=\"col-lg-6 form-group\"><label>Personal empresa logística:</label><input type=text ng-disabled=\"!vm.ingreso.empresaLogistica.id || vm.personasLogistica.length==0\" ng-model=vm.ingreso.personaEmpresaLogistica placeholder=\"Seleccione o busque la persona de la empresa de logístca\" uib-typeahead=\"persona as persona.apellido.toUpperCase()+\', \'+persona.nombre.toUpperCase() for persona in vm.personasLogistica | filter:{apellido:$viewValue}\" class=form-control focus-on=personaEmpresaLogistica typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-3\"><label>Autoriza:</label><input class=form-control ng-maxlength=100 focus-on=solicitante ng-model=vm.ingreso.solicitante placeholder=\"Ingrese la persona que autoriza el ingreso\" type=text name=solicitante> <span uib-alert class=danger ng-if=\"vm.form.solicitante.$error.maxlength && vm.form.solicitante.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><div class=\"form-group col-lg-3\"><label>Número de orden de compra:</label><input class=form-control ng-maxlength=100 focus-on=numeroOrden ng-model=vm.ingreso.numeroOrden placeholder=\"Ingrese el número de orden de compra\" type=text name=numeroOrden> <span uib-alert class=danger ng-if=\"vm.form.numeroOrden.$error.maxlength && vm.form.numeroOrden.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><div class=\"form-group col-lg-3\"><label>Número de remito:</label><input class=form-control ng-maxlength=100 focus-on=numeroRemito ng-model=vm.ingreso.numeroRemito placeholder=\"Ingrese el número de remito\" type=text name=numeroRemito> <span uib-alert class=danger ng-if=\"vm.form.numeroRemito.$error.maxlength && vm.form.numeroRemito.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><div class=\"form-group col-lg-3\"><label>¿Es un ingreso de Cajas Cerradas?</label><br><toggle ng-model=vm.ingreso.caja on=SI off=NO onstyle=btn-success offstyle=btn-danger></toggle></div><div class=\"form-group col-lg-3\"><label>Número Vale de ingreso:</label><input class=form-control ng-maxlength=50 focus-on=numeroIngresoVale ng-model=vm.ingreso.numeroIngresoVale placeholder=\"Ingrese el número de Vale de ingreso \" type=text name=numeroIngresoVale> <span uib-alert class=danger ng-if=\"vm.form.numeroIngresoVale.$error.maxlength && vm.form.numeroIngresoVale.$dirty\">Este campo no puede superar los 50 caracteres.</span></div><div class=\"form-group col-lg-4\"><label>Número de guía:</label><input class=form-control ng-maxlength=100 focus-on=numeroGuia ng-model=vm.ingreso.numeroGuia placeholder=\"Ingrese el número de guía\" type=text name=numeroGuia> <span uib-alert class=danger ng-if=\"vm.form.numeroGuia.$error.maxlength && vm.form.numeroGuia.$dirty\">Este campo no puede superar los 100 caracteres. </span><span uib-alert class=danger ng-if=\"!vm.ingreso.empresaLogistica && vm.ingreso.numeroGuia\">Debe indicar una empresa de logística para ingresar un número de guía.</span></div><div class=\"form-group col-lg-5\"><label>Sucursal de origen:</label><input type=text ng-disabled=!vm.ingreso.empresa.nombre ng-model=vm.ingreso.sucursal placeholder=\"Seleccione o busque la sucursal\" uib-typeahead=\"sucursal as sucursal.nombre.toUpperCase() for sucursal in vm.sucursales | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=sucursal typeahead-editable=false focus-on=sucursal></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=form-control ng-maxlength=500 ng-model=vm.ingreso.observacion placeholder=\"Ingrese una observación\" type=text name=observacion style=resize:vertical></textarea><span uib-alert class=danger ng-if=\"vm.form.observacion.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 500 caracteres.</span></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.siguiente() ng-disabled=\"vm.form.$invalid || !vm.ingreso.empresa.nombre || !vm.ingreso.proveedor.nombre || (vm.ingreso.numeroGuia && !vm.ingreso.empresaLogistica)\"><span class=\"glyphicon glyphicon-ok\"></span> Siguiente</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/movimientos/ingreso/asignar-ubicaciones-cajas/asignar-ubicaciones-cajas.html","<div class=form-group ng-if=vm.comprobarIngresoCerrado();><center><button ng-click=vm.comprobarUbicaciones(); class=\"btn btn-success\" style=width:30%><i class=\"fa fa-check\"></i> Guardar</button> <button ng-click=vm.volver() class=\"btn btn-warning\" style=width:30%><i class=\"fa fa-arrow-left\"></i> Volver al listado</button></center></div><div class=col-lg-12 ng-if=vm.comprobarIngresoCerrado()><div class=\"panel panel-default\"><div class=panel-body><div class=\"form-group col-lg-12\"><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.ingreso.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.ingreso.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-3\"><label>Número de movimiento:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroMovimiento type=text name=numeroMovimiento></div><div class=\"form-group col-lg-3\"><label>Fecha:</label><input class=form-control ng-readonly=true ng-model=vm.fecha type=text name=fecha></div><div class=\"form-group col-lg-6\"><label>Proveedor:</label><input type=text ng-readonly=true ng-model=vm.ingreso.proveedor.nombre class=\"form-control text-uppercase\" name=proveedor></div><div class=\"form-group col-lg-6\"><label>Persona Proveedor:</label><input type=text ng-readonly=true ng-model=vm.personaProveedor class=\"form-control text-uppercase\" name=personaProveedor></div><div class=\"form-group col-lg-6\"><label>Empresa logística:</label><input type=text ng-readonly=true ng-model=vm.ingreso.empresaLogistica.nombre class=\"form-control text-uppercase\" name=empresaLogistica></div><div class=\"form-group col-lg-6\"><label>Persona Empresa logística:</label><input type=text ng-readonly=true ng-model=vm.personaEmpresaLogistica class=\"form-control text-uppercase\" name=personaEmpresaLogistica></div><div class=\"form-group col-lg-3\"><label>Autorizó:</label><input type=text ng-model=vm.ingreso.solicitante class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-3\"><label>Número de orden de compra:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroOrden type=text name=numeroOrden></div><div class=\"form-group col-lg-3\"><label>Número de remito:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroRemito type=text name=numeroRemito></div><div class=\"form-group col-lg-3\"><label>Monto total:</label><input class=form-control ng-readonly=true ng-model=vm.montoTotal type=text name=montoTotal></div><div class=\"form-group col-lg-3\"><label>Número Vale Ingreso:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroIngresoVale type=text name=numeroIngresoVale></div><div class=\"form-group col-lg-4\"><label>Número guía</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroGuia type=text name=numeroGuia></div><div class=\"form-group col-lg-5\"><label>Sucursal de origen</label><input class=\"form-control text-uppercase\" ng-readonly=true ng-model=vm.ingreso.sucursal.nombre type=text name=sucursal></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=form-control ng-readonly=true ng-model=vm.ingreso.observacion type=text name=observacion style=resize:vertical></textarea></div></div></div><br><br><div class=form-group ng-if=vm.comprobarIngresoCerrado();><center><button ng-click=vm.asignarAutomaticamente() class=\"btn btn-primary\" style=width:30%><i class=\"fa fa-map-marker\"></i> Asignar ubicación automáticamente</button> <button ng-click=vm.limpiarUbicaciones() class=\"btn btn-warning\" style=width:30%><i class=\"fa fa-times\"></i> Remover ubicación asignadas</button></center></div><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesInventariables.length>0\" ng-if=vm.comprobarIngresoCerrado();><label>Detalle de cajas cerradas</label></div><form ng-show=true ng-if=vm.comprobarIngresoCerrado();><div class=col-lg-12 ng-show=\"vm.detallesInventariables.length>0\"><table ng-table=vm.tableParamsStock class=\"table table-hover\" ng-init=\"pallet.$hideRows = true\" show-group=false><tr class=ng-table-group ng-repeat-start=\"pallet in $data\"><td colspan=4><a href=\"\" ng-click=\"pallet.$hideRows = !pallet.$hideRows\"><span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': pallet.$hideRows, \'glyphicon-chevron-down\': !pallet.$hideRows }\"></span> Caja cerrada N° {{pallet.numeroCaja}} - {{ pallet.tipoSuministro.nombre.toUpperCase() }}</a></td><td style=width:35% title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !pallet.ubicacion.numeroOrden, \'has-success\': pallet.ubicacion.numeroOrden, \'has-warning\': pallet.ubicacion.numeroOrden && pallet.ubicacion.categoriaPeso.id!=pallet.tipoSuministro.categoriaPeso.id}\"><label class=control-label>Ubicación</label><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(pallet)>{{pallet.ubicacion? vm.ubicacionNaveNumeroOrden(pallet) : \"No asignó ninguna.\" }}</div><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i></div></td><!--             	  	<td title=\"\'¿Ocupar ubicación?\'\" align=\"center\">\r\n	<input type=\"checkbox\" ng-model=\"pallet.ocupar\">            	  		\r\n</td> --><td title=\"\'Asignar\'\" align=center><div class=btn-group><a class=\"btn btn-primary\" ng-click=vm.asignarIndividual(pallet)><i class=\"fa fa-map-marker\"></i> </a><a class=\"btn btn-danger\" ng-disabled=\"!(pallet.ubicacion && pallet.ubicacion.id)\" ng-click=vm.removerIndividual(pallet)><i class=\"fa fa-remove\"></i></a></div></td></tr><tr ng-hide=pallet.$hideRows ng-repeat=\"detalle in pallet.detalles\" ng-repeat-end><td title=\"\'Marca\'\" align=center>{{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'N° serie\'\" align=center>{{detalle.suministroInventariable.serie ? detalle.suministroInventariable.serie : \"-\" }}</td><td title=\"\'N° inventario\'\" align=center>{{detalle.suministroInventariable.inventario ? detalle.suministroInventariable.inventario : \"-\" }}</td><td title=\"\'Precio\'\" align=center>${{detalle.suministro.precioUnitario}}</td></tr></table></div></form></div><div ng-if=!vm.comprobarIngresoCerrado() class=col-lg-12><span uib-alert class=danger>No puede asignarle ubicaciones a un ingreso ya cerrado.</span></div>");
$templateCache.put("app/app/main/movimientos/ingreso/lista/lista-ingreso.html","<!--     <formly-form model=\"vm.user\" fields=\"vm.userFields\">\r\n  <button type=\"submit\" class=\"btn btn-primary col-sm-offset-4 col-sm-4\" ng-click=\"vm.submit(vm.user)\">Submit</button>\r\n</formly-form> --><div><form><div class=\"form-group col-lg-12\"><div class=form-group ng-if=\"vm.rol.id<=3\"><center><button ng-click=vm.crearNuevo() class=\"btn btn-success\" style=width:50%><i class=\"fa fa-plus\"></i> NUEVO INGRESO</button></center></div><div class=col ng-if=\"vm.rol.id<=3\"><div class=col><div class=form-check><label class=form-check-label for=filtrosCheckbox>Filtrar ingresos &nbsp;&nbsp;</label><input type=checkbox id=filtrosCheckbox class=form-check-input ng-model=vm.buscar ng-click=vm.busqueda()></div><div class=form-group><div class=form-group style=\"display:flex; justify-content: space-between\"><div style=\"width:99%; margin: 0px 2px 0px 2px\"><center><button class=\"btn btn-primary btn-block\" ng-disabled=!vm.buscar ng-click=vm.abrirModalFiltros()><span class=\"fa fa-filter\"></span> Filtros combinados</button></center></div><div style=\"width:99%; margin: 0px 2px 0px 2px\"><center><button class=\"btn btn-primary btn-block\" ng-disabled=!vm.buscar ng-click=vm.abrirModalFiltrosSuministro()><span class=\"fa fa-filter\"></span> Filtro tipo suministro</button></center></div><div style=\"width:99%; margin: 0px 2px 0px 2px\"><center><button class=\"btn btn-primary btn-block\" ng-disabled=!vm.buscar ng-click=vm.abrirModalNumeroMovimiento()><span class=\"fa fa-filter\"></span> Filtro N° movimiento</button></center></div><div style=\"width:99%; margin: 0px 2px 0px 2px\"><center><button class=\"btn btn-primary btn-block\" ng-disabled=!vm.buscar ng-click=vm.abrirModalNumeroRemito()><span class=\"fa fa-filter\"></span> Filtro N° Remito</button></center></div><div style=\"width:99%; margin: 0px 2px 0px 2px\"><center><button class=\"btn btn-primary btn-block\" ng-disabled=!vm.buscar ng-click=vm.abrirModalNumeroOrdenCompra()><span class=\"fa fa-filter\"></span> Filtro N° Orden compra</button></center></div><div style=\"width:99%; margin: 0px 2px 0px 2px\"><center><button class=\"btn btn-primary btn-block\" ng-disabled=!vm.buscar ng-click=vm.abrirModalFechaIngresoManual()><span class=\"fa fa-filter\"></span> Filtro fecha ingreso manual</button></center></div></div></div></div></div><br><div class=col-lg-12><div uib-alert type=info ng-show=vm.filtrosUsados>FILTROS APLICADOS:<div ng-repeat=\"filtro in vm.filtrosUsados\">{{vm.filtrosUsados[$index]}}</div></div></div><div ng-show=\"!vm.ingresos.length>0 && vm.bandera\" uib-alert class=\"danger col-lg-12 form-group\">No hay ingresos para los filtros indicados</div></div><div class=col-lg-12><table ng-table=vm.tableParams class=\"table table-condensed\" show-filter=true ng-show=\"vm.ingresos.length>0\"><tr ng-repeat=\"ingresos in $data\" ng-class=\"{\'verde-claro\': ingresos.estadoMovimiento.id==6, \'rojo-claro\':ingresos.estadoMovimiento.id==5}\"><div><td data-title=\"\'Fecha\'\" align=center data-sortable=\"\'fecha\'\" style=width:10%>{{ingresos.fecha | date : \"dd/MM/yyyy HH:mm\" }}</td><td data-title=\"\'Depósito\'\" data-sortable=\"\'deposito.nombre\'\" filter=\"{\'deposito.nombre\': \'text\'}\" align=center>{{ingresos.deposito.nombre.toUpperCase();}}</td><td data-title=\"\'Empresa\'\" data-sortable=\"\'empresa.nombre\'\" filter=\"{\'empresa.nombre\': \'text\'}\" align=center>{{ingresos.empresa.nombre.toUpperCase();}}</td><td data-title=\"\'Proveedor\'\" filter=\"{\'proveedor.nombre\': \'text\'}\" data-sortable=\"\'proveedor.nombre\'\" align=center>{{ingresos.proveedor.nombre.toUpperCase();}}</td><td data-title=\"\'N° Movimiento\'\" style=width:5% align=center filter=\"{\'numeroMovimiento\':\'text\'}\" data-sortable=\"\'numeroMovimiento\'\">{{ingresos.numeroMovimiento}}</td><td data-title=\"\'N° Remito\'\" style=width:7% align=center filter=\"{\'numeroRemito\':\'text\'}\" data-sortable=\"\'numeroRemito\'\">{{ingresos.numeroRemito}}</td><td data-title=\"\'N° Ingreso Vale\'\" style=width:7% align=center filter=\"{\'numeroIngresoVale\':\'text\'}\" data-sortable=\"\'numeroIngresoVale\'\">{{ingresos.numeroIngresoVale}}</td><td data-title=\"\'N° Guía\'\" filter=\"{\'numeroGuia\': \'text\'}\" data-sortable=\"\'numeroGuia\'\" align=center>{{ingresos.numeroGuia}}</td><td data-title=\"\'Fecha ingreso manual\'\" align=center data-sortable=\"\'fechaIngreso\'\" style=width:10%>{{ingresos.fechaIngreso | date : \"dd/MM/yyyy\" }}</td><td data-title=\"\'Estado\'\" style=width:5% data-sortable=\"\'estadoMovimiento.nombre\'\" filter=\"{\'estadoMovimiento.nombre\': \'text\'}\" align=center>{{ingresos.estadoMovimiento.nombre.toUpperCase();}}</td><td data-title=\"\'Acciones\'\" align=center style=width:12%><div class=btn-group><a class=\"btn btn-info\" ng-disabled=\"ingresos.estadoMovimiento.id==5\" ng-click=\"ingresos.estadoMovimiento.id==5 || vm.visualizarIngreso(ingresos)\"><i class=\"fa fa-search\"></i> </a><a ng-if=\"vm.rol.id<=3\" ng-disabled=\"ingresos.estadoMovimiento.id==6\" class=\"btn btn-primary\" ng-click=\"ingresos.estadoMovimiento.id==6 || vm.irAsignarUbicaciones(ingresos)\"><i class=\"fa fa-map-marker\"></i> </a><a ng-if=\"vm.rol.id<=3\" ng-disabled=\"ingresos.estadoMovimiento.id==6\" class=\"btn btn-danger\" ng-click=\"ingresos.estadoMovimiento.id==6 || vm.eliminar(ingresos)\"><i class=\"fa fa-trash\"></i></a></div></td></div></tr></table></div></form></div>");
$templateCache.put("app/app/main/movimientos/ingreso/problemas/editar-problemas.html","<div class=col-lg-12 ng-if=vm.comprobarIngresoCerrado()><div class=\"panel panel-default\"><div class=panel-body><div class=\"form-group col-lg-6\"><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.ingreso.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.ingreso.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Proveedor:</label><input type=text ng-readonly=true ng-model=vm.ingreso.proveedor.nombre class=\"form-control text-uppercase\" name=proveedor></div><div class=\"form-group col-lg-6\"><label>Persona Proveedor:</label><input type=text ng-readonly=true ng-model=vm.personaProveedor class=\"form-control text-uppercase\" name=proveedor></div><div class=\"form-group col-lg-3\"><label>Número de movimiento:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroMovimiento type=text name=numeroMovimiento></div><div class=\"form-group col-lg-3\"><label>Número de orden de compra:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroOrden type=text name=numeroOrden></div><div class=\"form-group col-lg-3\"><label>Fecha:</label><input class=form-control ng-readonly=true ng-model=vm.fecha type=text name=fecha></div><div class=\"form-group col-lg-3\"><label>Monto total:</label><input class=form-control ng-readonly=true ng-model=vm.montoTotal type=text name=montoTotal></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=form-control ng-readonly=true ng-model=vm.ingreso.observacion type=text name=observacion style=resize:vertical></textarea></div></div></div><br><div class=col-lg-12><label>Agregar problemas:</label><div class=col-lg-12><div class=col-lg-10><input type=text ng-model=vm.tipoProblema placeholder=\"Seleccione el problema\" uib-typeahead=\"tipoProblema as tipoProblema.nombre.toUpperCase() for tipoProblema in vm.tiposProblema\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=col-lg-2><button class=\"btn btn-success\" ng-disabled=!vm.tipoProblema.id ng-click=vm.agregarProblema()><span class=\"fa fa-check\"></span> Agregar</button></div></div></div><br><br><br><br><div class=col-lg-12 ng-show=\"vm.comprobarIngresoCerrado() && vm.ingreso.problemas.length==0\"><span class=danger uib-alert>El ingreso no tiene problemas asignados.</span></div><br><div class=\"col-lg-12 form-group\" ng-if=\"vm.comprobarIngresoCerrado() && vm.ingreso.problemas.length>0\"><label>Problemas asignados</label></div><form name=vm.form ng-show=true ng-if=vm.comprobarIngresoCerrado();><div class=col-lg-12 ng-show=\"vm.ingreso.problemas.length>0\"><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.ingreso.problemas.length>0\"><tr ng-repeat=\"problema in $data track by $index\"><div><td title=\"\'Problema\'\" align=center>{{problema.tipoProblema.nombre.toUpperCase();}}</td><td title=\"\'¿Foto?\'\" align=center>{{problema.encabezadoFoto? \"SI\" : \"NO\"}}</td><td data-title=\"\'Acciones\'\" align=center><div class=btn-group><!-- 								<a class=\"btn btn-info\" ng-click=\"vm.verProblema(problema)\">\r\n	<i class=\"fa fa-search\"></i>\r\n</a> --> <a class=\"btn btn-primary\" ng-click=vm.verProblema(problema)><i class=\"fa fa-camera\"></i> </a><a class=\"btn btn-danger\" ng-click=vm.eliminarProblema($index)><i class=\"fa fa-remove\"></i></a></div></td></div></tr></table></div><div class=\"form-group col-lg-12\"><label>Descripción del problema:</label><textarea class=form-control ng-maxlength=1000 ng-model=vm.ingreso.observacionProblema placeholder=\"Ingrese una descripción de los problemas observados\" type=text name=observacion style=resize:vertical></textarea><span uib-alert class=danger ng-if=\"vm.form.observacion.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.observacion.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 1000 caracteres.</span></div><!-- 		<div class=\"col-lg-12 row \" ng-if=\"vm.ingreso.encabezadoFoto\">\r\n	<center>\r\n		<div ng-if=\"vm.foto\" class=\"marco-imagenes\">\r\n			<img ng-src=\"{{vm.foto}}\" />\r\n		</div>  \r\n	</center>  \r\n            <button class=\"btn btn-danger\" ng-click=\"vm.quitarFoto();\">\r\n              <i class=\"fa fa-close\"></i>\r\n            </button>         \r\n</div>\r\n<button type=\"button\" class=\"btn btn-primary btn-block\" ng-click=\"vm.abrirSeleccionFoto()\">\r\n	<span class=\"glyphicon glyphicon-camera\"></span> \r\n	Seleccionar foto\r\n</button> --></form><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.editarProblemas()><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.volver()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div><div ng-if=!vm.comprobarIngresoCerrado() class=col-lg-12><span uib-alert class=danger>El ingreso todavía no tiene ubicaciones asignadas.</span></div>");
$templateCache.put("app/app/main/movimientos/ingreso/lista-cajas/lista-ingreso-cajas.html","<!--     <formly-form model=\"vm.user\" fields=\"vm.userFields\">\r\n  <button type=\"submit\" class=\"btn btn-primary col-sm-offset-4 col-sm-4\" ng-click=\"vm.submit(vm.user)\">Submit</button>\r\n</formly-form> --><div><form><div class=\"form-group col-lg-12\"><div class=form-group ng-if=\"vm.rol.id<=3\"><center><button ng-click=vm.crearNuevo() class=\"btn btn-success\" style=width:50%><i class=\"fa fa-plus\"></i> NUEVO INGRESO DE CAJAS</button></center></div><div class=col-lg-12 ng-if=\"vm.rol.id<=3\"><div class=col-lg-5><label>Filtrar ingresos:</label><div class=col-lg-12><div class=\"form-group col-lg-1\"><input type=checkbox ng-model=vm.buscar ng-click=vm.busqueda()></div><div class=col-lg-11><center><button class=\"btn btn-primary\" ng-disabled=!vm.buscar ng-click=vm.abrirModalFiltros()><span class=\"fa fa-filter\"></span> Abrir filtros de búsqueda</button></center></div></div></div></div><br><div class=col-lg-12 uib-alert type=info ng-show=vm.filtrosUsados>FILTROS APLICADOS:<div ng-repeat=\"filtro in vm.filtrosUsados\">{{vm.filtrosUsados[$index]}}</div></div><div ng-show=\"!vm.ingresos.length>0 && vm.bandera\" uib-alert class=\"danger col-lg-12 form-group\">No hay ingresos para los filtros indicados</div></div><div class=col-lg-12><table ng-table=vm.tableParams class=\"table table-condensed\" show-filter=true ng-show=\"vm.ingresos.length>0\"><tr ng-repeat=\"ingresos in $data\" ng-class=\"{\'verde-claro\': ingresos.estadoMovimiento.id==6, \'rojo-claro\':ingresos.estadoMovimiento.id==5}\"><div><td data-title=\"\'Fecha\'\" align=center data-sortable=\"\'fecha\'\">{{ingresos.fecha | date : \"dd/MM/yyyy HH:mm\" }}</td><td data-title=\"\'Depósito\'\" data-sortable=\"\'deposito.nombre\'\" filter=\"{\'deposito.nombre\': \'text\'}\" align=center>{{ingresos.deposito.nombre.toUpperCase();}}</td><td data-title=\"\'Empresa\'\" data-sortable=\"\'empresa.nombre\'\" filter=\"{\'empresa.nombre\': \'text\'}\" align=center>{{ingresos.empresa.nombre.toUpperCase();}}</td><td data-title=\"\'Proveedor\'\" filter=\"{\'proveedor.nombre\': \'text\'}\" data-sortable=\"\'proveedor.nombre\'\" align=center>{{ingresos.proveedor.nombre.toUpperCase();}}</td><td data-title=\"\'N° Movimiento\'\" style=width:5% align=center filter=\"{\'numeroMovimiento\':\'text\'}\" data-sortable=\"\'numeroMovimiento\'\">{{ingresos.numeroMovimiento}}</td><td data-title=\"\'N° de Cajas\'\" align=center data-sortable=\"\'fecha\'\"><button class=btn ng-click=vm.verNumeroCajasIngreso(ingresos);><i class=\"fa fa-search\"></i></button></td><td data-title=\"\'Estado\'\" style=width:5% data-sortable=\"\'estadoMovimiento.nombre\'\" filter=\"{\'estadoMovimiento.nombre\': \'text\'}\" align=center data-sortable=\"\'estado\'\">{{ingresos.estadoMovimiento.nombre.toUpperCase();}}</td><td data-title=\"\'Acciones\'\" align=center style=width:15%><div class=btn-group><a class=\"btn btn-info\" ng-disabled=\"ingresos.estadoMovimiento.id==5\" ng-click=\"ingresos.estadoMovimiento.id==5 || vm.visualizarIngreso(ingresos)\"><i class=\"fa fa-search\"></i> </a><a ng-if=\"vm.rol.id<=3\" ng-disabled=\"ingresos.estadoMovimiento.id==6\" class=\"btn btn-primary\" ng-click=\"ingresos.estadoMovimiento.id==6 || vm.irAsignarUbicaciones(ingresos)\"><i class=\"fa fa-map-marker\"></i> </a><a ng-if=\"vm.rol.id<=3\" ng-disabled=\"ingresos.estadoMovimiento.id==6\" class=\"btn btn-danger\" ng-click=\"ingresos.estadoMovimiento.id==6 || vm.eliminar(ingresos)\"><i class=\"fa fa-trash\"></i></a></div></td></div></tr></table></div></form></div>");
$templateCache.put("app/app/main/movimientos/ingreso/visualizar-ingreso/visualizar-ingreso.html","<div class=form-group ng-if=vm.comprobarIngresoCerrado();><center><button ng-click=vm.volver(); class=\"btn btn-info\" style=width:30%><i class=\"fa fa-arrow-left\"></i> Volver al listado</button> <button ng-if=\"vm.rol.id<=3\" ng-click=vm.imprimirInforme(); class=\"btn btn-primary\" style=width:30%><i class=\"fa fa-file-text-o\"></i> Obtener informe</button></center></div><div class=col-lg-12 ng-if=vm.comprobarIngresoCerrado()><div class=\"panel panel-default\"><div class=panel-body><div class=\"form-group col-lg-12\"><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.ingreso.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.ingreso.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Autorizó:</label><input type=text ng-model=vm.ingreso.solicitante class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Proveedor:</label><input type=text ng-readonly=true ng-model=vm.ingreso.proveedor.nombre class=\"form-control text-uppercase\" name=proveedor></div><div class=\"form-group col-lg-6\"><label>Persona Proveedor:</label><input type=text ng-readonly=true ng-model=vm.personaProveedor class=\"form-control text-uppercase\" name=personaProveedor></div><div class=\"form-group col-lg-4\"><label>Número de movimiento:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroMovimiento type=text name=numeroMovimiento></div><div class=\"form-group col-lg-4\"><label>Número de orden de compra:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroOrden type=text name=numeroOrden></div><div class=\"form-group col-lg-4\"><label>Número de remito:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroRemito type=text name=numeroRemito></div><div class=\"form-group col-lg-6\"><label>Fecha:</label><input class=form-control ng-readonly=true ng-model=vm.fecha type=text name=fecha></div><div class=\"form-group col-lg-6\"><label>Monto total:</label><input class=form-control ng-readonly=true ng-model=vm.montoTotal type=text name=montoTotal></div><div class=\"form-group col-lg-6\"><label>Número Vale Ingreso:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroIngresoVale type=text name=numeroIngresoVale></div><div class=\"form-group col-lg-6\"><label>Número guía</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroGuia type=text name=numeroGuia></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=form-control ng-readonly=true ng-model=vm.ingreso.observacion type=text name=observacion style=resize:vertical></textarea></div></div></div><div ng-if=\"vm.rol.id<=3\"><uib-accordion><div uib-accordion-group class=panel-default is-open=status.isCustomHeaderOpen><uib-accordion-heading>Problemas <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.isCustomHeaderOpen, \'glyphicon-chevron-right\': !status.isCustomHeaderOpen}\"></i></uib-accordion-heading><div class=col-lg-12><div ng-if=\"vm.ingreso.problemas.length==0\"><span uib-alert type=info>No posee ningún problema asignado</span></div><div><center><button class=\"btn btn-primary\" ng-click=vm.editarProblemas();><i class=\"fa fa-pencil-square\"></i> Agregar o quitar problemas</button></center></div><div ng-if=\"vm.ingreso.problemas.length>0\"><label>Problemas asignados:</label><table ng-table=vm.tableParams1 class=table><tr ng-repeat=\"problema in $data track by $index\"><td>{{problema.tipoProblema.nombre.toUpperCase();}}</td></tr></table><div class=col-lg-12 ng-if=vm.comprobarFotoProblema()><div uib-carousel active=0 interval=0 no-wrap=false><div uib-slide ng-repeat=\"problema in vm.problemas track by $index\" index=problema.ind><img ng-src={{problema.foto}} style=margin:auto><div><h4>{{problema.tipoProblema.nombre.toUpperCase();}}</h4></div></div></div><br></div><label>Descripción de problemas:</label><textarea class=form-control ng-readonly=true ng-disabled=true ng-model=vm.ingreso.observacionProblema type=text name=observacionProblema style=resize:vertical>\r\n						</textarea></div></div></div></uib-accordion></div><br><div class=\"col-lg-12 form-group\" ng-if=vm.comprobarIngresoCerrado();><label>Detalle de suministros del ingreso</label></div><form ng-show=true ng-if=vm.comprobarIngresoCerrado();><div class=col-lg-12 ng-show=\"vm.ingreso.detalles.length>0\"><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.ingreso.detalles.length>0\"><tr ng-repeat=\"detalles in $data track by $index\"><div><td title=\"\'Tipo Suministro\'\" sortable align=center>{{detalles.suministro.tipoSuministro.nombre.toUpperCase();}} ({{detalles.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase();}})</td><td title=\"\'Marca\'\" align=center>{{detalles.suministro.marca ? detalles.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'Fecha vencimiento\'\" align=center>{{detalles.suministro.fechaVencimiento ? detalles.suministro.fechaVencimiento : \"-\" | date : \"dd/MM/yyyy\" }}</td><td title=\"\'N° Inventario\'\" align=center>{{detalles.suministroInventariable? detalles.suministroInventariable.inventario : \'-\'}}</td><td title=\"\'N° Serie\'\" align=center>{{detalles.suministroInventariable? detalles.suministroInventariable.serie : \'-\'}}</td><td title=\"\'Cantidad\'\" align=center>{{detalles.cantidad}}</td><td ng-if=\"vm.rol.id<=3\" title=\"\'Precio por unidad\'\" align=center>${{detalles.suministro.precioUnitario.toFixed(2)}}</td><td ng-if=\"vm.rol.id<=3\" title=\"\'Total\'\" align=center>${{(detalles.suministro.precioUnitario*detalles.cantidad).toFixed(2)}}</td><td title=\"\'N° Caja\'\" align=center ng-if=vm.ingreso.caja>{{detalles.numeroCaja? detalles.numeroCaja : \'-\'}}</td><!-- 				        <td title=\"\'¿Activo?\'\" align=\"center\">\r\n    {{detalles.suministro.estadoSuministro.id==2? \"SI\" : \"NO\"}}\r\n</td> --><td title=\"\'¿Nuevo?\'\" align=center>{{detalles.suministroInventariable? detalles.suministroInventariable.nuevo? \"SI\" : \"NO\" : \"-\"}}</td><td ng-if=\"vm.rol.id<=3\" style=width:35% title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !detalles.suministro.ubicacion.numeroOrden, \'has-success\':detalles.suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(detalles) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(detalles)}}</div></div></td><td ng-if=\"vm.rol.id<=3\" data-title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-primary\" ng-click=vm.reporteNombre(detalles)><i class=\"fa fa-file-text\"></i> </a><a class=\"btn btn-warning\" ng-click=vm.editarSuministro(detalles)><i class=\"fa fa-pencil\"></i></a></div></td></div></tr></table></div></form></div><div ng-if=!vm.comprobarIngresoCerrado() class=col-lg-12><span uib-alert class=danger>El ingreso todavía no tiene ubicaciones asignadas.</span></div>");
$templateCache.put("app/app/main/movimientos/transferencias-stock/editar/editar.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><div class=\"form-group col-lg-12\"><br><center><button style=width:30% class=\"btn btn-success\" ng-disabled=\"vm.form.$invalid || vm.detalles.length==0\" ng-click=vm.guardar()><i class=\"fa fa-check\"></i> Guardar</button> <button style=width:30% class=\"btn btn-warning\" ng-click=vm.cancelar()><i class=\"fa fa-arrow-left\"></i> Cancelar</button></center><br></div><div class=col-lg-12><div class=\"form-group col-lg-6\"><label ng-if=!vm.bandera>Seleccione el depósito:</label><label ng-if=vm.bandera>Depósito:</label><input type=text ng-disabled=\"vm.deposito || vm.bandera\" ng-model=vm.transferencia.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label ng-if=!vm.bandera>Seleccione la empresa:</label><label ng-if=vm.bandera>Empresa:</label><input type=text ng-disabled=\"vm.empresa || vm.bandera\" ng-model=vm.transferencia.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Tipo de stock a transferir:</label><input type=text ng-disabled=vm.bandera ng-model=vm.transferencia.tipoDesde placeholder=\"Seleccione o busque el tipo de stock\" uib-typeahead=\"tipoDesde as tipoDesde.nombre.toUpperCase() for tipoDesde in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Se transfiere a:</label><input type=text ng-disabled=\"!vm.transferencia.tipoDesde.id || vm.bandera\" ng-model=vm.transferencia.tipoHasta placeholder=\"Seleccione o busque el tipo de stock\" uib-typeahead=\"tipoHasta as tipoHasta.nombre.toUpperCase() for tipoHasta in vm.tiposHasta | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=col-lg-12><label>Observación:</label><textarea class=form-control ng-disabled=vm.bandera ng-maxlength=1000 ng-model=vm.transferencia.observacion placeholder=\"Ingrese una descripción general de la transferencia\" type=text name=observacion required style=resize:vertical></textarea><span uib-alert class=danger ng-if=\"vm.form.observacion.$error.required && vm.form.observacion.$dirty\">Esta campo es requerido</span></div><br>&nbsp;<div><center><br><button style=width:40% ng-if=!vm.bandera ng-disabled=\"!vm.transferencia.deposito.id || !vm.transferencia.empresa.id || !vm.transferencia.tipoDesde.id || !vm.transferencia.tipoHasta.id || !vm.transferencia.observacion \" ng-click=vm.seleccionar() class=\"btn btn-primary\"><i class=\"fa fa-check\"></i> Seleccionar</button> <button ng-if=vm.bandera style=width:40% ng-click=vm.cambiarSeleccion() class=\"btn btn-warning\"><i class=\"fa fa-exchange\"></i> Cambiar</button><br></center></div><hr></div><div class=col-lg-12 ng-if=vm.bandera><div class=col-lg-12><br><center><button style=width:40% class=\"btn btn-primary btn-block\" ng-disabled=!vm.bandera ng-click=vm.agregarDetalleTransferencia()><i class=\"fa fa-plus\"></i> Agregar bien</button></center><br></div><br><br><div><div uib-alert class=col-lg-12 ng-if=\"vm.detalles.length==0\">No hay bienes agregados</div><label class=col-lg-12 ng-if=\"vm.detalles.length>0\">Detalles</label><div class=col-lg-12 ng-if=\"vm.detalles.length>0\"><table ng-table=vm.tableParams id=table1 show-filter=true class=table><tr ng-repeat=\"detalle in $data\"><td data-title=\"\'Grupo suministro\'\" align=center>{{detalle.suministroInventariable? detalle.suministroInventariable.suministro.tipoSuministro.familiaSuministro.grupoSuministro ? detalle.suministroInventariable.suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase() : \"-\" : detalle.suministro.tipoSuministro.familiaSuministro.grupoSuministro ? detalle.suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase() : \"-\"}}</td><td data-title=\"\'Familia suministro\'\" align=center>{{detalle.suministroInventariable? detalle.suministroInventariable.suministro.tipoSuministro.familiaSuministro ? detalle.suministroInventariable.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase() :\"-\" : detalle.suministro.tipoSuministro.familiaSuministro ? detalle.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase() : \"-\" }}</td><td data-title=\"\'Tipo suministro\'\" align=center>{{detalle.suministroInventariable? detalle.suministroInventariable.suministro.tipoSuministro ? detalle.suministroInventariable.suministro.tipoSuministro.nombre.toUpperCase() : \"-\":detalle.suministro.tipoSuministro ? detalle.suministro.tipoSuministro.nombre.toUpperCase() : \"-\" }}</td><td data-title=\"\'Marca\'\" align=center>{{detalle.suministroInventariable?detalle.suministroInventariable.suministro.marca ? detalle.suministroInventariable.suministro.marca.toUpperCase() : \"-\":detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\"}}</td><td data-title=\"\'N° inventario\'\" align=center>{{detalle.suministroInventariable.inventario ? detalle.suministroInventariable.inventario : \"-\"}}</td><td data-title=\"\'N° serie\'\" align=center>{{detalle.suministroInventariable.serie ? detalle.suministroInventariable.serie : \"-\"}}</td><td data-title=\"\'Cantidad\'\" align=center>{{detalle.suministro? detalle.suministro.cantidad : \"-\"}}</td><td data-title=\"\'\'\"><button class=\"btn btn-danger\" ng-click=vm.quitarDetalle(detalle)><i class=\"fa fa-remove\"></i></button></td></tr></table></div></div></div></div></form></div></div></div></div>");
$templateCache.put("app/app/main/movimientos/transferencias-stock/lista/lista.html","<!--     <formly-form model=\"vm.user\" fields=\"vm.userFields\">\r\n  <button type=\"submit\" class=\"btn btn-primary col-sm-offset-4 col-sm-4\" ng-click=\"vm.submit(vm.user)\">Submit</button>\r\n</formly-form> --><div><form><div class=\"form-group col-lg-12\"><div class=form-group ng-if=\"vm.rol.id<=3\"><center><button ng-click=vm.crearNuevo() class=\"btn btn-success\" style=width:50%><i class=\"fa fa-plus\"></i> NUEVA TRANSFERENCIA</button></center></div></div><div class=col-lg-12><table ng-table=vm.tableParams class=\"table table-condensed\" show-filter=true ng-show=\"vm.transferencias.length>0\"><tr ng-repeat=\"transferencias in $data\" ng-class=\"{\'verde-claro\': transferencias.estadoMovimiento.id==6, \'rojo-claro\':transferencias.estadoMovimiento.id==5}\"><div><td data-title=\"\'Fecha\'\" align=center data-sortable=\"\'fecha\'\">{{transferencias.fecha | date : \"dd/MM/yyyy\" }}</td><td data-title=\"\'Depósito\'\" data-sortable=\"\'deposito.nombre\'\" filter=\"{\'deposito.nombre\': \'text\'}\" align=center>{{transferencias.deposito.nombre.toUpperCase();}}</td><td data-title=\"\'Empresa\'\" data-sortable=\"\'empresa.nombre\'\" filter=\"{\'empresa.nombre\': \'text\'}\" align=center>{{transferencias.empresa.nombre.toUpperCase();}}</td><td data-title=\"\'N° Transferencia\'\" style=width:5% align=center filter=\"{\'numeroTransferencia\':\'text\'}\" data-sortable=\"\'numeroTransferencia\'\">{{transferencias.numeroTransferencia}}</td><td data-title=\"\'Tipo de transferencia\'\" align=center>{{vm.desdeHasta(transferencias);}}</td><td data-title=\"\'Acciones\'\" align=center style=width:10%><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.visualizarTransferencia(transferencias)><i class=\"fa fa-search\"></i></a></div></td></div></tr></table></div></form></div>");
$templateCache.put("app/app/main/usuarios/usuario/editar/editar-usuario.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=form-group><label>Ingrese apellido:</label><input class=form-control ng-maxlength=255 ng-model=vm.usuario.empleado.apellido placeholder=\"Ingrese el apellido\" type=text name=apellido required> <span uib-alert class=danger ng-if=\"vm.form.apellido.$error.required && vm.form.$dirty\">Este campo es requerido.</span> <span uib-alert class=danger ng-if=\"vm.form.apellido.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=form-group><label>Ingrese nombre:</label><input class=form-control ng-maxlength=255 ng-model=vm.usuario.empleado.nombre placeholder=\"Ingrese el nombre\" type=text name=nombre required> <span uib-alert class=danger ng-if=\"vm.form.nombre.$error.required && vm.form.$dirty\">Este campo es requerido.</span> <span uib-alert class=danger ng-if=\"vm.form.nombre.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=form-group><label>Ingrese o busque el Rol:</label><input type=text ng-model=vm.usuario.rol placeholder=\"Seleccione o busque el Rol\" uib-typeahead=\"rol as rol.nombre.toUpperCase() for rol in vm.roles | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 required name=rol typeahead-editable=false> <span uib-alert class=danger ng-show=\"vm.form.rol.$invalid && vm.form.$dirty\">Este campo es requerido.</span></div><div class=form-group ng-if=\"vm.usuario.rol.id && vm.usuario.rol.id!=1\"><label>Ingrese o busque el Depósito:</label><input type=text ng-model=vm.usuario.empleado.deposito ng-if=\"vm.usuario.rol.id && vm.usuario.rol.id!=1\" placeholder=\"Seleccione o busque el Depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=deposito typeahead-editable=false> <span uib-alert class=danger ng-show=\"((!vm.usuario.empleado.deposito.id && vm.usuario.rol.id<4) || (vm.rol.id>1 && !vm.usuario.empleado.deposito.id))\">Este campo es requerido. </span><span uib-alert class=danger ng-show=\"vm.usuario.empleado.empresa && !vm.usuario.empleado.deposito\">Si selecciona una empresa, debe seleccionar un depósito.</span></div><div class=form-group ng-if=\"vm.usuario.rol.id && vm.usuario.rol.id>3\"><label>Ingrese o busque la empresa:</label><input type=text ng-model=vm.usuario.empleado.empresa ng-if=\"vm.usuario.rol.id && vm.usuario.rol.id!=1\" placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=empresa typeahead-editable=false> <span uib-alert class=danger ng-show=\"vm.rol.id>1 && !vm.usuario.empleado.empresa\">Este campo es requerido. </span><span uib-alert class=danger ng-show=\"vm.usuario.rol.id>4 && !vm.usuario.empleado.empresa && vm.usuario.empleado.deposito\">Si selecciona un depósito, debe seleccionar una empresa.</span></div><div class=form-group><label>Activo: &nbsp;&nbsp;&nbsp;</label><toggle ng-model=vm.usuario.activo ng-change=vm.alerta(); on=SI off=NO onstyle=btn-success offstyle=btn-danger></toggle></div><br><br><div class=form-group><label>Nombre de usuario:</label><input class=form-control ng-maxlength=30 ng-minlength=4 ng-model=vm.usuario.nombreUsuario placeholder=\"Nombre de usuario\" type=text name=nombreUsuario required> <span uib-alert class=danger ng-if=\"vm.form.nombreUsuario.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 30 caracteres. </span><span uib-alert class=danger ng-if=\"vm.form.nombreUsuario.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.nombreUsuario.$error.minlength && vm.form.$dirty\">Este campo debe tener al menos 4 caracteres.</span></div><div class=\"form-group col-lg-12\" ng-if=\"vm.modo==\'editar\'\"><button type=button class=\"btn btn-primary btn-block\" ng-click=vm.abrirModalCambioPassword()><span class=\"fa fa-refresh\"></span> Renovar password</button></div><div class=\"form-group col-xs-6\" ng-if=\"vm.modo!==\'editar\'\"><label>Password:</label><input class=form-control ng-maxlength=25 ng-minlength=1 ng-model=vm.usuario.password placeholder=Password type=password name=password required> <span uib-alert class=danger ng-if=\"!vm.validarPassword().validation && vm.form.password.$dirty\">{{vm.validarPassword().mensaje}} </span><span uib-alert type=success ng-if=\"vm.validarPassword().validation && vm.form.password.$dirty\">{{vm.validarPassword().mensaje}}</span></div><div class=\"form-group col-xs-6\" ng-if=\"vm.modo!==\'editar\'\"><label>Repita Password:</label><input class=form-control ng-model=vm.usuario.repitePassword placeholder=\"Repita Password\" type=password name=repitePassword required> <span uib-alert class=danger ng-if=\"vm.form.repiteNuevaPassword.$error.required && vm.form.repiteNuevaPassword.$dirty\">Este campo es requerido.</span></div><span class=col-xs-12 uib-alert class=danger ng-if=\"vm.usuario.password !== vm.usuario.repitePassword && vm.form.repitePassword.$dirty\">Las contraseñas deben ser iguales.</span></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.guardar() ng-disabled=\"vm.form.$invalid || vm.usuario.password !== vm.usuario.repitePassword || (vm.rol.id>1 && vm.usuario.rol.id>3 && !vm.usuario.empleado.empresa.id) || (((vm.usuario.rol.id<4 && vm.usuario.rol.id>1) && !vm.usuario.empleado.deposito.id) || (vm.rol.id>1 && !vm.usuario.empleado.deposito.id)) || (vm.usuario.empleado.empresa.id && !vm.usuario.empleado.deposito.id) || (vm.usuario.rol.id>4 &&  !vm.usuario.empleado.empresa.id && vm.usuario.empleado.deposito.id) || (vm.modo!=\'editar\' && !vm.validarPassword().validation)\"><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/usuarios/usuario/usuario-pedidos/usuario-pedidos.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=\"form-group col-lg-12\"><label>Rol:</label><input type=text ng-model=vm.rolPedido.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-12\"><label>Empresa:</label><input type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la Empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 required name=empresa typeahead-editable=false> <span uib-alert class=danger ng-show=\"vm.form.empresa.$error.required && vm.form.empresa.$dirty\">Este campo es requerido.</span></div><div class=\"form-group col-lg-12\"><label>Solicitante:</label><input type=text ng-disabled=!vm.empresa.nombre ng-model=vm.usuario.solicitante placeholder=\"Seleccione o busque solicitante\" class=form-control uib-typeahead=\"solicita as solicita.apellido.toUpperCase()+\', \'+solicita.nombre.toUpperCase() for solicita in vm.solicitantes | filter:{apellido:$viewValue}\" typeahead-show-hint=true typeahead-min-length=0 name=solicitante typeahead-editable=false focus-on=solicitante required> <span uib-alert class=danger ng-show=\"vm.rol.id>1 && !vm.usuario.solicitante\">Este campo es requerido.</span></div><div class=\"form-group col-lg-12\"><label>Depósito:</label><input type=text ng-model=vm.deposito placeholder=\"Ingrese o busque el Depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=deposito typeahead-editable=false> <span uib-alert class=danger ng-show=\"((!vm.deposito.id && vm.usuario.rol.id<4) || (vm.rol.id>1 && !vm.deposito.id))\">Este campo es requerido.</span></div><div class=\"form-group col-lg-12\"><label>Activo: &nbsp;&nbsp;&nbsp;</label><toggle ng-model=vm.usuario.activo ng-change=vm.alerta(); on=SI off=NO onstyle=btn-success offstyle=btn-danger></toggle></div><br><br><div class=\"form-group col-lg-12\" ng-disabled=\"vm.modo==\'editar\'\"><label>Nombre de usuario:</label><input ng-disabled=\"vm.modo==\'editar\'\" class=form-control ng-maxlength=30 ng-minlength=4 ng-model=vm.usuario.nombreUsuario placeholder=\"Nombre de usuario\" type=text name=nombreUsuario required> <span uib-alert class=danger ng-if=\"vm.form.nombreUsuario.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 30 caracteres. </span><span uib-alert class=danger ng-if=\"vm.form.nombreUsuario.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.nombreUsuario.$error.minlength && vm.form.$dirty\">Este campo debe tener al menos 4 caracteres.</span></div><div class=\"form-group col-lg-12\" ng-if=\"vm.modo==\'editar\'\"><button type=button class=\"btn btn-primary btn-block\" ng-click=vm.abrirModalCambioPassword()><span class=\"fa fa-refresh\"></span> Renovar password</button></div><div class=\"form-group col-xs-6\" ng-if=\"vm.modo!==\'editar\'\"><label>Password:</label><input class=form-control ng-maxlength=25 ng-minlength=1 ng-model=vm.usuario.password placeholder=Password type=password name=password required> <span uib-alert class=danger ng-if=\"!vm.validarPassword().validation && vm.form.password.$dirty\">{{vm.validarPassword().mensaje}} </span><span uib-alert type=success ng-if=\"vm.validarPassword().validation && vm.form.password.$dirty\">{{vm.validarPassword().mensaje}}</span></div><div class=\"form-group col-xs-6\" ng-if=\"vm.modo!==\'editar\'\"><label>Repita Password:</label><input class=form-control ng-model=vm.usuario.repitePassword placeholder=\"Repita Password\" type=password name=repitePassword required> <span uib-alert class=danger ng-if=\"vm.form.repiteNuevaPassword.$error.required && vm.form.repiteNuevaPassword.$dirty\">Este campo es requerido.</span></div><span class=col-xs-12 uib-alert class=danger ng-if=\"vm.usuario.password !== vm.usuario.repitePassword && vm.form.repitePassword.$dirty\">Las contraseñas deben ser iguales.</span></form></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.guardar() ng-disabled=\"\r\n          vm.form.$invalid || \r\n          vm.usuario.password !== vm.usuario.repitePassword || \r\n          (vm.rol.id>2 && vm.usuario.rol.id>3 && !vm.usuario.empleado.empresa.id) || \r\n          (((vm.usuario.rol.id<4 && vm.usuario.rol.id>2) && !vm.usuario.empleado.deposito.id) || (vm.rol.id>2 && !vm.usuario.empleado.deposito.id)) ||\r\n           (vm.usuario.empleado.empresa.id && !vm.usuario.empleado.deposito.id) || \r\n           (vm.usuario.rol.id>4 &&  !vm.usuario.empleado.empresa.id && vm.usuario.empleado.deposito.id)\"><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div></div>");
$templateCache.put("app/app/main/usuarios/usuario/lista/lista-usuario.html","<div><form><div class=form-group><center><button ng-click=vm.crearNuevo() class=\"btn btn-success\" style=width:30%><i class=\"fa fa-plus\"></i> NUEVO USUARIO</button> <button ng-click=vm.crearNuevoPedidos() class=\"btn btn-primary\" style=width:30%><i class=\"fa fa-plus\"></i> NUEVO USUARIO PARA PEDIDOS</button></center></div><button class=\"btn btn-link\" ng-click=vm.exportToExcel()><span class=\"glyphicon glyphicon-share\"></span> Exportar a Excel</button><div class=col-lg-12><table id=table1 ng-table=vm.tableParams class=table show-filter=true ng-show=vm.usuarios><tr ng-repeat=\"usuario in $data\"><td title=\"\'Apellido\'\" data-sortable=\"\'empleado.apellido\'\">{{usuario.empleado.apellido}}</td><td title=\"\'Nombre\'\" data-sortable=\"\'empleado.nombre\'\">{{usuario.empleado.nombre}}</td><td title=\"\'Nombre usuario\'\" filter=\"{ nombreUsuario: \'text\'}\" data-sortable=\"\'nombreUsuario\'\">{{usuario.nombreUsuario}}</td><td title=\"\'Activo\'\" data-sortable=\"\'activo\'\">{{usuario.activo? \'Si\' : \'No\'}}</td><td title=\"\'Rol\'\" data-sortable=\"\'rol.nombre\'\">{{usuario.rol.nombre}}</td><td title=\"\'Empresa\'\" data-sortable=\"\'empleado.empresa.nombre\'\">{{usuario.empleado.empresa? usuario.empleado.empresa.nombre.toUpperCase() : \"-\"}}</td><td title=\"\'Depósito\'\" data-sortable=\"\'empleado.deposito.nombre\'\">{{usuario.empleado.deposito? usuario.empleado.deposito.nombre.toUpperCase() : \"-\"}}</td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.mostrarInformacion(usuario)><i class=\"fa fa-search\"></i> </a><a class=\"btn btn-warning\" ng-click=vm.editar(usuario)><i class=\"fa fa-pencil\"></i> </a><!-- 								<a class=\"btn btn-danger\" ng-click=\"vm.eliminar(usuario)\">\r\n<i class=\"fa fa-trash\"></i>\r\n</a> --></div></td></tr></table></div></form></div>");
$templateCache.put("app/app/main/suministro/categoria-peso/editar/editar-categoria.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=form-group><label>Ingrese el nombre de la categoría:</label><input class=form-control ng-maxlength=255 ng-model=vm.categoria.nombre placeholder=\"Ingrese el nombre de la categoría\" type=text name=categoria required> <span uib-alert class=danger ng-if=\"vm.form.categoria.$error.required && vm.form.$dirty\">Este campo es requerido.</span> <span uib-alert class=danger ng-if=\"vm.form.categoria.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=form-group><label>Ingrese la descripción:</label><textarea class=form-control ng-maxlength=500 ng-model=vm.categoria.descripcion placeholder=\"Ingrese la descripción de la categoría\" type=text name=descripcion required style=resize:vertical></textarea><span uib-alert class=danger ng-if=\"vm.form.descripcion.$error.required && vm.form.$dirty\">Este campo es requerido.</span> <span uib-alert class=danger ng-if=\"vm.form.descripcion.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 500 caracteres.</span></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.guardar() ng-disabled=vm.form.$invalid><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/suministro/categoria-peso/lista/lista-categoria.html","<div><form><div class=form-group><center><button ng-click=vm.crearNuevo() class=\"btn btn-success\" style=width:50%><i class=\"fa fa-plus\"></i> NUEVA CATEGORÍA PESO</button></center></div><button class=\"btn btn-link\" ng-click=vm.exportToExcel()><span class=\"glyphicon glyphicon-share\"></span> Exportar a Excel</button><div class=col-lg-12><table id=table1 ng-table=vm.tableParams class=table show-filter=true ng-show=vm.categorias><tr ng-repeat=\"categoria in $data\"><td title=\"\'Nombre\'\" filter=\"{ nombre: \'text\'}\" sortable>{{categoria.nombre.toUpperCase();}}</td><td title=\"\'Descripción\'\">{{categoria.descripcion}}</td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.mostrarInformacion(categoria)><i class=\"fa fa-search\"></i> </a><a class=\"btn btn-warning\" ng-click=vm.editar(categoria)><i class=\"fa fa-pencil\"></i> </a><a class=\"btn btn-danger\" ng-diabled=vm.bloquearPorRol(); ng-click=vm.eliminar(categoria)><i class=\"fa fa-trash\"></i></a></div></td></tr></table></div></form></div>");
$templateCache.put("app/app/main/suministro/familia-suministro/editar/editar-familia-suministro.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=form-group><label>Ingrese el nombre de la Familia de suministro:</label><input class=form-control ng-maxlength=255 ng-model=vm.familia.nombre placeholder=\"Ingrese el nombre de la familia\" type=text name=nombre required> <span uib-alert class=danger ng-if=\"vm.form.nombre.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.nombre.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=form-group><label>Ingrese o busque el Grupo de suministro:</label><input type=text ng-model=vm.familia.grupoSuministro placeholder=\"Seleccione o busque el Grupo de suministro\" uib-typeahead=\"grupoSuministro as grupoSuministro.nombre.toUpperCase()+\' (\'+grupoSuministro.empresa.nombre.toUpperCase()+\')\' for grupoSuministro in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 required name=grupoSuministro typeahead-editable=false> <span uib-alert class=danger ng-show=\"vm.form.grupoSuministro.$error.required && vm.form.$dirty\">Este campo es requerido.</span></div><div class=form-group><label>Ingrese el código de familia de suministro:</label><input class=form-control ng-maxlength=255 ng-model=vm.familia.codigoFamiliaSuministro placeholder=\"Ingrese el código de la familia de suministro\" type=text name=codigoFamiliaSuministro required> <span uib-alert class=danger ng-show=\"vm.form.codigoFamiliaSuministro.$error.required && vm.form.codigoFamiliaSuministro.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.codigoFamiliaSuministro.$error.maxlength && vm.form.codigoFamiliaSuministro.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=form-group><label>Ingrese la descripción:</label><textarea class=form-control ng-maxlength=500 ng-model=vm.familia.descripcion placeholder=\"Ingrese la descripción de la familia\" type=text name=descripcion required style=resize:vertical></textarea><span uib-alert class=danger ng-show=\"vm.form.descripcion.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.descripcion.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 500 caracteres.</span></div><br><br><div class=\"form-group col-xs-6\"><label>Ingrese el nombre del Encargado:</label><input class=form-control ng-maxlength=255 ng-model=vm.familia.nombreEncargado placeholder=\"Ingrese el nombre del Encargado\" type=text name=nombreEncargado> <span uib-alert class=danger ng-if=\"vm.form.nombreEncargado.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=\"form-group col-xs-6\"><label>Ingrese el apellido del Encargado:</label><input class=form-control ng-maxlength=255 ng-model=vm.familia.apellidoEncargado placeholder=\"Ingrese el apellido del Encargado\" type=text name=apellidoEncargado> <span uib-alert class=danger ng-if=\"vm.form.apellidoEncargado.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=\"form-group col-xs-4\"><label>Ingrese el teléfono del Encargado:</label><input class=form-control ng-maxlength=20 ng-model=vm.familia.telefonoEncargado placeholder=\"Ingrese el teléfono del Encargado\" type=text name=telefonoEncargado ng-pattern=/^([0-9])*$/ > <span uib-alert class=danger ng-if=\"vm.form.telefonoEncargado.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 20 caracteres. </span><span uib-alert class=danger ng-if=\"vm.form.telefonoEncargado.$error.pattern && vm.form.$dirty\">Ingrese un valor válido.</span></div><div class=\"form-group col-xs-4\"><label>Ingrese el email del Encargado:</label><input class=form-control ng-maxlength=80 ng-model=vm.familia.mailEncargado placeholder=\"Ingrese el email del Encargado\" type=email required name=mailEncargado ng-pattern=/[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$/ > <span uib-alert class=danger ng-if=\"vm.form.mailEncargado.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 80 caracteres. </span><span uib-alert class=danger ng-if=\"vm.form.mailEncargado.$error.pattern && vm.form.$dirty\">Ingrese un mail válido. </span><span uib-alert class=danger ng-if=\"vm.form.mailEncargado.$error.required && vm.form.$dirty\">Este campo es requerido.</span></div><div class=\"form-group col-xs-4\"><label>Ingrese el email adicional:</label><input class=form-control ng-maxlength=80 ng-model=vm.familia.mailAdicional placeholder=\"Ingrese el email adicional\" type=email required name=mailAdicional ng-pattern=/[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$/ > <span uib-alert class=danger ng-if=\"vm.form.mailAdicional.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 80 caracteres. </span><span uib-alert class=danger ng-if=\"vm.form.mailAdicional.$error.pattern && vm.form.$dirty\">Ingrese un mail válido. </span><span uib-alert class=danger ng-if=\"vm.form.mailAdicional.$error.required && vm.form.$dirty\">Este campo es requerido.</span></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.guardar() ng-disabled=\"vm.form.$invalid || !vm.familia.grupoSuministro.nombre\"><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/suministro/familia-suministro/lista/lista-familia-suministro.html","<!--     <formly-form model=\"vm.user\" fields=\"vm.userFields\">\r\n  <button type=\"submit\" class=\"btn btn-primary col-sm-offset-4 col-sm-4\" ng-click=\"vm.submit(vm.user)\">Submit</button>\r\n</formly-form> --><div><form><div class=\"form-group col-lg-12\"><div class=form-group><center><button ng-click=vm.crearNuevo() class=\"btn btn-success\" style=width:50%><i class=\"fa fa-plus\"></i> NUEVA FAMILIA DE SUMINISTRO</button></center></div><div><label>Filtrar por grupo de suministro:</label><div class=col-lg-12><div class=\"form-group col-lg-1\"><input type=checkbox ng-model=vm.buscar ng-click=vm.busqueda()></div><div class=\"form-group col-lg-9\"><input ng-disabled=!vm.buscar type=text ng-model=vm.grupoSuministro placeholder=\"Seleccione o busque el grupo de suministro\" uib-typeahead=\"grupoSuministro as grupoSuministro.nombre.toUpperCase()+\' - (\'+grupoSuministro.empresa.nombre.toUpperCase()+\')\' for grupoSuministro in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-editable=false typeahead-min-length=0></div><div class=\"col-lg-2 form-group\"><button ng-disabled=\"!vm.buscar || !vm.grupoSuministro.nombre\" class=\"btn btn-primary\" ng-click=vm.filtrar()><span class=\"fa fa-search\"></span> Buscar</button></div></div></div><br><div ng-show=\"!vm.familias.length>0 && vm.bandera\" uib-alert class=\"danger col-lg-12 form-group\">No hay familias de suministro para el grupo de suministro seleccionado.</div></div><button class=\"btn btn-link\" ng-click=vm.exportToExcel() ng-show=\"vm.familias.length>0\"><span class=\"fa fa-file-excel-o\"></span> Exportar a Excel</button> <button class=\"btn btn-link\" ng-click=vm.reportePdf() ng-show=\"vm.familias.length>0\"><span class=\"fa fa-file-pdf-o\"></span> Exportar a PDF</button><div class=col-lg-12><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.familias.length>0\"><tr ng-repeat=\"familias in $data\"><td title=\"\'Empresa\'\" align=center data-sortable=\"\'grupoSuministro.empresa.nombre\'\">{{familias.grupoSuministro.empresa.nombre.toUpperCase()}}</td><td title=\"\'Grupo de suministro\'\" align=center data-sortable=\"\'grupoSuministro.nombre\'\">{{familias.grupoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Nombre\'\" filter=\"{ nombre: \'text\'}\" data-sortable=\"\'nombre\'\">{{familias.nombre}}</td><td title=\"\'Código\'\" filter=\"{ codigoFamiliaSuministro: \'text\'}\" data-sortable=\"\'codigoFamiliaSuministro\'\">{{familias.codigoFamiliaSuministro? familias.codigoFamiliaSuministro.toUpperCase() : \"-\"}}</td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.mostrarInformacion(familias)><i class=\"fa fa-search\"></i> </a><a class=\"btn btn-warning\" ng-click=vm.editar(familias)><i class=\"fa fa-pencil\"></i> </a><a class=\"btn btn-danger\" ng-disabled=vm.bloquearPorRol(); ng-click=\"vm.bloquearPorRol() || vm.eliminar(familias)\"><i class=\"fa fa-trash\"></i></a></div></td></tr></table></div></form></div>");
$templateCache.put("app/app/main/suministro/grupo-suministro/editar/editar-grupo-suministro.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=form-group><label>Ingrese el nombre del Grupo de suministro:</label><input class=form-control ng-maxlength=255 ng-model=vm.grupo.nombre placeholder=\"Ingrese el nombre del Grupo de suministro\" type=text name=grupo required> <span uib-alert class=danger ng-if=\"vm.form.grupo.$error.required && vm.form.$dirty\">Este campo es requerido.</span> <span uib-alert class=danger ng-if=\"vm.form.grupo.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=form-group><label>Ingrese o busque la Empresa:</label><input type=text ng-model=vm.grupo.empresa ng-disabled=\"vm.modo==\'editar\'\" placeholder=\"Seleccione o busque la Empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 required name=empresa typeahead-editable=false> <span uib-alert class=danger ng-show=\"vm.form.empresa.$error.required && vm.form.$dirty\">Este campo es requerido.</span></div><div class=form-group><label>Ingrese la descripción:</label><textarea class=form-control ng-maxlength=500 ng-model=vm.grupo.descripcion placeholder=\"Ingrese la descripción del grupo de suministro\" type=text name=descripcion required style=resize:vertical></textarea><span uib-alert class=danger ng-if=\"vm.form.descripcion.$error.required && vm.form.$dirty\">Este campo es requerido.</span> <span uib-alert class=danger ng-if=\"vm.form.descripcion.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 500 caracteres.</span></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.guardar() ng-disabled=vm.form.$invalid><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/suministro/grupo-suministro/lista/lista-grupo-suministro.html","<div><form><div class=col-lg-12><div class=form-group><center><button ng-click=vm.crearNuevo() class=\"btn btn-success\" style=width:50%><i class=\"fa fa-plus\"></i> NUEVO GRUPO DE SUMINISTRO</button></center></div><div class=col-lg-12><label>Filtrar por empresa:</label><div class=col-lg-12><div class=\"form-group col-lg-1\"><input type=checkbox ng-model=vm.buscar ng-click=vm.busqueda()></div><div class=\"form-group col-lg-9\"><input ng-disabled=!vm.buscar type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"col-lg-2 form-group\"><button ng-disabled=\"!vm.buscar || !vm.empresa.nombre\" class=\"btn btn-primary\" ng-click=vm.filtrar()><span class=\"fa fa-search\"></span> Buscar</button></div></div></div><br><div ng-show=\"!vm.grupos.length>0 && vm.bandera\" uib-alert class=\"danger col-lg-12 form-group\">No hay grupos de suministro para la empresa seleccionada.</div></div><button class=\"btn btn-link\" ng-click=vm.exportToExcel() ng-show=\"vm.grupos.length>0\"><span class=\"fa fa-file-excel-o\"></span> Exportar a Excel</button> <button class=\"btn btn-link\" ng-click=vm.reportePdf() ng-show=\"vm.grupos.length>0\"><span class=\"fa fa-file-pdf-o\"></span> Exportar a PDF</button><div class=col-lg-12><table id=table1 ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.grupos.length>0\"><tr ng-repeat=\"grupo in $data\"><td title=\"\'Empresa\'\" align=center data-sortable=\"\'empresa.nombre\'\">{{grupo.empresa.nombre.toUpperCase();}}</td><td title=\"\'Nombre\'\" filter=\"{ nombre: \'text\'}\" data-sortable=\"\'nombre\'\">{{grupo.nombre.toUpperCase();}}</td><td title=\"\'Descripción\'\">{{grupo.descripcion}}</td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.mostrarInformacion(grupo)><i class=\"fa fa-search\"></i> </a><a class=\"btn btn-warning\" ng-click=vm.editar(grupo)><i class=\"fa fa-pencil\"></i> </a><a class=\"btn btn-danger\" ng-disabled=vm.bloquearPorRol(); ng-click=\"vm.bloquearPorRol() || vm.eliminar(grupo)\"><i class=\"fa fa-trash\"></i></a></div></td></tr></table></div></form></div>");
$templateCache.put("app/app/main/suministro/historial-suministro/editar/editar-historial-suministro.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><div class=\"form-group col-lg-12\"><br><center><button style=width:30% class=\"btn btn-success\" ng-disabled=\"vm.form.$invalid || vm.detalles.length==0\" ng-click=vm.guardar()><i class=\"fa fa-check\"></i> Guardar</button> <button style=width:30% class=\"btn btn-warning\" ng-click=vm.cancelar()><i class=\"fa fa-arrow-left\"></i> Cancelar</button></center><br></div><div class=\"col-lg-12 panel\"><div ng-class=\"{\'col-lg-10 \': !vm.deposito, \'col-lg-12 \': vm.deposito}\"><div class=form-group><label ng-if=!vm.bandera>Seleccione el depósito:</label><label ng-if=vm.bandera>Depósito:</label><input type=text ng-disabled=\"vm.deposito || vm.bandera\" ng-model=vm.historial.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><br><div class=col-lg-2 ng-if=!vm.bandera><button style=width:100% ng-disabled=!vm.historial.deposito.id ng-click=vm.seleccionarDeposito() class=\"btn btn-primary\"><i class=\"fa fa-check\"></i> Seleccionar</button></div><div class=col-lg-2 ng-if=\"vm.bandera && !vm.deposito\"><button style=width:100% ng-click=vm.cambiarDeposito() class=\"btn btn-warning\"><i class=\"fa fa-exchange\"></i> Cambiar</button></div></div></div><div class=col-lg-12 ng-if=vm.bandera><div class=\"form-group col-lg-12\"><label>Personal:</label><input class=form-control placeholder=\"Ingrese nombre y apellido del personal que realiza la reparación\" ng-model=vm.historial.personal type=text name=personal required ng-minlength=5> <span uib-alert class=danger ng-if=\"vm.form.personal.$error.required && vm.form.personal.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.personal.$error.minlength && vm.form.personal.$dirty\">Este debe poseer al menos 5 caracteres.</span></div><div class=col-lg-12><label>Descripción de la reparación:</label><textarea class=form-control ng-maxlength=1000 ng-model=vm.historial.descripcion placeholder=\"Ingrese una descripción general de la reparación\" type=text name=descripcion required style=resize:vertical></textarea><span uib-alert class=danger ng-if=\"vm.form.descripcion.$error.required && vm.form.descripcion.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.descripcion.$error.maxlength && vm.form.descripcion.$dirty\">Este campo no puede superar los 1000 caracteres.</span></div><br><br><div class=col-lg-12><br><center><button style=width:40% class=\"btn btn-primary btn-block\" ng-disabled=\"!vm.historial.personal || vm.form.$invalid\" ng-click=vm.agregarDetalleHistorial()><i class=\"fa fa-plus\"></i> Agregar bien</button></center><br></div><br><br><div><div uib-alert class=col-lg-12 ng-if=\"vm.detalles.length==0\">No hay bienes agregados</div><label class=col-lg-12 ng-if=\"vm.detalles.length>0\">Detalles</label><div class=col-lg-12 ng-if=\"vm.detalles.length>0\"><table ng-table=vm.tableParams id=table1 show-filter=true class=table><tr ng-repeat=\"detalle in $data\"><td data-title=\"\'Grupo suministro\'\" align=center>{{detalle.suministroInventariable.suministro.tipoSuministro.familiaSuministro.grupoSuministro ? detalle.suministroInventariable.suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase() : \"-\" }}</td><td data-title=\"\'Familia suministro\'\" align=center>{{detalle.suministroInventariable.suministro.tipoSuministro.familiaSuministro ? detalle.suministroInventariable.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase() : \"-\" }}</td><td data-title=\"\'Tipo suministro\'\" align=center>{{detalle.suministroInventariable.suministro.tipoSuministro ? detalle.suministroInventariable.suministro.tipoSuministro.nombre.toUpperCase() : \"-\" }}</td><td data-title=\"\'Marca\'\" align=center>{{detalle.suministroInventariable.suministro.marca ? detalle.suministroInventariable.suministro.marca.toUpperCase() : \"-\"}}</td><td data-title=\"\'N° inventario\'\" align=center>{{detalle.suministroInventariable.inventario ? detalle.suministroInventariable.inventario : \"-\"}}</td><td data-title=\"\'N° serie\'\" align=center>{{detalle.suministroInventariable.serie ? detalle.suministroInventariable.serie : \"-\"}}</td><td style=width:33% data-title=\"\'Descripción de reparación\'\">{{detalle.descripcion}}</td><td data-title=\"\'¿Foto?\'\">{{detalle.encabezadoFoto? \'Si\':\'No\'}} <button class=btn ng-if=detalle.encabezadoFoto ng-click=vm.mostrarFoto(detalle)><i class=\"fa fa-camera\"></i></button></td><td data-title=\"\'\'\"><button class=\"btn btn-danger\" ng-click=vm.quitarDetalle(detalle)><i class=\"fa fa-remove\"></i></button></td></tr></table></div></div></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\" ng-if=\"vm.modo==\'nuevo\'\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.guardar() ng-disabled=vm.form.$invalid><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div><div class=\"container-fluid row\" ng-if=\"vm.modo==\'visualizar\'\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-info btn-block\" ng-click=vm.volver()><span class=\"fa fa-arrow-left\"></span> Volver</button></div></div></div></div></div>");
$templateCache.put("app/app/main/suministro/historial-suministro/lista/lista-historial-suministro.html","<!--     <formly-form model=\"vm.user\" fields=\"vm.userFields\">\r\n  <button type=\"submit\" class=\"btn btn-primary col-sm-offset-4 col-sm-4\" ng-click=\"vm.submit(vm.user)\">Submit</button>\r\n</formly-form> --><div><form><div class=\"form-group col-lg-12\"><div class=form-group><center><button ng-click=vm.crearNuevo() class=\"btn btn-success\" style=width:50%><i class=\"fa fa-plus\"></i> NUEVA REPARACIÓN DE SUMINISTRO</button></center></div><div class=col-lg-12><label>Filtros:</label><div class=col-lg-12><div class=\"form-group col-lg-1\"><input type=checkbox ng-model=vm.buscar ng-click=vm.busqueda()></div><div class=\"form-group col-lg-11\"><button class=\"btn btn-primary\" ng-disabled=!vm.buscar ng-click=vm.abrirModalFiltros()><span class=\"fa fa-filter\"></span> Abrir filtros de suministro</button></div></div></div><div class=col-lg-12><div uib-alert type=info ng-show=vm.filtrosUsados>FILTROS APLICADOS:<div ng-repeat=\"filtro in vm.filtrosUsados\">{{vm.filtrosUsados[$index]}}</div></div><br></div><div ng-show=\"!vm.historiales.length>0 && vm.bandera\" uib-alert class=\"danger col-lg-12 form-group\">No hay historiales de reparación para los filtros indicados.</div></div><button class=\"btn btn-link\" ng-click=vm.exportToExcel() ng-show=false><span class=\"glyphicon glyphicon-share\"></span> Exportar a Excel</button><div class=col-lg-12><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.historiales.length>0\"><tr ng-repeat=\"historial in $data\"><td title=\"\'Fecha\'\" align=center sortable>{{historial.fecha | date: \'dd/MM/yyyy HH:mm\'}}</td><td title=\"\'Depósito\'\" align=center filter=\"{\'deposito.nombre\': \'text\'}\" sortable>{{historial.deposito? historial.deposito.nombre.toUpperCase() : \"-\"}}</td><td title=\"\'Personal que realizó la reparación\'\" align=center>{{historial.personal? historial.personal.toUpperCase() : \"-\"}}</td><td title=\"\'Descripción general\'\" align=center>{{historial.descripcion }}<br>{{historial.personal==null? \"(\"+historial.suministroInventariable.suministro.tipoSuministro.nombre.toUpperCase()+\" - N° Inventario: \"+historial.suministroInventariable.inventario+\". - N° serie: \"+historial.suministroInventariable.serie.toUpperCase()+\")\" : \"\"}}</td><td title=\"\'Cantidad bienes reparados\'\" align=center>{{historial.detalles.length>0? historial.detalles.length : \"1\";}}</td><td title=\"\'Acciones\'\" style=width:10% align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.mostrarInformacion(historial)><i class=\"fa fa-search\"></i> </a><a class=\"btn btn-danger\" ng-disabled=vm.bloquarPorRol() ng-click=\"vm.bloquearPorRol() || vm.eliminar(historial)\"><i class=\"fa fa-trash\"></i></a></div></td></tr></table></div></form></div>");
$templateCache.put("app/app/main/suministro/suministro/editar/editar-suministro.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=\"col-lg-6 form-group\" ng-if=\"vm.modo!=\'editar\'\"><label>Empresa</label><input type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=empresa typeahead-editable=false required> <span uib-alert ng-if=\"vm.form.empresa.$error.required && vm.form.empresa.$dirty\">Campo requerido</span></div><div class=\"col-lg-6 form-group\" ng-if=\"vm.modo==\'editar\'\"><label>Empresa</label><input type=text ng-disabled=\"vm.modo==\'editar\'\" class=form-control ng-model=vm.empresaMayus></div><div class=\"form-group col-lg-6\" ng-if=\"vm.modo!=\'editar\'\"><label>Grupo de suministro:</label><input ng-disabled=\"vm.modo==\'editar\' || !vm.empresa\" type=text ng-model=vm.grupoSuministro placeholder=\"Ingrese o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase() for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 required name=grupo typeahead-editable=false focus-on=grupoSuministro> <span uib-alert class=danger ng-show=\"(!vm.grupoSuministro.nombre && vm.form.grupoSuministro.$dirty) || (vm.form.grupoSuministro.$error.required && vm.form.grupoSuministro.$dirty)\">Este campo es requerido.</span></div><div class=\"col-lg-6 form-group\" ng-if=\"vm.modo==\'editar\'\"><label>Grupo de suministro:</label><input type=text class=form-control ng-disabled=\"vm.modo==\'editar\'\" ng-model=vm.grupoMayus></div><div class=\"form-group col-lg-6\" ng-if=\"vm.modo!=\'editar\'\"><label>Familia de suministro:</label><input ng-disabled=\"vm.modo==\'editar\' || !vm.empresa || !vm.grupoSuministro\" type=text ng-model=vm.familiaSuministro placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familiaSuministro as familiaSuministro.nombre.toUpperCase() for familiaSuministro in vm.familias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=familiaSuministro typeahead-editable=false focus-on=familiaSuministro> <span uib-alert class=danger ng-show=\"(!vm.familiaSuministro.nombre && vm.form.familiaSuministro.$dirty)|| (vm.form.familiaSuministro.$error.required && vm.form.familiaSuministro.$dirty)\">Este campo es requerido.</span></div><div class=\"col-lg-6 form-group\" ng-if=\"vm.modo==\'editar\'\"><label>Familia de suministro:</label><input type=text class=form-control ng-disabled=\"vm.modo==\'editar\'\" ng-model=vm.familiaMayus></div><div class=\"form-group col-lg-6\"><label>Tipo de suministro:</label><input ng-disabled=\"(vm.modo!=\'editar\' && (!vm.grupoSuministro || !vm.familiaSuministro))\" type=text ng-model=vm.suministro.suministro.tipoSuministro placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"tipoSuministro as tipoSuministro.nombre.toUpperCase() for tipoSuministro in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=tipoSuministro typeahead-editable=false focus-on=tipoSuministro> <span uib-alert class=danger ng-show=\"vm.form.tipoSuministro.$error.required && vm.form.tipoSuministro.$dirty\">Este campo es requerido.</span></div><div class=row><div class=\"form-group col-lg-2\"><label>¿Nuevo?: &nbsp;&nbsp;</label><br><toggle ng-model=vm.suministro.nuevo on=SI off=NO onstyle=btn-success offstyle=btn-danger></toggle></div><div class=col-lg-4><label>Precio:</label><input ng-disabled=\"vm.modo==\'editar\'\" class=form-control min=0 ng-min=0.01 ng-maxlength=15 ng-model=vm.suministro.suministro.precioUnitario placeholder=\"Precio unitario\" type=number name=precioBien required ng-pattern=/^[0-9]+(\\.[0-9]{1,2})?$/ step=0.01> <span uib-alert class=danger ng-show=\"vm.modo!=\'editar\' && vm.form.precioBien.$error.required && vm.form.precioBien.$dirty\">Campo requerido. </span><span uib-alert class=danger ng-show=\"vm.modo!=\'editar\' && vm.form.precioBien.$error.number && vm.form.precioBien.$dirty\">Valor inválido. </span><span uib-alert class=danger ng-if=\"vm.modo!=\'editar\' && vm.form.precioBien.$error.maxlength && vm.form.precioBien.$dirty\">Longitud máxima. </span><span uib-alert class=danger ng-if=\"vm.modo!=\'editar\' && vm.form.precioBien.$error.pattern && vm.form.precioBien.$dirty\">Valor inválido. </span><span uib-alert class=danger ng-if=\"vm.modo!=\'editar\' && vm.form.precioBien.$error.min && vm.form.precioBien.$dirty\">Valor negativo.</span></div><div class=col-lg-6><label>Marca:</label><input type=text name=marca ng-maxlength=100 class=form-control ng-model=vm.suministro.suministro.marca placeholder=\"Ingrese la marca\" required> <span uib-alert ng-if=\"vm.form.marca.$error.required && vm.form.marca.$dirty\">Este campo es requerido </span><span uib-alert class=danger ng-if=\"vm.form.marca.$error.maxlength && vm.form.marca.$dirty\">Este campo no puede superar los 100 caracteres.</span></div></div><div class=\"form-group col-lg-6\"><label>Ingrese el número de serie:</label><input class=form-control ng-maxlength=100 ng-model=vm.suministro.serie placeholder=\"Ingrese el número de serie\" type=text name=serie required> <span uib-alert class=danger ng-show=\"vm.form.serie.$error.required && vm.form.serie.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.serie.$error.maxlength && vm.form.serie.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><div class=\"form-group col-lg-6\"><label>Ingrese el número de inventario:</label><input class=form-control min=0 ng-min=0 ng-maxlength=9 ng-model=vm.suministro.inventario placeholder=\"Ingrese el número de inventario\" type=number name=inventario required step=1> <span uib-alert class=danger ng-show=\"vm.form.inventario.$error.required && vm.form.inventario.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-show=\"vm.form.inventario.$error.number && vm.form.inventario.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.inventario.$error.maxlength && vm.form.inventario.form.$dirty\">Este campo no puede superar los 10 caracteres. </span><span uib-alert class=danger ng-if=\"vm.form.inventario.$error.pattern && vm.form.inventario.form.$dirty\">Este campo no puede tener decimales. </span><span uib-alert class=danger ng-if=\"vm.form.inventario.$error.min && vm.form.inventario.form.$dirty\">Este campo no puede tener valores negativos.</span></div><div class=\"col-lg-12 form-group\"><label>Seleccione la sucursal de origen:</label><input type=text ng-model=vm.suministro.sucursal ng-disabled=!vm.empresa placeholder=\"Seleccione o busque la sucursal\" uib-typeahead=\"sucursal as sucursal.nombre.toUpperCase() for sucursal in vm.sucursales | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false focus-on=sucursal></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.guardar() ng-disabled=\"vm.form.$invalid || !vm.suministro.suministro.tipoSuministro.nombre\"><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/suministro/suministro/historico-suministro/historico-suministro.html","<div class=col-lg-12 ng-if=!vm.esInventariable()><div uib-alert>El suministro indicado no es correcto</div><div><button ng-click=vm.volver() class=\"btn btn-info\"><i class=\"fa fa-arrow-left\"></i> Volver</button></div></div><div class=col-lg-12 ng-if=vm.esInventariable()><div class=col-lg-12><button class=\"btn btn-link\" ng-click=vm.exportToExcel() ng-show=\"vm.movimientos.length>0\"><span class=\"glyphicon glyphicon-share\"></span> Exportar a Excel</button><h3>Suministro seleccionado:</h3><div class=\"panel panel-default panel-body\"><div class=container-fluid><table ng-table=vm.tableParamsSuministro class=table ng-show=vm.suministro.id><tr ng-repeat=\"suministro in $data\"><td title=\"\'Empresa\'\" align=center>{{suministro.suministro.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase();}}</td><td title=\"\'Grupo suministro\'\" align=center>{{suministro.suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Familia suministro\'\" align=center>{{suministro.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase();}}</td><td title=\"\'Tipo suministro\'\" align=center>{{suministro.suministro.tipoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Marca\'\" align=center>{{suministro.suministro.marca.toUpperCase();}}</td><td title=\"\'N° serie\'\" align=center>{{suministro.serie? suministro.serie.toUpperCase() : \"-\"}}</td><td title=\"\'N° inventario\'\" align=center>{{suministro.inventario ? suministro.inventario : \"-\"}}</td><td title=\"\'Sucursal anterior\'\" align=center>{{suministro.sucursal ? suministro.sucursal.nombre.toUpperCase() : \"-\"}}</td><td title=\"\'¿Activo?\'\" align=center>{{suministro.suministro.estadoSuministro==2? \"SI\" : \"NO\" }}</td><td title=\"\'¿Nuevo?\'\" align=center>{{suministro.nuevo? \"SI\":\"NO\"}}</td><td title=\"\'Ver foto\'\" align=center><div class=btn-group><a class=\"btn btn-primary\" ng-click=vm.verFoto(suministro)><i class=\"fa fa-camera\"></i></a></div></td></tr></table></div></div></div><div class=col-lg-12><h3>Movimientos históricos:</h3></div><div class=col-lg-12 ng-if=\"vm.esInventariable() && vm.movimientos.length==0\"><div uib-alert>El suministro no posee movimientos históricos</div></div><div class=col-lg-12 ng-if=\"vm.movimientos.length>0\"><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.movimientos.length>0\"><tr ng-repeat=\"movimiento in $data\"><td title=\"\'Fecha\'\" align=center>{{movimiento.fecha | date : \"dd/MM/yyyy HH:mm\"}}</td><td title=\"\'N° Movimiento\'\" align=center>{{movimiento.numeroMovimiento}}</td><td title=\"\'Tipo de movimiento\'\" align=center>{{movimiento.tipoMovimiento.nombre.toUpperCase();}}</td><td title=\"\'Empresa\'\" align=center>{{movimiento.empresa.nombre.toUpperCase();}}</td><td title=\"\'Sucursal\'\" align=center>{{movimiento.sucursal? movimiento.sucursal.nombre.toUpperCase():\"-\"}}</td><td title=\"\'Proveedor\'\" align=center>{{movimiento.proveedor? movimiento.proveedor.nombre.toUpperCase() : \"-\"}}</td><td title=\"\'Empresa Logística\'\" align=center>{{movimiento.egreso.empresaLogistica? movimiento.egreso.empresaLogistica.nombre.toUpperCase() : \"-\"}}</td><td title=\"\'Estado\'\" align=center>{{movimiento.estadoMovimiento? movimiento.estadoMovimiento.nombre.toUpperCase() : \"-\"}}</td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-disabled=\"movimiento.estadoMovimiento.id==5\" ng-click=\"movimiento.estadoMovimiento.id==5 || vm.mostrarInformacion(movimiento)\"><i class=\"fa fa-search\"></i></a></div></td></tr></table></div><div><button ng-click=vm.volver() class=\"btn btn-info\"><i class=\"fa fa-arrow-left\"></i> Volver</button></div></div>");
$templateCache.put("app/app/main/suministro/suministro/lista/lista-suministro.html","<div class=col-lg-12><form name=vm.form><div><div class=form-group><center><button ng-click=vm.crearNuevo() class=\"btn btn-success\" style=width:30%><i class=\"fa fa-plus\"></i> NUEVO SUMINISTRO</button> <button ng-click=vm.cargarDesdeExcel() class=\"btn btn-primary\" style=width:30%><i class=\"fa fa-plus\"></i> CARGAR DESDE EXCEL (.xlsx)</button></center></div><div><div class=col-lg-12><label>Buscar por N° de bien:</label></div><div class=\"col-lg-1 form-group\"><input type=radio ng-model=vm.radio value=etiqueta ng-change=vm.cambioRadio()></div><div class=\"col-lg-6 form-group\"><label>Empresa</label><input ng-disabled=\"vm.radio!=\'etiqueta\'\" type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=\"form-control input-sm\" typeahead-show-hint=true typeahead-min-length=0 name=empresa typeahead-editable=false required> <span uib-alert ng-show=\"vm.radio==\'etiqueta\' && vm.form.empresa.$error.required && vm.form.empresa.$dirty\">Campo requerido</span></div><div class=\"col-lg-5 form-group\"><label>N° de inventario</label><input ng-disabled=\"vm.radio!=\'etiqueta\' && !vm.empresa\" type=number name=etiqueta ng-model=vm.etiqueta placeholder=\"Ingrese el N° inventario\" ng-pattern=/^[0-9]{0}/ required name=etiqueta class=\"form-control input-sm\"> <span uib-alert class=danger ng-show=\"vm.radio==\'etiqueta\' && vm.form.etiqueta.$error.required && vm.form.etiqueta.$dirty\">Campo requerido. </span><span uib-alert ng-if=\"vm.radio==\'etiqueta\' && (vm.form.etiqueta.$error.pattern || vm.form.etiqueta.$error.number) && vm.form.etiqueta.$dirty\">Valor inválido.</span></div></div><div><div class=col-lg-12><label>Buscar por N° de serie:</label></div><div class=\"col-lg-1 form-group\"><input type=radio ng-model=vm.radio value=serie ng-change=vm.cambioRadio()></div><div class=\"col-lg-3 form-group\"><label>Empresa</label><input ng-disabled=\"vm.radio!=\'serie\'\" type=text ng-model=vm.empresa1 placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=\"form-control input-sm\" typeahead-show-hint=true typeahead-min-length=0 name=empresa1 typeahead-editable=false required> <span uib-alert ng-if=\"vm.radio==\'serie\' && vm.form.empresa1.$error.required && vm.form.empresa1.$dirty\">Campo requerido.</span></div><div class=\"col-lg-4 form-group\"><label>Grupo de suministro</label><input ng-disabled=\"vm.radio!=\'serie\' && !vm.empresa1.id\" type=text ng-model=vm.grupoSuministro placeholder=\"Seleccione o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase() for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=\"form-control input-sm\" typeahead-show-hint=true typeahead-min-length=0 name=grupo typeahead-editable=false required focus-on=grupoSuministro> <span uib-alert ng-if=\"vm.radio==\'serie\' && vm.empresa1.id && vm.form.grupo.$error.required && vm.form.grupo.$dirty\">Campo requerido.</span></div><div class=\"col-lg-4 form-group\"><label>Familia de suministro</label><input ng-disabled=\"vm.radio!=\'serie\' && !vm.empresa1 && !vm.grupoSuministro\" type=text ng-model=vm.familiaSuministro placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familia as familia.nombre.toUpperCase() for familia in vm.familias | filter:{nombre:$viewValue}\" class=\"form-control input-sm\" typeahead-show-hint=true typeahead-min-length=0 name=familia typeahead-editable=false required focus-on=familiaSuministro> <span uib-alert ng-if=\"vm.radio==\'serie\' && vm.form.familia.$error.required && vm.form.familia.$dirty && vm.empresa1.id && vm.grupoSuministro.id\">Campo requerido.</span></div><div class=\"col-lg-6 col-lg-offset-1 form-group\"><label>Tipo de suministro</label><input ng-disabled=\"vm.radio!=\'serie\' && !vm.empresa1.id && !vm.grupoSuministro.id && !vm.familiaSuministro.id\" type=text ng-model=vm.tipoSuministro placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"tipo as tipo.nombre.toUpperCase() for tipo in vm.tipos | filter:{nombre:$viewValue}\" class=\"form-control input-sm\" typeahead-show-hint=true typeahead-min-length=0 name=tipo typeahead-editable=false required focus-on=tipoSuministro> <span uib-alert ng-if=\"vm.radio==\'serie\' && vm.form.tipo.$error.required && vm.form.tipo.$dirty && vm.empresa1.id && vm.familiaSuministro.id && vm.grupoSuministro.id\">Campo requerido.</span></div><div class=\"col-lg-5 form-group\"><label>N° de serie completo</label><input type=text ng-disabled=\"vm.radio!=\'serie\' || !vm.tipoSuministro.id\" placeholder=\"Ingrese el N° de serie\" ng-model=vm.serie class=\"form-control input-sm\" required focus-on=serie name=serie> <span uib-alert ng-if=\"vm.radio==\'serie\' && vm.form.serie.$error.required && vm.form.serie.$dirty && vm.empresa1.id && vm.familiaSuministro.id && vm.grupoSuministro.id && vm.tipoSuministro.id\">Campo requerido.</span></div></div><div class=\"row align-items-center\"><div class=col-lg-12><label>Buscar por N° de serie parcial:</label></div><div class=\"col-lg-1 form-group\"><input type=radio ng-model=vm.radio value=serieParcial ng-change=vm.cambioRadio()></div><div class=\"col-lg-3 form-group\"><label>Empresa</label><input ng-disabled=\"vm.radio!=\'serieParcial\'\" type=text ng-model=vm.empresa2 placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=\"form-control input-sm\" typeahead-show-hint=true typeahead-min-length=0 name=empresa1 typeahead-editable=false required> <span uib-alert ng-if=\"vm.radio==\'serieParcial\' && vm.form.empresa1.$error.required && vm.form.empresa1.$dirty\">Campo requerido.</span></div><div class=\"col-lg-3 form-group\"><label>Grupo de suministro</label><input ng-disabled=\"vm.radio!=\'serieParcial\' && !vm.empresa2.id\" type=text ng-model=vm.grupoSuministroParcial placeholder=\"Seleccione o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase() for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=\"form-control input-sm\" typeahead-show-hint=true typeahead-min-length=0 name=grupoParcial typeahead-editable=false required focus-on=grupoSuministroParcial> <span uib-alert ng-if=\"vm.radio==\'serieParcial\' && vm.empresa2.id && vm.form.grupoParcial.$error.required && vm.form.grupoParcial.$dirty\">Campo requerido.</span></div><div class=\"col-lg-3 form-group\"><label>Familia de suministro</label><input ng-disabled=\"vm.radio!=\'serieParcial\' && !vm.empresa2 && !vm.grupoSuministroParcial\" type=text ng-model=vm.familiaSuministroParcial placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familia as familia.nombre.toUpperCase() for familia in vm.familias | filter:{nombre:$viewValue}\" class=\"form-control input-sm\" typeahead-show-hint=true typeahead-min-length=0 name=familiaParcial typeahead-editable=false required focus-on=familiaSuministroParcial> <span uib-alert ng-if=\"vm.radio==\'serieParcial\' && vm.form.familiaParcial.$error.required && vm.form.familiaParcial.$dirty && vm.empresa2.id && vm.grupoSuministroParcial.id\">Campo requerido.</span></div><div class=col-lg-2><label>N° de serie parcial</label><input type=text ng-disabled=\"vm.radio!=\'serieParcial\' || !vm.familiaSuministroParcial.id\" placeholder=\"Ingrese el N° de serie parcial\" ng-model=vm.serieParcial class=\"form-control input-sm\" focus-on=serieParcial required name=serieParcial> <span uib-alert ng-if=\"vm.radio==\'serieParcial\' && vm.form.serieParcial.$required && vm. form.serieParcial.$dirty && vm.empresa2.id && vm.familiaSuministroParcial.id && vm.grupoSuministroParcial.id\">Campo requerido. </span><span uib-alert ng-if=\"vm.radio==\'serieParcial\' && vm.serieParcial && vm.serieParcial.length<4\">Debe ingresar al menos 4 caracteres.</span></div></div><div class=col-lg-12><center><button class=\"btn btn-primary\" ng-click=vm.buscar(); ng-disabled=\"!(vm.radio==\'serie\' && vm.empresa1.id && vm.familiaSuministro.id && vm.grupoSuministro.id && vm.tipoSuministro.id && vm.serie) && !(vm.radio==\'etiqueta\' && vm.empresa.id && vm.etiqueta) && !(vm.radio==\'serieParcial\' && vm.empresa2.id && vm.familiaSuministroParcial.id && vm.grupoSuministroParcial && vm.serieParcial && vm.serieParcial.length>=4)\"><i class=\"fa fa-search\"></i> Buscar suministro</button></center></div></div><br><br><label class=col-lg-12 ng-if=\"vm.suministros.length>0 && vm.bandera\">Resultados de la búsqueda:</label><div class=col-lg-12 ng-if=\"vm.suministros.length==0 && vm.bandera\"><span uib-alert>No hay suministros que correspondan con la búsqueda.</span></div><div class=col-lg-12 ng-if=\"vm.suministros.length>0\"><table ng-table=vm.tableParams id=table1 show-filter=true class=table><tr ng-repeat=\"bien in $data\"><td data-title=\"\'Grupo suministro\'\" align=center>{{bien.suministro.tipoSuministro.familiaSuministro.grupoSuministro ? bien.suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase() : \"-\" }}</td><td data-title=\"\'Familia suministro\'\" align=center>{{bien.suministro.tipoSuministro.familiaSuministro ? bien.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase() : \"-\" }}</td><td data-title=\"\'Tipo suministro\'\" align=center>{{bien.suministro.tipoSuministro ? bien.suministro.tipoSuministro.nombre.toUpperCase() : \"-\" }}</td><td data-title=\"\'Marca\'\" align=center>{{bien.suministro.marca ? bien.suministro.marca.toUpperCase() : \"-\"}}</td><td data-title=\"\'N° inventario\'\" align=center>{{bien.inventario ? bien.inventario : \"-\"}}</td><td data-title=\"\'N° serie\'\" align=center>{{bien.serie ? bien.serie : \"-\"}}</td><td data-title=\"\'Precio\'\" align=center>${{bien.suministro.precioUnitario ? bien.suministro.precioUnitario : \"-\"}}</td><td data-title=\"\'Sucursal anterior\'\" align=center>{{bien.sucursal ? bien.sucursal.nombre.toUpperCase() : \"-\"}}</td><td data-title=\"\'¿Nuevo?\'\" align=center>{{bien.nuevo? \"SI\" : \"NO\" }}</td><td data-title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.mostrarInformacion(bien)><i class=\"fa fa-search\"></i> </a><a class=\"btn btn-warning\" ng-click=vm.editar(bien)><i class=\"fa fa-pencil\"></i> </a><a class=\"btn btn-primary\" ng-click=vm.verHistorial(bien)><i class=\"fa fa-history\"></i></a></div></td></tr></table></div></form></div>");
$templateCache.put("app/app/main/suministro/tipo-suministro/editar/editar-tipo-suministro.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=\"form-group col-lg-12\"><label>Ingrese el nombre del tipo de suministro:</label><input class=form-control ng-maxlength=255 ng-model=vm.tipo.nombre placeholder=\"Ingrese el nombre del tipo de suministro\" type=text name=nombre required> <span uib-alert class=danger ng-if=\"vm.form.nombre.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.nombre.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=\"form-group col-lg-6\"><label>Ingrese o busque el grupo de suministro:</label><input type=text ng-model=vm.grupo ng-change=vm.cambioGrupo(); placeholder=\"Ingrese o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase()+\' (\'+grupo.empresa.nombre.toUpperCase()+\')\' for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 required name=grupo typeahead-editable=false> <span uib-alert class=danger ng-show=\"(!vm.grupo.nombre && vm.form.$dirty)|| (vm.form.grupo.$error.required && vm.form.$dirty)\">Este campo es requerido.</span></div><div class=\"form-group col-lg-6\"><label>Ingrese o busque la familia de suministro:</label><input ng-disabled=!vm.grupo.nombre type=text ng-model=vm.tipo.familiaSuministro placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familiaSuministro as familiaSuministro.nombre.toUpperCase() for familiaSuministro in vm.familias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=familiaSuministro typeahead-editable=false focus-on=familiaSuministro> <span uib-alert class=danger ng-show=\"(!vm.tipo.familiaSuministro.nombre && vm.form.$dirty)|| (vm.form.familiaSuministro.$error.required && vm.form.$dirty)\">Este campo es requerido.</span></div><div class=\"form-group col-lg-4\"><label>Ingrese o busque la categoría de peso:</label><input type=text ng-model=vm.tipo.categoriaPeso placeholder=\"Ingrese o busque la categoría de peso\" uib-typeahead=\"categoria as categoria.nombre.toUpperCase() for categoria in vm.categorias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 required name=categoria typeahead-editable=false> <span uib-alert class=danger ng-show=\"(!vm.tipo.categoriaPeso.nombre && vm.form.$dirty)|| (vm.form.categoria.$error.required && vm.form.$dirty)\">Este campo es requerido.</span></div><div class=\"form-group col-lg-4\"><label>Ingrese el código de producto:</label><input class=form-control ng-maxlength=255 ng-model=vm.tipo.codigoProducto placeholder=\"Ingrese el código del producto\" type=text name=codigoProducto required> <span uib-alert class=danger ng-show=\"vm.form.codigoProducto.$error.required && vm.form.codigoProducto.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.codigoProducto.$error.maxlength && vm.form.codigoProducto.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=\"form-group col-lg-4\"><label>Período para tope de suministros:</label><input type=text ng-model=vm.tipo.tipoTope placeholder=\"Seleccione la periodicidad para los topes de suministros\" uib-typeahead=\"tipoTope as tipoTope.periodo.toUpperCase() for tipoTope in vm.tiposTope | filter:{periodo:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=tipoTope typeahead-editable=false focus-on=tipoTope></div><div class=\"form-group col-lg-6\" ng-if=\"vm.modo!=\'editar\'\"><label>Inventariable: &nbsp;&nbsp;&nbsp;</label><toggle ng-model=vm.tipo.inventariable on=SI off=NO onstyle=btn-success offstyle=btn-danger></toggle></div><div class=\"form-group col-lg-6\" ng-if=\"vm.modo==\'editar\'\"><label>Inventariable: &nbsp;&nbsp;&nbsp;</label>{{ vm.tipo.inventariable? \"SI\" : \"NO\"}}</div><div class=\"form-group col-lg-6\"><label>Solicitable para pedidos: &nbsp;&nbsp;&nbsp;</label><toggle ng-model=vm.tipo.solicitable on=SI off=NO onstyle=btn-success offstyle=btn-danger></toggle></div><div class=\"form-group col-lg-4\"><label>Ingrese el stock mínimo:</label><input class=form-control min=0 ng-min=0 ng-maxlength=15 ng-model=vm.tipo.stockMinimo placeholder=\"Ingrese el stock mínimo\" type=number name=stockMinimo ng-pattern=/^[0-9]{1,7}$/ required step=1> <span uib-alert class=danger ng-show=\"vm.form.stockMinimo.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-show=\"vm.form.stockMinimo.$error.number && vm.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.stockMinimo.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 15 caracteres. </span><span uib-alert class=danger ng-if=\"vm.form.stockMinimo.$error.pattern && vm.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.stockMinimo.$error.min && vm.form.$dirty\">Este campo no puede tener valores negativos.</span></div><div class=\"form-group col-lg-4\"><label>Ingrese el peso estimado unitario:</label><input class=form-control min=0 ng-min=0 ng-maxlength=15 ng-model=vm.tipo.pesoEstimado placeholder=\"Ingrese el peso estimado\" type=number name=pesoEstimado required ng-pattern=/^[0-9]+(\\.[0-9]{1,3})?$/ step=0.1> <span uib-alert class=danger ng-show=\"vm.form.pesoEstimado.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-show=\"vm.form.pesoEstimado.$error.number && vm.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.pesoEstimado.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 15 caracteres. </span><span uib-alert class=danger ng-if=\"vm.form.pesoEstimado.$error.pattern && vm.form.$dirty\">Este campo no puede tener mas de 3 decimales. </span><span uib-alert class=danger ng-if=\"vm.form.pesoEstimado.$error.min && vm.form.$dirty\">Este campo no puede tener valores negativos.</span></div><!--           <div class=\"form-group col-lg-12\">\r\n  <label>Ingrese el volumen por unidad: </label>\r\n  <input class=\"form-control\" min=\"0\" ng-min=\"0\" ng-maxlength=\"15\" ng-model=\"vm.tipo.volumenUnidad\" placeholder=\"Ingrese el volumen por unidad\" type=\"number\" name=\"volumenUnidad\" required ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" step=\"0.1\">\r\n  <span uib-alert class=\"danger\" ng-show=\"vm.form.volumenUnidad.$error.required && vm.form.$dirty\">\r\n    Este campo es requerido.\r\n  </span>\r\n  <span uib-alert class=\"danger\" ng-show=\"vm.form.volumenUnidad.$error.number && vm.form.$dirty\">\r\n    Ingrese un valor válido.\r\n  </span>\r\n  <span uib-alert class=\"danger\" ng-if=\"vm.form.volumenUnidad.$error.maxlength && vm.form.$dirty\">\r\n    Este campo no puede superar los 15 caracteres.\r\n  </span>\r\n  <span uib-alert class=\"danger\" ng-if=\"vm.form.volumenUnidad.$error.pattern && vm.form.$dirty\">\r\n    Ingrese un valor válido.\r\n  </span>\r\n  <span uib-alert class=\"danger\" ng-if=\"vm.form.volumenUnidad.$error.min && vm.form.$dirty\">\r\n    Este campo no puede tener valores negativos.\r\n  </span>\r\n</div> --><div class=\"form-group col-lg-4\"><label>Ingrese el valor unitario:</label><input class=form-control min=0 ng-min=0 ng-maxlength=15 ng-model=vm.tipo.precioActual placeholder=\"Ingrese el valor unitario\" type=number name=precioActual required ng-pattern=/^[0-9]+(\\.[0-9]{1,2})?$/ step=0.1> <span uib-alert class=danger ng-show=\"vm.form.precioActual.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-show=\"vm.form.precioActual.$error.number && vm.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.precioActual.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 15 caracteres. </span><span uib-alert class=danger ng-if=\"vm.form.precioActual.$error.pattern && vm.form.$dirty\">Este campo no puede tener mas de 2 decimales. </span><span uib-alert class=danger ng-if=\"vm.form.precioActual.$error.min && vm.form.$dirty\">Este campo no puede tener valores negativos.</span></div><div class=\"col-lg-12 row\" ng-if=vm.tipo.encabezadoFoto><center><div ng-if=vm.foto><img ng-src={{vm.foto}} class=img-thumbnail> <button class=\"btn btn-danger\" ng-click=vm.quitarFoto();><i class=\"fa fa-close\"></i></button></div><br></center></div><div class=col-lg-12><button type=button ng-if=\"vm.modo==\'editar\'\" class=\"btn btn-primary btn-block\" ng-click=vm.abrirSeleccionFoto()><span class=\"glyphicon glyphicon-camera\"></span> Seleccionar foto</button></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.guardar() ng-disabled=\"vm.form.$invalid || !vm.tipo.familiaSuministro.nombre || !vm.tipo.categoriaPeso.nombre\"><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/suministro/tipo-suministro/lista/lista-tipo-suministro.html","<!--     <formly-form model=\"vm.user\" fields=\"vm.userFields\">\r\n  <button type=\"submit\" class=\"btn btn-primary col-sm-offset-4 col-sm-4\" ng-click=\"vm.submit(vm.user)\">Submit</button>\r\n</formly-form> --><div><form><div class=\"form-group col-lg-12\"><div class=form-group><center><button ng-click=vm.crearNuevo() class=\"btn btn-success\" style=width:50%><i class=\"fa fa-plus\"></i> NUEVO TIPO DE SUMINISTRO</button></center></div><div><label>Filtrar por familia de suministro:</label><div class=col-lg-12><div class=\"form-group col-lg-1\"><input type=checkbox ng-model=vm.buscar ng-click=vm.busqueda()></div><div class=\"form-group col-lg-5\"><input ng-disabled=!vm.buscar type=text ng-model=vm.grupo placeholder=\"Seleccione o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase()+\' (\'+grupo.empresa.nombre.toUpperCase()+\')\' for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-editable=false typeahead-min-length=0></div><div class=\"form-group col-lg-5\"><input focus-on=familiaSuministro ng-disabled=\"!vm.buscar || !vm.grupo.nombre\" type=text ng-model=vm.familiaSuministro placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familiaSuministro as familiaSuministro.nombre.toUpperCase() for familiaSuministro in vm.familias | filter:{nombre:$viewValue}\" typeahead-editable=false class=form-control typeahead-show-hint=true typeahead-min-length=0></div><div class=\"col-lg-1 form-group\"><button ng-disabled=\"!vm.buscar || !vm.grupo.nombre || !vm.familiaSuministro.nombre\" class=\"btn btn-primary\" ng-click=vm.filtrar()><span class=\"fa fa-search\"></span> Buscar</button></div></div></div><br><div ng-show=\"!vm.tipos.length>0 && vm.bandera\" uib-alert class=\"danger col-lg-12 form-group\">No hay suministros para los filtros indicados.</div></div><button class=\"btn btn-link\" ng-click=vm.exportToExcel() ng-show=\"vm.tipos.length>0\"><span class=\"fa fa-file-excel-o\"></span> Exportar a Excel</button> <button class=\"btn btn-link\" ng-click=vm.reportePdf() ng-show=\"vm.tipos.length>0\"><span class=\"fa fa-file-pdf-o\"></span> Exportar a PDF</button><div class=col-lg-12><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.tipos.length>0\"><tr ng-repeat=\"tipos in $data\"><td title=\"\'Empresa\'\" align=center data-sortable=\"\'familiaSuministro.grupoSuministro.empresa.nombre\'\">{{tipos.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase();}}</td><td title=\"\'Grupo de suministro\'\" align=center data-sortable=\"\'familiaSuministro.grupoSuministro.nombre\'\">{{tipos.familiaSuministro.grupoSuministro.nombre.toUpperCase()}}</td><td title=\"\'Familia de suministro\'\" align=center data-sortable=\"\'familiaSuministro.nombre\'\">{{tipos.familiaSuministro.nombre.toUpperCase();}}</td><td title=\"\'Nombre\'\" align=center filter=\"{ nombre: \'text\'}\" data-sortable=\"\'nombre\'\">{{tipos.nombre.toUpperCase();}}</td><td title=\"\'Código\'\" align=center filter=\"{codigoProducto: \'text\'}\" data-sortable=\"\'codigoProducto\'\">{{tipos.codigoProducto.toUpperCase();}}</td><!-- 			        <td title=\"\'Categoría de peso\'\" align=\"center\">\r\n    {{tipos.categoriaPeso.nombre.toUpperCase();}}\r\n</td>\r\n<td title=\"\'Peso estimado\'\"  data-sortable=\"\'pesoEstimado\'\">\r\n    {{tipos.pesoEstimado + \" Kg\"}}\r\n</td> --><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.mostrarInformacion(tipos)><i class=\"fa fa-search\"></i> </a><a class=\"btn btn-warning\" ng-click=vm.editar(tipos)><i class=\"fa fa-pencil\"></i> </a><a class=\"btn btn-danger\" ng-disabled=vm.bloquearPorRol(); ng-click=\"vm.bloquearPorRol() || vm.eliminar(tipos)\"><i class=\"fa fa-trash\"></i></a></div></td></tr></table></div></form></div>");
$templateCache.put("app/app/main/ubicaciones/cambiar-ubicacion/buscar-suministro-cambiar-ubicacion/buscar-suministro-cambiar-ubicacion.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default panel-body\"><div class=form-group><label>Depósito</label><input type=text ng-model=vm.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=deposito typeahead-editable=false required></div><div class=col-lg-12 ng-if=vm.deposito.id><div class=col-lg-12><label>Buscar por N° de bien (sólo para inventariables):</label></div><div class=\"col-lg-1 form-group\"><input type=radio ng-model=vm.radio value=etiqueta ng-change=vm.cambioRadio()></div><div class=\"col-lg-6 form-group\"><label>Empresa</label><input ng-disabled=\"vm.radio!=\'etiqueta\'\" type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=empresa typeahead-editable=false required> <span uib-alert ng-show=\"vm.radio==\'etiqueta\' && vm.form.empresa.$error.required && vm.form.empresa.$dirty\">Campo requerido</span></div><div class=\"col-lg-5 form-group\"><label>N° de inventario</label><input ng-disabled=\"vm.radio!=\'etiqueta\' && !vm.empresa\" type=number name=etiqueta ng-model=vm.etiqueta placeholder=\"Ingrese el N° inventario\" ng-pattern=/^[0-9]{0}/ required name=etiqueta class=form-control> <span uib-alert class=danger ng-show=\"vm.radio==\'etiqueta\' && vm.form.etiqueta.$error.required && vm.form.etiqueta.$dirty\">Campo requerido. </span><span uib-alert ng-if=\"vm.radio==\'etiqueta\' && (vm.form.etiqueta.$error.pattern || vm.form.etiqueta.$error.number) && vm.form.etiqueta.$dirty\">Valor inválido.</span></div></div><div class=\"col-lg-12 row align-items-center\" ng-if=vm.deposito.id><div class=col-lg-12><label>Buscar por Tipo de suministro:</label></div><div class=\"col-lg-1 form-group\"><input type=radio ng-model=vm.radio value=tipo ng-change=vm.cambioRadio()></div><div class=\"col-lg-11 form-group\"><div class=col-lg-12><div class=col-lg-4><label>Empresa</label><input ng-disabled=\"vm.radio!=\'tipo\'\" type=text ng-model=vm.empresa1 placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=empresa1 typeahead-editable=false required> <span uib-alert ng-if=\"vm.radio==\'tipo\' && vm.form.empresa1.$error.required && vm.form.empresa1.$dirty\">Campo requerido.</span></div><div class=col-lg-4><label>Grupo de suministro</label><input ng-disabled=\"vm.radio!=\'tipo\' && !vm.empresa1.id\" type=text ng-model=vm.grupoSuministro placeholder=\"Seleccione o busque el grupo de suministro\" uib-typeahead=\"grupo as grupo.nombre.toUpperCase() for grupo in vm.grupos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=grupo typeahead-editable=false required focus-on=grupoSuministro> <span uib-alert ng-if=\"vm.radio==\'tipo\' && vm.empresa1.id && vm.form.grupo.$error.required && vm.form.grupo.$dirty\">Campo requerido.</span></div><div class=col-lg-4><label>Familia de suministro</label><input ng-disabled=\"vm.radio!=\'tipo\' && !vm.empresa1 && !vm.grupoSuministro\" type=text ng-model=vm.familiaSuministro placeholder=\"Seleccione o busque la familia de suministro\" uib-typeahead=\"familia as familia.nombre.toUpperCase() for familia in vm.familias | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=familia typeahead-editable=false required focus-on=familiaSuministro> <span uib-alert ng-if=\"vm.radio==\'tipo\' && vm.form.familia.$error.required && vm.form.familia.$dirty && vm.empresa1.id && vm.grupoSuministro.id\">Campo requerido.</span></div></div><br><br><br><br><div class=col-lg-12><div class=col-lg-12><label>Tipo de suministro</label><input ng-disabled=\"vm.radio!=\'tipo\' && !vm.empresa1.id && !vm.grupoSuministro.id && !vm.familiaSuministro.id\" type=text ng-model=vm.tipoSuministro placeholder=\"Seleccione o busque el tipo de suministro\" uib-typeahead=\"tipo as tipo.nombre.toUpperCase() for tipo in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=tipo typeahead-editable=false required focus-on=tipoSuministro> <span uib-alert ng-if=\"vm.radio==\'tipo\' && vm.form.tipo.$error.required && vm.form.tipo.$dirty && vm.empresa1.id && vm.familiaSuministro.id && vm.grupoSuministro.id\">Campo requerido.</span></div></div></div></div><div class=col-lg-12 ng-if=vm.deposito.id><center><button class=\"btn btn-primary\" ng-click=vm.buscar(); ng-disabled=\"!(vm.radio==\'tipo\' && vm.empresa1.id && vm.familiaSuministro.id && vm.grupoSuministro.id && vm.tipoSuministro.id) && !(vm.radio==\'etiqueta\' && vm.empresa.id && vm.etiqueta)\"><i class=\"fa fa-search\"></i> Buscar suministros</button></center></div></div><br><br><label class=col-lg-12 ng-if=\"vm.suministros.length>0 && vm.bandera\">Resultados de la búsqueda:</label><div class=col-lg-12 ng-if=\"vm.suministros.length==0 && vm.bandera\"><span uib-alert>No hay suministros que correspondan con la búsqueda.</span></div><div class=col-lg-12 ng-if=\"vm.suministros.length>0\"><table ng-table=vm.tableParams id=table1 show-filter=true class=table><tr ng-repeat=\"bien in $data\"><td data-title=\"\'Grupo suministro\'\" align=center>{{bien.suministro.tipoSuministro.familiaSuministro.grupoSuministro ? bien.suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase() : \"-\" }}</td><td data-title=\"\'Familia suministro\'\" align=center>{{bien.suministro.tipoSuministro.familiaSuministro ? bien.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase() : \"-\" }}</td><td data-title=\"\'Tipo suministro\'\" align=center>{{bien.suministro.tipoSuministro ? bien.suministro.tipoSuministro.nombre.toUpperCase() : \"-\" }}</td><td data-title=\"\'Marca\'\" align=center>{{bien.suministro.marca ? bien.suministro.marca.toUpperCase() : \"-\"}}</td><td data-title=\"\'N° inventario\'\" align=center>{{bien.inventario ? bien.inventario : \"-\"}}</td><td data-title=\"\'N° serie\'\" align=center>{{bien.serie ? bien.serie : \"-\"}}</td><td data-title=\"\'Precio\'\" align=center>${{bien.suministro.precioUnitario ? bien.suministro.precioUnitario : \"-\"}}</td><td data-title=\"\'¿Nuevo?\'\" align=center>{{bien.nuevo==\"-\" ? \"-\" : bien.nuevo? \"SI\" : \"NO\" }}</td><td title=\"\'Cantidad\'\" align=center>{{bien.suministro.cantidad }}</td><td style=width:35% title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(bien) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(bien)}}</div></div></td><td data-title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.mostrarInformacion(bien)><i class=\"fa fa-search\"></i> </a><a class=\"btn btn-primary\" ng-click=vm.irACambiarUbicacionSuministro(bien)><i class=\"fa fa-exchange\"></i></a></div></td></tr></table></div></form></div>");
$templateCache.put("app/app/main/ubicaciones/cambiar-ubicacion/cambiar-ubicacion-caja-cerrada/cambiar-ubicacion-caja-cerrada.html","<div class=col-lg-12><form name=vm.form><div class=\"panel panel-default panel-body\"><div class=\"form-group col-lg-6\"><label>Depósito:</label><input ng-disabled=\"vm.detallesInventariablesAgrupados.length>0\" type=text ng-model=vm.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false name=deposito required> <span uib-alert class=danger ng-show=\"vm.form.deposito.$error.required && vm.form.deposito.$dirty\">Este campo es requerido.</span></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input ng-disabled=\"vm.detallesInventariablesAgrupados.length>0\" type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la Empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 required name=empresa typeahead-editable=false focus-on=empresa> <span uib-alert class=danger ng-show=\"vm.form.empresa.$error.required && vm.form.empresa.$dirty\">Este campo es requerido.</span></div><div class=col-lg-12><center><button ng-if=\"vm.detallesInventariablesAgrupados.length==0\" class=\"btn btn-primary\" ng-click=vm.abrirModalAgregarCajas(); ng-disabled=\"!vm.deposito.id || !vm.empresa.id\"><i class=\"fa fa-search\"></i> Buscar caja cerrada</button> <button ng-if=\"vm.detallesInventariablesAgrupados.length>0\" class=\"btn btn-warning\" ng-click=vm.elegirOtraCaja(); ng-disabled=\"!vm.deposito.id || !vm.empresa.id\"><i class=\"fa fa-exchange\"></i> Cambiar selección</button></center></div></div><div class=\"panel panel-default panel-body\" ng-if=\"vm.detallesInventariablesAgrupados.length>0\"><h5 ng-if=\"vm.detallesInventariablesAgrupados.length>0\">Caja seleccionada:</h5><div class=col-lg-12><table ng-table=vm.tableParamsInventariableAgrupado class=\"table table-hover\" ng-init=\"agrupado.$hideRows = true\" show-group=false><tr class=ng-table-group ng-repeat-start=\"agrupado in $data\"><td colspan=6><a href=\"\" ng-click=\"agrupado.$hideRows = !agrupado.$hideRows\"><span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': agrupado.$hideRows, \'glyphicon-chevron-down\': !agrupado.$hideRows }\"></span> Caja cerrada N°: {{agrupado.numeroCaja}}<br>Tipo de suministro: {{ agrupado.tipoSuministro.nombre.toUpperCase() }}<br>Familia de suministro: {{ agrupado.tipoSuministro.familiaSuministro.nombre.toUpperCase();}}</a></td><td title=\"Cantidad total\">Cantidad total: {{agrupado.cantidad}}</td><td title=\"Precio total\">Precio total: <b>${{agrupado.precioTotal}}</b></td></tr><tr ng-hide=agrupado.$hideRows ng-repeat=\"detalle in agrupado.detalles\" ng-repeat-end><td title=\"\'Marca\'\" align=center>{{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'N° serie\'\" sortable align=center>{{detalle.suministroInventariable.serie ? detalle.suministroInventariable.serie : \"-\" }}</td><td title=\"\'N° inventario\'\" sortable align=center>{{detalle.suministroInventariable.inventario ? detalle.suministroInventariable.inventario : \"-\" }}</td><td title=\"\'Precio\'\" align=center>${{detalle.suministro.precioUnitario}}</td></tr></table></div><div class=col-lg-12><h5>Ubicación Actual:</h5></div><div class=form-group><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(vm.ubicacion) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(vm.ubicacion)}}</div></div></div><br><div class=col-lg-12 ng-if=\"vm.detallesInventariablesAgrupados.length>0\"><center><div><button style=width:60% class=\"btn btn-primary\" ng-click=vm.asignarIndividual()><i class=\"fa fa-map-marker\"></i> Buscar ubicación nueva</button></div></center></div><div ng-if=\"vm.detallesInventariablesAgrupados.length>0\"><div class=col-lg-12 ng-if=!vm.nuevaUbicacion.id><br><br><div uib-alert>Todavía no seleccionó una nueva ubicación</div></div><div class=col-lg-12 ng-if=vm.nuevaUbicacion.id><h5>Nueva ubicación elegida:</h5><div class=col-lg-10><div class=\"form-group has-feedback\"><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(vm.nuevaUbicacion) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(vm.nuevaUbicacion)}}</div></div></div><div class=col-lg-2><label>¿Ocupar?</label><input type=checkbox ng-model=vm.ocupar></div></div><div class=col-lg-12 ng-if=vm.nuevaUbicacion.id><center><button ng-click=vm.actualizarUbicacion(); ng-disabled=!vm.nuevaUbicacion.id class=\"btn btn-success\" style=width:30%><i class=\"fa fa-exchange\"></i> Actualizar ubicación</button></center><br></div></div></form></div>");
$templateCache.put("app/app/main/ubicaciones/cambiar-ubicacion/cambiar-ubicacion-suministro/cambiar-ubicacion-suministro.html","<div class=col-lg-12 ng-if=\"!vm.comprobarSuministro() && !vm.noUbicacion\"><div uib-alert>El suministro indicado no es correcto</div><div></div></div><div class=col-lg-12 ng-if=vm.noUbicacion><div uib-alert>El suministro no posee ubicación</div><div></div></div><div class=col-lg-12 ng-if=\"vm.comprobarSuministro() && vm.ubicacion.id\"><div><center><button ng-click=vm.volver(); class=\"btn btn-info\" style=width:30%><i class=\"fa fa-arrow-left\"></i> Volver</button> <button ng-click=vm.actualizarUbicacion(); ng-disabled=!vm.nuevaUbicacion.id class=\"btn btn-success\" style=width:30%><i class=\"fa fa-exchange\"></i> Actualizar ubicación</button></center></div><div class=col-lg-12 ng-if=vm.inventariable><h3>Suministro seleccionado:</h3><div class=\"panel panel-default panel-body\"><div class=container-fluid><table ng-table=vm.tableParamsSuministro class=table ng-show=vm.suministro.id><tr ng-repeat=\"suministro in $data\"><td title=\"\'Empresa\'\" align=center>{{suministro.suministro.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase();}}</td><td title=\"\'Grupo suministro\'\" align=center>{{suministro.suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Familia suministro\'\" align=center>{{suministro.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase();}}</td><td title=\"\'Tipo suministro\'\" align=center>{{suministro.suministro.tipoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Marca\'\" align=center>{{suministro.suministro.marca.toUpperCase();}}</td><td title=\"\'N° serie\'\" align=center ng-if=vm.inventariable>{{suministro.serie? suministro.serie.toUpperCase() : \"-\"}}</td><td title=\"\'N° inventario\'\" align=center ng-if=vm.inventariable>{{suministro.inventario ? suministro.inventario : \"-\"}}</td><!-- 				        <td title=\"\'¿Activo?\'\" align=\"center\">\r\n    {{suministro.suministro.estadoSuministro==2? \"SI\" : \"NO\" }}\r\n</td> --><td title=\"\'¿Nuevo?\'\" align=center ng-if=vm.inventariable>{{suministro.nuevo? \"SI\":\"NO\"}}</td><td title=\"\'Ver información\'\" align=center><div class=btn-group><a class=\"btn btn-primary\" ng-click=vm.mostrarInformacionSuministro()><i class=\"fa fa-search\"></i></a></div></td></tr></table></div></div></div><div class=col-lg-12 ng-if=!vm.inventariable><h3>Suministro seleccionado:</h3><div class=\"panel panel-default panel-body\"><div class=container-fluid><table ng-table=vm.tableParamsSuministro class=table ng-show=vm.suministro.id><tr ng-repeat=\"suministro in $data\"><td title=\"\'Empresa\'\" align=center>{{suministro.tipoSuministro.familiaSuministro.grupoSuministro.empresa.nombre.toUpperCase();}}</td><td title=\"\'Grupo suministro\'\" align=center>{{suministro.tipoSuministro.familiaSuministro.grupoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Familia suministro\'\" align=center>{{suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase();}}</td><td title=\"\'Tipo suministro\'\" align=center>{{suministro.tipoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Marca\'\" align=center>{{suministro.marca.toUpperCase();}}</td><td title=\"\'Ver información\'\" align=center><div class=btn-group><a class=\"btn btn-primary\" ng-click=vm.mostrarInformacionSuministro()><i class=\"fa fa-search\"></i></a></div></td></tr></table></div></div></div><div class=col-lg-12><h3>Ubicación Actual:</h3></div><div class=col-lg-12 ng-if=vm.comprobarSuministro()><div class=\"form-group has-feedback\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(vm.ubicacion) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(vm.ubicacion)}}</div></div><br><div class=col-lg-12><center><div><button style=width:60% class=\"btn btn-primary\" ng-click=vm.asignarIndividual()><i class=\"fa fa-map-marker\"></i> Buscar ubicación nueva</button></div></center></div></div><div class=col-lg-12 ng-if=!vm.nuevaUbicacion.id><br><br><div uib-alert>Todavía no seleccionó una nueva ubicación</div></div><div class=col-lg-12 ng-if=vm.nuevaUbicacion.id><br><br><div class=col-lg-10><div class=\"form-group has-feedback\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(vm.nuevaUbicacion) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(vm.nuevaUbicacion)}}</div></div></div><div class=col-lg-2><label>¿Ocupar?</label><input type=checkbox ng-model=vm.ocupar></div></div></div>");
$templateCache.put("app/app/main/ubicaciones/estante/lista/lista-estante-ubicaciones.html","<div><form><div class=form-group><center><button ng-click=vm.crearNuevo() class=\"btn btn-success\" style=width:30%><i class=\"fa fa-plus\"></i> NUEVA ESTANTERÍA</button> <button ng-click=vm.crearNuevaJerarquia() class=\"btn btn-primary\" style=width:30%><i class=\"fa fa-sitemap\"></i> NUEVA ESTANTERÍA COMPLETA</button></center></div><div class=col-lg-12><i class=\"fa-sitemap fa\"></i> <button class=\"btn btn-link\" ng-click=vm.irVistaDeposito()>Depósito: {{vm.estructura.pasillo.nave.deposito.nombre.toUpperCase();}}</button> / <button class=\"btn btn-link\" ng-click=vm.irVistaNave()>Nave: {{vm.estructura.pasillo.nave.nombre.toUpperCase();}}</button> / <button class=\"btn btn-link\" ng-click=vm.irVistaPasillo()>Pasillo N° {{vm.estructura.pasillo.numeroPasillo}}</button> / <i>Estructura N° {{vm.estructura.identificadorEstructura}}</i><br><br></div><div class=col-lg-12 ng-if=\"vm.estantes.length==0\"><span uib-alert>La estructura no posee estanterías.</span></div><div class=col-lg-12 ng-if=\"vm.estantes.length>0\"><div class=borde><div ng-repeat=\"estante in vm.estantes | orderBy:\'numeroEstante\'\"><div ng-if=\"estante.borrado===false\"><div class=\"estantes-vista btn btn-danger\" style=\"font-weight: bold\" ng-click=\"vm.verPlanoNiveles(estante); $event.stopPropagation();\" ng-style=vm.claseEstante(estante);>Estantería N° {{estante.numeroEstante}}<div ng-repeat=\"nivel in estante.niveles | orderBy:\'numeroNivel\' : true\"><div ng-if=\"nivel.borrado===false\"><div class=\"nivel-vista col-xs-12 btn btn-primary\" ng-click=\"vm.verPlanoUbicaciones(nivel); $event.stopPropagation();;\" ng-style=vm.claseNivel(estante);>Estante N° {{nivel.numeroNivel}}</div></div></div></div></div></div></div><br><br></div><div class=col-lg-12 ng-if=\"vm.estantes.length>0\"><p>Listado de estanterías:</p></div><div class=col-lg-12 ng-if=\"vm.estantes.length>0\"><table id=table1 ng-table=vm.tableParams class=table show-filter=true ng-show=vm.estantes><tr ng-repeat=\"estante in $data | orderBy:\'numeroEstante\'\"><td title=\"\'Número de estantería\'\" align=center filter=\"{ numeroEstante: \'text\'}\">{{estante.numeroEstante}}</td><td title=\"\'Cantidad de estantes\'\" align=center>{{vm.util.contarNoBorrados(estante.niveles);}} <a class=\"btn btn-success\" ng-click=vm.crearNuevoHijo(estante)><i class=\"fa fa-plus\"></i></a></td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.mostrarInformacion(estante)><i class=\"fa fa-search\"></i> </a><!-- 							<a class=\"btn btn-warning\" ng-disabled=\"true\" ng-click=\"true || vm.editar(estante)\">\r\n	<i class=\"fa fa-pencil\"></i>\r\n</a> --> <a class=\"btn btn-danger\" ng-click=vm.eliminar(estante)><i class=\"fa fa-remove\"></i></a></div></td></tr></table></div><div class=\"col-lg-12 form-group\"><a class=\"btn btn-primary\" ng-click=vm.volver()><i class=\"fa fa-arrow-circle-left\"></i> Volver</a></div></form></div>");
$templateCache.put("app/app/main/ubicaciones/estante/editar/editar-estante-ubicaciones.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><i class=\"fa-sitemap fa\"></i> <i>Depósito: {{vm.estructura.pasillo.nave.deposito.nombre.toUpperCase();}} </i>/ <i>Nave: {{vm.estructura.pasillo.nave.nombre.toUpperCase();}} </i>/ <i>Pasillo N° {{vm.estructura.pasillo.numeroPasillo}} </i>/ <i>Estructura N° {{vm.estructura.identificadorEstructura}}</i><br><br></div><div class=form-group><label>Número de Estantería:</label><input class=form-control ng-maxlength=2 ng-disabled=true ng-model=vm.estante.numeroEstante placeholder=\"Número de Estantería\" type=number name=numeroEstante ng-pattern=/^[1-9][0-9]{0}/ required> <span uib-alert class=danger ng-if=\"vm.form.numeroEstante.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"(vm.form.numeroEstante.$error.number || vm.form.numeroEstante.$error.pattern) && vm.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.numeroEstante.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 3 caracteres.</span></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.guardar() ng-disabled=vm.form.$invalid><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/ubicaciones/estante/nueva-jerarquia/nueva-jerarquia.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><i class=\"fa-sitemap fa\"></i> <i>Depósito: {{vm.estructura.pasillo.nave.deposito.nombre.toUpperCase();}} </i>/ <i>Nave: {{vm.estructura.pasillo.nave.nombre.toUpperCase();}} </i>/ <i>Pasillo N° {{vm.estructura.pasillo.numeroPasillo}} </i>/ <i>Estructura N° {{vm.estructura.identificadorEstructura}}</i><br><br><div class=form-group><label>Ingrese cuántos estantes tendrá la nueva estantería:</label><input class=form-control min=0 ng-min=0 ng-maxlength=1 ng-model=vm.cantidad.niveles placeholder=\"Cantidad de estantes\" type=number name=niveles required ng-pattern=/^-?[1-9][^\\.]*$/ step=1> <span uib-alert class=danger ng-show=\"vm.form.niveles.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-show=\"vm.form.niveles.$error.number && vm.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.niveles.$error.maxlength && vm.form.$dirty\">Ingrese un número mayor a 1 y menor a 10. </span><span uib-alert class=danger ng-if=\"vm.form.niveles.$error.pattern && vm.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.niveles.$error.min && vm.form.$dirty\">Este campo no puede tener valores negativos.</span></div><div class=form-group ng-if=vm.cantidad.niveles><label>Ingrese cuántas ubicaciones tendrá cada estante de la nueva estantería:</label><input class=form-control min=0 ng-min=0 max=20 ng-model=vm.cantidad.ubicaciones placeholder=\"Cantidad de ubicaciones\" type=number name=ubicaciones required ng-pattern=/^-?[1-9][^\\.]*$/ step=1> <span uib-alert class=danger ng-show=\"vm.form.ubicaciones.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-show=\"vm.form.ubicaciones.$error.number && vm.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.ubicaciones.$error.max && vm.form.$dirty\">Ingrese un número mayor a 1 y menor a 21. </span><span uib-alert class=danger ng-if=\"vm.form.ubicaciones.$error.pattern && vm.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.ubicaciones.$error.min && vm.form.$dirty\">Este campo no puede tener valores negativos.</span></div></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.crearJerarquia() ng-disabled=vm.form.$invalid><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/ubicaciones/estructura/lista/lista-estructura-ubicaciones.html","<div><form><div class=form-group><center><button ng-click=vm.crearNuevo() class=\"btn btn-success\" style=width:30%><i class=\"fa fa-plus\"></i> NUEVA ESTRUCTURA</button> <button ng-click=vm.crearNuevaJerarquia() class=\"btn btn-primary\" style=width:30%><i class=\"fa fa-sitemap\"></i> NUEVA ESTRUCTURA COMPLETA</button></center></div><div class=col-lg-12><i class=\"fa-sitemap fa\"></i> <button class=\"btn btn-link\" ng-click=vm.irVistaDeposito()>Depósito: {{vm.pasillo.nave.deposito.nombre.toUpperCase();}}</button> / <button class=\"btn btn-link\" ng-click=vm.irVistaNave()>Nave: {{vm.pasillo.nave.nombre.toUpperCase();}}</button> / <i>Pasillo N° {{vm.pasillo.numeroPasillo}}</i><br><br></div><div class=col-lg-12 ng-if=\"vm.estructuras.length==0\"><span uib-alert class=primary>El pasillo no posee estructuras.</span></div><div class=col-lg-12 ng-if=\"vm.estructuras.length>0\"><div class=\"borde flex-columnas\"><div ng-repeat=\"estructura in vm.estructuras | orderBy:\'identificadorEstructura*1\'\"><div ng-if=\"estructura.borrado===false\"><div class=\"estructura-vista btn btn-warning\" style=\"font-weight: bold\" ng-click=\"vm.verPlanoEstantes(estructura); $event.stopPropagation();\">Estructura N°<br>{{estructura.identificadorEstructura}}<div ng-repeat=\"estante in estructura.estantes | orderBy:\'numeroEstante*1\'\"><div ng-if=\"estante.borrado===false\"><div class=\"estante-vista col-xs-12 btn btn-danger\" ng-click=\"vm.verPlanoNiveles(estante); $event.stopPropagation();\" ng-style=vm.claseEstante(estructura);>Estantería N° {{estante.numeroEstante}}</div></div></div></div></div></div></div><br><br></div><div class=col-lg-12 ng-if=\"vm.estructuras.length>0\"><p>Listado de estructuras:</p></div><div class=col-lg-12 ng-if=\"vm.estructuras.length>0\"><table id=table1 ng-table=vm.tableParams class=table show-filter=true ng-show=vm.estructuras><tr ng-repeat=\"estructura in $data | orderBy:\'identificadorEstructura*1\'\"><td title=\"\'Número de estructura\'\" align=center filter=\"{ identificadorEstructura: \'text\'}\">{{estructura.identificadorEstructura}}</td><td title=\"\'Cantidad de estantes\'\" align=center>{{vm.util.contarNoBorrados(estructura.estantes);}} <a class=\"btn btn-success\" ng-click=vm.crearNuevoHijo(estructura)><i class=\"fa fa-plus\"></i></a></td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.mostrarInformacion(estructura)><i class=\"fa fa-search\"></i> </a><!-- 							<a class=\"btn btn-warning\" ng-disabled=\"true\" ng-click=\"true || vm.editar(estructura)\">\r\n	<i class=\"fa fa-pencil\"></i>\r\n</a> --> <a class=\"btn btn-danger\" ng-click=vm.eliminar(estructura)><i class=\"fa fa-remove\"></i></a></div></td></tr></table></div><div class=\"col-lg-12 form-group\"><a class=\"btn btn-primary\" ng-click=vm.volver()><i class=\"fa fa-arrow-circle-left\"></i> Volver</a></div></form></div>");
$templateCache.put("app/app/main/ubicaciones/estructura/editar/editar-estructura-ubicaciones.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><i class=\"fa-sitemap fa\"></i> <i>Depósito: {{vm.pasillo.nave.deposito.nombre.toUpperCase();}} </i>/ <i>Nave: {{vm.pasillo.nave.nombre.toUpperCase();}} </i>/ <i>Pasillo N° {{vm.pasillo.numeroPasillo}}</i><br><br></div><div class=form-group><label>Número de Estructura:</label><input class=form-control ng-maxlength=2 ng-disabled=true ng-model=vm.estructura.identificadorEstructura placeholder=\"Número de estructura\" type=number name=identificadorEstructura ng-pattern=/^[1-9][0-9]{0}/ required> <span uib-alert class=danger ng-if=\"vm.form.identificadorEstructura.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.identificadorEstructura.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 3 caracteres. </span><span uib-alert class=danger ng-if=\"(vm.form.identificadorEstructura.$error.number || vm.form.identificadorEstructura.$error.pattern) && vm.form.$dirty\">Ingrese un valor válido.</span></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.guardar() ng-disabled=vm.form.$invalid><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/ubicaciones/estructura/nueva-jerarquia/nueva-jerarquia.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><i class=\"fa-sitemap fa\"></i> <i>Depósito: {{vm.pasillo.nave.deposito.nombre.toUpperCase();}} </i>/ <i>Nave: {{vm.pasillo.nave.nombre.toUpperCase();}} </i>/ <i>Pasillo N° {{vm.pasillo.numeroPasillo}}</i><br><br><div class=form-group><label>Ingrese cuántas estanterías tendrá la nueva estructura:</label><input class=form-control min=0 ng-min=0 max=20 ng-model=vm.cantidad.estantes placeholder=\"Cantidad de estanterías\" type=number name=estantes required ng-pattern=/^-?[1-9][^\\.]*$/ step=1> <span uib-alert class=danger ng-show=\"vm.form.estantes.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-show=\"vm.form.estantes.$error.number && vm.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.estantes.$error.max && vm.form.$dirty\">Ingrese un número mayor a 1 y menor a 21. </span><span uib-alert class=danger ng-if=\"vm.form.estantes.$error.pattern && vm.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.estantes.$error.min && vm.form.$dirty\">Este campo no puede tener valores negativos.</span></div><div class=form-group ng-if=vm.cantidad.estantes><label>Ingrese cuántos estantes tendrá cada estantería de la nueva estructura:</label><input class=form-control min=0 ng-min=0 ng-maxlength=1 ng-model=vm.cantidad.niveles placeholder=\"Cantidad de estantes\" type=number name=niveles required ng-pattern=/^-?[1-9][^\\.]*$/ step=1> <span uib-alert class=danger ng-show=\"vm.form.niveles.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-show=\"vm.form.niveles.$error.number && vm.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.niveles.$error.maxlength && vm.form.$dirty\">Ingrese un número mayor a 1 y menor a 10. </span><span uib-alert class=danger ng-if=\"vm.form.niveles.$error.pattern && vm.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.niveles.$error.min && vm.form.$dirty\">Este campo no puede tener valores negativos.</span></div><div class=form-group ng-if=\"vm.cantidad.niveles && vm.cantidad.estantes\"><label>Ingrese cuántas ubicaciones tendrá cada estante, para cada estantería, de la nueva estructura:</label><input class=form-control min=0 ng-min=0 max=20 ng-model=vm.cantidad.ubicaciones placeholder=\"Cantidad de ubicaciones\" type=number name=ubicaciones required ng-pattern=/^-?[1-9][^\\.]*$/ step=1> <span uib-alert class=danger ng-show=\"vm.form.ubicaciones.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-show=\"vm.form.ubicaciones.$error.number && vm.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.ubicaciones.$error.max && vm.form.$dirty\">Ingrese un número mayor a 1 y menor a 21. </span><span uib-alert class=danger ng-if=\"vm.form.ubicaciones.$error.pattern && vm.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.ubicaciones.$error.min && vm.form.$dirty\">Este campo no puede tener valores negativos.</span></div></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.crearJerarquia() ng-disabled=vm.form.$invalid><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/ubicaciones/nave/lista/lista-nave-ubicaciones.html","<div><form><div class=form-group><center><!-- 				<button ng-click=\"vm.nuevasUbicaciones()\" class=\"btn btn-success\" style=\"width:50%\">\r\n	<i class=\"fa fa-plus\"></i>\r\n	NUEVAS UBICACIONES \r\n</button>\r\n			</center> --></center></div><div class=col-lg-12><i>Depósito: {{vm.deposito.nombre.toUpperCase();}}</i></div><div class=col-lg-12><table id=table1 ng-table=vm.tableParams class=table show-filter=true ng-show=vm.naves><tr ng-repeat=\"nave in $data\"><td title=\"\'Nombre\'\" filter=\"{ nombre: \'text\'}\" data-sortable=\"\'nombre\'\">{{nave.nombre.toUpperCase();}}</td><td title=\"\'Número de nave\'\" align=center filter=\"{ numeroNave: \'text\'}\" data-sortable=\"\'numeroNave\'\">{{nave.numeroNave}}</td><td title=\"\'Cantidad de pasillos\'\" align=center>{{vm.util.contarNoBorrados(nave.pasillos);}} <a class=\"btn btn-success\" ng-click=vm.crearNuevoHijo(nave)><i class=\"fa fa-plus\"></i></a></td><td title=\"\'Acciones\'\" align=center><div class=btn-group><button class=\"btn btn-info\" ng-click=vm.verPlano(nave)><i class=\"fa fa-search\"></i> Ver plano</button></div></td></tr></table></div><div class=\"col-lg-12 form-group\"><a class=\"btn btn-primary\" ng-click=vm.volver()><i class=\"fa fa-arrow-circle-left\"></i> Volver</a></div></form></div>");
$templateCache.put("app/app/main/ubicaciones/nivel/editar/editar-nivel-ubicaciones.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><i class=\"fa-sitemap fa\"></i> <i>Depósito: {{vm.estante.estructura.pasillo.nave.deposito.nombre.toUpperCase();}} </i>/ <i>Nave: {{vm.estante.estructura.pasillo.nave.nombre.toUpperCase();}} </i>/ <i>Pasillo N° {{vm.estante.estructura.pasillo.numeroPasillo}} </i>/ <i>Estructura N° {{vm.estante.estructura.identificadorEstructura}} </i>/ <i>Estantería N° {{vm.estante.numeroEstante}}</i><br><br></div><div class=form-group><label>Número de Estante:</label><input class=form-control ng-maxlength=2 ng-disabled=true ng-model=vm.nivel.numeroNivel placeholder=\"Número de estante\" type=number name=numeroNivel required ng-pattern=/^[1-9][0-9]{0}/ > <span uib-alert class=danger ng-if=\"vm.form.numeroNivel.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.numeroNivel.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 3 caracteres. </span><span uib-alert class=danger ng-if=\"(vm.form.numeroNivel.$error.number || vm.form.numeroNivel.$error.pattern) && vm.form.$dirty\">Ingrese un valor válido.</span></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.guardar() ng-disabled=vm.form.$invalid><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/ubicaciones/nivel/lista/lista-nivel-ubicaciones.html","<div><form><div class=form-group><center><button ng-click=vm.crearNuevo() class=\"btn btn-success\" style=width:30%><i class=\"fa fa-plus\"></i> NUEVO ESTANTE</button> <button ng-click=vm.crearNuevaJerarquia() class=\"btn btn-primary\" style=width:30%><i class=\"fa fa-sitemap\"></i> NUEVO ESTANTE COMPLETO</button></center></div><div class=col-lg-12><i class=\"fa-sitemap fa\"></i> <button class=\"btn btn-link\" ng-click=vm.irVistaDeposito()>Depósito: {{vm.estante.estructura.pasillo.nave.deposito.nombre.toUpperCase();}}</button> / <button class=\"btn btn-link\" ng-click=vm.irVistaNave()>Nave: {{vm.estante.estructura.pasillo.nave.nombre.toUpperCase();}}</button> / <button class=\"btn btn-link\" ng-click=vm.irVistaPasillo()>Pasillo N° {{vm.estante.estructura.pasillo.numeroPasillo}}</button> / <button class=\"btn btn-link\" ng-click=vm.irVistaEstructura()>Estructura N° {{vm.estante.estructura.identificadorEstructura}}</button> / <i>Estantería N° {{vm.estante.numeroEstante}}</i><br><br></div><div class=col-lg-12 ng-if=\"vm.niveles.length==0\"><span uib-alert>La estantería no posee estantes.</span></div><div class=col-lg-12 ng-if=\"vm.niveles.length>0\"><div class=borde><div ng-repeat=\"nivel in vm.niveles\"><div ng-if=\"nivel.borrado===false\"><div class=\"estantes-vista btn btn-primary\" style=\"font-weight: bold\" ng-click=vm.verPlanoUbicaciones(nivel) ng-style=vm.claseNivel(nivel);>Estante N° {{nivel.numeroNivel}}<div ng-repeat=\"ubicacion in nivel.ubicaciones | orderBy:\'numeroUbicacion\'\"><div ng-if=\"ubicacion.borrado===false\"><div class=\"col-xs-12 ubicaciones-vista btn btn-muted\" ng-class=\"{verde: ubicacion.estadoUbicacion.id==1, rojo: ubicacion.estadoUbicacion.id == 2, amarillo:ubicacion.estadoUbicacion.id==3}\" ng-click=\"vm.mostrarInfoUbicacion(ubicacion, nivel); $event.stopPropagation();\" ng-style=vm.claseUbicacion(nivel);>Ubicación N° {{ubicacion.numeroUbicacion}}<br>N° Orden: {{ubicacion.numeroOrden}}</div></div></div></div></div></div></div><br><br></div><div class=col-lg-12 ng-if=\"vm.niveles.length>0\"><p>Listado de estantes:</p></div><div class=col-lg-12 ng-if=\"vm.niveles.length>0\"><table id=table1 ng-table=vm.tableParams class=table show-filter=true ng-show=vm.niveles><tr ng-repeat=\"nivel in $data | orderBy:\'numeroUbicacion\'\"><td title=\"\'Número de estante\'\" align=center filter=\"{ numeroNivel: \'text\'}\">{{nivel.numeroNivel}}</td><td title=\"\'Cantidad de ubicaciones\'\" align=center>{{ vm.util.contarUbicacionesPorNivel(nivel);}} <a class=\"btn btn-success\" ng-click=vm.crearNuevoHijo(nivel)><i class=\"fa fa-plus\"></i></a></td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.mostrarInformacion(nivel)><i class=\"fa fa-search\"></i> </a><!-- 							<a class=\"btn btn-warning\" ng-disabled=\"true\" ng-click=\"true || vm.editar(nivel)\">\r\n	<i class=\"fa fa-pencil\"></i>\r\n</a> --> <a class=\"btn btn-danger\" ng-click=vm.eliminar(nivel)><i class=\"fa fa-remove\"></i></a></div></td></tr></table></div><div class=\"col-lg-12 form-group\"><a class=\"btn btn-primary\" ng-click=vm.volver()><i class=\"fa fa-arrow-circle-left\"></i> Volver</a></div></form></div>");
$templateCache.put("app/app/main/ubicaciones/nivel/nueva-jerarquia/nueva-jerarquia.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><i class=\"fa-sitemap fa\"></i> <i>Depósito: {{vm.estante.estructura.pasillo.nave.deposito.nombre.toUpperCase();}} </i>/ <i>Nave: {{vm.estante.estructura.pasillo.nave.nombre.toUpperCase();}} </i>/ <i>Pasillo N° {{vm.estante.estructura.pasillo.numeroPasillo}} </i>/ <i>Estructura N° {{vm.estante.estructura.identificadorEstructura}} </i>/ <i>Estantería N° {{vm.estante.numeroEstante}}</i><br><br><div class=form-group><label>Ingrese cuántas ubicaciones tendrá el nuevo estante:</label><input class=form-control min=0 ng-min=0 max=20 ng-model=vm.cantidad.ubicaciones placeholder=\"Cantidad de ubicaciones\" type=number name=ubicaciones required ng-pattern=/^-?[1-9][^\\.]*$/ step=1> <span uib-alert class=danger ng-show=\"vm.form.ubicaciones.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-show=\"vm.form.ubicaciones.$error.number && vm.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.ubicaciones.$error.max && vm.form.$dirty\">Ingrese un número mayor a 1 y menor a 21. </span><span uib-alert class=danger ng-if=\"vm.form.ubicaciones.$error.pattern && vm.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.ubicaciones.$error.min && vm.form.$dirty\">Este campo no puede tener valores negativos.</span></div></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.crearJerarquia() ng-disabled=vm.form.$invalid><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/ubicaciones/pasillo/editar/editar-pasillo-ubicaciones.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><i class=\"fa-sitemap fa\"></i> <i>Depósito: {{vm.nave.deposito.nombre.toUpperCase();}} </i>/ <i>Nave: {{vm.nave.nombre.toUpperCase();}}</i><br><br></div><div class=form-group><label>Número de Pasillo:</label><input class=form-control ng-disabled=true ng-maxlength=2 ng-model=vm.pasillo.numeroPasillo placeholder=\"Número de pasillo\" type=number name=numeroPasillo required ng-pattern=/^[1-9][0-9]{0}/ > <span uib-alert class=danger ng-if=\"vm.form.numeroPasillo.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.numeroPasillo.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 3 caracteres. </span><span uib-alert class=danger ng-if=\"(vm.form.numeroPasillo.$error.number || vm.form.numeroPasillo.$error.pattern) && vm.form.$dirty\">Ingrese un valor válido.</span></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.guardar() ng-disabled=vm.form.$invalid><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/ubicaciones/pasillo/lista/lista-pasillo-ubicaciones.html","<div><form><div class=form-group><center><button ng-click=vm.crearNuevo() class=\"btn btn-success\" style=width:30%><i class=\"fa fa-plus\"></i> NUEVO PASILLO</button> <button ng-click=vm.crearNuevaJerarquia() class=\"btn btn-primary\" style=width:30%><i class=\"fa fa-sitemap\"></i> NUEVO PASILLO COMPLETO</button></center></div><div class=col-lg-12><i class=\"fa-sitemap fa\"></i> <button class=\"btn btn-link\" ng-click=vm.irVistaDeposito()>Depósito: {{vm.nave.deposito.nombre.toUpperCase();}}</button> / <i>Nave: {{vm.nave.nombre.toUpperCase();}}</i><br><br></div><div class=col-lg-12 ng-if=\"vm.pasillos.length==0\"><span uib-alert class=info>La nave no posee pasillos.</span></div><div class=col-lg-12 ng-if=\"vm.pasillos.length>0\"><div class=borde><div ng-repeat=\"pasillo in vm.pasillos | orderBy:\'numeroPasillo*1\'\"><div ng-show=\"pasillo.borrado===false\"><div class=\"pasillo btn btn-muted\" ng-style=vm.clasePasillos(); ng-click=vm.verPlanoEstructura(pasillo)>Pasillo N° {{pasillo.numeroPasillo}}<div class=flex-columnas-estructura><div ng-repeat=\"estructura in pasillo.estructuras | filtroNoBorrados | orderBy:\'identificadorEstructura*1\'\"><div ng-if=\"estructura.borrado===false\"><div ng-if=\"estructura.borrado==false\" class=\"estructura btn btn-warning flex-div-hijo\" style=\"font-size:80%; font-weight: bold\" ng-click=\"vm.verPlanoEstantes(estructura); $event.stopPropagation();\">N° {{estructura.identificadorEstructura}}<div ng-repeat=\"estante in estructura.estantes | filtroNoBorrados | orderBy:\'numeroEstante*1\'\"><div ng-if=\"estante.borrado===false\"><div style=\"font-size:70%; font-weight: bold\" class=\"col-xs-12 estante btn btn-danger\" ng-style=vm.claseEstante(estructura) ng-click=\"vm.verPlanoNiveles(estante); $event.stopPropagation();\">N° {{estante.numeroEstante}}</div></div></div></div></div></div></div></div></div></div></div><div><br><div class=\"btn btn-warning\">&nbsp;</div>= Estructura.<br><div class=\"btn btn-danger\">&nbsp;</div>= Estantería.</div><br><br></div><div class=col-lg-12 ng-if=\"vm.pasillos.length>0\"><p>Listado de pasillos:</p></div><div class=col-lg-12 ng-if=\"vm.pasillos.length>0\"><table id=table1 ng-table=vm.tableParams class=table show-filter=true ng-show=vm.pasillos><tr ng-repeat=\"pasillo in $data | orderBy:\'numeroPasillo*1\'\"><td title=\"\'Número de pasillo\'\" align=center filter=\"{ numeroPasillo: \'text\'}\">{{pasillo.numeroPasillo}}</td><td title=\"\'Cantidad de estructuras\'\" align=center>{{vm.util.contarNoBorrados(pasillo.estructuras);}} <a class=\"btn btn-success\" ng-click=vm.crearNuevoHijo(pasillo)><i class=\"fa fa-plus\"></i></a></td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.mostrarInformacion(pasillo)><i class=\"fa fa-search\"></i> </a><!-- 							<a class=\"btn btn-warning\" ng-disabled=\"true\" ng-click=\"true || vm.editar(pasillo)\">\r\n	<i class=\"fa fa-pencil\"></i>\r\n</a> --> <a class=\"btn btn-danger\" ng-click=vm.eliminar(pasillo)><i class=\"fa fa-remove\"></i></a></div></td></tr></table></div><div class=\"col-lg-12 form-group\"><a class=\"btn btn-primary\" ng-click=vm.volver()><i class=\"fa fa-arrow-circle-left\"></i> Volver</a></div></form></div>");
$templateCache.put("app/app/main/ubicaciones/pasillo/nueva-jerarquia/nueva-jerarquia.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><i class=\"fa-sitemap fa\"></i> <i>Depósito: {{vm.nave.deposito.nombre.toUpperCase();}} </i>/ <i>Nave: {{vm.nave.nombre.toUpperCase();}}</i><br><br><div class=form-group><label>Ingrese cuántas estructuras tendrá el nuevo pasillo:</label><input class=form-control min=0 ng-min=0 ng-maxlength=1 ng-model=vm.cantidad.estructuras placeholder=\"Cantidad de estructuras\" type=number name=estructuras required ng-pattern=/^-?[1-9][^\\.]*$/ step=1> <span uib-alert class=danger ng-show=\"vm.form.estructuras.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-show=\"vm.form.estructuras.$error.number && vm.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.estructuras.$error.maxlength && vm.form.$dirty\">Ingrese un número mayor a 1 y menor a 10. </span><span uib-alert class=danger ng-if=\"vm.form.estructuras.$error.pattern && vm.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.estructuras.$error.min && vm.form.$dirty\">Este campo no puede tener valores negativos.</span></div><div class=form-group ng-if=vm.cantidad.estructuras><label>Ingrese cuántas estanterías tendrá cada estructura del nuevo pasillo:</label><input class=form-control min=0 ng-min=0 max=20 ng-model=vm.cantidad.estantes placeholder=\"Cantidad de estanterías\" type=number name=estantes required ng-pattern=/^-?[1-9][^\\.]*$/ step=1> <span uib-alert class=danger ng-show=\"vm.form.estantes.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-show=\"vm.form.estantes.$error.number && vm.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.estantes.$error.max && vm.form.$dirty\">Ingrese un número mayor a 1 y menor a 21. </span><span uib-alert class=danger ng-if=\"vm.form.estantes.$error.pattern && vm.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.estantes.$error.min && vm.form.$dirty\">Este campo no puede tener valores negativos.</span></div><div class=form-group ng-if=\"vm.cantidad.estructuras && vm.cantidad.estantes\"><label>Ingrese cuántos estantes tendrá cada estantería para cada estructura del nuevo pasillo:</label><input class=form-control min=0 ng-min=0 ng-maxlength=1 ng-model=vm.cantidad.niveles placeholder=\"Cantidad de estantes\" type=number name=niveles required ng-pattern=/^-?[1-9][^\\.]*$/ step=1> <span uib-alert class=danger ng-show=\"vm.form.niveles.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-show=\"vm.form.niveles.$error.number && vm.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.niveles.$error.maxlength && vm.form.$dirty\">Ingrese un número mayor a 1 y menor a 10. </span><span uib-alert class=danger ng-if=\"vm.form.niveles.$error.pattern && vm.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.niveles.$error.min && vm.form.$dirty\">Este campo no puede tener valores negativos.</span></div><div class=form-group ng-if=\"vm.cantidad.niveles && vm.cantidad.estantes && vm.cantidad.estructuras\"><label>Ingrese cuántas ubicaciones tendrá cada estante, para cada estantería, de cada estructura del nuevo pasillo:</label><input class=form-control min=0 ng-min=0 max=20 ng-model=vm.cantidad.ubicaciones placeholder=\"Cantidad de ubicaciones\" type=number name=ubicaciones required ng-pattern=/^-?[1-9][^\\.]*$/ step=1> <span uib-alert class=danger ng-show=\"vm.form.ubicaciones.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-show=\"vm.form.ubicaciones.$error.number && vm.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.ubicaciones.$error.max && vm.form.$dirty\">Ingrese un número mayor a 1 y menor a 21. </span><span uib-alert class=danger ng-if=\"vm.form.ubicaciones.$error.pattern && vm.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.ubicaciones.$error.min && vm.form.$dirty\">Este campo no puede tener valores negativos.</span></div></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.crearJerarquia() ng-disabled=vm.form.$invalid><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/ubicaciones/ubicaciones/editar/editar-ubicaciones.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><i class=\"fa-sitemap fa\"></i> <i>Depósito: {{vm.nivel.estante.estructura.pasillo.nave.deposito.nombre.toUpperCase();}} </i>/ <i>Nave: {{vm.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase();}} </i>/ <i>Pasillo N° {{vm.nivel.estante.estructura.pasillo.numeroPasillo}} </i>/ <i>Estructura N° {{vm.nivel.estante.estructura.identificadorEstructura}} </i>/ <i>Estantería N° {{vm.nivel.estante.numeroEstante}} </i>/ <i>Estante N° {{ vm.nivel.numeroNivel}}</i><br><br></div><div class=form-group><label>Número de Ubicación:</label><input class=form-control ng-maxlength=2 ng-disabled=true ng-model=vm.ubicacion.numeroUbicacion placeholder=\"Ingrese el número de ubicación\" type=text name=numeroUbicacion required ng-pattern=/^[1-9][0-9]{0}/ > <span uib-alert class=danger ng-if=\"vm.form.numeroUbicacion.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.numeroUbicacion.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 3 caracteres. </span><span uib-alert class=danger ng-if=\"vm.form.numeroUbicacion.$error.pattern && vm.form.$dirty\">Ingrese un valor válido.</span></div><div class=form-group><label>Categoría de peso:</label><input class=form-control ng-disabled=true ng-maxlength=255 ng-model=vm.categoria.nombre placeholder=\"Categoría de peso\" type=text name=categoriaPeso> <span uib-alert class=danger ng-if=\"vm.form.categoriaPeso.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=form-group ng-if=\"vm.modo==\'editar\'\"><label>Estado:</label><input class=form-control ng-disabled=true ng-maxlength=255 ng-model=vm.ubicacion.estadoUbicacion.nombre placeholder=Estado type=text name=estadoUbicacion> <span uib-alert class=danger ng-if=\"vm.form.estadoUbicacion.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div><div class=form-group ng-if=\"vm.modo!=\'editar\'\"><label>Estado:</label><input class=form-control ng-disabled=true ng-maxlength=255 ng-model=vm.estadoNuevo.nombre placeholder=Estado type=text name=estadoNuevo> <span uib-alert class=danger ng-if=\"vm.form.estadoNuevo.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 255 caracteres.</span></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.guardar() ng-disabled=vm.form.$invalid><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/ubicaciones/ubicaciones/lista/lista-ubicaciones.html","<div><form><div class=form-group><center><button ng-click=vm.crearNuevo() class=\"btn btn-success\" style=width:30%><i class=\"fa fa-plus\"></i> NUEVA UBICACIÓN</button> <button ng-click=vm.crearNuevas() class=\"btn btn-primary\" style=width:30%><i class=\"fa fa-plus-square\"></i> VARIAS UBICACIONES</button></center></div><div class=col-lg-12><i class=\"fa-sitemap fa\"></i> <button class=\"btn btn-link\" ng-click=vm.irVistaDeposito()>Depósito: {{vm.nivel.estante.estructura.pasillo.nave.deposito.nombre.toUpperCase();}}</button> / <button class=\"btn btn-link\" ng-click=vm.irVistaNave()>Nave: {{vm.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase();}}</button> / <button class=\"btn btn-link\" ng-click=vm.irVistaPasillo()>Pasillo N° {{vm.nivel.estante.estructura.pasillo.numeroPasillo}}</button> / <button class=\"btn btn-link\" ng-click=vm.irVistaEstructura()>Estructura N° {{vm.nivel.estante.estructura.identificadorEstructura}}</button> / <button class=\"btn btn-link\" ng-click=vm.irVistaEstanteria()>Estantería N° {{vm.nivel.estante.numeroEstante}}</button> / <i>Estante N° {{ vm.nivel.numeroNivel}}</i><br><br></div><div class=col-lg-12 ng-if=\"vm.ubicaciones.length==0\"><span uib-alert>El estante no posee ubicaciones.</span></div><div class=col-lg-12 ng-if=\"vm.ubicaciones.length>0\"><div class=borde><div ng-repeat=\"ubicacion in vm.ubicaciones | orderBy:\'+\'\"><div ng-if=\"ubicacion.borrado===false\"><div class=\"grilla ubicacion-vista btn btn-muted\" style=\"color: white\" ng-click=vm.mostrarInformacion(ubicacion) ng-style=vm.claseUbicaciones(); ng-class=\"{verde: ubicacion.estadoUbicacion.id==1, rojo: ubicacion.estadoUbicacion.id == 2, amarillo:ubicacion.estadoUbicacion.id==3}\">Ubicación N° {{ubicacion.numeroUbicacion}}<br>N° Orden: {{ubicacion.numeroOrden}}</div></div></div></div><br><br></div><div class=col-lg-12 ng-if=\"vm.ubicaciones.length>0\"><p>Listado de ubicaciones:</p></div><div class=col-lg-12 ng-if=\"vm.ubicaciones.length>0\"><table id=table1 ng-table=vm.tableParams class=table show-filter=true ng-show=vm.ubicaciones><tr ng-repeat=\"ubicacion in $data\"><td title=\"\'Número de ubicación\'\" align=center filter=\"{ numeroUbicacion: \'text\'}\">{{ubicacion.numeroUbicacion}}</td><td title=\"\'Ocupación\'\" align=center>{{ubicacion.estadoUbicacion.nombre}}</td><td title=\"\'Categoría de peso\'\" align=center>{{ubicacion.categoriaPeso.nombre}}</td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.mostrarInformacion(ubicacion)><i class=\"fa fa-search\"></i> </a><a class=\"btn btn-primary\" ng-disabled=\"ubicacion.estadoUbicacion.id==1\" ng-click=\"ubicacion.estadoUbicacion.id==1 || vm.cambiarEstado(ubicacion)\"><i class=\"fa fa-exchange\"></i> </a><a class=\"btn btn-danger\" ng-click=vm.eliminar(ubicacion)><i class=\"fa fa-remove\"></i></a></div></td></tr></table></div><div class=\"col-lg-12 form-group\"><a class=\"btn btn-primary\" ng-click=vm.volver()><i class=\"fa fa-arrow-circle-left\"></i> Volver</a></div></form></div>");
$templateCache.put("app/app/main/ubicaciones/ubicaciones/nueva-jerarquia/nueva-jerarquia.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=col-lg-12><i class=\"fa-sitemap fa\"></i> <i>Depósito: {{vm.nivel.estante.estructura.pasillo.nave.deposito.nombre.toUpperCase();}} </i>/ <i>Nave: {{vm.nivel.estante.estructura.pasillo.nave.nombre.toUpperCase();}} </i>/ <i>Pasillo N° {{vm.nivel.estante.estructura.pasillo.numeroPasillo}} </i>/ <i>Estructura N° {{vm.nivel.estante.estructura.identificadorEstructura}} </i>/ <i>Estantería N° {{vm.nivel.estante.numeroEstante}} </i>/ <i>Estante N° {{vm.nivel.numeroNivel}}</i><br><br><div class=form-group><label>Ingrese cuántas ubicaciones desea agregar:</label><input class=form-control min=0 ng-min=0 max=20 ng-model=vm.cantidad.ubicaciones placeholder=\"Cantidad de ubicaciones a agregar\" type=number name=ubicaciones required ng-pattern=/^-?[1-9][^\\.]*$/ step=1> <span uib-alert class=danger ng-show=\"vm.form.ubicaciones.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-show=\"vm.form.ubicaciones.$error.number && vm.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.ubicaciones.$error.max && vm.form.$dirty\">Ingrese un número mayor a 1 y menor a 21. </span><span uib-alert class=danger ng-if=\"vm.form.ubicaciones.$error.pattern && vm.form.$dirty\">Ingrese un valor válido. </span><span uib-alert class=danger ng-if=\"vm.form.ubicaciones.$error.min && vm.form.$dirty\">Este campo no puede tener valores negativos.</span></div></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.crearJerarquia() ng-disabled=vm.form.$invalid><span class=\"glyphicon glyphicon-ok\"></span> Guardar</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/movimientos/donacion-scrap/egreso/agregar-suministros-egreso/agregar-suministros-egreso.html","<div class=col-lg-12 ng-if=!vm.ocultar><div class=col-lg-12 ng-show=\"vm.detalles.length==0\"><span uib-alert class=danger>Ha recargado la página.</span></div><button ng-click=vm.volver() class=\"btn btn-warning\"><i class=\"fa fa-arrow-left\"></i> Volver a la pantalla de edición</button></div><div class=col-lg-12 ng-if=vm.ocultar><div class=form-group><center><button ng-click=vm.guardar() class=\"btn btn-success\" style=width:30%><i class=\"fa fa-check\"></i> Guardar</button> <button ng-click=vm.volver() class=\"btn btn-warning\" style=width:30%><i class=\"fa fa-arrow-left\"></i> Volver</button></center></div><div class=col-lg-12><div class=\"form-group col-lg-6\"><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.egreso.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.egreso.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Solicitó:</label><input type=text ng-model=vm.solicitante class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Autoriza:</label><input type=text ng-model=vm.egreso.solicitante class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-8\"><label>Tipo movimiento:</label><input type=text ng-model=vm.egreso.tipoMovimiento.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-4\"><label>Fecha:</label><input class=form-control ng-readonly=true ng-model=vm.fecha type=text name=fecha></div><div class=\"form-group col-lg-6\"><label>Número de Vale:</label><input class=form-control ng-readonly=true ng-model=vm.egreso.numeroVale type=text name=numeroVale></div><div class=\"form-group col-lg-6\"><label>Número de seguimiento mail:</label><input class=form-control ng-readonly=true ng-model=vm.egreso.numeroMail type=text name=numeroVale></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=form-control ng-readonly=true ng-model=vm.egreso.observacion type=text name=observacion style=resize:vertical></textarea></div><br><br><div class=\"form-group col-lg-12\"><center><button ng-click=vm.abrirModal() class=\"btn btn-primary\" style=width:30%><i class=\"fa fa-plus\"></i> Agregar suministros..</button></center></div><div class=col-lg-12 ng-show=\"vm.detalles.length==0\"><span uib-alert class=danger>No ha agregado ningún suministro.</span></div><div class=\"col-lg-12 form-group\" ng-show=\"vm.detalles.length>0\"><label>Total: ${{ vm.montoTotal() }}</label></div><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesNoInventariablesAgrupados.length>0\"><label>Detalle de suministros no inventariables</label></div><form ng-show=true><div class=col-lg-12 ng-show=\"vm.detallesNoInventariablesAgrupados.length>0\"><table ng-table=vm.tableParamsNoInventariableAgrupado class=\"table table-hover\" ng-init=\"agrupado.$hideRows = true\" show-group=false><tr class=ng-table-group ng-repeat-start=\"agrupado in $data\"><td colspan=6><a href=\"\" ng-click=\"agrupado.$hideRows = !agrupado.$hideRows\"><span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': agrupado.$hideRows, \'glyphicon-chevron-down\': !agrupado.$hideRows }\"></span> Tipo de suministro: {{ agrupado.tipoSuministro.nombre.toUpperCase() }}</a></td><td title=\"Precio total\">Precio total por tipo de suministro: <b>${{agrupado.precioTotal}}</b></td><td title=\"Cantidad solicitada\">Cantidad solicitada total: {{agrupado.cantidad}}</td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-danger\" ng-click=vm.quitarTipo(agrupado)><i class=\"fa fa-remove\"></i></a></div></td></tr><tr ng-hide=agrupado.$hideRows ng-repeat=\"detalle in agrupado.detalles\" ng-repeat-end><td title=\"\'Marca\'\" align=center>{{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'Cantidad actual\'\" align=center>{{detalle.suministro.cantidad}}</td><td title=\"\'Cantidad solicitada\'\" align=center>{{detalle.cantidad}}</td><td style=width:35% title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !detalle.suministro.ubicacion.numeroOrden, \'has-success\':detalle.suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(detalle) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(detalle)}}</div></div></td></tr></table></div></form><!-- \r\n		<div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesNoInventariables.length>0\">\r\n			<label>Detalle de suministros no inventariables</label>\r\n		</div>\r\n		<form ng-show=\"true\">\r\n	    	<div class=\"col-lg-12\" ng-show=\"vm.detallesNoInventariables.length>0\">\r\n	    		<table ng-table=\"vm.tableParams\" class=\"table\" show-filter=\"true\" ng-show=\"vm.detallesNoInventariables.length>0\">\r\n				    <tr ng-repeat=\"detalles in $data track by $index\" ng-if=\"detalles.suministro.tipoSuministro.inventariable!==true\">\r\n					    <div >\r\n					        <td title=\"\'Tipo Suministro\'\" data-sortable=\"\'suministro.tipoSuministro.nombre\'\" align=\"center\">\r\n					            {{detalles.suministro.tipoSuministro.nombre.toUpperCase();}}\r\n					        </td>\r\n					        <td title=\"\'Marca\'\" data-sortable=\"\'suministro.marca\'\" align=\"center\">\r\n					            {{detalles.suministro.marca ? detalles.suministro.marca.toUpperCase() : \"-\" }}\r\n					        </td>\r\n					        <td title=\"\'Fecha vencimiento\'\" data-sortable=\"\'suministro.fechaVencimiento\'\" align=\"center\">\r\n					            {{detalles.suministro.fechaVencimiento ? detalles.suministro.fechaVencimiento : \"-\" | date : \"dd/MM/yyyy\" }}\r\n					        </td>\r\n					        <td title=\"\'Cantidad actual\'\" align=\"center\">\r\n					            {{detalles.suministro.cantidad}}\r\n					        </td>\r\n					        <td title=\"\'Cantidad solicitada\'\" align=\"center\">\r\n					            {{detalles.cantidad}}\r\n					        </td>\r\n					        <td title=\"\'Acciones\'\" align=\"center\">\r\n								<div class=\"btn-group\">\r\n									<a class=\"btn btn-danger\" ng-click=\"vm.eliminar($index)\">\r\n										<i class=\"fa fa-trash\"></i>\r\n									</a>\r\n								</div>\r\n					        </td>\r\n					    </div>\r\n				    </tr>\r\n				</table>\r\n	    	</div>\r\n	    </form> --><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesInventariablesAgrupados.length>0\"><label>Detalle de suministros inventariables</label></div><form ng-show=true><div class=col-lg-12 ng-show=\"vm.detallesInventariablesAgrupados.length>0\"><table ng-table=vm.tableParamsInventariableAgrupado class=\"table table-hover\" ng-init=\"agrupado.$hideRows = true\" show-group=false><tr class=ng-table-group ng-repeat-start=\"agrupado in $data\"><td colspan=6><a href=\"\" ng-click=\"agrupado.$hideRows = !agrupado.$hideRows\"><span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': agrupado.$hideRows, \'glyphicon-chevron-down\': !agrupado.$hideRows }\"></span> Tipo de suministro: {{ agrupado.tipoSuministro.nombre.toUpperCase() }}</a></td><td title=\"Cantidad solicitada\">Cantidad solicitada total: {{agrupado.cantidad}}</td><td title=\"Precio total\">Precio total por tipo de suministro: <b>${{agrupado.precioTotal}}</b></td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-danger\" ng-click=vm.quitarTipo(agrupado)><i class=\"fa fa-remove\"></i></a></div></td></tr><tr ng-hide=agrupado.$hideRows ng-repeat=\"detalle in agrupado.detalles\" ng-repeat-end><td title=\"\'Marca\'\" align=center>{{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'N° serie\'\" data-sortable=\"\'suministroInventariable.serie\'\" align=center>{{detalle.suministroInventariable.serie ? detalle.suministroInventariable.serie : \"-\" }}</td><td title=\"\'N° inventario\'\" data-sortable=\"\'suministroInventariable.inventario\'\" align=center>{{detalle.suministroInventariable.inventario ? detalle.suministroInventariable.inventario : \"-\" }}</td><td title=\"\'Precio\'\" align=center>${{detalle.suministro.precioUnitario}}</td><td style=width:35% title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !detalle.suministro.ubicacion.numeroOrden, \'has-success\':detalle.suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(detalle) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(detalle)}}</div></div></td></tr></table></div></form><!-- \r\n		<form ng-show=\"true\">\r\n	    	<div class=\"col-lg-12\" ng-show=\"vm.detallesInventariables.length>0\">\r\n	    		<table ng-table=\"vm.tableParamsInventariableAgrupado\" class=\"table\" show-filter=\"true\" ng-show=\"vm.detallesInventariables.length>0\">\r\n				    <tr ng-repeat=\"detalle in $data track by $index\" ng-if=\"detalle.suministro.tipoSuministro.inventariable==true\">\r\n					    <div >\r\n					        <td title=\"\'Tipo Suministro\'\" data-sortable=\"\'suministro.tipoSuministro.nombre\'\" align=\"center\">\r\n					            {{detalle.suministro.tipoSuministro.nombre.toUpperCase();}}\r\n					        </td>\r\n					        <td title=\"\'Marca\'\" data-sortable=\"\'suministro.marca\'\" align=\"center\">\r\n					            {{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}\r\n					        </td>\r\n					        <td title=\"\'N° serie\'\" data-sortable=\"\'suministroInventariable.serie\'\" align=\"center\">\r\n					            {{detalle.suministroInventariable.serie ? detalle.suministroInventariable.serie : \"-\" }}\r\n					        </td>\r\n					        <td title=\"\'N° inventario\'\" data-sortable=\"\'suministroInventariable.inventario\'\" align=\"center\">\r\n					            {{detalle.suministroInventariable.inventario ? detalle.suministroInventariable.inventario : \"-\" }}\r\n					        </td>\r\n					        <td title=\"\'Precio\'\" align=\"center\">\r\n					            ${{detalle.suministro.precioUnitario}}\r\n					        </td>\r\n					        <td ng-if=\"!vm.egreso.caja\" title=\"\'Pallet\'\" align=\"center\" groupable=\"numeroRow\">\r\n					            {{detalle.numeroRow}}\r\n					        </td>\r\n					        <td ng-if=\"vm.egreso.caja\" title=\"\'Número caja\'\" align=\"center\" groupable=\"numeroCaja\">\r\n					        					            {{detalle.numeroCaja}}\r\n					        </td>\r\n					        <td title=\"\'Acciones\'\" align=\"center\" groupable=\"\'numeroRow\'\">\r\n								<div class=\"btn-group\">\r\n									<a class=\"btn btn-danger\" ng-click=\"vm.eliminar($index)\">\r\n										<i class=\"fa fa-trash\"></i>\r\n									</a>\r\n								</div>\r\n					        </td>\r\n					    </div>\r\n				    </tr>\r\n				</table>\r\n	    	</div>\r\n	    </form> --></div></div>");
$templateCache.put("app/app/main/movimientos/donacion-scrap/egreso/editar/editar-egreso.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=\"form-group col-lg-6\"><label>Depósito:</label><input type=text ng-model=vm.egreso.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false name=deposito required> <span uib-alert class=danger ng-show=\"vm.form.deposito.$error.required && vm.form.deposito.$dirty\">Este campo es requerido.</span></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.egreso.empresa placeholder=\"Seleccione o busque la Empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 required name=empresa typeahead-editable=false> <span uib-alert class=danger ng-show=\"vm.form.empresa.$error.required && vm.form.empresa.$dirty\">Este campo es requerido.</span></div><div class=\"form-group col-lg-12\"><label>Tipo de movimiento:</label><input type=text ng-model=vm.egreso.tipoMovimiento placeholder=\"Seleccione o busque el tipo de movimiento\" uib-typeahead=\"tipo as tipo.nombre.toUpperCase() for tipo in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 required name=tipoMovimiento typeahead-editable=false focus-on=tipoMovimiento> <span uib-alert class=danger ng-show=\"vm.form.tipoMovimiento.$error.required && vm.form.tipoMovimiento.$dirty\">Este campo es requerido.</span></div><div class=\"form-group col-lg-6\"><label>Solicita:</label><input type=text ng-disabled=!vm.egreso.empresa.nombre ng-model=vm.egreso.solicita placeholder=\"Seleccione o busque quién solicita\" class=form-control uib-typeahead=\"solicita as solicita.apellido.toUpperCase()+\', \'+solicita.nombre.toUpperCase() for solicita in vm.solicitantes | filter:{apellido:$viewValue}\" typeahead-show-hint=true typeahead-min-length=0 name=solicita typeahead-editable=false></div><div class=\"form-group col-lg-6\"><label>Autoriza:</label><input class=form-control ng-maxlength=100 focus-on=solicitante ng-model=vm.egreso.solicitante placeholder=\"Ingrese quién autoriza el egreso\" type=text name=solicitante> <span uib-alert class=danger ng-if=\"vm.form.solicitante.$error.maxlength && vm.form.solicitante.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><div class=\"form-group col-lg-6\"><label>Número de Vale</label><input type=text class=form-control ng-maxlength=100 ng-model=vm.egreso.numeroVale placeholder=\"Ingrese el número de Vale\" name=numeroVale> <span uib-alert class=danger ng-if=\"vm.form.numeroVale.$error.maxlength && vm.form.numeroVale.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><div class=\"form-group col-lg-6\"><label>Número de seguimiento por mail</label><input type=text class=form-control ng-maxlength=100 ng-model=vm.egreso.numeroMail placeholder=\"Ingrese el número de seguimiento por mail\" name=numeroMail> <span uib-alert class=danger ng-if=\"vm.form.numeroMail.$error.maxlength && vm.form.numeroMail.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=form-control ng-maxlength=500 ng-model=vm.egreso.observacion placeholder=\"Ingrese una observación\" type=text name=observacion style=resize:vertical></textarea><span uib-alert class=danger ng-if=\"vm.form.observacion.$error.required && vm.form.$dirty\">Este campo es requerido. </span><span uib-alert class=danger ng-if=\"vm.form.observacion.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 500 caracteres.</span></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.siguiente() ng-disabled=\"vm.form.$invalid || !vm.egreso.empresa.nombre\"><span class=\"glyphicon glyphicon-ok\"></span> Siguiente</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/movimientos/donacion-scrap/egreso/lista-despachados/lista-despachados.html","<div><form><div class=col-lg-12><div class=\"col-lg-12 panel\"><div class=col-lg-10><div class=form-group><label ng-if=!vm.bandera>Seleccione el depósito:</label><label ng-if=vm.bandera>Depósito seleccionado:</label><input type=text ng-disabled=vm.bandera ng-model=vm.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><br><div class=col-lg-2 ng-if=!vm.bandera><button style=width:100% ng-disabled=!vm.deposito.id ng-click=vm.buscarPorDeposito() class=\"btn btn-primary\"><i class=\"fa fa-filter\"></i> Filtrar</button></div><div class=col-lg-2 ng-if=vm.bandera><button style=width:100% ng-click=vm.cambiarFiltros() class=\"btn btn-warning\"><i class=\"fa fa-exchange\"></i> Cambiar filtros</button></div><div class=col-lg-12 ng-if=\"vm.deposito.id && vm.egresos.length==0 && vm.bandera\"><span uib-alert>No hay despachos de egresos para el depósito seleccionado</span></div></div></div><div class=col-lg-12 ng-if=\"vm.deposito.id && vm.egresos.length>0 && vm.bandera\"><div class=col-lg-12><label>Listado de despachos de egresos:</label></div><div class=container-fluid><div class=col-lg-12 ng-if=\"vm.deposito.id && vm.egresos.length>0 && vm.bandera\"><table ng-table=vm.tableParams class=\"table table-condensed\" show-filter=true><tr ng-repeat=\"egresos in $data\"><div><td data-title=\"\'Fecha\'\" align=center data-sortable=\"\'fecha\'\">{{egresos.fecha | date : \"dd/MM/yyyy HH:mm\" }}</td><td data-title=\"\'Empresa\'\" align=center data-sortable=\"\'empresa.nombre\'\" filter=\"{\'empresa.nombre\': \'text\'}\">{{egresos.empresa.nombre.toUpperCase();}}</td><td data-title=\"\'Empresa Logística\'\" align=center data-sortable=\"\'empresaLogistica.nombre\'\" filter=\"{\'empresaLogistica.nombre\': \'text\'}\">{{egresos.empresaLogistica.nombre.toUpperCase();}}</td><td data-title=\"\'N° Egreso\'\" style=width:5% align=center filter=\"{\'numeroEgreso\':\'text\'}\" data-sortable=\"\'numeroEgreso\'\">{{egresos.numeroEgreso}}</td><td data-title=\"\'Estado\'\" style=width:5% align=center>{{egresos.estadoEgreso.nombre.toUpperCase();}}</td><td data-title=\"\'Ver\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.visualizarEgreso(egresos)><i class=\"fa fa-search\"></i></a></div></td></div></tr></table></div></div></div></form></div>");
$templateCache.put("app/app/main/movimientos/donacion-scrap/egreso/lista/lista-egreso.html","<!--     <formly-form model=\"vm.user\" fields=\"vm.userFields\">\r\n  <button type=\"submit\" class=\"btn btn-primary col-sm-offset-4 col-sm-4\" ng-click=\"vm.submit(vm.user)\">Submit</button>\r\n</formly-form> --><div><form><div class=\"form-group col-lg-12\"><div class=form-group><center><button ng-click=vm.crearNuevo() class=\"btn btn-success\" style=width:50%><i class=\"fa fa-plus\"></i> NUEVO EGRESO</button></center></div><!-- 			<div class=\"col-lg-12\">\r\n	<div class=\"col-lg-12\">\r\n		<label>\r\n			Filtrar egresos:\r\n		</label>\r\n		<div class=\"col-lg-12\">\r\n			<div class=\"form-group col-lg-1\">\r\n				<input type=\"checkbox\" ng-model=\"vm.buscar\" ng-click=\"vm.busqueda()\">				\r\n			</div>\r\n			<div class=\"col-lg-4\">\r\n				<center>\r\n					<button class=\"btn btn-primary\" ng-disabled=\"!vm.buscar\" ng-click=\"vm.abrirModalFiltros()\">\r\n			        	<span class=\"fa fa-filter\"></span> Filtros de búsqueda combinados\r\n			    	</button>	\r\n				</center>\r\n			</div>\r\n			<div class=\"col-lg-4\">\r\n				<center>\r\n					<button class=\"btn btn-primary\" ng-disabled=\"!vm.buscar\" ng-click=\"vm.abrirModalFiltroCajas()\">\r\n			        	<span class=\"fa fa-filter\"></span> Filtros de Cajas\r\n			    	</button>	\r\n				</center>\r\n			</div>\r\n			<div class=\"col-lg-3\">\r\n				<center>\r\n					<button class=\"btn btn-primary\" ng-disabled=\"!vm.buscar\" ng-click=\"vm.abrirModalFiltroNumeroVale()\">\r\n			        	<span class=\"fa fa-filter\"></span> Buscar por N° de Vale\r\n			    	</button>	\r\n				</center>\r\n			</div>\r\n		</div>\r\n	</div>\r\n</div> --><br><div class=col-lg-12><div uib-alert type=info ng-show=vm.filtrosUsados>FILTROS APLICADOS:<div ng-repeat=\"filtro in vm.filtrosUsados\">{{vm.filtrosUsados[$index]}}</div></div></div><div ng-show=\"!vm.egresos.length>0 && vm.bandera\" uib-alert class=\"danger col-lg-12 form-group\">No hay egresos para los filtros indicados</div></div><!-- 		<div class=\"col-lg-12\" ng-if=\"vm.egresos.length==0\">\r\n	<span uib-alert>\r\n		No hay egresos registrados\r\n	</span>\r\n</div> --><div class=col-lg-12><table ng-table=vm.tableParams class=\"table table-condensed\" show-filter=true ng-show=\"vm.egresos.length>0\"><tr ng-repeat=\"egresos in $data\" ng-class=\"{\'amarillo-claro\': ingresos.tipoMovimiento.id==7, \'azul-claro\':ingresos.tipoMovimiento.id==8}\"><div><td data-title=\"\'Fecha\'\" align=center data-sortable=\"\'fecha\'\">{{egresos.fecha | date : \"dd/MM/yyyy HH:mm\" }}</td><!-- 				        <td data-title=\"\'¿Cajas?\'\" align=\"center\" data-sortable=\"\'fecha\'\">\r\n    {{egresos.caja? \"Si\" : \"No\"}}\r\n    <button class=\"btn\" ng-if=\"egresos.caja\" ng-click=\"vm.verNumeroCajasEgreso(egresos);\">\r\n    	<i class=\"fa fa-search\"></i>\r\n    </button>\r\n</td> --><td data-title=\"\'Depósito\'\" data-sortable=\"\'deposito.nombre\'\" filter=\"{\'deposito.nombre\': \'text\'}\" align=center>{{egresos.deposito.nombre.toUpperCase();}}</td><td data-title=\"\'Empresa\'\" data-sortable=\"\'empresa.nombre\'\" filter=\"{\'empresa.nombre\': \'text\'}\" align=center>{{egresos.empresa.nombre.toUpperCase();}}</td><td data-title=\"\'N° Movimiento\'\" style=width:5% align=center filter=\"{\'numeroMovimiento\':\'text\'}\" data-sortable=\"\'numeroMovimiento\'\">{{egresos.numeroMovimiento}}</td><td data-title=\"\'Tipo movimiento\'\" filter=\"{\'tipoMovimiento.nombre\': \'text\'}\" data-sortable=\"\'tipoMovimiento.nombre\'\" align=center>{{egresos.tipoMovimiento.nombre.toUpperCase();}}</td><td data-title=\"\'N° Vale\'\" style=width:5% align=center filter=\"{\'numeroVale\':\'text\'}\" data-sortable=\"\'numeroVale\'\">{{egresos.numeroVale? egresos.numeroVale : \"-\"}}</td><td data-title=\"\'N° Mail\'\" style=width:5% align=center filter=\"{\'numeroMail\':\'text\'}\" data-sortable=\"\'numeroMail\'\">{{egresos.numeroMail? egresos.numeroMail : \"-\"}}</td><td data-title=\"\'Estado\'\" style=width:5% data-sortable=\"\'estadoMovimiento.nombre\'\" filter=\"{\'estadoMovimiento.nombre\': \'text\'}\" align=center ng-class=\"{\'verde-claro\': egresos.estadoMovimiento.id==1, \'rojo-claro\':egresos.estadoMovimiento.id==2, \'amarillo-claro\': egresos.estadoMovimiento.id==3, \'azul-claro\':egresos.estadoMovimiento.id==4}\">{{egresos.estadoMovimiento.nombre.toUpperCase();}}</td><td data-title=\"\'Acciones\'\" align=center style=width:20%><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.visualizarEgreso(egresos)><i class=\"fa fa-search\"></i> </a><a class=\"btn btn-success\" ng-disabled=\"!(egresos.estadoMovimiento.id==17 || egresos.estadoMovimiento.id==18 || egresos.estadoMovimiento.id==21 || egresos.estadoMovimiento.id==22)\" ng-click=\"!(egresos.estadoMovimiento.id==17 || egresos.estadoMovimiento.id==18 || egresos.estadoMovimiento.id==21 || egresos.estadoMovimiento.id==22) || vm.cambiarEstado(egresos)\"><i class=\"fa fa-level-up\"></i> </a><a ng-disabled=\"!(egresos.estadoMovimiento.id==17 || egresos.estadoMovimiento.id==18 || egresos.estadoMovimiento.id==19 || egresos.estadoMovimiento.id==21 || egresos.estadoMovimiento.id==22 || egresos.estadoMovimiento.id==23)\" class=\"btn btn-danger\" ng-click=\"!(egresos.estadoMovimiento.id==17 || egresos.estadoMovimiento.id==18 || egresos.estadoMovimiento.id==19 || egresos.estadoMovimiento.id==21 || egresos.estadoMovimiento.id==22 || egresos.estadoMovimiento.id==23) || vm.eliminar(egresos)\"><i class=\"fa fa-trash\"></i></a></div></td></div></tr></table></div></form></div>");
$templateCache.put("app/app/main/movimientos/donacion-scrap/egreso/lista-generados/lista-generados.html","<!--     <formly-form model=\"vm.user\" fields=\"vm.userFields\">\r\n  <button type=\"submit\" class=\"btn btn-primary col-sm-offset-4 col-sm-4\" ng-click=\"vm.submit(vm.user)\">Submit</button>\r\n</formly-form> --><div><form><div class=\"col-lg-12 panel\"><div class=col-lg-10><div class=form-group><label ng-if=!vm.bandera>Seleccione el depósito:</label><label ng-if=vm.bandera>Depósito seleccionado:</label><input type=text ng-disabled=vm.bandera ng-model=vm.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><br><div class=col-lg-2 ng-if=!vm.bandera><button style=width:100% ng-disabled=!vm.deposito.id ng-click=vm.buscarPorDeposito() class=\"btn btn-primary\"><i class=\"fa fa-filter\"></i> Filtrar</button></div><div class=col-lg-2 ng-if=vm.bandera><button style=width:100% ng-click=vm.cambiarFiltros() class=\"btn btn-warning\"><i class=\"fa fa-exchange\"></i> Cambiar filtros</button></div><div class=col-lg-12 ng-if=\"vm.deposito.id && vm.egresos.length==0 && vm.bandera\"><span uib-alert>No hay despachos de egresos para el depósito seleccionado</span></div></div><div class=form-group ng-if=\"vm.deposito.id && vm.egresos.length>0 && vm.bandera\"><center><button ng-disabled=!vm.comprobarSeleccionado(); ng-click=vm.ubicacionesPorSuministros() class=\"btn btn-primary\" style=width:50%><i class=\"fa fa-file-text\"></i> UBICACIONES POR SUMINISTROS DE EGRESOS SELECCIONADOS</button></center></div><div class=col-lg-12 ng-if=\"vm.deposito.id && vm.egresos.length>0 && vm.bandera\"><table ng-table=vm.tableParams class=\"table table-condensed\" show-filter=true><tr ng-repeat=\"egresos in $data\" ng-class=\"{\'azul-claro\': egresos.seleccionado}\"><div><td data-title=\"\'Fecha\'\" align=center data-sortable=\"\'fecha\'\">{{egresos.fecha | date : \"dd/MM/yyyy HH:mm\" }}</td><td data-title=\"\'Tipo Movimiento\'\" align=center>{{egresos.tipoMovimiento.nombre.toUpperCase();}}</td><td data-title=\"\'Empresa\'\" data-sortable=\"\'empresa.nombre\'\" filter=\"{\'empresa.nombre\': \'text\'}\" align=center>{{egresos.empresa.nombre.toUpperCase();}}</td><td data-title=\"\'N° Movimiento\'\" style=width:5% align=center filter=\"{\'numeroMovimiento\':\'text\'}\" data-sortable=\"\'numeroMovimiento\'\">{{egresos.numeroMovimiento}}</td><td data-title=\"\'Estado\'\" style=width:5% align=center>{{egresos.estadoMovimiento.nombre.toUpperCase();}}</td><td data-title=\"\'Ver\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-disabled=\"egresos.estadoMovimiento.id!=17 && egresos.estadoMovimiento.id!=21\" ng-click=\"(egresos.estadoMovimiento.id!=17 && egresos.estadoMovimiento.id!=21) ||  vm.visualizarEgreso(egresos)\"><i class=\"fa fa-search\"></i></a></div></td><td data-title=\"\'Seleccionar\'\" align=center><input type=checkbox ng-model=egresos.seleccionado></td></div></tr></table></div></form></div>");
$templateCache.put("app/app/main/movimientos/donacion-scrap/egreso/lista-preparados/lista-preparados.html","<div><form><div class=col-lg-12><div class=\"col-lg-12 panel\"><div class=col-lg-5><div class=form-group><label ng-if=!vm.bandera>Seleccione el depósito:</label><label ng-if=vm.bandera>Depósito seleccionado:</label><input type=text ng-disabled=vm.bandera ng-model=vm.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><div class=col-lg-5><div class=form-group><label ng-if=!vm.bandera>Seleccione la empresa:</label><label ng-if=vm.bandera>Empresa seleccionada:</label><input ng-disabled=\"!vm.deposito.id || vm.bandera\" type=text ng-model=vm.empresa placeholder=\"Seleccione o busque la empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" focus-on=empresa class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div></div><br><div class=col-lg-2 ng-if=!vm.bandera><button style=width:100% ng-disabled=\"!vm.deposito.id || !vm.empresa.id\" ng-click=vm.buscarPorEmpresaDeposito() class=\"btn btn-primary\"><i class=\"fa fa-filter\"></i> Filtrar</button></div><div class=col-lg-2 ng-if=vm.bandera><button style=width:100% ng-click=vm.cambiarFiltros() class=\"btn btn-warning\"><i class=\"fa fa-exchange\"></i> Cambiar filtros</button></div><div class=col-lg-12 ng-if=\"vm.deposito.id && vm.empresa.id && vm.egresos.length==0 && vm.bandera\"><span uib-alert>No hay egresos generados para el depósito seleccionado</span></div></div></div><div class=form-group ng-if=\"vm.deposito.id && vm.empresa.id && vm.egresos.length>0 && vm.bandera\"><center><button ng-disabled=!vm.comprobarSeleccionado(); ng-click=vm.despacharSeleccionados() class=\"btn btn-primary\" style=width:50%><i class=\"fa fa-truck\"></i> DESPACHAR SELECCIONADOS</button></center></div><div class=col-lg-12 ng-if=\"vm.deposito.id && vm.empresa.id && vm.egresos.length>0 && vm.bandera\"><div class=col-lg-12><label>Listado de egresos preparados:</label></div><div class=container-fluid><div class=col-lg-12 ng-if=\"vm.deposito.id && vm.empresa.id && vm.egresos.length>0 && vm.bandera\"><table ng-table=vm.tableParams class=\"table table-condensed\" show-filter=true><tr ng-repeat=\"egresos in $data\" ng-class=\"{\'azul-claro\': egresos.seleccionado}\"><div><td data-title=\"\'Fecha\'\" align=center data-sortable=\"\'fecha\'\">{{egresos.fecha | date : \"dd/MM/yyyy HH:mm\" }}</td><td data-title=\"\'Empresa\'\" align=center>{{egresos.empresa.nombre.toUpperCase();}}</td><td data-title=\"\'Tipo Movimiento\'\" data-sortable=\"\'tipoMovimiento.nombre\'\" filter=\"{\'tipoMovimiento.nombre\': \'text\'}\" align=center>{{egresos.tipoMovimiento.nombre.toUpperCase();}}</td><td data-title=\"\'N° Movimiento\'\" style=width:5% align=center filter=\"{\'numeroMovimiento\':\'text\'}\" data-sortable=\"\'numeroMovimiento\'\">{{egresos.numeroMovimiento}}</td><td data-title=\"\'Estado\'\" style=width:5% align=center>{{egresos.estadoMovimiento.nombre.toUpperCase();}}</td><td data-title=\"\'Ver\'\" align=center><div class=btn-group><a class=\"btn btn-info\" ng-click=vm.visualizarEgreso(egresos)><i class=\"fa fa-search\"></i></a></div></td><td data-title=\"\'Seleccionar\'\" align=center><input type=checkbox ng-model=egresos.seleccionado></td></div></tr></table></div></div></div></form></div>");
$templateCache.put("app/app/main/movimientos/donacion-scrap/egreso/visualizar-egreso-despachado/visualizar-egreso-despachado.html","<div class=form-group ng-if=vm.comprobarEstadoEgreso();><center><button ng-click=vm.volver(); class=\"btn btn-info\" style=width:30%><i class=\"fa fa-arrow-left\"></i> Volver al listado</button> <button ng-click=vm.imprimirInforme(); class=\"btn btn-primary\" style=width:30%><i class=\"fa fa-file-text-o\"></i> Obtener informe</button></center></div><div class=col-lg-12 ng-if=vm.comprobarEstadoEgreso()><div class=\"panel panel-default\"><div class=panel-body><div class=\"form-group col-lg-12\"><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.egreso.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.egreso.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Solicitó:</label><input type=text ng-model=vm.egreso.solicitante class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-12\"><label>Tipo movimiento:</label><input type=text ng-model=vm.egreso.tipoMovimiento.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-4\"><label>Número de movimiento:</label><input class=form-control ng-readonly=true ng-model=vm.egreso.numeroMovimiento type=text name=numeroMovimiento></div><div class=\"form-group col-lg-4\"><label>Fecha creación:</label><input class=form-control ng-readonly=true ng-model=vm.fechaCreacion type=text name=fecha></div><div class=\"form-group col-lg-4\"><label>Monto total:</label><input class=form-control ng-readonly=true ng-model=vm.montoTotal type=text name=montoTotal></div><div class=\"form-group col-lg-12\"><label>Estado:</label><input class=form-control ng-readonly=true ng-model=vm.egreso.estadoMovimiento.nombre type=text name=estado></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=form-control ng-readonly=true ng-model=vm.egreso.observacion type=text name=observacion style=resize:vertical></textarea></div></div></div><div ng-if=false><uib-accordion><div uib-accordion-group class=panel-default is-open=status.isCustomHeaderOpen><uib-accordion-heading>Problemas <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.isCustomHeaderOpen, \'glyphicon-chevron-right\': !status.isCustomHeaderOpen}\"></i></uib-accordion-heading><div class=col-lg-12><div ng-if=\"vm.egreso.problemas.length==0\"><span uib-alert type=info>No posee ningún problema asignado</span></div><div><center><button class=\"btn btn-primary\" ng-click=vm.editarProblemas();><i class=\"fa fa-pencil-square\"></i> Agregar o quitar problemas</button></center></div><div ng-if=\"vm.egreso.problemas.length>0\"><label>Problemas asignados:</label><table ng-table=vm.tableParams1 class=table><tr ng-repeat=\"problema in $data track by $index\"><td>{{problema.nombre.toUpperCase();}}</td></tr></table><label>Descripción de problemas:</label><textarea class=form-control ng-readonly=true ng-model=vm.egreso.observacionProblema type=text name=observacionProblema style=resize:vertical></textarea></div></div></div></uib-accordion></div><br><div><uib-accordion><div uib-accordion-group class=panel-default is-open=status.isCustomHeaderOpen><uib-accordion-heading>Despacho <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.isCustomHeaderOpen, \'glyphicon-chevron-right\': !status.isCustomHeaderOpen}\"></i></uib-accordion-heading><div class=col-lg-12><div class=col-lg-12><center><button style=width:60% class=\"btn btn-primary\" ng-if=vm.egreso.egreso.id ng-click=vm.visualizarEgreso()><i class=\"fa fa-search\"></i> Ver despacho</button></center><br></div><div class=\"col-lg-6 form-group\"><label>Empresa logística:</label><input type=text ng-readonly=true ng-model=vm.egreso.egreso.empresaLogistica.nombre class=\"form-control text-uppercase\"></div><div class=\"col-lg-6 form-group\"><label>Retiró:</label><input type=text ng-readonly=true ng-model=vm.persona class=\"form-control text-uppercase\"></div><div class=\"col-lg-6 form-group\"><label>N° Egreso</label><input type=text ng-readonly=true ng-model=vm.egreso.egreso.numeroEgreso class=\"form-control text-uppercase\"></div><div class=\"col-lg-6 form-group\"><label>Fecha despacho</label><input type=text ng-readonly=true ng-model=vm.fechaDespacho class=\"form-control text-uppercase\"></div><div class=\"col-lg-12 form-group\"><label>N° Guía</label><input type=text ng-readonly=true ng-model=vm.egreso.egreso.nroGuia class=\"form-control text-uppercase\"></div><!-- 					<div class=\"col-lg-6 form-group\">\r\n	<label>Cantidad total de paquetes: </label>\r\n	<br>\r\n	<h3>\r\n		<b>\r\n			{{vm.egreso.egreso.cantidadPaquetes==1? vm.egreso.egreso.cantidadPaquetes + \" paquete\" : vm.egreso.egreso.cantidadPaquetes + \" paquetes\"}} \r\n		</b>\r\n	</h3>\r\n</div>\r\n<div class=\"col-lg-6 form-group\">\r\n	<label>Peso total de paquetes: </label>\r\n	<br>\r\n	<h3>\r\n		<b>\r\n			{{vm.egreso.egreso.pesoTotal}} Kg.\r\n		</b>\r\n	</h3>\r\n</div> --></div></div></uib-accordion></div><br><div><uib-accordion><div uib-accordion-group is-open=status.isCustomHeaderOpen><uib-accordion-heading>Detalle de suministros <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.isCustomHeaderOpen, \'glyphicon-chevron-right\': !status.isCustomHeaderOpen}\"></i></uib-accordion-heading><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesNoInventariablesAgrupados.length>0\"><label>Detalle de suministros no inventariables</label></div><form ng-show=true><div class=col-lg-12 ng-show=\"vm.detallesNoInventariablesAgrupados.length>0\"><table ng-table=vm.tableParamsNoInventariableAgrupado class=\"table table-hover\" ng-init=\"agrupado.$hideRows = true\" show-group=false><tr class=ng-table-group ng-repeat-start=\"agrupado in $data\"><td colspan=6><a href=\"\" ng-click=\"agrupado.$hideRows = !agrupado.$hideRows\"><span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': agrupado.$hideRows, \'glyphicon-chevron-down\': !agrupado.$hideRows }\"></span> Tipo de suministro: {{ agrupado.tipoSuministro.nombre.toUpperCase() }}</a></td><td title=\"Precio total\">Precio total por tipo de suministro: <b>${{agrupado.precioTotal}}</b></td><td title=\"Cantidad solicitada\">Cantidad solicitada total: <b>{{agrupado.cantidad}}</b></td><!-- 						        <td title=\"\'Acciones\'\" align=\"center\">\r\n									<div class=\"btn-group\">\r\n										<a class=\"btn btn-danger\" ng-click=\"vm.quitarTipo(agrupado)\">\r\n											<i class=\"fa fa-remove\"></i>\r\n										</a>\r\n									</div>\r\n</td> --></tr><tr ng-hide=agrupado.$hideRows ng-repeat=\"detalle in agrupado.detalles\" ng-repeat-end><td title=\"\'Marca\'\" align=center>{{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'Precio\'\" align=center>${{detalle.suministro.precioUnitario}}</td><td title=\"\'Cantidad solicitada\'\" align=center>{{detalle.cantidad}}</td><!-- 			            	  	<td style=\"width:35%;\" title=\"\'Ubicación\'\">\r\n	<div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !detalle.suministro.ubicacion.numeroOrden, \'has-success\':detalle.suministro.ubicacion.numeroOrden}\">\r\n									    <i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i>\r\n									    <div  ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto;\" class=\"form-control\" ng-click=\"vm.ubicacionCompleta(detalle)\" class=\"form-control\" style=\"word-wrap: white;\">\r\n									    	{{vm.ubicacionNaveNumeroOrden(detalle)}}\r\n									    </div>\r\n									</div>\r\n</td> --></tr></table></div></form><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesInventariablesAgrupados.length>0\"><label>Detalle de suministros inventariables</label></div><form ng-show=true><div class=col-lg-12 ng-show=\"vm.detallesInventariablesAgrupados.length>0\"><table ng-table=vm.tableParamsInventariableAgrupado class=\"table table-hover\" ng-init=\"agrupado.$hideRows = true\" show-group=false><tr class=ng-table-group ng-repeat-start=\"agrupado in $data\"><td colspan=6><a href=\"\" ng-click=\"agrupado.$hideRows = !agrupado.$hideRows\"><span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': agrupado.$hideRows, \'glyphicon-chevron-down\': !agrupado.$hideRows }\"></span> Tipo de suministro: {{ agrupado.tipoSuministro.nombre.toUpperCase() }}</a></td><td title=\"Precio total\">Precio total por tipo de suministro: <b>${{agrupado.precioTotal}}</b></td><td title=\"Cantidad solicitada\">Cantidad solicitada total: <b>{{agrupado.cantidad}}</b></td><!-- 				        <td title=\"\'Acciones\'\" align=\"center\">\r\n									<div class=\"btn-group\">\r\n										<a class=\"btn btn-danger\" ng-click=\"vm.quitarTipo(agrupado)\">\r\n											<i class=\"fa fa-remove\"></i>\r\n										</a>\r\n									</div>\r\n		</td> --></tr><tr ng-hide=agrupado.$hideRows ng-repeat=\"detalle in agrupado.detalles\" ng-repeat-end><td title=\"\'Marca\'\" align=center>{{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'N° serie\'\" sortable align=center>{{detalle.suministroInventariable.serie ? detalle.suministroInventariable.serie : \"-\" }}</td><td title=\"\'N° inventario\'\" sortable align=center>{{detalle.suministroInventariable.inventario ? detalle.suministroInventariable.inventario : \"-\" }}</td><td title=\"\'Precio\'\" align=center>${{detalle.suministro.precioUnitario}}</td><!-- 			            	  	<td style=\"width:35%;\" title=\"\'Ubicación\'\" ng-if=\"vm.comprobarEstadoEgreso();\">\r\n	<div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !detalle.suministro.ubicacion.numeroOrden, \'has-success\':detalle.suministro.ubicacion.numeroOrden}\">\r\n									    <i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i>\r\n									    <div  ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto;\" class=\"form-control\" ng-click=\"vm.ubicacionCompleta(detalle)\" class=\"form-control\" style=\"word-wrap: white;\">\r\n									    	{{vm.ubicacionNaveNumeroOrden(detalle)}}\r\n									    </div>\r\n									</div>\r\n</td> --></tr></table></div><form></form></form></div></uib-accordion></div></div><div ng-if=!vm.comprobarEstadoEgreso() class=col-lg-12><span uib-alert class=danger>El egreso no puede visualizarse </span><button ng-click=vm.volver(); class=\"btn btn-warning\" style=width:30%><i class=\"fa fa-arrow-left\"></i> Volver al listado</button></div>");
$templateCache.put("app/app/main/movimientos/donacion-scrap/egreso/visualizar-egreso/visualizar-egreso.html","<div class=form-group ng-if=vm.comprobarEstadoEgreso();><center><button ng-click=vm.volver(); class=\"btn btn-info\" style=width:30%><i class=\"fa fa-arrow-left\"></i> Volver al listado</button> <button ng-click=vm.imprimirInforme(); class=\"btn btn-primary\" style=width:30%><i class=\"fa fa-file-text-o\"></i> Obtener informe</button></center></div><div class=col-lg-12 ng-if=vm.comprobarEstadoEgreso()><div class=\"panel panel-default\"><div class=panel-body><div class=\"form-group col-lg-6\"><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.egreso.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.egreso.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Solicitó:</label><input type=text ng-model=vm.solicitante class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Autoriza:</label><input type=text ng-model=vm.egreso.solicitante class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Tipo Movimiento:</label><input class=form-control ng-readonly=true ng-model=vm.egreso.tipoMovimiento.nombre type=text name=tipoMovimiento></div><div class=\"form-group col-lg-6\"><label>Estado:</label><input class=form-control ng-readonly=true ng-model=vm.egreso.estadoMovimiento.nombre type=text name=estado></div><div class=\"form-group col-lg-4\"><label>Número de movimiento:</label><input class=form-control ng-readonly=true ng-model=vm.egreso.numeroMovimiento type=text name=numeroMovimiento></div><div class=\"form-group col-lg-4\"><label>Fecha:</label><input class=form-control ng-readonly=true ng-model=vm.fecha type=text name=fecha></div><div class=\"form-group col-lg-4\"><label>Monto total:</label><input class=form-control ng-readonly=true ng-model=vm.montoTotal type=text name=montoTotal></div><div class=\"form-group col-lg-6\"><label>Número de Vale:</label><input class=form-control ng-readonly=true ng-model=vm.egreso.numeroVale type=text name=numeroVale></div><div class=\"form-group col-lg-6\"><label>Número de seguimiento mail:</label><input class=form-control ng-readonly=true ng-model=vm.egreso.numeroMail type=text name=numeroVale></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=form-control ng-readonly=true ng-model=vm.egreso.observacion type=text name=observacion style=resize:vertical></textarea></div></div></div><!-- 	<div ng-if=\"false\">\r\n	<uib-accordion>\r\n	    <div uib-accordion-group class=\"panel-default\" is-open=\"status.isCustomHeaderOpen\">\r\n	      	<uib-accordion-heading>\r\n	        	Problemas \r\n	        	<i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.isCustomHeaderOpen, \'glyphicon-chevron-right\': !status.isCustomHeaderOpen}\"></i>\r\n	      	</uib-accordion-heading>\r\n	      	<div class=\"col-lg-12\">\r\n	      		<div ng-if=\"vm.egreso.problemas.length==0\">\r\n	      			<span uib-alert type=\"info\">\r\n	      				No posee ningún problema asignado\r\n	      			</span>		      			\r\n	      		</div>\r\n	      		<div>\r\n	      			<center>\r\n		      			<button class=\"btn btn-primary\" ng-click=\"vm.editarProblemas();\">\r\n							<i class=\"fa fa-pencil-square\"></i>\r\n		      				Agregar o quitar problemas\r\n		      			</button>\r\n	      			</center>\r\n	      		</div>\r\n	      		<div ng-if=\"vm.egreso.problemas.length>0\">\r\n		      		<label>\r\n		      			Problemas asignados:\r\n		      		</label>\r\n	      			<table ng-table=\"vm.tableParams1\" class=\"table\">\r\n	      				<tr ng-repeat=\"problema in $data track by $index\">\r\n							<td>\r\n								{{problema.nombre.toUpperCase();}}\r\n							</td>		      					\r\n	      				</tr>\r\n	      			</table>\r\n	      			<label>\r\n	      				Descripción de problemas:\r\n	      			</label>\r\n					<textarea class=\"form-control\" ng-readonly=\"true\" ng-model=\"vm.egreso.observacionProblema\" type=\"text\" name=\"observacionProblema\" style=\"resize:vertical\"></textarea>\r\n	      		</div>\r\n	      	</div>\r\n	    </div>\r\n	</uib-accordion>\r\n</div> --><br><div ng-if=!vm.egreso.caja><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesNoInventariablesAgrupados.length>0\"><label>Detalle de suministros no inventariables</label></div><form ng-show=true><div class=col-lg-12 ng-show=\"vm.detallesNoInventariablesAgrupados.length>0\"><table ng-table=vm.tableParamsNoInventariableAgrupado class=\"table table-hover\" ng-init=\"agrupado.$hideRows = true\" show-group=false><tr class=ng-table-group ng-repeat-start=\"agrupado in $data\"><td colspan=6><a href=\"\" ng-click=\"agrupado.$hideRows = !agrupado.$hideRows\"><span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': agrupado.$hideRows, \'glyphicon-chevron-down\': !agrupado.$hideRows }\"></span> Tipo de suministro: {{ agrupado.tipoSuministro.nombre.toUpperCase() }}</a></td><td title=\"Precio total\">Precio total por tipo de suministro: <b>${{agrupado.precioTotal}}</b></td><td title=\"Cantidad solicitada\">Cantidad solicitada total: <b>{{agrupado.cantidad}}</b></td><!-- 				        <td title=\"\'Acciones\'\" align=\"center\">\r\n							<div class=\"btn-group\">\r\n								<a class=\"btn btn-danger\" ng-click=\"vm.quitarTipo(agrupado)\">\r\n									<i class=\"fa fa-remove\"></i>\r\n								</a>\r\n							</div>\r\n</td> --></tr><tr ng-hide=agrupado.$hideRows ng-repeat=\"detalle in agrupado.detalles\" ng-repeat-end><td title=\"\'Marca\'\" align=center>{{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'Precio\'\" align=center>${{detalle.suministro.precioUnitario}}</td><td title=\"\'Cantidad solicitada\'\" align=center>{{detalle.cantidad}}</td><td style=width:35% title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !detalle.suministro.ubicacion.numeroOrden, \'has-success\':detalle.suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(detalle) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(detalle)}}</div></div></td></tr></table></div></form><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesInventariablesAgrupados.length>0\"><label>Detalle de suministros inventariables</label></div><form ng-show=true><div class=col-lg-12 ng-show=\"vm.detallesInventariablesAgrupados.length>0\"><table ng-table=vm.tableParamsInventariableAgrupado class=\"table table-hover\" ng-init=\"agrupado.$hideRows = true\" show-group=false><tr class=ng-table-group ng-repeat-start=\"agrupado in $data\"><td colspan=6><a href=\"\" ng-click=\"agrupado.$hideRows = !agrupado.$hideRows\"><span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': agrupado.$hideRows, \'glyphicon-chevron-down\': !agrupado.$hideRows }\"></span> Tipo de suministro: {{ agrupado.tipoSuministro.nombre.toUpperCase() }}</a></td><td title=\"Precio total\">Precio total por tipo de suministro: <b>${{agrupado.precioTotal}}</b></td><td title=\"Cantidad solicitada\">Cantidad solicitada total: <b>{{agrupado.cantidad}}</b></td><!-- 				        <td title=\"\'Acciones\'\" align=\"center\">\r\n							<div class=\"btn-group\">\r\n								<a class=\"btn btn-danger\" ng-click=\"vm.quitarTipo(agrupado)\">\r\n									<i class=\"fa fa-remove\"></i>\r\n								</a>\r\n							</div>\r\n</td> --></tr><tr ng-hide=agrupado.$hideRows ng-repeat=\"detalle in agrupado.detalles\" ng-repeat-end><td title=\"\'Marca\'\" align=center>{{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'N° serie\'\" sortable align=center>{{detalle.suministroInventariable.serie ? detalle.suministroInventariable.serie : \"-\" }}</td><td title=\"\'N° inventario\'\" sortable align=center>{{detalle.suministroInventariable.inventario ? detalle.suministroInventariable.inventario : \"-\" }}</td><td title=\"\'Precio\'\" align=center>${{detalle.suministro.precioUnitario}}</td><td style=width:35% title=\"\'Ubicación\'\" ng-if=vm.comprobarEstadoEgreso();><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !detalle.suministro.ubicacion.numeroOrden, \'has-success\':detalle.suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(detalle) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(detalle)}}</div></div></td></tr></table></div><form></form></form></div><!-- 	<div ng-if=\"vm.egreso.caja\">\r\n	<div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesInventariablesAgrupadosCajas.length>0\">\r\n		<label>Detalle de cajas cerradas</label>\r\n	</div>\r\n	<form ng-show=\"true\">\r\n    	<div class=\"col-lg-12\" ng-show=\"vm.detallesInventariablesAgrupadosCajas.length>0\">\r\n	        <table ng-table=\"vm.tableParamsInventariableAgrupadoCajas\" class=\"table table-hover\"  ng-init=\"agrupado.$hideRows = true\" show-group=\"false\">\r\n	            <tr class=\"ng-table-group\" ng-repeat-start=\"agrupado in $data\">\r\n	              	<td colspan=\"6\">\r\n		                <a href=\"\" ng-click=\"agrupado.$hideRows = !agrupado.$hideRows\">\r\n		                 	<span class=\"glyphicon\" ng-class=\"{ \'glyphicon-chevron-right\': agrupado.$hideRows, \'glyphicon-chevron-down\': !agrupado.$hideRows }\"></span>\r\n		                 	Caja cerrada N°: {{agrupado.numeroCaja}} <br>\r\n		                  	Tipo de suministro: {{ agrupado.tipoSuministro.nombre.toUpperCase() }} <br>\r\n		                  	Familia de suministro: {{ agrupado.tipoSuministro.familiaSuministro.nombre.toUpperCase();}}\r\n		                </a>\r\n            	  	</td>\r\n            	  	<td style=\"width:35%;\" title=\"\'Ubicación\'\">\r\n            	  		<div class=\"form-group has-feedback\">\r\n						    <label class=\"control-label\">Ubicación</label>\r\n						    <div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto;\" class=\"form-control\" ng-click=\"vm.ubicacionCompletaCaja(agrupado)\">\r\n						    	{{agrupado.ubicacion? vm.ubicacionNaveNumeroOrdenCaja(agrupado) : \"No asignó ninguna.\" }}\r\n						    </div>\r\n						    <i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i>\r\n						</div>\r\n            	  	</td>\r\n            	  	<td title=\"Cantidad total\">\r\n            	  		Cantidad total: {{agrupado.cantidad}}\r\n            	  	</td>\r\n            	  	<td title=\"Precio total\">\r\n            	  		Precio total: <b>${{agrupado.precioTotal}}</b>\r\n            	  	</td>\r\n	            </tr>\r\n	            <tr ng-hide=\"agrupado.$hideRows\" ng-repeat=\"detalle in agrupado.detalles\" ng-repeat-end>\r\n			        <td title=\"\'Marca\'\" align=\"center\">\r\n			            {{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}\r\n			        </td>\r\n			        <td title=\"\'N° serie\'\" align=\"center\">\r\n			            {{detalle.suministroInventariable.serie ? detalle.suministroInventariable.serie : \"-\" }}\r\n			        </td>\r\n			        <td title=\"\'N° inventario\'\" align=\"center\">\r\n			            {{detalle.suministroInventariable.inventario ? detalle.suministroInventariable.inventario : \"-\" }}\r\n			        </td>\r\n			        <td title=\"\'Precio\'\" align=\"center\">\r\n			            ${{detalle.suministro.precioUnitario}}\r\n			        </td>\r\n	            </tr>\r\n	        </table>\r\n    	</div>\r\n    </form>\r\n</div>\r\n --></div><div ng-if=!vm.comprobarEstadoEgreso() class=col-lg-12><span uib-alert class=danger>El egreso no puede visualizarse </span><button ng-click=vm.volver(); class=\"btn btn-warning\" style=width:30%><i class=\"fa fa-arrow-left\"></i> Volver al listado</button></div>");
$templateCache.put("app/app/main/movimientos/donacion-scrap/ingreso/agregar-suministros/agregar-suministros-donacion-scrap.html","<div class=col-lg-12 ng-if=!vm.ocultar><div class=col-lg-12 ng-show=\"vm.detalles.length==0\"><span uib-alert class=danger>Ha recargado la página.</span></div><button ng-click=vm.volver() class=\"btn btn-warning\"><i class=\"fa fa-arrow-left\"></i> Volver a la pantalla de edición</button></div><div class=col-lg-12 ng-if=vm.ocultar><div class=form-group><center><button ng-click=vm.guardar() class=\"btn btn-success\" style=width:30%><i class=\"fa fa-check\"></i> Guardar</button> <button ng-click=vm.volver() class=\"btn btn-warning\" style=width:30%><i class=\"fa fa-arrow-left\"></i> Volver</button></center></div><div class=col-lg-12><div class=\"form-group col-lg-12\"><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.ingreso.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.ingreso.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Autorizó:</label><input type=text ng-model=vm.ingreso.solicitante class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Tipo de movimiento:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.tipoMovimiento.nombre type=text name=tipoMovimiento></div><div class=\"form-group col-lg-6\"><label>Fecha:</label><input class=form-control ng-readonly=true ng-model=vm.fecha type=text name=fecha></div><div class=\"form-group col-lg-6\"><label>Proveedor:</label><input type=text ng-readonly=true ng-model=vm.ingreso.proveedor.nombre class=\"form-control text-uppercase\" name=proveedor></div><div class=\"form-group col-lg-6\"><label>Persona Proveedor:</label><input type=text ng-readonly=true ng-model=vm.personaProveedor class=\"form-control text-uppercase\" name=personaProveedor></div><div class=\"form-group col-lg-6\"><label>Empresa logística:</label><input type=text ng-readonly=true ng-model=vm.ingreso.empresaLogistica.nombre class=\"form-control text-uppercase\" name=empresaLogistica></div><div class=\"form-group col-lg-6\"><label>Persona Empresa logística:</label><input type=text ng-readonly=true ng-model=vm.personaEmpresaLogistica class=\"form-control text-uppercase\" name=personaEmpresaLogistica></div><div class=\"form-group col-lg-4\"><label>Número de remito:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroRemito type=text name=numeroRemito></div><div class=\"form-group col-lg-4\"><label>Número Vale Ingreso:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroIngresoVale type=text name=numeroIngresoVale></div><div class=\"form-group col-lg-4\"><label>Número guía</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroGuia type=text name=numeroGuia></div><div class=\"form-group col-lg-12\"><label>Sucursal de origen</label><input class=\"form-control text-uppercase\" ng-readonly=true ng-model=vm.ingreso.sucursal.nombre type=text name=sucursal></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=form-control ng-readonly=true ng-model=vm.ingreso.observacion type=text name=observacion style=resize:vertical></textarea></div><br><br><div class=\"form-group col-lg-12\"><center><button ng-click=vm.abrirModal() class=\"btn btn-primary\" style=width:30%><i class=\"fa fa-plus\"></i> Agregar suministros..</button> <button ng-click=vm.abrirModalAgregarSuministrosExcel() class=\"btn btn-success\" style=width:30%><i class=\"fa fa-file-excel-o\"></i> Agregar suministros desde un Excel</button></center></div><div class=col-lg-12 ng-show=\"vm.detalles.length==0\"><span uib-alert class=danger>No ha agregado ningún suministro.</span></div><div class=\"col-lg-12 form-group\" ng-show=\"vm.detalles.length>0\"><label>Total: ${{ vm.montoTotal() }}</label></div><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesNoInventariables.length>0\"><label>Detalle de suministros no inventariables</label></div><form ng-show=true><div class=col-lg-12 ng-show=\"vm.detallesNoInventariables.length>0\"><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.detallesNoInventariables.length>0\"><tr ng-repeat=\"detalles in $data track by $index\" ng-if=\"detalles.suministro.tipoSuministro.inventariable!==true\"><div><td title=\"\'Fecha\'\" data-sortable=\"\'fecha\'\" align=center>{{detalles.fecha | date : \"dd/MM/yyyy\"}}</td><td title=\"\'Tipo Suministro\'\" data-sortable=\"\'suministro.tipoSuministro.nombre\'\" align=center>{{detalles.suministro.tipoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Marca\'\" data-sortable=\"\'suministro.marca\'\" align=center>{{detalles.suministro.marca ? detalles.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'Fecha vencimiento\'\" data-sortable=\"\'suministro.fechaVencimiento\'\" align=center>{{detalles.suministro.fechaVencimiento ? detalles.suministro.fechaVencimiento : \"-\" | date : \"dd/MM/yyyy\" }}</td><td title=\"\'Cantidad\'\" align=center>{{detalles.cantidad}}</td><td title=\"\'Precio por unidad\'\" align=center>${{detalles.suministro.precioUnitario}}</td><td title=\"\'Total\'\" align=center>${{(detalles.suministro.precioUnitario*detalles.cantidad).toFixed(2)}}</td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-danger\" ng-click=vm.eliminar(detalles)><i class=\"fa fa-trash\"></i></a></div></td></div></tr></table></div></form><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesInventariables.length>0\"><label>Detalle de suministros inventariables</label></div><form ng-show=true><div class=col-lg-12 ng-show=\"vm.detallesInventariables.length>0\"><table ng-table=vm.tableParamsStock class=table show-filter=true ng-show=\"vm.detallesInventariables.length>0\"><tr ng-repeat=\"detalle in $data track by $index\" ng-if=\"detalle.suministro.tipoSuministro.inventariable==true\"><div><!-- 				        <td title=\"\'Cantidad\'\" data-sortable=\"\'cantidad\'\" align=\"center\">\r\n	    {{detalle.cantidad}}\r\n	</td> --><td title=\"\'Tipo Suministro\'\" data-sortable=\"\'suministro.tipoSuministro.nombre\'\" align=center>{{detalle.suministro.tipoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Marca\'\" data-sortable=\"\'suministro.marca\'\" align=center>{{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'N° serie\'\" data-sortable=\"\'suministroInventariable.serie\'\" align=center>{{detalle.suministroInventariable.serie ? detalle.suministroInventariable.serie : \"-\" }}</td><td title=\"\'N° inventario\'\" data-sortable=\"\'suministroInventariable.inventario\'\" align=center>{{detalle.suministroInventariable.inventario ? detalle.suministroInventariable.inventario : \"-\" }}</td><td title=\"\'Precio\'\" align=center>${{detalle.suministro.precioUnitario}}</td><td ng-if=!vm.ingreso.caja title=\"\'Pallet\'\" align=center groupable=numeroRow>{{detalle.numeroRow}}</td><td ng-if=vm.ingreso.caja title=\"\'Número caja\'\" align=center groupable=numeroCaja>{{detalle.numeroCaja}}</td><td title=\"\'Acciones\'\" align=center groupable=\"\'numeroRow\'\"><div class=btn-group><a class=\"btn btn-danger\" ng-click=vm.eliminar(detalle)><i class=\"fa fa-trash\"></i></a></div></td></div></tr></table></div></form></div></div>");
$templateCache.put("app/app/main/movimientos/donacion-scrap/ingreso/asignar-ubicaciones/asignar-ubicaciones.html","<div class=form-group ng-if=vm.comprobarIngresoCerrado();><center><button ng-click=vm.comprobarUbicaciones(); class=\"btn btn-success\" style=width:30%><i class=\"fa fa-check\"></i> Guardar</button> <button ng-click=vm.volver() class=\"btn btn-warning\" style=width:30%><i class=\"fa fa-arrow-left\"></i> Volver al listado</button></center></div><div class=col-lg-12 ng-if=vm.comprobarIngresoCerrado()><div class=\"panel panel-default\"><div class=panel-body><div class=\"form-group col-lg-12\"><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.ingreso.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.ingreso.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Autorizó:</label><input type=text ng-model=vm.ingreso.solicitante class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-3\"><label>Tipo de movimiento:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.tipoMovimiento.nombre type=text name=tipoMovimiento></div><div class=\"form-group col-lg-3\"><label>Número de movimiento:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroMovimiento type=text name=numeroMovimiento></div><div class=\"form-group col-lg-3\"><label>Fecha:</label><input class=form-control ng-readonly=true ng-model=vm.fecha type=text name=fecha></div><div class=\"form-group col-lg-3\"><label>Monto total:</label><input class=form-control ng-readonly=true ng-model=vm.montoTotal type=text name=montoTotal></div><div class=\"form-group col-lg-6\"><label>Proveedor:</label><input type=text ng-readonly=true ng-model=vm.ingreso.proveedor.nombre class=\"form-control text-uppercase\" name=proveedor></div><div class=\"form-group col-lg-6\"><label>Persona Proveedor:</label><input type=text ng-readonly=true ng-model=vm.personaProveedor class=\"form-control text-uppercase\" name=personaProveedor></div><div class=\"form-group col-lg-6\"><label>Empresa logística:</label><input type=text ng-readonly=true ng-model=vm.ingreso.empresaLogistica.nombre class=\"form-control text-uppercase\" name=empresaLogistica></div><div class=\"form-group col-lg-6\"><label>Persona Empresa logística:</label><input type=text ng-readonly=true ng-model=vm.personaEmpresaLogistica class=\"form-control text-uppercase\" name=personaEmpresaLogistica></div><div class=\"form-group col-lg-4\"><label>Número de remito:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroRemito type=text name=numeroRemito></div><div class=\"form-group col-lg-4\"><label>Número Vale Ingreso:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroIngresoVale type=text name=numeroIngresoVale></div><div class=\"form-group col-lg-4\"><label>Número guía</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroGuia type=text name=numeroGuia></div><div class=\"form-group col-lg-12\"><label>Sucursal de origen</label><input class=\"form-control text-uppercase\" ng-readonly=true ng-model=vm.ingreso.sucursal.nombre type=text name=sucursal></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=form-control ng-readonly=true ng-model=vm.ingreso.observacion type=text name=observacion style=resize:vertical></textarea></div></div></div><br><br><div class=form-group ng-if=vm.comprobarIngresoCerrado();><center><button ng-click=vm.asignarAutomaticamente() class=\"btn btn-primary\" style=width:30%><i class=\"fa fa-map-marker\"></i> Asignar ubicaciones automáticamente</button> <button ng-click=vm.limpiarUbicaciones() class=\"btn btn-warning\" style=width:30%><i class=\"fa fa-times\"></i> Remover ubicaciones asignadas</button></center></div><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesNoInventariables.length>0\" ng-if=vm.comprobarIngresoCerrado();><label>Detalle de suministros no inventariables</label></div><form ng-show=true ng-if=vm.comprobarIngresoCerrado();><div class=col-lg-12 ng-show=\"vm.detallesNoInventariables.length>0\"><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.detallesNoInventariables.length>0\"><tr ng-repeat=\"detalles in $data track by $index\" ng-if=\"detalles.suministro.tipoSuministro.inventariable!==true\"><div><td title=\"\'Tipo Suministro\'\" data-sortable=\"\'suministro.tipoSuministro.nombre\'\" align=center>{{detalles.suministro.tipoSuministro.nombre.toUpperCase();}}</td><td title=\"\'Marca\'\" data-sortable=\"\'suministro.marca\'\" align=center>{{detalles.suministro.marca ? detalles.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'Fecha vencimiento\'\" data-sortable=\"\'suministro.fechaVencimiento\'\" align=center>{{detalles.suministro.fechaVencimiento ? detalles.suministro.fechaVencimiento : \"-\" | date : \"dd/MM/yyyy\" }}</td><td title=\"\'Cantidad\'\" align=center>{{detalles.cantidad}}</td><td title=\"\'Precio por unidad\'\" align=center>${{detalles.suministro.precioUnitario}}</td><td title=\"\'Total\'\" align=center>${{(detalles.suministro.precioUnitario*detalles.cantidad).toFixed(2)}}</td><td style=width:35% title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !detalles.ubicacion.numeroOrden, \'has-success\':detalles.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(detalles) class=form-control style=\"word-wrap: white\">{{detalles.ubicacion? vm.ubicacionNaveNumeroOrden(detalles) : \"No asignó ninguna.\" }}</div></div></td><td title=\"\'¿Ocupar ubicación?\'\" align=center><input type=checkbox ng-model=detalles.ocupar ng-change=vm.corroborarOcuparUbicacionRepetida(detalles);></td><td title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-primary\" ng-click=vm.asignarIndividual(detalles)><i class=\"fa fa-map-marker\"></i> </a><a class=\"btn btn-danger\" ng-disabled=\"!(detalles.ubicacion && detalles.ubicacion.id)\" ng-click=vm.removerIndividual(detalles)><i class=\"fa fa-remove\"></i></a></div></td></div></tr></table></div></form><div class=\"col-lg-12 form-group\" ng-show=\"vm.detallesInventariables.length>0\" ng-if=vm.comprobarIngresoCerrado();><label>Detalle de suministros inventariables</label></div><form ng-show=true ng-if=vm.comprobarIngresoCerrado();><div class=col-lg-12 ng-show=\"vm.detallesInventariables.length>0\"><table ng-table=vm.tableParamsStock class=\"table table-hover\" ng-init=\"pallet.$hideRows = true\" show-group=false><tr class=ng-table-group ng-repeat-start=\"pallet in $data\"><td colspan=4><a href=\"\" ng-click=\"pallet.$hideRows = !pallet.$hideRows\"><span class=glyphicon ng-class=\"{ \'glyphicon-chevron-right\': pallet.$hideRows, \'glyphicon-chevron-down\': !pallet.$hideRows }\"></span> Pallet N° {{pallet.numeroRow}} - {{ pallet.tipoSuministro.nombre.toUpperCase() }}</a></td><td style=width:35% title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !pallet.ubicacion.numeroOrden, \'has-success\': pallet.ubicacion.numeroOrden, \'has-warning\': pallet.ubicacion.numeroOrden && pallet.ubicacion.categoriaPeso.id!=pallet.tipoSuministro.categoriaPeso.id}\"><label class=control-label>Ubicación</label><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(pallet)>{{pallet.ubicacion? vm.ubicacionNaveNumeroOrden(pallet) : \"No asignó ninguna.\" }}</div><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i></div></td><td title=\"\'¿Ocupar ubicación?\'\" align=center><div>¿Ocupar<br>ubicación?</div><input type=checkbox ng-model=pallet.ocupar ng-change=vm.corroborarOcuparUbicacionRepetida(pallet);></td><td title=\"\'Asignar\'\" align=center><div class=btn-group><a class=\"btn btn-primary\" ng-click=vm.asignarIndividual(pallet)><i class=\"fa fa-map-marker\"></i> </a><a class=\"btn btn-danger\" ng-disabled=\"!(pallet.ubicacion && pallet.ubicacion.id)\" ng-click=vm.removerIndividual(pallet)><i class=\"fa fa-remove\"></i></a></div></td></tr><tr ng-hide=pallet.$hideRows ng-repeat=\"detalle in pallet.detalles\" ng-repeat-end><td title=\"\'Marca\'\" align=center>{{detalle.suministro.marca ? detalle.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'N° serie\'\" align=center>{{detalle.suministroInventariable.serie ? detalle.suministroInventariable.serie : \"-\" }}</td><td title=\"\'N° inventario\'\" align=center>{{detalle.suministroInventariable.inventario ? detalle.suministroInventariable.inventario : \"-\" }}</td><td title=\"\'Precio\'\" align=center>${{detalle.suministro.precioUnitario}}</td></tr></table></div></form></div><div ng-if=!vm.comprobarIngresoCerrado() class=col-lg-12><span uib-alert class=danger>No puede asignarle ubicaciones a un ingreso ya cerrado.</span></div>");
$templateCache.put("app/app/main/movimientos/donacion-scrap/ingreso/lista/lista-donacion-scrap.html","<div><form><div class=\"form-group col-lg-12\"><div class=form-group><center><button ng-click=vm.crearNuevo() class=\"btn btn-success\" style=width:50%><i class=\"fa fa-plus\"></i> NUEVO INGRESO</button></center></div><!-- 			<div class=\"col-lg-12\">\r\n	<div class=\"col-lg-5\">\r\n		<label>\r\n			Filtrar ingresos:\r\n		</label>\r\n		<div class=\"col-lg-12\">\r\n			<div class=\"form-group col-lg-1\">\r\n				<input type=\"checkbox\" ng-model=\"vm.buscar\" ng-click=\"vm.busqueda()\">				\r\n			</div>\r\n			<div class=\"col-lg-11\">\r\n				<center>\r\n					<button class=\"btn btn-primary\" ng-disabled=\"!vm.buscar\" ng-click=\"vm.abrirModalFiltros()\">\r\n			        	<span class=\"fa fa-filter\"></span> Abrir filtros de búsqueda\r\n			    	</button>	\r\n				</center>\r\n			</div>\r\n		</div>\r\n	</div>\r\n</div> --><br><div class=col-lg-12><div uib-alert type=info ng-show=vm.filtrosUsados>FILTROS APLICADOS:<div ng-repeat=\"filtro in vm.filtrosUsados\">{{vm.filtrosUsados[$index]}}</div></div></div><div ng-show=\"!vm.ingresos.length>0 && vm.bandera\" uib-alert class=\"danger col-lg-12 form-group\">No hay ingresos para los filtros indicados</div></div><div class=col-lg-12><table ng-table=vm.tableParams class=\"table table-condensed\" show-filter=true ng-show=\"vm.ingresos.length>0\"><tr ng-repeat=\"ingresos in $data\"><div><td data-title=\"\'Fecha\'\" align=center data-sortable=\"\'fecha\'\">{{ingresos.fecha | date : \"dd/MM/yyyy HH:mm\" }}</td><td data-title=\"\'Depósito\'\" data-sortable=\"\'deposito.nombre\'\" filter=\"{\'deposito.nombre\': \'text\'}\" align=center>{{ingresos.deposito.nombre.toUpperCase();}}</td><td data-title=\"\'Empresa\'\" data-sortable=\"\'empresa.nombre\'\" filter=\"{\'empresa.nombre\': \'text\'}\" align=center>{{ingresos.empresa.nombre.toUpperCase();}}</td><td data-title=\"\'Proveedor\'\" filter=\"{\'proveedor.nombre\': \'text\'}\" data-sortable=\"\'proveedor.nombre\'\" align=center>{{ingresos.proveedor.nombre.toUpperCase();}}</td><td data-title=\"\'Tipo movimiento\'\" filter=\"{\'tipoMovimiento.nombre\': \'text\'}\" data-sortable=\"\'tipoMovimiento.nombre\'\" align=center>{{ingresos.tipoMovimiento.nombre.toUpperCase();}}</td><td data-title=\"\'N° Movimiento\'\" style=width:5% align=center filter=\"{\'numeroMovimiento\':\'text\'}\" data-sortable=\"\'numeroMovimiento\'\">{{ingresos.numeroMovimiento}}</td><td data-title=\"\'Estado\'\" style=width:5% data-sortable=\"\'estadoMovimiento.nombre\'\" filter=\"{\'estadoMovimiento.nombre\': \'text\'}\" align=center ng-class=\"{\'rojo-claro\': ingresos.estadoMovimiento.id==13 || ingresos.estadoMovimiento.id==15}\">{{ingresos.estadoMovimiento.nombre.toUpperCase();}}</td><td data-title=\"\'Acciones\'\" align=center style=width:20%><div class=btn-group><a class=\"btn btn-info\" ng-disabled=\"ingresos.estadoMovimiento.id==13 || ingresos.estadoMovimiento.id==15\" ng-click=\"ingresos.estadoMovimiento.id==13 || ingresos.estadoMovimiento.id==15 || vm.visualizarIngreso(ingresos)\"><i class=\"fa fa-search\"></i> </a><a ng-disabled=\"ingresos.estadoMovimiento.id==14 || ingresos.estadoMovimiento.id==16\" class=\"btn btn-primary\" ng-click=\"ingresos.estadoMovimiento.id==14 || ingresos.estadoMovimiento.id==16 || vm.irAsignarUbicaciones(ingresos)\"><i class=\"fa fa-map-marker\"></i> </a><a ng-disabled=\"ingresos.estadoMovimiento.id==14 || ingresos.estadoMovimiento.id==16\" class=\"btn btn-danger\" ng-click=\"ingresos.estadoMovimiento.id==14 || ingresos.estadoMovimiento.id==16 || vm.eliminar(ingresos)\"><i class=\"fa fa-trash\"></i></a></div></td></div></tr></table></div></form></div>");
$templateCache.put("app/app/main/movimientos/donacion-scrap/ingreso/editar/editar-donacion-scrap.html","<div class=col-lg-12><div class=\"panel panel-default\"><div class=panel-body><div class=container-fluid><form name=vm.form><div class=\"form-group col-lg-12\"><label>Depósito:</label><input type=text ng-model=vm.ingreso.deposito placeholder=\"Seleccione o busque el depósito\" uib-typeahead=\"deposito as deposito.nombre.toUpperCase() for deposito in vm.depositos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false required name=deposito focus-on=deposito> <span uib-alert class=danger ng-show=\"vm.form.deposito.$error.required && vm.form.deposito.$dirty\">Este campo es requerido.</span></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.ingreso.empresa placeholder=\"Seleccione o busque la Empresa\" uib-typeahead=\"empresa as empresa.nombre.toUpperCase() for empresa in vm.empresas | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 required name=empresa typeahead-editable=false> <span uib-alert class=danger ng-show=\"vm.form.empresa.$error.required && vm.form.empresa.$dirty\">Este campo es requerido.</span></div><div class=\"form-group col-lg-6\"><label>Autoriza:</label><input class=form-control ng-maxlength=100 focus-on=solicitante ng-model=vm.ingreso.solicitante placeholder=\"Ingrese la persona que autoriza el ingreso\" type=text name=solicitante> <span uib-alert class=danger focus-on=solicitante ng-if=\"vm.form.solicitante.$error.maxlength && vm.form.solicitante.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><div class=\"form-group col-lg-12\"><label>Tipo de movimiento:</label><input type=text ng-model=vm.ingreso.tipoMovimiento placeholder=\"Seleccione o busque el tipo de movimiento\" uib-typeahead=\"tipo as tipo.nombre.toUpperCase() for tipo in vm.tipos | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 required name=tipoMovimiento typeahead-editable=false> <span uib-alert class=danger ng-show=\"vm.form.tipoMovimiento.$error.required && vm.form.tipoMovimiento.$dirty\">Este campo es requerido.</span></div><div class=\"form-group col-lg-6\"><label>Proveedor:</label><input type=text ng-disabled=!vm.ingreso.empresa.nombre focus-on=proveedor ng-model=vm.ingreso.proveedor placeholder=\"Seleccione o busque el proveedor\" uib-typeahead=\"proveedor as proveedor.nombre.toUpperCase() for proveedor in vm.proveedores | filter:{nombre:$viewValue}\" class=form-control typeahead-editable=false typeahead-show-hint=true typeahead-min-length=0 required name=proveedor> <span uib-alert class=danger ng-if=\"vm.form.proveedor.$error.required && vm.form.proveedor.$dirty\">Este campo es requerido.</span></div><div class=\"form-group col-lg-6\"><label>Personal proveedor:</label><input type=text ng-disabled=\"!vm.ingreso.proveedor.id || vm.personas.length==0\" focus-on=personaProveedor ng-model=vm.ingreso.personaProveedor placeholder=\"Seleccione o busque personal de proveedor\" uib-typeahead=\"persona as persona.apellido.toUpperCase()+\', \'+persona.nombre.toUpperCase() for persona in vm.personas | filter:{apellido:$viewValue}\" class=form-control typeahead-editable=false typeahead-show-hint=true typeahead-min-length=0 name=persona></div><div class=\"form-group col-lg-6\"><label>Empresa logística:</label><input type=text ng-disabled=!vm.ingreso.empresa.nombre ng-model=vm.ingreso.empresaLogistica placeholder=\"Seleccione o busque la empresa de logística\" uib-typeahead=\"empresaLogistica as empresaLogistica.nombre.toUpperCase() for empresaLogistica in vm.empresasLogistica | filter:{nombre:$viewValue}\" class=form-control typeahead-editable=false typeahead-show-hint=true typeahead-min-length=0 focus-on=empresaLogistica></div><div class=\"col-lg-6 form-group\"><label>Personal empresa logística:</label><input type=text ng-disabled=\"!vm.ingreso.empresaLogistica.id || vm.personasLogistica.length==0\" ng-model=vm.ingreso.personaEmpresaLogistica placeholder=\"Seleccione o busque la persona de la empresa de logístca\" uib-typeahead=\"persona as persona.apellido.toUpperCase()+\', \'+persona.nombre.toUpperCase() for persona in vm.personasLogistica | filter:{nombre:$viewValue}\" class=form-control focus-on=personaEmpresaLogistica typeahead-show-hint=true typeahead-min-length=0 typeahead-editable=false></div><div class=\"form-group col-lg-4\"><label>Número de remito:</label><input class=form-control ng-maxlength=100 focus-on=numeroRemito ng-model=vm.ingreso.numeroRemito placeholder=\"Ingrese el número de remito\" type=text name=numeroRemito> <span uib-alert class=danger ng-if=\"vm.form.numeroRemito.$error.maxlength && vm.form.numeroRemito.$dirty\">Este campo no puede superar los 100 caracteres.</span></div><div class=\"form-group col-lg-4\"><label>Número Vale de ingreso:</label><input class=form-control ng-maxlength=50 focus-on=numeroIngresoVale ng-model=vm.ingreso.numeroIngresoVale placeholder=\"Ingrese el número de Vale de ingreso \" type=text name=numeroIngresoVale> <span uib-alert class=danger ng-if=\"vm.form.numeroIngresoVale.$error.maxlength && vm.form.numeroIngresoVale.$dirty\">Este campo no puede superar los 50 caracteres.</span></div><div class=\"form-group col-lg-4\"><label>Número de guía:</label><input class=form-control ng-maxlength=100 focus-on=numeroGuia ng-model=vm.ingreso.numeroGuia placeholder=\"Ingrese el número de guía\" type=text name=numeroGuia> <span uib-alert class=danger ng-if=\"vm.form.numeroGuia.$error.maxlength && vm.form.numeroGuia.$dirty\">Este campo no puede superar los 100 caracteres. </span><span uib-alert class=danger ng-if=\"!vm.ingreso.empresaLogistica && vm.ingreso.numeroGuia\">Debe indicar una empresa de logística para ingresar un número de guía.</span></div><div class=\"form-group col-lg-12\"><label>Sucursal de origen:</label><input type=text ng-disabled=!vm.ingreso.empresa.nombre ng-model=vm.ingreso.sucursal placeholder=\"Seleccione o busque la sucursal\" uib-typeahead=\"sucursal as sucursal.nombre.toUpperCase() for sucursal in vm.sucursales | filter:{nombre:$viewValue}\" class=form-control typeahead-show-hint=true typeahead-min-length=0 name=sucursal typeahead-editable=false focus-on=sucursal></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=form-control focus-on=observacion ng-maxlength=500 ng-model=vm.ingreso.observacion placeholder=\"Ingrese una observación\" type=text name=observacion style=resize:vertical></textarea><span uib-alert class=danger ng-if=\"vm.form.observacion.$error.maxlength && vm.form.$dirty\">Este campo no puede superar los 500 caracteres.</span></div></form></div></div><div class=panel-footer><div class=\"container-fluid row\"><div class=\"col-sm-offset-3 col-sm-3\"><button type=button class=\"btn btn-success btn-block\" ng-click=vm.siguiente() ng-disabled=\"vm.form.$invalid || !vm.ingreso.empresa.nombre || !vm.ingreso.proveedor.nombre\"><span class=\"glyphicon glyphicon-ok\"></span> Siguiente</button></div><div class=col-sm-3><button type=button class=\"btn btn-danger btn-block\" ng-click=vm.cancelar()><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></div></div></div>");
$templateCache.put("app/app/main/movimientos/donacion-scrap/ingreso/visualizar/visualizar-donacion-scrap.html","<div class=form-group ng-if=vm.comprobarIngresoCerrado();><center><button ng-click=vm.volver(); class=\"btn btn-info\" style=width:30%><i class=\"fa fa-arrow-left\"></i> Volver al listado</button> <button ng-click=vm.imprimirInforme(); class=\"btn btn-primary\" style=width:30%><i class=\"fa fa-file-text-o\"></i> Obtener informe</button></center></div><div class=col-lg-12 ng-if=vm.comprobarIngresoCerrado()><div class=\"panel panel-default\"><div class=panel-body><div class=\"form-group col-lg-12\"><label>Depósito:</label><input type=text ng-readonly=true ng-model=vm.ingreso.deposito.nombre class=\"form-control text-uppercase\"></div><div class=\"form-group col-lg-6\"><label>Empresa:</label><input type=text ng-model=vm.ingreso.empresa.nombre class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-6\"><label>Autorizó:</label><input type=text ng-model=vm.ingreso.solicitante class=\"form-control text-uppercase\" ng-readonly=true></div><div class=\"form-group col-lg-3\"><label>Tipo de movimiento:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.tipoMovimiento.nombre type=text name=tipoMovimiento></div><div class=\"form-group col-lg-3\"><label>Número de movimiento:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroMovimiento type=text name=numeroMovimiento></div><div class=\"form-group col-lg-3\"><label>Fecha:</label><input class=form-control ng-readonly=true ng-model=vm.fecha type=text name=fecha></div><div class=\"form-group col-lg-3\"><label>Monto total:</label><input class=form-control ng-readonly=true ng-model=vm.montoTotal type=text name=montoTotal></div><div class=\"form-group col-lg-6\"><label>Proveedor:</label><input type=text ng-readonly=true ng-model=vm.ingreso.proveedor.nombre class=\"form-control text-uppercase\" name=proveedor></div><div class=\"form-group col-lg-6\"><label>Persona Proveedor:</label><input type=text ng-readonly=true ng-model=vm.personaProveedor class=\"form-control text-uppercase\" name=personaProveedor></div><div class=\"form-group col-lg-6\"><label>Empresa logística:</label><input type=text ng-readonly=true ng-model=vm.ingreso.empresaLogistica.nombre class=\"form-control text-uppercase\" name=empresaLogistica></div><div class=\"form-group col-lg-6\"><label>Persona Empresa logística:</label><input type=text ng-readonly=true ng-model=vm.personaEmpresaLogistica class=\"form-control text-uppercase\" name=personaEmpresaLogistica></div><div class=\"form-group col-lg-4\"><label>Número de remito:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroRemito type=text name=numeroRemito></div><div class=\"form-group col-lg-4\"><label>Número Vale Ingreso:</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroIngresoVale type=text name=numeroIngresoVale></div><div class=\"form-group col-lg-4\"><label>Número guía</label><input class=form-control ng-readonly=true ng-model=vm.ingreso.numeroGuia type=text name=numeroGuia></div><div class=\"form-group col-lg-12\"><label>Sucursal de origen</label><input class=\"form-control text-uppercase\" ng-readonly=true ng-model=vm.ingreso.sucursal.nombre type=text name=sucursal></div><div class=\"form-group col-lg-12\"><label>Observación:</label><textarea class=form-control ng-readonly=true ng-model=vm.ingreso.observacion type=text name=observacion style=resize:vertical></textarea></div></div></div><!-- 	<div ng-if=\"true\">\r\n		<uib-accordion>\r\n		    <div uib-accordion-group class=\"panel-default\" is-open=\"status.isCustomHeaderOpen\">\r\n		      	<uib-accordion-heading>\r\n		        	Problemas \r\n		        	<i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.isCustomHeaderOpen, \'glyphicon-chevron-right\': !status.isCustomHeaderOpen}\"></i>\r\n		      	</uib-accordion-heading>\r\n		      	<div class=\"col-lg-12\">\r\n		      		<div ng-if=\"vm.ingreso.problemas.length==0\">\r\n		      			<span uib-alert type=\"info\">\r\n		      				No posee ningún problema asignado\r\n		      			</span>		      			\r\n		      		</div>\r\n		      		<div>\r\n		      			<center>\r\n			      			<button class=\"btn btn-primary\" ng-click=\"vm.editarProblemas();\">\r\n								<i class=\"fa fa-pencil-square\"></i>\r\n			      				Agregar o quitar problemas\r\n			      			</button>\r\n		      			</center>\r\n		      		</div>\r\n		      		<div ng-if=\"vm.ingreso.problemas.length>0\">\r\n			      		<label>\r\n			      			Problemas asignados:\r\n			      		</label>\r\n		      			<table ng-table=\"vm.tableParams1\" class=\"table\">\r\n		      				<tr ng-repeat=\"problema in $data track by $index\">\r\n								<td>\r\n									{{problema.tipoProblema.nombre.toUpperCase();}}\r\n								</td>		      					\r\n		      				</tr>\r\n		      			</table>\r\n						<div class=\"col-lg-12\" ng-if=\"vm.comprobarFotoProblema()\">\r\n							<div uib-carousel active=\"0\" interval=\"0\" no-wrap=\"false\">\r\n						  		<div uib-slide ng-repeat=\"problema in vm.problemas track by $index\" index=\"problema.ind\">\r\n						    		<img ng-src=\"{{problema.foto}}\" style=\"margin:auto;\">\r\n						    		<div class=\"\">\r\n						      			<h4>{{problema.tipoProblema.nombre.toUpperCase();}}</h4>\r\n						    		</div>\r\n						  		</div>\r\n							</div>\r\n							<br>\r\n						</div>\r\n		      			<label>\r\n		      				Descripción de problemas:\r\n		      			</label>\r\n						<textarea class=\"form-control\" ng-readonly=\"true\" ng-disabled=\"true\" ng-model=\"vm.ingreso.observacionProblema\" type=\"text\" name=\"observacionProblema\" style=\"resize:vertical\">\r\n						</textarea>\r\n		      		</div>\r\n		      	</div>\r\n		    </div>\r\n		</uib-accordion>\r\n	</div>\r\n	 --><br><div class=\"col-lg-12 form-group\" ng-if=vm.comprobarIngresoCerrado();><label>Detalle de suministros del ingreso</label></div><form ng-show=true ng-if=vm.comprobarIngresoCerrado();><div class=col-lg-12 ng-show=\"vm.ingreso.detalles.length>0\"><table ng-table=vm.tableParams class=table show-filter=true ng-show=\"vm.ingreso.detalles.length>0\"><tr ng-repeat=\"detalles in $data track by $index\"><div><td title=\"\'Tipo Suministro\'\" sortable align=center>{{detalles.suministro.tipoSuministro.nombre.toUpperCase();}} ({{detalles.suministro.tipoSuministro.familiaSuministro.nombre.toUpperCase();}})</td><td title=\"\'Marca\'\" align=center>{{detalles.suministro.marca ? detalles.suministro.marca.toUpperCase() : \"-\" }}</td><td title=\"\'Fecha vencimiento\'\" align=center>{{detalles.suministro.fechaVencimiento ? detalles.suministro.fechaVencimiento : \"-\" | date : \"dd/MM/yyyy\" }}</td><td title=\"\'N° Inventario\'\" align=center>{{detalles.suministroInventariable? detalles.suministroInventariable.inventario : \'-\'}}</td><td title=\"\'N° Serie\'\" align=center>{{detalles.suministroInventariable? detalles.suministroInventariable.serie : \'-\'}}</td><td title=\"\'Cantidad\'\" align=center>{{detalles.cantidad}}</td><td title=\"\'Precio por unidad\'\" align=center>${{detalles.suministro.precioUnitario.toFixed(2)}}</td><td title=\"\'Total\'\" align=center>${{(detalles.suministro.precioUnitario*detalles.cantidad).toFixed(2)}}</td><td title=\"\'N° Caja\'\" align=center ng-if=vm.ingreso.caja>{{detalles.numeroCaja? detalles.numeroCaja : \'-\'}}</td><!-- 				        <td title=\"\'¿Activo?\'\" align=\"center\">\r\n    {{detalles.suministro.estadoSuministro.id==2? \"SI\" : \"NO\"}}\r\n</td> --><td title=\"\'¿Nuevo?\'\" align=center>{{detalles.suministroInventariable? detalles.suministroInventariable.nuevo? \"SI\" : \"NO\" : \"-\"}}</td><td style=width:35% title=\"\'Ubicación\'\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\' : !detalles.suministro.ubicacion.numeroOrden, \'has-success\':detalles.suministro.ubicacion.numeroOrden}\"><i class=\"glyphicon glyphicon-map-marker form-control-feedback\"></i><div ng-style=\"{\'cursor\':\'pointer\'}\" style=\"overflow-x: auto\" class=form-control ng-click=vm.ubicacionCompleta(detalles) class=form-control style=\"word-wrap: white\">{{vm.ubicacionNaveNumeroOrden(detalles)}}</div></div></td><td data-title=\"\'Acciones\'\" align=center><div class=btn-group><a class=\"btn btn-warning\" ng-click=vm.editarSuministro(detalles)><i class=\"fa fa-pencil\"></i></a></div></td></div></tr></table></div></form></div><div ng-if=!vm.comprobarIngresoCerrado() class=col-lg-12><span uib-alert class=danger>El ingreso todavía no tiene ubicaciones asignadas.</span></div>");
$templateCache.put("app/app/main/movimientos/egreso/reclamos/lista/lista.html","<div><form><div class=col-lg-12><table ng-table=vm.tableParams class=\"table table-condensed\" show-filter=true ng-show=\"vm.egresos.length>0\"><tr ng-repeat=\"egresos in $data\" ng-class=\"{\'amarillo-claro\': !egresos.atencionReclamo, \'azul-claro\':egresos.atencionReclamo}\"><div><td data-title=\"\'Fecha reclamo\'\" style=width:5% ng-title=\"\'fecha\'\" align=center data-sortable=\"\'fecha\'\">{{egresos.fecha | date : \"dd/MM/yyyy\" }}</td><td data-title=\"\'Depósito\'\" data-sortable=\"\'deposito.nombre\'\" filter=\"{\'deposito.nombre\': \'text\'}\" align=center>{{egresos.deposito.nombre.toUpperCase();}}</td><td data-title=\"\'Empresa\'\" data-sortable=\"\'empresa.nombre\'\" filter=\"{\'empresa.nombre\': \'text\'}\" align=center>{{egresos.empresa.nombre.toUpperCase();}}</td><td data-title=\"\'Sucursal\'\" data-sortable=\"\'sucursal.nombre\'\" filter=\"{\'sucursal.nombre\': \'text\'}\" align=center>{{egresos.sucursal.nombre.toUpperCase();}}</td><td data-title=\"\'N° Movimiento\'\" style=width:5% align=center filter=\"{\'numeroMovimiento\':\'text\'}\" data-sortable=\"\'numeroMovimiento\'\">{{egresos.numeroMovimiento}}</td><td data-title=\"\'Reclamo\'\" style=width:30%><button class=\"btn btn-xs btn-warning\" ng-if=egresos.descripcionReclamo ng-click=vm.verReclamo(egresos);><i class=\"fa fa-search\"></i></button> {{egresos.descripcionReclamo}}</td><td data-title=\"\'Atendido\'\" style=width:30%><button class=\"btn btn-xs btn-success\" ng-if=egresos.atencionReclamo ng-click=vm.verAtencionReclamo(egresos);><i class=\"fa fa-search\"></i></button> {{egresos.atencionReclamo? egresos.atencionReclamo : \"-\"}}</td><td data-title=\"\'Acciones\'\" align=center style=width:8%><div class=btn-group><a class=\"btn btn-info btn-sm\" ng-click=vm.visualizarEgreso(egresos)><i class=\"fa fa-search\"></i> </a><a class=\"btn btn-primary btn-sm\" ng-disabled=egresos.fechaAtencionReclamo ng-click=\"egresos.fechaAtencionReclamo || vm.atenderReclamo(egresos)\"><i class=\"fa fa-check-circle-o\"></i></a></div></td></div></tr></table></div></form></div>");}]);